
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1tGIT", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $1139a3c475a74ec4$export$ffb0004e005737fa, (v) => $1139a3c475a74ec4$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $1139a3c475a74ec4$export$34b9dba7ce09269b, (v) => $1139a3c475a74ec4$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $1139a3c475a74ec4$export$25062201e9e25d76, (v) => $1139a3c475a74ec4$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1139a3c475a74ec4$export$ffb0004e005737fa;
var $1139a3c475a74ec4$export$34b9dba7ce09269b;
var $1139a3c475a74ec4$export$25062201e9e25d76;
"use strict";

var $lBnVc = parcelRequire("lBnVc");
var $1139a3c475a74ec4$var$k = Symbol.for("react.element"), $1139a3c475a74ec4$var$l = Symbol.for("react.fragment"), $1139a3c475a74ec4$var$m = Object.prototype.hasOwnProperty, $1139a3c475a74ec4$var$n = $lBnVc.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $1139a3c475a74ec4$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1139a3c475a74ec4$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$1139a3c475a74ec4$var$m.call(a, b) && !$1139a3c475a74ec4$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $1139a3c475a74ec4$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $1139a3c475a74ec4$var$n.current
    };
}
$1139a3c475a74ec4$export$ffb0004e005737fa = $1139a3c475a74ec4$var$l;
$1139a3c475a74ec4$export$34b9dba7ce09269b = $1139a3c475a74ec4$var$q;
$1139a3c475a74ec4$export$25062201e9e25d76 = $1139a3c475a74ec4$var$q;

});
parcelRegister("lBnVc", function(module, exports) {
"use strict";

module.exports = (parcelRequire("cvc0k"));

});
parcelRegister("cvc0k", function(module, exports) {

$parcel$export(module.exports, "Children", () => $91a1b116b1d6528c$export$dca3b0875bd9a954, (v) => $91a1b116b1d6528c$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $91a1b116b1d6528c$export$16fa2f45be04daa8, (v) => $91a1b116b1d6528c$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $91a1b116b1d6528c$export$ffb0004e005737fa, (v) => $91a1b116b1d6528c$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $91a1b116b1d6528c$export$e2c29f18771995cb, (v) => $91a1b116b1d6528c$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $91a1b116b1d6528c$export$221d75b3f55bb0bd, (v) => $91a1b116b1d6528c$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $91a1b116b1d6528c$export$5f8d39834fd61797, (v) => $91a1b116b1d6528c$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $91a1b116b1d6528c$export$74bf444e3cd11ea5, (v) => $91a1b116b1d6528c$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $91a1b116b1d6528c$export$ae55be85d98224ed, (v) => $91a1b116b1d6528c$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $91a1b116b1d6528c$export$e530037191fcd5d7, (v) => $91a1b116b1d6528c$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $91a1b116b1d6528c$export$fd42f52fd3ae1109, (v) => $91a1b116b1d6528c$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $91a1b116b1d6528c$export$c8a8987d4410bf2d, (v) => $91a1b116b1d6528c$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $91a1b116b1d6528c$export$d38cd72104c1f0e9, (v) => $91a1b116b1d6528c$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $91a1b116b1d6528c$export$7d1e3a5e95ceca43, (v) => $91a1b116b1d6528c$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $91a1b116b1d6528c$export$257a8862b851cb5b, (v) => $91a1b116b1d6528c$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $91a1b116b1d6528c$export$a8257692ac88316c, (v) => $91a1b116b1d6528c$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $91a1b116b1d6528c$export$488013bae63b21da, (v) => $91a1b116b1d6528c$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $91a1b116b1d6528c$export$7c73462e0d25e514, (v) => $91a1b116b1d6528c$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $91a1b116b1d6528c$export$7568632d0d33d16d, (v) => $91a1b116b1d6528c$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $91a1b116b1d6528c$export$88948ce120ea2619, (v) => $91a1b116b1d6528c$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $91a1b116b1d6528c$export$35808ee640e87ca7, (v) => $91a1b116b1d6528c$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $91a1b116b1d6528c$export$fae74005e78b1a27, (v) => $91a1b116b1d6528c$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $91a1b116b1d6528c$export$dc8fbce3eb94dc1e, (v) => $91a1b116b1d6528c$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $91a1b116b1d6528c$export$6a7bc4e911dc01cf, (v) => $91a1b116b1d6528c$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $91a1b116b1d6528c$export$6d9c69b0de29b591, (v) => $91a1b116b1d6528c$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $91a1b116b1d6528c$export$f680877a34711e37, (v) => $91a1b116b1d6528c$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $91a1b116b1d6528c$export$d5a552a76deda3c2, (v) => $91a1b116b1d6528c$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $91a1b116b1d6528c$export$aaabe4eda9ed9969, (v) => $91a1b116b1d6528c$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $91a1b116b1d6528c$export$e5c5a5f917a5871c, (v) => $91a1b116b1d6528c$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $91a1b116b1d6528c$export$1538c33de8887b59, (v) => $91a1b116b1d6528c$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $91a1b116b1d6528c$export$13e3392192263954, (v) => $91a1b116b1d6528c$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $91a1b116b1d6528c$export$b8f5890fc79d6aca, (v) => $91a1b116b1d6528c$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $91a1b116b1d6528c$export$60241385465d0a34, (v) => $91a1b116b1d6528c$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $91a1b116b1d6528c$export$306c0aa65ff9ec16, (v) => $91a1b116b1d6528c$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $91a1b116b1d6528c$export$7b286972b8d8ccbf, (v) => $91a1b116b1d6528c$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $91a1b116b1d6528c$export$83d89fbfd8236492, (v) => $91a1b116b1d6528c$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $91a1b116b1d6528c$export$dca3b0875bd9a954;
var $91a1b116b1d6528c$export$16fa2f45be04daa8;
var $91a1b116b1d6528c$export$ffb0004e005737fa;
var $91a1b116b1d6528c$export$e2c29f18771995cb;
var $91a1b116b1d6528c$export$221d75b3f55bb0bd;
var $91a1b116b1d6528c$export$5f8d39834fd61797;
var $91a1b116b1d6528c$export$74bf444e3cd11ea5;
var $91a1b116b1d6528c$export$ae55be85d98224ed;
var $91a1b116b1d6528c$export$e530037191fcd5d7;
var $91a1b116b1d6528c$export$fd42f52fd3ae1109;
var $91a1b116b1d6528c$export$c8a8987d4410bf2d;
var $91a1b116b1d6528c$export$d38cd72104c1f0e9;
var $91a1b116b1d6528c$export$7d1e3a5e95ceca43;
var $91a1b116b1d6528c$export$257a8862b851cb5b;
var $91a1b116b1d6528c$export$a8257692ac88316c;
var $91a1b116b1d6528c$export$488013bae63b21da;
var $91a1b116b1d6528c$export$7c73462e0d25e514;
var $91a1b116b1d6528c$export$7568632d0d33d16d;
var $91a1b116b1d6528c$export$88948ce120ea2619;
var $91a1b116b1d6528c$export$35808ee640e87ca7;
var $91a1b116b1d6528c$export$fae74005e78b1a27;
var $91a1b116b1d6528c$export$dc8fbce3eb94dc1e;
var $91a1b116b1d6528c$export$6a7bc4e911dc01cf;
var $91a1b116b1d6528c$export$6d9c69b0de29b591;
var $91a1b116b1d6528c$export$f680877a34711e37;
var $91a1b116b1d6528c$export$d5a552a76deda3c2;
var $91a1b116b1d6528c$export$aaabe4eda9ed9969;
var $91a1b116b1d6528c$export$e5c5a5f917a5871c;
var $91a1b116b1d6528c$export$1538c33de8887b59;
var $91a1b116b1d6528c$export$13e3392192263954;
var $91a1b116b1d6528c$export$b8f5890fc79d6aca;
var $91a1b116b1d6528c$export$60241385465d0a34;
var $91a1b116b1d6528c$export$306c0aa65ff9ec16;
var $91a1b116b1d6528c$export$7b286972b8d8ccbf;
var $91a1b116b1d6528c$export$83d89fbfd8236492;
"use strict";
var $91a1b116b1d6528c$var$l = Symbol.for("react.element"), $91a1b116b1d6528c$var$n = Symbol.for("react.portal"), $91a1b116b1d6528c$var$p = Symbol.for("react.fragment"), $91a1b116b1d6528c$var$q = Symbol.for("react.strict_mode"), $91a1b116b1d6528c$var$r = Symbol.for("react.profiler"), $91a1b116b1d6528c$var$t = Symbol.for("react.provider"), $91a1b116b1d6528c$var$u = Symbol.for("react.context"), $91a1b116b1d6528c$var$v = Symbol.for("react.forward_ref"), $91a1b116b1d6528c$var$w = Symbol.for("react.suspense"), $91a1b116b1d6528c$var$x = Symbol.for("react.memo"), $91a1b116b1d6528c$var$y = Symbol.for("react.lazy"), $91a1b116b1d6528c$var$z = Symbol.iterator;
function $91a1b116b1d6528c$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $91a1b116b1d6528c$var$z && a[$91a1b116b1d6528c$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $91a1b116b1d6528c$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $91a1b116b1d6528c$var$C = Object.assign, $91a1b116b1d6528c$var$D = {};
function $91a1b116b1d6528c$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $91a1b116b1d6528c$var$D;
    this.updater = e || $91a1b116b1d6528c$var$B;
}
$91a1b116b1d6528c$var$E.prototype.isReactComponent = {};
$91a1b116b1d6528c$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$91a1b116b1d6528c$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $91a1b116b1d6528c$var$F() {}
$91a1b116b1d6528c$var$F.prototype = $91a1b116b1d6528c$var$E.prototype;
function $91a1b116b1d6528c$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $91a1b116b1d6528c$var$D;
    this.updater = e || $91a1b116b1d6528c$var$B;
}
var $91a1b116b1d6528c$var$H = $91a1b116b1d6528c$var$G.prototype = new $91a1b116b1d6528c$var$F;
$91a1b116b1d6528c$var$H.constructor = $91a1b116b1d6528c$var$G;
$91a1b116b1d6528c$var$C($91a1b116b1d6528c$var$H, $91a1b116b1d6528c$var$E.prototype);
$91a1b116b1d6528c$var$H.isPureReactComponent = !0;
var $91a1b116b1d6528c$var$I = Array.isArray, $91a1b116b1d6528c$var$J = Object.prototype.hasOwnProperty, $91a1b116b1d6528c$var$K = {
    current: null
}, $91a1b116b1d6528c$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $91a1b116b1d6528c$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$91a1b116b1d6528c$var$J.call(b, d) && !$91a1b116b1d6528c$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $91a1b116b1d6528c$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $91a1b116b1d6528c$var$K.current
    };
}
function $91a1b116b1d6528c$var$N(a, b) {
    return {
        $$typeof: $91a1b116b1d6528c$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $91a1b116b1d6528c$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $91a1b116b1d6528c$var$l;
}
function $91a1b116b1d6528c$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $91a1b116b1d6528c$var$P = /\/+/g;
function $91a1b116b1d6528c$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $91a1b116b1d6528c$var$escape("" + a.key) : b.toString(36);
}
function $91a1b116b1d6528c$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $91a1b116b1d6528c$var$l:
                case $91a1b116b1d6528c$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $91a1b116b1d6528c$var$Q(h, 0) : d, $91a1b116b1d6528c$var$I(c) ? (e = "", null != a && (e = a.replace($91a1b116b1d6528c$var$P, "$&/") + "/"), $91a1b116b1d6528c$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($91a1b116b1d6528c$var$O(c) && (c = $91a1b116b1d6528c$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($91a1b116b1d6528c$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($91a1b116b1d6528c$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $91a1b116b1d6528c$var$Q(k, g);
        h += $91a1b116b1d6528c$var$R(k, b, e, f, c);
    }
    else if (f = $91a1b116b1d6528c$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $91a1b116b1d6528c$var$Q(k, g++), h += $91a1b116b1d6528c$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $91a1b116b1d6528c$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $91a1b116b1d6528c$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $91a1b116b1d6528c$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $91a1b116b1d6528c$var$U = {
    current: null
}, $91a1b116b1d6528c$var$V = {
    transition: null
}, $91a1b116b1d6528c$var$W = {
    ReactCurrentDispatcher: $91a1b116b1d6528c$var$U,
    ReactCurrentBatchConfig: $91a1b116b1d6528c$var$V,
    ReactCurrentOwner: $91a1b116b1d6528c$var$K
};
$91a1b116b1d6528c$export$dca3b0875bd9a954 = {
    map: $91a1b116b1d6528c$var$S,
    forEach: function(a, b, e) {
        $91a1b116b1d6528c$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $91a1b116b1d6528c$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $91a1b116b1d6528c$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$91a1b116b1d6528c$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$91a1b116b1d6528c$export$16fa2f45be04daa8 = $91a1b116b1d6528c$var$E;
$91a1b116b1d6528c$export$ffb0004e005737fa = $91a1b116b1d6528c$var$p;
$91a1b116b1d6528c$export$e2c29f18771995cb = $91a1b116b1d6528c$var$r;
$91a1b116b1d6528c$export$221d75b3f55bb0bd = $91a1b116b1d6528c$var$G;
$91a1b116b1d6528c$export$5f8d39834fd61797 = $91a1b116b1d6528c$var$q;
$91a1b116b1d6528c$export$74bf444e3cd11ea5 = $91a1b116b1d6528c$var$w;
$91a1b116b1d6528c$export$ae55be85d98224ed = $91a1b116b1d6528c$var$W;
$91a1b116b1d6528c$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $91a1b116b1d6528c$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $91a1b116b1d6528c$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$91a1b116b1d6528c$var$J.call(b, f) && !$91a1b116b1d6528c$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $91a1b116b1d6528c$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$91a1b116b1d6528c$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $91a1b116b1d6528c$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $91a1b116b1d6528c$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$91a1b116b1d6528c$export$c8a8987d4410bf2d = $91a1b116b1d6528c$var$M;
$91a1b116b1d6528c$export$d38cd72104c1f0e9 = function(a) {
    var b = $91a1b116b1d6528c$var$M.bind(null, a);
    b.type = a;
    return b;
};
$91a1b116b1d6528c$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$91a1b116b1d6528c$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $91a1b116b1d6528c$var$v,
        render: a
    };
};
$91a1b116b1d6528c$export$a8257692ac88316c = $91a1b116b1d6528c$var$O;
$91a1b116b1d6528c$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $91a1b116b1d6528c$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $91a1b116b1d6528c$var$T
    };
};
$91a1b116b1d6528c$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $91a1b116b1d6528c$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$91a1b116b1d6528c$export$7568632d0d33d16d = function(a) {
    var b = $91a1b116b1d6528c$var$V.transition;
    $91a1b116b1d6528c$var$V.transition = {};
    try {
        a();
    } finally{
        $91a1b116b1d6528c$var$V.transition = b;
    }
};
$91a1b116b1d6528c$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$91a1b116b1d6528c$export$35808ee640e87ca7 = function(a, b) {
    return $91a1b116b1d6528c$var$U.current.useCallback(a, b);
};
$91a1b116b1d6528c$export$fae74005e78b1a27 = function(a) {
    return $91a1b116b1d6528c$var$U.current.useContext(a);
};
$91a1b116b1d6528c$export$dc8fbce3eb94dc1e = function() {};
$91a1b116b1d6528c$export$6a7bc4e911dc01cf = function(a) {
    return $91a1b116b1d6528c$var$U.current.useDeferredValue(a);
};
$91a1b116b1d6528c$export$6d9c69b0de29b591 = function(a, b) {
    return $91a1b116b1d6528c$var$U.current.useEffect(a, b);
};
$91a1b116b1d6528c$export$f680877a34711e37 = function() {
    return $91a1b116b1d6528c$var$U.current.useId();
};
$91a1b116b1d6528c$export$d5a552a76deda3c2 = function(a, b, e) {
    return $91a1b116b1d6528c$var$U.current.useImperativeHandle(a, b, e);
};
$91a1b116b1d6528c$export$aaabe4eda9ed9969 = function(a, b) {
    return $91a1b116b1d6528c$var$U.current.useInsertionEffect(a, b);
};
$91a1b116b1d6528c$export$e5c5a5f917a5871c = function(a, b) {
    return $91a1b116b1d6528c$var$U.current.useLayoutEffect(a, b);
};
$91a1b116b1d6528c$export$1538c33de8887b59 = function(a, b) {
    return $91a1b116b1d6528c$var$U.current.useMemo(a, b);
};
$91a1b116b1d6528c$export$13e3392192263954 = function(a, b, e) {
    return $91a1b116b1d6528c$var$U.current.useReducer(a, b, e);
};
$91a1b116b1d6528c$export$b8f5890fc79d6aca = function(a) {
    return $91a1b116b1d6528c$var$U.current.useRef(a);
};
$91a1b116b1d6528c$export$60241385465d0a34 = function(a) {
    return $91a1b116b1d6528c$var$U.current.useState(a);
};
$91a1b116b1d6528c$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $91a1b116b1d6528c$var$U.current.useSyncExternalStore(a, b, e);
};
$91a1b116b1d6528c$export$7b286972b8d8ccbf = function() {
    return $91a1b116b1d6528c$var$U.current.useTransition();
};
$91a1b116b1d6528c$export$83d89fbfd8236492 = "18.2.0";

});



parcelRegister("iMlaS", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $dabd227c6ffbf98e$export$bf730a2d8bf68b42, (v) => $dabd227c6ffbf98e$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $dabd227c6ffbf98e$export$bf730a2d8bf68b42;
"use strict";

var $lBnVc = parcelRequire("lBnVc");
function $dabd227c6ffbf98e$var$n(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $dabd227c6ffbf98e$var$p = "function" === typeof Object.is ? Object.is : $dabd227c6ffbf98e$var$n, $dabd227c6ffbf98e$var$q = $lBnVc.useSyncExternalStore, $dabd227c6ffbf98e$var$r = $lBnVc.useRef, $dabd227c6ffbf98e$var$t = $lBnVc.useEffect, $dabd227c6ffbf98e$var$u = $lBnVc.useMemo, $dabd227c6ffbf98e$var$v = $lBnVc.useDebugValue;
$dabd227c6ffbf98e$export$bf730a2d8bf68b42 = function(a, b, e, l, h) {
    var c = $dabd227c6ffbf98e$var$r(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $dabd227c6ffbf98e$var$u(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== h && f.hasValue) {
                    var b = f.value;
                    if (h(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($dabd227c6ffbf98e$var$p(d, a)) return b;
            var e = l(a);
            if (void 0 !== h && h(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        h
    ]);
    var d = $dabd227c6ffbf98e$var$q(a, c[0], c[1]);
    $dabd227c6ffbf98e$var$t(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $dabd227c6ffbf98e$var$v(d);
    return d;
};

});

parcelRegister("e0VS3", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $a33df4b8f27c9b79$export$ae55be85d98224ed, (v) => $a33df4b8f27c9b79$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $a33df4b8f27c9b79$export$d39a5bbd09211389, (v) => $a33df4b8f27c9b79$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $a33df4b8f27c9b79$export$882461b6382ed46c, (v) => $a33df4b8f27c9b79$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $a33df4b8f27c9b79$export$466bfc07425424d5, (v) => $a33df4b8f27c9b79$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $a33df4b8f27c9b79$export$cd75ccfd720a3cd4, (v) => $a33df4b8f27c9b79$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $a33df4b8f27c9b79$export$fa8d919ba61d84db, (v) => $a33df4b8f27c9b79$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $a33df4b8f27c9b79$export$757ceba2d55c277e, (v) => $a33df4b8f27c9b79$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $a33df4b8f27c9b79$export$b3890eb0ae9dca99, (v) => $a33df4b8f27c9b79$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $a33df4b8f27c9b79$export$502457920280e6be, (v) => $a33df4b8f27c9b79$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $a33df4b8f27c9b79$export$c78a37762a8d58e1, (v) => $a33df4b8f27c9b79$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $a33df4b8f27c9b79$export$dc54d992c10e8a18, (v) => $a33df4b8f27c9b79$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $a33df4b8f27c9b79$export$83d89fbfd8236492, (v) => $a33df4b8f27c9b79$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $a33df4b8f27c9b79$export$ae55be85d98224ed;
var $a33df4b8f27c9b79$export$d39a5bbd09211389;
var $a33df4b8f27c9b79$export$882461b6382ed46c;
var $a33df4b8f27c9b79$export$466bfc07425424d5;
var $a33df4b8f27c9b79$export$cd75ccfd720a3cd4;
var $a33df4b8f27c9b79$export$fa8d919ba61d84db;
var $a33df4b8f27c9b79$export$757ceba2d55c277e;
var $a33df4b8f27c9b79$export$b3890eb0ae9dca99;
var $a33df4b8f27c9b79$export$502457920280e6be;
var $a33df4b8f27c9b79$export$c78a37762a8d58e1;
var $a33df4b8f27c9b79$export$dc54d992c10e8a18;
var $a33df4b8f27c9b79$export$83d89fbfd8236492;
"use strict";

var $lBnVc = parcelRequire("lBnVc");

var $j5eGm = parcelRequire("j5eGm");
function $a33df4b8f27c9b79$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $a33df4b8f27c9b79$var$da = new Set, $a33df4b8f27c9b79$var$ea = {};
function $a33df4b8f27c9b79$var$fa(a, b) {
    $a33df4b8f27c9b79$var$ha(a, b);
    $a33df4b8f27c9b79$var$ha(a + "Capture", b);
}
function $a33df4b8f27c9b79$var$ha(a, b) {
    $a33df4b8f27c9b79$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$a33df4b8f27c9b79$var$da.add(b[a]);
}
var $a33df4b8f27c9b79$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $a33df4b8f27c9b79$var$ja = Object.prototype.hasOwnProperty, $a33df4b8f27c9b79$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $a33df4b8f27c9b79$var$la = {}, $a33df4b8f27c9b79$var$ma = {};
function $a33df4b8f27c9b79$var$oa(a) {
    if ($a33df4b8f27c9b79$var$ja.call($a33df4b8f27c9b79$var$ma, a)) return !0;
    if ($a33df4b8f27c9b79$var$ja.call($a33df4b8f27c9b79$var$la, a)) return !1;
    if ($a33df4b8f27c9b79$var$ka.test(a)) return $a33df4b8f27c9b79$var$ma[a] = !0;
    $a33df4b8f27c9b79$var$la[a] = !0;
    return !1;
}
function $a33df4b8f27c9b79$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $a33df4b8f27c9b79$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $a33df4b8f27c9b79$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $a33df4b8f27c9b79$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $a33df4b8f27c9b79$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $a33df4b8f27c9b79$var$z[a] = new $a33df4b8f27c9b79$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $a33df4b8f27c9b79$var$z[b] = new $a33df4b8f27c9b79$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $a33df4b8f27c9b79$var$z[a] = new $a33df4b8f27c9b79$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $a33df4b8f27c9b79$var$z[a] = new $a33df4b8f27c9b79$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $a33df4b8f27c9b79$var$z[a] = new $a33df4b8f27c9b79$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $a33df4b8f27c9b79$var$z[a] = new $a33df4b8f27c9b79$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $a33df4b8f27c9b79$var$z[a] = new $a33df4b8f27c9b79$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $a33df4b8f27c9b79$var$z[a] = new $a33df4b8f27c9b79$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $a33df4b8f27c9b79$var$z[a] = new $a33df4b8f27c9b79$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $a33df4b8f27c9b79$var$ra = /[\-:]([a-z])/g;
function $a33df4b8f27c9b79$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($a33df4b8f27c9b79$var$ra, $a33df4b8f27c9b79$var$sa);
    $a33df4b8f27c9b79$var$z[b] = new $a33df4b8f27c9b79$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($a33df4b8f27c9b79$var$ra, $a33df4b8f27c9b79$var$sa);
    $a33df4b8f27c9b79$var$z[b] = new $a33df4b8f27c9b79$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($a33df4b8f27c9b79$var$ra, $a33df4b8f27c9b79$var$sa);
    $a33df4b8f27c9b79$var$z[b] = new $a33df4b8f27c9b79$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $a33df4b8f27c9b79$var$z[a] = new $a33df4b8f27c9b79$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$a33df4b8f27c9b79$var$z.xlinkHref = new $a33df4b8f27c9b79$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $a33df4b8f27c9b79$var$z[a] = new $a33df4b8f27c9b79$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $a33df4b8f27c9b79$var$ta(a, b, c, d) {
    var e = $a33df4b8f27c9b79$var$z.hasOwnProperty(b) ? $a33df4b8f27c9b79$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $a33df4b8f27c9b79$var$qa(b, c, e, d) && (c = null), d || null === e ? $a33df4b8f27c9b79$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $a33df4b8f27c9b79$var$ua = $lBnVc.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $a33df4b8f27c9b79$var$va = Symbol.for("react.element"), $a33df4b8f27c9b79$var$wa = Symbol.for("react.portal"), $a33df4b8f27c9b79$var$ya = Symbol.for("react.fragment"), $a33df4b8f27c9b79$var$za = Symbol.for("react.strict_mode"), $a33df4b8f27c9b79$var$Aa = Symbol.for("react.profiler"), $a33df4b8f27c9b79$var$Ba = Symbol.for("react.provider"), $a33df4b8f27c9b79$var$Ca = Symbol.for("react.context"), $a33df4b8f27c9b79$var$Da = Symbol.for("react.forward_ref"), $a33df4b8f27c9b79$var$Ea = Symbol.for("react.suspense"), $a33df4b8f27c9b79$var$Fa = Symbol.for("react.suspense_list"), $a33df4b8f27c9b79$var$Ga = Symbol.for("react.memo"), $a33df4b8f27c9b79$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $a33df4b8f27c9b79$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $a33df4b8f27c9b79$var$Ja = Symbol.iterator;
function $a33df4b8f27c9b79$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $a33df4b8f27c9b79$var$Ja && a[$a33df4b8f27c9b79$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $a33df4b8f27c9b79$var$A = Object.assign, $a33df4b8f27c9b79$var$La;
function $a33df4b8f27c9b79$var$Ma(a) {
    if (void 0 === $a33df4b8f27c9b79$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $a33df4b8f27c9b79$var$La = b && b[1] || "";
    }
    return "\n" + $a33df4b8f27c9b79$var$La + a;
}
var $a33df4b8f27c9b79$var$Na = !1;
function $a33df4b8f27c9b79$var$Oa(a, b) {
    if (!a || $a33df4b8f27c9b79$var$Na) return "";
    $a33df4b8f27c9b79$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $a33df4b8f27c9b79$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $a33df4b8f27c9b79$var$Ma(a) : "";
}
function $a33df4b8f27c9b79$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $a33df4b8f27c9b79$var$Ma(a.type);
        case 16:
            return $a33df4b8f27c9b79$var$Ma("Lazy");
        case 13:
            return $a33df4b8f27c9b79$var$Ma("Suspense");
        case 19:
            return $a33df4b8f27c9b79$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $a33df4b8f27c9b79$var$Oa(a.type, !1), a;
        case 11:
            return a = $a33df4b8f27c9b79$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $a33df4b8f27c9b79$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $a33df4b8f27c9b79$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $a33df4b8f27c9b79$var$ya:
            return "Fragment";
        case $a33df4b8f27c9b79$var$wa:
            return "Portal";
        case $a33df4b8f27c9b79$var$Aa:
            return "Profiler";
        case $a33df4b8f27c9b79$var$za:
            return "StrictMode";
        case $a33df4b8f27c9b79$var$Ea:
            return "Suspense";
        case $a33df4b8f27c9b79$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $a33df4b8f27c9b79$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $a33df4b8f27c9b79$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $a33df4b8f27c9b79$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $a33df4b8f27c9b79$var$Ga:
            return b = a.displayName || null, null !== b ? b : $a33df4b8f27c9b79$var$Qa(a.type) || "Memo";
        case $a33df4b8f27c9b79$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $a33df4b8f27c9b79$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $a33df4b8f27c9b79$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $a33df4b8f27c9b79$var$Qa(b);
        case 8:
            return b === $a33df4b8f27c9b79$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $a33df4b8f27c9b79$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $a33df4b8f27c9b79$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $a33df4b8f27c9b79$var$Ua(a) {
    var b = $a33df4b8f27c9b79$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $a33df4b8f27c9b79$var$Va(a) {
    a._valueTracker || (a._valueTracker = $a33df4b8f27c9b79$var$Ua(a));
}
function $a33df4b8f27c9b79$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $a33df4b8f27c9b79$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $a33df4b8f27c9b79$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $a33df4b8f27c9b79$var$Ya(a, b) {
    var c = b.checked;
    return $a33df4b8f27c9b79$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $a33df4b8f27c9b79$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $a33df4b8f27c9b79$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $a33df4b8f27c9b79$var$ab(a, b) {
    b = b.checked;
    null != b && $a33df4b8f27c9b79$var$ta(a, "checked", b, !1);
}
function $a33df4b8f27c9b79$var$bb(a, b) {
    $a33df4b8f27c9b79$var$ab(a, b);
    var c = $a33df4b8f27c9b79$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $a33df4b8f27c9b79$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $a33df4b8f27c9b79$var$cb(a, b.type, $a33df4b8f27c9b79$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $a33df4b8f27c9b79$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $a33df4b8f27c9b79$var$cb(a, b, c) {
    if ("number" !== b || $a33df4b8f27c9b79$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $a33df4b8f27c9b79$var$eb = Array.isArray;
function $a33df4b8f27c9b79$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $a33df4b8f27c9b79$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $a33df4b8f27c9b79$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($a33df4b8f27c9b79$var$p(91));
    return $a33df4b8f27c9b79$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $a33df4b8f27c9b79$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($a33df4b8f27c9b79$var$p(92));
            if ($a33df4b8f27c9b79$var$eb(c)) {
                if (1 < c.length) throw Error($a33df4b8f27c9b79$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $a33df4b8f27c9b79$var$Sa(c)
    };
}
function $a33df4b8f27c9b79$var$ib(a, b) {
    var c = $a33df4b8f27c9b79$var$Sa(b.value), d = $a33df4b8f27c9b79$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $a33df4b8f27c9b79$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $a33df4b8f27c9b79$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $a33df4b8f27c9b79$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $a33df4b8f27c9b79$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $a33df4b8f27c9b79$var$mb, $a33df4b8f27c9b79$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $a33df4b8f27c9b79$var$mb = $a33df4b8f27c9b79$var$mb || document.createElement("div");
        $a33df4b8f27c9b79$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $a33df4b8f27c9b79$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $a33df4b8f27c9b79$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $a33df4b8f27c9b79$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $a33df4b8f27c9b79$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($a33df4b8f27c9b79$var$pb).forEach(function(a) {
    $a33df4b8f27c9b79$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $a33df4b8f27c9b79$var$pb[b] = $a33df4b8f27c9b79$var$pb[a];
    });
});
function $a33df4b8f27c9b79$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $a33df4b8f27c9b79$var$pb.hasOwnProperty(a) && $a33df4b8f27c9b79$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $a33df4b8f27c9b79$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $a33df4b8f27c9b79$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $a33df4b8f27c9b79$var$tb = $a33df4b8f27c9b79$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $a33df4b8f27c9b79$var$ub(a, b) {
    if (b) {
        if ($a33df4b8f27c9b79$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($a33df4b8f27c9b79$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($a33df4b8f27c9b79$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($a33df4b8f27c9b79$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($a33df4b8f27c9b79$var$p(62));
    }
}
function $a33df4b8f27c9b79$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $a33df4b8f27c9b79$var$wb = null;
function $a33df4b8f27c9b79$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $a33df4b8f27c9b79$var$yb = null, $a33df4b8f27c9b79$var$zb = null, $a33df4b8f27c9b79$var$Ab = null;
function $a33df4b8f27c9b79$var$Bb(a) {
    if (a = $a33df4b8f27c9b79$var$Cb(a)) {
        if ("function" !== typeof $a33df4b8f27c9b79$var$yb) throw Error($a33df4b8f27c9b79$var$p(280));
        var b = a.stateNode;
        b && (b = $a33df4b8f27c9b79$var$Db(b), $a33df4b8f27c9b79$var$yb(a.stateNode, a.type, b));
    }
}
function $a33df4b8f27c9b79$var$Eb(a) {
    $a33df4b8f27c9b79$var$zb ? $a33df4b8f27c9b79$var$Ab ? $a33df4b8f27c9b79$var$Ab.push(a) : $a33df4b8f27c9b79$var$Ab = [
        a
    ] : $a33df4b8f27c9b79$var$zb = a;
}
function $a33df4b8f27c9b79$var$Fb() {
    if ($a33df4b8f27c9b79$var$zb) {
        var a = $a33df4b8f27c9b79$var$zb, b = $a33df4b8f27c9b79$var$Ab;
        $a33df4b8f27c9b79$var$Ab = $a33df4b8f27c9b79$var$zb = null;
        $a33df4b8f27c9b79$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$a33df4b8f27c9b79$var$Bb(b[a]);
    }
}
function $a33df4b8f27c9b79$var$Gb(a, b) {
    return a(b);
}
function $a33df4b8f27c9b79$var$Hb() {}
var $a33df4b8f27c9b79$var$Ib = !1;
function $a33df4b8f27c9b79$var$Jb(a, b, c) {
    if ($a33df4b8f27c9b79$var$Ib) return a(b, c);
    $a33df4b8f27c9b79$var$Ib = !0;
    try {
        return $a33df4b8f27c9b79$var$Gb(a, b, c);
    } finally{
        if ($a33df4b8f27c9b79$var$Ib = !1, null !== $a33df4b8f27c9b79$var$zb || null !== $a33df4b8f27c9b79$var$Ab) $a33df4b8f27c9b79$var$Hb(), $a33df4b8f27c9b79$var$Fb();
    }
}
function $a33df4b8f27c9b79$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $a33df4b8f27c9b79$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($a33df4b8f27c9b79$var$p(231, b, typeof c));
    return c;
}
var $a33df4b8f27c9b79$var$Lb = !1;
if ($a33df4b8f27c9b79$var$ia) try {
    var $a33df4b8f27c9b79$var$Mb = {};
    Object.defineProperty($a33df4b8f27c9b79$var$Mb, "passive", {
        get: function() {
            $a33df4b8f27c9b79$var$Lb = !0;
        }
    });
    window.addEventListener("test", $a33df4b8f27c9b79$var$Mb, $a33df4b8f27c9b79$var$Mb);
    window.removeEventListener("test", $a33df4b8f27c9b79$var$Mb, $a33df4b8f27c9b79$var$Mb);
} catch (a) {
    $a33df4b8f27c9b79$var$Lb = !1;
}
function $a33df4b8f27c9b79$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $a33df4b8f27c9b79$var$Ob = !1, $a33df4b8f27c9b79$var$Pb = null, $a33df4b8f27c9b79$var$Qb = !1, $a33df4b8f27c9b79$var$Rb = null, $a33df4b8f27c9b79$var$Sb = {
    onError: function(a) {
        $a33df4b8f27c9b79$var$Ob = !0;
        $a33df4b8f27c9b79$var$Pb = a;
    }
};
function $a33df4b8f27c9b79$var$Tb(a, b, c, d, e, f, g, h, k) {
    $a33df4b8f27c9b79$var$Ob = !1;
    $a33df4b8f27c9b79$var$Pb = null;
    $a33df4b8f27c9b79$var$Nb.apply($a33df4b8f27c9b79$var$Sb, arguments);
}
function $a33df4b8f27c9b79$var$Ub(a, b, c, d, e, f, g, h, k) {
    $a33df4b8f27c9b79$var$Tb.apply(this, arguments);
    if ($a33df4b8f27c9b79$var$Ob) {
        if ($a33df4b8f27c9b79$var$Ob) {
            var l = $a33df4b8f27c9b79$var$Pb;
            $a33df4b8f27c9b79$var$Ob = !1;
            $a33df4b8f27c9b79$var$Pb = null;
        } else throw Error($a33df4b8f27c9b79$var$p(198));
        $a33df4b8f27c9b79$var$Qb || ($a33df4b8f27c9b79$var$Qb = !0, $a33df4b8f27c9b79$var$Rb = l);
    }
}
function $a33df4b8f27c9b79$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $a33df4b8f27c9b79$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $a33df4b8f27c9b79$var$Xb(a) {
    if ($a33df4b8f27c9b79$var$Vb(a) !== a) throw Error($a33df4b8f27c9b79$var$p(188));
}
function $a33df4b8f27c9b79$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $a33df4b8f27c9b79$var$Vb(a);
        if (null === b) throw Error($a33df4b8f27c9b79$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $a33df4b8f27c9b79$var$Xb(e), a;
                if (f === d) return $a33df4b8f27c9b79$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($a33df4b8f27c9b79$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($a33df4b8f27c9b79$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($a33df4b8f27c9b79$var$p(190));
    }
    if (3 !== c.tag) throw Error($a33df4b8f27c9b79$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $a33df4b8f27c9b79$var$Zb(a) {
    a = $a33df4b8f27c9b79$var$Yb(a);
    return null !== a ? $a33df4b8f27c9b79$var$$b(a) : null;
}
function $a33df4b8f27c9b79$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $a33df4b8f27c9b79$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $a33df4b8f27c9b79$var$ac = $j5eGm.unstable_scheduleCallback, $a33df4b8f27c9b79$var$bc = $j5eGm.unstable_cancelCallback, $a33df4b8f27c9b79$var$cc = $j5eGm.unstable_shouldYield, $a33df4b8f27c9b79$var$dc = $j5eGm.unstable_requestPaint, $a33df4b8f27c9b79$var$B = $j5eGm.unstable_now, $a33df4b8f27c9b79$var$ec = $j5eGm.unstable_getCurrentPriorityLevel, $a33df4b8f27c9b79$var$fc = $j5eGm.unstable_ImmediatePriority, $a33df4b8f27c9b79$var$gc = $j5eGm.unstable_UserBlockingPriority, $a33df4b8f27c9b79$var$hc = $j5eGm.unstable_NormalPriority, $a33df4b8f27c9b79$var$ic = $j5eGm.unstable_LowPriority, $a33df4b8f27c9b79$var$jc = $j5eGm.unstable_IdlePriority, $a33df4b8f27c9b79$var$kc = null, $a33df4b8f27c9b79$var$lc = null;
function $a33df4b8f27c9b79$var$mc(a) {
    if ($a33df4b8f27c9b79$var$lc && "function" === typeof $a33df4b8f27c9b79$var$lc.onCommitFiberRoot) try {
        $a33df4b8f27c9b79$var$lc.onCommitFiberRoot($a33df4b8f27c9b79$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $a33df4b8f27c9b79$var$oc = Math.clz32 ? Math.clz32 : $a33df4b8f27c9b79$var$nc, $a33df4b8f27c9b79$var$pc = Math.log, $a33df4b8f27c9b79$var$qc = Math.LN2;
function $a33df4b8f27c9b79$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($a33df4b8f27c9b79$var$pc(a) / $a33df4b8f27c9b79$var$qc | 0) | 0;
}
var $a33df4b8f27c9b79$var$rc = 64, $a33df4b8f27c9b79$var$sc = 4194304;
function $a33df4b8f27c9b79$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $a33df4b8f27c9b79$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $a33df4b8f27c9b79$var$tc(h) : (f &= g, 0 !== f && (d = $a33df4b8f27c9b79$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $a33df4b8f27c9b79$var$tc(g) : 0 !== f && (d = $a33df4b8f27c9b79$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $a33df4b8f27c9b79$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $a33df4b8f27c9b79$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $a33df4b8f27c9b79$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $a33df4b8f27c9b79$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $a33df4b8f27c9b79$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $a33df4b8f27c9b79$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $a33df4b8f27c9b79$var$yc() {
    var a = $a33df4b8f27c9b79$var$rc;
    $a33df4b8f27c9b79$var$rc <<= 1;
    0 === ($a33df4b8f27c9b79$var$rc & 4194240) && ($a33df4b8f27c9b79$var$rc = 64);
    return a;
}
function $a33df4b8f27c9b79$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $a33df4b8f27c9b79$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $a33df4b8f27c9b79$var$oc(b);
    a[b] = c;
}
function $a33df4b8f27c9b79$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $a33df4b8f27c9b79$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $a33df4b8f27c9b79$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $a33df4b8f27c9b79$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $a33df4b8f27c9b79$var$C = 0;
function $a33df4b8f27c9b79$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $a33df4b8f27c9b79$var$Ec, $a33df4b8f27c9b79$var$Fc, $a33df4b8f27c9b79$var$Gc, $a33df4b8f27c9b79$var$Hc, $a33df4b8f27c9b79$var$Ic, $a33df4b8f27c9b79$var$Jc = !1, $a33df4b8f27c9b79$var$Kc = [], $a33df4b8f27c9b79$var$Lc = null, $a33df4b8f27c9b79$var$Mc = null, $a33df4b8f27c9b79$var$Nc = null, $a33df4b8f27c9b79$var$Oc = new Map, $a33df4b8f27c9b79$var$Pc = new Map, $a33df4b8f27c9b79$var$Qc = [], $a33df4b8f27c9b79$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $a33df4b8f27c9b79$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $a33df4b8f27c9b79$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $a33df4b8f27c9b79$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $a33df4b8f27c9b79$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $a33df4b8f27c9b79$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $a33df4b8f27c9b79$var$Pc.delete(b.pointerId);
    }
}
function $a33df4b8f27c9b79$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $a33df4b8f27c9b79$var$Cb(b), null !== b && $a33df4b8f27c9b79$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $a33df4b8f27c9b79$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $a33df4b8f27c9b79$var$Lc = $a33df4b8f27c9b79$var$Tc($a33df4b8f27c9b79$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $a33df4b8f27c9b79$var$Mc = $a33df4b8f27c9b79$var$Tc($a33df4b8f27c9b79$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $a33df4b8f27c9b79$var$Nc = $a33df4b8f27c9b79$var$Tc($a33df4b8f27c9b79$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $a33df4b8f27c9b79$var$Oc.set(f, $a33df4b8f27c9b79$var$Tc($a33df4b8f27c9b79$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $a33df4b8f27c9b79$var$Pc.set(f, $a33df4b8f27c9b79$var$Tc($a33df4b8f27c9b79$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $a33df4b8f27c9b79$var$Vc(a) {
    var b = $a33df4b8f27c9b79$var$Wc(a.target);
    if (null !== b) {
        var c = $a33df4b8f27c9b79$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $a33df4b8f27c9b79$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $a33df4b8f27c9b79$var$Ic(a.priority, function() {
                        $a33df4b8f27c9b79$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $a33df4b8f27c9b79$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $a33df4b8f27c9b79$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $a33df4b8f27c9b79$var$wb = d;
            c.target.dispatchEvent(d);
            $a33df4b8f27c9b79$var$wb = null;
        } else return b = $a33df4b8f27c9b79$var$Cb(c), null !== b && $a33df4b8f27c9b79$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $a33df4b8f27c9b79$var$Zc(a, b, c) {
    $a33df4b8f27c9b79$var$Xc(a) && c.delete(b);
}
function $a33df4b8f27c9b79$var$$c() {
    $a33df4b8f27c9b79$var$Jc = !1;
    null !== $a33df4b8f27c9b79$var$Lc && $a33df4b8f27c9b79$var$Xc($a33df4b8f27c9b79$var$Lc) && ($a33df4b8f27c9b79$var$Lc = null);
    null !== $a33df4b8f27c9b79$var$Mc && $a33df4b8f27c9b79$var$Xc($a33df4b8f27c9b79$var$Mc) && ($a33df4b8f27c9b79$var$Mc = null);
    null !== $a33df4b8f27c9b79$var$Nc && $a33df4b8f27c9b79$var$Xc($a33df4b8f27c9b79$var$Nc) && ($a33df4b8f27c9b79$var$Nc = null);
    $a33df4b8f27c9b79$var$Oc.forEach($a33df4b8f27c9b79$var$Zc);
    $a33df4b8f27c9b79$var$Pc.forEach($a33df4b8f27c9b79$var$Zc);
}
function $a33df4b8f27c9b79$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $a33df4b8f27c9b79$var$Jc || ($a33df4b8f27c9b79$var$Jc = !0, $j5eGm.unstable_scheduleCallback($j5eGm.unstable_NormalPriority, $a33df4b8f27c9b79$var$$c)));
}
function $a33df4b8f27c9b79$var$bd(a) {
    function b(b) {
        return $a33df4b8f27c9b79$var$ad(b, a);
    }
    if (0 < $a33df4b8f27c9b79$var$Kc.length) {
        $a33df4b8f27c9b79$var$ad($a33df4b8f27c9b79$var$Kc[0], a);
        for(var c = 1; c < $a33df4b8f27c9b79$var$Kc.length; c++){
            var d = $a33df4b8f27c9b79$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $a33df4b8f27c9b79$var$Lc && $a33df4b8f27c9b79$var$ad($a33df4b8f27c9b79$var$Lc, a);
    null !== $a33df4b8f27c9b79$var$Mc && $a33df4b8f27c9b79$var$ad($a33df4b8f27c9b79$var$Mc, a);
    null !== $a33df4b8f27c9b79$var$Nc && $a33df4b8f27c9b79$var$ad($a33df4b8f27c9b79$var$Nc, a);
    $a33df4b8f27c9b79$var$Oc.forEach(b);
    $a33df4b8f27c9b79$var$Pc.forEach(b);
    for(c = 0; c < $a33df4b8f27c9b79$var$Qc.length; c++)d = $a33df4b8f27c9b79$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $a33df4b8f27c9b79$var$Qc.length && (c = $a33df4b8f27c9b79$var$Qc[0], null === c.blockedOn);)$a33df4b8f27c9b79$var$Vc(c), null === c.blockedOn && $a33df4b8f27c9b79$var$Qc.shift();
}
var $a33df4b8f27c9b79$var$cd = $a33df4b8f27c9b79$var$ua.ReactCurrentBatchConfig, $a33df4b8f27c9b79$var$dd = !0;
function $a33df4b8f27c9b79$var$ed(a, b, c, d) {
    var e = $a33df4b8f27c9b79$var$C, f = $a33df4b8f27c9b79$var$cd.transition;
    $a33df4b8f27c9b79$var$cd.transition = null;
    try {
        $a33df4b8f27c9b79$var$C = 1, $a33df4b8f27c9b79$var$fd(a, b, c, d);
    } finally{
        $a33df4b8f27c9b79$var$C = e, $a33df4b8f27c9b79$var$cd.transition = f;
    }
}
function $a33df4b8f27c9b79$var$gd(a, b, c, d) {
    var e = $a33df4b8f27c9b79$var$C, f = $a33df4b8f27c9b79$var$cd.transition;
    $a33df4b8f27c9b79$var$cd.transition = null;
    try {
        $a33df4b8f27c9b79$var$C = 4, $a33df4b8f27c9b79$var$fd(a, b, c, d);
    } finally{
        $a33df4b8f27c9b79$var$C = e, $a33df4b8f27c9b79$var$cd.transition = f;
    }
}
function $a33df4b8f27c9b79$var$fd(a, b, c, d) {
    if ($a33df4b8f27c9b79$var$dd) {
        var e = $a33df4b8f27c9b79$var$Yc(a, b, c, d);
        if (null === e) $a33df4b8f27c9b79$var$hd(a, b, d, $a33df4b8f27c9b79$var$id, c), $a33df4b8f27c9b79$var$Sc(a, d);
        else if ($a33df4b8f27c9b79$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($a33df4b8f27c9b79$var$Sc(a, d), b & 4 && -1 < $a33df4b8f27c9b79$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $a33df4b8f27c9b79$var$Cb(e);
                null !== f && $a33df4b8f27c9b79$var$Ec(f);
                f = $a33df4b8f27c9b79$var$Yc(a, b, c, d);
                null === f && $a33df4b8f27c9b79$var$hd(a, b, d, $a33df4b8f27c9b79$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $a33df4b8f27c9b79$var$hd(a, b, d, null, c);
    }
}
var $a33df4b8f27c9b79$var$id = null;
function $a33df4b8f27c9b79$var$Yc(a, b, c, d) {
    $a33df4b8f27c9b79$var$id = null;
    a = $a33df4b8f27c9b79$var$xb(d);
    a = $a33df4b8f27c9b79$var$Wc(a);
    if (null !== a) {
        if (b = $a33df4b8f27c9b79$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $a33df4b8f27c9b79$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $a33df4b8f27c9b79$var$id = a;
    return null;
}
function $a33df4b8f27c9b79$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($a33df4b8f27c9b79$var$ec()){
                case $a33df4b8f27c9b79$var$fc:
                    return 1;
                case $a33df4b8f27c9b79$var$gc:
                    return 4;
                case $a33df4b8f27c9b79$var$hc:
                case $a33df4b8f27c9b79$var$ic:
                    return 16;
                case $a33df4b8f27c9b79$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $a33df4b8f27c9b79$var$kd = null, $a33df4b8f27c9b79$var$ld = null, $a33df4b8f27c9b79$var$md = null;
function $a33df4b8f27c9b79$var$nd() {
    if ($a33df4b8f27c9b79$var$md) return $a33df4b8f27c9b79$var$md;
    var a, b = $a33df4b8f27c9b79$var$ld, c = b.length, d, e = "value" in $a33df4b8f27c9b79$var$kd ? $a33df4b8f27c9b79$var$kd.value : $a33df4b8f27c9b79$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $a33df4b8f27c9b79$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $a33df4b8f27c9b79$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $a33df4b8f27c9b79$var$pd() {
    return !0;
}
function $a33df4b8f27c9b79$var$qd() {
    return !1;
}
function $a33df4b8f27c9b79$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $a33df4b8f27c9b79$var$pd : $a33df4b8f27c9b79$var$qd;
        this.isPropagationStopped = $a33df4b8f27c9b79$var$qd;
        return this;
    }
    $a33df4b8f27c9b79$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $a33df4b8f27c9b79$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $a33df4b8f27c9b79$var$pd);
        },
        persist: function() {},
        isPersistent: $a33df4b8f27c9b79$var$pd
    });
    return b;
}
var $a33df4b8f27c9b79$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $a33df4b8f27c9b79$var$td = $a33df4b8f27c9b79$var$rd($a33df4b8f27c9b79$var$sd), $a33df4b8f27c9b79$var$ud = $a33df4b8f27c9b79$var$A({}, $a33df4b8f27c9b79$var$sd, {
    view: 0,
    detail: 0
}), $a33df4b8f27c9b79$var$vd = $a33df4b8f27c9b79$var$rd($a33df4b8f27c9b79$var$ud), $a33df4b8f27c9b79$var$wd, $a33df4b8f27c9b79$var$xd, $a33df4b8f27c9b79$var$yd, $a33df4b8f27c9b79$var$Ad = $a33df4b8f27c9b79$var$A({}, $a33df4b8f27c9b79$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $a33df4b8f27c9b79$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $a33df4b8f27c9b79$var$yd && ($a33df4b8f27c9b79$var$yd && "mousemove" === a.type ? ($a33df4b8f27c9b79$var$wd = a.screenX - $a33df4b8f27c9b79$var$yd.screenX, $a33df4b8f27c9b79$var$xd = a.screenY - $a33df4b8f27c9b79$var$yd.screenY) : $a33df4b8f27c9b79$var$xd = $a33df4b8f27c9b79$var$wd = 0, $a33df4b8f27c9b79$var$yd = a);
        return $a33df4b8f27c9b79$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $a33df4b8f27c9b79$var$xd;
    }
}), $a33df4b8f27c9b79$var$Bd = $a33df4b8f27c9b79$var$rd($a33df4b8f27c9b79$var$Ad), $a33df4b8f27c9b79$var$Cd = $a33df4b8f27c9b79$var$A({}, $a33df4b8f27c9b79$var$Ad, {
    dataTransfer: 0
}), $a33df4b8f27c9b79$var$Dd = $a33df4b8f27c9b79$var$rd($a33df4b8f27c9b79$var$Cd), $a33df4b8f27c9b79$var$Ed = $a33df4b8f27c9b79$var$A({}, $a33df4b8f27c9b79$var$ud, {
    relatedTarget: 0
}), $a33df4b8f27c9b79$var$Fd = $a33df4b8f27c9b79$var$rd($a33df4b8f27c9b79$var$Ed), $a33df4b8f27c9b79$var$Gd = $a33df4b8f27c9b79$var$A({}, $a33df4b8f27c9b79$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $a33df4b8f27c9b79$var$Hd = $a33df4b8f27c9b79$var$rd($a33df4b8f27c9b79$var$Gd), $a33df4b8f27c9b79$var$Id = $a33df4b8f27c9b79$var$A({}, $a33df4b8f27c9b79$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $a33df4b8f27c9b79$var$Jd = $a33df4b8f27c9b79$var$rd($a33df4b8f27c9b79$var$Id), $a33df4b8f27c9b79$var$Kd = $a33df4b8f27c9b79$var$A({}, $a33df4b8f27c9b79$var$sd, {
    data: 0
}), $a33df4b8f27c9b79$var$Ld = $a33df4b8f27c9b79$var$rd($a33df4b8f27c9b79$var$Kd), $a33df4b8f27c9b79$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $a33df4b8f27c9b79$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $a33df4b8f27c9b79$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $a33df4b8f27c9b79$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $a33df4b8f27c9b79$var$Od[a]) ? !!b[a] : !1;
}
function $a33df4b8f27c9b79$var$zd() {
    return $a33df4b8f27c9b79$var$Pd;
}
var $a33df4b8f27c9b79$var$Qd = $a33df4b8f27c9b79$var$A({}, $a33df4b8f27c9b79$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $a33df4b8f27c9b79$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $a33df4b8f27c9b79$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $a33df4b8f27c9b79$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $a33df4b8f27c9b79$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $a33df4b8f27c9b79$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $a33df4b8f27c9b79$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $a33df4b8f27c9b79$var$Rd = $a33df4b8f27c9b79$var$rd($a33df4b8f27c9b79$var$Qd), $a33df4b8f27c9b79$var$Sd = $a33df4b8f27c9b79$var$A({}, $a33df4b8f27c9b79$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $a33df4b8f27c9b79$var$Td = $a33df4b8f27c9b79$var$rd($a33df4b8f27c9b79$var$Sd), $a33df4b8f27c9b79$var$Ud = $a33df4b8f27c9b79$var$A({}, $a33df4b8f27c9b79$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $a33df4b8f27c9b79$var$zd
}), $a33df4b8f27c9b79$var$Vd = $a33df4b8f27c9b79$var$rd($a33df4b8f27c9b79$var$Ud), $a33df4b8f27c9b79$var$Wd = $a33df4b8f27c9b79$var$A({}, $a33df4b8f27c9b79$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $a33df4b8f27c9b79$var$Xd = $a33df4b8f27c9b79$var$rd($a33df4b8f27c9b79$var$Wd), $a33df4b8f27c9b79$var$Yd = $a33df4b8f27c9b79$var$A({}, $a33df4b8f27c9b79$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $a33df4b8f27c9b79$var$Zd = $a33df4b8f27c9b79$var$rd($a33df4b8f27c9b79$var$Yd), $a33df4b8f27c9b79$var$$d = [
    9,
    13,
    27,
    32
], $a33df4b8f27c9b79$var$ae = $a33df4b8f27c9b79$var$ia && "CompositionEvent" in window, $a33df4b8f27c9b79$var$be = null;
$a33df4b8f27c9b79$var$ia && "documentMode" in document && ($a33df4b8f27c9b79$var$be = document.documentMode);
var $a33df4b8f27c9b79$var$ce = $a33df4b8f27c9b79$var$ia && "TextEvent" in window && !$a33df4b8f27c9b79$var$be, $a33df4b8f27c9b79$var$de = $a33df4b8f27c9b79$var$ia && (!$a33df4b8f27c9b79$var$ae || $a33df4b8f27c9b79$var$be && 8 < $a33df4b8f27c9b79$var$be && 11 >= $a33df4b8f27c9b79$var$be), $a33df4b8f27c9b79$var$ee = String.fromCharCode(32), $a33df4b8f27c9b79$var$fe = !1;
function $a33df4b8f27c9b79$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $a33df4b8f27c9b79$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $a33df4b8f27c9b79$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $a33df4b8f27c9b79$var$ie = !1;
function $a33df4b8f27c9b79$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $a33df4b8f27c9b79$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $a33df4b8f27c9b79$var$fe = !0;
            return $a33df4b8f27c9b79$var$ee;
        case "textInput":
            return a = b.data, a === $a33df4b8f27c9b79$var$ee && $a33df4b8f27c9b79$var$fe ? null : a;
        default:
            return null;
    }
}
function $a33df4b8f27c9b79$var$ke(a, b) {
    if ($a33df4b8f27c9b79$var$ie) return "compositionend" === a || !$a33df4b8f27c9b79$var$ae && $a33df4b8f27c9b79$var$ge(a, b) ? (a = $a33df4b8f27c9b79$var$nd(), $a33df4b8f27c9b79$var$md = $a33df4b8f27c9b79$var$ld = $a33df4b8f27c9b79$var$kd = null, $a33df4b8f27c9b79$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $a33df4b8f27c9b79$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $a33df4b8f27c9b79$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $a33df4b8f27c9b79$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$a33df4b8f27c9b79$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $a33df4b8f27c9b79$var$ne(a, b, c, d) {
    $a33df4b8f27c9b79$var$Eb(d);
    b = $a33df4b8f27c9b79$var$oe(b, "onChange");
    0 < b.length && (c = new $a33df4b8f27c9b79$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $a33df4b8f27c9b79$var$pe = null, $a33df4b8f27c9b79$var$qe = null;
function $a33df4b8f27c9b79$var$re(a) {
    $a33df4b8f27c9b79$var$se(a, 0);
}
function $a33df4b8f27c9b79$var$te(a) {
    var b = $a33df4b8f27c9b79$var$ue(a);
    if ($a33df4b8f27c9b79$var$Wa(b)) return a;
}
function $a33df4b8f27c9b79$var$ve(a, b) {
    if ("change" === a) return b;
}
var $a33df4b8f27c9b79$var$we = !1;
if ($a33df4b8f27c9b79$var$ia) {
    var $a33df4b8f27c9b79$var$xe;
    if ($a33df4b8f27c9b79$var$ia) {
        var $a33df4b8f27c9b79$var$ye = "oninput" in document;
        if (!$a33df4b8f27c9b79$var$ye) {
            var $a33df4b8f27c9b79$var$ze = document.createElement("div");
            $a33df4b8f27c9b79$var$ze.setAttribute("oninput", "return;");
            $a33df4b8f27c9b79$var$ye = "function" === typeof $a33df4b8f27c9b79$var$ze.oninput;
        }
        $a33df4b8f27c9b79$var$xe = $a33df4b8f27c9b79$var$ye;
    } else $a33df4b8f27c9b79$var$xe = !1;
    $a33df4b8f27c9b79$var$we = $a33df4b8f27c9b79$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $a33df4b8f27c9b79$var$Ae() {
    $a33df4b8f27c9b79$var$pe && ($a33df4b8f27c9b79$var$pe.detachEvent("onpropertychange", $a33df4b8f27c9b79$var$Be), $a33df4b8f27c9b79$var$qe = $a33df4b8f27c9b79$var$pe = null);
}
function $a33df4b8f27c9b79$var$Be(a) {
    if ("value" === a.propertyName && $a33df4b8f27c9b79$var$te($a33df4b8f27c9b79$var$qe)) {
        var b = [];
        $a33df4b8f27c9b79$var$ne(b, $a33df4b8f27c9b79$var$qe, a, $a33df4b8f27c9b79$var$xb(a));
        $a33df4b8f27c9b79$var$Jb($a33df4b8f27c9b79$var$re, b);
    }
}
function $a33df4b8f27c9b79$var$Ce(a, b, c) {
    "focusin" === a ? ($a33df4b8f27c9b79$var$Ae(), $a33df4b8f27c9b79$var$pe = b, $a33df4b8f27c9b79$var$qe = c, $a33df4b8f27c9b79$var$pe.attachEvent("onpropertychange", $a33df4b8f27c9b79$var$Be)) : "focusout" === a && $a33df4b8f27c9b79$var$Ae();
}
function $a33df4b8f27c9b79$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $a33df4b8f27c9b79$var$te($a33df4b8f27c9b79$var$qe);
}
function $a33df4b8f27c9b79$var$Ee(a, b) {
    if ("click" === a) return $a33df4b8f27c9b79$var$te(b);
}
function $a33df4b8f27c9b79$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $a33df4b8f27c9b79$var$te(b);
}
function $a33df4b8f27c9b79$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $a33df4b8f27c9b79$var$He = "function" === typeof Object.is ? Object.is : $a33df4b8f27c9b79$var$Ge;
function $a33df4b8f27c9b79$var$Ie(a, b) {
    if ($a33df4b8f27c9b79$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$a33df4b8f27c9b79$var$ja.call(b, e) || !$a33df4b8f27c9b79$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $a33df4b8f27c9b79$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $a33df4b8f27c9b79$var$Ke(a, b) {
    var c = $a33df4b8f27c9b79$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $a33df4b8f27c9b79$var$Je(c);
    }
}
function $a33df4b8f27c9b79$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $a33df4b8f27c9b79$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $a33df4b8f27c9b79$var$Me() {
    for(var a = window, b = $a33df4b8f27c9b79$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $a33df4b8f27c9b79$var$Xa(a.document);
    }
    return b;
}
function $a33df4b8f27c9b79$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $a33df4b8f27c9b79$var$Oe(a) {
    var b = $a33df4b8f27c9b79$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $a33df4b8f27c9b79$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $a33df4b8f27c9b79$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $a33df4b8f27c9b79$var$Ke(c, f);
                var g = $a33df4b8f27c9b79$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $a33df4b8f27c9b79$var$Pe = $a33df4b8f27c9b79$var$ia && "documentMode" in document && 11 >= document.documentMode, $a33df4b8f27c9b79$var$Qe = null, $a33df4b8f27c9b79$var$Re = null, $a33df4b8f27c9b79$var$Se = null, $a33df4b8f27c9b79$var$Te = !1;
function $a33df4b8f27c9b79$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $a33df4b8f27c9b79$var$Te || null == $a33df4b8f27c9b79$var$Qe || $a33df4b8f27c9b79$var$Qe !== $a33df4b8f27c9b79$var$Xa(d) || (d = $a33df4b8f27c9b79$var$Qe, "selectionStart" in d && $a33df4b8f27c9b79$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $a33df4b8f27c9b79$var$Se && $a33df4b8f27c9b79$var$Ie($a33df4b8f27c9b79$var$Se, d) || ($a33df4b8f27c9b79$var$Se = d, d = $a33df4b8f27c9b79$var$oe($a33df4b8f27c9b79$var$Re, "onSelect"), 0 < d.length && (b = new $a33df4b8f27c9b79$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $a33df4b8f27c9b79$var$Qe)));
}
function $a33df4b8f27c9b79$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $a33df4b8f27c9b79$var$We = {
    animationend: $a33df4b8f27c9b79$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $a33df4b8f27c9b79$var$Ve("Animation", "AnimationIteration"),
    animationstart: $a33df4b8f27c9b79$var$Ve("Animation", "AnimationStart"),
    transitionend: $a33df4b8f27c9b79$var$Ve("Transition", "TransitionEnd")
}, $a33df4b8f27c9b79$var$Xe = {}, $a33df4b8f27c9b79$var$Ye = {};
$a33df4b8f27c9b79$var$ia && ($a33df4b8f27c9b79$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $a33df4b8f27c9b79$var$We.animationend.animation, delete $a33df4b8f27c9b79$var$We.animationiteration.animation, delete $a33df4b8f27c9b79$var$We.animationstart.animation), "TransitionEvent" in window || delete $a33df4b8f27c9b79$var$We.transitionend.transition);
function $a33df4b8f27c9b79$var$Ze(a) {
    if ($a33df4b8f27c9b79$var$Xe[a]) return $a33df4b8f27c9b79$var$Xe[a];
    if (!$a33df4b8f27c9b79$var$We[a]) return a;
    var b = $a33df4b8f27c9b79$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $a33df4b8f27c9b79$var$Ye) return $a33df4b8f27c9b79$var$Xe[a] = b[c];
    return a;
}
var $a33df4b8f27c9b79$var$$e = $a33df4b8f27c9b79$var$Ze("animationend"), $a33df4b8f27c9b79$var$af = $a33df4b8f27c9b79$var$Ze("animationiteration"), $a33df4b8f27c9b79$var$bf = $a33df4b8f27c9b79$var$Ze("animationstart"), $a33df4b8f27c9b79$var$cf = $a33df4b8f27c9b79$var$Ze("transitionend"), $a33df4b8f27c9b79$var$df = new Map, $a33df4b8f27c9b79$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $a33df4b8f27c9b79$var$ff(a, b) {
    $a33df4b8f27c9b79$var$df.set(a, b);
    $a33df4b8f27c9b79$var$fa(b, [
        a
    ]);
}
for(var $a33df4b8f27c9b79$var$gf = 0; $a33df4b8f27c9b79$var$gf < $a33df4b8f27c9b79$var$ef.length; $a33df4b8f27c9b79$var$gf++){
    var $a33df4b8f27c9b79$var$hf = $a33df4b8f27c9b79$var$ef[$a33df4b8f27c9b79$var$gf], $a33df4b8f27c9b79$var$jf = $a33df4b8f27c9b79$var$hf.toLowerCase(), $a33df4b8f27c9b79$var$kf = $a33df4b8f27c9b79$var$hf[0].toUpperCase() + $a33df4b8f27c9b79$var$hf.slice(1);
    $a33df4b8f27c9b79$var$ff($a33df4b8f27c9b79$var$jf, "on" + $a33df4b8f27c9b79$var$kf);
}
$a33df4b8f27c9b79$var$ff($a33df4b8f27c9b79$var$$e, "onAnimationEnd");
$a33df4b8f27c9b79$var$ff($a33df4b8f27c9b79$var$af, "onAnimationIteration");
$a33df4b8f27c9b79$var$ff($a33df4b8f27c9b79$var$bf, "onAnimationStart");
$a33df4b8f27c9b79$var$ff("dblclick", "onDoubleClick");
$a33df4b8f27c9b79$var$ff("focusin", "onFocus");
$a33df4b8f27c9b79$var$ff("focusout", "onBlur");
$a33df4b8f27c9b79$var$ff($a33df4b8f27c9b79$var$cf, "onTransitionEnd");
$a33df4b8f27c9b79$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$a33df4b8f27c9b79$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$a33df4b8f27c9b79$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$a33df4b8f27c9b79$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$a33df4b8f27c9b79$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$a33df4b8f27c9b79$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$a33df4b8f27c9b79$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$a33df4b8f27c9b79$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$a33df4b8f27c9b79$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$a33df4b8f27c9b79$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $a33df4b8f27c9b79$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $a33df4b8f27c9b79$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($a33df4b8f27c9b79$var$lf));
function $a33df4b8f27c9b79$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $a33df4b8f27c9b79$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $a33df4b8f27c9b79$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $a33df4b8f27c9b79$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $a33df4b8f27c9b79$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($a33df4b8f27c9b79$var$Qb) throw a = $a33df4b8f27c9b79$var$Rb, $a33df4b8f27c9b79$var$Qb = !1, $a33df4b8f27c9b79$var$Rb = null, a;
}
function $a33df4b8f27c9b79$var$D(a, b) {
    var c = b[$a33df4b8f27c9b79$var$of];
    void 0 === c && (c = b[$a33df4b8f27c9b79$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($a33df4b8f27c9b79$var$pf(b, a, 2, !1), c.add(d));
}
function $a33df4b8f27c9b79$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $a33df4b8f27c9b79$var$pf(c, a, d, b);
}
var $a33df4b8f27c9b79$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $a33df4b8f27c9b79$var$sf(a) {
    if (!a[$a33df4b8f27c9b79$var$rf]) {
        a[$a33df4b8f27c9b79$var$rf] = !0;
        $a33df4b8f27c9b79$var$da.forEach(function(b) {
            "selectionchange" !== b && ($a33df4b8f27c9b79$var$mf.has(b) || $a33df4b8f27c9b79$var$qf(b, !1, a), $a33df4b8f27c9b79$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$a33df4b8f27c9b79$var$rf] || (b[$a33df4b8f27c9b79$var$rf] = !0, $a33df4b8f27c9b79$var$qf("selectionchange", !1, b));
    }
}
function $a33df4b8f27c9b79$var$pf(a, b, c, d) {
    switch($a33df4b8f27c9b79$var$jd(b)){
        case 1:
            var e = $a33df4b8f27c9b79$var$ed;
            break;
        case 4:
            e = $a33df4b8f27c9b79$var$gd;
            break;
        default:
            e = $a33df4b8f27c9b79$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$a33df4b8f27c9b79$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $a33df4b8f27c9b79$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $a33df4b8f27c9b79$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $a33df4b8f27c9b79$var$Jb(function() {
        var d = f, e = $a33df4b8f27c9b79$var$xb(c), g = [];
        a: {
            var h = $a33df4b8f27c9b79$var$df.get(a);
            if (void 0 !== h) {
                var k = $a33df4b8f27c9b79$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $a33df4b8f27c9b79$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $a33df4b8f27c9b79$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $a33df4b8f27c9b79$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $a33df4b8f27c9b79$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $a33df4b8f27c9b79$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $a33df4b8f27c9b79$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $a33df4b8f27c9b79$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $a33df4b8f27c9b79$var$Vd;
                        break;
                    case $a33df4b8f27c9b79$var$$e:
                    case $a33df4b8f27c9b79$var$af:
                    case $a33df4b8f27c9b79$var$bf:
                        k = $a33df4b8f27c9b79$var$Hd;
                        break;
                    case $a33df4b8f27c9b79$var$cf:
                        k = $a33df4b8f27c9b79$var$Xd;
                        break;
                    case "scroll":
                        k = $a33df4b8f27c9b79$var$vd;
                        break;
                    case "wheel":
                        k = $a33df4b8f27c9b79$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $a33df4b8f27c9b79$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $a33df4b8f27c9b79$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $a33df4b8f27c9b79$var$Kb(w, x), null != F && t.push($a33df4b8f27c9b79$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $a33df4b8f27c9b79$var$wb && (n = c.relatedTarget || c.fromElement) && ($a33df4b8f27c9b79$var$Wc(n) || n[$a33df4b8f27c9b79$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $a33df4b8f27c9b79$var$Wc(n) : null, null !== n && (J = $a33df4b8f27c9b79$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $a33df4b8f27c9b79$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $a33df4b8f27c9b79$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $a33df4b8f27c9b79$var$ue(k);
                        u = null == n ? h : $a33df4b8f27c9b79$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $a33df4b8f27c9b79$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $a33df4b8f27c9b79$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $a33df4b8f27c9b79$var$vf(F))u++;
                            for(; 0 < w - u;)t = $a33df4b8f27c9b79$var$vf(t), w--;
                            for(; 0 < u - w;)x = $a33df4b8f27c9b79$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $a33df4b8f27c9b79$var$vf(t);
                                x = $a33df4b8f27c9b79$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $a33df4b8f27c9b79$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $a33df4b8f27c9b79$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $a33df4b8f27c9b79$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $a33df4b8f27c9b79$var$ve;
                else if ($a33df4b8f27c9b79$var$me(h)) {
                    if ($a33df4b8f27c9b79$var$we) na = $a33df4b8f27c9b79$var$Fe;
                    else {
                        na = $a33df4b8f27c9b79$var$De;
                        var xa = $a33df4b8f27c9b79$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $a33df4b8f27c9b79$var$Ee);
                if (na && (na = na(a, d))) {
                    $a33df4b8f27c9b79$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $a33df4b8f27c9b79$var$cb(h, "number", h.value);
            }
            xa = d ? $a33df4b8f27c9b79$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($a33df4b8f27c9b79$var$me(xa) || "true" === xa.contentEditable) $a33df4b8f27c9b79$var$Qe = xa, $a33df4b8f27c9b79$var$Re = d, $a33df4b8f27c9b79$var$Se = null;
                    break;
                case "focusout":
                    $a33df4b8f27c9b79$var$Se = $a33df4b8f27c9b79$var$Re = $a33df4b8f27c9b79$var$Qe = null;
                    break;
                case "mousedown":
                    $a33df4b8f27c9b79$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $a33df4b8f27c9b79$var$Te = !1;
                    $a33df4b8f27c9b79$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($a33df4b8f27c9b79$var$Pe) break;
                case "keydown":
                case "keyup":
                    $a33df4b8f27c9b79$var$Ue(g, c, e);
            }
            var $a;
            if ($a33df4b8f27c9b79$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $a33df4b8f27c9b79$var$ie ? $a33df4b8f27c9b79$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($a33df4b8f27c9b79$var$de && "ko" !== c.locale && ($a33df4b8f27c9b79$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $a33df4b8f27c9b79$var$ie && ($a = $a33df4b8f27c9b79$var$nd()) : ($a33df4b8f27c9b79$var$kd = e, $a33df4b8f27c9b79$var$ld = "value" in $a33df4b8f27c9b79$var$kd ? $a33df4b8f27c9b79$var$kd.value : $a33df4b8f27c9b79$var$kd.textContent, $a33df4b8f27c9b79$var$ie = !0)), xa = $a33df4b8f27c9b79$var$oe(d, ba), 0 < xa.length && (ba = new $a33df4b8f27c9b79$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $a33df4b8f27c9b79$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $a33df4b8f27c9b79$var$ce ? $a33df4b8f27c9b79$var$je(a, c) : $a33df4b8f27c9b79$var$ke(a, c)) d = $a33df4b8f27c9b79$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $a33df4b8f27c9b79$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $a33df4b8f27c9b79$var$se(g, b);
    });
}
function $a33df4b8f27c9b79$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $a33df4b8f27c9b79$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $a33df4b8f27c9b79$var$Kb(a, c), null != f && d.unshift($a33df4b8f27c9b79$var$tf(a, f, e)), f = $a33df4b8f27c9b79$var$Kb(a, b), null != f && d.push($a33df4b8f27c9b79$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $a33df4b8f27c9b79$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $a33df4b8f27c9b79$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $a33df4b8f27c9b79$var$Kb(c, f), null != k && g.unshift($a33df4b8f27c9b79$var$tf(c, k, h))) : e || (k = $a33df4b8f27c9b79$var$Kb(c, f), null != k && g.push($a33df4b8f27c9b79$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $a33df4b8f27c9b79$var$xf = /\r\n?/g, $a33df4b8f27c9b79$var$yf = /\u0000|\uFFFD/g;
function $a33df4b8f27c9b79$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($a33df4b8f27c9b79$var$xf, "\n").replace($a33df4b8f27c9b79$var$yf, "");
}
function $a33df4b8f27c9b79$var$Af(a, b, c) {
    b = $a33df4b8f27c9b79$var$zf(b);
    if ($a33df4b8f27c9b79$var$zf(a) !== b && c) throw Error($a33df4b8f27c9b79$var$p(425));
}
function $a33df4b8f27c9b79$var$Bf() {}
var $a33df4b8f27c9b79$var$Cf = null, $a33df4b8f27c9b79$var$Df = null;
function $a33df4b8f27c9b79$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $a33df4b8f27c9b79$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $a33df4b8f27c9b79$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $a33df4b8f27c9b79$var$Hf = "function" === typeof Promise ? Promise : void 0, $a33df4b8f27c9b79$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $a33df4b8f27c9b79$var$Hf ? function(a) {
    return $a33df4b8f27c9b79$var$Hf.resolve(null).then(a).catch($a33df4b8f27c9b79$var$If);
} : $a33df4b8f27c9b79$var$Ff;
function $a33df4b8f27c9b79$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $a33df4b8f27c9b79$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $a33df4b8f27c9b79$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $a33df4b8f27c9b79$var$bd(b);
}
function $a33df4b8f27c9b79$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $a33df4b8f27c9b79$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $a33df4b8f27c9b79$var$Nf = Math.random().toString(36).slice(2), $a33df4b8f27c9b79$var$Of = "__reactFiber$" + $a33df4b8f27c9b79$var$Nf, $a33df4b8f27c9b79$var$Pf = "__reactProps$" + $a33df4b8f27c9b79$var$Nf, $a33df4b8f27c9b79$var$uf = "__reactContainer$" + $a33df4b8f27c9b79$var$Nf, $a33df4b8f27c9b79$var$of = "__reactEvents$" + $a33df4b8f27c9b79$var$Nf, $a33df4b8f27c9b79$var$Qf = "__reactListeners$" + $a33df4b8f27c9b79$var$Nf, $a33df4b8f27c9b79$var$Rf = "__reactHandles$" + $a33df4b8f27c9b79$var$Nf;
function $a33df4b8f27c9b79$var$Wc(a) {
    var b = a[$a33df4b8f27c9b79$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$a33df4b8f27c9b79$var$uf] || c[$a33df4b8f27c9b79$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $a33df4b8f27c9b79$var$Mf(a); null !== a;){
                if (c = a[$a33df4b8f27c9b79$var$Of]) return c;
                a = $a33df4b8f27c9b79$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $a33df4b8f27c9b79$var$Cb(a) {
    a = a[$a33df4b8f27c9b79$var$Of] || a[$a33df4b8f27c9b79$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $a33df4b8f27c9b79$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($a33df4b8f27c9b79$var$p(33));
}
function $a33df4b8f27c9b79$var$Db(a) {
    return a[$a33df4b8f27c9b79$var$Pf] || null;
}
var $a33df4b8f27c9b79$var$Sf = [], $a33df4b8f27c9b79$var$Tf = -1;
function $a33df4b8f27c9b79$var$Uf(a) {
    return {
        current: a
    };
}
function $a33df4b8f27c9b79$var$E(a) {
    0 > $a33df4b8f27c9b79$var$Tf || (a.current = $a33df4b8f27c9b79$var$Sf[$a33df4b8f27c9b79$var$Tf], $a33df4b8f27c9b79$var$Sf[$a33df4b8f27c9b79$var$Tf] = null, $a33df4b8f27c9b79$var$Tf--);
}
function $a33df4b8f27c9b79$var$G(a, b) {
    $a33df4b8f27c9b79$var$Tf++;
    $a33df4b8f27c9b79$var$Sf[$a33df4b8f27c9b79$var$Tf] = a.current;
    a.current = b;
}
var $a33df4b8f27c9b79$var$Vf = {}, $a33df4b8f27c9b79$var$H = $a33df4b8f27c9b79$var$Uf($a33df4b8f27c9b79$var$Vf), $a33df4b8f27c9b79$var$Wf = $a33df4b8f27c9b79$var$Uf(!1), $a33df4b8f27c9b79$var$Xf = $a33df4b8f27c9b79$var$Vf;
function $a33df4b8f27c9b79$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $a33df4b8f27c9b79$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $a33df4b8f27c9b79$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $a33df4b8f27c9b79$var$$f() {
    $a33df4b8f27c9b79$var$E($a33df4b8f27c9b79$var$Wf);
    $a33df4b8f27c9b79$var$E($a33df4b8f27c9b79$var$H);
}
function $a33df4b8f27c9b79$var$ag(a, b, c) {
    if ($a33df4b8f27c9b79$var$H.current !== $a33df4b8f27c9b79$var$Vf) throw Error($a33df4b8f27c9b79$var$p(168));
    $a33df4b8f27c9b79$var$G($a33df4b8f27c9b79$var$H, b);
    $a33df4b8f27c9b79$var$G($a33df4b8f27c9b79$var$Wf, c);
}
function $a33df4b8f27c9b79$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($a33df4b8f27c9b79$var$p(108, $a33df4b8f27c9b79$var$Ra(a) || "Unknown", e));
    return $a33df4b8f27c9b79$var$A({}, c, d);
}
function $a33df4b8f27c9b79$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $a33df4b8f27c9b79$var$Vf;
    $a33df4b8f27c9b79$var$Xf = $a33df4b8f27c9b79$var$H.current;
    $a33df4b8f27c9b79$var$G($a33df4b8f27c9b79$var$H, a);
    $a33df4b8f27c9b79$var$G($a33df4b8f27c9b79$var$Wf, $a33df4b8f27c9b79$var$Wf.current);
    return !0;
}
function $a33df4b8f27c9b79$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($a33df4b8f27c9b79$var$p(169));
    c ? (a = $a33df4b8f27c9b79$var$bg(a, b, $a33df4b8f27c9b79$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $a33df4b8f27c9b79$var$E($a33df4b8f27c9b79$var$Wf), $a33df4b8f27c9b79$var$E($a33df4b8f27c9b79$var$H), $a33df4b8f27c9b79$var$G($a33df4b8f27c9b79$var$H, a)) : $a33df4b8f27c9b79$var$E($a33df4b8f27c9b79$var$Wf);
    $a33df4b8f27c9b79$var$G($a33df4b8f27c9b79$var$Wf, c);
}
var $a33df4b8f27c9b79$var$eg = null, $a33df4b8f27c9b79$var$fg = !1, $a33df4b8f27c9b79$var$gg = !1;
function $a33df4b8f27c9b79$var$hg(a) {
    null === $a33df4b8f27c9b79$var$eg ? $a33df4b8f27c9b79$var$eg = [
        a
    ] : $a33df4b8f27c9b79$var$eg.push(a);
}
function $a33df4b8f27c9b79$var$ig(a) {
    $a33df4b8f27c9b79$var$fg = !0;
    $a33df4b8f27c9b79$var$hg(a);
}
function $a33df4b8f27c9b79$var$jg() {
    if (!$a33df4b8f27c9b79$var$gg && null !== $a33df4b8f27c9b79$var$eg) {
        $a33df4b8f27c9b79$var$gg = !0;
        var a = 0, b = $a33df4b8f27c9b79$var$C;
        try {
            var c = $a33df4b8f27c9b79$var$eg;
            for($a33df4b8f27c9b79$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $a33df4b8f27c9b79$var$eg = null;
            $a33df4b8f27c9b79$var$fg = !1;
        } catch (e) {
            throw null !== $a33df4b8f27c9b79$var$eg && ($a33df4b8f27c9b79$var$eg = $a33df4b8f27c9b79$var$eg.slice(a + 1)), $a33df4b8f27c9b79$var$ac($a33df4b8f27c9b79$var$fc, $a33df4b8f27c9b79$var$jg), e;
        } finally{
            $a33df4b8f27c9b79$var$C = b, $a33df4b8f27c9b79$var$gg = !1;
        }
    }
    return null;
}
var $a33df4b8f27c9b79$var$kg = [], $a33df4b8f27c9b79$var$lg = 0, $a33df4b8f27c9b79$var$mg = null, $a33df4b8f27c9b79$var$ng = 0, $a33df4b8f27c9b79$var$og = [], $a33df4b8f27c9b79$var$pg = 0, $a33df4b8f27c9b79$var$qg = null, $a33df4b8f27c9b79$var$rg = 1, $a33df4b8f27c9b79$var$sg = "";
function $a33df4b8f27c9b79$var$tg(a, b) {
    $a33df4b8f27c9b79$var$kg[$a33df4b8f27c9b79$var$lg++] = $a33df4b8f27c9b79$var$ng;
    $a33df4b8f27c9b79$var$kg[$a33df4b8f27c9b79$var$lg++] = $a33df4b8f27c9b79$var$mg;
    $a33df4b8f27c9b79$var$mg = a;
    $a33df4b8f27c9b79$var$ng = b;
}
function $a33df4b8f27c9b79$var$ug(a, b, c) {
    $a33df4b8f27c9b79$var$og[$a33df4b8f27c9b79$var$pg++] = $a33df4b8f27c9b79$var$rg;
    $a33df4b8f27c9b79$var$og[$a33df4b8f27c9b79$var$pg++] = $a33df4b8f27c9b79$var$sg;
    $a33df4b8f27c9b79$var$og[$a33df4b8f27c9b79$var$pg++] = $a33df4b8f27c9b79$var$qg;
    $a33df4b8f27c9b79$var$qg = a;
    var d = $a33df4b8f27c9b79$var$rg;
    a = $a33df4b8f27c9b79$var$sg;
    var e = 32 - $a33df4b8f27c9b79$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $a33df4b8f27c9b79$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $a33df4b8f27c9b79$var$rg = 1 << 32 - $a33df4b8f27c9b79$var$oc(b) + e | c << e | d;
        $a33df4b8f27c9b79$var$sg = f + a;
    } else $a33df4b8f27c9b79$var$rg = 1 << f | c << e | d, $a33df4b8f27c9b79$var$sg = a;
}
function $a33df4b8f27c9b79$var$vg(a) {
    null !== a.return && ($a33df4b8f27c9b79$var$tg(a, 1), $a33df4b8f27c9b79$var$ug(a, 1, 0));
}
function $a33df4b8f27c9b79$var$wg(a) {
    for(; a === $a33df4b8f27c9b79$var$mg;)$a33df4b8f27c9b79$var$mg = $a33df4b8f27c9b79$var$kg[--$a33df4b8f27c9b79$var$lg], $a33df4b8f27c9b79$var$kg[$a33df4b8f27c9b79$var$lg] = null, $a33df4b8f27c9b79$var$ng = $a33df4b8f27c9b79$var$kg[--$a33df4b8f27c9b79$var$lg], $a33df4b8f27c9b79$var$kg[$a33df4b8f27c9b79$var$lg] = null;
    for(; a === $a33df4b8f27c9b79$var$qg;)$a33df4b8f27c9b79$var$qg = $a33df4b8f27c9b79$var$og[--$a33df4b8f27c9b79$var$pg], $a33df4b8f27c9b79$var$og[$a33df4b8f27c9b79$var$pg] = null, $a33df4b8f27c9b79$var$sg = $a33df4b8f27c9b79$var$og[--$a33df4b8f27c9b79$var$pg], $a33df4b8f27c9b79$var$og[$a33df4b8f27c9b79$var$pg] = null, $a33df4b8f27c9b79$var$rg = $a33df4b8f27c9b79$var$og[--$a33df4b8f27c9b79$var$pg], $a33df4b8f27c9b79$var$og[$a33df4b8f27c9b79$var$pg] = null;
}
var $a33df4b8f27c9b79$var$xg = null, $a33df4b8f27c9b79$var$yg = null, $a33df4b8f27c9b79$var$I = !1, $a33df4b8f27c9b79$var$zg = null;
function $a33df4b8f27c9b79$var$Ag(a, b) {
    var c = $a33df4b8f27c9b79$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $a33df4b8f27c9b79$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $a33df4b8f27c9b79$var$xg = a, $a33df4b8f27c9b79$var$yg = $a33df4b8f27c9b79$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $a33df4b8f27c9b79$var$xg = a, $a33df4b8f27c9b79$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $a33df4b8f27c9b79$var$qg ? {
                id: $a33df4b8f27c9b79$var$rg,
                overflow: $a33df4b8f27c9b79$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $a33df4b8f27c9b79$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $a33df4b8f27c9b79$var$xg = a, $a33df4b8f27c9b79$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $a33df4b8f27c9b79$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $a33df4b8f27c9b79$var$Eg(a) {
    if ($a33df4b8f27c9b79$var$I) {
        var b = $a33df4b8f27c9b79$var$yg;
        if (b) {
            var c = b;
            if (!$a33df4b8f27c9b79$var$Cg(a, b)) {
                if ($a33df4b8f27c9b79$var$Dg(a)) throw Error($a33df4b8f27c9b79$var$p(418));
                b = $a33df4b8f27c9b79$var$Lf(c.nextSibling);
                var d = $a33df4b8f27c9b79$var$xg;
                b && $a33df4b8f27c9b79$var$Cg(a, b) ? $a33df4b8f27c9b79$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $a33df4b8f27c9b79$var$I = !1, $a33df4b8f27c9b79$var$xg = a);
            }
        } else {
            if ($a33df4b8f27c9b79$var$Dg(a)) throw Error($a33df4b8f27c9b79$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $a33df4b8f27c9b79$var$I = !1;
            $a33df4b8f27c9b79$var$xg = a;
        }
    }
}
function $a33df4b8f27c9b79$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $a33df4b8f27c9b79$var$xg = a;
}
function $a33df4b8f27c9b79$var$Gg(a) {
    if (a !== $a33df4b8f27c9b79$var$xg) return !1;
    if (!$a33df4b8f27c9b79$var$I) return $a33df4b8f27c9b79$var$Fg(a), $a33df4b8f27c9b79$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$a33df4b8f27c9b79$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $a33df4b8f27c9b79$var$yg)) {
        if ($a33df4b8f27c9b79$var$Dg(a)) throw $a33df4b8f27c9b79$var$Hg(), Error($a33df4b8f27c9b79$var$p(418));
        for(; b;)$a33df4b8f27c9b79$var$Ag(a, b), b = $a33df4b8f27c9b79$var$Lf(b.nextSibling);
    }
    $a33df4b8f27c9b79$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($a33df4b8f27c9b79$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $a33df4b8f27c9b79$var$yg = $a33df4b8f27c9b79$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $a33df4b8f27c9b79$var$yg = null;
        }
    } else $a33df4b8f27c9b79$var$yg = $a33df4b8f27c9b79$var$xg ? $a33df4b8f27c9b79$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $a33df4b8f27c9b79$var$Hg() {
    for(var a = $a33df4b8f27c9b79$var$yg; a;)a = $a33df4b8f27c9b79$var$Lf(a.nextSibling);
}
function $a33df4b8f27c9b79$var$Ig() {
    $a33df4b8f27c9b79$var$yg = $a33df4b8f27c9b79$var$xg = null;
    $a33df4b8f27c9b79$var$I = !1;
}
function $a33df4b8f27c9b79$var$Jg(a) {
    null === $a33df4b8f27c9b79$var$zg ? $a33df4b8f27c9b79$var$zg = [
        a
    ] : $a33df4b8f27c9b79$var$zg.push(a);
}
var $a33df4b8f27c9b79$var$Kg = $a33df4b8f27c9b79$var$ua.ReactCurrentBatchConfig;
function $a33df4b8f27c9b79$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $a33df4b8f27c9b79$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $a33df4b8f27c9b79$var$Mg = $a33df4b8f27c9b79$var$Uf(null), $a33df4b8f27c9b79$var$Ng = null, $a33df4b8f27c9b79$var$Og = null, $a33df4b8f27c9b79$var$Pg = null;
function $a33df4b8f27c9b79$var$Qg() {
    $a33df4b8f27c9b79$var$Pg = $a33df4b8f27c9b79$var$Og = $a33df4b8f27c9b79$var$Ng = null;
}
function $a33df4b8f27c9b79$var$Rg(a) {
    var b = $a33df4b8f27c9b79$var$Mg.current;
    $a33df4b8f27c9b79$var$E($a33df4b8f27c9b79$var$Mg);
    a._currentValue = b;
}
function $a33df4b8f27c9b79$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $a33df4b8f27c9b79$var$Tg(a, b) {
    $a33df4b8f27c9b79$var$Ng = a;
    $a33df4b8f27c9b79$var$Pg = $a33df4b8f27c9b79$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($a33df4b8f27c9b79$var$Ug = !0), a.firstContext = null);
}
function $a33df4b8f27c9b79$var$Vg(a) {
    var b = a._currentValue;
    if ($a33df4b8f27c9b79$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $a33df4b8f27c9b79$var$Og) {
            if (null === $a33df4b8f27c9b79$var$Ng) throw Error($a33df4b8f27c9b79$var$p(308));
            $a33df4b8f27c9b79$var$Og = a;
            $a33df4b8f27c9b79$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $a33df4b8f27c9b79$var$Og = $a33df4b8f27c9b79$var$Og.next = a;
    }
    return b;
}
var $a33df4b8f27c9b79$var$Wg = null;
function $a33df4b8f27c9b79$var$Xg(a) {
    null === $a33df4b8f27c9b79$var$Wg ? $a33df4b8f27c9b79$var$Wg = [
        a
    ] : $a33df4b8f27c9b79$var$Wg.push(a);
}
function $a33df4b8f27c9b79$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $a33df4b8f27c9b79$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $a33df4b8f27c9b79$var$Zg(a, d);
}
function $a33df4b8f27c9b79$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $a33df4b8f27c9b79$var$$g = !1;
function $a33df4b8f27c9b79$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $a33df4b8f27c9b79$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $a33df4b8f27c9b79$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $a33df4b8f27c9b79$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($a33df4b8f27c9b79$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $a33df4b8f27c9b79$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $a33df4b8f27c9b79$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $a33df4b8f27c9b79$var$Zg(a, c);
}
function $a33df4b8f27c9b79$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $a33df4b8f27c9b79$var$Cc(a, c);
    }
}
function $a33df4b8f27c9b79$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $a33df4b8f27c9b79$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $a33df4b8f27c9b79$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $a33df4b8f27c9b79$var$A({}, q, r);
                            break a;
                        case 2:
                            $a33df4b8f27c9b79$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $a33df4b8f27c9b79$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $a33df4b8f27c9b79$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($a33df4b8f27c9b79$var$p(191, e));
            e.call(d);
        }
    }
}
var $a33df4b8f27c9b79$var$jh = (new $lBnVc.Component).refs;
function $a33df4b8f27c9b79$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $a33df4b8f27c9b79$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $a33df4b8f27c9b79$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $a33df4b8f27c9b79$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $a33df4b8f27c9b79$var$L(), e = $a33df4b8f27c9b79$var$lh(a), f = $a33df4b8f27c9b79$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $a33df4b8f27c9b79$var$dh(a, f, e);
        null !== b && ($a33df4b8f27c9b79$var$mh(b, a, e, d), $a33df4b8f27c9b79$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $a33df4b8f27c9b79$var$L(), e = $a33df4b8f27c9b79$var$lh(a), f = $a33df4b8f27c9b79$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $a33df4b8f27c9b79$var$dh(a, f, e);
        null !== b && ($a33df4b8f27c9b79$var$mh(b, a, e, d), $a33df4b8f27c9b79$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $a33df4b8f27c9b79$var$L(), d = $a33df4b8f27c9b79$var$lh(a), e = $a33df4b8f27c9b79$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $a33df4b8f27c9b79$var$dh(a, e, d);
        null !== b && ($a33df4b8f27c9b79$var$mh(b, a, d, c), $a33df4b8f27c9b79$var$eh(b, a, d));
    }
};
function $a33df4b8f27c9b79$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$a33df4b8f27c9b79$var$Ie(c, d) || !$a33df4b8f27c9b79$var$Ie(e, f) : !0;
}
function $a33df4b8f27c9b79$var$ph(a, b, c) {
    var d = !1, e = $a33df4b8f27c9b79$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $a33df4b8f27c9b79$var$Vg(f) : (e = $a33df4b8f27c9b79$var$Zf(b) ? $a33df4b8f27c9b79$var$Xf : $a33df4b8f27c9b79$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $a33df4b8f27c9b79$var$Yf(a, e) : $a33df4b8f27c9b79$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $a33df4b8f27c9b79$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $a33df4b8f27c9b79$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $a33df4b8f27c9b79$var$nh.enqueueReplaceState(b, b.state, null);
}
function $a33df4b8f27c9b79$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $a33df4b8f27c9b79$var$jh;
    $a33df4b8f27c9b79$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $a33df4b8f27c9b79$var$Vg(f) : (f = $a33df4b8f27c9b79$var$Zf(b) ? $a33df4b8f27c9b79$var$Xf : $a33df4b8f27c9b79$var$H.current, e.context = $a33df4b8f27c9b79$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($a33df4b8f27c9b79$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $a33df4b8f27c9b79$var$nh.enqueueReplaceState(e, e.state, null), $a33df4b8f27c9b79$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $a33df4b8f27c9b79$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($a33df4b8f27c9b79$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($a33df4b8f27c9b79$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $a33df4b8f27c9b79$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($a33df4b8f27c9b79$var$p(284));
        if (!c._owner) throw Error($a33df4b8f27c9b79$var$p(290, a));
    }
    return a;
}
function $a33df4b8f27c9b79$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($a33df4b8f27c9b79$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $a33df4b8f27c9b79$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $a33df4b8f27c9b79$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $a33df4b8f27c9b79$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $a33df4b8f27c9b79$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $a33df4b8f27c9b79$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $a33df4b8f27c9b79$var$Ha && $a33df4b8f27c9b79$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $a33df4b8f27c9b79$var$sh(a, b, c), d.return = a, d;
        d = $a33df4b8f27c9b79$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $a33df4b8f27c9b79$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $a33df4b8f27c9b79$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $a33df4b8f27c9b79$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $a33df4b8f27c9b79$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $a33df4b8f27c9b79$var$va:
                    return c = $a33df4b8f27c9b79$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $a33df4b8f27c9b79$var$sh(a, null, b), c.return = a, c;
                case $a33df4b8f27c9b79$var$wa:
                    return b = $a33df4b8f27c9b79$var$zh(b, a.mode, c), b.return = a, b;
                case $a33df4b8f27c9b79$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($a33df4b8f27c9b79$var$eb(b) || $a33df4b8f27c9b79$var$Ka(b)) return b = $a33df4b8f27c9b79$var$Ah(b, a.mode, c, null), b.return = a, b;
            $a33df4b8f27c9b79$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $a33df4b8f27c9b79$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $a33df4b8f27c9b79$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $a33df4b8f27c9b79$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($a33df4b8f27c9b79$var$eb(c) || $a33df4b8f27c9b79$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $a33df4b8f27c9b79$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $a33df4b8f27c9b79$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $a33df4b8f27c9b79$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $a33df4b8f27c9b79$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($a33df4b8f27c9b79$var$eb(d) || $a33df4b8f27c9b79$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $a33df4b8f27c9b79$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $a33df4b8f27c9b79$var$I && $a33df4b8f27c9b79$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $a33df4b8f27c9b79$var$I && $a33df4b8f27c9b79$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $a33df4b8f27c9b79$var$I && $a33df4b8f27c9b79$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $a33df4b8f27c9b79$var$Ka(h);
        if ("function" !== typeof l) throw Error($a33df4b8f27c9b79$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($a33df4b8f27c9b79$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $a33df4b8f27c9b79$var$I && $a33df4b8f27c9b79$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $a33df4b8f27c9b79$var$I && $a33df4b8f27c9b79$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $a33df4b8f27c9b79$var$I && $a33df4b8f27c9b79$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $a33df4b8f27c9b79$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $a33df4b8f27c9b79$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $a33df4b8f27c9b79$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $a33df4b8f27c9b79$var$Ha && $a33df4b8f27c9b79$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $a33df4b8f27c9b79$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $a33df4b8f27c9b79$var$ya ? (d = $a33df4b8f27c9b79$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $a33df4b8f27c9b79$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $a33df4b8f27c9b79$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $a33df4b8f27c9b79$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $a33df4b8f27c9b79$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $a33df4b8f27c9b79$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($a33df4b8f27c9b79$var$eb(f)) return n(a, d, f, h);
            if ($a33df4b8f27c9b79$var$Ka(f)) return t(a, d, f, h);
            $a33df4b8f27c9b79$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $a33df4b8f27c9b79$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $a33df4b8f27c9b79$var$Bh = $a33df4b8f27c9b79$var$vh(!0), $a33df4b8f27c9b79$var$Ch = $a33df4b8f27c9b79$var$vh(!1), $a33df4b8f27c9b79$var$Dh = {}, $a33df4b8f27c9b79$var$Eh = $a33df4b8f27c9b79$var$Uf($a33df4b8f27c9b79$var$Dh), $a33df4b8f27c9b79$var$Fh = $a33df4b8f27c9b79$var$Uf($a33df4b8f27c9b79$var$Dh), $a33df4b8f27c9b79$var$Gh = $a33df4b8f27c9b79$var$Uf($a33df4b8f27c9b79$var$Dh);
function $a33df4b8f27c9b79$var$Hh(a) {
    if (a === $a33df4b8f27c9b79$var$Dh) throw Error($a33df4b8f27c9b79$var$p(174));
    return a;
}
function $a33df4b8f27c9b79$var$Ih(a, b) {
    $a33df4b8f27c9b79$var$G($a33df4b8f27c9b79$var$Gh, b);
    $a33df4b8f27c9b79$var$G($a33df4b8f27c9b79$var$Fh, a);
    $a33df4b8f27c9b79$var$G($a33df4b8f27c9b79$var$Eh, $a33df4b8f27c9b79$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $a33df4b8f27c9b79$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $a33df4b8f27c9b79$var$lb(b, a);
    }
    $a33df4b8f27c9b79$var$E($a33df4b8f27c9b79$var$Eh);
    $a33df4b8f27c9b79$var$G($a33df4b8f27c9b79$var$Eh, b);
}
function $a33df4b8f27c9b79$var$Jh() {
    $a33df4b8f27c9b79$var$E($a33df4b8f27c9b79$var$Eh);
    $a33df4b8f27c9b79$var$E($a33df4b8f27c9b79$var$Fh);
    $a33df4b8f27c9b79$var$E($a33df4b8f27c9b79$var$Gh);
}
function $a33df4b8f27c9b79$var$Kh(a) {
    $a33df4b8f27c9b79$var$Hh($a33df4b8f27c9b79$var$Gh.current);
    var b = $a33df4b8f27c9b79$var$Hh($a33df4b8f27c9b79$var$Eh.current);
    var c = $a33df4b8f27c9b79$var$lb(b, a.type);
    b !== c && ($a33df4b8f27c9b79$var$G($a33df4b8f27c9b79$var$Fh, a), $a33df4b8f27c9b79$var$G($a33df4b8f27c9b79$var$Eh, c));
}
function $a33df4b8f27c9b79$var$Lh(a) {
    $a33df4b8f27c9b79$var$Fh.current === a && ($a33df4b8f27c9b79$var$E($a33df4b8f27c9b79$var$Eh), $a33df4b8f27c9b79$var$E($a33df4b8f27c9b79$var$Fh));
}
var $a33df4b8f27c9b79$var$M = $a33df4b8f27c9b79$var$Uf(0);
function $a33df4b8f27c9b79$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $a33df4b8f27c9b79$var$Nh = [];
function $a33df4b8f27c9b79$var$Oh() {
    for(var a = 0; a < $a33df4b8f27c9b79$var$Nh.length; a++)$a33df4b8f27c9b79$var$Nh[a]._workInProgressVersionPrimary = null;
    $a33df4b8f27c9b79$var$Nh.length = 0;
}
var $a33df4b8f27c9b79$var$Ph = $a33df4b8f27c9b79$var$ua.ReactCurrentDispatcher, $a33df4b8f27c9b79$var$Qh = $a33df4b8f27c9b79$var$ua.ReactCurrentBatchConfig, $a33df4b8f27c9b79$var$Rh = 0, $a33df4b8f27c9b79$var$N = null, $a33df4b8f27c9b79$var$O = null, $a33df4b8f27c9b79$var$P = null, $a33df4b8f27c9b79$var$Sh = !1, $a33df4b8f27c9b79$var$Th = !1, $a33df4b8f27c9b79$var$Uh = 0, $a33df4b8f27c9b79$var$Vh = 0;
function $a33df4b8f27c9b79$var$Q() {
    throw Error($a33df4b8f27c9b79$var$p(321));
}
function $a33df4b8f27c9b79$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$a33df4b8f27c9b79$var$He(a[c], b[c])) return !1;
    return !0;
}
function $a33df4b8f27c9b79$var$Xh(a, b, c, d, e, f) {
    $a33df4b8f27c9b79$var$Rh = f;
    $a33df4b8f27c9b79$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $a33df4b8f27c9b79$var$Ph.current = null === a || null === a.memoizedState ? $a33df4b8f27c9b79$var$Yh : $a33df4b8f27c9b79$var$Zh;
    a = c(d, e);
    if ($a33df4b8f27c9b79$var$Th) {
        f = 0;
        do {
            $a33df4b8f27c9b79$var$Th = !1;
            $a33df4b8f27c9b79$var$Uh = 0;
            if (25 <= f) throw Error($a33df4b8f27c9b79$var$p(301));
            f += 1;
            $a33df4b8f27c9b79$var$P = $a33df4b8f27c9b79$var$O = null;
            b.updateQueue = null;
            $a33df4b8f27c9b79$var$Ph.current = $a33df4b8f27c9b79$var$$h;
            a = c(d, e);
        }while ($a33df4b8f27c9b79$var$Th);
    }
    $a33df4b8f27c9b79$var$Ph.current = $a33df4b8f27c9b79$var$ai;
    b = null !== $a33df4b8f27c9b79$var$O && null !== $a33df4b8f27c9b79$var$O.next;
    $a33df4b8f27c9b79$var$Rh = 0;
    $a33df4b8f27c9b79$var$P = $a33df4b8f27c9b79$var$O = $a33df4b8f27c9b79$var$N = null;
    $a33df4b8f27c9b79$var$Sh = !1;
    if (b) throw Error($a33df4b8f27c9b79$var$p(300));
    return a;
}
function $a33df4b8f27c9b79$var$bi() {
    var a = 0 !== $a33df4b8f27c9b79$var$Uh;
    $a33df4b8f27c9b79$var$Uh = 0;
    return a;
}
function $a33df4b8f27c9b79$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $a33df4b8f27c9b79$var$P ? $a33df4b8f27c9b79$var$N.memoizedState = $a33df4b8f27c9b79$var$P = a : $a33df4b8f27c9b79$var$P = $a33df4b8f27c9b79$var$P.next = a;
    return $a33df4b8f27c9b79$var$P;
}
function $a33df4b8f27c9b79$var$di() {
    if (null === $a33df4b8f27c9b79$var$O) {
        var a = $a33df4b8f27c9b79$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $a33df4b8f27c9b79$var$O.next;
    var b = null === $a33df4b8f27c9b79$var$P ? $a33df4b8f27c9b79$var$N.memoizedState : $a33df4b8f27c9b79$var$P.next;
    if (null !== b) $a33df4b8f27c9b79$var$P = b, $a33df4b8f27c9b79$var$O = a;
    else {
        if (null === a) throw Error($a33df4b8f27c9b79$var$p(310));
        $a33df4b8f27c9b79$var$O = a;
        a = {
            memoizedState: $a33df4b8f27c9b79$var$O.memoizedState,
            baseState: $a33df4b8f27c9b79$var$O.baseState,
            baseQueue: $a33df4b8f27c9b79$var$O.baseQueue,
            queue: $a33df4b8f27c9b79$var$O.queue,
            next: null
        };
        null === $a33df4b8f27c9b79$var$P ? $a33df4b8f27c9b79$var$N.memoizedState = $a33df4b8f27c9b79$var$P = a : $a33df4b8f27c9b79$var$P = $a33df4b8f27c9b79$var$P.next = a;
    }
    return $a33df4b8f27c9b79$var$P;
}
function $a33df4b8f27c9b79$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $a33df4b8f27c9b79$var$fi(a) {
    var b = $a33df4b8f27c9b79$var$di(), c = b.queue;
    if (null === c) throw Error($a33df4b8f27c9b79$var$p(311));
    c.lastRenderedReducer = a;
    var d = $a33df4b8f27c9b79$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($a33df4b8f27c9b79$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $a33df4b8f27c9b79$var$N.lanes |= m;
                $a33df4b8f27c9b79$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $a33df4b8f27c9b79$var$He(d, b.memoizedState) || ($a33df4b8f27c9b79$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $a33df4b8f27c9b79$var$N.lanes |= f, $a33df4b8f27c9b79$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $a33df4b8f27c9b79$var$gi(a) {
    var b = $a33df4b8f27c9b79$var$di(), c = b.queue;
    if (null === c) throw Error($a33df4b8f27c9b79$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $a33df4b8f27c9b79$var$He(f, b.memoizedState) || ($a33df4b8f27c9b79$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $a33df4b8f27c9b79$var$hi() {}
function $a33df4b8f27c9b79$var$ii(a, b) {
    var c = $a33df4b8f27c9b79$var$N, d = $a33df4b8f27c9b79$var$di(), e = b(), f = !$a33df4b8f27c9b79$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $a33df4b8f27c9b79$var$Ug = !0);
    d = d.queue;
    $a33df4b8f27c9b79$var$ji($a33df4b8f27c9b79$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $a33df4b8f27c9b79$var$P && $a33df4b8f27c9b79$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $a33df4b8f27c9b79$var$li(9, $a33df4b8f27c9b79$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $a33df4b8f27c9b79$var$R) throw Error($a33df4b8f27c9b79$var$p(349));
        0 !== ($a33df4b8f27c9b79$var$Rh & 30) || $a33df4b8f27c9b79$var$ni(c, b, e);
    }
    return e;
}
function $a33df4b8f27c9b79$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $a33df4b8f27c9b79$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $a33df4b8f27c9b79$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $a33df4b8f27c9b79$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $a33df4b8f27c9b79$var$oi(b) && $a33df4b8f27c9b79$var$pi(a);
}
function $a33df4b8f27c9b79$var$ki(a, b, c) {
    return c(function() {
        $a33df4b8f27c9b79$var$oi(b) && $a33df4b8f27c9b79$var$pi(a);
    });
}
function $a33df4b8f27c9b79$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$a33df4b8f27c9b79$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $a33df4b8f27c9b79$var$pi(a) {
    var b = $a33df4b8f27c9b79$var$Zg(a, 1);
    null !== b && $a33df4b8f27c9b79$var$mh(b, a, 1, -1);
}
function $a33df4b8f27c9b79$var$qi(a) {
    var b = $a33df4b8f27c9b79$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $a33df4b8f27c9b79$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $a33df4b8f27c9b79$var$ri.bind(null, $a33df4b8f27c9b79$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $a33df4b8f27c9b79$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $a33df4b8f27c9b79$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $a33df4b8f27c9b79$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $a33df4b8f27c9b79$var$si() {
    return $a33df4b8f27c9b79$var$di().memoizedState;
}
function $a33df4b8f27c9b79$var$ti(a, b, c, d) {
    var e = $a33df4b8f27c9b79$var$ci();
    $a33df4b8f27c9b79$var$N.flags |= a;
    e.memoizedState = $a33df4b8f27c9b79$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $a33df4b8f27c9b79$var$ui(a, b, c, d) {
    var e = $a33df4b8f27c9b79$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $a33df4b8f27c9b79$var$O) {
        var g = $a33df4b8f27c9b79$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $a33df4b8f27c9b79$var$Wh(d, g.deps)) {
            e.memoizedState = $a33df4b8f27c9b79$var$li(b, c, f, d);
            return;
        }
    }
    $a33df4b8f27c9b79$var$N.flags |= a;
    e.memoizedState = $a33df4b8f27c9b79$var$li(1 | b, c, f, d);
}
function $a33df4b8f27c9b79$var$vi(a, b) {
    return $a33df4b8f27c9b79$var$ti(8390656, 8, a, b);
}
function $a33df4b8f27c9b79$var$ji(a, b) {
    return $a33df4b8f27c9b79$var$ui(2048, 8, a, b);
}
function $a33df4b8f27c9b79$var$wi(a, b) {
    return $a33df4b8f27c9b79$var$ui(4, 2, a, b);
}
function $a33df4b8f27c9b79$var$xi(a, b) {
    return $a33df4b8f27c9b79$var$ui(4, 4, a, b);
}
function $a33df4b8f27c9b79$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $a33df4b8f27c9b79$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $a33df4b8f27c9b79$var$ui(4, 4, $a33df4b8f27c9b79$var$yi.bind(null, b, a), c);
}
function $a33df4b8f27c9b79$var$Ai() {}
function $a33df4b8f27c9b79$var$Bi(a, b) {
    var c = $a33df4b8f27c9b79$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $a33df4b8f27c9b79$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $a33df4b8f27c9b79$var$Ci(a, b) {
    var c = $a33df4b8f27c9b79$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $a33df4b8f27c9b79$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $a33df4b8f27c9b79$var$Di(a, b, c) {
    if (0 === ($a33df4b8f27c9b79$var$Rh & 21)) return a.baseState && (a.baseState = !1, $a33df4b8f27c9b79$var$Ug = !0), a.memoizedState = c;
    $a33df4b8f27c9b79$var$He(c, b) || (c = $a33df4b8f27c9b79$var$yc(), $a33df4b8f27c9b79$var$N.lanes |= c, $a33df4b8f27c9b79$var$hh |= c, a.baseState = !0);
    return b;
}
function $a33df4b8f27c9b79$var$Ei(a, b) {
    var c = $a33df4b8f27c9b79$var$C;
    $a33df4b8f27c9b79$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $a33df4b8f27c9b79$var$Qh.transition;
    $a33df4b8f27c9b79$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $a33df4b8f27c9b79$var$C = c, $a33df4b8f27c9b79$var$Qh.transition = d;
    }
}
function $a33df4b8f27c9b79$var$Fi() {
    return $a33df4b8f27c9b79$var$di().memoizedState;
}
function $a33df4b8f27c9b79$var$Gi(a, b, c) {
    var d = $a33df4b8f27c9b79$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($a33df4b8f27c9b79$var$Hi(a)) $a33df4b8f27c9b79$var$Ii(b, c);
    else if (c = $a33df4b8f27c9b79$var$Yg(a, b, c, d), null !== c) {
        var e = $a33df4b8f27c9b79$var$L();
        $a33df4b8f27c9b79$var$mh(c, a, d, e);
        $a33df4b8f27c9b79$var$Ji(c, b, d);
    }
}
function $a33df4b8f27c9b79$var$ri(a, b, c) {
    var d = $a33df4b8f27c9b79$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($a33df4b8f27c9b79$var$Hi(a)) $a33df4b8f27c9b79$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($a33df4b8f27c9b79$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $a33df4b8f27c9b79$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $a33df4b8f27c9b79$var$Yg(a, b, e, d);
        null !== c && (e = $a33df4b8f27c9b79$var$L(), $a33df4b8f27c9b79$var$mh(c, a, d, e), $a33df4b8f27c9b79$var$Ji(c, b, d));
    }
}
function $a33df4b8f27c9b79$var$Hi(a) {
    var b = a.alternate;
    return a === $a33df4b8f27c9b79$var$N || null !== b && b === $a33df4b8f27c9b79$var$N;
}
function $a33df4b8f27c9b79$var$Ii(a, b) {
    $a33df4b8f27c9b79$var$Th = $a33df4b8f27c9b79$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $a33df4b8f27c9b79$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $a33df4b8f27c9b79$var$Cc(a, c);
    }
}
var $a33df4b8f27c9b79$var$ai = {
    readContext: $a33df4b8f27c9b79$var$Vg,
    useCallback: $a33df4b8f27c9b79$var$Q,
    useContext: $a33df4b8f27c9b79$var$Q,
    useEffect: $a33df4b8f27c9b79$var$Q,
    useImperativeHandle: $a33df4b8f27c9b79$var$Q,
    useInsertionEffect: $a33df4b8f27c9b79$var$Q,
    useLayoutEffect: $a33df4b8f27c9b79$var$Q,
    useMemo: $a33df4b8f27c9b79$var$Q,
    useReducer: $a33df4b8f27c9b79$var$Q,
    useRef: $a33df4b8f27c9b79$var$Q,
    useState: $a33df4b8f27c9b79$var$Q,
    useDebugValue: $a33df4b8f27c9b79$var$Q,
    useDeferredValue: $a33df4b8f27c9b79$var$Q,
    useTransition: $a33df4b8f27c9b79$var$Q,
    useMutableSource: $a33df4b8f27c9b79$var$Q,
    useSyncExternalStore: $a33df4b8f27c9b79$var$Q,
    useId: $a33df4b8f27c9b79$var$Q,
    unstable_isNewReconciler: !1
}, $a33df4b8f27c9b79$var$Yh = {
    readContext: $a33df4b8f27c9b79$var$Vg,
    useCallback: function(a, b) {
        $a33df4b8f27c9b79$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $a33df4b8f27c9b79$var$Vg,
    useEffect: $a33df4b8f27c9b79$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $a33df4b8f27c9b79$var$ti(4194308, 4, $a33df4b8f27c9b79$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $a33df4b8f27c9b79$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $a33df4b8f27c9b79$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $a33df4b8f27c9b79$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $a33df4b8f27c9b79$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $a33df4b8f27c9b79$var$Gi.bind(null, $a33df4b8f27c9b79$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $a33df4b8f27c9b79$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $a33df4b8f27c9b79$var$qi,
    useDebugValue: $a33df4b8f27c9b79$var$Ai,
    useDeferredValue: function(a) {
        return $a33df4b8f27c9b79$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $a33df4b8f27c9b79$var$qi(!1), b = a[0];
        a = $a33df4b8f27c9b79$var$Ei.bind(null, a[1]);
        $a33df4b8f27c9b79$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $a33df4b8f27c9b79$var$N, e = $a33df4b8f27c9b79$var$ci();
        if ($a33df4b8f27c9b79$var$I) {
            if (void 0 === c) throw Error($a33df4b8f27c9b79$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $a33df4b8f27c9b79$var$R) throw Error($a33df4b8f27c9b79$var$p(349));
            0 !== ($a33df4b8f27c9b79$var$Rh & 30) || $a33df4b8f27c9b79$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $a33df4b8f27c9b79$var$vi($a33df4b8f27c9b79$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $a33df4b8f27c9b79$var$li(9, $a33df4b8f27c9b79$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $a33df4b8f27c9b79$var$ci(), b = $a33df4b8f27c9b79$var$R.identifierPrefix;
        if ($a33df4b8f27c9b79$var$I) {
            var c = $a33df4b8f27c9b79$var$sg;
            var d = $a33df4b8f27c9b79$var$rg;
            c = (d & ~(1 << 32 - $a33df4b8f27c9b79$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $a33df4b8f27c9b79$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $a33df4b8f27c9b79$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $a33df4b8f27c9b79$var$Zh = {
    readContext: $a33df4b8f27c9b79$var$Vg,
    useCallback: $a33df4b8f27c9b79$var$Bi,
    useContext: $a33df4b8f27c9b79$var$Vg,
    useEffect: $a33df4b8f27c9b79$var$ji,
    useImperativeHandle: $a33df4b8f27c9b79$var$zi,
    useInsertionEffect: $a33df4b8f27c9b79$var$wi,
    useLayoutEffect: $a33df4b8f27c9b79$var$xi,
    useMemo: $a33df4b8f27c9b79$var$Ci,
    useReducer: $a33df4b8f27c9b79$var$fi,
    useRef: $a33df4b8f27c9b79$var$si,
    useState: function() {
        return $a33df4b8f27c9b79$var$fi($a33df4b8f27c9b79$var$ei);
    },
    useDebugValue: $a33df4b8f27c9b79$var$Ai,
    useDeferredValue: function(a) {
        var b = $a33df4b8f27c9b79$var$di();
        return $a33df4b8f27c9b79$var$Di(b, $a33df4b8f27c9b79$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $a33df4b8f27c9b79$var$fi($a33df4b8f27c9b79$var$ei)[0], b = $a33df4b8f27c9b79$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $a33df4b8f27c9b79$var$hi,
    useSyncExternalStore: $a33df4b8f27c9b79$var$ii,
    useId: $a33df4b8f27c9b79$var$Fi,
    unstable_isNewReconciler: !1
}, $a33df4b8f27c9b79$var$$h = {
    readContext: $a33df4b8f27c9b79$var$Vg,
    useCallback: $a33df4b8f27c9b79$var$Bi,
    useContext: $a33df4b8f27c9b79$var$Vg,
    useEffect: $a33df4b8f27c9b79$var$ji,
    useImperativeHandle: $a33df4b8f27c9b79$var$zi,
    useInsertionEffect: $a33df4b8f27c9b79$var$wi,
    useLayoutEffect: $a33df4b8f27c9b79$var$xi,
    useMemo: $a33df4b8f27c9b79$var$Ci,
    useReducer: $a33df4b8f27c9b79$var$gi,
    useRef: $a33df4b8f27c9b79$var$si,
    useState: function() {
        return $a33df4b8f27c9b79$var$gi($a33df4b8f27c9b79$var$ei);
    },
    useDebugValue: $a33df4b8f27c9b79$var$Ai,
    useDeferredValue: function(a) {
        var b = $a33df4b8f27c9b79$var$di();
        return null === $a33df4b8f27c9b79$var$O ? b.memoizedState = a : $a33df4b8f27c9b79$var$Di(b, $a33df4b8f27c9b79$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $a33df4b8f27c9b79$var$gi($a33df4b8f27c9b79$var$ei)[0], b = $a33df4b8f27c9b79$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $a33df4b8f27c9b79$var$hi,
    useSyncExternalStore: $a33df4b8f27c9b79$var$ii,
    useId: $a33df4b8f27c9b79$var$Fi,
    unstable_isNewReconciler: !1
};
function $a33df4b8f27c9b79$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $a33df4b8f27c9b79$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $a33df4b8f27c9b79$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $a33df4b8f27c9b79$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $a33df4b8f27c9b79$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $a33df4b8f27c9b79$var$Oi(a, b, c) {
    c = $a33df4b8f27c9b79$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $a33df4b8f27c9b79$var$Pi || ($a33df4b8f27c9b79$var$Pi = !0, $a33df4b8f27c9b79$var$Qi = d);
        $a33df4b8f27c9b79$var$Mi(a, b);
    };
    return c;
}
function $a33df4b8f27c9b79$var$Ri(a, b, c) {
    c = $a33df4b8f27c9b79$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $a33df4b8f27c9b79$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $a33df4b8f27c9b79$var$Mi(a, b);
        "function" !== typeof d && (null === $a33df4b8f27c9b79$var$Si ? $a33df4b8f27c9b79$var$Si = new Set([
            this
        ]) : $a33df4b8f27c9b79$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $a33df4b8f27c9b79$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $a33df4b8f27c9b79$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $a33df4b8f27c9b79$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $a33df4b8f27c9b79$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $a33df4b8f27c9b79$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $a33df4b8f27c9b79$var$ch(-1, 1), b.tag = 2, $a33df4b8f27c9b79$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $a33df4b8f27c9b79$var$Xi = $a33df4b8f27c9b79$var$ua.ReactCurrentOwner, $a33df4b8f27c9b79$var$Ug = !1;
function $a33df4b8f27c9b79$var$Yi(a, b, c, d) {
    b.child = null === a ? $a33df4b8f27c9b79$var$Ch(b, null, c, d) : $a33df4b8f27c9b79$var$Bh(b, a.child, c, d);
}
function $a33df4b8f27c9b79$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $a33df4b8f27c9b79$var$Tg(b, e);
    d = $a33df4b8f27c9b79$var$Xh(a, b, c, d, f, e);
    c = $a33df4b8f27c9b79$var$bi();
    if (null !== a && !$a33df4b8f27c9b79$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $a33df4b8f27c9b79$var$$i(a, b, e);
    $a33df4b8f27c9b79$var$I && c && $a33df4b8f27c9b79$var$vg(b);
    b.flags |= 1;
    $a33df4b8f27c9b79$var$Yi(a, b, d, e);
    return b.child;
}
function $a33df4b8f27c9b79$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$a33df4b8f27c9b79$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $a33df4b8f27c9b79$var$cj(a, b, f, d, e);
        a = $a33df4b8f27c9b79$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $a33df4b8f27c9b79$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $a33df4b8f27c9b79$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $a33df4b8f27c9b79$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $a33df4b8f27c9b79$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($a33df4b8f27c9b79$var$Ie(f, d) && a.ref === b.ref) {
            if ($a33df4b8f27c9b79$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($a33df4b8f27c9b79$var$Ug = !0);
            else return b.lanes = a.lanes, $a33df4b8f27c9b79$var$$i(a, b, e);
        }
    }
    return $a33df4b8f27c9b79$var$dj(a, b, c, d, e);
}
function $a33df4b8f27c9b79$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $a33df4b8f27c9b79$var$G($a33df4b8f27c9b79$var$fj, $a33df4b8f27c9b79$var$gj), $a33df4b8f27c9b79$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $a33df4b8f27c9b79$var$G($a33df4b8f27c9b79$var$fj, $a33df4b8f27c9b79$var$gj), $a33df4b8f27c9b79$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $a33df4b8f27c9b79$var$G($a33df4b8f27c9b79$var$fj, $a33df4b8f27c9b79$var$gj);
            $a33df4b8f27c9b79$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $a33df4b8f27c9b79$var$G($a33df4b8f27c9b79$var$fj, $a33df4b8f27c9b79$var$gj), $a33df4b8f27c9b79$var$gj |= d;
    $a33df4b8f27c9b79$var$Yi(a, b, e, c);
    return b.child;
}
function $a33df4b8f27c9b79$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $a33df4b8f27c9b79$var$dj(a, b, c, d, e) {
    var f = $a33df4b8f27c9b79$var$Zf(c) ? $a33df4b8f27c9b79$var$Xf : $a33df4b8f27c9b79$var$H.current;
    f = $a33df4b8f27c9b79$var$Yf(b, f);
    $a33df4b8f27c9b79$var$Tg(b, e);
    c = $a33df4b8f27c9b79$var$Xh(a, b, c, d, f, e);
    d = $a33df4b8f27c9b79$var$bi();
    if (null !== a && !$a33df4b8f27c9b79$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $a33df4b8f27c9b79$var$$i(a, b, e);
    $a33df4b8f27c9b79$var$I && d && $a33df4b8f27c9b79$var$vg(b);
    b.flags |= 1;
    $a33df4b8f27c9b79$var$Yi(a, b, c, e);
    return b.child;
}
function $a33df4b8f27c9b79$var$ij(a, b, c, d, e) {
    if ($a33df4b8f27c9b79$var$Zf(c)) {
        var f = !0;
        $a33df4b8f27c9b79$var$cg(b);
    } else f = !1;
    $a33df4b8f27c9b79$var$Tg(b, e);
    if (null === b.stateNode) $a33df4b8f27c9b79$var$jj(a, b), $a33df4b8f27c9b79$var$ph(b, c, d), $a33df4b8f27c9b79$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $a33df4b8f27c9b79$var$Vg(l) : (l = $a33df4b8f27c9b79$var$Zf(c) ? $a33df4b8f27c9b79$var$Xf : $a33df4b8f27c9b79$var$H.current, l = $a33df4b8f27c9b79$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $a33df4b8f27c9b79$var$qh(b, g, d, l);
        $a33df4b8f27c9b79$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $a33df4b8f27c9b79$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $a33df4b8f27c9b79$var$Wf.current || $a33df4b8f27c9b79$var$$g ? ("function" === typeof m && ($a33df4b8f27c9b79$var$kh(b, c, m, d), k = b.memoizedState), (h = $a33df4b8f27c9b79$var$$g || $a33df4b8f27c9b79$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $a33df4b8f27c9b79$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $a33df4b8f27c9b79$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $a33df4b8f27c9b79$var$Vg(k) : (k = $a33df4b8f27c9b79$var$Zf(c) ? $a33df4b8f27c9b79$var$Xf : $a33df4b8f27c9b79$var$H.current, k = $a33df4b8f27c9b79$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $a33df4b8f27c9b79$var$qh(b, g, d, k);
        $a33df4b8f27c9b79$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $a33df4b8f27c9b79$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $a33df4b8f27c9b79$var$Wf.current || $a33df4b8f27c9b79$var$$g ? ("function" === typeof y && ($a33df4b8f27c9b79$var$kh(b, c, y, d), n = b.memoizedState), (l = $a33df4b8f27c9b79$var$$g || $a33df4b8f27c9b79$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $a33df4b8f27c9b79$var$kj(a, b, c, d, f, e);
}
function $a33df4b8f27c9b79$var$kj(a, b, c, d, e, f) {
    $a33df4b8f27c9b79$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $a33df4b8f27c9b79$var$dg(b, c, !1), $a33df4b8f27c9b79$var$$i(a, b, f);
    d = b.stateNode;
    $a33df4b8f27c9b79$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $a33df4b8f27c9b79$var$Bh(b, a.child, null, f), b.child = $a33df4b8f27c9b79$var$Bh(b, null, h, f)) : $a33df4b8f27c9b79$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $a33df4b8f27c9b79$var$dg(b, c, !0);
    return b.child;
}
function $a33df4b8f27c9b79$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $a33df4b8f27c9b79$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $a33df4b8f27c9b79$var$ag(a, b.context, !1);
    $a33df4b8f27c9b79$var$Ih(a, b.containerInfo);
}
function $a33df4b8f27c9b79$var$mj(a, b, c, d, e) {
    $a33df4b8f27c9b79$var$Ig();
    $a33df4b8f27c9b79$var$Jg(e);
    b.flags |= 256;
    $a33df4b8f27c9b79$var$Yi(a, b, c, d);
    return b.child;
}
var $a33df4b8f27c9b79$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $a33df4b8f27c9b79$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $a33df4b8f27c9b79$var$pj(a, b, c) {
    var d = b.pendingProps, e = $a33df4b8f27c9b79$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $a33df4b8f27c9b79$var$G($a33df4b8f27c9b79$var$M, e & 1);
    if (null === a) {
        $a33df4b8f27c9b79$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $a33df4b8f27c9b79$var$qj(g, d, 0, null), a = $a33df4b8f27c9b79$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $a33df4b8f27c9b79$var$oj(c), b.memoizedState = $a33df4b8f27c9b79$var$nj, a) : $a33df4b8f27c9b79$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $a33df4b8f27c9b79$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $a33df4b8f27c9b79$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $a33df4b8f27c9b79$var$wh(h, f) : (f = $a33df4b8f27c9b79$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $a33df4b8f27c9b79$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $a33df4b8f27c9b79$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $a33df4b8f27c9b79$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $a33df4b8f27c9b79$var$rj(a, b) {
    b = $a33df4b8f27c9b79$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $a33df4b8f27c9b79$var$tj(a, b, c, d) {
    null !== d && $a33df4b8f27c9b79$var$Jg(d);
    $a33df4b8f27c9b79$var$Bh(b, a.child, null, c);
    a = $a33df4b8f27c9b79$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $a33df4b8f27c9b79$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $a33df4b8f27c9b79$var$Li(Error($a33df4b8f27c9b79$var$p(422))), $a33df4b8f27c9b79$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $a33df4b8f27c9b79$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $a33df4b8f27c9b79$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $a33df4b8f27c9b79$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $a33df4b8f27c9b79$var$oj(g);
        b.memoizedState = $a33df4b8f27c9b79$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $a33df4b8f27c9b79$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($a33df4b8f27c9b79$var$p(419));
        d = $a33df4b8f27c9b79$var$Li(f, d, void 0);
        return $a33df4b8f27c9b79$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($a33df4b8f27c9b79$var$Ug || h) {
        d = $a33df4b8f27c9b79$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $a33df4b8f27c9b79$var$Zg(a, e), $a33df4b8f27c9b79$var$mh(d, a, e, -1));
        }
        $a33df4b8f27c9b79$var$uj();
        d = $a33df4b8f27c9b79$var$Li(Error($a33df4b8f27c9b79$var$p(421)));
        return $a33df4b8f27c9b79$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $a33df4b8f27c9b79$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $a33df4b8f27c9b79$var$yg = $a33df4b8f27c9b79$var$Lf(e.nextSibling);
    $a33df4b8f27c9b79$var$xg = b;
    $a33df4b8f27c9b79$var$I = !0;
    $a33df4b8f27c9b79$var$zg = null;
    null !== a && ($a33df4b8f27c9b79$var$og[$a33df4b8f27c9b79$var$pg++] = $a33df4b8f27c9b79$var$rg, $a33df4b8f27c9b79$var$og[$a33df4b8f27c9b79$var$pg++] = $a33df4b8f27c9b79$var$sg, $a33df4b8f27c9b79$var$og[$a33df4b8f27c9b79$var$pg++] = $a33df4b8f27c9b79$var$qg, $a33df4b8f27c9b79$var$rg = a.id, $a33df4b8f27c9b79$var$sg = a.overflow, $a33df4b8f27c9b79$var$qg = b);
    b = $a33df4b8f27c9b79$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $a33df4b8f27c9b79$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $a33df4b8f27c9b79$var$Sg(a.return, b, c);
}
function $a33df4b8f27c9b79$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $a33df4b8f27c9b79$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $a33df4b8f27c9b79$var$Yi(a, b, d.children, c);
    d = $a33df4b8f27c9b79$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $a33df4b8f27c9b79$var$wj(a, c, b);
            else if (19 === a.tag) $a33df4b8f27c9b79$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $a33df4b8f27c9b79$var$G($a33df4b8f27c9b79$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $a33df4b8f27c9b79$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $a33df4b8f27c9b79$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $a33df4b8f27c9b79$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $a33df4b8f27c9b79$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $a33df4b8f27c9b79$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $a33df4b8f27c9b79$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $a33df4b8f27c9b79$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $a33df4b8f27c9b79$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($a33df4b8f27c9b79$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $a33df4b8f27c9b79$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $a33df4b8f27c9b79$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $a33df4b8f27c9b79$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $a33df4b8f27c9b79$var$lj(b);
            $a33df4b8f27c9b79$var$Ig();
            break;
        case 5:
            $a33df4b8f27c9b79$var$Kh(b);
            break;
        case 1:
            $a33df4b8f27c9b79$var$Zf(b.type) && $a33df4b8f27c9b79$var$cg(b);
            break;
        case 4:
            $a33df4b8f27c9b79$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $a33df4b8f27c9b79$var$G($a33df4b8f27c9b79$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $a33df4b8f27c9b79$var$G($a33df4b8f27c9b79$var$M, $a33df4b8f27c9b79$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $a33df4b8f27c9b79$var$pj(a, b, c);
                $a33df4b8f27c9b79$var$G($a33df4b8f27c9b79$var$M, $a33df4b8f27c9b79$var$M.current & 1);
                a = $a33df4b8f27c9b79$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $a33df4b8f27c9b79$var$G($a33df4b8f27c9b79$var$M, $a33df4b8f27c9b79$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $a33df4b8f27c9b79$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $a33df4b8f27c9b79$var$G($a33df4b8f27c9b79$var$M, $a33df4b8f27c9b79$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $a33df4b8f27c9b79$var$ej(a, b, c);
    }
    return $a33df4b8f27c9b79$var$$i(a, b, c);
}
var $a33df4b8f27c9b79$var$Aj, $a33df4b8f27c9b79$var$Bj, $a33df4b8f27c9b79$var$Cj, $a33df4b8f27c9b79$var$Dj;
$a33df4b8f27c9b79$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$a33df4b8f27c9b79$var$Bj = function() {};
$a33df4b8f27c9b79$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $a33df4b8f27c9b79$var$Hh($a33df4b8f27c9b79$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $a33df4b8f27c9b79$var$Ya(a, e);
                d = $a33df4b8f27c9b79$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $a33df4b8f27c9b79$var$A({}, e, {
                    value: void 0
                });
                d = $a33df4b8f27c9b79$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $a33df4b8f27c9b79$var$gb(a, e);
                d = $a33df4b8f27c9b79$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $a33df4b8f27c9b79$var$Bf);
        }
        $a33df4b8f27c9b79$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($a33df4b8f27c9b79$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($a33df4b8f27c9b79$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $a33df4b8f27c9b79$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$a33df4b8f27c9b79$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $a33df4b8f27c9b79$var$Ej(a, b) {
    if (!$a33df4b8f27c9b79$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $a33df4b8f27c9b79$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $a33df4b8f27c9b79$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $a33df4b8f27c9b79$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $a33df4b8f27c9b79$var$S(b), null;
        case 1:
            return $a33df4b8f27c9b79$var$Zf(b.type) && $a33df4b8f27c9b79$var$$f(), $a33df4b8f27c9b79$var$S(b), null;
        case 3:
            d = b.stateNode;
            $a33df4b8f27c9b79$var$Jh();
            $a33df4b8f27c9b79$var$E($a33df4b8f27c9b79$var$Wf);
            $a33df4b8f27c9b79$var$E($a33df4b8f27c9b79$var$H);
            $a33df4b8f27c9b79$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $a33df4b8f27c9b79$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $a33df4b8f27c9b79$var$zg && ($a33df4b8f27c9b79$var$Gj($a33df4b8f27c9b79$var$zg), $a33df4b8f27c9b79$var$zg = null));
            $a33df4b8f27c9b79$var$Bj(a, b);
            $a33df4b8f27c9b79$var$S(b);
            return null;
        case 5:
            $a33df4b8f27c9b79$var$Lh(b);
            var e = $a33df4b8f27c9b79$var$Hh($a33df4b8f27c9b79$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $a33df4b8f27c9b79$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($a33df4b8f27c9b79$var$p(166));
                    $a33df4b8f27c9b79$var$S(b);
                    return null;
                }
                a = $a33df4b8f27c9b79$var$Hh($a33df4b8f27c9b79$var$Eh.current);
                if ($a33df4b8f27c9b79$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$a33df4b8f27c9b79$var$Of] = b;
                    d[$a33df4b8f27c9b79$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $a33df4b8f27c9b79$var$D("cancel", d);
                            $a33df4b8f27c9b79$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $a33df4b8f27c9b79$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $a33df4b8f27c9b79$var$lf.length; e++)$a33df4b8f27c9b79$var$D($a33df4b8f27c9b79$var$lf[e], d);
                            break;
                        case "source":
                            $a33df4b8f27c9b79$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $a33df4b8f27c9b79$var$D("error", d);
                            $a33df4b8f27c9b79$var$D("load", d);
                            break;
                        case "details":
                            $a33df4b8f27c9b79$var$D("toggle", d);
                            break;
                        case "input":
                            $a33df4b8f27c9b79$var$Za(d, f);
                            $a33df4b8f27c9b79$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $a33df4b8f27c9b79$var$D("invalid", d);
                            break;
                        case "textarea":
                            $a33df4b8f27c9b79$var$hb(d, f), $a33df4b8f27c9b79$var$D("invalid", d);
                    }
                    $a33df4b8f27c9b79$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $a33df4b8f27c9b79$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $a33df4b8f27c9b79$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $a33df4b8f27c9b79$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $a33df4b8f27c9b79$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $a33df4b8f27c9b79$var$Va(d);
                            $a33df4b8f27c9b79$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $a33df4b8f27c9b79$var$Va(d);
                            $a33df4b8f27c9b79$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $a33df4b8f27c9b79$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $a33df4b8f27c9b79$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$a33df4b8f27c9b79$var$Of] = b;
                    a[$a33df4b8f27c9b79$var$Pf] = d;
                    $a33df4b8f27c9b79$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $a33df4b8f27c9b79$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $a33df4b8f27c9b79$var$D("cancel", a);
                                $a33df4b8f27c9b79$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $a33df4b8f27c9b79$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $a33df4b8f27c9b79$var$lf.length; e++)$a33df4b8f27c9b79$var$D($a33df4b8f27c9b79$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $a33df4b8f27c9b79$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $a33df4b8f27c9b79$var$D("error", a);
                                $a33df4b8f27c9b79$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $a33df4b8f27c9b79$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $a33df4b8f27c9b79$var$Za(a, d);
                                e = $a33df4b8f27c9b79$var$Ya(a, d);
                                $a33df4b8f27c9b79$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $a33df4b8f27c9b79$var$A({}, d, {
                                    value: void 0
                                });
                                $a33df4b8f27c9b79$var$D("invalid", a);
                                break;
                            case "textarea":
                                $a33df4b8f27c9b79$var$hb(a, d);
                                e = $a33df4b8f27c9b79$var$gb(a, d);
                                $a33df4b8f27c9b79$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $a33df4b8f27c9b79$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $a33df4b8f27c9b79$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $a33df4b8f27c9b79$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $a33df4b8f27c9b79$var$ob(a, k) : "number" === typeof k && $a33df4b8f27c9b79$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($a33df4b8f27c9b79$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $a33df4b8f27c9b79$var$D("scroll", a) : null != k && $a33df4b8f27c9b79$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $a33df4b8f27c9b79$var$Va(a);
                                $a33df4b8f27c9b79$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $a33df4b8f27c9b79$var$Va(a);
                                $a33df4b8f27c9b79$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $a33df4b8f27c9b79$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $a33df4b8f27c9b79$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $a33df4b8f27c9b79$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $a33df4b8f27c9b79$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $a33df4b8f27c9b79$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $a33df4b8f27c9b79$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($a33df4b8f27c9b79$var$p(166));
                c = $a33df4b8f27c9b79$var$Hh($a33df4b8f27c9b79$var$Gh.current);
                $a33df4b8f27c9b79$var$Hh($a33df4b8f27c9b79$var$Eh.current);
                if ($a33df4b8f27c9b79$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$a33df4b8f27c9b79$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $a33df4b8f27c9b79$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $a33df4b8f27c9b79$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $a33df4b8f27c9b79$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$a33df4b8f27c9b79$var$Of] = b, b.stateNode = d;
            }
            $a33df4b8f27c9b79$var$S(b);
            return null;
        case 13:
            $a33df4b8f27c9b79$var$E($a33df4b8f27c9b79$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($a33df4b8f27c9b79$var$I && null !== $a33df4b8f27c9b79$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $a33df4b8f27c9b79$var$Hg(), $a33df4b8f27c9b79$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $a33df4b8f27c9b79$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($a33df4b8f27c9b79$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($a33df4b8f27c9b79$var$p(317));
                        f[$a33df4b8f27c9b79$var$Of] = b;
                    } else $a33df4b8f27c9b79$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $a33df4b8f27c9b79$var$S(b);
                    f = !1;
                } else null !== $a33df4b8f27c9b79$var$zg && ($a33df4b8f27c9b79$var$Gj($a33df4b8f27c9b79$var$zg), $a33df4b8f27c9b79$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($a33df4b8f27c9b79$var$M.current & 1) ? 0 === $a33df4b8f27c9b79$var$T && ($a33df4b8f27c9b79$var$T = 3) : $a33df4b8f27c9b79$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $a33df4b8f27c9b79$var$S(b);
            return null;
        case 4:
            return $a33df4b8f27c9b79$var$Jh(), $a33df4b8f27c9b79$var$Bj(a, b), null === a && $a33df4b8f27c9b79$var$sf(b.stateNode.containerInfo), $a33df4b8f27c9b79$var$S(b), null;
        case 10:
            return $a33df4b8f27c9b79$var$Rg(b.type._context), $a33df4b8f27c9b79$var$S(b), null;
        case 17:
            return $a33df4b8f27c9b79$var$Zf(b.type) && $a33df4b8f27c9b79$var$$f(), $a33df4b8f27c9b79$var$S(b), null;
        case 19:
            $a33df4b8f27c9b79$var$E($a33df4b8f27c9b79$var$M);
            f = b.memoizedState;
            if (null === f) return $a33df4b8f27c9b79$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $a33df4b8f27c9b79$var$Ej(f, !1);
                else {
                    if (0 !== $a33df4b8f27c9b79$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $a33df4b8f27c9b79$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $a33df4b8f27c9b79$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $a33df4b8f27c9b79$var$G($a33df4b8f27c9b79$var$M, $a33df4b8f27c9b79$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $a33df4b8f27c9b79$var$B() > $a33df4b8f27c9b79$var$Hj && (b.flags |= 128, d = !0, $a33df4b8f27c9b79$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $a33df4b8f27c9b79$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $a33df4b8f27c9b79$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$a33df4b8f27c9b79$var$I) return $a33df4b8f27c9b79$var$S(b), null;
                    } else 2 * $a33df4b8f27c9b79$var$B() - f.renderingStartTime > $a33df4b8f27c9b79$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $a33df4b8f27c9b79$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $a33df4b8f27c9b79$var$B(), b.sibling = null, c = $a33df4b8f27c9b79$var$M.current, $a33df4b8f27c9b79$var$G($a33df4b8f27c9b79$var$M, d ? c & 1 | 2 : c & 1), b;
            $a33df4b8f27c9b79$var$S(b);
            return null;
        case 22:
        case 23:
            return $a33df4b8f27c9b79$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($a33df4b8f27c9b79$var$gj & 1073741824) && ($a33df4b8f27c9b79$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $a33df4b8f27c9b79$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($a33df4b8f27c9b79$var$p(156, b.tag));
}
function $a33df4b8f27c9b79$var$Jj(a, b) {
    $a33df4b8f27c9b79$var$wg(b);
    switch(b.tag){
        case 1:
            return $a33df4b8f27c9b79$var$Zf(b.type) && $a33df4b8f27c9b79$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $a33df4b8f27c9b79$var$Jh(), $a33df4b8f27c9b79$var$E($a33df4b8f27c9b79$var$Wf), $a33df4b8f27c9b79$var$E($a33df4b8f27c9b79$var$H), $a33df4b8f27c9b79$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $a33df4b8f27c9b79$var$Lh(b), null;
        case 13:
            $a33df4b8f27c9b79$var$E($a33df4b8f27c9b79$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($a33df4b8f27c9b79$var$p(340));
                $a33df4b8f27c9b79$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $a33df4b8f27c9b79$var$E($a33df4b8f27c9b79$var$M), null;
        case 4:
            return $a33df4b8f27c9b79$var$Jh(), null;
        case 10:
            return $a33df4b8f27c9b79$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $a33df4b8f27c9b79$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $a33df4b8f27c9b79$var$Kj = !1, $a33df4b8f27c9b79$var$U = !1, $a33df4b8f27c9b79$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $a33df4b8f27c9b79$var$V = null;
function $a33df4b8f27c9b79$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $a33df4b8f27c9b79$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $a33df4b8f27c9b79$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $a33df4b8f27c9b79$var$W(a, b, d);
    }
}
var $a33df4b8f27c9b79$var$Oj = !1;
function $a33df4b8f27c9b79$var$Pj(a, b) {
    $a33df4b8f27c9b79$var$Cf = $a33df4b8f27c9b79$var$dd;
    a = $a33df4b8f27c9b79$var$Me();
    if ($a33df4b8f27c9b79$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $a33df4b8f27c9b79$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $a33df4b8f27c9b79$var$dd = !1;
    for($a33df4b8f27c9b79$var$V = b; null !== $a33df4b8f27c9b79$var$V;)if (b = $a33df4b8f27c9b79$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $a33df4b8f27c9b79$var$V = a;
    else for(; null !== $a33df4b8f27c9b79$var$V;){
        b = $a33df4b8f27c9b79$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $a33df4b8f27c9b79$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($a33df4b8f27c9b79$var$p(163));
            }
        } catch (F) {
            $a33df4b8f27c9b79$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $a33df4b8f27c9b79$var$V = a;
            break;
        }
        $a33df4b8f27c9b79$var$V = b.return;
    }
    n = $a33df4b8f27c9b79$var$Oj;
    $a33df4b8f27c9b79$var$Oj = !1;
    return n;
}
function $a33df4b8f27c9b79$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $a33df4b8f27c9b79$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $a33df4b8f27c9b79$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $a33df4b8f27c9b79$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $a33df4b8f27c9b79$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $a33df4b8f27c9b79$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$a33df4b8f27c9b79$var$Of], delete b[$a33df4b8f27c9b79$var$Pf], delete b[$a33df4b8f27c9b79$var$of], delete b[$a33df4b8f27c9b79$var$Qf], delete b[$a33df4b8f27c9b79$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $a33df4b8f27c9b79$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $a33df4b8f27c9b79$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $a33df4b8f27c9b79$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $a33df4b8f27c9b79$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $a33df4b8f27c9b79$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($a33df4b8f27c9b79$var$Wj(a, b, c), a = a.sibling; null !== a;)$a33df4b8f27c9b79$var$Wj(a, b, c), a = a.sibling;
}
function $a33df4b8f27c9b79$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($a33df4b8f27c9b79$var$Xj(a, b, c), a = a.sibling; null !== a;)$a33df4b8f27c9b79$var$Xj(a, b, c), a = a.sibling;
}
var $a33df4b8f27c9b79$var$X = null, $a33df4b8f27c9b79$var$Yj = !1;
function $a33df4b8f27c9b79$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$a33df4b8f27c9b79$var$ak(a, b, c), c = c.sibling;
}
function $a33df4b8f27c9b79$var$ak(a, b, c) {
    if ($a33df4b8f27c9b79$var$lc && "function" === typeof $a33df4b8f27c9b79$var$lc.onCommitFiberUnmount) try {
        $a33df4b8f27c9b79$var$lc.onCommitFiberUnmount($a33df4b8f27c9b79$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $a33df4b8f27c9b79$var$U || $a33df4b8f27c9b79$var$Mj(c, b);
        case 6:
            var d = $a33df4b8f27c9b79$var$X, e = $a33df4b8f27c9b79$var$Yj;
            $a33df4b8f27c9b79$var$X = null;
            $a33df4b8f27c9b79$var$Zj(a, b, c);
            $a33df4b8f27c9b79$var$X = d;
            $a33df4b8f27c9b79$var$Yj = e;
            null !== $a33df4b8f27c9b79$var$X && ($a33df4b8f27c9b79$var$Yj ? (a = $a33df4b8f27c9b79$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $a33df4b8f27c9b79$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $a33df4b8f27c9b79$var$X && ($a33df4b8f27c9b79$var$Yj ? (a = $a33df4b8f27c9b79$var$X, c = c.stateNode, 8 === a.nodeType ? $a33df4b8f27c9b79$var$Kf(a.parentNode, c) : 1 === a.nodeType && $a33df4b8f27c9b79$var$Kf(a, c), $a33df4b8f27c9b79$var$bd(a)) : $a33df4b8f27c9b79$var$Kf($a33df4b8f27c9b79$var$X, c.stateNode));
            break;
        case 4:
            d = $a33df4b8f27c9b79$var$X;
            e = $a33df4b8f27c9b79$var$Yj;
            $a33df4b8f27c9b79$var$X = c.stateNode.containerInfo;
            $a33df4b8f27c9b79$var$Yj = !0;
            $a33df4b8f27c9b79$var$Zj(a, b, c);
            $a33df4b8f27c9b79$var$X = d;
            $a33df4b8f27c9b79$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$a33df4b8f27c9b79$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $a33df4b8f27c9b79$var$Nj(c, b, g) : 0 !== (f & 4) && $a33df4b8f27c9b79$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $a33df4b8f27c9b79$var$Zj(a, b, c);
            break;
        case 1:
            if (!$a33df4b8f27c9b79$var$U && ($a33df4b8f27c9b79$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $a33df4b8f27c9b79$var$W(c, b, h);
            }
            $a33df4b8f27c9b79$var$Zj(a, b, c);
            break;
        case 21:
            $a33df4b8f27c9b79$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($a33df4b8f27c9b79$var$U = (d = $a33df4b8f27c9b79$var$U) || null !== c.memoizedState, $a33df4b8f27c9b79$var$Zj(a, b, c), $a33df4b8f27c9b79$var$U = d) : $a33df4b8f27c9b79$var$Zj(a, b, c);
            break;
        default:
            $a33df4b8f27c9b79$var$Zj(a, b, c);
    }
}
function $a33df4b8f27c9b79$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $a33df4b8f27c9b79$var$Lj);
        b.forEach(function(b) {
            var d = $a33df4b8f27c9b79$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $a33df4b8f27c9b79$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $a33df4b8f27c9b79$var$X = h.stateNode;
                        $a33df4b8f27c9b79$var$Yj = !1;
                        break a;
                    case 3:
                        $a33df4b8f27c9b79$var$X = h.stateNode.containerInfo;
                        $a33df4b8f27c9b79$var$Yj = !0;
                        break a;
                    case 4:
                        $a33df4b8f27c9b79$var$X = h.stateNode.containerInfo;
                        $a33df4b8f27c9b79$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $a33df4b8f27c9b79$var$X) throw Error($a33df4b8f27c9b79$var$p(160));
            $a33df4b8f27c9b79$var$ak(f, g, e);
            $a33df4b8f27c9b79$var$X = null;
            $a33df4b8f27c9b79$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $a33df4b8f27c9b79$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$a33df4b8f27c9b79$var$ek(b, a), b = b.sibling;
}
function $a33df4b8f27c9b79$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $a33df4b8f27c9b79$var$dk(b, a);
            $a33df4b8f27c9b79$var$fk(a);
            if (d & 4) {
                try {
                    $a33df4b8f27c9b79$var$Qj(3, a, a.return), $a33df4b8f27c9b79$var$Rj(3, a);
                } catch (t) {
                    $a33df4b8f27c9b79$var$W(a, a.return, t);
                }
                try {
                    $a33df4b8f27c9b79$var$Qj(5, a, a.return);
                } catch (t) {
                    $a33df4b8f27c9b79$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $a33df4b8f27c9b79$var$dk(b, a);
            $a33df4b8f27c9b79$var$fk(a);
            d & 512 && null !== c && $a33df4b8f27c9b79$var$Mj(c, c.return);
            break;
        case 5:
            $a33df4b8f27c9b79$var$dk(b, a);
            $a33df4b8f27c9b79$var$fk(a);
            d & 512 && null !== c && $a33df4b8f27c9b79$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $a33df4b8f27c9b79$var$ob(e, "");
                } catch (t) {
                    $a33df4b8f27c9b79$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $a33df4b8f27c9b79$var$ab(e, f);
                    $a33df4b8f27c9b79$var$vb(h, g);
                    var l = $a33df4b8f27c9b79$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $a33df4b8f27c9b79$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $a33df4b8f27c9b79$var$nb(e, q) : "children" === m ? $a33df4b8f27c9b79$var$ob(e, q) : $a33df4b8f27c9b79$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $a33df4b8f27c9b79$var$bb(e, f);
                            break;
                        case "textarea":
                            $a33df4b8f27c9b79$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $a33df4b8f27c9b79$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $a33df4b8f27c9b79$var$fb(e, !!f.multiple, f.defaultValue, !0) : $a33df4b8f27c9b79$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$a33df4b8f27c9b79$var$Pf] = f;
                } catch (t) {
                    $a33df4b8f27c9b79$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $a33df4b8f27c9b79$var$dk(b, a);
            $a33df4b8f27c9b79$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($a33df4b8f27c9b79$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $a33df4b8f27c9b79$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $a33df4b8f27c9b79$var$dk(b, a);
            $a33df4b8f27c9b79$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $a33df4b8f27c9b79$var$bd(b.containerInfo);
            } catch (t) {
                $a33df4b8f27c9b79$var$W(a, a.return, t);
            }
            break;
        case 4:
            $a33df4b8f27c9b79$var$dk(b, a);
            $a33df4b8f27c9b79$var$fk(a);
            break;
        case 13:
            $a33df4b8f27c9b79$var$dk(b, a);
            $a33df4b8f27c9b79$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($a33df4b8f27c9b79$var$gk = $a33df4b8f27c9b79$var$B()));
            d & 4 && $a33df4b8f27c9b79$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($a33df4b8f27c9b79$var$U = (l = $a33df4b8f27c9b79$var$U) || m, $a33df4b8f27c9b79$var$dk(b, a), $a33df4b8f27c9b79$var$U = l) : $a33df4b8f27c9b79$var$dk(b, a);
            $a33df4b8f27c9b79$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($a33df4b8f27c9b79$var$V = a, m = a.child; null !== m;){
                    for(q = $a33df4b8f27c9b79$var$V = m; null !== $a33df4b8f27c9b79$var$V;){
                        r = $a33df4b8f27c9b79$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $a33df4b8f27c9b79$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $a33df4b8f27c9b79$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $a33df4b8f27c9b79$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $a33df4b8f27c9b79$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $a33df4b8f27c9b79$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $a33df4b8f27c9b79$var$V = y) : $a33df4b8f27c9b79$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $a33df4b8f27c9b79$var$rb("display", g));
                            } catch (t) {
                                $a33df4b8f27c9b79$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $a33df4b8f27c9b79$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $a33df4b8f27c9b79$var$dk(b, a);
            $a33df4b8f27c9b79$var$fk(a);
            d & 4 && $a33df4b8f27c9b79$var$bk(a);
            break;
        case 21:
            break;
        default:
            $a33df4b8f27c9b79$var$dk(b, a), $a33df4b8f27c9b79$var$fk(a);
    }
}
function $a33df4b8f27c9b79$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($a33df4b8f27c9b79$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($a33df4b8f27c9b79$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($a33df4b8f27c9b79$var$ob(e, ""), d.flags &= -33);
                    var f = $a33df4b8f27c9b79$var$Vj(a);
                    $a33df4b8f27c9b79$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $a33df4b8f27c9b79$var$Vj(a);
                    $a33df4b8f27c9b79$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($a33df4b8f27c9b79$var$p(161));
            }
        } catch (k) {
            $a33df4b8f27c9b79$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $a33df4b8f27c9b79$var$ik(a, b, c) {
    $a33df4b8f27c9b79$var$V = a;
    $a33df4b8f27c9b79$var$jk(a, b, c);
}
function $a33df4b8f27c9b79$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $a33df4b8f27c9b79$var$V;){
        var e = $a33df4b8f27c9b79$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $a33df4b8f27c9b79$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $a33df4b8f27c9b79$var$U;
                h = $a33df4b8f27c9b79$var$Kj;
                var l = $a33df4b8f27c9b79$var$U;
                $a33df4b8f27c9b79$var$Kj = g;
                if (($a33df4b8f27c9b79$var$U = k) && !l) for($a33df4b8f27c9b79$var$V = e; null !== $a33df4b8f27c9b79$var$V;)g = $a33df4b8f27c9b79$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $a33df4b8f27c9b79$var$kk(e) : null !== k ? (k.return = g, $a33df4b8f27c9b79$var$V = k) : $a33df4b8f27c9b79$var$kk(e);
                for(; null !== f;)$a33df4b8f27c9b79$var$V = f, $a33df4b8f27c9b79$var$jk(f, b, c), f = f.sibling;
                $a33df4b8f27c9b79$var$V = e;
                $a33df4b8f27c9b79$var$Kj = h;
                $a33df4b8f27c9b79$var$U = l;
            }
            $a33df4b8f27c9b79$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $a33df4b8f27c9b79$var$V = f) : $a33df4b8f27c9b79$var$lk(a, b, c);
    }
}
function $a33df4b8f27c9b79$var$lk(a) {
    for(; null !== $a33df4b8f27c9b79$var$V;){
        var b = $a33df4b8f27c9b79$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $a33df4b8f27c9b79$var$U || $a33df4b8f27c9b79$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$a33df4b8f27c9b79$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $a33df4b8f27c9b79$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $a33df4b8f27c9b79$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $a33df4b8f27c9b79$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $a33df4b8f27c9b79$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($a33df4b8f27c9b79$var$p(163));
                }
                $a33df4b8f27c9b79$var$U || b.flags & 512 && $a33df4b8f27c9b79$var$Sj(b);
            } catch (r) {
                $a33df4b8f27c9b79$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $a33df4b8f27c9b79$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $a33df4b8f27c9b79$var$V = c;
            break;
        }
        $a33df4b8f27c9b79$var$V = b.return;
    }
}
function $a33df4b8f27c9b79$var$hk(a) {
    for(; null !== $a33df4b8f27c9b79$var$V;){
        var b = $a33df4b8f27c9b79$var$V;
        if (b === a) {
            $a33df4b8f27c9b79$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $a33df4b8f27c9b79$var$V = c;
            break;
        }
        $a33df4b8f27c9b79$var$V = b.return;
    }
}
function $a33df4b8f27c9b79$var$kk(a) {
    for(; null !== $a33df4b8f27c9b79$var$V;){
        var b = $a33df4b8f27c9b79$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $a33df4b8f27c9b79$var$Rj(4, b);
                    } catch (k) {
                        $a33df4b8f27c9b79$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $a33df4b8f27c9b79$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $a33df4b8f27c9b79$var$Sj(b);
                    } catch (k) {
                        $a33df4b8f27c9b79$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $a33df4b8f27c9b79$var$Sj(b);
                    } catch (k) {
                        $a33df4b8f27c9b79$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $a33df4b8f27c9b79$var$W(b, b.return, k);
        }
        if (b === a) {
            $a33df4b8f27c9b79$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $a33df4b8f27c9b79$var$V = h;
            break;
        }
        $a33df4b8f27c9b79$var$V = b.return;
    }
}
var $a33df4b8f27c9b79$var$mk = Math.ceil, $a33df4b8f27c9b79$var$nk = $a33df4b8f27c9b79$var$ua.ReactCurrentDispatcher, $a33df4b8f27c9b79$var$ok = $a33df4b8f27c9b79$var$ua.ReactCurrentOwner, $a33df4b8f27c9b79$var$pk = $a33df4b8f27c9b79$var$ua.ReactCurrentBatchConfig, $a33df4b8f27c9b79$var$K = 0, $a33df4b8f27c9b79$var$R = null, $a33df4b8f27c9b79$var$Y = null, $a33df4b8f27c9b79$var$Z = 0, $a33df4b8f27c9b79$var$gj = 0, $a33df4b8f27c9b79$var$fj = $a33df4b8f27c9b79$var$Uf(0), $a33df4b8f27c9b79$var$T = 0, $a33df4b8f27c9b79$var$qk = null, $a33df4b8f27c9b79$var$hh = 0, $a33df4b8f27c9b79$var$rk = 0, $a33df4b8f27c9b79$var$sk = 0, $a33df4b8f27c9b79$var$tk = null, $a33df4b8f27c9b79$var$uk = null, $a33df4b8f27c9b79$var$gk = 0, $a33df4b8f27c9b79$var$Hj = Infinity, $a33df4b8f27c9b79$var$vk = null, $a33df4b8f27c9b79$var$Pi = !1, $a33df4b8f27c9b79$var$Qi = null, $a33df4b8f27c9b79$var$Si = null, $a33df4b8f27c9b79$var$wk = !1, $a33df4b8f27c9b79$var$xk = null, $a33df4b8f27c9b79$var$yk = 0, $a33df4b8f27c9b79$var$zk = 0, $a33df4b8f27c9b79$var$Ak = null, $a33df4b8f27c9b79$var$Bk = -1, $a33df4b8f27c9b79$var$Ck = 0;
function $a33df4b8f27c9b79$var$L() {
    return 0 !== ($a33df4b8f27c9b79$var$K & 6) ? $a33df4b8f27c9b79$var$B() : -1 !== $a33df4b8f27c9b79$var$Bk ? $a33df4b8f27c9b79$var$Bk : $a33df4b8f27c9b79$var$Bk = $a33df4b8f27c9b79$var$B();
}
function $a33df4b8f27c9b79$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($a33df4b8f27c9b79$var$K & 2) && 0 !== $a33df4b8f27c9b79$var$Z) return $a33df4b8f27c9b79$var$Z & -$a33df4b8f27c9b79$var$Z;
    if (null !== $a33df4b8f27c9b79$var$Kg.transition) return 0 === $a33df4b8f27c9b79$var$Ck && ($a33df4b8f27c9b79$var$Ck = $a33df4b8f27c9b79$var$yc()), $a33df4b8f27c9b79$var$Ck;
    a = $a33df4b8f27c9b79$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $a33df4b8f27c9b79$var$jd(a.type);
    return a;
}
function $a33df4b8f27c9b79$var$mh(a, b, c, d) {
    if (50 < $a33df4b8f27c9b79$var$zk) throw $a33df4b8f27c9b79$var$zk = 0, $a33df4b8f27c9b79$var$Ak = null, Error($a33df4b8f27c9b79$var$p(185));
    $a33df4b8f27c9b79$var$Ac(a, c, d);
    if (0 === ($a33df4b8f27c9b79$var$K & 2) || a !== $a33df4b8f27c9b79$var$R) a === $a33df4b8f27c9b79$var$R && (0 === ($a33df4b8f27c9b79$var$K & 2) && ($a33df4b8f27c9b79$var$rk |= c), 4 === $a33df4b8f27c9b79$var$T && $a33df4b8f27c9b79$var$Dk(a, $a33df4b8f27c9b79$var$Z)), $a33df4b8f27c9b79$var$Ek(a, d), 1 === c && 0 === $a33df4b8f27c9b79$var$K && 0 === (b.mode & 1) && ($a33df4b8f27c9b79$var$Hj = $a33df4b8f27c9b79$var$B() + 500, $a33df4b8f27c9b79$var$fg && $a33df4b8f27c9b79$var$jg());
}
function $a33df4b8f27c9b79$var$Ek(a, b) {
    var c = a.callbackNode;
    $a33df4b8f27c9b79$var$wc(a, b);
    var d = $a33df4b8f27c9b79$var$uc(a, a === $a33df4b8f27c9b79$var$R ? $a33df4b8f27c9b79$var$Z : 0);
    if (0 === d) null !== c && $a33df4b8f27c9b79$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $a33df4b8f27c9b79$var$bc(c);
        if (1 === b) 0 === a.tag ? $a33df4b8f27c9b79$var$ig($a33df4b8f27c9b79$var$Fk.bind(null, a)) : $a33df4b8f27c9b79$var$hg($a33df4b8f27c9b79$var$Fk.bind(null, a)), $a33df4b8f27c9b79$var$Jf(function() {
            0 === ($a33df4b8f27c9b79$var$K & 6) && $a33df4b8f27c9b79$var$jg();
        }), c = null;
        else {
            switch($a33df4b8f27c9b79$var$Dc(d)){
                case 1:
                    c = $a33df4b8f27c9b79$var$fc;
                    break;
                case 4:
                    c = $a33df4b8f27c9b79$var$gc;
                    break;
                case 16:
                    c = $a33df4b8f27c9b79$var$hc;
                    break;
                case 536870912:
                    c = $a33df4b8f27c9b79$var$jc;
                    break;
                default:
                    c = $a33df4b8f27c9b79$var$hc;
            }
            c = $a33df4b8f27c9b79$var$Gk(c, $a33df4b8f27c9b79$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $a33df4b8f27c9b79$var$Hk(a, b) {
    $a33df4b8f27c9b79$var$Bk = -1;
    $a33df4b8f27c9b79$var$Ck = 0;
    if (0 !== ($a33df4b8f27c9b79$var$K & 6)) throw Error($a33df4b8f27c9b79$var$p(327));
    var c = a.callbackNode;
    if ($a33df4b8f27c9b79$var$Ik() && a.callbackNode !== c) return null;
    var d = $a33df4b8f27c9b79$var$uc(a, a === $a33df4b8f27c9b79$var$R ? $a33df4b8f27c9b79$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $a33df4b8f27c9b79$var$Jk(a, d);
    else {
        b = d;
        var e = $a33df4b8f27c9b79$var$K;
        $a33df4b8f27c9b79$var$K |= 2;
        var f = $a33df4b8f27c9b79$var$Kk();
        if ($a33df4b8f27c9b79$var$R !== a || $a33df4b8f27c9b79$var$Z !== b) $a33df4b8f27c9b79$var$vk = null, $a33df4b8f27c9b79$var$Hj = $a33df4b8f27c9b79$var$B() + 500, $a33df4b8f27c9b79$var$Lk(a, b);
        for(;;)try {
            $a33df4b8f27c9b79$var$Mk();
            break;
        } catch (h) {
            $a33df4b8f27c9b79$var$Nk(a, h);
        }
        $a33df4b8f27c9b79$var$Qg();
        $a33df4b8f27c9b79$var$nk.current = f;
        $a33df4b8f27c9b79$var$K = e;
        null !== $a33df4b8f27c9b79$var$Y ? b = 0 : ($a33df4b8f27c9b79$var$R = null, $a33df4b8f27c9b79$var$Z = 0, b = $a33df4b8f27c9b79$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $a33df4b8f27c9b79$var$xc(a), 0 !== e && (d = e, b = $a33df4b8f27c9b79$var$Ok(a, e)));
        if (1 === b) throw c = $a33df4b8f27c9b79$var$qk, $a33df4b8f27c9b79$var$Lk(a, 0), $a33df4b8f27c9b79$var$Dk(a, d), $a33df4b8f27c9b79$var$Ek(a, $a33df4b8f27c9b79$var$B()), c;
        if (6 === b) $a33df4b8f27c9b79$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$a33df4b8f27c9b79$var$Pk(e) && (b = $a33df4b8f27c9b79$var$Jk(a, d), 2 === b && (f = $a33df4b8f27c9b79$var$xc(a), 0 !== f && (d = f, b = $a33df4b8f27c9b79$var$Ok(a, f))), 1 === b)) throw c = $a33df4b8f27c9b79$var$qk, $a33df4b8f27c9b79$var$Lk(a, 0), $a33df4b8f27c9b79$var$Dk(a, d), $a33df4b8f27c9b79$var$Ek(a, $a33df4b8f27c9b79$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($a33df4b8f27c9b79$var$p(345));
                case 2:
                    $a33df4b8f27c9b79$var$Qk(a, $a33df4b8f27c9b79$var$uk, $a33df4b8f27c9b79$var$vk);
                    break;
                case 3:
                    $a33df4b8f27c9b79$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $a33df4b8f27c9b79$var$gk + 500 - $a33df4b8f27c9b79$var$B(), 10 < b)) {
                        if (0 !== $a33df4b8f27c9b79$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $a33df4b8f27c9b79$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $a33df4b8f27c9b79$var$Ff($a33df4b8f27c9b79$var$Qk.bind(null, a, $a33df4b8f27c9b79$var$uk, $a33df4b8f27c9b79$var$vk), b);
                        break;
                    }
                    $a33df4b8f27c9b79$var$Qk(a, $a33df4b8f27c9b79$var$uk, $a33df4b8f27c9b79$var$vk);
                    break;
                case 4:
                    $a33df4b8f27c9b79$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $a33df4b8f27c9b79$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $a33df4b8f27c9b79$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $a33df4b8f27c9b79$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $a33df4b8f27c9b79$var$Ff($a33df4b8f27c9b79$var$Qk.bind(null, a, $a33df4b8f27c9b79$var$uk, $a33df4b8f27c9b79$var$vk), d);
                        break;
                    }
                    $a33df4b8f27c9b79$var$Qk(a, $a33df4b8f27c9b79$var$uk, $a33df4b8f27c9b79$var$vk);
                    break;
                case 5:
                    $a33df4b8f27c9b79$var$Qk(a, $a33df4b8f27c9b79$var$uk, $a33df4b8f27c9b79$var$vk);
                    break;
                default:
                    throw Error($a33df4b8f27c9b79$var$p(329));
            }
        }
    }
    $a33df4b8f27c9b79$var$Ek(a, $a33df4b8f27c9b79$var$B());
    return a.callbackNode === c ? $a33df4b8f27c9b79$var$Hk.bind(null, a) : null;
}
function $a33df4b8f27c9b79$var$Ok(a, b) {
    var c = $a33df4b8f27c9b79$var$tk;
    a.current.memoizedState.isDehydrated && ($a33df4b8f27c9b79$var$Lk(a, b).flags |= 256);
    a = $a33df4b8f27c9b79$var$Jk(a, b);
    2 !== a && (b = $a33df4b8f27c9b79$var$uk, $a33df4b8f27c9b79$var$uk = c, null !== b && $a33df4b8f27c9b79$var$Gj(b));
    return a;
}
function $a33df4b8f27c9b79$var$Gj(a) {
    null === $a33df4b8f27c9b79$var$uk ? $a33df4b8f27c9b79$var$uk = a : $a33df4b8f27c9b79$var$uk.push.apply($a33df4b8f27c9b79$var$uk, a);
}
function $a33df4b8f27c9b79$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$a33df4b8f27c9b79$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $a33df4b8f27c9b79$var$Dk(a, b) {
    b &= ~$a33df4b8f27c9b79$var$sk;
    b &= ~$a33df4b8f27c9b79$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $a33df4b8f27c9b79$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $a33df4b8f27c9b79$var$Fk(a) {
    if (0 !== ($a33df4b8f27c9b79$var$K & 6)) throw Error($a33df4b8f27c9b79$var$p(327));
    $a33df4b8f27c9b79$var$Ik();
    var b = $a33df4b8f27c9b79$var$uc(a, 0);
    if (0 === (b & 1)) return $a33df4b8f27c9b79$var$Ek(a, $a33df4b8f27c9b79$var$B()), null;
    var c = $a33df4b8f27c9b79$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $a33df4b8f27c9b79$var$xc(a);
        0 !== d && (b = d, c = $a33df4b8f27c9b79$var$Ok(a, d));
    }
    if (1 === c) throw c = $a33df4b8f27c9b79$var$qk, $a33df4b8f27c9b79$var$Lk(a, 0), $a33df4b8f27c9b79$var$Dk(a, b), $a33df4b8f27c9b79$var$Ek(a, $a33df4b8f27c9b79$var$B()), c;
    if (6 === c) throw Error($a33df4b8f27c9b79$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $a33df4b8f27c9b79$var$Qk(a, $a33df4b8f27c9b79$var$uk, $a33df4b8f27c9b79$var$vk);
    $a33df4b8f27c9b79$var$Ek(a, $a33df4b8f27c9b79$var$B());
    return null;
}
function $a33df4b8f27c9b79$var$Rk(a, b) {
    var c = $a33df4b8f27c9b79$var$K;
    $a33df4b8f27c9b79$var$K |= 1;
    try {
        return a(b);
    } finally{
        $a33df4b8f27c9b79$var$K = c, 0 === $a33df4b8f27c9b79$var$K && ($a33df4b8f27c9b79$var$Hj = $a33df4b8f27c9b79$var$B() + 500, $a33df4b8f27c9b79$var$fg && $a33df4b8f27c9b79$var$jg());
    }
}
function $a33df4b8f27c9b79$var$Sk(a) {
    null !== $a33df4b8f27c9b79$var$xk && 0 === $a33df4b8f27c9b79$var$xk.tag && 0 === ($a33df4b8f27c9b79$var$K & 6) && $a33df4b8f27c9b79$var$Ik();
    var b = $a33df4b8f27c9b79$var$K;
    $a33df4b8f27c9b79$var$K |= 1;
    var c = $a33df4b8f27c9b79$var$pk.transition, d = $a33df4b8f27c9b79$var$C;
    try {
        if ($a33df4b8f27c9b79$var$pk.transition = null, $a33df4b8f27c9b79$var$C = 1, a) return a();
    } finally{
        $a33df4b8f27c9b79$var$C = d, $a33df4b8f27c9b79$var$pk.transition = c, $a33df4b8f27c9b79$var$K = b, 0 === ($a33df4b8f27c9b79$var$K & 6) && $a33df4b8f27c9b79$var$jg();
    }
}
function $a33df4b8f27c9b79$var$Ij() {
    $a33df4b8f27c9b79$var$gj = $a33df4b8f27c9b79$var$fj.current;
    $a33df4b8f27c9b79$var$E($a33df4b8f27c9b79$var$fj);
}
function $a33df4b8f27c9b79$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $a33df4b8f27c9b79$var$Gf(c));
    if (null !== $a33df4b8f27c9b79$var$Y) for(c = $a33df4b8f27c9b79$var$Y.return; null !== c;){
        var d = c;
        $a33df4b8f27c9b79$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $a33df4b8f27c9b79$var$$f();
                break;
            case 3:
                $a33df4b8f27c9b79$var$Jh();
                $a33df4b8f27c9b79$var$E($a33df4b8f27c9b79$var$Wf);
                $a33df4b8f27c9b79$var$E($a33df4b8f27c9b79$var$H);
                $a33df4b8f27c9b79$var$Oh();
                break;
            case 5:
                $a33df4b8f27c9b79$var$Lh(d);
                break;
            case 4:
                $a33df4b8f27c9b79$var$Jh();
                break;
            case 13:
                $a33df4b8f27c9b79$var$E($a33df4b8f27c9b79$var$M);
                break;
            case 19:
                $a33df4b8f27c9b79$var$E($a33df4b8f27c9b79$var$M);
                break;
            case 10:
                $a33df4b8f27c9b79$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $a33df4b8f27c9b79$var$Ij();
        }
        c = c.return;
    }
    $a33df4b8f27c9b79$var$R = a;
    $a33df4b8f27c9b79$var$Y = a = $a33df4b8f27c9b79$var$wh(a.current, null);
    $a33df4b8f27c9b79$var$Z = $a33df4b8f27c9b79$var$gj = b;
    $a33df4b8f27c9b79$var$T = 0;
    $a33df4b8f27c9b79$var$qk = null;
    $a33df4b8f27c9b79$var$sk = $a33df4b8f27c9b79$var$rk = $a33df4b8f27c9b79$var$hh = 0;
    $a33df4b8f27c9b79$var$uk = $a33df4b8f27c9b79$var$tk = null;
    if (null !== $a33df4b8f27c9b79$var$Wg) {
        for(b = 0; b < $a33df4b8f27c9b79$var$Wg.length; b++)if (c = $a33df4b8f27c9b79$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $a33df4b8f27c9b79$var$Wg = null;
    }
    return a;
}
function $a33df4b8f27c9b79$var$Nk(a, b) {
    do {
        var c = $a33df4b8f27c9b79$var$Y;
        try {
            $a33df4b8f27c9b79$var$Qg();
            $a33df4b8f27c9b79$var$Ph.current = $a33df4b8f27c9b79$var$ai;
            if ($a33df4b8f27c9b79$var$Sh) {
                for(var d = $a33df4b8f27c9b79$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $a33df4b8f27c9b79$var$Sh = !1;
            }
            $a33df4b8f27c9b79$var$Rh = 0;
            $a33df4b8f27c9b79$var$P = $a33df4b8f27c9b79$var$O = $a33df4b8f27c9b79$var$N = null;
            $a33df4b8f27c9b79$var$Th = !1;
            $a33df4b8f27c9b79$var$Uh = 0;
            $a33df4b8f27c9b79$var$ok.current = null;
            if (null === c || null === c.return) {
                $a33df4b8f27c9b79$var$T = 1;
                $a33df4b8f27c9b79$var$qk = b;
                $a33df4b8f27c9b79$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $a33df4b8f27c9b79$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $a33df4b8f27c9b79$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $a33df4b8f27c9b79$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $a33df4b8f27c9b79$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $a33df4b8f27c9b79$var$Ti(f, l, b);
                            $a33df4b8f27c9b79$var$uj();
                            break a;
                        }
                        k = Error($a33df4b8f27c9b79$var$p(426));
                    }
                } else if ($a33df4b8f27c9b79$var$I && h.mode & 1) {
                    var J = $a33df4b8f27c9b79$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $a33df4b8f27c9b79$var$Wi(J, g, h, f, b);
                        $a33df4b8f27c9b79$var$Jg($a33df4b8f27c9b79$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $a33df4b8f27c9b79$var$Ki(k, h);
                4 !== $a33df4b8f27c9b79$var$T && ($a33df4b8f27c9b79$var$T = 2);
                null === $a33df4b8f27c9b79$var$tk ? $a33df4b8f27c9b79$var$tk = [
                    f
                ] : $a33df4b8f27c9b79$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $a33df4b8f27c9b79$var$Oi(f, k, b);
                            $a33df4b8f27c9b79$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $a33df4b8f27c9b79$var$Si || !$a33df4b8f27c9b79$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $a33df4b8f27c9b79$var$Ri(f, h, b);
                                $a33df4b8f27c9b79$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $a33df4b8f27c9b79$var$Tk(c);
        } catch (na) {
            b = na;
            $a33df4b8f27c9b79$var$Y === c && null !== c && ($a33df4b8f27c9b79$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $a33df4b8f27c9b79$var$Kk() {
    var a = $a33df4b8f27c9b79$var$nk.current;
    $a33df4b8f27c9b79$var$nk.current = $a33df4b8f27c9b79$var$ai;
    return null === a ? $a33df4b8f27c9b79$var$ai : a;
}
function $a33df4b8f27c9b79$var$uj() {
    if (0 === $a33df4b8f27c9b79$var$T || 3 === $a33df4b8f27c9b79$var$T || 2 === $a33df4b8f27c9b79$var$T) $a33df4b8f27c9b79$var$T = 4;
    null === $a33df4b8f27c9b79$var$R || 0 === ($a33df4b8f27c9b79$var$hh & 268435455) && 0 === ($a33df4b8f27c9b79$var$rk & 268435455) || $a33df4b8f27c9b79$var$Dk($a33df4b8f27c9b79$var$R, $a33df4b8f27c9b79$var$Z);
}
function $a33df4b8f27c9b79$var$Jk(a, b) {
    var c = $a33df4b8f27c9b79$var$K;
    $a33df4b8f27c9b79$var$K |= 2;
    var d = $a33df4b8f27c9b79$var$Kk();
    if ($a33df4b8f27c9b79$var$R !== a || $a33df4b8f27c9b79$var$Z !== b) $a33df4b8f27c9b79$var$vk = null, $a33df4b8f27c9b79$var$Lk(a, b);
    for(;;)try {
        $a33df4b8f27c9b79$var$Uk();
        break;
    } catch (e) {
        $a33df4b8f27c9b79$var$Nk(a, e);
    }
    $a33df4b8f27c9b79$var$Qg();
    $a33df4b8f27c9b79$var$K = c;
    $a33df4b8f27c9b79$var$nk.current = d;
    if (null !== $a33df4b8f27c9b79$var$Y) throw Error($a33df4b8f27c9b79$var$p(261));
    $a33df4b8f27c9b79$var$R = null;
    $a33df4b8f27c9b79$var$Z = 0;
    return $a33df4b8f27c9b79$var$T;
}
function $a33df4b8f27c9b79$var$Uk() {
    for(; null !== $a33df4b8f27c9b79$var$Y;)$a33df4b8f27c9b79$var$Vk($a33df4b8f27c9b79$var$Y);
}
function $a33df4b8f27c9b79$var$Mk() {
    for(; null !== $a33df4b8f27c9b79$var$Y && !$a33df4b8f27c9b79$var$cc();)$a33df4b8f27c9b79$var$Vk($a33df4b8f27c9b79$var$Y);
}
function $a33df4b8f27c9b79$var$Vk(a) {
    var b = $a33df4b8f27c9b79$var$Wk(a.alternate, a, $a33df4b8f27c9b79$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $a33df4b8f27c9b79$var$Tk(a) : $a33df4b8f27c9b79$var$Y = b;
    $a33df4b8f27c9b79$var$ok.current = null;
}
function $a33df4b8f27c9b79$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $a33df4b8f27c9b79$var$Fj(c, b, $a33df4b8f27c9b79$var$gj), null !== c) {
                $a33df4b8f27c9b79$var$Y = c;
                return;
            }
        } else {
            c = $a33df4b8f27c9b79$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $a33df4b8f27c9b79$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $a33df4b8f27c9b79$var$T = 6;
                $a33df4b8f27c9b79$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $a33df4b8f27c9b79$var$Y = b;
            return;
        }
        $a33df4b8f27c9b79$var$Y = b = a;
    }while (null !== b);
    0 === $a33df4b8f27c9b79$var$T && ($a33df4b8f27c9b79$var$T = 5);
}
function $a33df4b8f27c9b79$var$Qk(a, b, c) {
    var d = $a33df4b8f27c9b79$var$C, e = $a33df4b8f27c9b79$var$pk.transition;
    try {
        $a33df4b8f27c9b79$var$pk.transition = null, $a33df4b8f27c9b79$var$C = 1, $a33df4b8f27c9b79$var$Xk(a, b, c, d);
    } finally{
        $a33df4b8f27c9b79$var$pk.transition = e, $a33df4b8f27c9b79$var$C = d;
    }
    return null;
}
function $a33df4b8f27c9b79$var$Xk(a, b, c, d) {
    do $a33df4b8f27c9b79$var$Ik();
    while (null !== $a33df4b8f27c9b79$var$xk);
    if (0 !== ($a33df4b8f27c9b79$var$K & 6)) throw Error($a33df4b8f27c9b79$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($a33df4b8f27c9b79$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $a33df4b8f27c9b79$var$Bc(a, f);
    a === $a33df4b8f27c9b79$var$R && ($a33df4b8f27c9b79$var$Y = $a33df4b8f27c9b79$var$R = null, $a33df4b8f27c9b79$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $a33df4b8f27c9b79$var$wk || ($a33df4b8f27c9b79$var$wk = !0, $a33df4b8f27c9b79$var$Gk($a33df4b8f27c9b79$var$hc, function() {
        $a33df4b8f27c9b79$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $a33df4b8f27c9b79$var$pk.transition;
        $a33df4b8f27c9b79$var$pk.transition = null;
        var g = $a33df4b8f27c9b79$var$C;
        $a33df4b8f27c9b79$var$C = 1;
        var h = $a33df4b8f27c9b79$var$K;
        $a33df4b8f27c9b79$var$K |= 4;
        $a33df4b8f27c9b79$var$ok.current = null;
        $a33df4b8f27c9b79$var$Pj(a, c);
        $a33df4b8f27c9b79$var$ek(c, a);
        $a33df4b8f27c9b79$var$Oe($a33df4b8f27c9b79$var$Df);
        $a33df4b8f27c9b79$var$dd = !!$a33df4b8f27c9b79$var$Cf;
        $a33df4b8f27c9b79$var$Df = $a33df4b8f27c9b79$var$Cf = null;
        a.current = c;
        $a33df4b8f27c9b79$var$ik(c, a, e);
        $a33df4b8f27c9b79$var$dc();
        $a33df4b8f27c9b79$var$K = h;
        $a33df4b8f27c9b79$var$C = g;
        $a33df4b8f27c9b79$var$pk.transition = f;
    } else a.current = c;
    $a33df4b8f27c9b79$var$wk && ($a33df4b8f27c9b79$var$wk = !1, $a33df4b8f27c9b79$var$xk = a, $a33df4b8f27c9b79$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($a33df4b8f27c9b79$var$Si = null);
    $a33df4b8f27c9b79$var$mc(c.stateNode, d);
    $a33df4b8f27c9b79$var$Ek(a, $a33df4b8f27c9b79$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($a33df4b8f27c9b79$var$Pi) throw $a33df4b8f27c9b79$var$Pi = !1, a = $a33df4b8f27c9b79$var$Qi, $a33df4b8f27c9b79$var$Qi = null, a;
    0 !== ($a33df4b8f27c9b79$var$yk & 1) && 0 !== a.tag && $a33df4b8f27c9b79$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $a33df4b8f27c9b79$var$Ak ? $a33df4b8f27c9b79$var$zk++ : ($a33df4b8f27c9b79$var$zk = 0, $a33df4b8f27c9b79$var$Ak = a) : $a33df4b8f27c9b79$var$zk = 0;
    $a33df4b8f27c9b79$var$jg();
    return null;
}
function $a33df4b8f27c9b79$var$Ik() {
    if (null !== $a33df4b8f27c9b79$var$xk) {
        var a = $a33df4b8f27c9b79$var$Dc($a33df4b8f27c9b79$var$yk), b = $a33df4b8f27c9b79$var$pk.transition, c = $a33df4b8f27c9b79$var$C;
        try {
            $a33df4b8f27c9b79$var$pk.transition = null;
            $a33df4b8f27c9b79$var$C = 16 > a ? 16 : a;
            if (null === $a33df4b8f27c9b79$var$xk) var d = !1;
            else {
                a = $a33df4b8f27c9b79$var$xk;
                $a33df4b8f27c9b79$var$xk = null;
                $a33df4b8f27c9b79$var$yk = 0;
                if (0 !== ($a33df4b8f27c9b79$var$K & 6)) throw Error($a33df4b8f27c9b79$var$p(331));
                var e = $a33df4b8f27c9b79$var$K;
                $a33df4b8f27c9b79$var$K |= 4;
                for($a33df4b8f27c9b79$var$V = a.current; null !== $a33df4b8f27c9b79$var$V;){
                    var f = $a33df4b8f27c9b79$var$V, g = f.child;
                    if (0 !== ($a33df4b8f27c9b79$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($a33df4b8f27c9b79$var$V = l; null !== $a33df4b8f27c9b79$var$V;){
                                    var m = $a33df4b8f27c9b79$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $a33df4b8f27c9b79$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $a33df4b8f27c9b79$var$V = q;
                                    else for(; null !== $a33df4b8f27c9b79$var$V;){
                                        m = $a33df4b8f27c9b79$var$V;
                                        var r = m.sibling, y = m.return;
                                        $a33df4b8f27c9b79$var$Tj(m);
                                        if (m === l) {
                                            $a33df4b8f27c9b79$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $a33df4b8f27c9b79$var$V = r;
                                            break;
                                        }
                                        $a33df4b8f27c9b79$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $a33df4b8f27c9b79$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $a33df4b8f27c9b79$var$V = g;
                    else b: for(; null !== $a33df4b8f27c9b79$var$V;){
                        f = $a33df4b8f27c9b79$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $a33df4b8f27c9b79$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $a33df4b8f27c9b79$var$V = x;
                            break b;
                        }
                        $a33df4b8f27c9b79$var$V = f.return;
                    }
                }
                var w = a.current;
                for($a33df4b8f27c9b79$var$V = w; null !== $a33df4b8f27c9b79$var$V;){
                    g = $a33df4b8f27c9b79$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $a33df4b8f27c9b79$var$V = u;
                    else b: for(g = w; null !== $a33df4b8f27c9b79$var$V;){
                        h = $a33df4b8f27c9b79$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $a33df4b8f27c9b79$var$Rj(9, h);
                            }
                        } catch (na) {
                            $a33df4b8f27c9b79$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $a33df4b8f27c9b79$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $a33df4b8f27c9b79$var$V = F;
                            break b;
                        }
                        $a33df4b8f27c9b79$var$V = h.return;
                    }
                }
                $a33df4b8f27c9b79$var$K = e;
                $a33df4b8f27c9b79$var$jg();
                if ($a33df4b8f27c9b79$var$lc && "function" === typeof $a33df4b8f27c9b79$var$lc.onPostCommitFiberRoot) try {
                    $a33df4b8f27c9b79$var$lc.onPostCommitFiberRoot($a33df4b8f27c9b79$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $a33df4b8f27c9b79$var$C = c, $a33df4b8f27c9b79$var$pk.transition = b;
        }
    }
    return !1;
}
function $a33df4b8f27c9b79$var$Yk(a, b, c) {
    b = $a33df4b8f27c9b79$var$Ki(c, b);
    b = $a33df4b8f27c9b79$var$Oi(a, b, 1);
    a = $a33df4b8f27c9b79$var$dh(a, b, 1);
    b = $a33df4b8f27c9b79$var$L();
    null !== a && ($a33df4b8f27c9b79$var$Ac(a, 1, b), $a33df4b8f27c9b79$var$Ek(a, b));
}
function $a33df4b8f27c9b79$var$W(a, b, c) {
    if (3 === a.tag) $a33df4b8f27c9b79$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $a33df4b8f27c9b79$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $a33df4b8f27c9b79$var$Si || !$a33df4b8f27c9b79$var$Si.has(d))) {
                a = $a33df4b8f27c9b79$var$Ki(c, a);
                a = $a33df4b8f27c9b79$var$Ri(b, a, 1);
                b = $a33df4b8f27c9b79$var$dh(b, a, 1);
                a = $a33df4b8f27c9b79$var$L();
                null !== b && ($a33df4b8f27c9b79$var$Ac(b, 1, a), $a33df4b8f27c9b79$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $a33df4b8f27c9b79$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $a33df4b8f27c9b79$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $a33df4b8f27c9b79$var$R === a && ($a33df4b8f27c9b79$var$Z & c) === c && (4 === $a33df4b8f27c9b79$var$T || 3 === $a33df4b8f27c9b79$var$T && ($a33df4b8f27c9b79$var$Z & 130023424) === $a33df4b8f27c9b79$var$Z && 500 > $a33df4b8f27c9b79$var$B() - $a33df4b8f27c9b79$var$gk ? $a33df4b8f27c9b79$var$Lk(a, 0) : $a33df4b8f27c9b79$var$sk |= c);
    $a33df4b8f27c9b79$var$Ek(a, b);
}
function $a33df4b8f27c9b79$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $a33df4b8f27c9b79$var$sc, $a33df4b8f27c9b79$var$sc <<= 1, 0 === ($a33df4b8f27c9b79$var$sc & 130023424) && ($a33df4b8f27c9b79$var$sc = 4194304)));
    var c = $a33df4b8f27c9b79$var$L();
    a = $a33df4b8f27c9b79$var$Zg(a, b);
    null !== a && ($a33df4b8f27c9b79$var$Ac(a, b, c), $a33df4b8f27c9b79$var$Ek(a, c));
}
function $a33df4b8f27c9b79$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $a33df4b8f27c9b79$var$Zk(a, c);
}
function $a33df4b8f27c9b79$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($a33df4b8f27c9b79$var$p(314));
    }
    null !== d && d.delete(b);
    $a33df4b8f27c9b79$var$Zk(a, c);
}
var $a33df4b8f27c9b79$var$Wk;
$a33df4b8f27c9b79$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $a33df4b8f27c9b79$var$Wf.current) $a33df4b8f27c9b79$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $a33df4b8f27c9b79$var$Ug = !1, $a33df4b8f27c9b79$var$zj(a, b, c);
            $a33df4b8f27c9b79$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $a33df4b8f27c9b79$var$Ug = !1, $a33df4b8f27c9b79$var$I && 0 !== (b.flags & 1048576) && $a33df4b8f27c9b79$var$ug(b, $a33df4b8f27c9b79$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $a33df4b8f27c9b79$var$jj(a, b);
            a = b.pendingProps;
            var e = $a33df4b8f27c9b79$var$Yf(b, $a33df4b8f27c9b79$var$H.current);
            $a33df4b8f27c9b79$var$Tg(b, c);
            e = $a33df4b8f27c9b79$var$Xh(null, b, d, a, e, c);
            var f = $a33df4b8f27c9b79$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $a33df4b8f27c9b79$var$Zf(d) ? (f = !0, $a33df4b8f27c9b79$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $a33df4b8f27c9b79$var$ah(b), e.updater = $a33df4b8f27c9b79$var$nh, b.stateNode = e, e._reactInternals = b, $a33df4b8f27c9b79$var$rh(b, d, a, c), b = $a33df4b8f27c9b79$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $a33df4b8f27c9b79$var$I && f && $a33df4b8f27c9b79$var$vg(b), $a33df4b8f27c9b79$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $a33df4b8f27c9b79$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $a33df4b8f27c9b79$var$$k(d);
                a = $a33df4b8f27c9b79$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $a33df4b8f27c9b79$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $a33df4b8f27c9b79$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $a33df4b8f27c9b79$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $a33df4b8f27c9b79$var$aj(null, b, d, $a33df4b8f27c9b79$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($a33df4b8f27c9b79$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $a33df4b8f27c9b79$var$Lg(d, e), $a33df4b8f27c9b79$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $a33df4b8f27c9b79$var$Lg(d, e), $a33df4b8f27c9b79$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $a33df4b8f27c9b79$var$lj(b);
                if (null === a) throw Error($a33df4b8f27c9b79$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $a33df4b8f27c9b79$var$bh(a, b);
                $a33df4b8f27c9b79$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $a33df4b8f27c9b79$var$Ki(Error($a33df4b8f27c9b79$var$p(423)), b);
                        b = $a33df4b8f27c9b79$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $a33df4b8f27c9b79$var$Ki(Error($a33df4b8f27c9b79$var$p(424)), b);
                        b = $a33df4b8f27c9b79$var$mj(a, b, d, c, e);
                        break a;
                    } else for($a33df4b8f27c9b79$var$yg = $a33df4b8f27c9b79$var$Lf(b.stateNode.containerInfo.firstChild), $a33df4b8f27c9b79$var$xg = b, $a33df4b8f27c9b79$var$I = !0, $a33df4b8f27c9b79$var$zg = null, c = $a33df4b8f27c9b79$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $a33df4b8f27c9b79$var$Ig();
                    if (d === e) {
                        b = $a33df4b8f27c9b79$var$$i(a, b, c);
                        break a;
                    }
                    $a33df4b8f27c9b79$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $a33df4b8f27c9b79$var$Kh(b), null === a && $a33df4b8f27c9b79$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $a33df4b8f27c9b79$var$Ef(d, e) ? g = null : null !== f && $a33df4b8f27c9b79$var$Ef(d, f) && (b.flags |= 32), $a33df4b8f27c9b79$var$hj(a, b), $a33df4b8f27c9b79$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $a33df4b8f27c9b79$var$Eg(b), null;
        case 13:
            return $a33df4b8f27c9b79$var$pj(a, b, c);
        case 4:
            return $a33df4b8f27c9b79$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $a33df4b8f27c9b79$var$Bh(b, null, d, c) : $a33df4b8f27c9b79$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $a33df4b8f27c9b79$var$Lg(d, e), $a33df4b8f27c9b79$var$Zi(a, b, d, e, c);
        case 7:
            return $a33df4b8f27c9b79$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $a33df4b8f27c9b79$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $a33df4b8f27c9b79$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $a33df4b8f27c9b79$var$G($a33df4b8f27c9b79$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($a33df4b8f27c9b79$var$He(f.value, g)) {
                        if (f.children === e.children && !$a33df4b8f27c9b79$var$Wf.current) {
                            b = $a33df4b8f27c9b79$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $a33df4b8f27c9b79$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $a33df4b8f27c9b79$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($a33df4b8f27c9b79$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $a33df4b8f27c9b79$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $a33df4b8f27c9b79$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $a33df4b8f27c9b79$var$Tg(b, c), e = $a33df4b8f27c9b79$var$Vg(e), d = d(e), b.flags |= 1, $a33df4b8f27c9b79$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $a33df4b8f27c9b79$var$Lg(d, b.pendingProps), e = $a33df4b8f27c9b79$var$Lg(d.type, e), $a33df4b8f27c9b79$var$aj(a, b, d, e, c);
        case 15:
            return $a33df4b8f27c9b79$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $a33df4b8f27c9b79$var$Lg(d, e), $a33df4b8f27c9b79$var$jj(a, b), b.tag = 1, $a33df4b8f27c9b79$var$Zf(d) ? (a = !0, $a33df4b8f27c9b79$var$cg(b)) : a = !1, $a33df4b8f27c9b79$var$Tg(b, c), $a33df4b8f27c9b79$var$ph(b, d, e), $a33df4b8f27c9b79$var$rh(b, d, e, c), $a33df4b8f27c9b79$var$kj(null, b, d, !0, a, c);
        case 19:
            return $a33df4b8f27c9b79$var$yj(a, b, c);
        case 22:
            return $a33df4b8f27c9b79$var$ej(a, b, c);
    }
    throw Error($a33df4b8f27c9b79$var$p(156, b.tag));
};
function $a33df4b8f27c9b79$var$Gk(a, b) {
    return $a33df4b8f27c9b79$var$ac(a, b);
}
function $a33df4b8f27c9b79$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $a33df4b8f27c9b79$var$Bg(a, b, c, d) {
    return new $a33df4b8f27c9b79$var$al(a, b, c, d);
}
function $a33df4b8f27c9b79$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $a33df4b8f27c9b79$var$$k(a) {
    if ("function" === typeof a) return $a33df4b8f27c9b79$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $a33df4b8f27c9b79$var$Da) return 11;
        if (a === $a33df4b8f27c9b79$var$Ga) return 14;
    }
    return 2;
}
function $a33df4b8f27c9b79$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $a33df4b8f27c9b79$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $a33df4b8f27c9b79$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $a33df4b8f27c9b79$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $a33df4b8f27c9b79$var$ya:
            return $a33df4b8f27c9b79$var$Ah(c.children, e, f, b);
        case $a33df4b8f27c9b79$var$za:
            g = 8;
            e |= 8;
            break;
        case $a33df4b8f27c9b79$var$Aa:
            return a = $a33df4b8f27c9b79$var$Bg(12, c, b, e | 2), a.elementType = $a33df4b8f27c9b79$var$Aa, a.lanes = f, a;
        case $a33df4b8f27c9b79$var$Ea:
            return a = $a33df4b8f27c9b79$var$Bg(13, c, b, e), a.elementType = $a33df4b8f27c9b79$var$Ea, a.lanes = f, a;
        case $a33df4b8f27c9b79$var$Fa:
            return a = $a33df4b8f27c9b79$var$Bg(19, c, b, e), a.elementType = $a33df4b8f27c9b79$var$Fa, a.lanes = f, a;
        case $a33df4b8f27c9b79$var$Ia:
            return $a33df4b8f27c9b79$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $a33df4b8f27c9b79$var$Ba:
                    g = 10;
                    break a;
                case $a33df4b8f27c9b79$var$Ca:
                    g = 9;
                    break a;
                case $a33df4b8f27c9b79$var$Da:
                    g = 11;
                    break a;
                case $a33df4b8f27c9b79$var$Ga:
                    g = 14;
                    break a;
                case $a33df4b8f27c9b79$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($a33df4b8f27c9b79$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $a33df4b8f27c9b79$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $a33df4b8f27c9b79$var$Ah(a, b, c, d) {
    a = $a33df4b8f27c9b79$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $a33df4b8f27c9b79$var$qj(a, b, c, d) {
    a = $a33df4b8f27c9b79$var$Bg(22, a, d, b);
    a.elementType = $a33df4b8f27c9b79$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $a33df4b8f27c9b79$var$xh(a, b, c) {
    a = $a33df4b8f27c9b79$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $a33df4b8f27c9b79$var$zh(a, b, c) {
    b = $a33df4b8f27c9b79$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $a33df4b8f27c9b79$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $a33df4b8f27c9b79$var$zc(0);
    this.expirationTimes = $a33df4b8f27c9b79$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $a33df4b8f27c9b79$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $a33df4b8f27c9b79$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $a33df4b8f27c9b79$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $a33df4b8f27c9b79$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $a33df4b8f27c9b79$var$ah(f);
    return a;
}
function $a33df4b8f27c9b79$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $a33df4b8f27c9b79$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $a33df4b8f27c9b79$var$el(a) {
    if (!a) return $a33df4b8f27c9b79$var$Vf;
    a = a._reactInternals;
    a: {
        if ($a33df4b8f27c9b79$var$Vb(a) !== a || 1 !== a.tag) throw Error($a33df4b8f27c9b79$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($a33df4b8f27c9b79$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($a33df4b8f27c9b79$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($a33df4b8f27c9b79$var$Zf(c)) return $a33df4b8f27c9b79$var$bg(a, c, b);
    }
    return b;
}
function $a33df4b8f27c9b79$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $a33df4b8f27c9b79$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $a33df4b8f27c9b79$var$el(null);
    c = a.current;
    d = $a33df4b8f27c9b79$var$L();
    e = $a33df4b8f27c9b79$var$lh(c);
    f = $a33df4b8f27c9b79$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $a33df4b8f27c9b79$var$dh(c, f, e);
    a.current.lanes = e;
    $a33df4b8f27c9b79$var$Ac(a, e, d);
    $a33df4b8f27c9b79$var$Ek(a, d);
    return a;
}
function $a33df4b8f27c9b79$var$gl(a, b, c, d) {
    var e = b.current, f = $a33df4b8f27c9b79$var$L(), g = $a33df4b8f27c9b79$var$lh(e);
    c = $a33df4b8f27c9b79$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $a33df4b8f27c9b79$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $a33df4b8f27c9b79$var$dh(e, b, g);
    null !== a && ($a33df4b8f27c9b79$var$mh(a, e, g, f), $a33df4b8f27c9b79$var$eh(a, e, g));
    return g;
}
function $a33df4b8f27c9b79$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $a33df4b8f27c9b79$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $a33df4b8f27c9b79$var$jl(a, b) {
    $a33df4b8f27c9b79$var$il(a, b);
    (a = a.alternate) && $a33df4b8f27c9b79$var$il(a, b);
}
function $a33df4b8f27c9b79$var$kl() {
    return null;
}
var $a33df4b8f27c9b79$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $a33df4b8f27c9b79$var$ml(a) {
    this._internalRoot = a;
}
$a33df4b8f27c9b79$var$nl.prototype.render = $a33df4b8f27c9b79$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($a33df4b8f27c9b79$var$p(409));
    $a33df4b8f27c9b79$var$gl(a, b, null, null);
};
$a33df4b8f27c9b79$var$nl.prototype.unmount = $a33df4b8f27c9b79$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $a33df4b8f27c9b79$var$Sk(function() {
            $a33df4b8f27c9b79$var$gl(null, a, null, null);
        });
        b[$a33df4b8f27c9b79$var$uf] = null;
    }
};
function $a33df4b8f27c9b79$var$nl(a) {
    this._internalRoot = a;
}
$a33df4b8f27c9b79$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $a33df4b8f27c9b79$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $a33df4b8f27c9b79$var$Qc.length && 0 !== b && b < $a33df4b8f27c9b79$var$Qc[c].priority; c++);
        $a33df4b8f27c9b79$var$Qc.splice(c, 0, a);
        0 === c && $a33df4b8f27c9b79$var$Vc(a);
    }
};
function $a33df4b8f27c9b79$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $a33df4b8f27c9b79$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $a33df4b8f27c9b79$var$ql() {}
function $a33df4b8f27c9b79$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $a33df4b8f27c9b79$var$hl(g);
                f.call(a);
            };
        }
        var g = $a33df4b8f27c9b79$var$fl(b, d, a, 0, null, !1, !1, "", $a33df4b8f27c9b79$var$ql);
        a._reactRootContainer = g;
        a[$a33df4b8f27c9b79$var$uf] = g.current;
        $a33df4b8f27c9b79$var$sf(8 === a.nodeType ? a.parentNode : a);
        $a33df4b8f27c9b79$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $a33df4b8f27c9b79$var$hl(k);
            h.call(a);
        };
    }
    var k = $a33df4b8f27c9b79$var$cl(a, 0, !1, null, null, !1, !1, "", $a33df4b8f27c9b79$var$ql);
    a._reactRootContainer = k;
    a[$a33df4b8f27c9b79$var$uf] = k.current;
    $a33df4b8f27c9b79$var$sf(8 === a.nodeType ? a.parentNode : a);
    $a33df4b8f27c9b79$var$Sk(function() {
        $a33df4b8f27c9b79$var$gl(b, k, c, d);
    });
    return k;
}
function $a33df4b8f27c9b79$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $a33df4b8f27c9b79$var$hl(g);
                h.call(a);
            };
        }
        $a33df4b8f27c9b79$var$gl(b, g, a, e);
    } else g = $a33df4b8f27c9b79$var$rl(c, b, a, e, d);
    return $a33df4b8f27c9b79$var$hl(g);
}
$a33df4b8f27c9b79$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $a33df4b8f27c9b79$var$tc(b.pendingLanes);
                0 !== c && ($a33df4b8f27c9b79$var$Cc(b, c | 1), $a33df4b8f27c9b79$var$Ek(b, $a33df4b8f27c9b79$var$B()), 0 === ($a33df4b8f27c9b79$var$K & 6) && ($a33df4b8f27c9b79$var$Hj = $a33df4b8f27c9b79$var$B() + 500, $a33df4b8f27c9b79$var$jg()));
            }
            break;
        case 13:
            $a33df4b8f27c9b79$var$Sk(function() {
                var b = $a33df4b8f27c9b79$var$Zg(a, 1);
                if (null !== b) {
                    var c = $a33df4b8f27c9b79$var$L();
                    $a33df4b8f27c9b79$var$mh(b, a, 1, c);
                }
            }), $a33df4b8f27c9b79$var$jl(a, 1);
    }
};
$a33df4b8f27c9b79$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $a33df4b8f27c9b79$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $a33df4b8f27c9b79$var$L();
            $a33df4b8f27c9b79$var$mh(b, a, 134217728, c);
        }
        $a33df4b8f27c9b79$var$jl(a, 134217728);
    }
};
$a33df4b8f27c9b79$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $a33df4b8f27c9b79$var$lh(a), c = $a33df4b8f27c9b79$var$Zg(a, b);
        if (null !== c) {
            var d = $a33df4b8f27c9b79$var$L();
            $a33df4b8f27c9b79$var$mh(c, a, b, d);
        }
        $a33df4b8f27c9b79$var$jl(a, b);
    }
};
$a33df4b8f27c9b79$var$Hc = function() {
    return $a33df4b8f27c9b79$var$C;
};
$a33df4b8f27c9b79$var$Ic = function(a, b) {
    var c = $a33df4b8f27c9b79$var$C;
    try {
        return $a33df4b8f27c9b79$var$C = a, b();
    } finally{
        $a33df4b8f27c9b79$var$C = c;
    }
};
$a33df4b8f27c9b79$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $a33df4b8f27c9b79$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $a33df4b8f27c9b79$var$Db(d);
                        if (!e) throw Error($a33df4b8f27c9b79$var$p(90));
                        $a33df4b8f27c9b79$var$Wa(d);
                        $a33df4b8f27c9b79$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $a33df4b8f27c9b79$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $a33df4b8f27c9b79$var$fb(a, !!c.multiple, b, !1);
    }
};
$a33df4b8f27c9b79$var$Gb = $a33df4b8f27c9b79$var$Rk;
$a33df4b8f27c9b79$var$Hb = $a33df4b8f27c9b79$var$Sk;
var $a33df4b8f27c9b79$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $a33df4b8f27c9b79$var$Cb,
        $a33df4b8f27c9b79$var$ue,
        $a33df4b8f27c9b79$var$Db,
        $a33df4b8f27c9b79$var$Eb,
        $a33df4b8f27c9b79$var$Fb,
        $a33df4b8f27c9b79$var$Rk
    ]
}, $a33df4b8f27c9b79$var$ul = {
    findFiberByHostInstance: $a33df4b8f27c9b79$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $a33df4b8f27c9b79$var$vl = {
    bundleType: $a33df4b8f27c9b79$var$ul.bundleType,
    version: $a33df4b8f27c9b79$var$ul.version,
    rendererPackageName: $a33df4b8f27c9b79$var$ul.rendererPackageName,
    rendererConfig: $a33df4b8f27c9b79$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $a33df4b8f27c9b79$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $a33df4b8f27c9b79$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $a33df4b8f27c9b79$var$ul.findFiberByHostInstance || $a33df4b8f27c9b79$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $a33df4b8f27c9b79$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$a33df4b8f27c9b79$var$wl.isDisabled && $a33df4b8f27c9b79$var$wl.supportsFiber) try {
        $a33df4b8f27c9b79$var$kc = $a33df4b8f27c9b79$var$wl.inject($a33df4b8f27c9b79$var$vl), $a33df4b8f27c9b79$var$lc = $a33df4b8f27c9b79$var$wl;
    } catch (a) {}
}
$a33df4b8f27c9b79$export$ae55be85d98224ed = $a33df4b8f27c9b79$var$tl;
$a33df4b8f27c9b79$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$a33df4b8f27c9b79$var$ol(b)) throw Error($a33df4b8f27c9b79$var$p(200));
    return $a33df4b8f27c9b79$var$dl(a, b, null, c);
};
$a33df4b8f27c9b79$export$882461b6382ed46c = function(a, b) {
    if (!$a33df4b8f27c9b79$var$ol(a)) throw Error($a33df4b8f27c9b79$var$p(299));
    var c = !1, d = "", e = $a33df4b8f27c9b79$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $a33df4b8f27c9b79$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$a33df4b8f27c9b79$var$uf] = b.current;
    $a33df4b8f27c9b79$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $a33df4b8f27c9b79$var$ml(b);
};
$a33df4b8f27c9b79$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($a33df4b8f27c9b79$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($a33df4b8f27c9b79$var$p(268, a));
    }
    a = $a33df4b8f27c9b79$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$a33df4b8f27c9b79$export$cd75ccfd720a3cd4 = function(a) {
    return $a33df4b8f27c9b79$var$Sk(a);
};
$a33df4b8f27c9b79$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$a33df4b8f27c9b79$var$pl(b)) throw Error($a33df4b8f27c9b79$var$p(200));
    return $a33df4b8f27c9b79$var$sl(null, a, b, !0, c);
};
$a33df4b8f27c9b79$export$757ceba2d55c277e = function(a, b, c) {
    if (!$a33df4b8f27c9b79$var$ol(a)) throw Error($a33df4b8f27c9b79$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $a33df4b8f27c9b79$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $a33df4b8f27c9b79$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$a33df4b8f27c9b79$var$uf] = b.current;
    $a33df4b8f27c9b79$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $a33df4b8f27c9b79$var$nl(b);
};
$a33df4b8f27c9b79$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$a33df4b8f27c9b79$var$pl(b)) throw Error($a33df4b8f27c9b79$var$p(200));
    return $a33df4b8f27c9b79$var$sl(null, a, b, !1, c);
};
$a33df4b8f27c9b79$export$502457920280e6be = function(a) {
    if (!$a33df4b8f27c9b79$var$pl(a)) throw Error($a33df4b8f27c9b79$var$p(40));
    return a._reactRootContainer ? ($a33df4b8f27c9b79$var$Sk(function() {
        $a33df4b8f27c9b79$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$a33df4b8f27c9b79$var$uf] = null;
        });
    }), !0) : !1;
};
$a33df4b8f27c9b79$export$c78a37762a8d58e1 = $a33df4b8f27c9b79$var$Rk;
$a33df4b8f27c9b79$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$a33df4b8f27c9b79$var$pl(c)) throw Error($a33df4b8f27c9b79$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($a33df4b8f27c9b79$var$p(38));
    return $a33df4b8f27c9b79$var$sl(a, b, c, !1, d);
};
$a33df4b8f27c9b79$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("j5eGm", function(module, exports) {
"use strict";

module.exports = (parcelRequire("7DUlI"));

});
parcelRegister("7DUlI", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $5907e2bb48b53256$export$c4744153514ff05d, (v) => $5907e2bb48b53256$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $5907e2bb48b53256$export$3e506c1ccc9cc1a7, (v) => $5907e2bb48b53256$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $5907e2bb48b53256$export$e26fe2ed2fa76875, (v) => $5907e2bb48b53256$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $5907e2bb48b53256$export$502329bbf4b505b1, (v) => $5907e2bb48b53256$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $5907e2bb48b53256$export$6e3807111c4874c4, (v) => $5907e2bb48b53256$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $5907e2bb48b53256$export$c27134553091fb3a, (v) => $5907e2bb48b53256$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $5907e2bb48b53256$export$33ee1acdc04fd2a2, (v) => $5907e2bb48b53256$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $5907e2bb48b53256$export$b00a404bbd5edef2, (v) => $5907e2bb48b53256$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $5907e2bb48b53256$export$8352ce38b91d0c62, (v) => $5907e2bb48b53256$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $5907e2bb48b53256$export$d66a1c1c77bd778b, (v) => $5907e2bb48b53256$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $5907e2bb48b53256$export$d3dfb8e4810cb555, (v) => $5907e2bb48b53256$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $5907e2bb48b53256$export$839f9183b0465a69, (v) => $5907e2bb48b53256$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $5907e2bb48b53256$export$72fdf0e06517287b, (v) => $5907e2bb48b53256$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $5907e2bb48b53256$export$4b844e58a3e414b4, (v) => $5907e2bb48b53256$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $5907e2bb48b53256$export$816d2913ae6b83b1, (v) => $5907e2bb48b53256$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $5907e2bb48b53256$export$61bcfe829111a1d0, (v) => $5907e2bb48b53256$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $5907e2bb48b53256$export$7ee8c9beb337bc3f, (v) => $5907e2bb48b53256$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $5907e2bb48b53256$export$b5836b71941fa3ed, (v) => $5907e2bb48b53256$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $5907e2bb48b53256$export$cf845f2c119da08a, (v) => $5907e2bb48b53256$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $5907e2bb48b53256$export$c4744153514ff05d;
var $5907e2bb48b53256$export$3e506c1ccc9cc1a7;
var $5907e2bb48b53256$export$e26fe2ed2fa76875;
var $5907e2bb48b53256$export$502329bbf4b505b1;
var $5907e2bb48b53256$export$6e3807111c4874c4;
var $5907e2bb48b53256$export$c27134553091fb3a;
var $5907e2bb48b53256$export$33ee1acdc04fd2a2;
var $5907e2bb48b53256$export$b00a404bbd5edef2;
var $5907e2bb48b53256$export$8352ce38b91d0c62;
var $5907e2bb48b53256$export$d66a1c1c77bd778b;
var $5907e2bb48b53256$export$d3dfb8e4810cb555;
var $5907e2bb48b53256$export$839f9183b0465a69;
var $5907e2bb48b53256$export$72fdf0e06517287b;
var $5907e2bb48b53256$export$4b844e58a3e414b4;
var $5907e2bb48b53256$export$816d2913ae6b83b1;
var $5907e2bb48b53256$export$61bcfe829111a1d0;
var $5907e2bb48b53256$export$7ee8c9beb337bc3f;
var $5907e2bb48b53256$export$b5836b71941fa3ed;
var $5907e2bb48b53256$export$cf845f2c119da08a;
"use strict";
function $5907e2bb48b53256$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $5907e2bb48b53256$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $5907e2bb48b53256$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $5907e2bb48b53256$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $5907e2bb48b53256$var$g(C, c)) n < e && 0 > $5907e2bb48b53256$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $5907e2bb48b53256$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $5907e2bb48b53256$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $5907e2bb48b53256$var$l = performance;
    $5907e2bb48b53256$export$c4744153514ff05d = function() {
        return $5907e2bb48b53256$var$l.now();
    };
} else {
    var $5907e2bb48b53256$var$p = Date, $5907e2bb48b53256$var$q = $5907e2bb48b53256$var$p.now();
    $5907e2bb48b53256$export$c4744153514ff05d = function() {
        return $5907e2bb48b53256$var$p.now() - $5907e2bb48b53256$var$q;
    };
}
var $5907e2bb48b53256$var$r = [], $5907e2bb48b53256$var$t = [], $5907e2bb48b53256$var$u = 1, $5907e2bb48b53256$var$v = null, $5907e2bb48b53256$var$y = 3, $5907e2bb48b53256$var$z = !1, $5907e2bb48b53256$var$A = !1, $5907e2bb48b53256$var$B = !1, $5907e2bb48b53256$var$D = "function" === typeof setTimeout ? setTimeout : null, $5907e2bb48b53256$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $5907e2bb48b53256$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $5907e2bb48b53256$var$G(a) {
    for(var b = $5907e2bb48b53256$var$h($5907e2bb48b53256$var$t); null !== b;){
        if (null === b.callback) $5907e2bb48b53256$var$k($5907e2bb48b53256$var$t);
        else if (b.startTime <= a) $5907e2bb48b53256$var$k($5907e2bb48b53256$var$t), b.sortIndex = b.expirationTime, $5907e2bb48b53256$var$f($5907e2bb48b53256$var$r, b);
        else break;
        b = $5907e2bb48b53256$var$h($5907e2bb48b53256$var$t);
    }
}
function $5907e2bb48b53256$var$H(a) {
    $5907e2bb48b53256$var$B = !1;
    $5907e2bb48b53256$var$G(a);
    if (!$5907e2bb48b53256$var$A) {
        if (null !== $5907e2bb48b53256$var$h($5907e2bb48b53256$var$r)) $5907e2bb48b53256$var$A = !0, $5907e2bb48b53256$var$I($5907e2bb48b53256$var$J);
        else {
            var b = $5907e2bb48b53256$var$h($5907e2bb48b53256$var$t);
            null !== b && $5907e2bb48b53256$var$K($5907e2bb48b53256$var$H, b.startTime - a);
        }
    }
}
function $5907e2bb48b53256$var$J(a, b) {
    $5907e2bb48b53256$var$A = !1;
    $5907e2bb48b53256$var$B && ($5907e2bb48b53256$var$B = !1, $5907e2bb48b53256$var$E($5907e2bb48b53256$var$L), $5907e2bb48b53256$var$L = -1);
    $5907e2bb48b53256$var$z = !0;
    var c = $5907e2bb48b53256$var$y;
    try {
        $5907e2bb48b53256$var$G(b);
        for($5907e2bb48b53256$var$v = $5907e2bb48b53256$var$h($5907e2bb48b53256$var$r); null !== $5907e2bb48b53256$var$v && (!($5907e2bb48b53256$var$v.expirationTime > b) || a && !$5907e2bb48b53256$var$M());){
            var d = $5907e2bb48b53256$var$v.callback;
            if ("function" === typeof d) {
                $5907e2bb48b53256$var$v.callback = null;
                $5907e2bb48b53256$var$y = $5907e2bb48b53256$var$v.priorityLevel;
                var e = d($5907e2bb48b53256$var$v.expirationTime <= b);
                b = $5907e2bb48b53256$export$c4744153514ff05d();
                "function" === typeof e ? $5907e2bb48b53256$var$v.callback = e : $5907e2bb48b53256$var$v === $5907e2bb48b53256$var$h($5907e2bb48b53256$var$r) && $5907e2bb48b53256$var$k($5907e2bb48b53256$var$r);
                $5907e2bb48b53256$var$G(b);
            } else $5907e2bb48b53256$var$k($5907e2bb48b53256$var$r);
            $5907e2bb48b53256$var$v = $5907e2bb48b53256$var$h($5907e2bb48b53256$var$r);
        }
        if (null !== $5907e2bb48b53256$var$v) var w = !0;
        else {
            var m = $5907e2bb48b53256$var$h($5907e2bb48b53256$var$t);
            null !== m && $5907e2bb48b53256$var$K($5907e2bb48b53256$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $5907e2bb48b53256$var$v = null, $5907e2bb48b53256$var$y = c, $5907e2bb48b53256$var$z = !1;
    }
}
var $5907e2bb48b53256$var$N = !1, $5907e2bb48b53256$var$O = null, $5907e2bb48b53256$var$L = -1, $5907e2bb48b53256$var$P = 5, $5907e2bb48b53256$var$Q = -1;
function $5907e2bb48b53256$var$M() {
    return $5907e2bb48b53256$export$c4744153514ff05d() - $5907e2bb48b53256$var$Q < $5907e2bb48b53256$var$P ? !1 : !0;
}
function $5907e2bb48b53256$var$R() {
    if (null !== $5907e2bb48b53256$var$O) {
        var a = $5907e2bb48b53256$export$c4744153514ff05d();
        $5907e2bb48b53256$var$Q = a;
        var b = !0;
        try {
            b = $5907e2bb48b53256$var$O(!0, a);
        } finally{
            b ? $5907e2bb48b53256$var$S() : ($5907e2bb48b53256$var$N = !1, $5907e2bb48b53256$var$O = null);
        }
    } else $5907e2bb48b53256$var$N = !1;
}
var $5907e2bb48b53256$var$S;
if ("function" === typeof $5907e2bb48b53256$var$F) $5907e2bb48b53256$var$S = function() {
    $5907e2bb48b53256$var$F($5907e2bb48b53256$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $5907e2bb48b53256$var$T = new MessageChannel, $5907e2bb48b53256$var$U = $5907e2bb48b53256$var$T.port2;
    $5907e2bb48b53256$var$T.port1.onmessage = $5907e2bb48b53256$var$R;
    $5907e2bb48b53256$var$S = function() {
        $5907e2bb48b53256$var$U.postMessage(null);
    };
} else $5907e2bb48b53256$var$S = function() {
    $5907e2bb48b53256$var$D($5907e2bb48b53256$var$R, 0);
};
function $5907e2bb48b53256$var$I(a) {
    $5907e2bb48b53256$var$O = a;
    $5907e2bb48b53256$var$N || ($5907e2bb48b53256$var$N = !0, $5907e2bb48b53256$var$S());
}
function $5907e2bb48b53256$var$K(a, b) {
    $5907e2bb48b53256$var$L = $5907e2bb48b53256$var$D(function() {
        a($5907e2bb48b53256$export$c4744153514ff05d());
    }, b);
}
$5907e2bb48b53256$export$3e506c1ccc9cc1a7 = 5;
$5907e2bb48b53256$export$e26fe2ed2fa76875 = 1;
$5907e2bb48b53256$export$502329bbf4b505b1 = 4;
$5907e2bb48b53256$export$6e3807111c4874c4 = 3;
$5907e2bb48b53256$export$c27134553091fb3a = null;
$5907e2bb48b53256$export$33ee1acdc04fd2a2 = 2;
$5907e2bb48b53256$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$5907e2bb48b53256$export$8352ce38b91d0c62 = function() {
    $5907e2bb48b53256$var$A || $5907e2bb48b53256$var$z || ($5907e2bb48b53256$var$A = !0, $5907e2bb48b53256$var$I($5907e2bb48b53256$var$J));
};
$5907e2bb48b53256$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $5907e2bb48b53256$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$5907e2bb48b53256$export$d3dfb8e4810cb555 = function() {
    return $5907e2bb48b53256$var$y;
};
$5907e2bb48b53256$export$839f9183b0465a69 = function() {
    return $5907e2bb48b53256$var$h($5907e2bb48b53256$var$r);
};
$5907e2bb48b53256$export$72fdf0e06517287b = function(a) {
    switch($5907e2bb48b53256$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $5907e2bb48b53256$var$y;
    }
    var c = $5907e2bb48b53256$var$y;
    $5907e2bb48b53256$var$y = b;
    try {
        return a();
    } finally{
        $5907e2bb48b53256$var$y = c;
    }
};
$5907e2bb48b53256$export$4b844e58a3e414b4 = function() {};
$5907e2bb48b53256$export$816d2913ae6b83b1 = function() {};
$5907e2bb48b53256$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $5907e2bb48b53256$var$y;
    $5907e2bb48b53256$var$y = a;
    try {
        return b();
    } finally{
        $5907e2bb48b53256$var$y = c;
    }
};
$5907e2bb48b53256$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $5907e2bb48b53256$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $5907e2bb48b53256$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $5907e2bb48b53256$var$f($5907e2bb48b53256$var$t, a), null === $5907e2bb48b53256$var$h($5907e2bb48b53256$var$r) && a === $5907e2bb48b53256$var$h($5907e2bb48b53256$var$t) && ($5907e2bb48b53256$var$B ? ($5907e2bb48b53256$var$E($5907e2bb48b53256$var$L), $5907e2bb48b53256$var$L = -1) : $5907e2bb48b53256$var$B = !0, $5907e2bb48b53256$var$K($5907e2bb48b53256$var$H, c - d))) : (a.sortIndex = e, $5907e2bb48b53256$var$f($5907e2bb48b53256$var$r, a), $5907e2bb48b53256$var$A || $5907e2bb48b53256$var$z || ($5907e2bb48b53256$var$A = !0, $5907e2bb48b53256$var$I($5907e2bb48b53256$var$J)));
    return a;
};
$5907e2bb48b53256$export$b5836b71941fa3ed = $5907e2bb48b53256$var$M;
$5907e2bb48b53256$export$cf845f2c119da08a = function(a) {
    var b = $5907e2bb48b53256$var$y;
    return function() {
        var c = $5907e2bb48b53256$var$y;
        $5907e2bb48b53256$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $5907e2bb48b53256$var$y = c;
        }
    };
};

});



parcelRegister("iEuwq", function(module, exports) {

$parcel$export(module.exports, "Color", () => Color);
$parcel$export(module.exports, "Rgb", () => Rgb);
$parcel$export(module.exports, "rgbConvert", () => rgbConvert);

var $huaPI = parcelRequire("huaPI");
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, $huaPI.default)(Color, color, {
    copy (channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable () {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    formatHex: color_formatHex,
    formatHex8: color_formatHex8,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHex8() {
    return this.rgb().formatHex8();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $huaPI.default)(Rgb, rgb, (0, $huaPI.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb () {
        return this;
    },
    clamp () {
        return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
    },
    displayable () {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    formatHex: rgb_formatHex,
    formatHex8: rgb_formatHex8,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
    const a = clampa(this.opacity);
    return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}
function clampa(opacity) {
    return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
    return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
    value = clampi(value);
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $huaPI.default)(Hsl, hsl, (0, $huaPI.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    clamp () {
        return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
    },
    displayable () {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl () {
        const a = clampa(this.opacity);
        return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
    }
}));
function clamph(value) {
    value = (value || 0) % 360;
    return value < 0 ? value + 360 : value;
}
function clampt(value) {
    return Math.max(0, Math.min(1, value || 0));
}
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("huaPI", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbada43df3ba5a47$export$2e2bcd8739ae039);
$parcel$export(module.exports, "extend", () => $cbada43df3ba5a47$export$8b58be045bf06082);
function $cbada43df3ba5a47$export$2e2bcd8739ae039(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $cbada43df3ba5a47$export$8b58be045bf06082(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


parcelRegister("kJcVt", function(module, exports) {

$parcel$export(module.exports, "resolveHostHeaderConfig", () => $f172096db04c3c21$export$c1625bf0b32b4481);
$parcel$export(module.exports, "getHostHeaderPlugin", () => $f172096db04c3c21$export$23d3b647211be53a);
parcelRequire("AueTL");
var $Yl5TU = parcelRequire("Yl5TU");
function $f172096db04c3c21$export$c1625bf0b32b4481(input) {
    return input;
}
const $f172096db04c3c21$export$858685d7aeef192d = (options)=>(next)=>async (args)=>{
            if (!(0, $Yl5TU.HttpRequest).isInstance(args.request)) return next(args);
            const { request: request } = args;
            const { handlerProtocol: handlerProtocol = "" } = options.requestHandler.metadata || {};
            if (handlerProtocol.indexOf("h2") >= 0 && !request.headers[":authority"]) {
                delete request.headers["host"];
                request.headers[":authority"] = request.hostname + (request.port ? ":" + request.port : "");
            } else if (!request.headers["host"]) {
                let host = request.hostname;
                if (request.port != null) host += `:${request.port}`;
                request.headers["host"] = host;
            }
            return next(args);
        };
const $f172096db04c3c21$export$696d244ba96181e8 = {
    name: "hostHeaderMiddleware",
    step: "build",
    priority: "low",
    tags: [
        "HOST"
    ],
    override: true
};
const $f172096db04c3c21$export$23d3b647211be53a = (options)=>({
        applyToStack: (clientStack)=>{
            clientStack.add($f172096db04c3c21$export$858685d7aeef192d(options), $f172096db04c3c21$export$696d244ba96181e8);
        }
    });

});
parcelRegister("AueTL", function(module, exports) {
$parcel$export(module.exports, "getHttpHandlerExtensionConfiguration", () => (parcelRequire("9muob")).getHttpHandlerExtensionConfiguration);
$parcel$export(module.exports, "resolveHttpHandlerRuntimeConfig", () => (parcelRequire("9muob")).resolveHttpHandlerRuntimeConfig);
$parcel$export(module.exports, "HttpRequest", () => (parcelRequire("Yl5TU")).HttpRequest);
$parcel$export(module.exports, "HttpResponse", () => (parcelRequire("1QalE")).HttpResponse);
$parcel$export(module.exports, "isValidHostname", () => (parcelRequire("jD1Fl")).isValidHostname);
parcelRequire("90ayw");
parcelRequire("d6yYk");
parcelRequire("f8vXW");
parcelRequire("fGZlw");
parcelRequire("Yl5TU");
parcelRequire("1QalE");
parcelRequire("jD1Fl");
parcelRequire("c4a3Z");

});
parcelRegister("90ayw", function(module, exports) {
$parcel$export(module.exports, "getHttpHandlerExtensionConfiguration", () => (parcelRequire("9muob")).getHttpHandlerExtensionConfiguration);
$parcel$export(module.exports, "resolveHttpHandlerRuntimeConfig", () => (parcelRequire("9muob")).resolveHttpHandlerRuntimeConfig);
parcelRequire("9muob");

});
parcelRegister("9muob", function(module, exports) {

$parcel$export(module.exports, "getHttpHandlerExtensionConfiguration", () => $6d0dbdc404b738bc$export$663b205817703038);
$parcel$export(module.exports, "resolveHttpHandlerRuntimeConfig", () => $6d0dbdc404b738bc$export$d94fe0350385c1a8);
const $6d0dbdc404b738bc$export$663b205817703038 = (runtimeConfig)=>{
    let httpHandler = runtimeConfig.httpHandler;
    return {
        setHttpHandler (handler) {
            httpHandler = handler;
        },
        httpHandler () {
            return httpHandler;
        },
        updateHttpClientConfig (key, value) {
            httpHandler.updateHttpClientConfig(key, value);
        },
        httpHandlerConfigs () {
            return httpHandler.httpHandlerConfigs();
        }
    };
};
const $6d0dbdc404b738bc$export$d94fe0350385c1a8 = (httpHandlerExtensionConfiguration)=>{
    return {
        httpHandler: httpHandlerExtensionConfiguration.httpHandler()
    };
};

});


parcelRegister("d6yYk", function(module, exports) {
parcelRequire("8t4sF");
var $ahM8M = parcelRequire("ahM8M");
class $98a6f698f4895300$export$a455218a85c89869 {
    constructor({ name: name, kind: kind = (0, $ahM8M.FieldPosition).HEADER, values: values = [] }){
        this.name = name;
        this.kind = kind;
        this.values = values;
    }
    add(value) {
        this.values.push(value);
    }
    set(values) {
        this.values = values;
    }
    remove(value) {
        this.values = this.values.filter((v)=>v !== value);
    }
    toString() {
        return this.values.map((v)=>v.includes(",") || v.includes(" ") ? `"${v}"` : v).join(", ");
    }
    get() {
        return this.values;
    }
}

});
parcelRegister("8t4sF", function(module, exports) {
$parcel$export(module.exports, "HttpApiKeyAuthLocation", () => (parcelRequire("lsTwx")).HttpApiKeyAuthLocation);
$parcel$export(module.exports, "EndpointURLScheme", () => (parcelRequire("loh90")).EndpointURLScheme);
$parcel$export(module.exports, "AlgorithmId", () => (parcelRequire("77Pav")).AlgorithmId);
$parcel$export(module.exports, "FieldPosition", () => (parcelRequire("ahM8M")).FieldPosition);
$parcel$export(module.exports, "SMITHY_CONTEXT_KEY", () => (parcelRequire("glfQ7")).SMITHY_CONTEXT_KEY);
parcelRequire("dioSm");
parcelRequire("67r8u");
parcelRequire("lri6q");
parcelRequire("jDQ7I");
parcelRequire("3u70Z");
parcelRequire("jI03c");
parcelRequire("725xI");
parcelRequire("exlrk");
parcelRequire("aTmRj");
parcelRequire("loh90");
parcelRequire("ksz7q");
parcelRequire("45Hk6");
parcelRequire("lhXDt");
parcelRequire("ahM8M");
parcelRequire("eWKTl");
parcelRequire("eVnS6");
parcelRequire("jiaFy");
parcelRequire("glfQ7");
parcelRequire("3tUPW");
parcelRequire("f6khE");
parcelRequire("8eDrh");
parcelRequire("2hBCN");
parcelRequire("l5osA");
parcelRequire("iWsp2");
parcelRequire("hyumF");
parcelRequire("7hjGy");
parcelRequire("9WN1m");
parcelRequire("4zGlX");
parcelRequire("gfeBp");
parcelRequire("6GZ4w");
parcelRequire("ibwan");
parcelRequire("hkTrR");
parcelRequire("1oKY4");
parcelRequire("h3461");
parcelRequire("koJQV");
parcelRequire("6S72u");

});
parcelRegister("dioSm", function(module, exports) {

});

parcelRegister("67r8u", function(module, exports) {
$parcel$export(module.exports, "HttpApiKeyAuthLocation", () => (parcelRequire("lsTwx")).HttpApiKeyAuthLocation);
parcelRequire("9vRI2");
parcelRequire("lsTwx");
parcelRequire("d2onp");
parcelRequire("1d0NF");
parcelRequire("9eNMd");
parcelRequire("k4MO4");

});
parcelRegister("9vRI2", function(module, exports) {
var $6ed0abdfed03c7f2$export$e24756d4ad084ce1;
(function(HttpAuthLocation) {
    HttpAuthLocation["HEADER"] = "header";
    HttpAuthLocation["QUERY"] = "query";
})($6ed0abdfed03c7f2$export$e24756d4ad084ce1 || ($6ed0abdfed03c7f2$export$e24756d4ad084ce1 = {}));

});

parcelRegister("lsTwx", function(module, exports) {

$parcel$export(module.exports, "HttpApiKeyAuthLocation", () => $fa0748604b9826b1$export$8c5ca875010cb2a6);
var $fa0748604b9826b1$export$8c5ca875010cb2a6;
(function(HttpApiKeyAuthLocation) {
    HttpApiKeyAuthLocation["HEADER"] = "header";
    HttpApiKeyAuthLocation["QUERY"] = "query";
})($fa0748604b9826b1$export$8c5ca875010cb2a6 || ($fa0748604b9826b1$export$8c5ca875010cb2a6 = {}));

});

parcelRegister("d2onp", function(module, exports) {

});

parcelRegister("1d0NF", function(module, exports) {

});

parcelRegister("9eNMd", function(module, exports) {

});

parcelRegister("k4MO4", function(module, exports) {

});


parcelRegister("lri6q", function(module, exports) {

});

parcelRegister("jDQ7I", function(module, exports) {

});

parcelRegister("3u70Z", function(module, exports) {

});

parcelRegister("jI03c", function(module, exports) {

});

parcelRegister("725xI", function(module, exports) {
parcelRequire("eDDBR");
parcelRequire("Rjhp2");
parcelRequire("hjypU");

});
parcelRegister("eDDBR", function(module, exports) {

});

parcelRegister("Rjhp2", function(module, exports) {

});

parcelRegister("hjypU", function(module, exports) {

});


parcelRegister("exlrk", function(module, exports) {

});

parcelRegister("aTmRj", function(module, exports) {

});

parcelRegister("loh90", function(module, exports) {

$parcel$export(module.exports, "EndpointURLScheme", () => $f929236056d9a792$export$b141d049add1dcb5);
var $f929236056d9a792$export$b141d049add1dcb5;
(function(EndpointURLScheme) {
    EndpointURLScheme["HTTP"] = "http";
    EndpointURLScheme["HTTPS"] = "https";
})($f929236056d9a792$export$b141d049add1dcb5 || ($f929236056d9a792$export$b141d049add1dcb5 = {}));

});

parcelRegister("ksz7q", function(module, exports) {
parcelRequire("2ATQU");
parcelRequire("3tQOM");
parcelRequire("krdsy");
parcelRequire("6b7zm");
parcelRequire("i52jc");

});
parcelRegister("2ATQU", function(module, exports) {

});

parcelRegister("3tQOM", function(module, exports) {

});

parcelRegister("krdsy", function(module, exports) {

});

parcelRegister("6b7zm", function(module, exports) {

});

parcelRegister("i52jc", function(module, exports) {

});


parcelRegister("45Hk6", function(module, exports) {

});

parcelRegister("lhXDt", function(module, exports) {

$parcel$export(module.exports, "AlgorithmId", () => (parcelRequire("77Pav")).AlgorithmId);
parcelRequire("f97AX");
parcelRequire("fz0JH");

var $77Pav = parcelRequire("77Pav");

});
parcelRegister("f97AX", function(module, exports) {

var $77Pav = parcelRequire("77Pav");
const $b06d9685bcc4dc1e$export$7081660fd0cd662b = (runtimeConfig)=>{
    return {
        ...(0, $77Pav.getChecksumConfiguration)(runtimeConfig)
    };
};
const $b06d9685bcc4dc1e$export$abfa28b95316e0ae = (config)=>{
    return {
        ...(0, $77Pav.resolveChecksumRuntimeConfig)(config)
    };
};

});
parcelRegister("77Pav", function(module, exports) {

$parcel$export(module.exports, "AlgorithmId", () => $5300e0d1a43c2957$export$fe562bf21391d1f0);
$parcel$export(module.exports, "getChecksumConfiguration", () => $5300e0d1a43c2957$export$129b301e72591856);
$parcel$export(module.exports, "resolveChecksumRuntimeConfig", () => $5300e0d1a43c2957$export$589dfc268e61d391);
var $5300e0d1a43c2957$export$fe562bf21391d1f0;
(function(AlgorithmId) {
    AlgorithmId["MD5"] = "md5";
    AlgorithmId["CRC32"] = "crc32";
    AlgorithmId["CRC32C"] = "crc32c";
    AlgorithmId["SHA1"] = "sha1";
    AlgorithmId["SHA256"] = "sha256";
})($5300e0d1a43c2957$export$fe562bf21391d1f0 || ($5300e0d1a43c2957$export$fe562bf21391d1f0 = {}));
const $5300e0d1a43c2957$export$129b301e72591856 = (runtimeConfig)=>{
    const checksumAlgorithms = [];
    if (runtimeConfig.sha256 !== undefined) checksumAlgorithms.push({
        algorithmId: ()=>$5300e0d1a43c2957$export$fe562bf21391d1f0.SHA256,
        checksumConstructor: ()=>runtimeConfig.sha256
    });
    if (runtimeConfig.md5 != undefined) checksumAlgorithms.push({
        algorithmId: ()=>$5300e0d1a43c2957$export$fe562bf21391d1f0.MD5,
        checksumConstructor: ()=>runtimeConfig.md5
    });
    return {
        _checksumAlgorithms: checksumAlgorithms,
        addChecksumAlgorithm (algo) {
            this._checksumAlgorithms.push(algo);
        },
        checksumAlgorithms () {
            return this._checksumAlgorithms;
        }
    };
};
const $5300e0d1a43c2957$export$589dfc268e61d391 = (clientConfig)=>{
    const runtimeConfig = {};
    clientConfig.checksumAlgorithms().forEach((checksumAlgorithm)=>{
        runtimeConfig[checksumAlgorithm.algorithmId()] = checksumAlgorithm.checksumConstructor();
    });
    return runtimeConfig;
};

});


parcelRegister("fz0JH", function(module, exports) {

});


parcelRegister("ahM8M", function(module, exports) {

$parcel$export(module.exports, "FieldPosition", () => $77d0d5a6b142a421$export$54765d03252bd9ed);
var $77d0d5a6b142a421$export$54765d03252bd9ed;
(function(FieldPosition) {
    FieldPosition[FieldPosition["HEADER"] = 0] = "HEADER";
    FieldPosition[FieldPosition["TRAILER"] = 1] = "TRAILER";
})($77d0d5a6b142a421$export$54765d03252bd9ed || ($77d0d5a6b142a421$export$54765d03252bd9ed = {}));

});

parcelRegister("eWKTl", function(module, exports) {

});

parcelRegister("eVnS6", function(module, exports) {
parcelRequire("e44k6");
parcelRequire("884O2");
parcelRequire("hWTF6");
parcelRequire("g5jOC");

});
parcelRegister("e44k6", function(module, exports) {

});

parcelRegister("884O2", function(module, exports) {

});

parcelRegister("hWTF6", function(module, exports) {

});

parcelRegister("g5jOC", function(module, exports) {

});


parcelRegister("jiaFy", function(module, exports) {

});

parcelRegister("glfQ7", function(module, exports) {

$parcel$export(module.exports, "SMITHY_CONTEXT_KEY", () => $be5ae4eff871d05c$export$94e7bb1b8aa610cb);
const $be5ae4eff871d05c$export$94e7bb1b8aa610cb = "__smithy_context";

});

parcelRegister("3tUPW", function(module, exports) {

});

parcelRegister("f6khE", function(module, exports) {
var $afe72679a62c9d15$export$bd84655cbf2c28d9;
(function(IniSectionType) {
    IniSectionType["PROFILE"] = "profile";
    IniSectionType["SSO_SESSION"] = "sso-session";
    IniSectionType["SERVICES"] = "services";
})($afe72679a62c9d15$export$bd84655cbf2c28d9 || ($afe72679a62c9d15$export$bd84655cbf2c28d9 = {}));

});

parcelRegister("8eDrh", function(module, exports) {

});

parcelRegister("2hBCN", function(module, exports) {

});

parcelRegister("l5osA", function(module, exports) {

});

parcelRegister("iWsp2", function(module, exports) {

});

parcelRegister("hyumF", function(module, exports) {

});

parcelRegister("7hjGy", function(module, exports) {

});

parcelRegister("9WN1m", function(module, exports) {

});

parcelRegister("4zGlX", function(module, exports) {

});

parcelRegister("gfeBp", function(module, exports) {

});

parcelRegister("6GZ4w", function(module, exports) {
var $4df609f29f5af684$export$6431f3fda9a48da2;
(function(RequestHandlerProtocol) {
    RequestHandlerProtocol["HTTP_0_9"] = "http/0.9";
    RequestHandlerProtocol["HTTP_1_0"] = "http/1.0";
    RequestHandlerProtocol["TDS_8_0"] = "tds/8.0";
})($4df609f29f5af684$export$6431f3fda9a48da2 || ($4df609f29f5af684$export$6431f3fda9a48da2 = {}));

});

parcelRegister("ibwan", function(module, exports) {

});

parcelRegister("hkTrR", function(module, exports) {

});

parcelRegister("1oKY4", function(module, exports) {

});

parcelRegister("h3461", function(module, exports) {

});

parcelRegister("koJQV", function(module, exports) {

});

parcelRegister("6S72u", function(module, exports) {

});



parcelRegister("f8vXW", function(module, exports) {
class $b05066182ac3686b$export$833b3e5a19fb8939 {
    constructor({ fields: fields = [], encoding: encoding = "utf-8" }){
        this.entries = {};
        fields.forEach(this.setField.bind(this));
        this.encoding = encoding;
    }
    setField(field) {
        this.entries[field.name.toLowerCase()] = field;
    }
    getField(name) {
        return this.entries[name.toLowerCase()];
    }
    removeField(name) {
        delete this.entries[name.toLowerCase()];
    }
    getByType(kind) {
        return Object.values(this.entries).filter((field)=>field.kind === kind);
    }
}

});

parcelRegister("fGZlw", function(module, exports) {

});

parcelRegister("Yl5TU", function(module, exports) {

$parcel$export(module.exports, "HttpRequest", () => $0b55f7933666a734$export$7587955500404ec3);
class $0b55f7933666a734$export$7587955500404ec3 {
    constructor(options){
        this.method = options.method || "GET";
        this.hostname = options.hostname || "localhost";
        this.port = options.port;
        this.query = options.query || {};
        this.headers = options.headers || {};
        this.body = options.body;
        this.protocol = options.protocol ? options.protocol.slice(-1) !== ":" ? `${options.protocol}:` : options.protocol : "https:";
        this.path = options.path ? options.path.charAt(0) !== "/" ? `/${options.path}` : options.path : "/";
        this.username = options.username;
        this.password = options.password;
        this.fragment = options.fragment;
    }
    static isInstance(request) {
        if (!request) return false;
        const req = request;
        return "method" in req && "protocol" in req && "hostname" in req && "path" in req && typeof req["query"] === "object" && typeof req["headers"] === "object";
    }
    clone() {
        const cloned = new $0b55f7933666a734$export$7587955500404ec3({
            ...this,
            headers: {
                ...this.headers
            }
        });
        if (cloned.query) cloned.query = $0b55f7933666a734$var$cloneQuery(cloned.query);
        return cloned;
    }
}
function $0b55f7933666a734$var$cloneQuery(query) {
    return Object.keys(query).reduce((carry, paramName)=>{
        const param = query[paramName];
        return {
            ...carry,
            [paramName]: Array.isArray(param) ? [
                ...param
            ] : param
        };
    }, {});
}

});

parcelRegister("1QalE", function(module, exports) {

$parcel$export(module.exports, "HttpResponse", () => $1572acbb3bbc9e6c$export$1d94dfe0d9d1f1e7);
class $1572acbb3bbc9e6c$export$1d94dfe0d9d1f1e7 {
    constructor(options){
        this.statusCode = options.statusCode;
        this.reason = options.reason;
        this.headers = options.headers || {};
        this.body = options.body;
    }
    static isInstance(response) {
        if (!response) return false;
        const resp = response;
        return typeof resp.statusCode === "number" && typeof resp.headers === "object";
    }
}

});

parcelRegister("jD1Fl", function(module, exports) {

$parcel$export(module.exports, "isValidHostname", () => $e4a2f3a614a91ac3$export$e024c793399bdd01);
function $e4a2f3a614a91ac3$export$e024c793399bdd01(hostname) {
    const hostPattern = /^[a-z0-9][a-z0-9\.\-]*[a-z0-9]$/;
    return hostPattern.test(hostname);
}

});

parcelRegister("c4a3Z", function(module, exports) {

});



parcelRegister("avFL0", function(module, exports) {
$parcel$export(module.exports, "getLoggerPlugin", () => (parcelRequire("cZu4U")).getLoggerPlugin);
parcelRequire("cZu4U");

});
parcelRegister("cZu4U", function(module, exports) {

$parcel$export(module.exports, "getLoggerPlugin", () => $9752836b80460bd9$export$f6ef65d7766fc255);
const $9752836b80460bd9$export$fe0e777ee4f58cde = ()=>(next, context)=>async (args)=>{
            try {
                const response = await next(args);
                const { clientName: clientName, commandName: commandName, logger: logger, dynamoDbDocumentClientOptions: dynamoDbDocumentClientOptions = {} } = context;
                const { overrideInputFilterSensitiveLog: overrideInputFilterSensitiveLog, overrideOutputFilterSensitiveLog: overrideOutputFilterSensitiveLog } = dynamoDbDocumentClientOptions;
                const inputFilterSensitiveLog = overrideInputFilterSensitiveLog ?? context.inputFilterSensitiveLog;
                const outputFilterSensitiveLog = overrideOutputFilterSensitiveLog ?? context.outputFilterSensitiveLog;
                const { $metadata: $metadata, ...outputWithoutMetadata } = response.output;
                logger?.info?.({
                    clientName: clientName,
                    commandName: commandName,
                    input: inputFilterSensitiveLog(args.input),
                    output: outputFilterSensitiveLog(outputWithoutMetadata),
                    metadata: $metadata
                });
                return response;
            } catch (error) {
                const { clientName: clientName, commandName: commandName, logger: logger, dynamoDbDocumentClientOptions: dynamoDbDocumentClientOptions = {} } = context;
                const { overrideInputFilterSensitiveLog: overrideInputFilterSensitiveLog } = dynamoDbDocumentClientOptions;
                const inputFilterSensitiveLog = overrideInputFilterSensitiveLog ?? context.inputFilterSensitiveLog;
                logger?.error?.({
                    clientName: clientName,
                    commandName: commandName,
                    input: inputFilterSensitiveLog(args.input),
                    error: error,
                    metadata: error.$metadata
                });
                throw error;
            }
        };
const $9752836b80460bd9$export$877c148ab4ad0722 = {
    name: "loggerMiddleware",
    tags: [
        "LOGGER"
    ],
    step: "initialize",
    override: true
};
const $9752836b80460bd9$export$f6ef65d7766fc255 = (options)=>({
        applyToStack: (clientStack)=>{
            clientStack.add($9752836b80460bd9$export$fe0e777ee4f58cde(), $9752836b80460bd9$export$877c148ab4ad0722);
        }
    });

});


parcelRegister("K0nIp", function(module, exports) {

$parcel$export(module.exports, "getRecursionDetectionPlugin", () => $08a497c068dfc626$export$11d0b9345788bd5);
parcelRequire("AueTL");
var $Yl5TU = parcelRequire("Yl5TU");

var $iF4fv = parcelRequire("iF4fv");
const $08a497c068dfc626$var$TRACE_ID_HEADER_NAME = "X-Amzn-Trace-Id";
const $08a497c068dfc626$var$ENV_LAMBDA_FUNCTION_NAME = "AWS_LAMBDA_FUNCTION_NAME";
const $08a497c068dfc626$var$ENV_TRACE_ID = "_X_AMZN_TRACE_ID";
const $08a497c068dfc626$export$d12885408d4c0634 = (options)=>(next)=>async (args)=>{
            const { request: request } = args;
            if (!(0, $Yl5TU.HttpRequest).isInstance(request) || options.runtime !== "node" || request.headers.hasOwnProperty($08a497c068dfc626$var$TRACE_ID_HEADER_NAME)) return next(args);
            const functionName = $iF4fv.env[$08a497c068dfc626$var$ENV_LAMBDA_FUNCTION_NAME];
            const traceId = $iF4fv.env[$08a497c068dfc626$var$ENV_TRACE_ID];
            const nonEmptyString = (str)=>typeof str === "string" && str.length > 0;
            if (nonEmptyString(functionName) && nonEmptyString(traceId)) request.headers[$08a497c068dfc626$var$TRACE_ID_HEADER_NAME] = traceId;
            return next({
                ...args,
                request: request
            });
        };
const $08a497c068dfc626$export$1f1705db3faed8f3 = {
    step: "build",
    tags: [
        "RECURSION_DETECTION"
    ],
    name: "recursionDetectionMiddleware",
    override: true,
    priority: "low"
};
const $08a497c068dfc626$export$11d0b9345788bd5 = (options)=>({
        applyToStack: (clientStack)=>{
            clientStack.add($08a497c068dfc626$export$d12885408d4c0634(options), $08a497c068dfc626$export$1f1705db3faed8f3);
        }
    });

});
parcelRegister("iF4fv", function(module, exports) {
// shim for using process in browser
var $d95f5a17a197577e$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $d95f5a17a197577e$var$cachedSetTimeout;
var $d95f5a17a197577e$var$cachedClearTimeout;
function $d95f5a17a197577e$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $d95f5a17a197577e$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $d95f5a17a197577e$var$cachedSetTimeout = setTimeout;
        else $d95f5a17a197577e$var$cachedSetTimeout = $d95f5a17a197577e$var$defaultSetTimout;
    } catch (e) {
        $d95f5a17a197577e$var$cachedSetTimeout = $d95f5a17a197577e$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $d95f5a17a197577e$var$cachedClearTimeout = clearTimeout;
        else $d95f5a17a197577e$var$cachedClearTimeout = $d95f5a17a197577e$var$defaultClearTimeout;
    } catch (e) {
        $d95f5a17a197577e$var$cachedClearTimeout = $d95f5a17a197577e$var$defaultClearTimeout;
    }
})();
function $d95f5a17a197577e$var$runTimeout(fun) {
    if ($d95f5a17a197577e$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($d95f5a17a197577e$var$cachedSetTimeout === $d95f5a17a197577e$var$defaultSetTimout || !$d95f5a17a197577e$var$cachedSetTimeout) && setTimeout) {
        $d95f5a17a197577e$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $d95f5a17a197577e$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $d95f5a17a197577e$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $d95f5a17a197577e$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $d95f5a17a197577e$var$runClearTimeout(marker) {
    if ($d95f5a17a197577e$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($d95f5a17a197577e$var$cachedClearTimeout === $d95f5a17a197577e$var$defaultClearTimeout || !$d95f5a17a197577e$var$cachedClearTimeout) && clearTimeout) {
        $d95f5a17a197577e$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $d95f5a17a197577e$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $d95f5a17a197577e$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $d95f5a17a197577e$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $d95f5a17a197577e$var$queue = [];
var $d95f5a17a197577e$var$draining = false;
var $d95f5a17a197577e$var$currentQueue;
var $d95f5a17a197577e$var$queueIndex = -1;
function $d95f5a17a197577e$var$cleanUpNextTick() {
    if (!$d95f5a17a197577e$var$draining || !$d95f5a17a197577e$var$currentQueue) return;
    $d95f5a17a197577e$var$draining = false;
    if ($d95f5a17a197577e$var$currentQueue.length) $d95f5a17a197577e$var$queue = $d95f5a17a197577e$var$currentQueue.concat($d95f5a17a197577e$var$queue);
    else $d95f5a17a197577e$var$queueIndex = -1;
    if ($d95f5a17a197577e$var$queue.length) $d95f5a17a197577e$var$drainQueue();
}
function $d95f5a17a197577e$var$drainQueue() {
    if ($d95f5a17a197577e$var$draining) return;
    var timeout = $d95f5a17a197577e$var$runTimeout($d95f5a17a197577e$var$cleanUpNextTick);
    $d95f5a17a197577e$var$draining = true;
    var len = $d95f5a17a197577e$var$queue.length;
    while(len){
        $d95f5a17a197577e$var$currentQueue = $d95f5a17a197577e$var$queue;
        $d95f5a17a197577e$var$queue = [];
        while(++$d95f5a17a197577e$var$queueIndex < len)if ($d95f5a17a197577e$var$currentQueue) $d95f5a17a197577e$var$currentQueue[$d95f5a17a197577e$var$queueIndex].run();
        $d95f5a17a197577e$var$queueIndex = -1;
        len = $d95f5a17a197577e$var$queue.length;
    }
    $d95f5a17a197577e$var$currentQueue = null;
    $d95f5a17a197577e$var$draining = false;
    $d95f5a17a197577e$var$runClearTimeout(timeout);
}
$d95f5a17a197577e$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $d95f5a17a197577e$var$queue.push(new $d95f5a17a197577e$var$Item(fun, args));
    if ($d95f5a17a197577e$var$queue.length === 1 && !$d95f5a17a197577e$var$draining) $d95f5a17a197577e$var$runTimeout($d95f5a17a197577e$var$drainQueue);
};
// v8 likes predictible objects
function $d95f5a17a197577e$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$d95f5a17a197577e$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$d95f5a17a197577e$var$process.title = "browser";
$d95f5a17a197577e$var$process.browser = true;
$d95f5a17a197577e$var$process.env = {};
$d95f5a17a197577e$var$process.argv = [];
$d95f5a17a197577e$var$process.version = ""; // empty string to avoid regexp issues
$d95f5a17a197577e$var$process.versions = {};
function $d95f5a17a197577e$var$noop() {}
$d95f5a17a197577e$var$process.on = $d95f5a17a197577e$var$noop;
$d95f5a17a197577e$var$process.addListener = $d95f5a17a197577e$var$noop;
$d95f5a17a197577e$var$process.once = $d95f5a17a197577e$var$noop;
$d95f5a17a197577e$var$process.off = $d95f5a17a197577e$var$noop;
$d95f5a17a197577e$var$process.removeListener = $d95f5a17a197577e$var$noop;
$d95f5a17a197577e$var$process.removeAllListeners = $d95f5a17a197577e$var$noop;
$d95f5a17a197577e$var$process.emit = $d95f5a17a197577e$var$noop;
$d95f5a17a197577e$var$process.prependListener = $d95f5a17a197577e$var$noop;
$d95f5a17a197577e$var$process.prependOnceListener = $d95f5a17a197577e$var$noop;
$d95f5a17a197577e$var$process.listeners = function(name) {
    return [];
};
$d95f5a17a197577e$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$d95f5a17a197577e$var$process.cwd = function() {
    return "/";
};
$d95f5a17a197577e$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$d95f5a17a197577e$var$process.umask = function() {
    return 0;
};

});


parcelRegister("c1MK9", function(module, exports) {
$parcel$export(module.exports, "resolveUserAgentConfig", () => (parcelRequire("jr2rX")).resolveUserAgentConfig);
$parcel$export(module.exports, "getUserAgentPlugin", () => (parcelRequire("dx4el")).getUserAgentPlugin);
parcelRequire("jr2rX");
parcelRequire("dx4el");

});
parcelRegister("jr2rX", function(module, exports) {

$parcel$export(module.exports, "resolveUserAgentConfig", () => $e262706c91cfbc5d$export$ec9a2d5663958cb);
function $e262706c91cfbc5d$export$ec9a2d5663958cb(input) {
    return {
        ...input,
        customUserAgent: typeof input.customUserAgent === "string" ? [
            [
                input.customUserAgent
            ]
        ] : input.customUserAgent
    };
}

});

parcelRegister("dx4el", function(module, exports) {

$parcel$export(module.exports, "getUserAgentPlugin", () => $9da1a382f617c425$export$5393c0d2d7f4f5f0);
parcelRequire("3Wq28");
var $5hd3k = parcelRequire("5hd3k");
parcelRequire("AueTL");
var $Yl5TU = parcelRequire("Yl5TU");

var $8J6F4 = parcelRequire("8J6F4");
const $9da1a382f617c425$export$62c460923941c0b0 = (options)=>(next, context)=>async (args)=>{
            const { request: request } = args;
            if (!(0, $Yl5TU.HttpRequest).isInstance(request)) return next(args);
            const { headers: headers } = request;
            const userAgent = context?.userAgent?.map($9da1a382f617c425$var$escapeUserAgent) || [];
            const defaultUserAgent = (await options.defaultUserAgentProvider()).map($9da1a382f617c425$var$escapeUserAgent);
            const customUserAgent = options?.customUserAgent?.map($9da1a382f617c425$var$escapeUserAgent) || [];
            const prefix = (0, $5hd3k.getUserAgentPrefix)();
            const sdkUserAgentValue = (prefix ? [
                prefix
            ] : []).concat([
                ...defaultUserAgent,
                ...userAgent,
                ...customUserAgent
            ]).join((0, $8J6F4.SPACE));
            const normalUAValue = [
                ...defaultUserAgent.filter((section)=>section.startsWith("aws-sdk-")),
                ...customUserAgent
            ].join((0, $8J6F4.SPACE));
            if (options.runtime !== "browser") {
                if (normalUAValue) headers[0, $8J6F4.X_AMZ_USER_AGENT] = headers[0, $8J6F4.X_AMZ_USER_AGENT] ? `${headers[0, $8J6F4.USER_AGENT]} ${normalUAValue}` : normalUAValue;
                headers[0, $8J6F4.USER_AGENT] = sdkUserAgentValue;
            } else headers[0, $8J6F4.X_AMZ_USER_AGENT] = sdkUserAgentValue;
            return next({
                ...args,
                request: request
            });
        };
const $9da1a382f617c425$var$escapeUserAgent = (userAgentPair)=>{
    const name = userAgentPair[0].split((0, $8J6F4.UA_NAME_SEPARATOR)).map((part)=>part.replace((0, $8J6F4.UA_NAME_ESCAPE_REGEX), (0, $8J6F4.UA_ESCAPE_CHAR))).join((0, $8J6F4.UA_NAME_SEPARATOR));
    const version = userAgentPair[1]?.replace((0, $8J6F4.UA_VALUE_ESCAPE_REGEX), (0, $8J6F4.UA_ESCAPE_CHAR));
    const prefixSeparatorIndex = name.indexOf((0, $8J6F4.UA_NAME_SEPARATOR));
    const prefix = name.substring(0, prefixSeparatorIndex);
    let uaName = name.substring(prefixSeparatorIndex + 1);
    if (prefix === "api") uaName = uaName.toLowerCase();
    return [
        prefix,
        uaName,
        version
    ].filter((item)=>item && item.length > 0).reduce((acc, item, index)=>{
        switch(index){
            case 0:
                return item;
            case 1:
                return `${acc}/${item}`;
            default:
                return `${acc}#${item}`;
        }
    }, "");
};
const $9da1a382f617c425$export$29eb04da6afef73f = {
    name: "getUserAgentMiddleware",
    step: "build",
    priority: "low",
    tags: [
        "SET_USER_AGENT",
        "USER_AGENT"
    ],
    override: true
};
const $9da1a382f617c425$export$5393c0d2d7f4f5f0 = (config)=>({
        applyToStack: (clientStack)=>{
            clientStack.add($9da1a382f617c425$export$62c460923941c0b0(config), $9da1a382f617c425$export$29eb04da6afef73f);
        }
    });

});
parcelRegister("3Wq28", function(module, exports) {
$parcel$export(module.exports, "awsEndpointFunctions", () => (parcelRequire("DDoDH")).awsEndpointFunctions);
$parcel$export(module.exports, "getUserAgentPrefix", () => (parcelRequire("5hd3k")).getUserAgentPrefix);
parcelRequire("DDoDH");
parcelRequire("5hd3k");
parcelRequire("7spWz");
parcelRequire("8QlB8");
parcelRequire("7xiXa");

});
parcelRegister("DDoDH", function(module, exports) {

$parcel$export(module.exports, "awsEndpointFunctions", () => $077233f061dfff51$export$1bfd97ffc6d0eef8);
parcelRequire("j27kH");
var $dCEjZ = parcelRequire("dCEjZ");

var $hn5GH = parcelRequire("hn5GH");

var $eXkM7 = parcelRequire("eXkM7");

var $5hd3k = parcelRequire("5hd3k");
const $077233f061dfff51$export$1bfd97ffc6d0eef8 = {
    isVirtualHostableS3Bucket: (0, $hn5GH.isVirtualHostableS3Bucket),
    parseArn: (0, $eXkM7.parseArn),
    partition: (0, $5hd3k.partition)
};
(0, $dCEjZ.customEndpointFunctions).aws = $077233f061dfff51$export$1bfd97ffc6d0eef8;

});
parcelRegister("j27kH", function(module, exports) {
$parcel$export(module.exports, "isIpAddress", () => (parcelRequire("6vGGL")).isIpAddress);
$parcel$export(module.exports, "isValidHostLabel", () => (parcelRequire("b8euM")).isValidHostLabel);
$parcel$export(module.exports, "customEndpointFunctions", () => (parcelRequire("dCEjZ")).customEndpointFunctions);
$parcel$export(module.exports, "resolveEndpoint", () => (parcelRequire("fdTj5")).resolveEndpoint);
parcelRequire("6vGGL");
parcelRequire("b8euM");
parcelRequire("dCEjZ");
parcelRequire("fdTj5");
parcelRequire("kqSrk");

});
parcelRegister("6vGGL", function(module, exports) {

$parcel$export(module.exports, "isIpAddress", () => $4bd6c06b60fca574$export$2c835f0fe38d2e0e);
const $4bd6c06b60fca574$var$IP_V4_REGEX = new RegExp(`^(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}$`);
const $4bd6c06b60fca574$export$2c835f0fe38d2e0e = (value)=>$4bd6c06b60fca574$var$IP_V4_REGEX.test(value) || value.startsWith("[") && value.endsWith("]");

});

parcelRegister("b8euM", function(module, exports) {

$parcel$export(module.exports, "isValidHostLabel", () => $81abaf8e6ac869ae$export$8a024457acd8bb49);
const $81abaf8e6ac869ae$var$VALID_HOST_LABEL_REGEX = new RegExp(`^(?!.*-$)(?!-)[a-zA-Z0-9-]{1,63}$`);
const $81abaf8e6ac869ae$export$8a024457acd8bb49 = (value, allowSubDomains = false)=>{
    if (!allowSubDomains) return $81abaf8e6ac869ae$var$VALID_HOST_LABEL_REGEX.test(value);
    const labels = value.split(".");
    for (const label of labels){
        if (!$81abaf8e6ac869ae$export$8a024457acd8bb49(label)) return false;
    }
    return true;
};

});

parcelRegister("dCEjZ", function(module, exports) {

$parcel$export(module.exports, "customEndpointFunctions", () => $9eae19f5b2e52452$export$2614fba0847da171);
const $9eae19f5b2e52452$export$2614fba0847da171 = {};

});

parcelRegister("fdTj5", function(module, exports) {

$parcel$export(module.exports, "resolveEndpoint", () => $b152f8b903a5fc78$export$48b88e4e5ecac119);
parcelRequire("dsq7I");
var $hEXM1 = parcelRequire("hEXM1");
var $9vwgw = parcelRequire("9vwgw");
parcelRequire("kqSrk");
var $1cC0Y = parcelRequire("1cC0Y");
parcelRequire("k2nBm");
var $1BaO8 = parcelRequire("1BaO8");
const $b152f8b903a5fc78$export$48b88e4e5ecac119 = (ruleSetObject, options)=>{
    const { endpointParams: endpointParams, logger: logger } = options;
    const { parameters: parameters, rules: rules } = ruleSetObject;
    options.logger?.debug?.(`${(0, $hEXM1.debugId)} Initial EndpointParams: ${(0, $9vwgw.toDebugString)(endpointParams)}`);
    const paramsWithDefault = Object.entries(parameters).filter(([, v])=>v.default != null).map(([k, v])=>[
            k,
            v.default
        ]);
    if (paramsWithDefault.length > 0) for (const [paramKey, paramDefaultValue] of paramsWithDefault)endpointParams[paramKey] = endpointParams[paramKey] ?? paramDefaultValue;
    const requiredParams = Object.entries(parameters).filter(([, v])=>v.required).map(([k])=>k);
    for (const requiredParam of requiredParams){
        if (endpointParams[requiredParam] == null) throw new (0, $1cC0Y.EndpointError)(`Missing required parameter: '${requiredParam}'`);
    }
    const endpoint = (0, $1BaO8.evaluateRules)(rules, {
        endpointParams: endpointParams,
        logger: logger,
        referenceRecord: {}
    });
    if (options.endpointParams?.Endpoint) try {
        const givenEndpoint = new URL(options.endpointParams.Endpoint);
        const { protocol: protocol, port: port } = givenEndpoint;
        endpoint.url.protocol = protocol;
        endpoint.url.port = port;
    } catch (e) {}
    options.logger?.debug?.(`${(0, $hEXM1.debugId)} Resolved endpoint: ${(0, $9vwgw.toDebugString)(endpoint)}`);
    return endpoint;
};

});
parcelRegister("dsq7I", function(module, exports) {
$parcel$export(module.exports, "debugId", () => (parcelRequire("hEXM1")).debugId);
$parcel$export(module.exports, "toDebugString", () => (parcelRequire("9vwgw")).toDebugString);
parcelRequire("hEXM1");
parcelRequire("9vwgw");

});
parcelRegister("hEXM1", function(module, exports) {

$parcel$export(module.exports, "debugId", () => $cdb489dbaf33caff$export$2a09d6727e5ecede);
const $cdb489dbaf33caff$export$2a09d6727e5ecede = "endpoints";

});

parcelRegister("9vwgw", function(module, exports) {

$parcel$export(module.exports, "toDebugString", () => $6ec009918ce560f1$export$7b48b8905f46d631);
function $6ec009918ce560f1$export$7b48b8905f46d631(input) {
    if (typeof input !== "object" || input == null) return input;
    if ("ref" in input) return `$${$6ec009918ce560f1$export$7b48b8905f46d631(input.ref)}`;
    if ("fn" in input) return `${input.fn}(${(input.argv || []).map($6ec009918ce560f1$export$7b48b8905f46d631).join(", ")})`;
    return JSON.stringify(input, null, 2);
}

});


parcelRegister("kqSrk", function(module, exports) {
$parcel$export(module.exports, "EndpointError", () => (parcelRequire("1cC0Y")).EndpointError);
parcelRequire("1cC0Y");
parcelRequire("kRGSa");
parcelRequire("2ywZn");
parcelRequire("llROi");
parcelRequire("c0WlA");
parcelRequire("gNYfM");
parcelRequire("1hCtu");

});
parcelRegister("1cC0Y", function(module, exports) {

$parcel$export(module.exports, "EndpointError", () => $0e04666225822b37$export$603f31e9980bccaf);
class $0e04666225822b37$export$603f31e9980bccaf extends Error {
    constructor(message){
        super(message);
        this.name = "EndpointError";
    }
}

});

parcelRegister("kRGSa", function(module, exports) {

});

parcelRegister("2ywZn", function(module, exports) {

});

parcelRegister("llROi", function(module, exports) {

});

parcelRegister("c0WlA", function(module, exports) {

});

parcelRegister("gNYfM", function(module, exports) {

});

parcelRegister("1hCtu", function(module, exports) {

});


parcelRegister("k2nBm", function(module, exports) {
$parcel$export(module.exports, "evaluateRules", () => (parcelRequire("1BaO8")).evaluateRules);
parcelRequire("dCEjZ");
parcelRequire("1BaO8");

});
parcelRegister("1BaO8", function(module, exports) {

$parcel$export(module.exports, "evaluateRules", () => $12a1a14be004ade6$export$cd6fa289eb934f12);
parcelRequire("kqSrk");
var $1cC0Y = parcelRequire("1cC0Y");

var $7vXZo = parcelRequire("7vXZo");

var $e3pxF = parcelRequire("e3pxF");

var $5jzKI = parcelRequire("5jzKI");
const $12a1a14be004ade6$export$cd6fa289eb934f12 = (rules, options)=>{
    for (const rule of rules){
        if (rule.type === "endpoint") {
            const endpointOrUndefined = (0, $7vXZo.evaluateEndpointRule)(rule, options);
            if (endpointOrUndefined) return endpointOrUndefined;
        } else if (rule.type === "error") (0, $e3pxF.evaluateErrorRule)(rule, options);
        else if (rule.type === "tree") {
            const endpointOrUndefined = (0, $5jzKI.evaluateTreeRule)(rule, options);
            if (endpointOrUndefined) return endpointOrUndefined;
        } else throw new (0, $1cC0Y.EndpointError)(`Unknown endpoint rule: ${rule}`);
    }
    throw new (0, $1cC0Y.EndpointError)(`Rules evaluation failed`);
};

});
parcelRegister("7vXZo", function(module, exports) {

$parcel$export(module.exports, "evaluateEndpointRule", () => $5789f63e51430387$export$791799461674b1cb);
parcelRequire("dsq7I");
var $hEXM1 = parcelRequire("hEXM1");
var $9vwgw = parcelRequire("9vwgw");

var $ewlT8 = parcelRequire("ewlT8");

var $iaiaG = parcelRequire("iaiaG");

var $7uQ9P = parcelRequire("7uQ9P");

var $4EzGs = parcelRequire("4EzGs");
const $5789f63e51430387$export$791799461674b1cb = (endpointRule, options)=>{
    const { conditions: conditions, endpoint: endpoint } = endpointRule;
    const { result: result, referenceRecord: referenceRecord } = (0, $ewlT8.evaluateConditions)(conditions, options);
    if (!result) return;
    const endpointRuleOptions = {
        ...options,
        referenceRecord: {
            ...options.referenceRecord,
            ...referenceRecord
        }
    };
    const { url: url, properties: properties, headers: headers } = endpoint;
    options.logger?.debug?.((0, $hEXM1.debugId), `Resolving endpoint from template: ${(0, $9vwgw.toDebugString)(endpoint)}`);
    return {
        ...headers != undefined && {
            headers: (0, $iaiaG.getEndpointHeaders)(headers, endpointRuleOptions)
        },
        ...properties != undefined && {
            properties: (0, $7uQ9P.getEndpointProperties)(properties, endpointRuleOptions)
        },
        url: (0, $4EzGs.getEndpointUrl)(url, endpointRuleOptions)
    };
};

});
parcelRegister("ewlT8", function(module, exports) {

$parcel$export(module.exports, "evaluateConditions", () => $a92508637318a6bd$export$bad219652748f1f3);
parcelRequire("dsq7I");
var $hEXM1 = parcelRequire("hEXM1");
var $9vwgw = parcelRequire("9vwgw");

var $12MX9 = parcelRequire("12MX9");
const $a92508637318a6bd$export$bad219652748f1f3 = (conditions = [], options)=>{
    const conditionsReferenceRecord = {};
    for (const condition of conditions){
        const { result: result, toAssign: toAssign } = (0, $12MX9.evaluateCondition)(condition, {
            ...options,
            referenceRecord: {
                ...options.referenceRecord,
                ...conditionsReferenceRecord
            }
        });
        if (!result) return {
            result: result
        };
        if (toAssign) {
            conditionsReferenceRecord[toAssign.name] = toAssign.value;
            options.logger?.debug?.((0, $hEXM1.debugId), `assign: ${toAssign.name} := ${(0, $9vwgw.toDebugString)(toAssign.value)}`);
        }
    }
    return {
        result: true,
        referenceRecord: conditionsReferenceRecord
    };
};

});
parcelRegister("12MX9", function(module, exports) {

$parcel$export(module.exports, "evaluateCondition", () => $0c2bf362ec1da24a$export$6695392473e235ae);
parcelRequire("dsq7I");
var $hEXM1 = parcelRequire("hEXM1");
var $9vwgw = parcelRequire("9vwgw");
parcelRequire("kqSrk");
var $1cC0Y = parcelRequire("1cC0Y");

var $iEp6S = parcelRequire("iEp6S");
const $0c2bf362ec1da24a$export$6695392473e235ae = ({ assign: assign, ...fnArgs }, options)=>{
    if (assign && assign in options.referenceRecord) throw new (0, $1cC0Y.EndpointError)(`'${assign}' is already defined in Reference Record.`);
    const value = (0, $iEp6S.callFunction)(fnArgs, options);
    options.logger?.debug?.((0, $hEXM1.debugId), `evaluateCondition: ${(0, $9vwgw.toDebugString)(fnArgs)} = ${(0, $9vwgw.toDebugString)(value)}`);
    return {
        result: value === "" ? true : !!value,
        ...assign != null && {
            toAssign: {
                name: assign,
                value: value
            }
        }
    };
};

});
parcelRegister("iEp6S", function(module, exports) {

$parcel$export(module.exports, "callFunction", () => $d93f70b738d74a82$export$d883fbf232f0d35a);

var $dCEjZ = parcelRequire("dCEjZ");

var $bpGD7 = parcelRequire("bpGD7");

var $8XYzP = parcelRequire("8XYzP");
const $d93f70b738d74a82$export$d883fbf232f0d35a = ({ fn: fn, argv: argv }, options)=>{
    const evaluatedArgs = argv.map((arg)=>[
            "boolean",
            "number"
        ].includes(typeof arg) ? arg : (0, $8XYzP.evaluateExpression)(arg, "arg", options));
    const fnSegments = fn.split(".");
    if (fnSegments[0] in (0, $dCEjZ.customEndpointFunctions) && fnSegments[1] != null) return (0, $dCEjZ.customEndpointFunctions)[fnSegments[0]][fnSegments[1]](...evaluatedArgs);
    return (0, $bpGD7.endpointFunctions)[fn](...evaluatedArgs);
};

});
parcelRegister("bpGD7", function(module, exports) {

$parcel$export(module.exports, "endpointFunctions", () => $84f318efe55ebaa5$export$fffca6040ff170c9);
parcelRequire("hOJyA");
var $eSNfp = parcelRequire("eSNfp");
var $gEGJf = parcelRequire("gEGJf");
var $gx8hT = parcelRequire("gx8hT");
var $b8euM = parcelRequire("b8euM");
var $8O3xY = parcelRequire("8O3xY");
var $gGrXK = parcelRequire("gGrXK");
var $1mTAP = parcelRequire("1mTAP");
var $e2uSp = parcelRequire("e2uSp");
var $jLFWl = parcelRequire("jLFWl");
const $84f318efe55ebaa5$export$fffca6040ff170c9 = {
    booleanEquals: $eSNfp.booleanEquals,
    getAttr: $gEGJf.getAttr,
    isSet: $gx8hT.isSet,
    isValidHostLabel: $b8euM.isValidHostLabel,
    not: $8O3xY.not,
    parseURL: $gGrXK.parseURL,
    stringEquals: $1mTAP.stringEquals,
    substring: $e2uSp.substring,
    uriEncode: $jLFWl.uriEncode
};

});
parcelRegister("hOJyA", function(module, exports) {
$parcel$export(module.exports, "booleanEquals", () => (parcelRequire("eSNfp")).booleanEquals);
$parcel$export(module.exports, "getAttr", () => (parcelRequire("gEGJf")).getAttr);
$parcel$export(module.exports, "isSet", () => (parcelRequire("gx8hT")).isSet);
$parcel$export(module.exports, "isValidHostLabel", () => (parcelRequire("b8euM")).isValidHostLabel);
$parcel$export(module.exports, "not", () => (parcelRequire("8O3xY")).not);
$parcel$export(module.exports, "parseURL", () => (parcelRequire("gGrXK")).parseURL);
$parcel$export(module.exports, "stringEquals", () => (parcelRequire("1mTAP")).stringEquals);
$parcel$export(module.exports, "substring", () => (parcelRequire("e2uSp")).substring);
$parcel$export(module.exports, "uriEncode", () => (parcelRequire("jLFWl")).uriEncode);
parcelRequire("eSNfp");
parcelRequire("gEGJf");
parcelRequire("gx8hT");
parcelRequire("b8euM");
parcelRequire("8O3xY");
parcelRequire("gGrXK");
parcelRequire("1mTAP");
parcelRequire("e2uSp");
parcelRequire("jLFWl");

});
parcelRegister("eSNfp", function(module, exports) {

$parcel$export(module.exports, "booleanEquals", () => $ad5c4f5a4f54af47$export$6608cbdc537206b3);
const $ad5c4f5a4f54af47$export$6608cbdc537206b3 = (value1, value2)=>value1 === value2;

});

parcelRegister("gEGJf", function(module, exports) {

$parcel$export(module.exports, "getAttr", () => $c20186cfc6011ae2$export$6a93fe6b2b4c71a0);
parcelRequire("kqSrk");
var $1cC0Y = parcelRequire("1cC0Y");

var $hG8wV = parcelRequire("hG8wV");
const $c20186cfc6011ae2$export$6a93fe6b2b4c71a0 = (value, path)=>(0, $hG8wV.getAttrPathList)(path).reduce((acc, index)=>{
        if (typeof acc !== "object") throw new (0, $1cC0Y.EndpointError)(`Index '${index}' in '${path}' not found in '${JSON.stringify(value)}'`);
        else if (Array.isArray(acc)) return acc[parseInt(index)];
        return acc[index];
    }, value);

});
parcelRegister("hG8wV", function(module, exports) {

$parcel$export(module.exports, "getAttrPathList", () => $cdecf9d06b309e06$export$e8fa1ee343c456a5);
parcelRequire("kqSrk");
var $1cC0Y = parcelRequire("1cC0Y");
const $cdecf9d06b309e06$export$e8fa1ee343c456a5 = (path)=>{
    const parts = path.split(".");
    const pathList = [];
    for (const part of parts){
        const squareBracketIndex = part.indexOf("[");
        if (squareBracketIndex !== -1) {
            if (part.indexOf("]") !== part.length - 1) throw new (0, $1cC0Y.EndpointError)(`Path: '${path}' does not end with ']'`);
            const arrayIndex = part.slice(squareBracketIndex + 1, -1);
            if (Number.isNaN(parseInt(arrayIndex))) throw new (0, $1cC0Y.EndpointError)(`Invalid array index: '${arrayIndex}' in path: '${path}'`);
            if (squareBracketIndex !== 0) pathList.push(part.slice(0, squareBracketIndex));
            pathList.push(arrayIndex);
        } else pathList.push(part);
    }
    return pathList;
};

});


parcelRegister("gx8hT", function(module, exports) {

$parcel$export(module.exports, "isSet", () => $c09628243cd80354$export$6750766a7c7ec627);
const $c09628243cd80354$export$6750766a7c7ec627 = (value)=>value != null;

});

parcelRegister("8O3xY", function(module, exports) {

$parcel$export(module.exports, "not", () => $6695be91c5b8878f$export$6003a5f097c73977);
const $6695be91c5b8878f$export$6003a5f097c73977 = (value)=>!value;

});

parcelRegister("gGrXK", function(module, exports) {

$parcel$export(module.exports, "parseURL", () => $c256426a75d717e9$export$4b3d9a5bae55976);
parcelRequire("8t4sF");
var $loh90 = parcelRequire("loh90");

var $6vGGL = parcelRequire("6vGGL");
const $c256426a75d717e9$var$DEFAULT_PORTS = {
    [(0, $loh90.EndpointURLScheme).HTTP]: 80,
    [(0, $loh90.EndpointURLScheme).HTTPS]: 443
};
const $c256426a75d717e9$export$4b3d9a5bae55976 = (value)=>{
    const whatwgURL = (()=>{
        try {
            if (value instanceof URL) return value;
            if (typeof value === "object" && "hostname" in value) {
                const { hostname: hostname, port: port, protocol: protocol = "", path: path = "", query: query = {} } = value;
                const url = new URL(`${protocol}//${hostname}${port ? `:${port}` : ""}${path}`);
                url.search = Object.entries(query).map(([k, v])=>`${k}=${v}`).join("&");
                return url;
            }
            return new URL(value);
        } catch (error) {
            return null;
        }
    })();
    if (!whatwgURL) {
        console.error(`Unable to parse ${JSON.stringify(value)} as a whatwg URL.`);
        return null;
    }
    const urlString = whatwgURL.href;
    const { host: host, hostname: hostname, pathname: pathname, protocol: protocol, search: search } = whatwgURL;
    if (search) return null;
    const scheme = protocol.slice(0, -1);
    if (!Object.values((0, $loh90.EndpointURLScheme)).includes(scheme)) return null;
    const isIp = (0, $6vGGL.isIpAddress)(hostname);
    const inputContainsDefaultPort = urlString.includes(`${host}:${$c256426a75d717e9$var$DEFAULT_PORTS[scheme]}`) || typeof value === "string" && value.includes(`${host}:${$c256426a75d717e9$var$DEFAULT_PORTS[scheme]}`);
    const authority = `${host}${inputContainsDefaultPort ? `:${$c256426a75d717e9$var$DEFAULT_PORTS[scheme]}` : ``}`;
    return {
        scheme: scheme,
        authority: authority,
        path: pathname,
        normalizedPath: pathname.endsWith("/") ? pathname : `${pathname}/`,
        isIp: isIp
    };
};

});

parcelRegister("1mTAP", function(module, exports) {

$parcel$export(module.exports, "stringEquals", () => $0ff2f81fdd173cc2$export$f8f73f238947765e);
const $0ff2f81fdd173cc2$export$f8f73f238947765e = (value1, value2)=>value1 === value2;

});

parcelRegister("e2uSp", function(module, exports) {

$parcel$export(module.exports, "substring", () => $a3893402c3bee315$export$662d3818631fba36);
const $a3893402c3bee315$export$662d3818631fba36 = (input, start, stop, reverse)=>{
    if (start >= stop || input.length < stop) return null;
    if (!reverse) return input.substring(start, stop);
    return input.substring(input.length - stop, input.length - start);
};

});

parcelRegister("jLFWl", function(module, exports) {

$parcel$export(module.exports, "uriEncode", () => $e642f085688a64bf$export$1ea6cdab375898b5);
const $e642f085688a64bf$export$1ea6cdab375898b5 = (value)=>encodeURIComponent(value).replace(/[!*'()]/g, (c)=>`%${c.charCodeAt(0).toString(16).toUpperCase()}`);

});



parcelRegister("8XYzP", function(module, exports) {

$parcel$export(module.exports, "evaluateExpression", () => $6872d2bca4681256$export$3191fa0ae67b450c);
parcelRequire("kqSrk");
var $1cC0Y = parcelRequire("1cC0Y");

var $iEp6S = parcelRequire("iEp6S");

var $55yd3 = parcelRequire("55yd3");

var $2hLtp = parcelRequire("2hLtp");
const $6872d2bca4681256$export$3191fa0ae67b450c = (obj, keyName, options)=>{
    if (typeof obj === "string") return (0, $55yd3.evaluateTemplate)(obj, options);
    else if (obj["fn"]) return (0, $iEp6S.callFunction)(obj, options);
    else if (obj["ref"]) return (0, $2hLtp.getReferenceValue)(obj, options);
    throw new (0, $1cC0Y.EndpointError)(`'${keyName}': ${String(obj)} is not a string, function or reference.`);
};

});
parcelRegister("55yd3", function(module, exports) {

$parcel$export(module.exports, "evaluateTemplate", () => $3b47f4b1a73d14b4$export$c77ca0e5a2c5469c);
parcelRequire("hOJyA");
var $gEGJf = parcelRequire("gEGJf");
const $3b47f4b1a73d14b4$export$c77ca0e5a2c5469c = (template, options)=>{
    const evaluatedTemplateArr = [];
    const templateContext = {
        ...options.endpointParams,
        ...options.referenceRecord
    };
    let currentIndex = 0;
    while(currentIndex < template.length){
        const openingBraceIndex = template.indexOf("{", currentIndex);
        if (openingBraceIndex === -1) {
            evaluatedTemplateArr.push(template.slice(currentIndex));
            break;
        }
        evaluatedTemplateArr.push(template.slice(currentIndex, openingBraceIndex));
        const closingBraceIndex = template.indexOf("}", openingBraceIndex);
        if (closingBraceIndex === -1) {
            evaluatedTemplateArr.push(template.slice(openingBraceIndex));
            break;
        }
        if (template[openingBraceIndex + 1] === "{" && template[closingBraceIndex + 1] === "}") {
            evaluatedTemplateArr.push(template.slice(openingBraceIndex + 1, closingBraceIndex));
            currentIndex = closingBraceIndex + 2;
        }
        const parameterName = template.substring(openingBraceIndex + 1, closingBraceIndex);
        if (parameterName.includes("#")) {
            const [refName, attrName] = parameterName.split("#");
            evaluatedTemplateArr.push((0, $gEGJf.getAttr)(templateContext[refName], attrName));
        } else evaluatedTemplateArr.push(templateContext[parameterName]);
        currentIndex = closingBraceIndex + 1;
    }
    return evaluatedTemplateArr.join("");
};

});

parcelRegister("2hLtp", function(module, exports) {

$parcel$export(module.exports, "getReferenceValue", () => $1aa1fe80966d66be$export$812bd59fe014e418);
const $1aa1fe80966d66be$export$812bd59fe014e418 = ({ ref: ref }, options)=>{
    const referenceRecord = {
        ...options.endpointParams,
        ...options.referenceRecord
    };
    return referenceRecord[ref];
};

});





parcelRegister("iaiaG", function(module, exports) {

$parcel$export(module.exports, "getEndpointHeaders", () => $d397419c9089dff2$export$479dec716600cbb);
parcelRequire("kqSrk");
var $1cC0Y = parcelRequire("1cC0Y");

var $8XYzP = parcelRequire("8XYzP");
const $d397419c9089dff2$export$479dec716600cbb = (headers, options)=>Object.entries(headers).reduce((acc, [headerKey, headerVal])=>({
            ...acc,
            [headerKey]: headerVal.map((headerValEntry)=>{
                const processedExpr = (0, $8XYzP.evaluateExpression)(headerValEntry, "Header value entry", options);
                if (typeof processedExpr !== "string") throw new (0, $1cC0Y.EndpointError)(`Header '${headerKey}' value '${processedExpr}' is not a string`);
                return processedExpr;
            })
        }), {});

});

parcelRegister("7uQ9P", function(module, exports) {

$parcel$export(module.exports, "getEndpointProperties", () => $5753cb27b07250a6$export$f7b44341c2929056);

var $hR5YM = parcelRequire("hR5YM");
const $5753cb27b07250a6$export$f7b44341c2929056 = (properties, options)=>Object.entries(properties).reduce((acc, [propertyKey, propertyVal])=>({
            ...acc,
            [propertyKey]: (0, $hR5YM.getEndpointProperty)(propertyVal, options)
        }), {});

});
parcelRegister("hR5YM", function(module, exports) {

$parcel$export(module.exports, "getEndpointProperty", () => $cffc06480409d472$export$39bc8a0c7360c2f4);
parcelRequire("kqSrk");
var $1cC0Y = parcelRequire("1cC0Y");

var $55yd3 = parcelRequire("55yd3");

var $7uQ9P = parcelRequire("7uQ9P");
const $cffc06480409d472$export$39bc8a0c7360c2f4 = (property, options)=>{
    if (Array.isArray(property)) return property.map((propertyEntry)=>$cffc06480409d472$export$39bc8a0c7360c2f4(propertyEntry, options));
    switch(typeof property){
        case "string":
            return (0, $55yd3.evaluateTemplate)(property, options);
        case "object":
            if (property === null) throw new (0, $1cC0Y.EndpointError)(`Unexpected endpoint property: ${property}`);
            return (0, $7uQ9P.getEndpointProperties)(property, options);
        case "boolean":
            return property;
        default:
            throw new (0, $1cC0Y.EndpointError)(`Unexpected endpoint property type: ${typeof property}`);
    }
};

});


parcelRegister("4EzGs", function(module, exports) {

$parcel$export(module.exports, "getEndpointUrl", () => $363693ea5c157add$export$c54f5a49b5be9709);
parcelRequire("kqSrk");
var $1cC0Y = parcelRequire("1cC0Y");

var $8XYzP = parcelRequire("8XYzP");
const $363693ea5c157add$export$c54f5a49b5be9709 = (endpointUrl, options)=>{
    const expression = (0, $8XYzP.evaluateExpression)(endpointUrl, "Endpoint URL", options);
    if (typeof expression === "string") try {
        return new URL(expression);
    } catch (error) {
        console.error(`Failed to construct URL with ${expression}`, error);
        throw error;
    }
    throw new (0, $1cC0Y.EndpointError)(`Endpoint URL must be a string, got ${typeof expression}`);
};

});


parcelRegister("e3pxF", function(module, exports) {

$parcel$export(module.exports, "evaluateErrorRule", () => $a3b5289a1ed3b4ab$export$a36dfbc7e1fb8626);
parcelRequire("kqSrk");
var $1cC0Y = parcelRequire("1cC0Y");

var $ewlT8 = parcelRequire("ewlT8");

var $8XYzP = parcelRequire("8XYzP");
const $a3b5289a1ed3b4ab$export$a36dfbc7e1fb8626 = (errorRule, options)=>{
    const { conditions: conditions, error: error } = errorRule;
    const { result: result, referenceRecord: referenceRecord } = (0, $ewlT8.evaluateConditions)(conditions, options);
    if (!result) return;
    throw new (0, $1cC0Y.EndpointError)((0, $8XYzP.evaluateExpression)(error, "Error", {
        ...options,
        referenceRecord: {
            ...options.referenceRecord,
            ...referenceRecord
        }
    }));
};

});

parcelRegister("5jzKI", function(module, exports) {

$parcel$export(module.exports, "evaluateTreeRule", () => $3dea75c6f1c742f4$export$2e518b103c26ca79);

var $ewlT8 = parcelRequire("ewlT8");

var $1BaO8 = parcelRequire("1BaO8");
const $3dea75c6f1c742f4$export$2e518b103c26ca79 = (treeRule, options)=>{
    const { conditions: conditions, rules: rules } = treeRule;
    const { result: result, referenceRecord: referenceRecord } = (0, $ewlT8.evaluateConditions)(conditions, options);
    if (!result) return;
    return (0, $1BaO8.evaluateRules)(rules, {
        ...options,
        referenceRecord: {
            ...options.referenceRecord,
            ...referenceRecord
        }
    });
};

});





parcelRegister("hn5GH", function(module, exports) {

$parcel$export(module.exports, "isVirtualHostableS3Bucket", () => $ca58ff1db3de89f1$export$6b6a3f4e857868ec);
parcelRequire("j27kH");
var $b8euM = parcelRequire("b8euM");
parcelRequire("7spWz");
var $6vGGL = parcelRequire("6vGGL");
const $ca58ff1db3de89f1$export$6b6a3f4e857868ec = (value, allowSubDomains = false)=>{
    if (allowSubDomains) {
        for (const label of value.split(".")){
            if (!$ca58ff1db3de89f1$export$6b6a3f4e857868ec(label)) return false;
        }
        return true;
    }
    if (!(0, $b8euM.isValidHostLabel)(value)) return false;
    if (value.length < 3 || value.length > 63) return false;
    if (value !== value.toLowerCase()) return false;
    if ((0, $6vGGL.isIpAddress)(value)) return false;
    return true;
};

});
parcelRegister("7spWz", function(module, exports) {

$parcel$export(module.exports, "isIpAddress", () => (parcelRequire("6vGGL")).isIpAddress);
parcelRequire("j27kH");
var $6vGGL = parcelRequire("6vGGL");

});


parcelRegister("eXkM7", function(module, exports) {

$parcel$export(module.exports, "parseArn", () => $ae36b0e3befb3915$export$ec6a98ce8737fc2c);
const $ae36b0e3befb3915$export$ec6a98ce8737fc2c = (value)=>{
    const segments = value.split(":");
    if (segments.length < 6) return null;
    const [arn, partition, service, region, accountId, ...resourceId] = segments;
    if (arn !== "arn" || partition === "" || service === "" || resourceId[0] === "") return null;
    return {
        partition: partition,
        service: service,
        region: region,
        accountId: accountId,
        resourceId: resourceId[0].includes("/") ? resourceId[0].split("/") : resourceId
    };
};

});

parcelRegister("5hd3k", function(module, exports) {

$parcel$export(module.exports, "partition", () => $3d78aa43c2ca90cb$export$b29f828819edca8d);
$parcel$export(module.exports, "getUserAgentPrefix", () => $3d78aa43c2ca90cb$export$c249da7071246380);

var $7lAeL = parcelRequire("7lAeL");
let $3d78aa43c2ca90cb$var$selectedPartitionsInfo = (0, (/*@__PURE__*/$parcel$interopDefault($7lAeL)));
let $3d78aa43c2ca90cb$var$selectedUserAgentPrefix = "";
const $3d78aa43c2ca90cb$export$b29f828819edca8d = (value)=>{
    const { partitions: partitions } = $3d78aa43c2ca90cb$var$selectedPartitionsInfo;
    for (const partition of partitions){
        const { regions: regions, outputs: outputs } = partition;
        for (const [region, regionData] of Object.entries(regions)){
            if (region === value) return {
                ...outputs,
                ...regionData
            };
        }
    }
    for (const partition of partitions){
        const { regionRegex: regionRegex, outputs: outputs } = partition;
        if (new RegExp(regionRegex).test(value)) return {
            ...outputs
        };
    }
    const DEFAULT_PARTITION = partitions.find((partition)=>partition.id === "aws");
    if (!DEFAULT_PARTITION) throw new Error("Provided region was not found in the partition array or regex, and default partition with id 'aws' doesn't exist.");
    return {
        ...DEFAULT_PARTITION.outputs
    };
};
const $3d78aa43c2ca90cb$export$5b2daaf969a6da2e = (partitionsInfo, userAgentPrefix = "")=>{
    $3d78aa43c2ca90cb$var$selectedPartitionsInfo = partitionsInfo;
    $3d78aa43c2ca90cb$var$selectedUserAgentPrefix = userAgentPrefix;
};
const $3d78aa43c2ca90cb$export$1003c50da40cdce = ()=>{
    $3d78aa43c2ca90cb$export$5b2daaf969a6da2e((0, (/*@__PURE__*/$parcel$interopDefault($7lAeL))), "");
};
const $3d78aa43c2ca90cb$export$c249da7071246380 = ()=>$3d78aa43c2ca90cb$var$selectedUserAgentPrefix;

});
parcelRegister("7lAeL", function(module, exports) {
module.exports = JSON.parse('{"partitions":[{"id":"aws","outputs":{"dnsSuffix":"amazonaws.com","dualStackDnsSuffix":"api.aws","implicitGlobalRegion":"us-east-1","name":"aws","supportsDualStack":true,"supportsFIPS":true},"regionRegex":"^(us|eu|ap|sa|ca|me|af|il)\\\\-\\\\w+\\\\-\\\\d+$","regions":{"af-south-1":{"description":"Africa (Cape Town)"},"ap-east-1":{"description":"Asia Pacific (Hong Kong)"},"ap-northeast-1":{"description":"Asia Pacific (Tokyo)"},"ap-northeast-2":{"description":"Asia Pacific (Seoul)"},"ap-northeast-3":{"description":"Asia Pacific (Osaka)"},"ap-south-1":{"description":"Asia Pacific (Mumbai)"},"ap-south-2":{"description":"Asia Pacific (Hyderabad)"},"ap-southeast-1":{"description":"Asia Pacific (Singapore)"},"ap-southeast-2":{"description":"Asia Pacific (Sydney)"},"ap-southeast-3":{"description":"Asia Pacific (Jakarta)"},"ap-southeast-4":{"description":"Asia Pacific (Melbourne)"},"aws-global":{"description":"AWS Standard global region"},"ca-central-1":{"description":"Canada (Central)"},"ca-west-1":{"description":"Canada West (Calgary)"},"eu-central-1":{"description":"Europe (Frankfurt)"},"eu-central-2":{"description":"Europe (Zurich)"},"eu-north-1":{"description":"Europe (Stockholm)"},"eu-south-1":{"description":"Europe (Milan)"},"eu-south-2":{"description":"Europe (Spain)"},"eu-west-1":{"description":"Europe (Ireland)"},"eu-west-2":{"description":"Europe (London)"},"eu-west-3":{"description":"Europe (Paris)"},"il-central-1":{"description":"Israel (Tel Aviv)"},"me-central-1":{"description":"Middle East (UAE)"},"me-south-1":{"description":"Middle East (Bahrain)"},"sa-east-1":{"description":"South America (Sao Paulo)"},"us-east-1":{"description":"US East (N. Virginia)"},"us-east-2":{"description":"US East (Ohio)"},"us-west-1":{"description":"US West (N. California)"},"us-west-2":{"description":"US West (Oregon)"}}},{"id":"aws-cn","outputs":{"dnsSuffix":"amazonaws.com.cn","dualStackDnsSuffix":"api.amazonwebservices.com.cn","implicitGlobalRegion":"cn-northwest-1","name":"aws-cn","supportsDualStack":true,"supportsFIPS":true},"regionRegex":"^cn\\\\-\\\\w+\\\\-\\\\d+$","regions":{"aws-cn-global":{"description":"AWS China global region"},"cn-north-1":{"description":"China (Beijing)"},"cn-northwest-1":{"description":"China (Ningxia)"}}},{"id":"aws-us-gov","outputs":{"dnsSuffix":"amazonaws.com","dualStackDnsSuffix":"api.aws","implicitGlobalRegion":"us-gov-west-1","name":"aws-us-gov","supportsDualStack":true,"supportsFIPS":true},"regionRegex":"^us\\\\-gov\\\\-\\\\w+\\\\-\\\\d+$","regions":{"aws-us-gov-global":{"description":"AWS GovCloud (US) global region"},"us-gov-east-1":{"description":"AWS GovCloud (US-East)"},"us-gov-west-1":{"description":"AWS GovCloud (US-West)"}}},{"id":"aws-iso","outputs":{"dnsSuffix":"c2s.ic.gov","dualStackDnsSuffix":"c2s.ic.gov","implicitGlobalRegion":"us-iso-east-1","name":"aws-iso","supportsDualStack":false,"supportsFIPS":true},"regionRegex":"^us\\\\-iso\\\\-\\\\w+\\\\-\\\\d+$","regions":{"aws-iso-global":{"description":"AWS ISO (US) global region"},"us-iso-east-1":{"description":"US ISO East"},"us-iso-west-1":{"description":"US ISO WEST"}}},{"id":"aws-iso-b","outputs":{"dnsSuffix":"sc2s.sgov.gov","dualStackDnsSuffix":"sc2s.sgov.gov","implicitGlobalRegion":"us-isob-east-1","name":"aws-iso-b","supportsDualStack":false,"supportsFIPS":true},"regionRegex":"^us\\\\-isob\\\\-\\\\w+\\\\-\\\\d+$","regions":{"aws-iso-b-global":{"description":"AWS ISOB (US) global region"},"us-isob-east-1":{"description":"US ISOB East (Ohio)"}}},{"id":"aws-iso-e","outputs":{"dnsSuffix":"cloud.adc-e.uk","dualStackDnsSuffix":"cloud.adc-e.uk","implicitGlobalRegion":"eu-isoe-west-1","name":"aws-iso-e","supportsDualStack":false,"supportsFIPS":true},"regionRegex":"^eu\\\\-isoe\\\\-\\\\w+\\\\-\\\\d+$","regions":{}},{"id":"aws-iso-f","outputs":{"dnsSuffix":"csp.hci.ic.gov","dualStackDnsSuffix":"csp.hci.ic.gov","implicitGlobalRegion":"us-isof-south-1","name":"aws-iso-f","supportsDualStack":false,"supportsFIPS":true},"regionRegex":"^us\\\\-isof\\\\-\\\\w+\\\\-\\\\d+$","regions":{}}],"version":"1.1"}');

});



parcelRegister("8QlB8", function(module, exports) {
parcelRequire("j27kH");
var $fdTj5 = parcelRequire("fdTj5");

});

parcelRegister("7xiXa", function(module, exports) {
parcelRequire("ayHcp");
parcelRequire("fTlSb");
parcelRequire("885cd");
parcelRequire("4kLeB");
parcelRequire("a3NeA");
parcelRequire("dsVG9");

});
parcelRegister("ayHcp", function(module, exports) {
parcelRequire("j27kH");
var $1cC0Y = parcelRequire("1cC0Y");

});

parcelRegister("fTlSb", function(module, exports) {

});

parcelRegister("885cd", function(module, exports) {

});

parcelRegister("4kLeB", function(module, exports) {

});

parcelRegister("a3NeA", function(module, exports) {

});

parcelRegister("dsVG9", function(module, exports) {

});



parcelRegister("8J6F4", function(module, exports) {

$parcel$export(module.exports, "USER_AGENT", () => $65a7b18057737e3c$export$97a08a1bb7ee0545);
$parcel$export(module.exports, "X_AMZ_USER_AGENT", () => $65a7b18057737e3c$export$e010e3d6246262a3);
$parcel$export(module.exports, "SPACE", () => $65a7b18057737e3c$export$27b7b95a5fde2b31);
$parcel$export(module.exports, "UA_NAME_SEPARATOR", () => $65a7b18057737e3c$export$43290ff793d1777d);
$parcel$export(module.exports, "UA_NAME_ESCAPE_REGEX", () => $65a7b18057737e3c$export$2d1b87b5b2a59af3);
$parcel$export(module.exports, "UA_VALUE_ESCAPE_REGEX", () => $65a7b18057737e3c$export$84cb6e726944481);
$parcel$export(module.exports, "UA_ESCAPE_CHAR", () => $65a7b18057737e3c$export$f810014d932f8c3e);
const $65a7b18057737e3c$export$97a08a1bb7ee0545 = "user-agent";
const $65a7b18057737e3c$export$e010e3d6246262a3 = "x-amz-user-agent";
const $65a7b18057737e3c$export$27b7b95a5fde2b31 = " ";
const $65a7b18057737e3c$export$43290ff793d1777d = "/";
const $65a7b18057737e3c$export$2d1b87b5b2a59af3 = /[^\!\$\%\&\'\*\+\-\.\^\_\`\|\~\d\w]/g;
const $65a7b18057737e3c$export$84cb6e726944481 = /[^\!\$\%\&\'\*\+\-\.\^\_\`\|\~\d\w\#]/g;
const $65a7b18057737e3c$export$f810014d932f8c3e = "-";

});



parcelRegister("bIgHl", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_USE_DUALSTACK_ENDPOINT", () => (parcelRequire("1gTFA")).DEFAULT_USE_DUALSTACK_ENDPOINT);
$parcel$export(module.exports, "DEFAULT_USE_FIPS_ENDPOINT", () => (parcelRequire("4GfQZ")).DEFAULT_USE_FIPS_ENDPOINT);
$parcel$export(module.exports, "resolveRegionConfig", () => (parcelRequire("4aYuz")).resolveRegionConfig);
parcelRequire("2WZcu");
parcelRequire("hujei");
parcelRequire("7RfIS");

});
parcelRegister("2WZcu", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_USE_DUALSTACK_ENDPOINT", () => (parcelRequire("1gTFA")).DEFAULT_USE_DUALSTACK_ENDPOINT);
$parcel$export(module.exports, "DEFAULT_USE_FIPS_ENDPOINT", () => (parcelRequire("4GfQZ")).DEFAULT_USE_FIPS_ENDPOINT);
parcelRequire("1gTFA");
parcelRequire("4GfQZ");
parcelRequire("9yCZF");
parcelRequire("7VxYM");

});
parcelRegister("1gTFA", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_USE_DUALSTACK_ENDPOINT", () => $0ed277eaf399e0fa$export$beb01fae7626c427);
parcelRequire("g2HCV");
var $kLlHt = parcelRequire("kLlHt");
var $jYygt = parcelRequire("jYygt");
const $0ed277eaf399e0fa$export$eacd91361c129033 = "AWS_USE_DUALSTACK_ENDPOINT";
const $0ed277eaf399e0fa$export$71f82540e79c63bf = "use_dualstack_endpoint";
const $0ed277eaf399e0fa$export$beb01fae7626c427 = false;
const $0ed277eaf399e0fa$export$522137fc0ae615ab = {
    environmentVariableSelector: (env)=>(0, $kLlHt.booleanSelector)(env, $0ed277eaf399e0fa$export$eacd91361c129033, (0, $jYygt.SelectorType).ENV),
    configFileSelector: (profile)=>(0, $kLlHt.booleanSelector)(profile, $0ed277eaf399e0fa$export$71f82540e79c63bf, (0, $jYygt.SelectorType).CONFIG),
    default: false
};

});
parcelRegister("g2HCV", function(module, exports) {
$parcel$export(module.exports, "booleanSelector", () => (parcelRequire("kLlHt")).booleanSelector);
$parcel$export(module.exports, "SelectorType", () => (parcelRequire("jYygt")).SelectorType);
parcelRequire("kLlHt");
parcelRequire("cjeeU");
parcelRequire("jYygt");

});
parcelRegister("kLlHt", function(module, exports) {

$parcel$export(module.exports, "booleanSelector", () => $f1d907a15ed77563$export$f8c4049184e0ac3f);
const $f1d907a15ed77563$export$f8c4049184e0ac3f = (obj, key, type)=>{
    if (!(key in obj)) return undefined;
    if (obj[key] === "true") return true;
    if (obj[key] === "false") return false;
    throw new Error(`Cannot load ${type} "${key}". Expected "true" or "false", got ${obj[key]}.`);
};

});

parcelRegister("cjeeU", function(module, exports) {
const $8f624e087cc155aa$export$964ee8ab6fdb2cf2 = (obj, key, type)=>{
    if (!(key in obj)) return undefined;
    const numberValue = parseInt(obj[key], 10);
    if (Number.isNaN(numberValue)) throw new TypeError(`Cannot load ${type} '${key}'. Expected number, got '${obj[key]}'.`);
    return numberValue;
};

});

parcelRegister("jYygt", function(module, exports) {

$parcel$export(module.exports, "SelectorType", () => $e8ae33301b12ca7a$export$4e8b093ec8dcab0d);
var $e8ae33301b12ca7a$export$4e8b093ec8dcab0d;
(function(SelectorType) {
    SelectorType["ENV"] = "env";
    SelectorType["CONFIG"] = "shared config entry";
})($e8ae33301b12ca7a$export$4e8b093ec8dcab0d || ($e8ae33301b12ca7a$export$4e8b093ec8dcab0d = {}));

});



parcelRegister("4GfQZ", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_USE_FIPS_ENDPOINT", () => $368761dc07c4d3cf$export$5555deeca435a10b);
parcelRequire("g2HCV");
var $kLlHt = parcelRequire("kLlHt");
var $jYygt = parcelRequire("jYygt");
const $368761dc07c4d3cf$export$b7eebc18f98c6d7f = "AWS_USE_FIPS_ENDPOINT";
const $368761dc07c4d3cf$export$30cf725f60d4be3e = "use_fips_endpoint";
const $368761dc07c4d3cf$export$5555deeca435a10b = false;
const $368761dc07c4d3cf$export$42f76cc8f259f4b8 = {
    environmentVariableSelector: (env)=>(0, $kLlHt.booleanSelector)(env, $368761dc07c4d3cf$export$b7eebc18f98c6d7f, (0, $jYygt.SelectorType).ENV),
    configFileSelector: (profile)=>(0, $kLlHt.booleanSelector)(profile, $368761dc07c4d3cf$export$30cf725f60d4be3e, (0, $jYygt.SelectorType).CONFIG),
    default: false
};

});

parcelRegister("9yCZF", function(module, exports) {
parcelRequire("e2ELD");
var $j5KxT = parcelRequire("j5KxT");
const $6f55895fd1a94574$export$6cd750975e36686c = (input)=>{
    const { endpoint: endpoint, urlParser: urlParser } = input;
    return {
        ...input,
        tls: input.tls ?? true,
        endpoint: (0, $j5KxT.normalizeProvider)(typeof endpoint === "string" ? urlParser(endpoint) : endpoint),
        isCustomEndpoint: true,
        useDualstackEndpoint: (0, $j5KxT.normalizeProvider)(input.useDualstackEndpoint ?? false)
    };
};

});
parcelRegister("e2ELD", function(module, exports) {
$parcel$export(module.exports, "getSmithyContext", () => (parcelRequire("3eYQu")).getSmithyContext);
$parcel$export(module.exports, "normalizeProvider", () => (parcelRequire("j5KxT")).normalizeProvider);
parcelRequire("3eYQu");
parcelRequire("j5KxT");

});
parcelRegister("3eYQu", function(module, exports) {

$parcel$export(module.exports, "getSmithyContext", () => $25c1e08fc187d1cb$export$1d3c197393275463);
parcelRequire("8t4sF");
var $glfQ7 = parcelRequire("glfQ7");
const $25c1e08fc187d1cb$export$1d3c197393275463 = (context)=>context[0, $glfQ7.SMITHY_CONTEXT_KEY] || (context[0, $glfQ7.SMITHY_CONTEXT_KEY] = {});

});

parcelRegister("j5KxT", function(module, exports) {

$parcel$export(module.exports, "normalizeProvider", () => $de6296f03d85b036$export$b1276c07738d6325);
const $de6296f03d85b036$export$b1276c07738d6325 = (input)=>{
    if (typeof input === "function") return input;
    const promisified = Promise.resolve(input);
    return ()=>promisified;
};

});



parcelRegister("7VxYM", function(module, exports) {
parcelRequire("e2ELD");
var $j5KxT = parcelRequire("j5KxT");

var $4SeRH = parcelRequire("4SeRH");
const $5c5836df0c5c8604$export$24f352b1bd1e2f8b = (input)=>{
    const useDualstackEndpoint = (0, $j5KxT.normalizeProvider)(input.useDualstackEndpoint ?? false);
    const { endpoint: endpoint, useFipsEndpoint: useFipsEndpoint, urlParser: urlParser } = input;
    return {
        ...input,
        tls: input.tls ?? true,
        endpoint: endpoint ? (0, $j5KxT.normalizeProvider)(typeof endpoint === "string" ? urlParser(endpoint) : endpoint) : ()=>(0, $4SeRH.getEndpointFromRegion)({
                ...input,
                useDualstackEndpoint: useDualstackEndpoint,
                useFipsEndpoint: useFipsEndpoint
            }),
        isCustomEndpoint: !!endpoint,
        useDualstackEndpoint: useDualstackEndpoint
    };
};

});
parcelRegister("4SeRH", function(module, exports) {

$parcel$export(module.exports, "getEndpointFromRegion", () => $38c7bc7d103e04b3$export$c69bd155af41e6f1);
const $38c7bc7d103e04b3$export$c69bd155af41e6f1 = async (input)=>{
    const { tls: tls = true } = input;
    const region = await input.region();
    const dnsHostRegex = new RegExp(/^([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9])$/);
    if (!dnsHostRegex.test(region)) throw new Error("Invalid region in client config");
    const useDualstackEndpoint = await input.useDualstackEndpoint();
    const useFipsEndpoint = await input.useFipsEndpoint();
    const { hostname: hostname } = await input.regionInfoProvider(region, {
        useDualstackEndpoint: useDualstackEndpoint,
        useFipsEndpoint: useFipsEndpoint
    }) ?? {};
    if (!hostname) throw new Error("Cannot resolve hostname from client config");
    return input.urlParser(`${tls ? "https:" : "http:"}//${hostname}`);
};

});



parcelRegister("hujei", function(module, exports) {
$parcel$export(module.exports, "resolveRegionConfig", () => (parcelRequire("4aYuz")).resolveRegionConfig);
parcelRequire("ayHvu");
parcelRequire("4aYuz");

});
parcelRegister("ayHvu", function(module, exports) {
const $7afed3ebf6937966$export$26513716e2900bad = "AWS_REGION";
const $7afed3ebf6937966$export$8afb1c306a7d01b = "region";
const $7afed3ebf6937966$export$1509d3ea54119a08 = {
    environmentVariableSelector: (env)=>env[$7afed3ebf6937966$export$26513716e2900bad],
    configFileSelector: (profile)=>profile[$7afed3ebf6937966$export$8afb1c306a7d01b],
    default: ()=>{
        throw new Error("Region is missing");
    }
};
const $7afed3ebf6937966$export$9a37503ca194454d = {
    preferredFile: "credentials"
};

});

parcelRegister("4aYuz", function(module, exports) {

$parcel$export(module.exports, "resolveRegionConfig", () => $30a705125b24f9e2$export$7696ef37558bd0ec);

var $a6tht = parcelRequire("a6tht");

var $1Q8Y8 = parcelRequire("1Q8Y8");
const $30a705125b24f9e2$export$7696ef37558bd0ec = (input)=>{
    const { region: region, useFipsEndpoint: useFipsEndpoint } = input;
    if (!region) throw new Error("Region is missing");
    return {
        ...input,
        region: async ()=>{
            if (typeof region === "string") return (0, $a6tht.getRealRegion)(region);
            const providedRegion = await region();
            return (0, $a6tht.getRealRegion)(providedRegion);
        },
        useFipsEndpoint: async ()=>{
            const providedRegion = typeof region === "string" ? region : await region();
            if ((0, $1Q8Y8.isFipsRegion)(providedRegion)) return true;
            return typeof useFipsEndpoint !== "function" ? Promise.resolve(!!useFipsEndpoint) : useFipsEndpoint();
        }
    };
};

});
parcelRegister("a6tht", function(module, exports) {

$parcel$export(module.exports, "getRealRegion", () => $75b12d8121a0e1ea$export$ecbdf004a8547a7f);

var $1Q8Y8 = parcelRequire("1Q8Y8");
const $75b12d8121a0e1ea$export$ecbdf004a8547a7f = (region)=>(0, $1Q8Y8.isFipsRegion)(region) ? [
        "fips-aws-global",
        "aws-fips"
    ].includes(region) ? "us-east-1" : region.replace(/fips-(dkr-|prod-)?|-fips/, "") : region;

});
parcelRegister("1Q8Y8", function(module, exports) {

$parcel$export(module.exports, "isFipsRegion", () => $15719acf0fa615ad$export$cc893cb7e6a508dd);
const $15719acf0fa615ad$export$cc893cb7e6a508dd = (region)=>typeof region === "string" && (region.startsWith("fips-") || region.endsWith("-fips"));

});




parcelRegister("7RfIS", function(module, exports) {
parcelRequire("dEN3O");
parcelRequire("2nwgv");
parcelRequire("iTlrx");

});
parcelRegister("dEN3O", function(module, exports) {

});

parcelRegister("2nwgv", function(module, exports) {

});

parcelRegister("iTlrx", function(module, exports) {

var $k03DT = parcelRequire("k03DT");

var $gDi05 = parcelRequire("gDi05");

var $3OBjY = parcelRequire("3OBjY");

var $x3Zfx = parcelRequire("x3Zfx");
const $dc0dff3d6fb2d8fe$export$2b789d827caebed0 = (region, { useFipsEndpoint: useFipsEndpoint = false, useDualstackEndpoint: useDualstackEndpoint = false, signingService: signingService, regionHash: regionHash, partitionHash: partitionHash })=>{
    const partition = (0, $3OBjY.getResolvedPartition)(region, {
        partitionHash: partitionHash
    });
    const resolvedRegion = region in regionHash ? region : partitionHash[partition]?.endpoint ?? region;
    const hostnameOptions = {
        useFipsEndpoint: useFipsEndpoint,
        useDualstackEndpoint: useDualstackEndpoint
    };
    const regionHostname = (0, $k03DT.getHostnameFromVariants)(regionHash[resolvedRegion]?.variants, hostnameOptions);
    const partitionHostname = (0, $k03DT.getHostnameFromVariants)(partitionHash[partition]?.variants, hostnameOptions);
    const hostname = (0, $gDi05.getResolvedHostname)(resolvedRegion, {
        regionHostname: regionHostname,
        partitionHostname: partitionHostname
    });
    if (hostname === undefined) throw new Error(`Endpoint resolution failed for: ${{
        resolvedRegion: resolvedRegion,
        useFipsEndpoint: useFipsEndpoint,
        useDualstackEndpoint: useDualstackEndpoint
    }}`);
    const signingRegion = (0, $x3Zfx.getResolvedSigningRegion)(hostname, {
        signingRegion: regionHash[resolvedRegion]?.signingRegion,
        regionRegex: partitionHash[partition].regionRegex,
        useFipsEndpoint: useFipsEndpoint
    });
    return {
        partition: partition,
        signingService: signingService,
        hostname: hostname,
        ...signingRegion && {
            signingRegion: signingRegion
        },
        ...regionHash[resolvedRegion]?.signingService && {
            signingService: regionHash[resolvedRegion].signingService
        }
    };
};

});
parcelRegister("k03DT", function(module, exports) {

$parcel$export(module.exports, "getHostnameFromVariants", () => $e8f6a20d5f90df27$export$75494cb913bf7ef6);
const $e8f6a20d5f90df27$export$75494cb913bf7ef6 = (variants = [], { useFipsEndpoint: useFipsEndpoint, useDualstackEndpoint: useDualstackEndpoint })=>variants.find(({ tags: tags })=>useFipsEndpoint === tags.includes("fips") && useDualstackEndpoint === tags.includes("dualstack"))?.hostname;

});

parcelRegister("gDi05", function(module, exports) {

$parcel$export(module.exports, "getResolvedHostname", () => $c1be405fbaba8a91$export$d062b2a57a5d579b);
const $c1be405fbaba8a91$export$d062b2a57a5d579b = (resolvedRegion, { regionHostname: regionHostname, partitionHostname: partitionHostname })=>regionHostname ? regionHostname : partitionHostname ? partitionHostname.replace("{region}", resolvedRegion) : undefined;

});

parcelRegister("3OBjY", function(module, exports) {

$parcel$export(module.exports, "getResolvedPartition", () => $2c72fdd09fdc5b59$export$2ba1c8e181ae49f8);
const $2c72fdd09fdc5b59$export$2ba1c8e181ae49f8 = (region, { partitionHash: partitionHash })=>Object.keys(partitionHash || {}).find((key)=>partitionHash[key].regions.includes(region)) ?? "aws";

});

parcelRegister("x3Zfx", function(module, exports) {

$parcel$export(module.exports, "getResolvedSigningRegion", () => $06362ce5a51d09a9$export$be75b39beeb48b5c);
const $06362ce5a51d09a9$export$be75b39beeb48b5c = (hostname, { signingRegion: signingRegion, regionRegex: regionRegex, useFipsEndpoint: useFipsEndpoint })=>{
    if (signingRegion) return signingRegion;
    else if (useFipsEndpoint) {
        const regionRegexJs = regionRegex.replace("\\\\", "\\").replace(/^\^/g, "\\.").replace(/\$$/g, "\\.");
        const regionRegexmatchArray = hostname.match(regionRegexJs);
        if (regionRegexmatchArray) return regionRegexmatchArray[0].slice(1, -1);
    }
};

});




parcelRegister("21756", function(module, exports) {
$parcel$export(module.exports, "getHttpAuthSchemeEndpointRuleSetPlugin", () => (parcelRequire("eGqnu")).getHttpAuthSchemeEndpointRuleSetPlugin);
$parcel$export(module.exports, "getHttpSigningPlugin", () => (parcelRequire("hshmJ")).getHttpSigningPlugin);
$parcel$export(module.exports, "DefaultIdentityProviderConfig", () => (parcelRequire("9iah1")).DefaultIdentityProviderConfig);
$parcel$export(module.exports, "doesIdentityRequireRefresh", () => (parcelRequire("9gMMV")).doesIdentityRequireRefresh);
$parcel$export(module.exports, "isIdentityExpired", () => (parcelRequire("9gMMV")).isIdentityExpired);
$parcel$export(module.exports, "memoizeIdentityProvider", () => (parcelRequire("9gMMV")).memoizeIdentityProvider);
$parcel$export(module.exports, "NoAuthSigner", () => (parcelRequire("9atsw")).NoAuthSigner);
$parcel$export(module.exports, "normalizeProvider", () => (parcelRequire("g5Jyl")).normalizeProvider);
$parcel$export(module.exports, "requestBuilder", () => (parcelRequire("ld8GT")).requestBuilder);
parcelRequire("4q98K");
parcelRequire("6z3Ch");
parcelRequire("B5asE");
parcelRequire("keJph");
parcelRequire("g5Jyl");
parcelRequire("ld8GT");

var $3Ib1X = parcelRequire("3Ib1X");

});
parcelRegister("4q98K", function(module, exports) {
$parcel$export(module.exports, "getHttpAuthSchemeEndpointRuleSetPlugin", () => (parcelRequire("eGqnu")).getHttpAuthSchemeEndpointRuleSetPlugin);
parcelRequire("jQvwo");
parcelRequire("eGqnu");
parcelRequire("iDQj8");

});
parcelRegister("jQvwo", function(module, exports) {

$parcel$export(module.exports, "httpAuthSchemeMiddleware", () => $03ba81575c310c35$export$681dcf755d3830d0);
parcelRequire("8t4sF");
parcelRequire("e2ELD");
var $3eYQu = parcelRequire("3eYQu");
function $03ba81575c310c35$var$convertHttpAuthSchemesToMap(httpAuthSchemes) {
    const map = new Map();
    for (const scheme of httpAuthSchemes)map.set(scheme.schemeId, scheme);
    return map;
}
const $03ba81575c310c35$export$681dcf755d3830d0 = (config, mwOptions)=>(next, context)=>async (args)=>{
            const options = config.httpAuthSchemeProvider(await mwOptions.httpAuthSchemeParametersProvider(config, context, args.input));
            const authSchemes = $03ba81575c310c35$var$convertHttpAuthSchemesToMap(config.httpAuthSchemes);
            const smithyContext = (0, $3eYQu.getSmithyContext)(context);
            const failureReasons = [];
            for (const option of options){
                const scheme = authSchemes.get(option.schemeId);
                if (!scheme) {
                    failureReasons.push(`HttpAuthScheme \`${option.schemeId}\` was not enabled for this service.`);
                    continue;
                }
                const identityProvider = scheme.identityProvider(await mwOptions.identityProviderConfigProvider(config));
                if (!identityProvider) {
                    failureReasons.push(`HttpAuthScheme \`${option.schemeId}\` did not have an IdentityProvider configured.`);
                    continue;
                }
                const { identityProperties: identityProperties = {}, signingProperties: signingProperties = {} } = option.propertiesExtractor?.(config, context) || {};
                option.identityProperties = Object.assign(option.identityProperties || {}, identityProperties);
                option.signingProperties = Object.assign(option.signingProperties || {}, signingProperties);
                smithyContext.selectedHttpAuthScheme = {
                    httpAuthOption: option,
                    identity: await identityProvider(option.identityProperties),
                    signer: scheme.signer
                };
                break;
            }
            if (!smithyContext.selectedHttpAuthScheme) throw new Error(failureReasons.join("\n"));
            return next(args);
        };

});

parcelRegister("eGqnu", function(module, exports) {

$parcel$export(module.exports, "getHttpAuthSchemeEndpointRuleSetPlugin", () => $ab097301893950e9$export$6ababc1a6356ca41);
parcelRequire("f1nrT");
var $iHLqk = parcelRequire("iHLqk");

var $jQvwo = parcelRequire("jQvwo");
const $ab097301893950e9$export$8c136d4eb4815c3e = {
    step: "serialize",
    tags: [
        "HTTP_AUTH_SCHEME"
    ],
    name: "httpAuthSchemeMiddleware",
    override: true,
    relation: "before",
    toMiddleware: (0, $iHLqk.endpointMiddlewareOptions).name
};
const $ab097301893950e9$export$6ababc1a6356ca41 = (config, { httpAuthSchemeParametersProvider: httpAuthSchemeParametersProvider, identityProviderConfigProvider: identityProviderConfigProvider })=>({
        applyToStack: (clientStack)=>{
            clientStack.addRelativeTo((0, $jQvwo.httpAuthSchemeMiddleware)(config, {
                httpAuthSchemeParametersProvider: httpAuthSchemeParametersProvider,
                identityProviderConfigProvider: identityProviderConfigProvider
            }), $ab097301893950e9$export$8c136d4eb4815c3e);
        }
    });

});
parcelRegister("f1nrT", function(module, exports) {
$parcel$export(module.exports, "endpointMiddlewareOptions", () => (parcelRequire("iHLqk")).endpointMiddlewareOptions);
$parcel$export(module.exports, "getEndpointPlugin", () => (parcelRequire("iHLqk")).getEndpointPlugin);
$parcel$export(module.exports, "resolveEndpointConfig", () => (parcelRequire("7vygy")).resolveEndpointConfig);
parcelRequire("8rTzs");
parcelRequire("4JJOK");
parcelRequire("iHLqk");
parcelRequire("7vygy");
parcelRequire("39juE");

});
parcelRegister("8rTzs", function(module, exports) {
parcelRequire("eeMFI");
parcelRequire("dskhG");

});
parcelRegister("eeMFI", function(module, exports) {

$parcel$export(module.exports, "getEndpointFromInstructions", () => $a5d820b09b4d532e$export$deed4544608f82ff);
parcelRequire("9MdBC");
var $g5YR3 = parcelRequire("g5YR3");

var $bOOWM = parcelRequire("bOOWM");

var $iIdSV = parcelRequire("iIdSV");

var $dskhG = parcelRequire("dskhG");
const $a5d820b09b4d532e$export$deed4544608f82ff = async (commandInput, instructionsSupplier, clientConfig, context)=>{
    if (!clientConfig.endpoint) {
        const endpointFromConfig = await (0, $iIdSV.getEndpointFromConfig)(clientConfig.serviceId || "");
        if (endpointFromConfig) clientConfig.endpoint = ()=>Promise.resolve((0, $dskhG.toEndpointV1)(endpointFromConfig));
    }
    const endpointParams = await $a5d820b09b4d532e$export$a4c001b14047c450(commandInput, instructionsSupplier, clientConfig);
    if (typeof clientConfig.endpointProvider !== "function") throw new Error("config.endpointProvider is not set.");
    const endpoint = clientConfig.endpointProvider(endpointParams, context);
    return endpoint;
};
const $a5d820b09b4d532e$export$a4c001b14047c450 = async (commandInput, instructionsSupplier, clientConfig)=>{
    const endpointParams = {};
    const instructions = instructionsSupplier?.getEndpointParameterInstructions?.() || {};
    for (const [name, instruction] of Object.entries(instructions))switch(instruction.type){
        case "staticContextParams":
            endpointParams[name] = instruction.value;
            break;
        case "contextParams":
            endpointParams[name] = commandInput[instruction.name];
            break;
        case "clientContextParams":
        case "builtInParams":
            endpointParams[name] = await (0, $bOOWM.createConfigValueProvider)(instruction.name, name, clientConfig)();
            break;
        default:
            throw new Error("Unrecognized endpoint parameter instruction: " + JSON.stringify(instruction));
    }
    if (Object.keys(instructions).length === 0) Object.assign(endpointParams, clientConfig);
    if (String(clientConfig.serviceId).toLowerCase() === "s3") await (0, $g5YR3.resolveParamsForS3)(endpointParams);
    return endpointParams;
};

});
parcelRegister("9MdBC", function(module, exports) {
$parcel$export(module.exports, "resolveParamsForS3", () => (parcelRequire("g5YR3")).resolveParamsForS3);
parcelRequire("g5YR3");

});
parcelRegister("g5YR3", function(module, exports) {

$parcel$export(module.exports, "resolveParamsForS3", () => $bb7c5177f2c0c53f$export$972ee8f9276654f0);
const $bb7c5177f2c0c53f$export$972ee8f9276654f0 = async (endpointParams)=>{
    const bucket = endpointParams?.Bucket || "";
    if (typeof endpointParams.Bucket === "string") endpointParams.Bucket = bucket.replace(/#/g, encodeURIComponent("#")).replace(/\?/g, encodeURIComponent("?"));
    if ($bb7c5177f2c0c53f$export$fe7fec9fee338b98(bucket)) {
        if (endpointParams.ForcePathStyle === true) throw new Error("Path-style addressing cannot be used with ARN buckets");
    } else if (!$bb7c5177f2c0c53f$export$360a1e07839d0d27(bucket) || bucket.indexOf(".") !== -1 && !String(endpointParams.Endpoint).startsWith("http:") || bucket.toLowerCase() !== bucket || bucket.length < 3) endpointParams.ForcePathStyle = true;
    if (endpointParams.DisableMultiRegionAccessPoints) {
        endpointParams.disableMultiRegionAccessPoints = true;
        endpointParams.DisableMRAP = true;
    }
    return endpointParams;
};
const $bb7c5177f2c0c53f$var$DOMAIN_PATTERN = /^[a-z0-9][a-z0-9\.\-]{1,61}[a-z0-9]$/;
const $bb7c5177f2c0c53f$var$IP_ADDRESS_PATTERN = /(\d+\.){3}\d+/;
const $bb7c5177f2c0c53f$var$DOTS_PATTERN = /\.\./;
const $bb7c5177f2c0c53f$export$b0b24e5455be29b0 = /\./;
const $bb7c5177f2c0c53f$export$43f53815580748f = /^(.+\.)?s3(-fips)?(\.dualstack)?[.-]([a-z0-9-]+)\./;
const $bb7c5177f2c0c53f$export$360a1e07839d0d27 = (bucketName)=>$bb7c5177f2c0c53f$var$DOMAIN_PATTERN.test(bucketName) && !$bb7c5177f2c0c53f$var$IP_ADDRESS_PATTERN.test(bucketName) && !$bb7c5177f2c0c53f$var$DOTS_PATTERN.test(bucketName);
const $bb7c5177f2c0c53f$export$fe7fec9fee338b98 = (bucketName)=>{
    const [arn, partition, service, region, account, typeOrId] = bucketName.split(":");
    const isArn = arn === "arn" && bucketName.split(":").length >= 6;
    const isValidArn = [
        arn,
        partition,
        service,
        account,
        typeOrId
    ].filter(Boolean).length === 5;
    if (isArn && !isValidArn) throw new Error(`Invalid ARN: ${bucketName} was an invalid ARN.`);
    return arn === "arn" && !!partition && !!service && !!account && !!typeOrId;
};

});


parcelRegister("bOOWM", function(module, exports) {

$parcel$export(module.exports, "createConfigValueProvider", () => $89abe23f89e1cde7$export$47243fd4b8e52f1e);
const $89abe23f89e1cde7$export$47243fd4b8e52f1e = (configKey, canonicalEndpointParamKey, config)=>{
    const configProvider = async ()=>{
        const configValue = config[configKey] ?? config[canonicalEndpointParamKey];
        if (typeof configValue === "function") return configValue();
        return configValue;
    };
    if (configKey === "credentialScope" || canonicalEndpointParamKey === "CredentialScope") return async ()=>{
        const credentials = typeof config.credentials === "function" ? await config.credentials() : config.credentials;
        const configValue = credentials?.credentialScope ?? credentials?.CredentialScope;
        return configValue;
    };
    if (configKey === "endpoint" || canonicalEndpointParamKey === "endpoint") return async ()=>{
        const endpoint = await configProvider();
        if (endpoint && typeof endpoint === "object") {
            if ("url" in endpoint) return endpoint.url.href;
            if ("hostname" in endpoint) {
                const { protocol: protocol, hostname: hostname, port: port, path: path } = endpoint;
                return `${protocol}//${hostname}${port ? ":" + port : ""}${path}`;
            }
        }
        return endpoint;
    };
    return configProvider;
};

});

parcelRegister("iIdSV", function(module, exports) {

$parcel$export(module.exports, "getEndpointFromConfig", () => $d9f71b4c7e48a0a6$export$8a5041d6190772fe);
const $d9f71b4c7e48a0a6$export$8a5041d6190772fe = async (serviceId)=>undefined;

});

parcelRegister("dskhG", function(module, exports) {

$parcel$export(module.exports, "toEndpointV1", () => $9cbd9fe3592994fc$export$32d52e935fceeb99);

var $kOVEw = parcelRequire("kOVEw");
const $9cbd9fe3592994fc$export$32d52e935fceeb99 = (endpoint)=>{
    if (typeof endpoint === "object") {
        if ("url" in endpoint) return (0, $kOVEw.parseUrl)(endpoint.url);
        return endpoint;
    }
    return (0, $kOVEw.parseUrl)(endpoint);
};

});
parcelRegister("kOVEw", function(module, exports) {

$parcel$export(module.exports, "parseUrl", () => $f28532c12623ce1f$export$7a5253c0f62e0150);

var $8Y72X = parcelRequire("8Y72X");
const $f28532c12623ce1f$export$7a5253c0f62e0150 = (url)=>{
    if (typeof url === "string") return $f28532c12623ce1f$export$7a5253c0f62e0150(new URL(url));
    const { hostname: hostname, pathname: pathname, port: port, protocol: protocol, search: search } = url;
    let query;
    if (search) query = (0, $8Y72X.parseQueryString)(search);
    return {
        hostname: hostname,
        port: port ? parseInt(port) : undefined,
        protocol: protocol,
        path: pathname,
        query: query
    };
};

});
parcelRegister("8Y72X", function(module, exports) {

$parcel$export(module.exports, "parseQueryString", () => $687964abaa25ddf2$export$66256f83798e5415);
function $687964abaa25ddf2$export$66256f83798e5415(querystring) {
    const query = {};
    querystring = querystring.replace(/^\?/, "");
    if (querystring) for (const pair of querystring.split("&")){
        let [key, value = null] = pair.split("=");
        key = decodeURIComponent(key);
        if (value) value = decodeURIComponent(value);
        if (!(key in query)) query[key] = value;
        else if (Array.isArray(query[key])) query[key].push(value);
        else query[key] = [
            query[key],
            value
        ];
    }
    return query;
}

});





parcelRegister("4JJOK", function(module, exports) {

$parcel$export(module.exports, "endpointMiddleware", () => $372ee7c88bf833c6$export$aa1c2d132a457833);
parcelRequire("e2ELD");
var $3eYQu = parcelRequire("3eYQu");

var $eeMFI = parcelRequire("eeMFI");
const $372ee7c88bf833c6$export$aa1c2d132a457833 = ({ config: config, instructions: instructions })=>{
    return (next, context)=>async (args)=>{
            const endpoint = await (0, $eeMFI.getEndpointFromInstructions)(args.input, {
                getEndpointParameterInstructions () {
                    return instructions;
                }
            }, {
                ...config
            }, context);
            context.endpointV2 = endpoint;
            context.authSchemes = endpoint.properties?.authSchemes;
            const authScheme = context.authSchemes?.[0];
            if (authScheme) {
                context["signing_region"] = authScheme.signingRegion;
                context["signing_service"] = authScheme.signingName;
                const smithyContext = (0, $3eYQu.getSmithyContext)(context);
                const httpAuthOption = smithyContext?.selectedHttpAuthScheme?.httpAuthOption;
                if (httpAuthOption) httpAuthOption.signingProperties = Object.assign(httpAuthOption.signingProperties || {}, {
                    signing_region: authScheme.signingRegion,
                    signingRegion: authScheme.signingRegion,
                    signing_service: authScheme.signingName,
                    signingName: authScheme.signingName,
                    signingRegionSet: authScheme.signingRegionSet
                }, authScheme.properties);
            }
            return next({
                ...args
            });
        };
};

});

parcelRegister("iHLqk", function(module, exports) {

$parcel$export(module.exports, "endpointMiddlewareOptions", () => $d9e10785359bfb38$export$1e040b8d263b920b);
$parcel$export(module.exports, "getEndpointPlugin", () => $d9e10785359bfb38$export$946c80457b765eab);
parcelRequire("bXwma");
var $KxEGr = parcelRequire("KxEGr");

var $4JJOK = parcelRequire("4JJOK");
const $d9e10785359bfb38$export$1e040b8d263b920b = {
    step: "serialize",
    tags: [
        "ENDPOINT_PARAMETERS",
        "ENDPOINT_V2",
        "ENDPOINT"
    ],
    name: "endpointV2Middleware",
    override: true,
    relation: "before",
    toMiddleware: (0, $KxEGr.serializerMiddlewareOption).name
};
const $d9e10785359bfb38$export$946c80457b765eab = (config, instructions)=>({
        applyToStack: (clientStack)=>{
            clientStack.addRelativeTo((0, $4JJOK.endpointMiddleware)({
                config: config,
                instructions: instructions
            }), $d9e10785359bfb38$export$1e040b8d263b920b);
        }
    });

});
parcelRegister("bXwma", function(module, exports) {
$parcel$export(module.exports, "getSerdePlugin", () => (parcelRequire("KxEGr")).getSerdePlugin);
$parcel$export(module.exports, "serializerMiddlewareOption", () => (parcelRequire("KxEGr")).serializerMiddlewareOption);
parcelRequire("fPXCc");
parcelRequire("KxEGr");
parcelRequire("2GEZk");

});
parcelRegister("fPXCc", function(module, exports) {

$parcel$export(module.exports, "deserializerMiddleware", () => $b879dcc2dc51d3a2$export$d10196e291075f95);
const $b879dcc2dc51d3a2$export$d10196e291075f95 = (options, deserializer)=>(next, context)=>async (args)=>{
            const { response: response } = await next(args);
            try {
                const parsed = await deserializer(response, options);
                return {
                    response: response,
                    output: parsed
                };
            } catch (error) {
                Object.defineProperty(error, "$response", {
                    value: response
                });
                if (!("$metadata" in error)) {
                    const hint = `Deserialization error: to see the raw response, inspect the hidden field {error}.$response on this object.`;
                    error.message += "\n  " + hint;
                    if (typeof error.$responseBodyText !== "undefined") {
                        if (error.$response) error.$response.body = error.$responseBodyText;
                    }
                }
                throw error;
            }
        };

});

parcelRegister("KxEGr", function(module, exports) {

$parcel$export(module.exports, "serializerMiddlewareOption", () => $08be67362e3b4e9a$export$1bd449976e9c484d);
$parcel$export(module.exports, "getSerdePlugin", () => $08be67362e3b4e9a$export$53fdc69654553fd4);

var $fPXCc = parcelRequire("fPXCc");

var $2GEZk = parcelRequire("2GEZk");
const $08be67362e3b4e9a$export$f5d82b333b4f39c9 = {
    name: "deserializerMiddleware",
    step: "deserialize",
    tags: [
        "DESERIALIZER"
    ],
    override: true
};
const $08be67362e3b4e9a$export$1bd449976e9c484d = {
    name: "serializerMiddleware",
    step: "serialize",
    tags: [
        "SERIALIZER"
    ],
    override: true
};
function $08be67362e3b4e9a$export$53fdc69654553fd4(config, serializer, deserializer) {
    return {
        applyToStack: (commandStack)=>{
            commandStack.add((0, $fPXCc.deserializerMiddleware)(config, deserializer), $08be67362e3b4e9a$export$f5d82b333b4f39c9);
            commandStack.add((0, $2GEZk.serializerMiddleware)(config, serializer), $08be67362e3b4e9a$export$1bd449976e9c484d);
        }
    };
}

});
parcelRegister("2GEZk", function(module, exports) {

$parcel$export(module.exports, "serializerMiddleware", () => $1f4f4c634356fb28$export$125a23d36094c5de);
const $1f4f4c634356fb28$export$125a23d36094c5de = (options, serializer)=>(next, context)=>async (args)=>{
            const endpoint = context.endpointV2?.url && options.urlParser ? async ()=>options.urlParser(context.endpointV2.url) : options.endpoint;
            if (!endpoint) throw new Error("No valid endpoint provider available.");
            const request = await serializer(args.input, {
                ...options,
                endpoint: endpoint
            });
            return next({
                ...args,
                request: request
            });
        };

});




parcelRegister("7vygy", function(module, exports) {

$parcel$export(module.exports, "resolveEndpointConfig", () => $5776022dc7317e7b$export$8c5b66831e3f26ff);
parcelRequire("e2ELD");
var $j5KxT = parcelRequire("j5KxT");

var $dskhG = parcelRequire("dskhG");
const $5776022dc7317e7b$export$8c5b66831e3f26ff = (input)=>{
    const tls = input.tls ?? true;
    const { endpoint: endpoint } = input;
    const customEndpointProvider = endpoint != null ? async ()=>(0, $dskhG.toEndpointV1)(await (0, $j5KxT.normalizeProvider)(endpoint)()) : undefined;
    const isCustomEndpoint = !!endpoint;
    return {
        ...input,
        endpoint: customEndpointProvider,
        tls: tls,
        isCustomEndpoint: isCustomEndpoint,
        useDualstackEndpoint: (0, $j5KxT.normalizeProvider)(input.useDualstackEndpoint ?? false),
        useFipsEndpoint: (0, $j5KxT.normalizeProvider)(input.useFipsEndpoint ?? false)
    };
};

});

parcelRegister("39juE", function(module, exports) {

});



parcelRegister("iDQj8", function(module, exports) {
parcelRequire("bXwma");
var $KxEGr = parcelRequire("KxEGr");

var $jQvwo = parcelRequire("jQvwo");
const $d92471b81f9a3574$export$11cd3870e3f87892 = {
    step: "serialize",
    tags: [
        "HTTP_AUTH_SCHEME"
    ],
    name: "httpAuthSchemeMiddleware",
    override: true,
    relation: "before",
    toMiddleware: (0, $KxEGr.serializerMiddlewareOption).name
};
const $d92471b81f9a3574$export$ac2af07429c3a20e = (config, { httpAuthSchemeParametersProvider: httpAuthSchemeParametersProvider, identityProviderConfigProvider: identityProviderConfigProvider })=>({
        applyToStack: (clientStack)=>{
            clientStack.addRelativeTo((0, $jQvwo.httpAuthSchemeMiddleware)(config, {
                httpAuthSchemeParametersProvider: httpAuthSchemeParametersProvider,
                identityProviderConfigProvider: identityProviderConfigProvider
            }), $d92471b81f9a3574$export$11cd3870e3f87892);
        }
    });

});


parcelRegister("6z3Ch", function(module, exports) {
$parcel$export(module.exports, "getHttpSigningPlugin", () => (parcelRequire("hshmJ")).getHttpSigningPlugin);
parcelRequire("bFHZm");
parcelRequire("hshmJ");

});
parcelRegister("bFHZm", function(module, exports) {

$parcel$export(module.exports, "httpSigningMiddleware", () => $87f5a5420fbe2f4c$export$fe39ed571a606f80);
parcelRequire("AueTL");
var $Yl5TU = parcelRequire("Yl5TU");
parcelRequire("8t4sF");
parcelRequire("e2ELD");
var $3eYQu = parcelRequire("3eYQu");
const $87f5a5420fbe2f4c$var$defaultErrorHandler = (signingProperties)=>(error)=>{
        throw error;
    };
const $87f5a5420fbe2f4c$var$defaultSuccessHandler = (httpResponse, signingProperties)=>{};
const $87f5a5420fbe2f4c$export$fe39ed571a606f80 = (config)=>(next, context)=>async (args)=>{
            if (!(0, $Yl5TU.HttpRequest).isInstance(args.request)) return next(args);
            const smithyContext = (0, $3eYQu.getSmithyContext)(context);
            const scheme = smithyContext.selectedHttpAuthScheme;
            if (!scheme) throw new Error(`No HttpAuthScheme was selected: unable to sign request`);
            const { httpAuthOption: { signingProperties: signingProperties = {} }, identity: identity, signer: signer } = scheme;
            const output = await next({
                ...args,
                request: await signer.sign(args.request, identity, signingProperties)
            }).catch((signer.errorHandler || $87f5a5420fbe2f4c$var$defaultErrorHandler)(signingProperties));
            (signer.successHandler || $87f5a5420fbe2f4c$var$defaultSuccessHandler)(output.response, signingProperties);
            return output;
        };

});

parcelRegister("hshmJ", function(module, exports) {

$parcel$export(module.exports, "getHttpSigningPlugin", () => $cb5285a5db560e20$export$ed476aa7e410a);
parcelRequire("ggI4s");
var $6Httz = parcelRequire("6Httz");

var $bFHZm = parcelRequire("bFHZm");
const $cb5285a5db560e20$export$dce1f72b9e752c12 = {
    step: "finalizeRequest",
    tags: [
        "HTTP_SIGNING"
    ],
    name: "httpSigningMiddleware",
    aliases: [
        "apiKeyMiddleware",
        "tokenMiddleware",
        "awsAuthMiddleware"
    ],
    override: true,
    relation: "after",
    toMiddleware: (0, $6Httz.retryMiddlewareOptions).name
};
const $cb5285a5db560e20$export$ed476aa7e410a = (config)=>({
        applyToStack: (clientStack)=>{
            clientStack.addRelativeTo((0, $bFHZm.httpSigningMiddleware)(config), $cb5285a5db560e20$export$dce1f72b9e752c12);
        }
    });

});
parcelRegister("ggI4s", function(module, exports) {
$parcel$export(module.exports, "resolveRetryConfig", () => (parcelRequire("66f0Z")).resolveRetryConfig);
$parcel$export(module.exports, "getRetryPlugin", () => (parcelRequire("6Httz")).getRetryPlugin);
$parcel$export(module.exports, "retryMiddlewareOptions", () => (parcelRequire("6Httz")).retryMiddlewareOptions);
parcelRequire("5Yrrz");
parcelRequire("4Mvr5");
parcelRequire("66f0Z");
parcelRequire("2JUAt");
parcelRequire("juP97");
parcelRequire("leJLz");
parcelRequire("6Httz");

});
parcelRegister("5Yrrz", function(module, exports) {
parcelRequire("dysC5");
var $dZQSX = parcelRequire("dZQSX");
var $blSB9 = parcelRequire("blSB9");

var $4Mvr5 = parcelRequire("4Mvr5");
class $4597d813545145b1$export$b6f3faf7501de8bc extends (0, $4Mvr5.StandardRetryStrategy) {
    constructor(maxAttemptsProvider, options){
        const { rateLimiter: rateLimiter, ...superOptions } = options ?? {};
        super(maxAttemptsProvider, superOptions);
        this.rateLimiter = rateLimiter ?? new (0, $dZQSX.DefaultRateLimiter)();
        this.mode = (0, $blSB9.RETRY_MODES).ADAPTIVE;
    }
    async retry(next, args) {
        return super.retry(next, args, {
            beforeRequest: async ()=>{
                return this.rateLimiter.getSendToken();
            },
            afterRequest: (response)=>{
                this.rateLimiter.updateClientSendingRate(response);
            }
        });
    }
}

});
parcelRegister("dysC5", function(module, exports) {
$parcel$export(module.exports, "AdaptiveRetryStrategy", () => (parcelRequire("g4D1u")).AdaptiveRetryStrategy);
$parcel$export(module.exports, "DefaultRateLimiter", () => (parcelRequire("dZQSX")).DefaultRateLimiter);
$parcel$export(module.exports, "StandardRetryStrategy", () => (parcelRequire("97cmp")).StandardRetryStrategy);
$parcel$export(module.exports, "DEFAULT_MAX_ATTEMPTS", () => (parcelRequire("blSB9")).DEFAULT_MAX_ATTEMPTS);
$parcel$export(module.exports, "DEFAULT_RETRY_MODE", () => (parcelRequire("blSB9")).DEFAULT_RETRY_MODE);
$parcel$export(module.exports, "RETRY_MODES", () => (parcelRequire("blSB9")).RETRY_MODES);
$parcel$export(module.exports, "DEFAULT_RETRY_DELAY_BASE", () => (parcelRequire("8X8U9")).DEFAULT_RETRY_DELAY_BASE);
$parcel$export(module.exports, "INITIAL_RETRY_TOKENS", () => (parcelRequire("8X8U9")).INITIAL_RETRY_TOKENS);
$parcel$export(module.exports, "INVOCATION_ID_HEADER", () => (parcelRequire("8X8U9")).INVOCATION_ID_HEADER);
$parcel$export(module.exports, "MAXIMUM_RETRY_DELAY", () => (parcelRequire("8X8U9")).MAXIMUM_RETRY_DELAY);
$parcel$export(module.exports, "NO_RETRY_INCREMENT", () => (parcelRequire("8X8U9")).NO_RETRY_INCREMENT);
$parcel$export(module.exports, "REQUEST_HEADER", () => (parcelRequire("8X8U9")).REQUEST_HEADER);
$parcel$export(module.exports, "RETRY_COST", () => (parcelRequire("8X8U9")).RETRY_COST);
$parcel$export(module.exports, "THROTTLING_RETRY_DELAY_BASE", () => (parcelRequire("8X8U9")).THROTTLING_RETRY_DELAY_BASE);
$parcel$export(module.exports, "TIMEOUT_RETRY_COST", () => (parcelRequire("8X8U9")).TIMEOUT_RETRY_COST);
parcelRequire("g4D1u");
parcelRequire("kdCtX");
parcelRequire("dZQSX");
parcelRequire("97cmp");
parcelRequire("blSB9");
parcelRequire("8X8U9");
parcelRequire("2Lovs");

});
parcelRegister("g4D1u", function(module, exports) {

$parcel$export(module.exports, "AdaptiveRetryStrategy", () => $bb3b4a38645c0f24$export$b6f3faf7501de8bc);

var $blSB9 = parcelRequire("blSB9");

var $dZQSX = parcelRequire("dZQSX");

var $97cmp = parcelRequire("97cmp");
class $bb3b4a38645c0f24$export$b6f3faf7501de8bc {
    constructor(maxAttemptsProvider, options){
        this.maxAttemptsProvider = maxAttemptsProvider;
        this.mode = (0, $blSB9.RETRY_MODES).ADAPTIVE;
        const { rateLimiter: rateLimiter } = options ?? {};
        this.rateLimiter = rateLimiter ?? new (0, $dZQSX.DefaultRateLimiter)();
        this.standardRetryStrategy = new (0, $97cmp.StandardRetryStrategy)(maxAttemptsProvider);
    }
    async acquireInitialRetryToken(retryTokenScope) {
        await this.rateLimiter.getSendToken();
        return this.standardRetryStrategy.acquireInitialRetryToken(retryTokenScope);
    }
    async refreshRetryTokenForRetry(tokenToRenew, errorInfo) {
        this.rateLimiter.updateClientSendingRate(errorInfo);
        return this.standardRetryStrategy.refreshRetryTokenForRetry(tokenToRenew, errorInfo);
    }
    recordSuccess(token) {
        this.rateLimiter.updateClientSendingRate({});
        this.standardRetryStrategy.recordSuccess(token);
    }
}

});
parcelRegister("blSB9", function(module, exports) {

$parcel$export(module.exports, "RETRY_MODES", () => $843c01ef65527460$export$6842199fccd474d3);
$parcel$export(module.exports, "DEFAULT_MAX_ATTEMPTS", () => $843c01ef65527460$export$2c7e51f38ba5a406);
$parcel$export(module.exports, "DEFAULT_RETRY_MODE", () => $843c01ef65527460$export$41315747b7c5d042);
var $843c01ef65527460$export$6842199fccd474d3;
(function(RETRY_MODES) {
    RETRY_MODES["STANDARD"] = "standard";
    RETRY_MODES["ADAPTIVE"] = "adaptive";
})($843c01ef65527460$export$6842199fccd474d3 || ($843c01ef65527460$export$6842199fccd474d3 = {}));
const $843c01ef65527460$export$2c7e51f38ba5a406 = 3;
const $843c01ef65527460$export$41315747b7c5d042 = $843c01ef65527460$export$6842199fccd474d3.STANDARD;

});

parcelRegister("dZQSX", function(module, exports) {

$parcel$export(module.exports, "DefaultRateLimiter", () => $a309feca09638eb6$export$4d4bb1390e4746c4);

var $bj4DA = parcelRequire("bj4DA");
class $a309feca09638eb6$export$4d4bb1390e4746c4 {
    constructor(options){
        this.currentCapacity = 0;
        this.enabled = false;
        this.lastMaxRate = 0;
        this.measuredTxRate = 0;
        this.requestCount = 0;
        this.lastTimestamp = 0;
        this.timeWindow = 0;
        this.beta = options?.beta ?? 0.7;
        this.minCapacity = options?.minCapacity ?? 1;
        this.minFillRate = options?.minFillRate ?? 0.5;
        this.scaleConstant = options?.scaleConstant ?? 0.4;
        this.smooth = options?.smooth ?? 0.8;
        const currentTimeInSeconds = this.getCurrentTimeInSeconds();
        this.lastThrottleTime = currentTimeInSeconds;
        this.lastTxRateBucket = Math.floor(this.getCurrentTimeInSeconds());
        this.fillRate = this.minFillRate;
        this.maxCapacity = this.minCapacity;
    }
    getCurrentTimeInSeconds() {
        return Date.now() / 1000;
    }
    async getSendToken() {
        return this.acquireTokenBucket(1);
    }
    async acquireTokenBucket(amount) {
        if (!this.enabled) return;
        this.refillTokenBucket();
        if (amount > this.currentCapacity) {
            const delay = (amount - this.currentCapacity) / this.fillRate * 1000;
            await new Promise((resolve)=>setTimeout(resolve, delay));
        }
        this.currentCapacity = this.currentCapacity - amount;
    }
    refillTokenBucket() {
        const timestamp = this.getCurrentTimeInSeconds();
        if (!this.lastTimestamp) {
            this.lastTimestamp = timestamp;
            return;
        }
        const fillAmount = (timestamp - this.lastTimestamp) * this.fillRate;
        this.currentCapacity = Math.min(this.maxCapacity, this.currentCapacity + fillAmount);
        this.lastTimestamp = timestamp;
    }
    updateClientSendingRate(response) {
        let calculatedRate;
        this.updateMeasuredRate();
        if ((0, $bj4DA.isThrottlingError)(response)) {
            const rateToUse = !this.enabled ? this.measuredTxRate : Math.min(this.measuredTxRate, this.fillRate);
            this.lastMaxRate = rateToUse;
            this.calculateTimeWindow();
            this.lastThrottleTime = this.getCurrentTimeInSeconds();
            calculatedRate = this.cubicThrottle(rateToUse);
            this.enableTokenBucket();
        } else {
            this.calculateTimeWindow();
            calculatedRate = this.cubicSuccess(this.getCurrentTimeInSeconds());
        }
        const newRate = Math.min(calculatedRate, 2 * this.measuredTxRate);
        this.updateTokenBucketRate(newRate);
    }
    calculateTimeWindow() {
        this.timeWindow = this.getPrecise(Math.pow(this.lastMaxRate * (1 - this.beta) / this.scaleConstant, 1 / 3));
    }
    cubicThrottle(rateToUse) {
        return this.getPrecise(rateToUse * this.beta);
    }
    cubicSuccess(timestamp) {
        return this.getPrecise(this.scaleConstant * Math.pow(timestamp - this.lastThrottleTime - this.timeWindow, 3) + this.lastMaxRate);
    }
    enableTokenBucket() {
        this.enabled = true;
    }
    updateTokenBucketRate(newRate) {
        this.refillTokenBucket();
        this.fillRate = Math.max(newRate, this.minFillRate);
        this.maxCapacity = Math.max(newRate, this.minCapacity);
        this.currentCapacity = Math.min(this.currentCapacity, this.maxCapacity);
    }
    updateMeasuredRate() {
        const t = this.getCurrentTimeInSeconds();
        const timeBucket = Math.floor(t * 2) / 2;
        this.requestCount++;
        if (timeBucket > this.lastTxRateBucket) {
            const currentRate = this.requestCount / (timeBucket - this.lastTxRateBucket);
            this.measuredTxRate = this.getPrecise(currentRate * this.smooth + this.measuredTxRate * (1 - this.smooth));
            this.requestCount = 0;
            this.lastTxRateBucket = timeBucket;
        }
    }
    getPrecise(num) {
        return parseFloat(num.toFixed(8));
    }
}

});
parcelRegister("bj4DA", function(module, exports) {

$parcel$export(module.exports, "isRetryableByTrait", () => $83b510f78a7c1c0c$export$46428803f4bd8a0c);
$parcel$export(module.exports, "isClockSkewError", () => $83b510f78a7c1c0c$export$7b87435661177a94);
$parcel$export(module.exports, "isThrottlingError", () => $83b510f78a7c1c0c$export$cbecb89f6256ccc8);
$parcel$export(module.exports, "isTransientError", () => $83b510f78a7c1c0c$export$31778435da988512);
$parcel$export(module.exports, "isServerError", () => $83b510f78a7c1c0c$export$a7cbe72d7c4012af);

var $1GbtT = parcelRequire("1GbtT");
const $83b510f78a7c1c0c$export$46428803f4bd8a0c = (error)=>error.$retryable !== undefined;
const $83b510f78a7c1c0c$export$7b87435661177a94 = (error)=>(0, $1GbtT.CLOCK_SKEW_ERROR_CODES).includes(error.name);
const $83b510f78a7c1c0c$export$ca8501ea0db9a003 = (error)=>error.$metadata?.clockSkewCorrected;
const $83b510f78a7c1c0c$export$cbecb89f6256ccc8 = (error)=>error.$metadata?.httpStatusCode === 429 || (0, $1GbtT.THROTTLING_ERROR_CODES).includes(error.name) || error.$retryable?.throttling == true;
const $83b510f78a7c1c0c$export$31778435da988512 = (error)=>$83b510f78a7c1c0c$export$ca8501ea0db9a003(error) || (0, $1GbtT.TRANSIENT_ERROR_CODES).includes(error.name) || (0, $1GbtT.NODEJS_TIMEOUT_ERROR_CODES).includes(error?.code || "") || (0, $1GbtT.TRANSIENT_ERROR_STATUS_CODES).includes(error.$metadata?.httpStatusCode || 0);
const $83b510f78a7c1c0c$export$a7cbe72d7c4012af = (error)=>{
    if (error.$metadata?.httpStatusCode !== undefined) {
        const statusCode = error.$metadata.httpStatusCode;
        if (500 <= statusCode && statusCode <= 599 && !$83b510f78a7c1c0c$export$31778435da988512(error)) return true;
        return false;
    }
    return false;
};

});
parcelRegister("1GbtT", function(module, exports) {

$parcel$export(module.exports, "CLOCK_SKEW_ERROR_CODES", () => $13929e9f8decf817$export$9fde012b8b2a10ca);
$parcel$export(module.exports, "THROTTLING_ERROR_CODES", () => $13929e9f8decf817$export$89cd1b0ccfcb99d);
$parcel$export(module.exports, "TRANSIENT_ERROR_CODES", () => $13929e9f8decf817$export$18bd3bfe89ded398);
$parcel$export(module.exports, "TRANSIENT_ERROR_STATUS_CODES", () => $13929e9f8decf817$export$38bf589d26009e4f);
$parcel$export(module.exports, "NODEJS_TIMEOUT_ERROR_CODES", () => $13929e9f8decf817$export$e4f761fe9d74ce41);
const $13929e9f8decf817$export$9fde012b8b2a10ca = [
    "AuthFailure",
    "InvalidSignatureException",
    "RequestExpired",
    "RequestInTheFuture",
    "RequestTimeTooSkewed",
    "SignatureDoesNotMatch"
];
const $13929e9f8decf817$export$89cd1b0ccfcb99d = [
    "BandwidthLimitExceeded",
    "EC2ThrottledException",
    "LimitExceededException",
    "PriorRequestNotComplete",
    "ProvisionedThroughputExceededException",
    "RequestLimitExceeded",
    "RequestThrottled",
    "RequestThrottledException",
    "SlowDown",
    "ThrottledException",
    "Throttling",
    "ThrottlingException",
    "TooManyRequestsException",
    "TransactionInProgressException"
];
const $13929e9f8decf817$export$18bd3bfe89ded398 = [
    "TimeoutError",
    "RequestTimeout",
    "RequestTimeoutException"
];
const $13929e9f8decf817$export$38bf589d26009e4f = [
    500,
    502,
    503,
    504
];
const $13929e9f8decf817$export$e4f761fe9d74ce41 = [
    "ECONNRESET",
    "ECONNREFUSED",
    "EPIPE",
    "ETIMEDOUT"
];

});



parcelRegister("97cmp", function(module, exports) {

$parcel$export(module.exports, "StandardRetryStrategy", () => $6a2e5b038b4d707e$export$64af437cce00eae8);

var $blSB9 = parcelRequire("blSB9");

var $8X8U9 = parcelRequire("8X8U9");

var $3ahqH = parcelRequire("3ahqH");

var $kYtDq = parcelRequire("kYtDq");
class $6a2e5b038b4d707e$export$64af437cce00eae8 {
    constructor(maxAttempts){
        this.maxAttempts = maxAttempts;
        this.mode = (0, $blSB9.RETRY_MODES).STANDARD;
        this.capacity = (0, $8X8U9.INITIAL_RETRY_TOKENS);
        this.retryBackoffStrategy = (0, $3ahqH.getDefaultRetryBackoffStrategy)();
        this.maxAttemptsProvider = typeof maxAttempts === "function" ? maxAttempts : async ()=>maxAttempts;
    }
    async acquireInitialRetryToken(retryTokenScope) {
        return (0, $kYtDq.createDefaultRetryToken)({
            retryDelay: (0, $8X8U9.DEFAULT_RETRY_DELAY_BASE),
            retryCount: 0
        });
    }
    async refreshRetryTokenForRetry(token, errorInfo) {
        const maxAttempts = await this.getMaxAttempts();
        if (this.shouldRetry(token, errorInfo, maxAttempts)) {
            const errorType = errorInfo.errorType;
            this.retryBackoffStrategy.setDelayBase(errorType === "THROTTLING" ? (0, $8X8U9.THROTTLING_RETRY_DELAY_BASE) : (0, $8X8U9.DEFAULT_RETRY_DELAY_BASE));
            const delayFromErrorType = this.retryBackoffStrategy.computeNextBackoffDelay(token.getRetryCount());
            const retryDelay = errorInfo.retryAfterHint ? Math.max(errorInfo.retryAfterHint.getTime() - Date.now() || 0, delayFromErrorType) : delayFromErrorType;
            const capacityCost = this.getCapacityCost(errorType);
            this.capacity -= capacityCost;
            return (0, $kYtDq.createDefaultRetryToken)({
                retryDelay: retryDelay,
                retryCount: token.getRetryCount() + 1,
                retryCost: capacityCost
            });
        }
        throw new Error("No retry token available");
    }
    recordSuccess(token) {
        this.capacity = Math.max((0, $8X8U9.INITIAL_RETRY_TOKENS), this.capacity + (token.getRetryCost() ?? (0, $8X8U9.NO_RETRY_INCREMENT)));
    }
    getCapacity() {
        return this.capacity;
    }
    async getMaxAttempts() {
        try {
            return await this.maxAttemptsProvider();
        } catch (error) {
            console.warn(`Max attempts provider could not resolve. Using default of ${(0, $blSB9.DEFAULT_MAX_ATTEMPTS)}`);
            return 0, $blSB9.DEFAULT_MAX_ATTEMPTS;
        }
    }
    shouldRetry(tokenToRenew, errorInfo, maxAttempts) {
        const attempts = tokenToRenew.getRetryCount() + 1;
        return attempts < maxAttempts && this.capacity >= this.getCapacityCost(errorInfo.errorType) && this.isRetryableError(errorInfo.errorType);
    }
    getCapacityCost(errorType) {
        return errorType === "TRANSIENT" ? (0, $8X8U9.TIMEOUT_RETRY_COST) : (0, $8X8U9.RETRY_COST);
    }
    isRetryableError(errorType) {
        return errorType === "THROTTLING" || errorType === "TRANSIENT";
    }
}

});
parcelRegister("8X8U9", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_RETRY_DELAY_BASE", () => $684abdb2de90173c$export$7067ba90effbd789);
$parcel$export(module.exports, "MAXIMUM_RETRY_DELAY", () => $684abdb2de90173c$export$2412c80d04e902c6);
$parcel$export(module.exports, "THROTTLING_RETRY_DELAY_BASE", () => $684abdb2de90173c$export$4af31f8250b48e23);
$parcel$export(module.exports, "INITIAL_RETRY_TOKENS", () => $684abdb2de90173c$export$f8c3d11675a1153);
$parcel$export(module.exports, "RETRY_COST", () => $684abdb2de90173c$export$797febae1136bc84);
$parcel$export(module.exports, "TIMEOUT_RETRY_COST", () => $684abdb2de90173c$export$b643545eaf9af837);
$parcel$export(module.exports, "NO_RETRY_INCREMENT", () => $684abdb2de90173c$export$a25da3406dc148e4);
$parcel$export(module.exports, "INVOCATION_ID_HEADER", () => $684abdb2de90173c$export$197fd517bf66ccb2);
$parcel$export(module.exports, "REQUEST_HEADER", () => $684abdb2de90173c$export$d4f764f0ec4f52f);
const $684abdb2de90173c$export$7067ba90effbd789 = 100;
const $684abdb2de90173c$export$2412c80d04e902c6 = 20000;
const $684abdb2de90173c$export$4af31f8250b48e23 = 500;
const $684abdb2de90173c$export$f8c3d11675a1153 = 500;
const $684abdb2de90173c$export$797febae1136bc84 = 5;
const $684abdb2de90173c$export$b643545eaf9af837 = 10;
const $684abdb2de90173c$export$a25da3406dc148e4 = 1;
const $684abdb2de90173c$export$197fd517bf66ccb2 = "amz-sdk-invocation-id";
const $684abdb2de90173c$export$d4f764f0ec4f52f = "amz-sdk-request";

});

parcelRegister("3ahqH", function(module, exports) {

$parcel$export(module.exports, "getDefaultRetryBackoffStrategy", () => $24dfd36a4c706b0c$export$fc672061560e1611);

var $8X8U9 = parcelRequire("8X8U9");
const $24dfd36a4c706b0c$export$fc672061560e1611 = ()=>{
    let delayBase = (0, $8X8U9.DEFAULT_RETRY_DELAY_BASE);
    const computeNextBackoffDelay = (attempts)=>{
        return Math.floor(Math.min((0, $8X8U9.MAXIMUM_RETRY_DELAY), Math.random() * 2 ** attempts * delayBase));
    };
    const setDelayBase = (delay)=>{
        delayBase = delay;
    };
    return {
        computeNextBackoffDelay: computeNextBackoffDelay,
        setDelayBase: setDelayBase
    };
};

});

parcelRegister("kYtDq", function(module, exports) {

$parcel$export(module.exports, "createDefaultRetryToken", () => $f450661da6806407$export$330ec27afca1b9b);

var $8X8U9 = parcelRequire("8X8U9");
const $f450661da6806407$export$330ec27afca1b9b = ({ retryDelay: retryDelay, retryCount: retryCount, retryCost: retryCost })=>{
    const getRetryCount = ()=>retryCount;
    const getRetryDelay = ()=>Math.min((0, $8X8U9.MAXIMUM_RETRY_DELAY), retryDelay);
    const getRetryCost = ()=>retryCost;
    return {
        getRetryCount: getRetryCount,
        getRetryDelay: getRetryDelay,
        getRetryCost: getRetryCost
    };
};

});



parcelRegister("kdCtX", function(module, exports) {

var $8X8U9 = parcelRequire("8X8U9");

var $97cmp = parcelRequire("97cmp");
class $eb82df51ee8b12b8$export$4d488d77e5dad28e extends (0, $97cmp.StandardRetryStrategy) {
    constructor(maxAttempts, computeNextBackoffDelay = (0, $8X8U9.DEFAULT_RETRY_DELAY_BASE)){
        super(typeof maxAttempts === "function" ? maxAttempts : async ()=>maxAttempts);
        if (typeof computeNextBackoffDelay === "number") this.computeNextBackoffDelay = ()=>computeNextBackoffDelay;
        else this.computeNextBackoffDelay = computeNextBackoffDelay;
    }
    async refreshRetryTokenForRetry(tokenToRenew, errorInfo) {
        const token = await super.refreshRetryTokenForRetry(tokenToRenew, errorInfo);
        token.getRetryDelay = ()=>this.computeNextBackoffDelay(token.getRetryCount());
        return token;
    }
}

});

parcelRegister("2Lovs", function(module, exports) {

});


parcelRegister("4Mvr5", function(module, exports) {

$parcel$export(module.exports, "StandardRetryStrategy", () => $37b407a79c7b563e$export$64af437cce00eae8);
parcelRequire("AueTL");
var $Yl5TU = parcelRequire("Yl5TU");
var $1QalE = parcelRequire("1QalE");

var $bj4DA = parcelRequire("bj4DA");
parcelRequire("dysC5");
var $blSB9 = parcelRequire("blSB9");
var $8X8U9 = parcelRequire("8X8U9");

var $2q4zK = parcelRequire("2q4zK");

var $czLTc = parcelRequire("czLTc");

var $2JUAt = parcelRequire("2JUAt");

var $leJLz = parcelRequire("leJLz");

var $1xWow = parcelRequire("1xWow");
class $37b407a79c7b563e$export$64af437cce00eae8 {
    constructor(maxAttemptsProvider, options){
        this.maxAttemptsProvider = maxAttemptsProvider;
        this.mode = (0, $blSB9.RETRY_MODES).STANDARD;
        this.retryDecider = options?.retryDecider ?? (0, $leJLz.defaultRetryDecider);
        this.delayDecider = options?.delayDecider ?? (0, $2JUAt.defaultDelayDecider);
        this.retryQuota = options?.retryQuota ?? (0, $czLTc.getDefaultRetryQuota)((0, $8X8U9.INITIAL_RETRY_TOKENS));
    }
    shouldRetry(error, attempts, maxAttempts) {
        return attempts < maxAttempts && this.retryDecider(error) && this.retryQuota.hasRetryTokens(error);
    }
    async getMaxAttempts() {
        let maxAttempts;
        try {
            maxAttempts = await this.maxAttemptsProvider();
        } catch (error) {
            maxAttempts = (0, $blSB9.DEFAULT_MAX_ATTEMPTS);
        }
        return maxAttempts;
    }
    async retry(next, args, options) {
        let retryTokenAmount;
        let attempts = 0;
        let totalDelay = 0;
        const maxAttempts = await this.getMaxAttempts();
        const { request: request } = args;
        if ((0, $Yl5TU.HttpRequest).isInstance(request)) request.headers[0, $8X8U9.INVOCATION_ID_HEADER] = (0, $2q4zK.default)();
        while(true)try {
            if ((0, $Yl5TU.HttpRequest).isInstance(request)) request.headers[0, $8X8U9.REQUEST_HEADER] = `attempt=${attempts + 1}; max=${maxAttempts}`;
            if (options?.beforeRequest) await options.beforeRequest();
            const { response: response, output: output } = await next(args);
            if (options?.afterRequest) options.afterRequest(response);
            this.retryQuota.releaseRetryTokens(retryTokenAmount);
            output.$metadata.attempts = attempts + 1;
            output.$metadata.totalRetryDelay = totalDelay;
            return {
                response: response,
                output: output
            };
        } catch (e) {
            const err = (0, $1xWow.asSdkError)(e);
            attempts++;
            if (this.shouldRetry(err, attempts, maxAttempts)) {
                retryTokenAmount = this.retryQuota.retrieveRetryTokens(err);
                const delayFromDecider = this.delayDecider((0, $bj4DA.isThrottlingError)(err) ? (0, $8X8U9.THROTTLING_RETRY_DELAY_BASE) : (0, $8X8U9.DEFAULT_RETRY_DELAY_BASE), attempts);
                const delayFromResponse = $37b407a79c7b563e$var$getDelayFromRetryAfterHeader(err.$response);
                const delay = Math.max(delayFromResponse || 0, delayFromDecider);
                totalDelay += delay;
                await new Promise((resolve)=>setTimeout(resolve, delay));
                continue;
            }
            if (!err.$metadata) err.$metadata = {};
            err.$metadata.attempts = attempts;
            err.$metadata.totalRetryDelay = totalDelay;
            throw err;
        }
    }
}
const $37b407a79c7b563e$var$getDelayFromRetryAfterHeader = (response)=>{
    if (!(0, $1QalE.HttpResponse).isInstance(response)) return;
    const retryAfterHeaderName = Object.keys(response.headers).find((key)=>key.toLowerCase() === "retry-after");
    if (!retryAfterHeaderName) return;
    const retryAfter = response.headers[retryAfterHeaderName];
    const retryAfterSeconds = Number(retryAfter);
    if (!Number.isNaN(retryAfterSeconds)) return retryAfterSeconds * 1000;
    const retryAfterDate = new Date(retryAfter);
    return retryAfterDate.getTime() - Date.now();
};

});
parcelRegister("2q4zK", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c318f1b8ece0f85$export$2e2bcd8739ae039);

var $jS7Ji = parcelRequire("jS7Ji");

var $7r9Kn = parcelRequire("7r9Kn");
function $1c318f1b8ece0f85$var$v4(options, buf, offset) {
    options = options || {};
    var rnds = options.random || (options.rng || (0, $jS7Ji.default))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $7r9Kn.default)(rnds);
}
var $1c318f1b8ece0f85$export$2e2bcd8739ae039 = $1c318f1b8ece0f85$var$v4;

});
parcelRegister("jS7Ji", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7790e6813fab6fe$export$2e2bcd8739ae039);
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var $e7790e6813fab6fe$var$getRandomValues;
var $e7790e6813fab6fe$var$rnds8 = new Uint8Array(16);
function $e7790e6813fab6fe$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$e7790e6813fab6fe$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
        // find the complete implementation of crypto (msCrypto) on IE11.
        $e7790e6813fab6fe$var$getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== "undefined" && typeof msCrypto.getRandomValues === "function" && msCrypto.getRandomValues.bind(msCrypto);
        if (!$e7790e6813fab6fe$var$getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return $e7790e6813fab6fe$var$getRandomValues($e7790e6813fab6fe$var$rnds8);
}

});

parcelRegister("7r9Kn", function(module, exports) {

$parcel$export(module.exports, "default", () => $56a29d95045d92a1$export$2e2bcd8739ae039);

var $jswqB = parcelRequire("jswqB");
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $56a29d95045d92a1$var$byteToHex = [];
for(var $56a29d95045d92a1$var$i = 0; $56a29d95045d92a1$var$i < 256; ++$56a29d95045d92a1$var$i)$56a29d95045d92a1$var$byteToHex.push(($56a29d95045d92a1$var$i + 0x100).toString(16).substr(1));
function $56a29d95045d92a1$var$stringify(arr) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    var uuid = ($56a29d95045d92a1$var$byteToHex[arr[offset + 0]] + $56a29d95045d92a1$var$byteToHex[arr[offset + 1]] + $56a29d95045d92a1$var$byteToHex[arr[offset + 2]] + $56a29d95045d92a1$var$byteToHex[arr[offset + 3]] + "-" + $56a29d95045d92a1$var$byteToHex[arr[offset + 4]] + $56a29d95045d92a1$var$byteToHex[arr[offset + 5]] + "-" + $56a29d95045d92a1$var$byteToHex[arr[offset + 6]] + $56a29d95045d92a1$var$byteToHex[arr[offset + 7]] + "-" + $56a29d95045d92a1$var$byteToHex[arr[offset + 8]] + $56a29d95045d92a1$var$byteToHex[arr[offset + 9]] + "-" + $56a29d95045d92a1$var$byteToHex[arr[offset + 10]] + $56a29d95045d92a1$var$byteToHex[arr[offset + 11]] + $56a29d95045d92a1$var$byteToHex[arr[offset + 12]] + $56a29d95045d92a1$var$byteToHex[arr[offset + 13]] + $56a29d95045d92a1$var$byteToHex[arr[offset + 14]] + $56a29d95045d92a1$var$byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $jswqB.default)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
var $56a29d95045d92a1$export$2e2bcd8739ae039 = $56a29d95045d92a1$var$stringify;

});
parcelRegister("jswqB", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2a9c962c9a1261d$export$2e2bcd8739ae039);

var $1ewTh = parcelRequire("1ewTh");
function $e2a9c962c9a1261d$var$validate(uuid) {
    return typeof uuid === "string" && (0, $1ewTh.default).test(uuid);
}
var $e2a9c962c9a1261d$export$2e2bcd8739ae039 = $e2a9c962c9a1261d$var$validate;

});
parcelRegister("1ewTh", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e609ca3b11b4dda$export$2e2bcd8739ae039);
var $0e609ca3b11b4dda$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

});




parcelRegister("czLTc", function(module, exports) {

$parcel$export(module.exports, "getDefaultRetryQuota", () => $927de6b77f39d2e1$export$2ebe7988802fc284);
parcelRequire("dysC5");
var $8X8U9 = parcelRequire("8X8U9");
const $927de6b77f39d2e1$export$2ebe7988802fc284 = (initialRetryTokens, options)=>{
    const MAX_CAPACITY = initialRetryTokens;
    const noRetryIncrement = options?.noRetryIncrement ?? (0, $8X8U9.NO_RETRY_INCREMENT);
    const retryCost = options?.retryCost ?? (0, $8X8U9.RETRY_COST);
    const timeoutRetryCost = options?.timeoutRetryCost ?? (0, $8X8U9.TIMEOUT_RETRY_COST);
    let availableCapacity = initialRetryTokens;
    const getCapacityAmount = (error)=>error.name === "TimeoutError" ? timeoutRetryCost : retryCost;
    const hasRetryTokens = (error)=>getCapacityAmount(error) <= availableCapacity;
    const retrieveRetryTokens = (error)=>{
        if (!hasRetryTokens(error)) throw new Error("No retry token available");
        const capacityAmount = getCapacityAmount(error);
        availableCapacity -= capacityAmount;
        return capacityAmount;
    };
    const releaseRetryTokens = (capacityReleaseAmount)=>{
        availableCapacity += capacityReleaseAmount ?? noRetryIncrement;
        availableCapacity = Math.min(availableCapacity, MAX_CAPACITY);
    };
    return Object.freeze({
        hasRetryTokens: hasRetryTokens,
        retrieveRetryTokens: retrieveRetryTokens,
        releaseRetryTokens: releaseRetryTokens
    });
};

});

parcelRegister("2JUAt", function(module, exports) {

$parcel$export(module.exports, "defaultDelayDecider", () => $1febadcb20b9752d$export$1cddd42598a3b1f6);
parcelRequire("dysC5");
var $8X8U9 = parcelRequire("8X8U9");
const $1febadcb20b9752d$export$1cddd42598a3b1f6 = (delayBase, attempts)=>Math.floor(Math.min((0, $8X8U9.MAXIMUM_RETRY_DELAY), Math.random() * 2 ** attempts * delayBase));

});

parcelRegister("leJLz", function(module, exports) {

$parcel$export(module.exports, "defaultRetryDecider", () => $f75e67ff3cf12e8a$export$3839fd261f89ec2);

var $bj4DA = parcelRequire("bj4DA");
const $f75e67ff3cf12e8a$export$3839fd261f89ec2 = (error)=>{
    if (!error) return false;
    return (0, $bj4DA.isRetryableByTrait)(error) || (0, $bj4DA.isClockSkewError)(error) || (0, $bj4DA.isThrottlingError)(error) || (0, $bj4DA.isTransientError)(error);
};

});

parcelRegister("1xWow", function(module, exports) {

$parcel$export(module.exports, "asSdkError", () => $12062b77cf575cd1$export$c780f8210b6eca50);
const $12062b77cf575cd1$export$c780f8210b6eca50 = (error)=>{
    if (error instanceof Error) return error;
    if (error instanceof Object) return Object.assign(new Error(), error);
    if (typeof error === "string") return new Error(error);
    return new Error(`AWS SDK error wrapper for ${error}`);
};

});



parcelRegister("66f0Z", function(module, exports) {

$parcel$export(module.exports, "resolveRetryConfig", () => $470ef349d17672bb$export$ca7f6138f2c98476);
parcelRequire("e2ELD");
var $j5KxT = parcelRequire("j5KxT");
parcelRequire("dysC5");
var $g4D1u = parcelRequire("g4D1u");
var $blSB9 = parcelRequire("blSB9");
var $97cmp = parcelRequire("97cmp");
const $470ef349d17672bb$export$a19952f9e421517c = "AWS_MAX_ATTEMPTS";
const $470ef349d17672bb$export$9ae8a04532f798bc = "max_attempts";
const $470ef349d17672bb$export$8023fdddb2ca30e0 = {
    environmentVariableSelector: (env)=>{
        const value = env[$470ef349d17672bb$export$a19952f9e421517c];
        if (!value) return undefined;
        const maxAttempt = parseInt(value);
        if (Number.isNaN(maxAttempt)) throw new Error(`Environment variable ${$470ef349d17672bb$export$a19952f9e421517c} mast be a number, got "${value}"`);
        return maxAttempt;
    },
    configFileSelector: (profile)=>{
        const value = profile[$470ef349d17672bb$export$9ae8a04532f798bc];
        if (!value) return undefined;
        const maxAttempt = parseInt(value);
        if (Number.isNaN(maxAttempt)) throw new Error(`Shared config file entry ${$470ef349d17672bb$export$9ae8a04532f798bc} mast be a number, got "${value}"`);
        return maxAttempt;
    },
    default: (0, $blSB9.DEFAULT_MAX_ATTEMPTS)
};
const $470ef349d17672bb$export$ca7f6138f2c98476 = (input)=>{
    const { retryStrategy: retryStrategy } = input;
    const maxAttempts = (0, $j5KxT.normalizeProvider)(input.maxAttempts ?? (0, $blSB9.DEFAULT_MAX_ATTEMPTS));
    return {
        ...input,
        maxAttempts: maxAttempts,
        retryStrategy: async ()=>{
            if (retryStrategy) return retryStrategy;
            const retryMode = await (0, $j5KxT.normalizeProvider)(input.retryMode)();
            if (retryMode === (0, $blSB9.RETRY_MODES).ADAPTIVE) return new (0, $g4D1u.AdaptiveRetryStrategy)(maxAttempts);
            return new (0, $97cmp.StandardRetryStrategy)(maxAttempts);
        }
    };
};
const $470ef349d17672bb$export$4728af91ff39ef3b = "AWS_RETRY_MODE";
const $470ef349d17672bb$export$c5c0171a17765aea = "retry_mode";
const $470ef349d17672bb$export$972bf2bb01959ff5 = {
    environmentVariableSelector: (env)=>env[$470ef349d17672bb$export$4728af91ff39ef3b],
    configFileSelector: (profile)=>profile[$470ef349d17672bb$export$c5c0171a17765aea],
    default: (0, $blSB9.DEFAULT_RETRY_MODE)
};

});

parcelRegister("juP97", function(module, exports) {
parcelRequire("AueTL");
var $Yl5TU = parcelRequire("Yl5TU");
parcelRequire("dysC5");
var $8X8U9 = parcelRequire("8X8U9");
const $e3187e33caa2e61f$export$536b11ee0b9c4a95 = ()=>(next)=>async (args)=>{
            const { request: request } = args;
            if ((0, $Yl5TU.HttpRequest).isInstance(request)) {
                delete request.headers[0, $8X8U9.INVOCATION_ID_HEADER];
                delete request.headers[0, $8X8U9.REQUEST_HEADER];
            }
            return next(args);
        };
const $e3187e33caa2e61f$export$3ec587d8f35e7a2c = {
    name: "omitRetryHeadersMiddleware",
    tags: [
        "RETRY",
        "HEADERS",
        "OMIT_RETRY_HEADERS"
    ],
    relation: "before",
    toMiddleware: "awsAuthMiddleware",
    override: true
};
const $e3187e33caa2e61f$export$fa165e6edc16c2a2 = (options)=>({
        applyToStack: (clientStack)=>{
            clientStack.addRelativeTo($e3187e33caa2e61f$export$536b11ee0b9c4a95(), $e3187e33caa2e61f$export$3ec587d8f35e7a2c);
        }
    });

});

parcelRegister("6Httz", function(module, exports) {

$parcel$export(module.exports, "retryMiddlewareOptions", () => $4e0d9f900552d431$export$44d3d03587957ce9);
$parcel$export(module.exports, "getRetryPlugin", () => $4e0d9f900552d431$export$c73199e2b1df9340);
parcelRequire("AueTL");
var $Yl5TU = parcelRequire("Yl5TU");
var $1QalE = parcelRequire("1QalE");

var $bj4DA = parcelRequire("bj4DA");
parcelRequire("33pc1");
var $4RSUY = parcelRequire("4RSUY");
parcelRequire("dysC5");
var $8X8U9 = parcelRequire("8X8U9");

var $2q4zK = parcelRequire("2q4zK");

var $jjVcP = parcelRequire("jjVcP");

var $1xWow = parcelRequire("1xWow");
const $4e0d9f900552d431$export$a3922aa5f87bae85 = (options)=>(next, context)=>async (args)=>{
            let retryStrategy = await options.retryStrategy();
            const maxAttempts = await options.maxAttempts();
            if ($4e0d9f900552d431$var$isRetryStrategyV2(retryStrategy)) {
                retryStrategy;
                let retryToken = await retryStrategy.acquireInitialRetryToken(context["partition_id"]);
                let lastError = new Error();
                let attempts = 0;
                let totalRetryDelay = 0;
                const { request: request } = args;
                const isRequest = (0, $Yl5TU.HttpRequest).isInstance(request);
                if (isRequest) request.headers[0, $8X8U9.INVOCATION_ID_HEADER] = (0, $2q4zK.default)();
                while(true)try {
                    if (isRequest) request.headers[0, $8X8U9.REQUEST_HEADER] = `attempt=${attempts + 1}; max=${maxAttempts}`;
                    const { response: response, output: output } = await next(args);
                    retryStrategy.recordSuccess(retryToken);
                    output.$metadata.attempts = attempts + 1;
                    output.$metadata.totalRetryDelay = totalRetryDelay;
                    return {
                        response: response,
                        output: output
                    };
                } catch (e) {
                    const retryErrorInfo = $4e0d9f900552d431$var$getRetryErrorInfo(e);
                    lastError = (0, $1xWow.asSdkError)(e);
                    if (isRequest && (0, $jjVcP.isStreamingPayload)(request)) {
                        (context.logger instanceof (0, $4RSUY.NoOpLogger) ? console : context.logger)?.warn("An error was encountered in a non-retryable streaming request.");
                        throw lastError;
                    }
                    try {
                        retryToken = await retryStrategy.refreshRetryTokenForRetry(retryToken, retryErrorInfo);
                    } catch (refreshError) {
                        if (!lastError.$metadata) lastError.$metadata = {};
                        lastError.$metadata.attempts = attempts + 1;
                        lastError.$metadata.totalRetryDelay = totalRetryDelay;
                        throw lastError;
                    }
                    attempts = retryToken.getRetryCount();
                    const delay = retryToken.getRetryDelay();
                    totalRetryDelay += delay;
                    await new Promise((resolve)=>setTimeout(resolve, delay));
                }
            } else {
                retryStrategy;
                if (retryStrategy?.mode) context.userAgent = [
                    ...context.userAgent || [],
                    [
                        "cfg/retry-mode",
                        retryStrategy.mode
                    ]
                ];
                return retryStrategy.retry(next, args);
            }
        };
const $4e0d9f900552d431$var$isRetryStrategyV2 = (retryStrategy)=>typeof retryStrategy.acquireInitialRetryToken !== "undefined" && typeof retryStrategy.refreshRetryTokenForRetry !== "undefined" && typeof retryStrategy.recordSuccess !== "undefined";
const $4e0d9f900552d431$var$getRetryErrorInfo = (error)=>{
    const errorInfo = {
        error: error,
        errorType: $4e0d9f900552d431$var$getRetryErrorType(error)
    };
    const retryAfterHint = $4e0d9f900552d431$export$8f45b27d98dcedff(error.$response);
    if (retryAfterHint) errorInfo.retryAfterHint = retryAfterHint;
    return errorInfo;
};
const $4e0d9f900552d431$var$getRetryErrorType = (error)=>{
    if ((0, $bj4DA.isThrottlingError)(error)) return "THROTTLING";
    if ((0, $bj4DA.isTransientError)(error)) return "TRANSIENT";
    if ((0, $bj4DA.isServerError)(error)) return "SERVER_ERROR";
    return "CLIENT_ERROR";
};
const $4e0d9f900552d431$export$44d3d03587957ce9 = {
    name: "retryMiddleware",
    tags: [
        "RETRY"
    ],
    step: "finalizeRequest",
    priority: "high",
    override: true
};
const $4e0d9f900552d431$export$c73199e2b1df9340 = (options)=>({
        applyToStack: (clientStack)=>{
            clientStack.add($4e0d9f900552d431$export$a3922aa5f87bae85(options), $4e0d9f900552d431$export$44d3d03587957ce9);
        }
    });
const $4e0d9f900552d431$export$8f45b27d98dcedff = (response)=>{
    if (!(0, $1QalE.HttpResponse).isInstance(response)) return;
    const retryAfterHeaderName = Object.keys(response.headers).find((key)=>key.toLowerCase() === "retry-after");
    if (!retryAfterHeaderName) return;
    const retryAfter = response.headers[retryAfterHeaderName];
    const retryAfterSeconds = Number(retryAfter);
    if (!Number.isNaN(retryAfterSeconds)) return new Date(retryAfterSeconds * 1000);
    const retryAfterDate = new Date(retryAfter);
    return retryAfterDate;
};

});
parcelRegister("33pc1", function(module, exports) {
$parcel$export(module.exports, "NoOpLogger", () => (parcelRequire("4RSUY")).NoOpLogger);
$parcel$export(module.exports, "Client", () => (parcelRequire("cr1Pw")).Client);
$parcel$export(module.exports, "collectBody", () => (parcelRequire("7fiNM")).collectBody);
$parcel$export(module.exports, "Command", () => (parcelRequire("hMwCU")).Command);
$parcel$export(module.exports, "SENSITIVE_STRING", () => (parcelRequire("4HRM9")).SENSITIVE_STRING);
$parcel$export(module.exports, "parseEpochTimestamp", () => (parcelRequire("d8z3h")).parseEpochTimestamp);
$parcel$export(module.exports, "parseRfc3339DateTime", () => (parcelRequire("d8z3h")).parseRfc3339DateTime);
$parcel$export(module.exports, "parseRfc3339DateTimeWithOffset", () => (parcelRequire("d8z3h")).parseRfc3339DateTimeWithOffset);
$parcel$export(module.exports, "withBaseException", () => (parcelRequire("cYbAK")).withBaseException);
$parcel$export(module.exports, "loadConfigsForDefaultMode", () => (parcelRequire("bOftX")).loadConfigsForDefaultMode);
$parcel$export(module.exports, "getDefaultExtensionConfiguration", () => (parcelRequire("5Px3r")).getDefaultExtensionConfiguration);
$parcel$export(module.exports, "resolveDefaultRuntimeConfig", () => (parcelRequire("5Px3r")).resolveDefaultRuntimeConfig);
$parcel$export(module.exports, "decorateServiceException", () => (parcelRequire("1CRbD")).decorateServiceException);
$parcel$export(module.exports, "ServiceException", () => (parcelRequire("1CRbD")).ServiceException);
$parcel$export(module.exports, "extendedEncodeURIComponent", () => (parcelRequire("e2AgL")).extendedEncodeURIComponent);
$parcel$export(module.exports, "getValueFromTextNode", () => (parcelRequire("ijICi")).getValueFromTextNode);
$parcel$export(module.exports, "map", () => (parcelRequire("eJMW4")).map);
$parcel$export(module.exports, "take", () => (parcelRequire("eJMW4")).take);
$parcel$export(module.exports, "expectBoolean", () => (parcelRequire("cXA1B")).expectBoolean);
$parcel$export(module.exports, "expectInt32", () => (parcelRequire("cXA1B")).expectInt32);
$parcel$export(module.exports, "expectNonNull", () => (parcelRequire("cXA1B")).expectNonNull);
$parcel$export(module.exports, "expectNumber", () => (parcelRequire("cXA1B")).expectNumber);
$parcel$export(module.exports, "expectObject", () => (parcelRequire("cXA1B")).expectObject);
$parcel$export(module.exports, "expectString", () => (parcelRequire("cXA1B")).expectString);
$parcel$export(module.exports, "limitedParseDouble", () => (parcelRequire("cXA1B")).limitedParseDouble);
$parcel$export(module.exports, "strictParseInt32", () => (parcelRequire("cXA1B")).strictParseInt32);
$parcel$export(module.exports, "resolvedPath", () => (parcelRequire("8phr2")).resolvedPath);
$parcel$export(module.exports, "serializeFloat", () => (parcelRequire("iAvye")).serializeFloat);
$parcel$export(module.exports, "_json", () => (parcelRequire("Phm09"))._json);
parcelRequire("4RSUY");
parcelRequire("cr1Pw");
parcelRequire("7fiNM");
parcelRequire("hMwCU");
parcelRequire("4HRM9");
parcelRequire("e9XFc");
parcelRequire("d8z3h");
parcelRequire("cYbAK");
parcelRequire("bOftX");
parcelRequire("h3Dxu");
parcelRequire("4TJos");
parcelRequire("1CRbD");
parcelRequire("e2AgL");
parcelRequire("dAW7b");
parcelRequire("ijICi");
parcelRequire("iiyLk");
parcelRequire("eJMW4");
parcelRequire("cXA1B");
parcelRequire("8phr2");
parcelRequire("iAvye");
parcelRequire("Phm09");
parcelRequire("1AVlS");

});
parcelRegister("4RSUY", function(module, exports) {

$parcel$export(module.exports, "NoOpLogger", () => $38b6b63d5af4cbeb$export$4147bde06f294c2e);
class $38b6b63d5af4cbeb$export$4147bde06f294c2e {
    trace() {}
    debug() {}
    info() {}
    warn() {}
    error() {}
}

});

parcelRegister("cr1Pw", function(module, exports) {

$parcel$export(module.exports, "Client", () => $90d96d11914d1444$export$1f2bb630327ac4b6);
parcelRequire("5H29d");
var $2jfjD = parcelRequire("2jfjD");
class $90d96d11914d1444$export$1f2bb630327ac4b6 {
    constructor(config){
        this.middlewareStack = (0, $2jfjD.constructStack)();
        this.config = config;
    }
    send(command, optionsOrCb, cb) {
        const options = typeof optionsOrCb !== "function" ? optionsOrCb : undefined;
        const callback = typeof optionsOrCb === "function" ? optionsOrCb : cb;
        const handler = command.resolveMiddleware(this.middlewareStack, this.config, options);
        if (callback) handler(command).then((result)=>callback(null, result.output), (err)=>callback(err)).catch(()=>{});
        else return handler(command).then((result)=>result.output);
    }
    destroy() {
        if (this.config.requestHandler.destroy) this.config.requestHandler.destroy();
    }
}

});
parcelRegister("5H29d", function(module, exports) {
$parcel$export(module.exports, "constructStack", () => (parcelRequire("2jfjD")).constructStack);
parcelRequire("2jfjD");

});
parcelRegister("2jfjD", function(module, exports) {

$parcel$export(module.exports, "constructStack", () => $1ae93c7cdcbb0e22$export$73604a93307363d8);
const $1ae93c7cdcbb0e22$var$getAllAliases = (name, aliases)=>{
    const _aliases = [];
    if (name) _aliases.push(name);
    if (aliases) for (const alias of aliases)_aliases.push(alias);
    return _aliases;
};
const $1ae93c7cdcbb0e22$var$getMiddlewareNameWithAliases = (name, aliases)=>{
    return `${name || "anonymous"}${aliases && aliases.length > 0 ? ` (a.k.a. ${aliases.join(",")})` : ""}`;
};
const $1ae93c7cdcbb0e22$export$73604a93307363d8 = ()=>{
    let absoluteEntries = [];
    let relativeEntries = [];
    let identifyOnResolve = false;
    const entriesNameSet = new Set();
    const sort = (entries)=>entries.sort((a, b)=>$1ae93c7cdcbb0e22$var$stepWeights[b.step] - $1ae93c7cdcbb0e22$var$stepWeights[a.step] || $1ae93c7cdcbb0e22$var$priorityWeights[b.priority || "normal"] - $1ae93c7cdcbb0e22$var$priorityWeights[a.priority || "normal"]);
    const removeByName = (toRemove)=>{
        let isRemoved = false;
        const filterCb = (entry)=>{
            const aliases = $1ae93c7cdcbb0e22$var$getAllAliases(entry.name, entry.aliases);
            if (aliases.includes(toRemove)) {
                isRemoved = true;
                for (const alias of aliases)entriesNameSet.delete(alias);
                return false;
            }
            return true;
        };
        absoluteEntries = absoluteEntries.filter(filterCb);
        relativeEntries = relativeEntries.filter(filterCb);
        return isRemoved;
    };
    const removeByReference = (toRemove)=>{
        let isRemoved = false;
        const filterCb = (entry)=>{
            if (entry.middleware === toRemove) {
                isRemoved = true;
                for (const alias of $1ae93c7cdcbb0e22$var$getAllAliases(entry.name, entry.aliases))entriesNameSet.delete(alias);
                return false;
            }
            return true;
        };
        absoluteEntries = absoluteEntries.filter(filterCb);
        relativeEntries = relativeEntries.filter(filterCb);
        return isRemoved;
    };
    const cloneTo = (toStack)=>{
        absoluteEntries.forEach((entry)=>{
            toStack.add(entry.middleware, {
                ...entry
            });
        });
        relativeEntries.forEach((entry)=>{
            toStack.addRelativeTo(entry.middleware, {
                ...entry
            });
        });
        toStack.identifyOnResolve?.(stack.identifyOnResolve());
        return toStack;
    };
    const expandRelativeMiddlewareList = (from)=>{
        const expandedMiddlewareList = [];
        from.before.forEach((entry)=>{
            if (entry.before.length === 0 && entry.after.length === 0) expandedMiddlewareList.push(entry);
            else expandedMiddlewareList.push(...expandRelativeMiddlewareList(entry));
        });
        expandedMiddlewareList.push(from);
        from.after.reverse().forEach((entry)=>{
            if (entry.before.length === 0 && entry.after.length === 0) expandedMiddlewareList.push(entry);
            else expandedMiddlewareList.push(...expandRelativeMiddlewareList(entry));
        });
        return expandedMiddlewareList;
    };
    const getMiddlewareList = (debug = false)=>{
        const normalizedAbsoluteEntries = [];
        const normalizedRelativeEntries = [];
        const normalizedEntriesNameMap = {};
        absoluteEntries.forEach((entry)=>{
            const normalizedEntry = {
                ...entry,
                before: [],
                after: []
            };
            for (const alias of $1ae93c7cdcbb0e22$var$getAllAliases(normalizedEntry.name, normalizedEntry.aliases))normalizedEntriesNameMap[alias] = normalizedEntry;
            normalizedAbsoluteEntries.push(normalizedEntry);
        });
        relativeEntries.forEach((entry)=>{
            const normalizedEntry = {
                ...entry,
                before: [],
                after: []
            };
            for (const alias of $1ae93c7cdcbb0e22$var$getAllAliases(normalizedEntry.name, normalizedEntry.aliases))normalizedEntriesNameMap[alias] = normalizedEntry;
            normalizedRelativeEntries.push(normalizedEntry);
        });
        normalizedRelativeEntries.forEach((entry)=>{
            if (entry.toMiddleware) {
                const toMiddleware = normalizedEntriesNameMap[entry.toMiddleware];
                if (toMiddleware === undefined) {
                    if (debug) return;
                    throw new Error(`${entry.toMiddleware} is not found when adding ` + `${$1ae93c7cdcbb0e22$var$getMiddlewareNameWithAliases(entry.name, entry.aliases)} ` + `middleware ${entry.relation} ${entry.toMiddleware}`);
                }
                if (entry.relation === "after") toMiddleware.after.push(entry);
                if (entry.relation === "before") toMiddleware.before.push(entry);
            }
        });
        const mainChain = sort(normalizedAbsoluteEntries).map(expandRelativeMiddlewareList).reduce((wholeList, expandedMiddlewareList)=>{
            wholeList.push(...expandedMiddlewareList);
            return wholeList;
        }, []);
        return mainChain;
    };
    const stack = {
        add: (middleware, options = {})=>{
            const { name: name, override: override, aliases: _aliases } = options;
            const entry = {
                step: "initialize",
                priority: "normal",
                middleware: middleware,
                ...options
            };
            const aliases = $1ae93c7cdcbb0e22$var$getAllAliases(name, _aliases);
            if (aliases.length > 0) {
                if (aliases.some((alias)=>entriesNameSet.has(alias))) {
                    if (!override) throw new Error(`Duplicate middleware name '${$1ae93c7cdcbb0e22$var$getMiddlewareNameWithAliases(name, _aliases)}'`);
                    for (const alias of aliases){
                        const toOverrideIndex = absoluteEntries.findIndex((entry)=>entry.name === alias || entry.aliases?.some((a)=>a === alias));
                        if (toOverrideIndex === -1) continue;
                        const toOverride = absoluteEntries[toOverrideIndex];
                        if (toOverride.step !== entry.step || entry.priority !== toOverride.priority) throw new Error(`"${$1ae93c7cdcbb0e22$var$getMiddlewareNameWithAliases(toOverride.name, toOverride.aliases)}" middleware with ` + `${toOverride.priority} priority in ${toOverride.step} step cannot ` + `be overridden by "${$1ae93c7cdcbb0e22$var$getMiddlewareNameWithAliases(name, _aliases)}" middleware with ` + `${entry.priority} priority in ${entry.step} step.`);
                        absoluteEntries.splice(toOverrideIndex, 1);
                    }
                }
                for (const alias of aliases)entriesNameSet.add(alias);
            }
            absoluteEntries.push(entry);
        },
        addRelativeTo: (middleware, options)=>{
            const { name: name, override: override, aliases: _aliases } = options;
            const entry = {
                middleware: middleware,
                ...options
            };
            const aliases = $1ae93c7cdcbb0e22$var$getAllAliases(name, _aliases);
            if (aliases.length > 0) {
                if (aliases.some((alias)=>entriesNameSet.has(alias))) {
                    if (!override) throw new Error(`Duplicate middleware name '${$1ae93c7cdcbb0e22$var$getMiddlewareNameWithAliases(name, _aliases)}'`);
                    for (const alias of aliases){
                        const toOverrideIndex = relativeEntries.findIndex((entry)=>entry.name === alias || entry.aliases?.some((a)=>a === alias));
                        if (toOverrideIndex === -1) continue;
                        const toOverride = relativeEntries[toOverrideIndex];
                        if (toOverride.toMiddleware !== entry.toMiddleware || toOverride.relation !== entry.relation) throw new Error(`"${$1ae93c7cdcbb0e22$var$getMiddlewareNameWithAliases(toOverride.name, toOverride.aliases)}" middleware ` + `${toOverride.relation} "${toOverride.toMiddleware}" middleware cannot be overridden ` + `by "${$1ae93c7cdcbb0e22$var$getMiddlewareNameWithAliases(name, _aliases)}" middleware ${entry.relation} ` + `"${entry.toMiddleware}" middleware.`);
                        relativeEntries.splice(toOverrideIndex, 1);
                    }
                }
                for (const alias of aliases)entriesNameSet.add(alias);
            }
            relativeEntries.push(entry);
        },
        clone: ()=>cloneTo($1ae93c7cdcbb0e22$export$73604a93307363d8()),
        use: (plugin)=>{
            plugin.applyToStack(stack);
        },
        remove: (toRemove)=>{
            if (typeof toRemove === "string") return removeByName(toRemove);
            else return removeByReference(toRemove);
        },
        removeByTag: (toRemove)=>{
            let isRemoved = false;
            const filterCb = (entry)=>{
                const { tags: tags, name: name, aliases: _aliases } = entry;
                if (tags && tags.includes(toRemove)) {
                    const aliases = $1ae93c7cdcbb0e22$var$getAllAliases(name, _aliases);
                    for (const alias of aliases)entriesNameSet.delete(alias);
                    isRemoved = true;
                    return false;
                }
                return true;
            };
            absoluteEntries = absoluteEntries.filter(filterCb);
            relativeEntries = relativeEntries.filter(filterCb);
            return isRemoved;
        },
        concat: (from)=>{
            const cloned = cloneTo($1ae93c7cdcbb0e22$export$73604a93307363d8());
            cloned.use(from);
            cloned.identifyOnResolve(identifyOnResolve || cloned.identifyOnResolve() || (from.identifyOnResolve?.() ?? false));
            return cloned;
        },
        applyToStack: cloneTo,
        identify: ()=>{
            return getMiddlewareList(true).map((mw)=>{
                const step = mw.step ?? mw.relation + " " + mw.toMiddleware;
                return $1ae93c7cdcbb0e22$var$getMiddlewareNameWithAliases(mw.name, mw.aliases) + " - " + step;
            });
        },
        identifyOnResolve (toggle) {
            if (typeof toggle === "boolean") identifyOnResolve = toggle;
            return identifyOnResolve;
        },
        resolve: (handler, context)=>{
            for (const middleware of getMiddlewareList().map((entry)=>entry.middleware).reverse())handler = middleware(handler, context);
            if (identifyOnResolve) console.log(stack.identify());
            return handler;
        }
    };
    return stack;
};
const $1ae93c7cdcbb0e22$var$stepWeights = {
    initialize: 5,
    serialize: 4,
    build: 3,
    finalizeRequest: 2,
    deserialize: 1
};
const $1ae93c7cdcbb0e22$var$priorityWeights = {
    high: 3,
    normal: 2,
    low: 1
};

});



parcelRegister("7fiNM", function(module, exports) {

$parcel$export(module.exports, "collectBody", () => $546884c94cb0b5b1$export$3392bcddb824e5ca);
parcelRequire("1f44S");
var $26Vkj = parcelRequire("26Vkj");
const $546884c94cb0b5b1$export$3392bcddb824e5ca = async (streamBody = new Uint8Array(), context)=>{
    if (streamBody instanceof Uint8Array) return (0, $26Vkj.Uint8ArrayBlobAdapter).mutate(streamBody);
    if (!streamBody) return (0, $26Vkj.Uint8ArrayBlobAdapter).mutate(new Uint8Array());
    const fromContext = context.streamCollector(streamBody);
    return (0, $26Vkj.Uint8ArrayBlobAdapter).mutate(await fromContext);
};

});
parcelRegister("1f44S", function(module, exports) {
$parcel$export(module.exports, "Uint8ArrayBlobAdapter", () => (parcelRequire("26Vkj")).Uint8ArrayBlobAdapter);
$parcel$export(module.exports, "sdkStreamMixin", () => (parcelRequire("43oIY")).sdkStreamMixin);
parcelRequire("26Vkj");
parcelRequire("fpmWD");
parcelRequire("43oIY");

});
parcelRegister("26Vkj", function(module, exports) {

$parcel$export(module.exports, "Uint8ArrayBlobAdapter", () => $18989c2b7c7a55c6$export$1465fbad93f83f0a);

var $bkJnu = parcelRequire("bkJnu");
class $18989c2b7c7a55c6$export$1465fbad93f83f0a extends Uint8Array {
    static fromString(source, encoding = "utf-8") {
        switch(typeof source){
            case "string":
                return (0, $bkJnu.transformFromString)(source, encoding);
            default:
                throw new Error(`Unsupported conversion from ${typeof source} to Uint8ArrayBlobAdapter.`);
        }
    }
    static mutate(source) {
        Object.setPrototypeOf(source, $18989c2b7c7a55c6$export$1465fbad93f83f0a.prototype);
        return source;
    }
    transformToString(encoding = "utf-8") {
        return (0, $bkJnu.transformToString)(this, encoding);
    }
}

});
parcelRegister("bkJnu", function(module, exports) {

$parcel$export(module.exports, "transformToString", () => $8404c313f8ffe25a$export$e9aa0d127315abe);
$parcel$export(module.exports, "transformFromString", () => $8404c313f8ffe25a$export$ed8c0e91f57de3aa);
parcelRequire("cteja");
var $6Gr16 = parcelRequire("6Gr16");
var $030I1 = parcelRequire("030I1");
parcelRequire("cace4");
var $3tKur = parcelRequire("3tKur");
var $hpab6 = parcelRequire("hpab6");

var $26Vkj = parcelRequire("26Vkj");
function $8404c313f8ffe25a$export$e9aa0d127315abe(payload, encoding = "utf-8") {
    if (encoding === "base64") return (0, $030I1.toBase64)(payload);
    return (0, $hpab6.toUtf8)(payload);
}
function $8404c313f8ffe25a$export$ed8c0e91f57de3aa(str, encoding) {
    if (encoding === "base64") return (0, $26Vkj.Uint8ArrayBlobAdapter).mutate((0, $6Gr16.fromBase64)(str));
    return (0, $26Vkj.Uint8ArrayBlobAdapter).mutate((0, $3tKur.fromUtf8)(str));
}

});
parcelRegister("cteja", function(module, exports) {
$parcel$export(module.exports, "fromBase64", () => (parcelRequire("6Gr16")).fromBase64);
$parcel$export(module.exports, "toBase64", () => (parcelRequire("030I1")).toBase64);
parcelRequire("6Gr16");
parcelRequire("030I1");

});
parcelRegister("6Gr16", function(module, exports) {

$parcel$export(module.exports, "fromBase64", () => $4ddb9f47b6eae89e$export$c537b38001c583b7);

var $aY1Ki = parcelRequire("aY1Ki");
const $4ddb9f47b6eae89e$export$c537b38001c583b7 = (input)=>{
    let totalByteLength = input.length / 4 * 3;
    if (input.slice(-2) === "==") totalByteLength -= 2;
    else if (input.slice(-1) === "=") totalByteLength--;
    const out = new ArrayBuffer(totalByteLength);
    const dataView = new DataView(out);
    for(let i = 0; i < input.length; i += 4){
        let bits = 0;
        let bitLength = 0;
        for(let j = i, limit = i + 3; j <= limit; j++)if (input[j] !== "=") {
            if (!(input[j] in (0, $aY1Ki.alphabetByEncoding))) throw new TypeError(`Invalid character ${input[j]} in base64 string.`);
            bits |= (0, $aY1Ki.alphabetByEncoding)[input[j]] << (limit - j) * (0, $aY1Ki.bitsPerLetter);
            bitLength += (0, $aY1Ki.bitsPerLetter);
        } else bits >>= (0, $aY1Ki.bitsPerLetter);
        const chunkOffset = i / 4 * 3;
        bits >>= bitLength % (0, $aY1Ki.bitsPerByte);
        const byteLength = Math.floor(bitLength / (0, $aY1Ki.bitsPerByte));
        for(let k = 0; k < byteLength; k++){
            const offset = (byteLength - k - 1) * (0, $aY1Ki.bitsPerByte);
            dataView.setUint8(chunkOffset + k, (bits & 255 << offset) >> offset);
        }
    }
    return new Uint8Array(out);
};

});
parcelRegister("aY1Ki", function(module, exports) {

$parcel$export(module.exports, "alphabetByEncoding", () => $7fc0dc9ffcffa30a$export$7753813254d72972);
$parcel$export(module.exports, "alphabetByValue", () => $7fc0dc9ffcffa30a$export$8f4022378ddff4c7);
$parcel$export(module.exports, "bitsPerLetter", () => $7fc0dc9ffcffa30a$export$1c5cfd5e95b84581);
$parcel$export(module.exports, "bitsPerByte", () => $7fc0dc9ffcffa30a$export$79b97ac4c24c9385);
$parcel$export(module.exports, "maxLetterValue", () => $7fc0dc9ffcffa30a$export$43e943b030ae3d73);
const $7fc0dc9ffcffa30a$export$7753813254d72972 = {};
const $7fc0dc9ffcffa30a$export$8f4022378ddff4c7 = new Array(64);
for(let i = 0, start = "A".charCodeAt(0), limit = "Z".charCodeAt(0); i + start <= limit; i++){
    const char = String.fromCharCode(i + start);
    $7fc0dc9ffcffa30a$export$7753813254d72972[char] = i;
    $7fc0dc9ffcffa30a$export$8f4022378ddff4c7[i] = char;
}
for(let i = 0, start = "a".charCodeAt(0), limit = "z".charCodeAt(0); i + start <= limit; i++){
    const char = String.fromCharCode(i + start);
    const index = i + 26;
    $7fc0dc9ffcffa30a$export$7753813254d72972[char] = index;
    $7fc0dc9ffcffa30a$export$8f4022378ddff4c7[index] = char;
}
for(let i = 0; i < 10; i++){
    $7fc0dc9ffcffa30a$export$7753813254d72972[i.toString(10)] = i + 52;
    const char = i.toString(10);
    const index = i + 52;
    $7fc0dc9ffcffa30a$export$7753813254d72972[char] = index;
    $7fc0dc9ffcffa30a$export$8f4022378ddff4c7[index] = char;
}
$7fc0dc9ffcffa30a$export$7753813254d72972["+"] = 62;
$7fc0dc9ffcffa30a$export$8f4022378ddff4c7[62] = "+";
$7fc0dc9ffcffa30a$export$7753813254d72972["/"] = 63;
$7fc0dc9ffcffa30a$export$8f4022378ddff4c7[63] = "/";
const $7fc0dc9ffcffa30a$export$1c5cfd5e95b84581 = 6;
const $7fc0dc9ffcffa30a$export$79b97ac4c24c9385 = 8;
const $7fc0dc9ffcffa30a$export$43e943b030ae3d73 = 63;

});


parcelRegister("030I1", function(module, exports) {

$parcel$export(module.exports, "toBase64", () => $0090d4b8d484254e$export$37cc283d8fbd3462);
parcelRequire("cace4");
var $3tKur = parcelRequire("3tKur");

var $aY1Ki = parcelRequire("aY1Ki");
function $0090d4b8d484254e$export$37cc283d8fbd3462(_input) {
    let input;
    if (typeof _input === "string") input = (0, $3tKur.fromUtf8)(_input);
    else input = _input;
    const isArrayLike = typeof input === "object" && typeof input.length === "number";
    const isUint8Array = typeof input === "object" && typeof input.byteOffset === "number" && typeof input.byteLength === "number";
    if (!isArrayLike && !isUint8Array) throw new Error("@smithy/util-base64: toBase64 encoder function only accepts string | Uint8Array.");
    let str = "";
    for(let i = 0; i < input.length; i += 3){
        let bits = 0;
        let bitLength = 0;
        for(let j = i, limit = Math.min(i + 3, input.length); j < limit; j++){
            bits |= input[j] << (limit - j - 1) * (0, $aY1Ki.bitsPerByte);
            bitLength += (0, $aY1Ki.bitsPerByte);
        }
        const bitClusterCount = Math.ceil(bitLength / (0, $aY1Ki.bitsPerLetter));
        bits <<= bitClusterCount * (0, $aY1Ki.bitsPerLetter) - bitLength;
        for(let k = 1; k <= bitClusterCount; k++){
            const offset = (bitClusterCount - k) * (0, $aY1Ki.bitsPerLetter);
            str += (0, $aY1Ki.alphabetByValue)[(bits & (0, $aY1Ki.maxLetterValue) << offset) >> offset];
        }
        str += "==".slice(0, 4 - bitClusterCount);
    }
    return str;
}

});
parcelRegister("cace4", function(module, exports) {
$parcel$export(module.exports, "fromUtf8", () => (parcelRequire("3tKur")).fromUtf8);
$parcel$export(module.exports, "toUint8Array", () => (parcelRequire("cHGTK")).toUint8Array);
$parcel$export(module.exports, "toUtf8", () => (parcelRequire("hpab6")).toUtf8);
parcelRequire("3tKur");
parcelRequire("cHGTK");
parcelRequire("hpab6");

});
parcelRegister("3tKur", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", () => $28882480075f378e$export$c7c5cef950a4d2fc);
const $28882480075f378e$export$c7c5cef950a4d2fc = (input)=>new TextEncoder().encode(input);

});

parcelRegister("cHGTK", function(module, exports) {

$parcel$export(module.exports, "toUint8Array", () => $93fac6d8b349b952$export$73470fd2221e6aef);

var $3tKur = parcelRequire("3tKur");
const $93fac6d8b349b952$export$73470fd2221e6aef = (data)=>{
    if (typeof data === "string") return (0, $3tKur.fromUtf8)(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
};

});

parcelRegister("hpab6", function(module, exports) {

$parcel$export(module.exports, "toUtf8", () => $cabcaa98f7ad05ce$export$b4b216764bb846eb);
const $cabcaa98f7ad05ce$export$b4b216764bb846eb = (input)=>{
    if (typeof input === "string") return input;
    if (typeof input !== "object" || typeof input.byteOffset !== "number" || typeof input.byteLength !== "number") throw new Error("@smithy/util-utf8: toUtf8 encoder function only accepts string | Uint8Array.");
    return new TextDecoder("utf-8").decode(input);
};

});






parcelRegister("fpmWD", function(module, exports) {
const $b37afd2f1652176d$export$cc0c9507624e70d1 = (readableStream, options)=>{
    const { base64Encoder: base64Encoder, bodyLengthChecker: bodyLengthChecker, checksumAlgorithmFn: checksumAlgorithmFn, checksumLocationName: checksumLocationName, streamHasher: streamHasher } = options;
    const checksumRequired = base64Encoder !== undefined && bodyLengthChecker !== undefined && checksumAlgorithmFn !== undefined && checksumLocationName !== undefined && streamHasher !== undefined;
    const digest = checksumRequired ? streamHasher(checksumAlgorithmFn, readableStream) : undefined;
    const reader = readableStream.getReader();
    return new ReadableStream({
        async pull (controller) {
            const { value: value, done: done } = await reader.read();
            if (done) {
                controller.enqueue(`0\r\n`);
                if (checksumRequired) {
                    const checksum = base64Encoder(await digest);
                    controller.enqueue(`${checksumLocationName}:${checksum}\r\n`);
                    controller.enqueue(`\r\n`);
                }
                controller.close();
            } else controller.enqueue(`${(bodyLengthChecker(value) || 0).toString(16)}\r\n${value}\r\n`);
        }
    });
};

});

parcelRegister("43oIY", function(module, exports) {

$parcel$export(module.exports, "sdkStreamMixin", () => $2f3a9ef55179bf34$export$5f9760b56bbf9f65);
parcelRequire("ioEDO");
var $ahmip = parcelRequire("ahmip");
parcelRequire("cteja");
var $030I1 = parcelRequire("030I1");

var $i6ugP = parcelRequire("i6ugP");
parcelRequire("cace4");
var $hpab6 = parcelRequire("hpab6");
const $2f3a9ef55179bf34$var$ERR_MSG_STREAM_HAS_BEEN_TRANSFORMED = "The stream has already been transformed.";
const $2f3a9ef55179bf34$export$5f9760b56bbf9f65 = (stream)=>{
    if (!$2f3a9ef55179bf34$var$isBlobInstance(stream) && !$2f3a9ef55179bf34$var$isReadableStreamInstance(stream)) {
        const name = stream?.__proto__?.constructor?.name || stream;
        throw new Error(`Unexpected stream implementation, expect Blob or ReadableStream, got ${name}`);
    }
    let transformed = false;
    const transformToByteArray = async ()=>{
        if (transformed) throw new Error($2f3a9ef55179bf34$var$ERR_MSG_STREAM_HAS_BEEN_TRANSFORMED);
        transformed = true;
        return await (0, $ahmip.streamCollector)(stream);
    };
    const blobToWebStream = (blob)=>{
        if (typeof blob.stream !== "function") throw new Error("Cannot transform payload Blob to web stream. Please make sure the Blob.stream() is polyfilled.\nIf you are using React Native, this API is not yet supported, see: https://react-native.canny.io/feature-requests/p/fetch-streaming-body");
        return blob.stream();
    };
    return Object.assign(stream, {
        transformToByteArray: transformToByteArray,
        transformToString: async (encoding)=>{
            const buf = await transformToByteArray();
            if (encoding === "base64") return (0, $030I1.toBase64)(buf);
            else if (encoding === "hex") return (0, $i6ugP.toHex)(buf);
            else if (encoding === undefined || encoding === "utf8" || encoding === "utf-8") return (0, $hpab6.toUtf8)(buf);
            else if (typeof TextDecoder === "function") return new TextDecoder(encoding).decode(buf);
            else throw new Error("TextDecoder is not available, please make sure polyfill is provided.");
        },
        transformToWebStream: ()=>{
            if (transformed) throw new Error($2f3a9ef55179bf34$var$ERR_MSG_STREAM_HAS_BEEN_TRANSFORMED);
            transformed = true;
            if ($2f3a9ef55179bf34$var$isBlobInstance(stream)) return blobToWebStream(stream);
            else if ($2f3a9ef55179bf34$var$isReadableStreamInstance(stream)) return stream;
            else throw new Error(`Cannot transform payload to web stream, got ${stream}`);
        }
    });
};
const $2f3a9ef55179bf34$var$isBlobInstance = (stream)=>typeof Blob === "function" && stream instanceof Blob;
const $2f3a9ef55179bf34$var$isReadableStreamInstance = (stream)=>typeof ReadableStream === "function" && stream instanceof ReadableStream;

});
parcelRegister("ioEDO", function(module, exports) {
$parcel$export(module.exports, "FetchHttpHandler", () => (parcelRequire("gMAof")).FetchHttpHandler);
$parcel$export(module.exports, "streamCollector", () => (parcelRequire("ahmip")).streamCollector);
parcelRequire("gMAof");
parcelRequire("ahmip");

});
parcelRegister("gMAof", function(module, exports) {

$parcel$export(module.exports, "FetchHttpHandler", () => $c37d5b551bcc284f$export$83588b87edbfa7e0);
parcelRequire("AueTL");
var $1QalE = parcelRequire("1QalE");

var $fo4hU = parcelRequire("fo4hU");

var $gbm4W = parcelRequire("gbm4W");
const $c37d5b551bcc284f$export$3d6343d6ab3191df = {
    supported: Boolean(typeof Request !== "undefined" && "keepalive" in new Request("https://[::1]"))
};
class $c37d5b551bcc284f$export$83588b87edbfa7e0 {
    static create(instanceOrOptions) {
        if (typeof instanceOrOptions?.handle === "function") return instanceOrOptions;
        return new $c37d5b551bcc284f$export$83588b87edbfa7e0(instanceOrOptions);
    }
    constructor(options){
        if (typeof options === "function") this.configProvider = options().then((opts)=>opts || {});
        else {
            this.config = options ?? {};
            this.configProvider = Promise.resolve(this.config);
        }
    }
    destroy() {}
    async handle(request, { abortSignal: abortSignal } = {}) {
        if (!this.config) this.config = await this.configProvider;
        const requestTimeoutInMs = this.config.requestTimeout;
        const keepAlive = this.config.keepAlive === true;
        if (abortSignal?.aborted) {
            const abortError = new Error("Request aborted");
            abortError.name = "AbortError";
            return Promise.reject(abortError);
        }
        let path = request.path;
        const queryString = (0, $fo4hU.buildQueryString)(request.query || {});
        if (queryString) path += `?${queryString}`;
        if (request.fragment) path += `#${request.fragment}`;
        let auth = "";
        if (request.username != null || request.password != null) {
            const username = request.username ?? "";
            const password = request.password ?? "";
            auth = `${username}:${password}@`;
        }
        const { port: port, method: method } = request;
        const url = `${request.protocol}//${auth}${request.hostname}${port ? `:${port}` : ""}${path}`;
        const body = method === "GET" || method === "HEAD" ? undefined : request.body;
        const requestOptions = {
            body: body,
            headers: new Headers(request.headers),
            method: method
        };
        if (typeof AbortController !== "undefined") requestOptions["signal"] = abortSignal;
        if ($c37d5b551bcc284f$export$3d6343d6ab3191df.supported) requestOptions["keepalive"] = keepAlive;
        const fetchRequest = new Request(url, requestOptions);
        const raceOfPromises = [
            fetch(fetchRequest).then((response)=>{
                const fetchHeaders = response.headers;
                const transformedHeaders = {};
                for (const pair of fetchHeaders.entries())transformedHeaders[pair[0]] = pair[1];
                const hasReadableStream = response.body != undefined;
                if (!hasReadableStream) return response.blob().then((body)=>({
                        response: new (0, $1QalE.HttpResponse)({
                            headers: transformedHeaders,
                            reason: response.statusText,
                            statusCode: response.status,
                            body: body
                        })
                    }));
                return {
                    response: new (0, $1QalE.HttpResponse)({
                        headers: transformedHeaders,
                        reason: response.statusText,
                        statusCode: response.status,
                        body: response.body
                    })
                };
            }),
            (0, $gbm4W.requestTimeout)(requestTimeoutInMs)
        ];
        if (abortSignal) raceOfPromises.push(new Promise((resolve, reject)=>{
            abortSignal.onabort = ()=>{
                const abortError = new Error("Request aborted");
                abortError.name = "AbortError";
                reject(abortError);
            };
        }));
        return Promise.race(raceOfPromises);
    }
    updateHttpClientConfig(key, value) {
        this.config = undefined;
        this.configProvider = this.configProvider.then((config)=>{
            config[key] = value;
            return config;
        });
    }
    httpHandlerConfigs() {
        return this.config ?? {};
    }
}

});
parcelRegister("fo4hU", function(module, exports) {

$parcel$export(module.exports, "buildQueryString", () => $b33c6c5d608280e2$export$6b17a39e52c8ee53);
parcelRequire("ceETf");
var $gFFnP = parcelRequire("gFFnP");
function $b33c6c5d608280e2$export$6b17a39e52c8ee53(query) {
    const parts = [];
    for (let key of Object.keys(query).sort()){
        const value = query[key];
        key = (0, $gFFnP.escapeUri)(key);
        if (Array.isArray(value)) for(let i = 0, iLen = value.length; i < iLen; i++)parts.push(`${key}=${(0, $gFFnP.escapeUri)(value[i])}`);
        else {
            let qsEntry = key;
            if (value || typeof value === "string") qsEntry += `=${(0, $gFFnP.escapeUri)(value)}`;
            parts.push(qsEntry);
        }
    }
    return parts.join("&");
}

});
parcelRegister("ceETf", function(module, exports) {
$parcel$export(module.exports, "escapeUri", () => (parcelRequire("gFFnP")).escapeUri);
parcelRequire("gFFnP");
parcelRequire("lX1ZU");

});
parcelRegister("gFFnP", function(module, exports) {

$parcel$export(module.exports, "escapeUri", () => $c230938962a34f83$export$c3b4775ad75a73db);
const $c230938962a34f83$export$c3b4775ad75a73db = (uri)=>encodeURIComponent(uri).replace(/[!'()*]/g, $c230938962a34f83$var$hexEncode);
const $c230938962a34f83$var$hexEncode = (c)=>`%${c.charCodeAt(0).toString(16).toUpperCase()}`;

});

parcelRegister("lX1ZU", function(module, exports) {

var $gFFnP = parcelRequire("gFFnP");
const $ffb0a84f2579a63c$export$547c045505a754ef = (uri)=>uri.split("/").map((0, $gFFnP.escapeUri)).join("/");

});



parcelRegister("gbm4W", function(module, exports) {

$parcel$export(module.exports, "requestTimeout", () => $bc7ecccc4e1e24f5$export$363ac302bdbd807b);
function $bc7ecccc4e1e24f5$export$363ac302bdbd807b(timeoutInMs = 0) {
    return new Promise((resolve, reject)=>{
        if (timeoutInMs) setTimeout(()=>{
            const timeoutError = new Error(`Request did not complete within ${timeoutInMs} ms`);
            timeoutError.name = "TimeoutError";
            reject(timeoutError);
        }, timeoutInMs);
    });
}

});


parcelRegister("ahmip", function(module, exports) {

$parcel$export(module.exports, "streamCollector", () => $77bcc967b1ff36be$export$17bf97b72e307d52);
parcelRequire("cteja");
var $6Gr16 = parcelRequire("6Gr16");
const $77bcc967b1ff36be$export$17bf97b72e307d52 = (stream)=>{
    if (typeof Blob === "function" && stream instanceof Blob) return $77bcc967b1ff36be$var$collectBlob(stream);
    return $77bcc967b1ff36be$var$collectStream(stream);
};
async function $77bcc967b1ff36be$var$collectBlob(blob) {
    const base64 = await $77bcc967b1ff36be$var$readToBase64(blob);
    const arrayBuffer = (0, $6Gr16.fromBase64)(base64);
    return new Uint8Array(arrayBuffer);
}
async function $77bcc967b1ff36be$var$collectStream(stream) {
    let res = new Uint8Array(0);
    const reader = stream.getReader();
    let isDone = false;
    while(!isDone){
        const { done: done, value: value } = await reader.read();
        if (value) {
            const prior = res;
            res = new Uint8Array(prior.length + value.length);
            res.set(prior);
            res.set(value, prior.length);
        }
        isDone = done;
    }
    return res;
}
function $77bcc967b1ff36be$var$readToBase64(blob) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onloadend = ()=>{
            if (reader.readyState !== 2) return reject(new Error("Reader aborted too early"));
            const result = reader.result ?? "";
            const commaIndex = result.indexOf(",");
            const dataOffset = commaIndex > -1 ? commaIndex + 1 : result.length;
            resolve(result.substring(dataOffset));
        };
        reader.onabort = ()=>reject(new Error("Read aborted"));
        reader.onerror = ()=>reject(reader.error);
        reader.readAsDataURL(blob);
    });
}

});


parcelRegister("i6ugP", function(module, exports) {

$parcel$export(module.exports, "fromHex", () => $d2e0449c26888881$export$1a8ceedbd5845648);
$parcel$export(module.exports, "toHex", () => $d2e0449c26888881$export$7ea66e3774a60b67);
const $d2e0449c26888881$var$SHORT_TO_HEX = {};
const $d2e0449c26888881$var$HEX_TO_SHORT = {};
for(let i = 0; i < 256; i++){
    let encodedByte = i.toString(16).toLowerCase();
    if (encodedByte.length === 1) encodedByte = `0${encodedByte}`;
    $d2e0449c26888881$var$SHORT_TO_HEX[i] = encodedByte;
    $d2e0449c26888881$var$HEX_TO_SHORT[encodedByte] = i;
}
function $d2e0449c26888881$export$1a8ceedbd5845648(encoded) {
    if (encoded.length % 2 !== 0) throw new Error("Hex encoded strings must have an even number length");
    const out = new Uint8Array(encoded.length / 2);
    for(let i = 0; i < encoded.length; i += 2){
        const encodedByte = encoded.slice(i, i + 2).toLowerCase();
        if (encodedByte in $d2e0449c26888881$var$HEX_TO_SHORT) out[i / 2] = $d2e0449c26888881$var$HEX_TO_SHORT[encodedByte];
        else throw new Error(`Cannot decode unrecognized sequence ${encodedByte} as hexadecimal`);
    }
    return out;
}
function $d2e0449c26888881$export$7ea66e3774a60b67(bytes) {
    let out = "";
    for(let i = 0; i < bytes.byteLength; i++)out += $d2e0449c26888881$var$SHORT_TO_HEX[bytes[i]];
    return out;
}

});




parcelRegister("hMwCU", function(module, exports) {

$parcel$export(module.exports, "Command", () => $cf203a510ad685d0$export$cc7e12c76513e857);
parcelRequire("5H29d");
var $2jfjD = parcelRequire("2jfjD");
parcelRequire("8t4sF");
var $glfQ7 = parcelRequire("glfQ7");
class $cf203a510ad685d0$export$cc7e12c76513e857 {
    constructor(){
        this.middlewareStack = (0, $2jfjD.constructStack)();
    }
    static classBuilder() {
        return new $cf203a510ad685d0$var$ClassBuilder();
    }
    resolveMiddlewareWithContext(clientStack, configuration, options, { middlewareFn: middlewareFn, clientName: clientName, commandName: commandName, inputFilterSensitiveLog: inputFilterSensitiveLog, outputFilterSensitiveLog: outputFilterSensitiveLog, smithyContext: smithyContext, additionalContext: additionalContext, CommandCtor: CommandCtor }) {
        for (const mw of middlewareFn.bind(this)(CommandCtor, clientStack, configuration, options))this.middlewareStack.use(mw);
        const stack = clientStack.concat(this.middlewareStack);
        const { logger: logger } = configuration;
        const handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: inputFilterSensitiveLog,
            outputFilterSensitiveLog: outputFilterSensitiveLog,
            [(0, $glfQ7.SMITHY_CONTEXT_KEY)]: {
                ...smithyContext
            },
            ...additionalContext
        };
        const { requestHandler: requestHandler } = configuration;
        return stack.resolve((request)=>requestHandler.handle(request.request, options || {}), handlerExecutionContext);
    }
}
class $cf203a510ad685d0$var$ClassBuilder {
    constructor(){
        this._init = ()=>{};
        this._ep = {};
        this._middlewareFn = ()=>[];
        this._commandName = "";
        this._clientName = "";
        this._additionalContext = {};
        this._smithyContext = {};
        this._inputFilterSensitiveLog = (_)=>_;
        this._outputFilterSensitiveLog = (_)=>_;
        this._serializer = null;
        this._deserializer = null;
    }
    init(cb) {
        this._init = cb;
    }
    ep(endpointParameterInstructions) {
        this._ep = endpointParameterInstructions;
        return this;
    }
    m(middlewareSupplier) {
        this._middlewareFn = middlewareSupplier;
        return this;
    }
    s(service, operation, smithyContext = {}) {
        this._smithyContext = {
            service: service,
            operation: operation,
            ...smithyContext
        };
        return this;
    }
    c(additionalContext = {}) {
        this._additionalContext = additionalContext;
        return this;
    }
    n(clientName, commandName) {
        this._clientName = clientName;
        this._commandName = commandName;
        return this;
    }
    f(inputFilter = (_)=>_, outputFilter = (_)=>_) {
        this._inputFilterSensitiveLog = inputFilter;
        this._outputFilterSensitiveLog = outputFilter;
        return this;
    }
    ser(serializer) {
        this._serializer = serializer;
        return this;
    }
    de(deserializer) {
        this._deserializer = deserializer;
        return this;
    }
    build() {
        const closure = this;
        let CommandRef;
        return CommandRef = class extends $cf203a510ad685d0$export$cc7e12c76513e857 {
            static getEndpointParameterInstructions() {
                return closure._ep;
            }
            constructor(...[input]){
                super();
                this.serialize = closure._serializer;
                this.deserialize = closure._deserializer;
                this.input = input ?? {};
                closure._init(this);
            }
            resolveMiddleware(stack, configuration, options) {
                return this.resolveMiddlewareWithContext(stack, configuration, options, {
                    CommandCtor: CommandRef,
                    middlewareFn: closure._middlewareFn,
                    clientName: closure._clientName,
                    commandName: closure._commandName,
                    inputFilterSensitiveLog: closure._inputFilterSensitiveLog,
                    outputFilterSensitiveLog: closure._outputFilterSensitiveLog,
                    smithyContext: closure._smithyContext,
                    additionalContext: closure._additionalContext
                });
            }
        };
    }
}

});

parcelRegister("4HRM9", function(module, exports) {

$parcel$export(module.exports, "SENSITIVE_STRING", () => $36d4e4475956414c$export$17127055dc9ac067);
const $36d4e4475956414c$export$17127055dc9ac067 = "***SensitiveInformation***";

});

parcelRegister("e9XFc", function(module, exports) {
const $a4f02fe7f5459643$export$d13079724e1f0e8b = (commands, Client)=>{
    for (const command of Object.keys(commands)){
        const CommandCtor = commands[command];
        const methodImpl = async function(args, optionsOrCb, cb) {
            const command = new CommandCtor(args);
            if (typeof optionsOrCb === "function") this.send(command, optionsOrCb);
            else if (typeof cb === "function") {
                if (typeof optionsOrCb !== "object") throw new Error(`Expected http options but got ${typeof optionsOrCb}`);
                this.send(command, optionsOrCb || {}, cb);
            } else return this.send(command, optionsOrCb);
        };
        const methodName = (command[0].toLowerCase() + command.slice(1)).replace(/Command$/, "");
        Client.prototype[methodName] = methodImpl;
    }
};

});

parcelRegister("d8z3h", function(module, exports) {

$parcel$export(module.exports, "parseRfc3339DateTime", () => $9907364bfb8cfe95$export$202e14f4d6038b6c);
$parcel$export(module.exports, "parseRfc3339DateTimeWithOffset", () => $9907364bfb8cfe95$export$3cb821e2875b4b7d);
$parcel$export(module.exports, "parseEpochTimestamp", () => $9907364bfb8cfe95$export$685da212e4e79e10);

var $cXA1B = parcelRequire("cXA1B");
const $9907364bfb8cfe95$var$DAYS = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat"
];
const $9907364bfb8cfe95$var$MONTHS = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
function $9907364bfb8cfe95$export$5b50865171ed23a9(date) {
    const year = date.getUTCFullYear();
    const month = date.getUTCMonth();
    const dayOfWeek = date.getUTCDay();
    const dayOfMonthInt = date.getUTCDate();
    const hoursInt = date.getUTCHours();
    const minutesInt = date.getUTCMinutes();
    const secondsInt = date.getUTCSeconds();
    const dayOfMonthString = dayOfMonthInt < 10 ? `0${dayOfMonthInt}` : `${dayOfMonthInt}`;
    const hoursString = hoursInt < 10 ? `0${hoursInt}` : `${hoursInt}`;
    const minutesString = minutesInt < 10 ? `0${minutesInt}` : `${minutesInt}`;
    const secondsString = secondsInt < 10 ? `0${secondsInt}` : `${secondsInt}`;
    return `${$9907364bfb8cfe95$var$DAYS[dayOfWeek]}, ${dayOfMonthString} ${$9907364bfb8cfe95$var$MONTHS[month]} ${year} ${hoursString}:${minutesString}:${secondsString} GMT`;
}
const $9907364bfb8cfe95$var$RFC3339 = new RegExp(/^(\d{4})-(\d{2})-(\d{2})[tT](\d{2}):(\d{2}):(\d{2})(?:\.(\d+))?[zZ]$/);
const $9907364bfb8cfe95$export$202e14f4d6038b6c = (value)=>{
    if (value === null || value === undefined) return undefined;
    if (typeof value !== "string") throw new TypeError("RFC-3339 date-times must be expressed as strings");
    const match = $9907364bfb8cfe95$var$RFC3339.exec(value);
    if (!match) throw new TypeError("Invalid RFC-3339 date-time value");
    const [_, yearStr, monthStr, dayStr, hours, minutes, seconds, fractionalMilliseconds] = match;
    const year = (0, $cXA1B.strictParseShort)($9907364bfb8cfe95$var$stripLeadingZeroes(yearStr));
    const month = $9907364bfb8cfe95$var$parseDateValue(monthStr, "month", 1, 12);
    const day = $9907364bfb8cfe95$var$parseDateValue(dayStr, "day", 1, 31);
    return $9907364bfb8cfe95$var$buildDate(year, month, day, {
        hours: hours,
        minutes: minutes,
        seconds: seconds,
        fractionalMilliseconds: fractionalMilliseconds
    });
};
const $9907364bfb8cfe95$var$RFC3339_WITH_OFFSET = new RegExp(/^(\d{4})-(\d{2})-(\d{2})[tT](\d{2}):(\d{2}):(\d{2})(?:\.(\d+))?(([-+]\d{2}\:\d{2})|[zZ])$/);
const $9907364bfb8cfe95$export$3cb821e2875b4b7d = (value)=>{
    if (value === null || value === undefined) return undefined;
    if (typeof value !== "string") throw new TypeError("RFC-3339 date-times must be expressed as strings");
    const match = $9907364bfb8cfe95$var$RFC3339_WITH_OFFSET.exec(value);
    if (!match) throw new TypeError("Invalid RFC-3339 date-time value");
    const [_, yearStr, monthStr, dayStr, hours, minutes, seconds, fractionalMilliseconds, offsetStr] = match;
    const year = (0, $cXA1B.strictParseShort)($9907364bfb8cfe95$var$stripLeadingZeroes(yearStr));
    const month = $9907364bfb8cfe95$var$parseDateValue(monthStr, "month", 1, 12);
    const day = $9907364bfb8cfe95$var$parseDateValue(dayStr, "day", 1, 31);
    const date = $9907364bfb8cfe95$var$buildDate(year, month, day, {
        hours: hours,
        minutes: minutes,
        seconds: seconds,
        fractionalMilliseconds: fractionalMilliseconds
    });
    if (offsetStr.toUpperCase() != "Z") date.setTime(date.getTime() - $9907364bfb8cfe95$var$parseOffsetToMilliseconds(offsetStr));
    return date;
};
const $9907364bfb8cfe95$var$IMF_FIXDATE = new RegExp(/^(?:Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d{2}) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d{1,2}):(\d{2}):(\d{2})(?:\.(\d+))? GMT$/);
const $9907364bfb8cfe95$var$RFC_850_DATE = new RegExp(/^(?:Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d{2})-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d{2}) (\d{1,2}):(\d{2}):(\d{2})(?:\.(\d+))? GMT$/);
const $9907364bfb8cfe95$var$ASC_TIME = new RegExp(/^(?:Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( [1-9]|\d{2}) (\d{1,2}):(\d{2}):(\d{2})(?:\.(\d+))? (\d{4})$/);
const $9907364bfb8cfe95$export$cf3a566289648a1e = (value)=>{
    if (value === null || value === undefined) return undefined;
    if (typeof value !== "string") throw new TypeError("RFC-7231 date-times must be expressed as strings");
    let match = $9907364bfb8cfe95$var$IMF_FIXDATE.exec(value);
    if (match) {
        const [_, dayStr, monthStr, yearStr, hours, minutes, seconds, fractionalMilliseconds] = match;
        return $9907364bfb8cfe95$var$buildDate((0, $cXA1B.strictParseShort)($9907364bfb8cfe95$var$stripLeadingZeroes(yearStr)), $9907364bfb8cfe95$var$parseMonthByShortName(monthStr), $9907364bfb8cfe95$var$parseDateValue(dayStr, "day", 1, 31), {
            hours: hours,
            minutes: minutes,
            seconds: seconds,
            fractionalMilliseconds: fractionalMilliseconds
        });
    }
    match = $9907364bfb8cfe95$var$RFC_850_DATE.exec(value);
    if (match) {
        const [_, dayStr, monthStr, yearStr, hours, minutes, seconds, fractionalMilliseconds] = match;
        return $9907364bfb8cfe95$var$adjustRfc850Year($9907364bfb8cfe95$var$buildDate($9907364bfb8cfe95$var$parseTwoDigitYear(yearStr), $9907364bfb8cfe95$var$parseMonthByShortName(monthStr), $9907364bfb8cfe95$var$parseDateValue(dayStr, "day", 1, 31), {
            hours: hours,
            minutes: minutes,
            seconds: seconds,
            fractionalMilliseconds: fractionalMilliseconds
        }));
    }
    match = $9907364bfb8cfe95$var$ASC_TIME.exec(value);
    if (match) {
        const [_, monthStr, dayStr, hours, minutes, seconds, fractionalMilliseconds, yearStr] = match;
        return $9907364bfb8cfe95$var$buildDate((0, $cXA1B.strictParseShort)($9907364bfb8cfe95$var$stripLeadingZeroes(yearStr)), $9907364bfb8cfe95$var$parseMonthByShortName(monthStr), $9907364bfb8cfe95$var$parseDateValue(dayStr.trimLeft(), "day", 1, 31), {
            hours: hours,
            minutes: minutes,
            seconds: seconds,
            fractionalMilliseconds: fractionalMilliseconds
        });
    }
    throw new TypeError("Invalid RFC-7231 date-time value");
};
const $9907364bfb8cfe95$export$685da212e4e79e10 = (value)=>{
    if (value === null || value === undefined) return undefined;
    let valueAsDouble;
    if (typeof value === "number") valueAsDouble = value;
    else if (typeof value === "string") valueAsDouble = (0, $cXA1B.strictParseDouble)(value);
    else throw new TypeError("Epoch timestamps must be expressed as floating point numbers or their string representation");
    if (Number.isNaN(valueAsDouble) || valueAsDouble === Infinity || valueAsDouble === -Infinity) throw new TypeError("Epoch timestamps must be valid, non-Infinite, non-NaN numerics");
    return new Date(Math.round(valueAsDouble * 1000));
};
const $9907364bfb8cfe95$var$buildDate = (year, month, day, time)=>{
    const adjustedMonth = month - 1;
    $9907364bfb8cfe95$var$validateDayOfMonth(year, adjustedMonth, day);
    return new Date(Date.UTC(year, adjustedMonth, day, $9907364bfb8cfe95$var$parseDateValue(time.hours, "hour", 0, 23), $9907364bfb8cfe95$var$parseDateValue(time.minutes, "minute", 0, 59), $9907364bfb8cfe95$var$parseDateValue(time.seconds, "seconds", 0, 60), $9907364bfb8cfe95$var$parseMilliseconds(time.fractionalMilliseconds)));
};
const $9907364bfb8cfe95$var$parseTwoDigitYear = (value)=>{
    const thisYear = new Date().getUTCFullYear();
    const valueInThisCentury = Math.floor(thisYear / 100) * 100 + (0, $cXA1B.strictParseShort)($9907364bfb8cfe95$var$stripLeadingZeroes(value));
    if (valueInThisCentury < thisYear) return valueInThisCentury + 100;
    return valueInThisCentury;
};
const $9907364bfb8cfe95$var$FIFTY_YEARS_IN_MILLIS = 1576800000000;
const $9907364bfb8cfe95$var$adjustRfc850Year = (input)=>{
    if (input.getTime() - new Date().getTime() > $9907364bfb8cfe95$var$FIFTY_YEARS_IN_MILLIS) return new Date(Date.UTC(input.getUTCFullYear() - 100, input.getUTCMonth(), input.getUTCDate(), input.getUTCHours(), input.getUTCMinutes(), input.getUTCSeconds(), input.getUTCMilliseconds()));
    return input;
};
const $9907364bfb8cfe95$var$parseMonthByShortName = (value)=>{
    const monthIdx = $9907364bfb8cfe95$var$MONTHS.indexOf(value);
    if (monthIdx < 0) throw new TypeError(`Invalid month: ${value}`);
    return monthIdx + 1;
};
const $9907364bfb8cfe95$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
const $9907364bfb8cfe95$var$validateDayOfMonth = (year, month, day)=>{
    let maxDays = $9907364bfb8cfe95$var$DAYS_IN_MONTH[month];
    if (month === 1 && $9907364bfb8cfe95$var$isLeapYear(year)) maxDays = 29;
    if (day > maxDays) throw new TypeError(`Invalid day for ${$9907364bfb8cfe95$var$MONTHS[month]} in ${year}: ${day}`);
};
const $9907364bfb8cfe95$var$isLeapYear = (year)=>{
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
};
const $9907364bfb8cfe95$var$parseDateValue = (value, type, lower, upper)=>{
    const dateVal = (0, $cXA1B.strictParseByte)($9907364bfb8cfe95$var$stripLeadingZeroes(value));
    if (dateVal < lower || dateVal > upper) throw new TypeError(`${type} must be between ${lower} and ${upper}, inclusive`);
    return dateVal;
};
const $9907364bfb8cfe95$var$parseMilliseconds = (value)=>{
    if (value === null || value === undefined) return 0;
    return (0, $cXA1B.strictParseFloat32)("0." + value) * 1000;
};
const $9907364bfb8cfe95$var$parseOffsetToMilliseconds = (value)=>{
    const directionStr = value[0];
    let direction = 1;
    if (directionStr == "+") direction = 1;
    else if (directionStr == "-") direction = -1;
    else throw new TypeError(`Offset direction, ${directionStr}, must be "+" or "-"`);
    const hour = Number(value.substring(1, 3));
    const minute = Number(value.substring(4, 6));
    return direction * (hour * 60 + minute) * 60000;
};
const $9907364bfb8cfe95$var$stripLeadingZeroes = (value)=>{
    let idx = 0;
    while(idx < value.length - 1 && value.charAt(idx) === "0")idx++;
    if (idx === 0) return value;
    return value.slice(idx);
};

});
parcelRegister("cXA1B", function(module, exports) {

$parcel$export(module.exports, "expectBoolean", () => $96f6f07f2e383536$export$259b2ebfc29bf466);
$parcel$export(module.exports, "expectNumber", () => $96f6f07f2e383536$export$f3945e48fdb5f9a);
$parcel$export(module.exports, "expectInt32", () => $96f6f07f2e383536$export$99c64e845cdac9c1);
$parcel$export(module.exports, "expectNonNull", () => $96f6f07f2e383536$export$8413a63dbe548a49);
$parcel$export(module.exports, "expectObject", () => $96f6f07f2e383536$export$cf825aadce530e7e);
$parcel$export(module.exports, "expectString", () => $96f6f07f2e383536$export$7ed80f53fe336639);
$parcel$export(module.exports, "strictParseDouble", () => $96f6f07f2e383536$export$89e17ed633a86621);
$parcel$export(module.exports, "strictParseFloat32", () => $96f6f07f2e383536$export$b15cbcea8b4c492f);
$parcel$export(module.exports, "limitedParseDouble", () => $96f6f07f2e383536$export$11335e83c8af2784);
$parcel$export(module.exports, "strictParseInt32", () => $96f6f07f2e383536$export$c3c2f00b115709e6);
$parcel$export(module.exports, "strictParseShort", () => $96f6f07f2e383536$export$813d4a13f25c6b38);
$parcel$export(module.exports, "strictParseByte", () => $96f6f07f2e383536$export$f18d20ea3b6b353);
const $96f6f07f2e383536$export$3fb54149990fb5b5 = (value)=>{
    switch(value){
        case "true":
            return true;
        case "false":
            return false;
        default:
            throw new Error(`Unable to parse boolean value "${value}"`);
    }
};
const $96f6f07f2e383536$export$259b2ebfc29bf466 = (value)=>{
    if (value === null || value === undefined) return undefined;
    if (typeof value === "number") {
        if (value === 0 || value === 1) $96f6f07f2e383536$export$af88d00dbe7f521.warn($96f6f07f2e383536$var$stackTraceWarning(`Expected boolean, got ${typeof value}: ${value}`));
        if (value === 0) return false;
        if (value === 1) return true;
    }
    if (typeof value === "string") {
        const lower = value.toLowerCase();
        if (lower === "false" || lower === "true") $96f6f07f2e383536$export$af88d00dbe7f521.warn($96f6f07f2e383536$var$stackTraceWarning(`Expected boolean, got ${typeof value}: ${value}`));
        if (lower === "false") return false;
        if (lower === "true") return true;
    }
    if (typeof value === "boolean") return value;
    throw new TypeError(`Expected boolean, got ${typeof value}: ${value}`);
};
const $96f6f07f2e383536$export$f3945e48fdb5f9a = (value)=>{
    if (value === null || value === undefined) return undefined;
    if (typeof value === "string") {
        const parsed = parseFloat(value);
        if (!Number.isNaN(parsed)) {
            if (String(parsed) !== String(value)) $96f6f07f2e383536$export$af88d00dbe7f521.warn($96f6f07f2e383536$var$stackTraceWarning(`Expected number but observed string: ${value}`));
            return parsed;
        }
    }
    if (typeof value === "number") return value;
    throw new TypeError(`Expected number, got ${typeof value}: ${value}`);
};
const $96f6f07f2e383536$var$MAX_FLOAT = Math.ceil(2 ** 127 * (2 - 2 ** -23));
const $96f6f07f2e383536$export$44880ec4d8d4909d = (value)=>{
    const expected = $96f6f07f2e383536$export$f3945e48fdb5f9a(value);
    if (expected !== undefined && !Number.isNaN(expected) && expected !== Infinity && expected !== -Infinity) {
        if (Math.abs(expected) > $96f6f07f2e383536$var$MAX_FLOAT) throw new TypeError(`Expected 32-bit float, got ${value}`);
    }
    return expected;
};
const $96f6f07f2e383536$export$a883517a83c9c18 = (value)=>{
    if (value === null || value === undefined) return undefined;
    if (Number.isInteger(value) && !Number.isNaN(value)) return value;
    throw new TypeError(`Expected integer, got ${typeof value}: ${value}`);
};
const $96f6f07f2e383536$export$dbec7593c34ded08 = $96f6f07f2e383536$export$a883517a83c9c18;
const $96f6f07f2e383536$export$99c64e845cdac9c1 = (value)=>$96f6f07f2e383536$var$expectSizedInt(value, 32);
const $96f6f07f2e383536$export$d4f903340b146129 = (value)=>$96f6f07f2e383536$var$expectSizedInt(value, 16);
const $96f6f07f2e383536$export$3e4c4435b3b19562 = (value)=>$96f6f07f2e383536$var$expectSizedInt(value, 8);
const $96f6f07f2e383536$var$expectSizedInt = (value, size)=>{
    const expected = $96f6f07f2e383536$export$a883517a83c9c18(value);
    if (expected !== undefined && $96f6f07f2e383536$var$castInt(expected, size) !== expected) throw new TypeError(`Expected ${size}-bit integer, got ${value}`);
    return expected;
};
const $96f6f07f2e383536$var$castInt = (value, size)=>{
    switch(size){
        case 32:
            return Int32Array.of(value)[0];
        case 16:
            return Int16Array.of(value)[0];
        case 8:
            return Int8Array.of(value)[0];
    }
};
const $96f6f07f2e383536$export$8413a63dbe548a49 = (value, location)=>{
    if (value === null || value === undefined) {
        if (location) throw new TypeError(`Expected a non-null value for ${location}`);
        throw new TypeError("Expected a non-null value");
    }
    return value;
};
const $96f6f07f2e383536$export$cf825aadce530e7e = (value)=>{
    if (value === null || value === undefined) return undefined;
    if (typeof value === "object" && !Array.isArray(value)) return value;
    const receivedType = Array.isArray(value) ? "array" : typeof value;
    throw new TypeError(`Expected object, got ${receivedType}: ${value}`);
};
const $96f6f07f2e383536$export$7ed80f53fe336639 = (value)=>{
    if (value === null || value === undefined) return undefined;
    if (typeof value === "string") return value;
    if ([
        "boolean",
        "number",
        "bigint"
    ].includes(typeof value)) {
        $96f6f07f2e383536$export$af88d00dbe7f521.warn($96f6f07f2e383536$var$stackTraceWarning(`Expected string, got ${typeof value}: ${value}`));
        return String(value);
    }
    throw new TypeError(`Expected string, got ${typeof value}: ${value}`);
};
const $96f6f07f2e383536$export$9ef77073e45b6301 = (value)=>{
    if (value === null || value === undefined) return undefined;
    const asObject = $96f6f07f2e383536$export$cf825aadce530e7e(value);
    const setKeys = Object.entries(asObject).filter(([, v])=>v != null).map(([k])=>k);
    if (setKeys.length === 0) throw new TypeError(`Unions must have exactly one non-null member. None were found.`);
    if (setKeys.length > 1) throw new TypeError(`Unions must have exactly one non-null member. Keys ${setKeys} were not null.`);
    return asObject;
};
const $96f6f07f2e383536$export$89e17ed633a86621 = (value)=>{
    if (typeof value == "string") return $96f6f07f2e383536$export$f3945e48fdb5f9a($96f6f07f2e383536$var$parseNumber(value));
    return $96f6f07f2e383536$export$f3945e48fdb5f9a(value);
};
const $96f6f07f2e383536$export$884f8e3b42a6cfbf = $96f6f07f2e383536$export$89e17ed633a86621;
const $96f6f07f2e383536$export$b15cbcea8b4c492f = (value)=>{
    if (typeof value == "string") return $96f6f07f2e383536$export$44880ec4d8d4909d($96f6f07f2e383536$var$parseNumber(value));
    return $96f6f07f2e383536$export$44880ec4d8d4909d(value);
};
const $96f6f07f2e383536$var$NUMBER_REGEX = /(-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?)|(-?Infinity)|(NaN)/g;
const $96f6f07f2e383536$var$parseNumber = (value)=>{
    const matches = value.match($96f6f07f2e383536$var$NUMBER_REGEX);
    if (matches === null || matches[0].length !== value.length) throw new TypeError(`Expected real number, got implicit NaN`);
    return parseFloat(value);
};
const $96f6f07f2e383536$export$11335e83c8af2784 = (value)=>{
    if (typeof value == "string") return $96f6f07f2e383536$var$parseFloatString(value);
    return $96f6f07f2e383536$export$f3945e48fdb5f9a(value);
};
const $96f6f07f2e383536$export$b6a7906d2e4b31df = $96f6f07f2e383536$export$11335e83c8af2784;
const $96f6f07f2e383536$export$50b04c19f942a079 = $96f6f07f2e383536$export$11335e83c8af2784;
const $96f6f07f2e383536$export$f14938f3036dd492 = (value)=>{
    if (typeof value == "string") return $96f6f07f2e383536$var$parseFloatString(value);
    return $96f6f07f2e383536$export$44880ec4d8d4909d(value);
};
const $96f6f07f2e383536$var$parseFloatString = (value)=>{
    switch(value){
        case "NaN":
            return NaN;
        case "Infinity":
            return Infinity;
        case "-Infinity":
            return -Infinity;
        default:
            throw new Error(`Unable to parse float value: ${value}`);
    }
};
const $96f6f07f2e383536$export$f90617f39a736d36 = (value)=>{
    if (typeof value === "string") return $96f6f07f2e383536$export$a883517a83c9c18($96f6f07f2e383536$var$parseNumber(value));
    return $96f6f07f2e383536$export$a883517a83c9c18(value);
};
const $96f6f07f2e383536$export$39b7be5d28a09fe1 = $96f6f07f2e383536$export$f90617f39a736d36;
const $96f6f07f2e383536$export$c3c2f00b115709e6 = (value)=>{
    if (typeof value === "string") return $96f6f07f2e383536$export$99c64e845cdac9c1($96f6f07f2e383536$var$parseNumber(value));
    return $96f6f07f2e383536$export$99c64e845cdac9c1(value);
};
const $96f6f07f2e383536$export$813d4a13f25c6b38 = (value)=>{
    if (typeof value === "string") return $96f6f07f2e383536$export$d4f903340b146129($96f6f07f2e383536$var$parseNumber(value));
    return $96f6f07f2e383536$export$d4f903340b146129(value);
};
const $96f6f07f2e383536$export$f18d20ea3b6b353 = (value)=>{
    if (typeof value === "string") return $96f6f07f2e383536$export$3e4c4435b3b19562($96f6f07f2e383536$var$parseNumber(value));
    return $96f6f07f2e383536$export$3e4c4435b3b19562(value);
};
const $96f6f07f2e383536$var$stackTraceWarning = (message)=>{
    return String(new TypeError(message).stack || message).split("\n").slice(0, 5).filter((s)=>!s.includes("stackTraceWarning")).join("\n");
};
const $96f6f07f2e383536$export$af88d00dbe7f521 = {
    warn: console.warn
};

});


parcelRegister("cYbAK", function(module, exports) {

$parcel$export(module.exports, "withBaseException", () => $9714147e7c6fb7b2$export$62ac8acba1748a85);

var $1CRbD = parcelRequire("1CRbD");
const $9714147e7c6fb7b2$export$3df0f68aaf858737 = ({ output: output, parsedBody: parsedBody, exceptionCtor: exceptionCtor, errorCode: errorCode })=>{
    const $metadata = $9714147e7c6fb7b2$var$deserializeMetadata(output);
    const statusCode = $metadata.httpStatusCode ? $metadata.httpStatusCode + "" : undefined;
    const response = new exceptionCtor({
        name: parsedBody?.code || parsedBody?.Code || errorCode || statusCode || "UnknownError",
        $fault: "client",
        $metadata: $metadata
    });
    throw (0, $1CRbD.decorateServiceException)(response, parsedBody);
};
const $9714147e7c6fb7b2$export$62ac8acba1748a85 = (ExceptionCtor)=>{
    return ({ output: output, parsedBody: parsedBody, errorCode: errorCode })=>{
        $9714147e7c6fb7b2$export$3df0f68aaf858737({
            output: output,
            parsedBody: parsedBody,
            exceptionCtor: ExceptionCtor,
            errorCode: errorCode
        });
    };
};
const $9714147e7c6fb7b2$var$deserializeMetadata = (output)=>({
        httpStatusCode: output.statusCode,
        requestId: output.headers["x-amzn-requestid"] ?? output.headers["x-amzn-request-id"] ?? output.headers["x-amz-request-id"],
        extendedRequestId: output.headers["x-amz-id-2"],
        cfId: output.headers["x-amz-cf-id"]
    });

});
parcelRegister("1CRbD", function(module, exports) {

$parcel$export(module.exports, "ServiceException", () => $12f298d0eaa1e1d8$export$29647f3b4097d3c0);
$parcel$export(module.exports, "decorateServiceException", () => $12f298d0eaa1e1d8$export$db01f0c43e877a50);
class $12f298d0eaa1e1d8$export$29647f3b4097d3c0 extends Error {
    constructor(options){
        super(options.message);
        Object.setPrototypeOf(this, $12f298d0eaa1e1d8$export$29647f3b4097d3c0.prototype);
        this.name = options.name;
        this.$fault = options.$fault;
        this.$metadata = options.$metadata;
    }
}
const $12f298d0eaa1e1d8$export$db01f0c43e877a50 = (exception, additions = {})=>{
    Object.entries(additions).filter(([, v])=>v !== undefined).forEach(([k, v])=>{
        if (exception[k] == undefined || exception[k] === "") exception[k] = v;
    });
    const message = exception.message || exception.Message || "UnknownError";
    exception.message = message;
    delete exception.Message;
    return exception;
};

});


parcelRegister("bOftX", function(module, exports) {

$parcel$export(module.exports, "loadConfigsForDefaultMode", () => $89905fa7ef9f5a76$export$b6e2b46631b45a92);
const $89905fa7ef9f5a76$export$b6e2b46631b45a92 = (mode)=>{
    switch(mode){
        case "standard":
            return {
                retryMode: "standard",
                connectionTimeout: 3100
            };
        case "in-region":
            return {
                retryMode: "standard",
                connectionTimeout: 1100
            };
        case "cross-region":
            return {
                retryMode: "standard",
                connectionTimeout: 3100
            };
        case "mobile":
            return {
                retryMode: "standard",
                connectionTimeout: 30000
            };
        default:
            return {};
    }
};

});

parcelRegister("h3Dxu", function(module, exports) {
let $c6b16327b5012edd$var$warningEmitted = false;
const $c6b16327b5012edd$export$96550b8fa3e6f65a = (version)=>{
    if (version && !$c6b16327b5012edd$var$warningEmitted && parseInt(version.substring(1, version.indexOf("."))) < 14) $c6b16327b5012edd$var$warningEmitted = true;
};

});

parcelRegister("4TJos", function(module, exports) {
$parcel$export(module.exports, "getDefaultExtensionConfiguration", () => (parcelRequire("5Px3r")).getDefaultExtensionConfiguration);
$parcel$export(module.exports, "resolveDefaultRuntimeConfig", () => (parcelRequire("5Px3r")).resolveDefaultRuntimeConfig);
parcelRequire("5Px3r");

});
parcelRegister("5Px3r", function(module, exports) {

$parcel$export(module.exports, "getDefaultExtensionConfiguration", () => $43eb5b1a976beb52$export$2d53aaae46f156f5);
$parcel$export(module.exports, "resolveDefaultRuntimeConfig", () => $43eb5b1a976beb52$export$abfa28b95316e0ae);

var $1I7Vc = parcelRequire("1I7Vc");

var $gC2b7 = parcelRequire("gC2b7");
const $43eb5b1a976beb52$export$2d53aaae46f156f5 = (runtimeConfig)=>{
    return {
        ...(0, $1I7Vc.getChecksumConfiguration)(runtimeConfig),
        ...(0, $gC2b7.getRetryConfiguration)(runtimeConfig)
    };
};
const $43eb5b1a976beb52$export$7081660fd0cd662b = $43eb5b1a976beb52$export$2d53aaae46f156f5;
const $43eb5b1a976beb52$export$abfa28b95316e0ae = (config)=>{
    return {
        ...(0, $1I7Vc.resolveChecksumRuntimeConfig)(config),
        ...(0, $gC2b7.resolveRetryRuntimeConfig)(config)
    };
};

});
parcelRegister("1I7Vc", function(module, exports) {

$parcel$export(module.exports, "getChecksumConfiguration", () => $13f00b8cb0723a4a$export$129b301e72591856);
$parcel$export(module.exports, "resolveChecksumRuntimeConfig", () => $13f00b8cb0723a4a$export$589dfc268e61d391);
parcelRequire("8t4sF");
var $77Pav = parcelRequire("77Pav");
const $13f00b8cb0723a4a$export$129b301e72591856 = (runtimeConfig)=>{
    const checksumAlgorithms = [];
    for(const id in 0, $77Pav.AlgorithmId){
        const algorithmId = (0, $77Pav.AlgorithmId)[id];
        if (runtimeConfig[algorithmId] === undefined) continue;
        checksumAlgorithms.push({
            algorithmId: ()=>algorithmId,
            checksumConstructor: ()=>runtimeConfig[algorithmId]
        });
    }
    return {
        _checksumAlgorithms: checksumAlgorithms,
        addChecksumAlgorithm (algo) {
            this._checksumAlgorithms.push(algo);
        },
        checksumAlgorithms () {
            return this._checksumAlgorithms;
        }
    };
};
const $13f00b8cb0723a4a$export$589dfc268e61d391 = (clientConfig)=>{
    const runtimeConfig = {};
    clientConfig.checksumAlgorithms().forEach((checksumAlgorithm)=>{
        runtimeConfig[checksumAlgorithm.algorithmId()] = checksumAlgorithm.checksumConstructor();
    });
    return runtimeConfig;
};

});

parcelRegister("gC2b7", function(module, exports) {

$parcel$export(module.exports, "getRetryConfiguration", () => $c181e288ebbb2006$export$d36c8ee6d99d60f7);
$parcel$export(module.exports, "resolveRetryRuntimeConfig", () => $c181e288ebbb2006$export$67f4c4448e6afddf);
const $c181e288ebbb2006$export$d36c8ee6d99d60f7 = (runtimeConfig)=>{
    let _retryStrategy = runtimeConfig.retryStrategy;
    return {
        setRetryStrategy (retryStrategy) {
            _retryStrategy = retryStrategy;
        },
        retryStrategy () {
            return _retryStrategy;
        }
    };
};
const $c181e288ebbb2006$export$67f4c4448e6afddf = (retryStrategyConfiguration)=>{
    const runtimeConfig = {};
    runtimeConfig.retryStrategy = retryStrategyConfiguration.retryStrategy();
    return runtimeConfig;
};

});



parcelRegister("e2AgL", function(module, exports) {

$parcel$export(module.exports, "extendedEncodeURIComponent", () => $a38d62f4ae4978ef$export$7640f3c16fe7f54b);
function $a38d62f4ae4978ef$export$7640f3c16fe7f54b(str) {
    return encodeURIComponent(str).replace(/[!'()*]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}

});

parcelRegister("dAW7b", function(module, exports) {
const $9e5bb78b2e1da543$export$52272e038712c64e = (mayBeArray)=>Array.isArray(mayBeArray) ? mayBeArray : [
        mayBeArray
    ];

});

parcelRegister("ijICi", function(module, exports) {

$parcel$export(module.exports, "getValueFromTextNode", () => $d55c9c4b267c73ab$export$113d90026b452881);
const $d55c9c4b267c73ab$export$113d90026b452881 = (obj)=>{
    const textNodeName = "#text";
    for(const key in obj){
        if (obj.hasOwnProperty(key) && obj[key][textNodeName] !== undefined) obj[key] = obj[key][textNodeName];
        else if (typeof obj[key] === "object" && obj[key] !== null) obj[key] = $d55c9c4b267c73ab$export$113d90026b452881(obj[key]);
    }
    return obj;
};

});

parcelRegister("iiyLk", function(module, exports) {
const $d524df83621ba262$export$40e2db4f1ce24b10 = function() {
    const Class = Object.getPrototypeOf(this).constructor;
    const Constructor = Function.bind.apply(String, [
        null,
        ...arguments
    ]);
    const instance = new Constructor();
    Object.setPrototypeOf(instance, Class.prototype);
    return instance;
};
$d524df83621ba262$export$40e2db4f1ce24b10.prototype = Object.create(String.prototype, {
    constructor: {
        value: $d524df83621ba262$export$40e2db4f1ce24b10,
        enumerable: false,
        writable: true,
        configurable: true
    }
});
Object.setPrototypeOf($d524df83621ba262$export$40e2db4f1ce24b10, String);
class $d524df83621ba262$export$494ed5148690ecaf extends $d524df83621ba262$export$40e2db4f1ce24b10 {
    deserializeJSON() {
        return JSON.parse(super.toString());
    }
    toJSON() {
        return super.toString();
    }
    static fromObject(object) {
        if (object instanceof $d524df83621ba262$export$494ed5148690ecaf) return object;
        else if (object instanceof String || typeof object === "string") return new $d524df83621ba262$export$494ed5148690ecaf(object);
        return new $d524df83621ba262$export$494ed5148690ecaf(JSON.stringify(object));
    }
}

});

parcelRegister("eJMW4", function(module, exports) {

$parcel$export(module.exports, "map", () => $abab3a4381809583$export$871de8747c9eaa88);
$parcel$export(module.exports, "take", () => $abab3a4381809583$export$b7df5d561049483a);
function $abab3a4381809583$export$871de8747c9eaa88(arg0, arg1, arg2) {
    let target;
    let filter;
    let instructions;
    if (typeof arg1 === "undefined" && typeof arg2 === "undefined") {
        target = {};
        instructions = arg0;
    } else {
        target = arg0;
        if (typeof arg1 === "function") {
            filter = arg1;
            instructions = arg2;
            return $abab3a4381809583$var$mapWithFilter(target, filter, instructions);
        } else instructions = arg1;
    }
    for (const key of Object.keys(instructions)){
        if (!Array.isArray(instructions[key])) {
            target[key] = instructions[key];
            continue;
        }
        $abab3a4381809583$var$applyInstruction(target, null, instructions, key);
    }
    return target;
}
const $abab3a4381809583$export$a2c0df515c751f13 = (target)=>{
    const output = {};
    for (const [k, v] of Object.entries(target || {}))output[k] = [
        ,
        v
    ];
    return output;
};
const $abab3a4381809583$export$b7df5d561049483a = (source, instructions)=>{
    const out = {};
    for(const key in instructions)$abab3a4381809583$var$applyInstruction(out, source, instructions, key);
    return out;
};
const $abab3a4381809583$var$mapWithFilter = (target, filter, instructions)=>{
    return $abab3a4381809583$export$871de8747c9eaa88(target, Object.entries(instructions).reduce((_instructions, [key, value])=>{
        if (Array.isArray(value)) _instructions[key] = value;
        else if (typeof value === "function") _instructions[key] = [
            filter,
            value()
        ];
        else _instructions[key] = [
            filter,
            value
        ];
        return _instructions;
    }, {}));
};
const $abab3a4381809583$var$applyInstruction = (target, source, instructions, targetKey)=>{
    if (source !== null) {
        let instruction = instructions[targetKey];
        if (typeof instruction === "function") instruction = [
            ,
            instruction
        ];
        const [filter = $abab3a4381809583$var$nonNullish, valueFn = $abab3a4381809583$var$pass, sourceKey = targetKey] = instruction;
        if (typeof filter === "function" && filter(source[sourceKey]) || typeof filter !== "function" && !!filter) target[targetKey] = valueFn(source[sourceKey]);
        return;
    }
    let [filter, value] = instructions[targetKey];
    if (typeof value === "function") {
        let _value;
        const defaultFilterPassed = filter === undefined && (_value = value()) != null;
        const customFilterPassed = typeof filter === "function" && !!filter(void 0) || typeof filter !== "function" && !!filter;
        if (defaultFilterPassed) target[targetKey] = _value;
        else if (customFilterPassed) target[targetKey] = value();
    } else {
        const defaultFilterPassed = filter === undefined && value != null;
        const customFilterPassed = typeof filter === "function" && !!filter(value) || typeof filter !== "function" && !!filter;
        if (defaultFilterPassed || customFilterPassed) target[targetKey] = value;
    }
};
const $abab3a4381809583$var$nonNullish = (_)=>_ != null;
const $abab3a4381809583$var$pass = (_)=>_;

});

parcelRegister("8phr2", function(module, exports) {

$parcel$export(module.exports, "resolvedPath", () => $61ee2ec4012a7aba$export$405ac9a9ce1cbd80);

var $e2AgL = parcelRequire("e2AgL");
const $61ee2ec4012a7aba$export$405ac9a9ce1cbd80 = (resolvedPath, input, memberName, labelValueProvider, uriLabel, isGreedyLabel)=>{
    if (input != null && input[memberName] !== undefined) {
        const labelValue = labelValueProvider();
        if (labelValue.length <= 0) throw new Error("Empty value provided for input HTTP label: " + memberName + ".");
        resolvedPath = resolvedPath.replace(uriLabel, isGreedyLabel ? labelValue.split("/").map((segment)=>(0, $e2AgL.extendedEncodeURIComponent)(segment)).join("/") : (0, $e2AgL.extendedEncodeURIComponent)(labelValue));
    } else throw new Error("No value provided for input HTTP label: " + memberName + ".");
    return resolvedPath;
};

});

parcelRegister("iAvye", function(module, exports) {

$parcel$export(module.exports, "serializeFloat", () => $d884103029536750$export$4a2bea4ecaa09ba7);
const $d884103029536750$export$4a2bea4ecaa09ba7 = (value)=>{
    if (value !== value) return "NaN";
    switch(value){
        case Infinity:
            return "Infinity";
        case -Infinity:
            return "-Infinity";
        default:
            return value;
    }
};

});

parcelRegister("Phm09", function(module, exports) {

$parcel$export(module.exports, "_json", () => $09a239a69d1dd14d$export$e0ede334cf6ab53c);
const $09a239a69d1dd14d$export$e0ede334cf6ab53c = (obj)=>{
    if (obj == null) return {};
    if (Array.isArray(obj)) return obj.filter((_)=>_ != null).map($09a239a69d1dd14d$export$e0ede334cf6ab53c);
    if (typeof obj === "object") {
        const target = {};
        for (const key of Object.keys(obj)){
            if (obj[key] == null) continue;
            target[key] = $09a239a69d1dd14d$export$e0ede334cf6ab53c(obj[key]);
        }
        return target;
    }
    return obj;
};

});

parcelRegister("1AVlS", function(module, exports) {
function $1295a41b2dbad102$export$b0cd0cd33296db41(value, delimiter, numDelimiters) {
    if (numDelimiters <= 0 || !Number.isInteger(numDelimiters)) throw new Error("Invalid number of delimiters (" + numDelimiters + ") for splitEvery.");
    const segments = value.split(delimiter);
    if (numDelimiters === 1) return segments;
    const compoundSegments = [];
    let currentSegment = "";
    for(let i = 0; i < segments.length; i++){
        if (currentSegment === "") currentSegment = segments[i];
        else currentSegment += delimiter + segments[i];
        if ((i + 1) % numDelimiters === 0) {
            compoundSegments.push(currentSegment);
            currentSegment = "";
        }
    }
    if (currentSegment !== "") compoundSegments.push(currentSegment);
    return compoundSegments;
}

});


parcelRegister("jjVcP", function(module, exports) {

$parcel$export(module.exports, "isStreamingPayload", () => $e10c2a950ec3178e$export$e29b4465f2a53696);
const $e10c2a950ec3178e$export$e29b4465f2a53696 = (request)=>request?.body instanceof ReadableStream;

});





parcelRegister("B5asE", function(module, exports) {
$parcel$export(module.exports, "DefaultIdentityProviderConfig", () => (parcelRequire("9iah1")).DefaultIdentityProviderConfig);
$parcel$export(module.exports, "NoAuthSigner", () => (parcelRequire("9atsw")).NoAuthSigner);
$parcel$export(module.exports, "doesIdentityRequireRefresh", () => (parcelRequire("9gMMV")).doesIdentityRequireRefresh);
$parcel$export(module.exports, "isIdentityExpired", () => (parcelRequire("9gMMV")).isIdentityExpired);
$parcel$export(module.exports, "memoizeIdentityProvider", () => (parcelRequire("9gMMV")).memoizeIdentityProvider);
parcelRequire("9iah1");
parcelRequire("5sNNj");
parcelRequire("9gMMV");

});
parcelRegister("9iah1", function(module, exports) {

$parcel$export(module.exports, "DefaultIdentityProviderConfig", () => $6c3dc39bc712db73$export$67f43b78065c5551);
class $6c3dc39bc712db73$export$67f43b78065c5551 {
    constructor(config){
        this.authSchemes = new Map();
        for (const [key, value] of Object.entries(config))if (value !== undefined) this.authSchemes.set(key, value);
    }
    getIdentityProvider(schemeId) {
        return this.authSchemes.get(schemeId);
    }
}

});

parcelRegister("5sNNj", function(module, exports) {
$parcel$export(module.exports, "NoAuthSigner", () => (parcelRequire("9atsw")).NoAuthSigner);
parcelRequire("82y5N");
parcelRequire("koHc7");
parcelRequire("9atsw");

});
parcelRegister("82y5N", function(module, exports) {
parcelRequire("8t4sF");
var $lsTwx = parcelRequire("lsTwx");
class $5da8f4b760720d5d$export$823b895391979983 {
    async sign(httpRequest, identity, signingProperties) {
        if (!signingProperties) throw new Error("request could not be signed with `apiKey` since the `name` and `in` signer properties are missing");
        if (!signingProperties.name) throw new Error("request could not be signed with `apiKey` since the `name` signer property is missing");
        if (!signingProperties.in) throw new Error("request could not be signed with `apiKey` since the `in` signer property is missing");
        if (!identity.apiKey) throw new Error("request could not be signed with `apiKey` since the `apiKey` is not defined");
        const clonedRequest = httpRequest.clone();
        if (signingProperties.in === (0, $lsTwx.HttpApiKeyAuthLocation).QUERY) clonedRequest.query[signingProperties.name] = identity.apiKey;
        else if (signingProperties.in === (0, $lsTwx.HttpApiKeyAuthLocation).HEADER) clonedRequest.headers[signingProperties.name] = signingProperties.scheme ? `${signingProperties.scheme} ${identity.apiKey}` : identity.apiKey;
        else throw new Error("request can only be signed with `apiKey` locations `query` or `header`, but found: `" + signingProperties.in + "`");
        return clonedRequest;
    }
}

});

parcelRegister("koHc7", function(module, exports) {
class $ed978e14ab61685f$export$f646f7f27c38a496 {
    async sign(httpRequest, identity, signingProperties) {
        const clonedRequest = httpRequest.clone();
        if (!identity.token) throw new Error("request could not be signed with `token` since the `token` is not defined");
        clonedRequest.headers["Authorization"] = `Bearer ${identity.token}`;
        return clonedRequest;
    }
}

});

parcelRegister("9atsw", function(module, exports) {

$parcel$export(module.exports, "NoAuthSigner", () => $01b8f75336e307c9$export$19622a6daa7bca6e);
class $01b8f75336e307c9$export$19622a6daa7bca6e {
    async sign(httpRequest, identity, signingProperties) {
        return httpRequest;
    }
}

});


parcelRegister("9gMMV", function(module, exports) {

$parcel$export(module.exports, "doesIdentityRequireRefresh", () => $6bfb73fc639ab3f9$export$5fef7ca5b4791fa9);
$parcel$export(module.exports, "isIdentityExpired", () => $6bfb73fc639ab3f9$export$42a11a4dafc8f476);
$parcel$export(module.exports, "memoizeIdentityProvider", () => $6bfb73fc639ab3f9$export$b258763a05c20e85);
const $6bfb73fc639ab3f9$export$4c74afac7567edb5 = (expirationMs)=>(identity)=>$6bfb73fc639ab3f9$export$5fef7ca5b4791fa9(identity) && identity.expiration.getTime() - Date.now() < expirationMs;
const $6bfb73fc639ab3f9$export$1d503351280d1918 = 300000;
const $6bfb73fc639ab3f9$export$42a11a4dafc8f476 = $6bfb73fc639ab3f9$export$4c74afac7567edb5($6bfb73fc639ab3f9$export$1d503351280d1918);
const $6bfb73fc639ab3f9$export$5fef7ca5b4791fa9 = (identity)=>identity.expiration !== undefined;
const $6bfb73fc639ab3f9$export$b258763a05c20e85 = (provider, isExpired, requiresRefresh)=>{
    if (provider === undefined) return undefined;
    const normalizedProvider = typeof provider !== "function" ? async ()=>Promise.resolve(provider) : provider;
    let resolved;
    let pending;
    let hasResult;
    let isConstant = false;
    const coalesceProvider = async (options)=>{
        if (!pending) pending = normalizedProvider(options);
        try {
            resolved = await pending;
            hasResult = true;
            isConstant = false;
        } finally{
            pending = undefined;
        }
        return resolved;
    };
    if (isExpired === undefined) return async (options)=>{
        if (!hasResult || options?.forceRefresh) resolved = await coalesceProvider(options);
        return resolved;
    };
    return async (options)=>{
        if (!hasResult || options?.forceRefresh) resolved = await coalesceProvider(options);
        if (isConstant) return resolved;
        if (!requiresRefresh(resolved)) {
            isConstant = true;
            return resolved;
        }
        if (isExpired(resolved)) {
            await coalesceProvider(options);
            return resolved;
        }
        return resolved;
    };
};

});


parcelRegister("keJph", function(module, exports) {
parcelRequire("8t4sF");
var $glfQ7 = parcelRequire("glfQ7");
const $ebb85643d4334184$export$1d3c197393275463 = (context)=>context[0, $glfQ7.SMITHY_CONTEXT_KEY] || (context[0, $glfQ7.SMITHY_CONTEXT_KEY] = {});

});

parcelRegister("g5Jyl", function(module, exports) {

$parcel$export(module.exports, "normalizeProvider", () => $bb7072d8b8367da6$export$b1276c07738d6325);
const $bb7072d8b8367da6$export$b1276c07738d6325 = (input)=>{
    if (typeof input === "function") return input;
    const promisified = Promise.resolve(input);
    return ()=>promisified;
};

});

parcelRegister("ld8GT", function(module, exports) {

$parcel$export(module.exports, "requestBuilder", () => $f7118db65a9b8142$export$9f1f89e694d26cd0);
parcelRequire("AueTL");
var $Yl5TU = parcelRequire("Yl5TU");
parcelRequire("33pc1");
var $8phr2 = parcelRequire("8phr2");
function $f7118db65a9b8142$export$9f1f89e694d26cd0(input, context) {
    return new $f7118db65a9b8142$export$e63ecf257fa6a994(input, context);
}
class $f7118db65a9b8142$export$e63ecf257fa6a994 {
    constructor(input, context){
        this.input = input;
        this.context = context;
        this.query = {};
        this.method = "";
        this.headers = {};
        this.path = "";
        this.body = null;
        this.hostname = "";
        this.resolvePathStack = [];
    }
    async build() {
        const { hostname: hostname, protocol: protocol = "https", port: port, path: basePath } = await this.context.endpoint();
        this.path = basePath;
        for (const resolvePath of this.resolvePathStack)resolvePath(this.path);
        return new (0, $Yl5TU.HttpRequest)({
            protocol: protocol,
            hostname: this.hostname || hostname,
            port: port,
            method: this.method,
            path: this.path,
            query: this.query,
            body: this.body,
            headers: this.headers
        });
    }
    hn(hostname) {
        this.hostname = hostname;
        return this;
    }
    bp(uriLabel) {
        this.resolvePathStack.push((basePath)=>{
            this.path = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + uriLabel;
        });
        return this;
    }
    p(memberName, labelValueProvider, uriLabel, isGreedyLabel) {
        this.resolvePathStack.push((path)=>{
            this.path = (0, $8phr2.resolvedPath)(path, this.input, memberName, labelValueProvider, uriLabel, isGreedyLabel);
        });
        return this;
    }
    h(headers) {
        this.headers = headers;
        return this;
    }
    q(query) {
        this.query = query;
        return this;
    }
    b(body) {
        this.body = body;
        return this;
    }
    m(method) {
        this.method = method;
        return this;
    }
}

});

parcelRegister("3Ib1X", function(module, exports) {
const $2b3e0997e111218a$var$makePagedClientRequest = async (CommandCtor, client, input, ...args)=>{
    return await client.send(new CommandCtor(input), ...args);
};
function $2b3e0997e111218a$export$531a5724c6bf0340(ClientCtor, CommandCtor, inputTokenName, outputTokenName, pageSizeTokenName) {
    return async function* paginateOperation(config, input, ...additionalArguments) {
        let token = config.startingToken || undefined;
        let hasNext = true;
        let page;
        while(hasNext){
            input[inputTokenName] = token;
            if (pageSizeTokenName) input[pageSizeTokenName] = input[pageSizeTokenName] ?? config.pageSize;
            if (config.client instanceof ClientCtor) page = await $2b3e0997e111218a$var$makePagedClientRequest(CommandCtor, config.client, input, ...additionalArguments);
            else throw new Error(`Invalid client, expected instance of ${ClientCtor.name}`);
            yield page;
            const prevToken = token;
            token = $2b3e0997e111218a$var$get(page, outputTokenName);
            hasNext = !!(token && (!config.stopOnSameToken || token !== prevToken));
        }
        return undefined;
    };
}
const $2b3e0997e111218a$var$get = (fromObject, path)=>{
    let cursor = fromObject;
    const pathComponents = path.split(".");
    for (const step of pathComponents){
        if (!cursor || typeof cursor !== "object") return undefined;
        cursor = cursor[step];
    }
    return cursor;
};

});


parcelRegister("e8QI9", function(module, exports) {

$parcel$export(module.exports, "getContentLengthPlugin", () => $a4bab361a2b6058c$export$7e6ddf9365a30fe9);
parcelRequire("AueTL");
var $Yl5TU = parcelRequire("Yl5TU");
const $a4bab361a2b6058c$var$CONTENT_LENGTH_HEADER = "content-length";
function $a4bab361a2b6058c$export$940b29eb2788b975(bodyLengthChecker) {
    return (next)=>async (args)=>{
            const request = args.request;
            if ((0, $Yl5TU.HttpRequest).isInstance(request)) {
                const { body: body, headers: headers } = request;
                if (body && Object.keys(headers).map((str)=>str.toLowerCase()).indexOf($a4bab361a2b6058c$var$CONTENT_LENGTH_HEADER) === -1) try {
                    const length = bodyLengthChecker(body);
                    request.headers = {
                        ...request.headers,
                        [$a4bab361a2b6058c$var$CONTENT_LENGTH_HEADER]: String(length)
                    };
                } catch (error) {}
            }
            return next({
                ...args,
                request: request
            });
        };
}
const $a4bab361a2b6058c$export$1f7816f8f350b2f5 = {
    step: "build",
    tags: [
        "SET_CONTENT_LENGTH",
        "CONTENT_LENGTH"
    ],
    name: "contentLengthMiddleware",
    override: true
};
const $a4bab361a2b6058c$export$7e6ddf9365a30fe9 = (options)=>({
        applyToStack: (clientStack)=>{
            clientStack.add($a4bab361a2b6058c$export$940b29eb2788b975(options.bodyLengthChecker), $a4bab361a2b6058c$export$1f7816f8f350b2f5);
        }
    });

});

parcelRegister("7UJxK", function(module, exports) {

$parcel$export(module.exports, "resolveAwsSdkSigV4Config", () => $5c3117527e57d15f$export$e18f3f8a841a90ec);
parcelRequire("21756");
var $9gMMV = parcelRequire("9gMMV");
var $g5Jyl = parcelRequire("g5Jyl");
parcelRequire("cAPJ7");
var $2BeZO = parcelRequire("2BeZO");
const $5c3117527e57d15f$export$e18f3f8a841a90ec = (config)=>{
    let normalizedCreds;
    if (config.credentials) normalizedCreds = (0, $9gMMV.memoizeIdentityProvider)(config.credentials, (0, $9gMMV.isIdentityExpired), (0, $9gMMV.doesIdentityRequireRefresh));
    if (!normalizedCreds) {
        if (config.credentialDefaultProvider) normalizedCreds = (0, $g5Jyl.normalizeProvider)(config.credentialDefaultProvider(Object.assign({}, config, {
            parentClientConfig: config
        })));
        else normalizedCreds = async ()=>{
            throw new Error("`credentials` is missing");
        };
    }
    const { signingEscapePath: signingEscapePath = true, systemClockOffset: systemClockOffset = config.systemClockOffset || 0, sha256: sha256 } = config;
    let signer;
    if (config.signer) signer = (0, $g5Jyl.normalizeProvider)(config.signer);
    else if (config.regionInfoProvider) signer = ()=>(0, $g5Jyl.normalizeProvider)(config.region)().then(async (region)=>[
                await config.regionInfoProvider(region, {
                    useFipsEndpoint: await config.useFipsEndpoint(),
                    useDualstackEndpoint: await config.useDualstackEndpoint()
                }) || {},
                region
            ]).then(([regionInfo, region])=>{
            const { signingRegion: signingRegion, signingService: signingService } = regionInfo;
            config.signingRegion = config.signingRegion || signingRegion || region;
            config.signingName = config.signingName || signingService || config.serviceId;
            const params = {
                ...config,
                credentials: normalizedCreds,
                region: config.signingRegion,
                service: config.signingName,
                sha256: sha256,
                uriEscapePath: signingEscapePath
            };
            const SignerCtor = config.signerConstructor || (0, $2BeZO.SignatureV4);
            return new SignerCtor(params);
        });
    else signer = async (authScheme)=>{
        authScheme = Object.assign({}, {
            name: "sigv4",
            signingName: config.signingName || config.defaultSigningName,
            signingRegion: await (0, $g5Jyl.normalizeProvider)(config.region)(),
            properties: {}
        }, authScheme);
        const signingRegion = authScheme.signingRegion;
        const signingService = authScheme.signingName;
        config.signingRegion = config.signingRegion || signingRegion;
        config.signingName = config.signingName || signingService || config.serviceId;
        const params = {
            ...config,
            credentials: normalizedCreds,
            region: config.signingRegion,
            service: config.signingName,
            sha256: sha256,
            uriEscapePath: signingEscapePath
        };
        const SignerCtor = config.signerConstructor || (0, $2BeZO.SignatureV4);
        return new SignerCtor(params);
    };
    return {
        ...config,
        systemClockOffset: systemClockOffset,
        signingEscapePath: signingEscapePath,
        credentials: normalizedCreds,
        signer: signer
    };
};
const $5c3117527e57d15f$export$d85a20fa3e1218b1 = $5c3117527e57d15f$export$e18f3f8a841a90ec;

});
parcelRegister("cAPJ7", function(module, exports) {
$parcel$export(module.exports, "SignatureV4", () => (parcelRequire("2BeZO")).SignatureV4);
parcelRequire("2BeZO");

var $2Mpx0 = parcelRequire("2Mpx0");

var $6QPwd = parcelRequire("6QPwd");

var $5e75L = parcelRequire("5e75L");

var $kh5Zk = parcelRequire("kh5Zk");

var $dxNZk = parcelRequire("dxNZk");
parcelRequire("fYZPV");

});
parcelRegister("2BeZO", function(module, exports) {

$parcel$export(module.exports, "SignatureV4", () => $1e4aab6042254637$export$20baf4d3f65eb30c);
parcelRequire("1pqc7");
var $gkUvU = parcelRequire("gkUvU");

var $i6ugP = parcelRequire("i6ugP");
parcelRequire("e2ELD");
var $j5KxT = parcelRequire("j5KxT");
parcelRequire("cace4");
var $3tKur = parcelRequire("3tKur");
var $cHGTK = parcelRequire("cHGTK");
var $hpab6 = parcelRequire("hpab6");

var $dKey1 = parcelRequire("dKey1");

var $fYZPV = parcelRequire("fYZPV");

var $2Mpx0 = parcelRequire("2Mpx0");

var $6QPwd = parcelRequire("6QPwd");

var $5e75L = parcelRequire("5e75L");

var $qiFzL = parcelRequire("qiFzL");

var $kh5Zk = parcelRequire("kh5Zk");

var $dxNZk = parcelRequire("dxNZk");

var $bEM4m = parcelRequire("bEM4m");
class $1e4aab6042254637$export$20baf4d3f65eb30c {
    constructor({ applyChecksum: applyChecksum, credentials: credentials, region: region, service: service, sha256: sha256, uriEscapePath: uriEscapePath = true }){
        this.headerMarshaller = new (0, $gkUvU.HeaderMarshaller)((0, $hpab6.toUtf8), (0, $3tKur.fromUtf8));
        this.service = service;
        this.sha256 = sha256;
        this.uriEscapePath = uriEscapePath;
        this.applyChecksum = typeof applyChecksum === "boolean" ? applyChecksum : true;
        this.regionProvider = (0, $j5KxT.normalizeProvider)(region);
        this.credentialProvider = (0, $j5KxT.normalizeProvider)(credentials);
    }
    async presign(originalRequest, options = {}) {
        const { signingDate: signingDate = new Date(), expiresIn: expiresIn = 3600, unsignableHeaders: unsignableHeaders, unhoistableHeaders: unhoistableHeaders, signableHeaders: signableHeaders, signingRegion: signingRegion, signingService: signingService } = options;
        const credentials = await this.credentialProvider();
        this.validateResolvedCredentials(credentials);
        const region = signingRegion ?? await this.regionProvider();
        const { longDate: longDate, shortDate: shortDate } = $1e4aab6042254637$var$formatDate(signingDate);
        if (expiresIn > (0, $dKey1.MAX_PRESIGNED_TTL)) return Promise.reject("Signature version 4 presigned URLs must have an expiration date less than one week in the future");
        const scope = (0, $fYZPV.createScope)(shortDate, region, signingService ?? this.service);
        const request = (0, $kh5Zk.moveHeadersToQuery)((0, $dxNZk.prepareRequest)(originalRequest), {
            unhoistableHeaders: unhoistableHeaders
        });
        if (credentials.sessionToken) request.query[0, $dKey1.TOKEN_QUERY_PARAM] = credentials.sessionToken;
        request.query[0, $dKey1.ALGORITHM_QUERY_PARAM] = (0, $dKey1.ALGORITHM_IDENTIFIER);
        request.query[0, $dKey1.CREDENTIAL_QUERY_PARAM] = `${credentials.accessKeyId}/${scope}`;
        request.query[0, $dKey1.AMZ_DATE_QUERY_PARAM] = longDate;
        request.query[0, $dKey1.EXPIRES_QUERY_PARAM] = expiresIn.toString(10);
        const canonicalHeaders = (0, $2Mpx0.getCanonicalHeaders)(request, unsignableHeaders, signableHeaders);
        request.query[0, $dKey1.SIGNED_HEADERS_QUERY_PARAM] = $1e4aab6042254637$var$getCanonicalHeaderList(canonicalHeaders);
        request.query[0, $dKey1.SIGNATURE_QUERY_PARAM] = await this.getSignature(longDate, scope, this.getSigningKey(credentials, region, shortDate, signingService), this.createCanonicalRequest(request, canonicalHeaders, await (0, $5e75L.getPayloadHash)(originalRequest, this.sha256)));
        return request;
    }
    async sign(toSign, options) {
        if (typeof toSign === "string") return this.signString(toSign, options);
        else if (toSign.headers && toSign.payload) return this.signEvent(toSign, options);
        else if (toSign.message) return this.signMessage(toSign, options);
        else return this.signRequest(toSign, options);
    }
    async signEvent({ headers: headers, payload: payload }, { signingDate: signingDate = new Date(), priorSignature: priorSignature, signingRegion: signingRegion, signingService: signingService }) {
        const region = signingRegion ?? await this.regionProvider();
        const { shortDate: shortDate, longDate: longDate } = $1e4aab6042254637$var$formatDate(signingDate);
        const scope = (0, $fYZPV.createScope)(shortDate, region, signingService ?? this.service);
        const hashedPayload = await (0, $5e75L.getPayloadHash)({
            headers: {},
            body: payload
        }, this.sha256);
        const hash = new this.sha256();
        hash.update(headers);
        const hashedHeaders = (0, $i6ugP.toHex)(await hash.digest());
        const stringToSign = [
            (0, $dKey1.EVENT_ALGORITHM_IDENTIFIER),
            longDate,
            scope,
            priorSignature,
            hashedHeaders,
            hashedPayload
        ].join("\n");
        return this.signString(stringToSign, {
            signingDate: signingDate,
            signingRegion: region,
            signingService: signingService
        });
    }
    async signMessage(signableMessage, { signingDate: signingDate = new Date(), signingRegion: signingRegion, signingService: signingService }) {
        const promise = this.signEvent({
            headers: this.headerMarshaller.format(signableMessage.message.headers),
            payload: signableMessage.message.body
        }, {
            signingDate: signingDate,
            signingRegion: signingRegion,
            signingService: signingService,
            priorSignature: signableMessage.priorSignature
        });
        return promise.then((signature)=>{
            return {
                message: signableMessage.message,
                signature: signature
            };
        });
    }
    async signString(stringToSign, { signingDate: signingDate = new Date(), signingRegion: signingRegion, signingService: signingService } = {}) {
        const credentials = await this.credentialProvider();
        this.validateResolvedCredentials(credentials);
        const region = signingRegion ?? await this.regionProvider();
        const { shortDate: shortDate } = $1e4aab6042254637$var$formatDate(signingDate);
        const hash = new this.sha256(await this.getSigningKey(credentials, region, shortDate, signingService));
        hash.update((0, $cHGTK.toUint8Array)(stringToSign));
        return (0, $i6ugP.toHex)(await hash.digest());
    }
    async signRequest(requestToSign, { signingDate: signingDate = new Date(), signableHeaders: signableHeaders, unsignableHeaders: unsignableHeaders, signingRegion: signingRegion, signingService: signingService } = {}) {
        const credentials = await this.credentialProvider();
        this.validateResolvedCredentials(credentials);
        const region = signingRegion ?? await this.regionProvider();
        const request = (0, $dxNZk.prepareRequest)(requestToSign);
        const { longDate: longDate, shortDate: shortDate } = $1e4aab6042254637$var$formatDate(signingDate);
        const scope = (0, $fYZPV.createScope)(shortDate, region, signingService ?? this.service);
        request.headers[0, $dKey1.AMZ_DATE_HEADER] = longDate;
        if (credentials.sessionToken) request.headers[0, $dKey1.TOKEN_HEADER] = credentials.sessionToken;
        const payloadHash = await (0, $5e75L.getPayloadHash)(request, this.sha256);
        if (!(0, $qiFzL.hasHeader)((0, $dKey1.SHA256_HEADER), request.headers) && this.applyChecksum) request.headers[0, $dKey1.SHA256_HEADER] = payloadHash;
        const canonicalHeaders = (0, $2Mpx0.getCanonicalHeaders)(request, unsignableHeaders, signableHeaders);
        const signature = await this.getSignature(longDate, scope, this.getSigningKey(credentials, region, shortDate, signingService), this.createCanonicalRequest(request, canonicalHeaders, payloadHash));
        request.headers[0, $dKey1.AUTH_HEADER] = `${0, $dKey1.ALGORITHM_IDENTIFIER} ` + `Credential=${credentials.accessKeyId}/${scope}, ` + `SignedHeaders=${$1e4aab6042254637$var$getCanonicalHeaderList(canonicalHeaders)}, ` + `Signature=${signature}`;
        return request;
    }
    createCanonicalRequest(request, canonicalHeaders, payloadHash) {
        const sortedHeaders = Object.keys(canonicalHeaders).sort();
        return `${request.method}
${this.getCanonicalPath(request)}
${(0, $6QPwd.getCanonicalQuery)(request)}
${sortedHeaders.map((name)=>`${name}:${canonicalHeaders[name]}`).join("\n")}

${sortedHeaders.join(";")}
${payloadHash}`;
    }
    async createStringToSign(longDate, credentialScope, canonicalRequest) {
        const hash = new this.sha256();
        hash.update((0, $cHGTK.toUint8Array)(canonicalRequest));
        const hashedRequest = await hash.digest();
        return `${0, $dKey1.ALGORITHM_IDENTIFIER}
${longDate}
${credentialScope}
${(0, $i6ugP.toHex)(hashedRequest)}`;
    }
    getCanonicalPath({ path: path }) {
        if (this.uriEscapePath) {
            const normalizedPathSegments = [];
            for (const pathSegment of path.split("/")){
                if (pathSegment?.length === 0) continue;
                if (pathSegment === ".") continue;
                if (pathSegment === "..") normalizedPathSegments.pop();
                else normalizedPathSegments.push(pathSegment);
            }
            const normalizedPath = `${path?.startsWith("/") ? "/" : ""}${normalizedPathSegments.join("/")}${normalizedPathSegments.length > 0 && path?.endsWith("/") ? "/" : ""}`;
            const doubleEncoded = encodeURIComponent(normalizedPath);
            return doubleEncoded.replace(/%2F/g, "/");
        }
        return path;
    }
    async getSignature(longDate, credentialScope, keyPromise, canonicalRequest) {
        const stringToSign = await this.createStringToSign(longDate, credentialScope, canonicalRequest);
        const hash = new this.sha256(await keyPromise);
        hash.update((0, $cHGTK.toUint8Array)(stringToSign));
        return (0, $i6ugP.toHex)(await hash.digest());
    }
    getSigningKey(credentials, region, shortDate, service) {
        return (0, $fYZPV.getSigningKey)(this.sha256, credentials, shortDate, region, service || this.service);
    }
    validateResolvedCredentials(credentials) {
        if (typeof credentials !== "object" || typeof credentials.accessKeyId !== "string" || typeof credentials.secretAccessKey !== "string") throw new Error("Resolved credential object is not valid");
    }
}
const $1e4aab6042254637$var$formatDate = (now)=>{
    const longDate = (0, $bEM4m.iso8601)(now).replace(/[\-:]/g, "");
    return {
        longDate: longDate,
        shortDate: longDate.slice(0, 8)
    };
};
const $1e4aab6042254637$var$getCanonicalHeaderList = (headers)=>Object.keys(headers).sort().join(";");

});
parcelRegister("1pqc7", function(module, exports) {
$parcel$export(module.exports, "HeaderMarshaller", () => (parcelRequire("gkUvU")).HeaderMarshaller);
parcelRequire("3S4Om");
parcelRequire("gkUvU");
parcelRequire("1FKNG");
parcelRequire("5MtN5");
parcelRequire("6qG1H");
parcelRequire("7P7VW");
parcelRequire("c1mUl");
parcelRequire("55JPZ");

});
parcelRegister("3S4Om", function(module, exports) {

var $dXfwr = parcelRequire("dXfwr");

var $gkUvU = parcelRequire("gkUvU");

var $4AtkP = parcelRequire("4AtkP");
class $2d1a25abb39dbfbf$export$60e2ad0c77b6bab {
    constructor(toUtf8, fromUtf8){
        this.headerMarshaller = new (0, $gkUvU.HeaderMarshaller)(toUtf8, fromUtf8);
        this.messageBuffer = [];
        this.isEndOfStream = false;
    }
    feed(message) {
        this.messageBuffer.push(this.decode(message));
    }
    endOfStream() {
        this.isEndOfStream = true;
    }
    getMessage() {
        const message = this.messageBuffer.pop();
        const isEndOfStream = this.isEndOfStream;
        return {
            getMessage () {
                return message;
            },
            isEndOfStream () {
                return isEndOfStream;
            }
        };
    }
    getAvailableMessages() {
        const messages = this.messageBuffer;
        this.messageBuffer = [];
        const isEndOfStream = this.isEndOfStream;
        return {
            getMessages () {
                return messages;
            },
            isEndOfStream () {
                return isEndOfStream;
            }
        };
    }
    encode({ headers: rawHeaders, body: body }) {
        const headers = this.headerMarshaller.format(rawHeaders);
        const length = headers.byteLength + body.byteLength + 16;
        const out = new Uint8Array(length);
        const view = new DataView(out.buffer, out.byteOffset, out.byteLength);
        const checksum = new (0, $dXfwr.Crc32)();
        view.setUint32(0, length, false);
        view.setUint32(4, headers.byteLength, false);
        view.setUint32(8, checksum.update(out.subarray(0, 8)).digest(), false);
        out.set(headers, 12);
        out.set(body, headers.byteLength + 12);
        view.setUint32(length - 4, checksum.update(out.subarray(8, length - 4)).digest(), false);
        return out;
    }
    decode(message) {
        const { headers: headers, body: body } = (0, $4AtkP.splitMessage)(message);
        return {
            headers: this.headerMarshaller.parse(headers),
            body: body
        };
    }
    formatHeaders(rawHeaders) {
        return this.headerMarshaller.format(rawHeaders);
    }
}

});
parcelRegister("dXfwr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AwsCrc32 = module.exports.Crc32 = module.exports.crc32 = void 0;

var $2hFF5 = parcelRequire("2hFF5");

var $hh31F = parcelRequire("hh31F");
function $a28cd3779cebfbd3$var$crc32(data) {
    return new $a28cd3779cebfbd3$var$Crc32().update(data).digest();
}
module.exports.crc32 = $a28cd3779cebfbd3$var$crc32;
var $a28cd3779cebfbd3$var$Crc32 = /** @class */ function() {
    function Crc32() {
        this.checksum = 0xffffffff;
    }
    Crc32.prototype.update = function(data) {
        var e_1, _a;
        try {
            for(var data_1 = $2hFF5.__values(data), data_1_1 = data_1.next(); !data_1_1.done; data_1_1 = data_1.next()){
                var byte = data_1_1.value;
                this.checksum = this.checksum >>> 8 ^ $a28cd3779cebfbd3$var$lookupTable[(this.checksum ^ byte) & 0xff];
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (data_1_1 && !data_1_1.done && (_a = data_1.return)) _a.call(data_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return this;
    };
    Crc32.prototype.digest = function() {
        return (this.checksum ^ 0xffffffff) >>> 0;
    };
    return Crc32;
}();
module.exports.Crc32 = $a28cd3779cebfbd3$var$Crc32;
// prettier-ignore
var $a28cd3779cebfbd3$var$a_lookUpTable = [
    0x00000000,
    0x77073096,
    0xEE0E612C,
    0x990951BA,
    0x076DC419,
    0x706AF48F,
    0xE963A535,
    0x9E6495A3,
    0x0EDB8832,
    0x79DCB8A4,
    0xE0D5E91E,
    0x97D2D988,
    0x09B64C2B,
    0x7EB17CBD,
    0xE7B82D07,
    0x90BF1D91,
    0x1DB71064,
    0x6AB020F2,
    0xF3B97148,
    0x84BE41DE,
    0x1ADAD47D,
    0x6DDDE4EB,
    0xF4D4B551,
    0x83D385C7,
    0x136C9856,
    0x646BA8C0,
    0xFD62F97A,
    0x8A65C9EC,
    0x14015C4F,
    0x63066CD9,
    0xFA0F3D63,
    0x8D080DF5,
    0x3B6E20C8,
    0x4C69105E,
    0xD56041E4,
    0xA2677172,
    0x3C03E4D1,
    0x4B04D447,
    0xD20D85FD,
    0xA50AB56B,
    0x35B5A8FA,
    0x42B2986C,
    0xDBBBC9D6,
    0xACBCF940,
    0x32D86CE3,
    0x45DF5C75,
    0xDCD60DCF,
    0xABD13D59,
    0x26D930AC,
    0x51DE003A,
    0xC8D75180,
    0xBFD06116,
    0x21B4F4B5,
    0x56B3C423,
    0xCFBA9599,
    0xB8BDA50F,
    0x2802B89E,
    0x5F058808,
    0xC60CD9B2,
    0xB10BE924,
    0x2F6F7C87,
    0x58684C11,
    0xC1611DAB,
    0xB6662D3D,
    0x76DC4190,
    0x01DB7106,
    0x98D220BC,
    0xEFD5102A,
    0x71B18589,
    0x06B6B51F,
    0x9FBFE4A5,
    0xE8B8D433,
    0x7807C9A2,
    0x0F00F934,
    0x9609A88E,
    0xE10E9818,
    0x7F6A0DBB,
    0x086D3D2D,
    0x91646C97,
    0xE6635C01,
    0x6B6B51F4,
    0x1C6C6162,
    0x856530D8,
    0xF262004E,
    0x6C0695ED,
    0x1B01A57B,
    0x8208F4C1,
    0xF50FC457,
    0x65B0D9C6,
    0x12B7E950,
    0x8BBEB8EA,
    0xFCB9887C,
    0x62DD1DDF,
    0x15DA2D49,
    0x8CD37CF3,
    0xFBD44C65,
    0x4DB26158,
    0x3AB551CE,
    0xA3BC0074,
    0xD4BB30E2,
    0x4ADFA541,
    0x3DD895D7,
    0xA4D1C46D,
    0xD3D6F4FB,
    0x4369E96A,
    0x346ED9FC,
    0xAD678846,
    0xDA60B8D0,
    0x44042D73,
    0x33031DE5,
    0xAA0A4C5F,
    0xDD0D7CC9,
    0x5005713C,
    0x270241AA,
    0xBE0B1010,
    0xC90C2086,
    0x5768B525,
    0x206F85B3,
    0xB966D409,
    0xCE61E49F,
    0x5EDEF90E,
    0x29D9C998,
    0xB0D09822,
    0xC7D7A8B4,
    0x59B33D17,
    0x2EB40D81,
    0xB7BD5C3B,
    0xC0BA6CAD,
    0xEDB88320,
    0x9ABFB3B6,
    0x03B6E20C,
    0x74B1D29A,
    0xEAD54739,
    0x9DD277AF,
    0x04DB2615,
    0x73DC1683,
    0xE3630B12,
    0x94643B84,
    0x0D6D6A3E,
    0x7A6A5AA8,
    0xE40ECF0B,
    0x9309FF9D,
    0x0A00AE27,
    0x7D079EB1,
    0xF00F9344,
    0x8708A3D2,
    0x1E01F268,
    0x6906C2FE,
    0xF762575D,
    0x806567CB,
    0x196C3671,
    0x6E6B06E7,
    0xFED41B76,
    0x89D32BE0,
    0x10DA7A5A,
    0x67DD4ACC,
    0xF9B9DF6F,
    0x8EBEEFF9,
    0x17B7BE43,
    0x60B08ED5,
    0xD6D6A3E8,
    0xA1D1937E,
    0x38D8C2C4,
    0x4FDFF252,
    0xD1BB67F1,
    0xA6BC5767,
    0x3FB506DD,
    0x48B2364B,
    0xD80D2BDA,
    0xAF0A1B4C,
    0x36034AF6,
    0x41047A60,
    0xDF60EFC3,
    0xA867DF55,
    0x316E8EEF,
    0x4669BE79,
    0xCB61B38C,
    0xBC66831A,
    0x256FD2A0,
    0x5268E236,
    0xCC0C7795,
    0xBB0B4703,
    0x220216B9,
    0x5505262F,
    0xC5BA3BBE,
    0xB2BD0B28,
    0x2BB45A92,
    0x5CB36A04,
    0xC2D7FFA7,
    0xB5D0CF31,
    0x2CD99E8B,
    0x5BDEAE1D,
    0x9B64C2B0,
    0xEC63F226,
    0x756AA39C,
    0x026D930A,
    0x9C0906A9,
    0xEB0E363F,
    0x72076785,
    0x05005713,
    0x95BF4A82,
    0xE2B87A14,
    0x7BB12BAE,
    0x0CB61B38,
    0x92D28E9B,
    0xE5D5BE0D,
    0x7CDCEFB7,
    0x0BDBDF21,
    0x86D3D2D4,
    0xF1D4E242,
    0x68DDB3F8,
    0x1FDA836E,
    0x81BE16CD,
    0xF6B9265B,
    0x6FB077E1,
    0x18B74777,
    0x88085AE6,
    0xFF0F6A70,
    0x66063BCA,
    0x11010B5C,
    0x8F659EFF,
    0xF862AE69,
    0x616BFFD3,
    0x166CCF45,
    0xA00AE278,
    0xD70DD2EE,
    0x4E048354,
    0x3903B3C2,
    0xA7672661,
    0xD06016F7,
    0x4969474D,
    0x3E6E77DB,
    0xAED16A4A,
    0xD9D65ADC,
    0x40DF0B66,
    0x37D83BF0,
    0xA9BCAE53,
    0xDEBB9EC5,
    0x47B2CF7F,
    0x30B5FFE9,
    0xBDBDF21C,
    0xCABAC28A,
    0x53B39330,
    0x24B4A3A6,
    0xBAD03605,
    0xCDD70693,
    0x54DE5729,
    0x23D967BF,
    0xB3667A2E,
    0xC4614AB8,
    0x5D681B02,
    0x2A6F2B94,
    0xB40BBE37,
    0xC30C8EA1,
    0x5A05DF1B,
    0x2D02EF8D
];
var $a28cd3779cebfbd3$var$lookupTable = (0, $hh31F.uint32ArrayFrom)($a28cd3779cebfbd3$var$a_lookUpTable);

var $em8va = parcelRequire("em8va");
Object.defineProperty(module.exports, "AwsCrc32", {
    enumerable: true,
    get: function() {
        return $em8va.AwsCrc32;
    }
});

});
parcelRegister("2hFF5", function(module, exports) {

$parcel$export(module.exports, "__awaiter", () => $1a9d7c77e7bb3fdc$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $1a9d7c77e7bb3fdc$export$67ebef60e6f28a6);
$parcel$export(module.exports, "__values", () => $1a9d7c77e7bb3fdc$export$19a8beecd37a4c45);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $1a9d7c77e7bb3fdc$var$extendStatics = function(d, b) {
    $1a9d7c77e7bb3fdc$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $1a9d7c77e7bb3fdc$var$extendStatics(d, b);
};
function $1a9d7c77e7bb3fdc$export$a8ba968b8961cb8a(d, b) {
    $1a9d7c77e7bb3fdc$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $1a9d7c77e7bb3fdc$export$18ce0697a983be9b = function() {
    $1a9d7c77e7bb3fdc$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1a9d7c77e7bb3fdc$export$18ce0697a983be9b.apply(this, arguments);
};
function $1a9d7c77e7bb3fdc$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $1a9d7c77e7bb3fdc$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $1a9d7c77e7bb3fdc$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $1a9d7c77e7bb3fdc$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $1a9d7c77e7bb3fdc$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $1a9d7c77e7bb3fdc$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $1a9d7c77e7bb3fdc$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $1a9d7c77e7bb3fdc$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $1a9d7c77e7bb3fdc$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $1a9d7c77e7bb3fdc$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $1a9d7c77e7bb3fdc$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($1a9d7c77e7bb3fdc$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $1a9d7c77e7bb3fdc$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $1a9d7c77e7bb3fdc$export$10c90e4f7922046c(v) {
    return this instanceof $1a9d7c77e7bb3fdc$export$10c90e4f7922046c ? (this.v = v, this) : new $1a9d7c77e7bb3fdc$export$10c90e4f7922046c(v);
}
function $1a9d7c77e7bb3fdc$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $1a9d7c77e7bb3fdc$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $1a9d7c77e7bb3fdc$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $1a9d7c77e7bb3fdc$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $1a9d7c77e7bb3fdc$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $1a9d7c77e7bb3fdc$export$19a8beecd37a4c45 === "function" ? $1a9d7c77e7bb3fdc$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $1a9d7c77e7bb3fdc$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $1a9d7c77e7bb3fdc$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $1a9d7c77e7bb3fdc$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $1a9d7c77e7bb3fdc$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $1a9d7c77e7bb3fdc$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("hh31F", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.uint32ArrayFrom = module.exports.numToUint8 = module.exports.isEmptyData = module.exports.convertToBuffer = void 0;

var $6QrDh = parcelRequire("6QrDh");
Object.defineProperty(module.exports, "convertToBuffer", {
    enumerable: true,
    get: function() {
        return $6QrDh.convertToBuffer;
    }
});

var $4HYJw = parcelRequire("4HYJw");
Object.defineProperty(module.exports, "isEmptyData", {
    enumerable: true,
    get: function() {
        return $4HYJw.isEmptyData;
    }
});

var $v79S5 = parcelRequire("v79S5");
Object.defineProperty(module.exports, "numToUint8", {
    enumerable: true,
    get: function() {
        return $v79S5.numToUint8;
    }
});

var $7fqTg = parcelRequire("7fqTg");
Object.defineProperty(module.exports, "uint32ArrayFrom", {
    enumerable: true,
    get: function() {
        return $7fqTg.uint32ArrayFrom;
    }
});

});
parcelRegister("6QrDh", function(module, exports) {

var $5Pbds = parcelRequire("5Pbds");
var $4fbd08a87169f722$require$Buffer = $5Pbds.Buffer;
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.convertToBuffer = void 0;

var $8fYP2 = parcelRequire("8fYP2");
// Quick polyfill
var $4fbd08a87169f722$var$fromUtf8 = typeof $4fbd08a87169f722$require$Buffer !== "undefined" && $4fbd08a87169f722$require$Buffer.from ? function(input) {
    return $4fbd08a87169f722$require$Buffer.from(input, "utf8");
} : $8fYP2.fromUtf8;
function $4fbd08a87169f722$var$convertToBuffer(data) {
    // Already a Uint8, do nothing
    if (data instanceof Uint8Array) return data;
    if (typeof data === "string") return $4fbd08a87169f722$var$fromUtf8(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}
module.exports.convertToBuffer = $4fbd08a87169f722$var$convertToBuffer;

});
parcelRegister("5Pbds", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $43da6a70d9e56dbe$export$a143d493d941bafc, (v) => $43da6a70d9e56dbe$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $43da6a70d9e56dbe$export$f99ded8fe4b79145, (v) => $43da6a70d9e56dbe$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $43da6a70d9e56dbe$export$a143d493d941bafc;
var $43da6a70d9e56dbe$export$e4cf37d7f6fb9e0a;
var $43da6a70d9e56dbe$export$f99ded8fe4b79145;
var $43da6a70d9e56dbe$export$599f31c3813fae4d;
"use strict";

var $80sMt = parcelRequire("80sMt");

var $98vqs = parcelRequire("98vqs");
var $43da6a70d9e56dbe$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$43da6a70d9e56dbe$export$a143d493d941bafc = $43da6a70d9e56dbe$var$Buffer;
$43da6a70d9e56dbe$export$e4cf37d7f6fb9e0a = $43da6a70d9e56dbe$var$SlowBuffer;
$43da6a70d9e56dbe$export$f99ded8fe4b79145 = 50;
var $43da6a70d9e56dbe$var$K_MAX_LENGTH = 0x7fffffff;
$43da6a70d9e56dbe$export$599f31c3813fae4d = $43da6a70d9e56dbe$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $43da6a70d9e56dbe$var$Buffer.TYPED_ARRAY_SUPPORT = $43da6a70d9e56dbe$var$typedArraySupport();
if (!$43da6a70d9e56dbe$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $43da6a70d9e56dbe$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($43da6a70d9e56dbe$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$43da6a70d9e56dbe$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($43da6a70d9e56dbe$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$43da6a70d9e56dbe$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $43da6a70d9e56dbe$var$createBuffer(length) {
    if (length > $43da6a70d9e56dbe$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $43da6a70d9e56dbe$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $43da6a70d9e56dbe$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $43da6a70d9e56dbe$var$allocUnsafe(arg);
    }
    return $43da6a70d9e56dbe$var$from(arg, encodingOrOffset, length);
}
$43da6a70d9e56dbe$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $43da6a70d9e56dbe$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $43da6a70d9e56dbe$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $43da6a70d9e56dbe$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($43da6a70d9e56dbe$var$isInstance(value, ArrayBuffer) || value && $43da6a70d9e56dbe$var$isInstance(value.buffer, ArrayBuffer)) return $43da6a70d9e56dbe$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($43da6a70d9e56dbe$var$isInstance(value, SharedArrayBuffer) || value && $43da6a70d9e56dbe$var$isInstance(value.buffer, SharedArrayBuffer))) return $43da6a70d9e56dbe$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $43da6a70d9e56dbe$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $43da6a70d9e56dbe$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $43da6a70d9e56dbe$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $43da6a70d9e56dbe$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $43da6a70d9e56dbe$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($43da6a70d9e56dbe$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($43da6a70d9e56dbe$var$Buffer, Uint8Array);
function $43da6a70d9e56dbe$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $43da6a70d9e56dbe$var$alloc(size, fill, encoding) {
    $43da6a70d9e56dbe$var$assertSize(size);
    if (size <= 0) return $43da6a70d9e56dbe$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $43da6a70d9e56dbe$var$createBuffer(size).fill(fill, encoding) : $43da6a70d9e56dbe$var$createBuffer(size).fill(fill);
    return $43da6a70d9e56dbe$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $43da6a70d9e56dbe$var$Buffer.alloc = function(size, fill, encoding) {
    return $43da6a70d9e56dbe$var$alloc(size, fill, encoding);
};
function $43da6a70d9e56dbe$var$allocUnsafe(size) {
    $43da6a70d9e56dbe$var$assertSize(size);
    return $43da6a70d9e56dbe$var$createBuffer(size < 0 ? 0 : $43da6a70d9e56dbe$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $43da6a70d9e56dbe$var$Buffer.allocUnsafe = function(size) {
    return $43da6a70d9e56dbe$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $43da6a70d9e56dbe$var$Buffer.allocUnsafeSlow = function(size) {
    return $43da6a70d9e56dbe$var$allocUnsafe(size);
};
function $43da6a70d9e56dbe$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$43da6a70d9e56dbe$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    var length = $43da6a70d9e56dbe$var$byteLength(string, encoding) | 0;
    var buf = $43da6a70d9e56dbe$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $43da6a70d9e56dbe$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $43da6a70d9e56dbe$var$checked(array.length) | 0;
    var buf = $43da6a70d9e56dbe$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $43da6a70d9e56dbe$var$fromArrayView(arrayView) {
    if ($43da6a70d9e56dbe$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $43da6a70d9e56dbe$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $43da6a70d9e56dbe$var$fromArrayLike(arrayView);
}
function $43da6a70d9e56dbe$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $43da6a70d9e56dbe$var$Buffer.prototype);
    return buf;
}
function $43da6a70d9e56dbe$var$fromObject(obj) {
    if ($43da6a70d9e56dbe$var$Buffer.isBuffer(obj)) {
        var len = $43da6a70d9e56dbe$var$checked(obj.length) | 0;
        var buf = $43da6a70d9e56dbe$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $43da6a70d9e56dbe$var$numberIsNaN(obj.length)) return $43da6a70d9e56dbe$var$createBuffer(0);
        return $43da6a70d9e56dbe$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $43da6a70d9e56dbe$var$fromArrayLike(obj.data);
}
function $43da6a70d9e56dbe$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $43da6a70d9e56dbe$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $43da6a70d9e56dbe$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $43da6a70d9e56dbe$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $43da6a70d9e56dbe$var$Buffer.alloc(+length);
}
$43da6a70d9e56dbe$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $43da6a70d9e56dbe$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$43da6a70d9e56dbe$var$Buffer.compare = function compare(a, b) {
    if ($43da6a70d9e56dbe$var$isInstance(a, Uint8Array)) a = $43da6a70d9e56dbe$var$Buffer.from(a, a.offset, a.byteLength);
    if ($43da6a70d9e56dbe$var$isInstance(b, Uint8Array)) b = $43da6a70d9e56dbe$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$43da6a70d9e56dbe$var$Buffer.isBuffer(a) || !$43da6a70d9e56dbe$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$43da6a70d9e56dbe$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$43da6a70d9e56dbe$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $43da6a70d9e56dbe$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $43da6a70d9e56dbe$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($43da6a70d9e56dbe$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $43da6a70d9e56dbe$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$43da6a70d9e56dbe$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $43da6a70d9e56dbe$var$byteLength(string, encoding) {
    if ($43da6a70d9e56dbe$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $43da6a70d9e56dbe$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $43da6a70d9e56dbe$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $43da6a70d9e56dbe$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $43da6a70d9e56dbe$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$43da6a70d9e56dbe$var$Buffer.byteLength = $43da6a70d9e56dbe$var$byteLength;
function $43da6a70d9e56dbe$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $43da6a70d9e56dbe$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $43da6a70d9e56dbe$var$utf8Slice(this, start, end);
        case "ascii":
            return $43da6a70d9e56dbe$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $43da6a70d9e56dbe$var$latin1Slice(this, start, end);
        case "base64":
            return $43da6a70d9e56dbe$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $43da6a70d9e56dbe$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$43da6a70d9e56dbe$var$Buffer.prototype._isBuffer = true;
function $43da6a70d9e56dbe$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$43da6a70d9e56dbe$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$43da6a70d9e56dbe$var$swap(this, i, i + 1);
    return this;
};
$43da6a70d9e56dbe$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $43da6a70d9e56dbe$var$swap(this, i, i + 3);
        $43da6a70d9e56dbe$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$43da6a70d9e56dbe$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $43da6a70d9e56dbe$var$swap(this, i, i + 7);
        $43da6a70d9e56dbe$var$swap(this, i + 1, i + 6);
        $43da6a70d9e56dbe$var$swap(this, i + 2, i + 5);
        $43da6a70d9e56dbe$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$43da6a70d9e56dbe$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $43da6a70d9e56dbe$var$utf8Slice(this, 0, length);
    return $43da6a70d9e56dbe$var$slowToString.apply(this, arguments);
};
$43da6a70d9e56dbe$var$Buffer.prototype.toLocaleString = $43da6a70d9e56dbe$var$Buffer.prototype.toString;
$43da6a70d9e56dbe$var$Buffer.prototype.equals = function equals(b) {
    if (!$43da6a70d9e56dbe$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $43da6a70d9e56dbe$var$Buffer.compare(this, b) === 0;
};
$43da6a70d9e56dbe$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $43da6a70d9e56dbe$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($43da6a70d9e56dbe$var$customInspectSymbol) $43da6a70d9e56dbe$var$Buffer.prototype[$43da6a70d9e56dbe$var$customInspectSymbol] = $43da6a70d9e56dbe$var$Buffer.prototype.inspect;
$43da6a70d9e56dbe$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($43da6a70d9e56dbe$var$isInstance(target, Uint8Array)) target = $43da6a70d9e56dbe$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$43da6a70d9e56dbe$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $43da6a70d9e56dbe$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($43da6a70d9e56dbe$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $43da6a70d9e56dbe$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($43da6a70d9e56dbe$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $43da6a70d9e56dbe$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $43da6a70d9e56dbe$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $43da6a70d9e56dbe$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$43da6a70d9e56dbe$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$43da6a70d9e56dbe$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $43da6a70d9e56dbe$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$43da6a70d9e56dbe$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $43da6a70d9e56dbe$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $43da6a70d9e56dbe$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($43da6a70d9e56dbe$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $43da6a70d9e56dbe$var$utf8Write(buf, string, offset, length) {
    return $43da6a70d9e56dbe$var$blitBuffer($43da6a70d9e56dbe$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $43da6a70d9e56dbe$var$asciiWrite(buf, string, offset, length) {
    return $43da6a70d9e56dbe$var$blitBuffer($43da6a70d9e56dbe$var$asciiToBytes(string), buf, offset, length);
}
function $43da6a70d9e56dbe$var$base64Write(buf, string, offset, length) {
    return $43da6a70d9e56dbe$var$blitBuffer($43da6a70d9e56dbe$var$base64ToBytes(string), buf, offset, length);
}
function $43da6a70d9e56dbe$var$ucs2Write(buf, string, offset, length) {
    return $43da6a70d9e56dbe$var$blitBuffer($43da6a70d9e56dbe$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$43da6a70d9e56dbe$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $43da6a70d9e56dbe$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $43da6a70d9e56dbe$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $43da6a70d9e56dbe$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $43da6a70d9e56dbe$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $43da6a70d9e56dbe$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$43da6a70d9e56dbe$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $43da6a70d9e56dbe$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $80sMt.fromByteArray(buf);
    else return $80sMt.fromByteArray(buf.slice(start, end));
}
function $43da6a70d9e56dbe$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $43da6a70d9e56dbe$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $43da6a70d9e56dbe$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $43da6a70d9e56dbe$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $43da6a70d9e56dbe$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $43da6a70d9e56dbe$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $43da6a70d9e56dbe$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $43da6a70d9e56dbe$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $43da6a70d9e56dbe$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $43da6a70d9e56dbe$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $43da6a70d9e56dbe$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$43da6a70d9e56dbe$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $43da6a70d9e56dbe$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $43da6a70d9e56dbe$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$43da6a70d9e56dbe$var$Buffer.prototype.readUintLE = $43da6a70d9e56dbe$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $43da6a70d9e56dbe$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$43da6a70d9e56dbe$var$Buffer.prototype.readUintBE = $43da6a70d9e56dbe$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $43da6a70d9e56dbe$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$43da6a70d9e56dbe$var$Buffer.prototype.readUint8 = $43da6a70d9e56dbe$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $43da6a70d9e56dbe$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$43da6a70d9e56dbe$var$Buffer.prototype.readUint16LE = $43da6a70d9e56dbe$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $43da6a70d9e56dbe$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$43da6a70d9e56dbe$var$Buffer.prototype.readUint16BE = $43da6a70d9e56dbe$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $43da6a70d9e56dbe$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$43da6a70d9e56dbe$var$Buffer.prototype.readUint32LE = $43da6a70d9e56dbe$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $43da6a70d9e56dbe$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$43da6a70d9e56dbe$var$Buffer.prototype.readUint32BE = $43da6a70d9e56dbe$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $43da6a70d9e56dbe$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$43da6a70d9e56dbe$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $43da6a70d9e56dbe$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$43da6a70d9e56dbe$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $43da6a70d9e56dbe$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$43da6a70d9e56dbe$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $43da6a70d9e56dbe$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$43da6a70d9e56dbe$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $43da6a70d9e56dbe$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$43da6a70d9e56dbe$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $43da6a70d9e56dbe$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$43da6a70d9e56dbe$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $43da6a70d9e56dbe$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$43da6a70d9e56dbe$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $43da6a70d9e56dbe$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$43da6a70d9e56dbe$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $43da6a70d9e56dbe$var$checkOffset(offset, 4, this.length);
    return $98vqs.read(this, offset, true, 23, 4);
};
$43da6a70d9e56dbe$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $43da6a70d9e56dbe$var$checkOffset(offset, 4, this.length);
    return $98vqs.read(this, offset, false, 23, 4);
};
$43da6a70d9e56dbe$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $43da6a70d9e56dbe$var$checkOffset(offset, 8, this.length);
    return $98vqs.read(this, offset, true, 52, 8);
};
$43da6a70d9e56dbe$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $43da6a70d9e56dbe$var$checkOffset(offset, 8, this.length);
    return $98vqs.read(this, offset, false, 52, 8);
};
function $43da6a70d9e56dbe$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$43da6a70d9e56dbe$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$43da6a70d9e56dbe$var$Buffer.prototype.writeUintLE = $43da6a70d9e56dbe$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $43da6a70d9e56dbe$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$43da6a70d9e56dbe$var$Buffer.prototype.writeUintBE = $43da6a70d9e56dbe$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $43da6a70d9e56dbe$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$43da6a70d9e56dbe$var$Buffer.prototype.writeUint8 = $43da6a70d9e56dbe$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $43da6a70d9e56dbe$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$43da6a70d9e56dbe$var$Buffer.prototype.writeUint16LE = $43da6a70d9e56dbe$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $43da6a70d9e56dbe$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$43da6a70d9e56dbe$var$Buffer.prototype.writeUint16BE = $43da6a70d9e56dbe$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $43da6a70d9e56dbe$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$43da6a70d9e56dbe$var$Buffer.prototype.writeUint32LE = $43da6a70d9e56dbe$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $43da6a70d9e56dbe$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$43da6a70d9e56dbe$var$Buffer.prototype.writeUint32BE = $43da6a70d9e56dbe$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $43da6a70d9e56dbe$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$43da6a70d9e56dbe$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $43da6a70d9e56dbe$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$43da6a70d9e56dbe$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $43da6a70d9e56dbe$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$43da6a70d9e56dbe$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $43da6a70d9e56dbe$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$43da6a70d9e56dbe$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $43da6a70d9e56dbe$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$43da6a70d9e56dbe$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $43da6a70d9e56dbe$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$43da6a70d9e56dbe$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $43da6a70d9e56dbe$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$43da6a70d9e56dbe$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $43da6a70d9e56dbe$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $43da6a70d9e56dbe$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $43da6a70d9e56dbe$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $43da6a70d9e56dbe$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $98vqs.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$43da6a70d9e56dbe$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $43da6a70d9e56dbe$var$writeFloat(this, value, offset, true, noAssert);
};
$43da6a70d9e56dbe$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $43da6a70d9e56dbe$var$writeFloat(this, value, offset, false, noAssert);
};
function $43da6a70d9e56dbe$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $43da6a70d9e56dbe$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $98vqs.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$43da6a70d9e56dbe$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $43da6a70d9e56dbe$var$writeDouble(this, value, offset, true, noAssert);
};
$43da6a70d9e56dbe$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $43da6a70d9e56dbe$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$43da6a70d9e56dbe$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$43da6a70d9e56dbe$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$43da6a70d9e56dbe$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$43da6a70d9e56dbe$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $43da6a70d9e56dbe$var$Buffer.isBuffer(val) ? val : $43da6a70d9e56dbe$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $43da6a70d9e56dbe$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $43da6a70d9e56dbe$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($43da6a70d9e56dbe$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $43da6a70d9e56dbe$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $43da6a70d9e56dbe$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $43da6a70d9e56dbe$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $43da6a70d9e56dbe$var$base64ToBytes(str) {
    return $80sMt.toByteArray($43da6a70d9e56dbe$var$base64clean(str));
}
function $43da6a70d9e56dbe$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $43da6a70d9e56dbe$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $43da6a70d9e56dbe$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $43da6a70d9e56dbe$var$hexSliceLookupTable = function() {
    var alphabet = "0123456789abcdef";
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

});
parcelRegister("80sMt", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $5d44a61170d2e905$export$d622b2ad8d90c771, (v) => $5d44a61170d2e905$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $5d44a61170d2e905$export$6100ba28696e12de, (v) => $5d44a61170d2e905$export$6100ba28696e12de = v);
var $5d44a61170d2e905$export$a48f0734ac7c2329;
var $5d44a61170d2e905$export$d622b2ad8d90c771;
var $5d44a61170d2e905$export$6100ba28696e12de;
"use strict";
$5d44a61170d2e905$export$a48f0734ac7c2329 = $5d44a61170d2e905$var$byteLength;
$5d44a61170d2e905$export$d622b2ad8d90c771 = $5d44a61170d2e905$var$toByteArray;
$5d44a61170d2e905$export$6100ba28696e12de = $5d44a61170d2e905$var$fromByteArray;
var $5d44a61170d2e905$var$lookup = [];
var $5d44a61170d2e905$var$revLookup = [];
var $5d44a61170d2e905$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $5d44a61170d2e905$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $5d44a61170d2e905$var$i = 0, $5d44a61170d2e905$var$len = $5d44a61170d2e905$var$code.length; $5d44a61170d2e905$var$i < $5d44a61170d2e905$var$len; ++$5d44a61170d2e905$var$i){
    $5d44a61170d2e905$var$lookup[$5d44a61170d2e905$var$i] = $5d44a61170d2e905$var$code[$5d44a61170d2e905$var$i];
    $5d44a61170d2e905$var$revLookup[$5d44a61170d2e905$var$code.charCodeAt($5d44a61170d2e905$var$i)] = $5d44a61170d2e905$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$5d44a61170d2e905$var$revLookup["-".charCodeAt(0)] = 62;
$5d44a61170d2e905$var$revLookup["_".charCodeAt(0)] = 63;
function $5d44a61170d2e905$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $5d44a61170d2e905$var$byteLength(b64) {
    var lens = $5d44a61170d2e905$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $5d44a61170d2e905$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $5d44a61170d2e905$var$toByteArray(b64) {
    var tmp;
    var lens = $5d44a61170d2e905$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $5d44a61170d2e905$var$Arr($5d44a61170d2e905$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $5d44a61170d2e905$var$revLookup[b64.charCodeAt(i)] << 18 | $5d44a61170d2e905$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $5d44a61170d2e905$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $5d44a61170d2e905$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $5d44a61170d2e905$var$revLookup[b64.charCodeAt(i)] << 2 | $5d44a61170d2e905$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $5d44a61170d2e905$var$revLookup[b64.charCodeAt(i)] << 10 | $5d44a61170d2e905$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $5d44a61170d2e905$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $5d44a61170d2e905$var$tripletToBase64(num) {
    return $5d44a61170d2e905$var$lookup[num >> 18 & 0x3F] + $5d44a61170d2e905$var$lookup[num >> 12 & 0x3F] + $5d44a61170d2e905$var$lookup[num >> 6 & 0x3F] + $5d44a61170d2e905$var$lookup[num & 0x3F];
}
function $5d44a61170d2e905$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($5d44a61170d2e905$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $5d44a61170d2e905$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($5d44a61170d2e905$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($5d44a61170d2e905$var$lookup[tmp >> 2] + $5d44a61170d2e905$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($5d44a61170d2e905$var$lookup[tmp >> 10] + $5d44a61170d2e905$var$lookup[tmp >> 4 & 0x3F] + $5d44a61170d2e905$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("98vqs", function(module, exports) {

$parcel$export(module.exports, "read", () => $6a6d3ceaa3edb1b3$export$aafa59e2e03f2942, (v) => $6a6d3ceaa3edb1b3$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $6a6d3ceaa3edb1b3$export$68d8715fc104d294, (v) => $6a6d3ceaa3edb1b3$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $6a6d3ceaa3edb1b3$export$aafa59e2e03f2942;
var $6a6d3ceaa3edb1b3$export$68d8715fc104d294;
$6a6d3ceaa3edb1b3$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$6a6d3ceaa3edb1b3$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("8fYP2", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", () => $602ee775ba99a40b$export$c7c5cef950a4d2fc);

var $01cIK = parcelRequire("01cIK");

var $3XYbj = parcelRequire("3XYbj");
const $602ee775ba99a40b$export$c7c5cef950a4d2fc = (input)=>typeof TextEncoder === "function" ? (0, $3XYbj.fromUtf8)(input) : (0, $01cIK.fromUtf8)(input);
const $602ee775ba99a40b$export$b4b216764bb846eb = (input)=>typeof TextDecoder === "function" ? (0, $3XYbj.toUtf8)(input) : (0, $01cIK.toUtf8)(input);

});
parcelRegister("01cIK", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", () => $0039f6314f311c2f$export$c7c5cef950a4d2fc);
$parcel$export(module.exports, "toUtf8", () => $0039f6314f311c2f$export$b4b216764bb846eb);
const $0039f6314f311c2f$export$c7c5cef950a4d2fc = (input)=>{
    const bytes = [];
    for(let i = 0, len = input.length; i < len; i++){
        const value = input.charCodeAt(i);
        if (value < 0x80) bytes.push(value);
        else if (value < 0x800) bytes.push(value >> 6 | 192, value & 63 | 128);
        else if (i + 1 < input.length && (value & 0xfc00) === 0xd800 && (input.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            const surrogatePair = 0x10000 + ((value & 1023) << 10) + (input.charCodeAt(++i) & 1023);
            bytes.push(surrogatePair >> 18 | 240, surrogatePair >> 12 & 63 | 128, surrogatePair >> 6 & 63 | 128, surrogatePair & 63 | 128);
        } else bytes.push(value >> 12 | 224, value >> 6 & 63 | 128, value & 63 | 128);
    }
    return Uint8Array.from(bytes);
};
const $0039f6314f311c2f$export$b4b216764bb846eb = (input)=>{
    let decoded = "";
    for(let i = 0, len = input.length; i < len; i++){
        const byte = input[i];
        if (byte < 0x80) decoded += String.fromCharCode(byte);
        else if (192 <= byte && byte < 224) {
            const nextByte = input[++i];
            decoded += String.fromCharCode((byte & 31) << 6 | nextByte & 63);
        } else if (240 <= byte && byte < 365) {
            const surrogatePair = [
                byte,
                input[++i],
                input[++i],
                input[++i]
            ];
            const encoded = "%" + surrogatePair.map((byteValue)=>byteValue.toString(16)).join("%");
            decoded += decodeURIComponent(encoded);
        } else decoded += String.fromCharCode((byte & 15) << 12 | (input[++i] & 63) << 6 | input[++i] & 63);
    }
    return decoded;
};

});

parcelRegister("3XYbj", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", () => $2e3590969badfec4$export$c7c5cef950a4d2fc);
$parcel$export(module.exports, "toUtf8", () => $2e3590969badfec4$export$b4b216764bb846eb);
function $2e3590969badfec4$export$c7c5cef950a4d2fc(input) {
    return new TextEncoder().encode(input);
}
function $2e3590969badfec4$export$b4b216764bb846eb(input) {
    return new TextDecoder("utf-8").decode(input);
}

});



parcelRegister("4HYJw", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isEmptyData = void 0;
function $36da49e80c62d0a7$var$isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
module.exports.isEmptyData = $36da49e80c62d0a7$var$isEmptyData;

});

parcelRegister("v79S5", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.numToUint8 = void 0;
function $05d872d6826705ad$var$numToUint8(num) {
    return new Uint8Array([
        (num & 0xff000000) >> 24,
        (num & 0x00ff0000) >> 16,
        (num & 0x0000ff00) >> 8,
        num & 0x000000ff
    ]);
}
module.exports.numToUint8 = $05d872d6826705ad$var$numToUint8;

});

parcelRegister("7fqTg", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.uint32ArrayFrom = void 0;
// IE 11 does not support Array.from, so we do it manually
function $546ecb00e648400e$var$uint32ArrayFrom(a_lookUpTable) {
    if (!Uint32Array.from) {
        var return_array = new Uint32Array(a_lookUpTable.length);
        var a_index = 0;
        while(a_index < a_lookUpTable.length){
            return_array[a_index] = a_lookUpTable[a_index];
            a_index += 1;
        }
        return return_array;
    }
    return Uint32Array.from(a_lookUpTable);
}
module.exports.uint32ArrayFrom = $546ecb00e648400e$var$uint32ArrayFrom;

});


parcelRegister("em8va", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AwsCrc32 = void 0;

var $2hFF5 = parcelRequire("2hFF5");

var $hh31F = parcelRequire("hh31F");

var $dXfwr = parcelRequire("dXfwr");
var $a739b707706fe6ff$var$AwsCrc32 = /** @class */ function() {
    function AwsCrc32() {
        this.crc32 = new $dXfwr.Crc32();
    }
    AwsCrc32.prototype.update = function(toHash) {
        if ((0, $hh31F.isEmptyData)(toHash)) return;
        this.crc32.update((0, $hh31F.convertToBuffer)(toHash));
    };
    AwsCrc32.prototype.digest = function() {
        return $2hFF5.__awaiter(this, void 0, void 0, function() {
            return $2hFF5.__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    (0, $hh31F.numToUint8)(this.crc32.digest())
                ];
            });
        });
    };
    AwsCrc32.prototype.reset = function() {
        this.crc32 = new $dXfwr.Crc32();
    };
    return AwsCrc32;
}();
module.exports.AwsCrc32 = $a739b707706fe6ff$var$AwsCrc32;

});


parcelRegister("gkUvU", function(module, exports) {

$parcel$export(module.exports, "HeaderMarshaller", () => $be4a5a05781f9e3b$export$74fd41a85c5dcec9);

var $i6ugP = parcelRequire("i6ugP");

var $1FKNG = parcelRequire("1FKNG");
class $be4a5a05781f9e3b$export$74fd41a85c5dcec9 {
    constructor(toUtf8, fromUtf8){
        this.toUtf8 = toUtf8;
        this.fromUtf8 = fromUtf8;
    }
    format(headers) {
        const chunks = [];
        for (const headerName of Object.keys(headers)){
            const bytes = this.fromUtf8(headerName);
            chunks.push(Uint8Array.from([
                bytes.byteLength
            ]), bytes, this.formatHeaderValue(headers[headerName]));
        }
        const out = new Uint8Array(chunks.reduce((carry, bytes)=>carry + bytes.byteLength, 0));
        let position = 0;
        for (const chunk of chunks){
            out.set(chunk, position);
            position += chunk.byteLength;
        }
        return out;
    }
    formatHeaderValue(header) {
        switch(header.type){
            case "boolean":
                return Uint8Array.from([
                    header.value ? 0 : 1
                ]);
            case "byte":
                return Uint8Array.from([
                    2,
                    header.value
                ]);
            case "short":
                const shortView = new DataView(new ArrayBuffer(3));
                shortView.setUint8(0, 3);
                shortView.setInt16(1, header.value, false);
                return new Uint8Array(shortView.buffer);
            case "integer":
                const intView = new DataView(new ArrayBuffer(5));
                intView.setUint8(0, 4);
                intView.setInt32(1, header.value, false);
                return new Uint8Array(intView.buffer);
            case "long":
                const longBytes = new Uint8Array(9);
                longBytes[0] = 5;
                longBytes.set(header.value.bytes, 1);
                return longBytes;
            case "binary":
                const binView = new DataView(new ArrayBuffer(3 + header.value.byteLength));
                binView.setUint8(0, 6);
                binView.setUint16(1, header.value.byteLength, false);
                const binBytes = new Uint8Array(binView.buffer);
                binBytes.set(header.value, 3);
                return binBytes;
            case "string":
                const utf8Bytes = this.fromUtf8(header.value);
                const strView = new DataView(new ArrayBuffer(3 + utf8Bytes.byteLength));
                strView.setUint8(0, 7);
                strView.setUint16(1, utf8Bytes.byteLength, false);
                const strBytes = new Uint8Array(strView.buffer);
                strBytes.set(utf8Bytes, 3);
                return strBytes;
            case "timestamp":
                const tsBytes = new Uint8Array(9);
                tsBytes[0] = 8;
                tsBytes.set((0, $1FKNG.Int64).fromNumber(header.value.valueOf()).bytes, 1);
                return tsBytes;
            case "uuid":
                if (!$be4a5a05781f9e3b$var$UUID_PATTERN.test(header.value)) throw new Error(`Invalid UUID received: ${header.value}`);
                const uuidBytes = new Uint8Array(17);
                uuidBytes[0] = 9;
                uuidBytes.set((0, $i6ugP.fromHex)(header.value.replace(/\-/g, "")), 1);
                return uuidBytes;
        }
    }
    parse(headers) {
        const out = {};
        let position = 0;
        while(position < headers.byteLength){
            const nameLength = headers.getUint8(position++);
            const name = this.toUtf8(new Uint8Array(headers.buffer, headers.byteOffset + position, nameLength));
            position += nameLength;
            switch(headers.getUint8(position++)){
                case 0:
                    out[name] = {
                        type: $be4a5a05781f9e3b$var$BOOLEAN_TAG,
                        value: true
                    };
                    break;
                case 1:
                    out[name] = {
                        type: $be4a5a05781f9e3b$var$BOOLEAN_TAG,
                        value: false
                    };
                    break;
                case 2:
                    out[name] = {
                        type: $be4a5a05781f9e3b$var$BYTE_TAG,
                        value: headers.getInt8(position++)
                    };
                    break;
                case 3:
                    out[name] = {
                        type: $be4a5a05781f9e3b$var$SHORT_TAG,
                        value: headers.getInt16(position, false)
                    };
                    position += 2;
                    break;
                case 4:
                    out[name] = {
                        type: $be4a5a05781f9e3b$var$INT_TAG,
                        value: headers.getInt32(position, false)
                    };
                    position += 4;
                    break;
                case 5:
                    out[name] = {
                        type: $be4a5a05781f9e3b$var$LONG_TAG,
                        value: new (0, $1FKNG.Int64)(new Uint8Array(headers.buffer, headers.byteOffset + position, 8))
                    };
                    position += 8;
                    break;
                case 6:
                    const binaryLength = headers.getUint16(position, false);
                    position += 2;
                    out[name] = {
                        type: $be4a5a05781f9e3b$var$BINARY_TAG,
                        value: new Uint8Array(headers.buffer, headers.byteOffset + position, binaryLength)
                    };
                    position += binaryLength;
                    break;
                case 7:
                    const stringLength = headers.getUint16(position, false);
                    position += 2;
                    out[name] = {
                        type: $be4a5a05781f9e3b$var$STRING_TAG,
                        value: this.toUtf8(new Uint8Array(headers.buffer, headers.byteOffset + position, stringLength))
                    };
                    position += stringLength;
                    break;
                case 8:
                    out[name] = {
                        type: $be4a5a05781f9e3b$var$TIMESTAMP_TAG,
                        value: new Date(new (0, $1FKNG.Int64)(new Uint8Array(headers.buffer, headers.byteOffset + position, 8)).valueOf())
                    };
                    position += 8;
                    break;
                case 9:
                    const uuidBytes = new Uint8Array(headers.buffer, headers.byteOffset + position, 16);
                    position += 16;
                    out[name] = {
                        type: $be4a5a05781f9e3b$var$UUID_TAG,
                        value: `${(0, $i6ugP.toHex)(uuidBytes.subarray(0, 4))}-${(0, $i6ugP.toHex)(uuidBytes.subarray(4, 6))}-${(0, $i6ugP.toHex)(uuidBytes.subarray(6, 8))}-${(0, $i6ugP.toHex)(uuidBytes.subarray(8, 10))}-${(0, $i6ugP.toHex)(uuidBytes.subarray(10))}`
                    };
                    break;
                default:
                    throw new Error(`Unrecognized header type tag`);
            }
        }
        return out;
    }
}
var $be4a5a05781f9e3b$var$HEADER_VALUE_TYPE;
(function(HEADER_VALUE_TYPE) {
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["boolTrue"] = 0] = "boolTrue";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["boolFalse"] = 1] = "boolFalse";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["byte"] = 2] = "byte";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["short"] = 3] = "short";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["integer"] = 4] = "integer";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["long"] = 5] = "long";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["byteArray"] = 6] = "byteArray";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["string"] = 7] = "string";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["timestamp"] = 8] = "timestamp";
    HEADER_VALUE_TYPE[HEADER_VALUE_TYPE["uuid"] = 9] = "uuid";
})($be4a5a05781f9e3b$var$HEADER_VALUE_TYPE || ($be4a5a05781f9e3b$var$HEADER_VALUE_TYPE = {}));
const $be4a5a05781f9e3b$var$BOOLEAN_TAG = "boolean";
const $be4a5a05781f9e3b$var$BYTE_TAG = "byte";
const $be4a5a05781f9e3b$var$SHORT_TAG = "short";
const $be4a5a05781f9e3b$var$INT_TAG = "integer";
const $be4a5a05781f9e3b$var$LONG_TAG = "long";
const $be4a5a05781f9e3b$var$BINARY_TAG = "binary";
const $be4a5a05781f9e3b$var$STRING_TAG = "string";
const $be4a5a05781f9e3b$var$TIMESTAMP_TAG = "timestamp";
const $be4a5a05781f9e3b$var$UUID_TAG = "uuid";
const $be4a5a05781f9e3b$var$UUID_PATTERN = /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/;

});
parcelRegister("1FKNG", function(module, exports) {

$parcel$export(module.exports, "Int64", () => $137dec5738f3e04c$export$8a5e19712a0a5deb);

var $i6ugP = parcelRequire("i6ugP");
class $137dec5738f3e04c$export$8a5e19712a0a5deb {
    constructor(bytes){
        this.bytes = bytes;
        if (bytes.byteLength !== 8) throw new Error("Int64 buffers must be exactly 8 bytes");
    }
    static fromNumber(number) {
        if (number > 9223372036854776000 || number < -9223372036854776000) throw new Error(`${number} is too large (or, if negative, too small) to represent as an Int64`);
        const bytes = new Uint8Array(8);
        for(let i = 7, remaining = Math.abs(Math.round(number)); i > -1 && remaining > 0; i--, remaining /= 256)bytes[i] = remaining;
        if (number < 0) $137dec5738f3e04c$var$negate(bytes);
        return new $137dec5738f3e04c$export$8a5e19712a0a5deb(bytes);
    }
    valueOf() {
        const bytes = this.bytes.slice(0);
        const negative = bytes[0] & 128;
        if (negative) $137dec5738f3e04c$var$negate(bytes);
        return parseInt((0, $i6ugP.toHex)(bytes), 16) * (negative ? -1 : 1);
    }
    toString() {
        return String(this.valueOf());
    }
}
function $137dec5738f3e04c$var$negate(bytes) {
    for(let i = 0; i < 8; i++)bytes[i] ^= 0xff;
    for(let i = 7; i > -1; i--){
        bytes[i]++;
        if (bytes[i] !== 0) break;
    }
}

});


parcelRegister("4AtkP", function(module, exports) {

$parcel$export(module.exports, "splitMessage", () => $35714787f911703e$export$546b6bc432bd9a53);

var $dXfwr = parcelRequire("dXfwr");
const $35714787f911703e$var$PRELUDE_MEMBER_LENGTH = 4;
const $35714787f911703e$var$PRELUDE_LENGTH = $35714787f911703e$var$PRELUDE_MEMBER_LENGTH * 2;
const $35714787f911703e$var$CHECKSUM_LENGTH = 4;
const $35714787f911703e$var$MINIMUM_MESSAGE_LENGTH = $35714787f911703e$var$PRELUDE_LENGTH + $35714787f911703e$var$CHECKSUM_LENGTH * 2;
function $35714787f911703e$export$546b6bc432bd9a53({ byteLength: byteLength, byteOffset: byteOffset, buffer: buffer }) {
    if (byteLength < $35714787f911703e$var$MINIMUM_MESSAGE_LENGTH) throw new Error("Provided message too short to accommodate event stream message overhead");
    const view = new DataView(buffer, byteOffset, byteLength);
    const messageLength = view.getUint32(0, false);
    if (byteLength !== messageLength) throw new Error("Reported message length does not match received message length");
    const headerLength = view.getUint32($35714787f911703e$var$PRELUDE_MEMBER_LENGTH, false);
    const expectedPreludeChecksum = view.getUint32($35714787f911703e$var$PRELUDE_LENGTH, false);
    const expectedMessageChecksum = view.getUint32(byteLength - $35714787f911703e$var$CHECKSUM_LENGTH, false);
    const checksummer = new (0, $dXfwr.Crc32)().update(new Uint8Array(buffer, byteOffset, $35714787f911703e$var$PRELUDE_LENGTH));
    if (expectedPreludeChecksum !== checksummer.digest()) throw new Error(`The prelude checksum specified in the message (${expectedPreludeChecksum}) does not match the calculated CRC32 checksum (${checksummer.digest()})`);
    checksummer.update(new Uint8Array(buffer, byteOffset + $35714787f911703e$var$PRELUDE_LENGTH, byteLength - ($35714787f911703e$var$PRELUDE_LENGTH + $35714787f911703e$var$CHECKSUM_LENGTH)));
    if (expectedMessageChecksum !== checksummer.digest()) throw new Error(`The message checksum (${checksummer.digest()}) did not match the expected value of ${expectedMessageChecksum}`);
    return {
        headers: new DataView(buffer, byteOffset + $35714787f911703e$var$PRELUDE_LENGTH + $35714787f911703e$var$CHECKSUM_LENGTH, headerLength),
        body: new Uint8Array(buffer, byteOffset + $35714787f911703e$var$PRELUDE_LENGTH + $35714787f911703e$var$CHECKSUM_LENGTH + headerLength, messageLength - headerLength - ($35714787f911703e$var$PRELUDE_LENGTH + $35714787f911703e$var$CHECKSUM_LENGTH + $35714787f911703e$var$CHECKSUM_LENGTH))
    };
}

});


parcelRegister("5MtN5", function(module, exports) {

});

parcelRegister("6qG1H", function(module, exports) {
class $4ae5c5594dfd7933$export$4ffe73dc7dfe29dd {
    constructor(options){
        this.options = options;
    }
    [Symbol.asyncIterator]() {
        return this.asyncIterator();
    }
    async *asyncIterator() {
        for await (const bytes of this.options.inputStream){
            const decoded = this.options.decoder.decode(bytes);
            yield decoded;
        }
    }
}

});

parcelRegister("7P7VW", function(module, exports) {
class $5b23734159dd2792$export$1204278c33e35f1b {
    constructor(options){
        this.options = options;
    }
    [Symbol.asyncIterator]() {
        return this.asyncIterator();
    }
    async *asyncIterator() {
        for await (const msg of this.options.messageStream){
            const encoded = this.options.encoder.encode(msg);
            yield encoded;
        }
        if (this.options.includeEndFrame) yield new Uint8Array(0);
    }
}

});

parcelRegister("c1mUl", function(module, exports) {
class $8c07590830f4e6eb$export$c78403d78d3ee8a {
    constructor(options){
        this.options = options;
    }
    [Symbol.asyncIterator]() {
        return this.asyncIterator();
    }
    async *asyncIterator() {
        for await (const message of this.options.messageStream){
            const deserialized = await this.options.deserializer(message);
            if (deserialized === undefined) continue;
            yield deserialized;
        }
    }
}

});

parcelRegister("55JPZ", function(module, exports) {
class $3b50f9bcfda7303e$export$96361fe9dd919a8e {
    constructor(options){
        this.options = options;
    }
    [Symbol.asyncIterator]() {
        return this.asyncIterator();
    }
    async *asyncIterator() {
        for await (const chunk of this.options.inputStream){
            const payloadBuf = this.options.serializer(chunk);
            yield payloadBuf;
        }
    }
}

});


parcelRegister("dKey1", function(module, exports) {

$parcel$export(module.exports, "ALGORITHM_QUERY_PARAM", () => $a01adb1cb0591896$export$186cd8495ba0377d);
$parcel$export(module.exports, "CREDENTIAL_QUERY_PARAM", () => $a01adb1cb0591896$export$5c8e6dd7758f59d6);
$parcel$export(module.exports, "AMZ_DATE_QUERY_PARAM", () => $a01adb1cb0591896$export$6e114beec37430d7);
$parcel$export(module.exports, "SIGNED_HEADERS_QUERY_PARAM", () => $a01adb1cb0591896$export$2dcbb254f883c238);
$parcel$export(module.exports, "EXPIRES_QUERY_PARAM", () => $a01adb1cb0591896$export$a0afe6f3bbfaf76e);
$parcel$export(module.exports, "SIGNATURE_QUERY_PARAM", () => $a01adb1cb0591896$export$41ae838dc1e0f082);
$parcel$export(module.exports, "TOKEN_QUERY_PARAM", () => $a01adb1cb0591896$export$8e1383b7eea7bee);
$parcel$export(module.exports, "AUTH_HEADER", () => $a01adb1cb0591896$export$9924a64a4b8b0d58);
$parcel$export(module.exports, "AMZ_DATE_HEADER", () => $a01adb1cb0591896$export$acf4b8bdf24aab34);
$parcel$export(module.exports, "GENERATED_HEADERS", () => $a01adb1cb0591896$export$20d6a73fd0b10982);
$parcel$export(module.exports, "SIGNATURE_HEADER", () => $a01adb1cb0591896$export$29961f34c719157e);
$parcel$export(module.exports, "SHA256_HEADER", () => $a01adb1cb0591896$export$eaef12179141669a);
$parcel$export(module.exports, "TOKEN_HEADER", () => $a01adb1cb0591896$export$fdc81b663012a8d2);
$parcel$export(module.exports, "ALWAYS_UNSIGNABLE_HEADERS", () => $a01adb1cb0591896$export$8ffdcd58c4092560);
$parcel$export(module.exports, "PROXY_HEADER_PATTERN", () => $a01adb1cb0591896$export$8085db98abbe0597);
$parcel$export(module.exports, "SEC_HEADER_PATTERN", () => $a01adb1cb0591896$export$758380400526c39);
$parcel$export(module.exports, "ALGORITHM_IDENTIFIER", () => $a01adb1cb0591896$export$863a63fba5b2ddf5);
$parcel$export(module.exports, "EVENT_ALGORITHM_IDENTIFIER", () => $a01adb1cb0591896$export$9a1f6cf06ac56167);
$parcel$export(module.exports, "UNSIGNED_PAYLOAD", () => $a01adb1cb0591896$export$91f7321b40d9fd07);
$parcel$export(module.exports, "MAX_CACHE_SIZE", () => $a01adb1cb0591896$export$bf665777b4a1722f);
$parcel$export(module.exports, "KEY_TYPE_IDENTIFIER", () => $a01adb1cb0591896$export$c4bf0942098f6bb);
$parcel$export(module.exports, "MAX_PRESIGNED_TTL", () => $a01adb1cb0591896$export$274df788bdcca184);
const $a01adb1cb0591896$export$186cd8495ba0377d = "X-Amz-Algorithm";
const $a01adb1cb0591896$export$5c8e6dd7758f59d6 = "X-Amz-Credential";
const $a01adb1cb0591896$export$6e114beec37430d7 = "X-Amz-Date";
const $a01adb1cb0591896$export$2dcbb254f883c238 = "X-Amz-SignedHeaders";
const $a01adb1cb0591896$export$a0afe6f3bbfaf76e = "X-Amz-Expires";
const $a01adb1cb0591896$export$41ae838dc1e0f082 = "X-Amz-Signature";
const $a01adb1cb0591896$export$8e1383b7eea7bee = "X-Amz-Security-Token";
const $a01adb1cb0591896$export$296a4bada3fe6343 = "X-Amz-Region-Set";
const $a01adb1cb0591896$export$9924a64a4b8b0d58 = "authorization";
const $a01adb1cb0591896$export$acf4b8bdf24aab34 = $a01adb1cb0591896$export$6e114beec37430d7.toLowerCase();
const $a01adb1cb0591896$export$c65c8c9f514da472 = "date";
const $a01adb1cb0591896$export$20d6a73fd0b10982 = [
    $a01adb1cb0591896$export$9924a64a4b8b0d58,
    $a01adb1cb0591896$export$acf4b8bdf24aab34,
    $a01adb1cb0591896$export$c65c8c9f514da472
];
const $a01adb1cb0591896$export$29961f34c719157e = $a01adb1cb0591896$export$41ae838dc1e0f082.toLowerCase();
const $a01adb1cb0591896$export$eaef12179141669a = "x-amz-content-sha256";
const $a01adb1cb0591896$export$fdc81b663012a8d2 = $a01adb1cb0591896$export$8e1383b7eea7bee.toLowerCase();
const $a01adb1cb0591896$export$96307741595055fc = "host";
const $a01adb1cb0591896$export$8ffdcd58c4092560 = {
    authorization: true,
    "cache-control": true,
    connection: true,
    expect: true,
    from: true,
    "keep-alive": true,
    "max-forwards": true,
    pragma: true,
    referer: true,
    te: true,
    trailer: true,
    "transfer-encoding": true,
    upgrade: true,
    "user-agent": true,
    "x-amzn-trace-id": true
};
const $a01adb1cb0591896$export$8085db98abbe0597 = /^proxy-/;
const $a01adb1cb0591896$export$758380400526c39 = /^sec-/;
const $a01adb1cb0591896$export$94e2b626bfa803e0 = [
    /^proxy-/i,
    /^sec-/i
];
const $a01adb1cb0591896$export$863a63fba5b2ddf5 = "AWS4-HMAC-SHA256";
const $a01adb1cb0591896$export$7ad82ab3c556a776 = "AWS4-ECDSA-P256-SHA256";
const $a01adb1cb0591896$export$9a1f6cf06ac56167 = "AWS4-HMAC-SHA256-PAYLOAD";
const $a01adb1cb0591896$export$91f7321b40d9fd07 = "UNSIGNED-PAYLOAD";
const $a01adb1cb0591896$export$bf665777b4a1722f = 50;
const $a01adb1cb0591896$export$c4bf0942098f6bb = "aws4_request";
const $a01adb1cb0591896$export$274df788bdcca184 = 604800;

});

parcelRegister("fYZPV", function(module, exports) {

$parcel$export(module.exports, "createScope", () => $ba2c6d0b8b8e1136$export$41a9651decfe2bde);
$parcel$export(module.exports, "getSigningKey", () => $ba2c6d0b8b8e1136$export$8b95a069d16dd783);

var $i6ugP = parcelRequire("i6ugP");
parcelRequire("cace4");
var $cHGTK = parcelRequire("cHGTK");

var $dKey1 = parcelRequire("dKey1");
const $ba2c6d0b8b8e1136$var$signingKeyCache = {};
const $ba2c6d0b8b8e1136$var$cacheQueue = [];
const $ba2c6d0b8b8e1136$export$41a9651decfe2bde = (shortDate, region, service)=>`${shortDate}/${region}/${service}/${0, $dKey1.KEY_TYPE_IDENTIFIER}`;
const $ba2c6d0b8b8e1136$export$8b95a069d16dd783 = async (sha256Constructor, credentials, shortDate, region, service)=>{
    const credsHash = await $ba2c6d0b8b8e1136$var$hmac(sha256Constructor, credentials.secretAccessKey, credentials.accessKeyId);
    const cacheKey = `${shortDate}:${region}:${service}:${(0, $i6ugP.toHex)(credsHash)}:${credentials.sessionToken}`;
    if (cacheKey in $ba2c6d0b8b8e1136$var$signingKeyCache) return $ba2c6d0b8b8e1136$var$signingKeyCache[cacheKey];
    $ba2c6d0b8b8e1136$var$cacheQueue.push(cacheKey);
    while($ba2c6d0b8b8e1136$var$cacheQueue.length > (0, $dKey1.MAX_CACHE_SIZE))delete $ba2c6d0b8b8e1136$var$signingKeyCache[$ba2c6d0b8b8e1136$var$cacheQueue.shift()];
    let key = `AWS4${credentials.secretAccessKey}`;
    for (const signable of [
        shortDate,
        region,
        service,
        (0, $dKey1.KEY_TYPE_IDENTIFIER)
    ])key = await $ba2c6d0b8b8e1136$var$hmac(sha256Constructor, key, signable);
    return $ba2c6d0b8b8e1136$var$signingKeyCache[cacheKey] = key;
};
const $ba2c6d0b8b8e1136$export$a31b95746ea0a30a = ()=>{
    $ba2c6d0b8b8e1136$var$cacheQueue.length = 0;
    Object.keys($ba2c6d0b8b8e1136$var$signingKeyCache).forEach((cacheKey)=>{
        delete $ba2c6d0b8b8e1136$var$signingKeyCache[cacheKey];
    });
};
const $ba2c6d0b8b8e1136$var$hmac = (ctor, secret, data)=>{
    const hash = new ctor(secret);
    hash.update((0, $cHGTK.toUint8Array)(data));
    return hash.digest();
};

});

parcelRegister("2Mpx0", function(module, exports) {

$parcel$export(module.exports, "getCanonicalHeaders", () => $2063de71dca464cc$export$859d7f1bb55e2914);

var $dKey1 = parcelRequire("dKey1");
const $2063de71dca464cc$export$859d7f1bb55e2914 = ({ headers: headers }, unsignableHeaders, signableHeaders)=>{
    const canonical = {};
    for (const headerName of Object.keys(headers).sort()){
        if (headers[headerName] == undefined) continue;
        const canonicalHeaderName = headerName.toLowerCase();
        if (canonicalHeaderName in (0, $dKey1.ALWAYS_UNSIGNABLE_HEADERS) || unsignableHeaders?.has(canonicalHeaderName) || (0, $dKey1.PROXY_HEADER_PATTERN).test(canonicalHeaderName) || (0, $dKey1.SEC_HEADER_PATTERN).test(canonicalHeaderName)) {
            if (!signableHeaders || signableHeaders && !signableHeaders.has(canonicalHeaderName)) continue;
        }
        canonical[canonicalHeaderName] = headers[headerName].trim().replace(/\s+/g, " ");
    }
    return canonical;
};

});

parcelRegister("6QPwd", function(module, exports) {

$parcel$export(module.exports, "getCanonicalQuery", () => $4fcf8ff08d8d7e76$export$8fea7e63ecd1ddbb);
parcelRequire("ceETf");
var $gFFnP = parcelRequire("gFFnP");

var $dKey1 = parcelRequire("dKey1");
const $4fcf8ff08d8d7e76$export$8fea7e63ecd1ddbb = ({ query: query = {} })=>{
    const keys = [];
    const serialized = {};
    for (const key of Object.keys(query).sort()){
        if (key.toLowerCase() === (0, $dKey1.SIGNATURE_HEADER)) continue;
        keys.push(key);
        const value = query[key];
        if (typeof value === "string") serialized[key] = `${(0, $gFFnP.escapeUri)(key)}=${(0, $gFFnP.escapeUri)(value)}`;
        else if (Array.isArray(value)) serialized[key] = value.slice(0).reduce((encoded, value)=>encoded.concat([
                `${(0, $gFFnP.escapeUri)(key)}=${(0, $gFFnP.escapeUri)(value)}`
            ]), []).sort().join("&");
    }
    return keys.map((key)=>serialized[key]).filter((serialized)=>serialized).join("&");
};

});

parcelRegister("5e75L", function(module, exports) {

$parcel$export(module.exports, "getPayloadHash", () => $3ce3c2dfe1f0dbc7$export$a46a74202b0efd71);

var $3BHCw = parcelRequire("3BHCw");

var $i6ugP = parcelRequire("i6ugP");
parcelRequire("cace4");
var $cHGTK = parcelRequire("cHGTK");

var $dKey1 = parcelRequire("dKey1");
const $3ce3c2dfe1f0dbc7$export$a46a74202b0efd71 = async ({ headers: headers, body: body }, hashConstructor)=>{
    for (const headerName of Object.keys(headers)){
        if (headerName.toLowerCase() === (0, $dKey1.SHA256_HEADER)) return headers[headerName];
    }
    if (body == undefined) return "e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855";
    else if (typeof body === "string" || ArrayBuffer.isView(body) || (0, $3BHCw.isArrayBuffer)(body)) {
        const hashCtor = new hashConstructor();
        hashCtor.update((0, $cHGTK.toUint8Array)(body));
        return (0, $i6ugP.toHex)(await hashCtor.digest());
    }
    return 0, $dKey1.UNSIGNED_PAYLOAD;
};

});
parcelRegister("3BHCw", function(module, exports) {

$parcel$export(module.exports, "isArrayBuffer", () => $2a06a9e291daa332$export$9dd3754ae86f0017);
const $2a06a9e291daa332$export$9dd3754ae86f0017 = (arg)=>typeof ArrayBuffer === "function" && arg instanceof ArrayBuffer || Object.prototype.toString.call(arg) === "[object ArrayBuffer]";

});


parcelRegister("qiFzL", function(module, exports) {

$parcel$export(module.exports, "hasHeader", () => $04f0e9363cf77a22$export$17944590be865217);
const $04f0e9363cf77a22$export$17944590be865217 = (soughtHeader, headers)=>{
    soughtHeader = soughtHeader.toLowerCase();
    for (const headerName of Object.keys(headers)){
        if (soughtHeader === headerName.toLowerCase()) return true;
    }
    return false;
};
const $04f0e9363cf77a22$export$149b1181d497cd = (soughtHeader, headers)=>{
    soughtHeader = soughtHeader.toLowerCase();
    for (const headerName of Object.keys(headers)){
        if (soughtHeader === headerName.toLowerCase()) return headers[headerName];
    }
    return undefined;
};
const $04f0e9363cf77a22$export$d3408eaf94074c90 = (soughtHeader, headers)=>{
    soughtHeader = soughtHeader.toLowerCase();
    for (const headerName of Object.keys(headers))if (soughtHeader === headerName.toLowerCase()) delete headers[headerName];
};

});

parcelRegister("kh5Zk", function(module, exports) {

$parcel$export(module.exports, "moveHeadersToQuery", () => $ec2a0a48ea1de9e9$export$bfc08a76d4bd60f6);

var $330FX = parcelRequire("330FX");
const $ec2a0a48ea1de9e9$export$bfc08a76d4bd60f6 = (request, options = {})=>{
    const { headers: headers, query: query = {} } = typeof request.clone === "function" ? request.clone() : (0, $330FX.cloneRequest)(request);
    for (const name of Object.keys(headers)){
        const lname = name.toLowerCase();
        if (lname.slice(0, 6) === "x-amz-" && !options.unhoistableHeaders?.has(lname)) {
            query[name] = headers[name];
            delete headers[name];
        }
    }
    return {
        ...request,
        headers: headers,
        query: query
    };
};

});
parcelRegister("330FX", function(module, exports) {

$parcel$export(module.exports, "cloneRequest", () => $23822d16e4d6dc0f$export$d043aa0bf7223286);
const $23822d16e4d6dc0f$export$d043aa0bf7223286 = ({ headers: headers, query: query, ...rest })=>({
        ...rest,
        headers: {
            ...headers
        },
        query: query ? $23822d16e4d6dc0f$export$4923819f93729b21(query) : undefined
    });
const $23822d16e4d6dc0f$export$4923819f93729b21 = (query)=>Object.keys(query).reduce((carry, paramName)=>{
        const param = query[paramName];
        return {
            ...carry,
            [paramName]: Array.isArray(param) ? [
                ...param
            ] : param
        };
    }, {});

});


parcelRegister("dxNZk", function(module, exports) {

$parcel$export(module.exports, "prepareRequest", () => $9dc52209b08db43f$export$a7cfe9131aa06be4);

var $330FX = parcelRequire("330FX");

var $dKey1 = parcelRequire("dKey1");
const $9dc52209b08db43f$export$a7cfe9131aa06be4 = (request)=>{
    request = typeof request.clone === "function" ? request.clone() : (0, $330FX.cloneRequest)(request);
    for (const headerName of Object.keys(request.headers))if ((0, $dKey1.GENERATED_HEADERS).indexOf(headerName.toLowerCase()) > -1) delete request.headers[headerName];
    return request;
};

});

parcelRegister("bEM4m", function(module, exports) {

$parcel$export(module.exports, "iso8601", () => $87c8b7b60cf75edc$export$b65d57190c224ef2);
const $87c8b7b60cf75edc$export$b65d57190c224ef2 = (time)=>$87c8b7b60cf75edc$export$e67a095c620b86fe(time).toISOString().replace(/\.\d{3}Z$/, "Z");
const $87c8b7b60cf75edc$export$e67a095c620b86fe = (time)=>{
    if (typeof time === "number") return new Date(time * 1000);
    if (typeof time === "string") {
        if (Number(time)) return new Date(Number(time) * 1000);
        return new Date(time);
    }
    return time;
};

});




parcelRegister("kq0db", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WebCryptoSha256 = module.exports.Ie11Sha256 = void 0;

var $8h5Kl = parcelRequire("8h5Kl");

$8h5Kl.__exportStar((parcelRequire("kP84E")), module.exports);

var $bSO3n = parcelRequire("bSO3n");
Object.defineProperty(module.exports, "Ie11Sha256", {
    enumerable: true,
    get: function() {
        return $bSO3n.Sha256;
    }
});

var $igiTs = parcelRequire("igiTs");
Object.defineProperty(module.exports, "WebCryptoSha256", {
    enumerable: true,
    get: function() {
        return $igiTs.Sha256;
    }
});

});
parcelRegister("8h5Kl", function(module, exports) {

$parcel$export(module.exports, "__exportStar", () => $60645e6225678b11$export$f33643c0debef087);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $60645e6225678b11$var$extendStatics = function(d, b) {
    $60645e6225678b11$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $60645e6225678b11$var$extendStatics(d, b);
};
function $60645e6225678b11$export$a8ba968b8961cb8a(d, b) {
    $60645e6225678b11$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $60645e6225678b11$export$18ce0697a983be9b = function() {
    $60645e6225678b11$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $60645e6225678b11$export$18ce0697a983be9b.apply(this, arguments);
};
function $60645e6225678b11$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $60645e6225678b11$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $60645e6225678b11$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $60645e6225678b11$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $60645e6225678b11$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $60645e6225678b11$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $60645e6225678b11$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $60645e6225678b11$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $60645e6225678b11$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $60645e6225678b11$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $60645e6225678b11$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($60645e6225678b11$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $60645e6225678b11$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $60645e6225678b11$export$10c90e4f7922046c(v) {
    return this instanceof $60645e6225678b11$export$10c90e4f7922046c ? (this.v = v, this) : new $60645e6225678b11$export$10c90e4f7922046c(v);
}
function $60645e6225678b11$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $60645e6225678b11$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $60645e6225678b11$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $60645e6225678b11$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $60645e6225678b11$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $60645e6225678b11$export$19a8beecd37a4c45 === "function" ? $60645e6225678b11$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $60645e6225678b11$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $60645e6225678b11$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $60645e6225678b11$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $60645e6225678b11$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $60645e6225678b11$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("kP84E", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Sha256 = void 0;

var $bSO3n = parcelRequire("bSO3n");

var $igiTs = parcelRequire("igiTs");

var $5x3wv = parcelRequire("5x3wv");

var $a0eT5 = parcelRequire("a0eT5");

var $h0pIy = parcelRequire("h0pIy");

var $dKTnf = parcelRequire("dKTnf");

var $hh31F = parcelRequire("hh31F");
var $f28ed5676e994517$var$Sha256 = /** @class */ function() {
    function Sha256(secret) {
        if ((0, $a0eT5.supportsWebCrypto)((0, $dKTnf.locateWindow)())) this.hash = new $igiTs.Sha256(secret);
        else if ((0, $h0pIy.isMsWindow)((0, $dKTnf.locateWindow)())) this.hash = new $bSO3n.Sha256(secret);
        else this.hash = new $5x3wv.Sha256(secret);
    }
    Sha256.prototype.update = function(data, encoding) {
        this.hash.update((0, $hh31F.convertToBuffer)(data));
    };
    Sha256.prototype.digest = function() {
        return this.hash.digest();
    };
    Sha256.prototype.reset = function() {
        this.hash.reset();
    };
    return Sha256;
}();
module.exports.Sha256 = $f28ed5676e994517$var$Sha256;

});
parcelRegister("bSO3n", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Sha256 = void 0;

var $hL6rC = parcelRequire("hL6rC");

var $eFqZV = parcelRequire("eFqZV");

var $8fYP2 = parcelRequire("8fYP2");

var $dKTnf = parcelRequire("dKTnf");
var $8a6b906a7e8fedbc$var$Sha256 = /** @class */ function() {
    function Sha256(secret) {
        this.secret = secret;
        this.reset();
    }
    Sha256.prototype.update = function(toHash) {
        var _this = this;
        if ((0, $hL6rC.isEmptyData)(toHash)) return;
        this.operation = this.operation.then(function(operation) {
            operation.onerror = function() {
                _this.operation = Promise.reject(new Error("Error encountered updating hash"));
            };
            operation.process($8a6b906a7e8fedbc$var$toArrayBufferView(toHash));
            return operation;
        });
        this.operation.catch(function() {});
    };
    Sha256.prototype.digest = function() {
        return this.operation.then(function(operation) {
            return new Promise(function(resolve, reject) {
                operation.onerror = function() {
                    reject(new Error("Error encountered finalizing hash"));
                };
                operation.oncomplete = function() {
                    if (operation.result) resolve(new Uint8Array(operation.result));
                    reject(new Error("Error encountered finalizing hash"));
                };
                operation.finish();
            });
        });
    };
    Sha256.prototype.reset = function() {
        if (this.secret) {
            this.operation = $8a6b906a7e8fedbc$var$getKeyPromise(this.secret).then(function(keyData) {
                return (0, $dKTnf.locateWindow)().msCrypto.subtle.sign($eFqZV.SHA_256_HMAC_ALGO, keyData);
            });
            this.operation.catch(function() {});
        } else this.operation = Promise.resolve((0, $dKTnf.locateWindow)().msCrypto.subtle.digest("SHA-256"));
    };
    return Sha256;
}();
module.exports.Sha256 = $8a6b906a7e8fedbc$var$Sha256;
function $8a6b906a7e8fedbc$var$getKeyPromise(secret) {
    return new Promise(function(resolve, reject) {
        var keyOperation = (0, $dKTnf.locateWindow)().msCrypto.subtle.importKey("raw", $8a6b906a7e8fedbc$var$toArrayBufferView(secret), $eFqZV.SHA_256_HMAC_ALGO, false, [
            "sign"
        ]);
        keyOperation.oncomplete = function() {
            if (keyOperation.result) resolve(keyOperation.result);
            reject(new Error("ImportKey completed without importing key."));
        };
        keyOperation.onerror = function() {
            reject(new Error("ImportKey failed to import key."));
        };
    });
}
function $8a6b906a7e8fedbc$var$toArrayBufferView(data) {
    if (typeof data === "string") return (0, $8fYP2.fromUtf8)(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}

});
parcelRegister("hL6rC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isEmptyData = void 0;
function $cedbd33654d7046d$var$isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
module.exports.isEmptyData = $cedbd33654d7046d$var$isEmptyData;

});

parcelRegister("eFqZV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EMPTY_DATA_SHA_256 = module.exports.SHA_256_HMAC_ALGO = module.exports.SHA_256_HASH = void 0;
module.exports.SHA_256_HASH = {
    name: "SHA-256"
};
module.exports.SHA_256_HMAC_ALGO = {
    name: "HMAC",
    hash: module.exports.SHA_256_HASH
};
module.exports.EMPTY_DATA_SHA_256 = new Uint8Array([
    227,
    176,
    196,
    66,
    152,
    252,
    28,
    20,
    154,
    251,
    244,
    200,
    153,
    111,
    185,
    36,
    39,
    174,
    65,
    228,
    100,
    155,
    147,
    76,
    164,
    149,
    153,
    27,
    120,
    82,
    184,
    85
]);

});

parcelRegister("dKTnf", function(module, exports) {

$parcel$export(module.exports, "locateWindow", () => $a03a865493c4f868$export$2a77db4d0e0dd1ff);
const $a03a865493c4f868$var$fallbackWindow = {};
function $a03a865493c4f868$export$2a77db4d0e0dd1ff() {
    if (typeof window !== "undefined") return window;
    else if (typeof self !== "undefined") return self;
    return $a03a865493c4f868$var$fallbackWindow;
}

});


parcelRegister("igiTs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Sha256 = void 0;

var $hh31F = parcelRequire("hh31F");

var $eFqZV = parcelRequire("eFqZV");

var $dKTnf = parcelRequire("dKTnf");
var $d4b86072d37bebc9$var$Sha256 = /** @class */ function() {
    function Sha256(secret) {
        this.toHash = new Uint8Array(0);
        this.secret = secret;
        this.reset();
    }
    Sha256.prototype.update = function(data) {
        if ((0, $hh31F.isEmptyData)(data)) return;
        var update = (0, $hh31F.convertToBuffer)(data);
        var typedArray = new Uint8Array(this.toHash.byteLength + update.byteLength);
        typedArray.set(this.toHash, 0);
        typedArray.set(update, this.toHash.byteLength);
        this.toHash = typedArray;
    };
    Sha256.prototype.digest = function() {
        var _this = this;
        if (this.key) return this.key.then(function(key) {
            return (0, $dKTnf.locateWindow)().crypto.subtle.sign($eFqZV.SHA_256_HMAC_ALGO, key, _this.toHash).then(function(data) {
                return new Uint8Array(data);
            });
        });
        if ((0, $hh31F.isEmptyData)(this.toHash)) return Promise.resolve($eFqZV.EMPTY_DATA_SHA_256);
        return Promise.resolve().then(function() {
            return (0, $dKTnf.locateWindow)().crypto.subtle.digest($eFqZV.SHA_256_HASH, _this.toHash);
        }).then(function(data) {
            return Promise.resolve(new Uint8Array(data));
        });
    };
    Sha256.prototype.reset = function() {
        var _this = this;
        this.toHash = new Uint8Array(0);
        if (this.secret && this.secret !== void 0) {
            this.key = new Promise(function(resolve, reject) {
                (0, $dKTnf.locateWindow)().crypto.subtle.importKey("raw", (0, $hh31F.convertToBuffer)(_this.secret), $eFqZV.SHA_256_HMAC_ALGO, false, [
                    "sign"
                ]).then(resolve, reject);
            });
            this.key.catch(function() {});
        }
    };
    return Sha256;
}();
module.exports.Sha256 = $d4b86072d37bebc9$var$Sha256;

});

parcelRegister("5x3wv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $hGvqL = parcelRequire("hGvqL");

$hGvqL.__exportStar((parcelRequire("j0rqA")), module.exports);

});
parcelRegister("hGvqL", function(module, exports) {

$parcel$export(module.exports, "__awaiter", () => $cdfebd69c314c8cd$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $cdfebd69c314c8cd$export$67ebef60e6f28a6);
$parcel$export(module.exports, "__exportStar", () => $cdfebd69c314c8cd$export$f33643c0debef087);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $cdfebd69c314c8cd$var$extendStatics = function(d, b) {
    $cdfebd69c314c8cd$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $cdfebd69c314c8cd$var$extendStatics(d, b);
};
function $cdfebd69c314c8cd$export$a8ba968b8961cb8a(d, b) {
    $cdfebd69c314c8cd$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $cdfebd69c314c8cd$export$18ce0697a983be9b = function() {
    $cdfebd69c314c8cd$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $cdfebd69c314c8cd$export$18ce0697a983be9b.apply(this, arguments);
};
function $cdfebd69c314c8cd$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $cdfebd69c314c8cd$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $cdfebd69c314c8cd$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $cdfebd69c314c8cd$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $cdfebd69c314c8cd$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $cdfebd69c314c8cd$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $cdfebd69c314c8cd$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $cdfebd69c314c8cd$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $cdfebd69c314c8cd$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $cdfebd69c314c8cd$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $cdfebd69c314c8cd$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($cdfebd69c314c8cd$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $cdfebd69c314c8cd$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $cdfebd69c314c8cd$export$10c90e4f7922046c(v) {
    return this instanceof $cdfebd69c314c8cd$export$10c90e4f7922046c ? (this.v = v, this) : new $cdfebd69c314c8cd$export$10c90e4f7922046c(v);
}
function $cdfebd69c314c8cd$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $cdfebd69c314c8cd$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $cdfebd69c314c8cd$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $cdfebd69c314c8cd$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $cdfebd69c314c8cd$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $cdfebd69c314c8cd$export$19a8beecd37a4c45 === "function" ? $cdfebd69c314c8cd$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $cdfebd69c314c8cd$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $cdfebd69c314c8cd$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $cdfebd69c314c8cd$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $cdfebd69c314c8cd$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $cdfebd69c314c8cd$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("j0rqA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Sha256 = void 0;

var $hGvqL = parcelRequire("hGvqL");

var $vUt6n = parcelRequire("vUt6n");

var $jPLEe = parcelRequire("jPLEe");

var $hh31F = parcelRequire("hh31F");
var $dd634afdc9dbe885$var$Sha256 = /** @class */ function() {
    function Sha256(secret) {
        this.secret = secret;
        this.hash = new $jPLEe.RawSha256();
        this.reset();
    }
    Sha256.prototype.update = function(toHash) {
        if ((0, $hh31F.isEmptyData)(toHash) || this.error) return;
        try {
            this.hash.update((0, $hh31F.convertToBuffer)(toHash));
        } catch (e) {
            this.error = e;
        }
    };
    /* This synchronous method keeps compatibility
     * with the v2 aws-sdk.
     */ Sha256.prototype.digestSync = function() {
        if (this.error) throw this.error;
        if (this.outer) {
            if (!this.outer.finished) this.outer.update(this.hash.digest());
            return this.outer.digest();
        }
        return this.hash.digest();
    };
    /* The underlying digest method here is synchronous.
     * To keep the same interface with the other hash functions
     * the default is to expose this as an async method.
     * However, it can sometimes be useful to have a sync method.
     */ Sha256.prototype.digest = function() {
        return $hGvqL.__awaiter(this, void 0, void 0, function() {
            return $hGvqL.__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.digestSync()
                ];
            });
        });
    };
    Sha256.prototype.reset = function() {
        this.hash = new $jPLEe.RawSha256();
        if (this.secret) {
            this.outer = new $jPLEe.RawSha256();
            var inner = $dd634afdc9dbe885$var$bufferFromSecret(this.secret);
            var outer = new Uint8Array($vUt6n.BLOCK_SIZE);
            outer.set(inner);
            for(var i = 0; i < $vUt6n.BLOCK_SIZE; i++){
                inner[i] ^= 0x36;
                outer[i] ^= 0x5c;
            }
            this.hash.update(inner);
            this.outer.update(outer);
            // overwrite the copied key in memory
            for(var i = 0; i < inner.byteLength; i++)inner[i] = 0;
        }
    };
    return Sha256;
}();
module.exports.Sha256 = $dd634afdc9dbe885$var$Sha256;
function $dd634afdc9dbe885$var$bufferFromSecret(secret) {
    var input = (0, $hh31F.convertToBuffer)(secret);
    if (input.byteLength > $vUt6n.BLOCK_SIZE) {
        var bufferHash = new $jPLEe.RawSha256();
        bufferHash.update(input);
        input = bufferHash.digest();
    }
    var buffer = new Uint8Array($vUt6n.BLOCK_SIZE);
    buffer.set(input);
    return buffer;
}

});
parcelRegister("vUt6n", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MAX_HASHABLE_LENGTH = module.exports.INIT = module.exports.KEY = module.exports.DIGEST_LENGTH = module.exports.BLOCK_SIZE = void 0;
/**
 * @internal
 */ module.exports.BLOCK_SIZE = 64;
/**
 * @internal
 */ module.exports.DIGEST_LENGTH = 32;
/**
 * @internal
 */ module.exports.KEY = new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
/**
 * @internal
 */ module.exports.INIT = [
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
];
/**
 * @internal
 */ module.exports.MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;

});

parcelRegister("jPLEe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RawSha256 = void 0;

var $vUt6n = parcelRequire("vUt6n");
/**
 * @internal
 */ var $e707bd9987097a2b$var$RawSha256 = /** @class */ function() {
    function RawSha256() {
        this.state = Int32Array.from($vUt6n.INIT);
        this.temp = new Int32Array(64);
        this.buffer = new Uint8Array(64);
        this.bufferLength = 0;
        this.bytesHashed = 0;
        /**
         * @internal
         */ this.finished = false;
    }
    RawSha256.prototype.update = function(data) {
        if (this.finished) throw new Error("Attempted to update an already finished hash.");
        var position = 0;
        var byteLength = data.byteLength;
        this.bytesHashed += byteLength;
        if (this.bytesHashed * 8 > $vUt6n.MAX_HASHABLE_LENGTH) throw new Error("Cannot hash more than 2^53 - 1 bits");
        while(byteLength > 0){
            this.buffer[this.bufferLength++] = data[position++];
            byteLength--;
            if (this.bufferLength === $vUt6n.BLOCK_SIZE) {
                this.hashBuffer();
                this.bufferLength = 0;
            }
        }
    };
    RawSha256.prototype.digest = function() {
        if (!this.finished) {
            var bitsHashed = this.bytesHashed * 8;
            var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
            var undecoratedLength = this.bufferLength;
            bufferView.setUint8(this.bufferLength++, 0x80);
            // Ensure the final block has enough room for the hashed length
            if (undecoratedLength % $vUt6n.BLOCK_SIZE >= $vUt6n.BLOCK_SIZE - 8) {
                for(var i = this.bufferLength; i < $vUt6n.BLOCK_SIZE; i++)bufferView.setUint8(i, 0);
                this.hashBuffer();
                this.bufferLength = 0;
            }
            for(var i = this.bufferLength; i < $vUt6n.BLOCK_SIZE - 8; i++)bufferView.setUint8(i, 0);
            bufferView.setUint32($vUt6n.BLOCK_SIZE - 8, Math.floor(bitsHashed / 0x100000000), true);
            bufferView.setUint32($vUt6n.BLOCK_SIZE - 4, bitsHashed);
            this.hashBuffer();
            this.finished = true;
        }
        // The value in state is little-endian rather than big-endian, so flip
        // each word into a new Uint8Array
        var out = new Uint8Array($vUt6n.DIGEST_LENGTH);
        for(var i = 0; i < 8; i++){
            out[i * 4] = this.state[i] >>> 24 & 0xff;
            out[i * 4 + 1] = this.state[i] >>> 16 & 0xff;
            out[i * 4 + 2] = this.state[i] >>> 8 & 0xff;
            out[i * 4 + 3] = this.state[i] >>> 0 & 0xff;
        }
        return out;
    };
    RawSha256.prototype.hashBuffer = function() {
        var _a = this, buffer = _a.buffer, state = _a.state;
        var state0 = state[0], state1 = state[1], state2 = state[2], state3 = state[3], state4 = state[4], state5 = state[5], state6 = state[6], state7 = state[7];
        for(var i = 0; i < $vUt6n.BLOCK_SIZE; i++){
            if (i < 16) this.temp[i] = (buffer[i * 4] & 0xff) << 24 | (buffer[i * 4 + 1] & 0xff) << 16 | (buffer[i * 4 + 2] & 0xff) << 8 | buffer[i * 4 + 3] & 0xff;
            else {
                var u = this.temp[i - 2];
                var t1_1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
                u = this.temp[i - 15];
                var t2_1 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
                this.temp[i] = (t1_1 + this.temp[i - 7] | 0) + (t2_1 + this.temp[i - 16] | 0);
            }
            var t1 = (((state4 >>> 6 | state4 << 26) ^ (state4 >>> 11 | state4 << 21) ^ (state4 >>> 25 | state4 << 7)) + (state4 & state5 ^ ~state4 & state6) | 0) + (state7 + ($vUt6n.KEY[i] + this.temp[i] | 0) | 0) | 0;
            var t2 = ((state0 >>> 2 | state0 << 30) ^ (state0 >>> 13 | state0 << 19) ^ (state0 >>> 22 | state0 << 10)) + (state0 & state1 ^ state0 & state2 ^ state1 & state2) | 0;
            state7 = state6;
            state6 = state5;
            state5 = state4;
            state4 = state3 + t1 | 0;
            state3 = state2;
            state2 = state1;
            state1 = state0;
            state0 = t1 + t2 | 0;
        }
        state[0] += state0;
        state[1] += state1;
        state[2] += state2;
        state[3] += state3;
        state[4] += state4;
        state[5] += state5;
        state[6] += state6;
        state[7] += state7;
    };
    return RawSha256;
}();
module.exports.RawSha256 = $e707bd9987097a2b$var$RawSha256;

});



parcelRegister("a0eT5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $cQNiN = parcelRequire("cQNiN");

$cQNiN.__exportStar((parcelRequire("io4Gi")), module.exports);

});
parcelRegister("cQNiN", function(module, exports) {

$parcel$export(module.exports, "__awaiter", () => $95b095b950f77ead$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $95b095b950f77ead$export$67ebef60e6f28a6);
$parcel$export(module.exports, "__exportStar", () => $95b095b950f77ead$export$f33643c0debef087);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $95b095b950f77ead$var$extendStatics = function(d, b) {
    $95b095b950f77ead$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $95b095b950f77ead$var$extendStatics(d, b);
};
function $95b095b950f77ead$export$a8ba968b8961cb8a(d, b) {
    $95b095b950f77ead$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $95b095b950f77ead$export$18ce0697a983be9b = function() {
    $95b095b950f77ead$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $95b095b950f77ead$export$18ce0697a983be9b.apply(this, arguments);
};
function $95b095b950f77ead$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $95b095b950f77ead$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $95b095b950f77ead$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $95b095b950f77ead$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $95b095b950f77ead$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $95b095b950f77ead$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $95b095b950f77ead$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $95b095b950f77ead$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $95b095b950f77ead$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $95b095b950f77ead$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $95b095b950f77ead$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($95b095b950f77ead$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $95b095b950f77ead$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $95b095b950f77ead$export$10c90e4f7922046c(v) {
    return this instanceof $95b095b950f77ead$export$10c90e4f7922046c ? (this.v = v, this) : new $95b095b950f77ead$export$10c90e4f7922046c(v);
}
function $95b095b950f77ead$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $95b095b950f77ead$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $95b095b950f77ead$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $95b095b950f77ead$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $95b095b950f77ead$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $95b095b950f77ead$export$19a8beecd37a4c45 === "function" ? $95b095b950f77ead$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $95b095b950f77ead$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $95b095b950f77ead$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $95b095b950f77ead$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $95b095b950f77ead$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $95b095b950f77ead$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("io4Gi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.supportsZeroByteGCM = module.exports.supportsSubtleCrypto = module.exports.supportsSecureRandom = module.exports.supportsWebCrypto = void 0;

var $cQNiN = parcelRequire("cQNiN");
var $d62e197ada50459e$var$subtleCryptoMethods = [
    "decrypt",
    "digest",
    "encrypt",
    "exportKey",
    "generateKey",
    "importKey",
    "sign",
    "verify"
];
function $d62e197ada50459e$var$supportsWebCrypto(window) {
    if ($d62e197ada50459e$var$supportsSecureRandom(window) && typeof window.crypto.subtle === "object") {
        var subtle = window.crypto.subtle;
        return $d62e197ada50459e$var$supportsSubtleCrypto(subtle);
    }
    return false;
}
module.exports.supportsWebCrypto = $d62e197ada50459e$var$supportsWebCrypto;
function $d62e197ada50459e$var$supportsSecureRandom(window) {
    if (typeof window === "object" && typeof window.crypto === "object") {
        var getRandomValues = window.crypto.getRandomValues;
        return typeof getRandomValues === "function";
    }
    return false;
}
module.exports.supportsSecureRandom = $d62e197ada50459e$var$supportsSecureRandom;
function $d62e197ada50459e$var$supportsSubtleCrypto(subtle) {
    return subtle && $d62e197ada50459e$var$subtleCryptoMethods.every(function(methodName) {
        return typeof subtle[methodName] === "function";
    });
}
module.exports.supportsSubtleCrypto = $d62e197ada50459e$var$supportsSubtleCrypto;
function $d62e197ada50459e$var$supportsZeroByteGCM(subtle) {
    return $cQNiN.__awaiter(this, void 0, void 0, function() {
        var key, zeroByteAuthTag, _a;
        return $cQNiN.__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    if (!$d62e197ada50459e$var$supportsSubtleCrypto(subtle)) return [
                        2 /*return*/ ,
                        false
                    ];
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4 /*yield*/ ,
                        subtle.generateKey({
                            name: "AES-GCM",
                            length: 128
                        }, false, [
                            "encrypt"
                        ])
                    ];
                case 2:
                    key = _b.sent();
                    return [
                        4 /*yield*/ ,
                        subtle.encrypt({
                            name: "AES-GCM",
                            iv: new Uint8Array(Array(12)),
                            additionalData: new Uint8Array(Array(16)),
                            tagLength: 128
                        }, key, new Uint8Array(0))
                    ];
                case 3:
                    zeroByteAuthTag = _b.sent();
                    return [
                        2 /*return*/ ,
                        zeroByteAuthTag.byteLength === 16
                    ];
                case 4:
                    _a = _b.sent();
                    return [
                        2 /*return*/ ,
                        false
                    ];
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
module.exports.supportsZeroByteGCM = $d62e197ada50459e$var$supportsZeroByteGCM;

});


parcelRegister("h0pIy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lkVOF = parcelRequire("lkVOF");

$lkVOF.__exportStar((parcelRequire("7519P")), module.exports);

$lkVOF.__exportStar((parcelRequire("ebMMa")), module.exports);

$lkVOF.__exportStar((parcelRequire("gpIWR")), module.exports);

$lkVOF.__exportStar((parcelRequire("4pyFG")), module.exports);

$lkVOF.__exportStar((parcelRequire("s7Wik")), module.exports);

});
parcelRegister("lkVOF", function(module, exports) {

$parcel$export(module.exports, "__exportStar", () => $f888504fd34d65e0$export$f33643c0debef087);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $f888504fd34d65e0$var$extendStatics = function(d, b) {
    $f888504fd34d65e0$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $f888504fd34d65e0$var$extendStatics(d, b);
};
function $f888504fd34d65e0$export$a8ba968b8961cb8a(d, b) {
    $f888504fd34d65e0$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $f888504fd34d65e0$export$18ce0697a983be9b = function() {
    $f888504fd34d65e0$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f888504fd34d65e0$export$18ce0697a983be9b.apply(this, arguments);
};
function $f888504fd34d65e0$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $f888504fd34d65e0$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $f888504fd34d65e0$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $f888504fd34d65e0$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $f888504fd34d65e0$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $f888504fd34d65e0$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $f888504fd34d65e0$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $f888504fd34d65e0$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $f888504fd34d65e0$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $f888504fd34d65e0$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $f888504fd34d65e0$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($f888504fd34d65e0$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $f888504fd34d65e0$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $f888504fd34d65e0$export$10c90e4f7922046c(v) {
    return this instanceof $f888504fd34d65e0$export$10c90e4f7922046c ? (this.v = v, this) : new $f888504fd34d65e0$export$10c90e4f7922046c(v);
}
function $f888504fd34d65e0$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $f888504fd34d65e0$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $f888504fd34d65e0$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $f888504fd34d65e0$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $f888504fd34d65e0$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $f888504fd34d65e0$export$19a8beecd37a4c45 === "function" ? $f888504fd34d65e0$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $f888504fd34d65e0$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $f888504fd34d65e0$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $f888504fd34d65e0$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $f888504fd34d65e0$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $f888504fd34d65e0$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("7519P", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("ebMMa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("gpIWR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("4pyFG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("s7Wik", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isMsWindow = void 0;
var $0548c634d6f46b1e$var$msSubtleCryptoMethods = [
    "decrypt",
    "digest",
    "encrypt",
    "exportKey",
    "generateKey",
    "importKey",
    "sign",
    "verify"
];
function $0548c634d6f46b1e$var$quacksLikeAnMsWindow(window) {
    return "MSInputMethodContext" in window && "msCrypto" in window;
}
/**
 * Determines if the provided window is (or is like) the window object one would
 * expect to encounter in Internet Explorer 11.
 */ function $0548c634d6f46b1e$var$isMsWindow(window) {
    if ($0548c634d6f46b1e$var$quacksLikeAnMsWindow(window) && window.msCrypto.subtle !== undefined) {
        var _a = window.msCrypto, getRandomValues = _a.getRandomValues, subtle_1 = _a.subtle;
        return $0548c634d6f46b1e$var$msSubtleCryptoMethods.map(function(methodName) {
            return subtle_1[methodName];
        }).concat(getRandomValues).every(function(method) {
            return typeof method === "function";
        });
    }
    return false;
}
module.exports.isMsWindow = $0548c634d6f46b1e$var$isMsWindow;

});




parcelRegister("dPlLR", function(module, exports) {

$parcel$export(module.exports, "defaultUserAgent", () => $a110ed0460584cf3$export$69d579f32876892f);

var $l4Evi = parcelRequire("l4Evi");
const $a110ed0460584cf3$export$69d579f32876892f = ({ serviceId: serviceId, clientVersion: clientVersion })=>async ()=>{
        const parsedUA = typeof window !== "undefined" && window?.navigator?.userAgent ? (0, (/*@__PURE__*/$parcel$interopDefault($l4Evi))).parse(window.navigator.userAgent) : undefined;
        const sections = [
            [
                "aws-sdk-js",
                clientVersion
            ],
            [
                "ua",
                "2.0"
            ],
            [
                `os/${parsedUA?.os?.name || "other"}`,
                parsedUA?.os?.version
            ],
            [
                "lang/js"
            ],
            [
                "md/browser",
                `${parsedUA?.browser?.name ?? "unknown"}_${parsedUA?.browser?.version ?? "unknown"}`
            ]
        ];
        if (serviceId) sections.push([
            `api/${serviceId}`,
            clientVersion
        ]);
        return sections;
    };

});
parcelRegister("l4Evi", function(module, exports) {
!function(e, t) {
    module.exports = t();
}(module.exports, function() {
    return function(e) {
        var t = {};
        function r(n) {
            if (t[n]) return t[n].exports;
            var i = t[n] = {
                i: n,
                l: !1,
                exports: {}
            };
            return e[n].call(i.exports, i, i.exports, r), i.l = !0, i.exports;
        }
        return r.m = e, r.c = t, r.d = function(e, t, n) {
            r.o(e, t) || Object.defineProperty(e, t, {
                enumerable: !0,
                get: n
            });
        }, r.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, r.t = function(e, t) {
            if (1 & t && (e = r(e)), 8 & t) return e;
            if (4 & t && "object" == typeof e && e && e.__esModule) return e;
            var n = Object.create(null);
            if (r.r(n), Object.defineProperty(n, "default", {
                enumerable: !0,
                value: e
            }), 2 & t && "string" != typeof e) for(var i in e)r.d(n, i, (function(t) {
                return e[t];
            }).bind(null, i));
            return n;
        }, r.n = function(e) {
            var t = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return r.d(t, "a", t), t;
        }, r.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, r.p = "", r(r.s = 90);
    }({
        17: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n = r(18), i = function() {
                function e() {}
                return e.getFirstMatch = function(e, t) {
                    var r = t.match(e);
                    return r && r.length > 0 && r[1] || "";
                }, e.getSecondMatch = function(e, t) {
                    var r = t.match(e);
                    return r && r.length > 1 && r[2] || "";
                }, e.matchAndReturnConst = function(e, t, r) {
                    if (e.test(t)) return r;
                }, e.getWindowsVersionName = function(e) {
                    switch(e){
                        case "NT":
                            return "NT";
                        case "XP":
                            return "XP";
                        case "NT 5.0":
                            return "2000";
                        case "NT 5.1":
                            return "XP";
                        case "NT 5.2":
                            return "2003";
                        case "NT 6.0":
                            return "Vista";
                        case "NT 6.1":
                            return "7";
                        case "NT 6.2":
                            return "8";
                        case "NT 6.3":
                            return "8.1";
                        case "NT 10.0":
                            return "10";
                        default:
                            return;
                    }
                }, e.getMacOSVersionName = function(e) {
                    var t = e.split(".").splice(0, 2).map(function(e) {
                        return parseInt(e, 10) || 0;
                    });
                    if (t.push(0), 10 === t[0]) switch(t[1]){
                        case 5:
                            return "Leopard";
                        case 6:
                            return "Snow Leopard";
                        case 7:
                            return "Lion";
                        case 8:
                            return "Mountain Lion";
                        case 9:
                            return "Mavericks";
                        case 10:
                            return "Yosemite";
                        case 11:
                            return "El Capitan";
                        case 12:
                            return "Sierra";
                        case 13:
                            return "High Sierra";
                        case 14:
                            return "Mojave";
                        case 15:
                            return "Catalina";
                        default:
                            return;
                    }
                }, e.getAndroidVersionName = function(e) {
                    var t = e.split(".").splice(0, 2).map(function(e) {
                        return parseInt(e, 10) || 0;
                    });
                    if (t.push(0), !(1 === t[0] && t[1] < 5)) return 1 === t[0] && t[1] < 6 ? "Cupcake" : 1 === t[0] && t[1] >= 6 ? "Donut" : 2 === t[0] && t[1] < 2 ? "Eclair" : 2 === t[0] && 2 === t[1] ? "Froyo" : 2 === t[0] && t[1] > 2 ? "Gingerbread" : 3 === t[0] ? "Honeycomb" : 4 === t[0] && t[1] < 1 ? "Ice Cream Sandwich" : 4 === t[0] && t[1] < 4 ? "Jelly Bean" : 4 === t[0] && t[1] >= 4 ? "KitKat" : 5 === t[0] ? "Lollipop" : 6 === t[0] ? "Marshmallow" : 7 === t[0] ? "Nougat" : 8 === t[0] ? "Oreo" : 9 === t[0] ? "Pie" : void 0;
                }, e.getVersionPrecision = function(e) {
                    return e.split(".").length;
                }, e.compareVersions = function(t, r, n) {
                    void 0 === n && (n = !1);
                    var i = e.getVersionPrecision(t), s = e.getVersionPrecision(r), a = Math.max(i, s), o = 0, u = e.map([
                        t,
                        r
                    ], function(t) {
                        var r = a - e.getVersionPrecision(t), n = t + new Array(r + 1).join(".0");
                        return e.map(n.split("."), function(e) {
                            return new Array(20 - e.length).join("0") + e;
                        }).reverse();
                    });
                    for(n && (o = a - Math.min(i, s)), a -= 1; a >= o;){
                        if (u[0][a] > u[1][a]) return 1;
                        if (u[0][a] === u[1][a]) {
                            if (a === o) return 0;
                            a -= 1;
                        } else if (u[0][a] < u[1][a]) return -1;
                    }
                }, e.map = function(e, t) {
                    var r, n = [];
                    if (Array.prototype.map) return Array.prototype.map.call(e, t);
                    for(r = 0; r < e.length; r += 1)n.push(t(e[r]));
                    return n;
                }, e.find = function(e, t) {
                    var r, n;
                    if (Array.prototype.find) return Array.prototype.find.call(e, t);
                    for(r = 0, n = e.length; r < n; r += 1){
                        var i = e[r];
                        if (t(i, r)) return i;
                    }
                }, e.assign = function(e) {
                    for(var t, r, n = e, i = arguments.length, s = new Array(i > 1 ? i - 1 : 0), a = 1; a < i; a++)s[a - 1] = arguments[a];
                    if (Object.assign) return Object.assign.apply(Object, [
                        e
                    ].concat(s));
                    var o = function() {
                        var e = s[t];
                        "object" == typeof e && null !== e && Object.keys(e).forEach(function(t) {
                            n[t] = e[t];
                        });
                    };
                    for(t = 0, r = s.length; t < r; t += 1)o();
                    return e;
                }, e.getBrowserAlias = function(e) {
                    return n.BROWSER_ALIASES_MAP[e];
                }, e.getBrowserTypeByAlias = function(e) {
                    return n.BROWSER_MAP[e] || "";
                }, e;
            }();
            t.default = i, e.exports = t.default;
        },
        18: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.ENGINE_MAP = t.OS_MAP = t.PLATFORMS_MAP = t.BROWSER_MAP = t.BROWSER_ALIASES_MAP = void 0;
            t.BROWSER_ALIASES_MAP = {
                "Amazon Silk": "amazon_silk",
                "Android Browser": "android",
                Bada: "bada",
                BlackBerry: "blackberry",
                Chrome: "chrome",
                Chromium: "chromium",
                Electron: "electron",
                Epiphany: "epiphany",
                Firefox: "firefox",
                Focus: "focus",
                Generic: "generic",
                "Google Search": "google_search",
                Googlebot: "googlebot",
                "Internet Explorer": "ie",
                "K-Meleon": "k_meleon",
                Maxthon: "maxthon",
                "Microsoft Edge": "edge",
                "MZ Browser": "mz",
                "NAVER Whale Browser": "naver",
                Opera: "opera",
                "Opera Coast": "opera_coast",
                PhantomJS: "phantomjs",
                Puffin: "puffin",
                QupZilla: "qupzilla",
                QQ: "qq",
                QQLite: "qqlite",
                Safari: "safari",
                Sailfish: "sailfish",
                "Samsung Internet for Android": "samsung_internet",
                SeaMonkey: "seamonkey",
                Sleipnir: "sleipnir",
                Swing: "swing",
                Tizen: "tizen",
                "UC Browser": "uc",
                Vivaldi: "vivaldi",
                "WebOS Browser": "webos",
                WeChat: "wechat",
                "Yandex Browser": "yandex",
                Roku: "roku"
            };
            t.BROWSER_MAP = {
                amazon_silk: "Amazon Silk",
                android: "Android Browser",
                bada: "Bada",
                blackberry: "BlackBerry",
                chrome: "Chrome",
                chromium: "Chromium",
                electron: "Electron",
                epiphany: "Epiphany",
                firefox: "Firefox",
                focus: "Focus",
                generic: "Generic",
                googlebot: "Googlebot",
                google_search: "Google Search",
                ie: "Internet Explorer",
                k_meleon: "K-Meleon",
                maxthon: "Maxthon",
                edge: "Microsoft Edge",
                mz: "MZ Browser",
                naver: "NAVER Whale Browser",
                opera: "Opera",
                opera_coast: "Opera Coast",
                phantomjs: "PhantomJS",
                puffin: "Puffin",
                qupzilla: "QupZilla",
                qq: "QQ Browser",
                qqlite: "QQ Browser Lite",
                safari: "Safari",
                sailfish: "Sailfish",
                samsung_internet: "Samsung Internet for Android",
                seamonkey: "SeaMonkey",
                sleipnir: "Sleipnir",
                swing: "Swing",
                tizen: "Tizen",
                uc: "UC Browser",
                vivaldi: "Vivaldi",
                webos: "WebOS Browser",
                wechat: "WeChat",
                yandex: "Yandex Browser"
            };
            t.PLATFORMS_MAP = {
                tablet: "tablet",
                mobile: "mobile",
                desktop: "desktop",
                tv: "tv"
            };
            t.OS_MAP = {
                WindowsPhone: "Windows Phone",
                Windows: "Windows",
                MacOS: "macOS",
                iOS: "iOS",
                Android: "Android",
                WebOS: "WebOS",
                BlackBerry: "BlackBerry",
                Bada: "Bada",
                Tizen: "Tizen",
                Linux: "Linux",
                ChromeOS: "Chrome OS",
                PlayStation4: "PlayStation 4",
                Roku: "Roku"
            };
            t.ENGINE_MAP = {
                EdgeHTML: "EdgeHTML",
                Blink: "Blink",
                Trident: "Trident",
                Presto: "Presto",
                Gecko: "Gecko",
                WebKit: "WebKit"
            };
        },
        90: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(91)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            function a(e, t) {
                for(var r = 0; r < t.length; r++){
                    var n = t[r];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
                }
            }
            var o = function() {
                function e() {}
                var t, r, n;
                return e.getParser = function(e, t) {
                    if (void 0 === t && (t = !1), "string" != typeof e) throw new Error("UserAgent should be a string");
                    return new i.default(e, t);
                }, e.parse = function(e) {
                    return new i.default(e).getResult();
                }, t = e, n = [
                    {
                        key: "BROWSER_MAP",
                        get: function() {
                            return s.BROWSER_MAP;
                        }
                    },
                    {
                        key: "ENGINE_MAP",
                        get: function() {
                            return s.ENGINE_MAP;
                        }
                    },
                    {
                        key: "OS_MAP",
                        get: function() {
                            return s.OS_MAP;
                        }
                    },
                    {
                        key: "PLATFORMS_MAP",
                        get: function() {
                            return s.PLATFORMS_MAP;
                        }
                    }
                ], r = null, n && a(t, n), e;
            }();
            t.default = o, e.exports = t.default;
        },
        91: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n = u(r(92)), i = u(r(93)), s = u(r(94)), a = u(r(95)), o = u(r(17));
            function u(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }
            var d = function() {
                function e(e, t) {
                    if (void 0 === t && (t = !1), null == e || "" === e) throw new Error("UserAgent parameter can't be empty");
                    this._ua = e, this.parsedResult = {}, !0 !== t && this.parse();
                }
                var t = e.prototype;
                return t.getUA = function() {
                    return this._ua;
                }, t.test = function(e) {
                    return e.test(this._ua);
                }, t.parseBrowser = function() {
                    var e = this;
                    this.parsedResult.browser = {};
                    var t = o.default.find(n.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.browser = t.describe(this.getUA())), this.parsedResult.browser;
                }, t.getBrowser = function() {
                    return this.parsedResult.browser ? this.parsedResult.browser : this.parseBrowser();
                }, t.getBrowserName = function(e) {
                    return e ? String(this.getBrowser().name).toLowerCase() || "" : this.getBrowser().name || "";
                }, t.getBrowserVersion = function() {
                    return this.getBrowser().version;
                }, t.getOS = function() {
                    return this.parsedResult.os ? this.parsedResult.os : this.parseOS();
                }, t.parseOS = function() {
                    var e = this;
                    this.parsedResult.os = {};
                    var t = o.default.find(i.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.os = t.describe(this.getUA())), this.parsedResult.os;
                }, t.getOSName = function(e) {
                    var t = this.getOS().name;
                    return e ? String(t).toLowerCase() || "" : t || "";
                }, t.getOSVersion = function() {
                    return this.getOS().version;
                }, t.getPlatform = function() {
                    return this.parsedResult.platform ? this.parsedResult.platform : this.parsePlatform();
                }, t.getPlatformType = function(e) {
                    void 0 === e && (e = !1);
                    var t = this.getPlatform().type;
                    return e ? String(t).toLowerCase() || "" : t || "";
                }, t.parsePlatform = function() {
                    var e = this;
                    this.parsedResult.platform = {};
                    var t = o.default.find(s.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.platform = t.describe(this.getUA())), this.parsedResult.platform;
                }, t.getEngine = function() {
                    return this.parsedResult.engine ? this.parsedResult.engine : this.parseEngine();
                }, t.getEngineName = function(e) {
                    return e ? String(this.getEngine().name).toLowerCase() || "" : this.getEngine().name || "";
                }, t.parseEngine = function() {
                    var e = this;
                    this.parsedResult.engine = {};
                    var t = o.default.find(a.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.engine = t.describe(this.getUA())), this.parsedResult.engine;
                }, t.parse = function() {
                    return this.parseBrowser(), this.parseOS(), this.parsePlatform(), this.parseEngine(), this;
                }, t.getResult = function() {
                    return o.default.assign({}, this.parsedResult);
                }, t.satisfies = function(e) {
                    var t = this, r = {}, n = 0, i = {}, s = 0;
                    if (Object.keys(e).forEach(function(t) {
                        var a = e[t];
                        "string" == typeof a ? (i[t] = a, s += 1) : "object" == typeof a && (r[t] = a, n += 1);
                    }), n > 0) {
                        var a = Object.keys(r), u = o.default.find(a, function(e) {
                            return t.isOS(e);
                        });
                        if (u) {
                            var d = this.satisfies(r[u]);
                            if (void 0 !== d) return d;
                        }
                        var c = o.default.find(a, function(e) {
                            return t.isPlatform(e);
                        });
                        if (c) {
                            var f = this.satisfies(r[c]);
                            if (void 0 !== f) return f;
                        }
                    }
                    if (s > 0) {
                        var l = Object.keys(i), h = o.default.find(l, function(e) {
                            return t.isBrowser(e, !0);
                        });
                        if (void 0 !== h) return this.compareVersion(i[h]);
                    }
                }, t.isBrowser = function(e, t) {
                    void 0 === t && (t = !1);
                    var r = this.getBrowserName().toLowerCase(), n = e.toLowerCase(), i = o.default.getBrowserTypeByAlias(n);
                    return t && i && (n = i.toLowerCase()), n === r;
                }, t.compareVersion = function(e) {
                    var t = [
                        0
                    ], r = e, n = !1, i = this.getBrowserVersion();
                    if ("string" == typeof i) return ">" === e[0] || "<" === e[0] ? (r = e.substr(1), "=" === e[1] ? (n = !0, r = e.substr(2)) : t = [], ">" === e[0] ? t.push(1) : t.push(-1)) : "=" === e[0] ? r = e.substr(1) : "~" === e[0] && (n = !0, r = e.substr(1)), t.indexOf(o.default.compareVersions(i, r, n)) > -1;
                }, t.isOS = function(e) {
                    return this.getOSName(!0) === String(e).toLowerCase();
                }, t.isPlatform = function(e) {
                    return this.getPlatformType(!0) === String(e).toLowerCase();
                }, t.isEngine = function(e) {
                    return this.getEngineName(!0) === String(e).toLowerCase();
                }, t.is = function(e, t) {
                    return void 0 === t && (t = !1), this.isBrowser(e, t) || this.isOS(e) || this.isPlatform(e);
                }, t.some = function(e) {
                    var t = this;
                    return void 0 === e && (e = []), e.some(function(e) {
                        return t.is(e);
                    });
                }, e;
            }();
            t.default = d, e.exports = t.default;
        },
        92: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            };
            var s = /version\/(\d+(\.?_?\d+)+)/i, a = [
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Googlebot"
                        }, r = i.default.getFirstMatch(/googlebot\/(\d+(\.\d+))/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opera/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opr\/|opios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera"
                        }, r = i.default.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /SamsungBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Samsung Internet for Android"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /Whale/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "NAVER Whale Browser"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /MZBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "MZ Browser"
                        }, r = i.default.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /focus/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Focus"
                        }, r = i.default.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /swing/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Swing"
                        }, r = i.default.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /coast/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera Coast"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opt\/\d+(?:.?_?\d+)+/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera Touch"
                        }, r = i.default.getFirstMatch(/(?:opt)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /yabrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Yandex Browser"
                        }, r = i.default.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /ucbrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "UC Browser"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /Maxthon|mxios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Maxthon"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /epiphany/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Epiphany"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /puffin/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Puffin"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /sleipnir/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Sleipnir"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /k-meleon/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "K-Meleon"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /micromessenger/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "WeChat"
                        }, r = i.default.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /qqbrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: /qqbrowserlite/i.test(e) ? "QQ Browser Lite" : "QQ Browser"
                        }, r = i.default.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /msie|trident/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Internet Explorer"
                        }, r = i.default.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /\sedg\//i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Microsoft Edge"
                        }, r = i.default.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /edg([ea]|ios)/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Microsoft Edge"
                        }, r = i.default.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /vivaldi/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Vivaldi"
                        }, r = i.default.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /seamonkey/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "SeaMonkey"
                        }, r = i.default.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /sailfish/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Sailfish"
                        }, r = i.default.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /silk/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Amazon Silk"
                        }, r = i.default.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /phantom/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "PhantomJS"
                        }, r = i.default.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /slimerjs/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "SlimerJS"
                        }, r = i.default.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /blackberry|\bbb\d+/i,
                        /rim\stablet/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "BlackBerry"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /(web|hpw)[o0]s/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "WebOS Browser"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /bada/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Bada"
                        }, r = i.default.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Tizen"
                        }, r = i.default.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /qupzilla/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "QupZilla"
                        }, r = i.default.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /firefox|iceweasel|fxios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Firefox"
                        }, r = i.default.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /electron/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Electron"
                        }, r = i.default.getFirstMatch(/(?:electron)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /MiuiBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Miui"
                        }, r = i.default.getFirstMatch(/(?:MiuiBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /chromium/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Chromium"
                        }, r = i.default.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /chrome|crios|crmo/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Chrome"
                        }, r = i.default.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /GSA/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Google Search"
                        }, r = i.default.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        var t = !e.test(/like android/i), r = e.test(/android/i);
                        return t && r;
                    },
                    describe: function(e) {
                        var t = {
                            name: "Android Browser"
                        }, r = i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /playstation 4/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "PlayStation 4"
                        }, r = i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /safari|applewebkit/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Safari"
                        }, r = i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /.*/i
                    ],
                    describe: function(e) {
                        var t = -1 !== e.search("\\(") ? /^(.*)\/(.*)[ \t]\((.*)/ : /^(.*)\/(.*) /;
                        return {
                            name: i.default.getFirstMatch(t, e),
                            version: i.default.getSecondMatch(t, e)
                        };
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        },
        93: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            var a = [
                {
                    test: [
                        /Roku\/DVP/
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i, e);
                        return {
                            name: s.OS_MAP.Roku,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /windows phone/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.WindowsPhone,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /windows /i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i, e), r = i.default.getWindowsVersionName(t);
                        return {
                            name: s.OS_MAP.Windows,
                            version: t,
                            versionName: r
                        };
                    }
                },
                {
                    test: [
                        /Macintosh(.*?) FxiOS(.*?)\//
                    ],
                    describe: function(e) {
                        var t = {
                            name: s.OS_MAP.iOS
                        }, r = i.default.getSecondMatch(/(Version\/)(\d[\d.]+)/, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /macintosh/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i, e).replace(/[_\s]/g, "."), r = i.default.getMacOSVersionName(t), n = {
                            name: s.OS_MAP.MacOS,
                            version: t
                        };
                        return r && (n.versionName = r), n;
                    }
                },
                {
                    test: [
                        /(ipod|iphone|ipad)/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i, e).replace(/[_\s]/g, ".");
                        return {
                            name: s.OS_MAP.iOS,
                            version: t
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = !e.test(/like android/i), r = e.test(/android/i);
                        return t && r;
                    },
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i, e), r = i.default.getAndroidVersionName(t), n = {
                            name: s.OS_MAP.Android,
                            version: t
                        };
                        return r && (n.versionName = r), n;
                    }
                },
                {
                    test: [
                        /(web|hpw)[o0]s/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i, e), r = {
                            name: s.OS_MAP.WebOS
                        };
                        return t && t.length && (r.version = t), r;
                    }
                },
                {
                    test: [
                        /blackberry|\bbb\d+/i,
                        /rim\stablet/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i, e) || i.default.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i, e) || i.default.getFirstMatch(/\bbb(\d+)/i, e);
                        return {
                            name: s.OS_MAP.BlackBerry,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /bada/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/bada\/(\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.Bada,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.Tizen,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /linux/i
                    ],
                    describe: function() {
                        return {
                            name: s.OS_MAP.Linux
                        };
                    }
                },
                {
                    test: [
                        /CrOS/
                    ],
                    describe: function() {
                        return {
                            name: s.OS_MAP.ChromeOS
                        };
                    }
                },
                {
                    test: [
                        /PlayStation 4/
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/PlayStation 4[/\s](\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.PlayStation4,
                            version: t
                        };
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        },
        94: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            var a = [
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function() {
                        return {
                            type: "bot",
                            vendor: "Google"
                        };
                    }
                },
                {
                    test: [
                        /huawei/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/(can-l01)/i, e) && "Nova", r = {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Huawei"
                        };
                        return t && (r.model = t), r;
                    }
                },
                {
                    test: [
                        /nexus\s*(?:7|8|9|10).*/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Nexus"
                        };
                    }
                },
                {
                    test: [
                        /ipad/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Apple",
                            model: "iPad"
                        };
                    }
                },
                {
                    test: [
                        /Macintosh(.*?) FxiOS(.*?)\//
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Apple",
                            model: "iPad"
                        };
                    }
                },
                {
                    test: [
                        /kftt build/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Amazon",
                            model: "Kindle Fire HD 7"
                        };
                    }
                },
                {
                    test: [
                        /silk/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Amazon"
                        };
                    }
                },
                {
                    test: [
                        /tablet(?! pc)/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = e.test(/ipod|iphone/i), r = e.test(/like (ipod|iphone)/i);
                        return t && !r;
                    },
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/(ipod|iphone)/i, e);
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Apple",
                            model: t
                        };
                    }
                },
                {
                    test: [
                        /nexus\s*[0-6].*/i,
                        /galaxy nexus/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Nexus"
                        };
                    }
                },
                {
                    test: [
                        /[^-]mobi/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "blackberry" === e.getBrowserName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "BlackBerry"
                        };
                    }
                },
                {
                    test: function(e) {
                        return "bada" === e.getBrowserName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "windows phone" === e.getBrowserName();
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Microsoft"
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = Number(String(e.getOSVersion()).split(".")[0]);
                        return "android" === e.getOSName(!0) && t >= 3;
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet
                        };
                    }
                },
                {
                    test: function(e) {
                        return "android" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "macos" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.desktop,
                            vendor: "Apple"
                        };
                    }
                },
                {
                    test: function(e) {
                        return "windows" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.desktop
                        };
                    }
                },
                {
                    test: function(e) {
                        return "linux" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.desktop
                        };
                    }
                },
                {
                    test: function(e) {
                        return "playstation 4" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tv
                        };
                    }
                },
                {
                    test: function(e) {
                        return "roku" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tv
                        };
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        },
        95: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            var a = [
                {
                    test: function(e) {
                        return "microsoft edge" === e.getBrowserName(!0);
                    },
                    describe: function(e) {
                        if (/\sedg\//i.test(e)) return {
                            name: s.ENGINE_MAP.Blink
                        };
                        var t = i.default.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i, e);
                        return {
                            name: s.ENGINE_MAP.EdgeHTML,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /trident/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.Trident
                        }, r = i.default.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        return e.test(/presto/i);
                    },
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.Presto
                        }, r = i.default.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        var t = e.test(/gecko/i), r = e.test(/like gecko/i);
                        return t && !r;
                    },
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.Gecko
                        }, r = i.default.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /(apple)?webkit\/537\.36/i
                    ],
                    describe: function() {
                        return {
                            name: s.ENGINE_MAP.Blink
                        };
                    }
                },
                {
                    test: [
                        /(apple)?webkit/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.WebKit
                        }, r = i.default.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        }
    });
});

});


parcelRegister("ch0sh", function(module, exports) {
$parcel$export(module.exports, "invalidProvider", () => (parcelRequire("1j16v")).invalidProvider);
parcelRequire("hUrOq");
parcelRequire("1j16v");

});
parcelRegister("hUrOq", function(module, exports) {
const $d09d3d920c3e7bc5$export$8b6362171c4dfa64 = (message)=>()=>{
        throw new Error(message);
    };

});

parcelRegister("1j16v", function(module, exports) {

$parcel$export(module.exports, "invalidProvider", () => $0f386c03aea0c4f0$export$d59dd53963f8f3d5);
const $0f386c03aea0c4f0$export$d59dd53963f8f3d5 = (message)=>()=>Promise.reject(message);

});


parcelRegister("3slPz", function(module, exports) {
$parcel$export(module.exports, "calculateBodyLength", () => (parcelRequire("9v2WL")).calculateBodyLength);
parcelRequire("9v2WL");

});
parcelRegister("9v2WL", function(module, exports) {

$parcel$export(module.exports, "calculateBodyLength", () => $6ea94b76e219c71e$export$967f3527bf233bc0);
const $6ea94b76e219c71e$var$TEXT_ENCODER = typeof TextEncoder == "function" ? new TextEncoder() : null;
const $6ea94b76e219c71e$export$967f3527bf233bc0 = (body)=>{
    if (typeof body === "string") {
        if ($6ea94b76e219c71e$var$TEXT_ENCODER) return $6ea94b76e219c71e$var$TEXT_ENCODER.encode(body).byteLength;
        let len = body.length;
        for(let i = len - 1; i >= 0; i--){
            const code = body.charCodeAt(i);
            if (code > 0x7f && code <= 0x7ff) len++;
            else if (code > 0x7ff && code <= 0xffff) len += 2;
            if (code >= 0xdc00 && code <= 0xdfff) i--;
        }
        return len;
    } else if (typeof body.byteLength === "number") return body.byteLength;
    else if (typeof body.size === "number") return body.size;
    throw new Error(`Body Length computation failed for ${body}`);
};

});


parcelRegister("59IvS", function(module, exports) {

$parcel$export(module.exports, "AwsSdkSigV4Signer", () => $3c10526acb93d236$export$8d10c019aa195a2b);
parcelRequire("AueTL");
var $Yl5TU = parcelRequire("Yl5TU");

var $ctdzk = parcelRequire("ctdzk");
var $ctoa2 = parcelRequire("ctoa2");
var $3TrxF = parcelRequire("3TrxF");
const $3c10526acb93d236$var$throwSigningPropertyError = (name, property)=>{
    if (!property) throw new Error(`Property \`${name}\` is not resolved for AWS SDK SigV4Auth`);
    return property;
};
const $3c10526acb93d236$var$validateSigningProperties = async (signingProperties)=>{
    const context = $3c10526acb93d236$var$throwSigningPropertyError("context", signingProperties.context);
    const config = $3c10526acb93d236$var$throwSigningPropertyError("config", signingProperties.config);
    const authScheme = context.endpointV2?.properties?.authSchemes?.[0];
    const signerFunction = $3c10526acb93d236$var$throwSigningPropertyError("signer", config.signer);
    const signer = await signerFunction(authScheme);
    const signingRegion = signingProperties?.signingRegion;
    const signingName = signingProperties?.signingName;
    return {
        config: config,
        signer: signer,
        signingRegion: signingRegion,
        signingName: signingName
    };
};
class $3c10526acb93d236$export$8d10c019aa195a2b {
    async sign(httpRequest, identity, signingProperties) {
        if (!(0, $Yl5TU.HttpRequest).isInstance(httpRequest)) throw new Error("The request is not an instance of `HttpRequest` and cannot be signed");
        const { config: config, signer: signer, signingRegion: signingRegion, signingName: signingName } = await $3c10526acb93d236$var$validateSigningProperties(signingProperties);
        const signedRequest = await signer.sign(httpRequest, {
            signingDate: (0, $ctoa2.getSkewCorrectedDate)(config.systemClockOffset),
            signingRegion: signingRegion,
            signingService: signingName
        });
        return signedRequest;
    }
    errorHandler(signingProperties) {
        return (error)=>{
            const serverTime = error.ServerTime ?? (0, $ctdzk.getDateHeader)(error.$response);
            if (serverTime) {
                const config = $3c10526acb93d236$var$throwSigningPropertyError("config", signingProperties.config);
                const initialSystemClockOffset = config.systemClockOffset;
                config.systemClockOffset = (0, $3TrxF.getUpdatedSystemClockOffset)(serverTime, config.systemClockOffset);
                const clockSkewCorrected = config.systemClockOffset !== initialSystemClockOffset;
                if (clockSkewCorrected && error.$metadata) error.$metadata.clockSkewCorrected = true;
            }
            throw error;
        };
    }
    successHandler(httpResponse, signingProperties) {
        const dateHeader = (0, $ctdzk.getDateHeader)(httpResponse);
        if (dateHeader) {
            const config = $3c10526acb93d236$var$throwSigningPropertyError("config", signingProperties.config);
            config.systemClockOffset = (0, $3TrxF.getUpdatedSystemClockOffset)(dateHeader, config.systemClockOffset);
        }
    }
}
const $3c10526acb93d236$export$9e647fbacb03e1b7 = $3c10526acb93d236$export$8d10c019aa195a2b;

});
parcelRegister("ctdzk", function(module, exports) {

$parcel$export(module.exports, "getDateHeader", () => $9142b7f1e3fadb72$export$6a001c300b5a041e);
parcelRequire("AueTL");
var $1QalE = parcelRequire("1QalE");
const $9142b7f1e3fadb72$export$6a001c300b5a041e = (response)=>(0, $1QalE.HttpResponse).isInstance(response) ? response.headers?.date ?? response.headers?.Date : undefined;

});

parcelRegister("ctoa2", function(module, exports) {

$parcel$export(module.exports, "getSkewCorrectedDate", () => $914aef567176ebd1$export$86d5c90340985ada);
const $914aef567176ebd1$export$86d5c90340985ada = (systemClockOffset)=>new Date(Date.now() + systemClockOffset);

});

parcelRegister("3TrxF", function(module, exports) {

$parcel$export(module.exports, "getUpdatedSystemClockOffset", () => $2d5bdf6fcc4a84c9$export$1ed4d48b860b1348);

var $faZc1 = parcelRequire("faZc1");
const $2d5bdf6fcc4a84c9$export$1ed4d48b860b1348 = (clockTime, currentSystemClockOffset)=>{
    const clockTimeInMs = Date.parse(clockTime);
    if ((0, $faZc1.isClockSkewed)(clockTimeInMs, currentSystemClockOffset)) return clockTimeInMs - Date.now();
    return currentSystemClockOffset;
};

});
parcelRegister("faZc1", function(module, exports) {

$parcel$export(module.exports, "isClockSkewed", () => $b0c741d075cea5f5$export$c162a01d4a03ea6f);

var $ctoa2 = parcelRequire("ctoa2");
const $b0c741d075cea5f5$export$c162a01d4a03ea6f = (clockTime, systemClockOffset)=>Math.abs((0, $ctoa2.getSkewCorrectedDate)(systemClockOffset).getTime() - clockTime) >= 300000;

});



parcelRegister("cZNaw", function(module, exports) {
$parcel$export(module.exports, "resolveDefaultsModeConfig", () => (parcelRequire("9hPVM")).resolveDefaultsModeConfig);
parcelRequire("9hPVM");

});
parcelRegister("9hPVM", function(module, exports) {

$parcel$export(module.exports, "resolveDefaultsModeConfig", () => $6c2dfbf81fd9029a$export$b146d618450007ac);
parcelRequire("gNNye");
var $7rOmg = parcelRequire("7rOmg");

var $l4Evi = parcelRequire("l4Evi");

var $g1uku = parcelRequire("g1uku");
const $6c2dfbf81fd9029a$export$b146d618450007ac = ({ defaultsMode: defaultsMode } = {})=>(0, $7rOmg.memoize)(async ()=>{
        const mode = typeof defaultsMode === "function" ? await defaultsMode() : defaultsMode;
        switch(mode?.toLowerCase()){
            case "auto":
                return Promise.resolve($6c2dfbf81fd9029a$var$isMobileBrowser() ? "mobile" : "standard");
            case "mobile":
            case "in-region":
            case "cross-region":
            case "standard":
            case "legacy":
                return Promise.resolve(mode?.toLocaleLowerCase());
            case undefined:
                return Promise.resolve("legacy");
            default:
                throw new Error(`Invalid parameter for "defaultsMode", expect ${(0, $g1uku.DEFAULTS_MODE_OPTIONS).join(", ")}, got ${mode}`);
        }
    });
const $6c2dfbf81fd9029a$var$isMobileBrowser = ()=>{
    const parsedUA = typeof window !== "undefined" && window?.navigator?.userAgent ? (0, (/*@__PURE__*/$parcel$interopDefault($l4Evi))).parse(window.navigator.userAgent) : undefined;
    const platform = parsedUA?.platform?.type;
    return platform === "tablet" || platform === "mobile";
};

});
parcelRegister("gNNye", function(module, exports) {
$parcel$export(module.exports, "CredentialsProviderError", () => (parcelRequire("eaU4c")).CredentialsProviderError);
$parcel$export(module.exports, "memoize", () => (parcelRequire("7rOmg")).memoize);
parcelRequire("eaU4c");
parcelRequire("bYpo4");
parcelRequire("hOB2C");
parcelRequire("keIeW");
parcelRequire("8jedV");
parcelRequire("7rOmg");

});
parcelRegister("eaU4c", function(module, exports) {

$parcel$export(module.exports, "CredentialsProviderError", () => $a51d7d8ac3b097b7$export$921076535eff0df5);

var $bYpo4 = parcelRequire("bYpo4");
class $a51d7d8ac3b097b7$export$921076535eff0df5 extends (0, $bYpo4.ProviderError) {
    constructor(message, tryNextLink = true){
        super(message, tryNextLink);
        this.tryNextLink = tryNextLink;
        this.name = "CredentialsProviderError";
        Object.setPrototypeOf(this, $a51d7d8ac3b097b7$export$921076535eff0df5.prototype);
    }
}

});
parcelRegister("bYpo4", function(module, exports) {

$parcel$export(module.exports, "ProviderError", () => $8b78fdaeeb925fa2$export$478ec1fdae99aa79);
class $8b78fdaeeb925fa2$export$478ec1fdae99aa79 extends Error {
    constructor(message, tryNextLink = true){
        super(message);
        this.tryNextLink = tryNextLink;
        this.name = "ProviderError";
        Object.setPrototypeOf(this, $8b78fdaeeb925fa2$export$478ec1fdae99aa79.prototype);
    }
    static from(error, tryNextLink = true) {
        return Object.assign(new this(error.message, tryNextLink), error);
    }
}

});


parcelRegister("hOB2C", function(module, exports) {

var $bYpo4 = parcelRequire("bYpo4");
class $cf83d6d2601682d8$export$5c605c2f83e2f56b extends (0, $bYpo4.ProviderError) {
    constructor(message, tryNextLink = true){
        super(message, tryNextLink);
        this.tryNextLink = tryNextLink;
        this.name = "TokenProviderError";
        Object.setPrototypeOf(this, $cf83d6d2601682d8$export$5c605c2f83e2f56b.prototype);
    }
}

});

parcelRegister("keIeW", function(module, exports) {

var $bYpo4 = parcelRequire("bYpo4");
const $ebb76e92bf610dcd$export$e08e3b67e392101e = (...providers)=>async ()=>{
        if (providers.length === 0) throw new (0, $bYpo4.ProviderError)("No providers in chain");
        let lastProviderError;
        for (const provider of providers)try {
            const credentials = await provider();
            return credentials;
        } catch (err) {
            lastProviderError = err;
            if (err?.tryNextLink) continue;
            throw err;
        }
        throw lastProviderError;
    };

});

parcelRegister("8jedV", function(module, exports) {
const $60cb219bc6085a97$export$294ab423a8f4a426 = (staticValue)=>()=>Promise.resolve(staticValue);

});

parcelRegister("7rOmg", function(module, exports) {

$parcel$export(module.exports, "memoize", () => $56c21e179b0f4adb$export$fc10aeed3a532e2a);
const $56c21e179b0f4adb$export$fc10aeed3a532e2a = (provider, isExpired, requiresRefresh)=>{
    let resolved;
    let pending;
    let hasResult;
    let isConstant = false;
    const coalesceProvider = async ()=>{
        if (!pending) pending = provider();
        try {
            resolved = await pending;
            hasResult = true;
            isConstant = false;
        } finally{
            pending = undefined;
        }
        return resolved;
    };
    if (isExpired === undefined) return async (options)=>{
        if (!hasResult || options?.forceRefresh) resolved = await coalesceProvider();
        return resolved;
    };
    return async (options)=>{
        if (!hasResult || options?.forceRefresh) resolved = await coalesceProvider();
        if (isConstant) return resolved;
        if (requiresRefresh && !requiresRefresh(resolved)) {
            isConstant = true;
            return resolved;
        }
        if (isExpired(resolved)) {
            await coalesceProvider();
            return resolved;
        }
        return resolved;
    };
};

});


parcelRegister("g1uku", function(module, exports) {

$parcel$export(module.exports, "DEFAULTS_MODE_OPTIONS", () => $baa44424dfd37cd4$export$32aeb2667d16f7c1);
const $baa44424dfd37cd4$export$32aeb2667d16f7c1 = [
    "in-region",
    "cross-region",
    "mobile",
    "standard",
    "legacy"
];

});



parcelRegister("dkoxR", function(module, exports) {
$parcel$export(module.exports, "getAwsRegionExtensionConfiguration", () => (parcelRequire("8jFmv")).getAwsRegionExtensionConfiguration);
$parcel$export(module.exports, "resolveAwsRegionExtensionConfiguration", () => (parcelRequire("8jFmv")).resolveAwsRegionExtensionConfiguration);
parcelRequire("8jFmv");
parcelRequire("0V3x7");

});
parcelRegister("8jFmv", function(module, exports) {

$parcel$export(module.exports, "getAwsRegionExtensionConfiguration", () => $60e02eb920e27000$export$be3086d183cd8ea6);
$parcel$export(module.exports, "resolveAwsRegionExtensionConfiguration", () => $60e02eb920e27000$export$74973a8fb8dfc16e);
const $60e02eb920e27000$export$be3086d183cd8ea6 = (runtimeConfig)=>{
    let runtimeConfigRegion = async ()=>{
        if (runtimeConfig.region === undefined) throw new Error("Region is missing from runtimeConfig");
        const region = runtimeConfig.region;
        if (typeof region === "string") return region;
        return region();
    };
    return {
        setRegion (region) {
            runtimeConfigRegion = region;
        },
        region () {
            return runtimeConfigRegion;
        }
    };
};
const $60e02eb920e27000$export$74973a8fb8dfc16e = (awsRegionExtensionConfiguration)=>{
    return {
        region: awsRegionExtensionConfiguration.region()
    };
};

});

parcelRegister("0V3x7", function(module, exports) {
parcelRequire("7jpSG");
parcelRequire("gVThx");

});
parcelRegister("7jpSG", function(module, exports) {
const $552e62275ad4dbad$export$26513716e2900bad = "AWS_REGION";
const $552e62275ad4dbad$export$8afb1c306a7d01b = "region";
const $552e62275ad4dbad$export$1509d3ea54119a08 = {
    environmentVariableSelector: (env)=>env[$552e62275ad4dbad$export$26513716e2900bad],
    configFileSelector: (profile)=>profile[$552e62275ad4dbad$export$8afb1c306a7d01b],
    default: ()=>{
        throw new Error("Region is missing");
    }
};
const $552e62275ad4dbad$export$9a37503ca194454d = {
    preferredFile: "credentials"
};

});

parcelRegister("gVThx", function(module, exports) {

var $iA8Md = parcelRequire("iA8Md");

var $fdORM = parcelRequire("fdORM");
const $c53cda0bad4043df$export$7696ef37558bd0ec = (input)=>{
    const { region: region, useFipsEndpoint: useFipsEndpoint } = input;
    if (!region) throw new Error("Region is missing");
    return {
        ...input,
        region: async ()=>{
            if (typeof region === "string") return (0, $iA8Md.getRealRegion)(region);
            const providedRegion = await region();
            return (0, $iA8Md.getRealRegion)(providedRegion);
        },
        useFipsEndpoint: async ()=>{
            const providedRegion = typeof region === "string" ? region : await region();
            if ((0, $fdORM.isFipsRegion)(providedRegion)) return true;
            return typeof useFipsEndpoint !== "function" ? Promise.resolve(!!useFipsEndpoint) : useFipsEndpoint();
        }
    };
};

});
parcelRegister("iA8Md", function(module, exports) {

$parcel$export(module.exports, "getRealRegion", () => $d87265a39853cb4a$export$ecbdf004a8547a7f);

var $fdORM = parcelRequire("fdORM");
const $d87265a39853cb4a$export$ecbdf004a8547a7f = (region)=>(0, $fdORM.isFipsRegion)(region) ? [
        "fips-aws-global",
        "aws-fips"
    ].includes(region) ? "us-east-1" : region.replace(/fips-(dkr-|prod-)?|-fips/, "") : region;

});
parcelRegister("fdORM", function(module, exports) {

$parcel$export(module.exports, "isFipsRegion", () => $b14f86ef9cf638c4$export$cc893cb7e6a508dd);
const $b14f86ef9cf638c4$export$cc893cb7e6a508dd = (region)=>typeof region === "string" && (region.startsWith("fips-") || region.endsWith("-fips"));

});





parcelRegister("3Z3zT", function(module, exports) {

$parcel$export(module.exports, "parseJsonBody", () => $2e69d816f45dcea4$export$759bcb35b0d1bf81);
$parcel$export(module.exports, "parseJsonErrorBody", () => $2e69d816f45dcea4$export$cb111c4739f3951f);
$parcel$export(module.exports, "loadRestJsonErrorCode", () => $2e69d816f45dcea4$export$6e21dac881a79e70);

var $hOREa = parcelRequire("hOREa");
const $2e69d816f45dcea4$export$759bcb35b0d1bf81 = (streamBody, context)=>(0, $hOREa.collectBodyString)(streamBody, context).then((encoded)=>{
        if (encoded.length) try {
            return JSON.parse(encoded);
        } catch (e) {
            if (e?.name === "SyntaxError") Object.defineProperty(e, "$responseBodyText", {
                value: encoded
            });
            throw e;
        }
        return {};
    });
const $2e69d816f45dcea4$export$cb111c4739f3951f = async (errorBody, context)=>{
    const value = await $2e69d816f45dcea4$export$759bcb35b0d1bf81(errorBody, context);
    value.message = value.message ?? value.Message;
    return value;
};
const $2e69d816f45dcea4$export$6e21dac881a79e70 = (output, data)=>{
    const findKey = (object, key)=>Object.keys(object).find((k)=>k.toLowerCase() === key.toLowerCase());
    const sanitizeErrorCode = (rawValue)=>{
        let cleanValue = rawValue;
        if (typeof cleanValue === "number") cleanValue = cleanValue.toString();
        if (cleanValue.indexOf(",") >= 0) cleanValue = cleanValue.split(",")[0];
        if (cleanValue.indexOf(":") >= 0) cleanValue = cleanValue.split(":")[0];
        if (cleanValue.indexOf("#") >= 0) cleanValue = cleanValue.split("#")[1];
        return cleanValue;
    };
    const headerKey = findKey(output.headers, "x-amzn-errortype");
    if (headerKey !== undefined) return sanitizeErrorCode(output.headers[headerKey]);
    if (data.code !== undefined) return sanitizeErrorCode(data.code);
    if (data["__type"] !== undefined) return sanitizeErrorCode(data["__type"]);
};

});
parcelRegister("hOREa", function(module, exports) {

$parcel$export(module.exports, "collectBodyString", () => $cf90b85756b9ed6c$export$3cc1021c6dfb9c3e);
parcelRequire("33pc1");
var $7fiNM = parcelRequire("7fiNM");
const $cf90b85756b9ed6c$export$3cc1021c6dfb9c3e = (streamBody, context)=>(0, $7fiNM.collectBody)(streamBody, context).then((body)=>context.utf8Encoder(body));

});


parcelRegister("h81q0", function(module, exports) {

var $duOut = parcelRequire("duOut");
module.exports = $duOut("9f8La").then(()=>parcelRequire("02AJL"));

});
parcelRegister("duOut", function(module, exports) {
"use strict";

function $9d353e13045b964e$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("6SeRc")).resolve(id));
}
module.exports = $9d353e13045b964e$var$load;

});


parcelRegister("8Jx27", function(module, exports) {
"use strict";

});

parcelRegister("pFLo9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Sha256 = void 0;

var $3Z7oc = parcelRequire("3Z7oc");

var $jPqDr = parcelRequire("jPqDr");

var $adDsT = parcelRequire("adDsT");

var $fTnBm = parcelRequire("fTnBm");
var $04d2bb3de0ccea7c$var$Sha256 = /** @class */ function() {
    function Sha256(secret) {
        this.hash = new $adDsT.RawSha256();
        if (secret) {
            this.outer = new $adDsT.RawSha256();
            var inner = $04d2bb3de0ccea7c$var$bufferFromSecret(secret);
            var outer = new Uint8Array($jPqDr.BLOCK_SIZE);
            outer.set(inner);
            for(var i = 0; i < $jPqDr.BLOCK_SIZE; i++){
                inner[i] ^= 0x36;
                outer[i] ^= 0x5c;
            }
            this.hash.update(inner);
            this.outer.update(outer);
            // overwrite the copied key in memory
            for(var i = 0; i < inner.byteLength; i++)inner[i] = 0;
        }
    }
    Sha256.prototype.update = function(toHash) {
        if ((0, $fTnBm.isEmptyData)(toHash) || this.error) return;
        try {
            this.hash.update((0, $fTnBm.convertToBuffer)(toHash));
        } catch (e) {
            this.error = e;
        }
    };
    /* This synchronous method keeps compatibility
     * with the v2 aws-sdk.
     */ Sha256.prototype.digestSync = function() {
        if (this.error) throw this.error;
        if (this.outer) {
            if (!this.outer.finished) this.outer.update(this.hash.digest());
            return this.outer.digest();
        }
        return this.hash.digest();
    };
    /* The underlying digest method here is synchronous.
     * To keep the same interface with the other hash functions
     * the default is to expose this as an async method.
     * However, it can sometimes be useful to have a sync method.
     */ Sha256.prototype.digest = function() {
        return (0, $3Z7oc.__awaiter)(this, void 0, void 0, function() {
            return (0, $3Z7oc.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.digestSync()
                ];
            });
        });
    };
    return Sha256;
}();
module.exports.Sha256 = $04d2bb3de0ccea7c$var$Sha256;
function $04d2bb3de0ccea7c$var$bufferFromSecret(secret) {
    var input = (0, $fTnBm.convertToBuffer)(secret);
    if (input.byteLength > $jPqDr.BLOCK_SIZE) {
        var bufferHash = new $adDsT.RawSha256();
        bufferHash.update(input);
        input = bufferHash.digest();
    }
    var buffer = new Uint8Array($jPqDr.BLOCK_SIZE);
    buffer.set(input);
    return buffer;
}

});
parcelRegister("3Z7oc", function(module, exports) {

$parcel$export(module.exports, "__awaiter", () => $2e6cccf54e5b1519$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $2e6cccf54e5b1519$export$67ebef60e6f28a6);
$parcel$export(module.exports, "__exportStar", () => $2e6cccf54e5b1519$export$f33643c0debef087);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $2e6cccf54e5b1519$var$extendStatics = function(d, b) {
    $2e6cccf54e5b1519$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $2e6cccf54e5b1519$var$extendStatics(d, b);
};
function $2e6cccf54e5b1519$export$a8ba968b8961cb8a(d, b) {
    $2e6cccf54e5b1519$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $2e6cccf54e5b1519$export$18ce0697a983be9b = function() {
    $2e6cccf54e5b1519$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2e6cccf54e5b1519$export$18ce0697a983be9b.apply(this, arguments);
};
function $2e6cccf54e5b1519$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $2e6cccf54e5b1519$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $2e6cccf54e5b1519$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $2e6cccf54e5b1519$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $2e6cccf54e5b1519$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $2e6cccf54e5b1519$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $2e6cccf54e5b1519$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $2e6cccf54e5b1519$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $2e6cccf54e5b1519$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $2e6cccf54e5b1519$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $2e6cccf54e5b1519$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($2e6cccf54e5b1519$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $2e6cccf54e5b1519$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $2e6cccf54e5b1519$export$10c90e4f7922046c(v) {
    return this instanceof $2e6cccf54e5b1519$export$10c90e4f7922046c ? (this.v = v, this) : new $2e6cccf54e5b1519$export$10c90e4f7922046c(v);
}
function $2e6cccf54e5b1519$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $2e6cccf54e5b1519$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $2e6cccf54e5b1519$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $2e6cccf54e5b1519$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $2e6cccf54e5b1519$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $2e6cccf54e5b1519$export$19a8beecd37a4c45 === "function" ? $2e6cccf54e5b1519$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $2e6cccf54e5b1519$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $2e6cccf54e5b1519$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $2e6cccf54e5b1519$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $2e6cccf54e5b1519$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $2e6cccf54e5b1519$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("jPqDr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MAX_HASHABLE_LENGTH = module.exports.INIT = module.exports.KEY = module.exports.DIGEST_LENGTH = module.exports.BLOCK_SIZE = void 0;
/**
 * @internal
 */ module.exports.BLOCK_SIZE = 64;
/**
 * @internal
 */ module.exports.DIGEST_LENGTH = 32;
/**
 * @internal
 */ module.exports.KEY = new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
/**
 * @internal
 */ module.exports.INIT = [
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
];
/**
 * @internal
 */ module.exports.MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;

});

parcelRegister("adDsT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RawSha256 = void 0;

var $jPqDr = parcelRequire("jPqDr");
/**
 * @internal
 */ var $7709bb3c17ec712d$var$RawSha256 = /** @class */ function() {
    function RawSha256() {
        this.state = Int32Array.from($jPqDr.INIT);
        this.temp = new Int32Array(64);
        this.buffer = new Uint8Array(64);
        this.bufferLength = 0;
        this.bytesHashed = 0;
        /**
         * @internal
         */ this.finished = false;
    }
    RawSha256.prototype.update = function(data) {
        if (this.finished) throw new Error("Attempted to update an already finished hash.");
        var position = 0;
        var byteLength = data.byteLength;
        this.bytesHashed += byteLength;
        if (this.bytesHashed * 8 > $jPqDr.MAX_HASHABLE_LENGTH) throw new Error("Cannot hash more than 2^53 - 1 bits");
        while(byteLength > 0){
            this.buffer[this.bufferLength++] = data[position++];
            byteLength--;
            if (this.bufferLength === $jPqDr.BLOCK_SIZE) {
                this.hashBuffer();
                this.bufferLength = 0;
            }
        }
    };
    RawSha256.prototype.digest = function() {
        if (!this.finished) {
            var bitsHashed = this.bytesHashed * 8;
            var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
            var undecoratedLength = this.bufferLength;
            bufferView.setUint8(this.bufferLength++, 0x80);
            // Ensure the final block has enough room for the hashed length
            if (undecoratedLength % $jPqDr.BLOCK_SIZE >= $jPqDr.BLOCK_SIZE - 8) {
                for(var i = this.bufferLength; i < $jPqDr.BLOCK_SIZE; i++)bufferView.setUint8(i, 0);
                this.hashBuffer();
                this.bufferLength = 0;
            }
            for(var i = this.bufferLength; i < $jPqDr.BLOCK_SIZE - 8; i++)bufferView.setUint8(i, 0);
            bufferView.setUint32($jPqDr.BLOCK_SIZE - 8, Math.floor(bitsHashed / 0x100000000), true);
            bufferView.setUint32($jPqDr.BLOCK_SIZE - 4, bitsHashed);
            this.hashBuffer();
            this.finished = true;
        }
        // The value in state is little-endian rather than big-endian, so flip
        // each word into a new Uint8Array
        var out = new Uint8Array($jPqDr.DIGEST_LENGTH);
        for(var i = 0; i < 8; i++){
            out[i * 4] = this.state[i] >>> 24 & 0xff;
            out[i * 4 + 1] = this.state[i] >>> 16 & 0xff;
            out[i * 4 + 2] = this.state[i] >>> 8 & 0xff;
            out[i * 4 + 3] = this.state[i] >>> 0 & 0xff;
        }
        return out;
    };
    RawSha256.prototype.hashBuffer = function() {
        var _a = this, buffer = _a.buffer, state = _a.state;
        var state0 = state[0], state1 = state[1], state2 = state[2], state3 = state[3], state4 = state[4], state5 = state[5], state6 = state[6], state7 = state[7];
        for(var i = 0; i < $jPqDr.BLOCK_SIZE; i++){
            if (i < 16) this.temp[i] = (buffer[i * 4] & 0xff) << 24 | (buffer[i * 4 + 1] & 0xff) << 16 | (buffer[i * 4 + 2] & 0xff) << 8 | buffer[i * 4 + 3] & 0xff;
            else {
                var u = this.temp[i - 2];
                var t1_1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
                u = this.temp[i - 15];
                var t2_1 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
                this.temp[i] = (t1_1 + this.temp[i - 7] | 0) + (t2_1 + this.temp[i - 16] | 0);
            }
            var t1 = (((state4 >>> 6 | state4 << 26) ^ (state4 >>> 11 | state4 << 21) ^ (state4 >>> 25 | state4 << 7)) + (state4 & state5 ^ ~state4 & state6) | 0) + (state7 + ($jPqDr.KEY[i] + this.temp[i] | 0) | 0) | 0;
            var t2 = ((state0 >>> 2 | state0 << 30) ^ (state0 >>> 13 | state0 << 19) ^ (state0 >>> 22 | state0 << 10)) + (state0 & state1 ^ state0 & state2 ^ state1 & state2) | 0;
            state7 = state6;
            state6 = state5;
            state5 = state4;
            state4 = state3 + t1 | 0;
            state3 = state2;
            state2 = state1;
            state1 = state0;
            state0 = t1 + t2 | 0;
        }
        state[0] += state0;
        state[1] += state1;
        state[2] += state2;
        state[3] += state3;
        state[4] += state4;
        state[5] += state5;
        state[6] += state6;
        state[7] += state7;
    };
    return RawSha256;
}();
module.exports.RawSha256 = $7709bb3c17ec712d$var$RawSha256;

});

parcelRegister("fTnBm", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.uint32ArrayFrom = module.exports.numToUint8 = module.exports.isEmptyData = module.exports.convertToBuffer = void 0;

var $eo017 = parcelRequire("eo017");
Object.defineProperty(module.exports, "convertToBuffer", {
    enumerable: true,
    get: function() {
        return $eo017.convertToBuffer;
    }
});

var $krsH1 = parcelRequire("krsH1");
Object.defineProperty(module.exports, "isEmptyData", {
    enumerable: true,
    get: function() {
        return $krsH1.isEmptyData;
    }
});

var $colhh = parcelRequire("colhh");
Object.defineProperty(module.exports, "numToUint8", {
    enumerable: true,
    get: function() {
        return $colhh.numToUint8;
    }
});

var $bM1wi = parcelRequire("bM1wi");
Object.defineProperty(module.exports, "uint32ArrayFrom", {
    enumerable: true,
    get: function() {
        return $bM1wi.uint32ArrayFrom;
    }
});

});
parcelRegister("eo017", function(module, exports) {

var $jYnzf = parcelRequire("jYnzf");
var $a79351f365b7af78$require$Buffer = $jYnzf.Buffer;
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.convertToBuffer = void 0;

var $8fYP2 = parcelRequire("8fYP2");
// Quick polyfill
var $a79351f365b7af78$var$fromUtf8 = typeof $a79351f365b7af78$require$Buffer !== "undefined" && $a79351f365b7af78$require$Buffer.from ? function(input) {
    return $a79351f365b7af78$require$Buffer.from(input, "utf8");
} : $8fYP2.fromUtf8;
function $a79351f365b7af78$var$convertToBuffer(data) {
    // Already a Uint8, do nothing
    if (data instanceof Uint8Array) return data;
    if (typeof data === "string") return $a79351f365b7af78$var$fromUtf8(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}
module.exports.convertToBuffer = $a79351f365b7af78$var$convertToBuffer;

});
parcelRegister("jYnzf", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $e8a5e6f3acf57928$export$a143d493d941bafc, (v) => $e8a5e6f3acf57928$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $e8a5e6f3acf57928$export$f99ded8fe4b79145, (v) => $e8a5e6f3acf57928$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $e8a5e6f3acf57928$export$a143d493d941bafc;
var $e8a5e6f3acf57928$export$e4cf37d7f6fb9e0a;
var $e8a5e6f3acf57928$export$f99ded8fe4b79145;
/*
 * Export kMaxLength after typed array support is determined.
 */ var $e8a5e6f3acf57928$export$599f31c3813fae4d;
"use strict";

var $80sMt = parcelRequire("80sMt");

var $98vqs = parcelRequire("98vqs");

var $9wf3N = parcelRequire("9wf3N");
$e8a5e6f3acf57928$export$a143d493d941bafc = $e8a5e6f3acf57928$var$Buffer;
$e8a5e6f3acf57928$export$e4cf37d7f6fb9e0a = $e8a5e6f3acf57928$var$SlowBuffer;
$e8a5e6f3acf57928$export$f99ded8fe4b79145 = 50;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */ $e8a5e6f3acf57928$var$Buffer.TYPED_ARRAY_SUPPORT = $parcel$global.TYPED_ARRAY_SUPPORT !== undefined ? $parcel$global.TYPED_ARRAY_SUPPORT : $e8a5e6f3acf57928$var$typedArraySupport();
$e8a5e6f3acf57928$export$599f31c3813fae4d = $e8a5e6f3acf57928$var$kMaxLength();
function $e8a5e6f3acf57928$var$typedArraySupport() {
    try {
        var arr = new Uint8Array(1);
        arr.__proto__ = {
            __proto__: Uint8Array.prototype,
            foo: function() {
                return 42;
            }
        };
        return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === "function" && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
        ;
    } catch (e) {
        return false;
    }
}
function $e8a5e6f3acf57928$var$kMaxLength() {
    return $e8a5e6f3acf57928$var$Buffer.TYPED_ARRAY_SUPPORT ? 0x7fffffff : 0x3fffffff;
}
function $e8a5e6f3acf57928$var$createBuffer(that, length) {
    if ($e8a5e6f3acf57928$var$kMaxLength() < length) throw new RangeError("Invalid typed array length");
    if ($e8a5e6f3acf57928$var$Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = new Uint8Array(length);
        that.__proto__ = $e8a5e6f3acf57928$var$Buffer.prototype;
    } else {
        // Fallback: Return an object instance of the Buffer class
        if (that === null) that = new $e8a5e6f3acf57928$var$Buffer(length);
        that.length = length;
    }
    return that;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $e8a5e6f3acf57928$var$Buffer(arg, encodingOrOffset, length) {
    if (!$e8a5e6f3acf57928$var$Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof $e8a5e6f3acf57928$var$Buffer)) return new $e8a5e6f3acf57928$var$Buffer(arg, encodingOrOffset, length);
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new Error("If encoding is specified then the first argument must be a string");
        return $e8a5e6f3acf57928$var$allocUnsafe(this, arg);
    }
    return $e8a5e6f3acf57928$var$from(this, arg, encodingOrOffset, length);
}
$e8a5e6f3acf57928$var$Buffer.poolSize = 8192 // not used by this implementation
;
// TODO: Legacy, not needed anymore. Remove in next major version.
$e8a5e6f3acf57928$var$Buffer._augment = function(arr) {
    arr.__proto__ = $e8a5e6f3acf57928$var$Buffer.prototype;
    return arr;
};
function $e8a5e6f3acf57928$var$from(that, value, encodingOrOffset, length) {
    if (typeof value === "number") throw new TypeError('"value" argument must not be a number');
    if (typeof ArrayBuffer !== "undefined" && value instanceof ArrayBuffer) return $e8a5e6f3acf57928$var$fromArrayBuffer(that, value, encodingOrOffset, length);
    if (typeof value === "string") return $e8a5e6f3acf57928$var$fromString(that, value, encodingOrOffset);
    return $e8a5e6f3acf57928$var$fromObject(that, value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $e8a5e6f3acf57928$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $e8a5e6f3acf57928$var$from(null, value, encodingOrOffset, length);
};
if ($e8a5e6f3acf57928$var$Buffer.TYPED_ARRAY_SUPPORT) {
    $e8a5e6f3acf57928$var$Buffer.prototype.__proto__ = Uint8Array.prototype;
    $e8a5e6f3acf57928$var$Buffer.__proto__ = Uint8Array;
    if (typeof Symbol !== "undefined" && Symbol.species && $e8a5e6f3acf57928$var$Buffer[Symbol.species] === $e8a5e6f3acf57928$var$Buffer) // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty($e8a5e6f3acf57928$var$Buffer, Symbol.species, {
        value: null,
        configurable: true
    });
}
function $e8a5e6f3acf57928$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be a number');
    else if (size < 0) throw new RangeError('"size" argument must not be negative');
}
function $e8a5e6f3acf57928$var$alloc(that, size, fill, encoding) {
    $e8a5e6f3acf57928$var$assertSize(size);
    if (size <= 0) return $e8a5e6f3acf57928$var$createBuffer(that, size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === "string" ? $e8a5e6f3acf57928$var$createBuffer(that, size).fill(fill, encoding) : $e8a5e6f3acf57928$var$createBuffer(that, size).fill(fill);
    return $e8a5e6f3acf57928$var$createBuffer(that, size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $e8a5e6f3acf57928$var$Buffer.alloc = function(size, fill, encoding) {
    return $e8a5e6f3acf57928$var$alloc(null, size, fill, encoding);
};
function $e8a5e6f3acf57928$var$allocUnsafe(that, size) {
    $e8a5e6f3acf57928$var$assertSize(size);
    that = $e8a5e6f3acf57928$var$createBuffer(that, size < 0 ? 0 : $e8a5e6f3acf57928$var$checked(size) | 0);
    if (!$e8a5e6f3acf57928$var$Buffer.TYPED_ARRAY_SUPPORT) for(var i = 0; i < size; ++i)that[i] = 0;
    return that;
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $e8a5e6f3acf57928$var$Buffer.allocUnsafe = function(size) {
    return $e8a5e6f3acf57928$var$allocUnsafe(null, size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $e8a5e6f3acf57928$var$Buffer.allocUnsafeSlow = function(size) {
    return $e8a5e6f3acf57928$var$allocUnsafe(null, size);
};
function $e8a5e6f3acf57928$var$fromString(that, string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$e8a5e6f3acf57928$var$Buffer.isEncoding(encoding)) throw new TypeError('"encoding" must be a valid string encoding');
    var length = $e8a5e6f3acf57928$var$byteLength(string, encoding) | 0;
    that = $e8a5e6f3acf57928$var$createBuffer(that, length);
    var actual = that.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual);
    return that;
}
function $e8a5e6f3acf57928$var$fromArrayLike(that, array) {
    var length = array.length < 0 ? 0 : $e8a5e6f3acf57928$var$checked(array.length) | 0;
    that = $e8a5e6f3acf57928$var$createBuffer(that, length);
    for(var i = 0; i < length; i += 1)that[i] = array[i] & 255;
    return that;
}
function $e8a5e6f3acf57928$var$fromArrayBuffer(that, array, byteOffset, length) {
    array.byteLength // this throws if `array` is not a valid ArrayBuffer
    ;
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError("'offset' is out of bounds");
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError("'length' is out of bounds");
    if (byteOffset === undefined && length === undefined) array = new Uint8Array(array);
    else if (length === undefined) array = new Uint8Array(array, byteOffset);
    else array = new Uint8Array(array, byteOffset, length);
    if ($e8a5e6f3acf57928$var$Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = array;
        that.__proto__ = $e8a5e6f3acf57928$var$Buffer.prototype;
    } else // Fallback: Return an object instance of the Buffer class
    that = $e8a5e6f3acf57928$var$fromArrayLike(that, array);
    return that;
}
function $e8a5e6f3acf57928$var$fromObject(that, obj) {
    if ($e8a5e6f3acf57928$var$Buffer.isBuffer(obj)) {
        var len = $e8a5e6f3acf57928$var$checked(obj.length) | 0;
        that = $e8a5e6f3acf57928$var$createBuffer(that, len);
        if (that.length === 0) return that;
        obj.copy(that, 0, 0, len);
        return that;
    }
    if (obj) {
        if (typeof ArrayBuffer !== "undefined" && obj.buffer instanceof ArrayBuffer || "length" in obj) {
            if (typeof obj.length !== "number" || $e8a5e6f3acf57928$var$isnan(obj.length)) return $e8a5e6f3acf57928$var$createBuffer(that, 0);
            return $e8a5e6f3acf57928$var$fromArrayLike(that, obj);
        }
        if (obj.type === "Buffer" && $9wf3N(obj.data)) return $e8a5e6f3acf57928$var$fromArrayLike(that, obj.data);
    }
    throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
}
function $e8a5e6f3acf57928$var$checked(length) {
    // Note: cannot use `length < kMaxLength()` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $e8a5e6f3acf57928$var$kMaxLength()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $e8a5e6f3acf57928$var$kMaxLength().toString(16) + " bytes");
    return length | 0;
}
function $e8a5e6f3acf57928$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $e8a5e6f3acf57928$var$Buffer.alloc(+length);
}
$e8a5e6f3acf57928$var$Buffer.isBuffer = function isBuffer(b) {
    return !!(b != null && b._isBuffer);
};
$e8a5e6f3acf57928$var$Buffer.compare = function compare(a, b) {
    if (!$e8a5e6f3acf57928$var$Buffer.isBuffer(a) || !$e8a5e6f3acf57928$var$Buffer.isBuffer(b)) throw new TypeError("Arguments must be Buffers");
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$e8a5e6f3acf57928$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$e8a5e6f3acf57928$var$Buffer.concat = function concat(list, length) {
    if (!$9wf3N(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $e8a5e6f3acf57928$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $e8a5e6f3acf57928$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if (!$e8a5e6f3acf57928$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $e8a5e6f3acf57928$var$byteLength(string, encoding) {
    if ($e8a5e6f3acf57928$var$Buffer.isBuffer(string)) return string.length;
    if (typeof ArrayBuffer !== "undefined" && typeof ArrayBuffer.isView === "function" && (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") string = "" + string;
    var len = string.length;
    if (len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
        case undefined:
            return $e8a5e6f3acf57928$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $e8a5e6f3acf57928$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return $e8a5e6f3acf57928$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$e8a5e6f3acf57928$var$Buffer.byteLength = $e8a5e6f3acf57928$var$byteLength;
function $e8a5e6f3acf57928$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $e8a5e6f3acf57928$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $e8a5e6f3acf57928$var$utf8Slice(this, start, end);
        case "ascii":
            return $e8a5e6f3acf57928$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $e8a5e6f3acf57928$var$latin1Slice(this, start, end);
        case "base64":
            return $e8a5e6f3acf57928$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $e8a5e6f3acf57928$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
$e8a5e6f3acf57928$var$Buffer.prototype._isBuffer = true;
function $e8a5e6f3acf57928$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$e8a5e6f3acf57928$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$e8a5e6f3acf57928$var$swap(this, i, i + 1);
    return this;
};
$e8a5e6f3acf57928$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $e8a5e6f3acf57928$var$swap(this, i, i + 3);
        $e8a5e6f3acf57928$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$e8a5e6f3acf57928$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $e8a5e6f3acf57928$var$swap(this, i, i + 7);
        $e8a5e6f3acf57928$var$swap(this, i + 1, i + 6);
        $e8a5e6f3acf57928$var$swap(this, i + 2, i + 5);
        $e8a5e6f3acf57928$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$e8a5e6f3acf57928$var$Buffer.prototype.toString = function toString() {
    var length = this.length | 0;
    if (length === 0) return "";
    if (arguments.length === 0) return $e8a5e6f3acf57928$var$utf8Slice(this, 0, length);
    return $e8a5e6f3acf57928$var$slowToString.apply(this, arguments);
};
$e8a5e6f3acf57928$var$Buffer.prototype.equals = function equals(b) {
    if (!$e8a5e6f3acf57928$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $e8a5e6f3acf57928$var$Buffer.compare(this, b) === 0;
};
$e8a5e6f3acf57928$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $e8a5e6f3acf57928$export$f99ded8fe4b79145;
    if (this.length > 0) {
        str = this.toString("hex", 0, max).match(/.{2}/g).join(" ");
        if (this.length > max) str += " ... ";
    }
    return "<Buffer " + str + ">";
};
$e8a5e6f3acf57928$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (!$e8a5e6f3acf57928$var$Buffer.isBuffer(target)) throw new TypeError("Argument must be a Buffer");
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $e8a5e6f3acf57928$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if (isNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $e8a5e6f3acf57928$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($e8a5e6f3acf57928$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $e8a5e6f3acf57928$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if ($e8a5e6f3acf57928$var$Buffer.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $e8a5e6f3acf57928$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $e8a5e6f3acf57928$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$e8a5e6f3acf57928$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$e8a5e6f3acf57928$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $e8a5e6f3acf57928$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$e8a5e6f3acf57928$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $e8a5e6f3acf57928$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $e8a5e6f3acf57928$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    // must be an even number of digits
    var strLen = string.length;
    if (strLen % 2 !== 0) throw new TypeError("Invalid hex string");
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if (isNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $e8a5e6f3acf57928$var$utf8Write(buf, string, offset, length) {
    return $e8a5e6f3acf57928$var$blitBuffer($e8a5e6f3acf57928$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $e8a5e6f3acf57928$var$asciiWrite(buf, string, offset, length) {
    return $e8a5e6f3acf57928$var$blitBuffer($e8a5e6f3acf57928$var$asciiToBytes(string), buf, offset, length);
}
function $e8a5e6f3acf57928$var$latin1Write(buf, string, offset, length) {
    return $e8a5e6f3acf57928$var$asciiWrite(buf, string, offset, length);
}
function $e8a5e6f3acf57928$var$base64Write(buf, string, offset, length) {
    return $e8a5e6f3acf57928$var$blitBuffer($e8a5e6f3acf57928$var$base64ToBytes(string), buf, offset, length);
}
function $e8a5e6f3acf57928$var$ucs2Write(buf, string, offset, length) {
    return $e8a5e6f3acf57928$var$blitBuffer($e8a5e6f3acf57928$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$e8a5e6f3acf57928$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset | 0;
        if (isFinite(length)) {
            length = length | 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    // legacy write(string, encoding, offset, length) - remove in v0.13
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $e8a5e6f3acf57928$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $e8a5e6f3acf57928$var$utf8Write(this, string, offset, length);
        case "ascii":
            return $e8a5e6f3acf57928$var$asciiWrite(this, string, offset, length);
        case "latin1":
        case "binary":
            return $e8a5e6f3acf57928$var$latin1Write(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $e8a5e6f3acf57928$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $e8a5e6f3acf57928$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$e8a5e6f3acf57928$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $e8a5e6f3acf57928$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $80sMt.fromByteArray(buf);
    else return $80sMt.fromByteArray(buf.slice(start, end));
}
function $e8a5e6f3acf57928$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $e8a5e6f3acf57928$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $e8a5e6f3acf57928$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $e8a5e6f3acf57928$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $e8a5e6f3acf57928$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $e8a5e6f3acf57928$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $e8a5e6f3acf57928$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $e8a5e6f3acf57928$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $e8a5e6f3acf57928$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $e8a5e6f3acf57928$var$toHex(buf[i]);
    return out;
}
function $e8a5e6f3acf57928$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    for(var i = 0; i < bytes.length; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$e8a5e6f3acf57928$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf;
    if ($e8a5e6f3acf57928$var$Buffer.TYPED_ARRAY_SUPPORT) {
        newBuf = this.subarray(start, end);
        newBuf.__proto__ = $e8a5e6f3acf57928$var$Buffer.prototype;
    } else {
        var sliceLen = end - start;
        newBuf = new $e8a5e6f3acf57928$var$Buffer(sliceLen, undefined);
        for(var i = 0; i < sliceLen; ++i)newBuf[i] = this[i + start];
    }
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $e8a5e6f3acf57928$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$e8a5e6f3acf57928$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $e8a5e6f3acf57928$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$e8a5e6f3acf57928$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $e8a5e6f3acf57928$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$e8a5e6f3acf57928$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    if (!noAssert) $e8a5e6f3acf57928$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$e8a5e6f3acf57928$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    if (!noAssert) $e8a5e6f3acf57928$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$e8a5e6f3acf57928$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    if (!noAssert) $e8a5e6f3acf57928$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$e8a5e6f3acf57928$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    if (!noAssert) $e8a5e6f3acf57928$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$e8a5e6f3acf57928$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    if (!noAssert) $e8a5e6f3acf57928$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$e8a5e6f3acf57928$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $e8a5e6f3acf57928$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$e8a5e6f3acf57928$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $e8a5e6f3acf57928$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$e8a5e6f3acf57928$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    if (!noAssert) $e8a5e6f3acf57928$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$e8a5e6f3acf57928$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    if (!noAssert) $e8a5e6f3acf57928$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$e8a5e6f3acf57928$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    if (!noAssert) $e8a5e6f3acf57928$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$e8a5e6f3acf57928$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    if (!noAssert) $e8a5e6f3acf57928$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$e8a5e6f3acf57928$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    if (!noAssert) $e8a5e6f3acf57928$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$e8a5e6f3acf57928$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    if (!noAssert) $e8a5e6f3acf57928$var$checkOffset(offset, 4, this.length);
    return $98vqs.read(this, offset, true, 23, 4);
};
$e8a5e6f3acf57928$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    if (!noAssert) $e8a5e6f3acf57928$var$checkOffset(offset, 4, this.length);
    return $98vqs.read(this, offset, false, 23, 4);
};
$e8a5e6f3acf57928$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    if (!noAssert) $e8a5e6f3acf57928$var$checkOffset(offset, 8, this.length);
    return $98vqs.read(this, offset, true, 52, 8);
};
$e8a5e6f3acf57928$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    if (!noAssert) $e8a5e6f3acf57928$var$checkOffset(offset, 8, this.length);
    return $98vqs.read(this, offset, false, 52, 8);
};
function $e8a5e6f3acf57928$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$e8a5e6f3acf57928$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$e8a5e6f3acf57928$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $e8a5e6f3acf57928$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$e8a5e6f3acf57928$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $e8a5e6f3acf57928$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$e8a5e6f3acf57928$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $e8a5e6f3acf57928$var$checkInt(this, value, offset, 1, 0xff, 0);
    if (!$e8a5e6f3acf57928$var$Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    this[offset] = value & 0xff;
    return offset + 1;
};
function $e8a5e6f3acf57928$var$objectWriteUInt16(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i)buf[offset + i] = (value & 0xff << 8 * (littleEndian ? i : 1 - i)) >>> (littleEndian ? i : 1 - i) * 8;
}
$e8a5e6f3acf57928$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $e8a5e6f3acf57928$var$checkInt(this, value, offset, 2, 0xffff, 0);
    if ($e8a5e6f3acf57928$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else $e8a5e6f3acf57928$var$objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
$e8a5e6f3acf57928$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $e8a5e6f3acf57928$var$checkInt(this, value, offset, 2, 0xffff, 0);
    if ($e8a5e6f3acf57928$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else $e8a5e6f3acf57928$var$objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
function $e8a5e6f3acf57928$var$objectWriteUInt32(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffffffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i)buf[offset + i] = value >>> (littleEndian ? i : 3 - i) * 8 & 0xff;
}
$e8a5e6f3acf57928$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $e8a5e6f3acf57928$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    if ($e8a5e6f3acf57928$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset + 3] = value >>> 24;
        this[offset + 2] = value >>> 16;
        this[offset + 1] = value >>> 8;
        this[offset] = value & 0xff;
    } else $e8a5e6f3acf57928$var$objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
$e8a5e6f3acf57928$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $e8a5e6f3acf57928$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    if ($e8a5e6f3acf57928$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else $e8a5e6f3acf57928$var$objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
$e8a5e6f3acf57928$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $e8a5e6f3acf57928$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$e8a5e6f3acf57928$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $e8a5e6f3acf57928$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$e8a5e6f3acf57928$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $e8a5e6f3acf57928$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (!$e8a5e6f3acf57928$var$Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$e8a5e6f3acf57928$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $e8a5e6f3acf57928$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    if ($e8a5e6f3acf57928$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else $e8a5e6f3acf57928$var$objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
$e8a5e6f3acf57928$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $e8a5e6f3acf57928$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    if ($e8a5e6f3acf57928$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else $e8a5e6f3acf57928$var$objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
$e8a5e6f3acf57928$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $e8a5e6f3acf57928$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if ($e8a5e6f3acf57928$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
        this[offset + 2] = value >>> 16;
        this[offset + 3] = value >>> 24;
    } else $e8a5e6f3acf57928$var$objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
$e8a5e6f3acf57928$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $e8a5e6f3acf57928$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    if ($e8a5e6f3acf57928$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else $e8a5e6f3acf57928$var$objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
function $e8a5e6f3acf57928$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $e8a5e6f3acf57928$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) $e8a5e6f3acf57928$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $98vqs.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$e8a5e6f3acf57928$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $e8a5e6f3acf57928$var$writeFloat(this, value, offset, true, noAssert);
};
$e8a5e6f3acf57928$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $e8a5e6f3acf57928$var$writeFloat(this, value, offset, false, noAssert);
};
function $e8a5e6f3acf57928$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) $e8a5e6f3acf57928$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $98vqs.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$e8a5e6f3acf57928$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $e8a5e6f3acf57928$var$writeDouble(this, value, offset, true, noAssert);
};
$e8a5e6f3acf57928$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $e8a5e6f3acf57928$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$e8a5e6f3acf57928$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("sourceStart out of bounds");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    var i;
    if (this === target && start < targetStart && targetStart < end) // descending copy from end
    for(i = len - 1; i >= 0; --i)target[i + targetStart] = this[i + start];
    else if (len < 1000 || !$e8a5e6f3acf57928$var$Buffer.TYPED_ARRAY_SUPPORT) // ascending copy from start
    for(i = 0; i < len; ++i)target[i + targetStart] = this[i + start];
    else Uint8Array.prototype.set.call(target, this.subarray(start, start + len), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$e8a5e6f3acf57928$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (code < 256) val = code;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$e8a5e6f3acf57928$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    } else if (typeof val === "number") val = val & 255;
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $e8a5e6f3acf57928$var$Buffer.isBuffer(val) ? val : $e8a5e6f3acf57928$var$utf8ToBytes(new $e8a5e6f3acf57928$var$Buffer(val, encoding).toString());
        var len = bytes.length;
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $e8a5e6f3acf57928$var$INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;
function $e8a5e6f3acf57928$var$base64clean(str) {
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = $e8a5e6f3acf57928$var$stringtrim(str).replace($e8a5e6f3acf57928$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $e8a5e6f3acf57928$var$stringtrim(str) {
    if (str.trim) return str.trim();
    return str.replace(/^\s+|\s+$/g, "");
}
function $e8a5e6f3acf57928$var$toHex(n) {
    if (n < 16) return "0" + n.toString(16);
    return n.toString(16);
}
function $e8a5e6f3acf57928$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $e8a5e6f3acf57928$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $e8a5e6f3acf57928$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $e8a5e6f3acf57928$var$base64ToBytes(str) {
    return $80sMt.toByteArray($e8a5e6f3acf57928$var$base64clean(str));
}
function $e8a5e6f3acf57928$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
function $e8a5e6f3acf57928$var$isnan(val) {
    return val !== val // eslint-disable-line no-self-compare
    ;
}

});
parcelRegister("9wf3N", function(module, exports) {
var $6ee2c8dc1ff7aeaa$var$toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return $6ee2c8dc1ff7aeaa$var$toString.call(arr) == "[object Array]";
};

});



parcelRegister("krsH1", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isEmptyData = void 0;
function $ee1c961a332d3c21$var$isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
module.exports.isEmptyData = $ee1c961a332d3c21$var$isEmptyData;

});

parcelRegister("colhh", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.numToUint8 = void 0;
function $90583b398da338be$var$numToUint8(num) {
    return new Uint8Array([
        (num & 0xff000000) >> 24,
        (num & 0x00ff0000) >> 16,
        (num & 0x0000ff00) >> 8,
        num & 0x000000ff
    ]);
}
module.exports.numToUint8 = $90583b398da338be$var$numToUint8;

});

parcelRegister("bM1wi", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.uint32ArrayFrom = void 0;
// IE 11 does not support Array.from, so we do it manually
function $89255b40618e5d37$var$uint32ArrayFrom(a_lookUpTable) {
    if (!Array.from) {
        var return_array = new Uint32Array(a_lookUpTable.length);
        var a_index = 0;
        while(a_index < a_lookUpTable.length)return_array[a_index] = a_lookUpTable[a_index];
        return return_array;
    }
    return Uint32Array.from(a_lookUpTable);
}
module.exports.uint32ArrayFrom = $89255b40618e5d37$var$uint32ArrayFrom;

});



parcelRegister("jextc", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $e00949930ae094d2$export$2e2bcd8739ae039);
function $e00949930ae094d2$export$2e2bcd8739ae039(e, n) {
    return n = n || {}, new Promise(function(t, r) {
        var s = new XMLHttpRequest, o = [], u = [], i = {}, a = function() {
            return {
                ok: 2 == (s.status / 100 | 0),
                statusText: s.statusText,
                status: s.status,
                url: s.responseURL,
                text: function() {
                    return Promise.resolve(s.responseText);
                },
                json: function() {
                    return Promise.resolve(s.responseText).then(JSON.parse);
                },
                blob: function() {
                    return Promise.resolve(new Blob([
                        s.response
                    ]));
                },
                clone: a,
                headers: {
                    keys: function() {
                        return o;
                    },
                    entries: function() {
                        return u;
                    },
                    get: function(e) {
                        return i[e.toLowerCase()];
                    },
                    has: function(e) {
                        return e.toLowerCase() in i;
                    }
                }
            };
        };
        for(var l in s.open(n.method || "get", e, !0), s.onload = function() {
            s.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, function(e, n, t) {
                o.push(n = n.toLowerCase()), u.push([
                    n,
                    t
                ]), i[n] = i[n] ? i[n] + "," + t : t;
            }), t(a());
        }, s.onerror = r, s.withCredentials = "include" == n.credentials, n.headers)s.setRequestHeader(l, n.headers[l]);
        s.send(n.body || null);
    });
}

});

parcelRegister("lQpid", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $fe7212ee73ce5285$export$2b8d127b894957b9, (v) => $fe7212ee73ce5285$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $fe7212ee73ce5285$export$cea3a54a6425200c, (v) => $fe7212ee73ce5285$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $fe7212ee73ce5285$export$a7c73072b1a182ae, (v) => $fe7212ee73ce5285$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $fe7212ee73ce5285$export$9f27bc3417b4524d, (v) => $fe7212ee73ce5285$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $fe7212ee73ce5285$export$db77ccec0bb4ccac, (v) => $fe7212ee73ce5285$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $fe7212ee73ce5285$export$8392c0c9d3dcbd35, (v) => $fe7212ee73ce5285$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $fe7212ee73ce5285$export$ffb0004e005737fa, (v) => $fe7212ee73ce5285$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $fe7212ee73ce5285$export$b624eff549462981, (v) => $fe7212ee73ce5285$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $fe7212ee73ce5285$export$7897aa7841a5380c, (v) => $fe7212ee73ce5285$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $fe7212ee73ce5285$export$602eac185826482c, (v) => $fe7212ee73ce5285$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $fe7212ee73ce5285$export$e2c29f18771995cb, (v) => $fe7212ee73ce5285$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $fe7212ee73ce5285$export$5f8d39834fd61797, (v) => $fe7212ee73ce5285$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $fe7212ee73ce5285$export$74bf444e3cd11ea5, (v) => $fe7212ee73ce5285$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $fe7212ee73ce5285$export$92387174baf9b227, (v) => $fe7212ee73ce5285$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $fe7212ee73ce5285$export$ec112efeb987d9c6, (v) => $fe7212ee73ce5285$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $fe7212ee73ce5285$export$b706b080d889d2c9, (v) => $fe7212ee73ce5285$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $fe7212ee73ce5285$export$5be5a87408f70ddc, (v) => $fe7212ee73ce5285$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $fe7212ee73ce5285$export$45a5e7f76e0caa8d, (v) => $fe7212ee73ce5285$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $fe7212ee73ce5285$export$455c2e768291efa6, (v) => $fe7212ee73ce5285$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $fe7212ee73ce5285$export$9522e17588c12572, (v) => $fe7212ee73ce5285$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $fe7212ee73ce5285$export$2110ac352bb060b9, (v) => $fe7212ee73ce5285$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $fe7212ee73ce5285$export$56885ab8b9c456ab, (v) => $fe7212ee73ce5285$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $fe7212ee73ce5285$export$d927fcb6adf8f9de, (v) => $fe7212ee73ce5285$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $fe7212ee73ce5285$export$b82d16f27459e05a, (v) => $fe7212ee73ce5285$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $fe7212ee73ce5285$export$522c17b4f5e123e8, (v) => $fe7212ee73ce5285$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $fe7212ee73ce5285$export$1aabd8a0274ecfd6, (v) => $fe7212ee73ce5285$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $fe7212ee73ce5285$export$9b621391a187a31a, (v) => $fe7212ee73ce5285$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $fe7212ee73ce5285$export$f5bbd400c2f4426f, (v) => $fe7212ee73ce5285$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $fe7212ee73ce5285$export$2b8d127b894957b9;
var $fe7212ee73ce5285$export$cea3a54a6425200c;
var $fe7212ee73ce5285$export$a7c73072b1a182ae;
var $fe7212ee73ce5285$export$9f27bc3417b4524d;
var $fe7212ee73ce5285$export$db77ccec0bb4ccac;
var $fe7212ee73ce5285$export$8392c0c9d3dcbd35;
var $fe7212ee73ce5285$export$ffb0004e005737fa;
var $fe7212ee73ce5285$export$b624eff549462981;
var $fe7212ee73ce5285$export$7897aa7841a5380c;
var $fe7212ee73ce5285$export$602eac185826482c;
var $fe7212ee73ce5285$export$e2c29f18771995cb;
var $fe7212ee73ce5285$export$5f8d39834fd61797;
var $fe7212ee73ce5285$export$74bf444e3cd11ea5;
var $fe7212ee73ce5285$export$92387174baf9b227;
var $fe7212ee73ce5285$export$ec112efeb987d9c6;
var $fe7212ee73ce5285$export$b706b080d889d2c9;
var $fe7212ee73ce5285$export$5be5a87408f70ddc;
var $fe7212ee73ce5285$export$45a5e7f76e0caa8d;
var $fe7212ee73ce5285$export$455c2e768291efa6;
var $fe7212ee73ce5285$export$9522e17588c12572;
var $fe7212ee73ce5285$export$2110ac352bb060b9;
var $fe7212ee73ce5285$export$56885ab8b9c456ab;
var $fe7212ee73ce5285$export$d927fcb6adf8f9de;
var $fe7212ee73ce5285$export$b82d16f27459e05a;
var $fe7212ee73ce5285$export$522c17b4f5e123e8;
var $fe7212ee73ce5285$export$1aabd8a0274ecfd6;
var $fe7212ee73ce5285$export$9b621391a187a31a;
var $fe7212ee73ce5285$export$f5bbd400c2f4426f;
"use strict";
var $fe7212ee73ce5285$var$b = "function" === typeof Symbol && Symbol.for, $fe7212ee73ce5285$var$c = $fe7212ee73ce5285$var$b ? Symbol.for("react.element") : 60103, $fe7212ee73ce5285$var$d = $fe7212ee73ce5285$var$b ? Symbol.for("react.portal") : 60106, $fe7212ee73ce5285$var$e = $fe7212ee73ce5285$var$b ? Symbol.for("react.fragment") : 60107, $fe7212ee73ce5285$var$f = $fe7212ee73ce5285$var$b ? Symbol.for("react.strict_mode") : 60108, $fe7212ee73ce5285$var$g = $fe7212ee73ce5285$var$b ? Symbol.for("react.profiler") : 60114, $fe7212ee73ce5285$var$h = $fe7212ee73ce5285$var$b ? Symbol.for("react.provider") : 60109, $fe7212ee73ce5285$var$k = $fe7212ee73ce5285$var$b ? Symbol.for("react.context") : 60110, $fe7212ee73ce5285$var$l = $fe7212ee73ce5285$var$b ? Symbol.for("react.async_mode") : 60111, $fe7212ee73ce5285$var$m = $fe7212ee73ce5285$var$b ? Symbol.for("react.concurrent_mode") : 60111, $fe7212ee73ce5285$var$n = $fe7212ee73ce5285$var$b ? Symbol.for("react.forward_ref") : 60112, $fe7212ee73ce5285$var$p = $fe7212ee73ce5285$var$b ? Symbol.for("react.suspense") : 60113, $fe7212ee73ce5285$var$q = $fe7212ee73ce5285$var$b ? Symbol.for("react.suspense_list") : 60120, $fe7212ee73ce5285$var$r = $fe7212ee73ce5285$var$b ? Symbol.for("react.memo") : 60115, $fe7212ee73ce5285$var$t = $fe7212ee73ce5285$var$b ? Symbol.for("react.lazy") : 60116, $fe7212ee73ce5285$var$v = $fe7212ee73ce5285$var$b ? Symbol.for("react.block") : 60121, $fe7212ee73ce5285$var$w = $fe7212ee73ce5285$var$b ? Symbol.for("react.fundamental") : 60117, $fe7212ee73ce5285$var$x = $fe7212ee73ce5285$var$b ? Symbol.for("react.responder") : 60118, $fe7212ee73ce5285$var$y = $fe7212ee73ce5285$var$b ? Symbol.for("react.scope") : 60119;
function $fe7212ee73ce5285$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $fe7212ee73ce5285$var$c:
                switch(a = a.type, a){
                    case $fe7212ee73ce5285$var$l:
                    case $fe7212ee73ce5285$var$m:
                    case $fe7212ee73ce5285$var$e:
                    case $fe7212ee73ce5285$var$g:
                    case $fe7212ee73ce5285$var$f:
                    case $fe7212ee73ce5285$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $fe7212ee73ce5285$var$k:
                            case $fe7212ee73ce5285$var$n:
                            case $fe7212ee73ce5285$var$t:
                            case $fe7212ee73ce5285$var$r:
                            case $fe7212ee73ce5285$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $fe7212ee73ce5285$var$d:
                return u;
        }
    }
}
function $fe7212ee73ce5285$var$A(a) {
    return $fe7212ee73ce5285$var$z(a) === $fe7212ee73ce5285$var$m;
}
$fe7212ee73ce5285$export$2b8d127b894957b9 = $fe7212ee73ce5285$var$l;
$fe7212ee73ce5285$export$cea3a54a6425200c = $fe7212ee73ce5285$var$m;
$fe7212ee73ce5285$export$a7c73072b1a182ae = $fe7212ee73ce5285$var$k;
$fe7212ee73ce5285$export$9f27bc3417b4524d = $fe7212ee73ce5285$var$h;
$fe7212ee73ce5285$export$db77ccec0bb4ccac = $fe7212ee73ce5285$var$c;
$fe7212ee73ce5285$export$8392c0c9d3dcbd35 = $fe7212ee73ce5285$var$n;
$fe7212ee73ce5285$export$ffb0004e005737fa = $fe7212ee73ce5285$var$e;
$fe7212ee73ce5285$export$b624eff549462981 = $fe7212ee73ce5285$var$t;
$fe7212ee73ce5285$export$7897aa7841a5380c = $fe7212ee73ce5285$var$r;
$fe7212ee73ce5285$export$602eac185826482c = $fe7212ee73ce5285$var$d;
$fe7212ee73ce5285$export$e2c29f18771995cb = $fe7212ee73ce5285$var$g;
$fe7212ee73ce5285$export$5f8d39834fd61797 = $fe7212ee73ce5285$var$f;
$fe7212ee73ce5285$export$74bf444e3cd11ea5 = $fe7212ee73ce5285$var$p;
$fe7212ee73ce5285$export$92387174baf9b227 = function(a) {
    return $fe7212ee73ce5285$var$A(a) || $fe7212ee73ce5285$var$z(a) === $fe7212ee73ce5285$var$l;
};
$fe7212ee73ce5285$export$ec112efeb987d9c6 = $fe7212ee73ce5285$var$A;
$fe7212ee73ce5285$export$b706b080d889d2c9 = function(a) {
    return $fe7212ee73ce5285$var$z(a) === $fe7212ee73ce5285$var$k;
};
$fe7212ee73ce5285$export$5be5a87408f70ddc = function(a) {
    return $fe7212ee73ce5285$var$z(a) === $fe7212ee73ce5285$var$h;
};
$fe7212ee73ce5285$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $fe7212ee73ce5285$var$c;
};
$fe7212ee73ce5285$export$455c2e768291efa6 = function(a) {
    return $fe7212ee73ce5285$var$z(a) === $fe7212ee73ce5285$var$n;
};
$fe7212ee73ce5285$export$9522e17588c12572 = function(a) {
    return $fe7212ee73ce5285$var$z(a) === $fe7212ee73ce5285$var$e;
};
$fe7212ee73ce5285$export$2110ac352bb060b9 = function(a) {
    return $fe7212ee73ce5285$var$z(a) === $fe7212ee73ce5285$var$t;
};
$fe7212ee73ce5285$export$56885ab8b9c456ab = function(a) {
    return $fe7212ee73ce5285$var$z(a) === $fe7212ee73ce5285$var$r;
};
$fe7212ee73ce5285$export$d927fcb6adf8f9de = function(a) {
    return $fe7212ee73ce5285$var$z(a) === $fe7212ee73ce5285$var$d;
};
$fe7212ee73ce5285$export$b82d16f27459e05a = function(a) {
    return $fe7212ee73ce5285$var$z(a) === $fe7212ee73ce5285$var$g;
};
$fe7212ee73ce5285$export$522c17b4f5e123e8 = function(a) {
    return $fe7212ee73ce5285$var$z(a) === $fe7212ee73ce5285$var$f;
};
$fe7212ee73ce5285$export$1aabd8a0274ecfd6 = function(a) {
    return $fe7212ee73ce5285$var$z(a) === $fe7212ee73ce5285$var$p;
};
$fe7212ee73ce5285$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $fe7212ee73ce5285$var$e || a === $fe7212ee73ce5285$var$m || a === $fe7212ee73ce5285$var$g || a === $fe7212ee73ce5285$var$f || a === $fe7212ee73ce5285$var$p || a === $fe7212ee73ce5285$var$q || "object" === typeof a && null !== a && (a.$$typeof === $fe7212ee73ce5285$var$t || a.$$typeof === $fe7212ee73ce5285$var$r || a.$$typeof === $fe7212ee73ce5285$var$h || a.$$typeof === $fe7212ee73ce5285$var$k || a.$$typeof === $fe7212ee73ce5285$var$n || a.$$typeof === $fe7212ee73ce5285$var$w || a.$$typeof === $fe7212ee73ce5285$var$x || a.$$typeof === $fe7212ee73ce5285$var$y || a.$$typeof === $fe7212ee73ce5285$var$v);
};
$fe7212ee73ce5285$export$f5bbd400c2f4426f = $fe7212ee73ce5285$var$z;

});

var $c0c9bc5c50648c54$exports = {};
"use strict";

$c0c9bc5c50648c54$exports = (parcelRequire("1tGIT"));


/** Internal global with common properties and Sentry extensions  */ // The code below for 'isGlobalObj' and 'GLOBAL_OBJ' was copied from core-js before modification
// https://github.com/zloirock/core-js/blob/1b944df55282cdc99c90db5f49eb0b6eda2cc0a3/packages/core-js/internals/global.js
// core-js has the following licence:
//
// Copyright (c) 2014-2022 Denis Pushkarev
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
/** Returns 'obj' if it's the global object, otherwise returns undefined */ function $42ab17974bcac25b$var$isGlobalObj(obj) {
    return obj && obj.Math == Math ? obj : undefined;
}
/** Get's the global object for the current JavaScript runtime */ const $42ab17974bcac25b$export$f1a6cdb1459e81d1 = typeof globalThis == "object" && $42ab17974bcac25b$var$isGlobalObj(globalThis) || // eslint-disable-next-line no-restricted-globals
typeof window == "object" && $42ab17974bcac25b$var$isGlobalObj(window) || typeof self == "object" && $42ab17974bcac25b$var$isGlobalObj(self) || typeof $parcel$global == "object" && $42ab17974bcac25b$var$isGlobalObj($parcel$global) || function() {
    return this;
}() || {};
/**
 * @deprecated Use GLOBAL_OBJ instead or WINDOW from @sentry/browser. This will be removed in v8
 */ function $42ab17974bcac25b$export$256479dc0cea61c4() {
    return $42ab17974bcac25b$export$f1a6cdb1459e81d1;
}
/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $42ab17974bcac25b$export$7e223ec222791509(name, creator, obj) {
    const gbl = obj || $42ab17974bcac25b$export$f1a6cdb1459e81d1;
    const __SENTRY__ = gbl.__SENTRY__ = gbl.__SENTRY__ || {};
    const singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}

// eslint-disable-next-line @typescript-eslint/unbound-method
const $9cb15bc4eaa635db$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9cb15bc4eaa635db$export$e6127cc7fe7395c3(wat) {
    switch($9cb15bc4eaa635db$var$objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
            return true;
        default:
            return $9cb15bc4eaa635db$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $9cb15bc4eaa635db$var$isBuiltin(wat, className) {
    return $9cb15bc4eaa635db$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9cb15bc4eaa635db$export$9f9636d330b71954(wat) {
    return $9cb15bc4eaa635db$var$isBuiltin(wat, "ErrorEvent");
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9cb15bc4eaa635db$export$ef9e2056653f0c8e(wat) {
    return $9cb15bc4eaa635db$var$isBuiltin(wat, "DOMError");
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9cb15bc4eaa635db$export$12e869b2a583f783(wat) {
    return $9cb15bc4eaa635db$var$isBuiltin(wat, "DOMException");
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9cb15bc4eaa635db$export$844ec244b1367d54(wat) {
    return $9cb15bc4eaa635db$var$isBuiltin(wat, "String");
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9cb15bc4eaa635db$export$dbcbffa59149b824(wat) {
    return typeof wat === "object" && wat !== null && "__sentry_template_string__" in wat && "__sentry_template_values__" in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9cb15bc4eaa635db$export$c3825b437cbdea5c(wat) {
    return wat === null || $9cb15bc4eaa635db$export$dbcbffa59149b824(wat) || typeof wat !== "object" && typeof wat !== "function";
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9cb15bc4eaa635db$export$53b83ca8eaab0383(wat) {
    return $9cb15bc4eaa635db$var$isBuiltin(wat, "Object");
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9cb15bc4eaa635db$export$9671ea99bd126ace(wat) {
    return typeof Event !== "undefined" && $9cb15bc4eaa635db$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9cb15bc4eaa635db$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== "undefined" && $9cb15bc4eaa635db$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9cb15bc4eaa635db$export$49841c62b9eff15(wat) {
    return $9cb15bc4eaa635db$var$isBuiltin(wat, "RegExp");
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $9cb15bc4eaa635db$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === "function");
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9cb15bc4eaa635db$export$bc2894c7158efbac(wat) {
    return $9cb15bc4eaa635db$export$53b83ca8eaab0383(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9cb15bc4eaa635db$export$c9f5652083b8129d(wat) {
    return typeof wat === "number" && wat !== wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $9cb15bc4eaa635db$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9cb15bc4eaa635db$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === "object" && wat !== null && (wat.__isVue || wat._isVue));
}

/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $4ec7df47aede9936$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;



/** Prefix for logging strings */ const $fa35a81632814438$var$PREFIX = "Sentry Logger ";
const $fa35a81632814438$export$2a2b1d2252a69ecb = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert",
    "trace"
];
/** This may be mutated by the console instrumentation. */ const $fa35a81632814438$export$77c4ce905194557b = {};
/** JSDoc */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $fa35a81632814438$export$cda52e2a8927a2ca(callback) {
    if (!("console" in (0, $42ab17974bcac25b$export$f1a6cdb1459e81d1))) return callback();
    const console = (0, $42ab17974bcac25b$export$f1a6cdb1459e81d1).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($fa35a81632814438$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $fa35a81632814438$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $fa35a81632814438$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        },
        isEnabled: ()=>enabled
    };
    if (0, $4ec7df47aede9936$export$16a28057038b10ef) $fa35a81632814438$export$2a2b1d2252a69ecb.forEach((name)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = (...args)=>{
            if (enabled) $fa35a81632814438$export$cda52e2a8927a2ca(()=>{
                (0, $42ab17974bcac25b$export$f1a6cdb1459e81d1).console[name](`${$fa35a81632814438$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $fa35a81632814438$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
const $fa35a81632814438$export$af88d00dbe7f521 = $fa35a81632814438$var$makeLogger();


const $5874e77f331c673b$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 *
 * TODO(v8): Return type should be rounded.
 */ function $5874e77f331c673b$export$7740643b9eeaf0c4() {
    return Date.now() / $5874e77f331c673b$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $5874e77f331c673b$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $42ab17974bcac25b$export$f1a6cdb1459e81d1);
    if (!performance || !performance.now) return $5874e77f331c673b$export$7740643b9eeaf0c4;
    // Some browser and environments don't have a timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    const approxStartingTimeOrigin = Date.now() - performance.now();
    const timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + performance.now()) / $5874e77f331c673b$var$ONE_SECOND_IN_MS;
    };
}
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const $5874e77f331c673b$export$ee52dced521e3e18 = $5874e77f331c673b$var$createUnixTimestampInSecondsFunc();
/**
 * Re-exported with an old name for backwards-compatibility.
 * TODO (v8): Remove this
 *
 * @deprecated Use `timestampInSeconds` instead.
 */ const $5874e77f331c673b$export$c5907b5a8838db13 = $5874e77f331c673b$export$ee52dced521e3e18;
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */ let $5874e77f331c673b$export$f9f8cce55af5194c;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ const $5874e77f331c673b$export$baf075a948ffc0bf = (()=>{
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance: performance } = (0, $42ab17974bcac25b$export$f1a6cdb1459e81d1);
    if (!performance || !performance.now) {
        $5874e77f331c673b$export$f9f8cce55af5194c = "none";
        return undefined;
    }
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing && performance.timing.navigationStart;
    const hasNavigationStart = typeof navigationStart === "number";
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            $5874e77f331c673b$export$f9f8cce55af5194c = "timeOrigin";
            return performance.timeOrigin;
        } else {
            $5874e77f331c673b$export$f9f8cce55af5194c = "navigationStart";
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    $5874e77f331c673b$export$f9f8cce55af5194c = "dateNow";
    return dateNow;
})();



// eslint-disable-next-line deprecation/deprecation
const $0d4e7eac897b5a5b$var$WINDOW = (0, $42ab17974bcac25b$export$256479dc0cea61c4)();
const $0d4e7eac897b5a5b$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $0d4e7eac897b5a5b$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return "<unknown>";
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $0d4e7eac897b5a5b$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $0d4e7eac897b5a5b$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return "<unknown>";
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $0d4e7eac897b5a5b$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    let className;
    let classes;
    let key;
    let attr;
    let i;
    if (!elem || !elem.tagName) return "";
    // @ts-expect-error WINDOW has HTMLElement
    if ($0d4e7eac897b5a5b$var$WINDOW.HTMLElement) {
        // If using the component name annotation plugin, this value may be available on the DOM node
        if (elem instanceof HTMLElement && elem.dataset && elem.dataset["sentryComponent"]) return elem.dataset["sentryComponent"];
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $9cb15bc4eaa635db$export$844ec244b1367d54)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push(`.${classes[i]}`);
        }
    }
    const allowedAttrs = [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push(`[${key}="${attr}"]`);
    }
    return out.join("");
}
/**
 * A safe form of location.href
 */ function $0d4e7eac897b5a5b$export$1cfafeee2987818b() {
    try {
        return $0d4e7eac897b5a5b$var$WINDOW.document.location.href;
    } catch (oO) {
        return "";
    }
}
/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existance of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $0d4e7eac897b5a5b$export$c660c1f3ab49225c(selector) {
    if ($0d4e7eac897b5a5b$var$WINDOW.document && $0d4e7eac897b5a5b$var$WINDOW.document.querySelector) return $0d4e7eac897b5a5b$var$WINDOW.document.querySelector(selector);
    return null;
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` attribute. This attribute is added at build-time
 * by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $0d4e7eac897b5a5b$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$0d4e7eac897b5a5b$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement && currentElem.dataset["sentryComponent"]) return currentElem.dataset["sentryComponent"];
        currentElem = currentElem.parentNode;
    }
    return null;
}






/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $6185c1fc30855c3e$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $6185c1fc30855c3e$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += " {snip}";
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $6185c1fc30855c3e$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return "";
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $9cb15bc4eaa635db$export$7916fad0ebc23f48)(value)) output.push("[VueViewModel]");
            else output.push(String(value));
        } catch (e) {
            output.push("[value cannot be serialized]");
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $6185c1fc30855c3e$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $9cb15bc4eaa635db$export$844ec244b1367d54)(value)) return false;
    if ((0, $9cb15bc4eaa635db$export$49841c62b9eff15)(pattern)) return pattern.test(value);
    if ((0, $9cb15bc4eaa635db$export$844ec244b1367d54)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $6185c1fc30855c3e$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$6185c1fc30855c3e$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}


/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $c617c17708158965$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === "function") $c617c17708158965$export$5c1499e2e5d010ae(wrapped, original);
    source[name] = wrapped;
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $c617c17708158965$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (0, $4ec7df47aede9936$export$16a28057038b10ef) && (0, $fa35a81632814438$export$af88d00dbe7f521).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $c617c17708158965$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $c617c17708158965$export$e73679ffaf56810e(wrapped, "__sentry_original__", original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ function $c617c17708158965$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */ function $c617c17708158965$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map((key)=>`${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`).join("&");
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */ function $c617c17708158965$export$62ff257738bf57f5(value) {
    if ((0, $9cb15bc4eaa635db$export$e6127cc7fe7395c3)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$c617c17708158965$var$getOwnProperties(value)
    };
    else if ((0, $9cb15bc4eaa635db$export$9671ea99bd126ace)(value)) {
        const newObj = {
            type: value.type,
            target: $c617c17708158965$var$serializeEventTarget(value.target),
            currentTarget: $c617c17708158965$var$serializeEventTarget(value.currentTarget),
            ...$c617c17708158965$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== "undefined" && (0, $9cb15bc4eaa635db$export$49034edbe6b62415)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $c617c17708158965$var$serializeEventTarget(target) {
    try {
        return (0, $9cb15bc4eaa635db$export$45a5e7f76e0caa8d)(target) ? (0, $0d4e7eac897b5a5b$export$5647df6b7814ac86)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return "<unknown>";
    }
}
/** Filters out all but an object's own properties */ function $c617c17708158965$var$getOwnProperties(obj) {
    if (typeof obj === "object" && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $c617c17708158965$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($c617c17708158965$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return "[object has no keys]";
    if (keys[0].length >= maxLength) return (0, $6185c1fc30855c3e$export$6a506b36fdea397d)(keys[0], maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(", ");
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $6185c1fc30855c3e$export$6a506b36fdea397d)(serialized, maxLength);
    }
    return "";
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */ function $c617c17708158965$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $c617c17708158965$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $c617c17708158965$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if ($c617c17708158965$var$isPojo(inputValue)) {
        // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = {};
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        for (const key of Object.keys(inputValue))if (typeof inputValue[key] !== "undefined") returnValue[key] = $c617c17708158965$var$_dropUndefinedKeys(inputValue[key], memoizationMap);
        return returnValue;
    }
    if (Array.isArray(inputValue)) {
        // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = [];
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((item)=>{
            returnValue.push($c617c17708158965$var$_dropUndefinedKeys(item, memoizationMap));
        });
        return returnValue;
    }
    return inputValue;
}
function $c617c17708158965$var$isPojo(input) {
    if (!(0, $9cb15bc4eaa635db$export$53b83ca8eaab0383)(input)) return false;
    try {
        const name = Object.getPrototypeOf(input).constructor.name;
        return !name || name === "Object";
    } catch (e) {
        return true;
    }
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $c617c17708158965$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === "symbol" || typeof wat === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $9cb15bc4eaa635db$export$c3825b437cbdea5c)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}




/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */ function $bc1dfbb58bc0f8fc$export$19f53698e68b2496() {
    const gbl = (0, $42ab17974bcac25b$export$f1a6cdb1459e81d1);
    const crypto = gbl.crypto || gbl.msCrypto;
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto && crypto.randomUUID) return crypto.randomUUID().replace(/-/g, "");
        if (crypto && crypto.getRandomValues) getRandomByte = ()=>{
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            const typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            return typedArray[0];
        };
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $bc1dfbb58bc0f8fc$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $bc1dfbb58bc0f8fc$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $bc1dfbb58bc0f8fc$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $bc1dfbb58bc0f8fc$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || "";
    if (!firstException.type) firstException.type = type || "Error";
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $bc1dfbb58bc0f8fc$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $bc1dfbb58bc0f8fc$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: "generic",
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && "data" in newMechanism) {
        const mergedData = {
            ...currentMechanism && currentMechanism.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $bc1dfbb58bc0f8fc$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ /**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $bc1dfbb58bc0f8fc$export$d364f2020ab30578(input) {
    const match = input.match($bc1dfbb58bc0f8fc$var$SEMVER_REGEXP) || [];
    const major = parseInt(match[1], 10);
    const minor = parseInt(match[2], 10);
    const patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $bc1dfbb58bc0f8fc$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $6185c1fc30855c3e$export$4215662d762d6f9d)(line, 0));
    frame.context_line = (0, $6185c1fc30855c3e$export$4215662d762d6f9d)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $6185c1fc30855c3e$export$4215662d762d6f9d)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $bc1dfbb58bc0f8fc$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $c617c17708158965$export$e73679ffaf56810e)(exception, "__sentry_captured__", true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */ function $bc1dfbb58bc0f8fc$export$3131421a7d01b4fb(maybeArray) {
    return Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];
}


const $cee0c22ffcacfc8b$export$849dbeeeda01ae98 = "production";


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $217bdd4a17a6f5aa$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;







/* eslint-disable @typescript-eslint/explicit-function-return-type */ /** SyncPromise internal states */ var $8285c2d2e65b1e62$var$States;
(function(States) {
    /** Pending */ const PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ const RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ const REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})($8285c2d2e65b1e62$var$States || ($8285c2d2e65b1e62$var$States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $8285c2d2e65b1e62$export$1fda8aa4d135f8aa(value) {
    return new $8285c2d2e65b1e62$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $8285c2d2e65b1e62$export$78e43115b553f358(reason) {
    return new $8285c2d2e65b1e62$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $8285c2d2e65b1e62$export$6f292d4960313241 {
    constructor(executor){
        $8285c2d2e65b1e62$export$6f292d4960313241.prototype.__init.call(this);
        $8285c2d2e65b1e62$export$6f292d4960313241.prototype.__init2.call(this);
        $8285c2d2e65b1e62$export$6f292d4960313241.prototype.__init3.call(this);
        $8285c2d2e65b1e62$export$6f292d4960313241.prototype.__init4.call(this);
        this._state = $8285c2d2e65b1e62$var$States.PENDING;
        this._handlers = [];
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ then(onfulfilled, onrejected) {
        return new $8285c2d2e65b1e62$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** JSDoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** JSDoc */ finally(onfinally) {
        return new $8285c2d2e65b1e62$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** JSDoc */ __init() {
        this._resolve = (value)=>{
            this._setResult($8285c2d2e65b1e62$var$States.RESOLVED, value);
        };
    }
    /** JSDoc */ __init2() {
        this._reject = (reason)=>{
            this._setResult($8285c2d2e65b1e62$var$States.REJECTED, reason);
        };
    }
    /** JSDoc */ __init3() {
        this._setResult = (state, value)=>{
            if (this._state !== $8285c2d2e65b1e62$var$States.PENDING) return;
            if ((0, $9cb15bc4eaa635db$export$f5b060c2914b97c8)(value)) {
                value.then(this._resolve, this._reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
    }
    /** JSDoc */ __init4() {
        this._executeHandlers = ()=>{
            if (this._state === $8285c2d2e65b1e62$var$States.PENDING) return;
            const cachedHandlers = this._handlers.slice();
            this._handlers = [];
            cachedHandlers.forEach((handler)=>{
                if (handler[0]) return;
                if (this._state === $8285c2d2e65b1e62$var$States.RESOLVED) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](this._value);
                if (this._state === $8285c2d2e65b1e62$var$States.REJECTED) handler[2](this._value);
                handler[0] = true;
            });
        };
    }
}



/**
 * Returns the global event processors.
 * @deprecated Global event processors will be removed in v8.
 */ function $aebca1a2794783df$export$3c4238858b85e8ac() {
    return (0, $42ab17974bcac25b$export$7e223ec222791509)("globalEventProcessors", ()=>[]);
}
/**
 * Add a EventProcessor to be kept globally.
 * @deprecated Use `addEventProcessor` instead. Global event processors will be removed in v8.
 */ function $aebca1a2794783df$export$8e4e25f54d456511(callback) {
    // eslint-disable-next-line deprecation/deprecation
    $aebca1a2794783df$export$3c4238858b85e8ac().push(callback);
}
/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $aebca1a2794783df$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    return new (0, $8285c2d2e65b1e62$export$6f292d4960313241)((resolve, reject)=>{
        const processor = processors[index];
        if (event === null || typeof processor !== "function") resolve(event);
        else {
            const result = processor({
                ...event
            }, hint);
            (0, $217bdd4a17a6f5aa$export$16a28057038b10ef) && processor.id && result === null && (0, $fa35a81632814438$export$af88d00dbe7f521).log(`Event processor "${processor.id}" dropped event`);
            if ((0, $9cb15bc4eaa635db$export$f5b060c2914b97c8)(result)) result.then((final)=>$aebca1a2794783df$export$bf2a096c3e883e79(processors, final, hint, index + 1).then(resolve)).then(null, reject);
            else $aebca1a2794783df$export$bf2a096c3e883e79(processors, result, hint, index + 1).then(resolve).then(null, reject);
        }
    });
}



/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $0ddb591981a9106e$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $5874e77f331c673b$export$ee52dced521e3e18)();
    const session = {
        sid: (0, $bc1dfbb58bc0f8fc$export$19f53698e68b2496)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: "ok",
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$0ddb591981a9106e$var$sessionToJSON(session)
    };
    if (context) $0ddb591981a9106e$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $0ddb591981a9106e$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $5874e77f331c673b$export$ee52dced521e3e18)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $bc1dfbb58bc0f8fc$export$19f53698e68b2496)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === "number") session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === "number") session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === "number") session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $0ddb591981a9106e$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === "ok") context = {
        status: "exited"
    };
    $0ddb591981a9106e$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $0ddb591981a9106e$var$sessionToJSON(session) {
    return (0, $c617c17708158965$export$d25f2688db1bb433)({
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === "number" || typeof session.did === "string" ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    });
}






/**
 * Returns the root span of a given span.
 *
 * As long as we use `Transaction`s internally, the returned root span
 * will be a `Transaction` but be aware that this might change in the future.
 *
 * If the given span has no root span or transaction, `undefined` is returned.
 */ function $e2489ea8d472724b$export$c4c6a79b1260ca1b(span) {
    // TODO (v8): Remove this check and just return span
    // eslint-disable-next-line deprecation/deprecation
    return span.transaction;
}





const $60da58af4abc2207$export$9ca9946bd449ac06 = "baggage";
const $60da58af4abc2207$export$6e69537d67fa20f = "sentry-";
const $60da58af4abc2207$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $60da58af4abc2207$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $60da58af4abc2207$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    if (!(0, $9cb15bc4eaa635db$export$844ec244b1367d54)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    // Intermediary object to store baggage key value pairs of incoming baggage headers on.
    // It is later used to read Sentry-DSC-values from.
    let baggageObject = {};
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    baggageObject = baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $60da58af4abc2207$var$baggageHeaderToObject(curr);
        for (const key of Object.keys(currBaggageObject))acc[key] = currBaggageObject[key];
        return acc;
    }, {});
    else {
        // Return undefined if baggage header is an empty string (technically an empty baggage header is not spec conform but
        // this is how we choose to handle it)
        if (!baggageHeader) return undefined;
        baggageObject = $60da58af4abc2207$var$baggageHeaderToObject(baggageHeader);
    }
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($60da58af4abc2207$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($60da58af4abc2207$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $60da58af4abc2207$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$60da58af4abc2207$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $60da58af4abc2207$var$objectToBaggageHeader(sentryPrefixedDSC);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $60da58af4abc2207$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(",").map((baggageEntry)=>baggageEntry.split("=").map((keyOrValue)=>decodeURIComponent(keyOrValue.trim()))).reduce((acc, [key, value])=>{
        acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $60da58af4abc2207$var$objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $60da58af4abc2207$export$bdd844ddb2def819) {
            (0, $4ec7df47aede9936$export$16a28057038b10ef) && (0, $fa35a81632814438$export$af88d00dbe7f521).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, "");
}



// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const $e18f1ded1435d0eb$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $e18f1ded1435d0eb$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($e18f1ded1435d0eb$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === "1") parentSampled = true;
    else if (matches[3] === "0") parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create tracing context from incoming headers.
 *
 * @deprecated Use `propagationContextFromHeaders` instead.
 */ // TODO(v8): Remove this function
function $e18f1ded1435d0eb$export$ca5c066532785b6e(sentryTrace, baggage) {
    const traceparentData = $e18f1ded1435d0eb$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $60da58af4abc2207$export$5b96ee2c8421f107)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceparentData: traceparentData,
        dynamicSamplingContext: undefined,
        propagationContext: {
            traceId: traceId || (0, $bc1dfbb58bc0f8fc$export$19f53698e68b2496)(),
            spanId: (0, $bc1dfbb58bc0f8fc$export$19f53698e68b2496)().substring(16)
        }
    };
    else return {
        traceparentData: traceparentData,
        dynamicSamplingContext: dynamicSamplingContext || {},
        propagationContext: {
            traceId: traceId || (0, $bc1dfbb58bc0f8fc$export$19f53698e68b2496)(),
            parentSpanId: parentSpanId || (0, $bc1dfbb58bc0f8fc$export$19f53698e68b2496)().substring(16),
            spanId: (0, $bc1dfbb58bc0f8fc$export$19f53698e68b2496)().substring(16),
            sampled: parentSampled,
            dsc: dynamicSamplingContext || {}
        }
    };
}
/**
 * Create a propagation context from incoming headers.
 */ function $e18f1ded1435d0eb$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $e18f1ded1435d0eb$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $60da58af4abc2207$export$5b96ee2c8421f107)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceId: traceId || (0, $bc1dfbb58bc0f8fc$export$19f53698e68b2496)(),
        spanId: (0, $bc1dfbb58bc0f8fc$export$19f53698e68b2496)().substring(16)
    };
    else return {
        traceId: traceId || (0, $bc1dfbb58bc0f8fc$export$19f53698e68b2496)(),
        parentSpanId: parentSpanId || (0, $bc1dfbb58bc0f8fc$export$19f53698e68b2496)().substring(16),
        spanId: (0, $bc1dfbb58bc0f8fc$export$19f53698e68b2496)().substring(16),
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {}
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $e18f1ded1435d0eb$export$f35d907436da45cf(traceId = (0, $bc1dfbb58bc0f8fc$export$19f53698e68b2496)(), spanId = (0, $bc1dfbb58bc0f8fc$export$19f53698e68b2496)().substring(16), sampled) {
    let sampledString = "";
    if (sampled !== undefined) sampledString = sampled ? "-1" : "-0";
    return `${traceId}-${spanId}${sampledString}`;
}


// These are aligned with OpenTelemetry trace flags
const $af551fb4a4d89418$export$208d5b368507fb8b = 0x0;
const $af551fb4a4d89418$export$eb571cd9b5d98de8 = 0x1;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 */ function $af551fb4a4d89418$export$46c6fbd1d265ebf0(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, tags: tags, origin: origin } = $af551fb4a4d89418$export$92d8c23565496537(span);
    return (0, $c617c17708158965$export$d25f2688db1bb433)({
        data: data,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id,
        status: status,
        tags: tags,
        trace_id: trace_id,
        origin: origin
    });
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $af551fb4a4d89418$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $af551fb4a4d89418$export$5caecac1caaf3a71(span);
    return (0, $e18f1ded1435d0eb$export$f35d907436da45cf)(traceId, spanId, sampled);
}
/**
 * Convert a span time input intp a timestamp in seconds.
 */ function $af551fb4a4d89418$export$3f7581298f56c6d7(input) {
    if (typeof input === "number") return $af551fb4a4d89418$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $af551fb4a4d89418$var$ensureTimestampInSeconds(input.getTime());
    return (0, $5874e77f331c673b$export$ee52dced521e3e18)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $af551fb4a4d89418$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 * Note that all fields returned here are optional and need to be guarded against.
 *
 * Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
 * This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
 * And `spanToJSON` needs the Span class from `span.ts` to check here.
 * TODO v8: When we remove the deprecated stuff from `span.ts`, we can remove the circular dependency again.
 */ function $af551fb4a4d89418$export$92d8c23565496537(span) {
    if ($af551fb4a4d89418$var$spanIsSpanClass(span)) return span.getSpanJSON();
    // Fallback: We also check for `.toJSON()` here...
    // eslint-disable-next-line deprecation/deprecation
    if (typeof span.toJSON === "function") // eslint-disable-next-line deprecation/deprecation
    return span.toJSON();
    return {};
}
/**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $af551fb4a4d89418$var$spanIsSpanClass(span) {
    return typeof span.getSpanJSON === "function";
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $af551fb4a4d89418$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    // eslint-disable-next-line no-bitwise
    return Boolean(traceFlags & $af551fb4a4d89418$export$eb571cd9b5d98de8);
}


/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $6b0cfeb393c5569e$export$366bad00d6815eed(trace_id, client, scope) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    // TODO(v8): Remove segment from User
    // eslint-disable-next-line deprecation/deprecation
    const { segment: user_segment } = scope && scope.getUser() || {};
    const dsc = (0, $c617c17708158965$export$d25f2688db1bb433)({
        environment: options.environment || (0, $cee0c22ffcacfc8b$export$849dbeeeda01ae98),
        release: options.release,
        user_segment: user_segment,
        public_key: public_key,
        trace_id: trace_id
    });
    client.emit && client.emit("createDsc", dsc);
    return dsc;
}
/**
 * A Span with a frozen dynamic sampling context.
 */ /**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $6b0cfeb393c5569e$export$a117f995597e25df(span) {
    const client = (0, $3bf2cc17570e59fe$export$6bb76d6eba7e258c)();
    if (!client) return {};
    // passing emit=false here to only emit later once the DSC is actually populated
    const dsc = $6b0cfeb393c5569e$export$366bad00d6815eed((0, $af551fb4a4d89418$export$92d8c23565496537)(span).trace_id || "", client, (0, $3bf2cc17570e59fe$export$c7be4b0125a10cba)());
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    const txn = (0, $e2489ea8d472724b$export$c4c6a79b1260ca1b)(span);
    if (!txn) return dsc;
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    // For now we need to avoid breaking users who directly created a txn with a DSC, where this field is still set.
    // @see Transaction class constructor
    const v7FrozenDsc = txn && txn._frozenDynamicSamplingContext;
    if (v7FrozenDsc) return v7FrozenDsc;
    // TODO (v8): Replace txn.metadata with txn.attributes[]
    // We can't do this yet because attributes aren't always set yet.
    // eslint-disable-next-line deprecation/deprecation
    const { sampleRate: maybeSampleRate, source: source } = txn.metadata;
    if (maybeSampleRate != null) dsc.sample_rate = `${maybeSampleRate}`;
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const jsonSpan = (0, $af551fb4a4d89418$export$92d8c23565496537)(txn);
    // after JSON conversion, txn.name becomes jsonSpan.description
    if (source && source !== "url") dsc.transaction = jsonSpan.description;
    dsc.sampled = String((0, $af551fb4a4d89418$export$5caecac1caaf3a71)(txn));
    client.emit && client.emit("createDsc", dsc);
    return dsc;
}




/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function $ce9cd16e295abe53$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    // Apply general data
    $ce9cd16e295abe53$var$applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) $ce9cd16e295abe53$var$applySpanToEvent(event, span);
    $ce9cd16e295abe53$var$applyFingerprintToEvent(event, fingerprint);
    $ce9cd16e295abe53$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $ce9cd16e295abe53$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function $ce9cd16e295abe53$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: // eslint-disable-next-line deprecation/deprecation
    transactionName, span: span } = mergeData;
    $ce9cd16e295abe53$export$b1a120a2871faa46(data, "extra", extra);
    $ce9cd16e295abe53$export$b1a120a2871faa46(data, "tags", tags);
    $ce9cd16e295abe53$export$b1a120a2871faa46(data, "user", user);
    $ce9cd16e295abe53$export$b1a120a2871faa46(data, "contexts", contexts);
    $ce9cd16e295abe53$export$b1a120a2871faa46(data, "sdkProcessingMetadata", sdkProcessingMetadata);
    if (level) data.level = level;
    if (transactionName) // eslint-disable-next-line deprecation/deprecation
    data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function $ce9cd16e295abe53$export$b1a120a2871faa46(data, prop, mergeVal) {
    if (mergeVal && Object.keys(mergeVal).length) {
        // Clone object
        data[prop] = {
            ...data[prop]
        };
        for(const key in mergeVal)if (Object.prototype.hasOwnProperty.call(mergeVal, key)) data[prop][key] = mergeVal[key];
    }
}
function $ce9cd16e295abe53$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: // eslint-disable-next-line deprecation/deprecation
    transactionName } = data;
    const cleanedExtra = (0, $c617c17708158965$export$d25f2688db1bb433)(extra);
    if (cleanedExtra && Object.keys(cleanedExtra).length) event.extra = {
        ...cleanedExtra,
        ...event.extra
    };
    const cleanedTags = (0, $c617c17708158965$export$d25f2688db1bb433)(tags);
    if (cleanedTags && Object.keys(cleanedTags).length) event.tags = {
        ...cleanedTags,
        ...event.tags
    };
    const cleanedUser = (0, $c617c17708158965$export$d25f2688db1bb433)(user);
    if (cleanedUser && Object.keys(cleanedUser).length) event.user = {
        ...cleanedUser,
        ...event.user
    };
    const cleanedContexts = (0, $c617c17708158965$export$d25f2688db1bb433)(contexts);
    if (cleanedContexts && Object.keys(cleanedContexts).length) event.contexts = {
        ...cleanedContexts,
        ...event.contexts
    };
    if (level) event.level = level;
    if (transactionName) event.transaction = transactionName;
}
function $ce9cd16e295abe53$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function $ce9cd16e295abe53$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $ce9cd16e295abe53$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: (0, $af551fb4a4d89418$export$46c6fbd1d265ebf0)(span),
        ...event.contexts
    };
    const rootSpan = (0, $e2489ea8d472724b$export$c4c6a79b1260ca1b)(span);
    if (rootSpan) {
        event.sdkProcessingMetadata = {
            dynamicSamplingContext: (0, $6b0cfeb393c5569e$export$a117f995597e25df)(span),
            ...event.sdkProcessingMetadata
        };
        const transactionName = (0, $af551fb4a4d89418$export$92d8c23565496537)(rootSpan).description;
        if (transactionName) event.tags = {
            transaction: transactionName,
            ...event.tags
        };
    }
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function $ce9cd16e295abe53$var$applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? (0, $bc1dfbb58bc0f8fc$export$3131421a7d01b4fb)(event.fingerprint) : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
}


/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $d0c210911ed87beb$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * The global scope is kept in this module.
 * When accessing this via `getGlobalScope()` we'll make sure to set one if none is currently present.
 */ let $d0c210911ed87beb$var$globalScope;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */ class $d0c210911ed87beb$export$775b6bb06e53a214 {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called after {@link applyToEvent}. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ // eslint-disable-next-line deprecation/deprecation
    /**
   * Transaction Name
   */ /** Span */ /** Session */ /** Request Mode Session Status */ /** The client on this scope */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = $d0c210911ed87beb$var$generatePropagationContext();
    }
    /**
   * Inherit values from the parent scope.
   * @deprecated Use `scope.clone()` and `new Scope()` instead.
   */ static clone(scope) {
        return scope ? scope.clone() : new $d0c210911ed87beb$export$775b6bb06e53a214();
    }
    /**
   * Clone this scope instance.
   */ clone() {
        const newScope = new $d0c210911ed87beb$export$775b6bb06e53a214();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._span = this._span;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._requestSession = this._requestSession;
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        return newScope;
    }
    /** Update the client on the scope. */ setClient(client) {
        this._client = client;
    }
    /**
   * Get the client assigned to this scope.
   *
   * It is generally recommended to use the global function `Sentry.getClient()` instead, unless you know what you are doing.
   */ getClient() {
        return this._client;
    }
    /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * @inheritDoc
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * @inheritDoc
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            segment: undefined,
            username: undefined
        };
        if (this._session) (0, $0ddb591981a9106e$export$531818e825e774db)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getUser() {
        return this._user;
    }
    /**
   * @inheritDoc
   */ getRequestSession() {
        return this._requestSession;
    }
    /**
   * @inheritDoc
   */ setRequestSession(requestSession) {
        this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setLevel(// eslint-disable-next-line deprecation/deprecation
    level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope for future events.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the Span on the scope.
   * @param span Span
   * @deprecated Instead of setting a span on a scope, use `startSpan()`/`startSpanManual()` instead.
   */ setSpan(span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Returns the `Span` if there is one.
   * @deprecated Use `getActiveSpan()` instead.
   */ getSpan() {
        return this._span;
    }
    /**
   * Returns the `Transaction` attached to the scope (if there is one).
   * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
   */ getTransaction() {
        // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
        // have a pointer to the currently-active transaction.
        const span = this._span;
        // Cannot replace with getRootSpan because getRootSpan returns a span, not a transaction
        // Also, this method will be removed anyway.
        // eslint-disable-next-line deprecation/deprecation
        return span && span.transaction;
    }
    /**
   * @inheritDoc
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getSession() {
        return this._session;
    }
    /**
   * @inheritDoc
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === "function" ? captureContext(this) : captureContext;
        if (scopeToMerge instanceof $d0c210911ed87beb$export$775b6bb06e53a214) {
            const scopeData = scopeToMerge.getScopeData();
            this._tags = {
                ...this._tags,
                ...scopeData.tags
            };
            this._extra = {
                ...this._extra,
                ...scopeData.extra
            };
            this._contexts = {
                ...this._contexts,
                ...scopeData.contexts
            };
            if (scopeData.user && Object.keys(scopeData.user).length) this._user = scopeData.user;
            if (scopeData.level) this._level = scopeData.level;
            if (scopeData.fingerprint.length) this._fingerprint = scopeData.fingerprint;
            if (scopeToMerge.getRequestSession()) this._requestSession = scopeToMerge.getRequestSession();
            if (scopeData.propagationContext) this._propagationContext = scopeData.propagationContext;
        } else if ((0, $9cb15bc4eaa635db$export$53b83ca8eaab0383)(scopeToMerge)) {
            const scopeContext = captureContext;
            this._tags = {
                ...this._tags,
                ...scopeContext.tags
            };
            this._extra = {
                ...this._extra,
                ...scopeContext.extra
            };
            this._contexts = {
                ...this._contexts,
                ...scopeContext.contexts
            };
            if (scopeContext.user) this._user = scopeContext.user;
            if (scopeContext.level) this._level = scopeContext.level;
            if (scopeContext.fingerprint) this._fingerprint = scopeContext.fingerprint;
            if (scopeContext.requestSession) this._requestSession = scopeContext.requestSession;
            if (scopeContext.propagationContext) this._propagationContext = scopeContext.propagationContext;
        }
        return this;
    }
    /**
   * @inheritDoc
   */ clear() {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        this._attachments = [];
        this._propagationContext = $d0c210911ed87beb$var$generatePropagationContext();
        return this;
    }
    /**
   * @inheritDoc
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === "number" ? maxBreadcrumbs : $d0c210911ed87beb$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $5874e77f331c673b$export$7740643b9eeaf0c4)(),
            ...breadcrumb
        };
        const breadcrumbs = this._breadcrumbs;
        breadcrumbs.push(mergedBreadcrumb);
        this._breadcrumbs = breadcrumbs.length > maxCrumbs ? breadcrumbs.slice(-maxCrumbs) : breadcrumbs;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * @inheritDoc
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * @inheritDoc
   * @deprecated Use `getScopeData()` instead.
   */ getAttachments() {
        const data = this.getScopeData();
        return data.attachments;
    }
    /**
   * @inheritDoc
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /** @inheritDoc */ getScopeData() {
        const { _breadcrumbs: _breadcrumbs, _attachments: _attachments, _contexts: _contexts, _tags: _tags, _extra: _extra, _user: _user, _level: _level, _fingerprint: _fingerprint, _eventProcessors: _eventProcessors, _propagationContext: _propagationContext, _sdkProcessingMetadata: _sdkProcessingMetadata, _transactionName: _transactionName, _span: _span } = this;
        return {
            breadcrumbs: _breadcrumbs,
            attachments: _attachments,
            contexts: _contexts,
            tags: _tags,
            extra: _extra,
            user: _user,
            level: _level,
            fingerprint: _fingerprint || [],
            eventProcessors: _eventProcessors,
            propagationContext: _propagationContext,
            sdkProcessingMetadata: _sdkProcessingMetadata,
            transactionName: _transactionName,
            span: _span
        };
    }
    /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   * @deprecated Use `applyScopeDataToEvent()` directly
   */ applyToEvent(event, hint = {}, additionalEventProcessors = []) {
        (0, $ce9cd16e295abe53$export$43988bc651a80216)(event, this.getScopeData());
        // TODO (v8): Update this order to be: Global > Client > Scope
        const eventProcessors = [
            ...additionalEventProcessors,
            // eslint-disable-next-line deprecation/deprecation
            ...(0, $aebca1a2794783df$export$3c4238858b85e8ac)(),
            ...this._eventProcessors
        ];
        return (0, $aebca1a2794783df$export$bf2a096c3e883e79)(eventProcessors, event, hint);
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata,
            ...newData
        };
        return this;
    }
    /**
   * @inheritDoc
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * @inheritDoc
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @param exception The exception to capture.
   * @param hint Optinal additional data to attach to the Sentry event.
   * @returns the id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $bc1dfbb58bc0f8fc$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $fa35a81632814438$export$af88d00dbe7f521).warn("No client configured on scope - will not capture exception!");
            return eventId;
        }
        const syntheticException = new Error("Sentry syntheticException");
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @param message The message to capture.
   * @param level An optional severity level to report the message with.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $bc1dfbb58bc0f8fc$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $fa35a81632814438$export$af88d00dbe7f521).warn("No client configured on scope - will not capture message!");
            return eventId;
        }
        const syntheticException = new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Captures a manually created event for this scope and sends it to Sentry.
   *
   * @param exception The event to capture.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $bc1dfbb58bc0f8fc$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $fa35a81632814438$export$af88d00dbe7f521).warn("No client configured on scope - will not capture event!");
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $d0c210911ed87beb$export$aa55d5ab8e05984f() {
    if (!$d0c210911ed87beb$var$globalScope) $d0c210911ed87beb$var$globalScope = new $d0c210911ed87beb$export$775b6bb06e53a214();
    return $d0c210911ed87beb$var$globalScope;
}
/**
 * This is mainly needed for tests.
 * DO NOT USE this, as this is an internal API and subject to change.
 * @hidden
 */ function $d0c210911ed87beb$export$c83048efd17527d6(scope) {
    $d0c210911ed87beb$var$globalScope = scope;
}
function $d0c210911ed87beb$var$generatePropagationContext() {
    return {
        traceId: (0, $bc1dfbb58bc0f8fc$export$19f53698e68b2496)(),
        spanId: (0, $bc1dfbb58bc0f8fc$export$19f53698e68b2496)().substring(16)
    };
}



const $38444694bf1ffa62$export$31499a9cd224b78c = "7.108.0";


/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */ const $be307700159f7758$export$24a86ef7798177e4 = parseFloat((0, $38444694bf1ffa62$export$31499a9cd224b78c));
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $be307700159f7758$var$DEFAULT_BREADCRUMBS = 100;
/**
 * @inheritDoc
 */ class $be307700159f7758$export$8c41bb232f1008b1 {
    /** Is a {@link Layer}[] containing the client and scope */ /** Contains the last event id of a captured event.  */ /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   *
   * @deprecated Instantiation of Hub objects is deprecated and the constructor will be removed in version 8 of the SDK.
   *
   * If you are currently using the Hub for multi-client use like so:
   *
   * ```
   * // OLD
   * const hub = new Hub();
   * hub.bindClient(client);
   * makeMain(hub)
   * ```
   *
   * instead initialize the client as follows:
   *
   * ```
   * // NEW
   * Sentry.withIsolationScope(() => {
   *    Sentry.setCurrentClient(client);
   *    client.init();
   * });
   * ```
   *
   * If you are using the Hub to capture events like so:
   *
   * ```
   * // OLD
   * const client = new Client();
   * const hub = new Hub(client);
   * hub.captureException()
   * ```
   *
   * instead capture isolated events as follows:
   *
   * ```
   * // NEW
   * const client = new Client();
   * const scope = new Scope();
   * scope.setClient(client);
   * scope.captureException();
   * ```
   */ constructor(client, scope, isolationScope, _version = $be307700159f7758$export$24a86ef7798177e4){
        this._version = _version;
        let assignedScope;
        if (!scope) {
            assignedScope = new (0, $d0c210911ed87beb$export$775b6bb06e53a214)();
            assignedScope.setClient(client);
        } else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) {
            assignedIsolationScope = new (0, $d0c210911ed87beb$export$775b6bb06e53a214)();
            assignedIsolationScope.setClient(client);
        } else assignedIsolationScope = isolationScope;
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        if (client) // eslint-disable-next-line deprecation/deprecation
        this.bindClient(client);
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Checks if this hub's version is older than the given version.
   *
   * @param version A version number to compare to.
   * @return True if the given version is newer; otherwise false.
   *
   * @deprecated This will be removed in v8.
   */ isOlderThan(version) {
        return this._version < version;
    }
    /**
   * This binds the given client to the current scope.
   * @param client An SDK client (client) instance.
   *
   * @deprecated Use `initAndBind()` directly, or `setCurrentClient()` and/or `client.init()` instead.
   */ bindClient(client) {
        // eslint-disable-next-line deprecation/deprecation
        const top = this.getStackTop();
        top.client = client;
        top.scope.setClient(client);
        // eslint-disable-next-line deprecation/deprecation
        if (client && client.setupIntegrations) // eslint-disable-next-line deprecation/deprecation
        client.setupIntegrations();
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ pushScope() {
        // We want to clone the content of prev scope
        // eslint-disable-next-line deprecation/deprecation
        const scope = this.getScope().clone();
        // eslint-disable-next-line deprecation/deprecation
        this.getStack().push({
            // eslint-disable-next-line deprecation/deprecation
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ popScope() {
        // eslint-disable-next-line deprecation/deprecation
        if (this.getStack().length <= 1) return false;
        // eslint-disable-next-line deprecation/deprecation
        return !!this.getStack().pop();
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.withScope()` instead.
   */ withScope(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const scope = this.pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            throw e;
        }
        if ((0, $9cb15bc4eaa635db$export$f5b060c2914b97c8)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then((res)=>{
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            return res;
        }, (e)=>{
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            throw e;
        });
        // eslint-disable-next-line deprecation/deprecation
        this.popScope();
        return maybePromiseResult;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.getClient()` instead.
   */ getClient() {
        // eslint-disable-next-line deprecation/deprecation
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   *
   * @deprecated Use `Sentry.getCurrentScope()` instead.
   */ getScope() {
        // eslint-disable-next-line deprecation/deprecation
        return this.getStackTop().scope;
    }
    /**
   * @deprecated Use `Sentry.getIsolationScope()` instead.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the scope stack for domains or the process.
   * @deprecated This will be removed in v8.
   */ getStack() {
        return this._stack;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   * @deprecated This will be removed in v8.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureException()` instead.
   */ captureException(exception, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $bc1dfbb58bc0f8fc$export$19f53698e68b2496)();
        const syntheticException = new Error("Sentry syntheticException");
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use  `Sentry.captureMessage()` instead.
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $bc1dfbb58bc0f8fc$export$19f53698e68b2496)();
        const syntheticException = new Error(message);
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureEvent()` instead.
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $bc1dfbb58bc0f8fc$export$19f53698e68b2496)();
        if (!event.type) this._lastEventId = eventId;
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureEvent(event, {
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated This will be removed in v8.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.addBreadcrumb()` instead.
   */ addBreadcrumb(breadcrumb, hint) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        if (!client) return;
        const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $be307700159f7758$var$DEFAULT_BREADCRUMBS } = client.getOptions && client.getOptions() || {};
        if (maxBreadcrumbs <= 0) return;
        const timestamp = (0, $5874e77f331c673b$export$7740643b9eeaf0c4)();
        const mergedBreadcrumb = {
            timestamp: timestamp,
            ...breadcrumb
        };
        const finalBreadcrumb = beforeBreadcrumb ? (0, $fa35a81632814438$export$cda52e2a8927a2ca)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
        if (finalBreadcrumb === null) return;
        if (client.emit) client.emit("beforeAddBreadcrumb", finalBreadcrumb, hint);
        // TODO(v8): I know this comment doesn't make much sense because the hub will be deprecated but I still wanted to
        // write it down. In theory, we would have to add the breadcrumbs to the isolation scope here, however, that would
        // duplicate all of the breadcrumbs. There was the possibility of adding breadcrumbs to both, the isolation scope
        // and the normal scope, and deduplicating it down the line in the event processing pipeline. However, that would
        // have been very fragile, because the breadcrumb objects would have needed to keep their identity all throughout
        // the event processing pipeline.
        // In the new implementation, the top level `Sentry.addBreadcrumb()` should ONLY write to the isolation scope.
        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setUser()` instead.
   */ setUser(user) {
        // TODO(v8): The top level `Sentry.setUser()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setUser(user);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setUser(user);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTags()` instead.
   */ setTags(tags) {
        // TODO(v8): The top level `Sentry.setTags()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setTags(tags);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setTags(tags);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtras()` instead.
   */ setExtras(extras) {
        // TODO(v8): The top level `Sentry.setExtras()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setExtras(extras);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setExtras(extras);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTag()` instead.
   */ setTag(key, value) {
        // TODO(v8): The top level `Sentry.setTag()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setTag(key, value);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setTag(key, value);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtra()` instead.
   */ setExtra(key, extra) {
        // TODO(v8): The top level `Sentry.setExtra()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setExtra(key, extra);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setExtra(key, extra);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setContext()` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setContext(name, context) {
        // TODO(v8): The top level `Sentry.setContext()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setContext(name, context);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setContext(name, context);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `getScope()` directly.
   */ configureScope(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        if (client) callback(scope);
    }
    /**
   * @inheritDoc
   */ run(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const oldHub = $be307700159f7758$export$4188a14ad302d1bc(this);
        try {
            callback(this);
        } finally{
            // eslint-disable-next-line deprecation/deprecation
            $be307700159f7758$export$4188a14ad302d1bc(oldHub);
        }
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.getClient().getIntegrationByName()` instead.
   */ getIntegration(integration) {
        // eslint-disable-next-line deprecation/deprecation
        const client = this.getClient();
        if (!client) return null;
        try {
            // eslint-disable-next-line deprecation/deprecation
            return client.getIntegration(integration);
        } catch (_oO) {
            (0, $217bdd4a17a6f5aa$export$16a28057038b10ef) && (0, $fa35a81632814438$export$af88d00dbe7f521).warn(`Cannot retrieve integration ${integration.id} from the current Hub`);
            return null;
        }
    }
    /**
   * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
   *
   * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
   * new child span within the transaction or any span, call the respective `.startChild()` method.
   *
   * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
   *
   * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
   * finished child spans will be sent to Sentry.
   *
   * @param context Properties of the new `Transaction`.
   * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
   * default values). See {@link Options.tracesSampler}.
   *
   * @returns The transaction which was just started
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */ startTransaction(context, customSamplingContext) {
        const result = this._callExtensionMethod("startTransaction", context, customSamplingContext);
        if ((0, $217bdd4a17a6f5aa$export$16a28057038b10ef) && !result) {
            // eslint-disable-next-line deprecation/deprecation
            const client = this.getClient();
            if (!client) (0, $fa35a81632814438$export$af88d00dbe7f521).warn("Tracing extension 'startTransaction' is missing. You should 'init' the SDK before calling 'startTransaction'");
            else (0, $fa35a81632814438$export$af88d00dbe7f521).warn(`Tracing extension 'startTransaction' has not been added. Call 'addTracingExtensions' before calling 'init':
Sentry.addTracingExtensions();
Sentry.init({...});
`);
        }
        return result;
    }
    /**
   * @inheritDoc
   * @deprecated Use `spanToTraceHeader()` instead.
   */ traceHeaders() {
        return this._callExtensionMethod("traceHeaders");
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use top level `captureSession` instead.
   */ captureSession(endSession = false) {
        // both send the update and pull the session from the scope
        if (endSession) // eslint-disable-next-line deprecation/deprecation
        return this.endSession();
        // only send the update
        this._sendSessionUpdate();
    }
    /**
   * @inheritDoc
   * @deprecated Use top level `endSession` instead.
   */ endSession() {
        // eslint-disable-next-line deprecation/deprecation
        const layer = this.getStackTop();
        const scope = layer.scope;
        const session = scope.getSession();
        if (session) (0, $0ddb591981a9106e$export$56521d9ba90f62ee)(session);
        this._sendSessionUpdate();
        // the session is over; take it off of the scope
        scope.setSession();
    }
    /**
   * @inheritDoc
   * @deprecated Use top level `startSession` instead.
   */ startSession(context) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        const { release: release, environment: environment = (0, $cee0c22ffcacfc8b$export$849dbeeeda01ae98) } = client && client.getOptions() || {};
        // Will fetch userAgent if called from browser sdk
        const { userAgent: userAgent } = (0, $42ab17974bcac25b$export$f1a6cdb1459e81d1).navigator || {};
        const session = (0, $0ddb591981a9106e$export$14a186326edbb264)({
            release: release,
            environment: environment,
            user: scope.getUser(),
            ...userAgent && {
                userAgent: userAgent
            },
            ...context
        });
        // End existing session if there's one
        const currentSession = scope.getSession && scope.getSession();
        if (currentSession && currentSession.status === "ok") (0, $0ddb591981a9106e$export$531818e825e774db)(currentSession, {
            status: "exited"
        });
        // eslint-disable-next-line deprecation/deprecation
        this.endSession();
        // Afterwards we set the new session on the scope
        scope.setSession(session);
        return session;
    }
    /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   *
   * @deprecated Use top-level `getClient().getOptions().sendDefaultPii` instead. This function
   * only unnecessarily increased API surface but only wrapped accessing the option.
   */ shouldSendDefaultPii() {
        // eslint-disable-next-line deprecation/deprecation
        const client = this.getClient();
        const options = client && client.getOptions();
        return Boolean(options && options.sendDefaultPii);
    }
    /**
   * Sends the current Session on the scope
   */ _sendSessionUpdate() {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        const session = scope.getSession();
        if (session && client && client.captureSession) client.captureSession(session);
    }
    /**
   * Calls global extension method and binding current instance to the function call
   */ // @ts-expect-error Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _callExtensionMethod(method, ...args) {
        const carrier = $be307700159f7758$export$19eade501500c6c1();
        const sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === "function") return sentry.extensions[method].apply(this, args);
        (0, $217bdd4a17a6f5aa$export$16a28057038b10ef) && (0, $fa35a81632814438$export$af88d00dbe7f521).warn(`Extension method ${method} couldn't be found, doing nothing.`);
    }
}
/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $be307700159f7758$export$19eade501500c6c1() {
    (0, $42ab17974bcac25b$export$f1a6cdb1459e81d1).__SENTRY__ = (0, $42ab17974bcac25b$export$f1a6cdb1459e81d1).__SENTRY__ || {
        extensions: {},
        hub: undefined
    };
    return 0, $42ab17974bcac25b$export$f1a6cdb1459e81d1;
}
/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 *
 * @deprecated Use `setCurrentClient()` instead.
 */ function $be307700159f7758$export$4188a14ad302d1bc(hub) {
    const registry = $be307700159f7758$export$19eade501500c6c1();
    const oldHub = $be307700159f7758$export$bfa8a924a84a76b7(registry);
    $be307700159f7758$export$849f05434e95d2f2(registry, hub);
    return oldHub;
}
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 *
 * @deprecated Use the respective replacement method directly instead.
 */ function $be307700159f7758$export$a07cdf6544bbd7c() {
    // Get main carrier (global for every environment)
    const registry = $be307700159f7758$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) {
        const hub = registry.__SENTRY__.acs.getCurrentHub();
        if (hub) return hub;
    }
    // Return hub that lives on a global object
    return $be307700159f7758$var$getGlobalHub(registry);
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current exection context,
 * meaning that it will remain stable for the same Hub.
 */ function $be307700159f7758$export$68f3af03034c9e90() {
    // eslint-disable-next-line deprecation/deprecation
    return $be307700159f7758$export$a07cdf6544bbd7c().getIsolationScope();
}
function $be307700159f7758$var$getGlobalHub(registry = $be307700159f7758$export$19eade501500c6c1()) {
    // If there's no hub, or its an old API, assign a new one
    if (!$be307700159f7758$var$hasHubOnCarrier(registry) || // eslint-disable-next-line deprecation/deprecation
    $be307700159f7758$export$bfa8a924a84a76b7(registry).isOlderThan($be307700159f7758$export$24a86ef7798177e4)) // eslint-disable-next-line deprecation/deprecation
    $be307700159f7758$export$849f05434e95d2f2(registry, new $be307700159f7758$export$8c41bb232f1008b1());
    // Return hub that lives on a global object
    return $be307700159f7758$export$bfa8a924a84a76b7(registry);
}
/**
 * @private Private API with no semver guarantees!
 *
 * If the carrier does not contain a hub, a new hub is created with the global hub client and scope.
 */ function $be307700159f7758$export$236689a79f5aa020(carrier, parent = $be307700159f7758$var$getGlobalHub()) {
    // If there's no hub on current domain, or it's an old API, assign a new one
    if (!$be307700159f7758$var$hasHubOnCarrier(carrier) || // eslint-disable-next-line deprecation/deprecation
    $be307700159f7758$export$bfa8a924a84a76b7(carrier).isOlderThan($be307700159f7758$export$24a86ef7798177e4)) {
        // eslint-disable-next-line deprecation/deprecation
        const client = parent.getClient();
        // eslint-disable-next-line deprecation/deprecation
        const scope = parent.getScope();
        // eslint-disable-next-line deprecation/deprecation
        const isolationScope = parent.getIsolationScope();
        // eslint-disable-next-line deprecation/deprecation
        $be307700159f7758$export$849f05434e95d2f2(carrier, new $be307700159f7758$export$8c41bb232f1008b1(client, scope.clone(), isolationScope.clone()));
    }
}
/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $be307700159f7758$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = $be307700159f7758$export$19eade501500c6c1();
    registry.__SENTRY__ = registry.__SENTRY__ || {};
    registry.__SENTRY__.acs = strategy;
}
/**
 * Runs the supplied callback in its own async context. Async Context strategies are defined per SDK.
 *
 * @param callback The callback to run in its own async context
 * @param options Options to pass to the async context strategy
 * @returns The result of the callback
 */ function $be307700159f7758$export$70d775fb1f267027(callback, options = {}) {
    const registry = $be307700159f7758$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) return registry.__SENTRY__.acs.runWithAsyncContext(callback, options);
    // if there was no strategy, fallback to just calling the callback
    return callback();
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */ function $be307700159f7758$var$hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */ function $be307700159f7758$export$bfa8a924a84a76b7(carrier) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $42ab17974bcac25b$export$7e223ec222791509)("hub", ()=>new $be307700159f7758$export$8c41bb232f1008b1(), carrier);
}
/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */ function $be307700159f7758$export$849f05434e95d2f2(carrier, hub) {
    if (!carrier) return false;
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.hub = hub;
    return true;
}




/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $e4841c5bc676bc78$export$8115b0b78e956ab3() {
    const hasWeakSet = typeof WeakSet === "function";
    const inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(let i = 0; i < inner.length; i++){
            const value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(let i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}



/**
 * Does this filename look like it's part of the app code?
 */ function $3d9206da23706ada$export$1de92f38f4de99a8(filename, isNative = false) {
    const isInternal = isNative || filename && // It's not internal if it's an absolute linux path
    !filename.startsWith("/") && // It's not internal if it's an absolute windows path
    !filename.match(/^[A-Z]:/) && // It's not internal if the path is starting with a dot
    !filename.startsWith(".") && // It's not internal if the frame has a protocol. In node, this is usually the case if the file got pre-processed with a bundler like webpack
    !filename.match(/^[a-zA-Z]([a-zA-Z0-9.\-+])*:\/\//); // Schema from: https://stackoverflow.com/a/3641782
    // in_app is all that's not an internal Node function or a module within node_modules
    // note that isNative appears to return true even for node core libraries
    // see https://github.com/getsentry/raven-node/issues/176
    return !isInternal && filename !== undefined && !filename.includes("node_modules/");
}
/** Node Stack line parser */ // eslint-disable-next-line complexity
function $3d9206da23706ada$export$35059013cd4a06db(getModule) {
    const FILENAME_MATCH = /^\s*[-]{4,}$/;
    const FULL_MATCH = /at (?:async )?(?:(.+?)\s+\()?(?:(.+):(\d+):(\d+)?|([^)]+))\)?/;
    // eslint-disable-next-line complexity
    return (line)=>{
        const lineMatch = line.match(FULL_MATCH);
        if (lineMatch) {
            let object;
            let method;
            let functionName;
            let typeName;
            let methodName;
            if (lineMatch[1]) {
                functionName = lineMatch[1];
                let methodStart = functionName.lastIndexOf(".");
                if (functionName[methodStart - 1] === ".") methodStart--;
                if (methodStart > 0) {
                    object = functionName.slice(0, methodStart);
                    method = functionName.slice(methodStart + 1);
                    const objectEnd = object.indexOf(".Module");
                    if (objectEnd > 0) {
                        functionName = functionName.slice(objectEnd + 1);
                        object = object.slice(0, objectEnd);
                    }
                }
                typeName = undefined;
            }
            if (method) {
                typeName = object;
                methodName = method;
            }
            if (method === "<anonymous>") {
                methodName = undefined;
                functionName = undefined;
            }
            if (functionName === undefined) {
                methodName = methodName || "<anonymous>";
                functionName = typeName ? `${typeName}.${methodName}` : methodName;
            }
            let filename = lineMatch[2] && lineMatch[2].startsWith("file://") ? lineMatch[2].slice(7) : lineMatch[2];
            const isNative = lineMatch[5] === "native";
            // If it's a Windows path, trim the leading slash so that `/C:/foo` becomes `C:/foo`
            if (filename && filename.match(/\/[A-Z]:/)) filename = filename.slice(1);
            if (!filename && lineMatch[5] && !isNative) filename = lineMatch[5];
            return {
                filename: filename,
                module: getModule ? getModule(filename) : undefined,
                function: functionName,
                lineno: parseInt(lineMatch[3], 10) || undefined,
                colno: parseInt(lineMatch[4], 10) || undefined,
                in_app: $3d9206da23706ada$export$1de92f38f4de99a8(filename, isNative)
            };
        }
        if (line.match(FILENAME_MATCH)) return {
            filename: line
        };
        return undefined;
    };
}


const $aa7bfcbdaa2ccf41$var$STACKTRACE_FRAME_LIMIT = 50;
// Used to sanitize webpack (error: *) wrapped stack errors
const $aa7bfcbdaa2ccf41$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $aa7bfcbdaa2ccf41$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $aa7bfcbdaa2ccf41$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirst = 0)=>{
        const frames = [];
        const lines = stack.split("\n");
        for(let i = skipFirst; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $aa7bfcbdaa2ccf41$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($aa7bfcbdaa2ccf41$var$WEBPACK_ERROR_REGEXP, "$1") : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $aa7bfcbdaa2ccf41$var$STACKTRACE_FRAME_LIMIT) break;
        }
        return $aa7bfcbdaa2ccf41$export$c55c24c0eeba0205(frames);
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $aa7bfcbdaa2ccf41$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $aa7bfcbdaa2ccf41$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $aa7bfcbdaa2ccf41$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test(localStack[localStack.length - 1].function || "")) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($aa7bfcbdaa2ccf41$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || "")) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the hub itself, making it:
        //
        //   Sentry.captureException()
        //   getCurrentHub().captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($aa7bfcbdaa2ccf41$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || "")) localStack.pop();
    }
    return localStack.slice(0, $aa7bfcbdaa2ccf41$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || localStack[localStack.length - 1].filename,
            function: frame.function || "?"
        }));
}
const $aa7bfcbdaa2ccf41$var$defaultFunctionName = "<anonymous>";
/**
 * Safely extract function name from itself
 */ function $aa7bfcbdaa2ccf41$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== "function") return $aa7bfcbdaa2ccf41$var$defaultFunctionName;
        return fn.name || $aa7bfcbdaa2ccf41$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $aa7bfcbdaa2ccf41$var$defaultFunctionName;
    }
}
/**
 * Node.js stack line parser
 *
 * This is in @sentry/utils so it can be used from the Electron SDK in the browser for when `nodeIntegration == true`.
 * This allows it to be used without referencing or importing any node specific code which causes bundlers to complain
 */ function $aa7bfcbdaa2ccf41$export$673345a0da635a78(getModule) {
    return [
        90,
        (0, $3d9206da23706ada$export$35059013cd4a06db)(getModule)
    ];
}


/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $05c209cb09bdd9f5$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $05c209cb09bdd9f5$export$588732934346abbf("", input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $05c209cb09bdd9f5$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $05c209cb09bdd9f5$export$a3295358bff77e(object, depth);
    if ($05c209cb09bdd9f5$var$jsonSize(normalized) > maxSize) return $05c209cb09bdd9f5$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $05c209cb09bdd9f5$export$588732934346abbf(key, value, depth = Infinity, maxProperties = Infinity, memo = (0, $e4841c5bc676bc78$export$8115b0b78e956ab3)()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        "number",
        "boolean",
        "string"
    ].includes(typeof value) && !(0, $9cb15bc4eaa635db$export$c9f5652083b8129d)(value)) return value;
    const stringified = $05c209cb09bdd9f5$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith("[object ")) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value["__sentry_skip_normalization__"]) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value["__sentry_override_normalization_depth__"] === "number" ? value["__sentry_override_normalization_depth__"] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace("object ", "");
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return "[Circular ~]";
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $05c209cb09bdd9f5$export$588732934346abbf("", jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $c617c17708158965$export$62ff257738bf57f5)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = "[MaxProperties ~]";
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $05c209cb09bdd9f5$export$588732934346abbf(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $05c209cb09bdd9f5$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === "domain" && value && typeof value === "object" && value._events) return "[Domain]";
        if (key === "domainEmitter") return "[DomainEmitter]";
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== "undefined" && value === $parcel$global) return "[Global]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== "undefined" && value === window) return "[Window]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== "undefined" && value === document) return "[Document]";
        if ((0, $9cb15bc4eaa635db$export$7916fad0ebc23f48)(value)) return "[VueViewModel]";
        // React's SyntheticEvent thingy
        if ((0, $9cb15bc4eaa635db$export$bc2894c7158efbac)(value)) return "[SyntheticEvent]";
        if (typeof value === "number" && value !== value) return "[NaN]";
        if (typeof value === "function") return `[Function: ${(0, $aa7bfcbdaa2ccf41$export$aad197c7121a6651)(value)}]`;
        if (typeof value === "symbol") return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === "bigint") return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $05c209cb09bdd9f5$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $05c209cb09bdd9f5$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype ? prototype.constructor.name : "null prototype";
}
/** Calculates bytes size of input string */ function $05c209cb09bdd9f5$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $05c209cb09bdd9f5$var$jsonSize(value) {
    return $05c209cb09bdd9f5$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $05c209cb09bdd9f5$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, "/")// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (_Oo) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, "/").replace(/webpack:\/?/g, "") // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, "ig"), "app:///");
}







/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * Note: This also triggers callbacks for `addGlobalEventProcessor`, but not `beforeSend`.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $2201074dfdd5410f$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $bc1dfbb58bc0f8fc$export$19f53698e68b2496)(),
        timestamp: event.timestamp || (0, $5874e77f331c673b$export$7740643b9eeaf0c4)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $2201074dfdd5410f$var$applyClientOptions(prepared, options);
    $2201074dfdd5410f$var$applyIntegrationsMetadata(prepared, integrations);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $2201074dfdd5410f$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = $2201074dfdd5410f$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $bc1dfbb58bc0f8fc$export$c69a9a0313b03bb1)(prepared, hint.mechanism);
    const clientEventProcessors = client && client.getEventProcessors ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Hub.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = (0, $d0c210911ed87beb$export$aa55d5ab8e05984f)().getScopeData();
    if (isolationScope) {
        const isolationData = isolationScope.getScopeData();
        (0, $ce9cd16e295abe53$export$25ac7e259a513db4)(data, isolationData);
    }
    if (finalScope) {
        const finalScopeData = finalScope.getScopeData();
        (0, $ce9cd16e295abe53$export$25ac7e259a513db4)(data, finalScopeData);
    }
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $ce9cd16e295abe53$export$43988bc651a80216)(prepared, data);
    // TODO (v8): Update this order to be: Global > Client > Scope
    const eventProcessors = [
        ...clientEventProcessors,
        // eslint-disable-next-line deprecation/deprecation
        ...(0, $aebca1a2794783df$export$3c4238858b85e8ac)(),
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const result = (0, $aebca1a2794783df$export$bf2a096c3e883e79)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $2201074dfdd5410f$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === "number" && normalizeDepth > 0) return $2201074dfdd5410f$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 *  Enhances event using the client configuration.
 *  It takes care of all "static" values like environment, release and `dist`,
 *  as well as truncating overly long values.
 * @param event event instance to be enhanced
 */ function $2201074dfdd5410f$var$applyClientOptions(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength = 250 } = options;
    if (!("environment" in event)) event.environment = "environment" in options ? environment : (0, $cee0c22ffcacfc8b$export$849dbeeeda01ae98);
    if (event.release === undefined && release !== undefined) event.release = release;
    if (event.dist === undefined && dist !== undefined) event.dist = dist;
    if (event.message) event.message = (0, $6185c1fc30855c3e$export$6a506b36fdea397d)(event.message, maxValueLength);
    const exception = event.exception && event.exception.values && event.exception.values[0];
    if (exception && exception.value) exception.value = (0, $6185c1fc30855c3e$export$6a506b36fdea397d)(exception.value, maxValueLength);
    const request = event.request;
    if (request && request.url) request.url = (0, $6185c1fc30855c3e$export$6a506b36fdea397d)(request.url, maxValueLength);
}
const $2201074dfdd5410f$var$debugIdStackParserCache = new WeakMap();
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $2201074dfdd5410f$export$63042efc86f043e7(event, stackParser) {
    const debugIdMap = (0, $42ab17974bcac25b$export$f1a6cdb1459e81d1)._sentryDebugIds;
    if (!debugIdMap) return;
    let debugIdStackFramesCache;
    const cachedDebugIdStackFrameCache = $2201074dfdd5410f$var$debugIdStackParserCache.get(stackParser);
    if (cachedDebugIdStackFrameCache) debugIdStackFramesCache = cachedDebugIdStackFrameCache;
    else {
        debugIdStackFramesCache = new Map();
        $2201074dfdd5410f$var$debugIdStackParserCache.set(stackParser, debugIdStackFramesCache);
    }
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = Object.keys(debugIdMap).reduce((acc, debugIdStackTrace)=>{
        let parsedStack;
        const cachedParsedStack = debugIdStackFramesCache.get(debugIdStackTrace);
        if (cachedParsedStack) parsedStack = cachedParsedStack;
        else {
            parsedStack = stackParser(debugIdStackTrace);
            debugIdStackFramesCache.set(debugIdStackTrace, parsedStack);
        }
        for(let i = parsedStack.length - 1; i >= 0; i--){
            const stackFrame = parsedStack[i];
            if (stackFrame.filename) {
                acc[stackFrame.filename] = debugIdMap[debugIdStackTrace];
                break;
            }
        }
        return acc;
    }, {});
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $2201074dfdd5410f$export$1be657ba8ef44ff0(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.debug_id) {
                    if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                    else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                    delete frame.debug_id;
                }
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.keys(filenameDebugIdMap).forEach((filename)=>{
        images.push({
            type: "sourcemap",
            code_file: filename,
            debug_id: filenameDebugIdMap[filename]
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $2201074dfdd5410f$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $2201074dfdd5410f$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $05c209cb09bdd9f5$export$a3295358bff77e)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $05c209cb09bdd9f5$export$a3295358bff77e)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $05c209cb09bdd9f5$export$a3295358bff77e)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $05c209cb09bdd9f5$export$a3295358bff77e)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts && event.contexts.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $05c209cb09bdd9f5$export$a3295358bff77e)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        const data = (0, $af551fb4a4d89418$export$92d8c23565496537)(span).data;
        if (data) // This is a bit weird, as we generally have `Span` instances here, but to be safe we do not assume so
        // eslint-disable-next-line deprecation/deprecation
        span.data = (0, $05c209cb09bdd9f5$export$a3295358bff77e)(data, depth, maxBreadth);
        return span;
    });
    return normalized;
}
function $2201074dfdd5410f$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $d0c210911ed87beb$export$775b6bb06e53a214)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $2201074dfdd5410f$export$76b5f966996d1653(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($2201074dfdd5410f$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($2201074dfdd5410f$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $2201074dfdd5410f$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $d0c210911ed87beb$export$775b6bb06e53a214) || typeof hint === "function";
}
const $2201074dfdd5410f$var$captureContextKeys = [
    "user",
    "level",
    "extra",
    "contexts",
    "tags",
    "fingerprint",
    "requestSession",
    "propagationContext"
];
function $2201074dfdd5410f$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$2201074dfdd5410f$var$captureContextKeys.includes(key));
}


/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $3bf2cc17570e59fe$export$f5282963edea4a68(// eslint-disable-next-line @typescript-eslint/no-explicit-any
exception, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $be307700159f7758$export$a07cdf6544bbd7c)().captureException(exception, (0, $2201074dfdd5410f$export$76b5f966996d1653)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function $3bf2cc17570e59fe$export$45654777c133ae80(message, // eslint-disable-next-line deprecation/deprecation
captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === "string" ? captureContext : undefined;
    const context = typeof captureContext !== "string" ? {
        captureContext: captureContext
    } : undefined;
    // eslint-disable-next-line deprecation/deprecation
    return (0, $be307700159f7758$export$a07cdf6544bbd7c)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param exception The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function $3bf2cc17570e59fe$export$1462b974fdcf6ba2(event, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $be307700159f7758$export$a07cdf6544bbd7c)().captureEvent(event, hint);
}
/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 *
 * @deprecated Use getCurrentScope() directly.
 */ function $3bf2cc17570e59fe$export$99d44f04437e9cb8(callback) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $be307700159f7758$export$a07cdf6544bbd7c)().configureScope(callback);
}
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */ function $3bf2cc17570e59fe$export$efda9a273d7a036d(breadcrumb, hint) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $be307700159f7758$export$a07cdf6544bbd7c)().addBreadcrumb(breadcrumb, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $3bf2cc17570e59fe$export$2f04de43fe27971a(name, context) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $be307700159f7758$export$a07cdf6544bbd7c)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ function $3bf2cc17570e59fe$export$bb4922da0dd51b92(extras) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $be307700159f7758$export$a07cdf6544bbd7c)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ function $3bf2cc17570e59fe$export$8e8e7789d42ed61d(key, extra) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $be307700159f7758$export$a07cdf6544bbd7c)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ function $3bf2cc17570e59fe$export$74a8fb34822092e6(tags) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $be307700159f7758$export$a07cdf6544bbd7c)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ function $3bf2cc17570e59fe$export$a37d07ee78eb4569(key, value) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $be307700159f7758$export$a07cdf6544bbd7c)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ function $3bf2cc17570e59fe$export$8b6bb3dd62a01be2(user) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $be307700159f7758$export$a07cdf6544bbd7c)().setUser(user);
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $3bf2cc17570e59fe$export$ec58d9285c204497(...rest) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $be307700159f7758$export$a07cdf6544bbd7c)();
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(callback);
        // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(()=>{
            // eslint-disable-next-line deprecation/deprecation
            hub.getStackTop().scope = scope;
            return callback(scope);
        });
    }
    // eslint-disable-next-line deprecation/deprecation
    return hub.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 *
 * @param callback The callback in which the passed isolation scope is active. (Note: In environments without async
 * context strategy, the currently active isolation scope may change within execution of the callback.)
 * @returns The same value that `callback` returns.
 */ function $3bf2cc17570e59fe$export$9a4fed82c350c2bd(callback) {
    return (0, $be307700159f7758$export$70d775fb1f267027)(()=>{
        return callback((0, $be307700159f7758$export$68f3af03034c9e90)());
    });
}
/**
 * Forks the current scope and sets the provided span as active span in the context of the provided callback.
 *
 * @param span Spans started in the context of the provided callback will be children of this span.
 * @param callback Execution context in which the provided span will be active. Is passed the newly forked scope.
 * @returns the value returned from the provided callback function.
 */ function $3bf2cc17570e59fe$export$e57ac09b143d92a2(span, callback) {
    return $3bf2cc17570e59fe$export$ec58d9285c204497((scope)=>{
        // eslint-disable-next-line deprecation/deprecation
        scope.setSpan(span);
        return callback(scope);
    });
}
/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * NOTE: This function should only be used for *manual* instrumentation. Auto-instrumentation should call
 * `startTransaction` directly on the hub.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 *
 * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
 */ function $3bf2cc17570e59fe$export$e262da7ae6480481(context, customSamplingContext) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $be307700159f7758$export$a07cdf6544bbd7c)().startTransaction({
        ...context
    }, customSamplingContext);
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $3bf2cc17570e59fe$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const scope = $3bf2cc17570e59fe$export$c7be4b0125a10cba();
    const client = $3bf2cc17570e59fe$export$6bb76d6eba7e258c();
    if (!client) (0, $217bdd4a17a6f5aa$export$16a28057038b10ef) && (0, $fa35a81632814438$export$af88d00dbe7f521).warn("Cannot capture check-in. No client defined.");
    else if (!client.captureCheckIn) (0, $217bdd4a17a6f5aa$export$16a28057038b10ef) && (0, $fa35a81632814438$export$af88d00dbe7f521).warn("Cannot capture check-in. Client does not support sending check-ins.");
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $bc1dfbb58bc0f8fc$export$19f53698e68b2496)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $3bf2cc17570e59fe$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    const checkInId = $3bf2cc17570e59fe$export$413528111fbc67c({
        monitorSlug: monitorSlug,
        status: "in_progress"
    }, upsertMonitorConfig);
    const now = (0, $5874e77f331c673b$export$ee52dced521e3e18)();
    function finishCheckIn(status) {
        $3bf2cc17570e59fe$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: status,
            checkInId: checkInId,
            duration: (0, $5874e77f331c673b$export$ee52dced521e3e18)() - now
        });
    }
    let maybePromiseResult;
    try {
        maybePromiseResult = callback();
    } catch (e) {
        finishCheckIn("error");
        throw e;
    }
    if ((0, $9cb15bc4eaa635db$export$f5b060c2914b97c8)(maybePromiseResult)) Promise.resolve(maybePromiseResult).then(()=>{
        finishCheckIn("ok");
    }, ()=>{
        finishCheckIn("error");
    });
    else finishCheckIn("ok");
    return maybePromiseResult;
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $3bf2cc17570e59fe$export$4909b86c8034bf73(timeout) {
    const client = $3bf2cc17570e59fe$export$6bb76d6eba7e258c();
    if (client) return client.flush(timeout);
    (0, $217bdd4a17a6f5aa$export$16a28057038b10ef) && (0, $fa35a81632814438$export$af88d00dbe7f521).warn("Cannot flush events. No client defined.");
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $3bf2cc17570e59fe$export$8360e631d277ea4d(timeout) {
    const client = $3bf2cc17570e59fe$export$6bb76d6eba7e258c();
    if (client) return client.close(timeout);
    (0, $217bdd4a17a6f5aa$export$16a28057038b10ef) && (0, $fa35a81632814438$export$af88d00dbe7f521).warn("Cannot flush events and disable SDK. No client defined.");
    return Promise.resolve(false);
}
/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 * @deprecated This function will be removed in the next major version of the Sentry SDK.
 */ function $3bf2cc17570e59fe$export$5d4e9fd7fac8e617() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $be307700159f7758$export$a07cdf6544bbd7c)().lastEventId();
}
/**
 * Get the currently active client.
 */ function $3bf2cc17570e59fe$export$6bb76d6eba7e258c() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $be307700159f7758$export$a07cdf6544bbd7c)().getClient();
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function $3bf2cc17570e59fe$export$3f95c6f800b78024() {
    return !!$3bf2cc17570e59fe$export$6bb76d6eba7e258c();
}
/**
 * Get the currently active scope.
 */ function $3bf2cc17570e59fe$export$c7be4b0125a10cba() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $be307700159f7758$export$a07cdf6544bbd7c)().getScope();
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function $3bf2cc17570e59fe$export$c0d84948cecf78d8(context) {
    const client = $3bf2cc17570e59fe$export$6bb76d6eba7e258c();
    const isolationScope = (0, $be307700159f7758$export$68f3af03034c9e90)();
    const currentScope = $3bf2cc17570e59fe$export$c7be4b0125a10cba();
    const { release: release, environment: environment = (0, $cee0c22ffcacfc8b$export$849dbeeeda01ae98) } = client && client.getOptions() || {};
    // Will fetch userAgent if called from browser sdk
    const { userAgent: userAgent } = (0, $42ab17974bcac25b$export$f1a6cdb1459e81d1).navigator || {};
    const session = (0, $0ddb591981a9106e$export$14a186326edbb264)({
        release: release,
        environment: environment,
        user: currentScope.getUser() || isolationScope.getUser(),
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if (currentSession && currentSession.status === "ok") (0, $0ddb591981a9106e$export$531818e825e774db)(currentSession, {
        status: "exited"
    });
    $3bf2cc17570e59fe$export$17a5be43989a0bc1();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function $3bf2cc17570e59fe$export$17a5be43989a0bc1() {
    const isolationScope = (0, $be307700159f7758$export$68f3af03034c9e90)();
    const currentScope = $3bf2cc17570e59fe$export$c7be4b0125a10cba();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $0ddb591981a9106e$export$56521d9ba90f62ee)(session);
    $3bf2cc17570e59fe$var$_sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function $3bf2cc17570e59fe$var$_sendSessionUpdate() {
    const isolationScope = (0, $be307700159f7758$export$68f3af03034c9e90)();
    const currentScope = $3bf2cc17570e59fe$export$c7be4b0125a10cba();
    const client = $3bf2cc17570e59fe$export$6bb76d6eba7e258c();
    // TODO (v8): Remove currentScope and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session && client && client.captureSession) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function $3bf2cc17570e59fe$export$667e7b4d445d566b(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        $3bf2cc17570e59fe$export$17a5be43989a0bc1();
        return;
    }
    // only send the update
    $3bf2cc17570e59fe$var$_sendSessionUpdate();
}








const $cf0d247f1c37a8e9$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preseve the order of integrations in the array.
 *
 * @private
 */ function $cf0d247f1c37a8e9$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.keys(integrationsByName).map((k)=>integrationsByName[k]);
}
/** Gets integrations to install */ function $cf0d247f1c37a8e9$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === "function") integrations = (0, $bc1dfbb58bc0f8fc$export$3131421a7d01b4fb)(userIntegrations(defaultIntegrations));
    else integrations = defaultIntegrations;
    const finalIntegrations = $cf0d247f1c37a8e9$var$filterDuplicates(integrations);
    // The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
    // `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
    // processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
    // locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.
    const debugIndex = $cf0d247f1c37a8e9$var$findIndex(finalIntegrations, (integration)=>integration.name === "Debug");
    if (debugIndex !== -1) {
        const [debugInstance] = finalIntegrations.splice(debugIndex, 1);
        finalIntegrations.push(debugInstance);
    }
    return finalIntegrations;
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $cf0d247f1c37a8e9$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $cf0d247f1c37a8e9$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function $cf0d247f1c37a8e9$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)// guard against empty provided integrations
    if (integration && integration.afterAllSetup) integration.afterAllSetup(client);
}
/** Setup a single integration.  */ function $cf0d247f1c37a8e9$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $217bdd4a17a6f5aa$export$16a28057038b10ef) && (0, $fa35a81632814438$export$af88d00dbe7f521).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if ($cf0d247f1c37a8e9$export$b14a8888f80a0b3e.indexOf(integration.name) === -1) {
        // eslint-disable-next-line deprecation/deprecation
        integration.setupOnce((0, $aebca1a2794783df$export$8e4e25f54d456511), (0, $be307700159f7758$export$a07cdf6544bbd7c));
        $cf0d247f1c37a8e9$export$b14a8888f80a0b3e.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === "function") integration.setup(client);
    if (client.on && typeof integration.preprocessEvent === "function") {
        const callback = integration.preprocessEvent.bind(integration);
        client.on("preprocessEvent", (event, hint)=>callback(event, hint, client));
    }
    if (client.addEventProcessor && typeof integration.processEvent === "function") {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    (0, $217bdd4a17a6f5aa$export$16a28057038b10ef) && (0, $fa35a81632814438$export$af88d00dbe7f521).log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current hub's client. */ function $cf0d247f1c37a8e9$export$2d8f5188773bcddd(integration) {
    const client = (0, $3bf2cc17570e59fe$export$6bb76d6eba7e258c)();
    if (!client || !client.addIntegration) {
        (0, $217bdd4a17a6f5aa$export$16a28057038b10ef) && (0, $fa35a81632814438$export$af88d00dbe7f521).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
// Polyfill for Array.findIndex(), which is not supported in ES5
function $cf0d247f1c37a8e9$var$findIndex(arr, callback) {
    for(let i = 0; i < arr.length; i++){
        if (callback(arr[i]) === true) return i;
    }
    return -1;
}
/**
 * Convert a new integration function to the legacy class syntax.
 * In v8, we can remove this and instead export the integration functions directly.
 *
 * @deprecated This will be removed in v8!
 */ function $cf0d247f1c37a8e9$export$afa219bf23651160(name, fn) {
    return Object.assign(function ConvertedIntegration(...args) {
        return fn(...args);
    }, {
        id: name
    });
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function $cf0d247f1c37a8e9$export$2323046b9414659f(fn) {
    return fn;
}


let $59ebd5207e71d1e2$var$originalFunctionToString;
const $59ebd5207e71d1e2$var$INTEGRATION_NAME = "FunctionToString";
const $59ebd5207e71d1e2$var$SETUP_CLIENTS = new WeakMap();
const $59ebd5207e71d1e2$var$_functionToStringIntegration = ()=>{
    return {
        name: $59ebd5207e71d1e2$var$INTEGRATION_NAME,
        setupOnce () {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            $59ebd5207e71d1e2$var$originalFunctionToString = Function.prototype.toString;
            // intrinsics (like Function.prototype) might be immutable in some environments
            // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
            try {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                Function.prototype.toString = function(...args) {
                    const originalFunction = (0, $c617c17708158965$export$e6cc1e135e2092e5)(this);
                    const context = $59ebd5207e71d1e2$var$SETUP_CLIENTS.has((0, $3bf2cc17570e59fe$export$6bb76d6eba7e258c)()) && originalFunction !== undefined ? originalFunction : this;
                    return $59ebd5207e71d1e2$var$originalFunctionToString.apply(context, args);
                };
            } catch (e) {
            // ignore errors here, just don't patch this
            }
        },
        setup (client) {
            $59ebd5207e71d1e2$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */ const $59ebd5207e71d1e2$export$7918117e9202e4fb = (0, $cf0d247f1c37a8e9$export$2323046b9414659f)($59ebd5207e71d1e2$var$_functionToStringIntegration);
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * @deprecated Use `functionToStringIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $59ebd5207e71d1e2$export$da4704525c20ae79 = (0, $cf0d247f1c37a8e9$export$afa219bf23651160)($59ebd5207e71d1e2$var$INTEGRATION_NAME, $59ebd5207e71d1e2$export$7918117e9202e4fb);



/** Regular expression used to parse a Dsn. */ const $0de8772d34f1438f$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $0de8772d34f1438f$var$isValidProtocol(protocol) {
    return protocol === "http" || protocol === "https";
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $0de8772d34f1438f$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ""}` + `@${host}${port ? `:${port}` : ""}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $0de8772d34f1438f$export$b892860177f70a30(str) {
    const match = $0de8772d34f1438f$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, $fa35a81632814438$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = "", host, port = "", lastPath] = match.slice(1);
    let path = "";
    let projectId = lastPath;
    const split = projectId.split("/");
    if (split.length > 1) {
        path = split.slice(0, -1).join("/");
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $0de8772d34f1438f$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $0de8772d34f1438f$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || "",
        pass: components.pass || "",
        host: components.host,
        port: components.port || "",
        path: components.path || "",
        projectId: components.projectId
    };
}
function $0de8772d34f1438f$var$validateDsn(dsn) {
    if (!(0, $4ec7df47aede9936$export$16a28057038b10ef)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        "protocol",
        "publicKey",
        "host",
        "projectId"
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $fa35a81632814438$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $fa35a81632814438$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$0de8772d34f1438f$var$isValidProtocol(protocol)) {
        (0, $fa35a81632814438$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $fa35a81632814438$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $0de8772d34f1438f$export$128827c3562ec0cb(from) {
    const components = typeof from === "string" ? $0de8772d34f1438f$export$b892860177f70a30(from) : $0de8772d34f1438f$var$dsnFromComponents(from);
    if (!components || !$0de8772d34f1438f$var$validateDsn(components)) return undefined;
    return components;
}


const $e67dceff09c2335b$var$SENTRY_API_VERSION = "7";
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $e67dceff09c2335b$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : "";
    const port = dsn.port ? `:${dsn.port}` : "";
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ""}/api/`;
}
/** Returns the ingest API endpoint for target. */ function $e67dceff09c2335b$var$_getIngestEndpoint(dsn) {
    return `${$e67dceff09c2335b$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $e67dceff09c2335b$var$_encodedAuth(dsn, sdkInfo) {
    return (0, $c617c17708158965$export$9ef804feabbcbaf1)({
        // We send only the minimum set of required information. See
        // https://github.com/getsentry/sentry-javascript/issues/2572.
        sentry_key: dsn.publicKey,
        sentry_version: $e67dceff09c2335b$var$SENTRY_API_VERSION,
        ...sdkInfo && {
            sentry_client: `${sdkInfo.name}/${sdkInfo.version}`
        }
    });
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $e67dceff09c2335b$export$9964600bfe84e6a3(dsn, // TODO (v8): Remove `tunnelOrOptions` in favor of `options`, and use the substitute code below
// options: ClientOptions = {} as ClientOptions,
tunnelOrOptions = {}) {
    // TODO (v8): Use this code instead
    // const { tunnel, _metadata = {} } = options;
    // return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, _metadata.sdk)}`;
    const tunnel = typeof tunnelOrOptions === "string" ? tunnelOrOptions : tunnelOrOptions.tunnel;
    const sdkInfo = typeof tunnelOrOptions === "string" || !tunnelOrOptions._metadata ? undefined : tunnelOrOptions._metadata.sdk;
    return tunnel ? tunnel : `${$e67dceff09c2335b$var$_getIngestEndpoint(dsn)}?${$e67dceff09c2335b$var$_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function $e67dceff09c2335b$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $0de8772d34f1438f$export$128827c3562ec0cb)(dsnLike);
    if (!dsn) return "";
    const endpoint = `${$e67dceff09c2335b$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $0de8772d34f1438f$export$44d472fbb931a776)(dsn)}`;
    for(const key in dialogOptions){
        if (key === "dsn") continue;
        if (key === "onClose") continue;
        if (key === "user") {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}




// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const $3235049c57f9dc22$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    /^Cannot redefine property: googletag$/
];
const $3235049c57f9dc22$var$DEFAULT_IGNORE_TRANSACTIONS = [
    /^.*\/healthcheck$/,
    /^.*\/healthy$/,
    /^.*\/live$/,
    /^.*\/ready$/,
    /^.*\/heartbeat$/,
    /^.*\/health$/,
    /^.*\/healthz$/
];
/** Options for the InboundFilters integration */ const $3235049c57f9dc22$var$INTEGRATION_NAME = "InboundFilters";
const $3235049c57f9dc22$var$_inboundFiltersIntegration = (options = {})=>{
    return {
        name: $3235049c57f9dc22$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (event, _hint, client) {
            const clientOptions = client.getOptions();
            const mergedOptions = $3235049c57f9dc22$var$_mergeOptions(options, clientOptions);
            return $3235049c57f9dc22$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
};
const $3235049c57f9dc22$export$cb3c5c2ceb9818ba = (0, $cf0d247f1c37a8e9$export$2323046b9414659f)($3235049c57f9dc22$var$_inboundFiltersIntegration);
/**
 * Inbound filters configurable by the user.
 * @deprecated Use `inboundFiltersIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $3235049c57f9dc22$export$2ffbb5359dcc6be4 = (0, $cf0d247f1c37a8e9$export$afa219bf23651160)($3235049c57f9dc22$var$INTEGRATION_NAME, $3235049c57f9dc22$export$cb3c5c2ceb9818ba);
function $3235049c57f9dc22$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $3235049c57f9dc22$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || [],
            ...internalOptions.disableTransactionDefaults ? [] : $3235049c57f9dc22$var$DEFAULT_IGNORE_TRANSACTIONS
        ],
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
    };
}
function $3235049c57f9dc22$var$_shouldDropEvent(event, options) {
    if (options.ignoreInternal && $3235049c57f9dc22$var$_isSentryError(event)) {
        (0, $217bdd4a17a6f5aa$export$16a28057038b10ef) && (0, $fa35a81632814438$export$af88d00dbe7f521).warn(`Event dropped due to being internal Sentry Error.\nEvent: ${(0, $bc1dfbb58bc0f8fc$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($3235049c57f9dc22$var$_isIgnoredError(event, options.ignoreErrors)) {
        (0, $217bdd4a17a6f5aa$export$16a28057038b10ef) && (0, $fa35a81632814438$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, $bc1dfbb58bc0f8fc$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($3235049c57f9dc22$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
        (0, $217bdd4a17a6f5aa$export$16a28057038b10ef) && (0, $fa35a81632814438$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0, $bc1dfbb58bc0f8fc$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($3235049c57f9dc22$var$_isDeniedUrl(event, options.denyUrls)) {
        (0, $217bdd4a17a6f5aa$export$16a28057038b10ef) && (0, $fa35a81632814438$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, $bc1dfbb58bc0f8fc$export$4157119e2b157127)(event)}.\nUrl: ${$3235049c57f9dc22$var$_getEventFilterUrl(event)}`);
        return true;
    }
    if (!$3235049c57f9dc22$var$_isAllowedUrl(event, options.allowUrls)) {
        (0, $217bdd4a17a6f5aa$export$16a28057038b10ef) && (0, $fa35a81632814438$export$af88d00dbe7f521).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, $bc1dfbb58bc0f8fc$export$4157119e2b157127)(event)}.\nUrl: ${$3235049c57f9dc22$var$_getEventFilterUrl(event)}`);
        return true;
    }
    return false;
}
function $3235049c57f9dc22$var$_isIgnoredError(event, ignoreErrors) {
    // If event.type, this is not an error
    if (event.type || !ignoreErrors || !ignoreErrors.length) return false;
    return $3235049c57f9dc22$var$_getPossibleEventMessages(event).some((message)=>(0, $6185c1fc30855c3e$export$a7a5ec66062ea5d)(message, ignoreErrors));
}
function $3235049c57f9dc22$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (event.type !== "transaction" || !ignoreTransactions || !ignoreTransactions.length) return false;
    const name = event.transaction;
    return name ? (0, $6185c1fc30855c3e$export$a7a5ec66062ea5d)(name, ignoreTransactions) : false;
}
function $3235049c57f9dc22$var$_isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) return false;
    const url = $3235049c57f9dc22$var$_getEventFilterUrl(event);
    return !url ? false : (0, $6185c1fc30855c3e$export$a7a5ec66062ea5d)(url, denyUrls);
}
function $3235049c57f9dc22$var$_isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) return true;
    const url = $3235049c57f9dc22$var$_getEventFilterUrl(event);
    return !url ? true : (0, $6185c1fc30855c3e$export$a7a5ec66062ea5d)(url, allowUrls);
}
function $3235049c57f9dc22$var$_getPossibleEventMessages(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    let lastException;
    try {
        // @ts-expect-error Try catching to save bundle size
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        lastException = event.exception.values[event.exception.values.length - 1];
    } catch (e) {
    // try catching to save bundle size checking existence of variables
    }
    if (lastException) {
        if (lastException.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    }
    if ((0, $217bdd4a17a6f5aa$export$16a28057038b10ef) && possibleMessages.length === 0) (0, $fa35a81632814438$export$af88d00dbe7f521).error(`Could not extract message for event ${(0, $bc1dfbb58bc0f8fc$export$4157119e2b157127)(event)}`);
    return possibleMessages;
}
function $3235049c57f9dc22$var$_isSentryError(event) {
    try {
        // @ts-expect-error can't be a sentry error if undefined
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return event.exception.values[0].type === "SentryError";
    } catch (e) {
    // ignore
    }
    return false;
}
function $3235049c57f9dc22$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== "<anonymous>" && frame.filename !== "[native code]") return frame.filename || null;
    }
    return null;
}
function $3235049c57f9dc22$var$_getEventFilterUrl(event) {
    try {
        let frames;
        try {
            // @ts-expect-error we only care about frames if the whole thing here is defined
            frames = event.exception.values[0].stacktrace.frames;
        } catch (e) {
        // ignore
        }
        return frames ? $3235049c57f9dc22$var$_getLastValidUrl(frames) : null;
    } catch (oO) {
        (0, $217bdd4a17a6f5aa$export$16a28057038b10ef) && (0, $fa35a81632814438$export$af88d00dbe7f521).error(`Cannot extract url for event ${(0, $bc1dfbb58bc0f8fc$export$4157119e2b157127)(event)}`);
        return null;
    }
}





/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $832125eac2d656f6$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $217bdd4a17a6f5aa$export$16a28057038b10ef) (0, $fa35a81632814438$export$af88d00dbe7f521).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        (0, $fa35a81632814438$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn("[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.");
        });
    }
    const scope = (0, $3bf2cc17570e59fe$export$c7be4b0125a10cba)();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $832125eac2d656f6$export$ecb76f41d43c0e43(client);
    $832125eac2d656f6$var$initializeClient(client);
}
/**
 * Make the given client the current client.
 */ function $832125eac2d656f6$export$ecb76f41d43c0e43(client) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $be307700159f7758$export$a07cdf6544bbd7c)();
    // eslint-disable-next-line deprecation/deprecation
    const top = hub.getStackTop();
    top.client = client;
    top.scope.setClient(client);
}
/**
 * Initialize the client for the current scope.
 * Make sure to call this after `setCurrentClient()`.
 */ function $832125eac2d656f6$var$initializeClient(client) {
    if (client.init) client.init();
    else if (client.setupIntegrations) // eslint-disable-next-line deprecation/deprecation
    client.setupIntegrations();
}







// Based on https://github.com/angular/angular.js/pull/13945/files
// eslint-disable-next-line deprecation/deprecation
const $6dc680243bf9c936$var$WINDOW = (0, $42ab17974bcac25b$export$256479dc0cea61c4)();
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $6dc680243bf9c936$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const chromeVar = $6dc680243bf9c936$var$WINDOW.chrome;
    const isChromePackagedApp = chromeVar && chromeVar.app && chromeVar.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ const hasHistoryApi = "history" in $6dc680243bf9c936$var$WINDOW && !!$6dc680243bf9c936$var$WINDOW.history.pushState && !!$6dc680243bf9c936$var$WINDOW.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}





// We keep the handlers globally
const $2bd4cb908ffa433c$var$handlers = {};
const $2bd4cb908ffa433c$var$instrumented = {};
/** Add a handler function. */ function $2bd4cb908ffa433c$export$a4e09611e30da72e(type, handler) {
    $2bd4cb908ffa433c$var$handlers[type] = $2bd4cb908ffa433c$var$handlers[type] || [];
    $2bd4cb908ffa433c$var$handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $2bd4cb908ffa433c$export$b17eab759a1cb5fe() {
    Object.keys($2bd4cb908ffa433c$var$handlers).forEach((key)=>{
        $2bd4cb908ffa433c$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $2bd4cb908ffa433c$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$2bd4cb908ffa433c$var$instrumented[type]) {
        instrumentFn();
        $2bd4cb908ffa433c$var$instrumented[type] = true;
    }
}
/** Trigger handlers for a given instrumentation type. */ function $2bd4cb908ffa433c$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $2bd4cb908ffa433c$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $4ec7df47aede9936$export$16a28057038b10ef) && (0, $fa35a81632814438$export$af88d00dbe7f521).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $aa7bfcbdaa2ccf41$export$aad197c7121a6651)(handler)}\nError:`, e);
    }
}


const $0e7bd0efb15b353d$var$WINDOW = (0, $42ab17974bcac25b$export$f1a6cdb1459e81d1);
let $0e7bd0efb15b353d$var$lastHref;
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $0e7bd0efb15b353d$export$3f18c56c58114e75(handler) {
    const type = "history";
    (0, $2bd4cb908ffa433c$export$a4e09611e30da72e)(type, handler);
    (0, $2bd4cb908ffa433c$export$e18d6c5462c01368)(type, $0e7bd0efb15b353d$var$instrumentHistory);
}
function $0e7bd0efb15b353d$var$instrumentHistory() {
    if (!(0, $6dc680243bf9c936$export$67fc34576016d6ec)()) return;
    const oldOnPopState = $0e7bd0efb15b353d$var$WINDOW.onpopstate;
    $0e7bd0efb15b353d$var$WINDOW.onpopstate = function(...args) {
        const to = $0e7bd0efb15b353d$var$WINDOW.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $0e7bd0efb15b353d$var$lastHref;
        $0e7bd0efb15b353d$var$lastHref = to;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $2bd4cb908ffa433c$export$b18c893e424d3127)("history", handlerData);
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                const from = $0e7bd0efb15b353d$var$lastHref;
                const to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $0e7bd0efb15b353d$var$lastHref = to;
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $2bd4cb908ffa433c$export$b18c893e424d3127)("history", handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $c617c17708158965$export$9563e054e6f787fb)($0e7bd0efb15b353d$var$WINDOW.history, "pushState", historyReplacementFunction);
    (0, $c617c17708158965$export$9563e054e6f787fb)($0e7bd0efb15b353d$var$WINDOW.history, "replaceState", historyReplacementFunction);
}




// eslint-disable-next-line deprecation/deprecation
const $f0fcb9d2dddc107a$var$WINDOW = (0, $42ab17974bcac25b$export$256479dc0cea61c4)();
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $f0fcb9d2dddc107a$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $f0fcb9d2dddc107a$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $f0fcb9d2dddc107a$export$ab12a5d056f1d3a() {
    try {
        new DOMException("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */ function $f0fcb9d2dddc107a$export$edf3cb81fd7d2a3e() {
    if (!("fetch" in $f0fcb9d2dddc107a$var$WINDOW)) return false;
    try {
        new Headers();
        new Request("http://www.example.com");
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $f0fcb9d2dddc107a$export$18cf36ed71d733e7(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $f0fcb9d2dddc107a$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === "string") return true;
    if (!$f0fcb9d2dddc107a$export$edf3cb81fd7d2a3e()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($f0fcb9d2dddc107a$export$18cf36ed71d733e7($f0fcb9d2dddc107a$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $f0fcb9d2dddc107a$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === "function") try {
        const sandbox = doc.createElement("iframe");
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $f0fcb9d2dddc107a$export$18cf36ed71d733e7(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $4ec7df47aede9936$export$16a28057038b10ef) && (0, $fa35a81632814438$export$af88d00dbe7f521).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $f0fcb9d2dddc107a$export$531055a6c684a70a() {
    return "ReportingObserver" in $f0fcb9d2dddc107a$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */ function $f0fcb9d2dddc107a$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$f0fcb9d2dddc107a$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request("_", {
            referrerPolicy: "origin"
        });
        return true;
    } catch (e) {
        return false;
    }
}



/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */ function $1254ff1f1760ff55$export$b9f95b027256052c(options, name, names = [
    name
], source = "npm") {
    const metadata = options._metadata || {};
    if (!metadata.sdk) metadata.sdk = {
        name: `sentry.javascript.${name}`,
        packages: names.map((name)=>({
                name: `${source}:@sentry/${name}`,
                version: (0, $38444694bf1ffa62$export$31499a9cd224b78c)
            })),
        version: (0, $38444694bf1ffa62$export$31499a9cd224b78c)
    };
    options._metadata = metadata;
}




/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $2be9719d61f0a0f7$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $2be9719d61f0a0f7$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $2be9719d61f0a0f7$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $2be9719d61f0a0f7$export$604a45d95a155e2b(envelope, types) {
    return $2be9719d61f0a0f7$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8.
 */ function $2be9719d61f0a0f7$var$encodeUTF8(input, textEncoder) {
    const utf8 = textEncoder || new TextEncoder();
    return utf8.encode(input);
}
/**
 * Serializes an envelope.
 */ function $2be9719d61f0a0f7$export$32f9b428425aac85(envelope, textEncoder) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === "string") parts = typeof next === "string" ? parts + next : [
            $2be9719d61f0a0f7$var$encodeUTF8(parts, textEncoder),
            next
        ];
        else parts.push(typeof next === "string" ? $2be9719d61f0a0f7$var$encodeUTF8(next, textEncoder) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === "string" || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch (e) {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.strinify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $05c209cb09bdd9f5$export$a3295358bff77e)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === "string" ? parts : $2be9719d61f0a0f7$var$concatBuffers(parts);
}
function $2be9719d61f0a0f7$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $2be9719d61f0a0f7$export$3338d0c7b6e17a2b(env, textEncoder, textDecoder) {
    let buffer = typeof env === "string" ? textEncoder.encode(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse(textDecoder.decode(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === "number" ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates attachment envelope items
 */ function $2be9719d61f0a0f7$export$d8fc80952cc31fa4(attachment, textEncoder) {
    const buffer = typeof attachment.data === "string" ? $2be9719d61f0a0f7$var$encodeUTF8(attachment.data, textEncoder) : attachment.data;
    return [
        (0, $c617c17708158965$export$d25f2688db1bb433)({
            type: "attachment",
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        }),
        buffer
    ];
}
const $2be9719d61f0a0f7$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: "session",
    sessions: "session",
    attachment: "attachment",
    transaction: "transaction",
    event: "error",
    client_report: "internal",
    user_report: "default",
    profile: "profile",
    replay_event: "replay",
    replay_recording: "replay",
    check_in: "monitor",
    feedback: "feedback",
    span: "span",
    statsd: "statsd"
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $2be9719d61f0a0f7$export$b11169581eeaf237(type) {
    return $2be9719d61f0a0f7$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from from the metadata or an events */ function $2be9719d61f0a0f7$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent || !metadataOrEvent.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $2be9719d61f0a0f7$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata && event.sdkProcessingMetadata.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $0de8772d34f1438f$export$44d472fbb931a776)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: (0, $c617c17708158965$export$d25f2688db1bb433)({
                ...dynamicSamplingContext
            })
        }
    };
}

/** An error emitted by Sentry SDKs and related utilities. */ class $7a6608dd0661c2da$export$5949942ba2a7c0e2 extends Error {
    /** Display name of this error instance. */ constructor(message, logLevel = "warn"){
        super(message);
        this.message = message;
        this.name = new.target.prototype.constructor.name;
        // This sets the prototype to be `Error`, not `SentryError`. It's unclear why we do this, but commenting this line
        // out causes various (seemingly totally unrelated) playwright tests consistently time out. FYI, this makes
        // instances of `SentryError` fail `obj instanceof SentryError` checks.
        Object.setPrototypeOf(this, new.target.prototype);
        this.logLevel = logLevel;
    }
}





/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $8ba3675a13454a8c$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = [
        ...event.sdk.integrations || [],
        ...sdkInfo.integrations || []
    ];
    event.sdk.packages = [
        ...event.sdk.packages || [],
        ...sdkInfo.packages || []
    ];
    return event;
}
/** Creates an envelope from a Session */ function $8ba3675a13454a8c$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $2be9719d61f0a0f7$export$d369f3b2758f6743)(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $0de8772d34f1438f$export$44d472fbb931a776)(dsn)
        }
    };
    const envelopeItem = "aggregates" in session ? [
        {
            type: "sessions"
        },
        session
    ] : [
        {
            type: "session"
        },
        session.toJSON()
    ];
    return (0, $2be9719d61f0a0f7$export$f93f7f385160c44e)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $8ba3675a13454a8c$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $2be9719d61f0a0f7$export$d369f3b2758f6743)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjut a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== "replay_event" ? event.type : "event";
    $8ba3675a13454a8c$var$enhanceEventWithSdkInfo(event, metadata && metadata.sdk);
    const envelopeHeaders = (0, $2be9719d61f0a0f7$export$92b6093782fe661b)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $2be9719d61f0a0f7$export$f93f7f385160c44e)(envelopeHeaders, [
        eventItem
    ]);
}







const $0e00feabc29a439b$export$ffbd59c90957aeda = "c";
const $0e00feabc29a439b$export$41106537ee4dbdd = "g";
const $0e00feabc29a439b$export$d2e7506772279f4e = "s";
const $0e00feabc29a439b$export$9818d6472d7991f0 = "d";
/**
 * Normalization regex for metric names and metric tag names.
 *
 * This enforces that names and tag keys only contain alphanumeric characters,
 * underscores, forward slashes, periods, and dashes.
 *
 * See: https://develop.sentry.dev/sdk/metrics/#normalization
 */ const $0e00feabc29a439b$export$73db7eda248c6468 = /[^a-zA-Z0-9_/.-]+/g;
/**
 * Normalization regex for metric tag values.
 *
 * This enforces that values only contain words, digits, or the following
 * special characters: _:/@.{}[\]$-
 *
 * See: https://develop.sentry.dev/sdk/metrics/#normalization
 */ const $0e00feabc29a439b$export$2699a97e88d47e55 = /[^\w\d\s_:/@.{}[\]$-]+/g;
/**
 * This does not match spec in https://develop.sentry.dev/sdk/metrics
 * but was chosen to optimize for the most common case in browser environments.
 */ const $0e00feabc29a439b$export$9fcf9b73aae4b12 = 5000;
/**
 * SDKs are required to bucket into 10 second intervals (rollup in seconds)
 * which is the current lower bound of metric accuracy.
 */ const $0e00feabc29a439b$export$8f071e089fcfe0c = 10000;
/**
 * The maximum number of metrics that should be stored in memory.
 */ const $0e00feabc29a439b$export$aa41e9d920739c1a = 10000;


/**
 * Generate bucket key from metric properties.
 */ function $bafff8affeec1028$export$b8bd8c4dffa5aa2d(metricType, name, unit, tags) {
    const stringifiedTags = Object.entries((0, $c617c17708158965$export$d25f2688db1bb433)(tags)).sort((a, b)=>a[0].localeCompare(b[0]));
    return `${metricType}${name}${unit}${stringifiedTags}`;
}
/* eslint-disable no-bitwise */ /**
 * Simple hash function for strings.
 */ function $bafff8affeec1028$export$b211ce59c0ea1cfb(s) {
    let rv = 0;
    for(let i = 0; i < s.length; i++){
        const c = s.charCodeAt(i);
        rv = (rv << 5) - rv + c;
        rv &= rv;
    }
    return rv >>> 0;
}
/* eslint-enable no-bitwise */ /**
 * Serialize metrics buckets into a string based on statsd format.
 *
 * Example of format:
 * metric.name@second:1:1.2|d|#a:value,b:anothervalue|T12345677
 * Segments:
 * name: metric.name
 * unit: second
 * value: [1, 1.2]
 * type of metric: d (distribution)
 * tags: { a: value, b: anothervalue }
 * timestamp: 12345677
 */ function $bafff8affeec1028$export$66decd709db01dc8(metricBucketItems) {
    let out = "";
    for (const item of metricBucketItems){
        const tagEntries = Object.entries(item.tags);
        const maybeTags = tagEntries.length > 0 ? `|#${tagEntries.map(([key, value])=>`${key}:${value}`).join(",")}` : "";
        out += `${item.name}@${item.unit}:${item.metric}|${item.metricType}${maybeTags}|T${item.timestamp}\n`;
    }
    return out;
}
/**
 * Sanitizes tags.
 */ function $bafff8affeec1028$export$ae49af12dbdf2477(unsanitizedTags) {
    const tags = {};
    for(const key in unsanitizedTags)if (Object.prototype.hasOwnProperty.call(unsanitizedTags, key)) {
        const sanitizedKey = key.replace((0, $0e00feabc29a439b$export$73db7eda248c6468), "_");
        tags[sanitizedKey] = String(unsanitizedTags[key]).replace((0, $0e00feabc29a439b$export$2699a97e88d47e55), "");
    }
    return tags;
}


/**
 * Create envelope from a metric aggregate.
 */ function $5042a2a01d0a5c69$export$f23eb96e33154901(metricBucketItems, dsn, metadata, tunnel) {
    const headers = {
        sent_at: new Date().toISOString()
    };
    if (metadata && metadata.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && dsn) headers.dsn = (0, $0de8772d34f1438f$export$44d472fbb931a776)(dsn);
    const item = $5042a2a01d0a5c69$var$createMetricEnvelopeItem(metricBucketItems);
    return (0, $2be9719d61f0a0f7$export$f93f7f385160c44e)(headers, [
        item
    ]);
}
function $5042a2a01d0a5c69$var$createMetricEnvelopeItem(metricBucketItems) {
    const payload = (0, $bafff8affeec1028$export$66decd709db01dc8)(metricBucketItems);
    const metricHeaders = {
        type: "statsd",
        length: payload.length
    };
    return [
        metricHeaders,
        payload
    ];
}





const $b2bf8ed031d1ff0e$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class $b2bf8ed031d1ff0e$export$4f22f74eddb7716a {
    /**
   * A reference to a metrics aggregator
   *
   * @experimental Note this is alpha API. It may experience breaking changes in the future.
   */ /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ /** Indicates whether this client's integrations have been set up. */ /** Number of calls being processed */ /** Holds flushable  */ // eslint-disable-next-line @typescript-eslint/ban-types
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._integrationsInitialized = false;
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        if (options.dsn) this._dsn = (0, $0de8772d34f1438f$export$128827c3562ec0cb)(options.dsn);
        else (0, $217bdd4a17a6f5aa$export$16a28057038b10ef) && (0, $fa35a81632814438$export$af88d00dbe7f521).warn("No DSN provided, client will not send events.");
        if (this._dsn) {
            const url = (0, $e67dceff09c2335b$export$9964600bfe84e6a3)(this._dsn, options);
            this._transport = options.transport({
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    captureException(exception, hint, scope) {
        // ensure we haven't captured this very object before
        if ((0, $bc1dfbb58bc0f8fc$export$6de4ffac6a2f1098)(exception)) {
            (0, $217bdd4a17a6f5aa$export$16a28057038b10ef) && (0, $fa35a81632814438$export$af88d00dbe7f521).log($b2bf8ed031d1ff0e$var$ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        this._process(this.eventFromException(exception, hint).then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint, scope) {
        let eventId = hint && hint.event_id;
        const eventMessage = (0, $9cb15bc4eaa635db$export$dbcbffa59149b824)(message) ? message : String(message);
        const promisedEvent = (0, $9cb15bc4eaa635db$export$c3825b437cbdea5c)(message) ? this.eventFromMessage(eventMessage, level, hint) : this.eventFromException(message, hint);
        this._process(promisedEvent.then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint, scope) {
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && (0, $bc1dfbb58bc0f8fc$export$6de4ffac6a2f1098)(hint.originalException)) {
            (0, $217bdd4a17a6f5aa$export$16a28057038b10ef) && (0, $fa35a81632814438$export$af88d00dbe7f521).log($b2bf8ed031d1ff0e$var$ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        this._process(this._captureEvent(event, hint, capturedSpanScope || scope).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureSession(session) {
        if (!(typeof session.release === "string")) (0, $217bdd4a17a6f5aa$export$16a28057038b10ef) && (0, $fa35a81632814438$export$af88d00dbe7f521).warn("Discarded session because of missing or non-string release");
        else {
            this.sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            (0, $0ddb591981a9106e$export$531818e825e774db)(session, {
                init: false
            });
        }
    }
    /**
   * @inheritDoc
   */ getDsn() {
        return this._dsn;
    }
    /**
   * @inheritDoc
   */ getOptions() {
        return this._options;
    }
    /**
   * @see SdkMetadata in @sentry/types
   *
   * @return The metadata of the SDK
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * @inheritDoc
   */ getTransport() {
        return this._transport;
    }
    /**
   * @inheritDoc
   */ flush(timeout) {
        const transport = this._transport;
        if (transport) {
            if (this.metricsAggregator) this.metricsAggregator.flush();
            return this._isClientDoneProcessing(timeout).then((clientFinished)=>{
                return transport.flush(timeout).then((transportFlushed)=>clientFinished && transportFlushed);
            });
        } else return (0, $8285c2d2e65b1e62$export$1fda8aa4d135f8aa)(true);
    }
    /**
   * @inheritDoc
   */ close(timeout) {
        return this.flush(timeout).then((result)=>{
            this.getOptions().enabled = false;
            if (this.metricsAggregator) this.metricsAggregator.close();
            return result;
        });
    }
    /** Get all installed event processors. */ getEventProcessors() {
        return this._eventProcessors;
    }
    /** @inheritDoc */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /**
   * This is an internal function to setup all integrations that should run on the client.
   * @deprecated Use `client.init()` instead.
   */ setupIntegrations(forceInitialize) {
        if (forceInitialize && !this._integrationsInitialized || this._isEnabled() && !this._integrationsInitialized) this._setupIntegrations();
    }
    /** @inheritdoc */ init() {
        if (this._isEnabled()) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its `id`.
   *
   * @returns The installed integration or `undefined` if no integration with that `id` was installed.
   * @deprecated Use `getIntegrationByName()` instead.
   */ getIntegrationById(integrationId) {
        return this.getIntegrationByName(integrationId);
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * Returns the client's instance of the given integration class, it any.
   * @deprecated Use `getIntegrationByName()` instead.
   */ getIntegration(integration) {
        try {
            return this._integrations[integration.id] || null;
        } catch (_oO) {
            (0, $217bdd4a17a6f5aa$export$16a28057038b10ef) && (0, $fa35a81632814438$export$af88d00dbe7f521).warn(`Cannot retrieve integration ${integration.id} from the current Client`);
            return null;
        }
    }
    /**
   * @inheritDoc
   */ addIntegration(integration) {
        const isAlreadyInstalled = this._integrations[integration.name];
        // This hook takes care of only installing if not already installed
        (0, $cf0d247f1c37a8e9$export$e7390a03b70a6f2f)(this, integration, this._integrations);
        // Here we need to check manually to make sure to not run this multiple times
        if (!isAlreadyInstalled) (0, $cf0d247f1c37a8e9$export$35abcfd71227c6ca)(this, [
            integration
        ]);
    }
    /**
   * @inheritDoc
   */ sendEvent(event, hint = {}) {
        this.emit("beforeSendEvent", event, hint);
        let env = (0, $8ba3675a13454a8c$export$c31057337a18010f)(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = (0, $2be9719d61f0a0f7$export$d650323442802f6f)(env, (0, $2be9719d61f0a0f7$export$d8fc80952cc31fa4)(attachment, this._options.transportOptions && this._options.transportOptions.textEncoder));
        const promise = this._sendEnvelope(env);
        if (promise) promise.then((sendResponse)=>this.emit("afterSendEvent", event, sendResponse), null);
    }
    /**
   * @inheritDoc
   */ sendSession(session) {
        const env = (0, $8ba3675a13454a8c$export$124b03c077baa2f3)(session, this._dsn, this._options._metadata, this._options.tunnel);
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(env);
    }
    /**
   * @inheritDoc
   */ recordDroppedEvent(reason, category, _event) {
        // Note: we use `event` in replay, where we overwrite this hook.
        if (this._options.sendClientReports) {
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            (0, $217bdd4a17a6f5aa$export$16a28057038b10ef) && (0, $fa35a81632814438$export$af88d00dbe7f521).log(`Adding outcome: "${key}"`);
            // The following works because undefined + 1 === NaN and NaN is falsy
            this._outcomes[key] = this._outcomes[key] + 1 || 1;
        }
    }
    /**
   * @inheritDoc
   */ captureAggregateMetrics(metricBucketItems) {
        (0, $217bdd4a17a6f5aa$export$16a28057038b10ef) && (0, $fa35a81632814438$export$af88d00dbe7f521).log(`Flushing aggregated metrics, number of metrics: ${metricBucketItems.length}`);
        const metricsEnvelope = (0, $5042a2a01d0a5c69$export$f23eb96e33154901)(metricBucketItems, this._dsn, this._options._metadata, this._options.tunnel);
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(metricsEnvelope);
    }
    // Keep on() & emit() signatures in sync with types' client.ts interface
    /* eslint-disable @typescript-eslint/unified-signatures */ /** @inheritdoc */ /** @inheritdoc */ on(hook, callback) {
        if (!this._hooks[hook]) this._hooks[hook] = [];
        // @ts-expect-error We assue the types are correct
        this._hooks[hook].push(callback);
    }
    /** @inheritdoc */ /** @inheritdoc */ emit(hook, ...rest) {
        if (this._hooks[hook]) this._hooks[hook].forEach((callback)=>callback(...rest));
    }
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = (0, $cf0d247f1c37a8e9$export$51abed9797baa598)(this, integrations);
        (0, $cf0d247f1c37a8e9$export$35abcfd71227c6ca)(this, integrations);
        // TODO v8: We don't need this flag anymore
        this._integrationsInitialized = true;
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        let crashed = false;
        let errored = false;
        const exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            for (const ex of exceptions){
                const mechanism = ex.mechanism;
                if (mechanism && mechanism.handled === false) {
                    crashed = true;
                    break;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session.status === "ok";
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $0ddb591981a9106e$export$531818e825e774db)(session, {
                ...crashed && {
                    status: "crashed"
                },
                errors: session.errors || Number(errored || crashed)
            });
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ _isClientDoneProcessing(timeout) {
        return new (0, $8285c2d2e65b1e62$export$6f292d4960313241)((resolve)=>{
            let ticked = 0;
            const tick = 1;
            const interval = setInterval(()=>{
                if (this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, scope, isolationScope = (0, $be307700159f7758$export$68f3af03034c9e90)()) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && integrations.length > 0) hint.integrations = integrations;
        this.emit("preprocessEvent", event, hint);
        return (0, $2201074dfdd5410f$export$2d67fb380bd11267)(options, event, hint, scope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            const propagationContext = {
                ...isolationScope.getPropagationContext(),
                ...scope ? scope.getPropagationContext() : undefined
            };
            const trace = evt.contexts && evt.contexts.trace;
            if (!trace && propagationContext) {
                const { traceId: trace_id, spanId: spanId, parentSpanId: parentSpanId, dsc: dsc } = propagationContext;
                evt.contexts = {
                    trace: {
                        trace_id: trace_id,
                        span_id: spanId,
                        parent_span_id: parentSpanId
                    },
                    ...evt.contexts
                };
                const dynamicSamplingContext = dsc ? dsc : (0, $6b0cfeb393c5569e$export$366bad00d6815eed)(trace_id, this, scope);
                evt.sdkProcessingMetadata = {
                    dynamicSamplingContext: dynamicSamplingContext,
                    ...evt.sdkProcessingMetadata
                };
            }
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, scope) {
        return this._processEvent(event, hint, scope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (0, $217bdd4a17a6f5aa$export$16a28057038b10ef) {
                // If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
                // control flow, log just the message (no stack) as a log-level log.
                const sentryError = reason;
                if (sentryError.logLevel === "log") (0, $fa35a81632814438$export$af88d00dbe7f521).log(sentryError.message);
                else (0, $fa35a81632814438$export$af88d00dbe7f521).warn(sentryError);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, scope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $b2bf8ed031d1ff0e$var$isTransactionEvent(event);
        const isError = $b2bf8ed031d1ff0e$var$isErrorEvent(event);
        const eventType = event.type || "error";
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        if (isError && typeof sampleRate === "number" && Math.random() > sampleRate) {
            this.recordDroppedEvent("sample_rate", "error", event);
            return (0, $8285c2d2e65b1e62$export$78e43115b553f358)(new (0, $7a6608dd0661c2da$export$5949942ba2a7c0e2)(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`, "log"));
        }
        const dataCategory = eventType === "replay_event" ? "replay" : eventType;
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        return this._prepareEvent(event, hint, scope, capturedSpanIsolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent("event_processor", dataCategory, event);
                throw new (0, $7a6608dd0661c2da$export$5949942ba2a7c0e2)("An event processor returned `null`, will not send event.", "log");
            }
            const isInternalException = hint.data && hint.data.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $b2bf8ed031d1ff0e$var$processBeforeSend(options, prepared, hint);
            return $b2bf8ed031d1ff0e$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent("before_send", dataCategory, event);
                throw new (0, $7a6608dd0661c2da$export$5949942ba2a7c0e2)(`${beforeSendLabel} returned \`null\`, will not send event.`, "log");
            }
            const session = scope && scope.getSession();
            if (!isTransaction && session) this._updateSessionFromEvent(session, processedEvent);
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = "custom";
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if (reason instanceof (0, $7a6608dd0661c2da$export$5949942ba2a7c0e2)) throw reason;
            this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw new (0, $7a6608dd0661c2da$export$5949942ba2a7c0e2)(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(promise) {
        this._numProcessing++;
        promise.then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            return reason;
        });
    }
    /**
   * @inheritdoc
   */ _sendEnvelope(envelope) {
        this.emit("beforeEnvelope", envelope);
        if (this._isEnabled() && this._transport) return this._transport.send(envelope).then(null, (reason)=>{
            (0, $217bdd4a17a6f5aa$export$16a28057038b10ef) && (0, $fa35a81632814438$export$af88d00dbe7f521).error("Error while sending event:", reason);
        });
        else (0, $217bdd4a17a6f5aa$export$16a28057038b10ef) && (0, $fa35a81632814438$export$af88d00dbe7f521).error("Transport disabled");
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.keys(outcomes).map((key)=>{
            const [reason, category] = key.split(":");
            return {
                reason: reason,
                category: category,
                quantity: outcomes[key]
            };
        });
    }
}
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $b2bf8ed031d1ff0e$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $9cb15bc4eaa635db$export$f5b060c2914b97c8)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $9cb15bc4eaa635db$export$53b83ca8eaab0383)(event) && event !== null) throw new (0, $7a6608dd0661c2da$export$5949942ba2a7c0e2)(invalidValueError);
        return event;
    }, (e)=>{
        throw new (0, $7a6608dd0661c2da$export$5949942ba2a7c0e2)(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $9cb15bc4eaa635db$export$53b83ca8eaab0383)(beforeSendResult) && beforeSendResult !== null) throw new (0, $7a6608dd0661c2da$export$5949942ba2a7c0e2)(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $b2bf8ed031d1ff0e$var$processBeforeSend(options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction } = options;
    if ($b2bf8ed031d1ff0e$var$isErrorEvent(event) && beforeSend) return beforeSend(event, hint);
    if ($b2bf8ed031d1ff0e$var$isTransactionEvent(event) && beforeSendTransaction) return beforeSendTransaction(event, hint);
    return event;
}
function $b2bf8ed031d1ff0e$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $b2bf8ed031d1ff0e$var$isTransactionEvent(event) {
    return event.type === "transaction";
}
/**
 * Add an event processor to the current client.
 * This event processor will run for all events processed by this client.
 */ function $b2bf8ed031d1ff0e$export$9aac0b9f77928fbf(callback) {
    const client = (0, $3bf2cc17570e59fe$export$6bb76d6eba7e258c)();
    if (!client || !client.addEventProcessor) return;
    client.addEventProcessor(callback);
}




/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $2f3dd50741535725$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: "client_report"
        },
        {
            timestamp: timestamp || (0, $5874e77f331c673b$export$7740643b9eeaf0c4)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $2be9719d61f0a0f7$export$f93f7f385160c44e)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}

/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $1035b921f61838d7$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== "undefined" && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $1035b921f61838d7$export$8ad33f488b1ab046() {
    // @ts-expect-error "npm" is injected by rollup during build process
    return "npm";
}


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $16c176aae8900ce3$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;




/**
 * This function creates an exception from a JavaScript Error
 */ function $a2546dabde390261$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $a2546dabde390261$export$d478b2c12fbcfdda(stackParser, ex);
    const exception = {
        type: ex && ex.name,
        value: $a2546dabde390261$var$extractMessage(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === "") exception.value = "Unrecoverable error caught";
    return exception;
}
/**
 * @hidden
 */ function $a2546dabde390261$export$a6a5dd73e489caf(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $3bf2cc17570e59fe$export$6bb76d6eba7e258c)();
    const normalizeDepth = client && client.getOptions().normalizeDepth;
    const event = {
        exception: {
            values: [
                {
                    type: (0, $9cb15bc4eaa635db$export$9671ea99bd126ace)(exception) ? exception.constructor.name : isUnhandledRejection ? "UnhandledRejection" : "Error",
                    value: $a2546dabde390261$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: {
            __serialized__: (0, $05c209cb09bdd9f5$export$23fbbb20bed71033)(exception, normalizeDepth)
        }
    };
    if (syntheticException) {
        const frames = $a2546dabde390261$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
/**
 * @hidden
 */ function $a2546dabde390261$export$73fbea5a0a5234af(stackParser, ex) {
    return {
        exception: {
            values: [
                $a2546dabde390261$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $a2546dabde390261$export$d478b2c12fbcfdda(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || "";
    const popSize = $a2546dabde390261$var$getPopSize(ex);
    try {
        return stackParser(stacktrace, popSize);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $a2546dabde390261$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $a2546dabde390261$var$getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === "number") return ex.framesToPop;
        if ($a2546dabde390261$var$reactMinifiedRegexp.test(ex.message)) return 1;
    }
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $a2546dabde390261$var$extractMessage(ex) {
    const message = ex && ex.message;
    if (!message) return "No error message";
    if (message.error && typeof message.error.message === "string") return message.error.message;
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $a2546dabde390261$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $a2546dabde390261$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $bc1dfbb58bc0f8fc$export$c69a9a0313b03bb1)(event); // defaults to { type: 'generic', handled: true }
    event.level = "error";
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $8285c2d2e65b1e62$export$1fda8aa4d135f8aa)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $a2546dabde390261$export$5425b53185d13d6c(stackParser, message, // eslint-disable-next-line deprecation/deprecation
level = "info", hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $a2546dabde390261$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $8285c2d2e65b1e62$export$1fda8aa4d135f8aa)(event);
}
/**
 * @hidden
 */ function $a2546dabde390261$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $9cb15bc4eaa635db$export$9f9636d330b71954)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $a2546dabde390261$export$73fbea5a0a5234af(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $9cb15bc4eaa635db$export$ef9e2056653f0c8e)(exception) || (0, $9cb15bc4eaa635db$export$12e869b2a583f783)(exception)) {
        const domException = exception;
        if ("stack" in exception) event = $a2546dabde390261$export$73fbea5a0a5234af(stackParser, exception);
        else {
            const name = domException.name || ((0, $9cb15bc4eaa635db$export$ef9e2056653f0c8e)(domException) ? "DOMError" : "DOMException");
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $a2546dabde390261$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
            (0, $bc1dfbb58bc0f8fc$export$f26508487bf83ee7)(event, message);
        }
        if ("code" in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = {
            ...event.tags,
            "DOMException.code": `${domException.code}`
        };
        return event;
    }
    if ((0, $9cb15bc4eaa635db$export$e6127cc7fe7395c3)(exception)) // we have a real Error object, do nothing
    return $a2546dabde390261$export$73fbea5a0a5234af(stackParser, exception);
    if ((0, $9cb15bc4eaa635db$export$53b83ca8eaab0383)(exception) || (0, $9cb15bc4eaa635db$export$9671ea99bd126ace)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $a2546dabde390261$export$a6a5dd73e489caf(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $bc1dfbb58bc0f8fc$export$c69a9a0313b03bb1)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $a2546dabde390261$export$47d86ae4b3c9994(stackParser, exception, syntheticException, attachStacktrace);
    (0, $bc1dfbb58bc0f8fc$export$f26508487bf83ee7)(event, `${exception}`, undefined);
    (0, $bc1dfbb58bc0f8fc$export$c69a9a0313b03bb1)(event, {
        synthetic: true
    });
    return event;
}
/**
 * @hidden
 */ function $a2546dabde390261$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $a2546dabde390261$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
    }
    if ((0, $9cb15bc4eaa635db$export$dbcbffa59149b824)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $a2546dabde390261$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $c617c17708158965$export$b0244d5063c0b61b)(exception);
    const captureType = isUnhandledRejection ? "promise rejection" : "exception";
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $9cb15bc4eaa635db$export$9f9636d330b71954)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $9cb15bc4eaa635db$export$9671ea99bd126ace)(exception)) {
        const className = $a2546dabde390261$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $a2546dabde390261$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch (e) {
    // ignore errors here
    }
}





const $85f84a1a61bc748e$export$56d8a8a25bd48b81 = (0, $42ab17974bcac25b$export$f1a6cdb1459e81d1);
let $85f84a1a61bc748e$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $85f84a1a61bc748e$export$b79738ab10c590b2() {
    return $85f84a1a61bc748e$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $85f84a1a61bc748e$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $85f84a1a61bc748e$var$ignoreOnError++;
    setTimeout(()=>{
        $85f84a1a61bc748e$var$ignoreOnError--;
    });
}
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $85f84a1a61bc748e$export$4997ffc0176396a6(fn, options = {}, before) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (typeof fn !== "function") return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) return wrapper;
        // We don't wanna wrap it twice
        if ((0, $c617c17708158965$export$e6cc1e135e2092e5)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */ // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function() {
        const args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === "function") before.apply(this, arguments);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            const wrappedArguments = args.map((arg)=>$85f84a1a61bc748e$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $85f84a1a61bc748e$export$1265a142ff5ba165();
            (0, $3bf2cc17570e59fe$export$ec58d9285c204497)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $bc1dfbb58bc0f8fc$export$f26508487bf83ee7)(event, undefined, undefined);
                        (0, $bc1dfbb58bc0f8fc$export$c69a9a0313b03bb1)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $3bf2cc17570e59fe$export$f5282963edea4a68)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */ // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (_oO) {} // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $c617c17708158965$export$5c1499e2e5d010ae)(sentryWrapped, fn);
    (0, $c617c17708158965$export$e73679ffaf56810e)(fn, "__sentry_wrapped__", sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, "name");
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, "name", {
            get () {
                return fn.name;
            }
        });
    // eslint-disable-next-line no-empty
    } catch (_oO) {}
    return sentryWrapped;
}



/**
 * Creates an envelope from a user feedback.
 */ function $73a3ec2fb2cd2a23$export$24a4dfcb686ee5bf(feedback, { metadata: metadata, tunnel: tunnel, dsn: dsn }) {
    const headers = {
        event_id: feedback.event_id,
        sent_at: new Date().toISOString(),
        ...metadata && metadata.sdk && {
            sdk: {
                name: metadata.sdk.name,
                version: metadata.sdk.version
            }
        },
        ...!!tunnel && !!dsn && {
            dsn: (0, $0de8772d34f1438f$export$44d472fbb931a776)(dsn)
        }
    };
    const item = $73a3ec2fb2cd2a23$var$createUserFeedbackEnvelopeItem(feedback);
    return (0, $2be9719d61f0a0f7$export$f93f7f385160c44e)(headers, [
        item
    ]);
}
function $73a3ec2fb2cd2a23$var$createUserFeedbackEnvelopeItem(feedback) {
    const feedbackHeaders = {
        type: "user_report"
    };
    return [
        feedbackHeaders,
        feedback
    ];
}


/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/types Options for more information.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $3ab33ded96eddacd$export$1df9218a526d318d extends (0, $b2bf8ed031d1ff0e$export$4f22f74eddb7716a) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const sdkSource = (0, $85f84a1a61bc748e$export$56d8a8a25bd48b81).SENTRY_SDK_SOURCE || (0, $1035b921f61838d7$export$8ad33f488b1ab046)();
        (0, $1254ff1f1760ff55$export$b9f95b027256052c)(options, "browser", [
            "browser"
        ], sdkSource);
        super(options);
        if (options.sendClientReports && (0, $85f84a1a61bc748e$export$56d8a8a25bd48b81).document) (0, $85f84a1a61bc748e$export$56d8a8a25bd48b81).document.addEventListener("visibilitychange", ()=>{
            if ((0, $85f84a1a61bc748e$export$56d8a8a25bd48b81).document.visibilityState === "hidden") this._flushOutcomes();
        });
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $a2546dabde390261$export$ea3ec7e569b823fc)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, // eslint-disable-next-line deprecation/deprecation
    level = "info", hint) {
        return (0, $a2546dabde390261$export$5425b53185d13d6c)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * Sends user feedback to Sentry.
   */ captureUserFeedback(feedback) {
        if (!this._isEnabled()) {
            (0, $16c176aae8900ce3$export$16a28057038b10ef) && (0, $fa35a81632814438$export$af88d00dbe7f521).warn("SDK not enabled, will not capture user feedback.");
            return;
        }
        const envelope = (0, $73a3ec2fb2cd2a23$export$24a4dfcb686ee5bf)(feedback, {
            metadata: this.getSdkMetadata(),
            dsn: this.getDsn(),
            tunnel: this.getOptions().tunnel
        });
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(envelope);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, scope) {
        event.platform = event.platform || "javascript";
        return super._prepareEvent(event, hint, scope);
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (0, $16c176aae8900ce3$export$16a28057038b10ef) && (0, $fa35a81632814438$export$af88d00dbe7f521).log("No outcomes to send");
            return;
        }
        // This is really the only place where we want to check for a DSN and only send outcomes then
        if (!this._dsn) {
            (0, $16c176aae8900ce3$export$16a28057038b10ef) && (0, $fa35a81632814438$export$af88d00dbe7f521).log("No dsn provided, will not send outcomes");
            return;
        }
        (0, $16c176aae8900ce3$export$16a28057038b10ef) && (0, $fa35a81632814438$export$af88d00dbe7f521).log("Sending outcomes:", outcomes);
        const envelope = (0, $2f3dd50741535725$export$f3b9ed77c03eeb00)(outcomes, this._options.tunnel && (0, $0de8772d34f1438f$export$44d472fbb931a776)(this._dsn));
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(envelope);
    }
}









const $8916457187946c85$var$WINDOW = (0, $42ab17974bcac25b$export$f1a6cdb1459e81d1);
const $8916457187946c85$var$DEBOUNCE_DURATION = 1000;
let $8916457187946c85$var$debounceTimerID;
let $8916457187946c85$var$lastCapturedEventType;
let $8916457187946c85$var$lastCapturedEventTargetId;
/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $8916457187946c85$export$5aeffd3db2cf9df7(handler) {
    const type = "dom";
    (0, $2bd4cb908ffa433c$export$a4e09611e30da72e)(type, handler);
    (0, $2bd4cb908ffa433c$export$e18d6c5462c01368)(type, $8916457187946c85$export$3014bbf0af0e1d4a);
}
/** Exported for tests only. */ function $8916457187946c85$export$3014bbf0af0e1d4a() {
    if (!$8916457187946c85$var$WINDOW.document) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = (0, $2bd4cb908ffa433c$export$b18c893e424d3127).bind(null, "dom");
    const globalDOMEventHandler = $8916457187946c85$var$makeDOMEventHandler(triggerDOMHandler, true);
    $8916457187946c85$var$WINDOW.document.addEventListener("click", globalDOMEventHandler, false);
    $8916457187946c85$var$WINDOW.document.addEventListener("keypress", globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        "EventTarget",
        "Node"
    ].forEach((target)=>{
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        const proto = $8916457187946c85$var$WINDOW[target] && $8916457187946c85$var$WINDOW[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) return;
        (0, $c617c17708158965$export$9563e054e6f787fb)(proto, "addEventListener", function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $8916457187946c85$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $c617c17708158965$export$9563e054e6f787fb)(proto, "removeEventListener", function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete el.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */ function $8916457187946c85$var$isSimilarToLastCapturedEvent(event) {
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (event.type !== $8916457187946c85$var$lastCapturedEventType) return false;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (!event.target || event.target._sentryId !== $8916457187946c85$var$lastCapturedEventTargetId) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return true;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $8916457187946c85$var$shouldSkipDOMEvent(eventType, target) {
    // We are only interested in filtering `keypress` events for now.
    if (eventType !== "keypress") return false;
    if (!target || !target.tagName) return true;
    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable) return false;
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 */ function $8916457187946c85$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || event["_sentryCaptured"]) return;
        const target = $8916457187946c85$var$getEventTarget(event);
        // We always want to skip _some_ events.
        if ($8916457187946c85$var$shouldSkipDOMEvent(event.type, target)) return;
        // Mark event as "seen"
        (0, $c617c17708158965$export$e73679ffaf56810e)(event, "_sentryCaptured", true);
        if (target && !target._sentryId) // Add UUID to event target so we can identify if
        (0, $c617c17708158965$export$e73679ffaf56810e)(target, "_sentryId", (0, $bc1dfbb58bc0f8fc$export$19f53698e68b2496)());
        const name = event.type === "keypress" ? "input" : event.type;
        // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
        // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        if (!$8916457187946c85$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $8916457187946c85$var$lastCapturedEventType = event.type;
            $8916457187946c85$var$lastCapturedEventTargetId = target ? target._sentryId : undefined;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($8916457187946c85$var$debounceTimerID);
        $8916457187946c85$var$debounceTimerID = $8916457187946c85$var$WINDOW.setTimeout(()=>{
            $8916457187946c85$var$lastCapturedEventTargetId = undefined;
            $8916457187946c85$var$lastCapturedEventType = undefined;
        }, $8916457187946c85$var$DEBOUNCE_DURATION);
    };
}
function $8916457187946c85$var$getEventTarget(event) {
    try {
        return event.target;
    } catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
        return null;
    }
}





/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $d7c0ef15d0fe9fb6$export$1d6e0d073f9e6723(handler) {
    const type = "console";
    (0, $2bd4cb908ffa433c$export$a4e09611e30da72e)(type, handler);
    (0, $2bd4cb908ffa433c$export$e18d6c5462c01368)(type, $d7c0ef15d0fe9fb6$var$instrumentConsole);
}
function $d7c0ef15d0fe9fb6$var$instrumentConsole() {
    if (!("console" in (0, $42ab17974bcac25b$export$f1a6cdb1459e81d1))) return;
    (0, $fa35a81632814438$export$2a2b1d2252a69ecb).forEach(function(level) {
        if (!(level in (0, $42ab17974bcac25b$export$f1a6cdb1459e81d1).console)) return;
        (0, $c617c17708158965$export$9563e054e6f787fb)((0, $42ab17974bcac25b$export$f1a6cdb1459e81d1).console, level, function(originalConsoleMethod) {
            (0, $fa35a81632814438$export$77c4ce905194557b)[level] = originalConsoleMethod;
            return function(...args) {
                const handlerData = {
                    args: args,
                    level: level
                };
                (0, $2bd4cb908ffa433c$export$b18c893e424d3127)("console", handlerData);
                const log = (0, $fa35a81632814438$export$77c4ce905194557b)[level];
                log && log.apply((0, $42ab17974bcac25b$export$f1a6cdb1459e81d1).console, args);
            };
        });
    });
}





/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $1a388c3acbfbb74a$export$f75d3c772c923df0(handler) {
    const type = "fetch";
    (0, $2bd4cb908ffa433c$export$a4e09611e30da72e)(type, handler);
    (0, $2bd4cb908ffa433c$export$e18d6c5462c01368)(type, $1a388c3acbfbb74a$var$instrumentFetch);
}
function $1a388c3acbfbb74a$var$instrumentFetch() {
    if (!(0, $f0fcb9d2dddc107a$export$c82d238e23c40b21)()) return;
    (0, $c617c17708158965$export$9563e054e6f787fb)((0, $42ab17974bcac25b$export$f1a6cdb1459e81d1), "fetch", function(originalFetch) {
        return function(...args) {
            const { method: method, url: url } = $1a388c3acbfbb74a$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: Date.now()
            };
            (0, $2bd4cb908ffa433c$export$b18c893e424d3127)("fetch", {
                ...handlerData
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply((0, $42ab17974bcac25b$export$f1a6cdb1459e81d1), args).then((response)=>{
                const finishedHandlerData = {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    response: response
                };
                (0, $2bd4cb908ffa433c$export$b18c893e424d3127)("fetch", finishedHandlerData);
                return response;
            }, (error)=>{
                const erroredHandlerData = {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    error: error
                };
                (0, $2bd4cb908ffa433c$export$b18c893e424d3127)("fetch", erroredHandlerData);
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
function $1a388c3acbfbb74a$var$hasProp(obj, prop) {
    return !!obj && typeof obj === "object" && !!obj[prop];
}
function $1a388c3acbfbb74a$var$getUrlFromResource(resource) {
    if (typeof resource === "string") return resource;
    if (!resource) return "";
    if ($1a388c3acbfbb74a$var$hasProp(resource, "url")) return resource.url;
    if (resource.toString) return resource.toString();
    return "";
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function $1a388c3acbfbb74a$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: "GET",
        url: ""
    };
    if (fetchArgs.length === 2) {
        const [url, options] = fetchArgs;
        return {
            url: $1a388c3acbfbb74a$var$getUrlFromResource(url),
            method: $1a388c3acbfbb74a$var$hasProp(options, "method") ? String(options.method).toUpperCase() : "GET"
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $1a388c3acbfbb74a$var$getUrlFromResource(arg),
        method: $1a388c3acbfbb74a$var$hasProp(arg, "method") ? String(arg.method).toUpperCase() : "GET"
    };
}





const $352b7fbf00f71503$var$WINDOW = (0, $42ab17974bcac25b$export$f1a6cdb1459e81d1);
const $352b7fbf00f71503$export$55b6bb1e45c6cf59 = "__sentry_xhr_v3__";
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $352b7fbf00f71503$export$26ace48dd54c9aea(handler) {
    const type = "xhr";
    (0, $2bd4cb908ffa433c$export$a4e09611e30da72e)(type, handler);
    (0, $2bd4cb908ffa433c$export$e18d6c5462c01368)(type, $352b7fbf00f71503$export$c67d533bf77cbf54);
}
/** Exported only for tests. */ function $352b7fbf00f71503$export$c67d533bf77cbf54() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (!$352b7fbf00f71503$var$WINDOW.XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    (0, $c617c17708158965$export$9563e054e6f787fb)(xhrproto, "open", function(originalOpen) {
        return function(...args) {
            const startTimestamp = Date.now();
            // open() should always be called with two or more arguments
            // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
            const method = (0, $9cb15bc4eaa635db$export$844ec244b1367d54)(args[0]) ? args[0].toUpperCase() : undefined;
            const url = $352b7fbf00f71503$var$parseUrl(args[1]);
            if (!method || !url) return originalOpen.apply(this, args);
            this[$352b7fbf00f71503$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (method === "POST" && url.match(/sentry_key/)) this.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = this[$352b7fbf00f71503$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (this.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = this.status;
                    } catch (e) {
                    /* do nothing */ }
                    const handlerData = {
                        args: [
                            method,
                            url
                        ],
                        endTimestamp: Date.now(),
                        startTimestamp: startTimestamp,
                        xhr: this
                    };
                    (0, $2bd4cb908ffa433c$export$b18c893e424d3127)("xhr", handlerData);
                }
            };
            if ("onreadystatechange" in this && typeof this.onreadystatechange === "function") (0, $c617c17708158965$export$9563e054e6f787fb)(this, "onreadystatechange", function(original) {
                return function(...readyStateArgs) {
                    onreadystatechangeHandler();
                    return original.apply(this, readyStateArgs);
                };
            });
            else this.addEventListener("readystatechange", onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            (0, $c617c17708158965$export$9563e054e6f787fb)(this, "setRequestHeader", function(original) {
                return function(...setRequestHeaderArgs) {
                    const [header, value] = setRequestHeaderArgs;
                    const xhrInfo = this[$352b7fbf00f71503$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $9cb15bc4eaa635db$export$844ec244b1367d54)(header) && (0, $9cb15bc4eaa635db$export$844ec244b1367d54)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return original.apply(this, setRequestHeaderArgs);
                };
            });
            return originalOpen.apply(this, args);
        };
    });
    (0, $c617c17708158965$export$9563e054e6f787fb)(xhrproto, "send", function(originalSend) {
        return function(...args) {
            const sentryXhrData = this[$352b7fbf00f71503$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(this, args);
            if (args[0] !== undefined) sentryXhrData.body = args[0];
            const handlerData = {
                args: [
                    sentryXhrData.method,
                    sentryXhrData.url
                ],
                startTimestamp: Date.now(),
                xhr: this
            };
            (0, $2bd4cb908ffa433c$export$b18c893e424d3127)("xhr", handlerData);
            return originalSend.apply(this, args);
        };
    });
}
function $352b7fbf00f71503$var$parseUrl(url) {
    if ((0, $9cb15bc4eaa635db$export$844ec244b1367d54)(url)) return url;
    try {
        // url can be a string or URL
        // but since URL is not available in IE11, we do not check for it,
        // but simply assume it is an URL and return `toString()` from it (which returns the full URL)
        // If that fails, we just return undefined
        return url.toString();
    } catch (e2) {} // eslint-disable-line no-empty
    return undefined;
}

/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $6944bb0515e727a7$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || "";
    const fragment = match[8] || "";
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $6944bb0515e727a7$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
/**
 * Returns number of URL segments of a passed string URL.
 */ function $6944bb0515e727a7$export$69dd85280a8d374c(url) {
    // split at '/' or at '\/' to split regex urls correctly
    return url.split(/\\?\//).filter((s)=>s.length > 0 && s !== ",").length;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span description
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $6944bb0515e727a7$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host && host// Always filter out authority
    .replace(/^.*@/, "[filtered]:[filtered]@")// Don't show standard :80 (http) and :443 (https) ports to reduce the noise
    // TODO: Use new URL global if it exists
    .replace(/(:80)$/, "").replace(/(:443)$/, "") || "";
    return `${protocol ? `${protocol}://` : ""}${filteredHost}${path}`;
}

// Note: Ideally the `SeverityLevel` type would be derived from `validSeverityLevels`, but that would mean either
//
// a) moving `validSeverityLevels` to `@sentry/types`,
// b) moving the`SeverityLevel` type here, or
// c) importing `validSeverityLevels` from here into `@sentry/types`.
//
// Option A would make `@sentry/types` a runtime dependency of `@sentry/utils` (not good), and options B and C would
// create a circular dependency between `@sentry/types` and `@sentry/utils` (also not good). So a TODO accompanying the
// type, reminding anyone who changes it to change this list also, will have to do.
const $9982d13d4d1e2977$export$411d0ffdba845b6c = [
    "fatal",
    "error",
    "warning",
    "log",
    "info",
    "debug"
];
/**
 * Converts a string-based level into a member of the deprecated {@link Severity} enum.
 *
 * @deprecated `severityFromString` is deprecated. Please use `severityLevelFromString` instead.
 *
 * @param level String representation of Severity
 * @returns Severity
 */ function $9982d13d4d1e2977$export$e01cef29b4327697(level) {
    return $9982d13d4d1e2977$export$d771ef054122c30a(level);
}
/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $9982d13d4d1e2977$export$d771ef054122c30a(level) {
    return level === "warn" ? "warning" : $9982d13d4d1e2977$export$411d0ffdba845b6c.includes(level) ? level : "log";
}




/* eslint-disable max-lines */ /** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $43431361d45b53ad$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $43431361d45b53ad$var$INTEGRATION_NAME = "Breadcrumbs";
const $43431361d45b53ad$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $43431361d45b53ad$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        setup (client) {
            if (_options.console) (0, $d7c0ef15d0fe9fb6$export$1d6e0d073f9e6723)($43431361d45b53ad$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $8916457187946c85$export$5aeffd3db2cf9df7)($43431361d45b53ad$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $352b7fbf00f71503$export$26ace48dd54c9aea)($43431361d45b53ad$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $1a388c3acbfbb74a$export$f75d3c772c923df0)($43431361d45b53ad$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $0e7bd0efb15b353d$export$3f18c56c58114e75)($43431361d45b53ad$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry && client.on) client.on("beforeSendEvent", $43431361d45b53ad$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $43431361d45b53ad$export$c079d904b326663a = (0, $cf0d247f1c37a8e9$export$2323046b9414659f)($43431361d45b53ad$var$_breadcrumbsIntegration);
/**
 * Default Breadcrumbs instrumentations
 *
 * @deprecated Use `breadcrumbsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $43431361d45b53ad$export$2dc68d50d56fbbd = (0, $cf0d247f1c37a8e9$export$afa219bf23651160)($43431361d45b53ad$var$INTEGRATION_NAME, $43431361d45b53ad$export$c079d904b326663a);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function $43431361d45b53ad$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $3bf2cc17570e59fe$export$6bb76d6eba7e258c)() !== client) return;
        (0, $3bf2cc17570e59fe$export$efda9a273d7a036d)({
            category: `sentry.${event.type === "transaction" ? "transaction" : "event"}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $bc1dfbb58bc0f8fc$export$4157119e2b157127)(event)
        }, {
            event: event
        });
    };
}
/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $43431361d45b53ad$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $3bf2cc17570e59fe$export$6bb76d6eba7e258c)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === "object" ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === "object" && typeof dom.maxStringLength === "number" ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $43431361d45b53ad$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $16c176aae8900ce3$export$16a28057038b10ef) && (0, $fa35a81632814438$export$af88d00dbe7f521).warn(`\`dom.maxStringLength\` cannot exceed ${$43431361d45b53ad$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$43431361d45b53ad$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $43431361d45b53ad$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === "string") keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            const element = $43431361d45b53ad$var$_isEvent(event) ? event.target : event;
            target = (0, $0d4e7eac897b5a5b$export$5647df6b7814ac86)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $0d4e7eac897b5a5b$export$26727cfcc4d7e0fc)(element);
        } catch (e) {
            target = "<unknown>";
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            "ui.component_name": componentName
        };
        (0, $3bf2cc17570e59fe$export$efda9a273d7a036d)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function $43431361d45b53ad$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $3bf2cc17570e59fe$export$6bb76d6eba7e258c)() !== client) return;
        const breadcrumb = {
            category: "console",
            data: {
                arguments: handlerData.args,
                logger: "console"
            },
            level: (0, $9982d13d4d1e2977$export$d771ef054122c30a)(handlerData.level),
            message: (0, $6185c1fc30855c3e$export$465e9d514283d4fd)(handlerData.args, " ")
        };
        if (handlerData.level === "assert") {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $6185c1fc30855c3e$export$465e9d514283d4fd)(handlerData.args.slice(1), " ") || "console.assert"}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, $3bf2cc17570e59fe$export$efda9a273d7a036d)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $43431361d45b53ad$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $3bf2cc17570e59fe$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $352b7fbf00f71503$export$55b6bb1e45c6cf59];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        (0, $3bf2cc17570e59fe$export$efda9a273d7a036d)({
            category: "xhr",
            data: data,
            type: "http"
        }, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $43431361d45b53ad$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $3bf2cc17570e59fe$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        // We only capture complete fetch requests
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === "POST") // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        if (handlerData.error) {
            const data = handlerData.fetchData;
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $3bf2cc17570e59fe$export$efda9a273d7a036d)({
                category: "fetch",
                data: data,
                level: "error",
                type: "http"
            }, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response && response.status
            };
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $3bf2cc17570e59fe$export$efda9a273d7a036d)({
                category: "fetch",
                data: data,
                type: "http"
            }, hint);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function $43431361d45b53ad$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $3bf2cc17570e59fe$export$6bb76d6eba7e258c)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $6944bb0515e727a7$export$7a5253c0f62e0150)((0, $85f84a1a61bc748e$export$56d8a8a25bd48b81).location.href);
        let parsedFrom = from ? (0, $6944bb0515e727a7$export$7a5253c0f62e0150)(from) : undefined;
        const parsedTo = (0, $6944bb0515e727a7$export$7a5253c0f62e0150)(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom || !parsedFrom.path) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $3bf2cc17570e59fe$export$efda9a273d7a036d)({
            category: "navigation",
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $43431361d45b53ad$var$_isEvent(event) {
    return !!event && !!event.target;
}





const $305ba4656b814920$var$INTEGRATION_NAME = "Dedupe";
const $305ba4656b814920$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $305ba4656b814920$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($305ba4656b814920$var$_shouldDropEvent(currentEvent, previousEvent)) {
                    (0, $16c176aae8900ce3$export$16a28057038b10ef) && (0, $fa35a81632814438$export$af88d00dbe7f521).warn("Event dropped due to being a duplicate of previously captured event.");
                    return null;
                }
            } catch (_oO) {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
const $305ba4656b814920$export$6d39aa44cd0c7567 = (0, $cf0d247f1c37a8e9$export$2323046b9414659f)($305ba4656b814920$var$_dedupeIntegration);
/**
 * Deduplication filter.
 * @deprecated Use `dedupeIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $305ba4656b814920$export$688d98c249d31ad3 = (0, $cf0d247f1c37a8e9$export$afa219bf23651160)($305ba4656b814920$var$INTEGRATION_NAME, $305ba4656b814920$export$6d39aa44cd0c7567);
function $305ba4656b814920$var$_shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($305ba4656b814920$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($305ba4656b814920$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $305ba4656b814920$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$305ba4656b814920$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$305ba4656b814920$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $305ba4656b814920$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $305ba4656b814920$var$_getExceptionFromEvent(previousEvent);
    const currentException = $305ba4656b814920$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$305ba4656b814920$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$305ba4656b814920$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $305ba4656b814920$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = $305ba4656b814920$var$_getFramesFromEvent(currentEvent);
    let previousFrames = $305ba4656b814920$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        const frameA = previousFrames[i];
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $305ba4656b814920$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join("") === previousFingerprint.join(""));
    } catch (_oO) {
        return false;
    }
}
function $305ba4656b814920$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
function $305ba4656b814920$var$_getFramesFromEvent(event) {
    const exception = event.exception;
    if (exception) try {
        // @ts-expect-error Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    return undefined;
}





let $4bc4163a3d6d725c$var$_oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $4bc4163a3d6d725c$export$55b5c3ba2194f0c6(handler) {
    const type = "error";
    (0, $2bd4cb908ffa433c$export$a4e09611e30da72e)(type, handler);
    (0, $2bd4cb908ffa433c$export$e18d6c5462c01368)(type, $4bc4163a3d6d725c$var$instrumentError);
}
function $4bc4163a3d6d725c$var$instrumentError() {
    $4bc4163a3d6d725c$var$_oldOnErrorHandler = (0, $42ab17974bcac25b$export$f1a6cdb1459e81d1).onerror;
    (0, $42ab17974bcac25b$export$f1a6cdb1459e81d1).onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0, $2bd4cb908ffa433c$export$b18c893e424d3127)("error", handlerData);
        if ($4bc4163a3d6d725c$var$_oldOnErrorHandler && !$4bc4163a3d6d725c$var$_oldOnErrorHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $4bc4163a3d6d725c$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, $42ab17974bcac25b$export$f1a6cdb1459e81d1).onerror.__SENTRY_INSTRUMENTED__ = true;
}



let $0949ffdd0e6c569d$var$_oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $0949ffdd0e6c569d$export$8bf4fc6858821a4e(handler) {
    const type = "unhandledrejection";
    (0, $2bd4cb908ffa433c$export$a4e09611e30da72e)(type, handler);
    (0, $2bd4cb908ffa433c$export$e18d6c5462c01368)(type, $0949ffdd0e6c569d$var$instrumentUnhandledRejection);
}
function $0949ffdd0e6c569d$var$instrumentUnhandledRejection() {
    $0949ffdd0e6c569d$var$_oldOnUnhandledRejectionHandler = (0, $42ab17974bcac25b$export$f1a6cdb1459e81d1).onunhandledrejection;
    (0, $42ab17974bcac25b$export$f1a6cdb1459e81d1).onunhandledrejection = function(e) {
        const handlerData = e;
        (0, $2bd4cb908ffa433c$export$b18c893e424d3127)("unhandledrejection", handlerData);
        if ($0949ffdd0e6c569d$var$_oldOnUnhandledRejectionHandler && !$0949ffdd0e6c569d$var$_oldOnUnhandledRejectionHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $0949ffdd0e6c569d$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, $42ab17974bcac25b$export$f1a6cdb1459e81d1).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}





/* eslint-disable @typescript-eslint/no-unsafe-member-access */ const $c198e1f6e08732c9$var$INTEGRATION_NAME = "GlobalHandlers";
const $c198e1f6e08732c9$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $c198e1f6e08732c9$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $c198e1f6e08732c9$var$_installGlobalOnErrorHandler(client);
                $c198e1f6e08732c9$var$globalHandlerLog("onerror");
            }
            if (_options.onunhandledrejection) {
                $c198e1f6e08732c9$var$_installGlobalOnUnhandledRejectionHandler(client);
                $c198e1f6e08732c9$var$globalHandlerLog("onunhandledrejection");
            }
        }
    };
};
const $c198e1f6e08732c9$export$66acc70e8cf2b71a = (0, $cf0d247f1c37a8e9$export$2323046b9414659f)($c198e1f6e08732c9$var$_globalHandlersIntegration);
/**
 * Global handlers.
 * @deprecated Use `globalHandlersIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $c198e1f6e08732c9$export$204155decbc90e5a = (0, $cf0d247f1c37a8e9$export$afa219bf23651160)($c198e1f6e08732c9$var$INTEGRATION_NAME, $c198e1f6e08732c9$export$66acc70e8cf2b71a);
function $c198e1f6e08732c9$var$_installGlobalOnErrorHandler(client) {
    (0, $4bc4163a3d6d725c$export$55b5c3ba2194f0c6)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $c198e1f6e08732c9$var$getOptions();
        if ((0, $3bf2cc17570e59fe$export$6bb76d6eba7e258c)() !== client || (0, $85f84a1a61bc748e$export$b79738ab10c590b2)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = error === undefined && (0, $9cb15bc4eaa635db$export$844ec244b1367d54)(msg) ? $c198e1f6e08732c9$var$_eventFromIncompleteOnError(msg, url, line, column) : $c198e1f6e08732c9$var$_enhanceEventWithInitialFrame((0, $a2546dabde390261$export$9dd56ed1ef0c3420)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = "error";
        (0, $3bf2cc17570e59fe$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "onerror"
            }
        });
    });
}
function $c198e1f6e08732c9$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $0949ffdd0e6c569d$export$8bf4fc6858821a4e)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $c198e1f6e08732c9$var$getOptions();
        if ((0, $3bf2cc17570e59fe$export$6bb76d6eba7e258c)() !== client || (0, $85f84a1a61bc748e$export$b79738ab10c590b2)()) return;
        const error = $c198e1f6e08732c9$var$_getUnhandledRejectionError(e);
        const event = (0, $9cb15bc4eaa635db$export$c3825b437cbdea5c)(error) ? $c198e1f6e08732c9$var$_eventFromRejectionWithPrimitive(error) : (0, $a2546dabde390261$export$9dd56ed1ef0c3420)(stackParser, error, undefined, attachStacktrace, true);
        event.level = "error";
        (0, $3bf2cc17570e59fe$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "onunhandledrejection"
            }
        });
    });
}
function $c198e1f6e08732c9$var$_getUnhandledRejectionError(error) {
    if ((0, $9cb15bc4eaa635db$export$c3825b437cbdea5c)(error)) return error;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const e = error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ("reason" in e) return e.reason;
        else if ("detail" in e && "reason" in e.detail) return e.detail.reason;
    } catch (e2) {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $c198e1f6e08732c9$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: "UnhandledRejection",
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
/**
 * This function creates a stack from an old, error-less onerror handler.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $c198e1f6e08732c9$var$_eventFromIncompleteOnError(msg, url, line, column) {
    const ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
    // If 'message' is ErrorEvent, get real message from inside
    let message = (0, $9cb15bc4eaa635db$export$9f9636d330b71954)(msg) ? msg.message : msg;
    let name = "Error";
    const groups = message.match(ERROR_TYPES_RE);
    if (groups) {
        name = groups[1];
        message = groups[2];
    }
    const event = {
        exception: {
            values: [
                {
                    type: name,
                    value: message
                }
            ]
        }
    };
    return $c198e1f6e08732c9$var$_enhanceEventWithInitialFrame(event, url, line, column);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $c198e1f6e08732c9$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    const colno = isNaN(parseInt(column, 10)) ? undefined : column;
    const lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    const filename = (0, $9cb15bc4eaa635db$export$844ec244b1367d54)(url) && url.length > 0 ? url : (0, $0d4e7eac897b5a5b$export$1cfafeee2987818b)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: "?",
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $c198e1f6e08732c9$var$globalHandlerLog(type) {
    (0, $16c176aae8900ce3$export$16a28057038b10ef) && (0, $fa35a81632814438$export$af88d00dbe7f521).log(`Global Handler attached: ${type}`);
}
function $c198e1f6e08732c9$var$getOptions() {
    const client = (0, $3bf2cc17570e59fe$export$6bb76d6eba7e258c)();
    const options = client && client.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}




const $93d2fea2ea91437d$var$INTEGRATION_NAME = "HttpContext";
const $93d2fea2ea91437d$var$_httpContextIntegration = ()=>{
    return {
        name: $93d2fea2ea91437d$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event) {
            // if none of the information we want exists, don't bother
            if (!(0, $85f84a1a61bc748e$export$56d8a8a25bd48b81).navigator && !(0, $85f84a1a61bc748e$export$56d8a8a25bd48b81).location && !(0, $85f84a1a61bc748e$export$56d8a8a25bd48b81).document) return;
            // grab as much info as exists and add it to the event
            const url = event.request && event.request.url || (0, $85f84a1a61bc748e$export$56d8a8a25bd48b81).location && (0, $85f84a1a61bc748e$export$56d8a8a25bd48b81).location.href;
            const { referrer: referrer } = (0, $85f84a1a61bc748e$export$56d8a8a25bd48b81).document || {};
            const { userAgent: userAgent } = (0, $85f84a1a61bc748e$export$56d8a8a25bd48b81).navigator || {};
            const headers = {
                ...event.request && event.request.headers,
                ...referrer && {
                    Referer: referrer
                },
                ...userAgent && {
                    "User-Agent": userAgent
                }
            };
            const request = {
                ...event.request,
                ...url && {
                    url: url
                },
                headers: headers
            };
            event.request = request;
        }
    };
};
const $93d2fea2ea91437d$export$1378794447170364 = (0, $cf0d247f1c37a8e9$export$2323046b9414659f)($93d2fea2ea91437d$var$_httpContextIntegration);
/**
 * HttpContext integration collects information about HTTP request headers.
 * @deprecated Use `httpContextIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $93d2fea2ea91437d$export$5d2ee9a544b09a94 = (0, $cf0d247f1c37a8e9$export$afa219bf23651160)($93d2fea2ea91437d$var$INTEGRATION_NAME, $93d2fea2ea91437d$export$1378794447170364);





/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function $e2383de2cca32146$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser, maxValueLimit = 250, key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !(0, $9cb15bc4eaa635db$export$49034edbe6b62415)(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = $e2383de2cca32146$var$truncateAggregateExceptions($e2383de2cca32146$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0), maxValueLimit);
}
function $e2383de2cca32146$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    // Recursively call this function in order to walk down a chain of errors
    if ((0, $9cb15bc4eaa635db$export$49034edbe6b62415)(error[key], Error)) {
        $e2383de2cca32146$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $e2383de2cca32146$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $e2383de2cca32146$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if (Array.isArray(error.errors)) error.errors.forEach((childError, i)=>{
        if ((0, $9cb15bc4eaa635db$export$49034edbe6b62415)(childError, Error)) {
            $e2383de2cca32146$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $e2383de2cca32146$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $e2383de2cca32146$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $e2383de2cca32146$var$applyExceptionGroupFieldsForParentException(exception, exceptionId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: "generic",
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        ...exception.type === "AggregateError" && {
            is_exception_group: true
        },
        exception_id: exceptionId
    };
}
function $e2383de2cca32146$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: "generic",
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        type: "chained",
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}
/**
 * Truncate the message (exception.value) of all exceptions in the event.
 * Because this event processor is ran after `applyClientOptions`,
 * we need to truncate the message of the added exceptions here.
 */ function $e2383de2cca32146$var$truncateAggregateExceptions(exceptions, maxValueLength) {
    return exceptions.map((exception)=>{
        if (exception.value) exception.value = (0, $6185c1fc30855c3e$export$6a506b36fdea397d)(exception.value, maxValueLength);
        return exception;
    });
}



const $55cdcd545ef3f2e2$var$DEFAULT_KEY = "cause";
const $55cdcd545ef3f2e2$var$DEFAULT_LIMIT = 5;
const $55cdcd545ef3f2e2$var$INTEGRATION_NAME = "LinkedErrors";
const $55cdcd545ef3f2e2$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $55cdcd545ef3f2e2$var$DEFAULT_LIMIT;
    const key = options.key || $55cdcd545ef3f2e2$var$DEFAULT_KEY;
    return {
        name: $55cdcd545ef3f2e2$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $e2383de2cca32146$export$b91c38ed7d8ae9b2)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $a2546dabde390261$export$a6c2d27607295951), options.stackParser, options.maxValueLength, key, limit, event, hint);
        }
    };
};
const $55cdcd545ef3f2e2$export$ebabb00eb7f3a395 = (0, $cf0d247f1c37a8e9$export$2323046b9414659f)($55cdcd545ef3f2e2$var$_linkedErrorsIntegration);
/**
 * Aggregrate linked errors in an event.
 * @deprecated Use `linkedErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $55cdcd545ef3f2e2$export$8d1e60aaf616fb4f = (0, $cf0d247f1c37a8e9$export$afa219bf23651160)($55cdcd545ef3f2e2$var$INTEGRATION_NAME, $55cdcd545ef3f2e2$export$ebabb00eb7f3a395);





const $d3c16872d9dddf05$var$DEFAULT_EVENT_TARGET = [
    "EventTarget",
    "Window",
    "Node",
    "ApplicationCache",
    "AudioTrackList",
    "BroadcastChannel",
    "ChannelMergerNode",
    "CryptoOperation",
    "EventSource",
    "FileReader",
    "HTMLUnknownElement",
    "IDBDatabase",
    "IDBRequest",
    "IDBTransaction",
    "KeyOperation",
    "MediaController",
    "MessagePort",
    "ModalWindow",
    "Notification",
    "SVGElementInstance",
    "Screen",
    "SharedWorker",
    "TextTrack",
    "TextTrackCue",
    "TextTrackList",
    "WebSocket",
    "WebSocketWorker",
    "Worker",
    "XMLHttpRequest",
    "XMLHttpRequestEventTarget",
    "XMLHttpRequestUpload"
];
const $d3c16872d9dddf05$var$INTEGRATION_NAME = "TryCatch";
const $d3c16872d9dddf05$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        ...options
    };
    return {
        name: $d3c16872d9dddf05$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $c617c17708158965$export$9563e054e6f787fb)((0, $85f84a1a61bc748e$export$56d8a8a25bd48b81), "setTimeout", $d3c16872d9dddf05$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $c617c17708158965$export$9563e054e6f787fb)((0, $85f84a1a61bc748e$export$56d8a8a25bd48b81), "setInterval", $d3c16872d9dddf05$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $c617c17708158965$export$9563e054e6f787fb)((0, $85f84a1a61bc748e$export$56d8a8a25bd48b81), "requestAnimationFrame", $d3c16872d9dddf05$var$_wrapRAF);
            if (_options.XMLHttpRequest && "XMLHttpRequest" in (0, $85f84a1a61bc748e$export$56d8a8a25bd48b81)) (0, $c617c17708158965$export$9563e054e6f787fb)(XMLHttpRequest.prototype, "send", $d3c16872d9dddf05$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $d3c16872d9dddf05$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach($d3c16872d9dddf05$var$_wrapEventTarget);
            }
        }
    };
};
const $d3c16872d9dddf05$export$59bfe9f1c76150e = (0, $cf0d247f1c37a8e9$export$2323046b9414659f)($d3c16872d9dddf05$var$_browserApiErrorsIntegration);
/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 * @deprecated Use `browserApiErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $d3c16872d9dddf05$export$f1a018517668e6d3 = (0, $cf0d247f1c37a8e9$export$afa219bf23651160)($d3c16872d9dddf05$var$INTEGRATION_NAME, $d3c16872d9dddf05$export$59bfe9f1c76150e);
function $d3c16872d9dddf05$var$_wrapTimeFunction(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $85f84a1a61bc748e$export$4997ffc0176396a6)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $aa7bfcbdaa2ccf41$export$aad197c7121a6651)(original)
                },
                handled: false,
                type: "instrument"
            }
        });
        return original.apply(this, args);
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $d3c16872d9dddf05$var$_wrapRAF(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(callback) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return original.apply(this, [
            (0, $85f84a1a61bc748e$export$4997ffc0176396a6)(callback, {
                mechanism: {
                    data: {
                        function: "requestAnimationFrame",
                        handler: (0, $aa7bfcbdaa2ccf41$export$aad197c7121a6651)(original)
                    },
                    handled: false,
                    type: "instrument"
                }
            })
        ]);
    };
}
function $d3c16872d9dddf05$var$_wrapXHR(originalSend) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            "onload",
            "onerror",
            "onprogress",
            "onreadystatechange"
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === "function") // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $c617c17708158965$export$9563e054e6f787fb)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $aa7bfcbdaa2ccf41$export$aad197c7121a6651)(original)
                        },
                        handled: false,
                        type: "instrument"
                    }
                };
                // If Instrument integration has been called before TryCatch, get the name of original function
                const originalFunction = (0, $c617c17708158965$export$e6cc1e135e2092e5)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $aa7bfcbdaa2ccf41$export$aad197c7121a6651)(originalFunction);
                // Otherwise wrap directly
                return (0, $85f84a1a61bc748e$export$4997ffc0176396a6)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $d3c16872d9dddf05$var$_wrapEventTarget(target) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const globalObject = (0, $85f84a1a61bc748e$export$56d8a8a25bd48b81);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const proto = globalObject[target] && globalObject[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) return;
    (0, $c617c17708158965$export$9563e054e6f787fb)(proto, "addEventListener", function(original) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === "function") // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $85f84a1a61bc748e$export$4997ffc0176396a6)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            function: "handleEvent",
                            handler: (0, $aa7bfcbdaa2ccf41$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: "instrument"
                    }
                });
            } catch (err) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, $85f84a1a61bc748e$export$4997ffc0176396a6)(fn, {
                    mechanism: {
                        data: {
                            function: "addEventListener",
                            handler: (0, $aa7bfcbdaa2ccf41$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: "instrument"
                    }
                }),
                options
            ]);
        };
    });
    (0, $c617c17708158965$export$9563e054e6f787fb)(proto, "removeEventListener", function(originalRemoveEventListener) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            /**
         * There are 2 possible scenarios here:
         *
         * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
         * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
         * as a pass-through, and call original `removeEventListener` with it.
         *
         * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
         * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
         * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
         * in order for us to make a distinction between wrapped/non-wrapped functions possible.
         * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
         *
         * When someone adds a handler prior to initialization, and then do it again, but after,
         * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
         * to get rid of the initial handler and it'd stick there forever.
         */ const wrappedEventHandler = fn;
            try {
                const originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}



// global reference to slice
const $233ea84b5daa4216$var$UNKNOWN_FUNCTION = "?";
const $233ea84b5daa4216$var$OPERA10_PRIORITY = 10;
const $233ea84b5daa4216$var$OPERA11_PRIORITY = 20;
const $233ea84b5daa4216$var$CHROME_PRIORITY = 30;
const $233ea84b5daa4216$var$WINJS_PRIORITY = 40;
const $233ea84b5daa4216$var$GECKO_PRIORITY = 50;
function $233ea84b5daa4216$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
const $233ea84b5daa4216$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $233ea84b5daa4216$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
const $233ea84b5daa4216$var$chromeStackParserFn = (line)=>{
    const parts = $233ea84b5daa4216$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2] && parts[2].indexOf("eval") === 0; // start of line
        if (isEval) {
            const subMatch = $233ea84b5daa4216$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $233ea84b5daa4216$var$extractSafariExtensionDetails(parts[1] || $233ea84b5daa4216$var$UNKNOWN_FUNCTION, parts[2]);
        return $233ea84b5daa4216$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $233ea84b5daa4216$export$263a749fff749872 = [
    $233ea84b5daa4216$var$CHROME_PRIORITY,
    $233ea84b5daa4216$var$chromeStackParserFn
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $233ea84b5daa4216$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $233ea84b5daa4216$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $233ea84b5daa4216$var$gecko = (line)=>{
    const parts = $233ea84b5daa4216$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(" > eval") > -1;
        if (isEval) {
            const subMatch = $233ea84b5daa4216$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || "eval";
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ""; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || $233ea84b5daa4216$var$UNKNOWN_FUNCTION;
        [func, filename] = $233ea84b5daa4216$var$extractSafariExtensionDetails(func, filename);
        return $233ea84b5daa4216$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $233ea84b5daa4216$export$cdba47a5dd2804d = [
    $233ea84b5daa4216$var$GECKO_PRIORITY,
    $233ea84b5daa4216$var$gecko
];
const $233ea84b5daa4216$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $233ea84b5daa4216$var$winjs = (line)=>{
    const parts = $233ea84b5daa4216$var$winjsRegex.exec(line);
    return parts ? $233ea84b5daa4216$var$createFrame(parts[2], parts[1] || $233ea84b5daa4216$var$UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $233ea84b5daa4216$export$179460296da408e8 = [
    $233ea84b5daa4216$var$WINJS_PRIORITY,
    $233ea84b5daa4216$var$winjs
];
const $233ea84b5daa4216$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $233ea84b5daa4216$var$opera10 = (line)=>{
    const parts = $233ea84b5daa4216$var$opera10Regex.exec(line);
    return parts ? $233ea84b5daa4216$var$createFrame(parts[2], parts[3] || $233ea84b5daa4216$var$UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
const $233ea84b5daa4216$export$f892b52c880ffc7a = [
    $233ea84b5daa4216$var$OPERA10_PRIORITY,
    $233ea84b5daa4216$var$opera10
];
const $233ea84b5daa4216$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $233ea84b5daa4216$var$opera11 = (line)=>{
    const parts = $233ea84b5daa4216$var$opera11Regex.exec(line);
    return parts ? $233ea84b5daa4216$var$createFrame(parts[5], parts[3] || parts[4] || $233ea84b5daa4216$var$UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
const $233ea84b5daa4216$export$af11af13f09fb0dc = [
    $233ea84b5daa4216$var$OPERA11_PRIORITY,
    $233ea84b5daa4216$var$opera11
];
const $233ea84b5daa4216$export$7197c0fe6554c079 = [
    $233ea84b5daa4216$export$263a749fff749872,
    $233ea84b5daa4216$export$cdba47a5dd2804d,
    $233ea84b5daa4216$export$179460296da408e8
];
const $233ea84b5daa4216$export$2b2b997d81bf3907 = (0, $aa7bfcbdaa2ccf41$export$a5739666fb2d03d4)(...$233ea84b5daa4216$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $233ea84b5daa4216$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf("safari-extension") !== -1;
    const isSafariWebExtension = func.indexOf("safari-web-extension") !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf("@") !== -1 ? func.split("@")[0] : $233ea84b5daa4216$var$UNKNOWN_FUNCTION,
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};


// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
const $679d3f43fe73fa86$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $679d3f43fe73fa86$export$615352e17ed7741(header, now = Date.now()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $679d3f43fe73fa86$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $679d3f43fe73fa86$export$b89fc7b2e4c799e7(limits, category) {
    return limits[category] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $679d3f43fe73fa86$export$6c91fec22056810a(limits, category, now = Date.now()) {
    return $679d3f43fe73fa86$export$b89fc7b2e4c799e7(limits, category) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $679d3f43fe73fa86$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = Date.now()) {
    const updatedRateLimits = {
        ...limits
    };
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers && headers["x-sentry-rate-limits"];
    const retryAfterHeader = headers && headers["retry-after"];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     */ for (const limit of rateLimitHeader.trim().split(",")){
        const [retryAfter, categories] = limit.split(":", 2);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(";"))updatedRateLimits[category] = now + delay;
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $679d3f43fe73fa86$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}



/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $cc496911c3346d50$export$85a4f67f852183e6(limit) {
    const buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0];
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, $8285c2d2e65b1e62$export$78e43115b553f358)(new (0, $7a6608dd0661c2da$export$5949942ba2a7c0e2)("Not adding Promise because buffer limit was reached."));
        // start the task and add its promise to the queue
        const task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(()=>remove(task))// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, ()=>remove(task).then(null, ()=>{
            // We have to add another catch here because `remove()` starts a new promise chain.
            }));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        return new (0, $8285c2d2e65b1e62$export$6f292d4960313241)((resolve, reject)=>{
            let counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            const capturedSetTimeout = setTimeout(()=>{
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach((item)=>{
                (0, $8285c2d2e65b1e62$export$1fda8aa4d135f8aa)(item).then(()=>{
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}



const $e98a10ce4446776d$export$e515cf6dfd2f98b8 = 30;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $e98a10ce4446776d$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $cc496911c3346d50$export$85a4f67f852183e6)(options.bufferSize || $e98a10ce4446776d$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, $2be9719d61f0a0f7$export$c56c55acf0136fd3)(envelope, (item, type)=>{
            const envelopeItemDataCategory = (0, $2be9719d61f0a0f7$export$b11169581eeaf237)(type);
            if ((0, $679d3f43fe73fa86$export$6c91fec22056810a)(rateLimits, envelopeItemDataCategory)) {
                const event = $e98a10ce4446776d$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent("ratelimit_backoff", envelopeItemDataCategory, event);
            } else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return (0, $8285c2d2e65b1e62$export$1fda8aa4d135f8aa)();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const filteredEnvelope = (0, $2be9719d61f0a0f7$export$f93f7f385160c44e)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            (0, $2be9719d61f0a0f7$export$c56c55acf0136fd3)(filteredEnvelope, (item, type)=>{
                const event = $e98a10ce4446776d$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent(reason, (0, $2be9719d61f0a0f7$export$b11169581eeaf237)(type), event);
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $2be9719d61f0a0f7$export$32f9b428425aac85)(filteredEnvelope, options.textEncoder)
            }).then((response)=>{
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (0, $217bdd4a17a6f5aa$export$16a28057038b10ef) && (0, $fa35a81632814438$export$af88d00dbe7f521).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $679d3f43fe73fa86$export$699aff705e0d49d4)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss("network_error");
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error instanceof (0, $7a6608dd0661c2da$export$5949942ba2a7c0e2)) {
                (0, $217bdd4a17a6f5aa$export$16a28057038b10ef) && (0, $fa35a81632814438$export$af88d00dbe7f521).error("Skipped sending event because buffer is full.");
                recordEnvelopeLoss("queue_overflow");
                return (0, $8285c2d2e65b1e62$export$1fda8aa4d135f8aa)();
            } else throw error;
        });
    }
    // We use this to identifify if the transport is the base transport
    // TODO (v8): Remove this again as we'll no longer need it
    send.__sentry__baseTransport__ = true;
    return {
        send: send,
        flush: flush
    };
}
function $e98a10ce4446776d$var$getEventForEnvelopeItem(item, type) {
    if (type !== "event" && type !== "transaction") return undefined;
    return Array.isArray(item) ? item[1] : undefined;
}






let $8b451876a7954cae$var$cachedFetchImpl = undefined;
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $8b451876a7954cae$export$8be2119ce08e3379() {
    if ($8b451876a7954cae$var$cachedFetchImpl) return $8b451876a7954cae$var$cachedFetchImpl;
    /* eslint-disable @typescript-eslint/unbound-method */ // Fast path to avoid DOM I/O
    if ((0, $f0fcb9d2dddc107a$export$18cf36ed71d733e7)((0, $85f84a1a61bc748e$export$56d8a8a25bd48b81).fetch)) return $8b451876a7954cae$var$cachedFetchImpl = (0, $85f84a1a61bc748e$export$56d8a8a25bd48b81).fetch.bind((0, $85f84a1a61bc748e$export$56d8a8a25bd48b81));
    const document = (0, $85f84a1a61bc748e$export$56d8a8a25bd48b81).document;
    let fetchImpl = (0, $85f84a1a61bc748e$export$56d8a8a25bd48b81).fetch;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === "function") try {
        const sandbox = document.createElement("iframe");
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow.fetch) fetchImpl = contentWindow.fetch;
        document.head.removeChild(sandbox);
    } catch (e) {
        (0, $16c176aae8900ce3$export$16a28057038b10ef) && (0, $fa35a81632814438$export$af88d00dbe7f521).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", e);
    }
    return $8b451876a7954cae$var$cachedFetchImpl = fetchImpl.bind((0, $85f84a1a61bc748e$export$56d8a8a25bd48b81));
/* eslint-enable @typescript-eslint/unbound-method */ }
/** Clears cached fetch impl */ function $8b451876a7954cae$export$d499686d2dd738c6() {
    $8b451876a7954cae$var$cachedFetchImpl = undefined;
}


/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $4e69002db52b9120$export$b2311068c46d7cc8(options, nativeFetch = (0, $8b451876a7954cae$export$8be2119ce08e3379)()) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: "POST",
            referrerPolicy: "origin",
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. whenfinishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15,
            ...options.fetchOptions
        };
        try {
            return nativeFetch(options.url, requestOptions).then((response)=>{
                pendingBodySize -= requestSize;
                pendingCount--;
                return {
                    statusCode: response.status,
                    headers: {
                        "x-sentry-rate-limits": response.headers.get("X-Sentry-Rate-Limits"),
                        "retry-after": response.headers.get("Retry-After")
                    }
                };
            });
        } catch (e) {
            (0, $8b451876a7954cae$export$d499686d2dd738c6)();
            pendingBodySize -= requestSize;
            pendingCount--;
            return (0, $8285c2d2e65b1e62$export$78e43115b553f358)(e);
        }
    }
    return (0, $e98a10ce4446776d$export$d09f50d9ab7f7b69)(options, makeRequest);
}




/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */ const $ee47879019cc36cf$var$XHR_READYSTATE_DONE = 4;
/**
 * Creates a Transport that uses the XMLHttpRequest API to send events to Sentry.
 */ function $ee47879019cc36cf$export$5e1441cee30d5a39(options) {
    function makeRequest(request) {
        return new (0, $8285c2d2e65b1e62$export$6f292d4960313241)((resolve, reject)=>{
            const xhr = new XMLHttpRequest();
            xhr.onerror = reject;
            xhr.onreadystatechange = ()=>{
                if (xhr.readyState === $ee47879019cc36cf$var$XHR_READYSTATE_DONE) resolve({
                    statusCode: xhr.status,
                    headers: {
                        "x-sentry-rate-limits": xhr.getResponseHeader("X-Sentry-Rate-Limits"),
                        "retry-after": xhr.getResponseHeader("Retry-After")
                    }
                });
            };
            xhr.open("POST", options.url);
            for(const header in options.headers)if (Object.prototype.hasOwnProperty.call(options.headers, header)) xhr.setRequestHeader(header, options.headers[header]);
            xhr.send(request.body);
        });
    }
    return (0, $e98a10ce4446776d$export$d09f50d9ab7f7b69)(options, makeRequest);
}


/** @deprecated Use `getDefaultIntegrations(options)` instead. */ const $a680f7f2ea4c1359$export$5ef831fccfce35e5 = [
    (0, $3235049c57f9dc22$export$cb3c5c2ceb9818ba)(),
    (0, $59ebd5207e71d1e2$export$7918117e9202e4fb)(),
    (0, $d3c16872d9dddf05$export$59bfe9f1c76150e)(),
    (0, $43431361d45b53ad$export$c079d904b326663a)(),
    (0, $c198e1f6e08732c9$export$66acc70e8cf2b71a)(),
    (0, $55cdcd545ef3f2e2$export$ebabb00eb7f3a395)(),
    (0, $305ba4656b814920$export$6d39aa44cd0c7567)(),
    (0, $93d2fea2ea91437d$export$1378794447170364)()
];
/** Get the default integrations for the browser SDK. */ function $a680f7f2ea4c1359$export$5783b2920b1d62b9(_options) {
    // We return a copy of the defaultIntegrations here to avoid mutating this
    return [
        // eslint-disable-next-line deprecation/deprecation
        ...$a680f7f2ea4c1359$export$5ef831fccfce35e5
    ];
}
/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $a680f7f2ea4c1359$export$2cd8252107eb640b(options = {}) {
    if (options.defaultIntegrations === undefined) options.defaultIntegrations = $a680f7f2ea4c1359$export$5783b2920b1d62b9();
    if (options.release === undefined) {
        // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
        if (typeof __SENTRY_RELEASE__ === "string") options.release = __SENTRY_RELEASE__;
        // This supports the variable that sentry-webpack-plugin injects
        if ((0, $85f84a1a61bc748e$export$56d8a8a25bd48b81).SENTRY_RELEASE && (0, $85f84a1a61bc748e$export$56d8a8a25bd48b81).SENTRY_RELEASE.id) options.release = (0, $85f84a1a61bc748e$export$56d8a8a25bd48b81).SENTRY_RELEASE.id;
    }
    if (options.autoSessionTracking === undefined) options.autoSessionTracking = true;
    if (options.sendClientReports === undefined) options.sendClientReports = true;
    const clientOptions = {
        ...options,
        stackParser: (0, $aa7bfcbdaa2ccf41$export$1d5cf88b347146d4)(options.stackParser || (0, $233ea84b5daa4216$export$2b2b997d81bf3907)),
        integrations: (0, $cf0d247f1c37a8e9$export$68bc4c01ab8ae766)(options),
        transport: options.transport || ((0, $f0fcb9d2dddc107a$export$edf3cb81fd7d2a3e)() ? (0, $4e69002db52b9120$export$b2311068c46d7cc8) : (0, $ee47879019cc36cf$export$5e1441cee30d5a39))
    };
    (0, $832125eac2d656f6$export$5333c3f1c58d9bc1)((0, $3ab33ded96eddacd$export$1df9218a526d318d), clientOptions);
    if (options.autoSessionTracking) $a680f7f2ea4c1359$var$startSessionTracking();
}
const $a680f7f2ea4c1359$export$3a8fd680da42627b = (// eslint-disable-next-line deprecation/deprecation
options = {}, // eslint-disable-next-line deprecation/deprecation
hub = (0, $be307700159f7758$export$a07cdf6544bbd7c)())=>{
    // doesn't work without a document (React Native)
    if (!(0, $85f84a1a61bc748e$export$56d8a8a25bd48b81).document) {
        (0, $16c176aae8900ce3$export$16a28057038b10ef) && (0, $fa35a81632814438$export$af88d00dbe7f521).error("Global document not defined in showReportDialog call");
        return;
    }
    // eslint-disable-next-line deprecation/deprecation
    const { client: client, scope: scope } = hub.getStackTop();
    const dsn = options.dsn || client && client.getDsn();
    if (!dsn) {
        (0, $16c176aae8900ce3$export$16a28057038b10ef) && (0, $fa35a81632814438$export$af88d00dbe7f521).error("DSN not configured for showReportDialog call");
        return;
    }
    if (scope) options.user = {
        ...scope.getUser(),
        ...options.user
    };
    // TODO(v8): Remove this entire if statement. `eventId` will be a required option.
    // eslint-disable-next-line deprecation/deprecation
    if (!options.eventId) // eslint-disable-next-line deprecation/deprecation
    options.eventId = hub.lastEventId();
    const script = (0, $85f84a1a61bc748e$export$56d8a8a25bd48b81).document.createElement("script");
    script.async = true;
    script.crossOrigin = "anonymous";
    script.src = (0, $e67dceff09c2335b$export$671c7ed8e40a7a57)(dsn, options);
    if (options.onLoad) script.onload = options.onLoad;
    const { onClose: onClose } = options;
    if (onClose) {
        const reportDialogClosedMessageHandler = (event)=>{
            if (event.data === "__sentry_reportdialog_closed__") try {
                onClose();
            } finally{
                (0, $85f84a1a61bc748e$export$56d8a8a25bd48b81).removeEventListener("message", reportDialogClosedMessageHandler);
            }
        };
        (0, $85f84a1a61bc748e$export$56d8a8a25bd48b81).addEventListener("message", reportDialogClosedMessageHandler);
    }
    const injectionPoint = (0, $85f84a1a61bc748e$export$56d8a8a25bd48b81).document.head || (0, $85f84a1a61bc748e$export$56d8a8a25bd48b81).document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
    else (0, $16c176aae8900ce3$export$16a28057038b10ef) && (0, $fa35a81632814438$export$af88d00dbe7f521).error("Not injecting report dialog. No injection point found in HTML");
};
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $a680f7f2ea4c1359$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $a680f7f2ea4c1359$export$4e4d8b287d028b6b(callback) {
    callback();
}
/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @deprecated This function will be removed in v8.
 * It is not part of Sentry's official API and it's easily replaceable by using a try/catch block
 * and calling Sentry.captureException.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */ // TODO(v8): Remove this function
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $a680f7f2ea4c1359$export$4997ffc0176396a6(fn) {
    return (0, $85f84a1a61bc748e$export$4997ffc0176396a6)(fn)();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */ function $a680f7f2ea4c1359$var$startSessionTracking() {
    if (typeof (0, $85f84a1a61bc748e$export$56d8a8a25bd48b81).document === "undefined") {
        (0, $16c176aae8900ce3$export$16a28057038b10ef) && (0, $fa35a81632814438$export$af88d00dbe7f521).warn("Session tracking in non-browser environment with @sentry/browser is not supported.");
        return;
    }
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    (0, $3bf2cc17570e59fe$export$c0d84948cecf78d8)({
        ignoreDuration: true
    });
    (0, $3bf2cc17570e59fe$export$667e7b4d445d566b)();
    // We want to create a session for every navigation as well
    (0, $0e7bd0efb15b353d$export$3f18c56c58114e75)(({ from: from, to: to })=>{
        // Don't create an additional session for the initial route or if the location did not change
        if (from !== undefined && from !== to) {
            (0, $3bf2cc17570e59fe$export$c0d84948cecf78d8)({
                ignoreDuration: true
            });
            (0, $3bf2cc17570e59fe$export$667e7b4d445d566b)();
        }
    });
}
/**
 * Captures user feedback and sends it to Sentry.
 */ function $a680f7f2ea4c1359$export$88cefaf72d1e58a3(feedback) {
    const client = (0, $3bf2cc17570e59fe$export$6bb76d6eba7e258c)();
    if (client) client.captureUserFeedback(feedback);
}



var $lBnVc = parcelRequire("lBnVc");
var $7ae41b8772b98526$exports = {};
"use strict";

$7ae41b8772b98526$exports = (parcelRequire("iMlaS"));


var $d3287b130d7b0f6b$var$__defProp = Object.defineProperty;
var $d3287b130d7b0f6b$var$__defProps = Object.defineProperties;
var $d3287b130d7b0f6b$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $d3287b130d7b0f6b$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $d3287b130d7b0f6b$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $d3287b130d7b0f6b$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $d3287b130d7b0f6b$var$__defNormalProp = (obj, key, value)=>key in obj ? $d3287b130d7b0f6b$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $d3287b130d7b0f6b$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($d3287b130d7b0f6b$var$__hasOwnProp.call(b, prop)) $d3287b130d7b0f6b$var$__defNormalProp(a, prop, b[prop]);
    if ($d3287b130d7b0f6b$var$__getOwnPropSymbols) {
        for (var prop of $d3287b130d7b0f6b$var$__getOwnPropSymbols(b))if ($d3287b130d7b0f6b$var$__propIsEnum.call(b, prop)) $d3287b130d7b0f6b$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $d3287b130d7b0f6b$var$__spreadProps = (a, b)=>$d3287b130d7b0f6b$var$__defProps(a, $d3287b130d7b0f6b$var$__getOwnPropDescs(b));
var $d3287b130d7b0f6b$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($d3287b130d7b0f6b$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $d3287b130d7b0f6b$var$__getOwnPropSymbols) {
        for (var prop of $d3287b130d7b0f6b$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $d3287b130d7b0f6b$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var $d3287b130d7b0f6b$var$React = // prettier-ignore
// @ts-ignore
"default" in $lBnVc ? $lBnVc["default"] : $lBnVc;
// src/components/Context.ts
var $d3287b130d7b0f6b$var$ContextKey = Symbol.for(`react-redux-context`);
var $d3287b130d7b0f6b$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $d3287b130d7b0f6b$var$getContext() {
    var _a;
    if (!$d3287b130d7b0f6b$var$React.createContext) return {};
    const contextMap = (_a = $d3287b130d7b0f6b$var$gT[$d3287b130d7b0f6b$var$ContextKey]) != null ? _a : $d3287b130d7b0f6b$var$gT[$d3287b130d7b0f6b$var$ContextKey] = /* @__PURE__ */ new Map();
    let realContext = contextMap.get($d3287b130d7b0f6b$var$React.createContext);
    if (!realContext) {
        realContext = $d3287b130d7b0f6b$var$React.createContext(null);
        contextMap.set($d3287b130d7b0f6b$var$React.createContext, realContext);
    }
    return realContext;
}
var $d3287b130d7b0f6b$export$cc80c08dc91f1c00 = /* @__PURE__ */ $d3287b130d7b0f6b$var$getContext();
// src/utils/useSyncExternalStore.ts
var $d3287b130d7b0f6b$var$notInitialized = ()=>{
    throw new Error("uSES not initialized!");
};
// src/hooks/useReduxContext.ts
function $d3287b130d7b0f6b$var$createReduxContextHook(context = $d3287b130d7b0f6b$export$cc80c08dc91f1c00) {
    return function useReduxContext2() {
        const contextValue = $d3287b130d7b0f6b$var$React.useContext(context);
        return contextValue;
    };
}
var $d3287b130d7b0f6b$var$useReduxContext = /* @__PURE__ */ $d3287b130d7b0f6b$var$createReduxContextHook();
// src/hooks/useSelector.ts
var $d3287b130d7b0f6b$var$useSyncExternalStoreWithSelector = $d3287b130d7b0f6b$var$notInitialized;
var $d3287b130d7b0f6b$var$initializeUseSelector = (fn)=>{
    $d3287b130d7b0f6b$var$useSyncExternalStoreWithSelector = fn;
};
var $d3287b130d7b0f6b$var$refEquality = (a, b)=>a === b;
function $d3287b130d7b0f6b$export$2b53f90d2bd1cbfb(context = $d3287b130d7b0f6b$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $d3287b130d7b0f6b$export$cc80c08dc91f1c00 ? $d3287b130d7b0f6b$var$useReduxContext : $d3287b130d7b0f6b$var$createReduxContextHook(context);
    const useSelector2 = (selector, equalityFnOrOptions = {})=>{
        const { equalityFn: equalityFn = $d3287b130d7b0f6b$var$refEquality, devModeChecks: devModeChecks = {} } = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const { store: store, subscription: subscription, getServerState: getServerState, stabilityCheck: stabilityCheck, identityFunctionCheck: identityFunctionCheck } = useReduxContext2();
        const firstRun = $d3287b130d7b0f6b$var$React.useRef(true);
        const wrappedSelector = $d3287b130d7b0f6b$var$React.useCallback({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector,
            stabilityCheck,
            devModeChecks.stabilityCheck
        ]);
        const selectedState = $d3287b130d7b0f6b$var$useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        $d3287b130d7b0f6b$var$React.useDebugValue(selectedState);
        return selectedState;
    };
    Object.assign(useSelector2, {
        withTypes: ()=>useSelector2
    });
    return useSelector2;
}
var $d3287b130d7b0f6b$export$2105062e25df4afe = /* @__PURE__ */ $d3287b130d7b0f6b$export$2b53f90d2bd1cbfb();
// src/utils/react-is.ts
var $d3287b130d7b0f6b$var$REACT_ELEMENT_TYPE = Symbol.for("react.element");
var $d3287b130d7b0f6b$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
var $d3287b130d7b0f6b$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
var $d3287b130d7b0f6b$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
var $d3287b130d7b0f6b$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler");
var $d3287b130d7b0f6b$var$REACT_PROVIDER_TYPE = Symbol.for("react.provider");
var $d3287b130d7b0f6b$var$REACT_CONTEXT_TYPE = Symbol.for("react.context");
var $d3287b130d7b0f6b$var$REACT_SERVER_CONTEXT_TYPE = Symbol.for("react.server_context");
var $d3287b130d7b0f6b$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
var $d3287b130d7b0f6b$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
var $d3287b130d7b0f6b$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
var $d3287b130d7b0f6b$var$REACT_MEMO_TYPE = Symbol.for("react.memo");
var $d3287b130d7b0f6b$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
var $d3287b130d7b0f6b$var$REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
var $d3287b130d7b0f6b$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
var $d3287b130d7b0f6b$var$ForwardRef = $d3287b130d7b0f6b$var$REACT_FORWARD_REF_TYPE;
var $d3287b130d7b0f6b$var$Memo = $d3287b130d7b0f6b$var$REACT_MEMO_TYPE;
function $d3287b130d7b0f6b$var$isValidElementType(type) {
    if (typeof type === "string" || typeof type === "function") return true;
    if (type === $d3287b130d7b0f6b$var$REACT_FRAGMENT_TYPE || type === $d3287b130d7b0f6b$var$REACT_PROFILER_TYPE || type === $d3287b130d7b0f6b$var$REACT_STRICT_MODE_TYPE || type === $d3287b130d7b0f6b$var$REACT_SUSPENSE_TYPE || type === $d3287b130d7b0f6b$var$REACT_SUSPENSE_LIST_TYPE || type === $d3287b130d7b0f6b$var$REACT_OFFSCREEN_TYPE) return true;
    if (typeof type === "object" && type !== null) {
        if (type.$$typeof === $d3287b130d7b0f6b$var$REACT_LAZY_TYPE || type.$$typeof === $d3287b130d7b0f6b$var$REACT_MEMO_TYPE || type.$$typeof === $d3287b130d7b0f6b$var$REACT_PROVIDER_TYPE || type.$$typeof === $d3287b130d7b0f6b$var$REACT_CONTEXT_TYPE || type.$$typeof === $d3287b130d7b0f6b$var$REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
        // types supported by any Flight configuration anywhere since
        // we don't know which Flight build this will end up being used
        // with.
        type.$$typeof === $d3287b130d7b0f6b$var$REACT_CLIENT_REFERENCE || type.getModuleId !== void 0) return true;
    }
    return false;
}
function $d3287b130d7b0f6b$var$typeOf(object) {
    if (typeof object === "object" && object !== null) {
        const $$typeof = object.$$typeof;
        switch($$typeof){
            case $d3287b130d7b0f6b$var$REACT_ELEMENT_TYPE:
                {
                    const type = object.type;
                    switch(type){
                        case $d3287b130d7b0f6b$var$REACT_FRAGMENT_TYPE:
                        case $d3287b130d7b0f6b$var$REACT_PROFILER_TYPE:
                        case $d3287b130d7b0f6b$var$REACT_STRICT_MODE_TYPE:
                        case $d3287b130d7b0f6b$var$REACT_SUSPENSE_TYPE:
                        case $d3287b130d7b0f6b$var$REACT_SUSPENSE_LIST_TYPE:
                            return type;
                        default:
                            {
                                const $$typeofType = type && type.$$typeof;
                                switch($$typeofType){
                                    case $d3287b130d7b0f6b$var$REACT_SERVER_CONTEXT_TYPE:
                                    case $d3287b130d7b0f6b$var$REACT_CONTEXT_TYPE:
                                    case $d3287b130d7b0f6b$var$REACT_FORWARD_REF_TYPE:
                                    case $d3287b130d7b0f6b$var$REACT_LAZY_TYPE:
                                    case $d3287b130d7b0f6b$var$REACT_MEMO_TYPE:
                                    case $d3287b130d7b0f6b$var$REACT_PROVIDER_TYPE:
                                        return $$typeofType;
                                    default:
                                        return $$typeof;
                                }
                            }
                    }
                }
            case $d3287b130d7b0f6b$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
    return void 0;
}
function $d3287b130d7b0f6b$var$isContextConsumer(object) {
    return $d3287b130d7b0f6b$var$typeOf(object) === $d3287b130d7b0f6b$var$REACT_CONTEXT_TYPE;
}
function $d3287b130d7b0f6b$var$isMemo(object) {
    return $d3287b130d7b0f6b$var$typeOf(object) === $d3287b130d7b0f6b$var$REACT_MEMO_TYPE;
}
// src/utils/warning.ts
function $d3287b130d7b0f6b$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/connect/verifySubselectors.ts
function $d3287b130d7b0f6b$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) $d3287b130d7b0f6b$var$warning(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $d3287b130d7b0f6b$var$verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps) {
    $d3287b130d7b0f6b$var$verify(mapStateToProps, "mapStateToProps");
    $d3287b130d7b0f6b$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $d3287b130d7b0f6b$var$verify(mergeProps, "mergeProps");
}
// src/connect/selectorFactory.ts
function $d3287b130d7b0f6b$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $d3287b130d7b0f6b$var$finalPropsSelectorFactory(dispatch, _a) {
    var _b = _a, { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _b, options = $d3287b130d7b0f6b$var$__objRest(_b, [
        "initMapStateToProps",
        "initMapDispatchToProps",
        "initMergeProps"
    ]);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $d3287b130d7b0f6b$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
// src/utils/bindActionCreators.ts
function $d3287b130d7b0f6b$var$bindActionCreators(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}
// src/utils/isPlainObject.ts
function $d3287b130d7b0f6b$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    const proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/utils/verifyPlainObject.ts
function $d3287b130d7b0f6b$var$verifyPlainObject(value, displayName, methodName) {
    if (!$d3287b130d7b0f6b$var$isPlainObject(value)) $d3287b130d7b0f6b$var$warning(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}
// src/connect/wrapMapToProps.ts
function $d3287b130d7b0f6b$var$wrapMapToPropsConstant(getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function $d3287b130d7b0f6b$var$getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function $d3287b130d7b0f6b$var$wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, void 0);
        };
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $d3287b130d7b0f6b$var$getDependsOnOwnProps(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $d3287b130d7b0f6b$var$getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}
// src/connect/invalidArgFactory.ts
function $d3287b130d7b0f6b$var$createInvalidArgFactory(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}
// src/connect/mapDispatchToProps.ts
function $d3287b130d7b0f6b$var$mapDispatchToPropsFactory(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? $d3287b130d7b0f6b$var$wrapMapToPropsConstant((dispatch)=>// @ts-ignore
        $d3287b130d7b0f6b$var$bindActionCreators(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? $d3287b130d7b0f6b$var$wrapMapToPropsConstant((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === "function" ? // @ts-ignore
    $d3287b130d7b0f6b$var$wrapMapToPropsFunc(mapDispatchToProps, "mapDispatchToProps") : $d3287b130d7b0f6b$var$createInvalidArgFactory(mapDispatchToProps, "mapDispatchToProps");
}
// src/connect/mapStateToProps.ts
function $d3287b130d7b0f6b$var$mapStateToPropsFactory(mapStateToProps) {
    return !mapStateToProps ? $d3287b130d7b0f6b$var$wrapMapToPropsConstant(()=>({})) : typeof mapStateToProps === "function" ? // @ts-ignore
    $d3287b130d7b0f6b$var$wrapMapToPropsFunc(mapStateToProps, "mapStateToProps") : $d3287b130d7b0f6b$var$createInvalidArgFactory(mapStateToProps, "mapStateToProps");
}
// src/connect/mergeProps.ts
function $d3287b130d7b0f6b$var$defaultMergeProps(stateProps, dispatchProps, ownProps) {
    return $d3287b130d7b0f6b$var$__spreadValues($d3287b130d7b0f6b$var$__spreadValues($d3287b130d7b0f6b$var$__spreadValues({}, ownProps), stateProps), dispatchProps);
}
function $d3287b130d7b0f6b$var$wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $d3287b130d7b0f6b$var$mergePropsFactory(mergeProps) {
    return !mergeProps ? ()=>$d3287b130d7b0f6b$var$defaultMergeProps : typeof mergeProps === "function" ? $d3287b130d7b0f6b$var$wrapMergePropsFunc(mergeProps) : $d3287b130d7b0f6b$var$createInvalidArgFactory(mergeProps, "mergeProps");
}
// src/utils/batch.ts
function $d3287b130d7b0f6b$var$defaultNoopBatch(callback) {
    callback();
}
// src/utils/Subscription.ts
function $d3287b130d7b0f6b$var$createListenerCollection() {
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            $d3287b130d7b0f6b$var$defaultNoopBatch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            const listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            const listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $d3287b130d7b0f6b$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $d3287b130d7b0f6b$var$createSubscription(store, parentSub) {
    let unsubscribe;
    let listeners = $d3287b130d7b0f6b$var$nullListeners;
    let subscriptionsAmount = 0;
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener);
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $d3287b130d7b0f6b$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = void 0;
            listeners.clear();
            listeners = $d3287b130d7b0f6b$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}
// src/utils/useIsomorphicLayoutEffect.ts
var $d3287b130d7b0f6b$var$canUseDOM = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
var $d3287b130d7b0f6b$var$useIsomorphicLayoutEffect = $d3287b130d7b0f6b$var$canUseDOM ? $d3287b130d7b0f6b$var$React.useLayoutEffect : $d3287b130d7b0f6b$var$React.useEffect;
// src/utils/shallowEqual.ts
function $d3287b130d7b0f6b$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $d3287b130d7b0f6b$export$d36bdfa510afb180(objA, objB) {
    if ($d3287b130d7b0f6b$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$d3287b130d7b0f6b$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
// src/utils/hoistStatics.ts
var $d3287b130d7b0f6b$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $d3287b130d7b0f6b$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $d3287b130d7b0f6b$var$FORWARD_REF_STATICS = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $d3287b130d7b0f6b$var$MEMO_STATICS = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $d3287b130d7b0f6b$var$TYPE_STATICS = {
    [$d3287b130d7b0f6b$var$ForwardRef]: $d3287b130d7b0f6b$var$FORWARD_REF_STATICS,
    [$d3287b130d7b0f6b$var$Memo]: $d3287b130d7b0f6b$var$MEMO_STATICS
};
function $d3287b130d7b0f6b$var$getStatics(component) {
    if ($d3287b130d7b0f6b$var$isMemo(component)) return $d3287b130d7b0f6b$var$MEMO_STATICS;
    return $d3287b130d7b0f6b$var$TYPE_STATICS[component["$$typeof"]] || $d3287b130d7b0f6b$var$REACT_STATICS;
}
var $d3287b130d7b0f6b$var$defineProperty = Object.defineProperty;
var $d3287b130d7b0f6b$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $d3287b130d7b0f6b$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $d3287b130d7b0f6b$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $d3287b130d7b0f6b$var$getPrototypeOf = Object.getPrototypeOf;
var $d3287b130d7b0f6b$var$objectPrototype = Object.prototype;
function $d3287b130d7b0f6b$var$hoistNonReactStatics(targetComponent, sourceComponent) {
    if (typeof sourceComponent !== "string") {
        if ($d3287b130d7b0f6b$var$objectPrototype) {
            const inheritedComponent = $d3287b130d7b0f6b$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $d3287b130d7b0f6b$var$objectPrototype) $d3287b130d7b0f6b$var$hoistNonReactStatics(targetComponent, inheritedComponent);
        }
        let keys = $d3287b130d7b0f6b$var$getOwnPropertyNames(sourceComponent);
        if ($d3287b130d7b0f6b$var$getOwnPropertySymbols) keys = keys.concat($d3287b130d7b0f6b$var$getOwnPropertySymbols(sourceComponent));
        const targetStatics = $d3287b130d7b0f6b$var$getStatics(targetComponent);
        const sourceStatics = $d3287b130d7b0f6b$var$getStatics(sourceComponent);
        for(let i = 0; i < keys.length; ++i){
            const key = keys[i];
            if (!$d3287b130d7b0f6b$var$KNOWN_STATICS[key] && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                const descriptor = $d3287b130d7b0f6b$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $d3287b130d7b0f6b$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
// src/components/connect.tsx
var $d3287b130d7b0f6b$var$useSyncExternalStore = $d3287b130d7b0f6b$var$notInitialized;
var $d3287b130d7b0f6b$var$initializeConnect = (fn)=>{
    $d3287b130d7b0f6b$var$useSyncExternalStore = fn;
};
var $d3287b130d7b0f6b$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $d3287b130d7b0f6b$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $d3287b130d7b0f6b$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    $d3287b130d7b0f6b$var$useIsomorphicLayoutEffect(()=>effectFunc(...effectArgs), dependencies);
}
function $d3287b130d7b0f6b$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false;
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $d3287b130d7b0f6b$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    if (!shouldHandleStateChanges) return ()=>{};
    let didUnsubscribe = false;
    let lastThrownError = null;
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) return;
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true;
            additionalSubscribeListener();
        }
    };
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) throw lastThrownError;
    };
    return unsubscribeWrapper;
}
function $d3287b130d7b0f6b$var$strictEqual(a, b) {
    return a === b;
}
var $d3287b130d7b0f6b$var$hasWarnedAboutDeprecatedPureOption = false;
function $d3287b130d7b0f6b$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $d3287b130d7b0f6b$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = $d3287b130d7b0f6b$export$d36bdfa510afb180, areStatePropsEqual: areStatePropsEqual = $d3287b130d7b0f6b$export$d36bdfa510afb180, areMergedPropsEqual: areMergedPropsEqual = $d3287b130d7b0f6b$export$d36bdfa510afb180, forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = $d3287b130d7b0f6b$export$cc80c08dc91f1c00 } = {}) {
    const Context = context;
    const initMapStateToProps = $d3287b130d7b0f6b$var$mapStateToPropsFactory(mapStateToProps);
    const initMapDispatchToProps = $d3287b130d7b0f6b$var$mapDispatchToPropsFactory(mapDispatchToProps);
    const initMergeProps = $d3287b130d7b0f6b$var$mergePropsFactory(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: // @ts-ignore
            initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $d3287b130d7b0f6b$var$React.useMemo(()=>{
                const _a = props, { reactReduxForwardedRef: reactReduxForwardedRef2 } = _a, wrapperProps2 = $d3287b130d7b0f6b$var$__objRest(_a, [
                    "reactReduxForwardedRef"
                ]);
                return [
                    props.context,
                    reactReduxForwardedRef2,
                    wrapperProps2
                ];
            }, [
                props
            ]);
            const ContextToUse = $d3287b130d7b0f6b$var$React.useMemo(()=>{
                let ResultContext = Context;
                propsContext == null || propsContext.Consumer;
                return ResultContext;
            }, [
                propsContext,
                Context
            ]);
            const contextValue = $d3287b130d7b0f6b$var$React.useContext(ContextToUse);
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $d3287b130d7b0f6b$var$React.useMemo(()=>{
                return $d3287b130d7b0f6b$var$finalPropsSelectorFactory(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $d3287b130d7b0f6b$var$React.useMemo(()=>{
                if (!shouldHandleStateChanges) return $d3287b130d7b0f6b$var$NO_SUBSCRIPTION_ARRAY;
                const subscription2 = $d3287b130d7b0f6b$var$createSubscription(store, didStoreComeFromProps ? void 0 : contextValue.subscription);
                const notifyNestedSubs2 = subscription2.notifyNestedSubs.bind(subscription2);
                return [
                    subscription2,
                    notifyNestedSubs2
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]);
            const overriddenContextValue = $d3287b130d7b0f6b$var$React.useMemo(()=>{
                if (didStoreComeFromProps) return contextValue;
                return $d3287b130d7b0f6b$var$__spreadProps($d3287b130d7b0f6b$var$__spreadValues({}, contextValue), {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]);
            const lastChildProps = $d3287b130d7b0f6b$var$React.useRef();
            const lastWrapperProps = $d3287b130d7b0f6b$var$React.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $d3287b130d7b0f6b$var$React.useRef();
            const renderIsScheduled = $d3287b130d7b0f6b$var$React.useRef(false);
            const isProcessingDispatch = $d3287b130d7b0f6b$var$React.useRef(false);
            const isMounted = $d3287b130d7b0f6b$var$React.useRef(false);
            const latestSubscriptionCallbackError = $d3287b130d7b0f6b$var$React.useRef();
            $d3287b130d7b0f6b$var$useIsomorphicLayoutEffect(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $d3287b130d7b0f6b$var$React.useMemo(()=>{
                const selector = ()=>{
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]);
            const subscribeForReact = $d3287b130d7b0f6b$var$React.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $d3287b130d7b0f6b$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, // @ts-ignore
                    childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $d3287b130d7b0f6b$var$useIsomorphicLayoutEffectWithArgs($d3287b130d7b0f6b$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $d3287b130d7b0f6b$var$useSyncExternalStore(// TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
                subscribeForReact, // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
                // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `
The error may be correlated with this previous error:
${latestSubscriptionCallbackError.current.stack}

`;
                throw err;
            }
            $d3287b130d7b0f6b$var$useIsomorphicLayoutEffect(()=>{
                latestSubscriptionCallbackError.current = void 0;
                childPropsFromStoreUpdate.current = void 0;
                lastChildProps.current = actualChildProps;
            });
            const renderedWrappedComponent = $d3287b130d7b0f6b$var$React.useMemo(()=>{
                return(// @ts-ignore
                /* @__PURE__ */ $d3287b130d7b0f6b$var$React.createElement(WrappedComponent, $d3287b130d7b0f6b$var$__spreadProps($d3287b130d7b0f6b$var$__spreadValues({}, actualChildProps), {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]);
            const renderedChild = $d3287b130d7b0f6b$var$React.useMemo(()=>{
                if (shouldHandleStateChanges) return /* @__PURE__ */ $d3287b130d7b0f6b$var$React.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $d3287b130d7b0f6b$var$React.memo(ConnectFunction);
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $d3287b130d7b0f6b$var$React.forwardRef(function forwardConnectRef(props, ref) {
                return /* @__PURE__ */ $d3287b130d7b0f6b$var$React.createElement(Connect, $d3287b130d7b0f6b$var$__spreadProps($d3287b130d7b0f6b$var$__spreadValues({}, props), {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return /* @__PURE__ */ $d3287b130d7b0f6b$var$hoistNonReactStatics(forwarded, WrappedComponent);
        }
        return /* @__PURE__ */ $d3287b130d7b0f6b$var$hoistNonReactStatics(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $d3287b130d7b0f6b$export$64605811ab45167f = $d3287b130d7b0f6b$var$connect;
// src/components/Provider.tsx
function $d3287b130d7b0f6b$var$Provider({ store: store, context: context, children: children, serverState: serverState, stabilityCheck: stabilityCheck = "once", identityFunctionCheck: identityFunctionCheck = "once" }) {
    const contextValue = $d3287b130d7b0f6b$var$React.useMemo(()=>{
        const subscription = $d3287b130d7b0f6b$var$createSubscription(store);
        return {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : void 0,
            stabilityCheck: stabilityCheck,
            identityFunctionCheck: identityFunctionCheck
        };
    }, [
        store,
        serverState,
        stabilityCheck,
        identityFunctionCheck
    ]);
    const previousState = $d3287b130d7b0f6b$var$React.useMemo(()=>store.getState(), [
        store
    ]);
    $d3287b130d7b0f6b$var$useIsomorphicLayoutEffect(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = void 0;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || $d3287b130d7b0f6b$export$cc80c08dc91f1c00;
    return /* @__PURE__ */ $d3287b130d7b0f6b$var$React.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $d3287b130d7b0f6b$export$2881499e37b75b9a = $d3287b130d7b0f6b$var$Provider;
// src/hooks/useStore.ts
function $d3287b130d7b0f6b$export$671dba69185d0304(context = $d3287b130d7b0f6b$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $d3287b130d7b0f6b$export$cc80c08dc91f1c00 ? $d3287b130d7b0f6b$var$useReduxContext : // @ts-ignore
    $d3287b130d7b0f6b$var$createReduxContextHook(context);
    const useStore2 = ()=>{
        const { store: store } = useReduxContext2();
        return store;
    };
    Object.assign(useStore2, {
        withTypes: ()=>useStore2
    });
    return useStore2;
}
var $d3287b130d7b0f6b$export$6ccbb43953eebf8 = /* @__PURE__ */ $d3287b130d7b0f6b$export$671dba69185d0304();
// src/hooks/useDispatch.ts
function $d3287b130d7b0f6b$export$bc9b55530897c558(context = $d3287b130d7b0f6b$export$cc80c08dc91f1c00) {
    const useStore2 = context === $d3287b130d7b0f6b$export$cc80c08dc91f1c00 ? $d3287b130d7b0f6b$export$6ccbb43953eebf8 : $d3287b130d7b0f6b$export$671dba69185d0304(context);
    const useDispatch2 = ()=>{
        const store = useStore2();
        return store.dispatch;
    };
    Object.assign(useDispatch2, {
        withTypes: ()=>useDispatch2
    });
    return useDispatch2;
}
var $d3287b130d7b0f6b$export$8ad76b76a4c905f8 = /* @__PURE__ */ $d3287b130d7b0f6b$export$bc9b55530897c558();
// src/exports.ts
var $d3287b130d7b0f6b$export$712ea50be43a7858 = $d3287b130d7b0f6b$var$defaultNoopBatch;
// src/index.ts
$d3287b130d7b0f6b$var$initializeUseSelector((0, $7ae41b8772b98526$exports.useSyncExternalStoreWithSelector));
$d3287b130d7b0f6b$var$initializeConnect($lBnVc.useSyncExternalStore);


var $b8b130b8bbf51c97$var$__defProp = Object.defineProperty;
var $b8b130b8bbf51c97$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $b8b130b8bbf51c97$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $b8b130b8bbf51c97$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $b8b130b8bbf51c97$var$__defNormalProp = (obj, key, value)=>key in obj ? $b8b130b8bbf51c97$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $b8b130b8bbf51c97$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($b8b130b8bbf51c97$var$__hasOwnProp.call(b, prop)) $b8b130b8bbf51c97$var$__defNormalProp(a, prop, b[prop]);
    if ($b8b130b8bbf51c97$var$__getOwnPropSymbols) {
        for (var prop of $b8b130b8bbf51c97$var$__getOwnPropSymbols(b))if ($b8b130b8bbf51c97$var$__propIsEnum.call(b, prop)) $b8b130b8bbf51c97$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $b8b130b8bbf51c97$var$__publicField = (obj, key, value)=>{
    $b8b130b8bbf51c97$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
// src/devModeChecks/identityFunctionCheck.ts
var $b8b130b8bbf51c97$var$runIdentityFunctionCheck = (resultFunc, inputSelectorsResults, outputSelectorResult)=>{
    if (inputSelectorsResults.length === 1 && inputSelectorsResults[0] === outputSelectorResult) {
        let isInputSameAsOutput = false;
        try {
            const emptyObject = {};
            if (resultFunc(emptyObject) === emptyObject) isInputSameAsOutput = true;
        } catch (e) {}
        if (isInputSameAsOutput) {
            let stack = void 0;
            try {
                throw new Error();
            } catch (e) {
                ({ stack: stack } = e);
            }
            console.warn("The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.", {
                stack: stack
            });
        }
    }
};
// src/devModeChecks/inputStabilityCheck.ts
var $b8b130b8bbf51c97$var$runInputStabilityCheck = (inputSelectorResultsObject, options, inputSelectorArgs)=>{
    const { memoize: memoize, memoizeOptions: memoizeOptions } = options;
    const { inputSelectorResults: inputSelectorResults, inputSelectorResultsCopy: inputSelectorResultsCopy } = inputSelectorResultsObject;
    const createAnEmptyObject = memoize(()=>({}), ...memoizeOptions);
    const areInputSelectorResultsEqual = createAnEmptyObject.apply(null, inputSelectorResults) === createAnEmptyObject.apply(null, inputSelectorResultsCopy);
    if (!areInputSelectorResultsEqual) {
        let stack = void 0;
        try {
            throw new Error();
        } catch (e) {
            ({ stack: stack } = e);
        }
        console.warn("An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`", {
            arguments: inputSelectorArgs,
            firstInputs: inputSelectorResults,
            secondInputs: inputSelectorResultsCopy,
            stack: stack
        });
    }
};
// src/devModeChecks/setGlobalDevModeChecks.ts
var $b8b130b8bbf51c97$var$globalDevModeChecks = {
    inputStabilityCheck: "once",
    identityFunctionCheck: "once"
};
var $b8b130b8bbf51c97$export$1e290349de99e28c = (devModeChecks)=>{
    Object.assign($b8b130b8bbf51c97$var$globalDevModeChecks, devModeChecks);
};
// src/utils.ts
var $b8b130b8bbf51c97$var$NOT_FOUND = "NOT_FOUND";
function $b8b130b8bbf51c97$var$assertIsFunction(func, errorMessage = `expected a function, instead received ${typeof func}`) {
    if (typeof func !== "function") throw new TypeError(errorMessage);
}
function $b8b130b8bbf51c97$var$assertIsObject(object, errorMessage = `expected an object, instead received ${typeof object}`) {
    if (typeof object !== "object") throw new TypeError(errorMessage);
}
function $b8b130b8bbf51c97$var$assertIsArrayOfFunctions(array, errorMessage = `expected all items to be functions, instead received the following types: `) {
    if (!array.every((item)=>typeof item === "function")) {
        const itemTypes = array.map((item)=>typeof item === "function" ? `function ${item.name || "unnamed"}()` : typeof item).join(", ");
        throw new TypeError(`${errorMessage}[${itemTypes}]`);
    }
}
var $b8b130b8bbf51c97$var$ensureIsArray = (item)=>{
    return Array.isArray(item) ? item : [
        item
    ];
};
function $b8b130b8bbf51c97$var$getDependencies(createSelectorArgs) {
    const dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
    $b8b130b8bbf51c97$var$assertIsArrayOfFunctions(dependencies, `createSelector expects all input-selectors to be functions, but received the following types: `);
    return dependencies;
}
function $b8b130b8bbf51c97$var$collectInputSelectorResults(dependencies, inputSelectorArgs) {
    const inputSelectorResults = [];
    const { length: length } = dependencies;
    for(let i = 0; i < length; i++)inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
    return inputSelectorResults;
}
var $b8b130b8bbf51c97$var$getDevModeChecksExecutionInfo = (firstRun, devModeChecks)=>{
    const { identityFunctionCheck: identityFunctionCheck, inputStabilityCheck: inputStabilityCheck } = $b8b130b8bbf51c97$var$__spreadValues($b8b130b8bbf51c97$var$__spreadValues({}, $b8b130b8bbf51c97$var$globalDevModeChecks), devModeChecks);
    return {
        identityFunctionCheck: {
            shouldRun: identityFunctionCheck === "always" || identityFunctionCheck === "once" && firstRun,
            run: $b8b130b8bbf51c97$var$runIdentityFunctionCheck
        },
        inputStabilityCheck: {
            shouldRun: inputStabilityCheck === "always" || inputStabilityCheck === "once" && firstRun,
            run: $b8b130b8bbf51c97$var$runInputStabilityCheck
        }
    };
};
// src/autotrackMemoize/autotracking.ts
var $b8b130b8bbf51c97$var$$REVISION = 0;
var $b8b130b8bbf51c97$var$CURRENT_TRACKER = null;
var $b8b130b8bbf51c97$var$Cell = class {
    constructor(initialValue, isEqual = $b8b130b8bbf51c97$var$tripleEq){
        $b8b130b8bbf51c97$var$__publicField(this, "revision", $b8b130b8bbf51c97$var$$REVISION);
        $b8b130b8bbf51c97$var$__publicField(this, "_value");
        $b8b130b8bbf51c97$var$__publicField(this, "_lastValue");
        $b8b130b8bbf51c97$var$__publicField(this, "_isEqual", $b8b130b8bbf51c97$var$tripleEq);
        this._value = this._lastValue = initialValue;
        this._isEqual = isEqual;
    }
    // Whenever a storage value is read, it'll add itself to the current tracker if
    // one exists, entangling its state with that cache.
    get value() {
        $b8b130b8bbf51c97$var$CURRENT_TRACKER == null || $b8b130b8bbf51c97$var$CURRENT_TRACKER.add(this);
        return this._value;
    }
    // Whenever a storage value is updated, we bump the global revision clock,
    // assign the revision for this storage to the new value, _and_ we schedule a
    // rerender. This is important, and it's what makes autotracking  _pull_
    // based. We don't actively tell the caches which depend on the storage that
    // anything has happened. Instead, we recompute the caches when needed.
    set value(newValue) {
        if (this.value === newValue) return;
        this._value = newValue;
        this.revision = ++$b8b130b8bbf51c97$var$$REVISION;
    }
};
function $b8b130b8bbf51c97$var$tripleEq(a, b) {
    return a === b;
}
var $b8b130b8bbf51c97$var$TrackingCache = class {
    constructor(fn){
        $b8b130b8bbf51c97$var$__publicField(this, "_cachedValue");
        $b8b130b8bbf51c97$var$__publicField(this, "_cachedRevision", -1);
        $b8b130b8bbf51c97$var$__publicField(this, "_deps", []);
        $b8b130b8bbf51c97$var$__publicField(this, "hits", 0);
        $b8b130b8bbf51c97$var$__publicField(this, "fn");
        this.fn = fn;
    }
    clear() {
        this._cachedValue = void 0;
        this._cachedRevision = -1;
        this._deps = [];
        this.hits = 0;
    }
    get value() {
        if (this.revision > this._cachedRevision) {
            const { fn: fn } = this;
            const currentTracker = /* @__PURE__ */ new Set();
            const prevTracker = $b8b130b8bbf51c97$var$CURRENT_TRACKER;
            $b8b130b8bbf51c97$var$CURRENT_TRACKER = currentTracker;
            this._cachedValue = fn();
            $b8b130b8bbf51c97$var$CURRENT_TRACKER = prevTracker;
            this.hits++;
            this._deps = Array.from(currentTracker);
            this._cachedRevision = this.revision;
        }
        $b8b130b8bbf51c97$var$CURRENT_TRACKER == null || $b8b130b8bbf51c97$var$CURRENT_TRACKER.add(this);
        return this._cachedValue;
    }
    get revision() {
        return Math.max(...this._deps.map((d)=>d.revision), 0);
    }
};
function $b8b130b8bbf51c97$var$getValue(cell) {
    if (!(cell instanceof $b8b130b8bbf51c97$var$Cell)) console.warn("Not a valid cell! ", cell);
    return cell.value;
}
function $b8b130b8bbf51c97$var$setValue(storage, value) {
    if (!(storage instanceof $b8b130b8bbf51c97$var$Cell)) throw new TypeError("setValue must be passed a tracked store created with `createStorage`.");
    storage.value = storage._lastValue = value;
}
function $b8b130b8bbf51c97$var$createCell(initialValue, isEqual = $b8b130b8bbf51c97$var$tripleEq) {
    return new $b8b130b8bbf51c97$var$Cell(initialValue, isEqual);
}
function $b8b130b8bbf51c97$var$createCache(fn) {
    $b8b130b8bbf51c97$var$assertIsFunction(fn, "the first parameter to `createCache` must be a function");
    return new $b8b130b8bbf51c97$var$TrackingCache(fn);
}
// src/autotrackMemoize/tracking.ts
var $b8b130b8bbf51c97$var$neverEq = (a, b)=>false;
function $b8b130b8bbf51c97$var$createTag() {
    return $b8b130b8bbf51c97$var$createCell(null, $b8b130b8bbf51c97$var$neverEq);
}
function $b8b130b8bbf51c97$var$dirtyTag(tag, value) {
    $b8b130b8bbf51c97$var$setValue(tag, value);
}
var $b8b130b8bbf51c97$var$consumeCollection = (node)=>{
    let tag = node.collectionTag;
    if (tag === null) tag = node.collectionTag = $b8b130b8bbf51c97$var$createTag();
    $b8b130b8bbf51c97$var$getValue(tag);
};
var $b8b130b8bbf51c97$var$dirtyCollection = (node)=>{
    const tag = node.collectionTag;
    if (tag !== null) $b8b130b8bbf51c97$var$dirtyTag(tag, null);
};
// src/autotrackMemoize/proxy.ts
var $b8b130b8bbf51c97$var$REDUX_PROXY_LABEL = Symbol();
var $b8b130b8bbf51c97$var$nextId = 0;
var $b8b130b8bbf51c97$var$proto = Object.getPrototypeOf({});
var $b8b130b8bbf51c97$var$ObjectTreeNode = class {
    constructor(value){
        this.value = value;
        $b8b130b8bbf51c97$var$__publicField(this, "proxy", new Proxy(this, $b8b130b8bbf51c97$var$objectProxyHandler));
        $b8b130b8bbf51c97$var$__publicField(this, "tag", $b8b130b8bbf51c97$var$createTag());
        $b8b130b8bbf51c97$var$__publicField(this, "tags", {});
        $b8b130b8bbf51c97$var$__publicField(this, "children", {});
        $b8b130b8bbf51c97$var$__publicField(this, "collectionTag", null);
        $b8b130b8bbf51c97$var$__publicField(this, "id", $b8b130b8bbf51c97$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $b8b130b8bbf51c97$var$objectProxyHandler = {
    get (node, key) {
        function calculateResult() {
            const { value: value } = node;
            const childValue = Reflect.get(value, key);
            if (typeof key === "symbol") return childValue;
            if (key in $b8b130b8bbf51c97$var$proto) return childValue;
            if (typeof childValue === "object" && childValue !== null) {
                let childNode = node.children[key];
                if (childNode === void 0) childNode = node.children[key] = $b8b130b8bbf51c97$var$createNode(childValue);
                if (childNode.tag) $b8b130b8bbf51c97$var$getValue(childNode.tag);
                return childNode.proxy;
            } else {
                let tag = node.tags[key];
                if (tag === void 0) {
                    tag = node.tags[key] = $b8b130b8bbf51c97$var$createTag();
                    tag.value = childValue;
                }
                $b8b130b8bbf51c97$var$getValue(tag);
                return childValue;
            }
        }
        const res = calculateResult();
        return res;
    },
    ownKeys (node) {
        $b8b130b8bbf51c97$var$consumeCollection(node);
        return Reflect.ownKeys(node.value);
    },
    getOwnPropertyDescriptor (node, prop) {
        return Reflect.getOwnPropertyDescriptor(node.value, prop);
    },
    has (node, prop) {
        return Reflect.has(node.value, prop);
    }
};
var $b8b130b8bbf51c97$var$ArrayTreeNode = class {
    constructor(value){
        this.value = value;
        $b8b130b8bbf51c97$var$__publicField(this, "proxy", new Proxy([
            this
        ], $b8b130b8bbf51c97$var$arrayProxyHandler));
        $b8b130b8bbf51c97$var$__publicField(this, "tag", $b8b130b8bbf51c97$var$createTag());
        $b8b130b8bbf51c97$var$__publicField(this, "tags", {});
        $b8b130b8bbf51c97$var$__publicField(this, "children", {});
        $b8b130b8bbf51c97$var$__publicField(this, "collectionTag", null);
        $b8b130b8bbf51c97$var$__publicField(this, "id", $b8b130b8bbf51c97$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $b8b130b8bbf51c97$var$arrayProxyHandler = {
    get ([node], key) {
        if (key === "length") $b8b130b8bbf51c97$var$consumeCollection(node);
        return $b8b130b8bbf51c97$var$objectProxyHandler.get(node, key);
    },
    ownKeys ([node]) {
        return $b8b130b8bbf51c97$var$objectProxyHandler.ownKeys(node);
    },
    getOwnPropertyDescriptor ([node], prop) {
        return $b8b130b8bbf51c97$var$objectProxyHandler.getOwnPropertyDescriptor(node, prop);
    },
    has ([node], prop) {
        return $b8b130b8bbf51c97$var$objectProxyHandler.has(node, prop);
    }
};
function $b8b130b8bbf51c97$var$createNode(value) {
    if (Array.isArray(value)) return new $b8b130b8bbf51c97$var$ArrayTreeNode(value);
    return new $b8b130b8bbf51c97$var$ObjectTreeNode(value);
}
function $b8b130b8bbf51c97$var$updateNode(node, newValue) {
    const { value: value, tags: tags, children: children } = node;
    node.value = newValue;
    if (Array.isArray(value) && Array.isArray(newValue) && value.length !== newValue.length) $b8b130b8bbf51c97$var$dirtyCollection(node);
    else if (value !== newValue) {
        let oldKeysSize = 0;
        let newKeysSize = 0;
        let anyKeysAdded = false;
        for(const _key in value)oldKeysSize++;
        for(const key in newValue){
            newKeysSize++;
            if (!(key in value)) {
                anyKeysAdded = true;
                break;
            }
        }
        const isDifferent = anyKeysAdded || oldKeysSize !== newKeysSize;
        if (isDifferent) $b8b130b8bbf51c97$var$dirtyCollection(node);
    }
    for(const key in tags){
        const childValue = value[key];
        const newChildValue = newValue[key];
        if (childValue !== newChildValue) {
            $b8b130b8bbf51c97$var$dirtyCollection(node);
            $b8b130b8bbf51c97$var$dirtyTag(tags[key], newChildValue);
        }
        if (typeof newChildValue === "object" && newChildValue !== null) delete tags[key];
    }
    for(const key in children){
        const childNode = children[key];
        const newChildValue = newValue[key];
        const childValue = childNode.value;
        if (childValue === newChildValue) continue;
        else if (typeof newChildValue === "object" && newChildValue !== null) $b8b130b8bbf51c97$var$updateNode(childNode, newChildValue);
        else {
            $b8b130b8bbf51c97$var$deleteNode(childNode);
            delete children[key];
        }
    }
}
function $b8b130b8bbf51c97$var$deleteNode(node) {
    if (node.tag) $b8b130b8bbf51c97$var$dirtyTag(node.tag, null);
    $b8b130b8bbf51c97$var$dirtyCollection(node);
    for(const key in node.tags)$b8b130b8bbf51c97$var$dirtyTag(node.tags[key], null);
    for(const key in node.children)$b8b130b8bbf51c97$var$deleteNode(node.children[key]);
}
// src/lruMemoize.ts
function $b8b130b8bbf51c97$var$createSingletonCache(equals) {
    let entry;
    return {
        get (key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $b8b130b8bbf51c97$var$NOT_FOUND;
        },
        put (key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries () {
            return entry ? [
                entry
            ] : [];
        },
        clear () {
            entry = void 0;
        }
    };
}
function $b8b130b8bbf51c97$var$createLruCache(maxSize, equals) {
    let entries = [];
    function get(key) {
        const cacheIndex = entries.findIndex((entry)=>equals(key, entry.key));
        if (cacheIndex > -1) {
            const entry = entries[cacheIndex];
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        }
        return $b8b130b8bbf51c97$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $b8b130b8bbf51c97$var$NOT_FOUND) {
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $b8b130b8bbf51c97$export$3f025202a230c6dd = (a, b)=>a === b;
function $b8b130b8bbf51c97$var$createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
        const { length: length } = prev;
        for(let i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $b8b130b8bbf51c97$export$d8ead1d92249919b(func, equalityCheckOrOptions) {
    const providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    const { equalityCheck: equalityCheck = $b8b130b8bbf51c97$export$3f025202a230c6dd, maxSize: maxSize = 1, resultEqualityCheck: resultEqualityCheck } = providedOptions;
    const comparator = $b8b130b8bbf51c97$var$createCacheKeyComparator(equalityCheck);
    let resultsCount = 0;
    const cache = maxSize === 1 ? $b8b130b8bbf51c97$var$createSingletonCache(comparator) : $b8b130b8bbf51c97$var$createLruCache(maxSize, comparator);
    function memoized() {
        let value = cache.get(arguments);
        if (value === $b8b130b8bbf51c97$var$NOT_FOUND) {
            value = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const entries = cache.getEntries();
                const matchingEntry = entries.find((entry)=>resultEqualityCheck(entry.value, value));
                if (matchingEntry) {
                    value = matchingEntry.value;
                    resultsCount !== 0 && resultsCount--;
                }
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = ()=>{
        cache.clear();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/autotrackMemoize/autotrackMemoize.ts
function $b8b130b8bbf51c97$export$c8f9cf88d9fdee55(func) {
    const node = $b8b130b8bbf51c97$var$createNode([]);
    let lastArgs = null;
    const shallowEqual = $b8b130b8bbf51c97$var$createCacheKeyComparator($b8b130b8bbf51c97$export$3f025202a230c6dd);
    const cache = $b8b130b8bbf51c97$var$createCache(()=>{
        const res = func.apply(null, node.proxy);
        return res;
    });
    function memoized() {
        if (!shallowEqual(lastArgs, arguments)) {
            $b8b130b8bbf51c97$var$updateNode(node, arguments);
            lastArgs = arguments;
        }
        return cache.value;
    }
    memoized.clearCache = ()=>{
        return cache.clear();
    };
    return memoized;
}
// src/weakMapMemoize.ts
var $b8b130b8bbf51c97$var$StrongRef = class {
    constructor(value){
        this.value = value;
    }
    deref() {
        return this.value;
    }
};
var $b8b130b8bbf51c97$var$Ref = typeof WeakRef !== "undefined" ? WeakRef : $b8b130b8bbf51c97$var$StrongRef;
var $b8b130b8bbf51c97$var$UNTERMINATED = 0;
var $b8b130b8bbf51c97$var$TERMINATED = 1;
function $b8b130b8bbf51c97$var$createCacheNode() {
    return {
        s: $b8b130b8bbf51c97$var$UNTERMINATED,
        v: void 0,
        o: null,
        p: null
    };
}
function $b8b130b8bbf51c97$export$8402dc26d96f6902(func, options = {}) {
    let fnNode = $b8b130b8bbf51c97$var$createCacheNode();
    const { resultEqualityCheck: resultEqualityCheck } = options;
    let lastResult;
    let resultsCount = 0;
    function memoized() {
        var _a, _b;
        let cacheNode = fnNode;
        const { length: length } = arguments;
        for(let i = 0, l = length; i < l; i++){
            const arg = arguments[i];
            if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
                let objectCache = cacheNode.o;
                if (objectCache === null) cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
                const objectNode = objectCache.get(arg);
                if (objectNode === void 0) {
                    cacheNode = $b8b130b8bbf51c97$var$createCacheNode();
                    objectCache.set(arg, cacheNode);
                } else cacheNode = objectNode;
            } else {
                let primitiveCache = cacheNode.p;
                if (primitiveCache === null) cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
                const primitiveNode = primitiveCache.get(arg);
                if (primitiveNode === void 0) {
                    cacheNode = $b8b130b8bbf51c97$var$createCacheNode();
                    primitiveCache.set(arg, cacheNode);
                } else cacheNode = primitiveNode;
            }
        }
        const terminatedNode = cacheNode;
        let result;
        if (cacheNode.s === $b8b130b8bbf51c97$var$TERMINATED) result = cacheNode.v;
        else {
            result = func.apply(null, arguments);
            resultsCount++;
        }
        terminatedNode.s = $b8b130b8bbf51c97$var$TERMINATED;
        if (resultEqualityCheck) {
            const lastResultValue = (_b = (_a = lastResult == null ? void 0 : lastResult.deref) == null ? void 0 : _a.call(lastResult)) != null ? _b : lastResult;
            if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
                result = lastResultValue;
                resultsCount !== 0 && resultsCount--;
            }
            const needsWeakRef = typeof result === "object" && result !== null || typeof result === "function";
            lastResult = needsWeakRef ? new $b8b130b8bbf51c97$var$Ref(result) : result;
        }
        terminatedNode.v = result;
        return result;
    }
    memoized.clearCache = ()=>{
        fnNode = $b8b130b8bbf51c97$var$createCacheNode();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/createSelectorCreator.ts
function $b8b130b8bbf51c97$export$5943f4447f6ef248(memoizeOrOptions, ...memoizeOptionsFromArgs) {
    const createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
        memoize: memoizeOrOptions,
        memoizeOptions: memoizeOptionsFromArgs
    } : memoizeOrOptions;
    const createSelector2 = (...createSelectorArgs)=>{
        let recomputations = 0;
        let dependencyRecomputations = 0;
        let lastResult;
        let directlyPassedOptions = {};
        let resultFunc = createSelectorArgs.pop();
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc;
            resultFunc = createSelectorArgs.pop();
        }
        $b8b130b8bbf51c97$var$assertIsFunction(resultFunc, `createSelector expects an output function after the inputs, but received: [${typeof resultFunc}]`);
        const combinedOptions = $b8b130b8bbf51c97$var$__spreadValues($b8b130b8bbf51c97$var$__spreadValues({}, createSelectorCreatorOptions), directlyPassedOptions);
        const { memoize: memoize, memoizeOptions: memoizeOptions = [], argsMemoize: argsMemoize = $b8b130b8bbf51c97$export$8402dc26d96f6902, argsMemoizeOptions: argsMemoizeOptions = [], devModeChecks: devModeChecks = {} } = combinedOptions;
        const finalMemoizeOptions = $b8b130b8bbf51c97$var$ensureIsArray(memoizeOptions);
        const finalArgsMemoizeOptions = $b8b130b8bbf51c97$var$ensureIsArray(argsMemoizeOptions);
        const dependencies = $b8b130b8bbf51c97$var$getDependencies(createSelectorArgs);
        const memoizedResultFunc = memoize(function recomputationWrapper() {
            recomputations++;
            return resultFunc.apply(null, arguments);
        }, ...finalMemoizeOptions);
        let firstRun = true;
        const selector = argsMemoize(function dependenciesChecker() {
            dependencyRecomputations++;
            const inputSelectorResults = $b8b130b8bbf51c97$var$collectInputSelectorResults(dependencies, arguments);
            lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
            return lastResult;
        }, ...finalArgsMemoizeOptions);
        return Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            dependencyRecomputations: ()=>dependencyRecomputations,
            resetDependencyRecomputations: ()=>{
                dependencyRecomputations = 0;
            },
            lastResult: ()=>lastResult,
            recomputations: ()=>recomputations,
            resetRecomputations: ()=>{
                recomputations = 0;
            },
            memoize: memoize,
            argsMemoize: argsMemoize
        });
    };
    Object.assign(createSelector2, {
        withTypes: ()=>createSelector2
    });
    return createSelector2;
}
var $b8b130b8bbf51c97$export$595d22ed68ca2841 = /* @__PURE__ */ $b8b130b8bbf51c97$export$5943f4447f6ef248($b8b130b8bbf51c97$export$8402dc26d96f6902);
// src/createStructuredSelector.ts
var $b8b130b8bbf51c97$export$75979cfcd91bf38f = Object.assign((inputSelectorsObject, selectorCreator = $b8b130b8bbf51c97$export$595d22ed68ca2841)=>{
    $b8b130b8bbf51c97$var$assertIsObject(inputSelectorsObject, `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof inputSelectorsObject}`);
    const inputSelectorKeys = Object.keys(inputSelectorsObject);
    const dependencies = inputSelectorKeys.map((key)=>inputSelectorsObject[key]);
    const structuredSelector = selectorCreator(dependencies, (...inputSelectorResults)=>{
        return inputSelectorResults.reduce((composition, value, index)=>{
            composition[inputSelectorKeys[index]] = value;
            return composition;
        }, {});
    });
    return structuredSelector;
}, {
    withTypes: ()=>$b8b130b8bbf51c97$export$75979cfcd91bf38f
});

// src/utils/formatProdErrorMessage.ts
function $d98493d2be9cbe4c$var$formatProdErrorMessage(code) {
    return `Minified Redux error #${code}; visit https://redux.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}
// src/utils/symbol-observable.ts
var $d98493d2be9cbe4c$var$$$observable = /* @__PURE__ */ (()=>typeof Symbol === "function" && Symbol.observable || "@@observable")();
var $d98493d2be9cbe4c$var$symbol_observable_default = $d98493d2be9cbe4c$var$$$observable;
// src/utils/actionTypes.ts
var $d98493d2be9cbe4c$var$randomString = ()=>Math.random().toString(36).substring(7).split("").join(".");
var $d98493d2be9cbe4c$var$ActionTypes = {
    INIT: `@@redux/INIT${$d98493d2be9cbe4c$var$randomString()}`,
    REPLACE: `@@redux/REPLACE${$d98493d2be9cbe4c$var$randomString()}`,
    PROBE_UNKNOWN_ACTION: ()=>`@@redux/PROBE_UNKNOWN_ACTION${$d98493d2be9cbe4c$var$randomString()}`
};
var $d98493d2be9cbe4c$export$4219e499db7ca678 = $d98493d2be9cbe4c$var$ActionTypes;
// src/utils/isPlainObject.ts
function $d98493d2be9cbe4c$export$53b83ca8eaab0383(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}
// src/utils/kindOf.ts
function $d98493d2be9cbe4c$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    const type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($d98493d2be9cbe4c$var$isDate(val)) return "date";
    if ($d98493d2be9cbe4c$var$isError(val)) return "error";
    const constructorName = $d98493d2be9cbe4c$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    }
    return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $d98493d2be9cbe4c$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $d98493d2be9cbe4c$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $d98493d2be9cbe4c$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $d98493d2be9cbe4c$var$kindOf(val) {
    let typeOfVal = typeof val;
    return typeOfVal;
}
// src/createStore.ts
function $d98493d2be9cbe4c$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    if (typeof reducer !== "function") throw new Error($d98493d2be9cbe4c$var$formatProdErrorMessage(2));
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($d98493d2be9cbe4c$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = void 0;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($d98493d2be9cbe4c$var$formatProdErrorMessage(1));
        return enhancer($d98493d2be9cbe4c$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    let currentReducer = reducer;
    let currentState = preloadedState;
    let currentListeners = /* @__PURE__ */ new Map();
    let nextListeners = currentListeners;
    let listenerIdCounter = 0;
    let isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) {
            nextListeners = /* @__PURE__ */ new Map();
            currentListeners.forEach((listener, key)=>{
                nextListeners.set(key, listener);
            });
        }
    }
    function getState() {
        if (isDispatching) throw new Error($d98493d2be9cbe4c$var$formatProdErrorMessage(3));
        return currentState;
    }
    function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($d98493d2be9cbe4c$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($d98493d2be9cbe4c$var$formatProdErrorMessage(5));
        let isSubscribed = true;
        ensureCanMutateNextListeners();
        const listenerId = listenerIdCounter++;
        nextListeners.set(listenerId, listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($d98493d2be9cbe4c$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            nextListeners.delete(listenerId);
            currentListeners = null;
        };
    }
    function dispatch(action) {
        if (!$d98493d2be9cbe4c$export$53b83ca8eaab0383(action)) throw new Error($d98493d2be9cbe4c$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($d98493d2be9cbe4c$var$formatProdErrorMessage(8));
        if (typeof action.type !== "string") throw new Error($d98493d2be9cbe4c$var$formatProdErrorMessage(17));
        if (isDispatching) throw new Error($d98493d2be9cbe4c$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        const listeners = currentListeners = nextListeners;
        listeners.forEach((listener)=>{
            listener();
        });
        return action;
    }
    function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($d98493d2be9cbe4c$var$formatProdErrorMessage(10));
        currentReducer = nextReducer;
        dispatch({
            type: $d98493d2be9cbe4c$export$4219e499db7ca678.REPLACE
        });
    }
    function observable() {
        const outerSubscribe = subscribe;
        return {
            /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe (observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($d98493d2be9cbe4c$var$formatProdErrorMessage(11));
                function observeState() {
                    const observerAsObserver = observer;
                    if (observerAsObserver.next) observerAsObserver.next(getState());
                }
                observeState();
                const unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            },
            [$d98493d2be9cbe4c$var$symbol_observable_default] () {
                return this;
            }
        };
    }
    dispatch({
        type: $d98493d2be9cbe4c$export$4219e499db7ca678.INIT
    });
    const store = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer,
        [$d98493d2be9cbe4c$var$symbol_observable_default]: observable
    };
    return store;
}
function $d98493d2be9cbe4c$export$8928921ea2d3b126(reducer, preloadedState, enhancer) {
    return $d98493d2be9cbe4c$export$f51a9068ac82ea43(reducer, preloadedState, enhancer);
}
// src/utils/warning.ts
function $d98493d2be9cbe4c$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/combineReducers.ts
function $d98493d2be9cbe4c$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    const reducerKeys = Object.keys(reducers);
    const argumentName = action && action.type === $d98493d2be9cbe4c$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$d98493d2be9cbe4c$export$53b83ca8eaab0383(inputState)) return `The ${argumentName} has unexpected type of "${$d98493d2be9cbe4c$var$kindOf(inputState)}". Expected argument to be an object with the following keys: "${reducerKeys.join('", "')}"`;
    const unexpectedKeys = Object.keys(inputState).filter((key)=>!reducers.hasOwnProperty(key) && !unexpectedKeyCache[key]);
    unexpectedKeys.forEach((key)=>{
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $d98493d2be9cbe4c$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return `Unexpected ${unexpectedKeys.length > 1 ? "keys" : "key"} "${unexpectedKeys.join('", "')}" found in ${argumentName}. Expected to find one of the known reducer keys instead: "${reducerKeys.join('", "')}". Unexpected keys will be ignored.`;
}
function $d98493d2be9cbe4c$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach((key)=>{
        const reducer = reducers[key];
        const initialState = reducer(void 0, {
            type: $d98493d2be9cbe4c$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($d98493d2be9cbe4c$var$formatProdErrorMessage(12));
        if (typeof reducer(void 0, {
            type: $d98493d2be9cbe4c$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($d98493d2be9cbe4c$var$formatProdErrorMessage(13));
    });
}
function $d98493d2be9cbe4c$export$66e4520cdb265d18(reducers) {
    const reducerKeys = Object.keys(reducers);
    const finalReducers = {};
    for(let i = 0; i < reducerKeys.length; i++){
        const key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    const finalReducerKeys = Object.keys(finalReducers);
    let unexpectedKeyCache;
    let shapeAssertionError;
    try {
        $d98493d2be9cbe4c$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state = {}, action) {
        if (shapeAssertionError) throw shapeAssertionError;
        let hasChanged = false;
        const nextState = {};
        for(let i = 0; i < finalReducerKeys.length; i++){
            const key = finalReducerKeys[i];
            const reducer = finalReducers[key];
            const previousStateForKey = state[key];
            const nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                const actionType = action && action.type;
                throw new Error($d98493d2be9cbe4c$var$formatProdErrorMessage(14));
            }
            nextState[key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
// src/bindActionCreators.ts
function $d98493d2be9cbe4c$var$bindActionCreator(actionCreator, dispatch) {
    return function(...args) {
        return dispatch(actionCreator.apply(this, args));
    };
}
function $d98493d2be9cbe4c$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $d98493d2be9cbe4c$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($d98493d2be9cbe4c$var$formatProdErrorMessage(16));
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $d98493d2be9cbe4c$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
// src/compose.ts
function $d98493d2be9cbe4c$export$f672e0b6f7222cd7(...funcs) {
    if (funcs.length === 0) return (arg)=>arg;
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce((a, b)=>(...args)=>a(b(...args)));
}
// src/applyMiddleware.ts
function $d98493d2be9cbe4c$export$9ff26e0402cc7b7(...middlewares) {
    return (createStore2)=>(reducer, preloadedState)=>{
            const store = createStore2(reducer, preloadedState);
            let dispatch = ()=>{
                throw new Error($d98493d2be9cbe4c$var$formatProdErrorMessage(15));
            };
            const middlewareAPI = {
                getState: store.getState,
                dispatch: (action, ...args)=>dispatch(action, ...args)
            };
            const chain = middlewares.map((middleware)=>middleware(middlewareAPI));
            dispatch = $d98493d2be9cbe4c$export$f672e0b6f7222cd7(...chain)(store.dispatch);
            return {
                ...store,
                dispatch: dispatch
            };
        };
}
// src/utils/isAction.ts
function $d98493d2be9cbe4c$export$b956e38827fca970(action) {
    return $d98493d2be9cbe4c$export$53b83ca8eaab0383(action) && "type" in action && typeof action.type === "string";
}


var $d08a86c1c27131a8$var$__defProp = Object.defineProperty;
var $d08a86c1c27131a8$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $d08a86c1c27131a8$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $d08a86c1c27131a8$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $d08a86c1c27131a8$var$__defNormalProp = (obj, key, value)=>key in obj ? $d08a86c1c27131a8$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $d08a86c1c27131a8$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($d08a86c1c27131a8$var$__hasOwnProp.call(b, prop)) $d08a86c1c27131a8$var$__defNormalProp(a, prop, b[prop]);
    if ($d08a86c1c27131a8$var$__getOwnPropSymbols) {
        for (var prop of $d08a86c1c27131a8$var$__getOwnPropSymbols(b))if ($d08a86c1c27131a8$var$__propIsEnum.call(b, prop)) $d08a86c1c27131a8$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
// src/utils/env.ts
var $d08a86c1c27131a8$export$45b790e32b2810ee = Symbol.for("immer-nothing");
var $d08a86c1c27131a8$export$6ee2082928bcb0ee = Symbol.for("immer-draftable");
var $d08a86c1c27131a8$var$DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var $d08a86c1c27131a8$var$errors = [];
function $d08a86c1c27131a8$var$die(error, ...args) {
    throw new Error(`[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`);
}
// src/utils/common.ts
var $d08a86c1c27131a8$var$getPrototypeOf = Object.getPrototypeOf;
function $d08a86c1c27131a8$export$541ac630993a4c84(value) {
    return !!value && !!value[$d08a86c1c27131a8$var$DRAFT_STATE];
}
function $d08a86c1c27131a8$export$16e3aed3edb85946(value) {
    var _a;
    if (!value) return false;
    return $d08a86c1c27131a8$var$isPlainObject(value) || Array.isArray(value) || !!value[$d08a86c1c27131a8$export$6ee2082928bcb0ee] || !!((_a = value.constructor) == null ? void 0 : _a[$d08a86c1c27131a8$export$6ee2082928bcb0ee]) || $d08a86c1c27131a8$var$isMap(value) || $d08a86c1c27131a8$var$isSet(value);
}
var $d08a86c1c27131a8$var$objectCtorString = Object.prototype.constructor.toString();
function $d08a86c1c27131a8$var$isPlainObject(value) {
    if (!value || typeof value !== "object") return false;
    const proto = $d08a86c1c27131a8$var$getPrototypeOf(value);
    if (proto === null) return true;
    const Ctor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    if (Ctor === Object) return true;
    return typeof Ctor == "function" && Function.toString.call(Ctor) === $d08a86c1c27131a8$var$objectCtorString;
}
function $d08a86c1c27131a8$export$22e8af3f75a010e3(value) {
    if (!$d08a86c1c27131a8$export$541ac630993a4c84(value)) $d08a86c1c27131a8$var$die(15, value);
    return value[$d08a86c1c27131a8$var$DRAFT_STATE].base_;
}
function $d08a86c1c27131a8$var$each(obj, iter) {
    if ($d08a86c1c27131a8$var$getArchtype(obj) === 0 /* Object */ ) Reflect.ownKeys(obj).forEach((key)=>{
        iter(key, obj[key], obj);
    });
    else obj.forEach((entry, index)=>iter(index, entry, obj));
}
function $d08a86c1c27131a8$var$getArchtype(thing) {
    const state = thing[$d08a86c1c27131a8$var$DRAFT_STATE];
    return state ? state.type_ : Array.isArray(thing) ? 1 /* Array */  : $d08a86c1c27131a8$var$isMap(thing) ? 2 /* Map */  : $d08a86c1c27131a8$var$isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
function $d08a86c1c27131a8$var$has(thing, prop) {
    return $d08a86c1c27131a8$var$getArchtype(thing) === 2 /* Map */  ? thing.has(prop) : Object.prototype.hasOwnProperty.call(thing, prop);
}
function $d08a86c1c27131a8$var$get(thing, prop) {
    return $d08a86c1c27131a8$var$getArchtype(thing) === 2 /* Map */  ? thing.get(prop) : thing[prop];
}
function $d08a86c1c27131a8$var$set(thing, propOrOldValue, value) {
    const t = $d08a86c1c27131a8$var$getArchtype(thing);
    if (t === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (t === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
}
function $d08a86c1c27131a8$var$is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $d08a86c1c27131a8$var$isMap(target) {
    return target instanceof Map;
}
function $d08a86c1c27131a8$var$isSet(target) {
    return target instanceof Set;
}
function $d08a86c1c27131a8$var$latest(state) {
    return state.copy_ || state.base_;
}
function $d08a86c1c27131a8$var$shallowCopy(base, strict) {
    if ($d08a86c1c27131a8$var$isMap(base)) return new Map(base);
    if ($d08a86c1c27131a8$var$isSet(base)) return new Set(base);
    if (Array.isArray(base)) return Array.prototype.slice.call(base);
    if (!strict && $d08a86c1c27131a8$var$isPlainObject(base)) {
        if (!$d08a86c1c27131a8$var$getPrototypeOf(base)) {
            const obj = /* @__PURE__ */ Object.create(null);
            return Object.assign(obj, base);
        }
        return $d08a86c1c27131a8$var$__spreadValues({}, base);
    }
    const descriptors = Object.getOwnPropertyDescriptors(base);
    delete descriptors[$d08a86c1c27131a8$var$DRAFT_STATE];
    let keys = Reflect.ownKeys(descriptors);
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        const desc = descriptors[key];
        if (desc.writable === false) {
            desc.writable = true;
            desc.configurable = true;
        }
        if (desc.get || desc.set) descriptors[key] = {
            configurable: true,
            writable: true,
            // could live with !!desc.set as well here...
            enumerable: desc.enumerable,
            value: base[key]
        };
    }
    return Object.create($d08a86c1c27131a8$var$getPrototypeOf(base), descriptors);
}
function $d08a86c1c27131a8$export$792f3d81ea979f55(obj, deep = false) {
    if ($d08a86c1c27131a8$var$isFrozen(obj) || $d08a86c1c27131a8$export$541ac630993a4c84(obj) || !$d08a86c1c27131a8$export$16e3aed3edb85946(obj)) return obj;
    if ($d08a86c1c27131a8$var$getArchtype(obj) > 1) obj.set = obj.add = obj.clear = obj.delete = $d08a86c1c27131a8$var$dontMutateFrozenCollections;
    Object.freeze(obj);
    if (deep) Object.entries(obj).forEach(([key, value])=>$d08a86c1c27131a8$export$792f3d81ea979f55(value, true));
    return obj;
}
function $d08a86c1c27131a8$var$dontMutateFrozenCollections() {
    $d08a86c1c27131a8$var$die(2);
}
function $d08a86c1c27131a8$var$isFrozen(obj) {
    return Object.isFrozen(obj);
}
// src/utils/plugins.ts
var $d08a86c1c27131a8$var$plugins = {};
function $d08a86c1c27131a8$var$getPlugin(pluginKey) {
    const plugin = $d08a86c1c27131a8$var$plugins[pluginKey];
    if (!plugin) $d08a86c1c27131a8$var$die(0, pluginKey);
    return plugin;
}
function $d08a86c1c27131a8$var$loadPlugin(pluginKey, implementation) {
    if (!$d08a86c1c27131a8$var$plugins[pluginKey]) $d08a86c1c27131a8$var$plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var $d08a86c1c27131a8$var$currentScope;
function $d08a86c1c27131a8$var$getCurrentScope() {
    return $d08a86c1c27131a8$var$currentScope;
}
function $d08a86c1c27131a8$var$createScope(parent_, immer_) {
    return {
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0
    };
}
function $d08a86c1c27131a8$var$usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        $d08a86c1c27131a8$var$getPlugin("Patches");
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function $d08a86c1c27131a8$var$revokeScope(scope) {
    $d08a86c1c27131a8$var$leaveScope(scope);
    scope.drafts_.forEach($d08a86c1c27131a8$var$revokeDraft);
    scope.drafts_ = null;
}
function $d08a86c1c27131a8$var$leaveScope(scope) {
    if (scope === $d08a86c1c27131a8$var$currentScope) $d08a86c1c27131a8$var$currentScope = scope.parent_;
}
function $d08a86c1c27131a8$var$enterScope(immer2) {
    return $d08a86c1c27131a8$var$currentScope = $d08a86c1c27131a8$var$createScope($d08a86c1c27131a8$var$currentScope, immer2);
}
function $d08a86c1c27131a8$var$revokeDraft(draft) {
    const state = draft[$d08a86c1c27131a8$var$DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function $d08a86c1c27131a8$var$processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    const baseDraft = scope.drafts_[0];
    const isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[$d08a86c1c27131a8$var$DRAFT_STATE].modified_) {
            $d08a86c1c27131a8$var$revokeScope(scope);
            $d08a86c1c27131a8$var$die(4);
        }
        if ($d08a86c1c27131a8$export$16e3aed3edb85946(result)) {
            result = $d08a86c1c27131a8$var$finalize(scope, result);
            if (!scope.parent_) $d08a86c1c27131a8$var$maybeFreeze(scope, result);
        }
        if (scope.patches_) $d08a86c1c27131a8$var$getPlugin("Patches").generateReplacementPatches_(baseDraft[$d08a86c1c27131a8$var$DRAFT_STATE].base_, result, scope.patches_, scope.inversePatches_);
    } else result = $d08a86c1c27131a8$var$finalize(scope, baseDraft, []);
    $d08a86c1c27131a8$var$revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== $d08a86c1c27131a8$export$45b790e32b2810ee ? result : void 0;
}
function $d08a86c1c27131a8$var$finalize(rootScope, value, path) {
    if ($d08a86c1c27131a8$var$isFrozen(value)) return value;
    const state = value[$d08a86c1c27131a8$var$DRAFT_STATE];
    if (!state) {
        $d08a86c1c27131a8$var$each(value, (key, childValue)=>$d08a86c1c27131a8$var$finalizeProperty(rootScope, state, value, key, childValue, path));
        return value;
    }
    if (state.scope_ !== rootScope) return value;
    if (!state.modified_) {
        $d08a86c1c27131a8$var$maybeFreeze(rootScope, state.base_, true);
        return state.base_;
    }
    if (!state.finalized_) {
        state.finalized_ = true;
        state.scope_.unfinalizedDrafts_--;
        const result = state.copy_;
        let resultEach = result;
        let isSet2 = false;
        if (state.type_ === 3 /* Set */ ) {
            resultEach = new Set(result);
            result.clear();
            isSet2 = true;
        }
        $d08a86c1c27131a8$var$each(resultEach, (key, childValue)=>$d08a86c1c27131a8$var$finalizeProperty(rootScope, state, result, key, childValue, path, isSet2));
        $d08a86c1c27131a8$var$maybeFreeze(rootScope, result, false);
        if (path && rootScope.patches_) $d08a86c1c27131a8$var$getPlugin("Patches").generatePatches_(state, path, rootScope.patches_, rootScope.inversePatches_);
    }
    return state.copy_;
}
function $d08a86c1c27131a8$var$finalizeProperty(rootScope, parentState, targetObject, prop, childValue, rootPath, targetIsSet) {
    if ($d08a86c1c27131a8$export$541ac630993a4c84(childValue)) {
        const path = rootPath && parentState && parentState.type_ !== 3 /* Set */  && // Set objects are atomic since they have no keys.
        !$d08a86c1c27131a8$var$has(parentState.assigned_, prop) ? rootPath.concat(prop) : void 0;
        const res = $d08a86c1c27131a8$var$finalize(rootScope, childValue, path);
        $d08a86c1c27131a8$var$set(targetObject, prop, res);
        if ($d08a86c1c27131a8$export$541ac630993a4c84(res)) rootScope.canAutoFreeze_ = false;
        else return;
    } else if (targetIsSet) targetObject.add(childValue);
    if ($d08a86c1c27131a8$export$16e3aed3edb85946(childValue) && !$d08a86c1c27131a8$var$isFrozen(childValue)) {
        if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return;
        $d08a86c1c27131a8$var$finalize(rootScope, childValue);
        if ((!parentState || !parentState.scope_.parent_) && typeof prop !== "symbol" && Object.prototype.propertyIsEnumerable.call(targetObject, prop)) $d08a86c1c27131a8$var$maybeFreeze(rootScope, childValue);
    }
}
function $d08a86c1c27131a8$var$maybeFreeze(scope, value, deep = false) {
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) $d08a86c1c27131a8$export$792f3d81ea979f55(value, deep);
}
// src/core/proxy.ts
function $d08a86c1c27131a8$var$createProxyProxy(base, parent) {
    const isArray = Array.isArray(base);
    const state = {
        type_: isArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : $d08a86c1c27131a8$var$getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        assigned_: {},
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false
    };
    let target = state;
    let traps = $d08a86c1c27131a8$var$objectTraps;
    if (isArray) {
        target = [
            state
        ];
        traps = $d08a86c1c27131a8$var$arrayTraps;
    }
    const { revoke: revoke, proxy: proxy } = Proxy.revocable(target, traps);
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return proxy;
}
var $d08a86c1c27131a8$var$objectTraps = {
    get (state, prop) {
        if (prop === $d08a86c1c27131a8$var$DRAFT_STATE) return state;
        const source = $d08a86c1c27131a8$var$latest(state);
        if (!$d08a86c1c27131a8$var$has(source, prop)) return $d08a86c1c27131a8$var$readPropFromProto(state, source, prop);
        const value = source[prop];
        if (state.finalized_ || !$d08a86c1c27131a8$export$16e3aed3edb85946(value)) return value;
        if (value === $d08a86c1c27131a8$var$peek(state.base_, prop)) {
            $d08a86c1c27131a8$var$prepareCopy(state);
            return state.copy_[prop] = $d08a86c1c27131a8$var$createProxy(value, state);
        }
        return value;
    },
    has (state, prop) {
        return prop in $d08a86c1c27131a8$var$latest(state);
    },
    ownKeys (state) {
        return Reflect.ownKeys($d08a86c1c27131a8$var$latest(state));
    },
    set (state, prop, value) {
        const desc = $d08a86c1c27131a8$var$getDescriptorFromProto($d08a86c1c27131a8$var$latest(state), prop);
        if (desc == null ? void 0 : desc.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            const current2 = $d08a86c1c27131a8$var$peek($d08a86c1c27131a8$var$latest(state), prop);
            const currentState = current2 == null ? void 0 : current2[$d08a86c1c27131a8$var$DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_[prop] = false;
                return true;
            }
            if ($d08a86c1c27131a8$var$is(value, current2) && (value !== void 0 || $d08a86c1c27131a8$var$has(state.base_, prop))) return true;
            $d08a86c1c27131a8$var$prepareCopy(state);
            $d08a86c1c27131a8$var$markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_[prop] = true;
        return true;
    },
    deleteProperty (state, prop) {
        if ($d08a86c1c27131a8$var$peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_[prop] = false;
            $d08a86c1c27131a8$var$prepareCopy(state);
            $d08a86c1c27131a8$var$markChanged(state);
        } else delete state.assigned_[prop];
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor (state, prop) {
        const owner = $d08a86c1c27131a8$var$latest(state);
        const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            writable: true,
            configurable: state.type_ !== 1 /* Array */  || prop !== "length",
            enumerable: desc.enumerable,
            value: owner[prop]
        };
    },
    defineProperty () {
        $d08a86c1c27131a8$var$die(11);
    },
    getPrototypeOf (state) {
        return $d08a86c1c27131a8$var$getPrototypeOf(state.base_);
    },
    setPrototypeOf () {
        $d08a86c1c27131a8$var$die(12);
    }
};
var $d08a86c1c27131a8$var$arrayTraps = {};
$d08a86c1c27131a8$var$each($d08a86c1c27131a8$var$objectTraps, (key, fn)=>{
    $d08a86c1c27131a8$var$arrayTraps[key] = function() {
        arguments[0] = arguments[0][0];
        return fn.apply(this, arguments);
    };
});
$d08a86c1c27131a8$var$arrayTraps.deleteProperty = function(state, prop) {
    return $d08a86c1c27131a8$var$arrayTraps.set.call(this, state, prop, void 0);
};
$d08a86c1c27131a8$var$arrayTraps.set = function(state, prop, value) {
    return $d08a86c1c27131a8$var$objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function $d08a86c1c27131a8$var$peek(draft, prop) {
    const state = draft[$d08a86c1c27131a8$var$DRAFT_STATE];
    const source = state ? $d08a86c1c27131a8$var$latest(state) : draft;
    return source[prop];
}
function $d08a86c1c27131a8$var$readPropFromProto(state, source, prop) {
    var _a;
    const desc = $d08a86c1c27131a8$var$getDescriptorFromProto(source, prop);
    return desc ? `value` in desc ? desc.value : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (_a = desc.get) == null ? void 0 : _a.call(state.draft_) : void 0;
}
function $d08a86c1c27131a8$var$getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    let proto = $d08a86c1c27131a8$var$getPrototypeOf(source);
    while(proto){
        const desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = $d08a86c1c27131a8$var$getPrototypeOf(proto);
    }
    return void 0;
}
function $d08a86c1c27131a8$var$markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) $d08a86c1c27131a8$var$markChanged(state.parent_);
    }
}
function $d08a86c1c27131a8$var$prepareCopy(state) {
    if (!state.copy_) state.copy_ = $d08a86c1c27131a8$var$shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
}
// src/core/immerClass.ts
var $d08a86c1c27131a8$export$aaadc6ff0f822719 = class {
    constructor(config){
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = (base, recipe, patchListener)=>{
            if (typeof base === "function" && typeof recipe !== "function") {
                const defaultBase = recipe;
                recipe = base;
                const self = this;
                return function curriedProduce(base2 = defaultBase, ...args) {
                    return self.produce(base2, (draft)=>recipe.call(this, draft, ...args));
                };
            }
            if (typeof recipe !== "function") $d08a86c1c27131a8$var$die(6);
            if (patchListener !== void 0 && typeof patchListener !== "function") $d08a86c1c27131a8$var$die(7);
            let result;
            if ($d08a86c1c27131a8$export$16e3aed3edb85946(base)) {
                const scope = $d08a86c1c27131a8$var$enterScope(this);
                const proxy = $d08a86c1c27131a8$var$createProxy(base, void 0);
                let hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) $d08a86c1c27131a8$var$revokeScope(scope);
                    else $d08a86c1c27131a8$var$leaveScope(scope);
                }
                $d08a86c1c27131a8$var$usePatchesInScope(scope, patchListener);
                return $d08a86c1c27131a8$var$processResult(result, scope);
            } else if (!base || typeof base !== "object") {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === $d08a86c1c27131a8$export$45b790e32b2810ee) result = void 0;
                if (this.autoFreeze_) $d08a86c1c27131a8$export$792f3d81ea979f55(result, true);
                if (patchListener) {
                    const p = [];
                    const ip = [];
                    $d08a86c1c27131a8$var$getPlugin("Patches").generateReplacementPatches_(base, result, p, ip);
                    patchListener(p, ip);
                }
                return result;
            } else $d08a86c1c27131a8$var$die(1, base);
        };
        this.produceWithPatches = (base, recipe)=>{
            if (typeof base === "function") return (state, ...args)=>this.produceWithPatches(state, (draft)=>base(draft, ...args));
            let patches, inversePatches;
            const result = this.produce(base, recipe, (p, ip)=>{
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if (typeof (config == null ? void 0 : config.autoFreeze) === "boolean") this.setAutoFreeze(config.autoFreeze);
        if (typeof (config == null ? void 0 : config.useStrictShallowCopy) === "boolean") this.setUseStrictShallowCopy(config.useStrictShallowCopy);
    }
    createDraft(base) {
        if (!$d08a86c1c27131a8$export$16e3aed3edb85946(base)) $d08a86c1c27131a8$var$die(8);
        if ($d08a86c1c27131a8$export$541ac630993a4c84(base)) base = $d08a86c1c27131a8$export$97aac956da55dae9(base);
        const scope = $d08a86c1c27131a8$var$enterScope(this);
        const proxy = $d08a86c1c27131a8$var$createProxy(base, void 0);
        proxy[$d08a86c1c27131a8$var$DRAFT_STATE].isManual_ = true;
        $d08a86c1c27131a8$var$leaveScope(scope);
        return proxy;
    }
    finishDraft(draft, patchListener) {
        const state = draft && draft[$d08a86c1c27131a8$var$DRAFT_STATE];
        if (!state || !state.isManual_) $d08a86c1c27131a8$var$die(9);
        const { scope_: scope } = state;
        $d08a86c1c27131a8$var$usePatchesInScope(scope, patchListener);
        return $d08a86c1c27131a8$var$processResult(void 0, scope);
    }
    /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ setAutoFreeze(value) {
        this.autoFreeze_ = value;
    }
    /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ setUseStrictShallowCopy(value) {
        this.useStrictShallowCopy_ = value;
    }
    applyPatches(base, patches) {
        let i;
        for(i = patches.length - 1; i >= 0; i--){
            const patch = patches[i];
            if (patch.path.length === 0 && patch.op === "replace") {
                base = patch.value;
                break;
            }
        }
        if (i > -1) patches = patches.slice(i + 1);
        const applyPatchesImpl = $d08a86c1c27131a8$var$getPlugin("Patches").applyPatches_;
        if ($d08a86c1c27131a8$export$541ac630993a4c84(base)) return applyPatchesImpl(base, patches);
        return this.produce(base, (draft)=>applyPatchesImpl(draft, patches));
    }
};
function $d08a86c1c27131a8$var$createProxy(value, parent) {
    const draft = $d08a86c1c27131a8$var$isMap(value) ? $d08a86c1c27131a8$var$getPlugin("MapSet").proxyMap_(value, parent) : $d08a86c1c27131a8$var$isSet(value) ? $d08a86c1c27131a8$var$getPlugin("MapSet").proxySet_(value, parent) : $d08a86c1c27131a8$var$createProxyProxy(value, parent);
    const scope = parent ? parent.scope_ : $d08a86c1c27131a8$var$getCurrentScope();
    scope.drafts_.push(draft);
    return draft;
}
// src/core/current.ts
function $d08a86c1c27131a8$export$97aac956da55dae9(value) {
    if (!$d08a86c1c27131a8$export$541ac630993a4c84(value)) $d08a86c1c27131a8$var$die(10, value);
    return $d08a86c1c27131a8$var$currentImpl(value);
}
function $d08a86c1c27131a8$var$currentImpl(value) {
    if (!$d08a86c1c27131a8$export$16e3aed3edb85946(value) || $d08a86c1c27131a8$var$isFrozen(value)) return value;
    const state = value[$d08a86c1c27131a8$var$DRAFT_STATE];
    let copy;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = $d08a86c1c27131a8$var$shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
    } else copy = $d08a86c1c27131a8$var$shallowCopy(value, true);
    $d08a86c1c27131a8$var$each(copy, (key, childValue)=>{
        $d08a86c1c27131a8$var$set(copy, key, $d08a86c1c27131a8$var$currentImpl(childValue));
    });
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function $d08a86c1c27131a8$export$d3a6659991a0696c() {
    const errorOffset = 16;
    const REPLACE = "replace";
    const ADD = "add";
    const REMOVE = "remove";
    function generatePatches_(state, basePath, patches, inversePatches) {
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches, inversePatches);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches, inversePatches);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches, inversePatches);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, assigned_: assigned_ } = state;
        let copy_ = state.copy_;
        if (copy_.length < base_.length) {
            [base_, copy_] = [
                copy_,
                base_
            ];
            [patches, inversePatches] = [
                inversePatches,
                patches
            ];
        }
        for(let i = 0; i < base_.length; i++)if (assigned_[i] && copy_[i] !== base_[i]) {
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: REPLACE,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
            inversePatches.push({
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(base_[i])
            });
        }
        for(let i = base_.length; i < copy_.length; i++){
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: ADD,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
        }
        for(let i = copy_.length - 1; base_.length <= i; --i){
            const path = basePath.concat([
                i
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        const { base_: base_, copy_: copy_ } = state;
        $d08a86c1c27131a8$var$each(state.assigned_, (key, assignedValue)=>{
            const origValue = $d08a86c1c27131a8$var$get(base_, key);
            const value = $d08a86c1c27131a8$var$get(copy_, key);
            const op = !assignedValue ? REMOVE : $d08a86c1c27131a8$var$has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            const path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: value
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, copy_: copy_ } = state;
        let i = 0;
        base_.forEach((value)=>{
            if (!copy_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach((value)=>{
            if (!base_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, patches, inversePatches) {
        patches.push({
            op: REPLACE,
            path: [],
            value: replacement === $d08a86c1c27131a8$export$45b790e32b2810ee ? void 0 : replacement
        });
        inversePatches.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach((patch)=>{
            const { path: path, op: op } = patch;
            let base = draft;
            for(let i = 0; i < path.length - 1; i++){
                const parentType = $d08a86c1c27131a8$var$getArchtype(base);
                let p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === "constructor")) $d08a86c1c27131a8$var$die(errorOffset + 3);
                if (typeof base === "function" && p === "prototype") $d08a86c1c27131a8$var$die(errorOffset + 3);
                base = $d08a86c1c27131a8$var$get(base, p);
                if (typeof base !== "object") $d08a86c1c27131a8$var$die(errorOffset + 2, path.join("/"));
            }
            const type = $d08a86c1c27131a8$var$getArchtype(base);
            const value = deepClonePatchValue(patch.value);
            const key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            $d08a86c1c27131a8$var$die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    $d08a86c1c27131a8$var$die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!$d08a86c1c27131a8$export$16e3aed3edb85946(obj)) return obj;
        if (Array.isArray(obj)) return obj.map(deepClonePatchValue);
        if ($d08a86c1c27131a8$var$isMap(obj)) return new Map(Array.from(obj.entries()).map(([k, v])=>[
                k,
                deepClonePatchValue(v)
            ]));
        if ($d08a86c1c27131a8$var$isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        const cloned = Object.create($d08a86c1c27131a8$var$getPrototypeOf(obj));
        for(const key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if ($d08a86c1c27131a8$var$has(obj, $d08a86c1c27131a8$export$6ee2082928bcb0ee)) cloned[$d08a86c1c27131a8$export$6ee2082928bcb0ee] = obj[$d08a86c1c27131a8$export$6ee2082928bcb0ee];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if ($d08a86c1c27131a8$export$541ac630993a4c84(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    $d08a86c1c27131a8$var$loadPlugin("Patches", {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_
    });
}
// src/plugins/mapset.ts
function $d08a86c1c27131a8$export$7d9f65390203b435() {
    class DraftMap extends Map {
        constructor(target, parent){
            super();
            this[$d08a86c1c27131a8$var$DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $d08a86c1c27131a8$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: this,
                isManual_: false,
                revoked_: false
            };
        }
        get size() {
            return $d08a86c1c27131a8$var$latest(this[$d08a86c1c27131a8$var$DRAFT_STATE]).size;
        }
        has(key) {
            return $d08a86c1c27131a8$var$latest(this[$d08a86c1c27131a8$var$DRAFT_STATE]).has(key);
        }
        set(key, value) {
            const state = this[$d08a86c1c27131a8$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!$d08a86c1c27131a8$var$latest(state).has(key) || $d08a86c1c27131a8$var$latest(state).get(key) !== value) {
                prepareMapCopy(state);
                $d08a86c1c27131a8$var$markChanged(state);
                state.assigned_.set(key, true);
                state.copy_.set(key, value);
                state.assigned_.set(key, true);
            }
            return this;
        }
        delete(key) {
            if (!this.has(key)) return false;
            const state = this[$d08a86c1c27131a8$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            $d08a86c1c27131a8$var$markChanged(state);
            if (state.base_.has(key)) state.assigned_.set(key, false);
            else state.assigned_.delete(key);
            state.copy_.delete(key);
            return true;
        }
        clear() {
            const state = this[$d08a86c1c27131a8$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($d08a86c1c27131a8$var$latest(state).size) {
                prepareMapCopy(state);
                $d08a86c1c27131a8$var$markChanged(state);
                state.assigned_ = /* @__PURE__ */ new Map();
                $d08a86c1c27131a8$var$each(state.base_, (key)=>{
                    state.assigned_.set(key, false);
                });
                state.copy_.clear();
            }
        }
        forEach(cb, thisArg) {
            const state = this[$d08a86c1c27131a8$var$DRAFT_STATE];
            $d08a86c1c27131a8$var$latest(state).forEach((_value, key, _map)=>{
                cb.call(thisArg, this.get(key), key, this);
            });
        }
        get(key) {
            const state = this[$d08a86c1c27131a8$var$DRAFT_STATE];
            assertUnrevoked(state);
            const value = $d08a86c1c27131a8$var$latest(state).get(key);
            if (state.finalized_ || !$d08a86c1c27131a8$export$16e3aed3edb85946(value)) return value;
            if (value !== state.base_.get(key)) return value;
            const draft = $d08a86c1c27131a8$var$createProxy(value, state);
            prepareMapCopy(state);
            state.copy_.set(key, draft);
            return draft;
        }
        keys() {
            return $d08a86c1c27131a8$var$latest(this[$d08a86c1c27131a8$var$DRAFT_STATE]).keys();
        }
        values() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.values(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: value
                    };
                }
            };
        }
        entries() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.entries(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: [
                            r.value,
                            value
                        ]
                    };
                }
            };
        }
        [($d08a86c1c27131a8$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.entries();
        }
    }
    function proxyMap_(target, parent) {
        return new DraftMap(target, parent);
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    class DraftSet extends Set {
        constructor(target, parent){
            super();
            this[$d08a86c1c27131a8$var$DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $d08a86c1c27131a8$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false
            };
        }
        get size() {
            return $d08a86c1c27131a8$var$latest(this[$d08a86c1c27131a8$var$DRAFT_STATE]).size;
        }
        has(value) {
            const state = this[$d08a86c1c27131a8$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!state.copy_) return state.base_.has(value);
            if (state.copy_.has(value)) return true;
            if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
            return false;
        }
        add(value) {
            const state = this[$d08a86c1c27131a8$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!this.has(value)) {
                prepareSetCopy(state);
                $d08a86c1c27131a8$var$markChanged(state);
                state.copy_.add(value);
            }
            return this;
        }
        delete(value) {
            if (!this.has(value)) return false;
            const state = this[$d08a86c1c27131a8$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            $d08a86c1c27131a8$var$markChanged(state);
            return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
        }
        clear() {
            const state = this[$d08a86c1c27131a8$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($d08a86c1c27131a8$var$latest(state).size) {
                prepareSetCopy(state);
                $d08a86c1c27131a8$var$markChanged(state);
                state.copy_.clear();
            }
        }
        values() {
            const state = this[$d08a86c1c27131a8$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.values();
        }
        entries() {
            const state = this[$d08a86c1c27131a8$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.entries();
        }
        keys() {
            return this.values();
        }
        [($d08a86c1c27131a8$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.values();
        }
        forEach(cb, thisArg) {
            const iterator = this.values();
            let result = iterator.next();
            while(!result.done){
                cb.call(thisArg, result.value, result.value, this);
                result = iterator.next();
            }
        }
    }
    function proxySet_(target, parent) {
        return new DraftSet(target, parent);
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach((value)=>{
                if ($d08a86c1c27131a8$export$16e3aed3edb85946(value)) {
                    const draft = $d08a86c1c27131a8$var$createProxy(value, state);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) $d08a86c1c27131a8$var$die(3, JSON.stringify($d08a86c1c27131a8$var$latest(state)));
    }
    $d08a86c1c27131a8$var$loadPlugin("MapSet", {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_
    });
}
// src/immer.ts
var $d08a86c1c27131a8$var$immer = new $d08a86c1c27131a8$export$aaadc6ff0f822719();
var $d08a86c1c27131a8$export$b46cabe22e78bc00 = $d08a86c1c27131a8$var$immer.produce;
var $d08a86c1c27131a8$export$4da66d41c9492c78 = $d08a86c1c27131a8$var$immer.produceWithPatches.bind($d08a86c1c27131a8$var$immer);
var $d08a86c1c27131a8$export$573f26f60825c493 = $d08a86c1c27131a8$var$immer.setAutoFreeze.bind($d08a86c1c27131a8$var$immer);
var $d08a86c1c27131a8$export$333ce65961cbe047 = $d08a86c1c27131a8$var$immer.setUseStrictShallowCopy.bind($d08a86c1c27131a8$var$immer);
var $d08a86c1c27131a8$export$a8b8e03e6bbe5473 = $d08a86c1c27131a8$var$immer.applyPatches.bind($d08a86c1c27131a8$var$immer);
var $d08a86c1c27131a8$export$3c3214997190395f = $d08a86c1c27131a8$var$immer.createDraft.bind($d08a86c1c27131a8$var$immer);
var $d08a86c1c27131a8$export$c60f5e69c521b528 = $d08a86c1c27131a8$var$immer.finishDraft.bind($d08a86c1c27131a8$var$immer);
function $d08a86c1c27131a8$export$c05b21e3257751e5(value) {
    return value;
}
function $d08a86c1c27131a8$export$20f911b3f8cf0b74(value) {
    return value;
}



// src/index.ts
function $52fd07dd3983ec8b$var$createThunkMiddleware(extraArgument) {
    const middleware = ({ dispatch: dispatch, getState: getState })=>(next)=>(action)=>{
                if (typeof action === "function") return action(dispatch, getState, extraArgument);
                return next(action);
            };
    return middleware;
}
var $52fd07dd3983ec8b$export$dd164f5517779f15 = $52fd07dd3983ec8b$var$createThunkMiddleware();
var $52fd07dd3983ec8b$export$16d06542a1949d9e = $52fd07dd3983ec8b$var$createThunkMiddleware;



var $iF4fv = parcelRequire("iF4fv");
var $50aea76f54d86b4e$var$__defProp = Object.defineProperty;
var $50aea76f54d86b4e$var$__defProps = Object.defineProperties;
var $50aea76f54d86b4e$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $50aea76f54d86b4e$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $50aea76f54d86b4e$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $50aea76f54d86b4e$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $50aea76f54d86b4e$var$__defNormalProp = (obj, key, value)=>key in obj ? $50aea76f54d86b4e$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $50aea76f54d86b4e$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($50aea76f54d86b4e$var$__hasOwnProp.call(b, prop)) $50aea76f54d86b4e$var$__defNormalProp(a, prop, b[prop]);
    if ($50aea76f54d86b4e$var$__getOwnPropSymbols) {
        for (var prop of $50aea76f54d86b4e$var$__getOwnPropSymbols(b))if ($50aea76f54d86b4e$var$__propIsEnum.call(b, prop)) $50aea76f54d86b4e$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $50aea76f54d86b4e$var$__spreadProps = (a, b)=>$50aea76f54d86b4e$var$__defProps(a, $50aea76f54d86b4e$var$__getOwnPropDescs(b));
var $50aea76f54d86b4e$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($50aea76f54d86b4e$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $50aea76f54d86b4e$var$__getOwnPropSymbols) {
        for (var prop of $50aea76f54d86b4e$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $50aea76f54d86b4e$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var $50aea76f54d86b4e$var$__publicField = (obj, key, value)=>{
    $50aea76f54d86b4e$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
var $50aea76f54d86b4e$export$aab6de9e3dbb1473 = (...args)=>{
    const createSelector2 = (0, $b8b130b8bbf51c97$export$5943f4447f6ef248)(...args);
    const createDraftSafeSelector2 = Object.assign((...args2)=>{
        const selector = createSelector2(...args2);
        const wrappedSelector = (value, ...rest)=>selector((0, $d08a86c1c27131a8$export$541ac630993a4c84)(value) ? (0, $d08a86c1c27131a8$export$97aac956da55dae9)(value) : value, ...rest);
        Object.assign(wrappedSelector, selector);
        return wrappedSelector;
    }, {
        withTypes: ()=>createDraftSafeSelector2
    });
    return createDraftSafeSelector2;
};
var $50aea76f54d86b4e$export$a5d3c27355e35910 = $50aea76f54d86b4e$export$aab6de9e3dbb1473((0, $b8b130b8bbf51c97$export$8402dc26d96f6902));
var $50aea76f54d86b4e$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $d98493d2be9cbe4c$export$f672e0b6f7222cd7;
    return (0, $d98493d2be9cbe4c$export$f672e0b6f7222cd7).apply(null, arguments);
};
var $50aea76f54d86b4e$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop3) {
        return noop3;
    };
};
// src/tsHelpers.ts
var $50aea76f54d86b4e$var$hasMatchFunction = (v)=>{
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $50aea76f54d86b4e$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator(...args) {
        if (prepareAction) {
            let prepared = prepareAction(...args);
            if (!prepared) throw new Error($50aea76f54d86b4e$export$378fa86b259c0280(0));
            return $50aea76f54d86b4e$var$__spreadValues($50aea76f54d86b4e$var$__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = ()=>`${type}`;
    actionCreator.type = type;
    actionCreator.match = (action)=>(0, $d98493d2be9cbe4c$export$b956e38827fca970)(action) && action.type === type;
    return actionCreator;
}
function $50aea76f54d86b4e$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && // hasMatchFunction only wants Matchers but I don't see the point in rewriting it
    $50aea76f54d86b4e$var$hasMatchFunction(action);
}
function $50aea76f54d86b4e$export$ebd532f9034651f3(action) {
    return (0, $d98493d2be9cbe4c$export$b956e38827fca970)(action) && Object.keys(action).every($50aea76f54d86b4e$var$isValidKey);
}
function $50aea76f54d86b4e$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
// src/actionCreatorInvariantMiddleware.ts
function $50aea76f54d86b4e$var$getMessage(type) {
    const splitType = type ? `${type}`.split("/") : [];
    const actionName = splitType[splitType.length - 1] || "actionCreator";
    return `Detected an action creator with type "${type || "unknown"}" being dispatched. 
Make sure you're calling the action creator before dispatching, i.e. \`dispatch(${actionName}())\` instead of \`dispatch(${actionName})\`. This is necessary even if the action has no payload.`;
}
function $50aea76f54d86b4e$export$6a1fcb4ceef578f(options = {}) {
    var next, action;
    return ()=>(next)=>(action)=>next(action);
}
function $50aea76f54d86b4e$var$getTimeMeasureUtils(maxDelay, fnName) {
    let elapsed = 0;
    return {
        measureTime (fn) {
            const started = Date.now();
            try {
                return fn();
            } finally{
                const finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded () {
            if (elapsed > maxDelay) console.warn(`${fnName} took ${elapsed}ms, which is more than the warning threshold of ${maxDelay}ms. 
If your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.
It is disabled in production builds, so you don't need to worry about that.`);
        }
    };
}
function $50aea76f54d86b4e$var$find(iterable, comparator) {
    for (const entry of iterable){
        if (comparator(entry)) return entry;
    }
    return void 0;
}
var $50aea76f54d86b4e$export$1908877435b1d5e9 = class _Tuple extends Array {
    constructor(...items){
        super(...items);
        Object.setPrototypeOf(this, _Tuple.prototype);
    }
    static get [Symbol.species]() {
        return _Tuple;
    }
    concat(...arr) {
        return super.concat.apply(this, arr);
    }
    prepend(...arr) {
        if (arr.length === 1 && Array.isArray(arr[0])) return new _Tuple(...arr[0].concat(this));
        return new _Tuple(...arr.concat(this));
    }
};
function $50aea76f54d86b4e$var$freezeDraftable(val) {
    return (0, $d08a86c1c27131a8$export$16e3aed3edb85946)(val) ? (0, $d08a86c1c27131a8$export$b46cabe22e78bc00)(val, ()=>{}) : val;
}
function $50aea76f54d86b4e$var$emplace(map, key, handler) {
    if (map.has(key)) {
        let value = map.get(key);
        if (handler.update) {
            value = handler.update(value, key, map);
            map.set(key, value);
        }
        return value;
    }
    if (!handler.insert) throw new Error($50aea76f54d86b4e$export$378fa86b259c0280(10));
    const inserted = handler.insert(key, map);
    map.set(key, inserted);
    return inserted;
}
// src/immutableStateInvariantMiddleware.ts
function $50aea76f54d86b4e$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $50aea76f54d86b4e$var$trackForMutations(isImmutable, ignorePaths, obj) {
    const trackedProperties = $50aea76f54d86b4e$var$trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations () {
            return $50aea76f54d86b4e$var$detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function $50aea76f54d86b4e$var$trackProperties(isImmutable, ignorePaths = [], obj, path = "", checkedObjects = /* @__PURE__ */ new Set()) {
    const tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        for(const key in obj){
            const childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = $50aea76f54d86b4e$var$trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function $50aea76f54d86b4e$var$detectMutations(isImmutable, ignoredPaths = [], trackedProperty, obj, sameParentRef = false, path = "") {
    const prevObj = trackedProperty ? trackedProperty.value : void 0;
    const sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    const keysToDetect = {};
    for(let key in trackedProperty.children)keysToDetect[key] = true;
    for(let key in obj)keysToDetect[key] = true;
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for(let key in keysToDetect){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        const result = $50aea76f54d86b4e$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return result;
    }
    return {
        wasMutated: false
    };
}
function $50aea76f54d86b4e$export$9181bb1a5474289(options = {}) {
    var stringify, getSerialize, getState, next, action;
    return ()=>(next)=>(action)=>next(action);
}
function $50aea76f54d86b4e$export$77670485918dab4e(val) {
    const type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || (0, $d98493d2be9cbe4c$export$53b83ca8eaab0383)(val);
}
function $50aea76f54d86b4e$export$ada5dca0b571bc7(value, path = "", isSerializable = $50aea76f54d86b4e$export$77670485918dab4e, getEntries, ignoredPaths = [], cache) {
    let foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    const entries = getEntries != null ? getEntries(value) : Object.entries(value);
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for (const [key, nestedValue] of entries){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        if (!isSerializable(nestedValue)) return {
            keyPath: nestedPath,
            value: nestedValue
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $50aea76f54d86b4e$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return foundNestedSerializable;
        }
    }
    if (cache && $50aea76f54d86b4e$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $50aea76f54d86b4e$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for (const nestedValue of Object.values(value)){
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$50aea76f54d86b4e$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $50aea76f54d86b4e$export$6dea1aad6dac5ac2(options = {}) {
    var storeAPI, next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/getDefaultMiddleware.ts
function $50aea76f54d86b4e$var$isBoolean(x) {
    return typeof x === "boolean";
}
var $50aea76f54d86b4e$var$buildGetDefaultMiddleware = ()=>function getDefaultMiddleware(options) {
        const { thunk: thunk = true, immutableCheck: immutableCheck = true, serializableCheck: serializableCheck = true, actionCreatorCheck: actionCreatorCheck = true } = options != null ? options : {};
        let middlewareArray = new $50aea76f54d86b4e$export$1908877435b1d5e9();
        if (thunk) {
            if ($50aea76f54d86b4e$var$isBoolean(thunk)) middlewareArray.push((0, $52fd07dd3983ec8b$export$dd164f5517779f15));
            else middlewareArray.push((0, $52fd07dd3983ec8b$export$16d06542a1949d9e)(thunk.extraArgument));
        }
        return middlewareArray;
    };
// src/autoBatchEnhancer.ts
var $50aea76f54d86b4e$export$8fb31c0f05df007b = "RTK_autoBatch";
var $50aea76f54d86b4e$export$39fcd5145ec5e4e2 = ()=>(payload)=>({
            payload: payload,
            meta: {
                [$50aea76f54d86b4e$export$8fb31c0f05df007b]: true
            }
        });
var $50aea76f54d86b4e$var$createQueueWithTimer = (timeout)=>{
    return (notify)=>{
        setTimeout(notify, timeout);
    };
};
var $50aea76f54d86b4e$var$rAF = typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $50aea76f54d86b4e$var$createQueueWithTimer(10);
var $50aea76f54d86b4e$export$676277d7dca0f396 = (options = {
    type: "raf"
})=>(next)=>(...args)=>{
            const store = next(...args);
            let notifying = true;
            let shouldNotifyAtEndOfTick = false;
            let notificationQueued = false;
            const listeners = /* @__PURE__ */ new Set();
            const queueCallback = options.type === "tick" ? queueMicrotask : options.type === "raf" ? $50aea76f54d86b4e$var$rAF : options.type === "callback" ? options.queueNotification : $50aea76f54d86b4e$var$createQueueWithTimer(options.timeout);
            const notifyListeners = ()=>{
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach((l)=>l());
                }
            };
            return Object.assign({}, store, {
                // Override the base `store.subscribe` method to keep original listeners
                // from running if we're delaying notifications
                subscribe (listener2) {
                    const wrappedListener = ()=>notifying && listener2();
                    const unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return ()=>{
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                // Override the base `store.dispatch` method so that we can check actions
                // for the `shouldAutoBatch` flag and determine if batching is active
                dispatch (action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[$50aea76f54d86b4e$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
// src/getDefaultEnhancers.ts
var $50aea76f54d86b4e$var$buildGetDefaultEnhancers = (middlewareEnhancer)=>function getDefaultEnhancers(options) {
        const { autoBatch: autoBatch = true } = options != null ? options : {};
        let enhancerArray = new $50aea76f54d86b4e$export$1908877435b1d5e9(middlewareEnhancer);
        if (autoBatch) enhancerArray.push($50aea76f54d86b4e$export$676277d7dca0f396(typeof autoBatch === "object" ? autoBatch : void 0));
        return enhancerArray;
    };
// src/configureStore.ts
var $50aea76f54d86b4e$var$IS_PRODUCTION = true;
function $50aea76f54d86b4e$export$7d8a5b498da695ac(options) {
    const getDefaultMiddleware = $50aea76f54d86b4e$var$buildGetDefaultMiddleware();
    const { reducer: reducer, middleware: middleware, devTools: devTools = true, preloadedState: preloadedState, enhancers: enhancers } = options || {};
    let rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ((0, $d98493d2be9cbe4c$export$53b83ca8eaab0383)(reducer)) rootReducer = (0, $d98493d2be9cbe4c$export$66e4520cdb265d18)(reducer);
    else throw new Error($50aea76f54d86b4e$export$378fa86b259c0280(1));
    if (!$50aea76f54d86b4e$var$IS_PRODUCTION && middleware && typeof middleware !== "function") throw new Error($50aea76f54d86b4e$export$378fa86b259c0280(2));
    let finalMiddleware;
    if (typeof middleware === "function") {
        finalMiddleware = middleware(getDefaultMiddleware);
        if (!$50aea76f54d86b4e$var$IS_PRODUCTION && !Array.isArray(finalMiddleware)) throw new Error($50aea76f54d86b4e$export$378fa86b259c0280(3));
    } else finalMiddleware = getDefaultMiddleware();
    if (!$50aea76f54d86b4e$var$IS_PRODUCTION && finalMiddleware.some((item)=>typeof item !== "function")) throw new Error($50aea76f54d86b4e$export$378fa86b259c0280(4));
    let finalCompose = (0, $d98493d2be9cbe4c$export$f672e0b6f7222cd7);
    if (devTools) finalCompose = $50aea76f54d86b4e$var$composeWithDevTools($50aea76f54d86b4e$var$__spreadValues({
        // Enable capture of stack traces for dispatched Redux actions
        trace: !$50aea76f54d86b4e$var$IS_PRODUCTION
    }, typeof devTools === "object" && devTools));
    const middlewareEnhancer = (0, $d98493d2be9cbe4c$export$9ff26e0402cc7b7)(...finalMiddleware);
    const getDefaultEnhancers = $50aea76f54d86b4e$var$buildGetDefaultEnhancers(middlewareEnhancer);
    if (!$50aea76f54d86b4e$var$IS_PRODUCTION && enhancers && typeof enhancers !== "function") throw new Error($50aea76f54d86b4e$export$378fa86b259c0280(5));
    let storeEnhancers = typeof enhancers === "function" ? enhancers(getDefaultEnhancers) : getDefaultEnhancers();
    if (!$50aea76f54d86b4e$var$IS_PRODUCTION && !Array.isArray(storeEnhancers)) throw new Error($50aea76f54d86b4e$export$378fa86b259c0280(6));
    if (!$50aea76f54d86b4e$var$IS_PRODUCTION && storeEnhancers.some((item)=>typeof item !== "function")) throw new Error($50aea76f54d86b4e$export$378fa86b259c0280(7));
    if (!$50aea76f54d86b4e$var$IS_PRODUCTION && finalMiddleware.length && !storeEnhancers.includes(middlewareEnhancer)) console.error("middlewares were provided, but middleware enhancer was not included in final enhancers - make sure to call `getDefaultEnhancers`");
    const composedEnhancer = finalCompose(...storeEnhancers);
    return (0, $d98493d2be9cbe4c$export$f51a9068ac82ea43)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $50aea76f54d86b4e$var$executeReducerBuilderCallback(builderCallback) {
    const actionsMap = {};
    const actionMatchers = [];
    let defaultCaseReducer;
    const builder = {
        addCase (typeOrActionCreator, reducer) {
            const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error($50aea76f54d86b4e$export$378fa86b259c0280(28));
            if (type in actionsMap) throw new Error($50aea76f54d86b4e$export$378fa86b259c0280(29));
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher (matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase (reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $50aea76f54d86b4e$var$isStateFunction(x) {
    return typeof x === "function";
}
function $50aea76f54d86b4e$export$473eb76d322d0290(initialState, mapOrBuilderCallback) {
    let [actionsMap, finalActionMatchers, finalDefaultCaseReducer] = $50aea76f54d86b4e$var$executeReducerBuilderCallback(mapOrBuilderCallback);
    let getInitialState;
    if ($50aea76f54d86b4e$var$isStateFunction(initialState)) getInitialState = ()=>$50aea76f54d86b4e$var$freezeDraftable(initialState());
    else {
        const frozenInitialState = $50aea76f54d86b4e$var$freezeDraftable(initialState);
        getInitialState = ()=>frozenInitialState;
    }
    function reducer(state = getInitialState(), action) {
        let caseReducers = [
            actionsMap[action.type],
            ...finalActionMatchers.filter(({ matcher: matcher })=>matcher(action)).map(({ reducer: reducer2 })=>reducer2)
        ];
        if (caseReducers.filter((cr)=>!!cr).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce((previousState, caseReducer)=>{
            if (caseReducer) {
                if ((0, $d08a86c1c27131a8$export$541ac630993a4c84)(previousState)) {
                    const draft = previousState;
                    const result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $d08a86c1c27131a8$export$16e3aed3edb85946)(previousState)) {
                    const result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw new Error($50aea76f54d86b4e$export$378fa86b259c0280(9));
                    }
                    return result;
                } else return (0, $d08a86c1c27131a8$export$b46cabe22e78bc00)(previousState, (draft)=>{
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/nanoid.ts
var $50aea76f54d86b4e$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $50aea76f54d86b4e$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = "";
    let i = size;
    while(i--)id += $50aea76f54d86b4e$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/matchers.ts
var $50aea76f54d86b4e$var$matches = (matcher, action)=>{
    if ($50aea76f54d86b4e$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $50aea76f54d86b4e$export$2c3435c7647f7b0d(...matchers) {
    return (action)=>{
        return matchers.some((matcher)=>$50aea76f54d86b4e$var$matches(matcher, action));
    };
}
function $50aea76f54d86b4e$export$9dd1fb32974da385(...matchers) {
    return (action)=>{
        return matchers.every((matcher)=>$50aea76f54d86b4e$var$matches(matcher, action));
    };
}
function $50aea76f54d86b4e$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    const hasValidRequestId = typeof action.meta.requestId === "string";
    const hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $50aea76f54d86b4e$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $50aea76f54d86b4e$export$872dec21e9a69476(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$50aea76f54d86b4e$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    if (!$50aea76f54d86b4e$var$isAsyncThunkArray(asyncThunks)) return $50aea76f54d86b4e$export$872dec21e9a69476()(asyncThunks[0]);
    return (action)=>{
        const matchers = asyncThunks.map((asyncThunk)=>asyncThunk.pending);
        const combinedMatcher = $50aea76f54d86b4e$export$2c3435c7647f7b0d(...matchers);
        return combinedMatcher(action);
    };
}
function $50aea76f54d86b4e$export$a5c5d27e3994c5be(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$50aea76f54d86b4e$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    if (!$50aea76f54d86b4e$var$isAsyncThunkArray(asyncThunks)) return $50aea76f54d86b4e$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return (action)=>{
        const matchers = asyncThunks.map((asyncThunk)=>asyncThunk.rejected);
        const combinedMatcher = $50aea76f54d86b4e$export$2c3435c7647f7b0d(...matchers);
        return combinedMatcher(action);
    };
}
function $50aea76f54d86b4e$export$fcc3388fb56de601(...asyncThunks) {
    const hasFlag = (action)=>{
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return (action)=>{
        const combinedMatcher = $50aea76f54d86b4e$export$9dd1fb32974da385($50aea76f54d86b4e$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
    if (!$50aea76f54d86b4e$var$isAsyncThunkArray(asyncThunks)) return $50aea76f54d86b4e$export$fcc3388fb56de601()(asyncThunks[0]);
    return (action)=>{
        const combinedMatcher = $50aea76f54d86b4e$export$9dd1fb32974da385($50aea76f54d86b4e$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
}
function $50aea76f54d86b4e$export$1da80a6ef1307441(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$50aea76f54d86b4e$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    if (!$50aea76f54d86b4e$var$isAsyncThunkArray(asyncThunks)) return $50aea76f54d86b4e$export$1da80a6ef1307441()(asyncThunks[0]);
    return (action)=>{
        const matchers = asyncThunks.map((asyncThunk)=>asyncThunk.fulfilled);
        const combinedMatcher = $50aea76f54d86b4e$export$2c3435c7647f7b0d(...matchers);
        return combinedMatcher(action);
    };
}
function $50aea76f54d86b4e$export$6aa4142d99c1abce(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$50aea76f54d86b4e$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    if (!$50aea76f54d86b4e$var$isAsyncThunkArray(asyncThunks)) return $50aea76f54d86b4e$export$6aa4142d99c1abce()(asyncThunks[0]);
    return (action)=>{
        const matchers = [];
        for (const asyncThunk of asyncThunks)matchers.push(asyncThunk.pending, asyncThunk.rejected, asyncThunk.fulfilled);
        const combinedMatcher = $50aea76f54d86b4e$export$2c3435c7647f7b0d(...matchers);
        return combinedMatcher(action);
    };
}
// src/createAsyncThunk.ts
var $50aea76f54d86b4e$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $50aea76f54d86b4e$var$RejectWithValue = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
        /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $50aea76f54d86b4e$var$__publicField(this, "_type");
    }
};
var $50aea76f54d86b4e$var$FulfillWithMeta = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
        /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $50aea76f54d86b4e$var$__publicField(this, "_type");
    }
};
var $50aea76f54d86b4e$export$c97c53d0b2d5d81e = (value)=>{
    if (typeof value === "object" && value !== null) {
        const simpleError = {};
        for (const property of $50aea76f54d86b4e$var$commonProperties)if (typeof value[property] === "string") simpleError[property] = value[property];
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $50aea76f54d86b4e$export$6abd22dc03e5063f = /* @__PURE__ */ (()=>{
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        const fulfilled = $50aea76f54d86b4e$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", (payload, requestId, arg, meta)=>({
                payload: payload,
                meta: $50aea76f54d86b4e$var$__spreadProps($50aea76f54d86b4e$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            }));
        const pending = $50aea76f54d86b4e$export$309c7a02b0b0bc62(typePrefix + "/pending", (requestId, arg, meta)=>({
                payload: void 0,
                meta: $50aea76f54d86b4e$var$__spreadProps($50aea76f54d86b4e$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            }));
        const rejected = $50aea76f54d86b4e$export$309c7a02b0b0bc62(typePrefix + "/rejected", (error, requestId, arg, payload, meta)=>({
                payload: payload,
                error: (options && options.serializeError || $50aea76f54d86b4e$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $50aea76f54d86b4e$var$__spreadProps($50aea76f54d86b4e$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            }));
        function actionCreator(arg) {
            return (dispatch, getState, extra)=>{
                const requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $50aea76f54d86b4e$export$ac4959f4f1338dfc();
                const abortController = new AbortController();
                let abortHandler;
                let abortReason;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                const promise = async function() {
                    var _a, _b;
                    let finalAction;
                    try {
                        let conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                            getState: getState,
                            extra: extra
                        });
                        if ($50aea76f54d86b4e$var$isThenable(conditionResult)) conditionResult = await conditionResult;
                        if (conditionResult === false || abortController.signal.aborted) throw {
                            name: "ConditionError",
                            message: "Aborted due to condition callback returning false."
                        };
                        const abortedPromise = new Promise((_, reject)=>{
                            abortHandler = ()=>{
                                reject({
                                    name: "AbortError",
                                    message: abortReason || "Aborted"
                                });
                            };
                            abortController.signal.addEventListener("abort", abortHandler);
                        });
                        dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                            requestId: requestId,
                            arg: arg
                        }, {
                            getState: getState,
                            extra: extra
                        })));
                        finalAction = await Promise.race([
                            abortedPromise,
                            Promise.resolve(payloadCreator(arg, {
                                dispatch: dispatch,
                                getState: getState,
                                extra: extra,
                                requestId: requestId,
                                signal: abortController.signal,
                                abort: abort,
                                rejectWithValue: (value, meta)=>{
                                    return new $50aea76f54d86b4e$var$RejectWithValue(value, meta);
                                },
                                fulfillWithValue: (value, meta)=>{
                                    return new $50aea76f54d86b4e$var$FulfillWithMeta(value, meta);
                                }
                            })).then((result)=>{
                                if (result instanceof $50aea76f54d86b4e$var$RejectWithValue) throw result;
                                if (result instanceof $50aea76f54d86b4e$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                return fulfilled(result, requestId, arg);
                            })
                        ]);
                    } catch (err) {
                        finalAction = err instanceof $50aea76f54d86b4e$var$RejectWithValue ? rejected(null, requestId, arg, err.payload, err.meta) : rejected(err, requestId, arg);
                    } finally{
                        if (abortHandler) abortController.signal.removeEventListener("abort", abortHandler);
                    }
                    const skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                    if (!skipDispatch) dispatch(finalAction);
                    return finalAction;
                }();
                return Object.assign(promise, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap () {
                        return promise.then($50aea76f54d86b4e$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            settled: $50aea76f54d86b4e$export$2c3435c7647f7b0d(rejected, fulfilled),
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = ()=>createAsyncThunk2;
    return createAsyncThunk2;
})();
function $50aea76f54d86b4e$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $50aea76f54d86b4e$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/createSlice.ts
var $50aea76f54d86b4e$var$asyncThunkSymbol = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
var $50aea76f54d86b4e$export$343355ed40c51c46 = {
    [$50aea76f54d86b4e$var$asyncThunkSymbol]: $50aea76f54d86b4e$export$6abd22dc03e5063f
};
var $50aea76f54d86b4e$export$23a094319a4b586 = /* @__PURE__ */ ((ReducerType2)=>{
    ReducerType2["reducer"] = "reducer";
    ReducerType2["reducerWithPrepare"] = "reducerWithPrepare";
    ReducerType2["asyncThunk"] = "asyncThunk";
    return ReducerType2;
})($50aea76f54d86b4e$export$23a094319a4b586 || {});
function $50aea76f54d86b4e$var$getType(slice, actionKey) {
    return `${slice}/${actionKey}`;
}
function $50aea76f54d86b4e$export$affdea4146de9cf5({ creators: creators } = {}) {
    var _a;
    const cAT = (_a = creators == null ? void 0 : creators.asyncThunk) == null ? void 0 : _a[$50aea76f54d86b4e$var$asyncThunkSymbol];
    return function createSlice2(options) {
        const { name: name, reducerPath: reducerPath = name } = options;
        if (!name) throw new Error($50aea76f54d86b4e$export$378fa86b259c0280(11));
        typeof $iF4fv;
        const reducers = (typeof options.reducers === "function" ? options.reducers($50aea76f54d86b4e$var$buildReducerCreators()) : options.reducers) || {};
        const reducerNames = Object.keys(reducers);
        const context = {
            sliceCaseReducersByName: {},
            sliceCaseReducersByType: {},
            actionCreators: {},
            sliceMatchers: []
        };
        const contextMethods = {
            addCase (typeOrActionCreator, reducer2) {
                const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
                if (!type) throw new Error($50aea76f54d86b4e$export$378fa86b259c0280(12));
                if (type in context.sliceCaseReducersByType) throw new Error($50aea76f54d86b4e$export$378fa86b259c0280(13));
                context.sliceCaseReducersByType[type] = reducer2;
                return contextMethods;
            },
            addMatcher (matcher, reducer2) {
                context.sliceMatchers.push({
                    matcher: matcher,
                    reducer: reducer2
                });
                return contextMethods;
            },
            exposeAction (name2, actionCreator) {
                context.actionCreators[name2] = actionCreator;
                return contextMethods;
            },
            exposeCaseReducer (name2, reducer2) {
                context.sliceCaseReducersByName[name2] = reducer2;
                return contextMethods;
            }
        };
        reducerNames.forEach((reducerName)=>{
            const reducerDefinition = reducers[reducerName];
            const reducerDetails = {
                reducerName: reducerName,
                type: $50aea76f54d86b4e$var$getType(name, reducerName),
                createNotation: typeof options.reducers === "function"
            };
            if ($50aea76f54d86b4e$var$isAsyncThunkSliceReducerDefinition(reducerDefinition)) $50aea76f54d86b4e$var$handleThunkCaseReducerDefinition(reducerDetails, reducerDefinition, contextMethods, cAT);
            else $50aea76f54d86b4e$var$handleNormalReducerDefinition(reducerDetails, reducerDefinition, contextMethods);
        });
        function buildReducer() {
            const [extraReducers = {}, actionMatchers = [], defaultCaseReducer] = typeof options.extraReducers === "function" ? $50aea76f54d86b4e$var$executeReducerBuilderCallback(options.extraReducers) : [
                options.extraReducers
            ];
            const finalCaseReducers = $50aea76f54d86b4e$var$__spreadValues($50aea76f54d86b4e$var$__spreadValues({}, extraReducers), context.sliceCaseReducersByType);
            return $50aea76f54d86b4e$export$473eb76d322d0290(options.initialState, (builder)=>{
                for(let key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
                for (let sM of context.sliceMatchers)builder.addMatcher(sM.matcher, sM.reducer);
                for (let m of actionMatchers)builder.addMatcher(m.matcher, m.reducer);
                if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
            });
        }
        const selectSelf = (state)=>state;
        const injectedSelectorCache = /* @__PURE__ */ new Map();
        let _reducer;
        function reducer(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        }
        function getInitialState() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
        function makeSelectorProps(reducerPath2, injected = false) {
            function selectSlice(state) {
                let sliceState = state[reducerPath2];
                if (typeof sliceState === "undefined") {
                    if (injected) sliceState = getInitialState();
                }
                return sliceState;
            }
            function getSelectors(selectState = selectSelf) {
                const selectorCache = $50aea76f54d86b4e$var$emplace(injectedSelectorCache, injected, {
                    insert: ()=>/* @__PURE__ */ new WeakMap()
                });
                return $50aea76f54d86b4e$var$emplace(selectorCache, selectState, {
                    insert: ()=>{
                        var _a2;
                        const map = {};
                        for (const [name2, selector] of Object.entries((_a2 = options.selectors) != null ? _a2 : {}))map[name2] = $50aea76f54d86b4e$var$wrapSelector(selector, selectState, getInitialState, injected);
                        return map;
                    }
                });
            }
            return {
                reducerPath: reducerPath2,
                getSelectors: getSelectors,
                get selectors () {
                    return getSelectors(selectSlice);
                },
                selectSlice: selectSlice
            };
        }
        const slice = $50aea76f54d86b4e$var$__spreadProps($50aea76f54d86b4e$var$__spreadValues({
            name: name,
            reducer: reducer,
            actions: context.actionCreators,
            caseReducers: context.sliceCaseReducersByName,
            getInitialState: getInitialState
        }, makeSelectorProps(reducerPath)), {
            injectInto (injectable, _a2 = {}) {
                var _b = _a2, { reducerPath: pathOpt } = _b, config = $50aea76f54d86b4e$var$__objRest(_b, [
                    "reducerPath"
                ]);
                const newReducerPath = pathOpt != null ? pathOpt : reducerPath;
                injectable.inject({
                    reducerPath: newReducerPath,
                    reducer: reducer
                }, config);
                return $50aea76f54d86b4e$var$__spreadValues($50aea76f54d86b4e$var$__spreadValues({}, slice), makeSelectorProps(newReducerPath, true));
            }
        });
        return slice;
    };
}
function $50aea76f54d86b4e$var$wrapSelector(selector, selectState, getInitialState, injected) {
    function wrapper(rootState, ...args) {
        let sliceState = selectState(rootState);
        if (typeof sliceState === "undefined") {
            if (injected) sliceState = getInitialState();
        }
        return selector(sliceState, ...args);
    }
    wrapper.unwrapped = selector;
    return wrapper;
}
var $50aea76f54d86b4e$export$4d8d9bd83c24ae8b = /* @__PURE__ */ $50aea76f54d86b4e$export$affdea4146de9cf5();
function $50aea76f54d86b4e$var$buildReducerCreators() {
    function asyncThunk(payloadCreator, config) {
        return $50aea76f54d86b4e$var$__spreadValues({
            _reducerDefinitionType: "asyncThunk" /* asyncThunk */ ,
            payloadCreator: payloadCreator
        }, config);
    }
    asyncThunk.withTypes = ()=>asyncThunk;
    return {
        reducer (caseReducer) {
            return Object.assign({
                // hack so the wrapping function has the same name as the original
                // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
                [caseReducer.name] (...args) {
                    return caseReducer(...args);
                }
            }[caseReducer.name], {
                _reducerDefinitionType: "reducer" /* reducer */ 
            });
        },
        preparedReducer (prepare, reducer) {
            return {
                _reducerDefinitionType: "reducerWithPrepare" /* reducerWithPrepare */ ,
                prepare: prepare,
                reducer: reducer
            };
        },
        asyncThunk: asyncThunk
    };
}
function $50aea76f54d86b4e$var$handleNormalReducerDefinition({ type: type, reducerName: reducerName, createNotation: createNotation }, maybeReducerWithPrepare, context) {
    let caseReducer;
    let prepareCallback;
    if ("reducer" in maybeReducerWithPrepare) {
        if (createNotation && !$50aea76f54d86b4e$var$isCaseReducerWithPrepareDefinition(maybeReducerWithPrepare)) throw new Error($50aea76f54d86b4e$export$378fa86b259c0280(17));
        caseReducer = maybeReducerWithPrepare.reducer;
        prepareCallback = maybeReducerWithPrepare.prepare;
    } else caseReducer = maybeReducerWithPrepare;
    context.addCase(type, caseReducer).exposeCaseReducer(reducerName, caseReducer).exposeAction(reducerName, prepareCallback ? $50aea76f54d86b4e$export$309c7a02b0b0bc62(type, prepareCallback) : $50aea76f54d86b4e$export$309c7a02b0b0bc62(type));
}
function $50aea76f54d86b4e$var$isAsyncThunkSliceReducerDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "asyncThunk" /* asyncThunk */ ;
}
function $50aea76f54d86b4e$var$isCaseReducerWithPrepareDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "reducerWithPrepare" /* reducerWithPrepare */ ;
}
function $50aea76f54d86b4e$var$handleThunkCaseReducerDefinition({ type: type, reducerName: reducerName }, reducerDefinition, context, cAT) {
    if (!cAT) throw new Error($50aea76f54d86b4e$export$378fa86b259c0280(18));
    const { payloadCreator: payloadCreator, fulfilled: fulfilled, pending: pending, rejected: rejected, settled: settled, options: options } = reducerDefinition;
    const thunk = cAT(type, payloadCreator, options);
    context.exposeAction(reducerName, thunk);
    if (fulfilled) context.addCase(thunk.fulfilled, fulfilled);
    if (pending) context.addCase(thunk.pending, pending);
    if (rejected) context.addCase(thunk.rejected, rejected);
    if (settled) context.addMatcher(thunk.settled, settled);
    context.exposeCaseReducer(reducerName, {
        fulfilled: fulfilled || $50aea76f54d86b4e$var$noop,
        pending: pending || $50aea76f54d86b4e$var$noop,
        rejected: rejected || $50aea76f54d86b4e$var$noop,
        settled: settled || $50aea76f54d86b4e$var$noop
    });
}
function $50aea76f54d86b4e$var$noop() {}
// src/entities/entity_state.ts
function $50aea76f54d86b4e$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $50aea76f54d86b4e$var$createInitialStateFactory(stateAdapter) {
    function getInitialState(additionalState = {}, entities) {
        const state = Object.assign($50aea76f54d86b4e$var$getInitialEntityState(), additionalState);
        return entities ? stateAdapter.setAll(state, entities) : state;
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $50aea76f54d86b4e$var$createSelectorsFactory() {
    function getSelectors(selectState, options = {}) {
        const { createSelector: createSelector2 = $50aea76f54d86b4e$export$a5d3c27355e35910 } = options;
        const selectIds = (state)=>state.ids;
        const selectEntities = (state)=>state.entities;
        const selectAll = createSelector2(selectIds, selectEntities, (ids, entities)=>ids.map((id)=>entities[id]));
        const selectId = (_, id)=>id;
        const selectById = (entities, id)=>entities[id];
        const selectTotal = createSelector2(selectIds, (ids)=>ids.length);
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: createSelector2(selectEntities, selectId, selectById)
        };
        const selectGlobalizedEntities = createSelector2(selectState, selectEntities);
        return {
            selectIds: createSelector2(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: createSelector2(selectState, selectAll),
            selectTotal: createSelector2(selectState, selectTotal),
            selectById: createSelector2(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
var $50aea76f54d86b4e$var$isDraftTyped = (0, $d08a86c1c27131a8$export$541ac630993a4c84);
function $50aea76f54d86b4e$var$createSingleArgumentStateOperator(mutator) {
    const operator = $50aea76f54d86b4e$var$createStateOperator((_, state)=>mutator(state));
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $50aea76f54d86b4e$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $50aea76f54d86b4e$export$ebd532f9034651f3(arg2);
        }
        const runMutator = (draft)=>{
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ($50aea76f54d86b4e$var$isDraftTyped(state)) {
            runMutator(state);
            return state;
        }
        return (0, $d08a86c1c27131a8$export$b46cabe22e78bc00)(state, runMutator);
    };
}
// src/entities/utils.ts
function $50aea76f54d86b4e$var$selectIdValue(entity, selectId) {
    const key = selectId(entity);
    return key;
}
function $50aea76f54d86b4e$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $50aea76f54d86b4e$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $50aea76f54d86b4e$var$ensureEntitiesArray(newEntities);
    const added = [];
    const updated = [];
    for (const entity of newEntities){
        const id = $50aea76f54d86b4e$var$selectIdValue(entity, selectId);
        if (id in state.entities) updated.push({
            id: id,
            changes: entity
        });
        else added.push(entity);
    }
    return [
        added,
        updated
    ];
}
// src/entities/unsorted_state_adapter.ts
function $50aea76f54d86b4e$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        const key = $50aea76f54d86b4e$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $50aea76f54d86b4e$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)addOneMutably(entity, state);
    }
    function setOneMutably(entity, state) {
        const key = $50aea76f54d86b4e$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $50aea76f54d86b4e$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)setOneMutably(entity, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $50aea76f54d86b4e$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        let didMutate = false;
        keys.forEach((key)=>{
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter((id)=>id in state.entities);
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        const original3 = state.entities[update.id];
        if (original3 === void 0) return false;
        const updated = Object.assign({}, original3, update.changes);
        const newKey = $50aea76f54d86b4e$var$selectIdValue(updated, selectId);
        const hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        const newKeys = {};
        const updatesPerEntity = {};
        updates.forEach((update)=>{
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                // Spreads ignore falsy values, so this works even if there isn't
                // an existing update already at this key
                changes: $50aea76f54d86b4e$var$__spreadValues($50aea76f54d86b4e$var$__spreadValues({}, updatesPerEntity[update.id] ? updatesPerEntity[update.id].changes : null), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        const didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            const didMutateIds = updates.filter((update)=>takeNewKey(newKeys, update, state)).length > 0;
            if (didMutateIds) state.ids = Object.values(state.entities).map((e)=>$50aea76f54d86b4e$var$selectIdValue(e, selectId));
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated] = $50aea76f54d86b4e$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: $50aea76f54d86b4e$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $50aea76f54d86b4e$var$createStateOperator(addOneMutably),
        addMany: $50aea76f54d86b4e$var$createStateOperator(addManyMutably),
        setOne: $50aea76f54d86b4e$var$createStateOperator(setOneMutably),
        setMany: $50aea76f54d86b4e$var$createStateOperator(setManyMutably),
        setAll: $50aea76f54d86b4e$var$createStateOperator(setAllMutably),
        updateOne: $50aea76f54d86b4e$var$createStateOperator(updateOneMutably),
        updateMany: $50aea76f54d86b4e$var$createStateOperator(updateManyMutably),
        upsertOne: $50aea76f54d86b4e$var$createStateOperator(upsertOneMutably),
        upsertMany: $50aea76f54d86b4e$var$createStateOperator(upsertManyMutably),
        removeOne: $50aea76f54d86b4e$var$createStateOperator(removeOneMutably),
        removeMany: $50aea76f54d86b4e$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $50aea76f54d86b4e$var$createSortedStateAdapter(selectId, sort) {
    const { removeOne: removeOne, removeMany: removeMany, removeAll: removeAll } = $50aea76f54d86b4e$var$createUnsortedStateAdapter(selectId);
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state) {
        newEntities = $50aea76f54d86b4e$var$ensureEntitiesArray(newEntities);
        const models = newEntities.filter((model)=>!($50aea76f54d86b4e$var$selectIdValue(model, selectId) in state.entities));
        if (models.length !== 0) merge(models, state);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = $50aea76f54d86b4e$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) merge(newEntities, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $50aea76f54d86b4e$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        let appliedUpdates = false;
        for (let update of updates){
            const entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            const newId = selectId(entity);
            if (update.id !== newId) {
                delete state.entities[update.id];
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) resortEntities(state);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated] = $50aea76f54d86b4e$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length && i < b.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    function merge(models, state) {
        models.forEach((model)=>{
            state.entities[selectId(model)] = model;
        });
        resortEntities(state);
    }
    function resortEntities(state) {
        const allEntities = Object.values(state.entities);
        allEntities.sort(sort);
        const newSortedIds = allEntities.map(selectId);
        const { ids: ids } = state;
        if (!areArraysEqual(ids, newSortedIds)) state.ids = newSortedIds;
    }
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $50aea76f54d86b4e$var$createStateOperator(addOneMutably),
        updateOne: $50aea76f54d86b4e$var$createStateOperator(updateOneMutably),
        upsertOne: $50aea76f54d86b4e$var$createStateOperator(upsertOneMutably),
        setOne: $50aea76f54d86b4e$var$createStateOperator(setOneMutably),
        setMany: $50aea76f54d86b4e$var$createStateOperator(setManyMutably),
        setAll: $50aea76f54d86b4e$var$createStateOperator(setAllMutably),
        addMany: $50aea76f54d86b4e$var$createStateOperator(addManyMutably),
        updateMany: $50aea76f54d86b4e$var$createStateOperator(updateManyMutably),
        upsertMany: $50aea76f54d86b4e$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $50aea76f54d86b4e$export$abcf4037b41e0df(options = {}) {
    const { selectId: selectId, sortComparer: sortComparer } = $50aea76f54d86b4e$var$__spreadValues({
        sortComparer: false,
        selectId: (instance)=>instance.id
    }, options);
    const stateAdapter = sortComparer ? $50aea76f54d86b4e$var$createSortedStateAdapter(selectId, sortComparer) : $50aea76f54d86b4e$var$createUnsortedStateAdapter(selectId);
    const stateFactory = $50aea76f54d86b4e$var$createInitialStateFactory(stateAdapter);
    const selectorsFactory = $50aea76f54d86b4e$var$createSelectorsFactory();
    return $50aea76f54d86b4e$var$__spreadValues($50aea76f54d86b4e$var$__spreadValues($50aea76f54d86b4e$var$__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/listenerMiddleware/exceptions.ts
var $50aea76f54d86b4e$var$task = "task";
var $50aea76f54d86b4e$var$listener = "listener";
var $50aea76f54d86b4e$var$completed = "completed";
var $50aea76f54d86b4e$var$cancelled = "cancelled";
var $50aea76f54d86b4e$var$taskCancelled = `task-${$50aea76f54d86b4e$var$cancelled}`;
var $50aea76f54d86b4e$var$taskCompleted = `task-${$50aea76f54d86b4e$var$completed}`;
var $50aea76f54d86b4e$var$listenerCancelled = `${$50aea76f54d86b4e$var$listener}-${$50aea76f54d86b4e$var$cancelled}`;
var $50aea76f54d86b4e$var$listenerCompleted = `${$50aea76f54d86b4e$var$listener}-${$50aea76f54d86b4e$var$completed}`;
var $50aea76f54d86b4e$export$cb1bdac908fed7f = class {
    constructor(code){
        this.code = code;
        $50aea76f54d86b4e$var$__publicField(this, "name", "TaskAbortError");
        $50aea76f54d86b4e$var$__publicField(this, "message");
        this.message = `${$50aea76f54d86b4e$var$task} ${$50aea76f54d86b4e$var$cancelled} (reason: ${code})`;
    }
};
// src/listenerMiddleware/utils.ts
var $50aea76f54d86b4e$var$assertFunction = (func, expected)=>{
    if (typeof func !== "function") throw new Error($50aea76f54d86b4e$export$378fa86b259c0280(32));
};
var $50aea76f54d86b4e$var$noop2 = ()=>{};
var $50aea76f54d86b4e$var$catchRejection = (promise, onError = $50aea76f54d86b4e$var$noop2)=>{
    promise.catch(onError);
    return promise;
};
var $50aea76f54d86b4e$var$addAbortSignalListener = (abortSignal, callback)=>{
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return ()=>abortSignal.removeEventListener("abort", callback);
};
var $50aea76f54d86b4e$var$abortControllerWithReason = (abortController, reason)=>{
    const signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/task.ts
var $50aea76f54d86b4e$var$validateActive = (signal)=>{
    if (signal.aborted) {
        const { reason: reason } = signal;
        throw new $50aea76f54d86b4e$export$cb1bdac908fed7f(reason);
    }
};
function $50aea76f54d86b4e$var$raceWithSignal(signal, promise) {
    let cleanup = $50aea76f54d86b4e$var$noop2;
    return new Promise((resolve, reject)=>{
        const notifyRejection = ()=>reject(new $50aea76f54d86b4e$export$cb1bdac908fed7f(signal.reason));
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $50aea76f54d86b4e$var$addAbortSignalListener(signal, notifyRejection);
        promise.finally(()=>cleanup()).then(resolve, reject);
    }).finally(()=>{
        cleanup = $50aea76f54d86b4e$var$noop2;
    });
}
var $50aea76f54d86b4e$var$runTask = async (task2, cleanUp)=>{
    try {
        await Promise.resolve();
        const value = await task2();
        return {
            status: "ok",
            value: value
        };
    } catch (error) {
        return {
            status: error instanceof $50aea76f54d86b4e$export$cb1bdac908fed7f ? "cancelled" : "rejected",
            error: error
        };
    } finally{
        cleanUp == null || cleanUp();
    }
};
var $50aea76f54d86b4e$var$createPause = (signal)=>{
    return (promise)=>{
        return $50aea76f54d86b4e$var$catchRejection($50aea76f54d86b4e$var$raceWithSignal(signal, promise).then((output)=>{
            $50aea76f54d86b4e$var$validateActive(signal);
            return output;
        }));
    };
};
var $50aea76f54d86b4e$var$createDelay = (signal)=>{
    const pause = $50aea76f54d86b4e$var$createPause(signal);
    return (timeoutMs)=>{
        return pause(new Promise((resolve)=>setTimeout(resolve, timeoutMs)));
    };
};
// src/listenerMiddleware/index.ts
var { assign: $50aea76f54d86b4e$var$assign } = Object;
var $50aea76f54d86b4e$var$INTERNAL_NIL_TOKEN = {};
var $50aea76f54d86b4e$var$alm = "listenerMiddleware";
var $50aea76f54d86b4e$var$createFork = (parentAbortSignal, parentBlockingPromises)=>{
    const linkControllers = (controller)=>$50aea76f54d86b4e$var$addAbortSignalListener(parentAbortSignal, ()=>$50aea76f54d86b4e$var$abortControllerWithReason(controller, parentAbortSignal.reason));
    return (taskExecutor, opts)=>{
        $50aea76f54d86b4e$var$assertFunction(taskExecutor, "taskExecutor");
        const childAbortController = new AbortController();
        linkControllers(childAbortController);
        const result = $50aea76f54d86b4e$var$runTask(async ()=>{
            $50aea76f54d86b4e$var$validateActive(parentAbortSignal);
            $50aea76f54d86b4e$var$validateActive(childAbortController.signal);
            const result2 = await taskExecutor({
                pause: $50aea76f54d86b4e$var$createPause(childAbortController.signal),
                delay: $50aea76f54d86b4e$var$createDelay(childAbortController.signal),
                signal: childAbortController.signal
            });
            $50aea76f54d86b4e$var$validateActive(childAbortController.signal);
            return result2;
        }, ()=>$50aea76f54d86b4e$var$abortControllerWithReason(childAbortController, $50aea76f54d86b4e$var$taskCompleted));
        if (opts == null ? void 0 : opts.autoJoin) parentBlockingPromises.push(result.catch($50aea76f54d86b4e$var$noop2));
        return {
            result: $50aea76f54d86b4e$var$createPause(parentAbortSignal)(result),
            cancel () {
                $50aea76f54d86b4e$var$abortControllerWithReason(childAbortController, $50aea76f54d86b4e$var$taskCancelled);
            }
        };
    };
};
var $50aea76f54d86b4e$var$createTakePattern = (startListening, signal)=>{
    const take = async (predicate, timeout)=>{
        $50aea76f54d86b4e$var$validateActive(signal);
        let unsubscribe = ()=>{};
        const tuplePromise = new Promise((resolve, reject)=>{
            let stopListening = startListening({
                predicate: predicate,
                effect: (action, listenerApi)=>{
                    listenerApi.unsubscribe();
                    resolve([
                        action,
                        listenerApi.getState(),
                        listenerApi.getOriginalState()
                    ]);
                }
            });
            unsubscribe = ()=>{
                stopListening();
                reject();
            };
        });
        const promises = [
            tuplePromise
        ];
        if (timeout != null) promises.push(new Promise((resolve)=>setTimeout(resolve, timeout, null)));
        try {
            const output = await $50aea76f54d86b4e$var$raceWithSignal(signal, Promise.race(promises));
            $50aea76f54d86b4e$var$validateActive(signal);
            return output;
        } finally{
            unsubscribe();
        }
    };
    return (predicate, timeout)=>$50aea76f54d86b4e$var$catchRejection(take(predicate, timeout));
};
var $50aea76f54d86b4e$var$getListenerEntryPropsFrom = (options)=>{
    let { type: type, actionCreator: actionCreator, matcher: matcher, predicate: predicate, effect: effect } = options;
    if (type) predicate = $50aea76f54d86b4e$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error($50aea76f54d86b4e$export$378fa86b259c0280(21));
    $50aea76f54d86b4e$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $50aea76f54d86b4e$var$createListenerEntry = Object.assign((options)=>{
    const { type: type, predicate: predicate, effect: effect } = $50aea76f54d86b4e$var$getListenerEntryPropsFrom(options);
    const id = $50aea76f54d86b4e$export$ac4959f4f1338dfc();
    const entry = {
        id: id,
        effect: effect,
        type: type,
        predicate: predicate,
        pending: /* @__PURE__ */ new Set(),
        unsubscribe: ()=>{
            throw new Error($50aea76f54d86b4e$export$378fa86b259c0280(22));
        }
    };
    return entry;
}, {
    withTypes: ()=>$50aea76f54d86b4e$var$createListenerEntry
});
var $50aea76f54d86b4e$var$cancelActiveListeners = (entry)=>{
    entry.pending.forEach((controller)=>{
        $50aea76f54d86b4e$var$abortControllerWithReason(controller, $50aea76f54d86b4e$var$listenerCancelled);
    });
};
var $50aea76f54d86b4e$var$createClearListenerMiddleware = (listenerMap)=>{
    return ()=>{
        listenerMap.forEach($50aea76f54d86b4e$var$cancelActiveListeners);
        listenerMap.clear();
    };
};
var $50aea76f54d86b4e$var$safelyNotifyError = (errorHandler, errorToNotify, errorInfo)=>{
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(()=>{
            throw errorHandlerError;
        }, 0);
    }
};
var $50aea76f54d86b4e$export$f03a6b845d3fb58b = Object.assign($50aea76f54d86b4e$export$309c7a02b0b0bc62(`${$50aea76f54d86b4e$var$alm}/add`), {
    withTypes: ()=>$50aea76f54d86b4e$export$f03a6b845d3fb58b
});
var $50aea76f54d86b4e$export$b1b8022855fb2b71 = $50aea76f54d86b4e$export$309c7a02b0b0bc62(`${$50aea76f54d86b4e$var$alm}/removeAll`);
var $50aea76f54d86b4e$export$b03e9483f936dccb = Object.assign($50aea76f54d86b4e$export$309c7a02b0b0bc62(`${$50aea76f54d86b4e$var$alm}/remove`), {
    withTypes: ()=>$50aea76f54d86b4e$export$b03e9483f936dccb
});
var $50aea76f54d86b4e$var$defaultErrorHandler = (...args)=>{
    console.error(`${$50aea76f54d86b4e$var$alm}/error`, ...args);
};
var $50aea76f54d86b4e$export$1228acebbbcb485b = (middlewareOptions = {})=>{
    const listenerMap = /* @__PURE__ */ new Map();
    const { extra: extra, onError: onError = $50aea76f54d86b4e$var$defaultErrorHandler } = middlewareOptions;
    $50aea76f54d86b4e$var$assertFunction(onError, "onError");
    const insertEntry = (entry)=>{
        entry.unsubscribe = ()=>listenerMap.delete(entry.id);
        listenerMap.set(entry.id, entry);
        return (cancelOptions)=>{
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) $50aea76f54d86b4e$var$cancelActiveListeners(entry);
        };
    };
    const startListening = (options)=>{
        let entry = $50aea76f54d86b4e$var$find(Array.from(listenerMap.values()), (existingEntry)=>existingEntry.effect === options.effect);
        if (!entry) entry = $50aea76f54d86b4e$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    Object.assign(startListening, {
        withTypes: ()=>startListening
    });
    const stopListening = (options)=>{
        const { type: type, effect: effect, predicate: predicate } = $50aea76f54d86b4e$var$getListenerEntryPropsFrom(options);
        const entry = $50aea76f54d86b4e$var$find(Array.from(listenerMap.values()), (entry2)=>{
            const matchPredicateOrType = typeof type === "string" ? entry2.type === type : entry2.predicate === predicate;
            return matchPredicateOrType && entry2.effect === effect;
        });
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $50aea76f54d86b4e$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    Object.assign(stopListening, {
        withTypes: ()=>stopListening
    });
    const notifyListener = async (entry, action, api, getOriginalState)=>{
        const internalTaskController = new AbortController();
        const take = $50aea76f54d86b4e$var$createTakePattern(startListening, internalTaskController.signal);
        const autoJoinPromises = [];
        try {
            entry.pending.add(internalTaskController);
            await Promise.resolve(entry.effect(action, // Use assign() rather than ... to avoid extra helper functions added to bundle
            $50aea76f54d86b4e$var$assign({}, api, {
                getOriginalState: getOriginalState,
                condition: (predicate, timeout)=>take(predicate, timeout).then(Boolean),
                take: take,
                delay: $50aea76f54d86b4e$var$createDelay(internalTaskController.signal),
                pause: $50aea76f54d86b4e$var$createPause(internalTaskController.signal),
                extra: extra,
                signal: internalTaskController.signal,
                fork: $50aea76f54d86b4e$var$createFork(internalTaskController.signal, autoJoinPromises),
                unsubscribe: entry.unsubscribe,
                subscribe: ()=>{
                    listenerMap.set(entry.id, entry);
                },
                cancelActiveListeners: ()=>{
                    entry.pending.forEach((controller, _, set)=>{
                        if (controller !== internalTaskController) {
                            $50aea76f54d86b4e$var$abortControllerWithReason(controller, $50aea76f54d86b4e$var$listenerCancelled);
                            set.delete(controller);
                        }
                    });
                },
                cancel: ()=>{
                    $50aea76f54d86b4e$var$abortControllerWithReason(internalTaskController, $50aea76f54d86b4e$var$listenerCancelled);
                    entry.pending.delete(internalTaskController);
                },
                throwIfCancelled: ()=>{
                    $50aea76f54d86b4e$var$validateActive(internalTaskController.signal);
                }
            })));
        } catch (listenerError) {
            if (!(listenerError instanceof $50aea76f54d86b4e$export$cb1bdac908fed7f)) $50aea76f54d86b4e$var$safelyNotifyError(onError, listenerError, {
                raisedBy: "effect"
            });
        } finally{
            await Promise.all(autoJoinPromises);
            $50aea76f54d86b4e$var$abortControllerWithReason(internalTaskController, $50aea76f54d86b4e$var$listenerCompleted);
            entry.pending.delete(internalTaskController);
        }
    };
    const clearListenerMiddleware = $50aea76f54d86b4e$var$createClearListenerMiddleware(listenerMap);
    const middleware = (api)=>(next)=>(action)=>{
                if (!(0, $d98493d2be9cbe4c$export$b956e38827fca970)(action)) return next(action);
                if ($50aea76f54d86b4e$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($50aea76f54d86b4e$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($50aea76f54d86b4e$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                let originalState = api.getState();
                const getOriginalState = ()=>{
                    if (originalState === $50aea76f54d86b4e$var$INTERNAL_NIL_TOKEN) throw new Error($50aea76f54d86b4e$export$378fa86b259c0280(23));
                    return originalState;
                };
                let result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        const currentState = api.getState();
                        const listenerEntries = Array.from(listenerMap.values());
                        for (const entry of listenerEntries){
                            let runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $50aea76f54d86b4e$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $50aea76f54d86b4e$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
};
var $50aea76f54d86b4e$var$createMiddlewareEntry = (middleware)=>({
        id: $50aea76f54d86b4e$export$ac4959f4f1338dfc(),
        middleware: middleware,
        applied: /* @__PURE__ */ new Map()
    });
var $50aea76f54d86b4e$var$matchInstance = (instanceId)=>(action)=>{
        var _a;
        return ((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a.instanceId) === instanceId;
    };
var $50aea76f54d86b4e$export$4bb1606a79445586 = ()=>{
    const instanceId = $50aea76f54d86b4e$export$ac4959f4f1338dfc();
    const middlewareMap = /* @__PURE__ */ new Map();
    const withMiddleware = Object.assign($50aea76f54d86b4e$export$309c7a02b0b0bc62("dynamicMiddleware/add", (...middlewares)=>({
            payload: middlewares,
            meta: {
                instanceId: instanceId
            }
        })), {
        withTypes: ()=>withMiddleware
    });
    const addMiddleware = Object.assign(function addMiddleware2(...middlewares) {
        middlewares.forEach((middleware2)=>{
            let entry = $50aea76f54d86b4e$var$find(Array.from(middlewareMap.values()), (entry2)=>entry2.middleware === middleware2);
            if (!entry) entry = $50aea76f54d86b4e$var$createMiddlewareEntry(middleware2);
            middlewareMap.set(entry.id, entry);
        });
    }, {
        withTypes: ()=>addMiddleware
    });
    const getFinalMiddleware = (api)=>{
        const appliedMiddleware = Array.from(middlewareMap.values()).map((entry)=>$50aea76f54d86b4e$var$emplace(entry.applied, api, {
                insert: ()=>entry.middleware(api)
            }));
        return (0, $d98493d2be9cbe4c$export$f672e0b6f7222cd7)(...appliedMiddleware);
    };
    const isWithMiddleware = $50aea76f54d86b4e$export$9dd1fb32974da385(withMiddleware, $50aea76f54d86b4e$var$matchInstance(instanceId));
    const middleware = (api)=>(next)=>(action)=>{
                if (isWithMiddleware(action)) {
                    addMiddleware(...action.payload);
                    return api.dispatch;
                }
                return getFinalMiddleware(api)(next)(action);
            };
    return {
        middleware: middleware,
        addMiddleware: addMiddleware,
        withMiddleware: withMiddleware,
        instanceId: instanceId
    };
};
var $50aea76f54d86b4e$var$isSliceLike = (maybeSliceLike)=>"reducerPath" in maybeSliceLike && typeof maybeSliceLike.reducerPath === "string";
var $50aea76f54d86b4e$var$getReducers = (slices)=>slices.flatMap((sliceOrMap)=>$50aea76f54d86b4e$var$isSliceLike(sliceOrMap) ? [
            [
                sliceOrMap.reducerPath,
                sliceOrMap.reducer
            ]
        ] : Object.entries(sliceOrMap));
var $50aea76f54d86b4e$var$ORIGINAL_STATE = Symbol.for("rtk-state-proxy-original");
var $50aea76f54d86b4e$var$isStateProxy = (value)=>!!value && !!value[$50aea76f54d86b4e$var$ORIGINAL_STATE];
var $50aea76f54d86b4e$var$stateProxyMap = /* @__PURE__ */ new WeakMap();
var $50aea76f54d86b4e$var$createStateProxy = (state, reducerMap)=>$50aea76f54d86b4e$var$emplace($50aea76f54d86b4e$var$stateProxyMap, state, {
        insert: ()=>new Proxy(state, {
                get: (target, prop, receiver)=>{
                    if (prop === $50aea76f54d86b4e$var$ORIGINAL_STATE) return target;
                    const result = Reflect.get(target, prop, receiver);
                    if (typeof result === "undefined") {
                        const reducer = reducerMap[prop.toString()];
                        if (reducer) {
                            const reducerResult = reducer(void 0, {
                                type: $50aea76f54d86b4e$export$ac4959f4f1338dfc()
                            });
                            if (typeof reducerResult === "undefined") throw new Error($50aea76f54d86b4e$export$378fa86b259c0280(24));
                            return reducerResult;
                        }
                    }
                    return result;
                }
            })
    });
var $50aea76f54d86b4e$var$original = (state)=>{
    if (!$50aea76f54d86b4e$var$isStateProxy(state)) throw new Error($50aea76f54d86b4e$export$378fa86b259c0280(25));
    return state[$50aea76f54d86b4e$var$ORIGINAL_STATE];
};
var $50aea76f54d86b4e$var$noopReducer = (state = {})=>state;
function $50aea76f54d86b4e$export$a3734c7614660b9(...slices) {
    const reducerMap = Object.fromEntries($50aea76f54d86b4e$var$getReducers(slices));
    const getReducer = ()=>Object.keys(reducerMap).length ? (0, $d98493d2be9cbe4c$export$66e4520cdb265d18)(reducerMap) : $50aea76f54d86b4e$var$noopReducer;
    let reducer = getReducer();
    function combinedReducer(state, action) {
        return reducer(state, action);
    }
    combinedReducer.withLazyLoadedSlices = ()=>combinedReducer;
    const inject = (slice, config = {})=>{
        const { reducerPath: reducerPath, reducer: reducerToInject } = slice;
        const currentReducer = reducerMap[reducerPath];
        if (!config.overrideExisting && currentReducer && currentReducer !== reducerToInject) {
            typeof $iF4fv;
            return combinedReducer;
        }
        reducerMap[reducerPath] = reducerToInject;
        reducer = getReducer();
        return combinedReducer;
    };
    const selector = Object.assign(function makeSelector(selectorFn, selectState) {
        return function selector2(state, ...args) {
            return selectorFn($50aea76f54d86b4e$var$createStateProxy(selectState ? selectState(state, ...args) : state, reducerMap), ...args);
        };
    }, {
        original: $50aea76f54d86b4e$var$original
    });
    return Object.assign(combinedReducer, {
        inject: inject,
        selector: selector
    });
}
// src/formatProdErrorMessage.ts
function $50aea76f54d86b4e$export$378fa86b259c0280(code) {
    return `Minified Redux Toolkit error #${code}; visit https://redux-toolkit.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}


const $9cfb09fae6dbced4$var$initialState = {
    email: undefined,
    id: undefined,
    loading: true
};
const $9cfb09fae6dbced4$var$emailSelector = (state)=>state.email;
var $9cfb09fae6dbced4$export$2e2bcd8739ae039 = (0, $50aea76f54d86b4e$export$4d8d9bd83c24ae8b)({
    name: "user",
    initialState: $9cfb09fae6dbced4$var$initialState,
    reducers: {
        clear: ()=>({
                ...$9cfb09fae6dbced4$var$initialState,
                loading: false
            }),
        set: (_, action)=>({
                ...action.payload,
                loading: false
            }),
        setEmail: (state, action)=>({
                ...state,
                email: action.payload
            })
    },
    selectors: {
        email: $9cfb09fae6dbced4$var$emailSelector,
        id: (state)=>state.id,
        isSignedIn: (0, $b8b130b8bbf51c97$export$595d22ed68ca2841)($9cfb09fae6dbced4$var$emailSelector, (email)=>Boolean(email)),
        loading: (state)=>state.loading
    }
});


$a680f7f2ea4c1359$export$2cd8252107eb640b({
    dsn: "https://7fc7812ff3d6482ba2113d6fc90177fa@o4504114345017344.ingest.sentry.io/4504114369527808",
    // COMMIT_REF automatically supplied by Netlify https://docs.netlify.com/configure-builds/environment-variables/#git-metadata
    release: "a2f968556104e7777a0f50197a89394188e52d44"
});
const $24a8d9ab78e4f062$export$f5282963edea4a68 = (exception, context)=>{
    return $3bf2cc17570e59fe$export$f5282963edea4a68(exception, context);
};
const $24a8d9ab78e4f062$export$208a507d199ad5b2 = ()=>{
    const userId = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $9cfb09fae6dbced4$export$2e2bcd8739ae039).selectors.id);
    $3bf2cc17570e59fe$export$8b6bb3dd62a01be2(userId ? {
        id: userId
    } : null);
};



var $491d17d468ec31f9$exports = {};
$491d17d468ec31f9$exports = new URL("service-worker.js", import.meta.url).toString();


var $42836af780eac301$export$2e2bcd8739ae039 = navigator.serviceWorker.register($491d17d468ec31f9$exports);


/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */ 
var $iF4fv = parcelRequire("iF4fv");
const $e601d7027d812060$export$588c7fdda06fbb0a = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */ NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */ NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */ SDK_VERSION: "${JSCORE_VERSION}"
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Throws an error if the provided assertion is falsy
 */ const $e601d7027d812060$export$a7a9523472993e97 = function(assertion, message) {
    if (!assertion) throw $e601d7027d812060$export$a39cad550e7ab28a(message);
};
/**
 * Returns an Error object suitable for throwing.
 */ const $e601d7027d812060$export$a39cad550e7ab28a = function(message) {
    return new Error("Firebase Database (" + $e601d7027d812060$export$588c7fdda06fbb0a.SDK_VERSION + ") INTERNAL ASSERT FAILED: " + message);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $e601d7027d812060$var$stringToByteArray$1 = function(str) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if ((c & 0xfc00) === 0xd800 && i + 1 < str.length && (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param bytes Array of numbers representing characters.
 * @return Stringification of the array.
 */ const $e601d7027d812060$var$byteArrayToString = function(bytes) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let pos = 0, c = 0;
    while(pos < bytes.length){
        const c1 = bytes[pos++];
        if (c1 < 128) out[c++] = String.fromCharCode(c1);
        else if (c1 > 191 && c1 < 224) {
            const c2 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 31) << 6 | c2 & 63);
        } else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            const c4 = bytes[pos++];
            const u = ((c1 & 7) << 18 | (c2 & 63) << 12 | (c3 & 63) << 6 | c4 & 63) - 0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        } else {
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
        }
    }
    return out.join("");
};
// We define it as an object literal instead of a class because a class compiled down to es5 can't
// be treeshaked. https://github.com/rollup/rollup/issues/1691
// Static lookup maps, lazily populated by init_()
const $e601d7027d812060$export$b3b2de96497acc47 = {
    /**
     * Maps bytes to characters.
     */ byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     */ charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @private
     */ byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @private
     */ charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     */ ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     */ get ENCODED_VALS () {
        return this.ENCODED_VALS_BASE + "+/=";
    },
    /**
     * Our websafe alphabet.
     */ get ENCODED_VALS_WEBSAFE () {
        return this.ENCODED_VALS_BASE + "-_.";
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     */ HAS_NATIVE_SUPPORT: typeof atob === "function",
    /**
     * Base64-encode an array of bytes.
     *
     * @param input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeByteArray (input, webSafe) {
        if (!Array.isArray(input)) throw Error("encodeByteArray takes an array as a parameter");
        this.init_();
        const byteToCharMap = webSafe ? this.byteToCharMapWebSafe_ : this.byteToCharMap_;
        const output = [];
        for(let i = 0; i < input.length; i += 3){
            const byte1 = input[i];
            const haveByte2 = i + 1 < input.length;
            const byte2 = haveByte2 ? input[i + 1] : 0;
            const haveByte3 = i + 2 < input.length;
            const byte3 = haveByte3 ? input[i + 2] : 0;
            const outByte1 = byte1 >> 2;
            const outByte2 = (byte1 & 0x03) << 4 | byte2 >> 4;
            let outByte3 = (byte2 & 0x0f) << 2 | byte3 >> 6;
            let outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) outByte3 = 64;
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join("");
    },
    /**
     * Base64-encode a string.
     *
     * @param input A string to encode.
     * @param webSafe If true, we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return btoa(input);
        return this.encodeByteArray($e601d7027d812060$var$stringToByteArray$1(input), webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param input to decode.
     * @param webSafe True if we should use the
     *     alternative alphabet.
     * @return string representing the decoded value.
     */ decodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return atob(input);
        return $e601d7027d812060$var$byteArrayToString(this.decodeStringToByteArray(input, webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param input Input to decode.
     * @param webSafe True if we should use the web-safe alphabet.
     * @return bytes representing the decoded value.
     */ decodeStringToByteArray (input, webSafe) {
        this.init_();
        const charToByteMap = webSafe ? this.charToByteMapWebSafe_ : this.charToByteMap_;
        const output = [];
        for(let i = 0; i < input.length;){
            const byte1 = charToByteMap[input.charAt(i++)];
            const haveByte2 = i < input.length;
            const byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            const haveByte3 = i < input.length;
            const byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            const haveByte4 = i < input.length;
            const byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) throw new $e601d7027d812060$export$55ca9d4bee46aeb3();
            const outByte1 = byte1 << 2 | byte2 >> 4;
            output.push(outByte1);
            if (byte3 !== 64) {
                const outByte2 = byte2 << 4 & 0xf0 | byte3 >> 2;
                output.push(outByte2);
                if (byte4 !== 64) {
                    const outByte3 = byte3 << 6 & 0xc0 | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */ init_ () {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for(let i = 0; i < this.ENCODED_VALS.length; i++){
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * An error encountered while decoding base64 string.
 */ class $e601d7027d812060$export$55ca9d4bee46aeb3 extends Error {
    constructor(){
        super(...arguments);
        this.name = "DecodeBase64StringError";
    }
}
/**
 * URL-safe base64 encoding
 */ const $e601d7027d812060$export$e510a73ee562749 = function(str) {
    const utf8Bytes = $e601d7027d812060$var$stringToByteArray$1(str);
    return $e601d7027d812060$export$b3b2de96497acc47.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 encoding (without "." padding in the end).
 * e.g. Used in JSON Web Token (JWT) parts.
 */ const $e601d7027d812060$export$4b5284a3025a455 = function(str) {
    // Use base64url encoding and remove padding in the end (dot characters).
    return $e601d7027d812060$export$e510a73ee562749(str).replace(/\./g, "");
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param str To be decoded
 * @return Decoded result, if possible
 */ const $e601d7027d812060$export$c62426fdd000a97e = function(str) {
    try {
        return $e601d7027d812060$export$b3b2de96497acc47.decodeString(str, true);
    } catch (e) {
        console.error("base64Decode failed: ", e);
    }
    return null;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */ function $e601d7027d812060$export$6c40052bed430212(value) {
    return $e601d7027d812060$export$54e9fb29908872fa(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 *
 * Note: we don't merge __proto__ to prevent prototype pollution
 */ function $e601d7027d812060$export$54e9fb29908872fa(target, source) {
    if (!(source instanceof Object)) return source;
    switch(source.constructor){
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            const dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) target = {};
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for(const prop in source){
        // use isValidKey to guard against prototype pollution. See https://snyk.io/vuln/SNYK-JS-LODASH-450202
        if (!source.hasOwnProperty(prop) || !$e601d7027d812060$var$isValidKey(prop)) continue;
        target[prop] = $e601d7027d812060$export$54e9fb29908872fa(target[prop], source[prop]);
    }
    return target;
}
function $e601d7027d812060$var$isValidKey(key) {
    return key !== "__proto__";
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Polyfill for `globalThis` object.
 * @returns the `globalThis` object for the given environment.
 * @public
 */ function $e601d7027d812060$export$a4e55266d2135a7f() {
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw new Error("Unable to locate global object.");
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $e601d7027d812060$var$getDefaultsFromGlobal = ()=>$e601d7027d812060$export$a4e55266d2135a7f().__FIREBASE_DEFAULTS__;
/**
 * Attempt to read defaults from a JSON string provided to
 * process(.)env(.)__FIREBASE_DEFAULTS__ or a JSON file whose path is in
 * process(.)env(.)__FIREBASE_DEFAULTS_PATH__
 * The dots are in parens because certain compilers (Vite?) cannot
 * handle seeing that variable in comments.
 * See https://github.com/firebase/firebase-js-sdk/issues/6838
 */ const $e601d7027d812060$var$getDefaultsFromEnvVariable = ()=>{
    if (typeof $iF4fv === "undefined" || typeof $iF4fv.env === "undefined") return;
    const defaultsJsonString = undefined;
    if (defaultsJsonString) return JSON.parse(defaultsJsonString);
};
const $e601d7027d812060$var$getDefaultsFromCookie = ()=>{
    if (typeof document === "undefined") return;
    let match;
    try {
        match = document.cookie.match(/__FIREBASE_DEFAULTS__=([^;]+)/);
    } catch (e) {
        // Some environments such as Angular Universal SSR have a
        // `document` object but error on accessing `document.cookie`.
        return;
    }
    const decoded = match && $e601d7027d812060$export$c62426fdd000a97e(match[1]);
    return decoded && JSON.parse(decoded);
};
/**
 * Get the __FIREBASE_DEFAULTS__ object. It checks in order:
 * (1) if such an object exists as a property of `globalThis`
 * (2) if such an object was provided on a shell environment variable
 * (3) if such an object exists in a cookie
 * @public
 */ const $e601d7027d812060$export$212bb2fc580a90a8 = ()=>{
    try {
        return $e601d7027d812060$var$getDefaultsFromGlobal() || $e601d7027d812060$var$getDefaultsFromEnvVariable() || $e601d7027d812060$var$getDefaultsFromCookie();
    } catch (e) {
        /**
         * Catch-all for being unable to get __FIREBASE_DEFAULTS__ due
         * to any environment case we have not accounted for. Log to
         * info instead of swallowing so we can find these unknown cases
         * and add paths for them if needed.
         */ console.info(`Unable to get __FIREBASE_DEFAULTS__ due to: ${e}`);
        return;
    }
};
/**
 * Returns emulator host stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a URL host formatted like `127.0.0.1:9999` or `[::1]:4000` if available
 * @public
 */ const $e601d7027d812060$export$9c11895284c8adad = (productName)=>{
    var _a, _b;
    return (_b = (_a = $e601d7027d812060$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.emulatorHosts) === null || _b === void 0 ? void 0 : _b[productName];
};
/**
 * Returns emulator hostname and port stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a pair of hostname and port like `["::1", 4000]` if available
 * @public
 */ const $e601d7027d812060$export$a3febcf1f14a3a0c = (productName)=>{
    const host = $e601d7027d812060$export$9c11895284c8adad(productName);
    if (!host) return undefined;
    const separatorIndex = host.lastIndexOf(":"); // Finding the last since IPv6 addr also has colons.
    if (separatorIndex <= 0 || separatorIndex + 1 === host.length) throw new Error(`Invalid host ${host} with no separate hostname and port!`);
    // eslint-disable-next-line no-restricted-globals
    const port = parseInt(host.substring(separatorIndex + 1), 10);
    if (host[0] === "[") // Bracket-quoted `[ipv6addr]:port` => return "ipv6addr" (without brackets).
    return [
        host.substring(1, separatorIndex - 1),
        port
    ];
    else return [
        host.substring(0, separatorIndex),
        port
    ];
};
/**
 * Returns Firebase app config stored in the __FIREBASE_DEFAULTS__ object.
 * @public
 */ const $e601d7027d812060$export$3dfb6827a9f89756 = ()=>{
    var _a;
    return (_a = $e601d7027d812060$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.config;
};
/**
 * Returns an experimental setting on the __FIREBASE_DEFAULTS__ object (properties
 * prefixed by "_")
 * @public
 */ const $e601d7027d812060$export$5539a1a3afe87d6 = (name)=>{
    var _a;
    return (_a = $e601d7027d812060$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a[`_${name}`];
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $e601d7027d812060$export$85f6557964517f1a {
    constructor(){
        this.reject = ()=>{};
        this.resolve = ()=>{};
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
    /**
     * Our API internals are not promiseified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     */ wrapCallback(callback) {
        return (error, value)=>{
            if (error) this.reject(error);
            else this.resolve(value);
            if (typeof callback === "function") {
                // Attaching noop handler just in case developer wasn't expecting
                // promises
                this.promise.catch(()=>{});
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (callback.length === 1) callback(error);
                else callback(error, value);
            }
        };
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $e601d7027d812060$export$367bf224123348f1(token, projectId) {
    if (token.uid) throw new Error('The "uid" field is no longer supported by mockUserToken. Please use "sub" instead for Firebase Auth User ID.');
    // Unsecured JWTs use "none" as the algorithm.
    const header = {
        alg: "none",
        type: "JWT"
    };
    const project = projectId || "demo-project";
    const iat = token.iat || 0;
    const sub = token.sub || token.user_id;
    if (!sub) throw new Error("mockUserToken must contain 'sub' or 'user_id' field!");
    const payload = Object.assign({
        // Set all required fields to decent defaults
        iss: `https://securetoken.google.com/${project}`,
        aud: project,
        iat: iat,
        exp: iat + 3600,
        auth_time: iat,
        sub: sub,
        user_id: sub,
        firebase: {
            sign_in_provider: "custom",
            identities: {}
        }
    }, token);
    // Unsecured JWTs use the empty string as a signature.
    const signature = "";
    return [
        $e601d7027d812060$export$4b5284a3025a455(JSON.stringify(header)),
        $e601d7027d812060$export$4b5284a3025a455(JSON.stringify(payload)),
        signature
    ].join(".");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return user agent string
 */ function $e601d7027d812060$export$c36915b22ce77c19() {
    if (typeof navigator !== "undefined" && typeof navigator["userAgent"] === "string") return navigator["userAgent"];
    else return "";
}
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap
 * in the Ripple emulator) nor Cordova `onDeviceReady`, which would normally
 * wait for a callback.
 */ function $e601d7027d812060$export$872f8323f01d7ae0() {
    return typeof window !== "undefined" && // @ts-ignore Setting up an broadly applicable index signature for Window
    // just to deal with this case would probably be a bad idea.
    !!(window["cordova"] || window["phonegap"] || window["PhoneGap"]) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test($e601d7027d812060$export$c36915b22ce77c19());
}
/**
 * Detect Node.js.
 *
 * @return true if Node.js environment is detected or specified.
 */ // Node detection logic from: https://github.com/iliakan/detect-node/
function $e601d7027d812060$export$8ee0fc9ee280b4ee() {
    var _a;
    const forceEnvironment = (_a = $e601d7027d812060$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.forceEnvironment;
    if (forceEnvironment === "node") return true;
    else if (forceEnvironment === "browser") return false;
    try {
        return Object.prototype.toString.call($parcel$global.process) === "[object process]";
    } catch (e) {
        return false;
    }
}
/**
 * Detect Browser Environment
 */ function $e601d7027d812060$export$4e09c449d6c407f7() {
    return typeof self === "object" && self.self === self;
}
function $e601d7027d812060$export$caa8774a9107a58e() {
    const runtime = typeof chrome === "object" ? chrome.runtime : typeof browser === "object" ? browser.runtime : undefined;
    return typeof runtime === "object" && runtime.id !== undefined;
}
/**
 * Detect React Native.
 *
 * @return true if ReactNative environment is detected.
 */ function $e601d7027d812060$export$f7a1e23e542d38e3() {
    return typeof navigator === "object" && navigator["product"] === "ReactNative";
}
/** Detects Electron apps. */ function $e601d7027d812060$export$f2f6a8999f8ebd30() {
    return $e601d7027d812060$export$c36915b22ce77c19().indexOf("Electron/") >= 0;
}
/** Detects Internet Explorer. */ function $e601d7027d812060$export$7e7b1a9668aaed8() {
    const ua = $e601d7027d812060$export$c36915b22ce77c19();
    return ua.indexOf("MSIE ") >= 0 || ua.indexOf("Trident/") >= 0;
}
/** Detects Universal Windows Platform apps. */ function $e601d7027d812060$export$202944b2d2824246() {
    return $e601d7027d812060$export$c36915b22ce77c19().indexOf("MSAppHost/") >= 0;
}
/**
 * Detect whether the current SDK build is the Node version.
 *
 * @return true if it's the Node SDK build.
 */ function $e601d7027d812060$export$5d1d834fbbf8bab7() {
    return $e601d7027d812060$export$588c7fdda06fbb0a.NODE_CLIENT === true || $e601d7027d812060$export$588c7fdda06fbb0a.NODE_ADMIN === true;
}
/** Returns true if we are running in Safari. */ function $e601d7027d812060$export$95df08bae54cb4df() {
    return !$e601d7027d812060$export$8ee0fc9ee280b4ee() && !!navigator.userAgent && navigator.userAgent.includes("Safari") && !navigator.userAgent.includes("Chrome");
}
/**
 * This method checks if indexedDB is supported by current browser/service worker context
 * @return true if indexedDB is supported by current browser/service worker context
 */ function $e601d7027d812060$export$3865db50535c2055() {
    try {
        return typeof indexedDB === "object";
    } catch (e) {
        return false;
    }
}
/**
 * This method validates browser/sw context for indexedDB by opening a dummy indexedDB database and reject
 * if errors occur during the database open operation.
 *
 * @throws exception if current browser/sw context can't run idb.open (ex: Safari iframe, Firefox
 * private browsing)
 */ function $e601d7027d812060$export$a8a3018f3d187a4d() {
    return new Promise((resolve, reject)=>{
        try {
            let preExist = true;
            const DB_CHECK_NAME = "validate-browser-context-for-indexeddb-analytics-module";
            const request = self.indexedDB.open(DB_CHECK_NAME);
            request.onsuccess = ()=>{
                request.result.close();
                // delete database only when it doesn't pre-exist
                if (!preExist) self.indexedDB.deleteDatabase(DB_CHECK_NAME);
                resolve(true);
            };
            request.onupgradeneeded = ()=>{
                preExist = false;
            };
            request.onerror = ()=>{
                var _a;
                reject(((_a = request.error) === null || _a === void 0 ? void 0 : _a.message) || "");
            };
        } catch (error) {
            reject(error);
        }
    });
}
/**
 *
 * This method checks whether cookie is enabled within current browser
 * @return true if cookie is enabled within current browser
 */ function $e601d7027d812060$export$f172b7eb6cf60599() {
    if (typeof navigator === "undefined" || !navigator.cookieEnabled) return false;
    return true;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Standardized Firebase Error.
 *
 * Usage:
 *
 *   // Typescript string literals for type-safe codes
 *   type Err =
 *     'unknown' |
 *     'object-not-found'
 *     ;
 *
 *   // Closure enum for type-safe error codes
 *   // at-enum {string}
 *   var Err = {
 *     UNKNOWN: 'unknown',
 *     OBJECT_NOT_FOUND: 'object-not-found',
 *   }
 *
 *   let errors: Map<Err, string> = {
 *     'generic-error': "Unknown error",
 *     'file-not-found': "Could not find file: {$file}",
 *   };
 *
 *   // Type-safe function - must pass a valid error code as param.
 *   let error = new ErrorFactory<Err>('service', 'Service', errors);
 *
 *   ...
 *   throw error.create(Err.GENERIC);
 *   ...
 *   throw error.create(Err.FILE_NOT_FOUND, {'file': fileName});
 *   ...
 *   // Service: Could not file file: foo.txt (service/file-not-found).
 *
 *   catch (e) {
 *     assert(e.message === "Could not find file: foo.txt.");
 *     if ((e as FirebaseError)?.code === 'service/file-not-found') {
 *       console.log("Could not read file: " + e['file']);
 *     }
 *   }
 */ const $e601d7027d812060$var$ERROR_NAME = "FirebaseError";
// Based on code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
class $e601d7027d812060$export$dd24e9cd51226c56 extends Error {
    constructor(/** The error code for this error. */ code, message, /** Custom data for this error. */ customData){
        super(message);
        this.code = code;
        this.customData = customData;
        /** The custom name for all FirebaseErrors. */ this.name = $e601d7027d812060$var$ERROR_NAME;
        // Fix For ES5
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $e601d7027d812060$export$dd24e9cd51226c56.prototype);
        // Maintains proper stack trace for where our error was thrown.
        // Only available on V8.
        if (Error.captureStackTrace) Error.captureStackTrace(this, $e601d7027d812060$export$3fa6e1b18a3b2d40.prototype.create);
    }
}
class $e601d7027d812060$export$3fa6e1b18a3b2d40 {
    constructor(service, serviceName, errors){
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
    }
    create(code, ...data) {
        const customData = data[0] || {};
        const fullCode = `${this.service}/${code}`;
        const template = this.errors[code];
        const message = template ? $e601d7027d812060$var$replaceTemplate(template, customData) : "Error";
        // Service Name: Error message (service/code).
        const fullMessage = `${this.serviceName}: ${message} (${fullCode}).`;
        const error = new $e601d7027d812060$export$dd24e9cd51226c56(fullCode, fullMessage, customData);
        return error;
    }
}
function $e601d7027d812060$var$replaceTemplate(template, data) {
    return template.replace($e601d7027d812060$var$PATTERN, (_, key)=>{
        const value = data[key];
        return value != null ? String(value) : `<${key}?>`;
    });
}
const $e601d7027d812060$var$PATTERN = /\{\$([^}]+)}/g;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */ function $e601d7027d812060$export$c5a53ce6a17cf18d(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data Javascript object to be stringified.
 * @return {string} The JSON contents of the object.
 */ function $e601d7027d812060$export$fac44ee5b035f737(data) {
    return JSON.stringify(data);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $e601d7027d812060$export$2f872c0f2117be69 = function(token) {
    let header = {}, claims = {}, data = {}, signature = "";
    try {
        const parts = token.split(".");
        header = $e601d7027d812060$export$c5a53ce6a17cf18d($e601d7027d812060$export$c62426fdd000a97e(parts[0]) || "");
        claims = $e601d7027d812060$export$c5a53ce6a17cf18d($e601d7027d812060$export$c62426fdd000a97e(parts[1]) || "");
        signature = parts[2];
        data = claims["d"] || {};
        delete claims["d"];
    } catch (e) {}
    return {
        header: header,
        claims: claims,
        data: data,
        signature: signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $e601d7027d812060$export$5f870fcca7ae6a88 = function(token) {
    const claims = $e601d7027d812060$export$2f872c0f2117be69(token).claims;
    const now = Math.floor(new Date().getTime() / 1000);
    let validSince = 0, validUntil = 0;
    if (typeof claims === "object") {
        if (claims.hasOwnProperty("nbf")) validSince = claims["nbf"];
        else if (claims.hasOwnProperty("iat")) validSince = claims["iat"];
        if (claims.hasOwnProperty("exp")) validUntil = claims["exp"];
        else // token will expire after 24h by default
        validUntil = validSince + 86400;
    }
    return !!now && !!validSince && !!validUntil && now >= validSince && now <= validUntil;
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $e601d7027d812060$export$701c661ec91095f2 = function(token) {
    const claims = $e601d7027d812060$export$2f872c0f2117be69(token).claims;
    if (typeof claims === "object" && claims.hasOwnProperty("iat")) return claims["iat"];
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $e601d7027d812060$export$9565ca3d387f8aa0 = function(token) {
    const decoded = $e601d7027d812060$export$2f872c0f2117be69(token), claims = decoded.claims;
    return !!claims && typeof claims === "object" && claims.hasOwnProperty("iat");
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $e601d7027d812060$export$fc970ed23da99565 = function(token) {
    const claims = $e601d7027d812060$export$2f872c0f2117be69(token).claims;
    return typeof claims === "object" && claims["admin"] === true;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $e601d7027d812060$export$2344b14b097df817(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
function $e601d7027d812060$export$e51ae4db7b428f67(obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) return obj[key];
    else return undefined;
}
function $e601d7027d812060$export$dd1bc94b04021eeb(obj) {
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
}
function $e601d7027d812060$export$871de8747c9eaa88(obj, fn, contextObj) {
    const res = {};
    for(const key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res[key] = fn.call(contextObj, obj[key], key, obj);
    return res;
}
/**
 * Deep equal two objects. Support Arrays and Objects.
 */ function $e601d7027d812060$export$9cb4719e2e525b7a(a, b) {
    if (a === b) return true;
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    for (const k of aKeys){
        if (!bKeys.includes(k)) return false;
        const aProp = a[k];
        const bProp = b[k];
        if ($e601d7027d812060$var$isObject(aProp) && $e601d7027d812060$var$isObject(bProp)) {
            if (!$e601d7027d812060$export$9cb4719e2e525b7a(aProp, bProp)) return false;
        } else if (aProp !== bProp) return false;
    }
    for (const k of bKeys){
        if (!aKeys.includes(k)) return false;
    }
    return true;
}
function $e601d7027d812060$var$isObject(thing) {
    return thing !== null && typeof thing === "object";
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Rejects if the given promise doesn't resolve in timeInMS milliseconds.
 * @internal
 */ function $e601d7027d812060$export$a9cd205a244d9f54(promise, timeInMS = 2000) {
    const deferredPromise = new $e601d7027d812060$export$85f6557964517f1a();
    setTimeout(()=>deferredPromise.reject("timeout!"), timeInMS);
    promise.then(deferredPromise.resolve, deferredPromise.reject);
    return deferredPromise.promise;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a
 * params object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 */ function $e601d7027d812060$export$ac4103b836844853(querystringParams) {
    const params = [];
    for (const [key, value] of Object.entries(querystringParams))if (Array.isArray(value)) value.forEach((arrayVal)=>{
        params.push(encodeURIComponent(key) + "=" + encodeURIComponent(arrayVal));
    });
    else params.push(encodeURIComponent(key) + "=" + encodeURIComponent(value));
    return params.length ? "&" + params.join("&") : "";
}
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object
 * (e.g. {arg: 'val', arg2: 'val2'})
 */ function $e601d7027d812060$export$c1271ca4c8a70741(querystring) {
    const obj = {};
    const tokens = querystring.replace(/^\?/, "").split("&");
    tokens.forEach((token)=>{
        if (token) {
            const [key, value] = token.split("=");
            obj[decodeURIComponent(key)] = decodeURIComponent(value);
        }
    });
    return obj;
}
/**
 * Extract the query string part of a URL, including the leading question mark (if present).
 */ function $e601d7027d812060$export$1a8408415472d8ed(url) {
    const queryStart = url.indexOf("?");
    if (!queryStart) return "";
    const fragmentStart = url.indexOf("#", queryStart);
    return url.substring(queryStart, fragmentStart > 0 ? fragmentStart : undefined);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */ /**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @final
 * @struct
 */ class $e601d7027d812060$export$c85d589bf4e25fef {
    constructor(){
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @private
         */ this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @private
         */ this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @private
         */ this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @private
         */ this.pad_ = [];
        /**
         * @private {number}
         */ this.inbuf_ = 0;
        /**
         * @private {number}
         */ this.total_ = 0;
        this.blockSize = 64;
        this.pad_[0] = 128;
        for(let i = 1; i < this.blockSize; ++i)this.pad_[i] = 0;
        this.reset();
    }
    reset() {
        this.chain_[0] = 0x67452301;
        this.chain_[1] = 0xefcdab89;
        this.chain_[2] = 0x98badcfe;
        this.chain_[3] = 0x10325476;
        this.chain_[4] = 0xc3d2e1f0;
        this.inbuf_ = 0;
        this.total_ = 0;
    }
    /**
     * Internal compress helper function.
     * @param buf Block to compress.
     * @param offset Offset of the block in the buffer.
     * @private
     */ compress_(buf, offset) {
        if (!offset) offset = 0;
        const W = this.W_;
        // get 16 big endian words
        if (typeof buf === "string") for(let i = 0; i < 16; i++){
            // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
            // have a bug that turns the post-increment ++ operator into pre-increment
            // during JIT compilation.  We have code that depends heavily on SHA-1 for
            // correctness and which is affected by this bug, so I've removed all uses
            // of post-increment ++ in which the result value is used.  We can revert
            // this change once the Safari bug
            // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
            // most clients have been updated.
            W[i] = buf.charCodeAt(offset) << 24 | buf.charCodeAt(offset + 1) << 16 | buf.charCodeAt(offset + 2) << 8 | buf.charCodeAt(offset + 3);
            offset += 4;
        }
        else for(let i = 0; i < 16; i++){
            W[i] = buf[offset] << 24 | buf[offset + 1] << 16 | buf[offset + 2] << 8 | buf[offset + 3];
            offset += 4;
        }
        // expand to 80 words
        for(let i = 16; i < 80; i++){
            const t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = (t << 1 | t >>> 31) & 0xffffffff;
        }
        let a = this.chain_[0];
        let b = this.chain_[1];
        let c = this.chain_[2];
        let d = this.chain_[3];
        let e = this.chain_[4];
        let f, k;
        // TODO(user): Try to unroll this loop to speed up the computation.
        for(let i = 0; i < 80; i++){
            if (i < 40) {
                if (i < 20) {
                    f = d ^ b & (c ^ d);
                    k = 0x5a827999;
                } else {
                    f = b ^ c ^ d;
                    k = 0x6ed9eba1;
                }
            } else if (i < 60) {
                f = b & c | d & (b | c);
                k = 0x8f1bbcdc;
            } else {
                f = b ^ c ^ d;
                k = 0xca62c1d6;
            }
            const t = (a << 5 | a >>> 27) + f + e + k + W[i] & 0xffffffff;
            e = d;
            d = c;
            c = (b << 30 | b >>> 2) & 0xffffffff;
            b = a;
            a = t;
        }
        this.chain_[0] = this.chain_[0] + a & 0xffffffff;
        this.chain_[1] = this.chain_[1] + b & 0xffffffff;
        this.chain_[2] = this.chain_[2] + c & 0xffffffff;
        this.chain_[3] = this.chain_[3] + d & 0xffffffff;
        this.chain_[4] = this.chain_[4] + e & 0xffffffff;
    }
    update(bytes, length) {
        // TODO(johnlenz): tighten the function signature and remove this check
        if (bytes == null) return;
        if (length === undefined) length = bytes.length;
        const lengthMinusBlock = length - this.blockSize;
        let n = 0;
        // Using local instead of member variables gives ~5% speedup on Firefox 16.
        const buf = this.buf_;
        let inbuf = this.inbuf_;
        // The outer while loop should execute at most twice.
        while(n < length){
            // When we have no data in the block to top up, we can directly process the
            // input buffer (assuming it contains sufficient data). This gives ~25%
            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
            // the data is provided in large chunks (or in multiples of 64 bytes).
            if (inbuf === 0) while(n <= lengthMinusBlock){
                this.compress_(bytes, n);
                n += this.blockSize;
            }
            if (typeof bytes === "string") while(n < length){
                buf[inbuf] = bytes.charCodeAt(n);
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
            else while(n < length){
                buf[inbuf] = bytes[n];
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
        }
        this.inbuf_ = inbuf;
        this.total_ += length;
    }
    /** @override */ digest() {
        const digest = [];
        let totalBits = this.total_ * 8;
        // Add pad 0x80 0x00*.
        if (this.inbuf_ < 56) this.update(this.pad_, 56 - this.inbuf_);
        else this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
        // Add # bits.
        for(let i = this.blockSize - 1; i >= 56; i--){
            this.buf_[i] = totalBits & 255;
            totalBits /= 256; // Don't use bit-shifting here!
        }
        this.compress_(this.buf_);
        let n = 0;
        for(let i = 0; i < 5; i++)for(let j = 24; j >= 0; j -= 8){
            digest[n] = this.chain_[i] >> j & 255;
            ++n;
        }
        return digest;
    }
}
/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */ function $e601d7027d812060$export$364097d812234b3f(executor, onNoObservers) {
    const proxy = new $e601d7027d812060$var$ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */ class $e601d7027d812060$var$ObserverProxy {
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */ constructor(executor, onNoObservers){
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task.then(()=>{
            executor(this);
        }).catch((e)=>{
            this.error(e);
        });
    }
    next(value) {
        this.forEachObserver((observer)=>{
            observer.next(value);
        });
    }
    error(error) {
        this.forEachObserver((observer)=>{
            observer.error(error);
        });
        this.close(error);
    }
    complete() {
        this.forEachObserver((observer)=>{
            observer.complete();
        });
        this.close();
    }
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber sychronously to their
     *   call to subscribe().
     */ subscribe(nextOrObserver, error, complete) {
        let observer;
        if (nextOrObserver === undefined && error === undefined && complete === undefined) throw new Error("Missing Observer.");
        // Assemble an Observer object when passed as callback functions.
        if ($e601d7027d812060$var$implementsAnyMethods(nextOrObserver, [
            "next",
            "error",
            "complete"
        ])) observer = nextOrObserver;
        else observer = {
            next: nextOrObserver,
            error: error,
            complete: complete
        };
        if (observer.next === undefined) observer.next = $e601d7027d812060$var$noop;
        if (observer.error === undefined) observer.error = $e601d7027d812060$var$noop;
        if (observer.complete === undefined) observer.complete = $e601d7027d812060$var$noop;
        const unsub = this.unsubscribeOne.bind(this, this.observers.length);
        // Attempt to subscribe to a terminated Observable - we
        // just respond to the Observer with the final error or complete
        // event.
        if (this.finalized) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            try {
                if (this.finalError) observer.error(this.finalError);
                else observer.complete();
            } catch (e) {
            // nothing
            }
            return;
        });
        this.observers.push(observer);
        return unsub;
    }
    // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.
    unsubscribeOne(i) {
        if (this.observers === undefined || this.observers[i] === undefined) return;
        delete this.observers[i];
        this.observerCount -= 1;
        if (this.observerCount === 0 && this.onNoObservers !== undefined) this.onNoObservers(this);
    }
    forEachObserver(fn) {
        if (this.finalized) // Already closed by previous event....just eat the additional values.
        return;
        // Since sendOne calls asynchronously - there is no chance that
        // this.observers will become undefined.
        for(let i = 0; i < this.observers.length; i++)this.sendOne(i, fn);
    }
    // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.
    sendOne(i, fn) {
        // Execute the callback asynchronously
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            if (this.observers !== undefined && this.observers[i] !== undefined) try {
                fn(this.observers[i]);
            } catch (e) {
                // Ignore exceptions raised in Observers or missing methods of an
                // Observer.
                // Log error to console. b/31404806
                if (typeof console !== "undefined" && console.error) console.error(e);
            }
        });
    }
    close(err) {
        if (this.finalized) return;
        this.finalized = true;
        if (err !== undefined) this.finalError = err;
        // Proxy is no longer needed - garbage collect references
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            this.observers = undefined;
            this.onNoObservers = undefined;
        });
    }
}
/** Turn synchronous function into one called asynchronously. */ // eslint-disable-next-line @typescript-eslint/ban-types
function $e601d7027d812060$export$12af436354f1a4f7(fn, onError) {
    return (...args)=>{
        Promise.resolve(true).then(()=>{
            fn(...args);
        }).catch((error)=>{
            if (onError) onError(error);
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */ function $e601d7027d812060$var$implementsAnyMethods(obj, methods) {
    if (typeof obj !== "object" || obj === null) return false;
    for (const method of methods){
        if (method in obj && typeof obj[method] === "function") return true;
    }
    return false;
}
function $e601d7027d812060$var$noop() {
// do nothing
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param fnName The function name
 * @param minCount The minimum number of arguments to allow for the function call
 * @param maxCount The maximum number of argument to allow for the function call
 * @param argCount The actual number of arguments provided.
 */ const $e601d7027d812060$export$20164226a0ed35c3 = function(fnName, minCount, maxCount, argCount) {
    let argError;
    if (argCount < minCount) argError = "at least " + minCount;
    else if (argCount > maxCount) argError = maxCount === 0 ? "none" : "no more than " + maxCount;
    if (argError) {
        const error = fnName + " failed: Was called with " + argCount + (argCount === 1 ? " argument." : " arguments.") + " Expects " + argError + ".";
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param fnName The function name
 * @param argName The name of the argument
 * @return The prefix to add to the error thrown for validation.
 */ function $e601d7027d812060$export$adea4917e02d93dc(fnName, argName) {
    return `${fnName} failed: ${argName} argument `;
}
/**
 * @param fnName
 * @param argumentNumber
 * @param namespace
 * @param optional
 */ function $e601d7027d812060$export$8eef22622e725943(fnName, namespace, optional) {
    if (optional && !namespace) return;
    if (typeof namespace !== "string") //TODO: I should do more validation here. We only allow certain chars in namespaces.
    throw new Error($e601d7027d812060$export$adea4917e02d93dc(fnName, "namespace") + "must be a valid firebase namespace.");
}
function $e601d7027d812060$export$5bcd2a2eb6640dfa(fnName, argumentName, // eslint-disable-next-line @typescript-eslint/ban-types
callback, optional) {
    if (optional && !callback) return;
    if (typeof callback !== "function") throw new Error($e601d7027d812060$export$adea4917e02d93dc(fnName, argumentName) + "must be a valid function.");
}
function $e601d7027d812060$export$df77539402cfb523(fnName, argumentName, context, optional) {
    if (optional && !context) return;
    if (typeof context !== "object" || context === null) throw new Error($e601d7027d812060$export$adea4917e02d93dc(fnName, argumentName) + "must be a valid context object.");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in Javascript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */ const $e601d7027d812060$export$655666783217a925 = function(str) {
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            const high = c - 0xd800; // the high 10 bits.
            i++;
            $e601d7027d812060$export$a7a9523472993e97(i < str.length, "Surrogate pair missing trail surrogate.");
            const low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if (c < 65536) {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */ const $e601d7027d812060$export$9536dc0a75b20bf9 = function(str) {
    let p = 0;
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c < 128) p++;
        else if (c < 2048) p += 2;
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        } else p += 3;
    }
    return p;
};
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Copied from https://stackoverflow.com/a/2117523
 * Generates a new uuid.
 * @public
 */ const $e601d7027d812060$export$abe4376e1bf796d6 = function() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c)=>{
        const r = Math.random() * 16 | 0, v = c === "x" ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The amount of milliseconds to exponentially increase.
 */ const $e601d7027d812060$var$DEFAULT_INTERVAL_MILLIS = 1000;
/**
 * The factor to backoff by.
 * Should be a number greater than 1.
 */ const $e601d7027d812060$var$DEFAULT_BACKOFF_FACTOR = 2;
/**
 * The maximum milliseconds to increase to.
 *
 * <p>Visible for testing
 */ const $e601d7027d812060$export$bdf1213ffbdb096e = 14400000; // Four hours, like iOS and Android.
/**
 * The percentage of backoff time to randomize by.
 * See
 * http://go/safe-client-behavior#step-1-determine-the-appropriate-retry-interval-to-handle-spike-traffic
 * for context.
 *
 * <p>Visible for testing
 */ const $e601d7027d812060$export$3518ed2cfe61fa30 = 0.5;
/**
 * Based on the backoff method from
 * https://github.com/google/closure-library/blob/master/closure/goog/math/exponentialbackoff.js.
 * Extracted here so we don't need to pass metadata and a stateful ExponentialBackoff object around.
 */ function $e601d7027d812060$export$4d810c0ca64ed8e9(backoffCount, intervalMillis = $e601d7027d812060$var$DEFAULT_INTERVAL_MILLIS, backoffFactor = $e601d7027d812060$var$DEFAULT_BACKOFF_FACTOR) {
    // Calculates an exponentially increasing value.
    // Deviation: calculates value from count and a constant interval, so we only need to save value
    // and count to restore state.
    const currBaseValue = intervalMillis * Math.pow(backoffFactor, backoffCount);
    // A random "fuzz" to avoid waves of retries.
    // Deviation: randomFactor is required.
    const randomWait = Math.round(// A fraction of the backoff value to add/subtract.
    // Deviation: changes multiplication order to improve readability.
    $e601d7027d812060$export$3518ed2cfe61fa30 * currBaseValue * // A random float (rounded to int by Math.round above) in the range [-1, 1]. Determines
    // if we add or subtract.
    (Math.random() - 0.5) * 2);
    // Limits backoff to max to avoid effectively permanent backoff.
    return Math.min($e601d7027d812060$export$bdf1213ffbdb096e, currBaseValue + randomWait);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provide English ordinal letters after a number
 */ function $e601d7027d812060$export$7bb39f879164e4ac(i) {
    if (!Number.isFinite(i)) return `${i}`;
    return i + $e601d7027d812060$var$indicator(i);
}
function $e601d7027d812060$var$indicator(i) {
    i = Math.abs(i);
    const cent = i % 100;
    if (cent >= 10 && cent <= 20) return "th";
    const dec = i % 10;
    if (dec === 1) return "st";
    if (dec === 2) return "nd";
    if (dec === 3) return "rd";
    return "th";
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $e601d7027d812060$export$4befe9b5fa509a1b(service) {
    if (service && service._delegate) return service._delegate;
    else return service;
}


/**
 * Component for service name T, e.g. `auth`, `auth-internal`
 */ class $6158f8502f3b9916$export$16fa2f45be04daa8 {
    /**
     *
     * @param name The public service name, e.g. app, auth, firestore, database
     * @param instanceFactory Service factory responsible for creating the public interface
     * @param type whether the service provided by the component is public or private
     */ constructor(name, instanceFactory, type){
        this.name = name;
        this.instanceFactory = instanceFactory;
        this.type = type;
        this.multipleInstances = false;
        /**
         * Properties to be added to the service namespace
         */ this.serviceProps = {};
        this.instantiationMode = "LAZY" /* InstantiationMode.LAZY */ ;
        this.onInstanceCreated = null;
    }
    setInstantiationMode(mode) {
        this.instantiationMode = mode;
        return this;
    }
    setMultipleInstances(multipleInstances) {
        this.multipleInstances = multipleInstances;
        return this;
    }
    setServiceProps(props) {
        this.serviceProps = props;
        return this;
    }
    setInstanceCreatedCallback(callback) {
        this.onInstanceCreated = callback;
        return this;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $6158f8502f3b9916$var$DEFAULT_ENTRY_NAME = "[DEFAULT]";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for instance for service name T, e.g. 'auth', 'auth-internal'
 * NameServiceMapping[T] is an alias for the type of the instance
 */ class $6158f8502f3b9916$export$2881499e37b75b9a {
    constructor(name, container){
        this.name = name;
        this.container = container;
        this.component = null;
        this.instances = new Map();
        this.instancesDeferred = new Map();
        this.instancesOptions = new Map();
        this.onInitCallbacks = new Map();
    }
    /**
     * @param identifier A provider can provide mulitple instances of a service
     * if this.component.multipleInstances is true.
     */ get(identifier) {
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        if (!this.instancesDeferred.has(normalizedIdentifier)) {
            const deferred = new (0, $e601d7027d812060$export$85f6557964517f1a)();
            this.instancesDeferred.set(normalizedIdentifier, deferred);
            if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) // initialize the service if it can be auto-initialized
            try {
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                if (instance) deferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception during get(), it should not cause
            // a fatal error. We just return the unresolved promise in this case.
            }
        }
        return this.instancesDeferred.get(normalizedIdentifier).promise;
    }
    getImmediate(options) {
        var _a;
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(options === null || options === void 0 ? void 0 : options.identifier);
        const optional = (_a = options === null || options === void 0 ? void 0 : options.optional) !== null && _a !== void 0 ? _a : false;
        if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) try {
            return this.getOrInitializeService({
                instanceIdentifier: normalizedIdentifier
            });
        } catch (e) {
            if (optional) return null;
            else throw e;
        }
        else {
            // In case a component is not initialized and should/can not be auto-initialized at the moment, return null if the optional flag is set, or throw
            if (optional) return null;
            else throw Error(`Service ${this.name} is not available`);
        }
    }
    getComponent() {
        return this.component;
    }
    setComponent(component) {
        if (component.name !== this.name) throw Error(`Mismatching Component ${component.name} for Provider ${this.name}.`);
        if (this.component) throw Error(`Component for ${this.name} has already been provided`);
        this.component = component;
        // return early without attempting to initialize the component if the component requires explicit initialization (calling `Provider.initialize()`)
        if (!this.shouldAutoInitialize()) return;
        // if the service is eager, initialize the default instance
        if ($6158f8502f3b9916$var$isComponentEager(component)) try {
            this.getOrInitializeService({
                instanceIdentifier: $6158f8502f3b9916$var$DEFAULT_ENTRY_NAME
            });
        } catch (e) {
        // when the instance factory for an eager Component throws an exception during the eager
        // initialization, it should not cause a fatal error.
        // TODO: Investigate if we need to make it configurable, because some component may want to cause
        // a fatal error in this case?
        }
        // Create service instances for the pending promises and resolve them
        // NOTE: if this.multipleInstances is false, only the default instance will be created
        // and all promises with resolve with it regardless of the identifier.
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            try {
                // `getOrInitializeService()` should always return a valid instance since a component is guaranteed. use ! to make typescript happy.
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                instanceDeferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception, it should not cause
            // a fatal error. We just leave the promise unresolved.
            }
        }
    }
    clearInstance(identifier = $6158f8502f3b9916$var$DEFAULT_ENTRY_NAME) {
        this.instancesDeferred.delete(identifier);
        this.instancesOptions.delete(identifier);
        this.instances.delete(identifier);
    }
    // app.delete() will call this method on every provider to delete the services
    // TODO: should we mark the provider as deleted?
    async delete() {
        const services = Array.from(this.instances.values());
        await Promise.all([
            ...services.filter((service)=>"INTERNAL" in service) // legacy services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service.INTERNAL.delete()),
            ...services.filter((service)=>"_delete" in service) // modularized services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service._delete())
        ]);
    }
    isComponentSet() {
        return this.component != null;
    }
    isInitialized(identifier = $6158f8502f3b9916$var$DEFAULT_ENTRY_NAME) {
        return this.instances.has(identifier);
    }
    getOptions(identifier = $6158f8502f3b9916$var$DEFAULT_ENTRY_NAME) {
        return this.instancesOptions.get(identifier) || {};
    }
    initialize(opts = {}) {
        const { options: options = {} } = opts;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(opts.instanceIdentifier);
        if (this.isInitialized(normalizedIdentifier)) throw Error(`${this.name}(${normalizedIdentifier}) has already been initialized`);
        if (!this.isComponentSet()) throw Error(`Component ${this.name} has not been registered yet`);
        const instance = this.getOrInitializeService({
            instanceIdentifier: normalizedIdentifier,
            options: options
        });
        // resolve any pending promise waiting for the service instance
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedDeferredIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            if (normalizedIdentifier === normalizedDeferredIdentifier) instanceDeferred.resolve(instance);
        }
        return instance;
    }
    /**
     *
     * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
     * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
     *
     * @param identifier An optional instance identifier
     * @returns a function to unregister the callback
     */ onInit(callback, identifier) {
        var _a;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        const existingCallbacks = (_a = this.onInitCallbacks.get(normalizedIdentifier)) !== null && _a !== void 0 ? _a : new Set();
        existingCallbacks.add(callback);
        this.onInitCallbacks.set(normalizedIdentifier, existingCallbacks);
        const existingInstance = this.instances.get(normalizedIdentifier);
        if (existingInstance) callback(existingInstance, normalizedIdentifier);
        return ()=>{
            existingCallbacks.delete(callback);
        };
    }
    /**
     * Invoke onInit callbacks synchronously
     * @param instance the service instance`
     */ invokeOnInitCallbacks(instance, identifier) {
        const callbacks = this.onInitCallbacks.get(identifier);
        if (!callbacks) return;
        for (const callback of callbacks)try {
            callback(instance, identifier);
        } catch (_a) {
        // ignore errors in the onInit callback
        }
    }
    getOrInitializeService({ instanceIdentifier: instanceIdentifier, options: options = {} }) {
        let instance = this.instances.get(instanceIdentifier);
        if (!instance && this.component) {
            instance = this.component.instanceFactory(this.container, {
                instanceIdentifier: $6158f8502f3b9916$var$normalizeIdentifierForFactory(instanceIdentifier),
                options: options
            });
            this.instances.set(instanceIdentifier, instance);
            this.instancesOptions.set(instanceIdentifier, options);
            /**
             * Invoke onInit listeners.
             * Note this.component.onInstanceCreated is different, which is used by the component creator,
             * while onInit listeners are registered by consumers of the provider.
             */ this.invokeOnInitCallbacks(instance, instanceIdentifier);
            /**
             * Order is important
             * onInstanceCreated() should be called after this.instances.set(instanceIdentifier, instance); which
             * makes `isInitialized()` return true.
             */ if (this.component.onInstanceCreated) try {
                this.component.onInstanceCreated(this.container, instanceIdentifier, instance);
            } catch (_a) {
            // ignore errors in the onInstanceCreatedCallback
            }
        }
        return instance || null;
    }
    normalizeInstanceIdentifier(identifier = $6158f8502f3b9916$var$DEFAULT_ENTRY_NAME) {
        if (this.component) return this.component.multipleInstances ? identifier : $6158f8502f3b9916$var$DEFAULT_ENTRY_NAME;
        else return identifier; // assume multiple instances are supported before the component is provided.
    }
    shouldAutoInitialize() {
        return !!this.component && this.component.instantiationMode !== "EXPLICIT" /* InstantiationMode.EXPLICIT */ ;
    }
}
// undefined should be passed to the service factory for the default instance
function $6158f8502f3b9916$var$normalizeIdentifierForFactory(identifier) {
    return identifier === $6158f8502f3b9916$var$DEFAULT_ENTRY_NAME ? undefined : identifier;
}
function $6158f8502f3b9916$var$isComponentEager(component) {
    return component.instantiationMode === "EAGER" /* InstantiationMode.EAGER */ ;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * ComponentContainer that provides Providers for service name T, e.g. `auth`, `auth-internal`
 */ class $6158f8502f3b9916$export$436a80eea5d5c0c5 {
    constructor(name){
        this.name = name;
        this.providers = new Map();
    }
    /**
     *
     * @param component Component being added
     * @param overwrite When a component with the same name has already been registered,
     * if overwrite is true: overwrite the existing component with the new component and create a new
     * provider with the new component. It can be useful in tests where you want to use different mocks
     * for different tests.
     * if overwrite is false: throw an exception
     */ addComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) throw new Error(`Component ${component.name} has already been registered with ${this.name}`);
        provider.setComponent(component);
    }
    addOrOverwriteComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) // delete the existing provider from the container, so we can register the new component
        this.providers.delete(component.name);
        this.addComponent(component);
    }
    /**
     * getProvider provides a type safe interface where it can only be called with a field name
     * present in NameServiceMapping interface.
     *
     * Firebase SDKs providing services should extend NameServiceMapping interface to register
     * themselves.
     */ getProvider(name) {
        if (this.providers.has(name)) return this.providers.get(name);
        // create a Provider for a service that hasn't registered with Firebase
        const provider = new $6158f8502f3b9916$export$2881499e37b75b9a(name, this);
        this.providers.set(name, provider);
        return provider;
    }
    getProviders() {
        return Array.from(this.providers.values());
    }
}


/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A container for all of the Logger instances
 */ const $83d5152e0bc68e53$var$instances = [];
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */ var $83d5152e0bc68e53$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})($83d5152e0bc68e53$export$243e62d78d3b544d || ($83d5152e0bc68e53$export$243e62d78d3b544d = {}));
const $83d5152e0bc68e53$var$levelStringToEnum = {
    "debug": $83d5152e0bc68e53$export$243e62d78d3b544d.DEBUG,
    "verbose": $83d5152e0bc68e53$export$243e62d78d3b544d.VERBOSE,
    "info": $83d5152e0bc68e53$export$243e62d78d3b544d.INFO,
    "warn": $83d5152e0bc68e53$export$243e62d78d3b544d.WARN,
    "error": $83d5152e0bc68e53$export$243e62d78d3b544d.ERROR,
    "silent": $83d5152e0bc68e53$export$243e62d78d3b544d.SILENT
};
/**
 * The default log level
 */ const $83d5152e0bc68e53$var$defaultLogLevel = $83d5152e0bc68e53$export$243e62d78d3b544d.INFO;
/**
 * By default, `console.debug` is not displayed in the developer console (in
 * chrome). To avoid forcing users to have to opt-in to these logs twice
 * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
 * logs to the `console.log` function.
 */ const $83d5152e0bc68e53$var$ConsoleMethod = {
    [$83d5152e0bc68e53$export$243e62d78d3b544d.DEBUG]: "log",
    [$83d5152e0bc68e53$export$243e62d78d3b544d.VERBOSE]: "log",
    [$83d5152e0bc68e53$export$243e62d78d3b544d.INFO]: "info",
    [$83d5152e0bc68e53$export$243e62d78d3b544d.WARN]: "warn",
    [$83d5152e0bc68e53$export$243e62d78d3b544d.ERROR]: "error"
};
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */ const $83d5152e0bc68e53$var$defaultLogHandler = (instance, logType, ...args)=>{
    if (logType < instance.logLevel) return;
    const now = new Date().toISOString();
    const method = $83d5152e0bc68e53$var$ConsoleMethod[logType];
    if (method) console[method](`[${now}]  ${instance.name}:`, ...args);
    else throw new Error(`Attempted to log a message with an invalid logType (value: ${logType})`);
};
class $83d5152e0bc68e53$export$efa9a398d6368992 {
    /**
     * Gives you an instance of a Logger to capture messages according to
     * Firebase's logging scheme.
     *
     * @param name The name that the logs will be associated with
     */ constructor(name){
        this.name = name;
        /**
         * The log level of the given Logger instance.
         */ this._logLevel = $83d5152e0bc68e53$var$defaultLogLevel;
        /**
         * The main (internal) log handler for the Logger instance.
         * Can be set to a new function in internal package code but not by user.
         */ this._logHandler = $83d5152e0bc68e53$var$defaultLogHandler;
        /**
         * The optional, additional, user-defined log handler for the Logger instance.
         */ this._userLogHandler = null;
        /**
         * Capture the current instance for later use
         */ $83d5152e0bc68e53$var$instances.push(this);
    }
    get logLevel() {
        return this._logLevel;
    }
    set logLevel(val) {
        if (!(val in $83d5152e0bc68e53$export$243e62d78d3b544d)) throw new TypeError(`Invalid value "${val}" assigned to \`logLevel\``);
        this._logLevel = val;
    }
    // Workaround for setter/getter having to be the same type.
    setLogLevel(val) {
        this._logLevel = typeof val === "string" ? $83d5152e0bc68e53$var$levelStringToEnum[val] : val;
    }
    get logHandler() {
        return this._logHandler;
    }
    set logHandler(val) {
        if (typeof val !== "function") throw new TypeError("Value assigned to `logHandler` must be a function");
        this._logHandler = val;
    }
    get userLogHandler() {
        return this._userLogHandler;
    }
    set userLogHandler(val) {
        this._userLogHandler = val;
    }
    /**
     * The functions below are all based on the `console` interface
     */ debug(...args) {
        this._userLogHandler && this._userLogHandler(this, $83d5152e0bc68e53$export$243e62d78d3b544d.DEBUG, ...args);
        this._logHandler(this, $83d5152e0bc68e53$export$243e62d78d3b544d.DEBUG, ...args);
    }
    log(...args) {
        this._userLogHandler && this._userLogHandler(this, $83d5152e0bc68e53$export$243e62d78d3b544d.VERBOSE, ...args);
        this._logHandler(this, $83d5152e0bc68e53$export$243e62d78d3b544d.VERBOSE, ...args);
    }
    info(...args) {
        this._userLogHandler && this._userLogHandler(this, $83d5152e0bc68e53$export$243e62d78d3b544d.INFO, ...args);
        this._logHandler(this, $83d5152e0bc68e53$export$243e62d78d3b544d.INFO, ...args);
    }
    warn(...args) {
        this._userLogHandler && this._userLogHandler(this, $83d5152e0bc68e53$export$243e62d78d3b544d.WARN, ...args);
        this._logHandler(this, $83d5152e0bc68e53$export$243e62d78d3b544d.WARN, ...args);
    }
    error(...args) {
        this._userLogHandler && this._userLogHandler(this, $83d5152e0bc68e53$export$243e62d78d3b544d.ERROR, ...args);
        this._logHandler(this, $83d5152e0bc68e53$export$243e62d78d3b544d.ERROR, ...args);
    }
}
function $83d5152e0bc68e53$export$c622e99c0ce7b1c9(level) {
    $83d5152e0bc68e53$var$instances.forEach((inst)=>{
        inst.setLogLevel(level);
    });
}
function $83d5152e0bc68e53$export$29577d29c84db5f6(logCallback, options) {
    for (const instance of $83d5152e0bc68e53$var$instances){
        let customLogLevel = null;
        if (options && options.level) customLogLevel = $83d5152e0bc68e53$var$levelStringToEnum[options.level];
        if (logCallback === null) instance.userLogHandler = null;
        else instance.userLogHandler = (instance, level, ...args)=>{
            const message = args.map((arg)=>{
                if (arg == null) return null;
                else if (typeof arg === "string") return arg;
                else if (typeof arg === "number" || typeof arg === "boolean") return arg.toString();
                else if (arg instanceof Error) return arg.message;
                else try {
                    return JSON.stringify(arg);
                } catch (ignored) {
                    return null;
                }
            }).filter((arg)=>arg).join(" ");
            if (level >= (customLogLevel !== null && customLogLevel !== void 0 ? customLogLevel : instance.logLevel)) logCallback({
                level: $83d5152e0bc68e53$export$243e62d78d3b544d[level].toLowerCase(),
                message: message,
                args: args,
                type: instance.name
            });
        };
    }
}



const $c209e3720e1f6f91$export$23f2a1d2818174ef = (object, constructors)=>constructors.some((c)=>object instanceof c);
let $c209e3720e1f6f91$var$idbProxyableTypes;
let $c209e3720e1f6f91$var$cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function $c209e3720e1f6f91$var$getIdbProxyableTypes() {
    return $c209e3720e1f6f91$var$idbProxyableTypes || ($c209e3720e1f6f91$var$idbProxyableTypes = [
        IDBDatabase,
        IDBObjectStore,
        IDBIndex,
        IDBCursor,
        IDBTransaction
    ]);
}
// This is a function to prevent it throwing up in node environments.
function $c209e3720e1f6f91$var$getCursorAdvanceMethods() {
    return $c209e3720e1f6f91$var$cursorAdvanceMethods || ($c209e3720e1f6f91$var$cursorAdvanceMethods = [
        IDBCursor.prototype.advance,
        IDBCursor.prototype.continue,
        IDBCursor.prototype.continuePrimaryKey
    ]);
}
const $c209e3720e1f6f91$var$cursorRequestMap = new WeakMap();
const $c209e3720e1f6f91$var$transactionDoneMap = new WeakMap();
const $c209e3720e1f6f91$var$transactionStoreNamesMap = new WeakMap();
const $c209e3720e1f6f91$var$transformCache = new WeakMap();
const $c209e3720e1f6f91$export$407448d2b89b1813 = new WeakMap();
function $c209e3720e1f6f91$var$promisifyRequest(request) {
    const promise = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            request.removeEventListener("success", success);
            request.removeEventListener("error", error);
        };
        const success = ()=>{
            resolve($c209e3720e1f6f91$export$efccba1c4a2ef57b(request.result));
            unlisten();
        };
        const error = ()=>{
            reject(request.error);
            unlisten();
        };
        request.addEventListener("success", success);
        request.addEventListener("error", error);
    });
    promise.then((value)=>{
        // Since cursoring reuses the IDBRequest (*sigh*), we cache it for later retrieval
        // (see wrapFunction).
        if (value instanceof IDBCursor) $c209e3720e1f6f91$var$cursorRequestMap.set(value, request);
    // Catching to avoid "Uncaught Promise exceptions"
    }).catch(()=>{});
    // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    $c209e3720e1f6f91$export$407448d2b89b1813.set(promise, request);
    return promise;
}
function $c209e3720e1f6f91$var$cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if ($c209e3720e1f6f91$var$transactionDoneMap.has(tx)) return;
    const done = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            tx.removeEventListener("complete", complete);
            tx.removeEventListener("error", error);
            tx.removeEventListener("abort", error);
        };
        const complete = ()=>{
            resolve();
            unlisten();
        };
        const error = ()=>{
            reject(tx.error || new DOMException("AbortError", "AbortError"));
            unlisten();
        };
        tx.addEventListener("complete", complete);
        tx.addEventListener("error", error);
        tx.addEventListener("abort", error);
    });
    // Cache it for later retrieval.
    $c209e3720e1f6f91$var$transactionDoneMap.set(tx, done);
}
let $c209e3720e1f6f91$var$idbProxyTraps = {
    get (target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === "done") return $c209e3720e1f6f91$var$transactionDoneMap.get(target);
            // Polyfill for objectStoreNames because of Edge.
            if (prop === "objectStoreNames") return target.objectStoreNames || $c209e3720e1f6f91$var$transactionStoreNamesMap.get(target);
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === "store") return receiver.objectStoreNames[1] ? undefined : receiver.objectStore(receiver.objectStoreNames[0]);
        }
        // Else transform whatever we get back.
        return $c209e3720e1f6f91$export$efccba1c4a2ef57b(target[prop]);
    },
    set (target, prop, value) {
        target[prop] = value;
        return true;
    },
    has (target, prop) {
        if (target instanceof IDBTransaction && (prop === "done" || prop === "store")) return true;
        return prop in target;
    }
};
function $c209e3720e1f6f91$export$43caf9889c228507(callback) {
    $c209e3720e1f6f91$var$idbProxyTraps = callback($c209e3720e1f6f91$var$idbProxyTraps);
}
function $c209e3720e1f6f91$var$wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Edge doesn't support objectStoreNames (booo), so we polyfill it here.
    if (func === IDBDatabase.prototype.transaction && !("objectStoreNames" in IDBTransaction.prototype)) return function(storeNames, ...args) {
        const tx = func.call($c209e3720e1f6f91$export$3b14a55fb2447963(this), storeNames, ...args);
        $c209e3720e1f6f91$var$transactionStoreNamesMap.set(tx, storeNames.sort ? storeNames.sort() : [
            storeNames
        ]);
        return $c209e3720e1f6f91$export$efccba1c4a2ef57b(tx);
    };
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if ($c209e3720e1f6f91$var$getCursorAdvanceMethods().includes(func)) return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        func.apply($c209e3720e1f6f91$export$3b14a55fb2447963(this), args);
        return $c209e3720e1f6f91$export$efccba1c4a2ef57b($c209e3720e1f6f91$var$cursorRequestMap.get(this));
    };
    return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return $c209e3720e1f6f91$export$efccba1c4a2ef57b(func.apply($c209e3720e1f6f91$export$3b14a55fb2447963(this), args));
    };
}
function $c209e3720e1f6f91$var$transformCachableValue(value) {
    if (typeof value === "function") return $c209e3720e1f6f91$var$wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction) $c209e3720e1f6f91$var$cacheDonePromiseForTransaction(value);
    if ($c209e3720e1f6f91$export$23f2a1d2818174ef(value, $c209e3720e1f6f91$var$getIdbProxyableTypes())) return new Proxy(value, $c209e3720e1f6f91$var$idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function $c209e3720e1f6f91$export$efccba1c4a2ef57b(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest) return $c209e3720e1f6f91$var$promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if ($c209e3720e1f6f91$var$transformCache.has(value)) return $c209e3720e1f6f91$var$transformCache.get(value);
    const newValue = $c209e3720e1f6f91$var$transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        $c209e3720e1f6f91$var$transformCache.set(value, newValue);
        $c209e3720e1f6f91$export$407448d2b89b1813.set(newValue, value);
    }
    return newValue;
}
const $c209e3720e1f6f91$export$3b14a55fb2447963 = (value)=>$c209e3720e1f6f91$export$407448d2b89b1813.get(value);


/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */ function $b6239eac33e6d6a7$export$ca0ed41b1a2af7e(name, version, { blocked: blocked, upgrade: upgrade, blocking: blocking, terminated: terminated } = {}) {
    const request = indexedDB.open(name, version);
    const openPromise = (0, $c209e3720e1f6f91$export$efccba1c4a2ef57b)(request);
    if (upgrade) request.addEventListener("upgradeneeded", (event)=>{
        upgrade((0, $c209e3720e1f6f91$export$efccba1c4a2ef57b)(request.result), event.oldVersion, event.newVersion, (0, $c209e3720e1f6f91$export$efccba1c4a2ef57b)(request.transaction), event);
    });
    if (blocked) request.addEventListener("blocked", (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event.newVersion, event));
    openPromise.then((db)=>{
        if (terminated) db.addEventListener("close", ()=>terminated());
        if (blocking) db.addEventListener("versionchange", (event)=>blocking(event.oldVersion, event.newVersion, event));
    }).catch(()=>{});
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */ function $b6239eac33e6d6a7$export$9d6df0ac66a98bb2(name, { blocked: blocked } = {}) {
    const request = indexedDB.deleteDatabase(name);
    if (blocked) request.addEventListener("blocked", (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event));
    return (0, $c209e3720e1f6f91$export$efccba1c4a2ef57b)(request).then(()=>undefined);
}
const $b6239eac33e6d6a7$var$readMethods = [
    "get",
    "getKey",
    "getAll",
    "getAllKeys",
    "count"
];
const $b6239eac33e6d6a7$var$writeMethods = [
    "put",
    "add",
    "delete",
    "clear"
];
const $b6239eac33e6d6a7$var$cachedMethods = new Map();
function $b6239eac33e6d6a7$var$getMethod(target, prop) {
    if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === "string")) return;
    if ($b6239eac33e6d6a7$var$cachedMethods.get(prop)) return $b6239eac33e6d6a7$var$cachedMethods.get(prop);
    const targetFuncName = prop.replace(/FromIndex$/, "");
    const useIndex = prop !== targetFuncName;
    const isWrite = $b6239eac33e6d6a7$var$writeMethods.includes(targetFuncName);
    if (// Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || $b6239eac33e6d6a7$var$readMethods.includes(targetFuncName))) return;
    const method = async function(storeName, ...args) {
        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
        const tx = this.transaction(storeName, isWrite ? "readwrite" : "readonly");
        let target = tx.store;
        if (useIndex) target = target.index(args.shift());
        // Must reject if op rejects.
        // If it's a write operation, must reject if tx.done rejects.
        // Must reject with op rejection first.
        // Must resolve with op value.
        // Must handle both promises (no unhandled rejections)
        return (await Promise.all([
            target[targetFuncName](...args),
            isWrite && tx.done
        ]))[0];
    };
    $b6239eac33e6d6a7$var$cachedMethods.set(prop, method);
    return method;
}
(0, $c209e3720e1f6f91$export$43caf9889c228507)((oldTraps)=>({
        ...oldTraps,
        get: (target, prop, receiver)=>$b6239eac33e6d6a7$var$getMethod(target, prop) || oldTraps.get(target, prop, receiver),
        has: (target, prop)=>!!$b6239eac33e6d6a7$var$getMethod(target, prop) || oldTraps.has(target, prop)
    }));


/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $2406031bebeb53d7$var$PlatformLoggerServiceImpl {
    constructor(container){
        this.container = container;
    }
    // In initial implementation, this will be called by installations on
    // auth token refresh, and installations will send this string.
    getPlatformInfoString() {
        const providers = this.container.getProviders();
        // Loop through providers and get library/version pairs from any that are
        // version components.
        return providers.map((provider)=>{
            if ($2406031bebeb53d7$var$isVersionServiceProvider(provider)) {
                const service = provider.getImmediate();
                return `${service.library}/${service.version}`;
            } else return null;
        }).filter((logString)=>logString).join(" ");
    }
}
/**
 *
 * @param provider check if this provider provides a VersionService
 *
 * NOTE: Using Provider<'app-version'> is a hack to indicate that the provider
 * provides VersionService. The provider is not necessarily a 'app-version'
 * provider.
 */ function $2406031bebeb53d7$var$isVersionServiceProvider(provider) {
    const component = provider.getComponent();
    return (component === null || component === void 0 ? void 0 : component.type) === "VERSION" /* ComponentType.VERSION */ ;
}
const $2406031bebeb53d7$var$name$o = "@firebase/app";
const $2406031bebeb53d7$var$version$1 = "0.9.29";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $2406031bebeb53d7$var$logger = new (0, $83d5152e0bc68e53$export$efa9a398d6368992)("@firebase/app");
const $2406031bebeb53d7$var$name$n = "@firebase/app-compat";
const $2406031bebeb53d7$var$name$m = "@firebase/analytics-compat";
const $2406031bebeb53d7$var$name$l = "@firebase/analytics";
const $2406031bebeb53d7$var$name$k = "@firebase/app-check-compat";
const $2406031bebeb53d7$var$name$j = "@firebase/app-check";
const $2406031bebeb53d7$var$name$i = "@firebase/auth";
const $2406031bebeb53d7$var$name$h = "@firebase/auth-compat";
const $2406031bebeb53d7$var$name$g = "@firebase/database";
const $2406031bebeb53d7$var$name$f = "@firebase/database-compat";
const $2406031bebeb53d7$var$name$e = "@firebase/functions";
const $2406031bebeb53d7$var$name$d = "@firebase/functions-compat";
const $2406031bebeb53d7$var$name$c = "@firebase/installations";
const $2406031bebeb53d7$var$name$b = "@firebase/installations-compat";
const $2406031bebeb53d7$var$name$a = "@firebase/messaging";
const $2406031bebeb53d7$var$name$9 = "@firebase/messaging-compat";
const $2406031bebeb53d7$var$name$8 = "@firebase/performance";
const $2406031bebeb53d7$var$name$7 = "@firebase/performance-compat";
const $2406031bebeb53d7$var$name$6 = "@firebase/remote-config";
const $2406031bebeb53d7$var$name$5 = "@firebase/remote-config-compat";
const $2406031bebeb53d7$var$name$4 = "@firebase/storage";
const $2406031bebeb53d7$var$name$3 = "@firebase/storage-compat";
const $2406031bebeb53d7$var$name$2 = "@firebase/firestore";
const $2406031bebeb53d7$var$name$1 = "@firebase/firestore-compat";
const $2406031bebeb53d7$var$name = "firebase";
const $2406031bebeb53d7$var$version = "10.9.0";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The default app name
 *
 * @internal
 */ const $2406031bebeb53d7$export$9f30fa0c10967f7f = "[DEFAULT]";
const $2406031bebeb53d7$var$PLATFORM_LOG_STRING = {
    [$2406031bebeb53d7$var$name$o]: "fire-core",
    [$2406031bebeb53d7$var$name$n]: "fire-core-compat",
    [$2406031bebeb53d7$var$name$l]: "fire-analytics",
    [$2406031bebeb53d7$var$name$m]: "fire-analytics-compat",
    [$2406031bebeb53d7$var$name$j]: "fire-app-check",
    [$2406031bebeb53d7$var$name$k]: "fire-app-check-compat",
    [$2406031bebeb53d7$var$name$i]: "fire-auth",
    [$2406031bebeb53d7$var$name$h]: "fire-auth-compat",
    [$2406031bebeb53d7$var$name$g]: "fire-rtdb",
    [$2406031bebeb53d7$var$name$f]: "fire-rtdb-compat",
    [$2406031bebeb53d7$var$name$e]: "fire-fn",
    [$2406031bebeb53d7$var$name$d]: "fire-fn-compat",
    [$2406031bebeb53d7$var$name$c]: "fire-iid",
    [$2406031bebeb53d7$var$name$b]: "fire-iid-compat",
    [$2406031bebeb53d7$var$name$a]: "fire-fcm",
    [$2406031bebeb53d7$var$name$9]: "fire-fcm-compat",
    [$2406031bebeb53d7$var$name$8]: "fire-perf",
    [$2406031bebeb53d7$var$name$7]: "fire-perf-compat",
    [$2406031bebeb53d7$var$name$6]: "fire-rc",
    [$2406031bebeb53d7$var$name$5]: "fire-rc-compat",
    [$2406031bebeb53d7$var$name$4]: "fire-gcs",
    [$2406031bebeb53d7$var$name$3]: "fire-gcs-compat",
    [$2406031bebeb53d7$var$name$2]: "fire-fst",
    [$2406031bebeb53d7$var$name$1]: "fire-fst-compat",
    "fire-js": "fire-js",
    [$2406031bebeb53d7$var$name]: "fire-js-all"
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ const $2406031bebeb53d7$export$b4e3c36c855b14b5 = new Map();
/**
 * Registered components.
 *
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $2406031bebeb53d7$export$9566bce3835c0f28 = new Map();
/**
 * @param component - the component being added to this app's container
 *
 * @internal
 */ function $2406031bebeb53d7$export$fa5244b94c62d36a(app, component) {
    try {
        app.container.addComponent(component);
    } catch (e) {
        $2406031bebeb53d7$var$logger.debug(`Component ${component.name} failed to register with FirebaseApp ${app.name}`, e);
    }
}
/**
 *
 * @internal
 */ function $2406031bebeb53d7$export$4393112b42e2b41d(app, component) {
    app.container.addOrOverwriteComponent(component);
}
/**
 *
 * @param component - the component to register
 * @returns whether or not the component is registered successfully
 *
 * @internal
 */ function $2406031bebeb53d7$export$c930050e7bb63965(component) {
    const componentName = component.name;
    if ($2406031bebeb53d7$export$9566bce3835c0f28.has(componentName)) {
        $2406031bebeb53d7$var$logger.debug(`There were multiple attempts to register component ${componentName}.`);
        return false;
    }
    $2406031bebeb53d7$export$9566bce3835c0f28.set(componentName, component);
    // add the component to existing app instances
    for (const app of $2406031bebeb53d7$export$b4e3c36c855b14b5.values())$2406031bebeb53d7$export$fa5244b94c62d36a(app, component);
    return true;
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 *
 * @returns the provider for the service with the matching name
 *
 * @internal
 */ function $2406031bebeb53d7$export$fa0d6da0f5838f50(app, name) {
    const heartbeatController = app.container.getProvider("heartbeat").getImmediate({
        optional: true
    });
    if (heartbeatController) heartbeatController.triggerHeartbeat();
    return app.container.getProvider(name);
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 * @param instanceIdentifier - service instance identifier in case the service supports multiple instances
 *
 * @internal
 */ function $2406031bebeb53d7$export$48d18de2ff1c45a5(app, name, instanceIdentifier = $2406031bebeb53d7$export$9f30fa0c10967f7f) {
    $2406031bebeb53d7$export$fa0d6da0f5838f50(app, name).clearInstance(instanceIdentifier);
}
/**
 * Test only
 *
 * @internal
 */ function $2406031bebeb53d7$export$3685d89b9c3cdfaf() {
    $2406031bebeb53d7$export$9566bce3835c0f28.clear();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $2406031bebeb53d7$var$ERRORS = {
    ["no-app" /* AppError.NO_APP */ ]: "No Firebase App '{$appName}' has been created - call initializeApp() first",
    ["bad-app-name" /* AppError.BAD_APP_NAME */ ]: "Illegal App name: '{$appName}",
    ["duplicate-app" /* AppError.DUPLICATE_APP */ ]: "Firebase App named '{$appName}' already exists with different options or config",
    ["app-deleted" /* AppError.APP_DELETED */ ]: "Firebase App named '{$appName}' already deleted",
    ["no-options" /* AppError.NO_OPTIONS */ ]: "Need to provide options, when not being deployed to hosting via source.",
    ["invalid-app-argument" /* AppError.INVALID_APP_ARGUMENT */ ]: "firebase.{$appName}() takes either no argument or a Firebase App instance.",
    ["invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ ]: "First argument to `onLog` must be null or a function.",
    ["idb-open" /* AppError.IDB_OPEN */ ]: "Error thrown when opening IndexedDB. Original error: {$originalErrorMessage}.",
    ["idb-get" /* AppError.IDB_GET */ ]: "Error thrown when reading from IndexedDB. Original error: {$originalErrorMessage}.",
    ["idb-set" /* AppError.IDB_WRITE */ ]: "Error thrown when writing to IndexedDB. Original error: {$originalErrorMessage}.",
    ["idb-delete" /* AppError.IDB_DELETE */ ]: "Error thrown when deleting from IndexedDB. Original error: {$originalErrorMessage}."
};
const $2406031bebeb53d7$var$ERROR_FACTORY = new (0, $e601d7027d812060$export$3fa6e1b18a3b2d40)("app", "Firebase", $2406031bebeb53d7$var$ERRORS);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $2406031bebeb53d7$var$FirebaseAppImpl {
    constructor(options, config, container){
        this._isDeleted = false;
        this._options = Object.assign({}, options);
        this._config = Object.assign({}, config);
        this._name = config.name;
        this._automaticDataCollectionEnabled = config.automaticDataCollectionEnabled;
        this._container = container;
        this.container.addComponent(new (0, $6158f8502f3b9916$export$16fa2f45be04daa8)("app", ()=>this, "PUBLIC" /* ComponentType.PUBLIC */ ));
    }
    get automaticDataCollectionEnabled() {
        this.checkDestroyed();
        return this._automaticDataCollectionEnabled;
    }
    set automaticDataCollectionEnabled(val) {
        this.checkDestroyed();
        this._automaticDataCollectionEnabled = val;
    }
    get name() {
        this.checkDestroyed();
        return this._name;
    }
    get options() {
        this.checkDestroyed();
        return this._options;
    }
    get config() {
        this.checkDestroyed();
        return this._config;
    }
    get container() {
        return this._container;
    }
    get isDeleted() {
        return this._isDeleted;
    }
    set isDeleted(val) {
        this._isDeleted = val;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ checkDestroyed() {
        if (this.isDeleted) throw $2406031bebeb53d7$var$ERROR_FACTORY.create("app-deleted" /* AppError.APP_DELETED */ , {
            appName: this._name
        });
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The current SDK version.
 *
 * @public
 */ const $2406031bebeb53d7$export$31499a9cd224b78c = $2406031bebeb53d7$var$version;
function $2406031bebeb53d7$export$c55cfd413944906d(_options, rawConfig = {}) {
    let options = _options;
    if (typeof rawConfig !== "object") {
        const name = rawConfig;
        rawConfig = {
            name: name
        };
    }
    const config = Object.assign({
        name: $2406031bebeb53d7$export$9f30fa0c10967f7f,
        automaticDataCollectionEnabled: false
    }, rawConfig);
    const name = config.name;
    if (typeof name !== "string" || !name) throw $2406031bebeb53d7$var$ERROR_FACTORY.create("bad-app-name" /* AppError.BAD_APP_NAME */ , {
        appName: String(name)
    });
    options || (options = (0, $e601d7027d812060$export$3dfb6827a9f89756)());
    if (!options) throw $2406031bebeb53d7$var$ERROR_FACTORY.create("no-options" /* AppError.NO_OPTIONS */ );
    const existingApp = $2406031bebeb53d7$export$b4e3c36c855b14b5.get(name);
    if (existingApp) {
        // return the existing app if options and config deep equal the ones in the existing app.
        if ((0, $e601d7027d812060$export$9cb4719e2e525b7a)(options, existingApp.options) && (0, $e601d7027d812060$export$9cb4719e2e525b7a)(config, existingApp.config)) return existingApp;
        else throw $2406031bebeb53d7$var$ERROR_FACTORY.create("duplicate-app" /* AppError.DUPLICATE_APP */ , {
            appName: name
        });
    }
    const container = new (0, $6158f8502f3b9916$export$436a80eea5d5c0c5)(name);
    for (const component of $2406031bebeb53d7$export$9566bce3835c0f28.values())container.addComponent(component);
    const newApp = new $2406031bebeb53d7$var$FirebaseAppImpl(options, config, container);
    $2406031bebeb53d7$export$b4e3c36c855b14b5.set(name, newApp);
    return newApp;
}
/**
 * Retrieves a {@link @firebase/app#FirebaseApp} instance.
 *
 * When called with no arguments, the default app is returned. When an app name
 * is provided, the app corresponding to that name is returned.
 *
 * An exception is thrown if the app being retrieved has not yet been
 * initialized.
 *
 * @example
 * ```javascript
 * // Return the default app
 * const app = getApp();
 * ```
 *
 * @example
 * ```javascript
 * // Return a named app
 * const otherApp = getApp("otherApp");
 * ```
 *
 * @param name - Optional name of the app to return. If no name is
 *   provided, the default is `"[DEFAULT]"`.
 *
 * @returns The app corresponding to the provided app name.
 *   If no app name is provided, the default app is returned.
 *
 * @public
 */ function $2406031bebeb53d7$export$f9962582c9e66d99(name = $2406031bebeb53d7$export$9f30fa0c10967f7f) {
    const app = $2406031bebeb53d7$export$b4e3c36c855b14b5.get(name);
    if (!app && name === $2406031bebeb53d7$export$9f30fa0c10967f7f && (0, $e601d7027d812060$export$3dfb6827a9f89756)()) return $2406031bebeb53d7$export$c55cfd413944906d();
    if (!app) throw $2406031bebeb53d7$var$ERROR_FACTORY.create("no-app" /* AppError.NO_APP */ , {
        appName: name
    });
    return app;
}
/**
 * A (read-only) array of all initialized apps.
 * @public
 */ function $2406031bebeb53d7$export$68ddedf7d44b3bdf() {
    return Array.from($2406031bebeb53d7$export$b4e3c36c855b14b5.values());
}
/**
 * Renders this app unusable and frees the resources of all associated
 * services.
 *
 * @example
 * ```javascript
 * deleteApp(app)
 *   .then(function() {
 *     console.log("App deleted successfully");
 *   })
 *   .catch(function(error) {
 *     console.log("Error deleting app:", error);
 *   });
 * ```
 *
 * @public
 */ async function $2406031bebeb53d7$export$6eec44aa53d5ea34(app) {
    const name = app.name;
    if ($2406031bebeb53d7$export$b4e3c36c855b14b5.has(name)) {
        $2406031bebeb53d7$export$b4e3c36c855b14b5.delete(name);
        await Promise.all(app.container.getProviders().map((provider)=>provider.delete()));
        app.isDeleted = true;
    }
}
/**
 * Registers a library's name and version for platform logging purposes.
 * @param library - Name of 1p or 3p library (e.g. firestore, angularfire)
 * @param version - Current version of that library.
 * @param variant - Bundle variant, e.g., node, rn, etc.
 *
 * @public
 */ function $2406031bebeb53d7$export$d29d5299a7137abc(libraryKeyOrName, version, variant) {
    var _a;
    // TODO: We can use this check to whitelist strings when/if we set up
    // a good whitelist system.
    let library = (_a = $2406031bebeb53d7$var$PLATFORM_LOG_STRING[libraryKeyOrName]) !== null && _a !== void 0 ? _a : libraryKeyOrName;
    if (variant) library += `-${variant}`;
    const libraryMismatch = library.match(/\s|\//);
    const versionMismatch = version.match(/\s|\//);
    if (libraryMismatch || versionMismatch) {
        const warning = [
            `Unable to register library "${library}" with version "${version}":`
        ];
        if (libraryMismatch) warning.push(`library name "${library}" contains illegal characters (whitespace or "/")`);
        if (libraryMismatch && versionMismatch) warning.push("and");
        if (versionMismatch) warning.push(`version name "${version}" contains illegal characters (whitespace or "/")`);
        $2406031bebeb53d7$var$logger.warn(warning.join(" "));
        return;
    }
    $2406031bebeb53d7$export$c930050e7bb63965(new (0, $6158f8502f3b9916$export$16fa2f45be04daa8)(`${library}-version`, ()=>({
            library: library,
            version: version
        }), "VERSION" /* ComponentType.VERSION */ ));
}
/**
 * Sets log handler for all Firebase SDKs.
 * @param logCallback - An optional custom log handler that executes user code whenever
 * the Firebase SDK makes a logging call.
 *
 * @public
 */ function $2406031bebeb53d7$export$a82ad227dc8163dc(logCallback, options) {
    if (logCallback !== null && typeof logCallback !== "function") throw $2406031bebeb53d7$var$ERROR_FACTORY.create("invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ );
    (0, $83d5152e0bc68e53$export$29577d29c84db5f6)(logCallback, options);
}
/**
 * Sets log level for all Firebase SDKs.
 *
 * All of the log types above the current log level are captured (i.e. if
 * you set the log level to `info`, errors are logged, but `debug` and
 * `verbose` logs are not).
 *
 * @public
 */ function $2406031bebeb53d7$export$c622e99c0ce7b1c9(logLevel) {
    (0, $83d5152e0bc68e53$export$c622e99c0ce7b1c9)(logLevel);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $2406031bebeb53d7$var$DB_NAME = "firebase-heartbeat-database";
const $2406031bebeb53d7$var$DB_VERSION = 1;
const $2406031bebeb53d7$var$STORE_NAME = "firebase-heartbeat-store";
let $2406031bebeb53d7$var$dbPromise = null;
function $2406031bebeb53d7$var$getDbPromise() {
    if (!$2406031bebeb53d7$var$dbPromise) $2406031bebeb53d7$var$dbPromise = (0, $b6239eac33e6d6a7$export$ca0ed41b1a2af7e)($2406031bebeb53d7$var$DB_NAME, $2406031bebeb53d7$var$DB_VERSION, {
        upgrade: (db, oldVersion)=>{
            // We don't use 'break' in this switch statement, the fall-through
            // behavior is what we want, because if there are multiple versions between
            // the old version and the current version, we want ALL the migrations
            // that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch(oldVersion){
                case 0:
                    try {
                        db.createObjectStore($2406031bebeb53d7$var$STORE_NAME);
                    } catch (e) {
                        // Safari/iOS browsers throw occasional exceptions on
                        // db.createObjectStore() that may be a bug. Avoid blocking
                        // the rest of the app functionality.
                        console.warn(e);
                    }
            }
        }
    }).catch((e)=>{
        throw $2406031bebeb53d7$var$ERROR_FACTORY.create("idb-open" /* AppError.IDB_OPEN */ , {
            originalErrorMessage: e.message
        });
    });
    return $2406031bebeb53d7$var$dbPromise;
}
async function $2406031bebeb53d7$var$readHeartbeatsFromIndexedDB(app) {
    try {
        const db = await $2406031bebeb53d7$var$getDbPromise();
        const tx = db.transaction($2406031bebeb53d7$var$STORE_NAME);
        const result = await tx.objectStore($2406031bebeb53d7$var$STORE_NAME).get($2406031bebeb53d7$var$computeKey(app));
        // We already have the value but tx.done can throw,
        // so we need to await it here to catch errors
        await tx.done;
        return result;
    } catch (e) {
        if (e instanceof (0, $e601d7027d812060$export$dd24e9cd51226c56)) $2406031bebeb53d7$var$logger.warn(e.message);
        else {
            const idbGetError = $2406031bebeb53d7$var$ERROR_FACTORY.create("idb-get" /* AppError.IDB_GET */ , {
                originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
            });
            $2406031bebeb53d7$var$logger.warn(idbGetError.message);
        }
    }
}
async function $2406031bebeb53d7$var$writeHeartbeatsToIndexedDB(app, heartbeatObject) {
    try {
        const db = await $2406031bebeb53d7$var$getDbPromise();
        const tx = db.transaction($2406031bebeb53d7$var$STORE_NAME, "readwrite");
        const objectStore = tx.objectStore($2406031bebeb53d7$var$STORE_NAME);
        await objectStore.put(heartbeatObject, $2406031bebeb53d7$var$computeKey(app));
        await tx.done;
    } catch (e) {
        if (e instanceof (0, $e601d7027d812060$export$dd24e9cd51226c56)) $2406031bebeb53d7$var$logger.warn(e.message);
        else {
            const idbGetError = $2406031bebeb53d7$var$ERROR_FACTORY.create("idb-set" /* AppError.IDB_WRITE */ , {
                originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
            });
            $2406031bebeb53d7$var$logger.warn(idbGetError.message);
        }
    }
}
function $2406031bebeb53d7$var$computeKey(app) {
    return `${app.name}!${app.options.appId}`;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $2406031bebeb53d7$var$MAX_HEADER_BYTES = 1024;
// 30 days
const $2406031bebeb53d7$var$STORED_HEARTBEAT_RETENTION_MAX_MILLIS = 2592000000;
class $2406031bebeb53d7$var$HeartbeatServiceImpl {
    constructor(container){
        this.container = container;
        /**
         * In-memory cache for heartbeats, used by getHeartbeatsHeader() to generate
         * the header string.
         * Stores one record per date. This will be consolidated into the standard
         * format of one record per user agent string before being sent as a header.
         * Populated from indexedDB when the controller is instantiated and should
         * be kept in sync with indexedDB.
         * Leave public for easier testing.
         */ this._heartbeatsCache = null;
        const app = this.container.getProvider("app").getImmediate();
        this._storage = new $2406031bebeb53d7$var$HeartbeatStorageImpl(app);
        this._heartbeatsCachePromise = this._storage.read().then((result)=>{
            this._heartbeatsCache = result;
            return result;
        });
    }
    /**
     * Called to report a heartbeat. The function will generate
     * a HeartbeatsByUserAgent object, update heartbeatsCache, and persist it
     * to IndexedDB.
     * Note that we only store one heartbeat per day. So if a heartbeat for today is
     * already logged, subsequent calls to this function in the same day will be ignored.
     */ async triggerHeartbeat() {
        var _a, _b;
        const platformLogger = this.container.getProvider("platform-logger").getImmediate();
        // This is the "Firebase user agent" string from the platform logger
        // service, not the browser user agent.
        const agent = platformLogger.getPlatformInfoString();
        const date = $2406031bebeb53d7$var$getUTCDateString();
        if (((_a = this._heartbeatsCache) === null || _a === void 0 ? void 0 : _a.heartbeats) == null) {
            this._heartbeatsCache = await this._heartbeatsCachePromise;
            // If we failed to construct a heartbeats cache, then return immediately.
            if (((_b = this._heartbeatsCache) === null || _b === void 0 ? void 0 : _b.heartbeats) == null) return;
        }
        // Do not store a heartbeat if one is already stored for this day
        // or if a header has already been sent today.
        if (this._heartbeatsCache.lastSentHeartbeatDate === date || this._heartbeatsCache.heartbeats.some((singleDateHeartbeat)=>singleDateHeartbeat.date === date)) return;
        else // There is no entry for this date. Create one.
        this._heartbeatsCache.heartbeats.push({
            date: date,
            agent: agent
        });
        // Remove entries older than 30 days.
        this._heartbeatsCache.heartbeats = this._heartbeatsCache.heartbeats.filter((singleDateHeartbeat)=>{
            const hbTimestamp = new Date(singleDateHeartbeat.date).valueOf();
            const now = Date.now();
            return now - hbTimestamp <= $2406031bebeb53d7$var$STORED_HEARTBEAT_RETENTION_MAX_MILLIS;
        });
        return this._storage.overwrite(this._heartbeatsCache);
    }
    /**
     * Returns a base64 encoded string which can be attached to the heartbeat-specific header directly.
     * It also clears all heartbeats from memory as well as in IndexedDB.
     *
     * NOTE: Consuming product SDKs should not send the header if this method
     * returns an empty string.
     */ async getHeartbeatsHeader() {
        var _a;
        if (this._heartbeatsCache === null) await this._heartbeatsCachePromise;
        // If it's still null or the array is empty, there is no data to send.
        if (((_a = this._heartbeatsCache) === null || _a === void 0 ? void 0 : _a.heartbeats) == null || this._heartbeatsCache.heartbeats.length === 0) return "";
        const date = $2406031bebeb53d7$var$getUTCDateString();
        // Extract as many heartbeats from the cache as will fit under the size limit.
        const { heartbeatsToSend: heartbeatsToSend, unsentEntries: unsentEntries } = $2406031bebeb53d7$var$extractHeartbeatsForHeader(this._heartbeatsCache.heartbeats);
        const headerString = (0, $e601d7027d812060$export$4b5284a3025a455)(JSON.stringify({
            version: 2,
            heartbeats: heartbeatsToSend
        }));
        // Store last sent date to prevent another being logged/sent for the same day.
        this._heartbeatsCache.lastSentHeartbeatDate = date;
        if (unsentEntries.length > 0) {
            // Store any unsent entries if they exist.
            this._heartbeatsCache.heartbeats = unsentEntries;
            // This seems more likely than emptying the array (below) to lead to some odd state
            // since the cache isn't empty and this will be called again on the next request,
            // and is probably safest if we await it.
            await this._storage.overwrite(this._heartbeatsCache);
        } else {
            this._heartbeatsCache.heartbeats = [];
            // Do not wait for this, to reduce latency.
            this._storage.overwrite(this._heartbeatsCache);
        }
        return headerString;
    }
}
function $2406031bebeb53d7$var$getUTCDateString() {
    const today = new Date();
    // Returns date format 'YYYY-MM-DD'
    return today.toISOString().substring(0, 10);
}
function $2406031bebeb53d7$var$extractHeartbeatsForHeader(heartbeatsCache, maxSize = $2406031bebeb53d7$var$MAX_HEADER_BYTES) {
    // Heartbeats grouped by user agent in the standard format to be sent in
    // the header.
    const heartbeatsToSend = [];
    // Single date format heartbeats that are not sent.
    let unsentEntries = heartbeatsCache.slice();
    for (const singleDateHeartbeat of heartbeatsCache){
        // Look for an existing entry with the same user agent.
        const heartbeatEntry = heartbeatsToSend.find((hb)=>hb.agent === singleDateHeartbeat.agent);
        if (!heartbeatEntry) {
            // If no entry for this user agent exists, create one.
            heartbeatsToSend.push({
                agent: singleDateHeartbeat.agent,
                dates: [
                    singleDateHeartbeat.date
                ]
            });
            if ($2406031bebeb53d7$var$countBytes(heartbeatsToSend) > maxSize) {
                // If the header would exceed max size, remove the added heartbeat
                // entry and stop adding to the header.
                heartbeatsToSend.pop();
                break;
            }
        } else {
            heartbeatEntry.dates.push(singleDateHeartbeat.date);
            // If the header would exceed max size, remove the added date
            // and stop adding to the header.
            if ($2406031bebeb53d7$var$countBytes(heartbeatsToSend) > maxSize) {
                heartbeatEntry.dates.pop();
                break;
            }
        }
        // Pop unsent entry from queue. (Skipped if adding the entry exceeded
        // quota and the loop breaks early.)
        unsentEntries = unsentEntries.slice(1);
    }
    return {
        heartbeatsToSend: heartbeatsToSend,
        unsentEntries: unsentEntries
    };
}
class $2406031bebeb53d7$var$HeartbeatStorageImpl {
    constructor(app){
        this.app = app;
        this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck();
    }
    async runIndexedDBEnvironmentCheck() {
        if (!(0, $e601d7027d812060$export$3865db50535c2055)()) return false;
        else return (0, $e601d7027d812060$export$a8a3018f3d187a4d)().then(()=>true).catch(()=>false);
    }
    /**
     * Read all heartbeats.
     */ async read() {
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return {
            heartbeats: []
        };
        else {
            const idbHeartbeatObject = await $2406031bebeb53d7$var$readHeartbeatsFromIndexedDB(this.app);
            if (idbHeartbeatObject === null || idbHeartbeatObject === void 0 ? void 0 : idbHeartbeatObject.heartbeats) return idbHeartbeatObject;
            else return {
                heartbeats: []
            };
        }
    }
    // overwrite the storage with the provided heartbeats
    async overwrite(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return $2406031bebeb53d7$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: heartbeatsObject.heartbeats
            });
        }
    }
    // add heartbeats
    async add(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return $2406031bebeb53d7$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: [
                    ...existingHeartbeatsObject.heartbeats,
                    ...heartbeatsObject.heartbeats
                ]
            });
        }
    }
}
/**
 * Calculate bytes of a HeartbeatsByUserAgent array after being wrapped
 * in a platform logging header JSON object, stringified, and converted
 * to base 64.
 */ function $2406031bebeb53d7$var$countBytes(heartbeatsCache) {
    // base64 has a restricted set of characters, all of which should be 1 byte.
    return (0, $e601d7027d812060$export$4b5284a3025a455)(// heartbeatsCache wrapper properties
    JSON.stringify({
        version: 2,
        heartbeats: heartbeatsCache
    })).length;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $2406031bebeb53d7$var$registerCoreComponents(variant) {
    $2406031bebeb53d7$export$c930050e7bb63965(new (0, $6158f8502f3b9916$export$16fa2f45be04daa8)("platform-logger", (container)=>new $2406031bebeb53d7$var$PlatformLoggerServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    $2406031bebeb53d7$export$c930050e7bb63965(new (0, $6158f8502f3b9916$export$16fa2f45be04daa8)("heartbeat", (container)=>new $2406031bebeb53d7$var$HeartbeatServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    // Register `app` package.
    $2406031bebeb53d7$export$d29d5299a7137abc($2406031bebeb53d7$var$name$o, $2406031bebeb53d7$var$version$1, variant);
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    $2406031bebeb53d7$export$d29d5299a7137abc($2406031bebeb53d7$var$name$o, $2406031bebeb53d7$var$version$1, "esm2017");
    // Register platform SDK identifier (no version).
    $2406031bebeb53d7$export$d29d5299a7137abc("fire-js", "");
}
/**
 * Firebase App
 *
 * @remarks This package coordinates the communication between the different Firebase components
 * @packageDocumentation
 */ $2406031bebeb53d7$var$registerCoreComponents("");





const $e997c3be5cf5eb8e$var$name = "@firebase/installations";
const $e997c3be5cf5eb8e$var$version = "0.6.5";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $e997c3be5cf5eb8e$var$PENDING_TIMEOUT_MS = 10000;
const $e997c3be5cf5eb8e$var$PACKAGE_VERSION = `w:${$e997c3be5cf5eb8e$var$version}`;
const $e997c3be5cf5eb8e$var$INTERNAL_AUTH_VERSION = "FIS_v2";
const $e997c3be5cf5eb8e$var$INSTALLATIONS_API_URL = "https://firebaseinstallations.googleapis.com/v1";
const $e997c3be5cf5eb8e$var$TOKEN_EXPIRATION_BUFFER = 3600000; // One hour
const $e997c3be5cf5eb8e$var$SERVICE = "installations";
const $e997c3be5cf5eb8e$var$SERVICE_NAME = "Installations";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $e997c3be5cf5eb8e$var$ERROR_DESCRIPTION_MAP = {
    ["missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */ ]: 'Missing App configuration value: "{$valueName}"',
    ["not-registered" /* ErrorCode.NOT_REGISTERED */ ]: "Firebase Installation is not registered.",
    ["installation-not-found" /* ErrorCode.INSTALLATION_NOT_FOUND */ ]: "Firebase Installation not found.",
    ["request-failed" /* ErrorCode.REQUEST_FAILED */ ]: '{$requestName} request failed with error "{$serverCode} {$serverStatus}: {$serverMessage}"',
    ["app-offline" /* ErrorCode.APP_OFFLINE */ ]: "Could not process request. Application offline.",
    ["delete-pending-registration" /* ErrorCode.DELETE_PENDING_REGISTRATION */ ]: "Can't delete installation while there is a pending registration request."
};
const $e997c3be5cf5eb8e$var$ERROR_FACTORY = new (0, $e601d7027d812060$export$3fa6e1b18a3b2d40)($e997c3be5cf5eb8e$var$SERVICE, $e997c3be5cf5eb8e$var$SERVICE_NAME, $e997c3be5cf5eb8e$var$ERROR_DESCRIPTION_MAP);
/** Returns true if error is a FirebaseError that is based on an error from the server. */ function $e997c3be5cf5eb8e$var$isServerError(error) {
    return error instanceof (0, $e601d7027d812060$export$dd24e9cd51226c56) && error.code.includes("request-failed" /* ErrorCode.REQUEST_FAILED */ );
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $e997c3be5cf5eb8e$var$getInstallationsEndpoint({ projectId: projectId }) {
    return `${$e997c3be5cf5eb8e$var$INSTALLATIONS_API_URL}/projects/${projectId}/installations`;
}
function $e997c3be5cf5eb8e$var$extractAuthTokenInfoFromResponse(response) {
    return {
        token: response.token,
        requestStatus: 2 /* RequestStatus.COMPLETED */ ,
        expiresIn: $e997c3be5cf5eb8e$var$getExpiresInFromResponseExpiresIn(response.expiresIn),
        creationTime: Date.now()
    };
}
async function $e997c3be5cf5eb8e$var$getErrorFromResponse(requestName, response) {
    const responseJson = await response.json();
    const errorData = responseJson.error;
    return $e997c3be5cf5eb8e$var$ERROR_FACTORY.create("request-failed" /* ErrorCode.REQUEST_FAILED */ , {
        requestName: requestName,
        serverCode: errorData.code,
        serverMessage: errorData.message,
        serverStatus: errorData.status
    });
}
function $e997c3be5cf5eb8e$var$getHeaders({ apiKey: apiKey }) {
    return new Headers({
        "Content-Type": "application/json",
        Accept: "application/json",
        "x-goog-api-key": apiKey
    });
}
function $e997c3be5cf5eb8e$var$getHeadersWithAuth(appConfig, { refreshToken: refreshToken }) {
    const headers = $e997c3be5cf5eb8e$var$getHeaders(appConfig);
    headers.append("Authorization", $e997c3be5cf5eb8e$var$getAuthorizationHeader(refreshToken));
    return headers;
}
/**
 * Calls the passed in fetch wrapper and returns the response.
 * If the returned response has a status of 5xx, re-runs the function once and
 * returns the response.
 */ async function $e997c3be5cf5eb8e$var$retryIfServerError(fn) {
    const result = await fn();
    if (result.status >= 500 && result.status < 600) // Internal Server Error. Retry request.
    return fn();
    return result;
}
function $e997c3be5cf5eb8e$var$getExpiresInFromResponseExpiresIn(responseExpiresIn) {
    // This works because the server will never respond with fractions of a second.
    return Number(responseExpiresIn.replace("s", "000"));
}
function $e997c3be5cf5eb8e$var$getAuthorizationHeader(refreshToken) {
    return `${$e997c3be5cf5eb8e$var$INTERNAL_AUTH_VERSION} ${refreshToken}`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $e997c3be5cf5eb8e$var$createInstallationRequest({ appConfig: appConfig, heartbeatServiceProvider: heartbeatServiceProvider }, { fid: fid }) {
    const endpoint = $e997c3be5cf5eb8e$var$getInstallationsEndpoint(appConfig);
    const headers = $e997c3be5cf5eb8e$var$getHeaders(appConfig);
    // If heartbeat service exists, add the heartbeat string to the header.
    const heartbeatService = heartbeatServiceProvider.getImmediate({
        optional: true
    });
    if (heartbeatService) {
        const heartbeatsHeader = await heartbeatService.getHeartbeatsHeader();
        if (heartbeatsHeader) headers.append("x-firebase-client", heartbeatsHeader);
    }
    const body = {
        fid: fid,
        authVersion: $e997c3be5cf5eb8e$var$INTERNAL_AUTH_VERSION,
        appId: appConfig.appId,
        sdkVersion: $e997c3be5cf5eb8e$var$PACKAGE_VERSION
    };
    const request = {
        method: "POST",
        headers: headers,
        body: JSON.stringify(body)
    };
    const response = await $e997c3be5cf5eb8e$var$retryIfServerError(()=>fetch(endpoint, request));
    if (response.ok) {
        const responseValue = await response.json();
        const registeredInstallationEntry = {
            fid: responseValue.fid || fid,
            registrationStatus: 2 /* RequestStatus.COMPLETED */ ,
            refreshToken: responseValue.refreshToken,
            authToken: $e997c3be5cf5eb8e$var$extractAuthTokenInfoFromResponse(responseValue.authToken)
        };
        return registeredInstallationEntry;
    } else throw await $e997c3be5cf5eb8e$var$getErrorFromResponse("Create Installation", response);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Returns a promise that resolves after given time passes. */ function $e997c3be5cf5eb8e$var$sleep(ms) {
    return new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $e997c3be5cf5eb8e$var$bufferToBase64UrlSafe(array) {
    const b64 = btoa(String.fromCharCode(...array));
    return b64.replace(/\+/g, "-").replace(/\//g, "_");
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $e997c3be5cf5eb8e$var$VALID_FID_PATTERN = /^[cdef][\w-]{21}$/;
const $e997c3be5cf5eb8e$var$INVALID_FID = "";
/**
 * Generates a new FID using random values from Web Crypto API.
 * Returns an empty string if FID generation fails for any reason.
 */ function $e997c3be5cf5eb8e$var$generateFid() {
    try {
        // A valid FID has exactly 22 base64 characters, which is 132 bits, or 16.5
        // bytes. our implementation generates a 17 byte array instead.
        const fidByteArray = new Uint8Array(17);
        const crypto = self.crypto || self.msCrypto;
        crypto.getRandomValues(fidByteArray);
        // Replace the first 4 random bits with the constant FID header of 0b0111.
        fidByteArray[0] = 112 + fidByteArray[0] % 16;
        const fid = $e997c3be5cf5eb8e$var$encode(fidByteArray);
        return $e997c3be5cf5eb8e$var$VALID_FID_PATTERN.test(fid) ? fid : $e997c3be5cf5eb8e$var$INVALID_FID;
    } catch (_a) {
        // FID generation errored
        return $e997c3be5cf5eb8e$var$INVALID_FID;
    }
}
/** Converts a FID Uint8Array to a base64 string representation. */ function $e997c3be5cf5eb8e$var$encode(fidByteArray) {
    const b64String = $e997c3be5cf5eb8e$var$bufferToBase64UrlSafe(fidByteArray);
    // Remove the 23rd character that was added because of the extra 4 bits at the
    // end of our 17 byte array, and the '=' padding.
    return b64String.substr(0, 22);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Returns a string key that can be used to identify the app. */ function $e997c3be5cf5eb8e$var$getKey(appConfig) {
    return `${appConfig.appName}!${appConfig.appId}`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $e997c3be5cf5eb8e$var$fidChangeCallbacks = new Map();
/**
 * Calls the onIdChange callbacks with the new FID value, and broadcasts the
 * change to other tabs.
 */ function $e997c3be5cf5eb8e$var$fidChanged(appConfig, fid) {
    const key = $e997c3be5cf5eb8e$var$getKey(appConfig);
    $e997c3be5cf5eb8e$var$callFidChangeCallbacks(key, fid);
    $e997c3be5cf5eb8e$var$broadcastFidChange(key, fid);
}
function $e997c3be5cf5eb8e$var$addCallback(appConfig, callback) {
    // Open the broadcast channel if it's not already open,
    // to be able to listen to change events from other tabs.
    $e997c3be5cf5eb8e$var$getBroadcastChannel();
    const key = $e997c3be5cf5eb8e$var$getKey(appConfig);
    let callbackSet = $e997c3be5cf5eb8e$var$fidChangeCallbacks.get(key);
    if (!callbackSet) {
        callbackSet = new Set();
        $e997c3be5cf5eb8e$var$fidChangeCallbacks.set(key, callbackSet);
    }
    callbackSet.add(callback);
}
function $e997c3be5cf5eb8e$var$removeCallback(appConfig, callback) {
    const key = $e997c3be5cf5eb8e$var$getKey(appConfig);
    const callbackSet = $e997c3be5cf5eb8e$var$fidChangeCallbacks.get(key);
    if (!callbackSet) return;
    callbackSet.delete(callback);
    if (callbackSet.size === 0) $e997c3be5cf5eb8e$var$fidChangeCallbacks.delete(key);
    // Close broadcast channel if there are no more callbacks.
    $e997c3be5cf5eb8e$var$closeBroadcastChannel();
}
function $e997c3be5cf5eb8e$var$callFidChangeCallbacks(key, fid) {
    const callbacks = $e997c3be5cf5eb8e$var$fidChangeCallbacks.get(key);
    if (!callbacks) return;
    for (const callback of callbacks)callback(fid);
}
function $e997c3be5cf5eb8e$var$broadcastFidChange(key, fid) {
    const channel = $e997c3be5cf5eb8e$var$getBroadcastChannel();
    if (channel) channel.postMessage({
        key: key,
        fid: fid
    });
    $e997c3be5cf5eb8e$var$closeBroadcastChannel();
}
let $e997c3be5cf5eb8e$var$broadcastChannel = null;
/** Opens and returns a BroadcastChannel if it is supported by the browser. */ function $e997c3be5cf5eb8e$var$getBroadcastChannel() {
    if (!$e997c3be5cf5eb8e$var$broadcastChannel && "BroadcastChannel" in self) {
        $e997c3be5cf5eb8e$var$broadcastChannel = new BroadcastChannel("[Firebase] FID Change");
        $e997c3be5cf5eb8e$var$broadcastChannel.onmessage = (e)=>{
            $e997c3be5cf5eb8e$var$callFidChangeCallbacks(e.data.key, e.data.fid);
        };
    }
    return $e997c3be5cf5eb8e$var$broadcastChannel;
}
function $e997c3be5cf5eb8e$var$closeBroadcastChannel() {
    if ($e997c3be5cf5eb8e$var$fidChangeCallbacks.size === 0 && $e997c3be5cf5eb8e$var$broadcastChannel) {
        $e997c3be5cf5eb8e$var$broadcastChannel.close();
        $e997c3be5cf5eb8e$var$broadcastChannel = null;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $e997c3be5cf5eb8e$var$DATABASE_NAME = "firebase-installations-database";
const $e997c3be5cf5eb8e$var$DATABASE_VERSION = 1;
const $e997c3be5cf5eb8e$var$OBJECT_STORE_NAME = "firebase-installations-store";
let $e997c3be5cf5eb8e$var$dbPromise = null;
function $e997c3be5cf5eb8e$var$getDbPromise() {
    if (!$e997c3be5cf5eb8e$var$dbPromise) $e997c3be5cf5eb8e$var$dbPromise = (0, $b6239eac33e6d6a7$export$ca0ed41b1a2af7e)($e997c3be5cf5eb8e$var$DATABASE_NAME, $e997c3be5cf5eb8e$var$DATABASE_VERSION, {
        upgrade: (db, oldVersion)=>{
            // We don't use 'break' in this switch statement, the fall-through
            // behavior is what we want, because if there are multiple versions between
            // the old version and the current version, we want ALL the migrations
            // that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch(oldVersion){
                case 0:
                    db.createObjectStore($e997c3be5cf5eb8e$var$OBJECT_STORE_NAME);
            }
        }
    });
    return $e997c3be5cf5eb8e$var$dbPromise;
}
/** Assigns or overwrites the record for the given key with the given value. */ async function $e997c3be5cf5eb8e$var$set(appConfig, value) {
    const key = $e997c3be5cf5eb8e$var$getKey(appConfig);
    const db = await $e997c3be5cf5eb8e$var$getDbPromise();
    const tx = db.transaction($e997c3be5cf5eb8e$var$OBJECT_STORE_NAME, "readwrite");
    const objectStore = tx.objectStore($e997c3be5cf5eb8e$var$OBJECT_STORE_NAME);
    const oldValue = await objectStore.get(key);
    await objectStore.put(value, key);
    await tx.done;
    if (!oldValue || oldValue.fid !== value.fid) $e997c3be5cf5eb8e$var$fidChanged(appConfig, value.fid);
    return value;
}
/** Removes record(s) from the objectStore that match the given key. */ async function $e997c3be5cf5eb8e$var$remove(appConfig) {
    const key = $e997c3be5cf5eb8e$var$getKey(appConfig);
    const db = await $e997c3be5cf5eb8e$var$getDbPromise();
    const tx = db.transaction($e997c3be5cf5eb8e$var$OBJECT_STORE_NAME, "readwrite");
    await tx.objectStore($e997c3be5cf5eb8e$var$OBJECT_STORE_NAME).delete(key);
    await tx.done;
}
/**
 * Atomically updates a record with the result of updateFn, which gets
 * called with the current value. If newValue is undefined, the record is
 * deleted instead.
 * @return Updated value
 */ async function $e997c3be5cf5eb8e$var$update(appConfig, updateFn) {
    const key = $e997c3be5cf5eb8e$var$getKey(appConfig);
    const db = await $e997c3be5cf5eb8e$var$getDbPromise();
    const tx = db.transaction($e997c3be5cf5eb8e$var$OBJECT_STORE_NAME, "readwrite");
    const store = tx.objectStore($e997c3be5cf5eb8e$var$OBJECT_STORE_NAME);
    const oldValue = await store.get(key);
    const newValue = updateFn(oldValue);
    if (newValue === undefined) await store.delete(key);
    else await store.put(newValue, key);
    await tx.done;
    if (newValue && (!oldValue || oldValue.fid !== newValue.fid)) $e997c3be5cf5eb8e$var$fidChanged(appConfig, newValue.fid);
    return newValue;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates and returns the InstallationEntry from the database.
 * Also triggers a registration request if it is necessary and possible.
 */ async function $e997c3be5cf5eb8e$var$getInstallationEntry(installations) {
    let registrationPromise;
    const installationEntry = await $e997c3be5cf5eb8e$var$update(installations.appConfig, (oldEntry)=>{
        const installationEntry = $e997c3be5cf5eb8e$var$updateOrCreateInstallationEntry(oldEntry);
        const entryWithPromise = $e997c3be5cf5eb8e$var$triggerRegistrationIfNecessary(installations, installationEntry);
        registrationPromise = entryWithPromise.registrationPromise;
        return entryWithPromise.installationEntry;
    });
    if (installationEntry.fid === $e997c3be5cf5eb8e$var$INVALID_FID) // FID generation failed. Waiting for the FID from the server.
    return {
        installationEntry: await registrationPromise
    };
    return {
        installationEntry: installationEntry,
        registrationPromise: registrationPromise
    };
}
/**
 * Creates a new Installation Entry if one does not exist.
 * Also clears timed out pending requests.
 */ function $e997c3be5cf5eb8e$var$updateOrCreateInstallationEntry(oldEntry) {
    const entry = oldEntry || {
        fid: $e997c3be5cf5eb8e$var$generateFid(),
        registrationStatus: 0 /* RequestStatus.NOT_STARTED */ 
    };
    return $e997c3be5cf5eb8e$var$clearTimedOutRequest(entry);
}
/**
 * If the Firebase Installation is not registered yet, this will trigger the
 * registration and return an InProgressInstallationEntry.
 *
 * If registrationPromise does not exist, the installationEntry is guaranteed
 * to be registered.
 */ function $e997c3be5cf5eb8e$var$triggerRegistrationIfNecessary(installations, installationEntry) {
    if (installationEntry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */ ) {
        if (!navigator.onLine) {
            // Registration required but app is offline.
            const registrationPromiseWithError = Promise.reject($e997c3be5cf5eb8e$var$ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */ ));
            return {
                installationEntry: installationEntry,
                registrationPromise: registrationPromiseWithError
            };
        }
        // Try registering. Change status to IN_PROGRESS.
        const inProgressEntry = {
            fid: installationEntry.fid,
            registrationStatus: 1 /* RequestStatus.IN_PROGRESS */ ,
            registrationTime: Date.now()
        };
        const registrationPromise = $e997c3be5cf5eb8e$var$registerInstallation(installations, inProgressEntry);
        return {
            installationEntry: inProgressEntry,
            registrationPromise: registrationPromise
        };
    } else if (installationEntry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */ ) return {
        installationEntry: installationEntry,
        registrationPromise: $e997c3be5cf5eb8e$var$waitUntilFidRegistration(installations)
    };
    else return {
        installationEntry: installationEntry
    };
}
/** This will be executed only once for each new Firebase Installation. */ async function $e997c3be5cf5eb8e$var$registerInstallation(installations, installationEntry) {
    try {
        const registeredInstallationEntry = await $e997c3be5cf5eb8e$var$createInstallationRequest(installations, installationEntry);
        return $e997c3be5cf5eb8e$var$set(installations.appConfig, registeredInstallationEntry);
    } catch (e) {
        if ($e997c3be5cf5eb8e$var$isServerError(e) && e.customData.serverCode === 409) // Server returned a "FID can not be used" error.
        // Generate a new ID next time.
        await $e997c3be5cf5eb8e$var$remove(installations.appConfig);
        else // Registration failed. Set FID as not registered.
        await $e997c3be5cf5eb8e$var$set(installations.appConfig, {
            fid: installationEntry.fid,
            registrationStatus: 0 /* RequestStatus.NOT_STARTED */ 
        });
        throw e;
    }
}
/** Call if FID registration is pending in another request. */ async function $e997c3be5cf5eb8e$var$waitUntilFidRegistration(installations) {
    // Unfortunately, there is no way of reliably observing when a value in
    // IndexedDB changes (yet, see https://github.com/WICG/indexed-db-observers),
    // so we need to poll.
    let entry = await $e997c3be5cf5eb8e$var$updateInstallationRequest(installations.appConfig);
    while(entry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */ ){
        // createInstallation request still in progress.
        await $e997c3be5cf5eb8e$var$sleep(100);
        entry = await $e997c3be5cf5eb8e$var$updateInstallationRequest(installations.appConfig);
    }
    if (entry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */ ) {
        // The request timed out or failed in a different call. Try again.
        const { installationEntry: installationEntry, registrationPromise: registrationPromise } = await $e997c3be5cf5eb8e$var$getInstallationEntry(installations);
        if (registrationPromise) return registrationPromise;
        else // if there is no registrationPromise, entry is registered.
        return installationEntry;
    }
    return entry;
}
/**
 * Called only if there is a CreateInstallation request in progress.
 *
 * Updates the InstallationEntry in the DB based on the status of the
 * CreateInstallation request.
 *
 * Returns the updated InstallationEntry.
 */ function $e997c3be5cf5eb8e$var$updateInstallationRequest(appConfig) {
    return $e997c3be5cf5eb8e$var$update(appConfig, (oldEntry)=>{
        if (!oldEntry) throw $e997c3be5cf5eb8e$var$ERROR_FACTORY.create("installation-not-found" /* ErrorCode.INSTALLATION_NOT_FOUND */ );
        return $e997c3be5cf5eb8e$var$clearTimedOutRequest(oldEntry);
    });
}
function $e997c3be5cf5eb8e$var$clearTimedOutRequest(entry) {
    if ($e997c3be5cf5eb8e$var$hasInstallationRequestTimedOut(entry)) return {
        fid: entry.fid,
        registrationStatus: 0 /* RequestStatus.NOT_STARTED */ 
    };
    return entry;
}
function $e997c3be5cf5eb8e$var$hasInstallationRequestTimedOut(installationEntry) {
    return installationEntry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */  && installationEntry.registrationTime + $e997c3be5cf5eb8e$var$PENDING_TIMEOUT_MS < Date.now();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $e997c3be5cf5eb8e$var$generateAuthTokenRequest({ appConfig: appConfig, heartbeatServiceProvider: heartbeatServiceProvider }, installationEntry) {
    const endpoint = $e997c3be5cf5eb8e$var$getGenerateAuthTokenEndpoint(appConfig, installationEntry);
    const headers = $e997c3be5cf5eb8e$var$getHeadersWithAuth(appConfig, installationEntry);
    // If heartbeat service exists, add the heartbeat string to the header.
    const heartbeatService = heartbeatServiceProvider.getImmediate({
        optional: true
    });
    if (heartbeatService) {
        const heartbeatsHeader = await heartbeatService.getHeartbeatsHeader();
        if (heartbeatsHeader) headers.append("x-firebase-client", heartbeatsHeader);
    }
    const body = {
        installation: {
            sdkVersion: $e997c3be5cf5eb8e$var$PACKAGE_VERSION,
            appId: appConfig.appId
        }
    };
    const request = {
        method: "POST",
        headers: headers,
        body: JSON.stringify(body)
    };
    const response = await $e997c3be5cf5eb8e$var$retryIfServerError(()=>fetch(endpoint, request));
    if (response.ok) {
        const responseValue = await response.json();
        const completedAuthToken = $e997c3be5cf5eb8e$var$extractAuthTokenInfoFromResponse(responseValue);
        return completedAuthToken;
    } else throw await $e997c3be5cf5eb8e$var$getErrorFromResponse("Generate Auth Token", response);
}
function $e997c3be5cf5eb8e$var$getGenerateAuthTokenEndpoint(appConfig, { fid: fid }) {
    return `${$e997c3be5cf5eb8e$var$getInstallationsEndpoint(appConfig)}/${fid}/authTokens:generate`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a valid authentication token for the installation. Generates a new
 * token if one doesn't exist, is expired or about to expire.
 *
 * Should only be called if the Firebase Installation is registered.
 */ async function $e997c3be5cf5eb8e$var$refreshAuthToken(installations, forceRefresh = false) {
    let tokenPromise;
    const entry = await $e997c3be5cf5eb8e$var$update(installations.appConfig, (oldEntry)=>{
        if (!$e997c3be5cf5eb8e$var$isEntryRegistered(oldEntry)) throw $e997c3be5cf5eb8e$var$ERROR_FACTORY.create("not-registered" /* ErrorCode.NOT_REGISTERED */ );
        const oldAuthToken = oldEntry.authToken;
        if (!forceRefresh && $e997c3be5cf5eb8e$var$isAuthTokenValid(oldAuthToken)) // There is a valid token in the DB.
        return oldEntry;
        else if (oldAuthToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */ ) {
            // There already is a token request in progress.
            tokenPromise = $e997c3be5cf5eb8e$var$waitUntilAuthTokenRequest(installations, forceRefresh);
            return oldEntry;
        } else {
            // No token or token expired.
            if (!navigator.onLine) throw $e997c3be5cf5eb8e$var$ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */ );
            const inProgressEntry = $e997c3be5cf5eb8e$var$makeAuthTokenRequestInProgressEntry(oldEntry);
            tokenPromise = $e997c3be5cf5eb8e$var$fetchAuthTokenFromServer(installations, inProgressEntry);
            return inProgressEntry;
        }
    });
    const authToken = tokenPromise ? await tokenPromise : entry.authToken;
    return authToken;
}
/**
 * Call only if FID is registered and Auth Token request is in progress.
 *
 * Waits until the current pending request finishes. If the request times out,
 * tries once in this thread as well.
 */ async function $e997c3be5cf5eb8e$var$waitUntilAuthTokenRequest(installations, forceRefresh) {
    // Unfortunately, there is no way of reliably observing when a value in
    // IndexedDB changes (yet, see https://github.com/WICG/indexed-db-observers),
    // so we need to poll.
    let entry = await $e997c3be5cf5eb8e$var$updateAuthTokenRequest(installations.appConfig);
    while(entry.authToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */ ){
        // generateAuthToken still in progress.
        await $e997c3be5cf5eb8e$var$sleep(100);
        entry = await $e997c3be5cf5eb8e$var$updateAuthTokenRequest(installations.appConfig);
    }
    const authToken = entry.authToken;
    if (authToken.requestStatus === 0 /* RequestStatus.NOT_STARTED */ ) // The request timed out or failed in a different call. Try again.
    return $e997c3be5cf5eb8e$var$refreshAuthToken(installations, forceRefresh);
    else return authToken;
}
/**
 * Called only if there is a GenerateAuthToken request in progress.
 *
 * Updates the InstallationEntry in the DB based on the status of the
 * GenerateAuthToken request.
 *
 * Returns the updated InstallationEntry.
 */ function $e997c3be5cf5eb8e$var$updateAuthTokenRequest(appConfig) {
    return $e997c3be5cf5eb8e$var$update(appConfig, (oldEntry)=>{
        if (!$e997c3be5cf5eb8e$var$isEntryRegistered(oldEntry)) throw $e997c3be5cf5eb8e$var$ERROR_FACTORY.create("not-registered" /* ErrorCode.NOT_REGISTERED */ );
        const oldAuthToken = oldEntry.authToken;
        if ($e997c3be5cf5eb8e$var$hasAuthTokenRequestTimedOut(oldAuthToken)) return Object.assign(Object.assign({}, oldEntry), {
            authToken: {
                requestStatus: 0 /* RequestStatus.NOT_STARTED */ 
            }
        });
        return oldEntry;
    });
}
async function $e997c3be5cf5eb8e$var$fetchAuthTokenFromServer(installations, installationEntry) {
    try {
        const authToken = await $e997c3be5cf5eb8e$var$generateAuthTokenRequest(installations, installationEntry);
        const updatedInstallationEntry = Object.assign(Object.assign({}, installationEntry), {
            authToken: authToken
        });
        await $e997c3be5cf5eb8e$var$set(installations.appConfig, updatedInstallationEntry);
        return authToken;
    } catch (e) {
        if ($e997c3be5cf5eb8e$var$isServerError(e) && (e.customData.serverCode === 401 || e.customData.serverCode === 404)) // Server returned a "FID not found" or a "Invalid authentication" error.
        // Generate a new ID next time.
        await $e997c3be5cf5eb8e$var$remove(installations.appConfig);
        else {
            const updatedInstallationEntry = Object.assign(Object.assign({}, installationEntry), {
                authToken: {
                    requestStatus: 0 /* RequestStatus.NOT_STARTED */ 
                }
            });
            await $e997c3be5cf5eb8e$var$set(installations.appConfig, updatedInstallationEntry);
        }
        throw e;
    }
}
function $e997c3be5cf5eb8e$var$isEntryRegistered(installationEntry) {
    return installationEntry !== undefined && installationEntry.registrationStatus === 2 /* RequestStatus.COMPLETED */ ;
}
function $e997c3be5cf5eb8e$var$isAuthTokenValid(authToken) {
    return authToken.requestStatus === 2 /* RequestStatus.COMPLETED */  && !$e997c3be5cf5eb8e$var$isAuthTokenExpired(authToken);
}
function $e997c3be5cf5eb8e$var$isAuthTokenExpired(authToken) {
    const now = Date.now();
    return now < authToken.creationTime || authToken.creationTime + authToken.expiresIn < now + $e997c3be5cf5eb8e$var$TOKEN_EXPIRATION_BUFFER;
}
/** Returns an updated InstallationEntry with an InProgressAuthToken. */ function $e997c3be5cf5eb8e$var$makeAuthTokenRequestInProgressEntry(oldEntry) {
    const inProgressAuthToken = {
        requestStatus: 1 /* RequestStatus.IN_PROGRESS */ ,
        requestTime: Date.now()
    };
    return Object.assign(Object.assign({}, oldEntry), {
        authToken: inProgressAuthToken
    });
}
function $e997c3be5cf5eb8e$var$hasAuthTokenRequestTimedOut(authToken) {
    return authToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */  && authToken.requestTime + $e997c3be5cf5eb8e$var$PENDING_TIMEOUT_MS < Date.now();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Creates a Firebase Installation if there isn't one for the app and
 * returns the Installation ID.
 * @param installations - The `Installations` instance.
 *
 * @public
 */ async function $e997c3be5cf5eb8e$export$218c8c3169c024d2(installations) {
    const installationsImpl = installations;
    const { installationEntry: installationEntry, registrationPromise: registrationPromise } = await $e997c3be5cf5eb8e$var$getInstallationEntry(installationsImpl);
    if (registrationPromise) registrationPromise.catch(console.error);
    else // If the installation is already registered, update the authentication
    // token if needed.
    $e997c3be5cf5eb8e$var$refreshAuthToken(installationsImpl).catch(console.error);
    return installationEntry.fid;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a Firebase Installations auth token, identifying the current
 * Firebase Installation.
 * @param installations - The `Installations` instance.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ async function $e997c3be5cf5eb8e$export$257b2d10b709d8ef(installations, forceRefresh = false) {
    const installationsImpl = installations;
    await $e997c3be5cf5eb8e$var$completeInstallationRegistration(installationsImpl);
    // At this point we either have a Registered Installation in the DB, or we've
    // already thrown an error.
    const authToken = await $e997c3be5cf5eb8e$var$refreshAuthToken(installationsImpl, forceRefresh);
    return authToken.token;
}
async function $e997c3be5cf5eb8e$var$completeInstallationRegistration(installations) {
    const { registrationPromise: registrationPromise } = await $e997c3be5cf5eb8e$var$getInstallationEntry(installations);
    if (registrationPromise) // A createInstallation request is in progress. Wait until it finishes.
    await registrationPromise;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $e997c3be5cf5eb8e$var$deleteInstallationRequest(appConfig, installationEntry) {
    const endpoint = $e997c3be5cf5eb8e$var$getDeleteEndpoint(appConfig, installationEntry);
    const headers = $e997c3be5cf5eb8e$var$getHeadersWithAuth(appConfig, installationEntry);
    const request = {
        method: "DELETE",
        headers: headers
    };
    const response = await $e997c3be5cf5eb8e$var$retryIfServerError(()=>fetch(endpoint, request));
    if (!response.ok) throw await $e997c3be5cf5eb8e$var$getErrorFromResponse("Delete Installation", response);
}
function $e997c3be5cf5eb8e$var$getDeleteEndpoint(appConfig, { fid: fid }) {
    return `${$e997c3be5cf5eb8e$var$getInstallationsEndpoint(appConfig)}/${fid}`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Deletes the Firebase Installation and all associated data.
 * @param installations - The `Installations` instance.
 *
 * @public
 */ async function $e997c3be5cf5eb8e$export$5f6b87a08674814c(installations) {
    const { appConfig: appConfig } = installations;
    const entry = await $e997c3be5cf5eb8e$var$update(appConfig, (oldEntry)=>{
        if (oldEntry && oldEntry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */ ) // Delete the unregistered entry without sending a deleteInstallation request.
        return undefined;
        return oldEntry;
    });
    if (entry) {
        if (entry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */ ) // Can't delete while trying to register.
        throw $e997c3be5cf5eb8e$var$ERROR_FACTORY.create("delete-pending-registration" /* ErrorCode.DELETE_PENDING_REGISTRATION */ );
        else if (entry.registrationStatus === 2 /* RequestStatus.COMPLETED */ ) {
            if (!navigator.onLine) throw $e997c3be5cf5eb8e$var$ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */ );
            else {
                await $e997c3be5cf5eb8e$var$deleteInstallationRequest(appConfig, entry);
                await $e997c3be5cf5eb8e$var$remove(appConfig);
            }
        }
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sets a new callback that will get called when Installation ID changes.
 * Returns an unsubscribe function that will remove the callback when called.
 * @param installations - The `Installations` instance.
 * @param callback - The callback function that is invoked when FID changes.
 * @returns A function that can be called to unsubscribe.
 *
 * @public
 */ function $e997c3be5cf5eb8e$export$ceb4c11381bc36e8(installations, callback) {
    const { appConfig: appConfig } = installations;
    $e997c3be5cf5eb8e$var$addCallback(appConfig, callback);
    return ()=>{
        $e997c3be5cf5eb8e$var$removeCallback(appConfig, callback);
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns an instance of {@link Installations} associated with the given
 * {@link @firebase/app#FirebaseApp} instance.
 * @param app - The {@link @firebase/app#FirebaseApp} instance.
 *
 * @public
 */ function $e997c3be5cf5eb8e$export$9bfc115e43431ff5(app = (0, $2406031bebeb53d7$export$f9962582c9e66d99)()) {
    const installationsImpl = (0, $2406031bebeb53d7$export$fa0d6da0f5838f50)(app, "installations").getImmediate();
    return installationsImpl;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $e997c3be5cf5eb8e$var$extractAppConfig(app) {
    if (!app || !app.options) throw $e997c3be5cf5eb8e$var$getMissingValueError("App Configuration");
    if (!app.name) throw $e997c3be5cf5eb8e$var$getMissingValueError("App Name");
    // Required app config keys
    const configKeys = [
        "projectId",
        "apiKey",
        "appId"
    ];
    for (const keyName of configKeys){
        if (!app.options[keyName]) throw $e997c3be5cf5eb8e$var$getMissingValueError(keyName);
    }
    return {
        appName: app.name,
        projectId: app.options.projectId,
        apiKey: app.options.apiKey,
        appId: app.options.appId
    };
}
function $e997c3be5cf5eb8e$var$getMissingValueError(valueName) {
    return $e997c3be5cf5eb8e$var$ERROR_FACTORY.create("missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */ , {
        valueName: valueName
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $e997c3be5cf5eb8e$var$INSTALLATIONS_NAME = "installations";
const $e997c3be5cf5eb8e$var$INSTALLATIONS_NAME_INTERNAL = "installations-internal";
const $e997c3be5cf5eb8e$var$publicFactory = (container)=>{
    const app = container.getProvider("app").getImmediate();
    // Throws if app isn't configured properly.
    const appConfig = $e997c3be5cf5eb8e$var$extractAppConfig(app);
    const heartbeatServiceProvider = (0, $2406031bebeb53d7$export$fa0d6da0f5838f50)(app, "heartbeat");
    const installationsImpl = {
        app: app,
        appConfig: appConfig,
        heartbeatServiceProvider: heartbeatServiceProvider,
        _delete: ()=>Promise.resolve()
    };
    return installationsImpl;
};
const $e997c3be5cf5eb8e$var$internalFactory = (container)=>{
    const app = container.getProvider("app").getImmediate();
    // Internal FIS instance relies on public FIS instance.
    const installations = (0, $2406031bebeb53d7$export$fa0d6da0f5838f50)(app, $e997c3be5cf5eb8e$var$INSTALLATIONS_NAME).getImmediate();
    const installationsInternal = {
        getId: ()=>$e997c3be5cf5eb8e$export$218c8c3169c024d2(installations),
        getToken: (forceRefresh)=>$e997c3be5cf5eb8e$export$257b2d10b709d8ef(installations, forceRefresh)
    };
    return installationsInternal;
};
function $e997c3be5cf5eb8e$var$registerInstallations() {
    (0, $2406031bebeb53d7$export$c930050e7bb63965)(new (0, $6158f8502f3b9916$export$16fa2f45be04daa8)($e997c3be5cf5eb8e$var$INSTALLATIONS_NAME, $e997c3be5cf5eb8e$var$publicFactory, "PUBLIC" /* ComponentType.PUBLIC */ ));
    (0, $2406031bebeb53d7$export$c930050e7bb63965)(new (0, $6158f8502f3b9916$export$16fa2f45be04daa8)($e997c3be5cf5eb8e$var$INSTALLATIONS_NAME_INTERNAL, $e997c3be5cf5eb8e$var$internalFactory, "PRIVATE" /* ComponentType.PRIVATE */ ));
}
/**
 * The Firebase Installations Web SDK.
 * This SDK does not work in a Node.js environment.
 *
 * @packageDocumentation
 */ $e997c3be5cf5eb8e$var$registerInstallations();
(0, $2406031bebeb53d7$export$d29d5299a7137abc)($e997c3be5cf5eb8e$var$name, $e997c3be5cf5eb8e$var$version);
// BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
(0, $2406031bebeb53d7$export$d29d5299a7137abc)($e997c3be5cf5eb8e$var$name, $e997c3be5cf5eb8e$var$version, "esm2017");






/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $f0b1ff9a10cf7acb$var$DEFAULT_SW_PATH = "/firebase-messaging-sw.js";
const $f0b1ff9a10cf7acb$var$DEFAULT_SW_SCOPE = "/firebase-cloud-messaging-push-scope";
const $f0b1ff9a10cf7acb$var$DEFAULT_VAPID_KEY = "BDOU99-h67HcA6JeFXHbSNMu7e2yNNu3RzoMj8TM4W88jITfq7ZmPvIM1Iv-4_l2LxQcYwhqby2xGpWwzjfAnG4";
const $f0b1ff9a10cf7acb$var$ENDPOINT = "https://fcmregistrations.googleapis.com/v1";
const $f0b1ff9a10cf7acb$var$CONSOLE_CAMPAIGN_ID = "google.c.a.c_id";
const $f0b1ff9a10cf7acb$var$CONSOLE_CAMPAIGN_NAME = "google.c.a.c_l";
const $f0b1ff9a10cf7acb$var$CONSOLE_CAMPAIGN_TIME = "google.c.a.ts";
/** Set to '1' if Analytics is enabled for the campaign */ const $f0b1ff9a10cf7acb$var$CONSOLE_CAMPAIGN_ANALYTICS_ENABLED = "google.c.a.e";
var $f0b1ff9a10cf7acb$var$MessageType$1;
(function(MessageType) {
    MessageType[MessageType["DATA_MESSAGE"] = 1] = "DATA_MESSAGE";
    MessageType[MessageType["DISPLAY_NOTIFICATION"] = 3] = "DISPLAY_NOTIFICATION";
})($f0b1ff9a10cf7acb$var$MessageType$1 || ($f0b1ff9a10cf7acb$var$MessageType$1 = {}));
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License. You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under the License
 * is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express
 * or implied. See the License for the specific language governing permissions and limitations under
 * the License.
 */ var $f0b1ff9a10cf7acb$var$MessageType;
(function(MessageType) {
    MessageType["PUSH_RECEIVED"] = "push-received";
    MessageType["NOTIFICATION_CLICKED"] = "notification-clicked";
})($f0b1ff9a10cf7acb$var$MessageType || ($f0b1ff9a10cf7acb$var$MessageType = {}));
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $f0b1ff9a10cf7acb$var$arrayToBase64(array) {
    const uint8Array = new Uint8Array(array);
    const base64String = btoa(String.fromCharCode(...uint8Array));
    return base64String.replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
}
function $f0b1ff9a10cf7acb$var$base64ToArray(base64String) {
    const padding = "=".repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding).replace(/\-/g, "+").replace(/_/g, "/");
    const rawData = atob(base64);
    const outputArray = new Uint8Array(rawData.length);
    for(let i = 0; i < rawData.length; ++i)outputArray[i] = rawData.charCodeAt(i);
    return outputArray;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $f0b1ff9a10cf7acb$var$OLD_DB_NAME = "fcm_token_details_db";
/**
 * The last DB version of 'fcm_token_details_db' was 4. This is one higher, so that the upgrade
 * callback is called for all versions of the old DB.
 */ const $f0b1ff9a10cf7acb$var$OLD_DB_VERSION = 5;
const $f0b1ff9a10cf7acb$var$OLD_OBJECT_STORE_NAME = "fcm_token_object_Store";
async function $f0b1ff9a10cf7acb$var$migrateOldDatabase(senderId) {
    if ("databases" in indexedDB) {
        // indexedDb.databases() is an IndexedDB v3 API and does not exist in all browsers. TODO: Remove
        // typecast when it lands in TS types.
        const databases = await indexedDB.databases();
        const dbNames = databases.map((db)=>db.name);
        if (!dbNames.includes($f0b1ff9a10cf7acb$var$OLD_DB_NAME)) // old DB didn't exist, no need to open.
        return null;
    }
    let tokenDetails = null;
    const db = await (0, $b6239eac33e6d6a7$export$ca0ed41b1a2af7e)($f0b1ff9a10cf7acb$var$OLD_DB_NAME, $f0b1ff9a10cf7acb$var$OLD_DB_VERSION, {
        upgrade: async (db, oldVersion, newVersion, upgradeTransaction)=>{
            var _a;
            if (oldVersion < 2) // Database too old, skip migration.
            return;
            if (!db.objectStoreNames.contains($f0b1ff9a10cf7acb$var$OLD_OBJECT_STORE_NAME)) // Database did not exist. Nothing to do.
            return;
            const objectStore = upgradeTransaction.objectStore($f0b1ff9a10cf7acb$var$OLD_OBJECT_STORE_NAME);
            const value = await objectStore.index("fcmSenderId").get(senderId);
            await objectStore.clear();
            if (!value) // No entry in the database, nothing to migrate.
            return;
            if (oldVersion === 2) {
                const oldDetails = value;
                if (!oldDetails.auth || !oldDetails.p256dh || !oldDetails.endpoint) return;
                tokenDetails = {
                    token: oldDetails.fcmToken,
                    createTime: (_a = oldDetails.createTime) !== null && _a !== void 0 ? _a : Date.now(),
                    subscriptionOptions: {
                        auth: oldDetails.auth,
                        p256dh: oldDetails.p256dh,
                        endpoint: oldDetails.endpoint,
                        swScope: oldDetails.swScope,
                        vapidKey: typeof oldDetails.vapidKey === "string" ? oldDetails.vapidKey : $f0b1ff9a10cf7acb$var$arrayToBase64(oldDetails.vapidKey)
                    }
                };
            } else if (oldVersion === 3) {
                const oldDetails = value;
                tokenDetails = {
                    token: oldDetails.fcmToken,
                    createTime: oldDetails.createTime,
                    subscriptionOptions: {
                        auth: $f0b1ff9a10cf7acb$var$arrayToBase64(oldDetails.auth),
                        p256dh: $f0b1ff9a10cf7acb$var$arrayToBase64(oldDetails.p256dh),
                        endpoint: oldDetails.endpoint,
                        swScope: oldDetails.swScope,
                        vapidKey: $f0b1ff9a10cf7acb$var$arrayToBase64(oldDetails.vapidKey)
                    }
                };
            } else if (oldVersion === 4) {
                const oldDetails = value;
                tokenDetails = {
                    token: oldDetails.fcmToken,
                    createTime: oldDetails.createTime,
                    subscriptionOptions: {
                        auth: $f0b1ff9a10cf7acb$var$arrayToBase64(oldDetails.auth),
                        p256dh: $f0b1ff9a10cf7acb$var$arrayToBase64(oldDetails.p256dh),
                        endpoint: oldDetails.endpoint,
                        swScope: oldDetails.swScope,
                        vapidKey: $f0b1ff9a10cf7acb$var$arrayToBase64(oldDetails.vapidKey)
                    }
                };
            }
        }
    });
    db.close();
    // Delete all old databases.
    await (0, $b6239eac33e6d6a7$export$9d6df0ac66a98bb2)($f0b1ff9a10cf7acb$var$OLD_DB_NAME);
    await (0, $b6239eac33e6d6a7$export$9d6df0ac66a98bb2)("fcm_vapid_details_db");
    await (0, $b6239eac33e6d6a7$export$9d6df0ac66a98bb2)("undefined");
    return $f0b1ff9a10cf7acb$var$checkTokenDetails(tokenDetails) ? tokenDetails : null;
}
function $f0b1ff9a10cf7acb$var$checkTokenDetails(tokenDetails) {
    if (!tokenDetails || !tokenDetails.subscriptionOptions) return false;
    const { subscriptionOptions: subscriptionOptions } = tokenDetails;
    return typeof tokenDetails.createTime === "number" && tokenDetails.createTime > 0 && typeof tokenDetails.token === "string" && tokenDetails.token.length > 0 && typeof subscriptionOptions.auth === "string" && subscriptionOptions.auth.length > 0 && typeof subscriptionOptions.p256dh === "string" && subscriptionOptions.p256dh.length > 0 && typeof subscriptionOptions.endpoint === "string" && subscriptionOptions.endpoint.length > 0 && typeof subscriptionOptions.swScope === "string" && subscriptionOptions.swScope.length > 0 && typeof subscriptionOptions.vapidKey === "string" && subscriptionOptions.vapidKey.length > 0;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Exported for tests.
const $f0b1ff9a10cf7acb$var$DATABASE_NAME = "firebase-messaging-database";
const $f0b1ff9a10cf7acb$var$DATABASE_VERSION = 1;
const $f0b1ff9a10cf7acb$var$OBJECT_STORE_NAME = "firebase-messaging-store";
let $f0b1ff9a10cf7acb$var$dbPromise = null;
function $f0b1ff9a10cf7acb$var$getDbPromise() {
    if (!$f0b1ff9a10cf7acb$var$dbPromise) $f0b1ff9a10cf7acb$var$dbPromise = (0, $b6239eac33e6d6a7$export$ca0ed41b1a2af7e)($f0b1ff9a10cf7acb$var$DATABASE_NAME, $f0b1ff9a10cf7acb$var$DATABASE_VERSION, {
        upgrade: (upgradeDb, oldVersion)=>{
            // We don't use 'break' in this switch statement, the fall-through behavior is what we want,
            // because if there are multiple versions between the old version and the current version, we
            // want ALL the migrations that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch(oldVersion){
                case 0:
                    upgradeDb.createObjectStore($f0b1ff9a10cf7acb$var$OBJECT_STORE_NAME);
            }
        }
    });
    return $f0b1ff9a10cf7acb$var$dbPromise;
}
/** Gets record(s) from the objectStore that match the given key. */ async function $f0b1ff9a10cf7acb$var$dbGet(firebaseDependencies) {
    const key = $f0b1ff9a10cf7acb$var$getKey(firebaseDependencies);
    const db = await $f0b1ff9a10cf7acb$var$getDbPromise();
    const tokenDetails = await db.transaction($f0b1ff9a10cf7acb$var$OBJECT_STORE_NAME).objectStore($f0b1ff9a10cf7acb$var$OBJECT_STORE_NAME).get(key);
    if (tokenDetails) return tokenDetails;
    else {
        // Check if there is a tokenDetails object in the old DB.
        const oldTokenDetails = await $f0b1ff9a10cf7acb$var$migrateOldDatabase(firebaseDependencies.appConfig.senderId);
        if (oldTokenDetails) {
            await $f0b1ff9a10cf7acb$var$dbSet(firebaseDependencies, oldTokenDetails);
            return oldTokenDetails;
        }
    }
}
/** Assigns or overwrites the record for the given key with the given value. */ async function $f0b1ff9a10cf7acb$var$dbSet(firebaseDependencies, tokenDetails) {
    const key = $f0b1ff9a10cf7acb$var$getKey(firebaseDependencies);
    const db = await $f0b1ff9a10cf7acb$var$getDbPromise();
    const tx = db.transaction($f0b1ff9a10cf7acb$var$OBJECT_STORE_NAME, "readwrite");
    await tx.objectStore($f0b1ff9a10cf7acb$var$OBJECT_STORE_NAME).put(tokenDetails, key);
    await tx.done;
    return tokenDetails;
}
/** Removes record(s) from the objectStore that match the given key. */ async function $f0b1ff9a10cf7acb$var$dbRemove(firebaseDependencies) {
    const key = $f0b1ff9a10cf7acb$var$getKey(firebaseDependencies);
    const db = await $f0b1ff9a10cf7acb$var$getDbPromise();
    const tx = db.transaction($f0b1ff9a10cf7acb$var$OBJECT_STORE_NAME, "readwrite");
    await tx.objectStore($f0b1ff9a10cf7acb$var$OBJECT_STORE_NAME).delete(key);
    await tx.done;
}
function $f0b1ff9a10cf7acb$var$getKey({ appConfig: appConfig }) {
    return appConfig.appId;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $f0b1ff9a10cf7acb$var$ERROR_MAP = {
    ["missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */ ]: 'Missing App configuration value: "{$valueName}"',
    ["only-available-in-window" /* ErrorCode.AVAILABLE_IN_WINDOW */ ]: "This method is available in a Window context.",
    ["only-available-in-sw" /* ErrorCode.AVAILABLE_IN_SW */ ]: "This method is available in a service worker context.",
    ["permission-default" /* ErrorCode.PERMISSION_DEFAULT */ ]: "The notification permission was not granted and dismissed instead.",
    ["permission-blocked" /* ErrorCode.PERMISSION_BLOCKED */ ]: "The notification permission was not granted and blocked instead.",
    ["unsupported-browser" /* ErrorCode.UNSUPPORTED_BROWSER */ ]: "This browser doesn't support the API's required to use the Firebase SDK.",
    ["indexed-db-unsupported" /* ErrorCode.INDEXED_DB_UNSUPPORTED */ ]: "This browser doesn't support indexedDb.open() (ex. Safari iFrame, Firefox Private Browsing, etc)",
    ["failed-service-worker-registration" /* ErrorCode.FAILED_DEFAULT_REGISTRATION */ ]: "We are unable to register the default service worker. {$browserErrorMessage}",
    ["token-subscribe-failed" /* ErrorCode.TOKEN_SUBSCRIBE_FAILED */ ]: "A problem occurred while subscribing the user to FCM: {$errorInfo}",
    ["token-subscribe-no-token" /* ErrorCode.TOKEN_SUBSCRIBE_NO_TOKEN */ ]: "FCM returned no token when subscribing the user to push.",
    ["token-unsubscribe-failed" /* ErrorCode.TOKEN_UNSUBSCRIBE_FAILED */ ]: "A problem occurred while unsubscribing the user from FCM: {$errorInfo}",
    ["token-update-failed" /* ErrorCode.TOKEN_UPDATE_FAILED */ ]: "A problem occurred while updating the user from FCM: {$errorInfo}",
    ["token-update-no-token" /* ErrorCode.TOKEN_UPDATE_NO_TOKEN */ ]: "FCM returned no token when updating the user to push.",
    ["use-sw-after-get-token" /* ErrorCode.USE_SW_AFTER_GET_TOKEN */ ]: "The useServiceWorker() method may only be called once and must be called before calling getToken() to ensure your service worker is used.",
    ["invalid-sw-registration" /* ErrorCode.INVALID_SW_REGISTRATION */ ]: "The input to useServiceWorker() must be a ServiceWorkerRegistration.",
    ["invalid-bg-handler" /* ErrorCode.INVALID_BG_HANDLER */ ]: "The input to setBackgroundMessageHandler() must be a function.",
    ["invalid-vapid-key" /* ErrorCode.INVALID_VAPID_KEY */ ]: "The public VAPID key must be a string.",
    ["use-vapid-key-after-get-token" /* ErrorCode.USE_VAPID_KEY_AFTER_GET_TOKEN */ ]: "The usePublicVapidKey() method may only be called once and must be called before calling getToken() to ensure your VAPID key is used."
};
const $f0b1ff9a10cf7acb$var$ERROR_FACTORY = new (0, $e601d7027d812060$export$3fa6e1b18a3b2d40)("messaging", "Messaging", $f0b1ff9a10cf7acb$var$ERROR_MAP);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $f0b1ff9a10cf7acb$var$requestGetToken(firebaseDependencies, subscriptionOptions) {
    const headers = await $f0b1ff9a10cf7acb$var$getHeaders(firebaseDependencies);
    const body = $f0b1ff9a10cf7acb$var$getBody(subscriptionOptions);
    const subscribeOptions = {
        method: "POST",
        headers: headers,
        body: JSON.stringify(body)
    };
    let responseData;
    try {
        const response = await fetch($f0b1ff9a10cf7acb$var$getEndpoint(firebaseDependencies.appConfig), subscribeOptions);
        responseData = await response.json();
    } catch (err) {
        throw $f0b1ff9a10cf7acb$var$ERROR_FACTORY.create("token-subscribe-failed" /* ErrorCode.TOKEN_SUBSCRIBE_FAILED */ , {
            errorInfo: err === null || err === void 0 ? void 0 : err.toString()
        });
    }
    if (responseData.error) {
        const message = responseData.error.message;
        throw $f0b1ff9a10cf7acb$var$ERROR_FACTORY.create("token-subscribe-failed" /* ErrorCode.TOKEN_SUBSCRIBE_FAILED */ , {
            errorInfo: message
        });
    }
    if (!responseData.token) throw $f0b1ff9a10cf7acb$var$ERROR_FACTORY.create("token-subscribe-no-token" /* ErrorCode.TOKEN_SUBSCRIBE_NO_TOKEN */ );
    return responseData.token;
}
async function $f0b1ff9a10cf7acb$var$requestUpdateToken(firebaseDependencies, tokenDetails) {
    const headers = await $f0b1ff9a10cf7acb$var$getHeaders(firebaseDependencies);
    const body = $f0b1ff9a10cf7acb$var$getBody(tokenDetails.subscriptionOptions);
    const updateOptions = {
        method: "PATCH",
        headers: headers,
        body: JSON.stringify(body)
    };
    let responseData;
    try {
        const response = await fetch(`${$f0b1ff9a10cf7acb$var$getEndpoint(firebaseDependencies.appConfig)}/${tokenDetails.token}`, updateOptions);
        responseData = await response.json();
    } catch (err) {
        throw $f0b1ff9a10cf7acb$var$ERROR_FACTORY.create("token-update-failed" /* ErrorCode.TOKEN_UPDATE_FAILED */ , {
            errorInfo: err === null || err === void 0 ? void 0 : err.toString()
        });
    }
    if (responseData.error) {
        const message = responseData.error.message;
        throw $f0b1ff9a10cf7acb$var$ERROR_FACTORY.create("token-update-failed" /* ErrorCode.TOKEN_UPDATE_FAILED */ , {
            errorInfo: message
        });
    }
    if (!responseData.token) throw $f0b1ff9a10cf7acb$var$ERROR_FACTORY.create("token-update-no-token" /* ErrorCode.TOKEN_UPDATE_NO_TOKEN */ );
    return responseData.token;
}
async function $f0b1ff9a10cf7acb$var$requestDeleteToken(firebaseDependencies, token) {
    const headers = await $f0b1ff9a10cf7acb$var$getHeaders(firebaseDependencies);
    const unsubscribeOptions = {
        method: "DELETE",
        headers: headers
    };
    try {
        const response = await fetch(`${$f0b1ff9a10cf7acb$var$getEndpoint(firebaseDependencies.appConfig)}/${token}`, unsubscribeOptions);
        const responseData = await response.json();
        if (responseData.error) {
            const message = responseData.error.message;
            throw $f0b1ff9a10cf7acb$var$ERROR_FACTORY.create("token-unsubscribe-failed" /* ErrorCode.TOKEN_UNSUBSCRIBE_FAILED */ , {
                errorInfo: message
            });
        }
    } catch (err) {
        throw $f0b1ff9a10cf7acb$var$ERROR_FACTORY.create("token-unsubscribe-failed" /* ErrorCode.TOKEN_UNSUBSCRIBE_FAILED */ , {
            errorInfo: err === null || err === void 0 ? void 0 : err.toString()
        });
    }
}
function $f0b1ff9a10cf7acb$var$getEndpoint({ projectId: projectId }) {
    return `${$f0b1ff9a10cf7acb$var$ENDPOINT}/projects/${projectId}/registrations`;
}
async function $f0b1ff9a10cf7acb$var$getHeaders({ appConfig: appConfig, installations: installations }) {
    const authToken = await installations.getToken();
    return new Headers({
        "Content-Type": "application/json",
        Accept: "application/json",
        "x-goog-api-key": appConfig.apiKey,
        "x-goog-firebase-installations-auth": `FIS ${authToken}`
    });
}
function $f0b1ff9a10cf7acb$var$getBody({ p256dh: p256dh, auth: auth, endpoint: endpoint, vapidKey: vapidKey }) {
    const body = {
        web: {
            endpoint: endpoint,
            auth: auth,
            p256dh: p256dh
        }
    };
    if (vapidKey !== $f0b1ff9a10cf7acb$var$DEFAULT_VAPID_KEY) body.web.applicationPubKey = vapidKey;
    return body;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // UpdateRegistration will be called once every week.
const $f0b1ff9a10cf7acb$var$TOKEN_EXPIRATION_MS = 604800000; // 7 days
async function $f0b1ff9a10cf7acb$var$getTokenInternal(messaging) {
    const pushSubscription = await $f0b1ff9a10cf7acb$var$getPushSubscription(messaging.swRegistration, messaging.vapidKey);
    const subscriptionOptions = {
        vapidKey: messaging.vapidKey,
        swScope: messaging.swRegistration.scope,
        endpoint: pushSubscription.endpoint,
        auth: $f0b1ff9a10cf7acb$var$arrayToBase64(pushSubscription.getKey("auth")),
        p256dh: $f0b1ff9a10cf7acb$var$arrayToBase64(pushSubscription.getKey("p256dh"))
    };
    const tokenDetails = await $f0b1ff9a10cf7acb$var$dbGet(messaging.firebaseDependencies);
    if (!tokenDetails) // No token, get a new one.
    return $f0b1ff9a10cf7acb$var$getNewToken(messaging.firebaseDependencies, subscriptionOptions);
    else if (!$f0b1ff9a10cf7acb$var$isTokenValid(tokenDetails.subscriptionOptions, subscriptionOptions)) {
        // Invalid token, get a new one.
        try {
            await $f0b1ff9a10cf7acb$var$requestDeleteToken(messaging.firebaseDependencies, tokenDetails.token);
        } catch (e) {
            // Suppress errors because of #2364
            console.warn(e);
        }
        return $f0b1ff9a10cf7acb$var$getNewToken(messaging.firebaseDependencies, subscriptionOptions);
    } else if (Date.now() >= tokenDetails.createTime + $f0b1ff9a10cf7acb$var$TOKEN_EXPIRATION_MS) // Weekly token refresh
    return $f0b1ff9a10cf7acb$var$updateToken(messaging, {
        token: tokenDetails.token,
        createTime: Date.now(),
        subscriptionOptions: subscriptionOptions
    });
    else // Valid token, nothing to do.
    return tokenDetails.token;
}
/**
 * This method deletes the token from the database, unsubscribes the token from FCM, and unregisters
 * the push subscription if it exists.
 */ async function $f0b1ff9a10cf7acb$var$deleteTokenInternal(messaging) {
    const tokenDetails = await $f0b1ff9a10cf7acb$var$dbGet(messaging.firebaseDependencies);
    if (tokenDetails) {
        await $f0b1ff9a10cf7acb$var$requestDeleteToken(messaging.firebaseDependencies, tokenDetails.token);
        await $f0b1ff9a10cf7acb$var$dbRemove(messaging.firebaseDependencies);
    }
    // Unsubscribe from the push subscription.
    const pushSubscription = await messaging.swRegistration.pushManager.getSubscription();
    if (pushSubscription) return pushSubscription.unsubscribe();
    // If there's no SW, consider it a success.
    return true;
}
async function $f0b1ff9a10cf7acb$var$updateToken(messaging, tokenDetails) {
    try {
        const updatedToken = await $f0b1ff9a10cf7acb$var$requestUpdateToken(messaging.firebaseDependencies, tokenDetails);
        const updatedTokenDetails = Object.assign(Object.assign({}, tokenDetails), {
            token: updatedToken,
            createTime: Date.now()
        });
        await $f0b1ff9a10cf7acb$var$dbSet(messaging.firebaseDependencies, updatedTokenDetails);
        return updatedToken;
    } catch (e) {
        await $f0b1ff9a10cf7acb$var$deleteTokenInternal(messaging);
        throw e;
    }
}
async function $f0b1ff9a10cf7acb$var$getNewToken(firebaseDependencies, subscriptionOptions) {
    const token = await $f0b1ff9a10cf7acb$var$requestGetToken(firebaseDependencies, subscriptionOptions);
    const tokenDetails = {
        token: token,
        createTime: Date.now(),
        subscriptionOptions: subscriptionOptions
    };
    await $f0b1ff9a10cf7acb$var$dbSet(firebaseDependencies, tokenDetails);
    return tokenDetails.token;
}
/**
 * Gets a PushSubscription for the current user.
 */ async function $f0b1ff9a10cf7acb$var$getPushSubscription(swRegistration, vapidKey) {
    const subscription = await swRegistration.pushManager.getSubscription();
    if (subscription) return subscription;
    return swRegistration.pushManager.subscribe({
        userVisibleOnly: true,
        // Chrome <= 75 doesn't support base64-encoded VAPID key. For backward compatibility, VAPID key
        // submitted to pushManager#subscribe must be of type Uint8Array.
        applicationServerKey: $f0b1ff9a10cf7acb$var$base64ToArray(vapidKey)
    });
}
/**
 * Checks if the saved tokenDetails object matches the configuration provided.
 */ function $f0b1ff9a10cf7acb$var$isTokenValid(dbOptions, currentOptions) {
    const isVapidKeyEqual = currentOptions.vapidKey === dbOptions.vapidKey;
    const isEndpointEqual = currentOptions.endpoint === dbOptions.endpoint;
    const isAuthEqual = currentOptions.auth === dbOptions.auth;
    const isP256dhEqual = currentOptions.p256dh === dbOptions.p256dh;
    return isVapidKeyEqual && isEndpointEqual && isAuthEqual && isP256dhEqual;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $f0b1ff9a10cf7acb$var$externalizePayload(internalPayload) {
    const payload = {
        from: internalPayload.from,
        // eslint-disable-next-line camelcase
        collapseKey: internalPayload.collapse_key,
        // eslint-disable-next-line camelcase
        messageId: internalPayload.fcmMessageId
    };
    $f0b1ff9a10cf7acb$var$propagateNotificationPayload(payload, internalPayload);
    $f0b1ff9a10cf7acb$var$propagateDataPayload(payload, internalPayload);
    $f0b1ff9a10cf7acb$var$propagateFcmOptions(payload, internalPayload);
    return payload;
}
function $f0b1ff9a10cf7acb$var$propagateNotificationPayload(payload, messagePayloadInternal) {
    if (!messagePayloadInternal.notification) return;
    payload.notification = {};
    const title = messagePayloadInternal.notification.title;
    if (!!title) payload.notification.title = title;
    const body = messagePayloadInternal.notification.body;
    if (!!body) payload.notification.body = body;
    const image = messagePayloadInternal.notification.image;
    if (!!image) payload.notification.image = image;
    const icon = messagePayloadInternal.notification.icon;
    if (!!icon) payload.notification.icon = icon;
}
function $f0b1ff9a10cf7acb$var$propagateDataPayload(payload, messagePayloadInternal) {
    if (!messagePayloadInternal.data) return;
    payload.data = messagePayloadInternal.data;
}
function $f0b1ff9a10cf7acb$var$propagateFcmOptions(payload, messagePayloadInternal) {
    var _a, _b, _c, _d, _e;
    // fcmOptions.link value is written into notification.click_action. see more in b/232072111
    if (!messagePayloadInternal.fcmOptions && !((_a = messagePayloadInternal.notification) === null || _a === void 0 ? void 0 : _a.click_action)) return;
    payload.fcmOptions = {};
    const link = (_c = (_b = messagePayloadInternal.fcmOptions) === null || _b === void 0 ? void 0 : _b.link) !== null && _c !== void 0 ? _c : (_d = messagePayloadInternal.notification) === null || _d === void 0 ? void 0 : _d.click_action;
    if (!!link) payload.fcmOptions.link = link;
    // eslint-disable-next-line camelcase
    const analyticsLabel = (_e = messagePayloadInternal.fcmOptions) === null || _e === void 0 ? void 0 : _e.analytics_label;
    if (!!analyticsLabel) payload.fcmOptions.analyticsLabel = analyticsLabel;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $f0b1ff9a10cf7acb$var$isConsoleMessage(data) {
    // This message has a campaign ID, meaning it was sent using the Firebase Console.
    return typeof data === "object" && !!data && $f0b1ff9a10cf7acb$var$CONSOLE_CAMPAIGN_ID in data;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ $f0b1ff9a10cf7acb$var$_mergeStrings("hts/frbslgigp.ogepscmv/ieo/eaylg", "tp:/ieaeogn-agolai.o/1frlglgc/o");
$f0b1ff9a10cf7acb$var$_mergeStrings("AzSCbw63g1R0nCw85jG8", "Iaya3yLKwmgvh7cF0q4");
function $f0b1ff9a10cf7acb$var$_mergeStrings(s1, s2) {
    const resultArray = [];
    for(let i = 0; i < s1.length; i++){
        resultArray.push(s1.charAt(i));
        if (i < s2.length) resultArray.push(s2.charAt(i));
    }
    return resultArray.join("");
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $f0b1ff9a10cf7acb$var$extractAppConfig(app) {
    if (!app || !app.options) throw $f0b1ff9a10cf7acb$var$getMissingValueError("App Configuration Object");
    if (!app.name) throw $f0b1ff9a10cf7acb$var$getMissingValueError("App Name");
    // Required app config keys
    const configKeys = [
        "projectId",
        "apiKey",
        "appId",
        "messagingSenderId"
    ];
    const { options: options } = app;
    for (const keyName of configKeys){
        if (!options[keyName]) throw $f0b1ff9a10cf7acb$var$getMissingValueError(keyName);
    }
    return {
        appName: app.name,
        projectId: options.projectId,
        apiKey: options.apiKey,
        appId: options.appId,
        senderId: options.messagingSenderId
    };
}
function $f0b1ff9a10cf7acb$var$getMissingValueError(valueName) {
    return $f0b1ff9a10cf7acb$var$ERROR_FACTORY.create("missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */ , {
        valueName: valueName
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $f0b1ff9a10cf7acb$var$MessagingService {
    constructor(app, installations, analyticsProvider){
        // logging is only done with end user consent. Default to false.
        this.deliveryMetricsExportedToBigQueryEnabled = false;
        this.onBackgroundMessageHandler = null;
        this.onMessageHandler = null;
        this.logEvents = [];
        this.isLogServiceStarted = false;
        const appConfig = $f0b1ff9a10cf7acb$var$extractAppConfig(app);
        this.firebaseDependencies = {
            app: app,
            appConfig: appConfig,
            installations: installations,
            analyticsProvider: analyticsProvider
        };
    }
    _delete() {
        return Promise.resolve();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $f0b1ff9a10cf7acb$var$registerDefaultSw(messaging) {
    try {
        messaging.swRegistration = await navigator.serviceWorker.register($f0b1ff9a10cf7acb$var$DEFAULT_SW_PATH, {
            scope: $f0b1ff9a10cf7acb$var$DEFAULT_SW_SCOPE
        });
        // The timing when browser updates sw when sw has an update is unreliable from experiment. It
        // leads to version conflict when the SDK upgrades to a newer version in the main page, but sw
        // is stuck with the old version. For example,
        // https://github.com/firebase/firebase-js-sdk/issues/2590 The following line reliably updates
        // sw if there was an update.
        messaging.swRegistration.update().catch(()=>{
        /* it is non blocking and we don't care if it failed */ });
    } catch (e) {
        throw $f0b1ff9a10cf7acb$var$ERROR_FACTORY.create("failed-service-worker-registration" /* ErrorCode.FAILED_DEFAULT_REGISTRATION */ , {
            browserErrorMessage: e === null || e === void 0 ? void 0 : e.message
        });
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $f0b1ff9a10cf7acb$var$updateSwReg(messaging, swRegistration) {
    if (!swRegistration && !messaging.swRegistration) await $f0b1ff9a10cf7acb$var$registerDefaultSw(messaging);
    if (!swRegistration && !!messaging.swRegistration) return;
    if (!(swRegistration instanceof ServiceWorkerRegistration)) throw $f0b1ff9a10cf7acb$var$ERROR_FACTORY.create("invalid-sw-registration" /* ErrorCode.INVALID_SW_REGISTRATION */ );
    messaging.swRegistration = swRegistration;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $f0b1ff9a10cf7acb$var$updateVapidKey(messaging, vapidKey) {
    if (!!vapidKey) messaging.vapidKey = vapidKey;
    else if (!messaging.vapidKey) messaging.vapidKey = $f0b1ff9a10cf7acb$var$DEFAULT_VAPID_KEY;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $f0b1ff9a10cf7acb$var$getToken$1(messaging, options) {
    if (!navigator) throw $f0b1ff9a10cf7acb$var$ERROR_FACTORY.create("only-available-in-window" /* ErrorCode.AVAILABLE_IN_WINDOW */ );
    if (Notification.permission === "default") await Notification.requestPermission();
    if (Notification.permission !== "granted") throw $f0b1ff9a10cf7acb$var$ERROR_FACTORY.create("permission-blocked" /* ErrorCode.PERMISSION_BLOCKED */ );
    await $f0b1ff9a10cf7acb$var$updateVapidKey(messaging, options === null || options === void 0 ? void 0 : options.vapidKey);
    await $f0b1ff9a10cf7acb$var$updateSwReg(messaging, options === null || options === void 0 ? void 0 : options.serviceWorkerRegistration);
    return $f0b1ff9a10cf7acb$var$getTokenInternal(messaging);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $f0b1ff9a10cf7acb$var$logToScion(messaging, messageType, data) {
    const eventType = $f0b1ff9a10cf7acb$var$getEventType(messageType);
    const analytics = await messaging.firebaseDependencies.analyticsProvider.get();
    analytics.logEvent(eventType, {
        /* eslint-disable camelcase */ message_id: data[$f0b1ff9a10cf7acb$var$CONSOLE_CAMPAIGN_ID],
        message_name: data[$f0b1ff9a10cf7acb$var$CONSOLE_CAMPAIGN_NAME],
        message_time: data[$f0b1ff9a10cf7acb$var$CONSOLE_CAMPAIGN_TIME],
        message_device_time: Math.floor(Date.now() / 1000)
    });
}
function $f0b1ff9a10cf7acb$var$getEventType(messageType) {
    switch(messageType){
        case $f0b1ff9a10cf7acb$var$MessageType.NOTIFICATION_CLICKED:
            return "notification_open";
        case $f0b1ff9a10cf7acb$var$MessageType.PUSH_RECEIVED:
            return "notification_foreground";
        default:
            throw new Error();
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $f0b1ff9a10cf7acb$var$messageEventListener(messaging, event) {
    const internalPayload = event.data;
    if (!internalPayload.isFirebaseMessaging) return;
    if (messaging.onMessageHandler && internalPayload.messageType === $f0b1ff9a10cf7acb$var$MessageType.PUSH_RECEIVED) {
        if (typeof messaging.onMessageHandler === "function") messaging.onMessageHandler($f0b1ff9a10cf7acb$var$externalizePayload(internalPayload));
        else messaging.onMessageHandler.next($f0b1ff9a10cf7acb$var$externalizePayload(internalPayload));
    }
    // Log to Scion if applicable
    const dataPayload = internalPayload.data;
    if ($f0b1ff9a10cf7acb$var$isConsoleMessage(dataPayload) && dataPayload[$f0b1ff9a10cf7acb$var$CONSOLE_CAMPAIGN_ANALYTICS_ENABLED] === "1") await $f0b1ff9a10cf7acb$var$logToScion(messaging, internalPayload.messageType, dataPayload);
}
const $f0b1ff9a10cf7acb$var$name = "@firebase/messaging";
const $f0b1ff9a10cf7acb$var$version = "0.12.6";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $f0b1ff9a10cf7acb$var$WindowMessagingFactory = (container)=>{
    const messaging = new $f0b1ff9a10cf7acb$var$MessagingService(container.getProvider("app").getImmediate(), container.getProvider("installations-internal").getImmediate(), container.getProvider("analytics-internal"));
    navigator.serviceWorker.addEventListener("message", (e)=>$f0b1ff9a10cf7acb$var$messageEventListener(messaging, e));
    return messaging;
};
const $f0b1ff9a10cf7acb$var$WindowMessagingInternalFactory = (container)=>{
    const messaging = container.getProvider("messaging").getImmediate();
    const messagingInternal = {
        getToken: (options)=>$f0b1ff9a10cf7acb$var$getToken$1(messaging, options)
    };
    return messagingInternal;
};
function $f0b1ff9a10cf7acb$var$registerMessagingInWindow() {
    (0, $2406031bebeb53d7$export$c930050e7bb63965)(new (0, $6158f8502f3b9916$export$16fa2f45be04daa8)("messaging", $f0b1ff9a10cf7acb$var$WindowMessagingFactory, "PUBLIC" /* ComponentType.PUBLIC */ ));
    (0, $2406031bebeb53d7$export$c930050e7bb63965)(new (0, $6158f8502f3b9916$export$16fa2f45be04daa8)("messaging-internal", $f0b1ff9a10cf7acb$var$WindowMessagingInternalFactory, "PRIVATE" /* ComponentType.PRIVATE */ ));
    (0, $2406031bebeb53d7$export$d29d5299a7137abc)($f0b1ff9a10cf7acb$var$name, $f0b1ff9a10cf7acb$var$version);
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    (0, $2406031bebeb53d7$export$d29d5299a7137abc)($f0b1ff9a10cf7acb$var$name, $f0b1ff9a10cf7acb$var$version, "esm2017");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Checks if all required APIs exist in the browser.
 * @returns a Promise that resolves to a boolean.
 *
 * @public
 */ async function $f0b1ff9a10cf7acb$export$48c17662a6902497() {
    try {
        // This throws if open() is unsupported, so adding it to the conditional
        // statement below can cause an uncaught error.
        await (0, $e601d7027d812060$export$a8a3018f3d187a4d)();
    } catch (e) {
        return false;
    }
    // firebase-js-sdk/issues/2393 reveals that idb#open in Safari iframe and Firefox private browsing
    // might be prohibited to run. In these contexts, an error would be thrown during the messaging
    // instantiating phase, informing the developers to import/call isSupported for special handling.
    return typeof window !== "undefined" && (0, $e601d7027d812060$export$3865db50535c2055)() && (0, $e601d7027d812060$export$f172b7eb6cf60599)() && "serviceWorker" in navigator && "PushManager" in window && "Notification" in window && "fetch" in window && ServiceWorkerRegistration.prototype.hasOwnProperty("showNotification") && PushSubscription.prototype.hasOwnProperty("getKey");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $f0b1ff9a10cf7acb$var$deleteToken$1(messaging) {
    if (!navigator) throw $f0b1ff9a10cf7acb$var$ERROR_FACTORY.create("only-available-in-window" /* ErrorCode.AVAILABLE_IN_WINDOW */ );
    if (!messaging.swRegistration) await $f0b1ff9a10cf7acb$var$registerDefaultSw(messaging);
    return $f0b1ff9a10cf7acb$var$deleteTokenInternal(messaging);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $f0b1ff9a10cf7acb$var$onMessage$1(messaging, nextOrObserver) {
    if (!navigator) throw $f0b1ff9a10cf7acb$var$ERROR_FACTORY.create("only-available-in-window" /* ErrorCode.AVAILABLE_IN_WINDOW */ );
    messaging.onMessageHandler = nextOrObserver;
    return ()=>{
        messaging.onMessageHandler = null;
    };
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Retrieves a Firebase Cloud Messaging instance.
 *
 * @returns The Firebase Cloud Messaging instance associated with the provided firebase app.
 *
 * @public
 */ function $f0b1ff9a10cf7acb$export$f74c3c76482a8451(app = (0, $2406031bebeb53d7$export$f9962582c9e66d99)()) {
    // Conscious decision to make this async check non-blocking during the messaging instance
    // initialization phase for performance consideration. An error would be thrown latter for
    // developer's information. Developers can then choose to import and call `isSupported` for
    // special handling.
    $f0b1ff9a10cf7acb$export$48c17662a6902497().then((isSupported)=>{
        // If `isWindowSupported()` resolved, but returned false.
        if (!isSupported) throw $f0b1ff9a10cf7acb$var$ERROR_FACTORY.create("unsupported-browser" /* ErrorCode.UNSUPPORTED_BROWSER */ );
    }, (_)=>{
        // If `isWindowSupported()` rejected.
        throw $f0b1ff9a10cf7acb$var$ERROR_FACTORY.create("indexed-db-unsupported" /* ErrorCode.INDEXED_DB_UNSUPPORTED */ );
    });
    return (0, $2406031bebeb53d7$export$fa0d6da0f5838f50)((0, $e601d7027d812060$export$4befe9b5fa509a1b)(app), "messaging").getImmediate();
}
/**
 * Subscribes the {@link Messaging} instance to push notifications. Returns a Firebase Cloud
 * Messaging registration token that can be used to send push messages to that {@link Messaging}
 * instance.
 *
 * If notification permission isn't already granted, this method asks the user for permission. The
 * returned promise rejects if the user does not allow the app to show notifications.
 *
 * @param messaging - The {@link Messaging} instance.
 * @param options - Provides an optional vapid key and an optional service worker registration.
 *
 * @returns The promise resolves with an FCM registration token.
 *
 * @public
 */ async function $f0b1ff9a10cf7acb$export$257b2d10b709d8ef(messaging, options) {
    messaging = (0, $e601d7027d812060$export$4befe9b5fa509a1b)(messaging);
    return $f0b1ff9a10cf7acb$var$getToken$1(messaging, options);
}
/**
 * Deletes the registration token associated with this {@link Messaging} instance and unsubscribes
 * the {@link Messaging} instance from the push subscription.
 *
 * @param messaging - The {@link Messaging} instance.
 *
 * @returns The promise resolves when the token has been successfully deleted.
 *
 * @public
 */ function $f0b1ff9a10cf7acb$export$95d23a5f596fdc8e(messaging) {
    messaging = (0, $e601d7027d812060$export$4befe9b5fa509a1b)(messaging);
    return $f0b1ff9a10cf7acb$var$deleteToken$1(messaging);
}
/**
 * When a push message is received and the user is currently on a page for your origin, the
 * message is passed to the page and an `onMessage()` event is dispatched with the payload of
 * the push message.
 *
 *
 * @param messaging - The {@link Messaging} instance.
 * @param nextOrObserver - This function, or observer object with `next` defined,
 *     is called when a message is received and the user is currently viewing your page.
 * @returns To stop listening for messages execute this returned function.
 *
 * @public
 */ function $f0b1ff9a10cf7acb$export$7275a8dcb77dc20d(messaging, nextOrObserver) {
    messaging = (0, $e601d7027d812060$export$4befe9b5fa509a1b)(messaging);
    return $f0b1ff9a10cf7acb$var$onMessage$1(messaging, nextOrObserver);
}
/**
 * The Firebase Cloud Messaging Web SDK.
 * This SDK does not work in a Node.js environment.
 *
 * @packageDocumentation
 */ $f0b1ff9a10cf7acb$var$registerMessagingInWindow();





/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param argument - The value to convert
 *
 * @returns The parsed date in the local time zone
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */ function $48f2cd94c2808d74$export$e67a095c620b86fe(argument) {
    const argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || typeof argument === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new argument.constructor(+argument);
    else if (typeof argument === "number" || argStr === "[object Number]" || typeof argument === "string" || argStr === "[object String]") // TODO: Can we get rid of as?
    return new Date(argument);
    else // TODO: Can we get rid of as?
    return new Date(NaN);
}
var // Fallback for modularized imports:
$48f2cd94c2808d74$export$2e2bcd8739ae039 = $48f2cd94c2808d74$export$e67a095c620b86fe;


let $6fc64aba02a3bdcd$var$defaultOptions = {};
function $6fc64aba02a3bdcd$export$430a3269e24b912e() {
    return $6fc64aba02a3bdcd$var$defaultOptions;
}
function $6fc64aba02a3bdcd$export$95365be1b0704abc(newOptions) {
    $6fc64aba02a3bdcd$var$defaultOptions = newOptions;
}


function $f6a8848b728040ba$export$ef8b6d9133084f4e(date, options) {
    const defaultOptions = (0, $6fc64aba02a3bdcd$export$430a3269e24b912e)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $48f2cd94c2808d74$export$e67a095c620b86fe)(date);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    _date.setDate(_date.getDate() + diff);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
var // Fallback for modularized imports:
$f6a8848b728040ba$export$2e2bcd8739ae039 = $f6a8848b728040ba$export$ef8b6d9133084f4e;



function $f2ddddaabfe67186$export$42c81a444fbfb5d4(date, options) {
    const defaultOptions = (0, $6fc64aba02a3bdcd$export$430a3269e24b912e)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $48f2cd94c2808d74$export$e67a095c620b86fe)(date);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    _date.setDate(_date.getDate() - diff);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$f2ddddaabfe67186$export$2e2bcd8739ae039 = $f2ddddaabfe67186$export$42c81a444fbfb5d4;


const $06d17fa75ca1067f$export$34c88de16c0a2653 = {
    weekStartsOn: 1
};
const $06d17fa75ca1067f$export$9bcd4dc4ef454cb9 = Intl.DateTimeFormat(undefined, {
    day: "numeric",
    month: "short"
});
const $06d17fa75ca1067f$export$406508d2ca449bd = Intl.DateTimeFormat(undefined, {
    day: "numeric",
    month: "long",
    year: "numeric"
});
const $06d17fa75ca1067f$export$59113f23fb667b84 = Intl.DateTimeFormat(undefined, {
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    month: "numeric",
    second: "numeric",
    year: "numeric"
});
const $06d17fa75ca1067f$export$5b8f5fb13700b442 = Intl.DateTimeFormat(undefined, {
    day: "numeric",
    month: "long",
    weekday: "long",
    year: "numeric"
});
const $06d17fa75ca1067f$export$47adaa677c311957 = Intl.DateTimeFormat(undefined, {
    hour: "numeric"
});
const $06d17fa75ca1067f$export$4137bbc3ff26d570 = Intl.DateTimeFormat(undefined, {
    month: "long"
});
const $06d17fa75ca1067f$export$9fc2c6bef079c03f = Intl.DateTimeFormat(undefined, {
    month: "narrow"
});
const $06d17fa75ca1067f$export$e176cbe7be9b5dd8 = Intl.DateTimeFormat(undefined, {
    month: "short"
});
const $06d17fa75ca1067f$export$550deca24c3b7679 = Intl.DateTimeFormat(undefined, {
    month: "long",
    year: "numeric"
});
const $06d17fa75ca1067f$export$d0b308cb19a3b90e = Intl.DateTimeFormat(undefined, {
    month: "short",
    year: "2-digit"
});
const $06d17fa75ca1067f$export$5a00511f040384d7 = Intl.DateTimeFormat(undefined, {
    hour: "numeric",
    minute: "numeric",
    second: "numeric"
});
const $06d17fa75ca1067f$export$2c59d0e3b71c316 = Intl.DateTimeFormat(undefined, {
    weekday: "narrow"
});
const $06d17fa75ca1067f$export$a938dcff503049a5 = Intl.DateTimeFormat(undefined, {
    weekday: "short"
});
const $06d17fa75ca1067f$export$daf84c177a4aeca8 = Intl.DateTimeFormat(undefined, {
    year: "numeric"
});
const $06d17fa75ca1067f$var$dayMonthLongFormatter = Intl.DateTimeFormat(undefined, {
    day: "numeric",
    month: "long"
});
const $06d17fa75ca1067f$export$1143122ff5520ba9 = (week)=>$06d17fa75ca1067f$var$dayMonthLongFormatter.formatRange((0, $f2ddddaabfe67186$export$42c81a444fbfb5d4)(week, $06d17fa75ca1067f$export$34c88de16c0a2653), (0, $f6a8848b728040ba$export$ef8b6d9133084f4e)(week, $06d17fa75ca1067f$export$34c88de16c0a2653));
const $06d17fa75ca1067f$export$c8fd8d8bcad3b27c = (week)=>$06d17fa75ca1067f$export$406508d2ca449bd.formatRange((0, $f2ddddaabfe67186$export$42c81a444fbfb5d4)(week, $06d17fa75ca1067f$export$34c88de16c0a2653), (0, $f6a8848b728040ba$export$ef8b6d9133084f4e)(week, $06d17fa75ca1067f$export$34c88de16c0a2653));



/**
 * @name constructFrom
 * @category Generic Helpers
 * @summary Constructs a date using the reference date and the value
 *
 * @description
 * The function constructs a new date using the constructor from the reference
 * date and the given value. It helps to build generic functions that accept
 * date extensions.
 *
 * It defaults to `Date` if the passed reference date is a number or a string.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The reference date to take constructor from
 * @param value - The value to create the date
 *
 * @returns Date initialized using the given date and value
 *
 * @example
 * import { constructFrom } from 'date-fns'
 *
 * // A function that clones a date preserving the original type
 * function cloneDate<DateType extends Date(date: DateType): DateType {
 *   return constructFrom(
 *     date, // Use contrustor from the given date
 *     date.getTime() // Use the date value to create a new date
 *   )
 * }
 */ function $ee5e01283bb626d4$export$ead8a1812b171991(date, value) {
    if (date instanceof Date) return new date.constructor(value);
    else return new Date(value);
}
var // Fallback for modularized imports:
$ee5e01283bb626d4$export$2e2bcd8739ae039 = $ee5e01283bb626d4$export$ead8a1812b171991;


function $cb8fdbef2aba70f2$export$dd412b56f1e4d8aa(date, amount) {
    const _date = (0, $48f2cd94c2808d74$export$e67a095c620b86fe)(date);
    if (isNaN(amount)) return (0, $ee5e01283bb626d4$export$ead8a1812b171991)(date, NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return _date;
    _date.setDate(_date.getDate() + amount);
    return _date;
}
var // Fallback for modularized imports:
$cb8fdbef2aba70f2$export$2e2bcd8739ae039 = $cb8fdbef2aba70f2$export$dd412b56f1e4d8aa;


const $5a123094476b33d7$export$a716cf793ad7f839 = "2024-03-29T02:34:37.885Z";
const $5a123094476b33d7$export$99e2532e676f9073 = 32;
const $5a123094476b33d7$export$d550936f86997951 = {
    apiKey: "AIzaSyDJUEfQvbke4ImRxqW5KwijugRKCzXw4BY",
    appId: "1:189351604256:web:35457f768494fdf7e14c45",
    messagingSenderId: "189351604256",
    projectId: "moodtracker-4df02"
};
const $5a123094476b33d7$export$3b818226f8d6346d = "t";
const $5a123094476b33d7$export$9659e0d912e2b51e = 5;
const $5a123094476b33d7$export$83043d74884e8814 = [
    0,
    10
];
const $5a123094476b33d7$export$1c4e9440df4662e4 = $5a123094476b33d7$export$83043d74884e8814[1] - $5a123094476b33d7$export$83043d74884e8814[0];
const $5a123094476b33d7$export$88df5ff28be7bede = [
    ...Array($5a123094476b33d7$export$1c4e9440df4662e4 + 1).keys()
];
const $5a123094476b33d7$export$b53a3867abacf7cf = "https://github.com/benji6";
const $5a123094476b33d7$export$3508dfda2bc7d28 = `${$5a123094476b33d7$export$b53a3867abacf7cf}/moodtracker`;
const $5a123094476b33d7$export$2cdbc1b6a383b7bf = `${$5a123094476b33d7$export$3508dfda2bc7d28}/issues`;
const $5a123094476b33d7$export$b8187a7ff42a2a5e = "MoodTracker is a free and open source web app that aims to help you understand yourself better. Track your emotional landscape, keep a mood journal, time your meditations, keep a meditation log and gain new insights into yourself. It's simple to use, works offline and because it runs in your browser you can use it across all your devices!";
const $5a123094476b33d7$export$eb05085f459232d3 = {
    cognitoIdentityPoolId: "us-east-1:4338729d-7f9a-4d17-b26a-ec5e2b0ee928",
    cognitoUserPoolId: "us-east-1_rdB8iu5X4",
    region: "us-east-1"
};
const $5a123094476b33d7$export$4fd720569787ab6f = {
    generic: "Something went wrong, check the data you have entered and try again",
    integer: "Please type a valid whole number",
    network: "Something went wrong. This feature requires an internet connection, please check your connection and try again. If the problem persists it may be an issue on our side.",
    noChanges: "No changes have been made, please make an update then try again",
    server: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
        children: [
            "Something went wrong. This looks like a problem on our side. We will look into it. Please try again later. If the problem persists then",
            " ",
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("a", {
                href: $5a123094476b33d7$export$2cdbc1b6a383b7bf,
                rel: "noopener",
                target: "_blank",
                children: "raise an issue on GitHub"
            })
        ]
    }),
    specialCharacters: "This field must not contain any special characters",
    rangeOverflow: "Value is too big, please input something smaller",
    rangeUnderflow: "Value is too small, please input something bigger",
    required: "Required"
};
const $5a123094476b33d7$export$1b1adb72711c28e5 = {
    noPunctuation: "[\\p{L}\\p{Emoji_Presentation}\\s\\-]*"
};
const $5a123094476b33d7$export$a9905336c0111a3a = {
    daysPerWeek: 7,
    hoursPerDay: 24,
    millisecondsPerDay: 86400000,
    minutesPerHour: 60,
    secondsPerDay: 86400,
    secondsPerHour: 3600,
    secondsPerMinute: 60,
    secondsPerYear: 31536000
};
const $5a123094476b33d7$export$a2b4f255152a6585 = (()=>{
    const keys = [
        "addMoodPage",
        "addMoodRadioButton",
        "addMoodSubmitButton",
        "dateAwokeInput",
        "descriptionInput",
        "deviceSpecificSettingsDialog",
        "hoursSleptInput",
        "meditatePage",
        "meditationCustomTimeInput",
        "meditationPresetTimeButton",
        "meditationTimerPage",
        "minutesSleptInput",
        "moodCardMood",
        "moodCardTags",
        "moodCardTime",
        "moodList",
        "navButton",
        "resetPasswordPage",
        "signInLink",
        "signOutButton",
        "signOutConfirmButton",
        "sleepAddPage",
        "sleepAddSubmitButton",
        "sleepCardValue",
        "statsOverviewPage",
        "weightAddPage",
        "weightAddSubmitButton",
        "weightCardTime",
        "weightCardValue",
        "weightValueInput"
    ];
    const testIds = {};
    for (const key of keys)testIds[key] = key;
    return testIds;
})();
const $5a123094476b33d7$export$e6909ad44e61103d = {
    dateAwoke: {
        "data-test-id": $5a123094476b33d7$export$a2b4f255152a6585.dateAwokeInput,
        label: "Date you woke up",
        name: "date-awoke",
        type: "date"
    },
    description: {
        autoComplete: "on",
        "data-test-id": $5a123094476b33d7$export$a2b4f255152a6585.descriptionInput,
        label: "Mood tags",
        maxLength: $5a123094476b33d7$export$99e2532e676f9073,
        name: "description",
        optional: true,
        pattern: $5a123094476b33d7$export$1b1adb72711c28e5.noPunctuation,
        supportiveText: `Add one or more words separated by spaces to describe your mood (${$5a123094476b33d7$export$99e2532e676f9073} characters max). For example, "pensive" or "happy excited". These words will be used in your word clouds.`
    },
    exploration: {
        label: "Mood journal",
        name: "exploration",
        optional: true,
        rows: 5,
        supportiveText: "Use this space as a journal to explore how you're feeling, why you're feeling that way and what's going on in your life right now"
    },
    hoursSlept: {
        "data-test-id": $5a123094476b33d7$export$a2b4f255152a6585.hoursSleptInput,
        label: "Hours slept",
        name: "hours-slept"
    },
    minutesSlept: {
        "data-test-id": $5a123094476b33d7$export$a2b4f255152a6585.minutesSleptInput,
        label: "Minutes slept",
        name: "minutes-slept"
    },
    mood: {
        label: "Mood",
        name: "mood"
    },
    weight: {
        "data-test-id": $5a123094476b33d7$export$a2b4f255152a6585.weightValueInput,
        label: "Weight (kg)",
        max: 650,
        min: 0,
        name: "weight",
        style: {
            width: "6em"
        },
        step: 0.1,
        supportiveText: "The best time to weigh yourself is after you wake up",
        type: "number"
    }
};
const $5a123094476b33d7$export$543f9b8922278769 = {
    cacheTime: Infinity,
    networkMode: "offlineFirst",
    staleTime: $5a123094476b33d7$export$a9905336c0111a3a.secondsPerYear * 1e3
};
const $5a123094476b33d7$var$now = Date.now();
const $5a123094476b33d7$var$startOfWeekDate = (0, $f2ddddaabfe67186$export$42c81a444fbfb5d4)($5a123094476b33d7$var$now, (0, $06d17fa75ca1067f$export$34c88de16c0a2653));
const $5a123094476b33d7$var$weekdayDates = [
    (0, $cb8fdbef2aba70f2$export$dd412b56f1e4d8aa)($5a123094476b33d7$var$startOfWeekDate, 0),
    (0, $cb8fdbef2aba70f2$export$dd412b56f1e4d8aa)($5a123094476b33d7$var$startOfWeekDate, 1),
    (0, $cb8fdbef2aba70f2$export$dd412b56f1e4d8aa)($5a123094476b33d7$var$startOfWeekDate, 2),
    (0, $cb8fdbef2aba70f2$export$dd412b56f1e4d8aa)($5a123094476b33d7$var$startOfWeekDate, 3),
    (0, $cb8fdbef2aba70f2$export$dd412b56f1e4d8aa)($5a123094476b33d7$var$startOfWeekDate, 4),
    (0, $cb8fdbef2aba70f2$export$dd412b56f1e4d8aa)($5a123094476b33d7$var$startOfWeekDate, 5),
    (0, $cb8fdbef2aba70f2$export$dd412b56f1e4d8aa)($5a123094476b33d7$var$startOfWeekDate, 6)
];
const $5a123094476b33d7$export$9c4d3a9dc816779e = $5a123094476b33d7$var$weekdayDates.map((date)=>(0, $06d17fa75ca1067f$export$2c59d0e3b71c316).format(date));
const $5a123094476b33d7$export$6d6c4805e4b04e86 = $5a123094476b33d7$var$weekdayDates.map((date)=>(0, $06d17fa75ca1067f$export$a938dcff503049a5).format(date));



var $c2a4cc2adbf11eb9$var$name = "firebase";
var $c2a4cc2adbf11eb9$var$version = "10.9.0";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $2406031bebeb53d7$export$d29d5299a7137abc)($c2a4cc2adbf11eb9$var$name, $c2a4cc2adbf11eb9$var$version, "app");



const $062e278e0d1dc91c$var$PUBLIC_VAPID_KEY = "BBhO8kx_ynJrYpotsDiOmkL46BWjWyDkKmaa9OntpGZV3rNM9Vc1fycZQpCUcF01pgHeIFXC2Sy7fFdmD82Hz9g";
const $062e278e0d1dc91c$var$firebaseApp = (0, $2406031bebeb53d7$export$c55cfd413944906d)((0, $5a123094476b33d7$export$d550936f86997951));
const $062e278e0d1dc91c$var$messagingPromise = (0, $f0b1ff9a10cf7acb$export$48c17662a6902497)().then((supported)=>{
    if (!supported) return;
    const messaging = (0, $f0b1ff9a10cf7acb$export$f74c3c76482a8451)($062e278e0d1dc91c$var$firebaseApp);
    (0, $f0b1ff9a10cf7acb$export$7275a8dcb77dc20d)(messaging, (payload)=>{
        const notification = payload.notification;
        new Notification(notification.title, {
            badge: notification.icon,
            icon: notification.icon,
            body: notification.body,
            lang: "en"
        });
    });
    return messaging;
});
const $062e278e0d1dc91c$export$bd61301356cef08f = async ()=>{
    const serviceWorkerRegistration = await (0, $42836af780eac301$export$2e2bcd8739ae039);
    const messaging = await $062e278e0d1dc91c$var$messagingPromise;
    if (!messaging) throw Error("Firebase messaging is not supported in this browser");
    return (0, $f0b1ff9a10cf7acb$export$257b2d10b709d8ef)(messaging, {
        serviceWorkerRegistration: serviceWorkerRegistration,
        vapidKey: $062e278e0d1dc91c$var$PUBLIC_VAPID_KEY
    });
};


var $f6795297da7ea874$export$882461b6382ed46c;
var $f6795297da7ea874$export$757ceba2d55c277e;
"use strict";
var $cc4070eb400e02f6$exports = {};
"use strict";
function $cc4070eb400e02f6$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($cc4070eb400e02f6$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$cc4070eb400e02f6$var$checkDCE();

$cc4070eb400e02f6$exports = (parcelRequire("e0VS3"));


var $f6795297da7ea874$var$i;
$f6795297da7ea874$export$882461b6382ed46c = $cc4070eb400e02f6$exports.createRoot;
$f6795297da7ea874$export$757ceba2d55c277e = $cc4070eb400e02f6$exports.hydrateRoot;



var $lBnVc = parcelRequire("lBnVc");
// src/persist.ts

// src/hydration.ts
function $03c580dd35460e6d$var$dehydrateMutation(mutation) {
    return {
        mutationKey: mutation.options.mutationKey,
        state: mutation.state,
        ...mutation.meta && {
            meta: mutation.meta
        }
    };
}
function $03c580dd35460e6d$var$dehydrateQuery(query) {
    return {
        state: query.state,
        queryKey: query.queryKey,
        queryHash: query.queryHash,
        ...query.meta && {
            meta: query.meta
        }
    };
}
function $03c580dd35460e6d$export$3aa4c2840e01e53(mutation) {
    return mutation.state.isPaused;
}
function $03c580dd35460e6d$export$e71bc20295698fa1(query) {
    return query.state.status === "success";
}
function $03c580dd35460e6d$export$12aee8bb597e7dfe(client, options = {}) {
    const filterMutation = options.shouldDehydrateMutation ?? $03c580dd35460e6d$export$3aa4c2840e01e53;
    const mutations = client.getMutationCache().getAll().flatMap((mutation)=>filterMutation(mutation) ? [
            $03c580dd35460e6d$var$dehydrateMutation(mutation)
        ] : []);
    const filterQuery = options.shouldDehydrateQuery ?? $03c580dd35460e6d$export$e71bc20295698fa1;
    const queries = client.getQueryCache().getAll().flatMap((query)=>filterQuery(query) ? [
            $03c580dd35460e6d$var$dehydrateQuery(query)
        ] : []);
    return {
        mutations: mutations,
        queries: queries
    };
}
function $03c580dd35460e6d$export$fa8d919ba61d84db(client, dehydratedState, options) {
    if (typeof dehydratedState !== "object" || dehydratedState === null) return;
    const mutationCache = client.getMutationCache();
    const queryCache = client.getQueryCache();
    const mutations = dehydratedState.mutations || [];
    const queries = dehydratedState.queries || [];
    mutations.forEach((dehydratedMutation)=>{
        var _a;
        mutationCache.build(client, {
            ...(_a = options == null ? void 0 : options.defaultOptions) == null ? void 0 : _a.mutations,
            mutationKey: dehydratedMutation.mutationKey,
            meta: dehydratedMutation.meta
        }, dehydratedMutation.state);
    });
    queries.forEach(({ queryKey: queryKey, state: state, queryHash: queryHash, meta: meta })=>{
        var _a;
        const query = queryCache.get(queryHash);
        if (query) {
            if (query.state.dataUpdatedAt < state.dataUpdatedAt) {
                const { fetchStatus: _ignored, ...dehydratedQueryState } = state;
                query.setState(dehydratedQueryState);
            }
            return;
        }
        queryCache.build(client, {
            ...(_a = options == null ? void 0 : options.defaultOptions) == null ? void 0 : _a.queries,
            queryKey: queryKey,
            queryHash: queryHash,
            meta: meta
        }, // Reset fetch status to idle to avoid
        // query being stuck in fetching state upon hydration
        {
            ...state,
            fetchStatus: "idle"
        });
    });
}


var $a26f2e5a746b1629$var$cacheEventTypes = [
    "added",
    "removed",
    "updated"
];
function $a26f2e5a746b1629$var$isCacheEventType(eventType) {
    return $a26f2e5a746b1629$var$cacheEventTypes.includes(eventType);
}
async function $a26f2e5a746b1629$export$781eb0ebad7272a1({ queryClient: queryClient, persister: persister, maxAge: maxAge = 86400000, buster: buster = "", hydrateOptions: hydrateOptions }) {
    try {
        const persistedClient = await persister.restoreClient();
        if (persistedClient) {
            if (persistedClient.timestamp) {
                const expired = Date.now() - persistedClient.timestamp > maxAge;
                const busted = persistedClient.buster !== buster;
                if (expired || busted) persister.removeClient();
                else (0, $03c580dd35460e6d$export$fa8d919ba61d84db)(queryClient, persistedClient.clientState, hydrateOptions);
            } else persister.removeClient();
        }
    } catch (err) {
        persister.removeClient();
    }
}
async function $a26f2e5a746b1629$export$8a3b4786a14f2528({ queryClient: queryClient, persister: persister, buster: buster = "", dehydrateOptions: dehydrateOptions }) {
    const persistClient = {
        buster: buster,
        timestamp: Date.now(),
        clientState: (0, $03c580dd35460e6d$export$12aee8bb597e7dfe)(queryClient, dehydrateOptions)
    };
    await persister.persistClient(persistClient);
}
function $a26f2e5a746b1629$export$9fe01d80627be88c(props) {
    const unsubscribeQueryCache = props.queryClient.getQueryCache().subscribe((event)=>{
        if ($a26f2e5a746b1629$var$isCacheEventType(event.type)) $a26f2e5a746b1629$export$8a3b4786a14f2528(props);
    });
    const unsubscribeMutationCache = props.queryClient.getMutationCache().subscribe((event)=>{
        if ($a26f2e5a746b1629$var$isCacheEventType(event.type)) $a26f2e5a746b1629$export$8a3b4786a14f2528(props);
    });
    return ()=>{
        unsubscribeQueryCache();
        unsubscribeMutationCache();
    };
}
function $a26f2e5a746b1629$export$217ab42a80f50b3b(props) {
    let hasUnsubscribed = false;
    let persistQueryClientUnsubscribe;
    const unsubscribe = ()=>{
        hasUnsubscribed = true;
        persistQueryClientUnsubscribe == null || persistQueryClientUnsubscribe();
    };
    const restorePromise = $a26f2e5a746b1629$export$781eb0ebad7272a1(props).then(()=>{
        if (!hasUnsubscribed) persistQueryClientUnsubscribe = $a26f2e5a746b1629$export$9fe01d80627be88c(props);
    });
    return [
        unsubscribe,
        restorePromise
    ];
}



var $lBnVc = parcelRequire("lBnVc");
"use client";
var $795bf5151991f2b5$var$IsRestoringContext = $lBnVc.createContext(false);
var $795bf5151991f2b5$export$4da0178d6b5f553 = ()=>$lBnVc.useContext($795bf5151991f2b5$var$IsRestoringContext);
var $795bf5151991f2b5$export$593807d4e94f9621 = $795bf5151991f2b5$var$IsRestoringContext.Provider;


var $lBnVc = parcelRequire("lBnVc");

"use client";
var $a0b182cf42560d7a$export$da112d31b0149f31 = $lBnVc.createContext(void 0);
var $a0b182cf42560d7a$export$22e77b9572c4fded = (queryClient)=>{
    const client = $lBnVc.useContext($a0b182cf42560d7a$export$da112d31b0149f31);
    if (queryClient) return queryClient;
    if (!client) throw new Error("No QueryClient set, use QueryClientProvider to set one");
    return client;
};
var $a0b182cf42560d7a$export$45604f0cc8ae667b = ({ client: client, children: children })=>{
    $lBnVc.useEffect(()=>{
        client.mount();
        return ()=>{
            client.unmount();
        };
    }, [
        client
    ]);
    return /* @__PURE__ */ (0, $c0c9bc5c50648c54$exports.jsx)($a0b182cf42560d7a$export$da112d31b0149f31.Provider, {
        value: client,
        children: children
    });
};



"use client";
var $e17d4e73c83178d1$export$9d736f54481e482f = ({ client: client, children: children, persistOptions: persistOptions, onSuccess: onSuccess, ...props })=>{
    const [isRestoring, setIsRestoring] = $lBnVc.useState(true);
    const refs = $lBnVc.useRef({
        persistOptions: persistOptions,
        onSuccess: onSuccess
    });
    const didRestore = $lBnVc.useRef(false);
    $lBnVc.useEffect(()=>{
        refs.current = {
            persistOptions: persistOptions,
            onSuccess: onSuccess
        };
    });
    $lBnVc.useEffect(()=>{
        const options = {
            ...refs.current.persistOptions,
            queryClient: client
        };
        if (!didRestore.current) {
            didRestore.current = true;
            setIsRestoring(true);
            (0, $a26f2e5a746b1629$export$781eb0ebad7272a1)(options).then(async ()=>{
                var _a, _b;
                try {
                    await ((_b = (_a = refs.current).onSuccess) == null ? void 0 : _b.call(_a));
                } finally{
                    setIsRestoring(false);
                }
            });
        }
        return isRestoring ? void 0 : (0, $a26f2e5a746b1629$export$9fe01d80627be88c)(options);
    }, [
        client,
        isRestoring
    ]);
    return /* @__PURE__ */ (0, $c0c9bc5c50648c54$exports.jsx)((0, $a0b182cf42560d7a$export$45604f0cc8ae667b), {
        client: client,
        ...props,
        children: /* @__PURE__ */ (0, $c0c9bc5c50648c54$exports.jsx)((0, $795bf5151991f2b5$export$593807d4e94f9621), {
            value: isRestoring,
            children: children
        })
    });
};

// src/retryStrategies.ts
var $fb9419627ca4844a$export$bfdae6a8e31d44db = ({ persistedClient: persistedClient })=>{
    const mutations = [
        ...persistedClient.clientState.mutations
    ];
    const queries = [
        ...persistedClient.clientState.queries
    ];
    const client = {
        ...persistedClient,
        clientState: {
            mutations: mutations,
            queries: queries
        }
    };
    const sortedQueries = [
        ...queries
    ].sort((a, b)=>a.state.dataUpdatedAt - b.state.dataUpdatedAt);
    if (sortedQueries.length > 0) {
        const oldestData = sortedQueries.shift();
        client.clientState.queries = queries.filter((q)=>q !== oldestData);
        return client;
    }
    return void 0;
};


function $a79fa34021646067$var$_slicedToArray(arr, i) {
    return $a79fa34021646067$var$_arrayWithHoles(arr) || $a79fa34021646067$var$_iterableToArrayLimit(arr, i) || $a79fa34021646067$var$_unsupportedIterableToArray(arr, i) || $a79fa34021646067$var$_nonIterableRest();
}
function $a79fa34021646067$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a79fa34021646067$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $a79fa34021646067$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $a79fa34021646067$var$_arrayLikeToArray(o, minLen);
}
function $a79fa34021646067$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $a79fa34021646067$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $a79fa34021646067$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $a79fa34021646067$export$b327150396135fe7(request) {
    return new Promise(function(resolve, reject) {
        // @ts-ignore - file size hacks
        request.oncomplete = request.onsuccess = function() {
            return resolve(request.result);
        }; // @ts-ignore - file size hacks
        request.onabort = request.onerror = function() {
            return reject(request.error);
        };
    });
}
function $a79fa34021646067$export$f51a9068ac82ea43(dbName, storeName) {
    var request = indexedDB.open(dbName);
    request.onupgradeneeded = function() {
        return request.result.createObjectStore(storeName);
    };
    var dbp = $a79fa34021646067$export$b327150396135fe7(request);
    return function(txMode, callback) {
        return dbp.then(function(db) {
            return callback(db.transaction(storeName, txMode).objectStore(storeName));
        });
    };
}
var $a79fa34021646067$var$defaultGetStoreFunc;
function $a79fa34021646067$var$defaultGetStore() {
    if (!$a79fa34021646067$var$defaultGetStoreFunc) $a79fa34021646067$var$defaultGetStoreFunc = $a79fa34021646067$export$f51a9068ac82ea43("keyval-store", "keyval");
    return $a79fa34021646067$var$defaultGetStoreFunc;
}
/**
 * Get a value by its key.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $a79fa34021646067$export$3988ae62b71be9a3(key) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $a79fa34021646067$var$defaultGetStore();
    return customStore("readonly", function(store) {
        return $a79fa34021646067$export$b327150396135fe7(store.get(key));
    });
}
/**
 * Set a value with a key.
 *
 * @param key
 * @param value
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $a79fa34021646067$export$adaa4cf7ef1b65be(key, value) {
    var customStore = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $a79fa34021646067$var$defaultGetStore();
    return customStore("readwrite", function(store) {
        store.put(value, key);
        return $a79fa34021646067$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Set multiple values at once. This is faster than calling set() multiple times.
 * It's also atomic – if one of the pairs can't be added, none will be added.
 *
 * @param entries Array of entries, where each entry is an array of `[key, value]`.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $a79fa34021646067$export$daa0a5170277c7a8(entries) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $a79fa34021646067$var$defaultGetStore();
    return customStore("readwrite", function(store) {
        entries.forEach(function(entry) {
            return store.put(entry[1], entry[0]);
        });
        return $a79fa34021646067$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Get multiple values by their keys
 *
 * @param keys
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $a79fa34021646067$export$5df405cccea42673(keys) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $a79fa34021646067$var$defaultGetStore();
    return customStore("readonly", function(store) {
        return Promise.all(keys.map(function(key) {
            return $a79fa34021646067$export$b327150396135fe7(store.get(key));
        }));
    });
}
/**
 * Update a value. This lets you see the old value and update it as an atomic operation.
 *
 * @param key
 * @param updater A callback that takes the old value and returns a new value.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $a79fa34021646067$export$722fbec263ad908a(key, updater) {
    var customStore = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $a79fa34021646067$var$defaultGetStore();
    return customStore("readwrite", function(store) {
        return(// If I try to chain promises, the transaction closes in browsers
        // that use a promise polyfill (IE10/11).
        new Promise(function(resolve, reject) {
            store.get(key).onsuccess = function() {
                try {
                    store.put(updater(this.result), key);
                    resolve($a79fa34021646067$export$b327150396135fe7(store.transaction));
                } catch (err) {
                    reject(err);
                }
            };
        }));
    });
}
/**
 * Delete a particular key from the store.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $a79fa34021646067$export$1d2f21e549771e67(key) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $a79fa34021646067$var$defaultGetStore();
    return customStore("readwrite", function(store) {
        store.delete(key);
        return $a79fa34021646067$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Delete multiple keys at once.
 *
 * @param keys List of keys to delete.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $a79fa34021646067$export$c8aa84257229cac8(keys) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $a79fa34021646067$var$defaultGetStore();
    return customStore("readwrite", function(store) {
        keys.forEach(function(key) {
            return store.delete(key);
        });
        return $a79fa34021646067$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Clear all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $a79fa34021646067$export$42ffd38884aecdac() {
    var customStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $a79fa34021646067$var$defaultGetStore();
    return customStore("readwrite", function(store) {
        store.clear();
        return $a79fa34021646067$export$b327150396135fe7(store.transaction);
    });
}
function $a79fa34021646067$var$eachCursor(store, callback) {
    store.openCursor().onsuccess = function() {
        if (!this.result) return;
        callback(this.result);
        this.result.continue();
    };
    return $a79fa34021646067$export$b327150396135fe7(store.transaction);
}
/**
 * Get all keys in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $a79fa34021646067$export$ed97f33186d4b816() {
    var customStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $a79fa34021646067$var$defaultGetStore();
    return customStore("readonly", function(store) {
        // Fast path for modern browsers
        if (store.getAllKeys) return $a79fa34021646067$export$b327150396135fe7(store.getAllKeys());
        var items = [];
        return $a79fa34021646067$var$eachCursor(store, function(cursor) {
            return items.push(cursor.key);
        }).then(function() {
            return items;
        });
    });
}
/**
 * Get all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $a79fa34021646067$export$68c286be0e7e55b7() {
    var customStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $a79fa34021646067$var$defaultGetStore();
    return customStore("readonly", function(store) {
        // Fast path for modern browsers
        if (store.getAll) return $a79fa34021646067$export$b327150396135fe7(store.getAll());
        var items = [];
        return $a79fa34021646067$var$eachCursor(store, function(cursor) {
            return items.push(cursor.value);
        }).then(function() {
            return items;
        });
    });
}
/**
 * Get all entries in the store. Each entry is an array of `[key, value]`.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $a79fa34021646067$export$3e9f948b41964866() {
    var customStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $a79fa34021646067$var$defaultGetStore();
    return customStore("readonly", function(store) {
        // Fast path for modern browsers
        // (although, hopefully we'll get a simpler path some day)
        if (store.getAll && store.getAllKeys) return Promise.all([
            $a79fa34021646067$export$b327150396135fe7(store.getAllKeys()),
            $a79fa34021646067$export$b327150396135fe7(store.getAll())
        ]).then(function(_ref) {
            var _ref2 = $a79fa34021646067$var$_slicedToArray(_ref, 2), keys = _ref2[0], values = _ref2[1];
            return keys.map(function(key, i) {
                return [
                    key,
                    values[i]
                ];
            });
        });
        var items = [];
        return customStore("readonly", function(store) {
            return $a79fa34021646067$var$eachCursor(store, function(cursor) {
                return items.push([
                    cursor.key,
                    cursor.value
                ]);
            }).then(function() {
                return items;
            });
        });
    });
}



var $82bb902b93e9fce2$var$__accessCheck = (obj, member, msg)=>{
    if (!member.has(obj)) throw TypeError("Cannot " + msg);
};
var $82bb902b93e9fce2$export$18a094aefa070634 = (obj, member, getter)=>{
    $82bb902b93e9fce2$var$__accessCheck(obj, member, "read from private field");
    return getter ? getter.call(obj) : member.get(obj);
};
var $82bb902b93e9fce2$export$addf369becd23283 = (obj, member, value1)=>{
    if (member.has(obj)) throw TypeError("Cannot add the same private member more than once");
    member instanceof WeakSet ? member.add(obj) : member.set(obj, value1);
};
var $82bb902b93e9fce2$export$42432efe6614d3b4 = (obj, member, value1, setter)=>{
    $82bb902b93e9fce2$var$__accessCheck(obj, member, "write to private field");
    setter ? setter.call(obj, value1) : member.set(obj, value1);
    return value1;
};
var $82bb902b93e9fce2$export$b1fe7cbb4502036b = (obj, member, setter, getter)=>({
        set _ (value){
            $82bb902b93e9fce2$export$42432efe6614d3b4(obj, member, value, setter);
        },
        get _ () {
            return $82bb902b93e9fce2$export$18a094aefa070634(obj, member, getter);
        }
    });
var $82bb902b93e9fce2$export$fa92d15b718fce20 = (obj, member, method)=>{
    $82bb902b93e9fce2$var$__accessCheck(obj, member, "access private method");
    return method;
};



// src/utils.ts
var $58dc61dd9f062c44$export$6acf61af03e62db = typeof window === "undefined" || "Deno" in globalThis;
function $58dc61dd9f062c44$export$8793edee2d425525() {
    return void 0;
}
function $58dc61dd9f062c44$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === "function" ? updater(input) : updater;
}
function $58dc61dd9f062c44$export$e539f754e934e270(value) {
    return typeof value === "number" && value >= 0 && value !== Infinity;
}
function $58dc61dd9f062c44$export$811b83d62bcf47f0(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function $58dc61dd9f062c44$export$c5d1efe363797780(filters, query) {
    const { type: type = "all", exact: exact, fetchStatus: fetchStatus, predicate: predicate, queryKey: queryKey, stale: stale } = filters;
    if (queryKey) {
        if (exact) {
            if (query.queryHash !== $58dc61dd9f062c44$export$cc90ca97bc0d73fd(queryKey, query.options)) return false;
        } else if (!$58dc61dd9f062c44$export$2f07189bb9fa26a7(query.queryKey, queryKey)) return false;
    }
    if (type !== "all") {
        const isActive = query.isActive();
        if (type === "active" && !isActive) return false;
        if (type === "inactive" && isActive) return false;
    }
    if (typeof stale === "boolean" && query.isStale() !== stale) return false;
    if (fetchStatus && fetchStatus !== query.state.fetchStatus) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function $58dc61dd9f062c44$export$a1ea5fb559f63ae3(filters, mutation) {
    const { exact: exact, status: status, predicate: predicate, mutationKey: mutationKey } = filters;
    if (mutationKey) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if ($58dc61dd9f062c44$export$1e87d19d4aab5805(mutation.options.mutationKey) !== $58dc61dd9f062c44$export$1e87d19d4aab5805(mutationKey)) return false;
        } else if (!$58dc61dd9f062c44$export$2f07189bb9fa26a7(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (status && mutation.state.status !== status) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function $58dc61dd9f062c44$export$cc90ca97bc0d73fd(queryKey, options) {
    const hashFn = (options == null ? void 0 : options.queryKeyHashFn) || $58dc61dd9f062c44$export$1e87d19d4aab5805;
    return hashFn(queryKey);
}
function $58dc61dd9f062c44$export$1e87d19d4aab5805(queryKey) {
    return JSON.stringify(queryKey, (_, val)=>$58dc61dd9f062c44$export$53b83ca8eaab0383(val) ? Object.keys(val).sort().reduce((result, key)=>{
            result[key] = val[key];
            return result;
        }, {}) : val);
}
function $58dc61dd9f062c44$export$2f07189bb9fa26a7(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === "object" && typeof b === "object") return !Object.keys(b).some((key)=>!$58dc61dd9f062c44$export$2f07189bb9fa26a7(a[key], b[key]));
    return false;
}
function $58dc61dd9f062c44$export$77a71fc411098696(a, b) {
    if (a === b) return a;
    const array = $58dc61dd9f062c44$export$7a8558113332b71e(a) && $58dc61dd9f062c44$export$7a8558113332b71e(b);
    if (array || $58dc61dd9f062c44$export$53b83ca8eaab0383(a) && $58dc61dd9f062c44$export$53b83ca8eaab0383(b)) {
        const aItems = array ? a : Object.keys(a);
        const aSize = aItems.length;
        const bItems = array ? b : Object.keys(b);
        const bSize = bItems.length;
        const copy = array ? [] : {};
        let equalItems = 0;
        for(let i = 0; i < bSize; i++){
            const key = array ? i : bItems[i];
            if (!array && a[key] === void 0 && b[key] === void 0 && aItems.includes(key)) {
                copy[key] = void 0;
                equalItems++;
            } else {
                copy[key] = $58dc61dd9f062c44$export$77a71fc411098696(a[key], b[key]);
                if (copy[key] === a[key] && a[key] !== void 0) equalItems++;
            }
        }
        return aSize === bSize && equalItems === aSize ? a : copy;
    }
    return b;
}
function $58dc61dd9f062c44$export$3e67810a3f0e9f1c(a, b) {
    if (!b || Object.keys(a).length !== Object.keys(b).length) return false;
    for(const key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
}
function $58dc61dd9f062c44$export$7a8558113332b71e(value) {
    return Array.isArray(value) && value.length === Object.keys(value).length;
}
function $58dc61dd9f062c44$export$53b83ca8eaab0383(o) {
    if (!$58dc61dd9f062c44$var$hasObjectPrototype(o)) return false;
    const ctor = o.constructor;
    if (ctor === void 0) return true;
    const prot = ctor.prototype;
    if (!$58dc61dd9f062c44$var$hasObjectPrototype(prot)) return false;
    if (!prot.hasOwnProperty("isPrototypeOf")) return false;
    return true;
}
function $58dc61dd9f062c44$var$hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
function $58dc61dd9f062c44$export$e772c8ff12451969(ms) {
    return new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
}
function $58dc61dd9f062c44$export$17619bac5b909b23(prevData, data, options) {
    if (typeof options.structuralSharing === "function") return options.structuralSharing(prevData, data);
    else if (options.structuralSharing !== false) return $58dc61dd9f062c44$export$77a71fc411098696(prevData, data);
    return data;
}
function $58dc61dd9f062c44$export$f537417e7e421eac(previousData) {
    return previousData;
}
function $58dc61dd9f062c44$export$ccce65a22a26f2bc(items, item, max = 0) {
    const newItems = [
        ...items,
        item
    ];
    return max && newItems.length > max ? newItems.slice(1) : newItems;
}
function $58dc61dd9f062c44$export$8c6246b73dd61f4a(items, item, max = 0) {
    const newItems = [
        item,
        ...items
    ];
    return max && newItems.length > max ? newItems.slice(0, -1) : newItems;
}
var $58dc61dd9f062c44$export$1aa5a89531b7670d = Symbol();







// src/notifyManager.ts
function $21dd3588127ff3f9$export$316a8efd03cd1458() {
    let queue = [];
    let transactions = 0;
    let notifyFn = (callback)=>{
        callback();
    };
    let batchNotifyFn = (callback)=>{
        callback();
    };
    let scheduleFn = (cb)=>setTimeout(cb, 0);
    const setScheduler = (fn)=>{
        scheduleFn = fn;
    };
    const batch = (callback)=>{
        let result;
        transactions++;
        try {
            result = callback();
        } finally{
            transactions--;
            if (!transactions) flush();
        }
        return result;
    };
    const schedule = (callback)=>{
        if (transactions) queue.push(callback);
        else scheduleFn(()=>{
            notifyFn(callback);
        });
    };
    const batchCalls = (callback)=>{
        return (...args)=>{
            schedule(()=>{
                callback(...args);
            });
        };
    };
    const flush = ()=>{
        const originalQueue = queue;
        queue = [];
        if (originalQueue.length) scheduleFn(()=>{
            batchNotifyFn(()=>{
                originalQueue.forEach((callback)=>{
                    notifyFn(callback);
                });
            });
        });
    };
    const setNotifyFunction = (fn)=>{
        notifyFn = fn;
    };
    const setBatchNotifyFunction = (fn)=>{
        batchNotifyFn = fn;
    };
    return {
        batch: batch,
        batchCalls: batchCalls,
        schedule: schedule,
        setNotifyFunction: setNotifyFunction,
        setBatchNotifyFunction: setBatchNotifyFunction,
        setScheduler: setScheduler
    };
}
var $21dd3588127ff3f9$export$520687f44db6e1ab = $21dd3588127ff3f9$export$316a8efd03cd1458();





// src/subscribable.ts
var $f619992c377f98ae$export$d26086b469ecdbcc = class {
    constructor(){
        this.listeners = /* @__PURE__ */ new Set();
        this.subscribe = this.subscribe.bind(this);
    }
    subscribe(listener) {
        this.listeners.add(listener);
        this.onSubscribe();
        return ()=>{
            this.listeners.delete(listener);
            this.onUnsubscribe();
        };
    }
    hasListeners() {
        return this.listeners.size > 0;
    }
    onSubscribe() {}
    onUnsubscribe() {}
};



var $c8420f591c39a8bc$var$_focused, $c8420f591c39a8bc$var$_cleanup, $c8420f591c39a8bc$var$_setup;
var $c8420f591c39a8bc$export$86f1af424b2ca4de = class extends (0, $f619992c377f98ae$export$d26086b469ecdbcc) {
    constructor(){
        super();
        (0, $82bb902b93e9fce2$export$addf369becd23283)(this, $c8420f591c39a8bc$var$_focused, void 0);
        (0, $82bb902b93e9fce2$export$addf369becd23283)(this, $c8420f591c39a8bc$var$_cleanup, void 0);
        (0, $82bb902b93e9fce2$export$addf369becd23283)(this, $c8420f591c39a8bc$var$_setup, void 0);
        (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $c8420f591c39a8bc$var$_setup, (onFocus)=>{
            if (!(0, $58dc61dd9f062c44$export$6acf61af03e62db) && window.addEventListener) {
                const listener = ()=>onFocus();
                window.addEventListener("visibilitychange", listener, false);
                return ()=>{
                    window.removeEventListener("visibilitychange", listener);
                };
            }
            return;
        });
    }
    onSubscribe() {
        if (!(0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $c8420f591c39a8bc$var$_cleanup)) this.setEventListener((0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $c8420f591c39a8bc$var$_setup));
    }
    onUnsubscribe() {
        var _a;
        if (!this.hasListeners()) {
            (_a = (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $c8420f591c39a8bc$var$_cleanup)) == null || _a.call(this);
            (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $c8420f591c39a8bc$var$_cleanup, void 0);
        }
    }
    setEventListener(setup) {
        var _a;
        (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $c8420f591c39a8bc$var$_setup, setup);
        (_a = (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $c8420f591c39a8bc$var$_cleanup)) == null || _a.call(this);
        (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $c8420f591c39a8bc$var$_cleanup, setup((focused)=>{
            if (typeof focused === "boolean") this.setFocused(focused);
            else this.onFocus();
        }));
    }
    setFocused(focused) {
        const changed = (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $c8420f591c39a8bc$var$_focused) !== focused;
        if (changed) {
            (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $c8420f591c39a8bc$var$_focused, focused);
            this.onFocus();
        }
    }
    onFocus() {
        const isFocused = this.isFocused();
        this.listeners.forEach((listener)=>{
            listener(isFocused);
        });
    }
    isFocused() {
        var _a;
        if (typeof (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $c8420f591c39a8bc$var$_focused) === "boolean") return (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $c8420f591c39a8bc$var$_focused);
        return ((_a = globalThis.document) == null ? void 0 : _a.visibilityState) !== "hidden";
    }
};
$c8420f591c39a8bc$var$_focused = new WeakMap();
$c8420f591c39a8bc$var$_cleanup = new WeakMap();
$c8420f591c39a8bc$var$_setup = new WeakMap();
var $c8420f591c39a8bc$export$6bf54661be5b02cf = new $c8420f591c39a8bc$export$86f1af424b2ca4de();





var $5007855dfbc75886$var$_online, $5007855dfbc75886$var$_cleanup, $5007855dfbc75886$var$_setup;
var $5007855dfbc75886$export$58774fb55d5ff7fc = class extends (0, $f619992c377f98ae$export$d26086b469ecdbcc) {
    constructor(){
        super();
        (0, $82bb902b93e9fce2$export$addf369becd23283)(this, $5007855dfbc75886$var$_online, true);
        (0, $82bb902b93e9fce2$export$addf369becd23283)(this, $5007855dfbc75886$var$_cleanup, void 0);
        (0, $82bb902b93e9fce2$export$addf369becd23283)(this, $5007855dfbc75886$var$_setup, void 0);
        (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $5007855dfbc75886$var$_setup, (onOnline)=>{
            if (!(0, $58dc61dd9f062c44$export$6acf61af03e62db) && window.addEventListener) {
                const onlineListener = ()=>onOnline(true);
                const offlineListener = ()=>onOnline(false);
                window.addEventListener("online", onlineListener, false);
                window.addEventListener("offline", offlineListener, false);
                return ()=>{
                    window.removeEventListener("online", onlineListener);
                    window.removeEventListener("offline", offlineListener);
                };
            }
            return;
        });
    }
    onSubscribe() {
        if (!(0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $5007855dfbc75886$var$_cleanup)) this.setEventListener((0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $5007855dfbc75886$var$_setup));
    }
    onUnsubscribe() {
        var _a;
        if (!this.hasListeners()) {
            (_a = (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $5007855dfbc75886$var$_cleanup)) == null || _a.call(this);
            (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $5007855dfbc75886$var$_cleanup, void 0);
        }
    }
    setEventListener(setup) {
        var _a;
        (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $5007855dfbc75886$var$_setup, setup);
        (_a = (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $5007855dfbc75886$var$_cleanup)) == null || _a.call(this);
        (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $5007855dfbc75886$var$_cleanup, setup(this.setOnline.bind(this)));
    }
    setOnline(online) {
        const changed = (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $5007855dfbc75886$var$_online) !== online;
        if (changed) {
            (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $5007855dfbc75886$var$_online, online);
            this.listeners.forEach((listener)=>{
                listener(online);
            });
        }
    }
    isOnline() {
        return (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $5007855dfbc75886$var$_online);
    }
};
$5007855dfbc75886$var$_online = new WeakMap();
$5007855dfbc75886$var$_cleanup = new WeakMap();
$5007855dfbc75886$var$_setup = new WeakMap();
var $5007855dfbc75886$export$b113e788b2dd3fdc = new $5007855dfbc75886$export$58774fb55d5ff7fc();



function $58dd9a6f7206d3ba$var$defaultRetryDelay(failureCount) {
    return Math.min(1e3 * 2 ** failureCount, 3e4);
}
function $58dd9a6f7206d3ba$export$61b92f63f30245cf(networkMode) {
    return (networkMode ?? "online") === "online" ? (0, $5007855dfbc75886$export$b113e788b2dd3fdc).isOnline() : true;
}
var $58dd9a6f7206d3ba$export$a8430ed4188f35a9 = class {
    constructor(options){
        this.revert = options == null ? void 0 : options.revert;
        this.silent = options == null ? void 0 : options.silent;
    }
};
function $58dd9a6f7206d3ba$export$986cc6445c1d323(value) {
    return value instanceof $58dd9a6f7206d3ba$export$a8430ed4188f35a9;
}
function $58dd9a6f7206d3ba$export$2cbd00fe8a2c8d85(config) {
    let isRetryCancelled = false;
    let failureCount = 0;
    let isResolved = false;
    let continueFn;
    let promiseResolve;
    let promiseReject;
    const promise = new Promise((outerResolve, outerReject)=>{
        promiseResolve = outerResolve;
        promiseReject = outerReject;
    });
    const cancel = (cancelOptions)=>{
        var _a;
        if (!isResolved) {
            reject(new $58dd9a6f7206d3ba$export$a8430ed4188f35a9(cancelOptions));
            (_a = config.abort) == null || _a.call(config);
        }
    };
    const cancelRetry = ()=>{
        isRetryCancelled = true;
    };
    const continueRetry = ()=>{
        isRetryCancelled = false;
    };
    const shouldPause = ()=>!(0, $c8420f591c39a8bc$export$6bf54661be5b02cf).isFocused() || config.networkMode !== "always" && !(0, $5007855dfbc75886$export$b113e788b2dd3fdc).isOnline();
    const resolve = (value)=>{
        var _a;
        if (!isResolved) {
            isResolved = true;
            (_a = config.onSuccess) == null || _a.call(config, value);
            continueFn == null || continueFn();
            promiseResolve(value);
        }
    };
    const reject = (value)=>{
        var _a;
        if (!isResolved) {
            isResolved = true;
            (_a = config.onError) == null || _a.call(config, value);
            continueFn == null || continueFn();
            promiseReject(value);
        }
    };
    const pause = ()=>{
        return new Promise((continueResolve)=>{
            var _a;
            continueFn = (value)=>{
                const canContinue = isResolved || !shouldPause();
                if (canContinue) continueResolve(value);
                return canContinue;
            };
            (_a = config.onPause) == null || _a.call(config);
        }).then(()=>{
            var _a;
            continueFn = void 0;
            if (!isResolved) (_a = config.onContinue) == null || _a.call(config);
        });
    };
    const run = ()=>{
        if (isResolved) return;
        let promiseOrValue;
        try {
            promiseOrValue = config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        }
        Promise.resolve(promiseOrValue).then(resolve).catch((error)=>{
            var _a;
            if (isResolved) return;
            const retry = config.retry ?? ((0, $58dc61dd9f062c44$export$6acf61af03e62db) ? 0 : 3);
            const retryDelay = config.retryDelay ?? $58dd9a6f7206d3ba$var$defaultRetryDelay;
            const delay = typeof retryDelay === "function" ? retryDelay(failureCount, error) : retryDelay;
            const shouldRetry = retry === true || typeof retry === "number" && failureCount < retry || typeof retry === "function" && retry(failureCount, error);
            if (isRetryCancelled || !shouldRetry) {
                reject(error);
                return;
            }
            failureCount++;
            (_a = config.onFail) == null || _a.call(config, failureCount, error);
            (0, $58dc61dd9f062c44$export$e772c8ff12451969)(delay).then(()=>{
                if (shouldPause()) return pause();
                return;
            }).then(()=>{
                if (isRetryCancelled) reject(error);
                else run();
            });
        });
    };
    if ($58dd9a6f7206d3ba$export$61b92f63f30245cf(config.networkMode)) run();
    else pause().then(run);
    return {
        promise: promise,
        cancel: cancel,
        continue: ()=>{
            const didContinue = continueFn == null ? void 0 : continueFn();
            return didContinue ? promise : Promise.resolve();
        },
        cancelRetry: cancelRetry,
        continueRetry: continueRetry
    };
}




var $d891b6039ad954d1$var$_gcTimeout;
var $d891b6039ad954d1$export$e09608847fcc8c59 = class {
    constructor(){
        (0, $82bb902b93e9fce2$export$addf369becd23283)(this, $d891b6039ad954d1$var$_gcTimeout, void 0);
    }
    destroy() {
        this.clearGcTimeout();
    }
    scheduleGc() {
        this.clearGcTimeout();
        if ((0, $58dc61dd9f062c44$export$e539f754e934e270)(this.gcTime)) (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $d891b6039ad954d1$var$_gcTimeout, setTimeout(()=>{
            this.optionalRemove();
        }, this.gcTime));
    }
    updateGcTime(newGcTime) {
        this.gcTime = Math.max(this.gcTime || 0, newGcTime ?? ((0, $58dc61dd9f062c44$export$6acf61af03e62db) ? Infinity : 300000));
    }
    clearGcTimeout() {
        if ((0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $d891b6039ad954d1$var$_gcTimeout)) {
            clearTimeout((0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $d891b6039ad954d1$var$_gcTimeout));
            (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $d891b6039ad954d1$var$_gcTimeout, void 0);
        }
    }
};
$d891b6039ad954d1$var$_gcTimeout = new WeakMap();


var $670d1234511b9450$var$_initialState, $670d1234511b9450$var$_revertState, $670d1234511b9450$var$_cache, $670d1234511b9450$var$_retryer, $670d1234511b9450$var$_observers, $670d1234511b9450$var$_defaultOptions, $670d1234511b9450$var$_abortSignalConsumed, $670d1234511b9450$var$_dispatch, $670d1234511b9450$var$dispatch_fn;
var $670d1234511b9450$export$62297b13309008b2 = class extends (0, $d891b6039ad954d1$export$e09608847fcc8c59) {
    constructor(config){
        super();
        (0, $82bb902b93e9fce2$export$addf369becd23283)(this, $670d1234511b9450$var$_dispatch);
        (0, $82bb902b93e9fce2$export$addf369becd23283)(this, $670d1234511b9450$var$_initialState, void 0);
        (0, $82bb902b93e9fce2$export$addf369becd23283)(this, $670d1234511b9450$var$_revertState, void 0);
        (0, $82bb902b93e9fce2$export$addf369becd23283)(this, $670d1234511b9450$var$_cache, void 0);
        (0, $82bb902b93e9fce2$export$addf369becd23283)(this, $670d1234511b9450$var$_retryer, void 0);
        (0, $82bb902b93e9fce2$export$addf369becd23283)(this, $670d1234511b9450$var$_observers, void 0);
        (0, $82bb902b93e9fce2$export$addf369becd23283)(this, $670d1234511b9450$var$_defaultOptions, void 0);
        (0, $82bb902b93e9fce2$export$addf369becd23283)(this, $670d1234511b9450$var$_abortSignalConsumed, void 0);
        (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $670d1234511b9450$var$_abortSignalConsumed, false);
        (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $670d1234511b9450$var$_defaultOptions, config.defaultOptions);
        this.setOptions(config.options);
        (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $670d1234511b9450$var$_observers, []);
        (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $670d1234511b9450$var$_cache, config.cache);
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $670d1234511b9450$var$_initialState, config.state || $670d1234511b9450$var$getDefaultState(this.options));
        this.state = (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $670d1234511b9450$var$_initialState);
        this.scheduleGc();
    }
    get meta() {
        return this.options.meta;
    }
    setOptions(options) {
        this.options = {
            ...(0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $670d1234511b9450$var$_defaultOptions),
            ...options
        };
        this.updateGcTime(this.options.gcTime);
    }
    optionalRemove() {
        if (!(0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $670d1234511b9450$var$_observers).length && this.state.fetchStatus === "idle") (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $670d1234511b9450$var$_cache).remove(this);
    }
    setData(newData, options) {
        const data = (0, $58dc61dd9f062c44$export$17619bac5b909b23)(this.state.data, newData, this.options);
        (0, $82bb902b93e9fce2$export$fa92d15b718fce20)(this, $670d1234511b9450$var$_dispatch, $670d1234511b9450$var$dispatch_fn).call(this, {
            data: data,
            type: "success",
            dataUpdatedAt: options == null ? void 0 : options.updatedAt,
            manual: options == null ? void 0 : options.manual
        });
        return data;
    }
    setState(state, setStateOptions) {
        (0, $82bb902b93e9fce2$export$fa92d15b718fce20)(this, $670d1234511b9450$var$_dispatch, $670d1234511b9450$var$dispatch_fn).call(this, {
            type: "setState",
            state: state,
            setStateOptions: setStateOptions
        });
    }
    cancel(options) {
        var _a, _b;
        const promise = (_a = (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $670d1234511b9450$var$_retryer)) == null ? void 0 : _a.promise;
        (_b = (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $670d1234511b9450$var$_retryer)) == null || _b.cancel(options);
        return promise ? promise.then((0, $58dc61dd9f062c44$export$8793edee2d425525)).catch((0, $58dc61dd9f062c44$export$8793edee2d425525)) : Promise.resolve();
    }
    destroy() {
        super.destroy();
        this.cancel({
            silent: true
        });
    }
    reset() {
        this.destroy();
        this.setState((0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $670d1234511b9450$var$_initialState));
    }
    isActive() {
        return (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $670d1234511b9450$var$_observers).some((observer)=>observer.options.enabled !== false);
    }
    isDisabled() {
        return this.getObserversCount() > 0 && !this.isActive();
    }
    isStale() {
        if (this.state.isInvalidated) return true;
        if (this.getObserversCount() > 0) return (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $670d1234511b9450$var$_observers).some((observer)=>observer.getCurrentResult().isStale);
        return this.state.data === void 0;
    }
    isStaleByTime(staleTime = 0) {
        return this.state.isInvalidated || this.state.data === void 0 || !(0, $58dc61dd9f062c44$export$811b83d62bcf47f0)(this.state.dataUpdatedAt, staleTime);
    }
    onFocus() {
        var _a;
        const observer = (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $670d1234511b9450$var$_observers).find((x)=>x.shouldFetchOnWindowFocus());
        observer == null || observer.refetch({
            cancelRefetch: false
        });
        (_a = (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $670d1234511b9450$var$_retryer)) == null || _a.continue();
    }
    onOnline() {
        var _a;
        const observer = (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $670d1234511b9450$var$_observers).find((x)=>x.shouldFetchOnReconnect());
        observer == null || observer.refetch({
            cancelRefetch: false
        });
        (_a = (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $670d1234511b9450$var$_retryer)) == null || _a.continue();
    }
    addObserver(observer) {
        if (!(0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $670d1234511b9450$var$_observers).includes(observer)) {
            (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $670d1234511b9450$var$_observers).push(observer);
            this.clearGcTimeout();
            (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $670d1234511b9450$var$_cache).notify({
                type: "observerAdded",
                query: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        if ((0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $670d1234511b9450$var$_observers).includes(observer)) {
            (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $670d1234511b9450$var$_observers, (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $670d1234511b9450$var$_observers).filter((x)=>x !== observer));
            if (!(0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $670d1234511b9450$var$_observers).length) {
                if ((0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $670d1234511b9450$var$_retryer)) {
                    if ((0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $670d1234511b9450$var$_abortSignalConsumed)) (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $670d1234511b9450$var$_retryer).cancel({
                        revert: true
                    });
                    else (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $670d1234511b9450$var$_retryer).cancelRetry();
                }
                this.scheduleGc();
            }
            (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $670d1234511b9450$var$_cache).notify({
                type: "observerRemoved",
                query: this,
                observer: observer
            });
        }
    }
    getObserversCount() {
        return (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $670d1234511b9450$var$_observers).length;
    }
    invalidate() {
        if (!this.state.isInvalidated) (0, $82bb902b93e9fce2$export$fa92d15b718fce20)(this, $670d1234511b9450$var$_dispatch, $670d1234511b9450$var$dispatch_fn).call(this, {
            type: "invalidate"
        });
    }
    fetch(options, fetchOptions) {
        var _a, _b, _c;
        if (this.state.fetchStatus !== "idle") {
            if (this.state.data !== void 0 && (fetchOptions == null ? void 0 : fetchOptions.cancelRefetch)) this.cancel({
                silent: true
            });
            else if ((0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $670d1234511b9450$var$_retryer)) {
                (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $670d1234511b9450$var$_retryer).continueRetry();
                return (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $670d1234511b9450$var$_retryer).promise;
            }
        }
        if (options) this.setOptions(options);
        if (!this.options.queryFn) {
            const observer = (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $670d1234511b9450$var$_observers).find((x)=>x.options.queryFn);
            if (observer) this.setOptions(observer.options);
        }
        const abortController = new AbortController();
        const queryFnContext = {
            queryKey: this.queryKey,
            meta: this.meta
        };
        const addSignalProperty = (object)=>{
            Object.defineProperty(object, "signal", {
                enumerable: true,
                get: ()=>{
                    (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $670d1234511b9450$var$_abortSignalConsumed, true);
                    return abortController.signal;
                }
            });
        };
        addSignalProperty(queryFnContext);
        const fetchFn = ()=>{
            if (!this.options.queryFn || this.options.queryFn === (0, $58dc61dd9f062c44$export$1aa5a89531b7670d)) return Promise.reject(new Error(`Missing queryFn: '${this.options.queryHash}'`));
            (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $670d1234511b9450$var$_abortSignalConsumed, false);
            if (this.options.persister) return this.options.persister(this.options.queryFn, queryFnContext, this);
            return this.options.queryFn(queryFnContext);
        };
        const context = {
            fetchOptions: fetchOptions,
            options: this.options,
            queryKey: this.queryKey,
            state: this.state,
            fetchFn: fetchFn
        };
        addSignalProperty(context);
        (_a = this.options.behavior) == null || _a.onFetch(context, this);
        (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $670d1234511b9450$var$_revertState, this.state);
        if (this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((_b = context.fetchOptions) == null ? void 0 : _b.meta)) (0, $82bb902b93e9fce2$export$fa92d15b718fce20)(this, $670d1234511b9450$var$_dispatch, $670d1234511b9450$var$dispatch_fn).call(this, {
            type: "fetch",
            meta: (_c = context.fetchOptions) == null ? void 0 : _c.meta
        });
        const onError = (error)=>{
            var _a2, _b2, _c2, _d;
            if (!((0, $58dd9a6f7206d3ba$export$986cc6445c1d323)(error) && error.silent)) (0, $82bb902b93e9fce2$export$fa92d15b718fce20)(this, $670d1234511b9450$var$_dispatch, $670d1234511b9450$var$dispatch_fn).call(this, {
                type: "error",
                error: error
            });
            if (!(0, $58dd9a6f7206d3ba$export$986cc6445c1d323)(error)) {
                (_b2 = (_a2 = (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $670d1234511b9450$var$_cache).config).onError) == null || _b2.call(_a2, error, this);
                (_d = (_c2 = (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $670d1234511b9450$var$_cache).config).onSettled) == null || _d.call(_c2, this.state.data, error, this);
            }
            if (!this.isFetchingOptimistic) this.scheduleGc();
            this.isFetchingOptimistic = false;
        };
        (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $670d1234511b9450$var$_retryer, (0, $58dd9a6f7206d3ba$export$2cbd00fe8a2c8d85)({
            fn: context.fetchFn,
            abort: abortController.abort.bind(abortController),
            onSuccess: (data)=>{
                var _a2, _b2, _c2, _d;
                if (data === void 0) {
                    onError(new Error(`${this.queryHash} data is undefined`));
                    return;
                }
                this.setData(data);
                (_b2 = (_a2 = (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $670d1234511b9450$var$_cache).config).onSuccess) == null || _b2.call(_a2, data, this);
                (_d = (_c2 = (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $670d1234511b9450$var$_cache).config).onSettled) == null || _d.call(_c2, data, this.state.error, this);
                if (!this.isFetchingOptimistic) this.scheduleGc();
                this.isFetchingOptimistic = false;
            },
            onError: onError,
            onFail: (failureCount, error)=>{
                (0, $82bb902b93e9fce2$export$fa92d15b718fce20)(this, $670d1234511b9450$var$_dispatch, $670d1234511b9450$var$dispatch_fn).call(this, {
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                (0, $82bb902b93e9fce2$export$fa92d15b718fce20)(this, $670d1234511b9450$var$_dispatch, $670d1234511b9450$var$dispatch_fn).call(this, {
                    type: "pause"
                });
            },
            onContinue: ()=>{
                (0, $82bb902b93e9fce2$export$fa92d15b718fce20)(this, $670d1234511b9450$var$_dispatch, $670d1234511b9450$var$dispatch_fn).call(this, {
                    type: "continue"
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay,
            networkMode: context.options.networkMode
        }));
        return (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $670d1234511b9450$var$_retryer).promise;
    }
};
$670d1234511b9450$var$_initialState = new WeakMap();
$670d1234511b9450$var$_revertState = new WeakMap();
$670d1234511b9450$var$_cache = new WeakMap();
$670d1234511b9450$var$_retryer = new WeakMap();
$670d1234511b9450$var$_observers = new WeakMap();
$670d1234511b9450$var$_defaultOptions = new WeakMap();
$670d1234511b9450$var$_abortSignalConsumed = new WeakMap();
$670d1234511b9450$var$_dispatch = new WeakSet();
$670d1234511b9450$var$dispatch_fn = function(action) {
    const reducer = (state)=>{
        switch(action.type){
            case "failed":
                return {
                    ...state,
                    fetchFailureCount: action.failureCount,
                    fetchFailureReason: action.error
                };
            case "pause":
                return {
                    ...state,
                    fetchStatus: "paused"
                };
            case "continue":
                return {
                    ...state,
                    fetchStatus: "fetching"
                };
            case "fetch":
                return {
                    ...state,
                    ...$670d1234511b9450$export$f3df9013f2b58bce(state.data, this.options),
                    fetchMeta: action.meta ?? null
                };
            case "success":
                return {
                    ...state,
                    data: action.data,
                    dataUpdateCount: state.dataUpdateCount + 1,
                    dataUpdatedAt: action.dataUpdatedAt ?? Date.now(),
                    error: null,
                    isInvalidated: false,
                    status: "success",
                    ...!action.manual && {
                        fetchStatus: "idle",
                        fetchFailureCount: 0,
                        fetchFailureReason: null
                    }
                };
            case "error":
                const error = action.error;
                if ((0, $58dd9a6f7206d3ba$export$986cc6445c1d323)(error) && error.revert && (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $670d1234511b9450$var$_revertState)) return {
                    ...(0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $670d1234511b9450$var$_revertState),
                    fetchStatus: "idle"
                };
                return {
                    ...state,
                    error: error,
                    errorUpdateCount: state.errorUpdateCount + 1,
                    errorUpdatedAt: Date.now(),
                    fetchFailureCount: state.fetchFailureCount + 1,
                    fetchFailureReason: error,
                    fetchStatus: "idle",
                    status: "error"
                };
            case "invalidate":
                return {
                    ...state,
                    isInvalidated: true
                };
            case "setState":
                return {
                    ...state,
                    ...action.state
                };
        }
    };
    this.state = reducer(this.state);
    (0, $21dd3588127ff3f9$export$520687f44db6e1ab).batch(()=>{
        (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $670d1234511b9450$var$_observers).forEach((observer)=>{
            observer.onQueryUpdate();
        });
        (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $670d1234511b9450$var$_cache).notify({
            query: this,
            type: "updated",
            action: action
        });
    });
};
function $670d1234511b9450$export$f3df9013f2b58bce(data, options) {
    return {
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchStatus: (0, $58dd9a6f7206d3ba$export$61b92f63f30245cf)(options.networkMode) ? "fetching" : "paused",
        ...data === void 0 && {
            error: null,
            status: "pending"
        }
    };
}
function $670d1234511b9450$var$getDefaultState(options) {
    const data = typeof options.initialData === "function" ? options.initialData() : options.initialData;
    const hasData = data !== void 0;
    const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === "function" ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    return {
        data: data,
        dataUpdateCount: 0,
        dataUpdatedAt: hasData ? initialDataUpdatedAt ?? Date.now() : 0,
        error: null,
        errorUpdateCount: 0,
        errorUpdatedAt: 0,
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchMeta: null,
        isInvalidated: false,
        status: hasData ? "success" : "pending",
        fetchStatus: "idle"
    };
}




var $32d0ec2080c5a974$var$_queries;
var $32d0ec2080c5a974$export$5dde0cd941da8468 = class extends (0, $f619992c377f98ae$export$d26086b469ecdbcc) {
    constructor(config = {}){
        super();
        this.config = config;
        (0, $82bb902b93e9fce2$export$addf369becd23283)(this, $32d0ec2080c5a974$var$_queries, void 0);
        (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $32d0ec2080c5a974$var$_queries, /* @__PURE__ */ new Map());
    }
    build(client, options, state) {
        const queryKey = options.queryKey;
        const queryHash = options.queryHash ?? (0, $58dc61dd9f062c44$export$cc90ca97bc0d73fd)(queryKey, options);
        let query = this.get(queryHash);
        if (!query) {
            query = new (0, $670d1234511b9450$export$62297b13309008b2)({
                cache: this,
                queryKey: queryKey,
                queryHash: queryHash,
                options: client.defaultQueryOptions(options),
                state: state,
                defaultOptions: client.getQueryDefaults(queryKey)
            });
            this.add(query);
        }
        return query;
    }
    add(query) {
        if (!(0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $32d0ec2080c5a974$var$_queries).has(query.queryHash)) {
            (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $32d0ec2080c5a974$var$_queries).set(query.queryHash, query);
            this.notify({
                type: "added",
                query: query
            });
        }
    }
    remove(query) {
        const queryInMap = (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $32d0ec2080c5a974$var$_queries).get(query.queryHash);
        if (queryInMap) {
            query.destroy();
            if (queryInMap === query) (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $32d0ec2080c5a974$var$_queries).delete(query.queryHash);
            this.notify({
                type: "removed",
                query: query
            });
        }
    }
    clear() {
        (0, $21dd3588127ff3f9$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                this.remove(query);
            });
        });
    }
    get(queryHash) {
        return (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $32d0ec2080c5a974$var$_queries).get(queryHash);
    }
    getAll() {
        return [
            ...(0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $32d0ec2080c5a974$var$_queries).values()
        ];
    }
    find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return this.getAll().find((query)=>(0, $58dc61dd9f062c44$export$c5d1efe363797780)(defaultedFilters, query));
    }
    findAll(filters = {}) {
        const queries = this.getAll();
        return Object.keys(filters).length > 0 ? queries.filter((query)=>(0, $58dc61dd9f062c44$export$c5d1efe363797780)(filters, query)) : queries;
    }
    notify(event) {
        (0, $21dd3588127ff3f9$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    onFocus() {
        (0, $21dd3588127ff3f9$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onFocus();
            });
        });
    }
    onOnline() {
        (0, $21dd3588127ff3f9$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onOnline();
            });
        });
    }
};
$32d0ec2080c5a974$var$_queries = new WeakMap();








var $cf0f9d9b6103160d$var$_observers, $cf0f9d9b6103160d$var$_defaultOptions, $cf0f9d9b6103160d$var$_mutationCache, $cf0f9d9b6103160d$var$_retryer, $cf0f9d9b6103160d$var$_dispatch, $cf0f9d9b6103160d$var$dispatch_fn;
var $cf0f9d9b6103160d$export$17b8b19c814bcf56 = class extends (0, $d891b6039ad954d1$export$e09608847fcc8c59) {
    constructor(config){
        super();
        (0, $82bb902b93e9fce2$export$addf369becd23283)(this, $cf0f9d9b6103160d$var$_dispatch);
        (0, $82bb902b93e9fce2$export$addf369becd23283)(this, $cf0f9d9b6103160d$var$_observers, void 0);
        (0, $82bb902b93e9fce2$export$addf369becd23283)(this, $cf0f9d9b6103160d$var$_defaultOptions, void 0);
        (0, $82bb902b93e9fce2$export$addf369becd23283)(this, $cf0f9d9b6103160d$var$_mutationCache, void 0);
        (0, $82bb902b93e9fce2$export$addf369becd23283)(this, $cf0f9d9b6103160d$var$_retryer, void 0);
        this.mutationId = config.mutationId;
        (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $cf0f9d9b6103160d$var$_defaultOptions, config.defaultOptions);
        (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $cf0f9d9b6103160d$var$_mutationCache, config.mutationCache);
        (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $cf0f9d9b6103160d$var$_observers, []);
        this.state = config.state || $cf0f9d9b6103160d$export$a1659b54bac3252a();
        this.setOptions(config.options);
        this.scheduleGc();
    }
    setOptions(options) {
        this.options = {
            ...(0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $cf0f9d9b6103160d$var$_defaultOptions),
            ...options
        };
        this.updateGcTime(this.options.gcTime);
    }
    get meta() {
        return this.options.meta;
    }
    addObserver(observer) {
        if (!(0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $cf0f9d9b6103160d$var$_observers).includes(observer)) {
            (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $cf0f9d9b6103160d$var$_observers).push(observer);
            this.clearGcTimeout();
            (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $cf0f9d9b6103160d$var$_mutationCache).notify({
                type: "observerAdded",
                mutation: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $cf0f9d9b6103160d$var$_observers, (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $cf0f9d9b6103160d$var$_observers).filter((x)=>x !== observer));
        this.scheduleGc();
        (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $cf0f9d9b6103160d$var$_mutationCache).notify({
            type: "observerRemoved",
            mutation: this,
            observer: observer
        });
    }
    optionalRemove() {
        if (!(0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $cf0f9d9b6103160d$var$_observers).length) {
            if (this.state.status === "pending") this.scheduleGc();
            else (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $cf0f9d9b6103160d$var$_mutationCache).remove(this);
        }
    }
    continue() {
        var _a;
        return ((_a = (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $cf0f9d9b6103160d$var$_retryer)) == null ? void 0 : _a.continue()) ?? // continuing a mutation assumes that variables are set, mutation must have been dehydrated before
        this.execute(this.state.variables);
    }
    async execute(variables) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t;
        const executeMutation = ()=>{
            (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $cf0f9d9b6103160d$var$_retryer, (0, $58dd9a6f7206d3ba$export$2cbd00fe8a2c8d85)({
                fn: ()=>{
                    if (!this.options.mutationFn) return Promise.reject(new Error("No mutationFn found"));
                    return this.options.mutationFn(variables);
                },
                onFail: (failureCount, error)=>{
                    (0, $82bb902b93e9fce2$export$fa92d15b718fce20)(this, $cf0f9d9b6103160d$var$_dispatch, $cf0f9d9b6103160d$var$dispatch_fn).call(this, {
                        type: "failed",
                        failureCount: failureCount,
                        error: error
                    });
                },
                onPause: ()=>{
                    (0, $82bb902b93e9fce2$export$fa92d15b718fce20)(this, $cf0f9d9b6103160d$var$_dispatch, $cf0f9d9b6103160d$var$dispatch_fn).call(this, {
                        type: "pause"
                    });
                },
                onContinue: ()=>{
                    (0, $82bb902b93e9fce2$export$fa92d15b718fce20)(this, $cf0f9d9b6103160d$var$_dispatch, $cf0f9d9b6103160d$var$dispatch_fn).call(this, {
                        type: "continue"
                    });
                },
                retry: this.options.retry ?? 0,
                retryDelay: this.options.retryDelay,
                networkMode: this.options.networkMode
            }));
            return (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $cf0f9d9b6103160d$var$_retryer).promise;
        };
        const restored = this.state.status === "pending";
        try {
            if (!restored) {
                (0, $82bb902b93e9fce2$export$fa92d15b718fce20)(this, $cf0f9d9b6103160d$var$_dispatch, $cf0f9d9b6103160d$var$dispatch_fn).call(this, {
                    type: "pending",
                    variables: variables
                });
                await ((_b = (_a = (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $cf0f9d9b6103160d$var$_mutationCache).config).onMutate) == null ? void 0 : _b.call(_a, variables, this));
                const context = await ((_d = (_c = this.options).onMutate) == null ? void 0 : _d.call(_c, variables));
                if (context !== this.state.context) (0, $82bb902b93e9fce2$export$fa92d15b718fce20)(this, $cf0f9d9b6103160d$var$_dispatch, $cf0f9d9b6103160d$var$dispatch_fn).call(this, {
                    type: "pending",
                    context: context,
                    variables: variables
                });
            }
            const data = await executeMutation();
            await ((_f = (_e = (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $cf0f9d9b6103160d$var$_mutationCache).config).onSuccess) == null ? void 0 : _f.call(_e, data, variables, this.state.context, this));
            await ((_h = (_g = this.options).onSuccess) == null ? void 0 : _h.call(_g, data, variables, this.state.context));
            await ((_j = (_i = (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $cf0f9d9b6103160d$var$_mutationCache).config).onSettled) == null ? void 0 : _j.call(_i, data, null, this.state.variables, this.state.context, this));
            await ((_l = (_k = this.options).onSettled) == null ? void 0 : _l.call(_k, data, null, variables, this.state.context));
            (0, $82bb902b93e9fce2$export$fa92d15b718fce20)(this, $cf0f9d9b6103160d$var$_dispatch, $cf0f9d9b6103160d$var$dispatch_fn).call(this, {
                type: "success",
                data: data
            });
            return data;
        } catch (error) {
            try {
                await ((_n = (_m = (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $cf0f9d9b6103160d$var$_mutationCache).config).onError) == null ? void 0 : _n.call(_m, error, variables, this.state.context, this));
                await ((_p = (_o = this.options).onError) == null ? void 0 : _p.call(_o, error, variables, this.state.context));
                await ((_r = (_q = (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $cf0f9d9b6103160d$var$_mutationCache).config).onSettled) == null ? void 0 : _r.call(_q, void 0, error, this.state.variables, this.state.context, this));
                await ((_t = (_s = this.options).onSettled) == null ? void 0 : _t.call(_s, void 0, error, variables, this.state.context));
                throw error;
            } finally{
                (0, $82bb902b93e9fce2$export$fa92d15b718fce20)(this, $cf0f9d9b6103160d$var$_dispatch, $cf0f9d9b6103160d$var$dispatch_fn).call(this, {
                    type: "error",
                    error: error
                });
            }
        }
    }
};
$cf0f9d9b6103160d$var$_observers = new WeakMap();
$cf0f9d9b6103160d$var$_defaultOptions = new WeakMap();
$cf0f9d9b6103160d$var$_mutationCache = new WeakMap();
$cf0f9d9b6103160d$var$_retryer = new WeakMap();
$cf0f9d9b6103160d$var$_dispatch = new WeakSet();
$cf0f9d9b6103160d$var$dispatch_fn = function(action) {
    const reducer = (state)=>{
        switch(action.type){
            case "failed":
                return {
                    ...state,
                    failureCount: action.failureCount,
                    failureReason: action.error
                };
            case "pause":
                return {
                    ...state,
                    isPaused: true
                };
            case "continue":
                return {
                    ...state,
                    isPaused: false
                };
            case "pending":
                return {
                    ...state,
                    context: action.context,
                    data: void 0,
                    failureCount: 0,
                    failureReason: null,
                    error: null,
                    isPaused: !(0, $58dd9a6f7206d3ba$export$61b92f63f30245cf)(this.options.networkMode),
                    status: "pending",
                    variables: action.variables,
                    submittedAt: Date.now()
                };
            case "success":
                return {
                    ...state,
                    data: action.data,
                    failureCount: 0,
                    failureReason: null,
                    error: null,
                    status: "success",
                    isPaused: false
                };
            case "error":
                return {
                    ...state,
                    data: void 0,
                    error: action.error,
                    failureCount: state.failureCount + 1,
                    failureReason: action.error,
                    isPaused: false,
                    status: "error"
                };
        }
    };
    this.state = reducer(this.state);
    (0, $21dd3588127ff3f9$export$520687f44db6e1ab).batch(()=>{
        (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $cf0f9d9b6103160d$var$_observers).forEach((observer)=>{
            observer.onMutationUpdate(action);
        });
        (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $cf0f9d9b6103160d$var$_mutationCache).notify({
            mutation: this,
            type: "updated",
            action: action
        });
    });
};
function $cf0f9d9b6103160d$export$a1659b54bac3252a() {
    return {
        context: void 0,
        data: void 0,
        error: null,
        failureCount: 0,
        failureReason: null,
        isPaused: false,
        status: "idle",
        variables: void 0,
        submittedAt: 0
    };
}




var $1fda9bb9af4c07c2$var$_mutations, $1fda9bb9af4c07c2$var$_mutationId, $1fda9bb9af4c07c2$var$_resuming;
var $1fda9bb9af4c07c2$export$1fcfd9a244434844 = class extends (0, $f619992c377f98ae$export$d26086b469ecdbcc) {
    constructor(config = {}){
        super();
        this.config = config;
        (0, $82bb902b93e9fce2$export$addf369becd23283)(this, $1fda9bb9af4c07c2$var$_mutations, void 0);
        (0, $82bb902b93e9fce2$export$addf369becd23283)(this, $1fda9bb9af4c07c2$var$_mutationId, void 0);
        (0, $82bb902b93e9fce2$export$addf369becd23283)(this, $1fda9bb9af4c07c2$var$_resuming, void 0);
        (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $1fda9bb9af4c07c2$var$_mutations, []);
        (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $1fda9bb9af4c07c2$var$_mutationId, 0);
    }
    build(client, options, state) {
        const mutation = new (0, $cf0f9d9b6103160d$export$17b8b19c814bcf56)({
            mutationCache: this,
            mutationId: ++(0, $82bb902b93e9fce2$export$b1fe7cbb4502036b)(this, $1fda9bb9af4c07c2$var$_mutationId)._,
            options: client.defaultMutationOptions(options),
            state: state
        });
        this.add(mutation);
        return mutation;
    }
    add(mutation) {
        (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $1fda9bb9af4c07c2$var$_mutations).push(mutation);
        this.notify({
            type: "added",
            mutation: mutation
        });
    }
    remove(mutation) {
        (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $1fda9bb9af4c07c2$var$_mutations, (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $1fda9bb9af4c07c2$var$_mutations).filter((x)=>x !== mutation));
        this.notify({
            type: "removed",
            mutation: mutation
        });
    }
    clear() {
        (0, $21dd3588127ff3f9$export$520687f44db6e1ab).batch(()=>{
            (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $1fda9bb9af4c07c2$var$_mutations).forEach((mutation)=>{
                this.remove(mutation);
            });
        });
    }
    getAll() {
        return (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $1fda9bb9af4c07c2$var$_mutations);
    }
    find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $1fda9bb9af4c07c2$var$_mutations).find((mutation)=>(0, $58dc61dd9f062c44$export$a1ea5fb559f63ae3)(defaultedFilters, mutation));
    }
    findAll(filters = {}) {
        return (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $1fda9bb9af4c07c2$var$_mutations).filter((mutation)=>(0, $58dc61dd9f062c44$export$a1ea5fb559f63ae3)(filters, mutation));
    }
    notify(event) {
        (0, $21dd3588127ff3f9$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    resumePausedMutations() {
        (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $1fda9bb9af4c07c2$var$_resuming, ((0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $1fda9bb9af4c07c2$var$_resuming) ?? Promise.resolve()).then(()=>{
            const pausedMutations = (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $1fda9bb9af4c07c2$var$_mutations).filter((x)=>x.state.isPaused);
            return (0, $21dd3588127ff3f9$export$520687f44db6e1ab).batch(()=>pausedMutations.reduce((promise, mutation)=>promise.then(()=>mutation.continue().catch((0, $58dc61dd9f062c44$export$8793edee2d425525))), Promise.resolve()));
        }).then(()=>{
            (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $1fda9bb9af4c07c2$var$_resuming, void 0);
        }));
        return (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $1fda9bb9af4c07c2$var$_resuming);
    }
};
$1fda9bb9af4c07c2$var$_mutations = new WeakMap();
$1fda9bb9af4c07c2$var$_mutationId = new WeakMap();
$1fda9bb9af4c07c2$var$_resuming = new WeakMap();







function $a2554cc86b811116$export$84470d1367601e8d(pages) {
    return {
        onFetch: (context, query)=>{
            const fetchFn = async ()=>{
                var _a, _b, _c, _d, _e;
                const options = context.options;
                const direction = (_c = (_b = (_a = context.fetchOptions) == null ? void 0 : _a.meta) == null ? void 0 : _b.fetchMore) == null ? void 0 : _c.direction;
                const oldPages = ((_d = context.state.data) == null ? void 0 : _d.pages) || [];
                const oldPageParams = ((_e = context.state.data) == null ? void 0 : _e.pageParams) || [];
                const empty = {
                    pages: [],
                    pageParams: []
                };
                let cancelled = false;
                const addSignalProperty = (object)=>{
                    Object.defineProperty(object, "signal", {
                        enumerable: true,
                        get: ()=>{
                            if (context.signal.aborted) cancelled = true;
                            else context.signal.addEventListener("abort", ()=>{
                                cancelled = true;
                            });
                            return context.signal;
                        }
                    });
                };
                const queryFn = context.options.queryFn && context.options.queryFn !== (0, $58dc61dd9f062c44$export$1aa5a89531b7670d) ? context.options.queryFn : ()=>{
                    return Promise.reject(new Error(`Missing queryFn: '${context.options.queryHash}'`));
                };
                const fetchPage = async (data, param, previous)=>{
                    if (cancelled) return Promise.reject();
                    if (param == null && data.pages.length) return Promise.resolve(data);
                    const queryFnContext = {
                        queryKey: context.queryKey,
                        pageParam: param,
                        direction: previous ? "backward" : "forward",
                        meta: context.options.meta
                    };
                    addSignalProperty(queryFnContext);
                    const page = await queryFn(queryFnContext);
                    const { maxPages: maxPages } = context.options;
                    const addTo = previous ? (0, $58dc61dd9f062c44$export$8c6246b73dd61f4a) : (0, $58dc61dd9f062c44$export$ccce65a22a26f2bc);
                    return {
                        pages: addTo(data.pages, page, maxPages),
                        pageParams: addTo(data.pageParams, param, maxPages)
                    };
                };
                let result;
                if (direction && oldPages.length) {
                    const previous = direction === "backward";
                    const pageParamFn = previous ? $a2554cc86b811116$var$getPreviousPageParam : $a2554cc86b811116$var$getNextPageParam;
                    const oldData = {
                        pages: oldPages,
                        pageParams: oldPageParams
                    };
                    const param = pageParamFn(options, oldData);
                    result = await fetchPage(oldData, param, previous);
                } else {
                    result = await fetchPage(empty, oldPageParams[0] ?? options.initialPageParam);
                    const remainingPages = pages ?? oldPages.length;
                    for(let i = 1; i < remainingPages; i++){
                        const param = $a2554cc86b811116$var$getNextPageParam(options, result);
                        result = await fetchPage(result, param);
                    }
                }
                return result;
            };
            if (context.options.persister) context.fetchFn = ()=>{
                var _a, _b;
                return (_b = (_a = context.options).persister) == null ? void 0 : _b.call(_a, fetchFn, {
                    queryKey: context.queryKey,
                    meta: context.options.meta,
                    signal: context.signal
                }, query);
            };
            else context.fetchFn = fetchFn;
        }
    };
}
function $a2554cc86b811116$var$getNextPageParam(options, { pages: pages, pageParams: pageParams }) {
    const lastIndex = pages.length - 1;
    return options.getNextPageParam(pages[lastIndex], pages, pageParams[lastIndex], pageParams);
}
function $a2554cc86b811116$var$getPreviousPageParam(options, { pages: pages, pageParams: pageParams }) {
    var _a;
    return (_a = options.getPreviousPageParam) == null ? void 0 : _a.call(options, pages[0], pages, pageParams[0], pageParams);
}
function $a2554cc86b811116$export$b9c88add8b8b5e6a(options, data) {
    if (!data) return false;
    return $a2554cc86b811116$var$getNextPageParam(options, data) != null;
}
function $a2554cc86b811116$export$db1663b730a8e6e4(options, data) {
    if (!data || !options.getPreviousPageParam) return false;
    return $a2554cc86b811116$var$getPreviousPageParam(options, data) != null;
}


var $3ccd5b3cb70a1e2f$var$_queryCache, $3ccd5b3cb70a1e2f$var$_mutationCache, $3ccd5b3cb70a1e2f$var$_defaultOptions, $3ccd5b3cb70a1e2f$var$_queryDefaults, $3ccd5b3cb70a1e2f$var$_mutationDefaults, $3ccd5b3cb70a1e2f$var$_mountCount, $3ccd5b3cb70a1e2f$var$_unsubscribeFocus, $3ccd5b3cb70a1e2f$var$_unsubscribeOnline;
var $3ccd5b3cb70a1e2f$export$405d0624ed55a03f = class {
    constructor(config = {}){
        (0, $82bb902b93e9fce2$export$addf369becd23283)(this, $3ccd5b3cb70a1e2f$var$_queryCache, void 0);
        (0, $82bb902b93e9fce2$export$addf369becd23283)(this, $3ccd5b3cb70a1e2f$var$_mutationCache, void 0);
        (0, $82bb902b93e9fce2$export$addf369becd23283)(this, $3ccd5b3cb70a1e2f$var$_defaultOptions, void 0);
        (0, $82bb902b93e9fce2$export$addf369becd23283)(this, $3ccd5b3cb70a1e2f$var$_queryDefaults, void 0);
        (0, $82bb902b93e9fce2$export$addf369becd23283)(this, $3ccd5b3cb70a1e2f$var$_mutationDefaults, void 0);
        (0, $82bb902b93e9fce2$export$addf369becd23283)(this, $3ccd5b3cb70a1e2f$var$_mountCount, void 0);
        (0, $82bb902b93e9fce2$export$addf369becd23283)(this, $3ccd5b3cb70a1e2f$var$_unsubscribeFocus, void 0);
        (0, $82bb902b93e9fce2$export$addf369becd23283)(this, $3ccd5b3cb70a1e2f$var$_unsubscribeOnline, void 0);
        (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $3ccd5b3cb70a1e2f$var$_queryCache, config.queryCache || new (0, $32d0ec2080c5a974$export$5dde0cd941da8468)());
        (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $3ccd5b3cb70a1e2f$var$_mutationCache, config.mutationCache || new (0, $1fda9bb9af4c07c2$export$1fcfd9a244434844)());
        (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $3ccd5b3cb70a1e2f$var$_defaultOptions, config.defaultOptions || {});
        (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $3ccd5b3cb70a1e2f$var$_queryDefaults, /* @__PURE__ */ new Map());
        (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $3ccd5b3cb70a1e2f$var$_mutationDefaults, /* @__PURE__ */ new Map());
        (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $3ccd5b3cb70a1e2f$var$_mountCount, 0);
    }
    mount() {
        (0, $82bb902b93e9fce2$export$b1fe7cbb4502036b)(this, $3ccd5b3cb70a1e2f$var$_mountCount)._++;
        if ((0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $3ccd5b3cb70a1e2f$var$_mountCount) !== 1) return;
        (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $3ccd5b3cb70a1e2f$var$_unsubscribeFocus, (0, $c8420f591c39a8bc$export$6bf54661be5b02cf).subscribe(async (focused)=>{
            if (focused) {
                await this.resumePausedMutations();
                (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $3ccd5b3cb70a1e2f$var$_queryCache).onFocus();
            }
        }));
        (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $3ccd5b3cb70a1e2f$var$_unsubscribeOnline, (0, $5007855dfbc75886$export$b113e788b2dd3fdc).subscribe(async (online)=>{
            if (online) {
                await this.resumePausedMutations();
                (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $3ccd5b3cb70a1e2f$var$_queryCache).onOnline();
            }
        }));
    }
    unmount() {
        var _a, _b;
        (0, $82bb902b93e9fce2$export$b1fe7cbb4502036b)(this, $3ccd5b3cb70a1e2f$var$_mountCount)._--;
        if ((0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $3ccd5b3cb70a1e2f$var$_mountCount) !== 0) return;
        (_a = (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $3ccd5b3cb70a1e2f$var$_unsubscribeFocus)) == null || _a.call(this);
        (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $3ccd5b3cb70a1e2f$var$_unsubscribeFocus, void 0);
        (_b = (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $3ccd5b3cb70a1e2f$var$_unsubscribeOnline)) == null || _b.call(this);
        (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $3ccd5b3cb70a1e2f$var$_unsubscribeOnline, void 0);
    }
    isFetching(filters) {
        return (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $3ccd5b3cb70a1e2f$var$_queryCache).findAll({
            ...filters,
            fetchStatus: "fetching"
        }).length;
    }
    isMutating(filters) {
        return (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $3ccd5b3cb70a1e2f$var$_mutationCache).findAll({
            ...filters,
            status: "pending"
        }).length;
    }
    getQueryData(queryKey) {
        var _a;
        const options = this.defaultQueryOptions({
            queryKey: queryKey
        });
        return (_a = (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $3ccd5b3cb70a1e2f$var$_queryCache).get(options.queryHash)) == null ? void 0 : _a.state.data;
    }
    ensureQueryData(options) {
        const cachedData = this.getQueryData(options.queryKey);
        if (cachedData === void 0) return this.fetchQuery(options);
        else {
            const defaultedOptions = this.defaultQueryOptions(options);
            const query = (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $3ccd5b3cb70a1e2f$var$_queryCache).build(this, defaultedOptions);
            if (options.revalidateIfStale && query.isStaleByTime(defaultedOptions.staleTime)) this.prefetchQuery(defaultedOptions);
            return Promise.resolve(cachedData);
        }
    }
    getQueriesData(filters) {
        return this.getQueryCache().findAll(filters).map(({ queryKey: queryKey, state: state })=>{
            const data = state.data;
            return [
                queryKey,
                data
            ];
        });
    }
    setQueryData(queryKey, updater, options) {
        const defaultedOptions = this.defaultQueryOptions({
            queryKey: queryKey
        });
        const query = (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $3ccd5b3cb70a1e2f$var$_queryCache).get(defaultedOptions.queryHash);
        const prevData = query == null ? void 0 : query.state.data;
        const data = (0, $58dc61dd9f062c44$export$7f095f455ad5af3f)(updater, prevData);
        if (data === void 0) return void 0;
        return (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $3ccd5b3cb70a1e2f$var$_queryCache).build(this, defaultedOptions).setData(data, {
            ...options,
            manual: true
        });
    }
    setQueriesData(filters, updater, options) {
        return (0, $21dd3588127ff3f9$export$520687f44db6e1ab).batch(()=>this.getQueryCache().findAll(filters).map(({ queryKey: queryKey })=>[
                    queryKey,
                    this.setQueryData(queryKey, updater, options)
                ]));
    }
    getQueryState(queryKey) {
        var _a;
        const options = this.defaultQueryOptions({
            queryKey: queryKey
        });
        return (_a = (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $3ccd5b3cb70a1e2f$var$_queryCache).get(options.queryHash)) == null ? void 0 : _a.state;
    }
    removeQueries(filters) {
        const queryCache = (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $3ccd5b3cb70a1e2f$var$_queryCache);
        (0, $21dd3588127ff3f9$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                queryCache.remove(query);
            });
        });
    }
    resetQueries(filters, options) {
        const queryCache = (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $3ccd5b3cb70a1e2f$var$_queryCache);
        const refetchFilters = {
            type: "active",
            ...filters
        };
        return (0, $21dd3588127ff3f9$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                query.reset();
            });
            return this.refetchQueries(refetchFilters, options);
        });
    }
    cancelQueries(filters = {}, cancelOptions = {}) {
        const defaultedCancelOptions = {
            revert: true,
            ...cancelOptions
        };
        const promises = (0, $21dd3588127ff3f9$export$520687f44db6e1ab).batch(()=>(0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $3ccd5b3cb70a1e2f$var$_queryCache).findAll(filters).map((query)=>query.cancel(defaultedCancelOptions)));
        return Promise.all(promises).then((0, $58dc61dd9f062c44$export$8793edee2d425525)).catch((0, $58dc61dd9f062c44$export$8793edee2d425525));
    }
    invalidateQueries(filters = {}, options = {}) {
        return (0, $21dd3588127ff3f9$export$520687f44db6e1ab).batch(()=>{
            (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $3ccd5b3cb70a1e2f$var$_queryCache).findAll(filters).forEach((query)=>{
                query.invalidate();
            });
            if (filters.refetchType === "none") return Promise.resolve();
            const refetchFilters = {
                ...filters,
                type: filters.refetchType ?? filters.type ?? "active"
            };
            return this.refetchQueries(refetchFilters, options);
        });
    }
    refetchQueries(filters = {}, options) {
        const fetchOptions = {
            ...options,
            cancelRefetch: (options == null ? void 0 : options.cancelRefetch) ?? true
        };
        const promises = (0, $21dd3588127ff3f9$export$520687f44db6e1ab).batch(()=>(0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $3ccd5b3cb70a1e2f$var$_queryCache).findAll(filters).filter((query)=>!query.isDisabled()).map((query)=>{
                let promise = query.fetch(void 0, fetchOptions);
                if (!fetchOptions.throwOnError) promise = promise.catch((0, $58dc61dd9f062c44$export$8793edee2d425525));
                return query.state.fetchStatus === "paused" ? Promise.resolve() : promise;
            }));
        return Promise.all(promises).then((0, $58dc61dd9f062c44$export$8793edee2d425525));
    }
    fetchQuery(options) {
        const defaultedOptions = this.defaultQueryOptions(options);
        if (defaultedOptions.retry === void 0) defaultedOptions.retry = false;
        const query = (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $3ccd5b3cb70a1e2f$var$_queryCache).build(this, defaultedOptions);
        return query.isStaleByTime(defaultedOptions.staleTime) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    }
    prefetchQuery(options) {
        return this.fetchQuery(options).then((0, $58dc61dd9f062c44$export$8793edee2d425525)).catch((0, $58dc61dd9f062c44$export$8793edee2d425525));
    }
    fetchInfiniteQuery(options) {
        options.behavior = (0, $a2554cc86b811116$export$84470d1367601e8d)(options.pages);
        return this.fetchQuery(options);
    }
    prefetchInfiniteQuery(options) {
        return this.fetchInfiniteQuery(options).then((0, $58dc61dd9f062c44$export$8793edee2d425525)).catch((0, $58dc61dd9f062c44$export$8793edee2d425525));
    }
    resumePausedMutations() {
        if ((0, $5007855dfbc75886$export$b113e788b2dd3fdc).isOnline()) return (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $3ccd5b3cb70a1e2f$var$_mutationCache).resumePausedMutations();
        return Promise.resolve();
    }
    getQueryCache() {
        return (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $3ccd5b3cb70a1e2f$var$_queryCache);
    }
    getMutationCache() {
        return (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $3ccd5b3cb70a1e2f$var$_mutationCache);
    }
    getDefaultOptions() {
        return (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $3ccd5b3cb70a1e2f$var$_defaultOptions);
    }
    setDefaultOptions(options) {
        (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $3ccd5b3cb70a1e2f$var$_defaultOptions, options);
    }
    setQueryDefaults(queryKey, options) {
        (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $3ccd5b3cb70a1e2f$var$_queryDefaults).set((0, $58dc61dd9f062c44$export$1e87d19d4aab5805)(queryKey), {
            queryKey: queryKey,
            defaultOptions: options
        });
    }
    getQueryDefaults(queryKey) {
        const defaults = [
            ...(0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $3ccd5b3cb70a1e2f$var$_queryDefaults).values()
        ];
        let result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, $58dc61dd9f062c44$export$2f07189bb9fa26a7)(queryKey, queryDefault.queryKey)) result = {
                ...result,
                ...queryDefault.defaultOptions
            };
        });
        return result;
    }
    setMutationDefaults(mutationKey, options) {
        (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $3ccd5b3cb70a1e2f$var$_mutationDefaults).set((0, $58dc61dd9f062c44$export$1e87d19d4aab5805)(mutationKey), {
            mutationKey: mutationKey,
            defaultOptions: options
        });
    }
    getMutationDefaults(mutationKey) {
        const defaults = [
            ...(0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $3ccd5b3cb70a1e2f$var$_mutationDefaults).values()
        ];
        let result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, $58dc61dd9f062c44$export$2f07189bb9fa26a7)(mutationKey, queryDefault.mutationKey)) result = {
                ...result,
                ...queryDefault.defaultOptions
            };
        });
        return result;
    }
    defaultQueryOptions(options) {
        if (options._defaulted) return options;
        const defaultedOptions = {
            ...(0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $3ccd5b3cb70a1e2f$var$_defaultOptions).queries,
            ...this.getQueryDefaults(options.queryKey),
            ...options,
            _defaulted: true
        };
        if (!defaultedOptions.queryHash) defaultedOptions.queryHash = (0, $58dc61dd9f062c44$export$cc90ca97bc0d73fd)(defaultedOptions.queryKey, defaultedOptions);
        if (defaultedOptions.refetchOnReconnect === void 0) defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== "always";
        if (defaultedOptions.throwOnError === void 0) defaultedOptions.throwOnError = !!defaultedOptions.suspense;
        if (!defaultedOptions.networkMode && defaultedOptions.persister) defaultedOptions.networkMode = "offlineFirst";
        if (defaultedOptions.enabled !== true && defaultedOptions.queryFn === (0, $58dc61dd9f062c44$export$1aa5a89531b7670d)) defaultedOptions.enabled = false;
        return defaultedOptions;
    }
    defaultMutationOptions(options) {
        if (options == null ? void 0 : options._defaulted) return options;
        return {
            ...(0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $3ccd5b3cb70a1e2f$var$_defaultOptions).mutations,
            ...(options == null ? void 0 : options.mutationKey) && this.getMutationDefaults(options.mutationKey),
            ...options,
            _defaulted: true
        };
    }
    clear() {
        (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $3ccd5b3cb70a1e2f$var$_queryCache).clear();
        (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $3ccd5b3cb70a1e2f$var$_mutationCache).clear();
    }
};
$3ccd5b3cb70a1e2f$var$_queryCache = new WeakMap();
$3ccd5b3cb70a1e2f$var$_mutationCache = new WeakMap();
$3ccd5b3cb70a1e2f$var$_defaultOptions = new WeakMap();
$3ccd5b3cb70a1e2f$var$_queryDefaults = new WeakMap();
$3ccd5b3cb70a1e2f$var$_mutationDefaults = new WeakMap();
$3ccd5b3cb70a1e2f$var$_mountCount = new WeakMap();
$3ccd5b3cb70a1e2f$var$_unsubscribeFocus = new WeakMap();
$3ccd5b3cb70a1e2f$var$_unsubscribeOnline = new WeakMap();


/**
 * React Router DOM v6.22.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $lBnVc = parcelRequire("lBnVc");

/**
 * @remix-run/router v1.15.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $18c31b251a4990f6$var$_extends() {
    $18c31b251a4990f6$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $18c31b251a4990f6$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $18c31b251a4990f6$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($18c31b251a4990f6$export$e19cd5f9376f8cee || ($18c31b251a4990f6$export$e19cd5f9376f8cee = {}));
const $18c31b251a4990f6$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $18c31b251a4990f6$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $18c31b251a4990f6$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $18c31b251a4990f6$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $18c31b251a4990f6$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $18c31b251a4990f6$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $18c31b251a4990f6$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $18c31b251a4990f6$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $18c31b251a4990f6$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $18c31b251a4990f6$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $18c31b251a4990f6$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $18c31b251a4990f6$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $18c31b251a4990f6$export$fe53371bee54353d(to);
    }
    return $18c31b251a4990f6$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $18c31b251a4990f6$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $18c31b251a4990f6$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $18c31b251a4990f6$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $18c31b251a4990f6$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $18c31b251a4990f6$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $18c31b251a4990f6$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $18c31b251a4990f6$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $18c31b251a4990f6$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $18c31b251a4990f6$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $18c31b251a4990f6$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $18c31b251a4990f6$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $18c31b251a4990f6$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $18c31b251a4990f6$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $18c31b251a4990f6$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $18c31b251a4990f6$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $18c31b251a4990f6$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $18c31b251a4990f6$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $18c31b251a4990f6$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($18c31b251a4990f6$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $18c31b251a4990f6$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $18c31b251a4990f6$export$e19cd5f9376f8cee.Push;
        let location = $18c31b251a4990f6$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $18c31b251a4990f6$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $18c31b251a4990f6$export$e19cd5f9376f8cee.Replace;
        let location = $18c31b251a4990f6$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $18c31b251a4990f6$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $18c31b251a4990f6$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $18c31b251a4990f6$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($18c31b251a4990f6$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($18c31b251a4990f6$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $18c31b251a4990f6$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($18c31b251a4990f6$var$ResultType || ($18c31b251a4990f6$var$ResultType = {}));
const $18c31b251a4990f6$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $18c31b251a4990f6$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $18c31b251a4990f6$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $18c31b251a4990f6$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $18c31b251a4990f6$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($18c31b251a4990f6$var$isIndexRoute(route)) {
            let indexRoute = $18c31b251a4990f6$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $18c31b251a4990f6$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $18c31b251a4990f6$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $18c31b251a4990f6$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $18c31b251a4990f6$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $18c31b251a4990f6$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $18c31b251a4990f6$var$flattenRoutes(routes);
    $18c31b251a4990f6$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $18c31b251a4990f6$var$decodePath(pathname);
        matches = $18c31b251a4990f6$var$matchRouteBranch(branches[i], decoded);
    }
    return matches;
}
function $18c31b251a4990f6$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $18c31b251a4990f6$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $18c31b251a4990f6$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $18c31b251a4990f6$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $18c31b251a4990f6$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $18c31b251a4990f6$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $18c31b251a4990f6$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $18c31b251a4990f6$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $18c31b251a4990f6$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $18c31b251a4990f6$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $18c31b251a4990f6$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $18c31b251a4990f6$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $18c31b251a4990f6$var$paramRe = /^:[\w-]+$/;
const $18c31b251a4990f6$var$dynamicSegmentValue = 3;
const $18c31b251a4990f6$var$indexRouteValue = 2;
const $18c31b251a4990f6$var$emptySegmentValue = 1;
const $18c31b251a4990f6$var$staticSegmentValue = 10;
const $18c31b251a4990f6$var$splatPenalty = -2;
const $18c31b251a4990f6$var$isSplat = (s)=>s === "*";
function $18c31b251a4990f6$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($18c31b251a4990f6$var$isSplat)) initialScore += $18c31b251a4990f6$var$splatPenalty;
    if (index) initialScore += $18c31b251a4990f6$var$indexRouteValue;
    return segments.filter((s)=>!$18c31b251a4990f6$var$isSplat(s)).reduce((score, segment)=>score + ($18c31b251a4990f6$var$paramRe.test(segment) ? $18c31b251a4990f6$var$dynamicSegmentValue : segment === "" ? $18c31b251a4990f6$var$emptySegmentValue : $18c31b251a4990f6$var$staticSegmentValue), initialScore);
}
function $18c31b251a4990f6$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $18c31b251a4990f6$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $18c31b251a4990f6$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $18c31b251a4990f6$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $18c31b251a4990f6$export$a5c6d149b50c1d86($18c31b251a4990f6$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $18c31b251a4990f6$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $18c31b251a4990f6$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $18c31b251a4990f6$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $18c31b251a4990f6$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $18c31b251a4990f6$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $18c31b251a4990f6$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $18c31b251a4990f6$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $18c31b251a4990f6$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $18c31b251a4990f6$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $18c31b251a4990f6$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $18c31b251a4990f6$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $18c31b251a4990f6$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $18c31b251a4990f6$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $18c31b251a4990f6$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $18c31b251a4990f6$var$normalizeSearch(search),
        hash: $18c31b251a4990f6$var$normalizeHash(hash)
    };
}
function $18c31b251a4990f6$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $18c31b251a4990f6$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $18c31b251a4990f6$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $18c31b251a4990f6$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $18c31b251a4990f6$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === matches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $18c31b251a4990f6$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $18c31b251a4990f6$export$8ccf933b0513f8d0(toArg);
    else {
        to = $18c31b251a4990f6$var$_extends({}, toArg);
        $18c31b251a4990f6$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $18c31b251a4990f6$var$getInvalidPathError("?", "pathname", "search", to));
        $18c31b251a4990f6$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $18c31b251a4990f6$var$getInvalidPathError("#", "pathname", "hash", to));
        $18c31b251a4990f6$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $18c31b251a4990f6$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $18c31b251a4990f6$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $18c31b251a4990f6$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $18c31b251a4990f6$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $18c31b251a4990f6$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $18c31b251a4990f6$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $18c31b251a4990f6$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $18c31b251a4990f6$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $18c31b251a4990f6$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $18c31b251a4990f6$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $18c31b251a4990f6$export$42a99a7a4bc0e76a extends Error {
}
class $18c31b251a4990f6$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $18c31b251a4990f6$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $18c31b251a4990f6$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $18c31b251a4990f6$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $18c31b251a4990f6$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $18c31b251a4990f6$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $18c31b251a4990f6$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $18c31b251a4990f6$var$unwrapTrackedPromise(value) {
    if (!$18c31b251a4990f6$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $18c31b251a4990f6$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $18c31b251a4990f6$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $18c31b251a4990f6$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $18c31b251a4990f6$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $18c31b251a4990f6$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $18c31b251a4990f6$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $18c31b251a4990f6$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $18c31b251a4990f6$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $18c31b251a4990f6$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $18c31b251a4990f6$var$validMutationMethods = new Set($18c31b251a4990f6$var$validMutationMethodsArr);
const $18c31b251a4990f6$var$validRequestMethodsArr = [
    "get",
    ...$18c31b251a4990f6$var$validMutationMethodsArr
];
const $18c31b251a4990f6$var$validRequestMethods = new Set($18c31b251a4990f6$var$validRequestMethodsArr);
const $18c31b251a4990f6$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $18c31b251a4990f6$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $18c31b251a4990f6$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $18c31b251a4990f6$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $18c31b251a4990f6$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $18c31b251a4990f6$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $18c31b251a4990f6$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $18c31b251a4990f6$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $18c31b251a4990f6$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $18c31b251a4990f6$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $18c31b251a4990f6$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $18c31b251a4990f6$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    // Config driven behavior flags
    let future = $18c31b251a4990f6$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $18c31b251a4990f6$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $18c31b251a4990f6$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $18c31b251a4990f6$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized;
    let hasLazyRoutes = initialMatches.some((m)=>m.route.lazy);
    let hasLoaders = initialMatches.some((m)=>m.route.loader);
    if (hasLazyRoutes) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!hasLoaders) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        let isRouteInitialized = (m)=>{
            // No loader, nothing to initialize
            if (!m.route.loader) return true;
            // Explicitly opting-in to running on hydration
            if (m.route.loader.hydrate === true) return false;
            // Otherwise, initialized if hydrated with data or an error
            return loaderData && loaderData[m.route.id] !== undefined || errors && errors[m.route.id] !== undefined;
        };
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every(isRouteInitialized);
        } else initialized = initialMatches.every(isRouteInitialized);
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $18c31b251a4990f6$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $18c31b251a4990f6$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $18c31b251a4990f6$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $18c31b251a4990f6$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $18c31b251a4990f6$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$18c31b251a4990f6$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($18c31b251a4990f6$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $18c31b251a4990f6$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $18c31b251a4990f6$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $18c31b251a4990f6$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $18c31b251a4990f6$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $18c31b251a4990f6$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $18c31b251a4990f6$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $18c31b251a4990f6$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $18c31b251a4990f6$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $18c31b251a4990f6$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($18c31b251a4990f6$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $18c31b251a4990f6$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $18c31b251a4990f6$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $18c31b251a4990f6$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $18c31b251a4990f6$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $18c31b251a4990f6$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $18c31b251a4990f6$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $18c31b251a4990f6$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $18c31b251a4990f6$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $18c31b251a4990f6$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $18c31b251a4990f6$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $18c31b251a4990f6$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $18c31b251a4990f6$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $18c31b251a4990f6$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $18c31b251a4990f6$var$getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $18c31b251a4990f6$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $18c31b251a4990f6$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $18c31b251a4990f6$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$18c31b251a4990f6$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && $18c31b251a4990f6$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            loadingNavigation = $18c31b251a4990f6$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        }
        // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionData, pendingError);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $18c31b251a4990f6$var$_extends({
            matches: matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $18c31b251a4990f6$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        // Call our action and get the result
        let result;
        let actionMatch = $18c31b251a4990f6$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $18c31b251a4990f6$var$ResultType.error,
            error: $18c31b251a4990f6$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await $18c31b251a4990f6$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($18c31b251a4990f6$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($18c31b251a4990f6$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $18c31b251a4990f6$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $18c31b251a4990f6$export$e19cd5f9376f8cee.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($18c31b251a4990f6$var$isDeferredResult(result)) throw $18c31b251a4990f6$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $18c31b251a4990f6$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $18c31b251a4990f6$var$getSubmissionFromNavigation(loadingNavigation);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $18c31b251a4990f6$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $18c31b251a4990f6$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}, updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        if (!isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration)) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = $18c31b251a4990f6$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState($18c31b251a4990f6$var$_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $18c31b251a4990f6$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(state, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $18c31b251a4990f6$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // During partial hydration, preserve SSR errors for routes that don't re-run
        if (future.v7_partialHydration && initialHydration && state.errors) Object.entries(state.errors).filter((_ref2)=>{
            let [id] = _ref2;
            return !matchesToLoad.some((m)=>m.route.id === id);
        }).forEach((_ref3)=>{
            let [routeId, error] = _ref3;
            errors = Object.assign(errors || {}, {
                [routeId]: error
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $18c31b251a4990f6$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $18c31b251a4990f6$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $18c31b251a4990f6$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $18c31b251a4990f6$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $18c31b251a4990f6$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $18c31b251a4990f6$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $18c31b251a4990f6$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, flushSync, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $18c31b251a4990f6$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $18c31b251a4990f6$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $18c31b251a4990f6$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResult = await $18c31b251a4990f6$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($18c31b251a4990f6$var$isRedirectResult(actionResult) || $18c31b251a4990f6$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $18c31b251a4990f6$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($18c31b251a4990f6$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $18c31b251a4990f6$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $18c31b251a4990f6$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(state, actionResult, {
                        fetcherSubmission: submission
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($18c31b251a4990f6$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($18c31b251a4990f6$var$isDeferredResult(actionResult)) throw $18c31b251a4990f6$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $18c31b251a4990f6$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $18c31b251a4990f6$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $18c31b251a4990f6$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $18c31b251a4990f6$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $18c31b251a4990f6$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, {
            [match.route.id]: actionResult.data
        }, undefined // No need to send through errors since we short circuit above
        );
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $18c31b251a4990f6$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $18c31b251a4990f6$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(state, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $18c31b251a4990f6$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $18c31b251a4990f6$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $18c31b251a4990f6$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $18c31b251a4990f6$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $18c31b251a4990f6$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $18c31b251a4990f6$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let result = await $18c31b251a4990f6$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($18c31b251a4990f6$var$isDeferredResult(result)) result = await $18c31b251a4990f6$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $18c31b251a4990f6$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($18c31b251a4990f6$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $18c31b251a4990f6$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(state, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($18c31b251a4990f6$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $18c31b251a4990f6$export$3e9cee6b33872309(!$18c31b251a4990f6$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $18c31b251a4990f6$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = $18c31b251a4990f6$var$createLocation(state.location, redirect.location, {
            _isRedirect: true
        });
        $18c31b251a4990f6$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation");
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.reloadDocument) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($18c31b251a4990f6$var$ABSOLUTE_URL_REGEX.test(redirect.location)) {
                const url = init.history.createURL(redirect.location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $18c31b251a4990f6$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(redirect.location);
                else routerWindow.location.assign(redirect.location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $18c31b251a4990f6$export$e19cd5f9376f8cee.Replace : $18c31b251a4990f6$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $18c31b251a4990f6$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($18c31b251a4990f6$var$redirectPreserveMethodStatusCodes.has(redirect.status) && activeSubmission && $18c31b251a4990f6$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $18c31b251a4990f6$var$_extends({}, activeSubmission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $18c31b251a4990f6$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$18c31b251a4990f6$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath)),
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) return $18c31b251a4990f6$var$callLoaderOrAction("loader", $18c31b251a4990f6$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
                else {
                    let error = {
                        type: $18c31b251a4990f6$var$ResultType.error,
                        error: $18c31b251a4990f6$var$getInternalRouterError(404, {
                            pathname: f.path
                        })
                    };
                    return error;
                }
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $18c31b251a4990f6$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $18c31b251a4990f6$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $18c31b251a4990f6$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $18c31b251a4990f6$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $18c31b251a4990f6$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $18c31b251a4990f6$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $18c31b251a4990f6$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $18c31b251a4990f6$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $18c31b251a4990f6$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $18c31b251a4990f6$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $18c31b251a4990f6$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref4) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref4;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $18c31b251a4990f6$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $18c31b251a4990f6$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$18c31b251a4990f6$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $18c31b251a4990f6$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $18c31b251a4990f6$export$4d0306f8f6a4585b = Symbol("deferred");
function $18c31b251a4990f6$export$3336b097a6fbc59a(routes, opts) {
    $18c31b251a4990f6$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $18c31b251a4990f6$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $18c31b251a4990f6$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $18c31b251a4990f6$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp3) {
        let { requestContext: requestContext } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $18c31b251a4990f6$var$createLocation("", $18c31b251a4990f6$export$fe53371bee54353d(url), null, "default");
        let matches = $18c31b251a4990f6$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$18c31b251a4990f6$var$isValidMethod(method) && method !== "HEAD") {
            let error = $18c31b251a4990f6$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $18c31b251a4990f6$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $18c31b251a4990f6$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $18c31b251a4990f6$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if ($18c31b251a4990f6$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $18c31b251a4990f6$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $18c31b251a4990f6$var$createLocation("", $18c31b251a4990f6$export$fe53371bee54353d(url), null, "default");
        let matches = $18c31b251a4990f6$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$18c31b251a4990f6$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $18c31b251a4990f6$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $18c31b251a4990f6$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $18c31b251a4990f6$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $18c31b251a4990f6$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $18c31b251a4990f6$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if ($18c31b251a4990f6$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$18c31b251a4990f6$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        $18c31b251a4990f6$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($18c31b251a4990f6$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $18c31b251a4990f6$var$getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return $18c31b251a4990f6$var$isResponse(result) ? result : $18c31b251a4990f6$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if ($18c31b251a4990f6$var$isQueryRouteResponse(e)) {
                if (e.type === $18c31b251a4990f6$var$ResultType.error) throw e.response;
                return e.response;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($18c31b251a4990f6$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $18c31b251a4990f6$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $18c31b251a4990f6$var$ResultType.error,
                error: error
            };
        } else {
            result = await $18c31b251a4990f6$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath, {
                isStaticRequest: true,
                isRouteRequest: isRouteRequest,
                requestContext: requestContext
            });
            if (request.signal.aborted) $18c31b251a4990f6$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($18c31b251a4990f6$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($18c31b251a4990f6$var$isDeferredResult(result)) {
            let error = $18c31b251a4990f6$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $18c31b251a4990f6$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($18c31b251a4990f6$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if ($18c31b251a4990f6$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $18c31b251a4990f6$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            });
            // action status codes take precedence over loader status codes
            return $18c31b251a4990f6$var$_extends({}, context, {
                statusCode: $18c31b251a4990f6$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $18c31b251a4990f6$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return $18c31b251a4990f6$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $18c31b251a4990f6$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $18c31b251a4990f6$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : $18c31b251a4990f6$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$18c31b251a4990f6$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath, {
                    isStaticRequest: true,
                    isRouteRequest: isRouteRequest,
                    requestContext: requestContext
                }))
        ]);
        if (request.signal.aborted) $18c31b251a4990f6$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $18c31b251a4990f6$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $18c31b251a4990f6$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $18c31b251a4990f6$export$fec11da027c70692(routes, context, error) {
    let newContext = $18c31b251a4990f6$var$_extends({}, context, {
        statusCode: $18c31b251a4990f6$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $18c31b251a4990f6$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $18c31b251a4990f6$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $18c31b251a4990f6$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $18c31b251a4990f6$export$cae722b0cc860f13(to ? to : ".", $18c31b251a4990f6$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $18c31b251a4990f6$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$18c31b251a4990f6$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $18c31b251a4990f6$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $18c31b251a4990f6$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $18c31b251a4990f6$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$18c31b251a4990f6$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$18c31b251a4990f6$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $18c31b251a4990f6$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $18c31b251a4990f6$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $18c31b251a4990f6$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$18c31b251a4990f6$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref5)=>{
                let [name, value] = _ref5;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$18c31b251a4990f6$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $18c31b251a4990f6$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $18c31b251a4990f6$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $18c31b251a4990f6$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $18c31b251a4990f6$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $18c31b251a4990f6$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($18c31b251a4990f6$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $18c31b251a4990f6$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $18c31b251a4990f6$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $18c31b251a4990f6$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $18c31b251a4990f6$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $18c31b251a4990f6$var$getMatchesToLoad(history, state, matches, submission, location, isInitialLoad, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $18c31b251a4990f6$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (isInitialLoad) {
            if (route.loader.hydrate) return true;
            return state.loaderData[route.id] === undefined && // Don't re-run if the loader ran and threw an error
            (!state.errors || state.errors[route.id] === undefined);
        }
        // Always call the loader on new route instances and pending defer cancellations
        if ($18c31b251a4990f6$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $18c31b251a4990f6$var$shouldRevalidateLoader(match, $18c31b251a4990f6$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $18c31b251a4990f6$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial load (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (isInitialLoad || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $18c31b251a4990f6$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $18c31b251a4990f6$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $18c31b251a4990f6$var$shouldRevalidateLoader(fetcherMatch, $18c31b251a4990f6$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $18c31b251a4990f6$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $18c31b251a4990f6$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $18c31b251a4990f6$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $18c31b251a4990f6$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $18c31b251a4990f6$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $18c31b251a4990f6$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$18c31b251a4990f6$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $18c31b251a4990f6$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
async function $18c31b251a4990f6$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, v7_relativeSplatPath, opts) {
    if (opts === void 0) opts = {};
    let resultType;
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        return Promise.race([
            handler({
                request: request,
                params: match.params,
                context: opts.requestContext
            }),
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let values = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    $18c31b251a4990f6$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError) throw handlerError;
                result = values[0];
            } else {
                // Load lazy route module, then run any returned handler
                await $18c31b251a4990f6$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still run even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $18c31b251a4990f6$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $18c31b251a4990f6$var$ResultType.data,
                    data: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $18c31b251a4990f6$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $18c31b251a4990f6$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = $18c31b251a4990f6$var$ResultType.error;
        result = e;
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    if ($18c31b251a4990f6$var$isResponse(result)) {
        let status = result.status;
        // Process redirects
        if ($18c31b251a4990f6$var$redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            $18c31b251a4990f6$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
            // Support relative routing in internal redirects
            if (!$18c31b251a4990f6$var$ABSOLUTE_URL_REGEX.test(location)) location = $18c31b251a4990f6$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location, v7_relativeSplatPath);
            else if (!opts.isStaticRequest) {
                // Strip off the protocol+origin for same-origin + same-basename absolute
                // redirects. If this is a static request, we can let it go back to the
                // browser as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                let isSameBasename = $18c31b251a4990f6$export$b69e3301ce081aa3(url.pathname, basename) != null;
                if (url.origin === currentUrl.origin && isSameBasename) location = url.pathname + url.search + url.hash;
            }
            // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (opts.isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: $18c31b251a4990f6$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null,
                reloadDocument: result.headers.get("X-Remix-Reload-Document") !== null
            };
        }
        // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (opts.isRouteRequest) {
            let queryRouteResponse = {
                type: resultType === $18c31b251a4990f6$var$ResultType.error ? $18c31b251a4990f6$var$ResultType.error : $18c31b251a4990f6$var$ResultType.data,
                response: result
            };
            throw queryRouteResponse;
        }
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $18c31b251a4990f6$var$ResultType.error,
                error: e
            };
        }
        if (resultType === $18c31b251a4990f6$var$ResultType.error) return {
            type: resultType,
            error: new $18c31b251a4990f6$export$6c6580e81da25755(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $18c31b251a4990f6$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $18c31b251a4990f6$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if ($18c31b251a4990f6$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $18c31b251a4990f6$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $18c31b251a4990f6$var$ResultType.data,
        data: result
    };
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $18c31b251a4990f6$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($18c31b251a4990f6$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $18c31b251a4990f6$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $18c31b251a4990f6$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $18c31b251a4990f6$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $18c31b251a4990f6$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $18c31b251a4990f6$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $18c31b251a4990f6$export$3e9cee6b33872309(!$18c31b251a4990f6$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($18c31b251a4990f6$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $18c31b251a4990f6$var$findNearestBoundary(matches, id);
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {};
            // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $18c31b251a4990f6$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($18c31b251a4990f6$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $18c31b251a4990f6$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $18c31b251a4990f6$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds);
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $18c31b251a4990f6$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($18c31b251a4990f6$var$isErrorResult(result)) {
            let boundaryMatch = $18c31b251a4990f6$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $18c31b251a4990f6$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($18c31b251a4990f6$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $18c31b251a4990f6$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($18c31b251a4990f6$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $18c31b251a4990f6$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $18c31b251a4990f6$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $18c31b251a4990f6$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $18c31b251a4990f6$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $18c31b251a4990f6$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $18c31b251a4990f6$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $18c31b251a4990f6$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $18c31b251a4990f6$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $18c31b251a4990f6$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($18c31b251a4990f6$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $18c31b251a4990f6$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $18c31b251a4990f6$export$8ccf933b0513f8d0(path) : path;
    return $18c31b251a4990f6$export$fe53371bee54353d($18c31b251a4990f6$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $18c31b251a4990f6$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $18c31b251a4990f6$var$isDeferredResult(result) {
    return result.type === $18c31b251a4990f6$var$ResultType.deferred;
}
function $18c31b251a4990f6$var$isErrorResult(result) {
    return result.type === $18c31b251a4990f6$var$ResultType.error;
}
function $18c31b251a4990f6$var$isRedirectResult(result) {
    return (result && result.type) === $18c31b251a4990f6$var$ResultType.redirect;
}
function $18c31b251a4990f6$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $18c31b251a4990f6$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $18c31b251a4990f6$var$isRedirectResponse(result) {
    if (!$18c31b251a4990f6$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $18c31b251a4990f6$var$isQueryRouteResponse(obj) {
    return obj && $18c31b251a4990f6$var$isResponse(obj.response) && (obj.type === $18c31b251a4990f6$var$ResultType.data || obj.type === $18c31b251a4990f6$var$ResultType.error);
}
function $18c31b251a4990f6$var$isValidMethod(method) {
    return $18c31b251a4990f6$var$validRequestMethods.has(method.toLowerCase());
}
function $18c31b251a4990f6$var$isMutationMethod(method) {
    return $18c31b251a4990f6$var$validMutationMethods.has(method.toLowerCase());
}
async function $18c31b251a4990f6$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$18c31b251a4990f6$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($18c31b251a4990f6$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $18c31b251a4990f6$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $18c31b251a4990f6$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $18c31b251a4990f6$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $18c31b251a4990f6$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $18c31b251a4990f6$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $18c31b251a4990f6$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $18c31b251a4990f6$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $18c31b251a4990f6$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $18c31b251a4990f6$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $18c31b251a4990f6$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $18c31b251a4990f6$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $18c31b251a4990f6$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $18c31b251a4990f6$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $18c31b251a4990f6$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $18c31b251a4990f6$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $18c31b251a4990f6$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $18c31b251a4990f6$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $18c31b251a4990f6$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($18c31b251a4990f6$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $18c31b251a4990f6$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($18c31b251a4990f6$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $18c31b251a4990f6$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.22.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $lBnVc = parcelRequire("lBnVc");

function $f02d97b5ca509f34$var$_extends() {
    $f02d97b5ca509f34$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f02d97b5ca509f34$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $f02d97b5ca509f34$export$3add0d5dce533e2e = /*#__PURE__*/ $lBnVc.createContext(null);
const $f02d97b5ca509f34$export$145dfa71566a64dc = /*#__PURE__*/ $lBnVc.createContext(null);
const $f02d97b5ca509f34$var$AwaitContext = /*#__PURE__*/ $lBnVc.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $f02d97b5ca509f34$export$26749e8557646306 = /*#__PURE__*/ $lBnVc.createContext(null);
const $f02d97b5ca509f34$export$c7914228fb69b0f5 = /*#__PURE__*/ $lBnVc.createContext(null);
const $f02d97b5ca509f34$export$9072aa6dd1f93057 = /*#__PURE__*/ $lBnVc.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $f02d97b5ca509f34$var$RouteErrorContext = /*#__PURE__*/ $lBnVc.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $f02d97b5ca509f34$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$f02d97b5ca509f34$export$9c954a9d03d32f4a() && (0, $18c31b251a4990f6$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $lBnVc.useContext($f02d97b5ca509f34$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $f02d97b5ca509f34$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $18c31b251a4990f6$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $f02d97b5ca509f34$export$9c954a9d03d32f4a() {
    return $lBnVc.useContext($f02d97b5ca509f34$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $f02d97b5ca509f34$export$45d76561a5302f2b() {
    !$f02d97b5ca509f34$export$9c954a9d03d32f4a() && (0, $18c31b251a4990f6$export$3e9cee6b33872309)(false);
    return $lBnVc.useContext($f02d97b5ca509f34$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $f02d97b5ca509f34$export$1b3f31771c5d07c() {
    return $lBnVc.useContext($f02d97b5ca509f34$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $f02d97b5ca509f34$export$6c330e8992e8a295(pattern) {
    !$f02d97b5ca509f34$export$9c954a9d03d32f4a() && (0, $18c31b251a4990f6$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $f02d97b5ca509f34$export$45d76561a5302f2b();
    return $lBnVc.useMemo(()=>(0, $18c31b251a4990f6$export$81336c211d5ff295)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $f02d97b5ca509f34$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $f02d97b5ca509f34$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $lBnVc.useContext($f02d97b5ca509f34$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $lBnVc.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $f02d97b5ca509f34$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $lBnVc.useContext($f02d97b5ca509f34$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $f02d97b5ca509f34$var$useNavigateStable() : $f02d97b5ca509f34$var$useNavigateUnstable();
}
function $f02d97b5ca509f34$var$useNavigateUnstable() {
    !$f02d97b5ca509f34$export$9c954a9d03d32f4a() && (0, $18c31b251a4990f6$export$3e9cee6b33872309)(false);
    let dataRouterContext = $lBnVc.useContext($f02d97b5ca509f34$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $lBnVc.useContext($f02d97b5ca509f34$export$26749e8557646306);
    let { matches: matches } = $lBnVc.useContext($f02d97b5ca509f34$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $f02d97b5ca509f34$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $18c31b251a4990f6$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $lBnVc.useRef(false);
    $f02d97b5ca509f34$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $lBnVc.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $18c31b251a4990f6$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $18c31b251a4990f6$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $f02d97b5ca509f34$var$OutletContext = /*#__PURE__*/ $lBnVc.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $f02d97b5ca509f34$export$4138103a3ae699cc() {
    return $lBnVc.useContext($f02d97b5ca509f34$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $f02d97b5ca509f34$export$a3be3530d8e40d0b(context) {
    let outlet = $lBnVc.useContext($f02d97b5ca509f34$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $lBnVc.createElement($f02d97b5ca509f34$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $f02d97b5ca509f34$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $lBnVc.useContext($f02d97b5ca509f34$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $f02d97b5ca509f34$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $lBnVc.useContext($f02d97b5ca509f34$export$26749e8557646306);
    let { matches: matches } = $lBnVc.useContext($f02d97b5ca509f34$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $f02d97b5ca509f34$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $18c31b251a4990f6$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $lBnVc.useMemo(()=>(0, $18c31b251a4990f6$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $f02d97b5ca509f34$export$5d3fca4a98652595(routes, locationArg) {
    return $f02d97b5ca509f34$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $f02d97b5ca509f34$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$f02d97b5ca509f34$export$9c954a9d03d32f4a() && (0, $18c31b251a4990f6$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $lBnVc.useContext($f02d97b5ca509f34$export$26749e8557646306);
    let { matches: parentMatches } = $lBnVc.useContext($f02d97b5ca509f34$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $f02d97b5ca509f34$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $18c31b251a4990f6$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $18c31b251a4990f6$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $18c31b251a4990f6$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $f02d97b5ca509f34$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $18c31b251a4990f6$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $18c31b251a4990f6$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $lBnVc.createElement($f02d97b5ca509f34$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $f02d97b5ca509f34$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $18c31b251a4990f6$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $f02d97b5ca509f34$var$DefaultErrorComponent() {
    let error = $f02d97b5ca509f34$export$ed527bf60f6e05f2();
    let message = (0, $18c31b251a4990f6$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $lBnVc.createElement($lBnVc.Fragment, null, /*#__PURE__*/ $lBnVc.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $lBnVc.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $lBnVc.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $f02d97b5ca509f34$var$defaultErrorElement = /*#__PURE__*/ $lBnVc.createElement($f02d97b5ca509f34$var$DefaultErrorComponent, null);
class $f02d97b5ca509f34$var$RenderErrorBoundary extends $lBnVc.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $lBnVc.createElement($f02d97b5ca509f34$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $lBnVc.createElement($f02d97b5ca509f34$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $f02d97b5ca509f34$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $lBnVc.useContext($f02d97b5ca509f34$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $lBnVc.createElement($f02d97b5ca509f34$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $f02d97b5ca509f34$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $18c31b251a4990f6$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $f02d97b5ca509f34$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $f02d97b5ca509f34$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $lBnVc.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $lBnVc.createElement($f02d97b5ca509f34$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $lBnVc.createElement($f02d97b5ca509f34$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $f02d97b5ca509f34$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($f02d97b5ca509f34$var$DataRouterHook || {});
var $f02d97b5ca509f34$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($f02d97b5ca509f34$var$DataRouterStateHook || {});
function $f02d97b5ca509f34$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $f02d97b5ca509f34$var$useDataRouterContext(hookName) {
    let ctx = $lBnVc.useContext($f02d97b5ca509f34$export$3add0d5dce533e2e);
    !ctx && (0, $18c31b251a4990f6$export$3e9cee6b33872309)(false);
    return ctx;
}
function $f02d97b5ca509f34$var$useDataRouterState(hookName) {
    let state = $lBnVc.useContext($f02d97b5ca509f34$export$145dfa71566a64dc);
    !state && (0, $18c31b251a4990f6$export$3e9cee6b33872309)(false);
    return state;
}
function $f02d97b5ca509f34$var$useRouteContext(hookName) {
    let route = $lBnVc.useContext($f02d97b5ca509f34$export$9072aa6dd1f93057);
    !route && (0, $18c31b251a4990f6$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $f02d97b5ca509f34$var$useCurrentRouteId(hookName) {
    let route = $f02d97b5ca509f34$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $18c31b251a4990f6$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $f02d97b5ca509f34$export$5fc8298006ad9e58() {
    return $f02d97b5ca509f34$var$useCurrentRouteId($f02d97b5ca509f34$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $f02d97b5ca509f34$export$d0fd4b7106de2769() {
    let state = $f02d97b5ca509f34$var$useDataRouterState($f02d97b5ca509f34$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $f02d97b5ca509f34$export$600dc272ed516c15() {
    let dataRouterContext = $f02d97b5ca509f34$var$useDataRouterContext($f02d97b5ca509f34$var$DataRouterHook.UseRevalidator);
    let state = $f02d97b5ca509f34$var$useDataRouterState($f02d97b5ca509f34$var$DataRouterStateHook.UseRevalidator);
    return $lBnVc.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $f02d97b5ca509f34$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $f02d97b5ca509f34$var$useDataRouterState($f02d97b5ca509f34$var$DataRouterStateHook.UseMatches);
    return $lBnVc.useMemo(()=>matches.map((m)=>(0, $18c31b251a4990f6$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $f02d97b5ca509f34$export$1448a5050d252c4d() {
    let state = $f02d97b5ca509f34$var$useDataRouterState($f02d97b5ca509f34$var$DataRouterStateHook.UseLoaderData);
    let routeId = $f02d97b5ca509f34$var$useCurrentRouteId($f02d97b5ca509f34$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $f02d97b5ca509f34$export$fd5d37484eab868d(routeId) {
    let state = $f02d97b5ca509f34$var$useDataRouterState($f02d97b5ca509f34$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $f02d97b5ca509f34$export$fdc00f3f26066d5e() {
    let state = $f02d97b5ca509f34$var$useDataRouterState($f02d97b5ca509f34$var$DataRouterStateHook.UseActionData);
    let routeId = $f02d97b5ca509f34$var$useCurrentRouteId($f02d97b5ca509f34$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $f02d97b5ca509f34$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $lBnVc.useContext($f02d97b5ca509f34$var$RouteErrorContext);
    let state = $f02d97b5ca509f34$var$useDataRouterState($f02d97b5ca509f34$var$DataRouterStateHook.UseRouteError);
    let routeId = $f02d97b5ca509f34$var$useCurrentRouteId($f02d97b5ca509f34$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $f02d97b5ca509f34$export$78a72ddb39bdd145() {
    let value = $lBnVc.useContext($f02d97b5ca509f34$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $f02d97b5ca509f34$export$17f53340677d5831() {
    let value = $lBnVc.useContext($f02d97b5ca509f34$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $f02d97b5ca509f34$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $f02d97b5ca509f34$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $f02d97b5ca509f34$var$useDataRouterContext($f02d97b5ca509f34$var$DataRouterHook.UseBlocker);
    let state = $f02d97b5ca509f34$var$useDataRouterState($f02d97b5ca509f34$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $lBnVc.useState("");
    let blockerFunction = $lBnVc.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $f02d97b5ca509f34$var$_extends({}, currentLocation, {
                pathname: (0, $18c31b251a4990f6$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $f02d97b5ca509f34$var$_extends({}, nextLocation, {
                pathname: (0, $18c31b251a4990f6$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $lBnVc.useEffect(()=>{
        let key = String(++$f02d97b5ca509f34$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $lBnVc.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $18c31b251a4990f6$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $f02d97b5ca509f34$var$useNavigateStable() {
    let { router: router } = $f02d97b5ca509f34$var$useDataRouterContext($f02d97b5ca509f34$var$DataRouterHook.UseNavigateStable);
    let id = $f02d97b5ca509f34$var$useCurrentRouteId($f02d97b5ca509f34$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $lBnVc.useRef(false);
    $f02d97b5ca509f34$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $lBnVc.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $f02d97b5ca509f34$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $f02d97b5ca509f34$var$alreadyWarned = {};
function $f02d97b5ca509f34$var$warningOnce(key, cond, message) {
    if (!cond && !$f02d97b5ca509f34$var$alreadyWarned[key]) $f02d97b5ca509f34$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $f02d97b5ca509f34$var$START_TRANSITION = "startTransition";
const $f02d97b5ca509f34$var$startTransitionImpl = $lBnVc[$f02d97b5ca509f34$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $f02d97b5ca509f34$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $lBnVc.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $lBnVc.useCallback((newState)=>{
        if (v7_startTransition && $f02d97b5ca509f34$var$startTransitionImpl) $f02d97b5ca509f34$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $lBnVc.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $lBnVc.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $lBnVc.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $lBnVc.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $lBnVc.createElement($lBnVc.Fragment, null, /*#__PURE__*/ $lBnVc.createElement($f02d97b5ca509f34$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $lBnVc.createElement($f02d97b5ca509f34$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $lBnVc.createElement($f02d97b5ca509f34$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $lBnVc.createElement($f02d97b5ca509f34$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $f02d97b5ca509f34$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $f02d97b5ca509f34$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $f02d97b5ca509f34$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $lBnVc.useRef();
    if (historyRef.current == null) historyRef.current = (0, $18c31b251a4990f6$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $lBnVc.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $lBnVc.useCallback((newState)=>{
        v7_startTransition && $f02d97b5ca509f34$var$startTransitionImpl ? $f02d97b5ca509f34$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $lBnVc.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $lBnVc.createElement($f02d97b5ca509f34$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $f02d97b5ca509f34$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$f02d97b5ca509f34$export$9c954a9d03d32f4a() && (0, $18c31b251a4990f6$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $lBnVc.useContext($f02d97b5ca509f34$export$26749e8557646306);
    let { matches: matches } = $lBnVc.useContext($f02d97b5ca509f34$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $f02d97b5ca509f34$export$45d76561a5302f2b();
    let navigate = $f02d97b5ca509f34$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $18c31b251a4990f6$export$cae722b0cc860f13)(to, (0, $18c31b251a4990f6$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $lBnVc.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $f02d97b5ca509f34$export$910ae8079b2c2852(props) {
    return $f02d97b5ca509f34$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $f02d97b5ca509f34$export$e7b0ac011bb776c6(_props) {
    (0, $18c31b251a4990f6$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $f02d97b5ca509f34$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $18c31b251a4990f6$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$f02d97b5ca509f34$export$9c954a9d03d32f4a() && (0, $18c31b251a4990f6$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $lBnVc.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $f02d97b5ca509f34$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $18c31b251a4990f6$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $lBnVc.useMemo(()=>{
        let trailingPathname = (0, $18c31b251a4990f6$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $lBnVc.createElement($f02d97b5ca509f34$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $lBnVc.createElement($f02d97b5ca509f34$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $f02d97b5ca509f34$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $f02d97b5ca509f34$export$5d3fca4a98652595($f02d97b5ca509f34$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $f02d97b5ca509f34$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $lBnVc.createElement($f02d97b5ca509f34$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $lBnVc.createElement($f02d97b5ca509f34$var$ResolveAwait, null, children));
}
var $f02d97b5ca509f34$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($f02d97b5ca509f34$var$AwaitRenderStatus || {});
const $f02d97b5ca509f34$var$neverSettledPromise = new Promise(()=>{});
class $f02d97b5ca509f34$var$AwaitErrorBoundary extends $lBnVc.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $f02d97b5ca509f34$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $f02d97b5ca509f34$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $f02d97b5ca509f34$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $f02d97b5ca509f34$var$AwaitRenderStatus.error : promise._data !== undefined ? $f02d97b5ca509f34$var$AwaitRenderStatus.success : $f02d97b5ca509f34$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $f02d97b5ca509f34$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $f02d97b5ca509f34$var$AwaitRenderStatus.error && promise._error instanceof (0, $18c31b251a4990f6$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $f02d97b5ca509f34$var$neverSettledPromise;
        if (status === $f02d97b5ca509f34$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $f02d97b5ca509f34$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $lBnVc.createElement($f02d97b5ca509f34$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $f02d97b5ca509f34$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $lBnVc.createElement($f02d97b5ca509f34$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $f02d97b5ca509f34$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $f02d97b5ca509f34$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $lBnVc.createElement($lBnVc.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $f02d97b5ca509f34$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $lBnVc.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $lBnVc.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $lBnVc.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $f02d97b5ca509f34$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $f02d97b5ca509f34$export$e7b0ac011bb776c6) && (0, $18c31b251a4990f6$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $18c31b251a4990f6$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $f02d97b5ca509f34$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $f02d97b5ca509f34$export$daf73786167a7f72(matches) {
    return $f02d97b5ca509f34$var$_renderMatches(matches);
}
function $f02d97b5ca509f34$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $lBnVc.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $lBnVc.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $lBnVc.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $f02d97b5ca509f34$export$f30f7e456d254e83(routes, opts) {
    return (0, $18c31b251a4990f6$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $f02d97b5ca509f34$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $18c31b251a4990f6$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $f02d97b5ca509f34$export$52b333d321859367
    }).initialize();
}



function $e94b7bcc277332d2$var$_extends() {
    $e94b7bcc277332d2$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e94b7bcc277332d2$var$_extends.apply(this, arguments);
}
function $e94b7bcc277332d2$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $e94b7bcc277332d2$var$defaultMethod = "get";
const $e94b7bcc277332d2$var$defaultEncType = "application/x-www-form-urlencoded";
function $e94b7bcc277332d2$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $e94b7bcc277332d2$var$isButtonElement(object) {
    return $e94b7bcc277332d2$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $e94b7bcc277332d2$var$isFormElement(object) {
    return $e94b7bcc277332d2$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $e94b7bcc277332d2$var$isInputElement(object) {
    return $e94b7bcc277332d2$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $e94b7bcc277332d2$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $e94b7bcc277332d2$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$e94b7bcc277332d2$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $e94b7bcc277332d2$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $e94b7bcc277332d2$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $e94b7bcc277332d2$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $e94b7bcc277332d2$var$_formDataSupportsSubmitter = null;
function $e94b7bcc277332d2$var$isFormDataSubmitterSupported() {
    if ($e94b7bcc277332d2$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $e94b7bcc277332d2$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $e94b7bcc277332d2$var$_formDataSupportsSubmitter = true;
    }
    return $e94b7bcc277332d2$var$_formDataSupportsSubmitter;
}
const $e94b7bcc277332d2$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $e94b7bcc277332d2$var$getFormEncType(encType) {
    if (encType != null && !$e94b7bcc277332d2$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $e94b7bcc277332d2$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($e94b7bcc277332d2$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $18c31b251a4990f6$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $e94b7bcc277332d2$var$defaultMethod;
        encType = $e94b7bcc277332d2$var$getFormEncType(target.getAttribute("enctype")) || $e94b7bcc277332d2$var$defaultEncType;
        formData = new FormData(target);
    } else if ($e94b7bcc277332d2$var$isButtonElement(target) || $e94b7bcc277332d2$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $18c31b251a4990f6$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $e94b7bcc277332d2$var$defaultMethod;
        encType = $e94b7bcc277332d2$var$getFormEncType(target.getAttribute("formenctype")) || $e94b7bcc277332d2$var$getFormEncType(form.getAttribute("enctype")) || $e94b7bcc277332d2$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$e94b7bcc277332d2$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($e94b7bcc277332d2$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $e94b7bcc277332d2$var$defaultMethod;
        action = null;
        encType = $e94b7bcc277332d2$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $e94b7bcc277332d2$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $e94b7bcc277332d2$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $e94b7bcc277332d2$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $e94b7bcc277332d2$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $e94b7bcc277332d2$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $e94b7bcc277332d2$export$1f3f55432a00e06d(routes, opts) {
    return (0, $18c31b251a4990f6$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $e94b7bcc277332d2$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $18c31b251a4990f6$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $e94b7bcc277332d2$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $f02d97b5ca509f34$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $e94b7bcc277332d2$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $18c31b251a4990f6$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $e94b7bcc277332d2$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $18c31b251a4990f6$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $e94b7bcc277332d2$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $f02d97b5ca509f34$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $e94b7bcc277332d2$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $e94b7bcc277332d2$var$_extends({}, state, {
        errors: $e94b7bcc277332d2$var$deserializeErrors(state.errors)
    });
    return state;
}
function $e94b7bcc277332d2$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $18c31b251a4990f6$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $e94b7bcc277332d2$export$7ad602f0e94e62d1 = /*#__PURE__*/ $lBnVc.createContext({
    isTransitioning: false
});
const $e94b7bcc277332d2$export$148fd98d095596d4 = /*#__PURE__*/ $lBnVc.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $e94b7bcc277332d2$var$START_TRANSITION = "startTransition";
const $e94b7bcc277332d2$var$startTransitionImpl = $lBnVc[$e94b7bcc277332d2$var$START_TRANSITION];
const $e94b7bcc277332d2$var$FLUSH_SYNC = "flushSync";
const $e94b7bcc277332d2$var$flushSyncImpl = $cc4070eb400e02f6$exports[$e94b7bcc277332d2$var$FLUSH_SYNC];
const $e94b7bcc277332d2$var$USE_ID = "useId";
const $e94b7bcc277332d2$var$useIdImpl = $lBnVc[$e94b7bcc277332d2$var$USE_ID];
function $e94b7bcc277332d2$var$startTransitionSafe(cb) {
    if ($e94b7bcc277332d2$var$startTransitionImpl) $e94b7bcc277332d2$var$startTransitionImpl(cb);
    else cb();
}
function $e94b7bcc277332d2$var$flushSyncSafe(cb) {
    if ($e94b7bcc277332d2$var$flushSyncImpl) $e94b7bcc277332d2$var$flushSyncImpl(cb);
    else cb();
}
class $e94b7bcc277332d2$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $e94b7bcc277332d2$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $lBnVc.useState(router.state);
    let [pendingState, setPendingState] = $lBnVc.useState();
    let [vtContext, setVtContext] = $lBnVc.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $lBnVc.useState();
    let [transition, setTransition] = $lBnVc.useState();
    let [interruption, setInterruption] = $lBnVc.useState();
    let fetcherData = $lBnVc.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $lBnVc.useCallback((cb)=>{
        if (v7_startTransition) $e94b7bcc277332d2$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $lBnVc.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, unstable_flushSync: flushSync, unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $e94b7bcc277332d2$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $e94b7bcc277332d2$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $e94b7bcc277332d2$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $e94b7bcc277332d2$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $e94b7bcc277332d2$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $lBnVc.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $lBnVc.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $e94b7bcc277332d2$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $lBnVc.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $lBnVc.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $lBnVc.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $lBnVc.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $lBnVc.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $lBnVc.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $lBnVc.createElement($lBnVc.Fragment, null, /*#__PURE__*/ $lBnVc.createElement((0, $f02d97b5ca509f34$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $lBnVc.createElement((0, $f02d97b5ca509f34$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $lBnVc.createElement($e94b7bcc277332d2$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $lBnVc.createElement($e94b7bcc277332d2$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $lBnVc.createElement((0, $f02d97b5ca509f34$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $lBnVc.createElement($e94b7bcc277332d2$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
function $e94b7bcc277332d2$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $f02d97b5ca509f34$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $e94b7bcc277332d2$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $lBnVc.useRef();
    if (historyRef.current == null) historyRef.current = (0, $18c31b251a4990f6$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $lBnVc.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $lBnVc.useCallback((newState)=>{
        v7_startTransition && $e94b7bcc277332d2$var$startTransitionImpl ? $e94b7bcc277332d2$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $lBnVc.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $lBnVc.createElement((0, $f02d97b5ca509f34$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $e94b7bcc277332d2$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $lBnVc.useRef();
    if (historyRef.current == null) historyRef.current = (0, $18c31b251a4990f6$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $lBnVc.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $lBnVc.useCallback((newState)=>{
        v7_startTransition && $e94b7bcc277332d2$var$startTransitionImpl ? $e94b7bcc277332d2$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $lBnVc.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $lBnVc.createElement((0, $f02d97b5ca509f34$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $e94b7bcc277332d2$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $lBnVc.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $lBnVc.useCallback((newState)=>{
        v7_startTransition && $e94b7bcc277332d2$var$startTransitionImpl ? $e94b7bcc277332d2$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $lBnVc.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $lBnVc.createElement((0, $f02d97b5ca509f34$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $e94b7bcc277332d2$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $e94b7bcc277332d2$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $e94b7bcc277332d2$export$a6c7ac8248d6e38a = /*#__PURE__*/ $lBnVc.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref7, rest = $e94b7bcc277332d2$var$_objectWithoutPropertiesLoose(_ref7, $e94b7bcc277332d2$var$_excluded);
    let { basename: basename } = $lBnVc.useContext((0, $f02d97b5ca509f34$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $e94b7bcc277332d2$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($e94b7bcc277332d2$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $18c31b251a4990f6$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $f02d97b5ca509f34$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $e94b7bcc277332d2$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $lBnVc.createElement("a", $e94b7bcc277332d2$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $e94b7bcc277332d2$export$b0d92dbee9b5b60d = /*#__PURE__*/ $lBnVc.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, unstable_viewTransition: unstable_viewTransition, children: children } = _ref8, rest = $e94b7bcc277332d2$var$_objectWithoutPropertiesLoose(_ref8, $e94b7bcc277332d2$var$_excluded2);
    let path = (0, $f02d97b5ca509f34$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $f02d97b5ca509f34$export$45d76561a5302f2b)();
    let routerState = $lBnVc.useContext((0, $f02d97b5ca509f34$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $lBnVc.useContext((0, $f02d97b5ca509f34$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $e94b7bcc277332d2$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $18c31b251a4990f6$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $lBnVc.createElement($e94b7bcc277332d2$export$a6c7ac8248d6e38a, $e94b7bcc277332d2$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $e94b7bcc277332d2$export$a7fed597f4b8afd8 = /*#__PURE__*/ $lBnVc.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $e94b7bcc277332d2$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref9, props = $e94b7bcc277332d2$var$_objectWithoutPropertiesLoose(_ref9, $e94b7bcc277332d2$var$_excluded3);
    let submit = $e94b7bcc277332d2$export$47c85c6e3a081d3();
    let formAction = $e94b7bcc277332d2$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $lBnVc.createElement("form", $e94b7bcc277332d2$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $e94b7bcc277332d2$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $e94b7bcc277332d2$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $e94b7bcc277332d2$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($e94b7bcc277332d2$var$DataRouterHook || ($e94b7bcc277332d2$var$DataRouterHook = {}));
var $e94b7bcc277332d2$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($e94b7bcc277332d2$var$DataRouterStateHook || ($e94b7bcc277332d2$var$DataRouterStateHook = {}));
// Internal hooks
function $e94b7bcc277332d2$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $e94b7bcc277332d2$var$useDataRouterContext(hookName) {
    let ctx = $lBnVc.useContext((0, $f02d97b5ca509f34$export$3add0d5dce533e2e));
    !ctx && (0, $18c31b251a4990f6$export$3e9cee6b33872309)(false);
    return ctx;
}
function $e94b7bcc277332d2$var$useDataRouterState(hookName) {
    let state = $lBnVc.useContext((0, $f02d97b5ca509f34$export$145dfa71566a64dc));
    !state && (0, $18c31b251a4990f6$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $e94b7bcc277332d2$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, unstable_viewTransition: unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $f02d97b5ca509f34$export$9770f232ac06a008)();
    let location = (0, $f02d97b5ca509f34$export$45d76561a5302f2b)();
    let path = (0, $f02d97b5ca509f34$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $lBnVc.useCallback((event)=>{
        if ($e94b7bcc277332d2$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $18c31b251a4990f6$export$fe53371bee54353d)(location) === (0, $18c31b251a4990f6$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $e94b7bcc277332d2$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $lBnVc.useRef($e94b7bcc277332d2$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $lBnVc.useRef(false);
    let location = (0, $f02d97b5ca509f34$export$45d76561a5302f2b)();
    let searchParams = $lBnVc.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $e94b7bcc277332d2$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $f02d97b5ca509f34$export$9770f232ac06a008)();
    let setSearchParams = $lBnVc.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $e94b7bcc277332d2$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $e94b7bcc277332d2$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $e94b7bcc277332d2$var$fetcherId = 0;
let $e94b7bcc277332d2$var$getUniqueFetcherId = ()=>"__" + String(++$e94b7bcc277332d2$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $e94b7bcc277332d2$export$47c85c6e3a081d3() {
    let { router: router } = $e94b7bcc277332d2$var$useDataRouterContext($e94b7bcc277332d2$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $lBnVc.useContext((0, $f02d97b5ca509f34$export$26749e8557646306));
    let currentRouteId = (0, $f02d97b5ca509f34$export$5fc8298006ad9e58)();
    return $lBnVc.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $e94b7bcc277332d2$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $e94b7bcc277332d2$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $e94b7bcc277332d2$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $e94b7bcc277332d2$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $lBnVc.useContext((0, $f02d97b5ca509f34$export$26749e8557646306));
    let routeContext = $lBnVc.useContext((0, $f02d97b5ca509f34$export$9072aa6dd1f93057));
    !routeContext && (0, $18c31b251a4990f6$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $e94b7bcc277332d2$var$_extends({}, (0, $f02d97b5ca509f34$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $f02d97b5ca509f34$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $18c31b251a4990f6$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $18c31b251a4990f6$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $e94b7bcc277332d2$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $e94b7bcc277332d2$var$useDataRouterContext($e94b7bcc277332d2$var$DataRouterHook.UseFetcher);
    let state = $e94b7bcc277332d2$var$useDataRouterState($e94b7bcc277332d2$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $lBnVc.useContext($e94b7bcc277332d2$export$148fd98d095596d4);
    let route = $lBnVc.useContext((0, $f02d97b5ca509f34$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $18c31b251a4990f6$export$3e9cee6b33872309)(false);
    !route && (0, $18c31b251a4990f6$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $18c31b251a4990f6$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $e94b7bcc277332d2$var$useIdImpl ? $e94b7bcc277332d2$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $lBnVc.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($e94b7bcc277332d2$var$getUniqueFetcherId());
    // Registration/cleanup
    $lBnVc.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $lBnVc.useCallback((href, opts)=>{
        !routeId && (0, $18c31b251a4990f6$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $e94b7bcc277332d2$export$47c85c6e3a081d3();
    let submit = $lBnVc.useCallback((target, opts)=>{
        submitImpl(target, $e94b7bcc277332d2$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $lBnVc.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $lBnVc.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $lBnVc.createElement($e94b7bcc277332d2$export$a7fed597f4b8afd8, $e94b7bcc277332d2$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $18c31b251a4990f6$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $lBnVc.useMemo(()=>$e94b7bcc277332d2$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $e94b7bcc277332d2$export$fa996778a3a31087() {
    let state = $e94b7bcc277332d2$var$useDataRouterState($e94b7bcc277332d2$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $e94b7bcc277332d2$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $e94b7bcc277332d2$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $e94b7bcc277332d2$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $e94b7bcc277332d2$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $e94b7bcc277332d2$var$useDataRouterContext($e94b7bcc277332d2$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $e94b7bcc277332d2$var$useDataRouterState($e94b7bcc277332d2$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $lBnVc.useContext((0, $f02d97b5ca509f34$export$26749e8557646306));
    let location = (0, $f02d97b5ca509f34$export$45d76561a5302f2b)();
    let matches = (0, $f02d97b5ca509f34$export$2378eb7f5ff86053)();
    let navigation = (0, $f02d97b5ca509f34$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $lBnVc.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $e94b7bcc277332d2$var$usePageHide($lBnVc.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $e94b7bcc277332d2$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $e94b7bcc277332d2$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($e94b7bcc277332d2$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $lBnVc.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $e94b7bcc277332d2$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $e94b7bcc277332d2$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $lBnVc.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($e94b7bcc277332d2$var$_extends({}, location, {
                    pathname: (0, $18c31b251a4990f6$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($e94b7bcc277332d2$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $lBnVc.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $e94b7bcc277332d2$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $lBnVc.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $e94b7bcc277332d2$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $lBnVc.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $e94b7bcc277332d2$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $f02d97b5ca509f34$export$b273b3273281a049)(when);
    $lBnVc.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $lBnVc.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $e94b7bcc277332d2$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $lBnVc.useContext($e94b7bcc277332d2$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $18c31b251a4990f6$export$3e9cee6b33872309)(false);
    let { basename: basename } = $e94b7bcc277332d2$var$useDataRouterContext($e94b7bcc277332d2$var$DataRouterHook.useViewTransitionState);
    let path = (0, $f02d97b5ca509f34$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $18c31b251a4990f6$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $18c31b251a4990f6$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $18c31b251a4990f6$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $18c31b251a4990f6$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}



var $lBnVc = parcelRequire("lBnVc");
// src/index.ts
// src/asyncThrottle.ts
// src/utils.ts
function $89aef34fe8cd6f34$export$8793edee2d425525() {}


function $fea1e2c48a585b34$export$62b8953b6e765ff1(func, { interval: interval = 1e3, onError: onError = (0, $89aef34fe8cd6f34$export$8793edee2d425525) } = {}) {
    if (typeof func !== "function") throw new Error("argument is not function.");
    let running = false;
    let lastTime = 0;
    let timeout;
    let currentArgs = null;
    const execFunc = async ()=>{
        if (currentArgs) {
            const args = currentArgs;
            currentArgs = null;
            try {
                running = true;
                await func(...args);
            } catch (error) {
                onError(error);
            } finally{
                lastTime = Date.now();
                running = false;
            }
        }
    };
    const delayFunc = async ()=>{
        clearTimeout(timeout);
        timeout = setTimeout(()=>{
            if (running) delayFunc();
            else execFunc();
        }, interval);
    };
    return (...args)=>{
        currentArgs = args;
        const tooSoon = Date.now() - lastTime < interval;
        if (running || tooSoon) delayFunc();
        else execFunc();
    };
}



var $3942fb3e179face4$export$5e03d65274f1beeb = ({ storage: storage, key: key = `REACT_QUERY_OFFLINE_CACHE`, throttleTime: throttleTime = 1e3, serialize: serialize = JSON.stringify, deserialize: deserialize = JSON.parse, retry: retry })=>{
    if (storage) {
        const trySave = async (persistedClient)=>{
            try {
                const serialized = await serialize(persistedClient);
                await storage.setItem(key, serialized);
                return;
            } catch (error) {
                return error;
            }
        };
        return {
            persistClient: (0, $fea1e2c48a585b34$export$62b8953b6e765ff1)(async (persistedClient)=>{
                let client = persistedClient;
                let error = await trySave(client);
                let errorCount = 0;
                while(error && client){
                    errorCount++;
                    client = await (retry == null ? void 0 : retry({
                        persistedClient: client,
                        error: error,
                        errorCount: errorCount
                    }));
                    if (client) error = await trySave(client);
                }
            }, {
                interval: throttleTime
            }),
            restoreClient: async ()=>{
                const cacheString = await storage.getItem(key);
                if (!cacheString) return;
                return await deserialize(cacheString);
            },
            removeClient: ()=>storage.removeItem(key)
        };
    }
    return {
        persistClient: (0, $89aef34fe8cd6f34$export$8793edee2d425525),
        restoreClient: ()=>Promise.resolve(void 0),
        removeClient: (0, $89aef34fe8cd6f34$export$8793edee2d425525)
    };
};




function $5944b19c1a091143$export$1b64bc9c5306ed54(date) {
    const _date = (0, $48f2cd94c2808d74$export$e67a095c620b86fe)(date);
    const day = _date.getDay();
    return day;
}
var // Fallback for modularized imports:
$5944b19c1a091143$export$2e2bcd8739ae039 = $5944b19c1a091143$export$1b64bc9c5306ed54;





function $60ab24d2b6cf99fc$export$f645ddd439eb259d(date) {
    const _date = (0, $48f2cd94c2808d74$export$e67a095c620b86fe)(date);
    const year = _date.getFullYear();
    const monthIndex = _date.getMonth();
    const lastDayOfMonth = (0, $ee5e01283bb626d4$export$ead8a1812b171991)(date, 0);
    lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
    lastDayOfMonth.setHours(0, 0, 0, 0);
    return lastDayOfMonth.getDate();
}
var // Fallback for modularized imports:
$60ab24d2b6cf99fc$export$2e2bcd8739ae039 = $60ab24d2b6cf99fc$export$f645ddd439eb259d;



function $eaafe8c4649b54ed$export$63264690f8e36790(date, month) {
    const _date = (0, $48f2cd94c2808d74$export$e67a095c620b86fe)(date);
    const year = _date.getFullYear();
    const day = _date.getDate();
    const dateWithDesiredMonth = (0, $ee5e01283bb626d4$export$ead8a1812b171991)(date, 0);
    dateWithDesiredMonth.setFullYear(year, month, 15);
    dateWithDesiredMonth.setHours(0, 0, 0, 0);
    const daysInMonth = (0, $60ab24d2b6cf99fc$export$f645ddd439eb259d)(dateWithDesiredMonth);
    // Set the last day of the new month
    // if the original date was the last day of the longer month
    _date.setMonth(month, Math.min(day, daysInMonth));
    return _date;
}
var // Fallback for modularized imports:
$eaafe8c4649b54ed$export$2e2bcd8739ae039 = $eaafe8c4649b54ed$export$63264690f8e36790;



function $33e570fdfee97a37$export$adaa4cf7ef1b65be(date, values) {
    let _date = (0, $48f2cd94c2808d74$export$e67a095c620b86fe)(date);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(+_date)) return (0, $ee5e01283bb626d4$export$ead8a1812b171991)(date, NaN);
    if (values.year != null) _date.setFullYear(values.year);
    if (values.month != null) _date = (0, $eaafe8c4649b54ed$export$63264690f8e36790)(_date, values.month);
    if (values.date != null) _date.setDate(values.date);
    if (values.hours != null) _date.setHours(values.hours);
    if (values.minutes != null) _date.setMinutes(values.minutes);
    if (values.seconds != null) _date.setSeconds(values.seconds);
    if (values.milliseconds != null) _date.setMilliseconds(values.milliseconds);
    return _date;
}
var // Fallback for modularized imports:
$33e570fdfee97a37$export$2e2bcd8739ae039 = $33e570fdfee97a37$export$adaa4cf7ef1b65be;




var $huaPI = parcelRequire("huaPI");

var $iEuwq = parcelRequire("iEuwq");
const $a68ffd4229652fbe$export$8449e153fbd325fc = Math.PI / 180;
const $a68ffd4229652fbe$export$41fc368e1a942b97 = 180 / Math.PI;


// https://observablehq.com/@mbostock/lab-and-rgb
const $8b856d3f9d3321ff$var$K = 18, $8b856d3f9d3321ff$var$Xn = 0.96422, $8b856d3f9d3321ff$var$Yn = 1, $8b856d3f9d3321ff$var$Zn = 0.82521, $8b856d3f9d3321ff$var$t0 = 4 / 29, $8b856d3f9d3321ff$var$t1 = 6 / 29, $8b856d3f9d3321ff$var$t2 = 3 * $8b856d3f9d3321ff$var$t1 * $8b856d3f9d3321ff$var$t1, $8b856d3f9d3321ff$var$t3 = $8b856d3f9d3321ff$var$t1 * $8b856d3f9d3321ff$var$t1 * $8b856d3f9d3321ff$var$t1;
function $8b856d3f9d3321ff$var$labConvert(o) {
    if (o instanceof $8b856d3f9d3321ff$export$f2722c70a60257f7) return new $8b856d3f9d3321ff$export$f2722c70a60257f7(o.l, o.a, o.b, o.opacity);
    if (o instanceof $8b856d3f9d3321ff$export$d9397e094a5fbb9a) return $8b856d3f9d3321ff$var$hcl2lab(o);
    if (!(o instanceof (0, $iEuwq.Rgb))) o = (0, $iEuwq.rgbConvert)(o);
    var r = $8b856d3f9d3321ff$var$rgb2lrgb(o.r), g = $8b856d3f9d3321ff$var$rgb2lrgb(o.g), b = $8b856d3f9d3321ff$var$rgb2lrgb(o.b), y = $8b856d3f9d3321ff$var$xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / $8b856d3f9d3321ff$var$Yn), x, z;
    if (r === g && g === b) x = z = y;
    else {
        x = $8b856d3f9d3321ff$var$xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / $8b856d3f9d3321ff$var$Xn);
        z = $8b856d3f9d3321ff$var$xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / $8b856d3f9d3321ff$var$Zn);
    }
    return new $8b856d3f9d3321ff$export$f2722c70a60257f7(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}
function $8b856d3f9d3321ff$export$3e2c219d3ab79d01(l, opacity) {
    return new $8b856d3f9d3321ff$export$f2722c70a60257f7(l, 0, 0, opacity == null ? 1 : opacity);
}
function $8b856d3f9d3321ff$export$2e2bcd8739ae039(l, a, b, opacity) {
    return arguments.length === 1 ? $8b856d3f9d3321ff$var$labConvert(l) : new $8b856d3f9d3321ff$export$f2722c70a60257f7(l, a, b, opacity == null ? 1 : opacity);
}
function $8b856d3f9d3321ff$export$f2722c70a60257f7(l, a, b, opacity) {
    this.l = +l;
    this.a = +a;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $huaPI.default)($8b856d3f9d3321ff$export$f2722c70a60257f7, $8b856d3f9d3321ff$export$2e2bcd8739ae039, (0, $huaPI.extend)((0, $iEuwq.Color), {
    brighter (k) {
        return new $8b856d3f9d3321ff$export$f2722c70a60257f7(this.l + $8b856d3f9d3321ff$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    darker (k) {
        return new $8b856d3f9d3321ff$export$f2722c70a60257f7(this.l - $8b856d3f9d3321ff$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    rgb () {
        var y = (this.l + 16) / 116, x = isNaN(this.a) ? y : y + this.a / 500, z = isNaN(this.b) ? y : y - this.b / 200;
        x = $8b856d3f9d3321ff$var$Xn * $8b856d3f9d3321ff$var$lab2xyz(x);
        y = $8b856d3f9d3321ff$var$Yn * $8b856d3f9d3321ff$var$lab2xyz(y);
        z = $8b856d3f9d3321ff$var$Zn * $8b856d3f9d3321ff$var$lab2xyz(z);
        return new (0, $iEuwq.Rgb)($8b856d3f9d3321ff$var$lrgb2rgb(3.1338561 * x - 1.6168667 * y - 0.4906146 * z), $8b856d3f9d3321ff$var$lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z), $8b856d3f9d3321ff$var$lrgb2rgb(0.0719453 * x - 0.2289914 * y + 1.4052427 * z), this.opacity);
    }
}));
function $8b856d3f9d3321ff$var$xyz2lab(t) {
    return t > $8b856d3f9d3321ff$var$t3 ? Math.pow(t, 1 / 3) : t / $8b856d3f9d3321ff$var$t2 + $8b856d3f9d3321ff$var$t0;
}
function $8b856d3f9d3321ff$var$lab2xyz(t) {
    return t > $8b856d3f9d3321ff$var$t1 ? t * t * t : $8b856d3f9d3321ff$var$t2 * (t - $8b856d3f9d3321ff$var$t0);
}
function $8b856d3f9d3321ff$var$lrgb2rgb(x) {
    return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}
function $8b856d3f9d3321ff$var$rgb2lrgb(x) {
    return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}
function $8b856d3f9d3321ff$var$hclConvert(o) {
    if (o instanceof $8b856d3f9d3321ff$export$d9397e094a5fbb9a) return new $8b856d3f9d3321ff$export$d9397e094a5fbb9a(o.h, o.c, o.l, o.opacity);
    if (!(o instanceof $8b856d3f9d3321ff$export$f2722c70a60257f7)) o = $8b856d3f9d3321ff$var$labConvert(o);
    if (o.a === 0 && o.b === 0) return new $8b856d3f9d3321ff$export$d9397e094a5fbb9a(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
    var h = Math.atan2(o.b, o.a) * (0, $a68ffd4229652fbe$export$41fc368e1a942b97);
    return new $8b856d3f9d3321ff$export$d9397e094a5fbb9a(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}
function $8b856d3f9d3321ff$export$5a21418738164530(l, c, h, opacity) {
    return arguments.length === 1 ? $8b856d3f9d3321ff$var$hclConvert(l) : new $8b856d3f9d3321ff$export$d9397e094a5fbb9a(h, c, l, opacity == null ? 1 : opacity);
}
function $8b856d3f9d3321ff$export$d0e870ba50062ff1(h, c, l, opacity) {
    return arguments.length === 1 ? $8b856d3f9d3321ff$var$hclConvert(h) : new $8b856d3f9d3321ff$export$d9397e094a5fbb9a(h, c, l, opacity == null ? 1 : opacity);
}
function $8b856d3f9d3321ff$export$d9397e094a5fbb9a(h, c, l, opacity) {
    this.h = +h;
    this.c = +c;
    this.l = +l;
    this.opacity = +opacity;
}
function $8b856d3f9d3321ff$var$hcl2lab(o) {
    if (isNaN(o.h)) return new $8b856d3f9d3321ff$export$f2722c70a60257f7(o.l, 0, 0, o.opacity);
    var h = o.h * (0, $a68ffd4229652fbe$export$8449e153fbd325fc);
    return new $8b856d3f9d3321ff$export$f2722c70a60257f7(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
}
(0, $huaPI.default)($8b856d3f9d3321ff$export$d9397e094a5fbb9a, $8b856d3f9d3321ff$export$d0e870ba50062ff1, (0, $huaPI.extend)((0, $iEuwq.Color), {
    brighter (k) {
        return new $8b856d3f9d3321ff$export$d9397e094a5fbb9a(this.h, this.c, this.l + $8b856d3f9d3321ff$var$K * (k == null ? 1 : k), this.opacity);
    },
    darker (k) {
        return new $8b856d3f9d3321ff$export$d9397e094a5fbb9a(this.h, this.c, this.l - $8b856d3f9d3321ff$var$K * (k == null ? 1 : k), this.opacity);
    },
    rgb () {
        return $8b856d3f9d3321ff$var$hcl2lab(this).rgb();
    }
}));


var $3964c1266304960b$export$2e2bcd8739ae039 = (x)=>()=>x;


function $edb048157c9e52a3$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $edb048157c9e52a3$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $edb048157c9e52a3$export$97d7b0c7ddb78dcf(a, b) {
    var d = b - a;
    return d ? $edb048157c9e52a3$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $3964c1266304960b$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
}
function $edb048157c9e52a3$export$a7ebe8cc6aaf8d37(y) {
    return (y = +y) === 1 ? $edb048157c9e52a3$export$2e2bcd8739ae039 : function(a, b) {
        return b - a ? $edb048157c9e52a3$var$exponential(a, b, y) : (0, $3964c1266304960b$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
    };
}
function $edb048157c9e52a3$export$2e2bcd8739ae039(a, b) {
    var d = b - a;
    return d ? $edb048157c9e52a3$var$linear(a, d) : (0, $3964c1266304960b$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
}


function $16294ebd154bca50$var$hcl(hue) {
    return function(start, end) {
        var h = hue((start = (0, $8b856d3f9d3321ff$export$d0e870ba50062ff1)(start)).h, (end = (0, $8b856d3f9d3321ff$export$d0e870ba50062ff1)(end)).h), c = (0, $edb048157c9e52a3$export$2e2bcd8739ae039)(start.c, end.c), l = (0, $edb048157c9e52a3$export$2e2bcd8739ae039)(start.l, end.l), opacity = (0, $edb048157c9e52a3$export$2e2bcd8739ae039)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.c = c(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var $16294ebd154bca50$export$2e2bcd8739ae039 = $16294ebd154bca50$var$hcl((0, $edb048157c9e52a3$export$97d7b0c7ddb78dcf));
var $16294ebd154bca50$export$5aaa50f7615f9b70 = $16294ebd154bca50$var$hcl((0, $edb048157c9e52a3$export$2e2bcd8739ae039));


const $c2e94012e82e0308$export$df7d25c84ebd12a5 = (xs, x, lo = 0)=>{
    let hi = xs.length;
    while(lo < hi){
        const mid = lo + hi >> 1;
        if (xs[mid] < x) lo = mid + 1;
        else hi = mid;
    }
    return lo;
};
const $c2e94012e82e0308$export$d07f57595c356899 = (s)=>s && `${s[0].toUpperCase()}${s.toLowerCase().slice(1)}`;
const $c2e94012e82e0308$export$5b8fdb0cdc6de921 = (moods, dateFrom, dateTo)=>{
    if (!moods.allIds.length) {
        (0, $24a8d9ab78e4f062$export$f5282963edea4a68)(Error("No moods"));
        return;
    }
    const earliestMoodTime = new Date(moods.allIds[0]).getTime();
    const latestMoodTime = new Date(moods.allIds.at(-1)).getTime();
    const d0 = dateFrom.getTime();
    const d1 = dateTo.getTime();
    if (d1 < d0) {
        (0, $24a8d9ab78e4f062$export$f5282963edea4a68)(Error("`dateFrom` must be equal to or before `dateTo`"));
        return;
    }
    if (d0 > latestMoodTime || d1 < earliestMoodTime) return;
    if (moods.allIds.length === 1) return moods.byId[moods.allIds[0]].mood;
    if (d1 === earliestMoodTime) return moods.byId[dateTo.toISOString()].mood;
    if (d0 === latestMoodTime) return moods.byId[dateFrom.toISOString()].mood;
    const maxArea = (Math.min(d1, latestMoodTime) - Math.max(d0, earliestMoodTime)) * (0, $5a123094476b33d7$export$1c4e9440df4662e4);
    let area = 0;
    const relevantMoodIds = $c2e94012e82e0308$export$11d4869c8daa6ec(moods.allIds, dateFrom, dateTo);
    for(let j = 1; j < relevantMoodIds.length; j++){
        const id0 = relevantMoodIds[j - 1];
        const t0 = new Date(id0).getTime();
        const mood0 = moods.byId[id0].mood;
        const id1 = relevantMoodIds[j];
        const t1 = new Date(id1).getTime();
        const mood1 = moods.byId[id1].mood;
        if (t0 < d0 && t1 > d1) {
            area += $c2e94012e82e0308$export$c806ce0ef917c32b(mood0 + (mood1 - mood0) * (d0 - t0) / (t1 - t0), mood0 + (mood1 - mood0) * (d1 - t0) / (t1 - t0), d1 - d0);
            continue;
        }
        if (t0 < d0) {
            area += $c2e94012e82e0308$export$c806ce0ef917c32b(mood1 + (mood0 - mood1) * (t1 - d0) / (t1 - t0), mood1, t1 - d0);
            continue;
        }
        if (t1 > d1) {
            area += $c2e94012e82e0308$export$c806ce0ef917c32b(mood0, mood0 + (mood1 - mood0) * (d1 - t0) / (t1 - t0), d1 - t0);
            break;
        }
        area += $c2e94012e82e0308$export$c806ce0ef917c32b(mood0, mood1, t1 - t0);
    }
    return area / maxArea * (0, $5a123094476b33d7$export$1c4e9440df4662e4);
};
const $c2e94012e82e0308$export$772b647faa1a81e0 = (xs)=>{
    if (!xs.length) throw Error("Need at least one number to compute mean");
    return $c2e94012e82e0308$export$a8616ca67e2741ea(xs);
};
const $c2e94012e82e0308$export$a8616ca67e2741ea = (xs)=>{
    if (!xs.length) return;
    let sum = 0;
    for(let i = 0; i < xs.length; i++)sum += xs[i];
    return sum / xs.length;
};
const $c2e94012e82e0308$export$4683e466d9b5386c = (xs)=>{
    if (!xs.length) return;
    if (xs.length <= 1) return 0;
    const mean = $c2e94012e82e0308$export$772b647faa1a81e0(xs);
    let sumOfSquaredDifferences = 0;
    for (const x of xs)sumOfSquaredDifferences += (x - mean) ** 2;
    return Math.sqrt(sumOfSquaredDifferences / (xs.length - 1));
};
const $c2e94012e82e0308$export$ed258585350e1d81 = (kelvin)=>kelvin - 273.15;
const $c2e94012e82e0308$export$e575061ef2a070eb = (xs)=>{
    const count = $c2e94012e82e0308$export$5563593ccbfe9912(()=>0);
    for (const x of xs)count[x] += 1;
    return {
        ...count
    };
};
const $c2e94012e82e0308$export$2c9169ad8071d2bc = (values)=>{
    const { length: length } = values;
    if (length < 2) throw Error(`\`createChartExtent\` requires at least 2 values but received ${length}`);
    const maxValue = Math.max(...values);
    const minValue = Math.min(...values);
    const adjustment = (10 - (maxValue - minValue) % 10) / 2;
    return [
        Math.round(minValue - adjustment),
        Math.round(maxValue + adjustment)
    ];
};
const $c2e94012e82e0308$export$27d3dd4acf9951a1 = (dateString)=>new Date(`${dateString}T00:00:00`);
const $c2e94012e82e0308$export$5563593ccbfe9912 = (createDefaultValue)=>new Proxy(Object.create(null), {
        get: (target, key)=>{
            if (!Object.hasOwn(target, key)) target[key] = createDefaultValue();
            return target[key];
        }
    });
const $c2e94012e82e0308$export$d7e7e8e9e6ba5acd = (description)=>{
    const descriptions = [];
    for (const word of description.split(/\s+/)){
        if (!word) continue;
        descriptions.push($c2e94012e82e0308$export$d07f57595c356899(word));
    }
    return descriptions;
};
const $c2e94012e82e0308$export$11d4869c8daa6ec = (ids, dateFrom, dateTo)=>{
    if (dateFrom > dateTo) throw Error("`dateFrom` should not be after `dateTo`");
    // We use these ISO-8601 strings to do string comparison of dates.
    // This is a very hot code path and testing indicates that this
    // comparison method is significantly faster than converting
    // and comparing in date object format or in number format.
    // A limitation is that the format of all IDs must be derived
    // from `toISOString` otherwise this may not function as expected.
    const fromIso = dateFrom.toISOString();
    const toIso = dateTo.toISOString();
    const i = $c2e94012e82e0308$export$df7d25c84ebd12a5(ids, fromIso);
    const j = $c2e94012e82e0308$export$df7d25c84ebd12a5(ids, toIso, i);
    return ids.slice(Math.max(i - 1, 0), Math.min(j + 2 - Number(i === j), ids.length + 1));
};
const $c2e94012e82e0308$export$3a3d91da857d6da2 = (ids, dateFrom, dateTo)=>{
    if (dateFrom > dateTo) throw Error("`dateFrom` should not be after `dateTo`");
    const fromIso = dateFrom.toISOString();
    const toIso = dateTo.toISOString();
    const i = $c2e94012e82e0308$export$df7d25c84ebd12a5(ids, fromIso);
    const j = $c2e94012e82e0308$export$df7d25c84ebd12a5(ids, toIso, i);
    if (toIso < ids[i]) return [];
    return ids.slice(i, j + 1);
};
const $c2e94012e82e0308$export$6729330625148ca3 = ({ isDaytime: isDaytime, weatherId: weatherId })=>{
    let iconName = "cloud";
    let label = "Clouds";
    let weatherColor = "var(--color-balance-more)";
    if (weatherId) {
        if (weatherId < 300) {
            iconName = "lightning";
            label = "Thunderstorm";
            weatherColor = "var(--color-figure-more)";
        } else if (weatherId < 400) {
            iconName = "drizzle";
            label = "Drizzle";
            weatherColor = "steelblue";
        } else if (weatherId < 600) {
            iconName = "rain";
            label = "Rain";
            weatherColor = "#30f";
        } else if (weatherId < 700) {
            iconName = "snow";
            label = "Snow";
        } else if (weatherId === 771) {
            iconName = "wind";
            label = "Squall";
            weatherColor = "var(--color-figure-more)";
        } else if (weatherId === 781) {
            iconName = "wind";
            label = "Tornado";
            weatherColor = "var(--color-figure-more)";
        } else if (weatherId < 800) {
            label = "Fog/Haze/Dust";
            iconName = "fog";
        } else if (weatherId < 802) {
            if (isDaytime) {
                iconName = "sun";
                weatherColor = "orange";
            } else {
                iconName = "moon";
                weatherColor = "rebeccapurple";
            }
            label = "Clear";
        } else if (weatherId < 803) {
            if (isDaytime) {
                iconName = "partly-cloudy-day";
                weatherColor = "orange";
            } else {
                iconName = "partly-cloudy-night";
                weatherColor = "rebeccapurple";
            }
            label = "Partly cloudy";
        }
    }
    return {
        iconName: iconName,
        label: label,
        weatherColor: weatherColor
    };
};
const $c2e94012e82e0308$export$f3013bcc8d8645bd = (date)=>`${$c2e94012e82e0308$export$30a208a52f4a49de(date)}-${String(date.getDate()).padStart(2, "0")}`;
const $c2e94012e82e0308$export$5de6434cc589fc5b = (date)=>`${$c2e94012e82e0308$export$f3013bcc8d8645bd(date)}T${String(date.getHours()).padStart(2, "0")}:00:00.000Z`;
const $c2e94012e82e0308$export$30a208a52f4a49de = (date)=>`${$c2e94012e82e0308$export$60b37fc597282c94(date)}-${String(date.getMonth() + 1).padStart(2, "0")}`;
const $c2e94012e82e0308$export$60b37fc597282c94 = (date)=>String(date.getFullYear());
const $c2e94012e82e0308$export$e0c93ebdf17e89e6 = (seconds)=>`${String(Math.floor(seconds / (0, $5a123094476b33d7$export$a9905336c0111a3a).secondsPerMinute)).padStart(2, "0")}:${String(Math.floor(seconds % (0, $5a123094476b33d7$export$a9905336c0111a3a).secondsPerMinute)).padStart(2, "0")}`;
const $c2e94012e82e0308$export$e8da94055c5ae2c4 = (date)=>{
    const dateFnsWeekdayIndex = (0, $5944b19c1a091143$export$1b64bc9c5306ed54)(date);
    return (dateFnsWeekdayIndex ? dateFnsWeekdayIndex : (0, $5a123094476b33d7$export$a9905336c0111a3a).daysPerWeek) - 1;
};
const $c2e94012e82e0308$export$7ff0d353c23134fe = (xs, f)=>{
    const ys = [];
    for(let i = xs.length - 1; i >= 0; i--)ys.push(f(xs[i]));
    return ys;
};
const $c2e94012e82e0308$var$getColorNegative = (0, $16294ebd154bca50$export$2e2bcd8739ae039)("#1747f0", "#00e0e0");
const $c2e94012e82e0308$var$getColorPositive = (0, $16294ebd154bca50$export$2e2bcd8739ae039)("#00e0e0", "#10ff00");
const $c2e94012e82e0308$var$getColor = (n)=>n < 0.5 ? $c2e94012e82e0308$var$getColorNegative(n * 2) : $c2e94012e82e0308$var$getColorPositive((n - 0.5) * 2);
const $c2e94012e82e0308$var$colorCache = new Map();
const $c2e94012e82e0308$export$18b446c953569205 = (mood)=>{
    const roundedMood = mood.toFixed(1);
    const cachedColor = $c2e94012e82e0308$var$colorCache.get(roundedMood);
    if (cachedColor) return cachedColor;
    const color = $c2e94012e82e0308$var$getColor(Number(roundedMood) / 10);
    $c2e94012e82e0308$var$colorCache.set(roundedMood, color);
    return color;
};
const $c2e94012e82e0308$export$cba7498d83c2e2d = (date)=>(0, $33e570fdfee97a37$export$adaa4cf7ef1b65be)(date, {
        hours: 0,
        milliseconds: 0,
        minutes: 0,
        seconds: 0
    });
const $c2e94012e82e0308$export$4b61d8bc5e82982b = (date)=>{
    const roundedDownDate = $c2e94012e82e0308$export$cba7498d83c2e2d(date);
    return Number(roundedDownDate) === Number(date) ? date : (0, $cb8fdbef2aba70f2$export$dd412b56f1e4d8aa)(roundedDownDate, 1);
};
const $c2e94012e82e0308$export$b9a78bbdc0cb614a = (n)=>Math.floor(n / 10) * 10;
const $c2e94012e82e0308$export$fcef0db106ecb6b8 = (n)=>Math.ceil(n / 10) * 10;
const $c2e94012e82e0308$export$c806ce0ef917c32b = (a, b, h)=>(a + b) / 2 * h;


const $035f270eea0b2c1d$var$celciusFormatter = Intl.NumberFormat(undefined, {
    maximumFractionDigits: 1,
    minimumFractionDigits: 1,
    style: "unit",
    unit: "celsius"
});
const $035f270eea0b2c1d$export$196dadf28b8781a5 = (kelvin)=>$035f270eea0b2c1d$var$celciusFormatter.format((0, $c2e94012e82e0308$export$ed258585350e1d81)(kelvin));
const $035f270eea0b2c1d$export$7774341304efafa2 = Intl.NumberFormat(undefined, {
    maximumFractionDigits: 0
});
const $035f270eea0b2c1d$export$da6f4123477e5931 = Intl.NumberFormat(undefined, {
    maximumFractionDigits: 1,
    minimumFractionDigits: 1
});
const $035f270eea0b2c1d$export$fd01c80332d24e86 = Intl.NumberFormat(undefined, {
    maximumFractionDigits: 1,
    minimumFractionDigits: 1,
    style: "percent"
});
const $035f270eea0b2c1d$export$1659d1d38b1f945b = Intl.NumberFormat(undefined, {
    maximumFractionDigits: 0,
    style: "unit",
    unit: "degree"
});
const $035f270eea0b2c1d$export$55cce6e1b8cd4208 = Intl.NumberFormat(undefined, {
    style: "unit",
    unit: "degree"
});
const $035f270eea0b2c1d$export$73f799d1a16dbca4 = Intl.NumberFormat(undefined, {
    maximumFractionDigits: 0,
    style: "unit",
    unit: "meter"
});
const $035f270eea0b2c1d$export$5ed428cfaac5d75d = Intl.NumberFormat(undefined, {
    maximumFractionDigits: 0,
    style: "percent"
});
const $035f270eea0b2c1d$export$10a982a3f524f6cd = Intl.NumberFormat(undefined, {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2
});






function $d6a4677f881c9818$export$2e2bcd8739ae039(prop) {
    return getComputedStyle(document.documentElement).getPropertyValue(prop).trim();
}
const $d6a4677f881c9818$export$2018caab28d589c9 = ()=>parseFloat($d6a4677f881c9818$export$2e2bcd8739ae039("--time-0")) * 1e3;
const $d6a4677f881c9818$export$859047452738ec6 = ()=>$d6a4677f881c9818$export$2018caab28d589c9() * parseFloat($d6a4677f881c9818$export$2e2bcd8739ae039("--time-scale-ratio"));


if (typeof document !== "undefined") {
    const metaThemeColor = document.querySelector("meta[name=theme-color]");
    if (metaThemeColor) metaThemeColor.setAttribute("content", (0, $d6a4677f881c9818$export$2e2bcd8739ae039)("--color-theme-app"));
}




function $5127ed73cb235c85$export$2e2bcd8739ae039(props) {
    return (0, $c0c9bc5c50648c54$exports.jsx)("div", {
        ...props,
        className: "button-group center"
    });
}
$5127ed73cb235c85$export$2e2bcd8739ae039.displayName = "Button.Group";


function $8d0e9e7c8b049b7a$export$2e2bcd8739ae039({ danger: danger = false, variant: variant = "primary", type: type = "submit", ...rest }) {
    const className = `button fw-b select-none button--${variant}${variant === "secondary" ? " bw-2" : ""}${variant === "tertiary" ? "" : " br-1 bs-0"}${danger ? " button--danger" : ""}${rest.disabled ? "" : " ripple"}`;
    return (0, $c0c9bc5c50648c54$exports.jsx)("button", {
        ...rest,
        className: className,
        type: type
    });
}
$8d0e9e7c8b049b7a$export$2e2bcd8739ae039.Group = (0, $5127ed73cb235c85$export$2e2bcd8739ae039);




function $83ecd450670418c8$export$2e2bcd8739ae039(props) {
    return (0, $c0c9bc5c50648c54$exports.jsx)("div", {
        ...props,
        className: "card-group slide-children-in"
    });
}
$83ecd450670418c8$export$2e2bcd8739ae039.displayName = "Card.Group";


function $7c1560fa3a8ca778$export$2e2bcd8739ae039({ color: color, ...rest }) {
    const props = color ? Object.assign(rest, {
        style: {
            "--color": color
        }
    }) : rest;
    if (!props.onClick) return (0, $c0c9bc5c50648c54$exports.jsx)("div", {
        ...props,
        className: "card br-1 bw-1 p-3"
    });
    return (0, $c0c9bc5c50648c54$exports.jsx)("button", {
        ...props,
        "aria-label": "View card",
        className: "card br-1 bw-1 p-3 ripple",
        type: "button"
    });
}
$7c1560fa3a8ca778$export$2e2bcd8739ae039.Group = (0, $83ecd450670418c8$export$2e2bcd8739ae039);




var $lBnVc = parcelRequire("lBnVc");

const $771bf5af5dde3604$var$composeValidators = (...validators)=>(value)=>{
        for(let i = 0; i < validators.length; i++){
            const validationResult = validators[i](value);
            if (validationResult) return validationResult;
        }
    };
const $771bf5af5dde3604$var$emailValidator = (value)=>/.+@.+/.test(value) ? undefined : "Email address not valid";
const $771bf5af5dde3604$var$passwordValidator = (value)=>{
    if (value.length < 8) return "Password must be at least 8 characters long";
    if (value.toLowerCase() === value) return "Password must have at least one uppercase letter";
    if (value.toUpperCase() === value) return "Password must have at least one lowercase letter";
    if (!/\d/g.test(value)) return "Password must contain at least one number";
};
const $771bf5af5dde3604$export$9b27c06e6f0b4566 = (value)=>value ? undefined : "Required";
const $771bf5af5dde3604$export$4c0c1934ef708d90 = $771bf5af5dde3604$var$composeValidators($771bf5af5dde3604$export$9b27c06e6f0b4566, $771bf5af5dde3604$var$emailValidator);
const $771bf5af5dde3604$export$d1c2c73868297cb7 = $771bf5af5dde3604$var$composeValidators($771bf5af5dde3604$export$9b27c06e6f0b4566, $771bf5af5dde3604$var$passwordValidator);


function $9b3b041e348a76a5$export$2e2bcd8739ae039({ onSubmit: onSubmit, ...rest }) {
    const [currentPasswordError, setCurrentPasswordError] = $lBnVc.useState("");
    const [newPasswordError, setNewPasswordError] = $lBnVc.useState("");
    const [isSubmitting, setIsSubmitting] = $lBnVc.useState(false);
    const [submitError, setSubmitError] = $lBnVc.useState();
    const [successfullyChanged, setSuccessfullyChanged] = $lBnVc.useState(false);
    return (0, $c0c9bc5c50648c54$exports.jsx)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039).Group, {
        ...rest,
        children: (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
            children: [
                (0, $c0c9bc5c50648c54$exports.jsx)("h2", {
                    children: "Change password"
                }),
                successfullyChanged ? (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
                    children: [
                        (0, $c0c9bc5c50648c54$exports.jsx)("p", {
                            className: "positive",
                            children: "Password successfully changed!"
                        }),
                        (0, $c0c9bc5c50648c54$exports.jsx)("p", {
                            children: "Use your new password next time you sign in."
                        })
                    ]
                }) : (0, $c0c9bc5c50648c54$exports.jsxs)("form", {
                    noValidate: true,
                    onSubmit: async (e)=>{
                        e.preventDefault();
                        setSubmitError(undefined);
                        const currentPassword = e.target.currentPassword.value;
                        const newPassword = e.target.newPassword.value;
                        const currentPasswordErrorMessage = (0, $771bf5af5dde3604$export$d1c2c73868297cb7)(currentPassword);
                        const newPasswordErrorMessage = (0, $771bf5af5dde3604$export$d1c2c73868297cb7)(newPassword);
                        if (currentPasswordErrorMessage || newPasswordErrorMessage) {
                            setCurrentPasswordError(currentPasswordErrorMessage || "");
                            setNewPasswordError(newPasswordErrorMessage || "");
                            return;
                        }
                        if (currentPasswordError) setCurrentPasswordError("");
                        if (newPasswordError) setNewPasswordError("");
                        setIsSubmitting(true);
                        try {
                            await onSubmit({
                                currentPassword: currentPassword,
                                newPassword: newPassword,
                                setSubmitError: setSubmitError
                            });
                            setSuccessfullyChanged(true);
                        } finally{
                            setIsSubmitting(false);
                        }
                    },
                    children: [
                        (0, $c0c9bc5c50648c54$exports.jsx)((0, $78053ee2024d275e$export$2e2bcd8739ae039), {
                            autoComplete: "current-password",
                            autoFocus: true,
                            error: currentPasswordError,
                            label: "Current password",
                            name: "currentPassword",
                            type: "password"
                        }),
                        (0, $c0c9bc5c50648c54$exports.jsx)((0, $78053ee2024d275e$export$2e2bcd8739ae039), {
                            autoComplete: "new-password",
                            error: newPasswordError,
                            label: "New password",
                            name: "newPassword",
                            type: "password"
                        }),
                        submitError && (0, $c0c9bc5c50648c54$exports.jsx)("p", {
                            className: "center",
                            children: (0, $c0c9bc5c50648c54$exports.jsx)("small", {
                                className: "negative",
                                children: submitError
                            })
                        }),
                        (0, $c0c9bc5c50648c54$exports.jsx)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039).Group, {
                            children: (0, $c0c9bc5c50648c54$exports.jsx)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039), {
                                disabled: isSubmitting,
                                children: "Change password"
                            })
                        })
                    ]
                })
            ]
        })
    });
}




var $lBnVc = parcelRequire("lBnVc");
function $76bff0585da7f039$export$2e2bcd8739ae039({ data: data, maxRange: maxRange, rotateXLabels: rotateXLabels = false, xAxisTitle: xAxisTitle, yAxisTitle: yAxisTitle, ...rest }) {
    if (!data.length) return;
    let range;
    if (maxRange === undefined) {
        const maxY = Math.max(...data.map(({ y: y })=>y).filter((y)=>y !== undefined));
        range = [
            0,
            maxY <= 7 ? Math.ceil(maxY + 1) : Math.ceil(maxY / 10) * 10
        ];
    } else range = [
        0,
        maxRange
    ];
    const yLabels = range[1] <= 10 ? [
        ...Array(range[1] + 1).keys()
    ] : [
        ...Array(11).keys()
    ].map((n)=>Math.round(n / 10 * range[1]));
    return (0, $c0c9bc5c50648c54$exports.jsxs)("div", {
        ...rest,
        className: "column-chart",
        style: {
            "--column-count": data.length
        },
        children: [
            (0, $c0c9bc5c50648c54$exports.jsx)("div", {
                className: "column-chart__grid-lines",
                children: yLabels.slice(1).map((x)=>(0, $c0c9bc5c50648c54$exports.jsx)("div", {}, x))
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("div", {
                className: "column-chart__y-title fade-in nowrap",
                children: yAxisTitle
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("div", {
                className: "column-chart__x-title fade-in nowrap",
                children: xAxisTitle
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("div", {
                className: "column-chart__x-label"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("div", {
                className: "column-chart__y-axis",
                style: {
                    "--y-label-count": yLabels.length
                },
                children: yLabels.map((yLabel, i)=>(0, $c0c9bc5c50648c54$exports.jsx)("div", {
                        className: "column-chart__y-label fade-in",
                        style: {
                            "--y-label-number": i
                        },
                        children: yLabel
                    }, yLabel))
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("div", {
                className: "column-chart__x-label"
            }),
            data.map(({ color: color, key: key, label: label, onClick: onClick, title: title, y: y }, i)=>{
                return (0, $c0c9bc5c50648c54$exports.jsxs)((0, $lBnVc.Fragment), {
                    children: [
                        (0, $c0c9bc5c50648c54$exports.jsx)("div", {
                            className: `column-chart__column${onClick ? " column-chart__column--clickable" : ""}`,
                            onClick: onClick,
                            title: title,
                            style: {
                                "--column-height": `${100 * (y ?? 0) / range[1]}%`,
                                "--column-number": i,
                                color: // This is a hack to fix a bug that seems specific to Chrome
                                // where the bar appears visible during the rendering animation
                                y === undefined ? "transparent" : color ?? "var(--color-theme)"
                            }
                        }),
                        (0, $c0c9bc5c50648c54$exports.jsx)("div", {
                            className: `column-chart__x-label fade-in${rotateXLabels ? " column-chart__x-label--rotate" : ""}`,
                            style: {
                                "--x-label-number": i
                            },
                            title: title,
                            children: label
                        })
                    ]
                }, key);
            })
        ]
    });
}



const $f76f4fcf1dff5806$export$4ea67cb20fff5f8 = 1.5;
const $f76f4fcf1dff5806$var$LINE_WIDTH_RATIO = 2.5;
const $f76f4fcf1dff5806$export$82e147c2a8288608 = 1e-3;
const $f76f4fcf1dff5806$export$5e26afff1152f42a = $f76f4fcf1dff5806$export$82e147c2a8288608 * $f76f4fcf1dff5806$var$LINE_WIDTH_RATIO;
const $f76f4fcf1dff5806$export$74e9b1310467281e = $f76f4fcf1dff5806$export$5e26afff1152f42a * $f76f4fcf1dff5806$var$LINE_WIDTH_RATIO;



var $lBnVc = parcelRequire("lBnVc");
const $7bbf1581437f8fcd$export$23984d5ab1b5f3ed = (0, $lBnVc.createContext)([
    0,
    1
]);
const $7bbf1581437f8fcd$export$11cd0a2fc2feb4cb = (0, $lBnVc.createContext)([
    0,
    1
]);



var $lBnVc = parcelRequire("lBnVc");
const $fbc24f9487a537d6$var$useTransformPointsToPlotArea = (data)=>{
    const domain = (0, $lBnVc.useContext)((0, $7bbf1581437f8fcd$export$23984d5ab1b5f3ed));
    const range = (0, $lBnVc.useContext)((0, $7bbf1581437f8fcd$export$11cd0a2fc2feb4cb));
    return data.map(([x, y])=>[
            (x - domain[0]) / (domain[1] - domain[0]) * (0, $f76f4fcf1dff5806$export$4ea67cb20fff5f8),
            1 - (y - range[0]) / (range[1] - range[0])
        ]);
};
const $fbc24f9487a537d6$var$thicknessToLineWidth = [
    (0, $f76f4fcf1dff5806$export$82e147c2a8288608),
    (0, $f76f4fcf1dff5806$export$5e26afff1152f42a),
    (0, $f76f4fcf1dff5806$export$74e9b1310467281e)
];
function $fbc24f9487a537d6$export$2e2bcd8739ae039({ color: color = "var(--color-theme)", data: data, thickness: thickness = 1 }) {
    const transformedPoints = $fbc24f9487a537d6$var$useTransformPointsToPlotArea(data);
    if (transformedPoints.length < 2) return;
    let polylinePoints = "";
    let lineLength = 0;
    let prevXY;
    for(let i = 0; i < transformedPoints.length; i++){
        const [x, y] = transformedPoints[i];
        if (prevXY) lineLength += Math.hypot(x - prevXY[0], y - prevXY[1]);
        prevXY = [
            x,
            y
        ];
        polylinePoints += `${x},${y} `;
    }
    polylinePoints = polylinePoints.trimEnd();
    return (0, $c0c9bc5c50648c54$exports.jsx)("polyline", {
        className: "line",
        fill: "none",
        points: polylinePoints,
        stroke: color,
        strokeWidth: $fbc24f9487a537d6$var$thicknessToLineWidth[thickness],
        style: {
            "--length": lineLength
        }
    });
}





const $3a774ac4219d659a$var$AXIS_LABEL_COUNT = 6;
function $3a774ac4219d659a$export$2e2bcd8739ae039({ centerXAxisLabels: centerXAxisLabels = false, children: children, domain: domain, points: points, range: range, xAxisLabels: xAxisLabels = [
    ...Array($3a774ac4219d659a$var$AXIS_LABEL_COUNT).keys()
].map((n)=>String(Math.round(n / ($3a774ac4219d659a$var$AXIS_LABEL_COUNT - 1) * (domain[1] - domain[0]) + domain[0]))), xAxisTitle: xAxisTitle, yAxisLabels: yAxisLabels = [
    ...Array($3a774ac4219d659a$var$AXIS_LABEL_COUNT).keys()
].map((n)=>String(Math.round(n / ($3a774ac4219d659a$var$AXIS_LABEL_COUNT - 1) * (range[1] - range[0]) + range[0]))), yAxisTitle: yAxisTitle, ...rest }) {
    const pointsWithinDomain = points?.filter(({ x: x })=>x >= domain[0] && x <= domain[1]);
    return (0, $c0c9bc5c50648c54$exports.jsxs)("div", {
        ...rest,
        className: `line-chart${centerXAxisLabels ? " line-chart--centered" : ""}`,
        children: [
            (0, $c0c9bc5c50648c54$exports.jsx)("div", {
                className: "line-chart__y-title fade-in nowrap",
                children: yAxisTitle
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("div", {
                className: "line-chart__y-axis",
                style: {
                    "--label-count": yAxisLabels.length
                },
                children: yAxisLabels.map((yLabel, i)=>(0, $c0c9bc5c50648c54$exports.jsx)("div", {
                        className: "line-chart__y-label fade-in",
                        style: {
                            "--label-number": i
                        },
                        children: yLabel
                    }, yLabel))
            }),
            (0, $c0c9bc5c50648c54$exports.jsxs)("div", {
                className: "line-chart__plot-area",
                children: [
                    pointsWithinDomain?.length ? (0, $c0c9bc5c50648c54$exports.jsx)((0, $c0c9bc5c50648c54$exports.Fragment), {
                        children: pointsWithinDomain.map(({ color: color = "var(--color-theme)", x: x, y: y }, i)=>(0, $c0c9bc5c50648c54$exports.jsx)("div", {
                                className: "line-chart__point",
                                style: {
                                    "--point-index": i,
                                    "--total-points": pointsWithinDomain.length,
                                    backgroundColor: color,
                                    bottom: `calc(${(y - range[0]) / (range[1] - range[0])} * (100% - var(--border-width-1)) - var(--point-diameter) / 2 + var(--border-width-1))`,
                                    left: `calc(${(x - domain[0]) / (domain[1] - domain[0])} * (100% - var(--border-width-1)) - var(--point-diameter) / 2 + var(--border-width-1))`
                                }
                            }, [
                                x,
                                y
                            ].join(":")))
                    }) : undefined,
                    (0, $c0c9bc5c50648c54$exports.jsxs)("svg", {
                        className: "line-chart__svg",
                        viewBox: `0 0 ${(0, $f76f4fcf1dff5806$export$4ea67cb20fff5f8)} 1`,
                        children: [
                            [
                                ...Array(xAxisLabels.length + Number(centerXAxisLabels)).keys()
                            ].map((i)=>i * (0, $f76f4fcf1dff5806$export$4ea67cb20fff5f8) / (xAxisLabels.length - Number(!centerXAxisLabels))).map((x)=>(0, $c0c9bc5c50648c54$exports.jsx)("line", {
                                    stroke: "var(--color-balance)",
                                    strokeDasharray: (0, $f76f4fcf1dff5806$export$74e9b1310467281e),
                                    strokeWidth: (0, $f76f4fcf1dff5806$export$82e147c2a8288608),
                                    x1: x,
                                    x2: x,
                                    y1: 0,
                                    y2: 1
                                }, x)),
                            yAxisLabels.map((_, i)=>i / (yAxisLabels.length - 1)).map((y)=>(0, $c0c9bc5c50648c54$exports.jsx)("line", {
                                    stroke: "var(--color-balance)",
                                    strokeDasharray: (0, $f76f4fcf1dff5806$export$74e9b1310467281e),
                                    strokeWidth: (0, $f76f4fcf1dff5806$export$82e147c2a8288608),
                                    x1: 0,
                                    x2: (0, $f76f4fcf1dff5806$export$4ea67cb20fff5f8),
                                    y1: y,
                                    y2: y
                                }, y)),
                            (0, $c0c9bc5c50648c54$exports.jsx)("defs", {
                                children: (0, $c0c9bc5c50648c54$exports.jsx)("clipPath", {
                                    id: "plot-area-clip-path",
                                    children: (0, $c0c9bc5c50648c54$exports.jsx)("rect", {
                                        x: 0,
                                        y: 0,
                                        height: 1,
                                        width: (0, $f76f4fcf1dff5806$export$4ea67cb20fff5f8)
                                    })
                                })
                            }),
                            (0, $c0c9bc5c50648c54$exports.jsx)((0, $7bbf1581437f8fcd$export$23984d5ab1b5f3ed).Provider, {
                                value: domain,
                                children: (0, $c0c9bc5c50648c54$exports.jsx)((0, $7bbf1581437f8fcd$export$11cd0a2fc2feb4cb).Provider, {
                                    value: range,
                                    children: (0, $c0c9bc5c50648c54$exports.jsx)("g", {
                                        clipPath: "url(#plot-area-clip-path)",
                                        children: children
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("div", {
                className: "line-chart__x-axis",
                style: {
                    "--label-count": xAxisLabels.length
                },
                children: xAxisLabels.map((xLabel, i)=>(0, $c0c9bc5c50648c54$exports.jsx)("div", {
                        className: `line-chart__x-label fade-in${centerXAxisLabels ? " line-chart__x-label--centered" : ""}`,
                        style: {
                            "--label-number": i
                        },
                        children: xLabel
                    }, xLabel + i))
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("div", {
                className: "line-chart__x-title fade-in nowrap",
                children: xAxisTitle
            })
        ]
    });
}


var $2ae3cd0ef43ccc32$export$2e2bcd8739ae039 = {
    ColumnChart: $76bff0585da7f039$export$2e2bcd8739ae039,
    Line: $fbc24f9487a537d6$export$2e2bcd8739ae039,
    LineChart: $3a774ac4219d659a$export$2e2bcd8739ae039
};




function $855c66307e03a080$export$2e2bcd8739ae039({ className: className, ...rest }) {
    return (0, $c0c9bc5c50648c54$exports.jsx)("div", {
        ...rest,
        className: `field select-none${className ? ` ${className}` : ""}`
    });
}



function $94fd4126dbe697d0$export$2e2bcd8739ae039({ children: children, indent: indent = false, ...rest }) {
    return children ? (0, $c0c9bc5c50648c54$exports.jsx)("div", {
        ...rest,
        "aria-live": "polite",
        className: `field-error fs-0 negative${indent ? " field-error--indent" : ""}`,
        "data-eri-id": "field-error",
        children: children
    }) : null;
}



const $e53b8b77a9cd0fc1$export$9a066abb1d77bead = {
    "at-sign": (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
        children: [
            (0, $c0c9bc5c50648c54$exports.jsx)("circle", {
                cx: "12",
                cy: "12",
                r: "4"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("path", {
                d: "M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-3.92 7.94"
            })
        ]
    }),
    bell: (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
        children: [
            (0, $c0c9bc5c50648c54$exports.jsx)("path", {
                d: "M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("path", {
                d: "M13.73 21a2 2 0 0 1-3.46 0"
            })
        ]
    }),
    book: (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
        children: [
            (0, $c0c9bc5c50648c54$exports.jsx)("path", {
                d: "M4 19.5A2.5 2.5 0 0 1 6.5 17H20"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("path", {
                d: "M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"
            })
        ]
    }),
    chart: (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
        children: [
            (0, $c0c9bc5c50648c54$exports.jsx)("line", {
                x1: "18",
                y1: "20",
                x2: "18",
                y2: "10"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("line", {
                x1: "12",
                y1: "20",
                x2: "12",
                y2: "4"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("line", {
                x1: "6",
                y1: "20",
                x2: "6",
                y2: "14"
            })
        ]
    }),
    check: (0, $c0c9bc5c50648c54$exports.jsx)("polyline", {
        points: "20 6 9 17 4 12"
    }),
    cloud: (0, $c0c9bc5c50648c54$exports.jsx)("path", {
        d: "M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z"
    }),
    compass: (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
        children: [
            (0, $c0c9bc5c50648c54$exports.jsx)("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("polygon", {
                points: "16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76"
            })
        ]
    }),
    copy: (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
        children: [
            (0, $c0c9bc5c50648c54$exports.jsx)("rect", {
                x: "9",
                y: "9",
                width: "13",
                height: "13",
                rx: "2",
                ry: "2"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("path", {
                d: "M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"
            })
        ]
    }),
    cross: (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
        children: [
            (0, $c0c9bc5c50648c54$exports.jsx)("line", {
                x1: "18",
                y1: "6",
                x2: "6",
                y2: "18"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("line", {
                x1: "6",
                y1: "6",
                x2: "18",
                y2: "18"
            })
        ]
    }),
    "dew-point": (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
        children: [
            (0, $c0c9bc5c50648c54$exports.jsx)("path", {
                d: "M5 12a5 5 0 106 0M5 12V3h6v9M11 3h2M11 6h2M11 9h2"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("path", {
                d: "M8 14a2 2 0 100 4 2 2 0 000-4zm0 0V9"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("path", {
                clipRule: "evenodd",
                d: "M19 3s3 2.993 3 4.887c0 1.655-1.345 3-3 3-1.656 0-2.988-1.345-3-3C16.01 5.992 19 3 19 3z"
            })
        ]
    }),
    down: (0, $c0c9bc5c50648c54$exports.jsx)("polyline", {
        points: "6 9 12 15 18 9"
    }),
    download: (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
        children: [
            (0, $c0c9bc5c50648c54$exports.jsx)("polyline", {
                points: "8 17 12 21 16 17"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("line", {
                x1: "12",
                y1: "12",
                x2: "12",
                y2: "21"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("path", {
                d: "M20.88 18.09A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.29"
            })
        ]
    }),
    drizzle: (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
        children: [
            (0, $c0c9bc5c50648c54$exports.jsx)("line", {
                x1: "8",
                y1: "19",
                x2: "8",
                y2: "21"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("line", {
                x1: "8",
                y1: "13",
                x2: "8",
                y2: "15"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("line", {
                x1: "16",
                y1: "19",
                x2: "16",
                y2: "21"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("line", {
                x1: "16",
                y1: "13",
                x2: "16",
                y2: "15"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("line", {
                x1: "12",
                y1: "21",
                x2: "12",
                y2: "23"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("line", {
                x1: "12",
                y1: "15",
                x2: "12",
                y2: "17"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("path", {
                d: "M20 16.58A5 5 0 0 0 18 7h-1.26A8 8 0 1 0 4 15.25"
            })
        ]
    }),
    droplet: (0, $c0c9bc5c50648c54$exports.jsx)("path", {
        d: "M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z"
    }),
    eye: (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
        children: [
            (0, $c0c9bc5c50648c54$exports.jsx)("path", {
                d: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("circle", {
                cx: "12",
                cy: "12",
                r: "3"
            })
        ]
    }),
    fog: (0, $c0c9bc5c50648c54$exports.jsx)("path", {
        d: "M9 14h6M9 22h6M7 18h10M3.5 17.382C2.188 16.707 1 15.388 1 13c0-4 3.333-5 5-5 0-2 0-6 6-6s6 4 6 6c1.667 0 5 1 5 5 0 2.388-1.188 3.707-2.5 4.382"
    }),
    heart: (0, $c0c9bc5c50648c54$exports.jsx)("path", {
        d: "M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"
    }),
    help: (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
        children: [
            (0, $c0c9bc5c50648c54$exports.jsx)("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("path", {
                d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("line", {
                x1: "12",
                y1: "17",
                x2: "12.01",
                y2: "17"
            })
        ]
    }),
    home: (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
        children: [
            (0, $c0c9bc5c50648c54$exports.jsx)("path", {
                d: "M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("polyline", {
                points: "9 22 9 12 15 12 15 22"
            })
        ]
    }),
    key: (0, $c0c9bc5c50648c54$exports.jsx)("path", {
        d: "M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4"
    }),
    left: (0, $c0c9bc5c50648c54$exports.jsx)("polyline", {
        points: "15 18 9 12 15 6"
    }),
    lightning: (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
        children: [
            (0, $c0c9bc5c50648c54$exports.jsx)("path", {
                d: "M19 16.9A5 5 0 0 0 18 7h-1.26a8 8 0 1 0-11.62 9"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("polyline", {
                points: "13 11 9 17 15 17 11 23"
            })
        ]
    }),
    link: (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
        children: [
            (0, $c0c9bc5c50648c54$exports.jsx)("path", {
                d: "M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("path", {
                d: "M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"
            })
        ]
    }),
    location: (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
        children: [
            (0, $c0c9bc5c50648c54$exports.jsx)("path", {
                d: "M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("circle", {
                cx: "12",
                cy: "10",
                r: "3"
            })
        ]
    }),
    lock: (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
        children: [
            (0, $c0c9bc5c50648c54$exports.jsx)("rect", {
                x: "3",
                y: "11",
                width: "18",
                height: "11",
                rx: "2",
                ry: "2"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("path", {
                d: "M7 11V7a5 5 0 0 1 10 0v4"
            })
        ]
    }),
    menu: (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
        children: [
            (0, $c0c9bc5c50648c54$exports.jsx)("line", {
                x1: "3",
                y1: "12",
                x2: "21",
                y2: "12"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("line", {
                x1: "3",
                y1: "6",
                x2: "21",
                y2: "6"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("line", {
                x1: "3",
                y1: "18",
                x2: "21",
                y2: "18"
            })
        ]
    }),
    minus: (0, $c0c9bc5c50648c54$exports.jsx)("line", {
        x1: "5",
        y1: "12",
        x2: "19",
        y2: "12"
    }),
    moon: (0, $c0c9bc5c50648c54$exports.jsx)("path", {
        d: "M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"
    }),
    // From material design
    "partly-cloudy-day": (0, $c0c9bc5c50648c54$exports.jsx)("svg", {
        viewBox: "0 0 48 48",
        children: (0, $c0c9bc5c50648c54$exports.jsx)("path", {
            d: "M23.15 11.25v-6.9h1.75v6.9Zm10.45 4.4-1.25-1.3 4.9-4.9 1.25 1.3Zm3.15 9.2V23.1h6.9v1.75Zm.5 13.65-4.85-4.9 1.3-1.3 4.85 4.9Zm-22.8-22.8-5-5 1.3-1.2 4.95 4.95Zm-.95 22.25h8q1.65 0 2.8-1.125T25.45 34q0-1.65-1.1-2.8t-2.8-1.15h-2l-.8-1.8q-.8-1.65-2.325-2.675Q14.9 24.55 13 24.55q-2.7 0-4.575 1.85T6.55 31q0 2.95 2 4.95t4.95 2Zm0 1.75q-3.6 0-6.15-2.55Q4.8 34.6 4.8 31q0-3.45 2.375-5.825T13 22.8q2.6 0 4.7 1.525t3 3.975q2.45 0 4.45 1.35t2 4.3q-.1 2.35-1.675 4.05-1.575 1.7-3.975 1.7Zm13.55-6.75q-.15-.35-.3-.75l-.3-.8q2.35-.8 3.775-2.85Q31.65 26.5 31.65 24q0-3.15-2.25-5.4-2.25-2.25-5.4-2.25-3.1 0-5.35 2.075Q16.4 20.5 16.3 23.6q-.35-.15-.825-.275Q15 23.2 14.65 23q.4-3.6 3.075-6Q20.4 14.6 24 14.6q3.9 0 6.65 2.75Q33.4 20.1 33.4 24q0 3.05-1.75 5.475t-4.6 3.475Z"
        })
    }),
    // From material design
    "partly-cloudy-night": (0, $c0c9bc5c50648c54$exports.jsx)("svg", {
        viewBox: "0 0 48 48",
        children: (0, $c0c9bc5c50648c54$exports.jsx)("path", {
            d: "M25.2 26.65Zm1 17.05h-5.65l.025-.225q.025-.225 0-.6t0-.625L20.6 42h4.75q4.75.25 8.675-2.15 3.925-2.4 6.175-6.1-4.25-.45-8.1-2.225-3.85-1.775-6.85-4.875-3.1-3-4.875-6.825T18.2 11.8q-3.75 2.2-5.95 5.85-2.2 3.65-2.2 7.95 0 .9.075 1.775.075.875.225 1.675l-.275.075q-.275.075-.575.1-.3.025-.575.05l-.275.025q-.15-.8-.25-1.75t-.1-1.75q0-5.65 3.15-10.175t8.4-6.475q.05 4.65 1.675 8.9t4.925 7.5q3.25 3.3 7.5 4.9 4.25 1.6 8.9 1.65-1.95 5.25-6.475 8.425Q31.85 43.7 26.2 43.7ZM12 41.95h9q1.25 0 2.125-.85T24 39.05q0-1.25-.825-2.15-.825-.9-2.075-.9h-2.65l-1-2.4q-.7-1.6-2.2-2.6-1.5-1-3.25-1-2.5 0-4.225 1.75Q6.05 33.5 6.05 36t1.725 4.225Q9.5 41.95 12 41.95Zm0 1.75q-3.25-.1-5.475-2.3Q4.3 39.2 4.3 36q0-3.25 2.225-5.5T12 28.25q2.3 0 4.175 1.25t2.875 3.3l.65 1.5h1.6q1.85.05 3.15 1.425 1.3 1.375 1.3 3.275 0 2-1.375 3.35T21 43.7Z"
        })
    }),
    pause: (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
        children: [
            (0, $c0c9bc5c50648c54$exports.jsx)("rect", {
                x: "6",
                y: "4",
                width: "4",
                height: "16"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("rect", {
                x: "14",
                y: "4",
                width: "4",
                height: "16"
            })
        ]
    }),
    play: (0, $c0c9bc5c50648c54$exports.jsx)("polygon", {
        points: "5 3 19 12 5 21 5 3"
    }),
    plus: (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
        children: [
            (0, $c0c9bc5c50648c54$exports.jsx)("line", {
                x1: "12",
                y1: "5",
                x2: "12",
                y2: "19"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("line", {
                x1: "5",
                y1: "12",
                x2: "19",
                y2: "12"
            })
        ]
    }),
    rain: (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
        children: [
            (0, $c0c9bc5c50648c54$exports.jsx)("line", {
                x1: "16",
                y1: "13",
                x2: "16",
                y2: "21"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("line", {
                x1: "8",
                y1: "13",
                x2: "8",
                y2: "21"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("line", {
                x1: "12",
                y1: "15",
                x2: "12",
                y2: "23"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("path", {
                d: "M20 16.58A5 5 0 0 0 18 7h-1.26A8 8 0 1 0 4 15.25"
            })
        ]
    }),
    right: (0, $c0c9bc5c50648c54$exports.jsx)("polyline", {
        points: "9 18 15 12 9 6"
    }),
    save: (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
        children: [
            (0, $c0c9bc5c50648c54$exports.jsx)("path", {
                d: "M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("polyline", {
                points: "17 21 17 13 7 13 7 21"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("polyline", {
                points: "7 3 7 8 15 8"
            })
        ]
    }),
    settings: (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
        children: [
            (0, $c0c9bc5c50648c54$exports.jsx)("circle", {
                cx: "12",
                cy: "12",
                r: "3"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("path", {
                d: "M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"
            })
        ]
    }),
    share: (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
        children: [
            (0, $c0c9bc5c50648c54$exports.jsx)("circle", {
                cx: "18",
                cy: "5",
                r: "3"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("circle", {
                cx: "6",
                cy: "12",
                r: "3"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("circle", {
                cx: "18",
                cy: "19",
                r: "3"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("line", {
                x1: "8.59",
                y1: "13.51",
                x2: "15.42",
                y2: "17.49"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("line", {
                x1: "15.41",
                y1: "6.51",
                x2: "8.59",
                y2: "10.49"
            })
        ]
    }),
    "sign-out": (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
        children: [
            (0, $c0c9bc5c50648c54$exports.jsx)("path", {
                d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("polyline", {
                points: "16 17 21 12 16 7"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("line", {
                x1: "21",
                y1: "12",
                x2: "9",
                y2: "12"
            })
        ]
    }),
    snow: (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
        children: [
            (0, $c0c9bc5c50648c54$exports.jsx)("path", {
                d: "M20 17.58A5 5 0 0 0 18 8h-1.26A8 8 0 1 0 4 16.25"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("line", {
                x1: "8",
                y1: "16",
                x2: "8.01",
                y2: "16"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("line", {
                x1: "8",
                y1: "20",
                x2: "8.01",
                y2: "20"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("line", {
                x1: "12",
                y1: "18",
                x2: "12.01",
                y2: "18"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("line", {
                x1: "12",
                y1: "22",
                x2: "12.01",
                y2: "22"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("line", {
                x1: "16",
                y1: "16",
                x2: "16.01",
                y2: "16"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("line", {
                x1: "16",
                y1: "20",
                x2: "16.01",
                y2: "20"
            })
        ]
    }),
    sun: (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
        children: [
            (0, $c0c9bc5c50648c54$exports.jsx)("circle", {
                cx: "12",
                cy: "12",
                r: "5"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("line", {
                x1: "12",
                y1: "1",
                x2: "12",
                y2: "3"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("line", {
                x1: "12",
                y1: "21",
                x2: "12",
                y2: "23"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("line", {
                x1: "4.22",
                y1: "4.22",
                x2: "5.64",
                y2: "5.64"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("line", {
                x1: "18.36",
                y1: "18.36",
                x2: "19.78",
                y2: "19.78"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("line", {
                x1: "1",
                y1: "12",
                x2: "3",
                y2: "12"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("line", {
                x1: "21",
                y1: "12",
                x2: "23",
                y2: "12"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("line", {
                x1: "4.22",
                y1: "19.78",
                x2: "5.64",
                y2: "18.36"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("line", {
                x1: "18.36",
                y1: "5.64",
                x2: "19.78",
                y2: "4.22"
            })
        ]
    }),
    sunrise: (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
        children: [
            (0, $c0c9bc5c50648c54$exports.jsx)("path", {
                d: "M17 18a5 5 0 0 0-10 0"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("line", {
                x1: "12",
                y1: "2",
                x2: "12",
                y2: "9"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("line", {
                x1: "4.22",
                y1: "10.22",
                x2: "5.64",
                y2: "11.64"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("line", {
                x1: "1",
                y1: "18",
                x2: "3",
                y2: "18"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("line", {
                x1: "21",
                y1: "18",
                x2: "23",
                y2: "18"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("line", {
                x1: "18.36",
                y1: "11.64",
                x2: "19.78",
                y2: "10.22"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("line", {
                x1: "23",
                y1: "22",
                x2: "1",
                y2: "22"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("polyline", {
                points: "8 6 12 2 16 6"
            })
        ]
    }),
    sunset: (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
        children: [
            (0, $c0c9bc5c50648c54$exports.jsx)("path", {
                d: "M17 18a5 5 0 0 0-10 0"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("line", {
                x1: "12",
                y1: "9",
                x2: "12",
                y2: "2"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("line", {
                x1: "4.22",
                y1: "10.22",
                x2: "5.64",
                y2: "11.64"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("line", {
                x1: "1",
                y1: "18",
                x2: "3",
                y2: "18"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("line", {
                x1: "21",
                y1: "18",
                x2: "23",
                y2: "18"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("line", {
                x1: "18.36",
                y1: "11.64",
                x2: "19.78",
                y2: "10.22"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("line", {
                x1: "23",
                y1: "22",
                x2: "1",
                y2: "22"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("polyline", {
                points: "16 5 12 9 8 5"
            })
        ]
    }),
    tag: (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
        children: [
            (0, $c0c9bc5c50648c54$exports.jsx)("path", {
                d: "M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("line", {
                x1: "7",
                y1: "7",
                x2: "7.01",
                y2: "7"
            })
        ]
    }),
    thermometer: (0, $c0c9bc5c50648c54$exports.jsx)("path", {
        d: "M14 14.76V3.5a2.5 2.5 0 0 0-5 0v11.26a4.5 4.5 0 1 0 5 0z"
    }),
    trash: (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
        children: [
            (0, $c0c9bc5c50648c54$exports.jsx)("polyline", {
                points: "3 6 5 6 21 6"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("path", {
                d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("line", {
                x1: "10",
                y1: "11",
                x2: "10",
                y2: "17"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("line", {
                x1: "14",
                y1: "11",
                x2: "14",
                y2: "17"
            })
        ]
    }),
    up: (0, $c0c9bc5c50648c54$exports.jsx)("polyline", {
        points: "18 15 12 9 6 15"
    }),
    weight: (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
        children: [
            (0, $c0c9bc5c50648c54$exports.jsx)("path", {
                stroke: "none",
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("path", {
                d: "M12 6m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("path", {
                d: "M6.835 9h10.33a1 1 0 0 1 .984 .821l1.637 9a1 1 0 0 1 -.984 1.179h-13.604a1 1 0 0 1 -.984 -1.179l1.637 -9a1 1 0 0 1 .984 -.821z"
            })
        ]
    }),
    wind: (0, $c0c9bc5c50648c54$exports.jsx)("path", {
        d: "M9.59 4.59A2 2 0 1 1 11 8H2m10.59 11.41A2 2 0 1 0 14 16H2m15.73-8.27A2.5 2.5 0 1 1 19.5 12H2"
    })
};
function $e53b8b77a9cd0fc1$export$2e2bcd8739ae039({ draw: draw, margin: margin, name: name, size: size = "inherit", ...rest }) {
    const className = `icon icon--size-${size}${draw ? " icon--draw" : ""}${size === "inherit" ? " icon--inline" : ""}${margin ? ` icon--margin-${margin}` : ""}`;
    return (0, $c0c9bc5c50648c54$exports.jsx)("svg", {
        strokeWidth: "2",
        ...rest,
        className: className,
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: $e53b8b77a9cd0fc1$export$9a066abb1d77bead[name]
    });
}


function $60ee988f6def5d2e$export$2e2bcd8739ae039({ label: label, error: error, ...rest }) {
    return (0, $c0c9bc5c50648c54$exports.jsx)((0, $855c66307e03a080$export$2e2bcd8739ae039), {
        className: "checkbox",
        children: (0, $c0c9bc5c50648c54$exports.jsxs)("label", {
            className: "checkbox__label",
            children: [
                (0, $c0c9bc5c50648c54$exports.jsx)("input", {
                    ...rest,
                    "aria-invalid": !!error,
                    className: "checkbox__input m-0",
                    type: "checkbox"
                }),
                (0, $c0c9bc5c50648c54$exports.jsx)("span", {
                    className: "checkbox__appearance br-1 bw-2",
                    children: (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                        name: "check",
                        size: "2"
                    })
                }),
                (0, $c0c9bc5c50648c54$exports.jsx)("span", {
                    className: "checkbox__label-copy",
                    children: label
                }),
                (0, $c0c9bc5c50648c54$exports.jsx)((0, $94fd4126dbe697d0$export$2e2bcd8739ae039), {
                    indent: true,
                    children: error
                })
            ]
        })
    });
}




var $lBnVc = parcelRequire("lBnVc");



function $71f0f49bdb6e1fc0$export$2e2bcd8739ae039({ children: children, optional: optional, ...rest }) {
    return (0, $c0c9bc5c50648c54$exports.jsxs)("span", {
        ...rest,
        className: "field-label-text fs-0 fw-b",
        children: [
            children,
            optional && " (optional)"
        ]
    });
}



function $8e334c6b85b3e9c1$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line jsx-a11y/label-has-associated-control
    return (0, $c0c9bc5c50648c54$exports.jsx)("label", {
        ...props,
        className: "label"
    });
}



function $32b541195f056073$export$2e2bcd8739ae039(props) {
    return props.children ? (0, $c0c9bc5c50648c54$exports.jsx)("span", {
        ...props,
        className: "supportive-text fs-0"
    }) : null;
}


function $3b97bac8379fc04c$export$2e2bcd8739ae039({ label: label, error: error, optional: optional = false, options: options, supportiveText: supportiveText, ...rest }) {
    const dataListIdRef = $lBnVc.useRef(`combo-box-auto-generated-id-${Math.random().toString(36)}`);
    return (0, $c0c9bc5c50648c54$exports.jsxs)((0, $855c66307e03a080$export$2e2bcd8739ae039), {
        children: [
            (0, $c0c9bc5c50648c54$exports.jsxs)((0, $8e334c6b85b3e9c1$export$2e2bcd8739ae039), {
                children: [
                    (0, $c0c9bc5c50648c54$exports.jsx)((0, $71f0f49bdb6e1fc0$export$2e2bcd8739ae039), {
                        optional: optional,
                        children: label
                    }),
                    (0, $c0c9bc5c50648c54$exports.jsx)((0, $32b541195f056073$export$2e2bcd8739ae039), {
                        children: supportiveText
                    }),
                    (0, $c0c9bc5c50648c54$exports.jsx)("input", {
                        // When fields aren't in forms they should not be required
                        // and do not need to be marked explicitly as optional,
                        // hence the user can override this attribute
                        required: !optional,
                        ...rest,
                        "aria-invalid": Boolean(error),
                        list: dataListIdRef.current
                    }),
                    (0, $c0c9bc5c50648c54$exports.jsx)("datalist", {
                        id: dataListIdRef.current,
                        children: options.map((option)=>(0, $c0c9bc5c50648c54$exports.jsx)("option", {
                                value: option
                            }, option))
                    })
                ]
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)((0, $94fd4126dbe697d0$export$2e2bcd8739ae039), {
                children: error
            })
        ]
    });
}








function $57887ab48588f6d3$export$2e2bcd8739ae039({ error: error, integer: integer, label: label, optional: optional = false, supportiveText: supportiveText, ...rest }) {
    return (0, $c0c9bc5c50648c54$exports.jsxs)((0, $855c66307e03a080$export$2e2bcd8739ae039), {
        children: [
            (0, $c0c9bc5c50648c54$exports.jsxs)((0, $8e334c6b85b3e9c1$export$2e2bcd8739ae039), {
                children: [
                    (0, $c0c9bc5c50648c54$exports.jsx)((0, $71f0f49bdb6e1fc0$export$2e2bcd8739ae039), {
                        optional: optional,
                        children: label
                    }),
                    (0, $c0c9bc5c50648c54$exports.jsx)((0, $32b541195f056073$export$2e2bcd8739ae039), {
                        children: supportiveText
                    }),
                    (0, $c0c9bc5c50648c54$exports.jsx)("span", {
                        className: "currency-field__input-container",
                        children: (0, $c0c9bc5c50648c54$exports.jsx)("input", {
                            autoComplete: "off",
                            // When fields aren't in forms they should not be required
                            // and do not need to be marked explicitly as optional,
                            // hence the user can override this attribute
                            required: !optional,
                            ...rest,
                            "aria-invalid": Boolean(error),
                            className: "currency-field__input",
                            inputMode: integer ? "numeric" : "decimal",
                            pattern: integer ? "[0-9]*" : "[0-9]*"
                        })
                    })
                ]
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)((0, $94fd4126dbe697d0$export$2e2bcd8739ae039), {
                children: error
            })
        ]
    });
}




function $3c22e17838f9d676$export$2e2bcd8739ae039(props) {
    return (0, $c0c9bc5c50648c54$exports.jsx)((0, $78053ee2024d275e$export$2e2bcd8739ae039), {
        ...props,
        type: "date"
    });
}




var $lBnVc = parcelRequire("lBnVc");



function $b11ffa75f8ddef13$export$2e2bcd8739ae039(props) {
    return (0, $c0c9bc5c50648c54$exports.jsx)("button", {
        ...props,
        "aria-label": "close",
        className: "close-button br-1 ripple",
        type: "button",
        children: (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
            name: "cross",
            size: "2"
        })
    });
}


function $70946b00ed05fabf$var$createPortalContainer(id) {
    if (typeof document === "undefined") return;
    const container = document.createElement("div");
    if (id) container.id = `${id}-portal`;
    return document.body.appendChild(container);
}
const $70946b00ed05fabf$export$be2a256375cf5387 = {
    fab: $70946b00ed05fabf$var$createPortalContainer(),
    quickNav: $70946b00ed05fabf$var$createPortalContainer("quick-nav"),
    nav: $70946b00ed05fabf$var$createPortalContainer(),
    dialog: $70946b00ed05fabf$var$createPortalContainer()
}; /* eslint-enable sort-keys */ 


function $2b02ccd0ece868b7$export$2e2bcd8739ae039({ children: children, disableClose: disableClose, onClose: onClose, open: open, title: title, ...rest }) {
    const dialogRef = $lBnVc.useRef(null);
    const closeDialog = $lBnVc.useCallback(()=>{
        if (!dialogRef.current) return;
        dialogRef.current.setAttribute("data-closing", "");
        dialogRef.current.addEventListener("animationend", ()=>{
            if (!dialogRef.current) return;
            dialogRef.current.removeAttribute("data-closing");
            dialogRef.current.close();
            onClose();
        }, {
            once: true
        });
    }, [
        onClose
    ]);
    $lBnVc.useEffect(()=>{
        if (!dialogRef.current || dialogRef.current.open === open) return;
        if (open) return dialogRef.current.showModal();
        closeDialog();
    }, [
        closeDialog,
        open
    ]);
    return $cc4070eb400e02f6$exports.createPortal(/*eslint-disable-next-line jsx-a11y/click-events-have-key-events*/ (0, $c0c9bc5c50648c54$exports.jsx)("dialog", {
        ...rest,
        "aria-describedby": "dialog-desc",
        "aria-labelledby": "dialog-title",
        className: "br-1 bs-1 p-0",
        onClick: disableClose ? undefined : (e)=>{
            if (e.target === dialogRef.current) closeDialog();
        },
        ref: dialogRef,
        children: (0, $c0c9bc5c50648c54$exports.jsxs)("div", {
            className: "dialog__container",
            children: [
                (0, $c0c9bc5c50648c54$exports.jsxs)("div", {
                    className: "dialog__header",
                    children: [
                        (0, $c0c9bc5c50648c54$exports.jsx)("h3", {
                            id: "dialog-title",
                            children: title
                        }),
                        (0, $c0c9bc5c50648c54$exports.jsx)("div", {
                            className: "dialog__close-button-container",
                            children: (0, $c0c9bc5c50648c54$exports.jsx)((0, $b11ffa75f8ddef13$export$2e2bcd8739ae039), {
                                disabled: disableClose || !open,
                                onClick: ()=>closeDialog()
                            })
                        })
                    ]
                }),
                (0, $c0c9bc5c50648c54$exports.jsx)("div", {
                    id: "dialog-desc",
                    children: children
                })
            ]
        })
    }), (0, $70946b00ed05fabf$export$be2a256375cf5387).dialog);
}




function $1c0da6391b4f32cc$export$2e2bcd8739ae039() {
    $1c0da6391b4f32cc$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1c0da6391b4f32cc$export$2e2bcd8739ae039.apply(this, arguments);
}


function $8f44a14af9000677$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


function $fe8b5ac3bd9510ac$export$2e2bcd8739ae039(o, p) {
    $fe8b5ac3bd9510ac$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $fe8b5ac3bd9510ac$export$2e2bcd8739ae039(o, p);
}


function $8dbb5e64a061b315$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $fe8b5ac3bd9510ac$export$2e2bcd8739ae039)(subClass, superClass);
}



/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $da63b6c863e6c16c$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}


function $bfe87679e457f65f$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $da63b6c863e6c16c$export$2e2bcd8739ae039)(element, className)) {
        if (typeof element.className === "string") element.className = element.className + " " + className;
        else element.setAttribute("class", (element.className && element.className.baseVal || "") + " " + className);
    }
}


function $a08e29fbda707a21$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
function $a08e29fbda707a21$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === "string") element.className = $a08e29fbda707a21$var$replaceClassName(element.className, className);
    else element.setAttribute("class", $a08e29fbda707a21$var$replaceClassName(element.className && element.className.baseVal || "", className));
}



var $lBnVc = parcelRequire("lBnVc");




var $lBnVc = parcelRequire("lBnVc");

var $1d58e325fe629805$export$2e2bcd8739ae039 = {
    disabled: false
};




var $lBnVc = parcelRequire("lBnVc");
var $faff20bc333fa9a7$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($lBnVc))).createContext(null);


var $834c4a5c1a939456$export$bb38bb9a1161268 = "unmounted";
var $834c4a5c1a939456$export$84cbff306f539230 = "exited";
var $834c4a5c1a939456$export$df38205c966be359 = "entering";
var $834c4a5c1a939456$export$78e9e6e3e014d60a = "entered";
var $834c4a5c1a939456$export$4aacc83d4d59139f = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $834c4a5c1a939456$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $8dbb5e64a061b315$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $834c4a5c1a939456$export$84cbff306f539230;
                _this.appearStatus = $834c4a5c1a939456$export$df38205c966be359;
            } else initialStatus = $834c4a5c1a939456$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $834c4a5c1a939456$export$bb38bb9a1161268;
        else initialStatus = $834c4a5c1a939456$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $834c4a5c1a939456$export$bb38bb9a1161268) return {
            status: $834c4a5c1a939456$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $834c4a5c1a939456$export$df38205c966be359 && status !== $834c4a5c1a939456$export$78e9e6e3e014d60a) nextStatus = $834c4a5c1a939456$export$df38205c966be359;
            } else if (status === $834c4a5c1a939456$export$df38205c966be359 || status === $834c4a5c1a939456$export$78e9e6e3e014d60a) nextStatus = $834c4a5c1a939456$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $834c4a5c1a939456$export$df38205c966be359) this.performEnter(mounting);
            else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $834c4a5c1a939456$export$84cbff306f539230) this.setState({
            status: $834c4a5c1a939456$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($cc4070eb400e02f6$exports))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $1d58e325fe629805$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $834c4a5c1a939456$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $834c4a5c1a939456$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $834c4a5c1a939456$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($cc4070eb400e02f6$exports))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $1d58e325fe629805$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $834c4a5c1a939456$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $834c4a5c1a939456$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $834c4a5c1a939456$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($cc4070eb400e02f6$exports))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $834c4a5c1a939456$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $8f44a14af9000677$export$2e2bcd8739ae039)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($lBnVc))).createElement((0, $faff20bc333fa9a7$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === "function" ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($lBnVc))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($lBnVc))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($lBnVc))).Component);
$834c4a5c1a939456$var$Transition.contextType = (0, $faff20bc333fa9a7$export$2e2bcd8739ae039);
$834c4a5c1a939456$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $834c4a5c1a939456$var$noop() {}
$834c4a5c1a939456$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $834c4a5c1a939456$var$noop,
    onEntering: $834c4a5c1a939456$var$noop,
    onEntered: $834c4a5c1a939456$var$noop,
    onExit: $834c4a5c1a939456$var$noop,
    onExiting: $834c4a5c1a939456$var$noop,
    onExited: $834c4a5c1a939456$var$noop
};
$834c4a5c1a939456$var$Transition.UNMOUNTED = $834c4a5c1a939456$export$bb38bb9a1161268;
$834c4a5c1a939456$var$Transition.EXITED = $834c4a5c1a939456$export$84cbff306f539230;
$834c4a5c1a939456$var$Transition.ENTERING = $834c4a5c1a939456$export$df38205c966be359;
$834c4a5c1a939456$var$Transition.ENTERED = $834c4a5c1a939456$export$78e9e6e3e014d60a;
$834c4a5c1a939456$var$Transition.EXITING = $834c4a5c1a939456$export$4aacc83d4d59139f;
var $834c4a5c1a939456$export$2e2bcd8739ae039 = $834c4a5c1a939456$var$Transition;



var $d0c4bf6f8d58b228$var$_addClass = function addClass(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c) {
        return (0, $bfe87679e457f65f$export$2e2bcd8739ae039)(node, c);
    });
};
var $d0c4bf6f8d58b228$var$removeClass = function removeClass(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c) {
        return (0, $a08e29fbda707a21$export$2e2bcd8739ae039)(node, c);
    });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */ var $d0c4bf6f8d58b228$var$CSSTransition = /*#__PURE__*/ function(_React$Component) {
    (0, $8dbb5e64a061b315$export$2e2bcd8739ae039)(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.appliedClasses = {
            appear: {},
            enter: {},
            exit: {}
        };
        _this.onEnter = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument[0], appearing = _this$resolveArgument[1];
            _this.removeClasses(node, "exit");
            _this.addClass(node, appearing ? "appear" : "enter", "base");
            if (_this.props.onEnter) _this.props.onEnter(maybeNode, maybeAppearing);
        };
        _this.onEntering = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument2[0], appearing = _this$resolveArgument2[1];
            var type = appearing ? "appear" : "enter";
            _this.addClass(node, type, "active");
            if (_this.props.onEntering) _this.props.onEntering(maybeNode, maybeAppearing);
        };
        _this.onEntered = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument3[0], appearing = _this$resolveArgument3[1];
            var type = appearing ? "appear" : "enter";
            _this.removeClasses(node, type);
            _this.addClass(node, type, "done");
            if (_this.props.onEntered) _this.props.onEntered(maybeNode, maybeAppearing);
        };
        _this.onExit = function(maybeNode) {
            var _this$resolveArgument4 = _this.resolveArguments(maybeNode), node = _this$resolveArgument4[0];
            _this.removeClasses(node, "appear");
            _this.removeClasses(node, "enter");
            _this.addClass(node, "exit", "base");
            if (_this.props.onExit) _this.props.onExit(maybeNode);
        };
        _this.onExiting = function(maybeNode) {
            var _this$resolveArgument5 = _this.resolveArguments(maybeNode), node = _this$resolveArgument5[0];
            _this.addClass(node, "exit", "active");
            if (_this.props.onExiting) _this.props.onExiting(maybeNode);
        };
        _this.onExited = function(maybeNode) {
            var _this$resolveArgument6 = _this.resolveArguments(maybeNode), node = _this$resolveArgument6[0];
            _this.removeClasses(node, "exit");
            _this.addClass(node, "exit", "done");
            if (_this.props.onExited) _this.props.onExited(maybeNode);
        };
        _this.resolveArguments = function(maybeNode, maybeAppearing) {
            return _this.props.nodeRef ? [
                _this.props.nodeRef.current,
                maybeNode
            ] // here `maybeNode` is actually `appearing`
             : [
                maybeNode,
                maybeAppearing
            ];
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = typeof classNames === "string";
            var prefix = isStringClassNames && classNames ? classNames + "-" : "";
            var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
            var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
            return {
                baseClassName: baseClassName,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.addClass = function addClass(node, type, phase) {
        var className = this.getClassNames(type)[phase + "ClassName"];
        var _this$getClassNames = this.getClassNames("enter"), doneClassName = _this$getClassNames.doneClassName;
        if (type === "appear" && phase === "done" && doneClassName) className += " " + doneClassName;
         // This is to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (phase === "active") /* eslint-disable no-unused-expressions */ node && node.scrollTop;
        if (className) {
            this.appliedClasses[type][phase] = className;
            $d0c4bf6f8d58b228$var$_addClass(node, className);
        }
    };
    _proto.removeClasses = function removeClasses(node, type) {
        var _this$appliedClasses$ = this.appliedClasses[type], baseClassName = _this$appliedClasses$.base, activeClassName = _this$appliedClasses$.active, doneClassName = _this$appliedClasses$.done;
        this.appliedClasses[type] = {};
        if (baseClassName) $d0c4bf6f8d58b228$var$removeClass(node, baseClassName);
        if (activeClassName) $d0c4bf6f8d58b228$var$removeClass(node, activeClassName);
        if (doneClassName) $d0c4bf6f8d58b228$var$removeClass(node, doneClassName);
    };
    _proto.render = function render() {
        var _this$props = this.props, _ = _this$props.classNames, props = (0, $8f44a14af9000677$export$2e2bcd8739ae039)(_this$props, [
            "classNames"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lBnVc))).createElement((0, $834c4a5c1a939456$export$2e2bcd8739ae039), (0, $1c0da6391b4f32cc$export$2e2bcd8739ae039)({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}((0, (/*@__PURE__*/$parcel$interopDefault($lBnVc))).Component);
$d0c4bf6f8d58b228$var$CSSTransition.defaultProps = {
    classNames: ""
};
$d0c4bf6f8d58b228$var$CSSTransition.propTypes = {};
var $d0c4bf6f8d58b228$export$2e2bcd8739ae039 = $d0c4bf6f8d58b228$var$CSSTransition;




const $44af648581d9fabc$var$PORTAL_EL = (0, $70946b00ed05fabf$export$be2a256375cf5387).fab;
function $44af648581d9fabc$export$2e2bcd8739ae039({ hide: hide = false, type: type = "submit", ...rest }) {
    if (!$44af648581d9fabc$var$PORTAL_EL) return;
    return $cc4070eb400e02f6$exports.createPortal((0, $c0c9bc5c50648c54$exports.jsx)((0, $d0c4bf6f8d58b228$export$2e2bcd8739ae039), {
        classNames: "fab-",
        in: !hide,
        mountOnEnter: true,
        timeout: {
            exit: (0, $d6a4677f881c9818$export$2018caab28d589c9)() + 100
        },
        unmountOnExit: true,
        children: (0, $c0c9bc5c50648c54$exports.jsx)("button", {
            ...rest,
            className: "fab br-max p-3 z-1",
            type: type
        })
    }), $44af648581d9fabc$var$PORTAL_EL);
}




var $lBnVc = parcelRequire("lBnVc");



function $31843a75f9f755dc$export$2e2bcd8739ae039({ onSubmit: onSubmit, ...rest }) {
    const navigate = (0, $f02d97b5ca509f34$export$9770f232ac06a008)();
    const [emailError, setEmailError] = $lBnVc.useState("");
    const [isSubmitting, setIsSubmitting] = $lBnVc.useState(false);
    const [submitError, setSubmitError] = $lBnVc.useState();
    return (0, $c0c9bc5c50648c54$exports.jsx)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039).Group, {
        ...rest,
        children: (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
            children: [
                (0, $c0c9bc5c50648c54$exports.jsx)("h2", {
                    children: "Forgot password?"
                }),
                (0, $c0c9bc5c50648c54$exports.jsx)("p", {
                    children: "If you already have an account we'll send you a code for resetting your password."
                }),
                (0, $c0c9bc5c50648c54$exports.jsxs)("p", {
                    children: [
                        "If you don't receive an email check your junk folder and the spelling of your address, or try ",
                        (0, $c0c9bc5c50648c54$exports.jsx)((0, $e94b7bcc277332d2$export$a6c7ac8248d6e38a), {
                            to: "/sign-up",
                            children: "signing up"
                        }),
                        "."
                    ]
                }),
                (0, $c0c9bc5c50648c54$exports.jsxs)("form", {
                    noValidate: true,
                    onSubmit: async (e)=>{
                        e.preventDefault();
                        setSubmitError(undefined);
                        const email = e.target.email.value;
                        const emailErrorMessage = (0, $771bf5af5dde3604$export$4c0c1934ef708d90)(email);
                        if (emailErrorMessage) return setEmailError(emailErrorMessage);
                        if (emailError) setEmailError("");
                        setIsSubmitting(true);
                        try {
                            await onSubmit({
                                email: email,
                                setSubmitError: setSubmitError
                            });
                            const searchParams = new URLSearchParams();
                            searchParams.set("email", email);
                            navigate(`/reset-password?${searchParams}`);
                        } finally{
                            setIsSubmitting(false);
                        }
                    },
                    children: [
                        (0, $c0c9bc5c50648c54$exports.jsx)((0, $78053ee2024d275e$export$2e2bcd8739ae039), {
                            autoComplete: "email",
                            autoFocus: true,
                            error: emailError,
                            label: "Email",
                            name: "email",
                            supportiveText: "Take care to type your address correctly",
                            type: "email"
                        }),
                        submitError && (0, $c0c9bc5c50648c54$exports.jsx)("p", {
                            className: "center",
                            children: (0, $c0c9bc5c50648c54$exports.jsx)("small", {
                                className: "negative",
                                children: submitError
                            })
                        }),
                        (0, $c0c9bc5c50648c54$exports.jsx)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039).Group, {
                            children: (0, $c0c9bc5c50648c54$exports.jsx)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039), {
                                disabled: isSubmitting,
                                children: "Send code"
                            })
                        }),
                        (0, $c0c9bc5c50648c54$exports.jsx)("p", {
                            className: "center",
                            children: (0, $c0c9bc5c50648c54$exports.jsxs)("small", {
                                children: [
                                    "Already have a verification code?",
                                    " ",
                                    (0, $c0c9bc5c50648c54$exports.jsx)((0, $e94b7bcc277332d2$export$a6c7ac8248d6e38a), {
                                        to: "/reset-password",
                                        children: "Reset your password"
                                    }),
                                    "!"
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
}



function $c96d31531953528e$export$2e2bcd8739ae039(props) {
    return (0, $c0c9bc5c50648c54$exports.jsx)("header", {
        className: "bs-1",
        children: (0, $c0c9bc5c50648c54$exports.jsx)("div", {
            ...props,
            className: "header__container"
        })
    });
}





var $lBnVc = parcelRequire("lBnVc");





const $49b8e8e237fe172a$var$handleLoad = ({ target: { src: src } })=>URL.revokeObjectURL(src);
function $49b8e8e237fe172a$export$2e2bcd8739ae039({ error: error, label: label, onChange: onChange, optional: optional = false, supportiveText: supportiveText, ...rest }) {
    const [{ imageName: imageName, imageUrl: imageUrl }, setState] = $lBnVc.useState({
        imageName: undefined,
        imageUrl: undefined
    });
    const handleChange = (e)=>{
        const files = e.target.files;
        if (!files.length) setState({
            imageName: undefined,
            imageUrl: undefined
        });
        else {
            const file = files[0];
            setState({
                imageName: file.name,
                imageUrl: URL.createObjectURL(file)
            });
        }
        if (onChange) onChange(e);
    };
    return (0, $c0c9bc5c50648c54$exports.jsxs)((0, $855c66307e03a080$export$2e2bcd8739ae039), {
        children: [
            (0, $c0c9bc5c50648c54$exports.jsxs)((0, $8e334c6b85b3e9c1$export$2e2bcd8739ae039), {
                children: [
                    (0, $c0c9bc5c50648c54$exports.jsx)((0, $71f0f49bdb6e1fc0$export$2e2bcd8739ae039), {
                        optional: optional,
                        children: label
                    }),
                    (0, $c0c9bc5c50648c54$exports.jsx)((0, $32b541195f056073$export$2e2bcd8739ae039), {
                        children: supportiveText
                    }),
                    imageUrl && (0, $c0c9bc5c50648c54$exports.jsx)("img", {
                        alt: `preview of ${imageName}`,
                        className: "image-upload__img bw-2",
                        onLoad: $49b8e8e237fe172a$var$handleLoad,
                        src: imageUrl
                    }),
                    (0, $c0c9bc5c50648c54$exports.jsx)("input", {
                        // When fields aren't in forms they should not be required
                        // and do not need to be marked explicitly as optional,
                        // hence the user can override this attribute
                        required: !optional,
                        ...rest,
                        accept: "image/*",
                        "aria-invalid": Boolean(error),
                        className: "image-upload__input",
                        onChange: handleChange,
                        type: "file"
                    })
                ]
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)((0, $94fd4126dbe697d0$export$2e2bcd8739ae039), {
                children: error
            })
        ]
    });
}







var $lBnVc = parcelRequire("lBnVc");



function $ac5e3c3d4ab962bb$export$2e2bcd8739ae039({ onClose: onClose, open: open, portalContainer: portalContainer, ...rest }) {
    const handleKeyDown = $lBnVc.useCallback((e)=>{
        if (open && onClose && e.code === "Escape") onClose();
    }, [
        onClose,
        open
    ]);
    $lBnVc.useEffect(()=>{
        window.addEventListener("keydown", handleKeyDown);
        return ()=>{
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        handleKeyDown
    ]);
    if (!portalContainer) return;
    return $cc4070eb400e02f6$exports.createPortal(/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */ (0, $c0c9bc5c50648c54$exports.jsxs)("div", {
        onKeyDown: handleKeyDown,
        children: [
            (0, $c0c9bc5c50648c54$exports.jsx)((0, $d0c4bf6f8d58b228$export$2e2bcd8739ae039), {
                classNames: "mask__mask-",
                in: open,
                mountOnEnter: true,
                timeout: {
                    exit: (0, $d6a4677f881c9818$export$859047452738ec6)() + 100
                },
                unmountOnExit: true,
                children: (0, $c0c9bc5c50648c54$exports.jsx)("div", {
                    className: "mask__mask z-3",
                    onClick: onClose
                })
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("div", {
                ...rest,
                className: "mask__container z-3"
            })
        ]
    }), /* eslint-enable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */ portalContainer);
}




function $cbf1cf2a529f6404$export$2e2bcd8739ae039(props) {
    return (0, $c0c9bc5c50648c54$exports.jsxs)("button", {
        ...props,
        className: "nav-button fs-0 fw-b ripple",
        children: [
            (0, $c0c9bc5c50648c54$exports.jsx)("span", {
                className: "nav-button__text",
                children: "Menu"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                name: "menu",
                margin: "start",
                size: "3"
            })
        ]
    });
}
$cbf1cf2a529f6404$export$2e2bcd8739ae039.displayName = "Nav.Button";




function $ae21a3b6cce5c0d6$export$2e2bcd8739ae039({ to: to, ...rest }) {
    return (0, $c0c9bc5c50648c54$exports.jsx)("li", {
        className: "nav-link m-0",
        children: (0, $c0c9bc5c50648c54$exports.jsx)((0, $e94b7bcc277332d2$export$b0d92dbee9b5b60d), {
            ...rest,
            className: ({ isActive: isActive })=>`nav-link__link fw-b ${isActive ? " nav-link__link--active" : ""} ripple`,
            end: true,
            to: to
        })
    });
}
$ae21a3b6cce5c0d6$export$2e2bcd8739ae039.displayName = "Nav.Link";



function $a8fe5f1c2e6031be$export$2e2bcd8739ae039(props) {
    return (0, $c0c9bc5c50648c54$exports.jsx)("ul", {
        ...props,
        className: "nav-list m-0"
    });
}
$a8fe5f1c2e6031be$export$2e2bcd8739ae039.displayName = "Nav.List";




var $lBnVc = parcelRequire("lBnVc");

function $85899e899c64fd67$export$2e2bcd8739ae039({ heading: heading, ...rest }) {
    const [isExpanded, setIsExpanded] = $lBnVc.useState(true);
    const [hasBeenClicked, setHasBeenClicked] = $lBnVc.useState(false);
    return (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
        children: [
            (0, $c0c9bc5c50648c54$exports.jsx)("li", {
                className: "nav-link m-0",
                children: (0, $c0c9bc5c50648c54$exports.jsxs)("button", {
                    className: "nav-sub-list__heading fw-b ripple",
                    onClick: ()=>{
                        if (!hasBeenClicked) setHasBeenClicked(true);
                        setIsExpanded(!isExpanded);
                    },
                    children: [
                        heading,
                        (0, $c0c9bc5c50648c54$exports.jsx)("span", {
                            className: `nav-sub-list__icon${isExpanded ? " nav-sub-list__icon--expanded" : ""}`,
                            children: (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                                name: "down",
                                strokeWidth: "4"
                            })
                        })
                    ]
                })
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("li", {
                className: "nav-sub-list__list",
                children: isExpanded && (0, $c0c9bc5c50648c54$exports.jsx)("ul", {
                    ...rest,
                    className: `m-0 p-0${hasBeenClicked ? " slide-in" : ""}`
                })
            })
        ]
    });
}
$85899e899c64fd67$export$2e2bcd8739ae039.displayName = "Nav.SubList";





var $lBnVc = parcelRequire("lBnVc");
const $2d448da79f9f8ce9$var$mediaQuery = typeof window === "undefined" ? undefined : window.matchMedia("(min-width: 66rem)");
function $2d448da79f9f8ce9$export$2e2bcd8739ae039() {
    const [isWideResolution, setIsWideResolution] = (0, $lBnVc.useState)($2d448da79f9f8ce9$var$mediaQuery ? $2d448da79f9f8ce9$var$mediaQuery.matches : false);
    (0, $lBnVc.useEffect)(()=>{
        const mediaQueryHandler = (e)=>setIsWideResolution(e.matches);
        $2d448da79f9f8ce9$var$mediaQuery?.addEventListener("change", mediaQueryHandler);
        return ()=>$2d448da79f9f8ce9$var$mediaQuery?.removeEventListener("change", mediaQueryHandler);
    }, []);
    return isWideResolution;
}


function $b7447fff7bd4991b$export$2e2bcd8739ae039({ children: children, onClose: onClose, open: open, ...rest }) {
    const isWideResolution = (0, $2d448da79f9f8ce9$export$2e2bcd8739ae039)();
    const navEl = /* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions */ (0, $c0c9bc5c50648c54$exports.jsxs)("nav", {
        ...rest,
        className: "nav",
        onClick: (e)=>e.stopPropagation(),
        children: [
            (0, $c0c9bc5c50648c54$exports.jsx)("div", {
                className: "nav__close-button",
                children: (0, $c0c9bc5c50648c54$exports.jsx)((0, $b11ffa75f8ddef13$export$2e2bcd8739ae039), {
                    onClick: onClose
                })
            }),
            children
        ]
    });
    return isWideResolution ? navEl : (0, $c0c9bc5c50648c54$exports.jsx)((0, $ac5e3c3d4ab962bb$export$2e2bcd8739ae039), {
        onClose: onClose,
        open: open,
        portalContainer: (0, $70946b00ed05fabf$export$be2a256375cf5387).nav,
        children: (0, $c0c9bc5c50648c54$exports.jsx)((0, $d0c4bf6f8d58b228$export$2e2bcd8739ae039), {
            classNames: "nav-",
            in: open,
            mountOnEnter: true,
            timeout: {
                exit: (0, $d6a4677f881c9818$export$859047452738ec6)() + 100
            },
            unmountOnExit: true,
            children: navEl
        })
    });
}
$b7447fff7bd4991b$export$2e2bcd8739ae039.Button = (0, $cbf1cf2a529f6404$export$2e2bcd8739ae039);
$b7447fff7bd4991b$export$2e2bcd8739ae039.Link = (0, $ae21a3b6cce5c0d6$export$2e2bcd8739ae039);
$b7447fff7bd4991b$export$2e2bcd8739ae039.List = (0, $a8fe5f1c2e6031be$export$2e2bcd8739ae039);
$b7447fff7bd4991b$export$2e2bcd8739ae039.SubList = (0, $85899e899c64fd67$export$2e2bcd8739ae039);




const $64123a2209d9f6c7$var$maxPageButtons = 5;
const $64123a2209d9f6c7$var$halfMaxPageButtons = Math.floor($64123a2209d9f6c7$var$maxPageButtons / 2);
function $64123a2209d9f6c7$export$2e2bcd8739ae039({ page: page, pageCount: pageCount, onChange: onChange }) {
    const pageNumbers = [];
    const pageButtonCount = Math.min(pageCount, $64123a2209d9f6c7$var$maxPageButtons);
    for(let i = 0; i < pageButtonCount; i++){
        if (page <= $64123a2209d9f6c7$var$halfMaxPageButtons) pageNumbers.push(i);
        else if (page >= pageCount - $64123a2209d9f6c7$var$halfMaxPageButtons) pageNumbers.push(i + pageCount - Math.min($64123a2209d9f6c7$var$maxPageButtons, pageCount));
        else pageNumbers.push(i + page - $64123a2209d9f6c7$var$halfMaxPageButtons);
    }
    return pageCount > 1 ? (0, $c0c9bc5c50648c54$exports.jsxs)("div", {
        className: "pagination select-none",
        children: [
            page !== 0 && (0, $c0c9bc5c50648c54$exports.jsx)("button", {
                "aria-label": "navigate to previous page",
                className: "pagination__button pagination__button--arrow br-1 ripple",
                "data-page": page - 1,
                onClick: ()=>onChange(page - 1),
                type: "button",
                children: (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                    name: "left",
                    size: "2"
                })
            }),
            pageNumbers.map((i)=>(0, $c0c9bc5c50648c54$exports.jsx)("button", {
                    "aria-label": `navigate to page ${i + 1}`,
                    className: "pagination__button br-1",
                    "data-page": i,
                    disabled: i === page,
                    onClick: ()=>onChange(i),
                    children: i + 1
                }, i)),
            page !== pageCount - 1 && (0, $c0c9bc5c50648c54$exports.jsx)("button", {
                "aria-label": "navigate to next page",
                className: "pagination__button pagination__button--arrow br-1 ripple",
                "data-page": page + 1,
                onClick: ()=>onChange(page + 1),
                type: "button",
                children: (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                    name: "right",
                    size: "2"
                })
            })
        ]
    }) : null;
}




function $f391ac5a7506b2ba$export$2e2bcd8739ae039({ noSlide: noSlide, ...rest }) {
    return (0, $c0c9bc5c50648c54$exports.jsx)("div", {
        ...rest,
        // padding used because margin cuts off the paper box-shadow
        className: `paper-group ${noSlide ? "" : " slide-children-in"}`
    });
}
$f391ac5a7506b2ba$export$2e2bcd8739ae039.displayName = "Paper.Group";


function $b613c61ec3efa9f5$export$2e2bcd8739ae039(props) {
    return props.onClick ? (0, $c0c9bc5c50648c54$exports.jsx)("button", {
        ...props,
        className: "paper bs-0 p-3 ripple",
        type: "button"
    }) : (0, $c0c9bc5c50648c54$exports.jsx)("div", {
        ...props,
        className: "paper bs-0 p-3"
    });
}
$b613c61ec3efa9f5$export$2e2bcd8739ae039.Group = (0, $f391ac5a7506b2ba$export$2e2bcd8739ae039);




var $lBnVc = parcelRequire("lBnVc");




function $2874a4d7cc34500d$export$2e2bcd8739ae039(props) {
    return (0, $c0c9bc5c50648c54$exports.jsx)((0, $e94b7bcc277332d2$export$b0d92dbee9b5b60d), {
        ...props,
        className: ({ isActive: isActive })=>`quick-nav-link${isActive ? " quick-nav-link--active" : ""}`,
        end: true
    });
}
$2874a4d7cc34500d$export$2e2bcd8739ae039.displayName = "QuickNav.Link";


function $6e81c212129c1867$export$2e2bcd8739ae039(props) {
    const navElRef = $lBnVc.useRef(null);
    $lBnVc.useEffect(()=>{
        const handler = ()=>{
            if (!navElRef.current) return;
            const boundingClientRect = navElRef.current.getBoundingClientRect();
            document.documentElement.style.setProperty("--quick-nav-height", `${boundingClientRect.height}px`);
        };
        document.documentElement.classList.add("quick-nav-mounted");
        addEventListener("resize", handler);
        handler();
        return ()=>{
            document.documentElement.classList.remove("quick-nav-mounted");
            document.documentElement.style.setProperty("--quick-nav-height", "0px");
            removeEventListener("resize", handler);
        };
    }, []);
    return $cc4070eb400e02f6$exports.createPortal((0, $c0c9bc5c50648c54$exports.jsx)("nav", {
        ...props,
        className: "quick-nav bs-1 z-1",
        ref: navElRef
    }), (0, $70946b00ed05fabf$export$be2a256375cf5387).quickNav);
}
$6e81c212129c1867$export$2e2bcd8739ae039.Link = (0, $2874a4d7cc34500d$export$2e2bcd8739ae039);







function $daefd689350ecce5$export$2e2bcd8739ae039({ error: error, label: label, children: children, ...rest }) {
    return (0, $c0c9bc5c50648c54$exports.jsx)((0, $855c66307e03a080$export$2e2bcd8739ae039), {
        children: (0, $c0c9bc5c50648c54$exports.jsxs)("fieldset", {
            ...rest,
            "aria-invalid": !!error,
            className: "radio-button-group p-0",
            children: [
                (0, $c0c9bc5c50648c54$exports.jsx)("legend", {
                    className: "p-0",
                    children: (0, $c0c9bc5c50648c54$exports.jsx)((0, $71f0f49bdb6e1fc0$export$2e2bcd8739ae039), {
                        optional: false,
                        children: label
                    })
                }),
                (0, $c0c9bc5c50648c54$exports.jsx)("div", {
                    className: "radio-button-group__container",
                    children: children
                }),
                (0, $c0c9bc5c50648c54$exports.jsx)((0, $94fd4126dbe697d0$export$2e2bcd8739ae039), {
                    children: error
                })
            ]
        })
    });
}
$daefd689350ecce5$export$2e2bcd8739ae039.displayName = "RadioButton.Group";


function $bc720a2257db6cb9$export$2e2bcd8739ae039({ children: children, color: color, ...rest }) {
    return (0, $c0c9bc5c50648c54$exports.jsxs)("label", {
        className: "radio-button",
        style: color ? {
            "--color": color
        } : undefined,
        children: [
            (0, $c0c9bc5c50648c54$exports.jsx)("input", {
                ...rest,
                className: "radio-button__input m-0",
                type: "radio"
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)("div", {
                className: "radio-button__appearance bw-2 center p-1",
                children: children
            })
        ]
    });
}
$bc720a2257db6cb9$export$2e2bcd8739ae039.Group = (0, $daefd689350ecce5$export$2e2bcd8739ae039);




var $lBnVc = parcelRequire("lBnVc");



function $20b851c2599992db$export$2e2bcd8739ae039({ onSubmit: onSubmit, ...rest }) {
    const [emailError, setEmailError] = $lBnVc.useState("");
    const [isSubmitting, setIsSubmitting] = $lBnVc.useState(false);
    const [submitError, setSubmitError] = $lBnVc.useState();
    return (0, $c0c9bc5c50648c54$exports.jsx)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039).Group, {
        ...rest,
        children: (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
            children: [
                (0, $c0c9bc5c50648c54$exports.jsx)("h2", {
                    children: "Resend verification email"
                }),
                (0, $c0c9bc5c50648c54$exports.jsxs)("form", {
                    noValidate: true,
                    onSubmit: async (e)=>{
                        e.preventDefault();
                        setSubmitError(undefined);
                        const email = e.target.email.value;
                        const emailErrorMessage = (0, $771bf5af5dde3604$export$4c0c1934ef708d90)(email);
                        if (emailErrorMessage) return setEmailError(emailErrorMessage);
                        if (emailError) setEmailError("");
                        setIsSubmitting(true);
                        try {
                            await onSubmit({
                                email: email,
                                setSubmitError: setSubmitError
                            });
                        } finally{
                            setIsSubmitting(false);
                        }
                    },
                    children: [
                        (0, $c0c9bc5c50648c54$exports.jsx)((0, $78053ee2024d275e$export$2e2bcd8739ae039), {
                            autoComplete: "email",
                            autoFocus: true,
                            error: emailError,
                            label: "Email",
                            name: "email",
                            supportiveText: "Take care to type your address correctly",
                            type: "email"
                        }),
                        submitError && (0, $c0c9bc5c50648c54$exports.jsx)("p", {
                            className: "center",
                            children: (0, $c0c9bc5c50648c54$exports.jsx)("small", {
                                className: "negative",
                                children: submitError
                            })
                        }),
                        (0, $c0c9bc5c50648c54$exports.jsx)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039).Group, {
                            children: (0, $c0c9bc5c50648c54$exports.jsx)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039), {
                                disabled: isSubmitting,
                                children: "Resend"
                            })
                        }),
                        (0, $c0c9bc5c50648c54$exports.jsx)("p", {
                            className: "center",
                            children: (0, $c0c9bc5c50648c54$exports.jsxs)("small", {
                                children: [
                                    "Looking for the ",
                                    (0, $c0c9bc5c50648c54$exports.jsx)((0, $e94b7bcc277332d2$export$a6c7ac8248d6e38a), {
                                        to: "/sign-in",
                                        children: "sign in"
                                    }),
                                    " or",
                                    " ",
                                    (0, $c0c9bc5c50648c54$exports.jsx)((0, $e94b7bcc277332d2$export$a6c7ac8248d6e38a), {
                                        to: "/sign-up",
                                        children: "sign up"
                                    }),
                                    " pages?"
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
}




var $lBnVc = parcelRequire("lBnVc");



function $c94889ba4ac6e873$export$2e2bcd8739ae039({ onSubmit: onSubmit, ...rest }) {
    const navigate = (0, $f02d97b5ca509f34$export$9770f232ac06a008)();
    const [codeError, setCodeError] = $lBnVc.useState("");
    const [emailError, setEmailError] = $lBnVc.useState("");
    const [passwordError, setPasswordError] = $lBnVc.useState("");
    const [isSubmitting, setIsSubmitting] = $lBnVc.useState(false);
    const [submitError, setSubmitError] = $lBnVc.useState();
    const location = (0, $f02d97b5ca509f34$export$45d76561a5302f2b)();
    const defaultEmailAddress = new URLSearchParams(location.search).get("email");
    const hasDefaultEmailAddress = Boolean(defaultEmailAddress);
    return (0, $c0c9bc5c50648c54$exports.jsx)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039).Group, {
        ...rest,
        children: (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
            children: [
                (0, $c0c9bc5c50648c54$exports.jsx)("h2", {
                    children: "Reset password"
                }),
                (0, $c0c9bc5c50648c54$exports.jsxs)("p", {
                    children: [
                        "Check your email for your verification code (it may be in your junk folder). If you don't have an account you will need to",
                        " ",
                        (0, $c0c9bc5c50648c54$exports.jsx)((0, $e94b7bcc277332d2$export$a6c7ac8248d6e38a), {
                            to: "/sign-up",
                            children: "sign up"
                        }),
                        "."
                    ]
                }),
                (0, $c0c9bc5c50648c54$exports.jsxs)("form", {
                    noValidate: true,
                    onSubmit: async (e)=>{
                        e.preventDefault();
                        setSubmitError(undefined);
                        const code = e.target.code.value;
                        const email = e.target.email.value;
                        const password = e.target.password.value;
                        const codeErrorMessage = (0, $771bf5af5dde3604$export$9b27c06e6f0b4566)(code);
                        const emailErrorMessage = (0, $771bf5af5dde3604$export$4c0c1934ef708d90)(email);
                        const passwordErrorMessage = (0, $771bf5af5dde3604$export$d1c2c73868297cb7)(password);
                        if (codeErrorMessage || emailErrorMessage || passwordErrorMessage) {
                            setCodeError(codeErrorMessage || "");
                            setEmailError(emailErrorMessage || "");
                            setPasswordError(passwordErrorMessage || "");
                            return;
                        }
                        if (codeError) setCodeError("");
                        if (emailError) setEmailError("");
                        if (passwordError) setPasswordError("");
                        setIsSubmitting(true);
                        try {
                            await onSubmit({
                                code: code,
                                email: email,
                                password: password,
                                setSubmitError: setSubmitError
                            });
                            const searchParams = new URLSearchParams();
                            searchParams.set("password-reset", "true");
                            searchParams.set("email", email);
                            navigate(`/sign-in?${searchParams}`);
                        } finally{
                            setIsSubmitting(false);
                        }
                    },
                    children: [
                        (0, $c0c9bc5c50648c54$exports.jsx)((0, $78053ee2024d275e$export$2e2bcd8739ae039), {
                            autoComplete: "email",
                            autoFocus: !hasDefaultEmailAddress,
                            defaultValue: defaultEmailAddress || undefined,
                            error: emailError,
                            label: "Email",
                            name: "email",
                            supportiveText: "Take care to type your address correctly",
                            type: "email"
                        }),
                        (0, $c0c9bc5c50648c54$exports.jsx)((0, $78053ee2024d275e$export$2e2bcd8739ae039), {
                            autoFocus: hasDefaultEmailAddress,
                            error: codeError,
                            label: "Verification code",
                            name: "code",
                            type: "code"
                        }),
                        (0, $c0c9bc5c50648c54$exports.jsx)((0, $78053ee2024d275e$export$2e2bcd8739ae039), {
                            autoComplete: "new-password",
                            error: passwordError,
                            label: "Password",
                            name: "password",
                            type: "password"
                        }),
                        submitError && (0, $c0c9bc5c50648c54$exports.jsx)("p", {
                            className: "center",
                            children: (0, $c0c9bc5c50648c54$exports.jsx)("small", {
                                className: "negative",
                                children: submitError
                            })
                        }),
                        (0, $c0c9bc5c50648c54$exports.jsx)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039).Group, {
                            children: (0, $c0c9bc5c50648c54$exports.jsx)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039), {
                                disabled: isSubmitting,
                                children: "Reset password"
                            })
                        }),
                        (0, $c0c9bc5c50648c54$exports.jsx)("p", {
                            className: "center",
                            children: (0, $c0c9bc5c50648c54$exports.jsxs)("small", {
                                children: [
                                    "Haven't received a verification code?",
                                    " ",
                                    (0, $c0c9bc5c50648c54$exports.jsx)((0, $e94b7bcc277332d2$export$a6c7ac8248d6e38a), {
                                        to: "/forgot-password",
                                        children: "Try again"
                                    }),
                                    "."
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
}









function $9a780bd1b5aff71e$export$2e2bcd8739ae039({ error: error, label: label, optional: optional = false, supportiveText: supportiveText, ...rest }) {
    return (0, $c0c9bc5c50648c54$exports.jsxs)((0, $855c66307e03a080$export$2e2bcd8739ae039), {
        children: [
            (0, $c0c9bc5c50648c54$exports.jsxs)((0, $8e334c6b85b3e9c1$export$2e2bcd8739ae039), {
                children: [
                    (0, $c0c9bc5c50648c54$exports.jsx)((0, $71f0f49bdb6e1fc0$export$2e2bcd8739ae039), {
                        optional: optional,
                        children: label
                    }),
                    (0, $c0c9bc5c50648c54$exports.jsx)((0, $32b541195f056073$export$2e2bcd8739ae039), {
                        children: supportiveText
                    }),
                    (0, $c0c9bc5c50648c54$exports.jsxs)("span", {
                        className: "select__select-container",
                        children: [
                            (0, $c0c9bc5c50648c54$exports.jsx)("select", {
                                // When fields aren't in forms they should not be required
                                // and do not need to be marked explicitly as optional,
                                // hence the user can override this attribute
                                required: !optional,
                                ...rest,
                                "aria-invalid": Boolean(error),
                                className: "select__select"
                            }),
                            (0, $c0c9bc5c50648c54$exports.jsx)("span", {
                                className: "select__icon",
                                children: (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                                    name: "down",
                                    size: "2"
                                })
                            })
                        ]
                    })
                ]
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)((0, $94fd4126dbe697d0$export$2e2bcd8739ae039), {
                children: error
            })
        ]
    });
}




function $33447185ca1860ea$export$2e2bcd8739ae039({ text: text, title: title = document.title, url: url = location.origin, ...rest }) {
    return "share" in navigator ? (0, $c0c9bc5c50648c54$exports.jsx)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039).Group, {
        children: (0, $c0c9bc5c50648c54$exports.jsxs)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039), {
            ...rest,
            onClick: ()=>navigator.share({
                    text: text,
                    title: title,
                    url: url
                }).catch((e)=>{
                    if (e instanceof DOMException && e.name === "AbortError") return;
                    throw e;
                }),
            variant: "secondary",
            children: [
                (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                    name: "share",
                    margin: "end"
                }),
                "Share"
            ]
        })
    }) : null;
}




var $lBnVc = parcelRequire("lBnVc");



function $4089390d48037f48$export$2e2bcd8739ae039({ onSubmit: onSubmit, ...rest }) {
    const [emailError, setEmailError] = $lBnVc.useState("");
    const [passwordError, setPasswordError] = $lBnVc.useState("");
    const [isSubmitting, setIsSubmitting] = $lBnVc.useState(false);
    const [submitError, setSubmitError] = $lBnVc.useState();
    const location = (0, $f02d97b5ca509f34$export$45d76561a5302f2b)();
    const defaultEmailAddress = new URLSearchParams(location.search).get("email");
    const hasDefaultEmailAddress = Boolean(defaultEmailAddress);
    const passwordWasReset = new URLSearchParams(location.search).has("password-reset");
    return (0, $c0c9bc5c50648c54$exports.jsx)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039).Group, {
        ...rest,
        children: (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
            children: [
                (0, $c0c9bc5c50648c54$exports.jsx)("h2", {
                    children: "Sign in"
                }),
                passwordWasReset && (0, $c0c9bc5c50648c54$exports.jsx)("p", {
                    children: (0, $c0c9bc5c50648c54$exports.jsx)("small", {
                        className: "positive",
                        children: "Password successfully reset, sign in with your new password!"
                    })
                }),
                (0, $c0c9bc5c50648c54$exports.jsxs)("form", {
                    noValidate: true,
                    onSubmit: async (e)=>{
                        e.preventDefault();
                        setSubmitError(undefined);
                        const email = e.target.email.value;
                        const password = e.target.password.value;
                        const emailErrorMessage = (0, $771bf5af5dde3604$export$4c0c1934ef708d90)(email);
                        const passwordErrorMessage = (0, $771bf5af5dde3604$export$d1c2c73868297cb7)(password);
                        if (emailErrorMessage || passwordErrorMessage) {
                            setEmailError(emailErrorMessage || "");
                            setPasswordError(passwordErrorMessage || "");
                            return;
                        }
                        if (emailError) setEmailError("");
                        if (passwordError) setPasswordError("");
                        setIsSubmitting(true);
                        try {
                            await onSubmit({
                                email: email,
                                password: password,
                                setSubmitError: setSubmitError
                            });
                        } finally{
                            setIsSubmitting(false);
                        }
                    },
                    children: [
                        (0, $c0c9bc5c50648c54$exports.jsx)((0, $78053ee2024d275e$export$2e2bcd8739ae039), {
                            autoComplete: "email",
                            autoFocus: !hasDefaultEmailAddress,
                            defaultValue: defaultEmailAddress || undefined,
                            error: emailError,
                            label: "Email",
                            name: "email",
                            type: "email"
                        }),
                        (0, $c0c9bc5c50648c54$exports.jsx)((0, $78053ee2024d275e$export$2e2bcd8739ae039), {
                            autoComplete: "current-password",
                            autoFocus: hasDefaultEmailAddress,
                            error: passwordError,
                            label: "Password",
                            name: "password",
                            type: "password"
                        }),
                        submitError && (0, $c0c9bc5c50648c54$exports.jsx)("p", {
                            className: "center",
                            children: (0, $c0c9bc5c50648c54$exports.jsx)("small", {
                                className: "negative",
                                children: submitError
                            })
                        }),
                        (0, $c0c9bc5c50648c54$exports.jsx)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039).Group, {
                            children: (0, $c0c9bc5c50648c54$exports.jsx)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039), {
                                disabled: isSubmitting,
                                children: "Sign in"
                            })
                        }),
                        (0, $c0c9bc5c50648c54$exports.jsxs)("p", {
                            className: "center",
                            children: [
                                (0, $c0c9bc5c50648c54$exports.jsxs)("small", {
                                    children: [
                                        "Don't have an account? ",
                                        (0, $c0c9bc5c50648c54$exports.jsx)((0, $e94b7bcc277332d2$export$a6c7ac8248d6e38a), {
                                            to: "/sign-up",
                                            children: "Sign up"
                                        }),
                                        "!"
                                    ]
                                }),
                                (0, $c0c9bc5c50648c54$exports.jsx)("br", {}),
                                (0, $c0c9bc5c50648c54$exports.jsxs)("small", {
                                    children: [
                                        (0, $c0c9bc5c50648c54$exports.jsx)((0, $e94b7bcc277332d2$export$a6c7ac8248d6e38a), {
                                            to: "/forgot-password",
                                            children: "Forgotten your password"
                                        }),
                                        "?"
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}




var $lBnVc = parcelRequire("lBnVc");



function $200920bc5a0804a7$export$2e2bcd8739ae039({ onSubmit: onSubmit, ...rest }) {
    const [emailError, setEmailError] = $lBnVc.useState("");
    const [passwordError, setPasswordError] = $lBnVc.useState("");
    const [isSubmitting, setIsSubmitting] = $lBnVc.useState(false);
    const [submitError, setSubmitError] = $lBnVc.useState();
    return (0, $c0c9bc5c50648c54$exports.jsx)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039).Group, {
        ...rest,
        children: (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
            children: [
                (0, $c0c9bc5c50648c54$exports.jsx)("h2", {
                    children: "Sign up"
                }),
                (0, $c0c9bc5c50648c54$exports.jsxs)("form", {
                    noValidate: true,
                    onSubmit: async (e)=>{
                        e.preventDefault();
                        setSubmitError(undefined);
                        const email = e.target.email.value;
                        const password = e.target.password.value;
                        const emailErrorMessage = (0, $771bf5af5dde3604$export$4c0c1934ef708d90)(email);
                        const passwordErrorMessage = (0, $771bf5af5dde3604$export$d1c2c73868297cb7)(password);
                        if (emailErrorMessage || passwordErrorMessage) {
                            setEmailError(emailErrorMessage || "");
                            setPasswordError(passwordErrorMessage || "");
                            return;
                        }
                        if (emailError) setEmailError("");
                        if (passwordError) setPasswordError("");
                        setIsSubmitting(true);
                        try {
                            await onSubmit({
                                email: email,
                                password: password,
                                setSubmitError: setSubmitError
                            });
                        } finally{
                            setIsSubmitting(false);
                        }
                    },
                    children: [
                        (0, $c0c9bc5c50648c54$exports.jsx)((0, $78053ee2024d275e$export$2e2bcd8739ae039), {
                            autoComplete: "email",
                            autoFocus: true,
                            error: emailError,
                            label: "Email",
                            name: "email",
                            type: "email"
                        }),
                        (0, $c0c9bc5c50648c54$exports.jsx)((0, $78053ee2024d275e$export$2e2bcd8739ae039), {
                            autoComplete: "new-password",
                            error: passwordError,
                            label: "Password",
                            name: "password",
                            type: "password"
                        }),
                        submitError && (0, $c0c9bc5c50648c54$exports.jsx)("p", {
                            className: "center",
                            children: (0, $c0c9bc5c50648c54$exports.jsx)("small", {
                                className: "negative",
                                children: submitError
                            })
                        }),
                        (0, $c0c9bc5c50648c54$exports.jsx)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039).Group, {
                            children: (0, $c0c9bc5c50648c54$exports.jsx)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039), {
                                disabled: isSubmitting,
                                children: "Sign up"
                            })
                        }),
                        (0, $c0c9bc5c50648c54$exports.jsx)("p", {
                            className: "center",
                            children: (0, $c0c9bc5c50648c54$exports.jsxs)("small", {
                                children: [
                                    "Already have an account? ",
                                    (0, $c0c9bc5c50648c54$exports.jsx)((0, $e94b7bcc277332d2$export$a6c7ac8248d6e38a), {
                                        to: "/sign-in",
                                        children: "Sign in"
                                    }),
                                    "!"
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
}



function $b3bd040c14d4ce5c$export$2e2bcd8739ae039({ inline: inline, margin: margin, ...rest }) {
    const className = `spinner br-max${inline ? " spinner--inline" : ""}${margin === undefined ? "" : ` spinner--margin-${margin}`}`;
    return (0, $c0c9bc5c50648c54$exports.jsx)("span", {
        ...rest,
        className: className
    });
}



function $19d86a636b501d10$export$2e2bcd8739ae039(props) {
    return (0, $c0c9bc5c50648c54$exports.jsx)("span", {
        ...props,
        className: "sub-heading fs-0 fw-n italic"
    });
}








function $ac4ce26ce45bf909$export$2e2bcd8739ae039({ label: label, error: error, optional: optional = false, supportiveText: supportiveText, ...rest }) {
    return (0, $c0c9bc5c50648c54$exports.jsxs)((0, $855c66307e03a080$export$2e2bcd8739ae039), {
        children: [
            (0, $c0c9bc5c50648c54$exports.jsxs)((0, $8e334c6b85b3e9c1$export$2e2bcd8739ae039), {
                children: [
                    (0, $c0c9bc5c50648c54$exports.jsx)((0, $71f0f49bdb6e1fc0$export$2e2bcd8739ae039), {
                        optional: optional,
                        children: label
                    }),
                    (0, $c0c9bc5c50648c54$exports.jsx)((0, $32b541195f056073$export$2e2bcd8739ae039), {
                        children: supportiveText
                    }),
                    (0, $c0c9bc5c50648c54$exports.jsx)("textarea", {
                        // When fields aren't in forms they should not be required
                        // and do not need to be marked explicitly as optional,
                        // hence the user can override this attribute
                        required: !optional,
                        ...rest,
                        "aria-invalid": Boolean(error)
                    })
                ]
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)((0, $94fd4126dbe697d0$export$2e2bcd8739ae039), {
                children: error
            })
        ]
    });
}








function $78053ee2024d275e$export$2e2bcd8739ae039({ label: label, error: error, optional: optional = false, supportiveText: supportiveText, ...rest }) {
    return (0, $c0c9bc5c50648c54$exports.jsxs)((0, $855c66307e03a080$export$2e2bcd8739ae039), {
        children: [
            (0, $c0c9bc5c50648c54$exports.jsxs)((0, $8e334c6b85b3e9c1$export$2e2bcd8739ae039), {
                children: [
                    (0, $c0c9bc5c50648c54$exports.jsx)((0, $71f0f49bdb6e1fc0$export$2e2bcd8739ae039), {
                        optional: optional,
                        children: label
                    }),
                    (0, $c0c9bc5c50648c54$exports.jsx)((0, $32b541195f056073$export$2e2bcd8739ae039), {
                        children: supportiveText
                    }),
                    (0, $c0c9bc5c50648c54$exports.jsx)("input", {
                        // When fields aren't in forms they should not be required
                        // and do not need to be marked explicitly as optional,
                        // hence the user can override this attribute
                        required: !optional,
                        ...rest,
                        "aria-invalid": Boolean(error)
                    })
                ]
            }),
            (0, $c0c9bc5c50648c54$exports.jsx)((0, $94fd4126dbe697d0$export$2e2bcd8739ae039), {
                children: error
            })
        ]
    });
}





function $828cb8aa9adcb6a3$export$2e2bcd8739ae039({ error: error, disabled: disabled, label: label, ...rest }) {
    return (0, $c0c9bc5c50648c54$exports.jsx)((0, $855c66307e03a080$export$2e2bcd8739ae039), {
        className: "toggle",
        children: (0, $c0c9bc5c50648c54$exports.jsxs)("label", {
            className: `toggle__label${disabled ? " toggle__label--disabled" : ""}`,
            children: [
                (0, $c0c9bc5c50648c54$exports.jsx)("input", {
                    ...rest,
                    "aria-invalid": !!error,
                    className: "toggle__input br-max",
                    disabled: disabled,
                    type: "checkbox"
                }),
                (0, $c0c9bc5c50648c54$exports.jsx)("span", {
                    className: "toggle__appearance br-max bw-2"
                }),
                (0, $c0c9bc5c50648c54$exports.jsx)("span", {
                    className: "toggle__label-copy",
                    children: label
                }),
                (0, $c0c9bc5c50648c54$exports.jsx)((0, $94fd4126dbe697d0$export$2e2bcd8739ae039), {
                    indent: true,
                    children: error
                })
            ]
        })
    });
}





function $d61dd5ef7bbf6537$export$2e2bcd8739ae039({ appName: appName, ...rest }) {
    return (0, $c0c9bc5c50648c54$exports.jsx)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039).Group, {
        ...rest,
        children: (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
            children: [
                (0, $c0c9bc5c50648c54$exports.jsx)("h2", {
                    children: "Verification email sent!"
                }),
                (0, $c0c9bc5c50648c54$exports.jsx)("p", {
                    children: "Check your email and click the link to confirm your email address."
                }),
                (0, $c0c9bc5c50648c54$exports.jsxs)("p", {
                    children: [
                        "When you're finished come back to ",
                        appName,
                        " to",
                        " ",
                        (0, $c0c9bc5c50648c54$exports.jsx)((0, $e94b7bcc277332d2$export$a6c7ac8248d6e38a), {
                            to: "/sign-in",
                            children: "sign in"
                        }),
                        " and get started!"
                    ]
                }),
                (0, $c0c9bc5c50648c54$exports.jsx)("p", {
                    className: "center",
                    children: (0, $c0c9bc5c50648c54$exports.jsxs)("small", {
                        children: [
                            "Can't find our email? Check your junk folder or",
                            " ",
                            (0, $c0c9bc5c50648c54$exports.jsx)((0, $e94b7bcc277332d2$export$a6c7ac8248d6e38a), {
                                to: "/resend-verification",
                                children: "resend the verification email"
                            }),
                            "."
                        ]
                    })
                })
            ]
        })
    });
}




var $lBnVc = parcelRequire("lBnVc");


var $lBnVc = parcelRequire("lBnVc");
// If you change SVG_ASPECT_RATIO then update the value of --aspect-ratio in the CSS
const $e6093c7ac38c9e54$export$d9691ae514d24731 = 5 / 3;
const $e6093c7ac38c9e54$export$b1b9c9c1bf44cff1 = 501;
const $e6093c7ac38c9e54$export$eacc6a6ba638282d = $e6093c7ac38c9e54$export$b1b9c9c1bf44cff1 * $e6093c7ac38c9e54$export$d9691ae514d24731;


var $74e2a6762af788c4$exports = {};
var $028e12634772ccc0$exports = {};
"use strict";
$028e12634772ccc0$exports = function(workerUrl, origin, isESM) {
    if (origin === self.location.origin) // If the worker bundle's url is on the same origin as the document,
    // use the worker bundle's own url.
    return workerUrl;
    else {
        // Otherwise, create a blob URL which loads the worker bundle with `importScripts`.
        var source = isESM ? "import " + JSON.stringify(workerUrl) + ";" : "importScripts(" + JSON.stringify(workerUrl) + ");";
        return URL.createObjectURL(new Blob([
            source
        ], {
            type: "application/javascript"
        }));
    }
};


let $74e2a6762af788c4$var$url = new URL("wordCloudWorker.c2ca809e.js", import.meta.url);
$74e2a6762af788c4$exports = $028e12634772ccc0$exports($74e2a6762af788c4$var$url.toString(), $74e2a6762af788c4$var$url.origin, true);


function $a694d498275b262c$export$2e2bcd8739ae039({ words: words, ...rest }) {
    const [wordsToRender, setWordsToRender] = (0, $lBnVc.useState)([]);
    const workerRef = (0, $lBnVc.useRef)();
    (0, $lBnVc.useEffect)(()=>{
        const wordCloudWorker = new Worker($74e2a6762af788c4$exports);
        wordCloudWorker.onmessage = ({ data: data })=>setWordsToRender(data);
        workerRef.current = wordCloudWorker;
        return ()=>wordCloudWorker.terminate();
    }, []);
    (0, $lBnVc.useEffect)(()=>{
        if (!workerRef.current) {
            // eslint-disable-next-line no-console
            console.error("workerRef.current is not set in Eri WordCloud");
            return;
        }
        workerRef.current.postMessage(words);
    }, [
        words
    ]);
    var word;
    return (0, $c0c9bc5c50648c54$exports.jsx)("svg", {
        ...rest,
        viewBox: `0 0 ${(0, $e6093c7ac38c9e54$export$eacc6a6ba638282d)} ${(0, $e6093c7ac38c9e54$export$b1b9c9c1bf44cff1)}`,
        children: wordsToRender.map(({ rotate: rotate, size: size, text: text, weighting: weighting, x: x, y: y })=>(0, $c0c9bc5c50648c54$exports.jsx)("g", {
                className: "fade-in word-cloud__word-container",
                transform: `rotate(${rotate / Math.PI * 180} ${x} ${y})`,
                children: (0, $c0c9bc5c50648c54$exports.jsxs)("text", {
                    className: "word-cloud__word",
                    style: {
                        "--word-from-x": `${x - (0, $e6093c7ac38c9e54$export$eacc6a6ba638282d) / 2}px`,
                        "--word-from-y": `${y - (0, $e6093c7ac38c9e54$export$b1b9c9c1bf44cff1) / 2}px`
                    },
                    fontSize: size,
                    x: x,
                    y: y,
                    textAnchor: "middle",
                    children: [
                        (0, $c0c9bc5c50648c54$exports.jsx)("title", {
                            children: weighting
                        }),
                        text
                    ]
                })
            }, text))
    });
}




var $lBnVc = parcelRequire("lBnVc");

const $60a25dc46f13c533$var$XMLNS = "http://www.w3.org/2000/svg";
const $60a25dc46f13c533$var$MAX_RADIUS = Math.hypot((0, $e6093c7ac38c9e54$export$d9691ae514d24731) / 2, 0.5);
const $60a25dc46f13c533$var$MIN_FONT_SIZE = 0.025;
const $60a25dc46f13c533$var$FONT_SIZE_RANGE = 0.125;
// This figure is the ratio of word space usage to total svg viewbox.
// Manual tests indicate that this ratio places all words provided
// 50% of the time which makes it a nice balance between displaying
// as many words as possible and not having too much empty space.
const $60a25dc46f13c533$var$OPTIMAL_WORD_SPACE_USAGE = 0.76;
const $60a25dc46f13c533$var$getRange = (xs)=>{
    let min = Infinity;
    let max = -Infinity;
    for(let i = 0; i < xs.length; i++){
        const x = xs[i];
        if (x < min) min = x;
        if (x > max) max = x;
    }
    return [
        min,
        max
    ];
};
const $60a25dc46f13c533$var$checkIfRectanglesIntersect = (rectA, rectB)=>rectA.x + rectA.width / 2 >= rectB.x - rectB.width / 2 && rectA.x - rectA.width / 2 <= rectB.x + rectB.width / 2 && rectA.y + rectA.height / 2 >= rectB.y - rectB.height / 2 && rectA.y - rectA.height / 2 <= rectB.y + rectB.height / 2;
const $60a25dc46f13c533$var$checkIfRectangleNotContained = (rect)=>rect.x < rect.width / 2 || rect.x > (0, $e6093c7ac38c9e54$export$d9691ae514d24731) - rect.width / 2 || rect.y < rect.height / 2 || rect.y > 1 - rect.height / 2;
const $60a25dc46f13c533$var$archimedeanSpiral = (theta)=>{
    const r = 0.001 * theta;
    return [
        r * Math.cos(theta) * (0, $e6093c7ac38c9e54$export$d9691ae514d24731),
        r * Math.sin(theta)
    ];
};
function $60a25dc46f13c533$export$2e2bcd8739ae039({ words: words, ...rest }) {
    const svgRef = $lBnVc.useRef(null);
    const [renderData, setRenderData] = $lBnVc.useState([]);
    $lBnVc.useEffect(()=>{
        const svgEl = svgRef.current;
        const weightings = Object.values(words);
        if (!weightings.length || !svgEl) return;
        const [minWeighting, maxWeighting] = $60a25dc46f13c533$var$getRange(weightings);
        const weightingRange = maxWeighting - minWeighting;
        const unplacedWords = [];
        const sortedWordEntries = Object.entries(words).sort((a, b)=>{
            const weightingDifference = b[1] - a[1];
            if (weightingDifference) return weightingDifference;
            return b[0].length - a[0].length;
        });
        for(let i = 0; i < sortedWordEntries.length; i++){
            const [word, weighting] = sortedWordEntries[i];
            const textEl = document.createElementNS($60a25dc46f13c533$var$XMLNS, "text");
            const fontSize = weightingRange ? (weighting - minWeighting) / weightingRange * $60a25dc46f13c533$var$FONT_SIZE_RANGE + $60a25dc46f13c533$var$MIN_FONT_SIZE : $60a25dc46f13c533$var$MIN_FONT_SIZE;
            textEl.setAttributeNS(null, "font-size", String(fontSize));
            textEl.setAttributeNS(null, "x", "-1");
            textEl.setAttributeNS(null, "y", "-1");
            textEl.textContent = word;
            svgEl.appendChild(textEl);
            const { height: height, width: width } = textEl.getBBox();
            svgEl.removeChild(textEl);
            unplacedWords.push({
                fontSize: fontSize,
                height: height,
                weighting: weighting,
                width: width,
                word: word
            });
        }
        let totalArea = 0;
        for(let i = 0; i < unplacedWords.length; i++){
            const { height: height, width: width } = unplacedWords[i];
            totalArea += height * width;
        }
        const wordSpaceUsage = totalArea / (0, $e6093c7ac38c9e54$export$d9691ae514d24731);
        const adjustmentRatio = Math.sqrt($60a25dc46f13c533$var$OPTIMAL_WORD_SPACE_USAGE / wordSpaceUsage);
        for(let i = 0; i < unplacedWords.length; i++){
            const word = unplacedWords[i];
            word.fontSize *= adjustmentRatio;
            word.height *= adjustmentRatio;
            word.width *= adjustmentRatio;
        }
        const placedWords = [];
        for(let i = 0; i < unplacedWords.length; i++){
            let theta = 0;
            const word = unplacedWords[i];
            let shouldPlaceWord = true;
            do {
                const [x, y] = $60a25dc46f13c533$var$archimedeanSpiral(theta);
                if (Math.hypot(x, y) > $60a25dc46f13c533$var$MAX_RADIUS) shouldPlaceWord = false;
                word.x = (x + 0.5) * (0, $e6093c7ac38c9e54$export$d9691ae514d24731);
                word.y = y + 0.5;
                theta += 0.2;
            }while (shouldPlaceWord && ($60a25dc46f13c533$var$checkIfRectangleNotContained(word) || placedWords.some((placedWord)=>$60a25dc46f13c533$var$checkIfRectanglesIntersect(word, placedWord))));
            if (shouldPlaceWord) placedWords.push(word);
        }
        setRenderData(placedWords);
    }, [
        svgRef,
        words
    ]);
    return (0, $c0c9bc5c50648c54$exports.jsx)("svg", {
        ...rest,
        className: "word-cloud-secondary",
        ref: svgRef,
        viewBox: `0 0 ${(0, $e6093c7ac38c9e54$export$d9691ae514d24731)} 1`,
        width: "100%",
        children: (0, $c0c9bc5c50648c54$exports.jsx)("g", {
            style: {
                "--total-words": renderData.length
            },
            children: renderData.map(({ fontSize: fontSize, weighting: weighting, word: word, x: x, y: y })=>(0, $c0c9bc5c50648c54$exports.jsxs)("text", {
                    className: "fade-in word-cloud-secondary__word",
                    dy: fontSize * 0.3,
                    fontSize: fontSize,
                    style: {
                        "--word-x": x,
                        "--word-y": y
                    },
                    textAnchor: "middle",
                    x: x,
                    y: y,
                    children: [
                        (0, $c0c9bc5c50648c54$exports.jsx)("title", {
                            children: weighting
                        }),
                        word
                    ]
                }, word))
        })
    });
}


var $59fee832cccbdf29$export$2e2bcd8739ae039 = (0, $lBnVc.memo)(function WordCloud({ ...props }) {
    if (!Object.keys(props.words).length) return;
    // TODO delete WordCloudSecondary when/if Safari ever supports OffscreenCanvas
    return "OffscreenCanvas" in window ? (0, $c0c9bc5c50648c54$exports.jsx)((0, $a694d498275b262c$export$2e2bcd8739ae039), {
        ...props
    }) : (0, $c0c9bc5c50648c54$exports.jsx)((0, $60a25dc46f13c533$export$2e2bcd8739ae039), {
        ...props
    });
});



function $073bb8f40de3ad76$export$2e2bcd8739ae039() {
    for(let i = 0; i < 7; i++){
        document.documentElement.style.setProperty(`--mesh-${i}-x`, `${Math.random() * 100}%`);
        document.documentElement.style.setProperty(`--mesh-${i}-y`, `${Math.random() * 100}%`);
    }
}








function $57060c3aae7b0bb4$export$18c3c6510fb97afc(date) {
    return (0, $ee5e01283bb626d4$export$ead8a1812b171991)(date, Date.now());
}
var // Fallback for modularized imports:
$57060c3aae7b0bb4$export$2e2bcd8739ae039 = $57060c3aae7b0bb4$export$18c3c6510fb97afc;



function $a59d383691563bf5$export$fe114145ae75d197(dateLeft, dateRight) {
    const _dateLeft = (0, $48f2cd94c2808d74$export$e67a095c620b86fe)(dateLeft);
    const _dateRight = (0, $48f2cd94c2808d74$export$e67a095c620b86fe)(dateRight);
    const diff = _dateLeft.getTime() - _dateRight.getTime();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}
var // Fallback for modularized imports:
$a59d383691563bf5$export$2e2bcd8739ae039 = $a59d383691563bf5$export$fe114145ae75d197;


/**
 * @module constants
 * @summary Useful constants
 * @description
 * Collection of useful date constants.
 *
 * The constants could be imported from `date-fns/constants`:
 *
 * ```ts
 * import { maxTime, minTime } from "./constants/date-fns/constants";
 *
 * function isAllowedTime(time) {
 *   return time <= maxTime && time >= minTime;
 * }
 * ```
 */ /**
 * @constant
 * @name daysInWeek
 * @summary Days in 1 week.
 */ const $cb8083d8e93c1630$export$dfd9b671c89acc8e = 7;
const $cb8083d8e93c1630$export$3913210603d8e9ae = 365.2425;
const $cb8083d8e93c1630$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
const $cb8083d8e93c1630$export$4dec998e48f9c246 = -$cb8083d8e93c1630$export$81caae6e1cc7a622;
const $cb8083d8e93c1630$export$4fad13613e88edc8 = 604800000;
const $cb8083d8e93c1630$export$b76b1809a2898f9a = 86400000;
const $cb8083d8e93c1630$export$91246f0b9bd9beff = 60000;
const $cb8083d8e93c1630$export$7f72910d6dfd237a = 3600000;
const $cb8083d8e93c1630$export$397c2d5776aa9055 = 1000;
const $cb8083d8e93c1630$export$3633035e63cee86a = 525600;
const $cb8083d8e93c1630$export$ab7da2ccd1075c38 = 43200;
const $cb8083d8e93c1630$export$2423174df8cd3cd2 = 1440;
const $cb8083d8e93c1630$export$f2f5ae5a8e2d8f9f = 60;
const $cb8083d8e93c1630$export$3c58128db900d44e = 3;
const $cb8083d8e93c1630$export$80d7e435f744f319 = 12;
const $cb8083d8e93c1630$export$4db7641526e3241f = 4;
const $cb8083d8e93c1630$export$698aec755e92c695 = 3600;
const $cb8083d8e93c1630$export$a77c1a7ebebe2a5a = 60;
const $cb8083d8e93c1630$export$815a9362476d2fe3 = $cb8083d8e93c1630$export$698aec755e92c695 * 24;
const $cb8083d8e93c1630$export$34804a017b31e2fe = $cb8083d8e93c1630$export$815a9362476d2fe3 * 7;
const $cb8083d8e93c1630$export$7271e9e3478110d1 = $cb8083d8e93c1630$export$815a9362476d2fe3 * $cb8083d8e93c1630$export$3913210603d8e9ae;
const $cb8083d8e93c1630$export$8e6600bbdee7dabb = $cb8083d8e93c1630$export$7271e9e3478110d1 / 12;
const $cb8083d8e93c1630$export$be1dccf2de902d31 = $cb8083d8e93c1630$export$8e6600bbdee7dabb * 3;




function $fbf0ced9948dd52a$export$489984ac7c996389(dateLeft, dateRight) {
    const _dateLeft = (0, $48f2cd94c2808d74$export$e67a095c620b86fe)(dateLeft);
    const _dateRight = (0, $48f2cd94c2808d74$export$e67a095c620b86fe)(dateRight);
    const yearDiff = _dateLeft.getFullYear() - _dateRight.getFullYear();
    const monthDiff = _dateLeft.getMonth() - _dateRight.getMonth();
    return yearDiff * 12 + monthDiff;
}
var // Fallback for modularized imports:
$fbf0ced9948dd52a$export$2e2bcd8739ae039 = $fbf0ced9948dd52a$export$489984ac7c996389;



function $1262ab450cea8c0e$export$eb9a03f0e9aa6cea(date) {
    const _date = (0, $48f2cd94c2808d74$export$e67a095c620b86fe)(date);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
var // Fallback for modularized imports:
$1262ab450cea8c0e$export$2e2bcd8739ae039 = $1262ab450cea8c0e$export$eb9a03f0e9aa6cea;



function $bf7aeaa107b361ad$export$a2258d9c4118825c(date) {
    const _date = (0, $48f2cd94c2808d74$export$e67a095c620b86fe)(date);
    const month = _date.getMonth();
    _date.setFullYear(_date.getFullYear(), month + 1, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
var // Fallback for modularized imports:
$bf7aeaa107b361ad$export$2e2bcd8739ae039 = $bf7aeaa107b361ad$export$a2258d9c4118825c;



function $9a9ca0ea2b680c01$export$c817d0312007ea5e(date) {
    const _date = (0, $48f2cd94c2808d74$export$e67a095c620b86fe)(date);
    return +(0, $1262ab450cea8c0e$export$eb9a03f0e9aa6cea)(_date) === +(0, $bf7aeaa107b361ad$export$a2258d9c4118825c)(_date);
}
var // Fallback for modularized imports:
$9a9ca0ea2b680c01$export$2e2bcd8739ae039 = $9a9ca0ea2b680c01$export$c817d0312007ea5e;



function $44851fffdb5f797e$export$fc1ed482c2861792(dateLeft, dateRight) {
    const _dateLeft = (0, $48f2cd94c2808d74$export$e67a095c620b86fe)(dateLeft);
    const _dateRight = (0, $48f2cd94c2808d74$export$e67a095c620b86fe)(dateRight);
    const sign = (0, $a59d383691563bf5$export$fe114145ae75d197)(_dateLeft, _dateRight);
    const difference = Math.abs((0, $fbf0ced9948dd52a$export$489984ac7c996389)(_dateLeft, _dateRight));
    let result;
    // Check for the difference of less than month
    if (difference < 1) result = 0;
    else {
        if (_dateLeft.getMonth() === 1 && _dateLeft.getDate() > 27) // This will check if the date is end of Feb and assign a higher end of month date
        // to compare it with Jan
        _dateLeft.setDate(30);
        _dateLeft.setMonth(_dateLeft.getMonth() - sign * difference);
        // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
        // If so, result must be decreased by 1 in absolute value
        let isLastMonthNotFull = (0, $a59d383691563bf5$export$fe114145ae75d197)(_dateLeft, _dateRight) === -sign;
        // Check for cases of one full calendar month
        if ((0, $9a9ca0ea2b680c01$export$c817d0312007ea5e)((0, $48f2cd94c2808d74$export$e67a095c620b86fe)(dateLeft)) && difference === 1 && (0, $a59d383691563bf5$export$fe114145ae75d197)(dateLeft, _dateRight) === 1) isLastMonthNotFull = false;
        result = sign * (difference - Number(isLastMonthNotFull));
    }
    // Prevent negative zero
    return result === 0 ? 0 : result;
}
var // Fallback for modularized imports:
$44851fffdb5f797e$export$2e2bcd8739ae039 = $44851fffdb5f797e$export$fc1ed482c2861792;


function $dcf542c2756265c7$export$b6474a47258c1211(method) {
    return (number)=>{
        const round = method ? Math[method] : Math.trunc;
        const result = round(number);
        // Prevent negative zero
        return result === 0 ? 0 : result;
    };
}



function $14c320f9cc9f7d86$export$7be94d13716b4bf6(dateLeft, dateRight) {
    return +(0, $48f2cd94c2808d74$export$e67a095c620b86fe)(dateLeft) - +(0, $48f2cd94c2808d74$export$e67a095c620b86fe)(dateRight);
}
var // Fallback for modularized imports:
$14c320f9cc9f7d86$export$2e2bcd8739ae039 = $14c320f9cc9f7d86$export$7be94d13716b4bf6;


function $24a4af32485acd32$export$c1889aec51783710(dateLeft, dateRight, options) {
    const diff = (0, $14c320f9cc9f7d86$export$7be94d13716b4bf6)(dateLeft, dateRight) / 1000;
    return (0, $dcf542c2756265c7$export$b6474a47258c1211)(options?.roundingMethod)(diff);
}
var // Fallback for modularized imports:
$24a4af32485acd32$export$2e2bcd8739ae039 = $24a4af32485acd32$export$c1889aec51783710;



const $cdd99311f809f178$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
const $cdd99311f809f178$export$2c14ff85d6318973 = (token, count, options)=>{
    let result;
    const tokenValue = $cdd99311f809f178$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};


function $3e2f6dc135365783$export$38e44e97ce4dbb7d(args) {
    return (options = {})=>{
        // TODO: Remove String()
        const width = options.width ? String(options.width) : args.defaultWidth;
        const format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}


const $7ffddac97f71b302$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
const $7ffddac97f71b302$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $7ffddac97f71b302$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $7ffddac97f71b302$export$cbf60ecb96cbb82f = {
    date: (0, $3e2f6dc135365783$export$38e44e97ce4dbb7d)({
        formats: $7ffddac97f71b302$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $3e2f6dc135365783$export$38e44e97ce4dbb7d)({
        formats: $7ffddac97f71b302$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $3e2f6dc135365783$export$38e44e97ce4dbb7d)({
        formats: $7ffddac97f71b302$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


const $21e34713fe136b87$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
const $21e34713fe136b87$export$8fbbfd65594f46a0 = (token, _date, _baseDate, _options)=>$21e34713fe136b87$var$formatRelativeLocale[token];


/* eslint-disable no-unused-vars */ /**
 * The localize function argument callback which allows to convert raw value to
 * the actual type.
 *
 * @param value - The value to convert
 *
 * @returns The converted value
 */ /**
 * The map of localized values for each width.
 */ /**
 * The index type of the locale unit value. It types conversion of units of
 * values that don't start at 0 (i.e. quarters).
 */ /**
 * Converts the unit value to the tuple of values.
 */ /**
 * The tuple of localized era values. The first element represents BC,
 * the second element represents AD.
 */ /**
 * The tuple of localized quarter values. The first element represents Q1.
 */ /**
 * The tuple of localized day values. The first element represents Sunday.
 */ /**
 * The tuple of localized month values. The first element represents January.
 */ function $e0bce715021d2b8d$export$63596d6ee8878b25(args) {
    return (value, options)=>{
        const context = options?.context ? String(options.context) : "standalone";
        let valuesArray;
        if (context === "formatting" && args.formattingValues) {
            const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            const width = options?.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            const defaultWidth = args.defaultWidth;
            const width = options?.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[width] || args.values[defaultWidth];
        }
        const index = args.argumentCallback ? args.argumentCallback(value) : value;
        // @ts-expect-error - For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}


const $b30d0430a7507f60$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
const $b30d0430a7507f60$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $b30d0430a7507f60$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
const $b30d0430a7507f60$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
const $b30d0430a7507f60$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
const $b30d0430a7507f60$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
const $b30d0430a7507f60$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    const rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
const $b30d0430a7507f60$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $b30d0430a7507f60$var$ordinalNumber,
    era: (0, $e0bce715021d2b8d$export$63596d6ee8878b25)({
        values: $b30d0430a7507f60$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $e0bce715021d2b8d$export$63596d6ee8878b25)({
        values: $b30d0430a7507f60$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $e0bce715021d2b8d$export$63596d6ee8878b25)({
        values: $b30d0430a7507f60$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $e0bce715021d2b8d$export$63596d6ee8878b25)({
        values: $b30d0430a7507f60$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $e0bce715021d2b8d$export$63596d6ee8878b25)({
        values: $b30d0430a7507f60$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $b30d0430a7507f60$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


function $53f3b0a1595262c2$export$1430a0f35710914d(args) {
    return (string, options = {})=>{
        const width = options.width;
        const matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        const matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        const key = Array.isArray(parsePatterns) ? $53f3b0a1595262c2$var$findIndex(parsePatterns, (pattern)=>pattern.test(matchedString)) : $53f3b0a1595262c2$var$findKey(parsePatterns, (pattern)=>pattern.test(matchedString));
        let value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $53f3b0a1595262c2$var$findKey(object, predicate) {
    for(const key in object){
        if (Object.prototype.hasOwnProperty.call(object, key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $53f3b0a1595262c2$var$findIndex(array, predicate) {
    for(let key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}


function $a8b3eb927850d100$export$fdaf2fd6d7edde95(args) {
    return (string, options = {})=>{
        const matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        let value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}


const $9ed77e5ba2857a52$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const $9ed77e5ba2857a52$var$parseOrdinalNumberPattern = /\d+/i;
const $9ed77e5ba2857a52$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
const $9ed77e5ba2857a52$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
const $9ed77e5ba2857a52$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
const $9ed77e5ba2857a52$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $9ed77e5ba2857a52$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
const $9ed77e5ba2857a52$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $9ed77e5ba2857a52$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
const $9ed77e5ba2857a52$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
const $9ed77e5ba2857a52$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
const $9ed77e5ba2857a52$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
const $9ed77e5ba2857a52$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $a8b3eb927850d100$export$fdaf2fd6d7edde95)({
        matchPattern: $9ed77e5ba2857a52$var$matchOrdinalNumberPattern,
        parsePattern: $9ed77e5ba2857a52$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $53f3b0a1595262c2$export$1430a0f35710914d)({
        matchPatterns: $9ed77e5ba2857a52$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $9ed77e5ba2857a52$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $53f3b0a1595262c2$export$1430a0f35710914d)({
        matchPatterns: $9ed77e5ba2857a52$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $9ed77e5ba2857a52$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $53f3b0a1595262c2$export$1430a0f35710914d)({
        matchPatterns: $9ed77e5ba2857a52$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $9ed77e5ba2857a52$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $53f3b0a1595262c2$export$1430a0f35710914d)({
        matchPatterns: $9ed77e5ba2857a52$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $9ed77e5ba2857a52$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $53f3b0a1595262c2$export$1430a0f35710914d)({
        matchPatterns: $9ed77e5ba2857a52$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $9ed77e5ba2857a52$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


const $276eeccbfbee2738$export$137380d9ce54f7f = {
    code: "en-US",
    formatDistance: (0, $cdd99311f809f178$export$2c14ff85d6318973),
    formatLong: (0, $7ffddac97f71b302$export$cbf60ecb96cbb82f),
    formatRelative: (0, $21e34713fe136b87$export$8fbbfd65594f46a0),
    localize: (0, $b30d0430a7507f60$export$b3bd0bc58e36cd63),
    match: (0, $9ed77e5ba2857a52$export$4659b591c19bdf3d),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var // Fallback for modularized imports:
$276eeccbfbee2738$export$2e2bcd8739ae039 = $276eeccbfbee2738$export$137380d9ce54f7f;




function $d2dedf999d199de7$export$113002b5eff6e430(date) {
    const _date = (0, $48f2cd94c2808d74$export$e67a095c620b86fe)(date);
    const utcDate = new Date(Date.UTC(_date.getFullYear(), _date.getMonth(), _date.getDate(), _date.getHours(), _date.getMinutes(), _date.getSeconds(), _date.getMilliseconds()));
    utcDate.setUTCFullYear(_date.getFullYear());
    return +date - +utcDate;
}


function $cbe7a7ad95e35df7$export$2c14ff85d6318973(date, baseDate, options) {
    const defaultOptions = (0, $6fc64aba02a3bdcd$export$430a3269e24b912e)();
    const locale = options?.locale ?? defaultOptions.locale ?? (0, $276eeccbfbee2738$export$137380d9ce54f7f);
    const minutesInAlmostTwoDays = 2520;
    const comparison = (0, $a59d383691563bf5$export$fe114145ae75d197)(date, baseDate);
    if (isNaN(comparison)) throw new RangeError("Invalid time value");
    const localizeOptions = Object.assign({}, options, {
        addSuffix: options?.addSuffix,
        comparison: comparison
    });
    let dateLeft;
    let dateRight;
    if (comparison > 0) {
        dateLeft = (0, $48f2cd94c2808d74$export$e67a095c620b86fe)(baseDate);
        dateRight = (0, $48f2cd94c2808d74$export$e67a095c620b86fe)(date);
    } else {
        dateLeft = (0, $48f2cd94c2808d74$export$e67a095c620b86fe)(date);
        dateRight = (0, $48f2cd94c2808d74$export$e67a095c620b86fe)(baseDate);
    }
    const seconds = (0, $24a4af32485acd32$export$c1889aec51783710)(dateRight, dateLeft);
    const offsetInSeconds = ((0, $d2dedf999d199de7$export$113002b5eff6e430)(dateRight) - (0, $d2dedf999d199de7$export$113002b5eff6e430)(dateLeft)) / 1000;
    const minutes = Math.round((seconds - offsetInSeconds) / 60);
    let months;
    // 0 up to 2 mins
    if (minutes < 2) {
        if (options?.includeSeconds) {
            if (seconds < 5) return locale.formatDistance("lessThanXSeconds", 5, localizeOptions);
            else if (seconds < 10) return locale.formatDistance("lessThanXSeconds", 10, localizeOptions);
            else if (seconds < 20) return locale.formatDistance("lessThanXSeconds", 20, localizeOptions);
            else if (seconds < 40) return locale.formatDistance("halfAMinute", 0, localizeOptions);
            else if (seconds < 60) return locale.formatDistance("lessThanXMinutes", 1, localizeOptions);
            else return locale.formatDistance("xMinutes", 1, localizeOptions);
        } else {
            if (minutes === 0) return locale.formatDistance("lessThanXMinutes", 1, localizeOptions);
            else return locale.formatDistance("xMinutes", minutes, localizeOptions);
        }
    } else if (minutes < 45) return locale.formatDistance("xMinutes", minutes, localizeOptions);
    else if (minutes < 90) return locale.formatDistance("aboutXHours", 1, localizeOptions);
    else if (minutes < (0, $cb8083d8e93c1630$export$2423174df8cd3cd2)) {
        const hours = Math.round(minutes / 60);
        return locale.formatDistance("aboutXHours", hours, localizeOptions);
    // 1 day up to 1.75 days
    } else if (minutes < minutesInAlmostTwoDays) return locale.formatDistance("xDays", 1, localizeOptions);
    else if (minutes < (0, $cb8083d8e93c1630$export$ab7da2ccd1075c38)) {
        const days = Math.round(minutes / (0, $cb8083d8e93c1630$export$2423174df8cd3cd2));
        return locale.formatDistance("xDays", days, localizeOptions);
    // 1 month up to 2 months
    } else if (minutes < (0, $cb8083d8e93c1630$export$ab7da2ccd1075c38) * 2) {
        months = Math.round(minutes / (0, $cb8083d8e93c1630$export$ab7da2ccd1075c38));
        return locale.formatDistance("aboutXMonths", months, localizeOptions);
    }
    months = (0, $44851fffdb5f797e$export$fc1ed482c2861792)(dateRight, dateLeft);
    // 2 months up to 12 months
    if (months < 12) {
        const nearestMonth = Math.round(minutes / (0, $cb8083d8e93c1630$export$ab7da2ccd1075c38));
        return locale.formatDistance("xMonths", nearestMonth, localizeOptions);
    // 1 year up to max Date
    } else {
        const monthsSinceStartOfYear = months % 12;
        const years = Math.trunc(months / 12);
        // N years up to 1 years 3 months
        if (monthsSinceStartOfYear < 3) return locale.formatDistance("aboutXYears", years, localizeOptions);
        else if (monthsSinceStartOfYear < 9) return locale.formatDistance("overXYears", years, localizeOptions);
        else return locale.formatDistance("almostXYears", years + 1, localizeOptions);
    }
}
var // Fallback for modularized imports:
$cbe7a7ad95e35df7$export$2e2bcd8739ae039 = $cbe7a7ad95e35df7$export$2c14ff85d6318973;


function $82fe5d0003ae257e$export$d130c20a256f8817(date, options) {
    return (0, $cbe7a7ad95e35df7$export$2c14ff85d6318973)(date, (0, $57060c3aae7b0bb4$export$18c3c6510fb97afc)(date), options);
}
var // Fallback for modularized imports:
$82fe5d0003ae257e$export$2e2bcd8739ae039 = $82fe5d0003ae257e$export$d130c20a256f8817;


function $9025684549319f54$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("p", {
        children: [
            "The version you're currently using was last updated",
            " ",
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("b", {
                children: [
                    (0, $82fe5d0003ae257e$export$d130c20a256f8817)(new Date((0, $5a123094476b33d7$export$a716cf793ad7f839))),
                    " ago"
                ]
            }),
            "."
        ]
    });
}


function $f5b733924af00917$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039).Group, {
        children: [
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h2", {
                        children: "About"
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("p", {
                        children: (0, $5a123094476b33d7$export$b8187a7ff42a2a5e)
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h3", {
                        children: "Open source"
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("p", {
                        children: [
                            "You can find the source code",
                            " ",
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("a", {
                                href: (0, $5a123094476b33d7$export$3508dfda2bc7d28),
                                rel: "noopener",
                                target: "_blank",
                                children: "here"
                            }),
                            " ",
                            "and if you have any ideas \uD83D\uDCA1, feedback \uD83D\uDDE3\uFE0F or bugs \uD83D\uDC1B you can raise them",
                            " ",
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("a", {
                                href: (0, $5a123094476b33d7$export$2cdbc1b6a383b7bf),
                                rel: "noopener",
                                target: "_blank",
                                children: "here"
                            }),
                            "."
                        ]
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("p", {
                        children: [
                            "The UI was put together using an open source component library I built called",
                            " ",
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("a", {
                                href: `${(0, $5a123094476b33d7$export$b53a3867abacf7cf)}/eri`,
                                rel: "noopener",
                                target: "_blank",
                                children: "Eri"
                            }),
                            "."
                        ]
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h3", {
                        children: "Updates"
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $9025684549319f54$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("p", {
                        children: [
                            "Check out ",
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e94b7bcc277332d2$export$a6c7ac8248d6e38a), {
                                to: "/blog",
                                children: "our blog"
                            }),
                            " for major feature announcements."
                        ]
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("p", {
                        children: [
                            "Check out the",
                            " ",
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("a", {
                                href: `${(0, $5a123094476b33d7$export$3508dfda2bc7d28)}/commits/master`,
                                rel: "noopener",
                                target: "_blank",
                                children: "commit log"
                            }),
                            " ",
                            "for an overview of all source code changes."
                        ]
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $33447185ca1860ea$export$2e2bcd8739ae039), {})
                ]
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h2", {
                        children: "Business model"
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("p", {
                        children: "I started building MoodTracker in April 2020 because I couldn't find anything that worked in the way I wanted and because I enjoy making things."
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("p", {
                        children: "The app is currently free because there are very few active users, which means that it costs me very little to run. If this app gets very popular and starts costing a lot of money then I may explore revenue models, but that doesn't seem like it will happen any time soon, so for now I'm very happy to share this experience for free."
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("p", {
                        children: "I hope that those of you who are using it are enjoying it and finding it useful! \uD83D\uDE42"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h2", {
                        children: "Acknowledgements"
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("ul", {
                        children: [
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("li", {
                                children: [
                                    "Open source icons from",
                                    " ",
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("a", {
                                        href: "https://feathericons.com",
                                        rel: "noopener",
                                        target: "_blank",
                                        children: "Feather"
                                    }),
                                    " ",
                                    "(MIT),",
                                    " ",
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("a", {
                                        href: "https://tabler-icons.io",
                                        rel: "noopener",
                                        target: "_blank",
                                        children: "tabler icons"
                                    }),
                                    " ",
                                    "(MIT) &",
                                    " ",
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("a", {
                                        href: "https://iconoir.com",
                                        rel: "noopener",
                                        target: "_blank",
                                        children: "iconoir"
                                    }),
                                    " ",
                                    "(MIT)"
                                ]
                            }),
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("li", {
                                children: [
                                    "Open source meditation bell from",
                                    " ",
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("a", {
                                        href: "https://freesound.org/people/fauxpress/sounds/42095",
                                        rel: "noopener",
                                        target: "_blank",
                                        children: "Freesound"
                                    }),
                                    " ",
                                    "(CC0 1.0)"
                                ]
                            }),
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("li", {
                                children: [
                                    "A lot of open source software projects (",
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("a", {
                                        href: (0, $5a123094476b33d7$export$3508dfda2bc7d28),
                                        rel: "noopener",
                                        target: "_blank",
                                        children: "see GitHub for details"
                                    }),
                                    ")"
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}







var $lBnVc = parcelRequire("lBnVc");




/* eslint-disable @typescript-eslint/no-explicit-any */ 
const $6ac94e7c3d018e58$export$d1ff6fea16bc8fb7 = 600;
const $6ac94e7c3d018e58$export$4e69567e01df0578 = 147;
const $6ac94e7c3d018e58$export$80bdfe9d0febd31c = 800;




function $32a1340ec0955a5e$export$2e2bcd8739ae039() {}


function $9b7198d8a3746240$export$2e2bcd8739ae039() {
    var lines = [], line;
    return {
        point: function(x, y, m) {
            line.push([
                x,
                y,
                m
            ]);
        },
        lineStart: function() {
            lines.push(line = []);
        },
        lineEnd: (0, $32a1340ec0955a5e$export$2e2bcd8739ae039),
        rejoin: function() {
            if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
        },
        result: function() {
            var result = lines;
            lines = [];
            line = null;
            return result;
        }
    };
}


var $8dcaf2b51049bed8$export$6c421550c66a327d = 1e-6;
var $8dcaf2b51049bed8$export$92c06fba281fe81b = 1e-12;
var $8dcaf2b51049bed8$export$18c7bea995a110f = Math.PI;
var $8dcaf2b51049bed8$export$e51408a300e8929a = $8dcaf2b51049bed8$export$18c7bea995a110f / 2;
var $8dcaf2b51049bed8$export$c39a5cba78ea0fc2 = $8dcaf2b51049bed8$export$18c7bea995a110f / 4;
var $8dcaf2b51049bed8$export$a4b4b4d4d776fe92 = $8dcaf2b51049bed8$export$18c7bea995a110f * 2;
var $8dcaf2b51049bed8$export$41fc368e1a942b97 = 180 / $8dcaf2b51049bed8$export$18c7bea995a110f;
var $8dcaf2b51049bed8$export$8449e153fbd325fc = $8dcaf2b51049bed8$export$18c7bea995a110f / 180;
var $8dcaf2b51049bed8$export$2335f513bbd82c6d = Math.abs;
var $8dcaf2b51049bed8$export$628dc4eed22b0fbd = Math.atan;
var $8dcaf2b51049bed8$export$b8b770ee6a0d9760 = Math.atan2;
var $8dcaf2b51049bed8$export$50d414a77b60d802 = Math.cos;
var $8dcaf2b51049bed8$export$803ce6b71a0a94b2 = Math.ceil;
var $8dcaf2b51049bed8$export$b310ec824aaee37f = Math.exp;
var $8dcaf2b51049bed8$export$a3fe094919f356fd = Math.floor;
var $8dcaf2b51049bed8$export$f95c7888b62f8e9a = Math.hypot;
var $8dcaf2b51049bed8$export$bef1f36f5486a6a3 = Math.log;
var $8dcaf2b51049bed8$export$9c297f60e22e3389 = Math.pow;
var $8dcaf2b51049bed8$export$5de3937cb4b592ed = Math.sin;
var $8dcaf2b51049bed8$export$c5552dfdbc7cec71 = Math.sign || function(x) {
    return x > 0 ? 1 : x < 0 ? -1 : 0;
};
var $8dcaf2b51049bed8$export$eba8049fb5020b81 = Math.sqrt;
var $8dcaf2b51049bed8$export$fcdd3b0b3246a325 = Math.tan;
function $8dcaf2b51049bed8$export$fd6306be3fde5b04(x) {
    return x > 1 ? 0 : x < -1 ? $8dcaf2b51049bed8$export$18c7bea995a110f : Math.acos(x);
}
function $8dcaf2b51049bed8$export$41726bdb1fc63f(x) {
    return x > 1 ? $8dcaf2b51049bed8$export$e51408a300e8929a : x < -1 ? -$8dcaf2b51049bed8$export$e51408a300e8929a : Math.asin(x);
}
function $8dcaf2b51049bed8$export$e808712c2966e662(x) {
    return (x = $8dcaf2b51049bed8$export$5de3937cb4b592ed(x / 2)) * x;
}


function $677c5b35fee6fa32$export$2e2bcd8739ae039(a, b) {
    return (0, $8dcaf2b51049bed8$export$2335f513bbd82c6d)(a[0] - b[0]) < (0, $8dcaf2b51049bed8$export$6c421550c66a327d) && (0, $8dcaf2b51049bed8$export$2335f513bbd82c6d)(a[1] - b[1]) < (0, $8dcaf2b51049bed8$export$6c421550c66a327d);
}



function $8385263718999824$var$Intersection(point, points, other, entry) {
    this.x = point;
    this.z = points;
    this.o = other; // another intersection
    this.e = entry; // is an entry?
    this.v = false; // visited
    this.n = this.p = null; // next & previous
}
function $8385263718999824$export$2e2bcd8739ae039(segments, compareIntersection, startInside, interpolate, stream) {
    var subject = [], clip = [], i, n;
    segments.forEach(function(segment) {
        if ((n = segment.length - 1) <= 0) return;
        var n, p0 = segment[0], p1 = segment[n], x;
        if ((0, $677c5b35fee6fa32$export$2e2bcd8739ae039)(p0, p1)) {
            if (!p0[2] && !p1[2]) {
                stream.lineStart();
                for(i = 0; i < n; ++i)stream.point((p0 = segment[i])[0], p0[1]);
                stream.lineEnd();
                return;
            }
            // handle degenerate cases by moving the point
            p1[0] += 2 * (0, $8dcaf2b51049bed8$export$6c421550c66a327d);
        }
        subject.push(x = new $8385263718999824$var$Intersection(p0, segment, null, true));
        clip.push(x.o = new $8385263718999824$var$Intersection(p0, null, x, false));
        subject.push(x = new $8385263718999824$var$Intersection(p1, segment, null, false));
        clip.push(x.o = new $8385263718999824$var$Intersection(p1, null, x, true));
    });
    if (!subject.length) return;
    clip.sort(compareIntersection);
    $8385263718999824$var$link(subject);
    $8385263718999824$var$link(clip);
    for(i = 0, n = clip.length; i < n; ++i)clip[i].e = startInside = !startInside;
    var start = subject[0], points, point;
    while(true){
        // Find first unvisited intersection.
        var current = start, isSubject = true;
        while(current.v)if ((current = current.n) === start) return;
        points = current.z;
        stream.lineStart();
        do {
            current.v = current.o.v = true;
            if (current.e) {
                if (isSubject) for(i = 0, n = points.length; i < n; ++i)stream.point((point = points[i])[0], point[1]);
                else interpolate(current.x, current.n.x, 1, stream);
                current = current.n;
            } else {
                if (isSubject) {
                    points = current.p.z;
                    for(i = points.length - 1; i >= 0; --i)stream.point((point = points[i])[0], point[1]);
                } else interpolate(current.x, current.p.x, -1, stream);
                current = current.p;
            }
            current = current.o;
            points = current.z;
            isSubject = !isSubject;
        }while (!current.v);
        stream.lineEnd();
    }
}
function $8385263718999824$var$link(array) {
    if (!(n = array.length)) return;
    var n, i = 0, a = array[0], b;
    while(++i < n){
        a.n = b = array[i];
        b.p = a;
        a = b;
    }
    a.n = b = array[0];
    b.p = a;
}



// https://github.com/python/cpython/blob/a74eea238f5baba15797e2e8b570d153bc8690a7/Modules/mathmodule.c#L1423
class $86babe4bf44a2b65$export$bda7ba77fb86c375 {
    constructor(){
        this._partials = new Float64Array(32);
        this._n = 0;
    }
    add(x) {
        const p = this._partials;
        let i = 0;
        for(let j = 0; j < this._n && j < 32; j++){
            const y = p[j], hi = x + y, lo = Math.abs(x) < Math.abs(y) ? x - (hi - y) : y - (hi - x);
            if (lo) p[i++] = lo;
            x = hi;
        }
        p[i] = x;
        this._n = i + 1;
        return this;
    }
    valueOf() {
        const p = this._partials;
        let n = this._n, x, y, lo, hi = 0;
        if (n > 0) {
            hi = p[--n];
            while(n > 0){
                x = hi;
                y = p[--n];
                hi = x + y;
                lo = y - (hi - x);
                if (lo) break;
            }
            if (n > 0 && (lo < 0 && p[n - 1] < 0 || lo > 0 && p[n - 1] > 0)) {
                y = lo * 2;
                x = hi + y;
                if (y == x - hi) hi = x;
            }
        }
        return hi;
    }
}
function $86babe4bf44a2b65$export$61cb83f1a93e9fae(values, valueof) {
    const adder = new $86babe4bf44a2b65$export$bda7ba77fb86c375();
    if (valueof === undefined) {
        for (let value of values)if (value = +value) adder.add(value);
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) adder.add(value);
    }
    return +adder;
}
function $86babe4bf44a2b65$export$5a6391da70c130da(values, valueof) {
    const adder = new $86babe4bf44a2b65$export$bda7ba77fb86c375();
    let index = -1;
    return Float64Array.from(values, valueof === undefined ? (v)=>adder.add(+v || 0) : (v)=>adder.add(+valueof(v, ++index, values) || 0));
}



function $69ea747ffacebb0f$export$12f9ad44fe773943(cartesian) {
    return [
        (0, $8dcaf2b51049bed8$export$b8b770ee6a0d9760)(cartesian[1], cartesian[0]),
        (0, $8dcaf2b51049bed8$export$41726bdb1fc63f)(cartesian[2])
    ];
}
function $69ea747ffacebb0f$export$6e6697ef026a96(spherical) {
    var lambda = spherical[0], phi = spherical[1], cosPhi = (0, $8dcaf2b51049bed8$export$50d414a77b60d802)(phi);
    return [
        cosPhi * (0, $8dcaf2b51049bed8$export$50d414a77b60d802)(lambda),
        cosPhi * (0, $8dcaf2b51049bed8$export$5de3937cb4b592ed)(lambda),
        (0, $8dcaf2b51049bed8$export$5de3937cb4b592ed)(phi)
    ];
}
function $69ea747ffacebb0f$export$2ef80f51436a9de9(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}
function $69ea747ffacebb0f$export$4763f5351b14293f(a, b) {
    return [
        a[1] * b[2] - a[2] * b[1],
        a[2] * b[0] - a[0] * b[2],
        a[0] * b[1] - a[1] * b[0]
    ];
}
function $69ea747ffacebb0f$export$e62eba72fc898eae(a, b) {
    a[0] += b[0], a[1] += b[1], a[2] += b[2];
}
function $69ea747ffacebb0f$export$52d0ee3fc868d452(vector, k) {
    return [
        vector[0] * k,
        vector[1] * k,
        vector[2] * k
    ];
}
function $69ea747ffacebb0f$export$6789498aec2cb34b(d) {
    var l = (0, $8dcaf2b51049bed8$export$eba8049fb5020b81)(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
    d[0] /= l, d[1] /= l, d[2] /= l;
}



function $8716d858eeaa45aa$var$longitude(point) {
    return (0, $8dcaf2b51049bed8$export$2335f513bbd82c6d)(point[0]) <= (0, $8dcaf2b51049bed8$export$18c7bea995a110f) ? point[0] : (0, $8dcaf2b51049bed8$export$c5552dfdbc7cec71)(point[0]) * (((0, $8dcaf2b51049bed8$export$2335f513bbd82c6d)(point[0]) + (0, $8dcaf2b51049bed8$export$18c7bea995a110f)) % (0, $8dcaf2b51049bed8$export$a4b4b4d4d776fe92) - (0, $8dcaf2b51049bed8$export$18c7bea995a110f));
}
function $8716d858eeaa45aa$export$2e2bcd8739ae039(polygon, point) {
    var lambda = $8716d858eeaa45aa$var$longitude(point), phi = point[1], sinPhi = (0, $8dcaf2b51049bed8$export$5de3937cb4b592ed)(phi), normal = [
        (0, $8dcaf2b51049bed8$export$5de3937cb4b592ed)(lambda),
        -(0, $8dcaf2b51049bed8$export$50d414a77b60d802)(lambda),
        0
    ], angle = 0, winding = 0;
    var sum = new (0, $86babe4bf44a2b65$export$bda7ba77fb86c375)();
    if (sinPhi === 1) phi = (0, $8dcaf2b51049bed8$export$e51408a300e8929a) + (0, $8dcaf2b51049bed8$export$6c421550c66a327d);
    else if (sinPhi === -1) phi = -(0, $8dcaf2b51049bed8$export$e51408a300e8929a) - (0, $8dcaf2b51049bed8$export$6c421550c66a327d);
    for(var i = 0, n = polygon.length; i < n; ++i){
        if (!(m = (ring = polygon[i]).length)) continue;
        var ring, m, point0 = ring[m - 1], lambda0 = $8716d858eeaa45aa$var$longitude(point0), phi0 = point0[1] / 2 + (0, $8dcaf2b51049bed8$export$c39a5cba78ea0fc2), sinPhi0 = (0, $8dcaf2b51049bed8$export$5de3937cb4b592ed)(phi0), cosPhi0 = (0, $8dcaf2b51049bed8$export$50d414a77b60d802)(phi0);
        for(var j = 0; j < m; ++j, lambda0 = lambda1, sinPhi0 = sinPhi1, cosPhi0 = cosPhi1, point0 = point1){
            var point1 = ring[j], lambda1 = $8716d858eeaa45aa$var$longitude(point1), phi1 = point1[1] / 2 + (0, $8dcaf2b51049bed8$export$c39a5cba78ea0fc2), sinPhi1 = (0, $8dcaf2b51049bed8$export$5de3937cb4b592ed)(phi1), cosPhi1 = (0, $8dcaf2b51049bed8$export$50d414a77b60d802)(phi1), delta = lambda1 - lambda0, sign = delta >= 0 ? 1 : -1, absDelta = sign * delta, antimeridian = absDelta > (0, $8dcaf2b51049bed8$export$18c7bea995a110f), k = sinPhi0 * sinPhi1;
            sum.add((0, $8dcaf2b51049bed8$export$b8b770ee6a0d9760)(k * sign * (0, $8dcaf2b51049bed8$export$5de3937cb4b592ed)(absDelta), cosPhi0 * cosPhi1 + k * (0, $8dcaf2b51049bed8$export$50d414a77b60d802)(absDelta)));
            angle += antimeridian ? delta + sign * (0, $8dcaf2b51049bed8$export$a4b4b4d4d776fe92) : delta;
            // Are the longitudes either side of the point’s meridian (lambda),
            // and are the latitudes smaller than the parallel (phi)?
            if (antimeridian ^ lambda0 >= lambda ^ lambda1 >= lambda) {
                var arc = (0, $69ea747ffacebb0f$export$4763f5351b14293f)((0, $69ea747ffacebb0f$export$6e6697ef026a96)(point0), (0, $69ea747ffacebb0f$export$6e6697ef026a96)(point1));
                (0, $69ea747ffacebb0f$export$6789498aec2cb34b)(arc);
                var intersection = (0, $69ea747ffacebb0f$export$4763f5351b14293f)(normal, arc);
                (0, $69ea747ffacebb0f$export$6789498aec2cb34b)(intersection);
                var phiArc = (antimeridian ^ delta >= 0 ? -1 : 1) * (0, $8dcaf2b51049bed8$export$41726bdb1fc63f)(intersection[2]);
                if (phi > phiArc || phi === phiArc && (arc[0] || arc[1])) winding += antimeridian ^ delta >= 0 ? 1 : -1;
            }
        }
    }
    // First, determine whether the South pole is inside or outside:
    //
    // It is inside if:
    // * the polygon winds around it in a clockwise direction.
    // * the polygon does not (cumulatively) wind around it, but has a negative
    //   (counter-clockwise) area.
    //
    // Second, count the (signed) number of times a segment crosses a lambda
    // from the point to the South pole.  If it is zero, then the point is the
    // same side as the South pole.
    return (angle < -(0, $8dcaf2b51049bed8$export$6c421550c66a327d) || angle < (0, $8dcaf2b51049bed8$export$6c421550c66a327d) && sum < -(0, $8dcaf2b51049bed8$export$92c06fba281fe81b)) ^ winding & 1;
}


function* $fc637454cbf5f40e$var$flatten(arrays) {
    for (const array of arrays)yield* array;
}
function $fc637454cbf5f40e$export$2e2bcd8739ae039(arrays) {
    return Array.from($fc637454cbf5f40e$var$flatten(arrays));
}


function $5654249242407038$export$2e2bcd8739ae039(pointVisible, clipLine, interpolate, start) {
    return function(sink) {
        var line = clipLine(sink), ringBuffer = (0, $9b7198d8a3746240$export$2e2bcd8739ae039)(), ringSink = clipLine(ringBuffer), polygonStarted = false, polygon, segments, ring;
        var clip = {
            point: point,
            lineStart: lineStart,
            lineEnd: lineEnd,
            polygonStart: function() {
                clip.point = pointRing;
                clip.lineStart = ringStart;
                clip.lineEnd = ringEnd;
                segments = [];
                polygon = [];
            },
            polygonEnd: function() {
                clip.point = point;
                clip.lineStart = lineStart;
                clip.lineEnd = lineEnd;
                segments = (0, $fc637454cbf5f40e$export$2e2bcd8739ae039)(segments);
                var startInside = (0, $8716d858eeaa45aa$export$2e2bcd8739ae039)(polygon, start);
                if (segments.length) {
                    if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
                    (0, $8385263718999824$export$2e2bcd8739ae039)(segments, $5654249242407038$var$compareIntersection, startInside, interpolate, sink);
                } else if (startInside) {
                    if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
                    sink.lineStart();
                    interpolate(null, null, 1, sink);
                    sink.lineEnd();
                }
                if (polygonStarted) sink.polygonEnd(), polygonStarted = false;
                segments = polygon = null;
            },
            sphere: function() {
                sink.polygonStart();
                sink.lineStart();
                interpolate(null, null, 1, sink);
                sink.lineEnd();
                sink.polygonEnd();
            }
        };
        function point(lambda, phi) {
            if (pointVisible(lambda, phi)) sink.point(lambda, phi);
        }
        function pointLine(lambda, phi) {
            line.point(lambda, phi);
        }
        function lineStart() {
            clip.point = pointLine;
            line.lineStart();
        }
        function lineEnd() {
            clip.point = point;
            line.lineEnd();
        }
        function pointRing(lambda, phi) {
            ring.push([
                lambda,
                phi
            ]);
            ringSink.point(lambda, phi);
        }
        function ringStart() {
            ringSink.lineStart();
            ring = [];
        }
        function ringEnd() {
            pointRing(ring[0][0], ring[0][1]);
            ringSink.lineEnd();
            var clean = ringSink.clean(), ringSegments = ringBuffer.result(), i, n = ringSegments.length, m, segment, point;
            ring.pop();
            polygon.push(ring);
            ring = null;
            if (!n) return;
            // No intersections.
            if (clean & 1) {
                segment = ringSegments[0];
                if ((m = segment.length - 1) > 0) {
                    if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
                    sink.lineStart();
                    for(i = 0; i < m; ++i)sink.point((point = segment[i])[0], point[1]);
                    sink.lineEnd();
                }
                return;
            }
            // Rejoin connected segments.
            // TODO reuse ringBuffer.rejoin()?
            if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));
            segments.push(ringSegments.filter($5654249242407038$var$validSegment));
        }
        return clip;
    };
}
function $5654249242407038$var$validSegment(segment) {
    return segment.length > 1;
}
// Intersections are sorted along the clip edge. For both antimeridian cutting
// and circle clipping, the same comparison is used.
function $5654249242407038$var$compareIntersection(a, b) {
    return ((a = a.x)[0] < 0 ? a[1] - (0, $8dcaf2b51049bed8$export$e51408a300e8929a) - (0, $8dcaf2b51049bed8$export$6c421550c66a327d) : (0, $8dcaf2b51049bed8$export$e51408a300e8929a) - a[1]) - ((b = b.x)[0] < 0 ? b[1] - (0, $8dcaf2b51049bed8$export$e51408a300e8929a) - (0, $8dcaf2b51049bed8$export$6c421550c66a327d) : (0, $8dcaf2b51049bed8$export$e51408a300e8929a) - b[1]);
}



var $d44e37f0b58dc4b2$export$2e2bcd8739ae039 = (0, $5654249242407038$export$2e2bcd8739ae039)(function() {
    return true;
}, $d44e37f0b58dc4b2$var$clipAntimeridianLine, $d44e37f0b58dc4b2$var$clipAntimeridianInterpolate, [
    -(0, $8dcaf2b51049bed8$export$18c7bea995a110f),
    -(0, $8dcaf2b51049bed8$export$e51408a300e8929a)
]);
// Takes a line and cuts into visible segments. Return values: 0 - there were
// intersections or the line was empty; 1 - no intersections; 2 - there were
// intersections, and the first and last segments should be rejoined.
function $d44e37f0b58dc4b2$var$clipAntimeridianLine(stream) {
    var lambda0 = NaN, phi0 = NaN, sign0 = NaN, clean; // no intersections
    return {
        lineStart: function() {
            stream.lineStart();
            clean = 1;
        },
        point: function(lambda1, phi1) {
            var sign1 = lambda1 > 0 ? (0, $8dcaf2b51049bed8$export$18c7bea995a110f) : -(0, $8dcaf2b51049bed8$export$18c7bea995a110f), delta = (0, $8dcaf2b51049bed8$export$2335f513bbd82c6d)(lambda1 - lambda0);
            if ((0, $8dcaf2b51049bed8$export$2335f513bbd82c6d)(delta - (0, $8dcaf2b51049bed8$export$18c7bea995a110f)) < (0, $8dcaf2b51049bed8$export$6c421550c66a327d)) {
                stream.point(lambda0, phi0 = (phi0 + phi1) / 2 > 0 ? (0, $8dcaf2b51049bed8$export$e51408a300e8929a) : -(0, $8dcaf2b51049bed8$export$e51408a300e8929a));
                stream.point(sign0, phi0);
                stream.lineEnd();
                stream.lineStart();
                stream.point(sign1, phi0);
                stream.point(lambda1, phi0);
                clean = 0;
            } else if (sign0 !== sign1 && delta >= (0, $8dcaf2b51049bed8$export$18c7bea995a110f)) {
                if ((0, $8dcaf2b51049bed8$export$2335f513bbd82c6d)(lambda0 - sign0) < (0, $8dcaf2b51049bed8$export$6c421550c66a327d)) lambda0 -= sign0 * (0, $8dcaf2b51049bed8$export$6c421550c66a327d); // handle degeneracies
                if ((0, $8dcaf2b51049bed8$export$2335f513bbd82c6d)(lambda1 - sign1) < (0, $8dcaf2b51049bed8$export$6c421550c66a327d)) lambda1 -= sign1 * (0, $8dcaf2b51049bed8$export$6c421550c66a327d);
                phi0 = $d44e37f0b58dc4b2$var$clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1);
                stream.point(sign0, phi0);
                stream.lineEnd();
                stream.lineStart();
                stream.point(sign1, phi0);
                clean = 0;
            }
            stream.point(lambda0 = lambda1, phi0 = phi1);
            sign0 = sign1;
        },
        lineEnd: function() {
            stream.lineEnd();
            lambda0 = phi0 = NaN;
        },
        clean: function() {
            return 2 - clean; // if intersections, rejoin first and last segments
        }
    };
}
function $d44e37f0b58dc4b2$var$clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1) {
    var cosPhi0, cosPhi1, sinLambda0Lambda1 = (0, $8dcaf2b51049bed8$export$5de3937cb4b592ed)(lambda0 - lambda1);
    return (0, $8dcaf2b51049bed8$export$2335f513bbd82c6d)(sinLambda0Lambda1) > (0, $8dcaf2b51049bed8$export$6c421550c66a327d) ? (0, $8dcaf2b51049bed8$export$628dc4eed22b0fbd)(((0, $8dcaf2b51049bed8$export$5de3937cb4b592ed)(phi0) * (cosPhi1 = (0, $8dcaf2b51049bed8$export$50d414a77b60d802)(phi1)) * (0, $8dcaf2b51049bed8$export$5de3937cb4b592ed)(lambda1) - (0, $8dcaf2b51049bed8$export$5de3937cb4b592ed)(phi1) * (cosPhi0 = (0, $8dcaf2b51049bed8$export$50d414a77b60d802)(phi0)) * (0, $8dcaf2b51049bed8$export$5de3937cb4b592ed)(lambda0)) / (cosPhi0 * cosPhi1 * sinLambda0Lambda1)) : (phi0 + phi1) / 2;
}
function $d44e37f0b58dc4b2$var$clipAntimeridianInterpolate(from, to, direction, stream) {
    var phi;
    if (from == null) {
        phi = direction * (0, $8dcaf2b51049bed8$export$e51408a300e8929a);
        stream.point(-(0, $8dcaf2b51049bed8$export$18c7bea995a110f), phi);
        stream.point(0, phi);
        stream.point((0, $8dcaf2b51049bed8$export$18c7bea995a110f), phi);
        stream.point((0, $8dcaf2b51049bed8$export$18c7bea995a110f), 0);
        stream.point((0, $8dcaf2b51049bed8$export$18c7bea995a110f), -phi);
        stream.point(0, -phi);
        stream.point(-(0, $8dcaf2b51049bed8$export$18c7bea995a110f), -phi);
        stream.point(-(0, $8dcaf2b51049bed8$export$18c7bea995a110f), 0);
        stream.point(-(0, $8dcaf2b51049bed8$export$18c7bea995a110f), phi);
    } else if ((0, $8dcaf2b51049bed8$export$2335f513bbd82c6d)(from[0] - to[0]) > (0, $8dcaf2b51049bed8$export$6c421550c66a327d)) {
        var lambda = from[0] < to[0] ? (0, $8dcaf2b51049bed8$export$18c7bea995a110f) : -(0, $8dcaf2b51049bed8$export$18c7bea995a110f);
        phi = direction * lambda / 2;
        stream.point(-lambda, phi);
        stream.point(0, phi);
        stream.point(lambda, phi);
    } else stream.point(to[0], to[1]);
}




function $1e8e0408b93ff086$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}



function $f130de3f0520d681$export$2e2bcd8739ae039(a, b) {
    function compose(x, y) {
        return x = a(x, y), b(x[0], x[1]);
    }
    if (a.invert && b.invert) compose.invert = function(x, y) {
        return x = b.invert(x, y), x && a.invert(x[0], x[1]);
    };
    return compose;
}



function $c6a139940504b724$var$rotationIdentity(lambda, phi) {
    if ((0, $8dcaf2b51049bed8$export$2335f513bbd82c6d)(lambda) > (0, $8dcaf2b51049bed8$export$18c7bea995a110f)) lambda -= Math.round(lambda / (0, $8dcaf2b51049bed8$export$a4b4b4d4d776fe92)) * (0, $8dcaf2b51049bed8$export$a4b4b4d4d776fe92);
    return [
        lambda,
        phi
    ];
}
$c6a139940504b724$var$rotationIdentity.invert = $c6a139940504b724$var$rotationIdentity;
function $c6a139940504b724$export$a2ba89726971a90f(deltaLambda, deltaPhi, deltaGamma) {
    return (deltaLambda %= (0, $8dcaf2b51049bed8$export$a4b4b4d4d776fe92)) ? deltaPhi || deltaGamma ? (0, $f130de3f0520d681$export$2e2bcd8739ae039)($c6a139940504b724$var$rotationLambda(deltaLambda), $c6a139940504b724$var$rotationPhiGamma(deltaPhi, deltaGamma)) : $c6a139940504b724$var$rotationLambda(deltaLambda) : deltaPhi || deltaGamma ? $c6a139940504b724$var$rotationPhiGamma(deltaPhi, deltaGamma) : $c6a139940504b724$var$rotationIdentity;
}
function $c6a139940504b724$var$forwardRotationLambda(deltaLambda) {
    return function(lambda, phi) {
        lambda += deltaLambda;
        if ((0, $8dcaf2b51049bed8$export$2335f513bbd82c6d)(lambda) > (0, $8dcaf2b51049bed8$export$18c7bea995a110f)) lambda -= Math.round(lambda / (0, $8dcaf2b51049bed8$export$a4b4b4d4d776fe92)) * (0, $8dcaf2b51049bed8$export$a4b4b4d4d776fe92);
        return [
            lambda,
            phi
        ];
    };
}
function $c6a139940504b724$var$rotationLambda(deltaLambda) {
    var rotation = $c6a139940504b724$var$forwardRotationLambda(deltaLambda);
    rotation.invert = $c6a139940504b724$var$forwardRotationLambda(-deltaLambda);
    return rotation;
}
function $c6a139940504b724$var$rotationPhiGamma(deltaPhi, deltaGamma) {
    var cosDeltaPhi = (0, $8dcaf2b51049bed8$export$50d414a77b60d802)(deltaPhi), sinDeltaPhi = (0, $8dcaf2b51049bed8$export$5de3937cb4b592ed)(deltaPhi), cosDeltaGamma = (0, $8dcaf2b51049bed8$export$50d414a77b60d802)(deltaGamma), sinDeltaGamma = (0, $8dcaf2b51049bed8$export$5de3937cb4b592ed)(deltaGamma);
    function rotation(lambda, phi) {
        var cosPhi = (0, $8dcaf2b51049bed8$export$50d414a77b60d802)(phi), x = (0, $8dcaf2b51049bed8$export$50d414a77b60d802)(lambda) * cosPhi, y = (0, $8dcaf2b51049bed8$export$5de3937cb4b592ed)(lambda) * cosPhi, z = (0, $8dcaf2b51049bed8$export$5de3937cb4b592ed)(phi), k = z * cosDeltaPhi + x * sinDeltaPhi;
        return [
            (0, $8dcaf2b51049bed8$export$b8b770ee6a0d9760)(y * cosDeltaGamma - k * sinDeltaGamma, x * cosDeltaPhi - z * sinDeltaPhi),
            (0, $8dcaf2b51049bed8$export$41726bdb1fc63f)(k * cosDeltaGamma + y * sinDeltaGamma)
        ];
    }
    rotation.invert = function(lambda, phi) {
        var cosPhi = (0, $8dcaf2b51049bed8$export$50d414a77b60d802)(phi), x = (0, $8dcaf2b51049bed8$export$50d414a77b60d802)(lambda) * cosPhi, y = (0, $8dcaf2b51049bed8$export$5de3937cb4b592ed)(lambda) * cosPhi, z = (0, $8dcaf2b51049bed8$export$5de3937cb4b592ed)(phi), k = z * cosDeltaGamma - y * sinDeltaGamma;
        return [
            (0, $8dcaf2b51049bed8$export$b8b770ee6a0d9760)(y * cosDeltaGamma + z * sinDeltaGamma, x * cosDeltaPhi + k * sinDeltaPhi),
            (0, $8dcaf2b51049bed8$export$41726bdb1fc63f)(k * cosDeltaPhi - x * sinDeltaPhi)
        ];
    };
    return rotation;
}
function $c6a139940504b724$export$2e2bcd8739ae039(rotate) {
    rotate = $c6a139940504b724$export$a2ba89726971a90f(rotate[0] * (0, $8dcaf2b51049bed8$export$8449e153fbd325fc), rotate[1] * (0, $8dcaf2b51049bed8$export$8449e153fbd325fc), rotate.length > 2 ? rotate[2] * (0, $8dcaf2b51049bed8$export$8449e153fbd325fc) : 0);
    function forward(coordinates) {
        coordinates = rotate(coordinates[0] * (0, $8dcaf2b51049bed8$export$8449e153fbd325fc), coordinates[1] * (0, $8dcaf2b51049bed8$export$8449e153fbd325fc));
        return coordinates[0] *= (0, $8dcaf2b51049bed8$export$41fc368e1a942b97), coordinates[1] *= (0, $8dcaf2b51049bed8$export$41fc368e1a942b97), coordinates;
    }
    forward.invert = function(coordinates) {
        coordinates = rotate.invert(coordinates[0] * (0, $8dcaf2b51049bed8$export$8449e153fbd325fc), coordinates[1] * (0, $8dcaf2b51049bed8$export$8449e153fbd325fc));
        return coordinates[0] *= (0, $8dcaf2b51049bed8$export$41fc368e1a942b97), coordinates[1] *= (0, $8dcaf2b51049bed8$export$41fc368e1a942b97), coordinates;
    };
    return forward;
}


function $67f4cf83e6103936$export$b5441eb324cd8d4e(stream, radius, delta, direction, t0, t1) {
    if (!delta) return;
    var cosRadius = (0, $8dcaf2b51049bed8$export$50d414a77b60d802)(radius), sinRadius = (0, $8dcaf2b51049bed8$export$5de3937cb4b592ed)(radius), step = direction * delta;
    if (t0 == null) {
        t0 = radius + direction * (0, $8dcaf2b51049bed8$export$a4b4b4d4d776fe92);
        t1 = radius - step / 2;
    } else {
        t0 = $67f4cf83e6103936$var$circleRadius(cosRadius, t0);
        t1 = $67f4cf83e6103936$var$circleRadius(cosRadius, t1);
        if (direction > 0 ? t0 < t1 : t0 > t1) t0 += direction * (0, $8dcaf2b51049bed8$export$a4b4b4d4d776fe92);
    }
    for(var point, t = t0; direction > 0 ? t > t1 : t < t1; t -= step){
        point = (0, $69ea747ffacebb0f$export$12f9ad44fe773943)([
            cosRadius,
            -sinRadius * (0, $8dcaf2b51049bed8$export$50d414a77b60d802)(t),
            -sinRadius * (0, $8dcaf2b51049bed8$export$5de3937cb4b592ed)(t)
        ]);
        stream.point(point[0], point[1]);
    }
}
// Returns the signed angle of a cartesian point relative to [cosRadius, 0, 0].
function $67f4cf83e6103936$var$circleRadius(cosRadius, point) {
    point = (0, $69ea747ffacebb0f$export$6e6697ef026a96)(point), point[0] -= cosRadius;
    (0, $69ea747ffacebb0f$export$6789498aec2cb34b)(point);
    var radius = (0, $8dcaf2b51049bed8$export$fd6306be3fde5b04)(-point[1]);
    return ((-point[2] < 0 ? -radius : radius) + (0, $8dcaf2b51049bed8$export$a4b4b4d4d776fe92) - (0, $8dcaf2b51049bed8$export$6c421550c66a327d)) % (0, $8dcaf2b51049bed8$export$a4b4b4d4d776fe92);
}
function $67f4cf83e6103936$export$2e2bcd8739ae039() {
    var center = (0, $1e8e0408b93ff086$export$2e2bcd8739ae039)([
        0,
        0
    ]), radius = (0, $1e8e0408b93ff086$export$2e2bcd8739ae039)(90), precision = (0, $1e8e0408b93ff086$export$2e2bcd8739ae039)(2), ring, rotate, stream = {
        point: point
    };
    function point(x, y) {
        ring.push(x = rotate(x, y));
        x[0] *= (0, $8dcaf2b51049bed8$export$41fc368e1a942b97), x[1] *= (0, $8dcaf2b51049bed8$export$41fc368e1a942b97);
    }
    function circle() {
        var c = center.apply(this, arguments), r = radius.apply(this, arguments) * (0, $8dcaf2b51049bed8$export$8449e153fbd325fc), p = precision.apply(this, arguments) * (0, $8dcaf2b51049bed8$export$8449e153fbd325fc);
        ring = [];
        rotate = (0, $c6a139940504b724$export$a2ba89726971a90f)(-c[0] * (0, $8dcaf2b51049bed8$export$8449e153fbd325fc), -c[1] * (0, $8dcaf2b51049bed8$export$8449e153fbd325fc), 0).invert;
        $67f4cf83e6103936$export$b5441eb324cd8d4e(stream, r, p, 1);
        c = {
            type: "Polygon",
            coordinates: [
                ring
            ]
        };
        ring = rotate = null;
        return c;
    }
    circle.center = function(_) {
        return arguments.length ? (center = typeof _ === "function" ? _ : (0, $1e8e0408b93ff086$export$2e2bcd8739ae039)([
            +_[0],
            +_[1]
        ]), circle) : center;
    };
    circle.radius = function(_) {
        return arguments.length ? (radius = typeof _ === "function" ? _ : (0, $1e8e0408b93ff086$export$2e2bcd8739ae039)(+_), circle) : radius;
    };
    circle.precision = function(_) {
        return arguments.length ? (precision = typeof _ === "function" ? _ : (0, $1e8e0408b93ff086$export$2e2bcd8739ae039)(+_), circle) : precision;
    };
    return circle;
}





function $e0a68981870c73a9$export$2e2bcd8739ae039(radius) {
    var cr = (0, $8dcaf2b51049bed8$export$50d414a77b60d802)(radius), delta = 2 * (0, $8dcaf2b51049bed8$export$8449e153fbd325fc), smallRadius = cr > 0, notHemisphere = (0, $8dcaf2b51049bed8$export$2335f513bbd82c6d)(cr) > (0, $8dcaf2b51049bed8$export$6c421550c66a327d); // TODO optimise for this common case
    function interpolate(from, to, direction, stream) {
        (0, $67f4cf83e6103936$export$b5441eb324cd8d4e)(stream, radius, delta, direction, from, to);
    }
    function visible(lambda, phi) {
        return (0, $8dcaf2b51049bed8$export$50d414a77b60d802)(lambda) * (0, $8dcaf2b51049bed8$export$50d414a77b60d802)(phi) > cr;
    }
    // Takes a line and cuts into visible segments. Return values used for polygon
    // clipping: 0 - there were intersections or the line was empty; 1 - no
    // intersections 2 - there were intersections, and the first and last segments
    // should be rejoined.
    function clipLine(stream) {
        var point0, c0, v0, v00, clean; // no intersections
        return {
            lineStart: function() {
                v00 = v0 = false;
                clean = 1;
            },
            point: function(lambda, phi) {
                var point1 = [
                    lambda,
                    phi
                ], point2, v = visible(lambda, phi), c = smallRadius ? v ? 0 : code(lambda, phi) : v ? code(lambda + (lambda < 0 ? (0, $8dcaf2b51049bed8$export$18c7bea995a110f) : -(0, $8dcaf2b51049bed8$export$18c7bea995a110f)), phi) : 0;
                if (!point0 && (v00 = v0 = v)) stream.lineStart();
                if (v !== v0) {
                    point2 = intersect(point0, point1);
                    if (!point2 || (0, $677c5b35fee6fa32$export$2e2bcd8739ae039)(point0, point2) || (0, $677c5b35fee6fa32$export$2e2bcd8739ae039)(point1, point2)) point1[2] = 1;
                }
                if (v !== v0) {
                    clean = 0;
                    if (v) {
                        // outside going in
                        stream.lineStart();
                        point2 = intersect(point1, point0);
                        stream.point(point2[0], point2[1]);
                    } else {
                        // inside going out
                        point2 = intersect(point0, point1);
                        stream.point(point2[0], point2[1], 2);
                        stream.lineEnd();
                    }
                    point0 = point2;
                } else if (notHemisphere && point0 && smallRadius ^ v) {
                    var t;
                    // If the codes for two points are different, or are both zero,
                    // and there this segment intersects with the small circle.
                    if (!(c & c0) && (t = intersect(point1, point0, true))) {
                        clean = 0;
                        if (smallRadius) {
                            stream.lineStart();
                            stream.point(t[0][0], t[0][1]);
                            stream.point(t[1][0], t[1][1]);
                            stream.lineEnd();
                        } else {
                            stream.point(t[1][0], t[1][1]);
                            stream.lineEnd();
                            stream.lineStart();
                            stream.point(t[0][0], t[0][1], 3);
                        }
                    }
                }
                if (v && (!point0 || !(0, $677c5b35fee6fa32$export$2e2bcd8739ae039)(point0, point1))) stream.point(point1[0], point1[1]);
                point0 = point1, v0 = v, c0 = c;
            },
            lineEnd: function() {
                if (v0) stream.lineEnd();
                point0 = null;
            },
            // Rejoin first and last segments if there were intersections and the first
            // and last points were visible.
            clean: function() {
                return clean | (v00 && v0) << 1;
            }
        };
    }
    // Intersects the great circle between a and b with the clip circle.
    function intersect(a, b, two) {
        var pa = (0, $69ea747ffacebb0f$export$6e6697ef026a96)(a), pb = (0, $69ea747ffacebb0f$export$6e6697ef026a96)(b);
        // We have two planes, n1.p = d1 and n2.p = d2.
        // Find intersection line p(t) = c1 n1 + c2 n2 + t (n1 ⨯ n2).
        var n1 = [
            1,
            0,
            0
        ], n2 = (0, $69ea747ffacebb0f$export$4763f5351b14293f)(pa, pb), n2n2 = (0, $69ea747ffacebb0f$export$2ef80f51436a9de9)(n2, n2), n1n2 = n2[0], determinant = n2n2 - n1n2 * n1n2;
        // Two polar points.
        if (!determinant) return !two && a;
        var c1 = cr * n2n2 / determinant, c2 = -cr * n1n2 / determinant, n1xn2 = (0, $69ea747ffacebb0f$export$4763f5351b14293f)(n1, n2), A = (0, $69ea747ffacebb0f$export$52d0ee3fc868d452)(n1, c1), B = (0, $69ea747ffacebb0f$export$52d0ee3fc868d452)(n2, c2);
        (0, $69ea747ffacebb0f$export$e62eba72fc898eae)(A, B);
        // Solve |p(t)|^2 = 1.
        var u = n1xn2, w = (0, $69ea747ffacebb0f$export$2ef80f51436a9de9)(A, u), uu = (0, $69ea747ffacebb0f$export$2ef80f51436a9de9)(u, u), t2 = w * w - uu * ((0, $69ea747ffacebb0f$export$2ef80f51436a9de9)(A, A) - 1);
        if (t2 < 0) return;
        var t = (0, $8dcaf2b51049bed8$export$eba8049fb5020b81)(t2), q = (0, $69ea747ffacebb0f$export$52d0ee3fc868d452)(u, (-w - t) / uu);
        (0, $69ea747ffacebb0f$export$e62eba72fc898eae)(q, A);
        q = (0, $69ea747ffacebb0f$export$12f9ad44fe773943)(q);
        if (!two) return q;
        // Two intersection points.
        var lambda0 = a[0], lambda1 = b[0], phi0 = a[1], phi1 = b[1], z;
        if (lambda1 < lambda0) z = lambda0, lambda0 = lambda1, lambda1 = z;
        var delta = lambda1 - lambda0, polar = (0, $8dcaf2b51049bed8$export$2335f513bbd82c6d)(delta - (0, $8dcaf2b51049bed8$export$18c7bea995a110f)) < (0, $8dcaf2b51049bed8$export$6c421550c66a327d), meridian = polar || delta < (0, $8dcaf2b51049bed8$export$6c421550c66a327d);
        if (!polar && phi1 < phi0) z = phi0, phi0 = phi1, phi1 = z;
        // Check that the first point is between a and b.
        if (meridian ? polar ? phi0 + phi1 > 0 ^ q[1] < ((0, $8dcaf2b51049bed8$export$2335f513bbd82c6d)(q[0] - lambda0) < (0, $8dcaf2b51049bed8$export$6c421550c66a327d) ? phi0 : phi1) : phi0 <= q[1] && q[1] <= phi1 : delta > (0, $8dcaf2b51049bed8$export$18c7bea995a110f) ^ (lambda0 <= q[0] && q[0] <= lambda1)) {
            var q1 = (0, $69ea747ffacebb0f$export$52d0ee3fc868d452)(u, (-w + t) / uu);
            (0, $69ea747ffacebb0f$export$e62eba72fc898eae)(q1, A);
            return [
                q,
                (0, $69ea747ffacebb0f$export$12f9ad44fe773943)(q1)
            ];
        }
    }
    // Generates a 4-bit vector representing the location of a point relative to
    // the small circle's bounding box.
    function code(lambda, phi) {
        var r = smallRadius ? radius : (0, $8dcaf2b51049bed8$export$18c7bea995a110f) - radius, code = 0;
        if (lambda < -r) code |= 1; // left
        else if (lambda > r) code |= 2; // right
        if (phi < -r) code |= 4; // below
        else if (phi > r) code |= 8; // above
        return code;
    }
    return (0, $5654249242407038$export$2e2bcd8739ae039)(visible, clipLine, interpolate, smallRadius ? [
        0,
        -radius
    ] : [
        -(0, $8dcaf2b51049bed8$export$18c7bea995a110f),
        radius - (0, $8dcaf2b51049bed8$export$18c7bea995a110f)
    ]);
}




function $c45335dbea09cfb0$export$2e2bcd8739ae039(a, b, x0, y0, x1, y1) {
    var ax = a[0], ay = a[1], bx = b[0], by = b[1], t0 = 0, t1 = 1, dx = bx - ax, dy = by - ay, r;
    r = x0 - ax;
    if (!dx && r > 0) return;
    r /= dx;
    if (dx < 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    } else if (dx > 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    }
    r = x1 - ax;
    if (!dx && r < 0) return;
    r /= dx;
    if (dx < 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    } else if (dx > 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    }
    r = y0 - ay;
    if (!dy && r > 0) return;
    r /= dy;
    if (dy < 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    } else if (dy > 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    }
    r = y1 - ay;
    if (!dy && r < 0) return;
    r /= dy;
    if (dy < 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    } else if (dy > 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    }
    if (t0 > 0) a[0] = ax + t0 * dx, a[1] = ay + t0 * dy;
    if (t1 < 1) b[0] = ax + t1 * dx, b[1] = ay + t1 * dy;
    return true;
}




var $b6a942874669ff0d$var$clipMax = 1e9, $b6a942874669ff0d$var$clipMin = -$b6a942874669ff0d$var$clipMax;
function $b6a942874669ff0d$export$2e2bcd8739ae039(x0, y0, x1, y1) {
    function visible(x, y) {
        return x0 <= x && x <= x1 && y0 <= y && y <= y1;
    }
    function interpolate(from, to, direction, stream) {
        var a = 0, a1 = 0;
        if (from == null || (a = corner(from, direction)) !== (a1 = corner(to, direction)) || comparePoint(from, to) < 0 ^ direction > 0) do stream.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
        while ((a = (a + direction + 4) % 4) !== a1);
        else stream.point(to[0], to[1]);
    }
    function corner(p, direction) {
        return (0, $8dcaf2b51049bed8$export$2335f513bbd82c6d)(p[0] - x0) < (0, $8dcaf2b51049bed8$export$6c421550c66a327d) ? direction > 0 ? 0 : 3 : (0, $8dcaf2b51049bed8$export$2335f513bbd82c6d)(p[0] - x1) < (0, $8dcaf2b51049bed8$export$6c421550c66a327d) ? direction > 0 ? 2 : 1 : (0, $8dcaf2b51049bed8$export$2335f513bbd82c6d)(p[1] - y0) < (0, $8dcaf2b51049bed8$export$6c421550c66a327d) ? direction > 0 ? 1 : 0 : direction > 0 ? 3 : 2; // abs(p[1] - y1) < epsilon
    }
    function compareIntersection(a, b) {
        return comparePoint(a.x, b.x);
    }
    function comparePoint(a, b) {
        var ca = corner(a, 1), cb = corner(b, 1);
        return ca !== cb ? ca - cb : ca === 0 ? b[1] - a[1] : ca === 1 ? a[0] - b[0] : ca === 2 ? a[1] - b[1] : b[0] - a[0];
    }
    return function(stream) {
        var activeStream = stream, bufferStream = (0, $9b7198d8a3746240$export$2e2bcd8739ae039)(), segments, polygon, ring, x__, y__, v__, x_, y_, v_, first, clean;
        var clipStream = {
            point: point,
            lineStart: lineStart,
            lineEnd: lineEnd,
            polygonStart: polygonStart,
            polygonEnd: polygonEnd
        };
        function point(x, y) {
            if (visible(x, y)) activeStream.point(x, y);
        }
        function polygonInside() {
            var winding = 0;
            for(var i = 0, n = polygon.length; i < n; ++i)for(var ring = polygon[i], j = 1, m = ring.length, point = ring[0], a0, a1, b0 = point[0], b1 = point[1]; j < m; ++j){
                a0 = b0, a1 = b1, point = ring[j], b0 = point[0], b1 = point[1];
                if (a1 <= y1) {
                    if (b1 > y1 && (b0 - a0) * (y1 - a1) > (b1 - a1) * (x0 - a0)) ++winding;
                } else if (b1 <= y1 && (b0 - a0) * (y1 - a1) < (b1 - a1) * (x0 - a0)) --winding;
            }
            return winding;
        }
        // Buffer geometry within a polygon and then clip it en masse.
        function polygonStart() {
            activeStream = bufferStream, segments = [], polygon = [], clean = true;
        }
        function polygonEnd() {
            var startInside = polygonInside(), cleanInside = clean && startInside, visible = (segments = (0, $fc637454cbf5f40e$export$2e2bcd8739ae039)(segments)).length;
            if (cleanInside || visible) {
                stream.polygonStart();
                if (cleanInside) {
                    stream.lineStart();
                    interpolate(null, null, 1, stream);
                    stream.lineEnd();
                }
                if (visible) (0, $8385263718999824$export$2e2bcd8739ae039)(segments, compareIntersection, startInside, interpolate, stream);
                stream.polygonEnd();
            }
            activeStream = stream, segments = polygon = ring = null;
        }
        function lineStart() {
            clipStream.point = linePoint;
            if (polygon) polygon.push(ring = []);
            first = true;
            v_ = false;
            x_ = y_ = NaN;
        }
        // TODO rather than special-case polygons, simply handle them separately.
        // Ideally, coincident intersection points should be jittered to avoid
        // clipping issues.
        function lineEnd() {
            if (segments) {
                linePoint(x__, y__);
                if (v__ && v_) bufferStream.rejoin();
                segments.push(bufferStream.result());
            }
            clipStream.point = point;
            if (v_) activeStream.lineEnd();
        }
        function linePoint(x, y) {
            var v = visible(x, y);
            if (polygon) ring.push([
                x,
                y
            ]);
            if (first) {
                x__ = x, y__ = y, v__ = v;
                first = false;
                if (v) {
                    activeStream.lineStart();
                    activeStream.point(x, y);
                }
            } else if (v && v_) activeStream.point(x, y);
            else {
                var a = [
                    x_ = Math.max($b6a942874669ff0d$var$clipMin, Math.min($b6a942874669ff0d$var$clipMax, x_)),
                    y_ = Math.max($b6a942874669ff0d$var$clipMin, Math.min($b6a942874669ff0d$var$clipMax, y_))
                ], b = [
                    x = Math.max($b6a942874669ff0d$var$clipMin, Math.min($b6a942874669ff0d$var$clipMax, x)),
                    y = Math.max($b6a942874669ff0d$var$clipMin, Math.min($b6a942874669ff0d$var$clipMax, y))
                ];
                if ((0, $c45335dbea09cfb0$export$2e2bcd8739ae039)(a, b, x0, y0, x1, y1)) {
                    if (!v_) {
                        activeStream.lineStart();
                        activeStream.point(a[0], a[1]);
                    }
                    activeStream.point(b[0], b[1]);
                    if (!v) activeStream.lineEnd();
                    clean = false;
                } else if (v) {
                    activeStream.lineStart();
                    activeStream.point(x, y);
                    clean = false;
                }
            }
            x_ = x, y_ = y, v_ = v;
        }
        return clipStream;
    };
}



var $4702f1ccb7a48975$export$2e2bcd8739ae039 = (x)=>x;




function $3b63d8bbfc9ff597$export$2e2bcd8739ae039(methods) {
    return {
        stream: $3b63d8bbfc9ff597$export$6b468dcfb64c653c(methods)
    };
}
function $3b63d8bbfc9ff597$export$6b468dcfb64c653c(methods) {
    return function(stream) {
        var s = new $3b63d8bbfc9ff597$var$TransformStream;
        for(var key in methods)s[key] = methods[key];
        s.stream = stream;
        return s;
    };
}
function $3b63d8bbfc9ff597$var$TransformStream() {}
$3b63d8bbfc9ff597$var$TransformStream.prototype = {
    constructor: $3b63d8bbfc9ff597$var$TransformStream,
    point: function(x, y) {
        this.stream.point(x, y);
    },
    sphere: function() {
        this.stream.sphere();
    },
    lineStart: function() {
        this.stream.lineStart();
    },
    lineEnd: function() {
        this.stream.lineEnd();
    },
    polygonStart: function() {
        this.stream.polygonStart();
    },
    polygonEnd: function() {
        this.stream.polygonEnd();
    }
};


function $b23136d2ce68b531$var$streamGeometry(geometry, stream) {
    if (geometry && $b23136d2ce68b531$var$streamGeometryType.hasOwnProperty(geometry.type)) $b23136d2ce68b531$var$streamGeometryType[geometry.type](geometry, stream);
}
var $b23136d2ce68b531$var$streamObjectType = {
    Feature: function(object, stream) {
        $b23136d2ce68b531$var$streamGeometry(object.geometry, stream);
    },
    FeatureCollection: function(object, stream) {
        var features = object.features, i = -1, n = features.length;
        while(++i < n)$b23136d2ce68b531$var$streamGeometry(features[i].geometry, stream);
    }
};
var $b23136d2ce68b531$var$streamGeometryType = {
    Sphere: function(object, stream) {
        stream.sphere();
    },
    Point: function(object, stream) {
        object = object.coordinates;
        stream.point(object[0], object[1], object[2]);
    },
    MultiPoint: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)object = coordinates[i], stream.point(object[0], object[1], object[2]);
    },
    LineString: function(object, stream) {
        $b23136d2ce68b531$var$streamLine(object.coordinates, stream, 0);
    },
    MultiLineString: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)$b23136d2ce68b531$var$streamLine(coordinates[i], stream, 0);
    },
    Polygon: function(object, stream) {
        $b23136d2ce68b531$var$streamPolygon(object.coordinates, stream);
    },
    MultiPolygon: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)$b23136d2ce68b531$var$streamPolygon(coordinates[i], stream);
    },
    GeometryCollection: function(object, stream) {
        var geometries = object.geometries, i = -1, n = geometries.length;
        while(++i < n)$b23136d2ce68b531$var$streamGeometry(geometries[i], stream);
    }
};
function $b23136d2ce68b531$var$streamLine(coordinates, stream, closed) {
    var i = -1, n = coordinates.length - closed, coordinate;
    stream.lineStart();
    while(++i < n)coordinate = coordinates[i], stream.point(coordinate[0], coordinate[1], coordinate[2]);
    stream.lineEnd();
}
function $b23136d2ce68b531$var$streamPolygon(coordinates, stream) {
    var i = -1, n = coordinates.length;
    stream.polygonStart();
    while(++i < n)$b23136d2ce68b531$var$streamLine(coordinates[i], stream, 1);
    stream.polygonEnd();
}
function $b23136d2ce68b531$export$2e2bcd8739ae039(object, stream) {
    if (object && $b23136d2ce68b531$var$streamObjectType.hasOwnProperty(object.type)) $b23136d2ce68b531$var$streamObjectType[object.type](object, stream);
    else $b23136d2ce68b531$var$streamGeometry(object, stream);
}



var $73514264e91fc979$var$x0 = Infinity, $73514264e91fc979$var$y0 = $73514264e91fc979$var$x0, $73514264e91fc979$var$x1 = -$73514264e91fc979$var$x0, $73514264e91fc979$var$y1 = $73514264e91fc979$var$x1;
var $73514264e91fc979$var$boundsStream = {
    point: $73514264e91fc979$var$boundsPoint,
    lineStart: (0, $32a1340ec0955a5e$export$2e2bcd8739ae039),
    lineEnd: (0, $32a1340ec0955a5e$export$2e2bcd8739ae039),
    polygonStart: (0, $32a1340ec0955a5e$export$2e2bcd8739ae039),
    polygonEnd: (0, $32a1340ec0955a5e$export$2e2bcd8739ae039),
    result: function() {
        var bounds = [
            [
                $73514264e91fc979$var$x0,
                $73514264e91fc979$var$y0
            ],
            [
                $73514264e91fc979$var$x1,
                $73514264e91fc979$var$y1
            ]
        ];
        $73514264e91fc979$var$x1 = $73514264e91fc979$var$y1 = -($73514264e91fc979$var$y0 = $73514264e91fc979$var$x0 = Infinity);
        return bounds;
    }
};
function $73514264e91fc979$var$boundsPoint(x, y) {
    if (x < $73514264e91fc979$var$x0) $73514264e91fc979$var$x0 = x;
    if (x > $73514264e91fc979$var$x1) $73514264e91fc979$var$x1 = x;
    if (y < $73514264e91fc979$var$y0) $73514264e91fc979$var$y0 = y;
    if (y > $73514264e91fc979$var$y1) $73514264e91fc979$var$y1 = y;
}
var $73514264e91fc979$export$2e2bcd8739ae039 = $73514264e91fc979$var$boundsStream;


function $af875c78cc43d8f1$var$fit(projection, fitBounds, object) {
    var clip = projection.clipExtent && projection.clipExtent();
    projection.scale(150).translate([
        0,
        0
    ]);
    if (clip != null) projection.clipExtent(null);
    (0, $b23136d2ce68b531$export$2e2bcd8739ae039)(object, projection.stream((0, $73514264e91fc979$export$2e2bcd8739ae039)));
    fitBounds((0, $73514264e91fc979$export$2e2bcd8739ae039).result());
    if (clip != null) projection.clipExtent(clip);
    return projection;
}
function $af875c78cc43d8f1$export$e450184041869e7f(projection, extent, object) {
    return $af875c78cc43d8f1$var$fit(projection, function(b) {
        var w = extent[1][0] - extent[0][0], h = extent[1][1] - extent[0][1], k = Math.min(w / (b[1][0] - b[0][0]), h / (b[1][1] - b[0][1])), x = +extent[0][0] + (w - k * (b[1][0] + b[0][0])) / 2, y = +extent[0][1] + (h - k * (b[1][1] + b[0][1])) / 2;
        projection.scale(150 * k).translate([
            x,
            y
        ]);
    }, object);
}
function $af875c78cc43d8f1$export$33a367fa1728c3ba(projection, size, object) {
    return $af875c78cc43d8f1$export$e450184041869e7f(projection, [
        [
            0,
            0
        ],
        size
    ], object);
}
function $af875c78cc43d8f1$export$7d8f2192ef31c5a7(projection, width, object) {
    return $af875c78cc43d8f1$var$fit(projection, function(b) {
        var w = +width, k = w / (b[1][0] - b[0][0]), x = (w - k * (b[1][0] + b[0][0])) / 2, y = -k * b[0][1];
        projection.scale(150 * k).translate([
            x,
            y
        ]);
    }, object);
}
function $af875c78cc43d8f1$export$7069bab0d2ced675(projection, height, object) {
    return $af875c78cc43d8f1$var$fit(projection, function(b) {
        var h = +height, k = h / (b[1][1] - b[0][1]), x = -k * b[0][0], y = (h - k * (b[1][1] + b[0][1])) / 2;
        projection.scale(150 * k).translate([
            x,
            y
        ]);
    }, object);
}





var $090ac3e89eb77df0$var$maxDepth = 16, $090ac3e89eb77df0$var$cosMinDistance = (0, $8dcaf2b51049bed8$export$50d414a77b60d802)(30 * (0, $8dcaf2b51049bed8$export$8449e153fbd325fc)); // cos(minimum angular distance)
function $090ac3e89eb77df0$export$2e2bcd8739ae039(project, delta2) {
    return +delta2 ? $090ac3e89eb77df0$var$resample(project, delta2) : $090ac3e89eb77df0$var$resampleNone(project);
}
function $090ac3e89eb77df0$var$resampleNone(project) {
    return (0, $3b63d8bbfc9ff597$export$6b468dcfb64c653c)({
        point: function(x, y) {
            x = project(x, y);
            this.stream.point(x[0], x[1]);
        }
    });
}
function $090ac3e89eb77df0$var$resample(project, delta2) {
    function resampleLineTo(x0, y0, lambda0, a0, b0, c0, x1, y1, lambda1, a1, b1, c1, depth, stream) {
        var dx = x1 - x0, dy = y1 - y0, d2 = dx * dx + dy * dy;
        if (d2 > 4 * delta2 && depth--) {
            var a = a0 + a1, b = b0 + b1, c = c0 + c1, m = (0, $8dcaf2b51049bed8$export$eba8049fb5020b81)(a * a + b * b + c * c), phi2 = (0, $8dcaf2b51049bed8$export$41726bdb1fc63f)(c /= m), lambda2 = (0, $8dcaf2b51049bed8$export$2335f513bbd82c6d)((0, $8dcaf2b51049bed8$export$2335f513bbd82c6d)(c) - 1) < (0, $8dcaf2b51049bed8$export$6c421550c66a327d) || (0, $8dcaf2b51049bed8$export$2335f513bbd82c6d)(lambda0 - lambda1) < (0, $8dcaf2b51049bed8$export$6c421550c66a327d) ? (lambda0 + lambda1) / 2 : (0, $8dcaf2b51049bed8$export$b8b770ee6a0d9760)(b, a), p = project(lambda2, phi2), x2 = p[0], y2 = p[1], dx2 = x2 - x0, dy2 = y2 - y0, dz = dy * dx2 - dx * dy2;
            if (dz * dz / d2 > delta2 // perpendicular projected distance
             || (0, $8dcaf2b51049bed8$export$2335f513bbd82c6d)((dx * dx2 + dy * dy2) / d2 - 0.5) > 0.3 // midpoint close to an end
             || a0 * a1 + b0 * b1 + c0 * c1 < $090ac3e89eb77df0$var$cosMinDistance) {
                resampleLineTo(x0, y0, lambda0, a0, b0, c0, x2, y2, lambda2, a /= m, b /= m, c, depth, stream);
                stream.point(x2, y2);
                resampleLineTo(x2, y2, lambda2, a, b, c, x1, y1, lambda1, a1, b1, c1, depth, stream);
            }
        }
    }
    return function(stream) {
        var lambda00, x00, y00, a00, b00, c00, lambda0, x0, y0, a0, b0, c0; // previous point
        var resampleStream = {
            point: point,
            lineStart: lineStart,
            lineEnd: lineEnd,
            polygonStart: function() {
                stream.polygonStart();
                resampleStream.lineStart = ringStart;
            },
            polygonEnd: function() {
                stream.polygonEnd();
                resampleStream.lineStart = lineStart;
            }
        };
        function point(x, y) {
            x = project(x, y);
            stream.point(x[0], x[1]);
        }
        function lineStart() {
            x0 = NaN;
            resampleStream.point = linePoint;
            stream.lineStart();
        }
        function linePoint(lambda, phi) {
            var c = (0, $69ea747ffacebb0f$export$6e6697ef026a96)([
                lambda,
                phi
            ]), p = project(lambda, phi);
            resampleLineTo(x0, y0, lambda0, a0, b0, c0, x0 = p[0], y0 = p[1], lambda0 = lambda, a0 = c[0], b0 = c[1], c0 = c[2], $090ac3e89eb77df0$var$maxDepth, stream);
            stream.point(x0, y0);
        }
        function lineEnd() {
            resampleStream.point = point;
            stream.lineEnd();
        }
        function ringStart() {
            lineStart();
            resampleStream.point = ringPoint;
            resampleStream.lineEnd = ringEnd;
        }
        function ringPoint(lambda, phi) {
            linePoint(lambda00 = lambda, phi), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
            resampleStream.point = linePoint;
        }
        function ringEnd() {
            resampleLineTo(x0, y0, lambda0, a0, b0, c0, x00, y00, lambda00, a00, b00, c00, $090ac3e89eb77df0$var$maxDepth, stream);
            resampleStream.lineEnd = lineEnd;
            lineEnd();
        }
        return resampleStream;
    };
}


var $3077c8206bce896e$var$transformRadians = (0, $3b63d8bbfc9ff597$export$6b468dcfb64c653c)({
    point: function(x, y) {
        this.stream.point(x * (0, $8dcaf2b51049bed8$export$8449e153fbd325fc), y * (0, $8dcaf2b51049bed8$export$8449e153fbd325fc));
    }
});
function $3077c8206bce896e$var$transformRotate(rotate) {
    return (0, $3b63d8bbfc9ff597$export$6b468dcfb64c653c)({
        point: function(x, y) {
            var r = rotate(x, y);
            return this.stream.point(r[0], r[1]);
        }
    });
}
function $3077c8206bce896e$var$scaleTranslate(k, dx, dy, sx, sy) {
    function transform(x, y) {
        x *= sx;
        y *= sy;
        return [
            dx + k * x,
            dy - k * y
        ];
    }
    transform.invert = function(x, y) {
        return [
            (x - dx) / k * sx,
            (dy - y) / k * sy
        ];
    };
    return transform;
}
function $3077c8206bce896e$var$scaleTranslateRotate(k, dx, dy, sx, sy, alpha) {
    if (!alpha) return $3077c8206bce896e$var$scaleTranslate(k, dx, dy, sx, sy);
    var cosAlpha = (0, $8dcaf2b51049bed8$export$50d414a77b60d802)(alpha), sinAlpha = (0, $8dcaf2b51049bed8$export$5de3937cb4b592ed)(alpha), a = cosAlpha * k, b = sinAlpha * k, ai = cosAlpha / k, bi = sinAlpha / k, ci = (sinAlpha * dy - cosAlpha * dx) / k, fi = (sinAlpha * dx + cosAlpha * dy) / k;
    function transform(x, y) {
        x *= sx;
        y *= sy;
        return [
            a * x - b * y + dx,
            dy - b * x - a * y
        ];
    }
    transform.invert = function(x, y) {
        return [
            sx * (ai * x - bi * y + ci),
            sy * (fi - bi * x - ai * y)
        ];
    };
    return transform;
}
function $3077c8206bce896e$export$2e2bcd8739ae039(project) {
    return $3077c8206bce896e$export$155d5a6fa6fddeba(function() {
        return project;
    })();
}
function $3077c8206bce896e$export$155d5a6fa6fddeba(projectAt) {
    var project, k = 150, x = 480, y = 250, lambda = 0, phi = 0, deltaLambda = 0, deltaPhi = 0, deltaGamma = 0, rotate, alpha = 0, sx = 1, sy = 1, theta = null, preclip = (0, $d44e37f0b58dc4b2$export$2e2bcd8739ae039), x0 = null, y0, x1, y1, postclip = (0, $4702f1ccb7a48975$export$2e2bcd8739ae039), delta2 = 0.5, projectResample, projectTransform, projectRotateTransform, cache, cacheStream;
    function projection(point) {
        return projectRotateTransform(point[0] * (0, $8dcaf2b51049bed8$export$8449e153fbd325fc), point[1] * (0, $8dcaf2b51049bed8$export$8449e153fbd325fc));
    }
    function invert(point) {
        point = projectRotateTransform.invert(point[0], point[1]);
        return point && [
            point[0] * (0, $8dcaf2b51049bed8$export$41fc368e1a942b97),
            point[1] * (0, $8dcaf2b51049bed8$export$41fc368e1a942b97)
        ];
    }
    projection.stream = function(stream) {
        return cache && cacheStream === stream ? cache : cache = $3077c8206bce896e$var$transformRadians($3077c8206bce896e$var$transformRotate(rotate)(preclip(projectResample(postclip(cacheStream = stream)))));
    };
    projection.preclip = function(_) {
        return arguments.length ? (preclip = _, theta = undefined, reset()) : preclip;
    };
    projection.postclip = function(_) {
        return arguments.length ? (postclip = _, x0 = y0 = x1 = y1 = null, reset()) : postclip;
    };
    projection.clipAngle = function(_) {
        return arguments.length ? (preclip = +_ ? (0, $e0a68981870c73a9$export$2e2bcd8739ae039)(theta = _ * (0, $8dcaf2b51049bed8$export$8449e153fbd325fc)) : (theta = null, $d44e37f0b58dc4b2$export$2e2bcd8739ae039), reset()) : theta * (0, $8dcaf2b51049bed8$export$41fc368e1a942b97);
    };
    projection.clipExtent = function(_) {
        return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, $4702f1ccb7a48975$export$2e2bcd8739ae039) : (0, $b6a942874669ff0d$export$2e2bcd8739ae039)(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [
            [
                x0,
                y0
            ],
            [
                x1,
                y1
            ]
        ];
    };
    projection.scale = function(_) {
        return arguments.length ? (k = +_, recenter()) : k;
    };
    projection.translate = function(_) {
        return arguments.length ? (x = +_[0], y = +_[1], recenter()) : [
            x,
            y
        ];
    };
    projection.center = function(_) {
        return arguments.length ? (lambda = _[0] % 360 * (0, $8dcaf2b51049bed8$export$8449e153fbd325fc), phi = _[1] % 360 * (0, $8dcaf2b51049bed8$export$8449e153fbd325fc), recenter()) : [
            lambda * (0, $8dcaf2b51049bed8$export$41fc368e1a942b97),
            phi * (0, $8dcaf2b51049bed8$export$41fc368e1a942b97)
        ];
    };
    projection.rotate = function(_) {
        return arguments.length ? (deltaLambda = _[0] % 360 * (0, $8dcaf2b51049bed8$export$8449e153fbd325fc), deltaPhi = _[1] % 360 * (0, $8dcaf2b51049bed8$export$8449e153fbd325fc), deltaGamma = _.length > 2 ? _[2] % 360 * (0, $8dcaf2b51049bed8$export$8449e153fbd325fc) : 0, recenter()) : [
            deltaLambda * (0, $8dcaf2b51049bed8$export$41fc368e1a942b97),
            deltaPhi * (0, $8dcaf2b51049bed8$export$41fc368e1a942b97),
            deltaGamma * (0, $8dcaf2b51049bed8$export$41fc368e1a942b97)
        ];
    };
    projection.angle = function(_) {
        return arguments.length ? (alpha = _ % 360 * (0, $8dcaf2b51049bed8$export$8449e153fbd325fc), recenter()) : alpha * (0, $8dcaf2b51049bed8$export$41fc368e1a942b97);
    };
    projection.reflectX = function(_) {
        return arguments.length ? (sx = _ ? -1 : 1, recenter()) : sx < 0;
    };
    projection.reflectY = function(_) {
        return arguments.length ? (sy = _ ? -1 : 1, recenter()) : sy < 0;
    };
    projection.precision = function(_) {
        return arguments.length ? (projectResample = (0, $090ac3e89eb77df0$export$2e2bcd8739ae039)(projectTransform, delta2 = _ * _), reset()) : (0, $8dcaf2b51049bed8$export$eba8049fb5020b81)(delta2);
    };
    projection.fitExtent = function(extent, object) {
        return (0, $af875c78cc43d8f1$export$e450184041869e7f)(projection, extent, object);
    };
    projection.fitSize = function(size, object) {
        return (0, $af875c78cc43d8f1$export$33a367fa1728c3ba)(projection, size, object);
    };
    projection.fitWidth = function(width, object) {
        return (0, $af875c78cc43d8f1$export$7d8f2192ef31c5a7)(projection, width, object);
    };
    projection.fitHeight = function(height, object) {
        return (0, $af875c78cc43d8f1$export$7069bab0d2ced675)(projection, height, object);
    };
    function recenter() {
        var center = $3077c8206bce896e$var$scaleTranslateRotate(k, 0, 0, sx, sy, alpha).apply(null, project(lambda, phi)), transform = $3077c8206bce896e$var$scaleTranslateRotate(k, x - center[0], y - center[1], sx, sy, alpha);
        rotate = (0, $c6a139940504b724$export$a2ba89726971a90f)(deltaLambda, deltaPhi, deltaGamma);
        projectTransform = (0, $f130de3f0520d681$export$2e2bcd8739ae039)(project, transform);
        projectRotateTransform = (0, $f130de3f0520d681$export$2e2bcd8739ae039)(rotate, projectTransform);
        projectResample = (0, $090ac3e89eb77df0$export$2e2bcd8739ae039)(projectTransform, delta2);
        return reset();
    }
    function reset() {
        cache = cacheStream = null;
        return projection;
    }
    return function() {
        project = projectAt.apply(this, arguments);
        projection.invert = project.invert && invert;
        return recenter();
    };
}



var $6920b4746c3efc53$var$A1 = 1.340264, $6920b4746c3efc53$var$A2 = -0.081106, $6920b4746c3efc53$var$A3 = 0.000893, $6920b4746c3efc53$var$A4 = 0.003796, $6920b4746c3efc53$var$M = (0, $8dcaf2b51049bed8$export$eba8049fb5020b81)(3) / 2, $6920b4746c3efc53$var$iterations = 12;
function $6920b4746c3efc53$export$a320734067e7a731(lambda, phi) {
    var l = (0, $8dcaf2b51049bed8$export$41726bdb1fc63f)($6920b4746c3efc53$var$M * (0, $8dcaf2b51049bed8$export$5de3937cb4b592ed)(phi)), l2 = l * l, l6 = l2 * l2 * l2;
    return [
        lambda * (0, $8dcaf2b51049bed8$export$50d414a77b60d802)(l) / ($6920b4746c3efc53$var$M * ($6920b4746c3efc53$var$A1 + 3 * $6920b4746c3efc53$var$A2 * l2 + l6 * (7 * $6920b4746c3efc53$var$A3 + 9 * $6920b4746c3efc53$var$A4 * l2))),
        l * ($6920b4746c3efc53$var$A1 + $6920b4746c3efc53$var$A2 * l2 + l6 * ($6920b4746c3efc53$var$A3 + $6920b4746c3efc53$var$A4 * l2))
    ];
}
$6920b4746c3efc53$export$a320734067e7a731.invert = function(x, y) {
    var l = y, l2 = l * l, l6 = l2 * l2 * l2;
    for(var i = 0, delta, fy, fpy; i < $6920b4746c3efc53$var$iterations; ++i){
        fy = l * ($6920b4746c3efc53$var$A1 + $6920b4746c3efc53$var$A2 * l2 + l6 * ($6920b4746c3efc53$var$A3 + $6920b4746c3efc53$var$A4 * l2)) - y;
        fpy = $6920b4746c3efc53$var$A1 + 3 * $6920b4746c3efc53$var$A2 * l2 + l6 * (7 * $6920b4746c3efc53$var$A3 + 9 * $6920b4746c3efc53$var$A4 * l2);
        l -= delta = fy / fpy, l2 = l * l, l6 = l2 * l2 * l2;
        if ((0, $8dcaf2b51049bed8$export$2335f513bbd82c6d)(delta) < (0, $8dcaf2b51049bed8$export$92c06fba281fe81b)) break;
    }
    return [
        $6920b4746c3efc53$var$M * x * ($6920b4746c3efc53$var$A1 + 3 * $6920b4746c3efc53$var$A2 * l2 + l6 * (7 * $6920b4746c3efc53$var$A3 + 9 * $6920b4746c3efc53$var$A4 * l2)) / (0, $8dcaf2b51049bed8$export$50d414a77b60d802)(l),
        (0, $8dcaf2b51049bed8$export$41726bdb1fc63f)((0, $8dcaf2b51049bed8$export$5de3937cb4b592ed)(l) / $6920b4746c3efc53$var$M)
    ];
};
function $6920b4746c3efc53$export$2e2bcd8739ae039() {
    return (0, $3077c8206bce896e$export$2e2bcd8739ae039)($6920b4746c3efc53$export$a320734067e7a731).scale(177.158);
}






var $f79728593e1f0bbc$var$areaSum = new (0, $86babe4bf44a2b65$export$bda7ba77fb86c375)(), $f79728593e1f0bbc$var$areaRingSum = new (0, $86babe4bf44a2b65$export$bda7ba77fb86c375)(), $f79728593e1f0bbc$var$x00, $f79728593e1f0bbc$var$y00, $f79728593e1f0bbc$var$x0, $f79728593e1f0bbc$var$y0;
var $f79728593e1f0bbc$var$areaStream = {
    point: (0, $32a1340ec0955a5e$export$2e2bcd8739ae039),
    lineStart: (0, $32a1340ec0955a5e$export$2e2bcd8739ae039),
    lineEnd: (0, $32a1340ec0955a5e$export$2e2bcd8739ae039),
    polygonStart: function() {
        $f79728593e1f0bbc$var$areaStream.lineStart = $f79728593e1f0bbc$var$areaRingStart;
        $f79728593e1f0bbc$var$areaStream.lineEnd = $f79728593e1f0bbc$var$areaRingEnd;
    },
    polygonEnd: function() {
        $f79728593e1f0bbc$var$areaStream.lineStart = $f79728593e1f0bbc$var$areaStream.lineEnd = $f79728593e1f0bbc$var$areaStream.point = (0, $32a1340ec0955a5e$export$2e2bcd8739ae039);
        $f79728593e1f0bbc$var$areaSum.add((0, $8dcaf2b51049bed8$export$2335f513bbd82c6d)($f79728593e1f0bbc$var$areaRingSum));
        $f79728593e1f0bbc$var$areaRingSum = new (0, $86babe4bf44a2b65$export$bda7ba77fb86c375)();
    },
    result: function() {
        var area = $f79728593e1f0bbc$var$areaSum / 2;
        $f79728593e1f0bbc$var$areaSum = new (0, $86babe4bf44a2b65$export$bda7ba77fb86c375)();
        return area;
    }
};
function $f79728593e1f0bbc$var$areaRingStart() {
    $f79728593e1f0bbc$var$areaStream.point = $f79728593e1f0bbc$var$areaPointFirst;
}
function $f79728593e1f0bbc$var$areaPointFirst(x, y) {
    $f79728593e1f0bbc$var$areaStream.point = $f79728593e1f0bbc$var$areaPoint;
    $f79728593e1f0bbc$var$x00 = $f79728593e1f0bbc$var$x0 = x, $f79728593e1f0bbc$var$y00 = $f79728593e1f0bbc$var$y0 = y;
}
function $f79728593e1f0bbc$var$areaPoint(x, y) {
    $f79728593e1f0bbc$var$areaRingSum.add($f79728593e1f0bbc$var$y0 * x - $f79728593e1f0bbc$var$x0 * y);
    $f79728593e1f0bbc$var$x0 = x, $f79728593e1f0bbc$var$y0 = y;
}
function $f79728593e1f0bbc$var$areaRingEnd() {
    $f79728593e1f0bbc$var$areaPoint($f79728593e1f0bbc$var$x00, $f79728593e1f0bbc$var$y00);
}
var $f79728593e1f0bbc$export$2e2bcd8739ae039 = $f79728593e1f0bbc$var$areaStream;




// TODO Enforce positive area for exterior, negative area for interior?
var $77bbf77f52eea476$var$X0 = 0, $77bbf77f52eea476$var$Y0 = 0, $77bbf77f52eea476$var$Z0 = 0, $77bbf77f52eea476$var$X1 = 0, $77bbf77f52eea476$var$Y1 = 0, $77bbf77f52eea476$var$Z1 = 0, $77bbf77f52eea476$var$X2 = 0, $77bbf77f52eea476$var$Y2 = 0, $77bbf77f52eea476$var$Z2 = 0, $77bbf77f52eea476$var$x00, $77bbf77f52eea476$var$y00, $77bbf77f52eea476$var$x0, $77bbf77f52eea476$var$y0;
var $77bbf77f52eea476$var$centroidStream = {
    point: $77bbf77f52eea476$var$centroidPoint,
    lineStart: $77bbf77f52eea476$var$centroidLineStart,
    lineEnd: $77bbf77f52eea476$var$centroidLineEnd,
    polygonStart: function() {
        $77bbf77f52eea476$var$centroidStream.lineStart = $77bbf77f52eea476$var$centroidRingStart;
        $77bbf77f52eea476$var$centroidStream.lineEnd = $77bbf77f52eea476$var$centroidRingEnd;
    },
    polygonEnd: function() {
        $77bbf77f52eea476$var$centroidStream.point = $77bbf77f52eea476$var$centroidPoint;
        $77bbf77f52eea476$var$centroidStream.lineStart = $77bbf77f52eea476$var$centroidLineStart;
        $77bbf77f52eea476$var$centroidStream.lineEnd = $77bbf77f52eea476$var$centroidLineEnd;
    },
    result: function() {
        var centroid = $77bbf77f52eea476$var$Z2 ? [
            $77bbf77f52eea476$var$X2 / $77bbf77f52eea476$var$Z2,
            $77bbf77f52eea476$var$Y2 / $77bbf77f52eea476$var$Z2
        ] : $77bbf77f52eea476$var$Z1 ? [
            $77bbf77f52eea476$var$X1 / $77bbf77f52eea476$var$Z1,
            $77bbf77f52eea476$var$Y1 / $77bbf77f52eea476$var$Z1
        ] : $77bbf77f52eea476$var$Z0 ? [
            $77bbf77f52eea476$var$X0 / $77bbf77f52eea476$var$Z0,
            $77bbf77f52eea476$var$Y0 / $77bbf77f52eea476$var$Z0
        ] : [
            NaN,
            NaN
        ];
        $77bbf77f52eea476$var$X0 = $77bbf77f52eea476$var$Y0 = $77bbf77f52eea476$var$Z0 = $77bbf77f52eea476$var$X1 = $77bbf77f52eea476$var$Y1 = $77bbf77f52eea476$var$Z1 = $77bbf77f52eea476$var$X2 = $77bbf77f52eea476$var$Y2 = $77bbf77f52eea476$var$Z2 = 0;
        return centroid;
    }
};
function $77bbf77f52eea476$var$centroidPoint(x, y) {
    $77bbf77f52eea476$var$X0 += x;
    $77bbf77f52eea476$var$Y0 += y;
    ++$77bbf77f52eea476$var$Z0;
}
function $77bbf77f52eea476$var$centroidLineStart() {
    $77bbf77f52eea476$var$centroidStream.point = $77bbf77f52eea476$var$centroidPointFirstLine;
}
function $77bbf77f52eea476$var$centroidPointFirstLine(x, y) {
    $77bbf77f52eea476$var$centroidStream.point = $77bbf77f52eea476$var$centroidPointLine;
    $77bbf77f52eea476$var$centroidPoint($77bbf77f52eea476$var$x0 = x, $77bbf77f52eea476$var$y0 = y);
}
function $77bbf77f52eea476$var$centroidPointLine(x, y) {
    var dx = x - $77bbf77f52eea476$var$x0, dy = y - $77bbf77f52eea476$var$y0, z = (0, $8dcaf2b51049bed8$export$eba8049fb5020b81)(dx * dx + dy * dy);
    $77bbf77f52eea476$var$X1 += z * ($77bbf77f52eea476$var$x0 + x) / 2;
    $77bbf77f52eea476$var$Y1 += z * ($77bbf77f52eea476$var$y0 + y) / 2;
    $77bbf77f52eea476$var$Z1 += z;
    $77bbf77f52eea476$var$centroidPoint($77bbf77f52eea476$var$x0 = x, $77bbf77f52eea476$var$y0 = y);
}
function $77bbf77f52eea476$var$centroidLineEnd() {
    $77bbf77f52eea476$var$centroidStream.point = $77bbf77f52eea476$var$centroidPoint;
}
function $77bbf77f52eea476$var$centroidRingStart() {
    $77bbf77f52eea476$var$centroidStream.point = $77bbf77f52eea476$var$centroidPointFirstRing;
}
function $77bbf77f52eea476$var$centroidRingEnd() {
    $77bbf77f52eea476$var$centroidPointRing($77bbf77f52eea476$var$x00, $77bbf77f52eea476$var$y00);
}
function $77bbf77f52eea476$var$centroidPointFirstRing(x, y) {
    $77bbf77f52eea476$var$centroidStream.point = $77bbf77f52eea476$var$centroidPointRing;
    $77bbf77f52eea476$var$centroidPoint($77bbf77f52eea476$var$x00 = $77bbf77f52eea476$var$x0 = x, $77bbf77f52eea476$var$y00 = $77bbf77f52eea476$var$y0 = y);
}
function $77bbf77f52eea476$var$centroidPointRing(x, y) {
    var dx = x - $77bbf77f52eea476$var$x0, dy = y - $77bbf77f52eea476$var$y0, z = (0, $8dcaf2b51049bed8$export$eba8049fb5020b81)(dx * dx + dy * dy);
    $77bbf77f52eea476$var$X1 += z * ($77bbf77f52eea476$var$x0 + x) / 2;
    $77bbf77f52eea476$var$Y1 += z * ($77bbf77f52eea476$var$y0 + y) / 2;
    $77bbf77f52eea476$var$Z1 += z;
    z = $77bbf77f52eea476$var$y0 * x - $77bbf77f52eea476$var$x0 * y;
    $77bbf77f52eea476$var$X2 += z * ($77bbf77f52eea476$var$x0 + x);
    $77bbf77f52eea476$var$Y2 += z * ($77bbf77f52eea476$var$y0 + y);
    $77bbf77f52eea476$var$Z2 += z * 3;
    $77bbf77f52eea476$var$centroidPoint($77bbf77f52eea476$var$x0 = x, $77bbf77f52eea476$var$y0 = y);
}
var $77bbf77f52eea476$export$2e2bcd8739ae039 = $77bbf77f52eea476$var$centroidStream;




function $6a2ce26763a731b7$export$2e2bcd8739ae039(context) {
    this._context = context;
}
$6a2ce26763a731b7$export$2e2bcd8739ae039.prototype = {
    _radius: 4.5,
    pointRadius: function(_) {
        return this._radius = _, this;
    },
    polygonStart: function() {
        this._line = 0;
    },
    polygonEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line === 0) this._context.closePath();
        this._point = NaN;
    },
    point: function(x, y) {
        switch(this._point){
            case 0:
                this._context.moveTo(x, y);
                this._point = 1;
                break;
            case 1:
                this._context.lineTo(x, y);
                break;
            default:
                this._context.moveTo(x + this._radius, y);
                this._context.arc(x, y, this._radius, 0, (0, $8dcaf2b51049bed8$export$a4b4b4d4d776fe92));
                break;
        }
    },
    result: (0, $32a1340ec0955a5e$export$2e2bcd8739ae039)
};





var $572a4be4e0eb681a$var$lengthSum = new (0, $86babe4bf44a2b65$export$bda7ba77fb86c375)(), $572a4be4e0eb681a$var$lengthRing, $572a4be4e0eb681a$var$x00, $572a4be4e0eb681a$var$y00, $572a4be4e0eb681a$var$x0, $572a4be4e0eb681a$var$y0;
var $572a4be4e0eb681a$var$lengthStream = {
    point: (0, $32a1340ec0955a5e$export$2e2bcd8739ae039),
    lineStart: function() {
        $572a4be4e0eb681a$var$lengthStream.point = $572a4be4e0eb681a$var$lengthPointFirst;
    },
    lineEnd: function() {
        if ($572a4be4e0eb681a$var$lengthRing) $572a4be4e0eb681a$var$lengthPoint($572a4be4e0eb681a$var$x00, $572a4be4e0eb681a$var$y00);
        $572a4be4e0eb681a$var$lengthStream.point = (0, $32a1340ec0955a5e$export$2e2bcd8739ae039);
    },
    polygonStart: function() {
        $572a4be4e0eb681a$var$lengthRing = true;
    },
    polygonEnd: function() {
        $572a4be4e0eb681a$var$lengthRing = null;
    },
    result: function() {
        var length = +$572a4be4e0eb681a$var$lengthSum;
        $572a4be4e0eb681a$var$lengthSum = new (0, $86babe4bf44a2b65$export$bda7ba77fb86c375)();
        return length;
    }
};
function $572a4be4e0eb681a$var$lengthPointFirst(x, y) {
    $572a4be4e0eb681a$var$lengthStream.point = $572a4be4e0eb681a$var$lengthPoint;
    $572a4be4e0eb681a$var$x00 = $572a4be4e0eb681a$var$x0 = x, $572a4be4e0eb681a$var$y00 = $572a4be4e0eb681a$var$y0 = y;
}
function $572a4be4e0eb681a$var$lengthPoint(x, y) {
    $572a4be4e0eb681a$var$x0 -= x, $572a4be4e0eb681a$var$y0 -= y;
    $572a4be4e0eb681a$var$lengthSum.add((0, $8dcaf2b51049bed8$export$eba8049fb5020b81)($572a4be4e0eb681a$var$x0 * $572a4be4e0eb681a$var$x0 + $572a4be4e0eb681a$var$y0 * $572a4be4e0eb681a$var$y0));
    $572a4be4e0eb681a$var$x0 = x, $572a4be4e0eb681a$var$y0 = y;
}
var $572a4be4e0eb681a$export$2e2bcd8739ae039 = $572a4be4e0eb681a$var$lengthStream;


// Simple caching for constant-radius points.
let $b82dd087fc58879c$var$cacheDigits, $b82dd087fc58879c$var$cacheAppend, $b82dd087fc58879c$var$cacheRadius, $b82dd087fc58879c$var$cacheCircle;
class $b82dd087fc58879c$export$2e2bcd8739ae039 {
    constructor(digits){
        this._append = digits == null ? $b82dd087fc58879c$var$append : $b82dd087fc58879c$var$appendRound(digits);
        this._radius = 4.5;
        this._ = "";
    }
    pointRadius(_) {
        this._radius = +_;
        return this;
    }
    polygonStart() {
        this._line = 0;
    }
    polygonEnd() {
        this._line = NaN;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {
        if (this._line === 0) this._ += "Z";
        this._point = NaN;
    }
    point(x, y) {
        switch(this._point){
            case 0:
                this._append`M${x},${y}`;
                this._point = 1;
                break;
            case 1:
                this._append`L${x},${y}`;
                break;
            default:
                this._append`M${x},${y}`;
                if (this._radius !== $b82dd087fc58879c$var$cacheRadius || this._append !== $b82dd087fc58879c$var$cacheAppend) {
                    const r = this._radius;
                    const s = this._;
                    this._ = ""; // stash the old string so we can cache the circle path fragment
                    this._append`m0,${r}a${r},${r} 0 1,1 0,${-2 * r}a${r},${r} 0 1,1 0,${2 * r}z`;
                    $b82dd087fc58879c$var$cacheRadius = r;
                    $b82dd087fc58879c$var$cacheAppend = this._append;
                    $b82dd087fc58879c$var$cacheCircle = this._;
                    this._ = s;
                }
                this._ += $b82dd087fc58879c$var$cacheCircle;
                break;
        }
    }
    result() {
        const result = this._;
        this._ = "";
        return result.length ? result : null;
    }
}
function $b82dd087fc58879c$var$append(strings) {
    let i = 1;
    this._ += strings[0];
    for(const j = strings.length; i < j; ++i)this._ += arguments[i] + strings[i];
}
function $b82dd087fc58879c$var$appendRound(digits) {
    const d = Math.floor(digits);
    if (!(d >= 0)) throw new RangeError(`invalid digits: ${digits}`);
    if (d > 15) return $b82dd087fc58879c$var$append;
    if (d !== $b82dd087fc58879c$var$cacheDigits) {
        const k = 10 ** d;
        $b82dd087fc58879c$var$cacheDigits = d;
        $b82dd087fc58879c$var$cacheAppend = function append(strings) {
            let i = 1;
            this._ += strings[0];
            for(const j = strings.length; i < j; ++i)this._ += Math.round(arguments[i] * k) / k + strings[i];
        };
    }
    return $b82dd087fc58879c$var$cacheAppend;
}


function $579d9aa4a9bb134b$export$2e2bcd8739ae039(projection, context) {
    let digits = 3, pointRadius = 4.5, projectionStream, contextStream;
    function path(object) {
        if (object) {
            if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
            (0, $b23136d2ce68b531$export$2e2bcd8739ae039)(object, projectionStream(contextStream));
        }
        return contextStream.result();
    }
    path.area = function(object) {
        (0, $b23136d2ce68b531$export$2e2bcd8739ae039)(object, projectionStream((0, $f79728593e1f0bbc$export$2e2bcd8739ae039)));
        return (0, $f79728593e1f0bbc$export$2e2bcd8739ae039).result();
    };
    path.measure = function(object) {
        (0, $b23136d2ce68b531$export$2e2bcd8739ae039)(object, projectionStream((0, $572a4be4e0eb681a$export$2e2bcd8739ae039)));
        return (0, $572a4be4e0eb681a$export$2e2bcd8739ae039).result();
    };
    path.bounds = function(object) {
        (0, $b23136d2ce68b531$export$2e2bcd8739ae039)(object, projectionStream((0, $73514264e91fc979$export$2e2bcd8739ae039)));
        return (0, $73514264e91fc979$export$2e2bcd8739ae039).result();
    };
    path.centroid = function(object) {
        (0, $b23136d2ce68b531$export$2e2bcd8739ae039)(object, projectionStream((0, $77bbf77f52eea476$export$2e2bcd8739ae039)));
        return (0, $77bbf77f52eea476$export$2e2bcd8739ae039).result();
    };
    path.projection = function(_) {
        if (!arguments.length) return projection;
        projectionStream = _ == null ? (projection = null, $4702f1ccb7a48975$export$2e2bcd8739ae039) : (projection = _).stream;
        return path;
    };
    path.context = function(_) {
        if (!arguments.length) return context;
        contextStream = _ == null ? (context = null, new (0, $b82dd087fc58879c$export$2e2bcd8739ae039)(digits)) : new (0, $6a2ce26763a731b7$export$2e2bcd8739ae039)(context = _);
        if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
        return path;
    };
    path.pointRadius = function(_) {
        if (!arguments.length) return pointRadius;
        pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
        return path;
    };
    path.digits = function(_) {
        if (!arguments.length) return digits;
        if (_ == null) digits = null;
        else {
            const d = Math.floor(_);
            if (!(d >= 0)) throw new RangeError(`invalid digits: ${_}`);
            digits = d;
        }
        if (context === null) contextStream = new (0, $b82dd087fc58879c$export$2e2bcd8739ae039)(digits);
        return path;
    };
    return path.projection(projection).digits(digits).context(context);
}


const $dd23642c1f810c98$export$b74061472fe7c07 = (0, $6920b4746c3efc53$export$2e2bcd8739ae039)().translate([
    (0, $6ac94e7c3d018e58$export$80bdfe9d0febd31c) / 2,
    (0, $6ac94e7c3d018e58$export$d1ff6fea16bc8fb7) / 2
]).scale((0, $6ac94e7c3d018e58$export$4e69567e01df0578));
const $dd23642c1f810c98$export$bb654e07daaf8c3a = (0, $579d9aa4a9bb134b$export$2e2bcd8739ae039)().projection($dd23642c1f810c98$export$b74061472fe7c07);


function $07364892e19669ef$export$2e2bcd8739ae039({ latitude: latitude, longitude: longitude }) {
    const [x, y] = (0, $dd23642c1f810c98$export$b74061472fe7c07)([
        longitude,
        latitude
    ]);
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("g", {
        transform: `translate(${x}, ${y})`,
        children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("g", {
            fill: "none",
            stroke: "var(--color-highlight-default)",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "2",
            transform: "translate(-12, -24)",
            children: [
                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("circle", {
                    cx: "12",
                    cy: "10",
                    r: "3"
                }),
                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("path", {
                    d: "M12 21.7C17.3 17 20 13 20 10a8 8 0 1 0-16 0c0 3 2.7 6.9 8 11.7z"
                })
            ]
        })
    });
}


function $c30b69d51e214c2d$export$2e2bcd8739ae039(x) {
    return x;
}


function $792fd37d81dce5e0$export$2e2bcd8739ae039(transform) {
    if (transform == null) return 0, $c30b69d51e214c2d$export$2e2bcd8739ae039;
    var x0, y0, kx = transform.scale[0], ky = transform.scale[1], dx = transform.translate[0], dy = transform.translate[1];
    return function(input, i) {
        if (!i) x0 = y0 = 0;
        var j = 2, n = input.length, output = new Array(n);
        output[0] = (x0 += input[0]) * kx + dx;
        output[1] = (y0 += input[1]) * ky + dy;
        while(j < n)output[j] = input[j], ++j;
        return output;
    };
}


function $31bb31c72abadaf9$export$2e2bcd8739ae039(topology) {
    var t = (0, $792fd37d81dce5e0$export$2e2bcd8739ae039)(topology.transform), key, x0 = Infinity, y0 = x0, x1 = -x0, y1 = -x0;
    function bboxPoint(p) {
        p = t(p);
        if (p[0] < x0) x0 = p[0];
        if (p[0] > x1) x1 = p[0];
        if (p[1] < y0) y0 = p[1];
        if (p[1] > y1) y1 = p[1];
    }
    function bboxGeometry(o) {
        switch(o.type){
            case "GeometryCollection":
                o.geometries.forEach(bboxGeometry);
                break;
            case "Point":
                bboxPoint(o.coordinates);
                break;
            case "MultiPoint":
                o.coordinates.forEach(bboxPoint);
                break;
        }
    }
    topology.arcs.forEach(function(arc) {
        var i = -1, n = arc.length, p;
        while(++i < n){
            p = t(arc[i], i);
            if (p[0] < x0) x0 = p[0];
            if (p[0] > x1) x1 = p[0];
            if (p[1] < y0) y0 = p[1];
            if (p[1] > y1) y1 = p[1];
        }
    });
    for(key in topology.objects)bboxGeometry(topology.objects[key]);
    return [
        x0,
        y0,
        x1,
        y1
    ];
}


function $2d69956138778748$export$2e2bcd8739ae039(array, n) {
    var t, j = array.length, i = j - n;
    while(i < --j)t = array[i], array[i++] = array[j], array[j] = t;
}



function $19b2ab9d9047e93f$export$2e2bcd8739ae039(topology, o) {
    if (typeof o === "string") o = topology.objects[o];
    return o.type === "GeometryCollection" ? {
        type: "FeatureCollection",
        features: o.geometries.map(function(o) {
            return $19b2ab9d9047e93f$var$feature(topology, o);
        })
    } : $19b2ab9d9047e93f$var$feature(topology, o);
}
function $19b2ab9d9047e93f$var$feature(topology, o) {
    var id = o.id, bbox = o.bbox, properties = o.properties == null ? {} : o.properties, geometry = $19b2ab9d9047e93f$export$be5493f9613cbbe(topology, o);
    return id == null && bbox == null ? {
        type: "Feature",
        properties: properties,
        geometry: geometry
    } : bbox == null ? {
        type: "Feature",
        id: id,
        properties: properties,
        geometry: geometry
    } : {
        type: "Feature",
        id: id,
        bbox: bbox,
        properties: properties,
        geometry: geometry
    };
}
function $19b2ab9d9047e93f$export$be5493f9613cbbe(topology, o) {
    var transformPoint = (0, $792fd37d81dce5e0$export$2e2bcd8739ae039)(topology.transform), arcs = topology.arcs;
    function arc(i, points) {
        if (points.length) points.pop();
        for(var a = arcs[i < 0 ? ~i : i], k = 0, n = a.length; k < n; ++k)points.push(transformPoint(a[k], k));
        if (i < 0) (0, $2d69956138778748$export$2e2bcd8739ae039)(points, n);
    }
    function point(p) {
        return transformPoint(p);
    }
    function line(arcs) {
        var points = [];
        for(var i = 0, n = arcs.length; i < n; ++i)arc(arcs[i], points);
        if (points.length < 2) points.push(points[0]); // This should never happen per the specification.
        return points;
    }
    function ring(arcs) {
        var points = line(arcs);
        while(points.length < 4)points.push(points[0]); // This may happen if an arc has only two points.
        return points;
    }
    function polygon(arcs) {
        return arcs.map(ring);
    }
    function geometry(o) {
        var type = o.type, coordinates;
        switch(type){
            case "GeometryCollection":
                return {
                    type: type,
                    geometries: o.geometries.map(geometry)
                };
            case "Point":
                coordinates = point(o.coordinates);
                break;
            case "MultiPoint":
                coordinates = o.coordinates.map(point);
                break;
            case "LineString":
                coordinates = line(o.arcs);
                break;
            case "MultiLineString":
                coordinates = o.arcs.map(line);
                break;
            case "Polygon":
                coordinates = polygon(o.arcs);
                break;
            case "MultiPolygon":
                coordinates = o.arcs.map(polygon);
                break;
            default:
                return null;
        }
        return {
            type: type,
            coordinates: coordinates
        };
    }
    return geometry(o);
}



function $36cfd745ada8b686$export$2e2bcd8739ae039(topology, arcs) {
    var stitchedArcs = {}, fragmentByStart = {}, fragmentByEnd = {}, fragments = [], emptyIndex = -1;
    // Stitch empty arcs first, since they may be subsumed by other arcs.
    arcs.forEach(function(i, j) {
        var arc = topology.arcs[i < 0 ? ~i : i], t;
        if (arc.length < 3 && !arc[1][0] && !arc[1][1]) t = arcs[++emptyIndex], arcs[emptyIndex] = i, arcs[j] = t;
    });
    arcs.forEach(function(i) {
        var e = ends(i), start = e[0], end = e[1], f, g;
        if (f = fragmentByEnd[start]) {
            delete fragmentByEnd[f.end];
            f.push(i);
            f.end = end;
            if (g = fragmentByStart[end]) {
                delete fragmentByStart[g.start];
                var fg = g === f ? f : f.concat(g);
                fragmentByStart[fg.start = f.start] = fragmentByEnd[fg.end = g.end] = fg;
            } else fragmentByStart[f.start] = fragmentByEnd[f.end] = f;
        } else if (f = fragmentByStart[end]) {
            delete fragmentByStart[f.start];
            f.unshift(i);
            f.start = start;
            if (g = fragmentByEnd[start]) {
                delete fragmentByEnd[g.end];
                var gf = g === f ? f : g.concat(f);
                fragmentByStart[gf.start = g.start] = fragmentByEnd[gf.end = f.end] = gf;
            } else fragmentByStart[f.start] = fragmentByEnd[f.end] = f;
        } else {
            f = [
                i
            ];
            fragmentByStart[f.start = start] = fragmentByEnd[f.end = end] = f;
        }
    });
    function ends(i) {
        var arc = topology.arcs[i < 0 ? ~i : i], p0 = arc[0], p1;
        if (topology.transform) p1 = [
            0,
            0
        ], arc.forEach(function(dp) {
            p1[0] += dp[0], p1[1] += dp[1];
        });
        else p1 = arc[arc.length - 1];
        return i < 0 ? [
            p1,
            p0
        ] : [
            p0,
            p1
        ];
    }
    function flush(fragmentByEnd, fragmentByStart) {
        for(var k in fragmentByEnd){
            var f = fragmentByEnd[k];
            delete fragmentByStart[f.start];
            delete f.start;
            delete f.end;
            f.forEach(function(i) {
                stitchedArcs[i < 0 ? ~i : i] = 1;
            });
            fragments.push(f);
        }
    }
    flush(fragmentByEnd, fragmentByStart);
    flush(fragmentByStart, fragmentByEnd);
    arcs.forEach(function(i) {
        if (!stitchedArcs[i < 0 ? ~i : i]) fragments.push([
            i
        ]);
    });
    return fragments;
}


function $a7c7e3a081e3de34$export$2e2bcd8739ae039(topology) {
    return (0, $19b2ab9d9047e93f$export$be5493f9613cbbe)(topology, $a7c7e3a081e3de34$export$fc3815c78e52e7d6.apply(this, arguments));
}
function $a7c7e3a081e3de34$export$fc3815c78e52e7d6(topology, object, filter) {
    var arcs, i, n;
    if (arguments.length > 1) arcs = $a7c7e3a081e3de34$var$extractArcs(topology, object, filter);
    else for(i = 0, arcs = new Array(n = topology.arcs.length); i < n; ++i)arcs[i] = i;
    return {
        type: "MultiLineString",
        arcs: (0, $36cfd745ada8b686$export$2e2bcd8739ae039)(topology, arcs)
    };
}
function $a7c7e3a081e3de34$var$extractArcs(topology, object, filter) {
    var arcs = [], geomsByArc = [], geom;
    function extract0(i) {
        var j = i < 0 ? ~i : i;
        (geomsByArc[j] || (geomsByArc[j] = [])).push({
            i: i,
            g: geom
        });
    }
    function extract1(arcs) {
        arcs.forEach(extract0);
    }
    function extract2(arcs) {
        arcs.forEach(extract1);
    }
    function extract3(arcs) {
        arcs.forEach(extract2);
    }
    function geometry(o) {
        switch(geom = o, o.type){
            case "GeometryCollection":
                o.geometries.forEach(geometry);
                break;
            case "LineString":
                extract1(o.arcs);
                break;
            case "MultiLineString":
            case "Polygon":
                extract2(o.arcs);
                break;
            case "MultiPolygon":
                extract3(o.arcs);
                break;
        }
    }
    geometry(object);
    geomsByArc.forEach(filter == null ? function(geoms) {
        arcs.push(geoms[0].i);
    } : function(geoms) {
        if (filter(geoms[0].g, geoms[geoms.length - 1].g)) arcs.push(geoms[0].i);
    });
    return arcs;
}




function $edfbfc40e61d39c2$var$planarRingArea(ring) {
    var i = -1, n = ring.length, a, b = ring[n - 1], area = 0;
    while(++i < n)a = b, b = ring[i], area += a[0] * b[1] - a[1] * b[0];
    return Math.abs(area); // Note: doubled area!
}
function $edfbfc40e61d39c2$export$2e2bcd8739ae039(topology) {
    return (0, $19b2ab9d9047e93f$export$be5493f9613cbbe)(topology, $edfbfc40e61d39c2$export$fa52272cf7935962.apply(this, arguments));
}
function $edfbfc40e61d39c2$export$fa52272cf7935962(topology, objects) {
    var polygonsByArc = {}, polygons = [], groups = [];
    objects.forEach(geometry);
    function geometry(o) {
        switch(o.type){
            case "GeometryCollection":
                o.geometries.forEach(geometry);
                break;
            case "Polygon":
                extract(o.arcs);
                break;
            case "MultiPolygon":
                o.arcs.forEach(extract);
                break;
        }
    }
    function extract(polygon) {
        polygon.forEach(function(ring) {
            ring.forEach(function(arc) {
                (polygonsByArc[arc = arc < 0 ? ~arc : arc] || (polygonsByArc[arc] = [])).push(polygon);
            });
        });
        polygons.push(polygon);
    }
    function area(ring) {
        return $edfbfc40e61d39c2$var$planarRingArea((0, $19b2ab9d9047e93f$export$be5493f9613cbbe)(topology, {
            type: "Polygon",
            arcs: [
                ring
            ]
        }).coordinates[0]);
    }
    polygons.forEach(function(polygon) {
        if (!polygon._) {
            var group = [], neighbors = [
                polygon
            ];
            polygon._ = 1;
            groups.push(group);
            while(polygon = neighbors.pop()){
                group.push(polygon);
                polygon.forEach(function(ring) {
                    ring.forEach(function(arc) {
                        polygonsByArc[arc < 0 ? ~arc : arc].forEach(function(polygon) {
                            if (!polygon._) {
                                polygon._ = 1;
                                neighbors.push(polygon);
                            }
                        });
                    });
                });
            }
        }
    });
    polygons.forEach(function(polygon) {
        delete polygon._;
    });
    return {
        type: "MultiPolygon",
        arcs: groups.map(function(polygons) {
            var arcs = [], n;
            // Extract the exterior (unique) arcs.
            polygons.forEach(function(polygon) {
                polygon.forEach(function(ring) {
                    ring.forEach(function(arc) {
                        if (polygonsByArc[arc < 0 ? ~arc : arc].length < 2) arcs.push(arc);
                    });
                });
            });
            // Stitch the arcs into one or more rings.
            arcs = (0, $36cfd745ada8b686$export$2e2bcd8739ae039)(topology, arcs);
            // If more than one ring is returned,
            // at most one of these rings can be the exterior;
            // choose the one with the greatest absolute area.
            if ((n = arcs.length) > 1) {
                for(var i = 1, k = area(arcs[0]), ki, t; i < n; ++i)if ((ki = area(arcs[i])) > k) t = arcs[0], arcs[0] = arcs[i], arcs[i] = t, k = ki;
            }
            return arcs;
        }).filter(function(arcs) {
            return arcs.length > 0;
        })
    };
}


function $aa9a878fc9e1bee1$export$2e2bcd8739ae039(a, x) {
    var lo = 0, hi = a.length;
    while(lo < hi){
        var mid = lo + hi >>> 1;
        if (a[mid] < x) lo = mid + 1;
        else hi = mid;
    }
    return lo;
}


function $b05044cec75ed2a0$export$2e2bcd8739ae039(objects) {
    var indexesByArc = {}, neighbors = objects.map(function() {
        return [];
    });
    function line(arcs, i) {
        arcs.forEach(function(a) {
            if (a < 0) a = ~a;
            var o = indexesByArc[a];
            if (o) o.push(i);
            else indexesByArc[a] = [
                i
            ];
        });
    }
    function polygon(arcs, i) {
        arcs.forEach(function(arc) {
            line(arc, i);
        });
    }
    function geometry(o, i) {
        if (o.type === "GeometryCollection") o.geometries.forEach(function(o) {
            geometry(o, i);
        });
        else if (o.type in geometryType) geometryType[o.type](o.arcs, i);
    }
    var geometryType = {
        LineString: line,
        MultiLineString: polygon,
        Polygon: polygon,
        MultiPolygon: function(arcs, i) {
            arcs.forEach(function(arc) {
                polygon(arc, i);
            });
        }
    };
    objects.forEach(geometry);
    for(var i in indexesByArc){
        for(var indexes = indexesByArc[i], m = indexes.length, j = 0; j < m; ++j)for(var k = j + 1; k < m; ++k){
            var ij = indexes[j], ik = indexes[k], n;
            if ((n = neighbors[ij])[i = (0, $aa9a878fc9e1bee1$export$2e2bcd8739ae039)(n, ik)] !== ik) n.splice(i, 0, ik);
            if ((n = neighbors[ik])[i = (0, $aa9a878fc9e1bee1$export$2e2bcd8739ae039)(n, ij)] !== ij) n.splice(i, 0, ij);
        }
    }
    return neighbors;
}




function $761d81e5076de18f$export$2e2bcd8739ae039(transform) {
    if (transform == null) return 0, $c30b69d51e214c2d$export$2e2bcd8739ae039;
    var x0, y0, kx = transform.scale[0], ky = transform.scale[1], dx = transform.translate[0], dy = transform.translate[1];
    return function(input, i) {
        if (!i) x0 = y0 = 0;
        var j = 2, n = input.length, output = new Array(n), x1 = Math.round((input[0] - dx) / kx), y1 = Math.round((input[1] - dy) / ky);
        output[0] = x1 - x0, x0 = x1;
        output[1] = y1 - y0, y0 = y1;
        while(j < n)output[j] = input[j], ++j;
        return output;
    };
}


function $74fca02ae7289dd8$export$2e2bcd8739ae039(topology, transform) {
    if (topology.transform) throw new Error("already quantized");
    if (!transform || !transform.scale) {
        if (!((n = Math.floor(transform)) >= 2)) throw new Error("n must be \u22652");
        box = topology.bbox || (0, $31bb31c72abadaf9$export$2e2bcd8739ae039)(topology);
        var x0 = box[0], y0 = box[1], x1 = box[2], y1 = box[3], n;
        transform = {
            scale: [
                x1 - x0 ? (x1 - x0) / (n - 1) : 1,
                y1 - y0 ? (y1 - y0) / (n - 1) : 1
            ],
            translate: [
                x0,
                y0
            ]
        };
    } else box = topology.bbox;
    var t = (0, $761d81e5076de18f$export$2e2bcd8739ae039)(transform), box, key, inputs = topology.objects, outputs = {};
    function quantizePoint(point) {
        return t(point);
    }
    function quantizeGeometry(input) {
        var output;
        switch(input.type){
            case "GeometryCollection":
                output = {
                    type: "GeometryCollection",
                    geometries: input.geometries.map(quantizeGeometry)
                };
                break;
            case "Point":
                output = {
                    type: "Point",
                    coordinates: quantizePoint(input.coordinates)
                };
                break;
            case "MultiPoint":
                output = {
                    type: "MultiPoint",
                    coordinates: input.coordinates.map(quantizePoint)
                };
                break;
            default:
                return input;
        }
        if (input.id != null) output.id = input.id;
        if (input.bbox != null) output.bbox = input.bbox;
        if (input.properties != null) output.properties = input.properties;
        return output;
    }
    function quantizeArc(input) {
        var i = 0, j = 1, n = input.length, p, output = new Array(n); // pessimistic
        output[0] = t(input[0], 0);
        while(++i < n)if ((p = t(input[i], i))[0] || p[1]) output[j++] = p; // non-coincident points
        if (j === 1) output[j++] = [
            0,
            0
        ]; // an arc must have at least two points
        output.length = j;
        return output;
    }
    for(key in inputs)outputs[key] = quantizeGeometry(inputs[key]);
    return {
        type: "Topology",
        bbox: box,
        transform: transform,
        objects: outputs,
        arcs: topology.arcs.map(quantizeArc)
    };
}







var $a149e277f7dc0241$exports = {};
$a149e277f7dc0241$exports = JSON.parse('{"type":"Topology","arcs":[[[16814,15074],[71,-45],[53,16],[15,54],[55,18],[39,37],[14,95],[59,24],[11,42],[32,-32],[21,-3]],[[17184,15280],[39,-1],[53,-26]],[[17276,15253],[21,-14],[51,38],[23,-23],[23,55],[41,-2],[11,17],[7,49],[30,41],[38,-27],[-8,-37],[22,-5],[-7,-101],[28,-39],[24,25],[31,12],[43,53],[48,-8],[72,-1]],[[17774,15286],[13,-34]],[[17787,15252],[-41,-13],[-35,-23],[-80,-14],[-75,-25],[-41,-52],[17,-51],[8,-60],[-35,-50],[3,-46],[-19,-43],[-67,4],[28,-80],[-45,-30],[-29,-73],[4,-72],[-28,-33],[-26,11],[-53,-16],[-7,-33],[-52,0],[-39,-68],[-3,-102],[-90,-50],[-49,10],[-14,-26],[-42,15],[-69,-17],[-117,61]],[[16791,14376],[63,109],[-6,77],[-52,20],[-6,76],[-23,96],[30,66],[-30,17],[19,88],[28,149]],[[14166,8695],[-128,-49],[-169,17],[-48,58],[-283,-6],[-11,-8],[-41,54],[-45,4],[-42,-21],[-34,-22]],[[13365,8722],[-6,75],[10,105],[24,110],[3,52],[23,108],[16,49],[41,79],[22,53],[7,89],[-3,68],[-21,43],[-19,72],[-17,72],[4,25],[21,48],[-21,116],[-14,80],[-35,76],[6,23]],[[13406,10065],[29,16],[20,-2],[25,15],[206,-2],[17,-89],[20,-72],[16,-39],[27,-63],[46,10],[23,17],[38,-17],[11,30],[17,70],[43,4],[4,21],[36,1],[-6,-44],[84,2],[1,-76],[15,-46],[-11,-73],[5,-73],[24,-45],[-4,-143],[17,11],[30,-3],[44,18],[31,-7]],[[14214,9486],[8,-37],[-8,-58],[12,-56],[-10,-45],[6,-42],[-146,2],[-3,-382],[47,-98],[46,-75]],[[13397,10103],[-19,90]],[[13378,10193],[28,52],[21,20],[26,-41]],[[13453,10224],[-25,-26],[-11,-30],[-3,-53],[-17,-12]],[[14013,15697],[-2,-31],[-22,-18],[-4,-39],[-33,-58]],[[13952,15551],[-12,8],[-1,27],[-39,40],[-6,57],[6,82],[10,37],[-12,19]],[[13898,15821],[-5,38],[30,59],[5,-22],[19,11]],[[13947,15907],[14,-33],[17,-12],[5,-43]],[[13983,15819],[-9,-41],[10,-52],[29,-29]],[[16143,13706],[12,6],[3,-33],[55,19],[57,-3],[42,-4],[48,81],[52,77],[44,74]],[[16456,13923],[13,-41]],[[16469,13882],[10,-95]],[[16479,13787],[-36,0],[-5,-78],[12,-17],[-32,-24],[0,-49],[-20,-49],[-2,-49]],[[16396,13521],[-14,-25],[-210,61],[-26,121],[-3,28]],[[7880,4211],[-42,4],[-75,0],[0,267]],[[7763,4482],[27,-55],[35,-90],[90,-72],[98,-30],[-31,-60],[-67,-6],[-35,42]],[[7767,4523],[-64,19],[-169,16],[-28,70],[1,90],[-47,-8],[-24,43],[-6,128],[53,52],[22,76],[-8,61],[37,102],[26,159],[-8,71],[31,22],[-8,46],[-32,24],[23,50],[-32,46],[-16,138],[28,24],[-12,147],[17,122],[18,107],[42,44],[-21,117],[0,110],[52,79],[-1,100],[40,117],[0,110],[-18,22],[-32,207],[43,124],[-7,116],[25,109],[46,113],[49,74],[-21,47],[14,39],[-2,200],[76,59],[24,125],[-8,30]],[[7870,8070],[58,108],[91,-29],[41,-87],[27,97],[80,-5],[11,-26]],[[8178,8128],[128,-196],[57,-18],[85,-89],[72,-47],[10,-52],[-69,-183],[71,-32],[78,-19],[55,20],[63,91],[12,106]],[[8740,7709],[34,23],[35,-69],[-1,-96],[-59,-66],[-47,-49],[-78,-116],[-93,-164]],[[8531,7172],[-18,-96],[-19,-123],[1,-120],[-15,-26],[-5,-78]],[[8475,6729],[-5,-63],[88,-102],[-9,-83],[43,-52],[-3,-59],[-67,-154],[-103,-64],[-140,-25],[-77,12],[15,-71],[-14,-90],[12,-61],[-41,-42],[-72,-17],[-67,44],[-27,-31],[10,-119],[47,-37],[38,38],[21,-62],[-64,-37],[-56,-75],[-10,-121],[-17,-64],[-66,0],[-54,-62],[-20,-90],[68,-87],[67,-25],[-24,-107],[-83,-68],[-45,-141],[-63,-47],[-29,-56],[22,-125],[47,-69],[-30,6]],[[15586,15727],[96,19]],[[15682,15746],[15,-32],[26,-21],[-14,-30],[38,-41],[-20,-38],[29,-33],[32,-19],[1,-84]],[[15789,15448],[-25,-3]],[[15764,15445],[-28,69],[0,19],[-31,0],[-20,32],[-15,-3]],[[15670,15562],[-27,35],[-52,29],[6,59],[-11,42]],[[8395,1195],[-21,-61],[-20,-54],[-146,16],[-156,-7],[-87,40],[0,5],[-38,35],[157,-5],[150,-11],[52,49],[36,42],[73,-49]],[[1449,1260],[-133,-16],[-92,42],[-41,42],[-3,7],[-45,33],[43,45],[129,-19],[70,-38],[53,-42],[19,-54]],[[9400,1434],[86,-52],[30,-73],[8,-51],[3,-61],[-108,-38],[-113,-31],[-131,-28],[-147,-23],[-165,7],[-91,40],[12,49],[149,33],[60,40],[44,52],[31,44],[42,43],[45,49],[36,0],[104,26],[105,-26]],[[4098,1979],[90,-18],[83,21],[-39,-43],[-66,-30],[-97,9],[-69,43],[15,40],[83,-22]],[[3795,1982],[106,-47],[-41,4],[-90,12],[-95,33],[50,26],[70,-28]],[[5648,2167],[76,-16],[77,14],[41,-68],[-55,9],[-85,-4],[-86,4],[-94,-7],[-71,24],[-37,49],[44,21],[89,-16],[101,-10]],[[7776,2285],[8,-54],[-12,-47],[-19,-45],[-82,-16],[-78,-24],[-92,2],[35,47],[-82,-16],[-78,-17],[-53,36],[-5,49],[77,47],[48,14],[80,-5],[21,62],[4,44],[-2,97],[40,56],[64,19],[37,-45],[17,-44],[30,-55],[23,-51],[19,-54]],[[8462,3101],[-30,-26],[-52,19],[-58,-12],[-47,-28],[-51,-31],[-34,-35],[-10,-47],[4,-45],[33,-40],[-48,-28],[-65,-9],[-38,-40],[-41,-38],[-44,-51],[-11,-45],[25,-50],[37,-37],[57,-28],[53,-38],[29,-47],[15,-45],[20,-47],[33,-40],[21,-44],[9,-111],[21,-44],[5,-47],[22,-47],[-10,-64],[-38,-49],[-41,-40],[-93,-17],[-31,-42],[-42,-40],[-106,-45],[-92,-18],[-88,-26],[-94,-26],[-56,-50],[-112,-4],[-123,4],[-110,-9],[-118,0],[22,-47],[107,-21],[77,-33],[44,-42],[-78,-38],[-120,12],[-100,-31],[-4,-49],[-2,-47],[82,-40],[15,-45],[88,-44],[148,-19],[125,-33],[100,-38],[127,-37],[173,-19],[171,-33],[119,-35],[130,-40],[68,-57],[34,-44],[85,42],[114,35],[122,38],[144,30],[125,33],[173,3],[171,-17],[140,-28],[45,52],[97,35],[177,2],[137,26],[131,26],[145,16],[154,22],[108,30],[-49,42],[-30,43],[0,44],[-135,-4],[-143,-19],[-137,0],[-19,45],[10,89],[31,26],[100,28],[117,28],[85,35],[84,36],[63,47],[96,21],[94,16],[48,10],[108,4],[102,17],[86,23],[85,29],[76,28],[97,37],[61,40],[66,36],[20,47],[-73,28],[24,49],[47,38],[72,23],[77,29],[71,37],[54,47],[34,57],[51,33],[83,-7],[34,-40],[83,-5],[3,45],[36,47],[75,-12],[18,-45],[83,-7],[90,21],[87,14],[80,-7],[30,-49],[76,40],[71,21],[79,16],[78,17],[71,28],[78,19],[60,26],[42,42],[52,-30],[72,16],[51,-56],[40,-43],[79,24],[31,47],[71,33],[92,-7],[27,-45],[57,45],[75,14],[82,4],[74,-2],[78,-14],[75,-7],[33,-40],[45,-35],[76,21],[82,5],[79,0],[78,2],[70,16],[74,15],[61,32],[65,22],[71,11],[54,33],[38,66],[40,40],[72,-19],[27,-42],[60,-28],[73,9],[49,-42],[52,-31],[71,28],[24,52],[63,21],[72,40],[69,17],[82,23],[54,26],[58,28],[54,26],[66,-14],[63,42],[45,33],[65,-2],[57,28],[14,42],[59,33],[57,24],[70,19],[64,9],[61,-7],[66,-12],[56,-33],[7,-51],[61,-40],[42,-33],[84,-14],[46,-33],[58,-33],[66,-7],[56,23],[60,50],[66,-26],[68,-14],[66,-14],[68,-10],[70,0],[57,-124],[-3,-31],[-8,-54],[-67,-31],[-54,-44],[9,-47],[78,2],[-10,-47],[-35,-45],[-33,-49],[53,-38],[81,-11],[81,21],[38,47],[23,45],[38,37],[44,35],[18,43],[36,58],[44,12],[79,5],[70,14],[71,19],[34,47],[21,45],[47,44],[69,31],[58,23],[39,40],[39,21],[51,19],[69,-12],[63,12],[68,14],[77,-7],[50,33],[36,80],[26,-33],[33,-56],[58,-24],[67,-9],[67,14],[71,-9],[66,-3],[43,12],[59,-7],[53,-26],[63,16],[75,0],[64,17],[73,-17],[46,40],[36,40],[47,33],[88,90],[45,-17],[53,-33],[46,-42],[89,-73],[69,-2],[64,0],[75,14],[75,16],[57,33],[48,35],[78,5],[52,26],[54,-23],[36,-38],[49,-38],[76,5],[48,-31],[83,-30],[88,-12],[72,10],[55,37],[46,38],[63,9],[63,-16],[72,-12],[66,19],[63,0],[61,-12],[64,-12],[63,21],[75,19],[71,5],[79,0],[64,12],[63,9],[19,59],[3,49],[44,-33],[12,-54],[23,-49],[29,-40],[59,-21],[79,7],[91,2],[63,7],[92,0],[65,3],[92,-5],[77,-10],[50,-37],[-14,-45],[45,-35],[75,-28],[78,-31],[90,-21],[94,-19],[71,-19],[79,-2],[45,40],[62,-33],[53,-38],[62,-28],[84,-12],[81,-14],[34,-47],[79,-28],[53,-42],[78,-19],[81,2],[75,-7],[83,3],[83,-10],[78,-16],[73,-28],[72,-24],[49,-35],[-8,-47],[-37,-42],[-31,-55],[-25,-42],[-33,-49],[-91,-19],[-41,-42],[-90,-26],[-32,-47],[-47,-45],[-51,-38],[-29,-49],[-17,-45],[-7,-54],[1,-44],[40,-47],[15,-45],[32,-42],[130,-17],[27,-51],[-125,-19],[-107,-26],[-132,-5],[-59,-68],[-12,-56],[-30,-45],[-37,-45],[93,-40],[35,-49],[60,-45],[85,-40],[97,-37],[105,-38],[160,-38],[35,-58],[201,-26],[14,-9],[52,-36],[192,31],[160,-38],[120,-29],[0,-634],[-25095,0],[0,634],[4,-1],[62,70],[125,-38],[8,5],[74,38],[10,-1],[8,-1],[101,-50],[88,50],[16,6],[204,22],[67,-28],[33,-15],[105,-40],[198,-30],[157,-38],[269,-28],[200,33],[297,-24],[168,-37],[184,35],[194,33],[15,56],[-275,5],[-225,28],[-59,47],[-187,26],[13,54],[25,50],[26,44],[-13,50],[-116,33],[-54,42],[-107,37],[169,-7],[161,19],[101,-40],[124,36],[115,44],[56,40],[-25,50],[-90,32],[-102,36],[-143,7],[-126,16],[-135,12],[-45,45],[-90,37],[-55,43],[-22,136],[34,-12],[63,-37],[115,11],[110,17],[58,-52],[110,12],[93,26],[87,33],[80,39],[105,12],[-3,45],[-24,45],[20,42],[90,21],[41,-40],[107,24],[80,30],[100,3],[94,11],[94,28],[75,26],[85,26],[55,-7],[47,-9],[104,16],[93,-21],[95,2],[92,17],[94,-12],[104,-12],[97,5],[101,-2],[104,-3],[95,5],[71,35],[85,19],[87,-26],[84,21],[75,43],[45,-38],[24,-42],[45,-40],[73,35],[83,-45],[94,-14],[81,-33],[98,7],[89,22],[105,-5],[94,-17],[96,-21],[37,52],[-46,40],[-34,42],[-90,10],[-39,44],[-15,45],[-25,89],[53,-16],[92,-7],[90,7],[82,-19],[71,-35],[30,-42],[94,-8],[90,17],[96,23],[86,15],[71,-29],[93,10],[60,91],[56,-54],[80,-21],[88,12],[57,-47],[91,-5],[85,-14],[83,-26],[55,45],[27,42],[70,-47],[95,12],[71,-26],[48,-40],[93,12],[72,26],[71,30],[85,17],[98,14],[89,16],[68,26],[41,38],[17,52],[-8,49],[-22,47],[-25,47],[-22,47],[-18,42],[-4,47],[7,47],[33,45],[27,49],[11,47],[-13,52],[-9,47],[35,54],[38,35],[45,45],[48,38],[56,35],[27,52],[38,33],[44,30],[67,7],[43,38],[50,23],[57,14],[50,31],[40,38],[55,14],[41,-31],[-26,-40],[-71,-35]],[[17353,4964],[45,-38],[66,-15],[2,-23],[-19,-54],[-107,-8],[-2,64],[10,49],[5,25]],[[22683,5903],[67,-41],[38,16],[55,23],[41,-8],[5,-142],[-23,-41],[-8,-97],[-24,33],[-48,-84],[-15,7],[-43,4],[-43,102],[-9,79],[-40,105],[1,55],[46,-11]],[[22555,9146],[25,-94],[45,45],[23,-51],[33,-47],[-7,-53],[15,-103],[11,-59],[17,-15],[19,-103],[-7,-62],[23,-81],[75,-63],[50,-57],[46,-52],[-9,-29],[40,-75],[27,-130],[28,26],[28,-52],[17,19],[12,-128],[50,-73],[32,-46],[55,-97],[19,-97],[2,-68],[-5,-74],[34,-102],[-4,-106],[-12,-56],[-19,-107],[1,-69],[-14,-86],[-30,-109],[-52,-59],[-26,-93],[-23,-59],[-20,-104],[-27,-59],[-18,-90],[-9,-83],[4,-38],[-40,-41],[-78,-5],[-65,-49],[-32,-46],[-42,-52],[-58,53],[-42,21],[10,63],[-38,-23],[-61,-87],[-60,33],[-39,19],[-40,8],[-68,35],[-45,74],[-13,91],[-16,61],[-34,48],[-67,15],[23,58],[-17,89],[-34,-83],[-62,-22],[36,66],[11,70],[27,58],[-6,89],[-57,-102],[-43,-41],[-27,-96],[-54,50],[2,63],[-44,87],[-37,45],[14,28],[-90,73],[-49,3],[-67,59],[-125,-12],[-90,-43],[-79,-40],[-67,8],[-74,-61],[-60,-28],[-14,-63],[-25,-49],[-60,-2],[-43,-11],[-62,22],[-50,-13],[-48,-6],[-41,-64],[-21,6],[-35,-34],[-33,-38],[-51,4],[-47,0],[-74,77],[-37,23],[1,68],[35,17],[12,27],[-3,43],[9,84],[-8,71],[-37,121],[-11,68],[3,69],[-28,78],[-2,35],[-31,48],[-8,94],[-40,95],[-10,51],[31,-52],[-24,111],[35,-34],[20,-47],[-1,62],[-34,94],[-7,38],[-16,36],[8,69],[14,30],[9,60],[-7,70],[29,86],[5,-91],[29,82],[57,40],[34,52],[53,44],[32,9],[19,-15],[55,45],[42,13],[11,27],[18,10],[39,-2],[73,35],[38,53],[18,64],[41,61],[3,48],[2,65],[49,102],[29,-103],[30,23],[-25,57],[22,58],[30,-26],[9,92],[38,59],[17,47],[35,20],[1,34],[30,-14],[2,30],[30,17],[34,16],[52,-55],[38,-71],[44,0],[44,-12],[-15,66],[34,96],[31,32],[-11,30],[31,68],[42,43],[36,-15],[58,23],[-1,61],[-51,40],[37,17],[46,-30],[37,-49],[59,-31],[20,13],[43,-37],[41,34],[26,-10],[16,23],[32,-60],[-18,-64],[-27,-48],[-24,-4],[8,-48],[-20,-60],[-25,-59],[5,-34],[55,-66],[54,-39],[36,-41],[50,-71],[20,0],[37,-31],[10,-37],[67,-41],[46,41],[13,65],[14,53],[9,66],[21,95],[-9,58],[5,35],[-8,69],[9,90],[13,25],[-11,40],[17,63],[13,66],[2,34],[26,45],[20,-58],[5,-76],[17,-14],[3,-51],[25,-61],[5,-67],[-2,-44]],[[13731,16571],[-5,-50],[-39,0],[13,-26],[-23,-77]],[[13677,16418],[-13,-20],[-61,-3],[-35,-27],[-58,9]],[[13510,16377],[-100,31],[-15,42],[-69,-21],[-8,-23],[-43,17]],[[13275,16423],[-35,3],[-32,22],[11,29],[-3,22]],[[13216,16499],[21,6],[36,-33],[10,32],[61,-5],[50,21],[33,-4],[22,-24],[7,20],[-10,78],[25,16],[24,55]],[[13495,16661],[52,-39],[39,49],[25,9],[54,-36],[33,6],[32,-23]],[[13730,16627],[-6,-15],[7,-41]],[[15682,15746],[18,19],[51,-34],[38,-7],[10,14],[-35,65],[18,16]],[[15782,15819],[20,-4],[48,-73],[31,-8],[12,31],[41,48]],[[15934,15813],[37,-63],[35,-85],[33,-6],[21,-32],[-57,-10],[-12,-93],[-12,-42],[-26,-28],[2,-60]],[[15955,15394],[-17,-6],[-44,63],[24,60],[-20,35],[-26,-9],[-83,-89]],[[15764,15445],[-48,16],[-35,55],[-11,46]],[[14593,10257],[-5,145],[-17,55]],[[14571,10457],[42,-10],[21,68],[37,-7]],[[14671,10508],[5,-48],[15,-27],[0,-39],[-17,-25],[-27,-62],[-25,-44],[-29,-6]],[[12977,16892],[-8,-81]],[[12969,16811],[-18,-5],[-8,-67]],[[12943,16739],[-61,55],[-36,-9],[-48,56],[-33,48],[-32,2],[-10,42]],[[12723,16933],[56,24]],[[12779,16957],[51,-9],[64,25],[44,-53],[39,-28]],[[12735,11548],[-57,-14]],[[12678,11534],[-18,83],[4,275],[-15,25],[-2,59],[-24,42],[-22,35],[9,64]],[[12610,12117],[24,13],[14,53],[34,11],[16,36]],[[12698,12230],[23,35],[25,0],[53,-69]],[[12799,12196],[-2,-40],[15,-71],[-14,-48],[8,-33],[-34,-74],[-21,-37],[-14,-75],[2,-77],[-4,-193]],[[12610,12117],[-61,2]],[[12549,12119],[-32,10],[-23,-20],[-30,9],[-121,-6],[-2,-68],[9,-90]],[[12350,11954],[-47,31],[-33,-5],[-24,-30],[-32,26],[-12,39],[-31,26]],[[12171,12041],[-5,70],[19,51],[-1,40],[55,100],[10,82],[19,29],[34,-16],[29,25],[10,31],[54,53],[13,38],[65,50],[39,17],[17,-23],[45,0]],[[12574,12588],[-6,-58],[9,-55],[40,-78],[2,-58],[80,-27],[-1,-82]],[[19008,13441],[-2,-86],[-24,19],[4,-97]],[[18986,13277],[-20,63],[-4,61],[-13,57],[-29,70],[-64,5],[6,-49],[-22,-67],[-29,24],[-11,-22],[-19,13],[-27,11]],[[18754,13443],[-11,99],[-24,90],[12,72],[-43,33],[15,43],[44,45],[-51,64],[25,81],[55,-52],[34,-6],[6,-83],[66,-17],[65,2],[40,-20],[-32,-102],[-31,-7],[-22,-68],[38,-62],[12,76],[19,1],[37,-191]],[[14127,16104],[20,-49],[27,8],[54,-18],[102,-7],[34,31],[83,28],[50,-44],[41,-12]],[[14538,16041],[-36,-50],[-25,-86],[22,-68]],[[14499,15837],[-60,16],[-71,-38]],[[14368,15815],[-1,-60],[-63,-11],[-49,42],[-56,-33],[-52,3]],[[14147,15756],[-4,80],[-35,38]],[[14108,15874],[11,17],[-7,15],[11,38],[27,37],[-34,52],[-6,44],[17,27]],[[7143,13648],[-17,-6],[-18,69],[-26,35],[15,76],[21,-5],[24,-100],[1,-69]],[[7123,13986],[-76,-19],[-5,44],[33,10],[46,-4],[2,-31]],[[7180,13987],[-12,-85],[-13,15],[1,63],[-31,47],[0,14],[55,-54]],[[13887,16019],[-13,-11],[-23,-28],[-10,-66]],[[13841,15914],[-61,45],[-27,50],[-26,27],[-32,45],[-15,37],[-35,56],[15,50],[25,-28],[15,25],[33,3],[60,-20],[48,2],[31,-27]],[[13872,16179],[26,0],[-18,-52],[34,-47],[-10,-56],[-17,-5]],[[14185,17265],[67,-1],[76,45],[16,68],[57,39],[-7,53]],[[14394,17469],[43,20],[75,47]],[[14512,17536],[73,-30],[10,-30],[37,14],[68,-28],[6,-57],[-14,-32],[43,-79],[29,-22],[-5,-21],[47,-21],[21,-32],[-28,-27],[-56,5],[-13,-12],[16,-39],[17,-77]],[[14763,17048],[-60,-7],[-21,-27],[-5,-60],[-27,12],[-63,-6],[-18,28],[-27,-21],[-26,17],[-55,3],[-78,28],[-70,10],[-54,-3],[-38,-32],[-33,-5]],[[14188,16985],[-2,53],[-21,56],[42,24],[0,48],[-19,46],[-3,53]],[[6333,12934],[0,17],[8,6],[13,-14],[25,72],[13,2]],[[6392,13017],[1,-18],[13,-1],[-1,-32],[-12,-52],[6,-19],[-7,-43],[4,-11],[-8,-61],[-13,-31],[-13,-4],[-14,-42]],[[6348,12703],[-21,0],[6,136],[0,95]],[[7870,8070],[-51,-17],[-27,166],[-37,134],[22,116],[-37,51],[-9,87],[-35,81]],[[7696,8688],[44,130],[-30,100],[16,41],[-12,44],[27,60],[2,102],[3,85],[15,40],[-60,193]],[[7701,9483],[52,-10],[35,3],[16,36],[61,49],[37,45],[91,20],[-8,-90],[9,-46],[-6,-80],[76,-108],[78,-20],[28,-44],[47,-24],[29,-35],[43,1],[41,-35],[3,-70],[14,-35],[0,-52],[-20,-2],[27,-139],[134,-5],[-11,-70],[8,-47],[38,-34],[16,-74],[-12,-95],[-19,-52],[7,-69],[-22,-24]],[[8493,8377],[-1,37],[-65,61],[-65,2],[-122,-35],[-33,-106],[-2,-64],[-27,-144]],[[8740,7709],[13,70],[10,70],[0,66],[-25,22],[-26,-19],[-26,5],[-9,46],[-6,110],[-13,36],[-47,33],[-29,-24],[-73,23],[4,163],[-20,67]],[[7701,9483],[-40,-20],[-31,13],[4,183],[-57,-71],[-61,3],[-27,64],[-46,7],[15,52],[-39,73],[-29,108],[18,22],[0,50],[42,35],[-7,65],[18,41],[5,56],[80,82],[57,23],[10,18],[62,-5]],[[7675,10282],[32,328],[1,53],[-11,68],[-31,44],[1,87],[39,20],[14,-13],[2,46],[-40,13],[-1,75],[135,-3],[24,42],[19,-38],[14,-71],[13,15]],[[7886,10948],[38,-64],[54,8],[14,37],[52,28],[28,19],[8,51],[50,34],[-4,25],[-59,11],[-9,75],[2,81],[-31,31],[13,11],[52,-15],[55,-30],[21,28],[50,19],[78,44],[25,46],[-9,34]],[[8314,11421],[36,5],[16,-27],[-9,-53],[24,-18],[16,-56],[-19,-42],[-11,-102],[18,-61],[5,-55],[43,-57],[34,-6],[7,24],[23,5],[31,21],[23,32],[38,-10],[17,4]],[[8606,11025],[38,-10],[6,25],[-11,24],[7,34],[28,-10],[33,12],[40,-25]],[[8747,11075],[30,-25],[22,32],[15,-5],[10,-33],[33,8],[27,46],[21,88],[42,110]],[[8947,11296],[23,5],[18,-66],[39,-210],[37,-19],[2,-83],[-53,-99],[22,-36],[123,-19],[3,-120],[53,78],[87,-43],[116,-73],[34,-70],[-11,-67],[81,37],[136,-63],[104,5],[103,-100],[89,-134],[53,-35],[60,-5],[25,-37],[24,-153],[12,-73],[-28,-198],[-36,-78],[-98,-167],[-44,-136],[-52,-104],[-17,-2],[-20,-89],[5,-224],[-19,-185],[-8,-79],[-22,-48],[-12,-160],[-71,-157],[-12,-124],[-56,-52],[-16,-71],[-76,0],[-110,-46],[-49,-54],[-78,-35],[-82,-95],[-59,-119],[-10,-90],[11,-66],[-13,-121],[-15,-59],[-49,-66],[-77,-211],[-62,-95],[-47,-56],[-32,-114],[-46,-69]],[[8827,6746],[-19,68],[30,57],[-40,82],[-55,66],[-71,77],[-26,-4],[-70,93],[-45,-13]],[[20508,11340],[28,45],[59,66]],[[20595,11451],[-3,-59],[-4,-77],[-33,4],[-15,-41],[-32,62]],[[18940,14129],[28,-38],[-5,-74],[-57,-4],[-59,8],[-44,-18],[-63,45],[-1,24]],[[18739,14072],[46,89],[37,31],[50,-28],[37,-3],[31,-32]],[[14599,8147],[-98,-88],[-63,-90],[-23,-80],[-21,-45],[-38,-10],[-12,-57],[-7,-37],[-45,-28],[-57,6],[-33,33],[-29,15],[-34,-28],[-18,-58],[-33,-36],[-34,-53],[-50,-12],[-16,42],[7,73],[-42,114],[-19,18]],[[13934,7826],[0,350],[69,4],[2,427],[52,4],[108,42],[26,-49],[45,47],[21,0],[39,27]],[[14296,8678],[13,-9]],[[14309,8669],[26,-96],[14,-21],[22,-69],[79,-132],[30,-13],[0,-42],[21,-76],[54,-19],[44,-54]],[[13613,11688],[57,9],[13,30],[12,-2],[17,-27],[88,46],[29,47],[37,42],[-7,42],[20,11],[67,-8],[65,56],[51,131],[35,48],[44,21]],[[14141,12134],[8,-51],[40,-75],[1,-49],[-12,-50],[5,-38],[24,-34],[53,-53]],[[14260,11784],[38,-48],[1,-39],[47,-63],[29,-51],[17,-72],[53,-48],[11,-38]],[[14456,11425],[-23,-13],[-45,3],[-52,13],[-26,-11],[-11,-29],[-22,-3],[-28,25],[-77,-60],[-32,12],[-10,-9],[-21,-72],[-52,23],[-51,12],[-44,44],[-57,41],[-38,-39],[-27,-61],[-6,-83]],[[13834,11218],[-45,6],[-47,20],[-42,-63],[-36,-112]],[[13664,11069],[-8,35],[-3,55],[-32,38],[-25,62],[-6,43],[-33,63],[5,36],[-7,50],[6,93],[17,22],[35,122]],[[8110,16382],[50,-16],[65,3],[-35,-49],[-25,-8],[-89,51],[-17,40],[26,37],[25,-58]],[[8239,16688],[-34,-2],[-90,38],[-65,56],[24,10],[92,-30],[71,-50],[2,-22]],[[3938,16617],[-35,-17],[-115,55],[-21,42],[-62,42],[-13,34],[-71,22],[-27,65],[6,28],[73,-26],[43,-18],[65,-13],[24,-41],[34,-57],[70,-50],[29,-66]],[[8634,16878],[-46,-105],[46,41],[47,-26],[-25,-42],[62,-33],[32,29],[70,-36],[-22,-88],[49,20],[9,-63],[21,-75],[-29,-106],[-31,-4],[-46,23],[15,98],[-20,15],[-80,-104],[-42,4],[49,56],[-67,30],[-75,-8],[-135,4],[-11,36],[44,42],[-30,32],[58,73],[72,191],[43,68],[61,41],[32,-5],[-13,-32],[-38,-76]],[[3264,17296],[33,-16],[66,10],[-20,-136],[60,-97],[-28,0],[-42,55],[-25,56],[-36,37],[-12,53],[4,38]],[[7022,18254],[-27,-63],[-31,10],[-18,36],[3,9],[27,36],[28,-3],[18,-25]],[[6839,18321],[-82,-67],[-49,3],[-16,33],[52,55],[96,-1],[-1,-23]],[[6611,18674],[13,-53],[36,19],[40,-32],[77,-41],[79,-37],[7,-57],[51,9],[50,-40],[-62,-37],[-109,28],[-39,54],[-69,-63],[-99,-62],[-24,70],[-95,-12],[61,59],[9,95],[24,110],[50,-10]],[[7259,18853],[-78,-6],[-18,59],[30,67],[64,17],[54,-34],[1,-51],[-8,-17],[-45,-35]],[[5880,19088],[-43,-42],[-94,36],[-57,-13],[-95,54],[61,37],[49,52],[74,-34],[42,-21],[21,-23],[42,-46]],[[3985,16676],[-10,0],[-135,118],[-50,52],[-126,49],[-39,106],[10,74],[-89,51],[-12,97],[-84,87],[-2,62]],[[3448,17372],[39,58],[-2,75],[-119,77],[-71,137],[-43,86],[-64,54],[-47,49],[-37,62],[-70,-39],[-68,-67],[-62,79],[-49,52],[-68,34],[-68,3],[0,683],[1,445]],[[2720,19160],[130,-28],[109,-58],[73,-11],[61,50],[85,37],[103,-14],[105,52],[114,30],[48,-49],[52,28],[15,56],[48,-13],[118,-107],[93,81],[9,-91],[86,20],[26,35],[85,-7],[106,-51],[164,-44],[96,-20],[68,8],[94,-61],[-98,-60],[126,-25],[188,14],[59,21],[75,-72],[75,61],[-71,50],[45,42],[85,5],[56,12],[56,-29],[70,-65],[78,10],[123,-54],[109,19],[101,-3],[-8,75],[62,20],[108,-40],[0,-114],[44,96],[56,-3],[32,120],[-75,74],[-81,49],[5,132],[83,87],[92,-19],[70,-53],[95,-135],[-62,-59],[130,-24],[-1,-123],[93,94],[84,-77],[-21,-89],[67,-81],[73,87],[51,103],[4,132],[99,-9],[103,-18],[94,-60],[4,-59],[-52,-64],[49,-64],[-9,-59],[-136,-83],[-97,-19],[-72,36],[-21,-60],[-67,-101],[-21,-53],[-80,-81],[-100,-8],[-55,-51],[-5,-78],[-81,-15],[-85,-97],[-76,-135],[-27,-94],[-4,-140],[103,-20],[31,-112],[33,-91],[97,24],[130,-52],[69,-46],[50,-57],[88,-33],[73,-50],[116,-7],[75,-12],[-11,-104],[22,-120],[50,-134],[104,-114],[54,39],[37,123],[-36,189],[-49,64],[111,56],[79,84],[39,84],[-6,80],[-47,102],[-85,90],[82,126],[-30,108],[-23,188],[48,27],[120,-32],[72,-12],[57,32],[65,-41],[86,-70],[21,-46],[124,-9],[-2,-101],[24,-152],[63,-19],[51,-70],[101,66],[66,133],[46,56],[55,-108],[91,-153],[77,-143],[-28,-76],[92,-67],[63,-69],[111,-31],[45,-38],[28,-102],[54,-16],[28,-45],[5,-135],[-51,-45],[-50,-42],[-115,-43],[-87,-98],[-118,-20],[-149,26],[-105,0],[-72,-8],[-58,-86],[-89,-53],[-101,-159],[-80,-111],[59,20],[112,158],[146,100],[105,12],[61,-59],[-66,-81],[23,-129],[22,-91],[91,-60],[115,18],[70,135],[5,-87],[45,-44],[-86,-78],[-155,-72],[-69,-48],[-78,-87],[-53,9],[-3,102],[122,99],[-112,-4],[-78,-15]],[[7867,16212],[-45,68],[0,164],[-31,34],[-47,-20],[-23,31],[-53,-90],[-21,-93],[-25,-55],[-30,-19],[-22,-6],[-7,-29],[-128,0],[-106,-1],[-32,-22],[-73,-87],[-9,-9],[-22,-47],[-64,0],[-69,0],[-31,-19],[11,-24],[6,-36],[-1,-13],[-91,-59],[-72,-19],[-81,-64],[-18,0],[-23,19],[-8,17],[1,12],[16,42],[32,66],[21,71],[-14,105],[-15,108],[-73,57],[9,21],[-10,15],[-19,0],[-14,19],[-4,28],[-13,-12],[-19,3],[4,12],[-16,12],[-7,32],[-54,38],[-57,40],[-68,46],[-65,44],[-63,-34],[-22,-1],[-86,31],[-57,-16],[-67,38],[-71,19],[-49,7],[-22,20],[-12,66],[-24,0],[0,-46],[-144,0],[-239,0],[-237,0],[-209,0],[-209,0],[-206,0],[-212,0],[-69,0],[-207,0],[-197,0]],[[4589,19569],[-35,-56],[155,37],[97,-61],[79,61],[64,-39],[57,-118],[35,50],[-50,123],[62,17],[69,-19],[78,-48],[44,-117],[21,-85],[118,-59],[125,-57],[-7,-53],[-115,-9],[45,-47],[-24,-44],[-126,19],[-120,33],[-81,-8],[-131,-40],[-176,-18],[-124,-12],[-38,57],[-95,33],[-62,-14],[-86,95],[46,13],[108,20],[98,-5],[91,21],[-135,28],[-149,-10],[-98,3],[-37,44],[161,48],[-107,-2],[-122,32],[59,90],[48,48],[187,73],[71,-24]],[[5263,19605],[-61,-79],[-109,84],[24,17],[93,5],[53,-27]],[[7226,19567],[6,-33],[-74,4],[-75,2],[-76,-16],[-21,7],[-76,64],[3,43],[33,8],[160,-13],[120,-66]],[[6513,19574],[55,-75],[65,97],[176,49],[120,-124],[-10,-79],[138,35],[65,48],[155,-61],[96,-57],[9,-52],[130,27],[72,-77],[169,-47],[60,-48],[66,-113],[-128,-56],[164,-78],[111,-26],[100,-110],[110,-8],[-22,-85],[-122,-139],[-86,51],[-110,116],[-90,-15],[-9,-69],[74,-70],[94,-55],[29,-32],[46,-119],[-25,-86],[-87,33],[-175,96],[98,-104],[73,-72],[11,-42],[-189,48],[-149,70],[-85,58],[24,34],[-104,61],[-101,59],[1,-35],[-202,-19],[-59,41],[46,88],[131,2],[144,16],[-23,43],[24,59],[90,117],[-19,53],[-27,41],[-107,59],[-141,40],[45,31],[-74,74],[-62,7],[-54,41],[-38,-35],[-126,-16],[-254,27],[-147,35],[-113,18],[-58,42],[73,55],[-99,1],[-23,121],[54,107],[72,49],[180,32],[-52,-77]],[[5552,19656],[83,-25],[124,15],[18,-35],[-65,-57],[106,-52],[-13,-108],[-114,-46],[-67,10],[-48,46],[-174,92],[2,39],[142,-15],[-77,78],[83,58]],[[6051,19528],[-75,-90],[-79,4],[-44,106],[1,59],[37,51],[69,33],[145,-4],[133,-29],[-104,-107],[-83,-23]],[[4150,19361],[-183,-58],[-37,53],[-161,63],[30,51],[48,88],[61,78],[-68,74],[235,19],[100,-25],[178,-7],[68,-35],[74,-50],[-87,-30],[-171,-85],[-87,-84],[0,-52]],[[6022,19792],[-38,-46],[-101,9],[-85,31],[37,54],[101,32],[60,-42],[26,-38]],[[5681,20001],[54,-55],[2,-62],[-32,-89],[-115,-12],[-75,19],[2,70],[-115,-10],[-4,93],[75,-4],[105,41],[98,-7],[5,16]],[[5004,19939],[28,-43],[62,20],[73,-5],[12,-59],[-42,-57],[-237,-18],[-175,-52],[-106,-3],[-9,39],[145,53],[-315,-14],[-98,22],[95,117],[66,33],[196,-40],[124,-71],[122,-9],[-100,114],[64,44],[72,-14],[23,-57]],[[5947,20047],[78,-39],[137,0],[60,-39],[-16,-45],[80,-27],[44,-29],[94,-5],[102,-10],[111,26],[142,10],[113,-8],[75,-46],[15,-49],[-43,-32],[-104,-26],[-89,15],[-200,-19],[-143,-2],[-113,15],[-185,38],[-24,66],[-9,60],[-70,52],[-144,15],[-81,37],[27,49],[143,-7]],[[4447,20112],[-9,-92],[-54,-42],[-65,-5],[-129,-52],[-112,-18],[-95,26],[119,90],[143,77],[107,-1],[95,17]],[[6006,20097],[-32,-3],[-130,7],[-19,34],[140,-2],[49,-22],[-8,-14]],[[4867,20118],[-130,-34],[-104,39],[57,38],[101,12],[99,-19],[-23,-36]],[[4903,20227],[-85,-23],[-116,0],[2,17],[71,36],[37,-6],[91,-24]],[[5867,20162],[-103,-25],[-57,28],[-29,45],[-6,49],[90,-4],[41,-8],[83,-42],[-19,-43]],[[5572,20194],[28,-50],[-114,13],[-115,39],[-155,4],[67,36],[-84,29],[-5,46],[137,-16],[188,-44],[53,-57]],[[6481,20354],[85,-39],[-96,-36],[-129,-90],[-123,-8],[-145,15],[-75,49],[1,43],[56,32],[-128,-1],[-77,40],[-44,55],[48,53],[49,37],[71,8],[-30,27],[162,7],[89,-65],[117,-25],[114,-23],[55,-79]],[[7772,20767],[187,-9],[149,-15],[128,-33],[-3,-32],[-170,-52],[-169,-24],[-63,-27],[152,0],[-165,-72],[-113,-34],[-119,-98],[-144,-20],[-45,-25],[-211,-13],[96,-15],[-48,-21],[58,-59],[-66,-41],[-108,-34],[-33,-47],[-97,-36],[9,-27],[119,4],[2,-29],[-186,-72],[-182,33],[-205,-18],[-104,14],[-132,6],[-8,58],[128,27],[-34,87],[43,8],[186,-52],[-95,77],[-113,23],[56,47],[124,28],[20,42],[-99,47],[-29,62],[190,-5],[55,-13],[109,43],[-157,14],[-244,-7],[-123,40],[-58,49],[-82,35],[-15,41],[104,23],[81,4],[137,19],[102,45],[87,-6],[75,-34],[53,65],[92,19],[125,13],[213,5],[37,-13],[202,21],[151,-8],[150,-8]],[[13275,16423],[-5,-49],[-31,-20],[-51,15],[-15,-49],[-34,-4],[-12,19],[-39,-40],[-33,-6],[-30,26]],[[13025,16315],[-24,52],[-34,-18],[1,54],[51,67],[-2,31],[32,-11],[19,20]],[[13068,16510],[59,-1],[15,26],[74,-36]],[[7880,4211],[-23,-48],[-60,-37],[-34,3],[-42,10],[-50,36],[-73,17],[-88,67],[-71,65],[-96,134],[57,-25],[98,-80],[93,-43],[36,55],[22,82],[65,50],[49,-15]],[[7767,4523],[-62,1],[-33,-30],[-63,-43],[-11,-112],[-30,-3],[-78,39],[-80,84],[-87,68],[-22,76],[20,71],[-35,79],[-9,205],[30,115],[73,93],[-106,35],[67,106],[24,199],[77,-42],[36,249],[-46,31],[-22,-149],[-44,17],[22,171],[24,222],[32,82],[-20,117],[-6,136],[29,3],[43,194],[48,192],[30,179],[-16,180],[20,99],[-8,148],[41,146],[12,232],[23,249],[22,269],[-6,196],[-14,169]],[[7642,8596],[36,31],[18,61]],[[17774,15286],[-10,69],[2,46],[-42,28],[-23,-12],[-18,111]],[[17683,15528],[20,27],[-9,28],[66,57],[48,23],[74,-16],[26,77],[90,14],[25,48],[109,65],[10,27]],[[18142,15878],[-5,68],[48,31],[-63,209],[138,48],[36,27],[50,214],[138,-39],[39,54],[3,120],[58,12],[53,79]],[[18637,16701],[27,10]],[[18664,16711],[19,-83],[58,-64],[100,-45],[48,-97],[-27,-140],[25,-52],[83,-20],[94,-17],[84,-75],[43,-13],[32,-111],[41,-71],[77,3],[144,-27],[92,17],[69,-18],[103,-73],[85,0],[30,-37],[82,64],[112,42],[105,4],[81,42],[50,65],[49,40],[-11,40],[-23,46],[37,77],[39,-11],[72,-24],[69,64],[107,46],[51,79],[49,34],[101,16],[55,-13],[8,42],[-64,84],[-55,39],[-54,-45],[-69,19],[-39,-15],[-18,49],[49,120],[34,90]],[[20681,16782],[84,-45],[98,76],[-1,53],[63,127],[39,38],[-1,67],[-38,28],[57,60],[87,21],[92,4],[105,-36],[61,-44],[43,-121],[26,-52],[24,-74],[26,-117],[122,-38],[82,-86],[28,-112],[106,-1],[61,48],[115,35],[-37,-108],[-27,-44],[-24,-131],[-47,-117],[-84,21],[-60,-42],[18,-103],[-10,-142],[-35,-3],[0,-61]],[[21654,15883],[-45,71],[-28,-67],[-107,-52],[11,-63],[-61,4],[-33,38],[-48,-85],[-76,-65],[-57,-77]],[[21210,15587],[-98,-35],[-51,-56],[-75,-32],[37,55],[-15,47],[56,81],[-37,62],[-61,-42],[-79,-83],[-43,-78],[-68,-6],[-35,-55],[36,-82],[57,-19],[3,-54],[55,-35],[78,85],[62,-46],[45,-3],[11,-63],[-99,-34],[-32,-65],[-68,-60],[-36,-84],[75,-66],[28,-118],[42,-110],[48,-92],[-2,-89],[-43,-33],[16,-64],[41,-37],[-10,-98],[-18,-95],[-39,-10],[-51,-130],[-56,-158],[-65,-143],[-96,-111],[-97,-101],[-79,-13],[-42,-54],[-24,39],[-40,-59],[-97,-60],[-74,-19],[-24,-127],[-38,-7],[-19,88],[17,46],[-94,38],[-33,-19]],[[20079,13383],[-70,31],[-33,49],[11,69],[-64,22],[-33,45],[-60,-64],[-67,-14],[-56,1],[-37,-30]],[[19670,13492],[-37,-17],[11,-138],[-37,4],[-6,28]],[[19601,13369],[-2,50],[-52,-35],[-30,22],[-52,45],[21,99],[-44,24],[-17,110],[-74,-20],[9,142],[66,101],[3,99],[-2,91],[-31,29],[-23,71],[-41,-9]],[[19332,14188],[-75,18],[23,50],[-32,75],[-50,-51],[-58,30],[-81,-77],[-63,-89],[-56,-15]],[[18739,14072],[-6,95],[-43,-25]],[[18690,14142],[-81,11],[-79,28],[-56,52],[-55,24],[-23,58],[-39,17],[-71,78],[-55,37],[-29,-29]],[[18202,14418],[-97,84],[-69,76],[-19,132],[50,-16],[2,61],[-28,62],[7,98],[-75,140]],[[17973,15055],[-114,49],[-21,92],[-51,56]],[[20239,13038],[-60,-58],[-57,38],[-2,103],[34,54],[76,34],[40,-3],[16,-46],[-31,-53],[-16,-69]],[[12350,11954],[19,-171],[-29,-100],[-19,-136],[31,-103],[-4,-48]],[[12348,11396],[-31,-1],[-49,24],[-45,-2],[-82,-21],[-49,-34],[-69,-44],[-13,3]],[[12010,11321],[5,99],[7,15],[-2,47],[-30,50],[-22,8],[-20,33],[15,53],[-7,58],[3,35]],[[11959,11719],[11,0],[4,53],[-5,23],[7,17],[26,14],[-18,96],[-16,50],[6,40],[14,10]],[[11988,12022],[9,11],[19,-18],[54,-1],[13,35],[12,-3],[20,14],[11,-52],[16,16],[29,17]],[[13664,11069],[-5,-65],[-56,29],[-56,31],[-88,5]],[[13459,11069],[-9,7],[-41,-16],[-42,16],[-33,-8]],[[13334,11068],[-114,3]],[[13220,11071],[10,95],[-27,79],[-32,21],[-14,53],[-18,18],[1,33]],[[13140,11370],[18,85],[33,115],[20,1],[42,71],[26,2],[39,-50],[48,41],[7,50],[15,48],[11,61],[38,49],[14,84],[14,27],[10,62],[19,77],[58,93],[4,39],[8,22],[-28,48]],[[13536,12295],[2,38],[20,7]],[[13558,12340],[28,-77],[4,-79],[-2,-80],[38,-109],[-39,1],[-20,-9],[-32,12],[-15,-56],[41,-70],[31,-21],[10,-49],[22,-83],[-11,-32]],[[13406,10065],[-9,38]],[[13453,10224],[19,-13],[24,46],[38,-1],[4,-34],[26,-21],[41,75],[41,59],[17,38],[-2,99],[30,116],[32,62],[46,58],[8,38],[2,44],[11,42],[-3,68],[8,106],[14,75],[21,64],[4,73]],[[14456,11425],[42,-99],[31,-14],[19,20],[32,-8],[39,25],[17,-51],[61,-80]],[[14697,11218],[-4,-140],[28,-16],[-23,-43],[-27,-32],[-26,-62],[-15,-56],[-4,-96],[-16,-46],[-1,-91]],[[14609,10636],[-20,-33],[-2,-72],[-10,-9],[-6,-65]],[[14593,10257],[12,-110],[-7,-62],[14,-70],[41,-67],[37,-151]],[[14690,9797],[-27,12],[-94,-20],[-18,-15],[-20,-76],[15,-53],[-12,-142],[-9,-121],[19,-21],[49,-47],[19,22],[6,-129],[-54,1],[-28,66],[-26,51],[-53,17],[-16,63],[-43,-38],[-55,16],[-24,55],[-44,11],[-33,-3],[-4,37],[-24,3]],[[13378,10193],[-57,127]],[[13321,10320],[53,66],[-26,79],[24,31],[47,14],[5,53],[37,-57],[62,-5],[21,56],[9,80],[-8,94],[-33,71],[31,139],[-18,24],[-52,-10],[-19,62],[5,52]],[[7675,10282],[-35,63],[-20,3],[45,122],[-54,56],[-42,-10],[-25,21],[-38,-32],[-52,15],[-41,126],[-32,31],[-23,57],[-46,56],[-19,-11]],[[7293,10779],[-29,28],[-35,40],[-20,-19],[-59,17],[-17,51],[-13,-2],[-69,69]],[[7051,10963],[-10,37],[26,9],[-3,60],[16,44],[35,8],[29,75],[27,63],[-26,29],[14,69],[-16,110],[15,31],[-11,102],[-28,64]],[[7119,11664],[8,58],[23,-8],[13,35],[-16,71],[8,17]],[[7155,11837],[36,-3],[53,83],[28,13],[1,40],[13,101],[40,56],[44,2],[5,25],[55,-10],[55,61],[27,26],[34,58],[24,-7],[19,-32],[-14,-40]],[[7575,12210],[-45,-20],[-17,-60],[-27,-35],[-21,-44],[-8,-86],[-19,-70],[36,-8],[8,-55],[16,-26],[5,-49],[-8,-44],[3,-25],[17,-10],[16,-42],[90,12],[40,-16],[49,-103],[29,13],[50,-7],[40,14],[24,-21],[-12,-64],[-16,-40],[-5,-86],[14,-80],[20,-36],[2,-27],[-35,-59],[25,-27],[18,-42],[22,-119]],[[6764,11784],[-38,27],[-14,25],[8,21],[-2,26],[-20,29],[-27,23],[-24,16],[-5,35],[-18,21],[4,-35],[-13,-28],[-16,33],[-23,12],[-9,24],[0,37],[9,37],[-19,17],[16,23]],[[6573,12127],[10,16],[46,-32],[16,16],[22,-10],[12,-25],[20,-8],[17,26]],[[6716,12110],[18,-66],[27,-48],[32,-51]],[[6793,11945],[-27,-11],[1,-48],[14,-18],[-10,-14],[3,-22],[-6,-24],[-4,-24]],[[6813,13579],[60,-8],[55,-2],[65,-41],[28,-44],[65,14],[25,-28],[59,-75],[43,-54],[23,2],[42,-24],[-5,-34],[51,-5],[53,-49],[-9,-28],[-46,-16],[-47,-6],[-48,10],[-100,-12],[47,67],[-28,31],[-45,8],[-24,35],[-17,68],[-39,-4],[-65,32],[-21,25],[-91,19],[-24,23],[26,30],[-69,6],[-50,-62],[-29,-2],[-10,-29],[-34,-13],[-30,11],[37,37],[15,43],[31,27],[36,23],[53,12],[17,13]],[[14829,15013],[5,1],[10,28],[50,-1],[64,36],[-47,-51],[5,-23]],[[14916,15003],[-8,4],[-13,-9],[-10,3],[-4,-5],[-1,12],[-5,8],[-14,1],[-19,-10],[-13,6]],[[14916,15003],[2,-10],[-72,-48],[-34,15],[-16,48],[33,5]],[[13495,16661],[-39,52],[-36,28],[-7,51],[-12,36],[50,26],[26,30],[50,23],[18,23],[18,-14],[31,12]],[[13594,16928],[33,-38],[52,-11],[-4,-33],[38,-24],[10,30],[48,-13],[7,-37],[52,-8],[32,-59]],[[13862,16735],[-21,0],[-11,-22],[-16,-5],[-4,-27],[-14,-6],[-2,-11],[-23,-12],[-31,2],[-10,-27]],[[13068,16510],[9,86],[35,82],[-100,22],[-33,31]],[[12979,16731],[4,53],[-14,27]],[[12977,16892],[-12,126],[42,0],[18,45],[17,110],[-13,40]],[[13029,17213],[13,26],[59,6],[13,-26],[47,59],[-16,45],[-3,68]],[[13142,17391],[53,-16],[44,18]],[[13239,17393],[1,-46],[71,-28],[-1,-42],[71,22],[39,33],[79,-47],[33,-39]],[[13532,17246],[16,-61],[-19,-32],[25,-42],[17,-65],[-5,-41],[28,-77]],[[15551,12321],[16,-37],[-2,-50],[-40,-29],[30,-33]],[[15555,12172],[-26,-64]],[[15529,12108],[-15,21],[-17,-8],[-39,2],[-1,36],[-5,34],[23,56],[25,53]],[[15500,12302],[30,-11],[21,30]],[[13142,17391],[-28,67],[-3,122],[12,33],[20,36],[61,7],[25,33],[56,34],[-2,-62],[-21,-39],[8,-33],[38,-19],[-17,-45],[-21,13],[-50,-86],[19,-59]],[[13432,17469],[-42,-98],[-73,68],[-9,50],[102,40],[22,-60]],[[7549,13162],[8,21],[55,-1],[41,-31],[18,3],[13,-42],[38,2],[-2,-36],[31,-4],[34,-44],[-26,-49],[-33,26],[-32,-5],[-23,6],[-12,-22],[-27,-7],[-11,29],[-23,-17],[-28,-83],[-18,20],[-3,34]],[[7549,12962],[1,33],[-18,36],[17,20],[6,46],[-6,65]],[[12845,13095],[-77,-12],[-1,77],[-32,19],[-44,35],[-16,56],[-236,262],[-235,261]],[[12204,13793],[-262,291]],[[11942,14084],[1,23],[0,8]],[[11943,14115],[0,142],[112,89],[70,18],[57,32],[27,60],[81,48],[3,89],[41,10],[31,45],[91,20],[13,46],[-18,26],[-24,127],[-4,72],[-27,77]],[[12396,15016],[67,66],[76,21],[44,49],[67,37],[118,21],[115,10],[35,-18],[66,47],[74,1],[29,-28],[48,8]],[[13135,15230],[-15,-62],[11,-114],[-16,-99],[-43,-67],[6,-91],[57,-71],[1,-29],[43,-48],[29,-216]],[[13208,14433],[23,-106],[4,-56],[-12,-97],[5,-55],[-9,-66],[6,-75],[-28,-50],[41,-88],[3,-51],[25,-67],[32,22],[55,-56],[31,-75]],[[13384,13613],[-239,-229],[-202,-235],[-98,-54]],[[7293,10779],[10,-91],[-22,-78],[-76,-126],[-83,-47],[-43,-104],[-13,-81],[-40,-50],[-29,61],[-28,13],[-29,-10],[-2,44],[20,29],[-8,50]],[[6950,10389],[37,89],[-15,53],[-27,-56],[-42,53],[15,33],[-12,109],[24,18],[13,75],[26,77],[-4,49],[38,26],[48,48]],[[15117,13437],[-276,0],[-271,0],[-280,0]],[[14290,13437],[0,441],[0,427],[-21,97],[18,74],[-11,51],[26,58]],[[14302,14585],[92,1],[68,-31],[69,-36],[32,-18],[54,38],[28,34],[62,10],[49,-15],[19,-60],[17,39],[55,-28],[55,-7],[34,31]],[[14936,14543],[39,-175],[7,-32]],[[14982,14336],[-20,-48],[-15,-90],[-19,-63],[-16,-21],[-23,39],[-32,53],[-49,172],[-7,-10],[28,-127],[43,-121],[53,-187],[26,-65],[22,-68],[63,-132],[-14,-21],[2,-78],[81,-108],[12,-24]],[[15500,12302],[-24,39],[-29,70],[-31,39],[-18,41],[-60,48],[-48,2],[-17,25],[-41,-29],[-42,55],[-22,-90],[-81,25]],[[15087,12527],[-7,48],[30,177],[6,79],[22,37],[52,20],[35,68]],[[15225,12956],[40,-138],[20,-111],[38,-58],[95,-113],[39,-69],[38,-69],[21,-41],[35,-36]],[[11918,15822],[3,85],[-28,52],[98,87],[86,-22],[93,1],[74,-21],[58,7],[113,-4]],[[12415,16007],[28,-47],[128,-55],[25,26],[79,-54],[81,16]],[[12756,15893],[3,-70],[-66,-80],[-89,-25],[-6,-41],[-43,-66],[-27,-98],[27,-68],[-40,-54],[-15,-78],[-53,-24],[-49,-92],[-89,-2],[-66,2],[-44,-42],[-26,-45],[-34,10],[-26,40],[-20,69],[-65,19]],[[12028,15248],[-6,39],[26,45],[10,33],[-25,36],[20,79],[-28,72],[30,9],[3,57],[11,18],[1,93],[32,33],[-19,60],[-41,4],[-12,-15],[-41,0],[-18,59],[-28,-18],[-25,-30]],[[14242,17731],[8,70],[-25,-15],[-44,43],[-7,69],[89,33],[87,18],[76,-20],[72,3]],[[14498,17932],[11,-21],[-50,-69],[21,-112],[-30,-38]],[[14450,17692],[-58,1],[-60,44],[-30,15],[-60,-21]],[[15529,12108],[-15,-42],[26,-66],[26,-58],[26,-43],[228,-142],[59,0]],[[15879,11757],[-197,-360],[-91,-5],[-62,-85],[-45,-2],[-19,-38]],[[15465,11267],[-47,0],[-29,41],[-63,-50],[-21,-50],[-46,9],[-16,14],[-16,-3],[-22,1],[-88,102],[-49,0],[-24,39],[0,68],[-36,20]],[[15008,11458],[-41,130],[-32,28],[-12,48],[-36,59],[-42,8],[23,68],[37,3],[11,37]],[[14916,11839],[-1,108],[21,125],[33,34],[7,49],[29,92],[42,59],[29,118],[11,103]],[[14214,18716],[-24,47],[-2,184],[-108,82],[-93,59]],[[13987,19088],[41,31],[78,-63],[91,6],[75,-29],[66,53],[34,88],[109,41],[89,-48],[-29,-84]],[[14541,19083],[-11,-84],[107,-80],[-64,-91],[81,-136],[-47,-103],[63,-89],[-29,-78],[103,-83],[-26,-61],[-65,-69],[-149,-153]],[[14504,18056],[-126,-10],[-123,-44],[-113,-25],[-41,65],[-67,40],[15,118],[-33,108],[33,70],[63,75],[159,130],[47,26],[-7,50],[-97,57]],[[24982,8717],[24,-35],[-12,-62],[-43,-17],[-39,15],[-6,53],[27,41],[31,-15],[18,20]],[[25051,8782],[-45,-26],[-9,45],[35,25],[22,6],[41,38],[0,-59],[-44,-29]],[[6,8817],[-6,-6],[0,59],[14,5],[-8,-58]],[[8281,4577],[84,72],[59,-30],[42,48],[56,-54],[-21,-42],[-94,-36],[-32,42],[-59,-54],[-35,54]],[[12943,16739],[16,-10],[20,2]],[[13025,16315],[-3,-34],[20,-45],[-24,-37],[18,-93],[38,-15],[-8,-52]],[[13066,16039],[-63,-68],[-138,33],[-101,-39],[-8,-72]],[[12415,16007],[36,72],[13,239],[-72,125],[-51,61],[-107,46],[-7,88],[91,26],[117,-31],[-22,136],[66,-52],[162,94],[21,98],[61,24]],[[8747,11075],[17,51],[6,54],[12,52],[-27,71],[-5,82],[36,103]],[[8786,11488],[24,-13],[51,-29],[74,-101],[12,-49]],[[13214,15854],[-23,-92],[-32,24],[-16,81],[14,44],[45,46],[12,-103]],[[13321,10320],[-72,121],[-46,99],[-42,124],[2,40],[15,38],[17,87],[14,89]],[[13209,10918],[24,7],[101,-1],[0,144]],[[12115,17260],[-52,24],[-43,-1],[14,64],[-14,64]],[[12020,17411],[58,5],[75,-74],[-38,-82]],[[12338,17832],[-74,-130],[71,16],[76,0],[-18,-98],[-63,-108],[72,-7],[6,-13],[62,-142],[47,-19],[43,-136],[20,-48],[85,-23],[-9,-76],[-35,-36],[28,-62],[-63,-63],[-93,2],[-119,-33],[-33,23],[-46,-56],[-64,14],[-49,-46],[-37,24],[102,126],[62,26],[0,0],[-109,20],[-20,48],[73,37],[-38,64],[13,79],[104,-11],[10,70],[-46,74],[-2,1],[-84,21],[-17,33],[26,53],[-23,34],[-38,-57],[-4,115],[-35,62],[25,124],[54,97],[56,-10],[84,11]],[[15586,15727],[-68,59],[-74,-6]],[[15444,15780],[11,51],[-18,82],[-40,44],[-39,14],[-25,37]],[[15333,16008],[8,14],[59,-20],[103,-20],[95,-57],[12,-23],[42,19],[65,-25],[21,-49],[44,-28]],[[12549,12119],[-5,-37],[29,-62],[0,-87],[7,-95],[17,-44],[-15,-108],[5,-59],[19,-76],[15,-43]],[[12621,11508],[-109,-70],[-39,-41],[-62,-35],[-63,34]],[[11959,11719],[-20,3],[-14,-48],[-19,1],[-14,25],[5,48],[-30,74],[-18,-14],[-15,-2]],[[11834,11806],[-19,-7],[1,44],[-11,31],[2,35],[-15,50],[-19,43],[-56,1],[-16,-23],[-20,-3],[-12,-26],[-8,-33],[-37,-53]],[[11624,11865],[-30,71],[-28,47],[-17,16],[-18,24],[-8,53],[-10,26],[-20,20]],[[11493,12122],[31,58],[21,-2],[18,20],[15,0],[11,16],[-5,40],[7,12],[1,41]],[[11592,12307],[34,-1],[50,-29],[16,2],[5,14],[38,-10],[10,7]],[[11745,12290],[4,-44],[11,0],[18,16],[12,-4],[19,-30],[30,-10],[19,26],[23,16],[16,17],[14,-3],[16,-27],[8,-33],[29,-50],[-15,-31],[-2,-39],[14,12],[9,-14],[-4,-36],[22,-34]],[[11374,12375],[8,53]],[[11382,12428],[76,4],[16,28],[22,2],[28,-30],[21,0],[23,20],[14,-35],[-30,-27],[-30,3],[-30,25],[-26,-28],[-12,-1],[-17,-17],[-63,3]],[[11493,12122],[-37,50],[-30,8],[-16,34],[1,18],[-22,25],[-4,26]],[[11385,12283],[37,20],[23,-4],[19,13],[128,-5]],[[13209,10918],[-13,18],[24,135]],[[14013,15697],[45,11],[27,26],[38,-2],[11,20],[13,4]],[[14368,15815],[34,-32],[-22,-75],[-16,-13]],[[14364,15695],[-43,3],[-36,12],[-84,-32],[48,-67],[-35,-20],[-39,0],[-37,62],[-13,-26],[15,-72],[35,-56],[-26,-27],[39,-55],[34,-35],[1,-67],[-64,31],[20,-61],[-44,-12],[27,-106],[-47,-2],[-57,52],[-26,96],[-12,80],[-27,55],[-36,69],[-5,34]],[[14200,15081],[38,-41],[54,7],[52,-8],[-2,-21],[38,14],[-9,-35],[-100,-10],[1,19],[-85,24],[13,51]],[[9288,20710],[234,72],[244,-6],[89,44],[247,12],[556,-15],[436,-95],[-128,-46],[-267,-6],[-375,-11],[35,-22],[247,13],[210,-41],[135,37],[58,-43],[-77,-70],[178,45],[338,46],[209,-23],[39,-51],[-284,-86],[-39,-27],[-223,-21],[162,-6],[-82,-87],[-56,-78],[2,-134],[84,-78],[-109,-5],[-115,-38],[129,-63],[16,-102],[-74,-11],[90,-104],[-155,-8],[81,-49],[-23,-42],[-98,-19],[-97,0],[87,-82],[1,-53],[-138,50],[-36,-32],[94,-30],[92,-74],[26,-96],[-124,-23],[-54,46],[-86,69],[24,-82],[-81,-63],[184,-5],[96,-6],[-187,-105],[-190,-94],[-204,-42],[-77,0],[-72,-47],[-97,-126],[-150,-84],[-48,-5],[-93,-30],[-100,-28],[-59,-74],[-1,-84],[-36,-79],[-113,-96],[28,-94],[-32,-99],[-35,-117],[-99,-7],[-102,98],[-140,0],[-67,66],[-47,117],[-121,149],[-35,79],[-10,107],[-96,111],[25,88],[-47,43],[69,140],[105,45],[28,50],[14,94],[-79,-43],[-38,-18],[-63,-17],[-85,39],[-5,82],[27,64],[65,1],[142,-32],[-120,77],[-62,41],[-69,-17],[-59,29],[78,112],[-42,45],[-56,83],[-83,127],[-89,47],[1,50],[-187,70],[-148,9],[-187,-5],[-170,-9],[-81,38],[-121,76],[183,38],[140,6],[-298,31],[-157,49],[10,47],[264,57],[255,58],[27,44],[-188,43],[60,48],[242,83],[101,13],[-29,54],[165,32],[215,19],[214,1],[76,-38],[185,66],[166,-45],[98,-9],[145,-39],[-166,65],[10,51]],[[6348,12703],[23,-22],[6,18],[20,-15]],[[6397,12684],[-31,-46],[-33,-33],[-5,-23],[5,-24],[-14,-30]],[[6319,12528],[-16,-8],[3,-14],[-13,-13],[-24,-30],[-2,-18]],[[6267,12445],[-36,21],[-43,2],[-32,24],[-38,49]],[[6118,12541],[2,35],[8,28],[-10,23],[34,98],[89,0],[2,41],[-11,7],[-8,26],[-26,28],[-26,40],[32,0],[0,68],[65,0],[64,-1]],[[8314,11421],[-47,91],[19,33],[-2,56],[43,19],[17,22],[-23,45],[6,44],[55,70]],[[8382,11801],[46,-44],[43,-78],[2,-62],[26,-3],[37,-58],[28,-42]],[[8564,11514],[-11,-108],[-43,-31],[4,-29],[-13,-62],[31,-87],[23,0],[9,-68],[42,-104]],[[6397,12684],[8,-5],[15,21],[20,2],[6,-10],[11,6],[33,-10],[32,3],[22,13],[8,13],[23,-6],[16,-8],[19,3],[13,10],[32,-16],[11,-3],[22,-23],[20,-26],[25,-19],[18,-33]],[[6751,12596],[-23,3],[-10,-17],[-24,-15],[-18,0],[-15,-16],[-14,6],[-12,18],[-7,-3],[-9,-29],[-7,1],[-1,-25],[-25,-33],[-12,-14],[-8,-15],[-20,24],[-15,-32],[-15,1],[-16,-3],[1,-59],[-10,-1],[-9,-27],[-21,-5]],[[6461,12355],[-12,37],[-21,11]],[[6428,12403],[4,48],[-9,13],[-14,9],[-31,-15],[-3,16],[-21,20],[-15,24],[-20,10]],[[13841,15914],[-7,-21]],[[13834,15893],[-66,45],[-40,43],[-64,36],[-59,88],[14,9],[-31,50],[-2,41],[-45,19],[-21,-52],[-20,40],[1,42],[3,2]],[[13504,16256],[48,-4],[13,20],[24,-20],[27,-2],[0,34],[24,12],[7,48],[55,32]],[[13702,16376],[22,-15],[52,-51],[58,-23],[26,18]],[[13860,16305],[17,-47],[22,-34],[-27,-45]],[[7549,12962],[-46,20],[-33,-8],[-43,9],[-33,-23],[-37,38],[6,38],[64,-16],[53,-10],[25,27],[-32,52],[1,46],[-44,18],[16,33],[42,-5],[61,-19]],[[13731,16571],[36,-31],[25,-13],[59,14],[5,25],[28,3],[34,19],[8,-8],[32,15],[17,28],[23,8],[74,-37],[15,12]],[[14087,16606],[39,-32],[5,-32]],[[14131,16542],[-43,-26],[-33,-81],[-42,-81],[-56,-23]],[[13957,16331],[-43,5],[-54,-31]],[[13702,16376],[-13,41],[-12,1]],[[20962,9569],[-29,-3],[-92,85],[65,23],[36,-36],[25,-37],[-5,-32]],[[21259,9730],[7,-23],[1,-37]],[[21267,9670],[-45,-89],[-60,-27],[-8,15],[6,40],[30,74],[69,47]],[[20766,9826],[25,-32],[43,10],[18,-51],[-81,-24],[-48,-16],[-38,1],[24,69],[38,1],[19,42]],[[21115,9826],[-10,-67],[-105,-34],[-93,15],[0,44],[55,25],[44,-36],[46,9],[63,44]],[[20119,9984],[134,-12],[15,50],[130,-58],[25,-78],[105,-22],[85,-71],[-79,-46],[-77,49],[-63,-4],[-72,9],[-66,22],[-80,46],[-52,11],[-29,-15],[-127,50],[-12,51],[-64,9],[48,115],[85,-7],[56,-47],[29,-9],[9,-43]],[[21939,10052],[-36,-82],[-7,90],[13,43],[14,41],[16,-35],[0,-57]],[[21418,10382],[-26,-40],[-48,22],[-14,52],[71,6],[17,-40]],[[21642,10426],[26,-92],[-59,50],[-58,10],[-40,-8],[-48,4],[17,66],[86,5],[76,-35]],[[22376,10485],[2,-391],[1,-391]],[[22379,9703],[-62,99],[-71,24],[-17,-34],[-89,-4],[30,98],[44,33],[-18,130],[-34,101],[-135,102],[-57,10],[-105,111],[-21,-59],[-26,-10],[-16,44],[0,52],[-54,59],[75,43],[50,-2],[-6,32],[-102,0],[-27,71],[-63,22],[-29,60],[94,29],[35,39],[112,-49],[11,-45],[20,-194],[72,-72],[58,127],[80,73],[62,0],[60,-42],[52,-43],[74,-23]],[[21278,10968],[-56,-119],[-53,-24],[-67,24],[-116,-6],[-61,-17],[-10,-91],[63,-107],[37,55],[130,40],[-5,-55],[-31,18],[-30,-71],[-61,-46],[66,-154],[-13,-41],[63,-139],[-1,-79],[-37,-35],[-28,42],[34,99],[-68,-47],[-18,33],[9,47],[-50,70],[5,117],[-46,-37],[6,-139],[3,-172],[-45,-17],[-30,35],[20,110],[-10,116],[-30,1],[-21,82],[28,79],[10,95],[35,181],[15,49],[59,89],[55,-35],[88,-17],[80,5],[69,87],[12,-26]],[[21518,10933],[-4,-105],[-35,12],[-11,-73],[29,-63],[-20,-15],[-28,76],[-21,154],[14,95],[23,44],[5,-65],[42,-11],[6,-49]],[[20192,11038],[12,-80],[47,-68],[45,24],[45,-8],[40,60],[34,11],[66,-34],[57,26],[35,167],[27,41],[24,137],[80,0],[61,-20]],[[20765,11294],[-40,-109],[51,-113],[-12,-56],[79,-111],[-83,-14],[-23,-82],[3,-108],[-67,-82],[-2,-120],[-27,-183],[-10,42],[-79,-54],[-28,74],[-50,7],[-35,38],[-82,-43],[-26,58],[-46,-7],[-57,14],[-11,161],[-34,33],[-34,103],[-10,105],[9,111],[41,80]],[[19924,10095],[-77,-2],[-59,100],[-90,98],[-29,73],[-53,97],[-35,90],[-53,168],[-61,100],[-20,103],[-26,94],[-63,75],[-36,103],[-53,67],[-73,133],[-6,61],[45,-5],[108,-23],[62,-118],[54,-81],[38,-50],[66,-129],[71,-2],[58,-82],[41,-100],[53,-55],[-28,-98],[40,-42],[25,-3],[12,-84],[24,-67],[51,-10],[34,-76],[-17,-149],[-3,-186]],[[18754,13443],[-10,-44],[-48,2],[-86,-25],[4,-90],[-37,-71],[-100,-81],[-78,-141],[-53,-76],[-69,-78],[0,-56],[-35,-29],[-63,-43],[-32,-6],[-21,-92],[14,-156],[4,-99],[-29,-114],[-1,-204],[-36,-6],[-32,-92],[22,-39],[-64,-34],[-23,-82],[-28,-34],[-66,112],[-33,168],[-26,121],[-25,57],[-37,115],[-17,150],[-12,75],[-64,165],[-28,232],[-21,154],[0,145],[-14,112],[-101,-72],[-49,15],[-91,145],[33,44],[-20,47],[-82,101]],[[17300,13639],[46,81],[154,-1],[-14,103],[-39,61],[-8,92],[-46,54],[77,126],[81,-9],[73,126],[44,121],[67,121],[-1,85],[60,70],[-57,59],[-24,81],[-25,105],[35,52],[105,-29],[78,18],[67,100]],[[18202,14418],[-45,-54],[-27,-112],[68,-46],[66,-59],[91,-67],[95,-15],[40,-61],[54,-12],[84,-28],[58,2],[8,48],[-9,76],[5,52]],[[19332,14188],[5,-46],[-24,-22],[6,-74],[-50,22],[-91,-83],[3,-68],[-39,-101],[-3,-59],[-31,-98],[-55,27],[-3,-124],[-15,-41],[7,-51],[-34,-29]],[[12115,17260],[12,-86],[-53,-107],[-123,-71],[-99,18],[57,125],[-37,122],[95,94],[53,56]],[[16791,14376],[34,-63],[29,-73],[66,-53],[2,-105],[33,-20],[6,-55],[-100,-62],[-27,-139]],[[16834,13806],[-131,36],[-76,28],[-78,15],[-30,147],[-34,22],[-53,-22],[-70,-58],[-86,40],[-70,92],[-67,34],[-47,114],[-51,160],[-38,-19],[-44,39],[-26,-47]],[[15933,14387],[-38,64],[-1,63],[-22,0],[11,87],[-36,91],[-85,66],[-49,114],[17,94],[35,41],[-6,70],[-45,36],[-45,143]],[[15669,15256],[-39,97],[14,37],[-22,137],[48,35]],[[15955,15394],[22,-88],[66,-25],[49,-60],[99,-21],[109,32],[6,28]],[[16306,15260],[62,23],[49,69],[47,-4],[30,23],[50,-11],[77,-61],[56,-13],[79,-107],[52,-4],[6,-101]],[[15933,14387],[-41,6]],[[15892,14393],[-47,10],[-51,-115]],[[15794,14288],[-130,10],[-196,241],[-104,84],[-84,33]],[[15280,14656],[-28,146]],[[15252,14802],[154,124],[26,145],[-6,88],[38,30],[36,75]],[[15500,15264],[30,18],[81,-15],[24,-31],[34,20]],[[11536,18770],[-16,-78],[79,-82],[-91,-91],[-201,-82],[-60,-22],[-92,17],[-194,38],[68,53],[-151,59],[123,23],[-3,36],[-146,27],[47,79],[106,17],[108,-81],[106,65],[88,-34],[113,64],[116,-8]],[[14936,14543],[20,39],[-4,7],[18,56],[14,90],[10,31],[2,1]],[[14996,14767],[23,0],[7,21],[19,1]],[[15045,14789],[1,-49],[-10,-18],[1,-1]],[[15037,14721],[-12,-38]],[[15025,14683],[-25,17],[-14,-80],[17,-13],[-18,-17],[-3,-31],[33,16]],[[15015,14575],[2,-47],[-35,-192]],[[13510,16377],[-8,-59],[17,-51]],[[13519,16267],[-55,17],[-57,-42],[4,-60],[-9,-34],[23,-61],[65,-61],[35,-99],[78,-96],[55,0],[17,-26],[-20,-24],[63,-44],[51,-36],[60,-62],[7,-23],[-13,-43],[-39,56],[-61,20],[-29,-78],[50,-44],[-8,-63],[-29,-7],[-37,-103],[-29,-9],[0,37],[14,64],[15,26],[-27,69],[-21,61],[-29,15],[-21,51],[-44,22],[-31,49],[-51,7],[-55,54],[-63,79],[-48,69],[-21,118],[-35,14],[-57,40],[-32,-16],[-40,-56],[-29,-9]],[[13629,15384],[-25,-95],[11,-37],[-15,-62],[-53,46],[-36,13],[-97,61],[10,61],[81,-11],[71,13],[53,11]],[[13190,15741],[41,-85],[-9,-159],[-32,8],[-29,-40],[-26,32],[-3,144],[-16,69],[39,-6],[35,37]],[[7140,13015],[47,-10],[37,-29],[12,-33],[-49,-2],[-21,-20],[-39,19],[-40,44],[8,27],[29,9],[16,-5]],[[15280,14656],[-14,-19],[-139,-60],[69,-120],[-23,-20],[-11,-40],[-53,-17],[-17,-43],[-30,-37],[-78,19]],[[14984,14319],[-2,17]],[[15015,14575],[10,35],[0,73]],[[15037,14721],[78,-47],[137,128]],[[21933,14894],[9,-41],[-39,-73],[-29,39],[-36,-28],[-18,-70],[-46,34],[1,57],[38,71],[40,-14],[29,51],[51,-26]],[[22375,15253],[-27,-96],[13,-60],[-37,-84],[-89,-57],[-122,-7],[-100,-137],[-46,46],[-3,90],[-122,-27],[-82,-56],[-82,-3],[71,-88],[-47,-204],[-45,-50],[-33,46],[17,109],[-44,34],[-29,83],[66,37],[37,75],[70,62],[51,82],[139,36],[74,-25],[73,214],[47,-58],[102,120],[40,47],[43,147],[-11,135],[29,75],[74,22],[38,-166],[-2,-97],[-64,-121],[1,-124]],[[22579,16097],[49,-26],[50,51],[15,-135],[-103,-33],[-61,-119],[-110,82],[-38,-131],[-77,-2],[-10,120],[34,92],[75,6],[20,166],[21,94],[82,-125],[53,-40]],[[18142,15878],[-43,17],[-35,44],[-103,12],[-116,3],[-25,-13],[-99,51],[-40,-25],[-11,-71],[-114,41],[-46,-17],[-16,-52]],[[17494,15868],[-40,-22],[-92,-84],[-30,-86],[-26,-1],[-19,57],[-89,4],[-14,98],[-34,1],[5,121],[-83,87],[-120,-9],[-82,-18],[-66,109],[-57,45],[-108,86],[-13,10],[-180,-71],[3,-442]],[[16449,15753],[-36,-6],[-49,94],[-47,34],[-79,-25],[-31,-40]],[[16207,15810],[-4,29],[18,50],[-14,42],[-81,41],[-31,108],[-38,30],[-3,39],[68,-11],[3,87],[59,20],[61,-18],[12,117],[-12,74],[-70,-6],[-59,30],[-81,-53],[-65,-25]],[[15970,16364],[-35,19],[7,62],[-45,80],[-51,-3],[-59,81],[40,91],[-21,24],[56,132],[72,-69],[8,87],[144,131],[109,3],[154,-83],[82,-49],[74,51],[111,2],[89,-62],[20,36],[98,-6],[18,57],[-113,83],[67,58],[-13,33],[67,31],[-51,82],[32,41],[261,42],[34,30],[174,44],[63,50],[125,-26],[22,-125],[73,30],[90,-41],[-6,-66],[67,7],[174,113],[-25,-37],[89,-93],[156,-305],[37,63],[96,-69],[100,31],[38,-22],[34,-69],[49,-23],[29,-51],[90,16],[37,-74]],[[15465,11267],[-61,-136],[1,-437],[41,-99]],[[15446,10595],[-48,-48],[-18,-50],[-26,-8],[-10,-85],[-22,-48],[-14,-80],[-28,-40]],[[15280,10236],[-100,120],[-5,70],[-252,244],[-12,13]],[[14911,10683],[-1,127],[20,49],[34,79],[26,88],[-31,138],[-8,60],[-33,83]],[[14918,11307],[43,72],[47,79]],[[17683,15528],[-132,-18],[-86,38],[-75,-9],[6,69],[76,-20],[26,37]],[[17498,15625],[53,-12],[89,87],[-83,63],[-49,-30],[-52,45],[59,78],[-21,12]],[[19699,12259],[-17,145],[45,100],[90,23],[65,-17]],[[19882,12510],[58,-48],[31,83],[62,-44]],[[20033,12501],[16,-80],[-8,-144],[-118,-92],[31,-73],[-73,-8],[-61,-49]],[[19820,12055],[-58,18],[-28,62],[-35,124]],[[21495,15429],[60,-141],[17,-78],[1,-138],[-27,-66],[-63,-23],[-56,-50],[-62,-10],[-8,65],[13,90],[-31,125],[52,20],[-48,103]],[[21343,15326],[4,11],[31,-4],[28,54],[49,6],[30,7],[10,29]],[[13947,15907],[13,26]],[[13960,15933],[16,9],[10,40],[12,6],[10,-16],[13,-8],[9,-19],[12,-6],[14,-22],[9,1],[-7,-29],[-9,-15],[3,-9]],[[14052,15865],[-16,-4],[-41,-19],[-3,-24],[-9,1]],[[15892,14393],[14,-53],[-6,-27],[23,-90]],[[15923,14223],[-50,-4],[-17,58],[-62,11]],[[19670,13492],[40,-94],[32,-109],[85,-1],[28,-105],[-45,-31],[-20,-44],[83,-71],[58,-142],[44,-106],[53,-83],[18,-85],[-13,-120]],[[19882,12510],[23,54],[3,101],[-57,105],[-4,118],[-53,98],[-53,8],[-14,-42],[-40,-3],[-21,21],[-74,-72],[-1,108],[17,126],[-47,6],[-4,72],[-31,37]],[[19526,13247],[15,44],[60,78]],[[14996,14767],[25,98],[35,84],[1,5]],[[15057,14954],[31,-7],[12,-47],[-38,-45],[-17,-66]],[[12010,11321],[-18,-1],[-72,57],[-64,91],[-59,66],[-47,77]],[[11750,11611],[17,39],[3,35],[32,65],[32,56]],[[13208,14433],[34,28],[7,51],[-8,49],[48,47],[21,38],[34,34],[4,93]],[[13348,14773],[82,-42],[30,11],[58,-20],[92,-54],[33,-107],[62,-23],[99,-50],[74,-60],[34,31],[33,56],[-16,91],[22,59],[50,56],[48,16],[95,-24],[23,-54],[26,0],[22,-21],[70,-14],[17,-39]],[[14290,13437],[0,-240],[-80,0],[-1,-51]],[[14209,13146],[-278,230],[-278,230],[-70,-66]],[[13583,13540],[-50,-45],[-39,66],[-110,52]],[[18249,11700],[-11,-125],[-29,-34],[-61,-28],[-33,96],[-12,172],[31,195],[49,-67],[32,-84],[34,-125]],[[14568,7323],[24,-36],[-22,-58],[-12,-39],[-38,-19],[-13,-38],[-25,-12],[-52,92],[37,76],[38,47],[32,24],[31,-37]],[[14185,17265],[-17,37],[-36,13]],[[14132,17315],[-6,30],[8,33],[-31,19],[-73,21]],[[14030,17418],[-15,101]],[[14015,17519],[80,37],[117,-8],[68,12],[10,-25],[37,-8],[67,-58]],[[14015,17519],[3,90],[34,76],[66,41],[55,-90],[56,2],[13,93]],[[14450,17692],[33,-27],[6,-58],[23,-71]],[[11943,14115],[-10,0],[1,-64],[-43,-4],[-22,-27],[-32,0],[-25,15],[-59,-13],[-22,-93],[-22,-9],[-33,-151],[-97,-130],[-23,-165],[-28,-54],[-9,-43],[-157,-10],[-1,0]],[[11361,13367],[3,56],[27,32],[23,63],[-5,41],[24,84],[39,77],[24,19],[18,70],[2,64],[25,74],[46,44],[45,122],[1,2],[35,46],[65,13],[55,82],[35,32],[58,100],[-18,150],[27,103],[9,63],[45,81],[70,55],[52,49],[46,125],[22,73],[51,0],[42,-51],[67,8],[72,-26],[30,-2]],[[14403,16582],[17,18],[46,12],[51,-38],[29,-4],[32,-32],[-5,-41],[25,-20],[10,-50],[24,-30],[-5,-18],[13,-12],[-18,-9],[-41,3],[-7,17],[-15,-10],[5,-21],[-19,-38],[-12,-42],[-17,-13]],[[14516,16254],[-13,55],[7,51],[-2,53],[-40,71],[-22,51],[-22,35],[-21,12]],[[16001,9301],[19,-51],[17,-79],[11,-144],[18,-57],[-7,-57],[-12,-35],[-24,70],[-13,-36],[13,-88],[-6,-51],[-19,-28],[-4,-102],[-28,-139],[-34,-166],[-43,-227],[-27,-167],[-32,-139],[-56,-28],[-61,-51],[-40,30],[-56,43],[-19,64],[-4,106],[-25,96],[-6,86],[12,86],[32,21],[0,40],[34,91],[6,77],[-16,56],[-13,76],[-6,111],[24,67],[10,76],[35,4],[38,25],[26,21],[31,2],[40,68],[57,74],[21,61],[-10,51],[30,-14],[38,83],[2,72],[23,54],[24,-52]],[[6118,12541],[-78,130],[-36,39],[-57,31],[-39,-9],[-56,-45],[-35,-12],[-50,32],[-52,23],[-65,55],[-52,16],[-79,56],[-58,58],[-18,32],[-39,7],[-71,38],[-29,54],[-75,69],[-35,75],[-17,59],[23,11],[-7,35],[16,31],[1,41],[-24,54],[-6,48],[-24,60],[-61,120],[-70,93],[-34,75],[-60,49],[-13,29],[11,75],[-36,28],[-41,58],[-17,84],[-38,9],[-40,63],[-33,59],[-3,37],[-37,91],[-25,92],[1,46],[-50,47],[-24,-5],[-39,33],[-12,-49],[12,-57],[7,-90],[24,-50],[51,-82],[12,-29],[10,-8],[10,-41],[12,1],[14,-77],[21,-31],[15,-42],[44,-61],[23,-112],[21,-52],[19,-56],[4,-64],[34,-4],[27,-54],[26,-54],[-2,-21],[-29,-44],[-13,0],[-18,73],[-46,69],[-50,58],[-36,30],[3,88],[-11,65],[-33,37],[-48,54],[-9,-16],[-18,31],[-43,29],[-41,70],[5,9],[29,-7],[26,45],[2,54],[-53,86],[-41,33],[-26,75],[-26,79],[-32,95],[-28,108]],[[4383,14700],[79,10],[88,13],[-6,-24],[105,-58],[159,-85],[139,1],[55,0],[0,50],[121,0],[25,-43],[36,-38],[42,-52],[23,-63],[17,-66],[36,-36],[58,-36],[44,94],[57,3],[49,-48],[35,-82],[24,-70],[41,-69],[15,-84],[20,-56],[54,-37],[50,-27],[27,4]],[[5776,13901],[-27,-106],[-12,-86],[-5,-161],[-7,-58],[12,-66],[22,-58],[14,-93],[46,-90],[16,-68],[27,-59],[74,-32],[29,-50],[61,33],[54,13],[52,21],[44,21],[44,49],[17,70],[5,100],[12,36],[48,31],[73,28],[62,-4],[42,10],[17,-26],[-2,-57],[-38,-72],[-16,-73],[12,-21],[-10,-52],[-17,-93],[-18,31],[-15,-2]],[[14052,15865],[23,7],[33,2]],[[11745,12290],[3,37],[-6,47],[-26,33],[-14,69],[-3,75]],[[11699,12551],[24,22],[11,70],[22,3],[49,-33],[39,23],[27,-8],[11,27],[279,2],[16,84],[-12,15],[-34,517],[-33,518],[106,2]],[[12845,13095],[0,-276],[-38,-80],[-6,-74],[-62,-19],[-95,-10],[-26,-43],[-44,-5]],[[19526,13247],[-40,-28],[-40,-52],[-49,-5],[-32,-130],[-30,-22],[34,-105],[44,-88],[29,-79],[-26,-104],[-24,-22],[17,-61],[46,-95],[8,-67],[-1,-56],[28,-109],[-39,-112],[-33,-123]],[[19418,11989],[-7,89],[21,92],[-23,71],[5,130],[-28,63],[-23,143],[-12,152],[-30,99],[-46,-60],[-79,-86],[-40,11],[-43,28],[24,149],[-14,112],[-55,139],[9,43],[-41,15],[-50,98]],[[13898,15821],[-15,9],[-19,40],[-30,23]],[[13887,16019],[19,-21],[10,-17],[23,-12],[26,-25],[-5,-11]],[[18664,16711],[74,21],[133,103],[106,57],[61,-37],[72,-2],[47,-56],[70,-4],[100,-30],[68,83],[-28,71],[72,124],[78,-49],[63,-14],[82,-31],[14,-90],[99,-51],[65,23],[89,15],[70,-15],[68,-58],[42,-61],[65,1],[88,-20],[64,30],[91,20],[103,84],[41,-13],[37,-40],[83,10]],[[14957,9415],[52,10],[84,-34],[18,15],[49,3],[24,36],[42,-2],[76,47],[56,69]],[[15358,9559],[11,-53],[-3,-120],[9,-105],[3,-188],[12,-58],[-21,-86],[-27,-83],[-44,-75],[-64,-45],[-79,-59],[-78,-128],[-27,-22],[-49,-86],[-29,-27],[-5,-86],[33,-91],[13,-70],[1,-36],[13,6],[-2,-118],[-12,-55],[17,-21],[-11,-50],[-29,-42],[-57,-41],[-84,-65],[-31,-44],[6,-51],[18,-8],[-6,-63]],[[14836,7589],[-53,1]],[[14783,7590],[-6,53],[-10,54]],[[14767,7697],[-6,43],[12,134],[-18,85],[-33,169]],[[14722,8128],[73,136],[19,86],[10,11],[8,71],[-11,35],[3,90],[13,83],[0,152],[-36,39],[-33,8],[-15,30],[-32,25],[-59,-2],[-4,45]],[[14658,8937],[-7,85],[212,99]],[[14863,9121],[40,-58],[19,11],[28,-30],[4,-48],[-15,-56],[5,-84],[46,-74],[21,83],[30,25],[-6,154],[-29,87],[-25,39],[-24,-2],[-20,156],[20,91]],[[11699,12551],[-46,82],[-42,88],[-46,32],[-34,35],[-39,-1],[-34,-26],[-34,10],[-24,-38]],[[11400,12733],[-6,65],[19,59],[9,113],[-8,118],[-8,60],[7,60],[-18,57],[-37,52]],[[11358,13317],[15,40],[273,-1],[-13,173],[17,62],[65,10],[-2,307],[229,-6],[0,182]],[[14863,9121],[-37,31],[21,112],[22,41],[-13,100],[14,97],[12,32],[-18,102],[-33,54]],[[14831,9690],[68,-23],[14,-33],[24,-56],[20,-163]],[[20595,11451],[54,83],[35,94],[28,0],[36,-60],[3,-52],[46,-34],[58,-36],[-4,-47],[-47,-6],[12,-59],[-51,-40]],[[20192,11038],[51,-41],[54,22],[14,102],[30,22],[83,26],[50,95],[34,76]],[[19668,11544],[16,-12],[41,-72],[29,-80],[4,-81],[-7,-55],[6,-41],[5,-71],[25,-33],[27,-106],[-1,-41],[-49,-8],[-66,89],[-83,95],[-8,62],[-40,80],[-10,99],[-25,66],[8,87],[-16,51]],[[19524,11573],[12,21],[57,-52],[6,-62],[46,14],[23,50]],[[14166,8695],[57,27],[45,-7],[28,-27],[0,-10]],[[13934,7826],[0,-443],[-62,-62],[-37,-8],[-44,22],[-31,9],[-12,51],[-28,33],[-33,-59]],[[13687,7369],[-52,91],[-27,87],[-16,117],[-17,87],[-23,185],[-2,143],[-9,66],[-27,49],[-36,99],[-36,144],[-16,75],[-56,117],[-5,93]],[[24104,8268],[57,-74],[36,-55],[-26,-29],[-39,32],[-50,54],[-44,64],[-47,84],[-9,41],[30,-2],[39,-40],[30,-41],[23,-34]],[[13583,13540],[17,-186],[26,-32],[1,-38],[29,-41],[-15,-52],[-27,-243],[-4,-156],[-89,-113],[-30,-158],[29,-45],[0,-77],[45,-3],[-7,-56]],[[13536,12295],[-13,-3],[-47,132],[-16,4],[-55,-67],[-54,35],[-37,7],[-21,-17],[-40,4],[-42,-51],[-35,-3],[-84,62],[-33,-29],[-36,2],[-26,45],[-70,45],[-75,-15],[-18,-25],[-10,-69],[-20,-49],[-5,-107]],[[13140,11370],[-72,-43],[-27,6],[-27,-27],[-55,3],[-38,75],[-23,86],[-49,79],[-52,-1],[-62,0]],[[6573,12127],[-24,38],[-33,49],[-15,40],[-30,38],[-35,54],[8,19],[12,-19],[5,9]],[[6751,12596],[-6,-11],[-3,-27],[7,-44],[-16,-41],[-8,-48],[-2,-53],[4,-31],[2,-54],[-11,-12],[-6,-51],[4,-32],[-14,-30],[3,-33],[11,-19]],[[12779,16957],[36,33],[61,177],[95,50],[58,-4]],[[13987,19088],[-44,-5],[-10,-79],[-131,19],[-19,-67],[-67,1],[-46,-86],[-69,-133],[-109,-168],[26,-41],[-24,-48],[-70,2],[-45,-112],[4,-160],[45,-60],[-23,-142],[-58,-82],[-31,-69]],[[13316,17858],[-47,74],[-137,-139],[-93,-28],[-97,61],[-24,129],[-23,277],[65,77],[184,101],[137,124],[128,167],[167,231],[117,91],[192,150],[153,53],[114,-7],[107,100],[127,-6],[125,24],[218,-88],[-90,-32],[77,-75]],[[14716,19142],[-119,-48],[-56,-11]],[[14271,20137],[-156,-49],[-123,28],[48,31],[-42,38],[145,24],[27,-45],[101,-27]],[[13820,20359],[229,-90],[-175,-47],[-39,-88],[-61,-23],[-33,-99],[-84,-5],[-150,73],[63,43],[-104,35],[-136,101],[-54,94],[190,43],[38,-42],[99,2],[27,41],[102,4],[88,-42]],[[14321,20444],[137,-43],[-103,-64],[-203,-14],[-205,20],[-12,33],[-101,2],[-76,55],[215,33],[102,-28],[70,36],[176,-30]],[[24608,5888],[16,-49],[50,48],[20,-50],[0,-51],[-26,-55],[-45,-89],[-36,-48],[26,-58],[-54,-1],[-60,-46],[-18,-78],[-40,-121],[-55,-54],[-35,-34],[-64,2],[-45,40],[-76,8],[-11,44],[37,89],[88,119],[45,22],[50,46],[60,63],[41,62],[31,89],[27,31],[10,67],[49,55],[15,-51]],[[24719,6460],[51,-127],[1,82],[32,-33],[10,-90],[56,-39],[47,-10],[40,46],[36,-14],[-17,-107],[-21,-70],[-54,3],[-18,-37],[6,-51],[-10,-22],[-26,-65],[-35,-82],[-54,-48],[-12,31],[-29,18],[40,98],[-23,66],[-75,48],[2,44],[51,42],[12,92],[-4,78],[-28,80],[2,21],[-33,50],[-55,106],[-29,85],[26,9],[37,-66],[55,-32],[19,-106]],[[16456,13923],[20,41],[9,-11],[-7,-49],[-9,-22]],[[16479,13787],[31,-82],[39,-43],[51,-16],[41,-22],[32,-68],[19,-40],[25,-15],[-1,-27],[-25,-72],[-11,-33],[-29,-39],[-26,-82],[-32,6],[-15,-28],[-11,-61],[9,-80],[-7,-15],[-32,0],[-43,-44],[-7,-59],[-16,-25],[-43,1],[-28,-30],[1,-49],[-34,-33],[-39,11],[-46,-40],[-32,-7]],[[16250,12795],[-23,84],[-55,198]],[[16172,13077],[209,120],[47,240],[-32,84]],[[17300,13639],[-51,31],[-21,86],[-54,91],[-128,-22],[-113,-2],[-99,-17]],[[7119,11664],[-24,34],[-15,65],[18,32],[-18,8],[-13,40],[-35,33],[-30,-7],[-14,-42],[-29,-30],[-15,-4],[-7,-25],[34,-65],[-19,-16],[-11,-17],[-32,-7],[-12,72],[-9,-20],[-23,7],[-14,48],[-29,8],[-18,14],[-30,0],[-2,-26],[-8,18]],[[6793,11945],[25,-43],[-1,-26],[28,-5],[6,10],[20,-30],[34,9],[29,30],[43,24],[24,36],[38,-7],[-3,-12],[39,-4],[31,-20],[23,-36],[26,-34]],[[7642,8596],[-70,69],[-6,49],[-138,121],[-125,131],[-54,74],[-29,99],[12,34],[-59,158],[-69,221],[-66,239],[-29,55],[-21,88],[-55,78],[-49,49],[22,54],[-34,114],[22,84],[56,76]],[[21357,11807],[7,-80],[4,-67],[-24,-110],[-25,122],[-33,-61],[23,-88],[-20,-56],[-82,69],[-20,87],[21,57],[-44,57],[-22,-50],[-33,5],[-51,-67],[-12,35],[28,101],[44,34],[38,45],[24,-54],[53,33],[12,53],[49,3],[-4,93],[56,-57],[6,-60],[5,-44]],[[21190,12030],[-25,-39],[-22,-76],[-22,-35],[-43,82],[15,33],[17,33],[8,75],[38,7],[-11,-81],[52,116],[-7,-115]],[[20808,11915],[-92,-114],[34,84],[50,74],[42,83],[36,119],[13,-98],[-46,-66],[-37,-82]],[[21044,12224],[42,-37],[44,0],[-1,-50],[-33,-51],[-44,-36],[-2,56],[5,61],[-11,57]],[[21296,12256],[20,-134],[-54,32],[1,-40],[17,-74],[-33,-27],[-3,84],[-21,7],[-11,72],[41,-9],[0,45],[-43,92],[67,-3],[19,-45]],[[21019,12365],[-19,-104],[-29,60],[-36,92],[60,-5],[24,-43]],[[21005,13017],[43,-34],[21,31],[6,-30],[-11,-50],[24,-86],[-18,-100],[-42,-40],[-11,-96],[16,-96],[37,-13],[31,14],[87,-66],[-7,-66],[23,-29],[-7,-55],[-55,59],[-25,63],[-18,-44],[-45,72],[-63,-18],[-35,27],[4,49],[22,31],[-21,28],[-9,-44],[-35,69],[-10,52],[-3,115],[28,-39],[8,188],[22,108],[43,0]],[[22376,10485],[121,-82],[129,-69],[48,-62],[39,-60],[11,-71],[116,-74],[17,-63],[-64,-13],[15,-80],[62,-79],[46,-127],[39,4],[-2,-53],[53,-21],[-20,-22],[74,-51],[-8,-34],[-46,-9],[-17,31],[-60,14],[-71,18],[-54,76],[-39,66],[-37,105],[-91,53],[-59,-34],[-42,-40],[9,-88],[-55,-42],[-39,20],[-72,5]],[[23414,9979],[-20,-12],[-30,46],[-31,76],[-15,92],[10,11],[8,-35],[21,-28],[33,-76],[33,-40],[-9,-34]],[[23142,10140],[-37,-10],[-11,-34],[-38,-29],[-35,-28],[-37,0],[-58,35],[-39,34],[5,37],[63,-18],[38,10],[10,57],[10,3],[7,-64],[40,10],[20,41],[39,42],[-8,71],[42,2],[14,-19],[-2,-67],[-23,-73]],[[23223,10257],[-22,-32],[-13,71],[-17,47],[-31,39],[-40,51],[-50,35],[19,29],[38,-33],[24,-27],[29,-29],[28,-50],[26,-38],[9,-63]],[[14188,16985],[35,-105],[-8,-33],[-34,-14],[-64,-100],[18,-54],[-15,7]],[[14120,16686],[-66,46],[-50,-17],[-33,12],[-42,-25],[-35,42],[-28,-16],[-4,7]],[[13532,17246],[47,36],[109,55],[88,41],[70,-21],[5,-29],[67,-1]],[[13918,17327],[86,-14],[128,2]],[[7927,13018],[36,-10],[12,-24],[-18,-30],[-52,0],[-41,-4],[-4,52],[10,17],[57,-1]],[[21654,15883],[10,-21]],[[21664,15862],[-27,7],[-30,-40],[-21,-41],[3,-86],[-36,-27],[-12,-21],[-27,-35],[-46,-20],[-30,-32],[-3,-52],[-8,-13],[28,-20],[40,-53]],[[21343,15326],[-34,23],[-8,-23],[-21,-10],[-2,23],[-18,11],[-19,19],[19,53],[17,14],[-7,22],[18,65],[-5,19],[-40,13],[-33,32]],[[12028,15248],[-28,-31],[-37,17],[-36,-14],[11,94],[-7,74],[-31,11],[-17,45],[6,79],[28,44],[5,48],[14,72],[-1,51],[-14,43],[-3,41]],[[16089,13767],[-4,87],[19,63],[19,13],[21,-37],[1,-71],[-15,-70]],[[16130,13752],[-20,-9],[-21,24]],[[14127,16104],[-13,21],[16,20],[-17,15],[-22,-27],[-40,35],[-6,50],[-42,28],[-8,38],[-38,47]],[[14131,16542],[30,25],[43,-13],[45,0],[32,-30],[24,19],[51,11],[18,28],[29,0]],[[14516,16254],[31,-22],[32,20],[32,-21]],[[14611,16231],[2,-31],[-34,-26],[-21,11],[-20,-144]],[[15333,16008],[-89,101],[-80,46],[-60,70],[51,19],[58,101],[-39,47],[102,49],[-1,26],[-63,-19]],[[15212,16448],[2,53],[36,34],[68,9],[11,40],[-16,66],[28,63],[0,35],[-103,39],[-41,-1],[-43,56],[-53,-19],[-89,42],[2,23],[-25,53],[-56,5],[-6,38],[18,24],[-45,68],[-72,-12],[-21,6],[-18,-27],[-26,5]],[[14498,17932],[79,67],[-73,57]],[[14716,19142],[71,42],[115,-73],[191,-28],[263,-136],[54,-57],[4,-80],[-77,-63],[-114,-32],[-311,91],[-51,-15],[113,-88],[5,-56],[4,-122],[90,-37],[55,-31],[9,58],[-42,52],[44,45],[168,-74],[59,29],[-47,88],[163,117],[64,-7],[65,-42],[41,83],[-58,71],[34,72],[-51,75],[195,-39],[39,-67],[-88,-15],[1,-67],[54,-41],[108,26],[17,77],[146,57],[243,103],[53,-6],[-69,-73],[86,-12],[50,41],[131,3],[103,50],[80,-73],[79,80],[-73,69],[36,40],[206,-36],[97,-38],[252,-137],[47,63],[-71,63],[-2,26],[-84,12],[23,56],[-37,94],[-2,38],[128,109],[46,109],[52,24],[184,-32],[15,-67],[-66,-97],[43,-38],[23,-84],[-16,-164],[77,-74],[-30,-80],[-137,-170],[80,-18],[28,43],[76,31],[19,59],[60,57],[-40,69],[32,79],[-76,10],[-17,66],[56,121],[-91,98],[125,80],[-16,86],[35,3],[36,-67],[-27,-116],[74,-22],[-31,87],[116,47],[145,6],[129,-68],[-62,100],[-7,128],[121,24],[168,-5],[151,15],[-57,63],[81,79],[80,3],[135,60],[184,16],[24,32],[183,12],[57,-27],[156,63],[128,-2],[20,52],[66,51],[165,50],[119,-39],[-95,-30],[158,-18],[19,-60],[64,30],[204,-2],[157,-59],[56,-44],[-18,-63],[-77,-35],[-183,-67],[-52,-36],[86,-16],[103,-31],[63,23],[35,-77],[31,31],[112,19],[223,-20],[17,-56],[292,-18],[4,92],[148,-21],[111,1],[112,-63],[32,-77],[-41,-50],[88,-95],[109,-49],[68,126],[111,-54],[119,33],[135,-37],[52,33],[114,-16],[-51,111],[92,52],[630,-78],[59,-71],[183,-92],[281,23],[139,-20],[58,-50],[-8,-87],[85,-34],[94,24],[123,3],[132,-23],[132,13],[121,-107],[87,39],[-57,76],[32,54],[222,-34],[145,7],[200,-57],[98,-52],[0,-478],[-1,-1],[-89,-53],[-90,9],[62,-64],[42,-99],[32,-32],[8,-49],[-18,-32],[-130,26],[-195,-90],[-62,-14],[-106,-85],[-101,-73],[-26,-55],[-100,83],[-181,-94],[-32,45],[-67,-52],[-93,17],[-23,-79],[-84,-116],[3,-49],[79,-27],[-9,-174],[-65,-5],[-30,-100],[29,-52],[-121,-61],[-25,-137],[-104,-29],[-20,-122],[-101,-112],[-26,83],[-30,175],[-38,266],[33,167],[59,71],[3,56],[109,27],[124,151],[120,123],[126,96],[56,169],[-85,-10],[-42,-99],[-177,-131],[-57,147],[-180,-41],[-174,-201],[57,-73],[-155,-32],[-108,-12],[5,87],[-108,18],[-87,-59],[-213,21],[-229,-36],[-226,-234],[-267,-283],[110,-15],[34,-75],[68,-27],[44,60],[77,-8],[100,-132],[3,-102],[-55,-120],[-6,-143],[-31,-192],[-105,-173],[-23,-83],[-95,-140],[-94,-138],[-45,-71],[-93,-71],[-44,-1],[-44,58],[-93,-88],[-11,-40]],[[15970,16364],[-32,-71],[-67,-20],[-69,-124],[63,-114],[-7,-81],[76,-141]],[[13918,17327],[16,52],[96,39]],[[14878,16312],[19,30],[49,-26],[23,-4],[9,-24],[10,-4]],[[14988,16284],[1,-10],[34,-29],[71,7],[-14,-43],[-76,-20],[-95,-70],[-38,25],[15,56],[-76,35],[12,23],[67,40],[-11,14]],[[22561,16885],[70,-212],[-103,39],[-43,-173],[68,-123],[-2,-84],[-53,73],[-46,-93],[-12,100],[7,117],[-8,130],[17,90],[3,161],[-41,118],[6,164],[64,55],[-27,56],[31,16],[18,-79],[24,-116],[-2,-118],[29,-121]],[[348,18785],[47,-30],[-17,88],[190,-18],[136,-113],[-69,-52],[-114,-12],[-2,-118],[-28,-24],[-65,3],[-53,42],[-93,35],[-16,52],[-70,20],[-80,-16],[-38,42],[16,45],[-84,-29],[32,-56],[-40,-51],[0,478],[171,-92],[183,-119],[-6,-75]],[[25095,19295],[-76,-6],[-13,38],[89,50],[0,-82]],[[91,19302],[-91,-7],[0,82],[9,5],[59,0],[101,-35],[-6,-16],[-72,-29]],[[22558,19580],[-106,0],[-143,13],[-12,6],[66,48],[87,11],[99,-46],[9,-32]],[[23055,19805],[-81,-47],[-111,10],[-130,48],[17,38],[130,-18],[175,-31]],[[22661,19862],[-55,-89],[-257,4],[-115,-29],[-138,78],[37,83],[92,22],[184,-5],[252,-64]],[[16558,19281],[-41,-10],[-228,16],[-18,53],[-126,32],[-11,65],[72,25],[-3,66],[139,102],[-65,15],[167,105],[-18,55],[155,63],[231,77],[232,22],[119,45],[136,16],[48,-48],[-47,-37],[-247,-60],[-213,-57],[-216,-114],[-104,-117],[-109,-116],[14,-99],[133,-99]],[[19872,20192],[-393,-47],[128,158],[57,13],[52,-8],[177,-68],[-21,-48]],[[16112,20460],[-93,-15],[-63,-10],[-10,-19],[-81,-20],[-76,28],[40,38],[-155,3],[136,22],[106,2],[14,-33],[40,29],[66,20],[103,-26],[-27,-19]],[[19514,20260],[-152,-15],[-194,35],[-116,46],[-53,86],[-95,24],[181,82],[150,27],[136,-61],[160,-116],[-17,-108]],[[14609,10636],[17,-12],[42,37]],[[14668,10661],[28,-68],[-4,-70],[-21,-15]],[[11358,13317],[3,50]],[[16172,13077],[-201,-46],[-65,-54],[-50,-126],[-32,-20],[-18,40],[-26,-6],[-68,12],[-13,12],[-80,-3],[-19,-11],[-28,31],[-19,-59],[7,-50],[-30,-39]],[[15530,12758],[-9,52],[-21,36],[-6,48],[-36,43],[-37,100],[-20,98],[-48,83],[-31,19],[-46,115],[-8,83],[3,71],[-40,133],[-33,47],[-38,25],[-22,68],[3,28],[-19,62],[-20,27],[-28,89],[-42,97],[-36,82],[-34,-1],[10,66],[4,42],[8,48]],[[15923,14223],[27,-104],[34,-27],[12,-42],[48,-51],[4,-49],[-7,-40],[9,-41],[20,-33],[9,-40],[10,-29]],[[16130,13752],[13,-46]],[[14141,12134],[1,29],[-25,35],[-1,70],[-15,46],[-24,-7],[7,44],[18,50],[-8,50],[23,37],[-15,28],[19,74],[32,88],[60,-8],[-4,476]],[[15117,13437],[23,-118],[-15,-22],[10,-123],[25,-144],[27,-29],[38,-45]],[[14916,11839],[-1,94],[-10,2],[2,60],[-9,41],[-36,47],[-8,87],[8,88],[-32,9],[-5,-27],[-42,-6],[17,-35],[6,-72],[-38,-66],[-35,-87],[-36,-12],[-58,70],[-27,-25],[-7,-35],[-36,-23],[-2,-24],[-70,0],[-9,24],[-51,5],[-25,-21],[-19,10],[-36,70],[-12,33],[-50,-16],[-19,-56],[-18,-107],[-24,-23],[-21,-13],[47,-47]],[[14918,11307],[-43,-55],[-49,0],[-56,-28],[-44,27],[-29,-33]],[[11385,12283],[-11,92]],[[11382,12428],[-28,94],[-35,42],[31,23],[33,84],[17,62]],[[23849,9540],[19,-42],[-49,1],[-26,74],[41,-29],[15,-4]],[[23760,9613],[-27,-3],[-43,12],[-14,19],[4,47],[46,-19],[23,-25],[11,-31]],[[23818,9645],[-11,-22],[-51,104],[-15,72],[24,0],[25,-96],[28,-58]],[[23692,9797],[3,-24],[-55,51],[-38,43],[-26,40],[11,12],[32,-29],[57,-55],[16,-38]],[[23529,9916],[-14,-7],[-30,27],[-29,49],[4,20],[41,-50],[28,-39]],[[11750,11611],[-19,9],[-50,49],[-36,64],[-12,44],[-9,88]],[[6428,12403],[-8,-28],[-41,1],[-25,12],[-28,24],[-39,7],[-20,26]],[[15555,12172],[23,-22],[13,-49],[32,-51],[34,0],[66,31],[76,14],[61,37],[35,8],[25,22],[40,4]],[[15960,12166],[-1,-2],[0,-49],[0,-121],[0,-63],[-32,-74],[-48,-100]],[[15960,12166],[22,2],[32,18],[37,12],[33,41],[26,1],[2,-33],[-6,-70],[0,-63],[-15,-44],[-20,-129],[-33,-134],[-43,-153],[-60,-176],[-60,-135],[-82,-163],[-69,-97],[-105,-120],[-65,-91],[-76,-145],[-16,-63],[-16,-29]],[[8564,11514],[83,-24],[8,21],[56,9],[75,-32]],[[14120,16686],[-19,-31],[-14,-49]],[[13504,16256],[15,11]],[[14214,18716],[-120,-34],[-68,-84],[11,-73],[-111,-97],[-134,-103],[-51,-169],[49,-84],[67,-67],[-64,-135],[-72,-28],[-27,-202],[-40,-112],[-84,12],[-40,-96],[-80,-5],[-22,113],[-59,136],[-53,170]],[[14783,7590],[-14,-53],[-41,-13],[-41,65],[-1,41],[19,45],[7,35],[20,9],[35,-22]],[[15057,14954],[-7,91],[17,50]],[[15067,15095],[19,26],[19,26],[4,67],[22,-23],[77,33],[37,-22],[58,0],[80,45],[37,-2],[80,19]],[[12678,11534],[-57,-26]],[[19699,12259],[-63,55],[-60,-2],[11,94],[-62,0],[-5,-132],[-38,-176],[-23,-106],[5,-86],[46,-4],[28,-110],[12,-103],[39,-69],[42,-14],[37,-62]],[[19524,11573],[-27,46],[-12,59],[-37,68],[-34,57],[-11,-71],[-14,67],[8,75],[21,115]],[[17276,15253],[39,122],[-15,89],[-51,29],[18,53],[58,-6],[33,66],[22,77],[94,28],[-15,-55],[10,-34],[29,3]],[[16306,15260],[-13,85],[10,125],[-54,41],[18,82],[-46,7],[15,101],[66,-29],[61,38],[-51,72],[-20,69],[-56,-31],[-7,-88],[-22,78]],[[16449,15753],[79,2],[-12,60],[60,41],[58,70],[94,-63],[8,-96],[26,-25],[76,6],[23,-22],[35,-124],[79,-82],[46,-57],[73,-59],[92,-51],[-2,-73]],[[21259,9730],[8,29],[60,27],[49,4],[21,15],[27,-15],[-26,-33],[-72,-52],[-59,-35]],[[8248,12088],[40,16],[15,-5],[-3,-89],[-58,-13],[-13,11],[20,33],[-1,47]],[[13135,15230],[75,48],[49,-14],[-2,-61],[59,44],[5,-23],[-35,-59],[0,-55],[24,-30],[-9,-104],[-46,-60],[13,-66],[36,-2],[18,-57],[26,-18]],[[15067,15095],[-25,54],[26,45],[-42,-10],[-59,28],[-48,-70],[-105,-13],[-57,64],[-75,4],[-16,-49],[-48,-15],[-68,64],[-76,-2],[-41,119],[-51,67],[34,93],[-44,58],[77,114],[107,5],[30,91],[133,-16],[83,78],[82,34],[115,3],[122,-85],[100,-46],[81,18],[60,-10],[82,62]],[[14499,15837],[8,-46],[61,-39],[-12,-29],[-83,-7],[-30,-37],[-58,-65],[-22,56],[1,25]],[[21036,13724],[-42,-193],[-29,-98],[-37,101],[-8,89],[41,118],[56,91],[32,-36],[-13,-72]],[[14668,10661],[24,14],[77,-1],[142,9]],[[15280,10236],[-32,-148],[4,-68],[45,-43],[2,-32],[-19,-72],[4,-36],[-5,-58],[24,-75],[29,-118],[26,-27]],[[14831,9690],[-39,36],[-45,20],[-28,20],[-29,31]],[[15212,16448],[-56,-10],[-46,-38],[-65,-7],[-60,-44],[3,-65]],[[14878,16312],[-9,13],[-109,31],[-4,44],[-65,-14],[-26,-66],[-54,-89]],[[8827,6746],[-30,-75],[-79,-67],[-51,24],[-38,-13],[-65,52],[-47,-4],[-42,66]],[[7867,16212],[13,-39],[-75,-58],[-72,-42],[-73,-35],[-37,-71],[-12,-27],[-1,-64],[23,-64],[29,-3],[-7,44],[21,-26],[-6,-35],[-47,-19],[-33,2],[-52,-21],[-30,-6],[-41,-6],[-58,-34],[103,22],[20,-22],[-97,-36],[-45,-1],[2,15],[-21,-33],[21,-6],[-15,-86],[-51,-92],[-5,31],[-16,6],[-22,30],[14,-65],[17,-21],[1,-46],[-22,-46],[-39,-96],[-7,5],[22,81],[-36,46],[-8,100],[-13,-52],[15,-76],[-46,19],[48,-39],[3,-114],[20,-8],[7,-42],[10,-120],[-45,-89],[-72,-35],[-46,-71],[-34,-8],[-36,-44],[-10,-40],[-76,-78],[-39,-57],[-33,-71],[-11,-85],[12,-83],[24,-103],[30,-85],[1,-52],[33,-139],[-2,-81],[-3,-47],[-18,-73],[-21,-15],[-34,15],[-11,52],[-26,28],[-37,103],[-33,92],[-10,47],[14,79],[-19,66],[-55,101],[-27,18],[-70,-54],[-13,6],[-34,56],[-43,29],[-79,-15],[-62,13],[-53,-8],[-29,-19],[13,-31],[-2,-49],[15,-24],[-13,-16],[-26,18],[-26,-23],[-51,4],[-52,64],[-60,-15],[-51,27],[-44,-8],[-58,-28],[-64,-89],[-69,-52],[-38,-57],[-16,-54],[-1,-83],[4,-57],[13,-41]],[[4383,14700],[-12,62],[-45,69],[-33,14],[-7,34],[-39,6],[-25,33],[-65,12],[-18,19],[-8,66],[-68,120],[-58,167],[2,28],[-30,40],[-54,100],[-10,98],[-37,66],[15,99],[-2,103],[-22,92],[27,113],[8,109],[9,109],[-13,161],[-22,102],[-20,56],[8,23],[101,-41],[37,-113],[17,32],[-11,98],[-23,99]],[[3448,17372],[-38,45],[-62,38],[-19,105],[-90,97],[-38,113],[-67,8],[-111,3],[-81,34],[-144,125],[-67,23],[-122,42],[-97,-10],[-137,55],[-83,51],[-77,-25],[14,-83],[-38,-8],[-81,-25],[-61,-40],[-77,-26],[-10,71],[31,117],[74,37],[-19,30],[-89,-66],[-47,-80],[-101,-86],[51,-58],[-66,-86],[-75,-50],[-69,-37],[-18,-53],[-109,-62],[-22,-56],[-81,-52],[-48,10],[-65,-34],[-71,-41],[-58,-40],[-119,-34],[-11,20],[76,56],[68,37],[74,66],[87,13],[34,50],[97,71],[15,24],[52,43],[12,91],[35,71],[-80,-37],[-22,21],[-38,-44],[-46,61],[-19,-43],[-26,60],[-69,-48],[-43,0],[-6,71],[13,44],[-45,43],[-91,-23],[-59,56],[-48,29],[0,68],[-54,51],[27,69],[57,67],[25,62],[57,9],[47,-20],[57,58],[50,-10],[53,37],[-13,55],[-39,22],[52,46],[-43,-2],[-74,-26],[-21,-26],[-55,26],[-99,-13],[-102,29],[-29,48],[-88,70],[98,50],[155,58],[58,0],[-10,-60],[147,5],[-56,74],[-86,46],[-50,60],[-67,51],[-95,38],[39,63],[123,4],[88,55],[17,58],[71,57],[68,14],[132,53],[64,-8],[108,64],[105,-25],[50,-54],[31,23],[118,-7],[-4,-28],[107,-20],[71,12],[147,-38],[134,-12],[53,-15],[93,19],[106,-36],[76,-17]],[[1705,13087],[-10,-20],[-18,17],[2,33],[-11,44],[3,13],[12,20],[-4,23],[4,12],[5,-3],[27,-20],[12,-10],[11,-16],[18,-42],[-2,-7],[-27,-26],[-22,-18]],[[1667,13274],[-23,-9],[-12,26],[-8,9],[-1,8],[7,10],[25,-11],[18,-19],[-6,-14]],[[1620,13338],[-2,-13],[-37,3],[5,15],[34,-5]],[[1558,13355],[-4,-7],[-5,2],[-24,4],[-9,27],[-3,5],[19,17],[6,-8],[20,-40]],[[1440,13434],[-8,-12],[-24,22],[4,9],[10,12],[16,-3],[2,-28]],[[1882,17649],[-70,-45],[-36,31],[-10,56],[63,42],[37,19],[46,-8],[30,-38],[-60,-57]],[[1005,17985],[-43,-19],[-45,22],[-43,33],[69,20],[56,-10],[6,-46]],[[576,18449],[43,-23],[44,13],[56,-32],[69,-16],[-5,-13],[-53,-26],[-53,27],[-27,21],[-61,-7],[-17,11],[4,45]],[[7575,12210],[-2,-28],[-41,-14],[23,-55],[-1,-63],[-31,-69],[27,-95],[30,7],[15,87],[-21,42],[-4,91],[87,49],[-10,56],[25,38],[25,-84],[49,-2],[45,-67],[3,-40],[62,-1],[75,13],[40,-54],[53,-15],[39,38],[1,30],[86,7],[84,2],[-59,-36],[24,-56],[55,-9],[53,-59],[11,-96],[37,2],[27,-28]],[[20079,13383],[-93,-103],[-58,-113],[-15,-83],[53,-127],[66,-157],[63,-74],[42,-96],[32,-222],[-9,-211],[-58,-79],[-80,-77],[-57,-100],[-87,-112],[-25,77],[19,81],[-52,68]],[[24248,8822],[-23,-16],[-24,52],[3,33],[44,-69]],[[24196,9006],[12,-97],[-19,15],[-15,-7],[-10,34],[-1,91],[33,-36]],[[16250,12795],[-51,-32],[-13,-54],[-2,-41],[-69,-50],[-112,-56],[-62,-85],[-31,-6],[-21,7],[-40,-50],[-45,-23],[-58,-6],[-18,-7],[-15,-32],[-19,-9],[-10,-30],[-35,2],[-22,-16],[-48,6],[-19,70],[2,66],[-11,35],[-14,89],[-20,49],[14,6],[-7,55],[9,23],[-3,52]],[[14599,8147],[29,-1],[33,-21],[24,15],[37,-12]],[[14836,7589],[-17,-87],[-9,-100],[-18,-54],[-47,-61],[-14,-17],[-29,-61],[-20,-62],[-39,-86],[-79,-123],[-49,-72],[-53,-55],[-73,-47],[-35,-6],[-9,-33],[-43,18],[-34,-23],[-76,23],[-42,-15],[-29,7],[-72,-48],[-59,-19],[-43,-45],[-32,-3],[-30,43],[-23,2],[-30,54],[-3,-17],[-10,32],[1,70],[-23,81],[23,22],[-2,92],[-46,112],[-35,102],[0,0],[-50,156]],[[14658,8937],[-53,-17],[-40,-47],[-8,-42],[-25,-10],[-61,-98],[-38,-78],[-24,-3],[-22,14],[-78,13]]],"transform":{"scale":[0.01434548714883443,0.008335499711981569],"translate":[-180,-90]},"objects":{"ne_110m_admin_0_countries":{"type":"GeometryCollection","geometries":[{"arcs":[[0,1,2,3,4,5]],"type":"Polygon"},{"arcs":[[[6,7,8,9]],[[10,11,12]]],"type":"MultiPolygon"},{"arcs":[[13,14,15,16,17]],"type":"Polygon"},{"arcs":[[18,19,20,21,22]],"type":"Polygon"},{"arcs":[[[23,24]],[[25,26,27,28,29,30]]],"type":"MultiPolygon"},{"arcs":[[31,32,33,34,35]],"type":"Polygon"},{"arcs":[[[36]],[[37]],[[38]],[[39]],[[40]],[[41]],[[42]],[[43]]],"type":"MultiPolygon"},{"arcs":[[44]],"type":"Polygon"},{"arcs":[[[45]],[[46]]],"type":"MultiPolygon"},{"arcs":[[47,48,49,50,51,52,53]],"type":"Polygon"},{"arcs":[[[-33,54,55,56,57]],[[-35,58]]],"type":"MultiPolygon"},{"arcs":[[59,60,61]],"type":"Polygon"},{"arcs":[[62,63,64,65,66]],"type":"Polygon"},{"arcs":[[67,68,69,70,71]],"type":"Polygon"},{"arcs":[[-70,72,73,74,75,76]],"type":"Polygon"},{"arcs":[[77,78,79]],"type":"Polygon"},{"arcs":[[80,81,82,83,84,85]],"type":"Polygon"},{"arcs":[[[86]],[[87]],[[88]]],"type":"MultiPolygon"},{"arcs":[[89,90,91]],"type":"Polygon"},{"arcs":[[92,93,94,95,96]],"type":"Polygon"},{"arcs":[[97,98,99]],"type":"Polygon"},{"arcs":[[-27,100,101,102,103]],"type":"Polygon"},{"arcs":[[-29,104,-103,105,106,107,108,109,110,111,112]],"type":"Polygon"},{"arcs":[[113,114]],"type":"Polygon"},{"arcs":[[115,116]],"type":"Polygon"},{"arcs":[[117,118,119,120]],"type":"Polygon"},{"arcs":[[121,122,123,124,125,126]],"type":"Polygon"},{"arcs":[[[127]],[[128]],[[129]],[[130]],[[131]],[[132]],[[133]],[[134]],[[135]],[[136]],[[137,138,139,140]],[[141]],[[142]],[[143]],[[144]],[[145]],[[146]],[[147]],[[148]],[[149]],[[150]],[[151]],[[152]],[[153]],[[154]],[[155]],[[156]],[[157]],[[158]],[[159]]],"type":"MultiPolygon"},{"arcs":[[-51,160,161,162]],"type":"Polygon"},{"arcs":[[[-24,163]],[[-26,164,165,-101]]],"type":"MultiPolygon"},{"arcs":[[[-4,166,167,168,169,170,171,172,173,174,175,176,177,-117,178,179,180,181]],[[182]]],"type":"MultiPolygon"},{"arcs":[[-75,183,184,185,186,187]],"type":"Polygon"},{"arcs":[[-127,188,189,190,191,192,193,194]],"type":"Polygon"},{"arcs":[[-9,195,-13,196,-125,197,198,199,-60,200,201]],"type":"Polygon"},{"arcs":[[-12,202,203,-189,-126,-197]],"type":"Polygon"},{"arcs":[[-107,204,205,206,207,208,209]],"type":"Polygon"},{"arcs":[[210,211,212,213]],"type":"Polygon"},{"arcs":[[214]],"type":"Polygon"},{"arcs":[[215,216]],"type":"Polygon"},{"arcs":[[-217,217]],"type":"Polygon"},{"arcs":[[-53,218,219,220]],"type":"Polygon"},{"arcs":[[-52,-163,221,222,-63,223,224,225,226,227,-219]],"type":"Polygon"},{"arcs":[[228,229,230,231]],"type":"Polygon"},{"arcs":[[[-226,232]],[[233]]],"type":"MultiPolygon"},{"arcs":[[234,235]],"type":"Polygon"},{"arcs":[[236,237,238,239,240,241,242,243]],"type":"Polygon"},{"arcs":[[-206,244,245]],"type":"Polygon"},{"arcs":[[246,247,248,249,250]],"type":"Polygon"},{"arcs":[[-232,251,252,253]],"type":"Polygon"},{"arcs":[[254,255,256,257]],"type":"Polygon"},{"arcs":[[258,259,260]],"type":"Polygon"},{"arcs":[[-231,261,262,263,264,265,-252]],"type":"Polygon"},{"arcs":[[266,267,268,269]],"type":"Polygon"},{"arcs":[[[270]],[[271]],[[272]]],"type":"MultiPolygon"},{"arcs":[[273]],"type":"Polygon"},{"arcs":[[[-65,274,-222,-162,275,276,-256,277]],[[-111,278,279]],[[280]]],"type":"MultiPolygon"},{"arcs":[[-190,-204,281,282]],"type":"Polygon"},{"arcs":[[[283,284]],[[285]]],"type":"MultiPolygon"},{"arcs":[[-32,286,287,288,-55]],"type":"Polygon"},{"arcs":[[-74,289,290,-184]],"type":"Polygon"},{"arcs":[[-187,291,292,293,294,295,296]],"type":"Polygon"},{"arcs":[[297,298]],"type":"Polygon"},{"arcs":[[-295,299,300]],"type":"Polygon"},{"arcs":[[-191,-283,301]],"type":"Polygon"},{"arcs":[[[-14,302,-84,303,304]],[[305]]],"type":"MultiPolygon"},{"arcs":[[306]],"type":"Polygon"},{"arcs":[[-100,307,308,309,310,311]],"type":"Polygon"},{"arcs":[[-109,312,313,314]],"type":"Polygon"},{"arcs":[[-309,315,316,317,318]],"type":"Polygon"},{"arcs":[[-91,319,320,321,322,323]],"type":"Polygon"},{"arcs":[[-236,324]],"type":"Polygon"},{"arcs":[[-48,325,326,327,328,-323,329]],"type":"Polygon"},{"arcs":[[[330]],[[331,332]],[[333]],[[334]],[[335]],[[336]],[[337]],[[338]],[[339,340]],[[341]],[[342]],[[343,344]],[[345]]],"type":"MultiPolygon"},{"arcs":[[-80,346,347,-181,348,-179,-116,-178,349]],"type":"Polygon"},{"arcs":[[-284,350]],"type":"Polygon"},{"arcs":[[-6,351,352,353,354,-59,-34,-58,355,356]],"type":"Polygon"},{"arcs":[[-354,357,358,359,360,361,362]],"type":"Polygon"},{"arcs":[[363]],"type":"Polygon"},{"arcs":[[364,365,366,367,368,369,-250]],"type":"Polygon"},{"arcs":[[[-50,370,371,-276,-161]],[[372]],[[373]]],"type":"MultiPolygon"},{"arcs":[[374]],"type":"Polygon"},{"arcs":[[-361,375,376,-370,377,-368,378]],"type":"Polygon"},{"arcs":[[[379]],[[380]],[[381]]],"type":"MultiPolygon"},{"arcs":[[-169,382,383,384,385,386]],"type":"Polygon"},{"arcs":[[-264,387,388,389,390,391]],"type":"Polygon"},{"arcs":[[-168,392,393,-383]],"type":"Polygon"},{"arcs":[[394,395,396,397]],"type":"Polygon"},{"arcs":[[398,399]],"type":"Polygon"},{"arcs":[[-17,400,401,402]],"type":"Polygon"},{"arcs":[[-359,403,404]],"type":"Polygon"},{"arcs":[[-176,405,-396,406,407]],"type":"Polygon"},{"arcs":[[-366,408,409]],"type":"Polygon"},{"arcs":[[-186,410,411,-292]],"type":"Polygon"},{"arcs":[[-243,412,413,-248,414,415,416]],"type":"Polygon"},{"arcs":[[417]],"type":"Polygon"},{"arcs":[[418]],"type":"Polygon"},{"arcs":[[-93,419,420,421,422]],"type":"Polygon"},{"arcs":[[-64,-223,-275]],"type":"Polygon"},{"arcs":[[-94,-423,423,-261,424]],"type":"Polygon"},{"arcs":[[-240,425,426]],"type":"Polygon"},{"arcs":[[427,428]],"type":"Polygon"},{"arcs":[[429]],"type":"Polygon"},{"arcs":[[-98,-312,430,431,432]],"type":"Polygon"},{"arcs":[[-18,-403,433,-85,-303]],"type":"Polygon"},{"arcs":[[-76,-188,-297,434,435,-237,436]],"type":"Polygon"},{"arcs":[[-78,-350,-177,-408,437,438]],"type":"Polygon"},{"arcs":[[-16,439,-320,-90,440,-401]],"type":"Polygon"},{"arcs":[[-171,441]],"type":"Polygon"},{"arcs":[[442,443,444,445,446,447,448,449]],"type":"Polygon"},{"arcs":[[-238,-436,450,451,452]],"type":"Polygon"},{"arcs":[[-450,453,454]],"type":"Polygon"},{"arcs":[[[-115,455,-344,456]],[[457,458]]],"type":"MultiPolygon"},{"arcs":[[-7,459,-119,460,461]],"type":"Polygon"},{"arcs":[[462]],"type":"Polygon"},{"arcs":[[-71,-77,-437,-244,-417,463,-194,464]],"type":"Polygon"},{"arcs":[[-72,-465,-193,465]],"type":"Polygon"},{"arcs":[[-212,466,-317,467]],"type":"Polygon"},{"arcs":[[-67,468,-224]],"type":"Polygon"},{"arcs":[[[-268,469,470,471]],[[472]],[[473]],[[474]]],"type":"MultiPolygon"},{"arcs":[[-180,-349]],"type":"Polygon"},{"arcs":[[[475]],[[476]]],"type":"MultiPolygon"},{"arcs":[[[-20,477]],[[-22,478,479,480]]],"type":"MultiPolygon"},{"arcs":[[-5,-182,-348,481,-352]],"type":"Polygon"},{"arcs":[[-208,482,-214,483]],"type":"Polygon"},{"arcs":[[-102,-166,484,-245,-205,-106]],"type":"Polygon"},{"arcs":[[[485]],[[486]],[[487]],[[488]],[[489]],[[490]],[[491]]],"type":"MultiPolygon"},{"arcs":[[[-340,492]],[[493]],[[494]],[[495]]],"type":"MultiPolygon"},{"arcs":[[-97,496,497,-220,-228,498,499,-420]],"type":"Polygon"},{"arcs":[[500]],"type":"Polygon"},{"arcs":[[-173,501,502,-400,503]],"type":"Polygon"},{"arcs":[[-258,504]],"type":"Polygon"},{"arcs":[[-28,-104,-105]],"type":"Polygon"},{"arcs":[[-369,-378]],"type":"Polygon"},{"arcs":[[505,506]],"type":"Polygon"},{"arcs":[[-81,507,-328,508,-429,509,510]],"type":"Polygon"},{"arcs":[[[-56,-289,511,512,-95,-425,-260,513,-269,-472,514,-502,-172,-442,-170,-387,515]],[[-421,-500,516]],[[517,518]],[[519]],[[520]],[[521]],[[522]],[[523]],[[524]],[[525]],[[526]],[[527]],[[528]],[[529]]],"type":"MultiPolygon"},{"arcs":[[-61,-200,530,531]],"type":"Polygon"},{"arcs":[[-239,-453,532,-426]],"type":"Polygon"},{"arcs":[[-23,-481,533,534,-376,-360,-405,535,-507,536]],"type":"Polygon"},{"arcs":[[-123,537,-415,-247,538,-253,-266,539]],"type":"Polygon"},{"arcs":[[-124,-540,-265,-392,540,-198]],"type":"Polygon"},{"arcs":[[-296,-301,541,-299,542,-451,-435]],"type":"Polygon"},{"arcs":[[[543]],[[544]],[[545]],[[546]],[[547]]],"type":"MultiPolygon"},{"arcs":[[-293,-412,548]],"type":"Polygon"},{"arcs":[[-310,-319,549]],"type":"Polygon"},{"arcs":[[-230,550,551,-262]],"type":"Polygon"},{"arcs":[[-263,-552,552,-388]],"type":"Polygon"},{"arcs":[[-86,-434,-402,-441,-92,-324,-329,-508]],"type":"Polygon"},{"arcs":[[-110,-315,553,-279]],"type":"Polygon"},{"arcs":[[-54,-221,-498,554,-326]],"type":"Polygon"},{"arcs":[[-49,-330,-322,555,-371]],"type":"Polygon"},{"arcs":[[-267,556,-470]],"type":"Polygon"},{"arcs":[[-446,557]],"type":"Polygon"},{"arcs":[[-362,-379,-367,-410,558,559]],"type":"Polygon"},{"arcs":[[-122,-195,-464,-416,-538]],"type":"Polygon"},{"arcs":[[-69,560,-290,-73]],"type":"Polygon"},{"arcs":[[-395,561,-459,562,-438,-407]],"type":"Polygon"},{"arcs":[[-3,563,-393,-167]],"type":"Polygon"},{"arcs":[[-1,-357,564,-385,565]],"type":"Polygon"},{"arcs":[[-332,566]],"type":"Polygon"},{"arcs":[[567]],"type":"Polygon"},{"arcs":[[-242,568,-413]],"type":"Polygon"},{"arcs":[[[-36,-355,-363,-560,569,-287]],[[-83,570,-304]]],"type":"MultiPolygon"},{"arcs":[[571]],"type":"Polygon"},{"arcs":[[-62,-532,572,-390,573,-443,-455,574,-201]],"type":"Polygon"},{"arcs":[[-199,-541,-391,-573,-531]],"type":"Polygon"},{"arcs":[[-96,-513,575,-518,576,-510,-428,-509,-327,-555,-497]],"type":"Polygon"},{"arcs":[[-30,-113,577]],"type":"Polygon"},{"arcs":[[[-141,578,-432,579]],[[-139,580]],[[581]],[[582]],[[583]],[[584]],[[585]],[[586]],[[587]],[[588]]],"type":"MultiPolygon"},{"arcs":[[-2,-566,-384,-394,-564]],"type":"Polygon"},{"arcs":[[-108,-210,589,-313]],"type":"Polygon"},{"arcs":[[-175,590,-397,-406]],"type":"Polygon"},{"arcs":[[[591]],[[592]]],"type":"MultiPolygon"},{"arcs":[[-480,593,-534]],"type":"Polygon"},{"arcs":[[-118,594,-447,-558,-445,595,-461],[-419]],"type":"Polygon"},{"arcs":[[-10,-202,-575,-454,-449,596,-120,-460]],"type":"Polygon"},{"arcs":[[-121,-597,-448,-595]],"type":"Polygon"}]}}}');


const $3bda04436e25bcfb$var$features = (0, $19b2ab9d9047e93f$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($a149e277f7dc0241$exports))), (0, (/*@__PURE__*/$parcel$interopDefault($a149e277f7dc0241$exports))).objects.ne_110m_admin_0_countries).features;
function $3bda04436e25bcfb$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("svg", {
        style: {
            marginBlock: "-11%"
        },
        viewBox: `0 0 ${(0, $6ac94e7c3d018e58$export$80bdfe9d0febd31c)} ${(0, $6ac94e7c3d018e58$export$d1ff6fea16bc8fb7)}`,
        children: [
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("g", {
                children: $3bda04436e25bcfb$var$features.map((d, i)=>/*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("path", {
                        d: (0, $dd23642c1f810c98$export$bb654e07daaf8c3a)(d) ?? undefined,
                        fill: "var(--color-balance-less)",
                        stroke: "var(--color-balance-more)"
                    }, `geo-${i}`))
            }),
            children
        ]
    });
}
$3bda04436e25bcfb$export$2e2bcd8739ae039.Marker = (0, $07364892e19669ef$export$2e2bcd8739ae039);






var $lBnVc = parcelRequire("lBnVc");








var $6ae7be924142e728$var$_client, $6ae7be924142e728$var$_currentQuery, $6ae7be924142e728$var$_currentQueryInitialState, $6ae7be924142e728$var$_currentResult, $6ae7be924142e728$var$_currentResultState, $6ae7be924142e728$var$_currentResultOptions, $6ae7be924142e728$var$_selectError, $6ae7be924142e728$var$_selectFn, $6ae7be924142e728$var$_selectResult, $6ae7be924142e728$var$_lastQueryWithDefinedData, $6ae7be924142e728$var$_staleTimeoutId, $6ae7be924142e728$var$_refetchIntervalId, $6ae7be924142e728$var$_currentRefetchInterval, $6ae7be924142e728$var$_trackedProps, $6ae7be924142e728$var$_executeFetch, $6ae7be924142e728$var$executeFetch_fn, $6ae7be924142e728$var$_updateStaleTimeout, $6ae7be924142e728$var$updateStaleTimeout_fn, $6ae7be924142e728$var$_computeRefetchInterval, $6ae7be924142e728$var$computeRefetchInterval_fn, $6ae7be924142e728$var$_updateRefetchInterval, $6ae7be924142e728$var$updateRefetchInterval_fn, $6ae7be924142e728$var$_updateTimers, $6ae7be924142e728$var$updateTimers_fn, $6ae7be924142e728$var$_clearStaleTimeout, $6ae7be924142e728$var$clearStaleTimeout_fn, $6ae7be924142e728$var$_clearRefetchInterval, $6ae7be924142e728$var$clearRefetchInterval_fn, $6ae7be924142e728$var$_updateQuery, $6ae7be924142e728$var$updateQuery_fn, $6ae7be924142e728$var$_notify, $6ae7be924142e728$var$notify_fn;
var $6ae7be924142e728$export$a06cf8c0066f0d4c = class extends (0, $f619992c377f98ae$export$d26086b469ecdbcc) {
    constructor(client, options){
        super();
        this.options = options;
        (0, $82bb902b93e9fce2$export$addf369becd23283)(this, $6ae7be924142e728$var$_executeFetch);
        (0, $82bb902b93e9fce2$export$addf369becd23283)(this, $6ae7be924142e728$var$_updateStaleTimeout);
        (0, $82bb902b93e9fce2$export$addf369becd23283)(this, $6ae7be924142e728$var$_computeRefetchInterval);
        (0, $82bb902b93e9fce2$export$addf369becd23283)(this, $6ae7be924142e728$var$_updateRefetchInterval);
        (0, $82bb902b93e9fce2$export$addf369becd23283)(this, $6ae7be924142e728$var$_updateTimers);
        (0, $82bb902b93e9fce2$export$addf369becd23283)(this, $6ae7be924142e728$var$_clearStaleTimeout);
        (0, $82bb902b93e9fce2$export$addf369becd23283)(this, $6ae7be924142e728$var$_clearRefetchInterval);
        (0, $82bb902b93e9fce2$export$addf369becd23283)(this, $6ae7be924142e728$var$_updateQuery);
        (0, $82bb902b93e9fce2$export$addf369becd23283)(this, $6ae7be924142e728$var$_notify);
        (0, $82bb902b93e9fce2$export$addf369becd23283)(this, $6ae7be924142e728$var$_client, void 0);
        (0, $82bb902b93e9fce2$export$addf369becd23283)(this, $6ae7be924142e728$var$_currentQuery, void 0);
        (0, $82bb902b93e9fce2$export$addf369becd23283)(this, $6ae7be924142e728$var$_currentQueryInitialState, void 0);
        (0, $82bb902b93e9fce2$export$addf369becd23283)(this, $6ae7be924142e728$var$_currentResult, void 0);
        (0, $82bb902b93e9fce2$export$addf369becd23283)(this, $6ae7be924142e728$var$_currentResultState, void 0);
        (0, $82bb902b93e9fce2$export$addf369becd23283)(this, $6ae7be924142e728$var$_currentResultOptions, void 0);
        (0, $82bb902b93e9fce2$export$addf369becd23283)(this, $6ae7be924142e728$var$_selectError, void 0);
        (0, $82bb902b93e9fce2$export$addf369becd23283)(this, $6ae7be924142e728$var$_selectFn, void 0);
        (0, $82bb902b93e9fce2$export$addf369becd23283)(this, $6ae7be924142e728$var$_selectResult, void 0);
        // This property keeps track of the last query with defined data.
        // It will be used to pass the previous data and query to the placeholder function between renders.
        (0, $82bb902b93e9fce2$export$addf369becd23283)(this, $6ae7be924142e728$var$_lastQueryWithDefinedData, void 0);
        (0, $82bb902b93e9fce2$export$addf369becd23283)(this, $6ae7be924142e728$var$_staleTimeoutId, void 0);
        (0, $82bb902b93e9fce2$export$addf369becd23283)(this, $6ae7be924142e728$var$_refetchIntervalId, void 0);
        (0, $82bb902b93e9fce2$export$addf369becd23283)(this, $6ae7be924142e728$var$_currentRefetchInterval, void 0);
        (0, $82bb902b93e9fce2$export$addf369becd23283)(this, $6ae7be924142e728$var$_trackedProps, /* @__PURE__ */ new Set());
        (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $6ae7be924142e728$var$_client, client);
        (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $6ae7be924142e728$var$_selectError, null);
        this.bindMethods();
        this.setOptions(options);
    }
    bindMethods() {
        this.refetch = this.refetch.bind(this);
    }
    onSubscribe() {
        if (this.listeners.size === 1) {
            (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $6ae7be924142e728$var$_currentQuery).addObserver(this);
            if ($6ae7be924142e728$var$shouldFetchOnMount((0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $6ae7be924142e728$var$_currentQuery), this.options)) (0, $82bb902b93e9fce2$export$fa92d15b718fce20)(this, $6ae7be924142e728$var$_executeFetch, $6ae7be924142e728$var$executeFetch_fn).call(this);
            else this.updateResult();
            (0, $82bb902b93e9fce2$export$fa92d15b718fce20)(this, $6ae7be924142e728$var$_updateTimers, $6ae7be924142e728$var$updateTimers_fn).call(this);
        }
    }
    onUnsubscribe() {
        if (!this.hasListeners()) this.destroy();
    }
    shouldFetchOnReconnect() {
        return $6ae7be924142e728$var$shouldFetchOn((0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $6ae7be924142e728$var$_currentQuery), this.options, this.options.refetchOnReconnect);
    }
    shouldFetchOnWindowFocus() {
        return $6ae7be924142e728$var$shouldFetchOn((0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $6ae7be924142e728$var$_currentQuery), this.options, this.options.refetchOnWindowFocus);
    }
    destroy() {
        this.listeners = /* @__PURE__ */ new Set();
        (0, $82bb902b93e9fce2$export$fa92d15b718fce20)(this, $6ae7be924142e728$var$_clearStaleTimeout, $6ae7be924142e728$var$clearStaleTimeout_fn).call(this);
        (0, $82bb902b93e9fce2$export$fa92d15b718fce20)(this, $6ae7be924142e728$var$_clearRefetchInterval, $6ae7be924142e728$var$clearRefetchInterval_fn).call(this);
        (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $6ae7be924142e728$var$_currentQuery).removeObserver(this);
    }
    setOptions(options, notifyOptions) {
        const prevOptions = this.options;
        const prevQuery = (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $6ae7be924142e728$var$_currentQuery);
        this.options = (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $6ae7be924142e728$var$_client).defaultQueryOptions(options);
        if (this.options.enabled !== void 0 && typeof this.options.enabled !== "boolean") throw new Error("Expected enabled to be a boolean");
        (0, $82bb902b93e9fce2$export$fa92d15b718fce20)(this, $6ae7be924142e728$var$_updateQuery, $6ae7be924142e728$var$updateQuery_fn).call(this);
        (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $6ae7be924142e728$var$_currentQuery).setOptions(this.options);
        if (prevOptions._defaulted && !(0, $58dc61dd9f062c44$export$3e67810a3f0e9f1c)(this.options, prevOptions)) (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $6ae7be924142e728$var$_client).getQueryCache().notify({
            type: "observerOptionsUpdated",
            query: (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $6ae7be924142e728$var$_currentQuery),
            observer: this
        });
        const mounted = this.hasListeners();
        if (mounted && $6ae7be924142e728$var$shouldFetchOptionally((0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $6ae7be924142e728$var$_currentQuery), prevQuery, this.options, prevOptions)) (0, $82bb902b93e9fce2$export$fa92d15b718fce20)(this, $6ae7be924142e728$var$_executeFetch, $6ae7be924142e728$var$executeFetch_fn).call(this);
        this.updateResult(notifyOptions);
        if (mounted && ((0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $6ae7be924142e728$var$_currentQuery) !== prevQuery || this.options.enabled !== prevOptions.enabled || this.options.staleTime !== prevOptions.staleTime)) (0, $82bb902b93e9fce2$export$fa92d15b718fce20)(this, $6ae7be924142e728$var$_updateStaleTimeout, $6ae7be924142e728$var$updateStaleTimeout_fn).call(this);
        const nextRefetchInterval = (0, $82bb902b93e9fce2$export$fa92d15b718fce20)(this, $6ae7be924142e728$var$_computeRefetchInterval, $6ae7be924142e728$var$computeRefetchInterval_fn).call(this);
        if (mounted && ((0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $6ae7be924142e728$var$_currentQuery) !== prevQuery || this.options.enabled !== prevOptions.enabled || nextRefetchInterval !== (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $6ae7be924142e728$var$_currentRefetchInterval))) (0, $82bb902b93e9fce2$export$fa92d15b718fce20)(this, $6ae7be924142e728$var$_updateRefetchInterval, $6ae7be924142e728$var$updateRefetchInterval_fn).call(this, nextRefetchInterval);
    }
    getOptimisticResult(options) {
        const query = (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $6ae7be924142e728$var$_client).getQueryCache().build((0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $6ae7be924142e728$var$_client), options);
        const result = this.createResult(query, options);
        if ($6ae7be924142e728$var$shouldAssignObserverCurrentProperties(this, result)) {
            (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $6ae7be924142e728$var$_currentResult, result);
            (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $6ae7be924142e728$var$_currentResultOptions, this.options);
            (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $6ae7be924142e728$var$_currentResultState, (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $6ae7be924142e728$var$_currentQuery).state);
        }
        return result;
    }
    getCurrentResult() {
        return (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $6ae7be924142e728$var$_currentResult);
    }
    trackResult(result, onPropTracked) {
        const trackedResult = {};
        Object.keys(result).forEach((key)=>{
            Object.defineProperty(trackedResult, key, {
                configurable: false,
                enumerable: true,
                get: ()=>{
                    this.trackProp(key);
                    onPropTracked == null || onPropTracked(key);
                    return result[key];
                }
            });
        });
        return trackedResult;
    }
    trackProp(key) {
        (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $6ae7be924142e728$var$_trackedProps).add(key);
    }
    getCurrentQuery() {
        return (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $6ae7be924142e728$var$_currentQuery);
    }
    refetch({ ...options } = {}) {
        return this.fetch({
            ...options
        });
    }
    fetchOptimistic(options) {
        const defaultedOptions = (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $6ae7be924142e728$var$_client).defaultQueryOptions(options);
        const query = (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $6ae7be924142e728$var$_client).getQueryCache().build((0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $6ae7be924142e728$var$_client), defaultedOptions);
        query.isFetchingOptimistic = true;
        return query.fetch().then(()=>this.createResult(query, defaultedOptions));
    }
    fetch(fetchOptions) {
        return (0, $82bb902b93e9fce2$export$fa92d15b718fce20)(this, $6ae7be924142e728$var$_executeFetch, $6ae7be924142e728$var$executeFetch_fn).call(this, {
            ...fetchOptions,
            cancelRefetch: fetchOptions.cancelRefetch ?? true
        }).then(()=>{
            this.updateResult();
            return (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $6ae7be924142e728$var$_currentResult);
        });
    }
    createResult(query, options) {
        var _a;
        const prevQuery = (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $6ae7be924142e728$var$_currentQuery);
        const prevOptions = this.options;
        const prevResult = (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $6ae7be924142e728$var$_currentResult);
        const prevResultState = (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $6ae7be924142e728$var$_currentResultState);
        const prevResultOptions = (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $6ae7be924142e728$var$_currentResultOptions);
        const queryChange = query !== prevQuery;
        const queryInitialState = queryChange ? query.state : (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $6ae7be924142e728$var$_currentQueryInitialState);
        const { state: state } = query;
        let newState = {
            ...state
        };
        let isPlaceholderData = false;
        let data;
        if (options._optimisticResults) {
            const mounted = this.hasListeners();
            const fetchOnMount = !mounted && $6ae7be924142e728$var$shouldFetchOnMount(query, options);
            const fetchOptionally = mounted && $6ae7be924142e728$var$shouldFetchOptionally(query, prevQuery, options, prevOptions);
            if (fetchOnMount || fetchOptionally) newState = {
                ...newState,
                ...(0, $670d1234511b9450$export$f3df9013f2b58bce)(state.data, query.options)
            };
            if (options._optimisticResults === "isRestoring") newState.fetchStatus = "idle";
        }
        let { error: error, errorUpdatedAt: errorUpdatedAt, status: status } = newState;
        if (options.select && newState.data !== void 0) {
            if (prevResult && newState.data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $6ae7be924142e728$var$_selectFn)) data = (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $6ae7be924142e728$var$_selectResult);
            else try {
                (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $6ae7be924142e728$var$_selectFn, options.select);
                data = options.select(newState.data);
                data = (0, $58dc61dd9f062c44$export$17619bac5b909b23)(prevResult == null ? void 0 : prevResult.data, data, options);
                (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $6ae7be924142e728$var$_selectResult, data);
                (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $6ae7be924142e728$var$_selectError, null);
            } catch (selectError) {
                (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $6ae7be924142e728$var$_selectError, selectError);
            }
        } else data = newState.data;
        if (options.placeholderData !== void 0 && data === void 0 && status === "pending") {
            let placeholderData;
            if ((prevResult == null ? void 0 : prevResult.isPlaceholderData) && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) placeholderData = prevResult.data;
            else {
                placeholderData = typeof options.placeholderData === "function" ? options.placeholderData((_a = (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $6ae7be924142e728$var$_lastQueryWithDefinedData)) == null ? void 0 : _a.state.data, (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $6ae7be924142e728$var$_lastQueryWithDefinedData)) : options.placeholderData;
                if (options.select && placeholderData !== void 0) try {
                    placeholderData = options.select(placeholderData);
                    (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $6ae7be924142e728$var$_selectError, null);
                } catch (selectError) {
                    (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $6ae7be924142e728$var$_selectError, selectError);
                }
            }
            if (placeholderData !== void 0) {
                status = "success";
                data = (0, $58dc61dd9f062c44$export$17619bac5b909b23)(prevResult == null ? void 0 : prevResult.data, placeholderData, options);
                isPlaceholderData = true;
            }
        }
        if ((0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $6ae7be924142e728$var$_selectError)) {
            error = (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $6ae7be924142e728$var$_selectError);
            data = (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $6ae7be924142e728$var$_selectResult);
            errorUpdatedAt = Date.now();
            status = "error";
        }
        const isFetching = newState.fetchStatus === "fetching";
        const isPending = status === "pending";
        const isError = status === "error";
        const isLoading = isPending && isFetching;
        const hasData = data !== void 0;
        const result = {
            status: status,
            fetchStatus: newState.fetchStatus,
            isPending: isPending,
            isSuccess: status === "success",
            isError: isError,
            isInitialLoading: isLoading,
            isLoading: isLoading,
            data: data,
            dataUpdatedAt: newState.dataUpdatedAt,
            error: error,
            errorUpdatedAt: errorUpdatedAt,
            failureCount: newState.fetchFailureCount,
            failureReason: newState.fetchFailureReason,
            errorUpdateCount: newState.errorUpdateCount,
            isFetched: newState.dataUpdateCount > 0 || newState.errorUpdateCount > 0,
            isFetchedAfterMount: newState.dataUpdateCount > queryInitialState.dataUpdateCount || newState.errorUpdateCount > queryInitialState.errorUpdateCount,
            isFetching: isFetching,
            isRefetching: isFetching && !isPending,
            isLoadingError: isError && !hasData,
            isPaused: newState.fetchStatus === "paused",
            isPlaceholderData: isPlaceholderData,
            isRefetchError: isError && hasData,
            isStale: $6ae7be924142e728$var$isStale(query, options),
            refetch: this.refetch
        };
        return result;
    }
    updateResult(notifyOptions) {
        const prevResult = (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $6ae7be924142e728$var$_currentResult);
        const nextResult = this.createResult((0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $6ae7be924142e728$var$_currentQuery), this.options);
        (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $6ae7be924142e728$var$_currentResultState, (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $6ae7be924142e728$var$_currentQuery).state);
        (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $6ae7be924142e728$var$_currentResultOptions, this.options);
        if ((0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $6ae7be924142e728$var$_currentResultState).data !== void 0) (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $6ae7be924142e728$var$_lastQueryWithDefinedData, (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $6ae7be924142e728$var$_currentQuery));
        if ((0, $58dc61dd9f062c44$export$3e67810a3f0e9f1c)(nextResult, prevResult)) return;
        (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $6ae7be924142e728$var$_currentResult, nextResult);
        const defaultNotifyOptions = {};
        const shouldNotifyListeners = ()=>{
            if (!prevResult) return true;
            const { notifyOnChangeProps: notifyOnChangeProps } = this.options;
            const notifyOnChangePropsValue = typeof notifyOnChangeProps === "function" ? notifyOnChangeProps() : notifyOnChangeProps;
            if (notifyOnChangePropsValue === "all" || !notifyOnChangePropsValue && !(0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $6ae7be924142e728$var$_trackedProps).size) return true;
            const includedProps = new Set(notifyOnChangePropsValue ?? (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $6ae7be924142e728$var$_trackedProps));
            if (this.options.throwOnError) includedProps.add("error");
            return Object.keys((0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $6ae7be924142e728$var$_currentResult)).some((key)=>{
                const typedKey = key;
                const changed = (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $6ae7be924142e728$var$_currentResult)[typedKey] !== prevResult[typedKey];
                return changed && includedProps.has(typedKey);
            });
        };
        if ((notifyOptions == null ? void 0 : notifyOptions.listeners) !== false && shouldNotifyListeners()) defaultNotifyOptions.listeners = true;
        (0, $82bb902b93e9fce2$export$fa92d15b718fce20)(this, $6ae7be924142e728$var$_notify, $6ae7be924142e728$var$notify_fn).call(this, {
            ...defaultNotifyOptions,
            ...notifyOptions
        });
    }
    onQueryUpdate() {
        this.updateResult();
        if (this.hasListeners()) (0, $82bb902b93e9fce2$export$fa92d15b718fce20)(this, $6ae7be924142e728$var$_updateTimers, $6ae7be924142e728$var$updateTimers_fn).call(this);
    }
};
$6ae7be924142e728$var$_client = new WeakMap();
$6ae7be924142e728$var$_currentQuery = new WeakMap();
$6ae7be924142e728$var$_currentQueryInitialState = new WeakMap();
$6ae7be924142e728$var$_currentResult = new WeakMap();
$6ae7be924142e728$var$_currentResultState = new WeakMap();
$6ae7be924142e728$var$_currentResultOptions = new WeakMap();
$6ae7be924142e728$var$_selectError = new WeakMap();
$6ae7be924142e728$var$_selectFn = new WeakMap();
$6ae7be924142e728$var$_selectResult = new WeakMap();
$6ae7be924142e728$var$_lastQueryWithDefinedData = new WeakMap();
$6ae7be924142e728$var$_staleTimeoutId = new WeakMap();
$6ae7be924142e728$var$_refetchIntervalId = new WeakMap();
$6ae7be924142e728$var$_currentRefetchInterval = new WeakMap();
$6ae7be924142e728$var$_trackedProps = new WeakMap();
$6ae7be924142e728$var$_executeFetch = new WeakSet();
$6ae7be924142e728$var$executeFetch_fn = function(fetchOptions) {
    (0, $82bb902b93e9fce2$export$fa92d15b718fce20)(this, $6ae7be924142e728$var$_updateQuery, $6ae7be924142e728$var$updateQuery_fn).call(this);
    let promise = (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $6ae7be924142e728$var$_currentQuery).fetch(this.options, fetchOptions);
    if (!(fetchOptions == null ? void 0 : fetchOptions.throwOnError)) promise = promise.catch((0, $58dc61dd9f062c44$export$8793edee2d425525));
    return promise;
};
$6ae7be924142e728$var$_updateStaleTimeout = new WeakSet();
$6ae7be924142e728$var$updateStaleTimeout_fn = function() {
    (0, $82bb902b93e9fce2$export$fa92d15b718fce20)(this, $6ae7be924142e728$var$_clearStaleTimeout, $6ae7be924142e728$var$clearStaleTimeout_fn).call(this);
    if ((0, $58dc61dd9f062c44$export$6acf61af03e62db) || (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $6ae7be924142e728$var$_currentResult).isStale || !(0, $58dc61dd9f062c44$export$e539f754e934e270)(this.options.staleTime)) return;
    const time = (0, $58dc61dd9f062c44$export$811b83d62bcf47f0)((0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $6ae7be924142e728$var$_currentResult).dataUpdatedAt, this.options.staleTime);
    const timeout = time + 1;
    (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $6ae7be924142e728$var$_staleTimeoutId, setTimeout(()=>{
        if (!(0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $6ae7be924142e728$var$_currentResult).isStale) this.updateResult();
    }, timeout));
};
$6ae7be924142e728$var$_computeRefetchInterval = new WeakSet();
$6ae7be924142e728$var$computeRefetchInterval_fn = function() {
    return (typeof this.options.refetchInterval === "function" ? this.options.refetchInterval((0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $6ae7be924142e728$var$_currentQuery)) : this.options.refetchInterval) ?? false;
};
$6ae7be924142e728$var$_updateRefetchInterval = new WeakSet();
$6ae7be924142e728$var$updateRefetchInterval_fn = function(nextInterval) {
    (0, $82bb902b93e9fce2$export$fa92d15b718fce20)(this, $6ae7be924142e728$var$_clearRefetchInterval, $6ae7be924142e728$var$clearRefetchInterval_fn).call(this);
    (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $6ae7be924142e728$var$_currentRefetchInterval, nextInterval);
    if ((0, $58dc61dd9f062c44$export$6acf61af03e62db) || this.options.enabled === false || !(0, $58dc61dd9f062c44$export$e539f754e934e270)((0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $6ae7be924142e728$var$_currentRefetchInterval)) || (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $6ae7be924142e728$var$_currentRefetchInterval) === 0) return;
    (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $6ae7be924142e728$var$_refetchIntervalId, setInterval(()=>{
        if (this.options.refetchIntervalInBackground || (0, $c8420f591c39a8bc$export$6bf54661be5b02cf).isFocused()) (0, $82bb902b93e9fce2$export$fa92d15b718fce20)(this, $6ae7be924142e728$var$_executeFetch, $6ae7be924142e728$var$executeFetch_fn).call(this);
    }, (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $6ae7be924142e728$var$_currentRefetchInterval)));
};
$6ae7be924142e728$var$_updateTimers = new WeakSet();
$6ae7be924142e728$var$updateTimers_fn = function() {
    (0, $82bb902b93e9fce2$export$fa92d15b718fce20)(this, $6ae7be924142e728$var$_updateStaleTimeout, $6ae7be924142e728$var$updateStaleTimeout_fn).call(this);
    (0, $82bb902b93e9fce2$export$fa92d15b718fce20)(this, $6ae7be924142e728$var$_updateRefetchInterval, $6ae7be924142e728$var$updateRefetchInterval_fn).call(this, (0, $82bb902b93e9fce2$export$fa92d15b718fce20)(this, $6ae7be924142e728$var$_computeRefetchInterval, $6ae7be924142e728$var$computeRefetchInterval_fn).call(this));
};
$6ae7be924142e728$var$_clearStaleTimeout = new WeakSet();
$6ae7be924142e728$var$clearStaleTimeout_fn = function() {
    if ((0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $6ae7be924142e728$var$_staleTimeoutId)) {
        clearTimeout((0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $6ae7be924142e728$var$_staleTimeoutId));
        (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $6ae7be924142e728$var$_staleTimeoutId, void 0);
    }
};
$6ae7be924142e728$var$_clearRefetchInterval = new WeakSet();
$6ae7be924142e728$var$clearRefetchInterval_fn = function() {
    if ((0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $6ae7be924142e728$var$_refetchIntervalId)) {
        clearInterval((0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $6ae7be924142e728$var$_refetchIntervalId));
        (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $6ae7be924142e728$var$_refetchIntervalId, void 0);
    }
};
$6ae7be924142e728$var$_updateQuery = new WeakSet();
$6ae7be924142e728$var$updateQuery_fn = function() {
    const query = (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $6ae7be924142e728$var$_client).getQueryCache().build((0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $6ae7be924142e728$var$_client), this.options);
    if (query === (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $6ae7be924142e728$var$_currentQuery)) return;
    const prevQuery = (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $6ae7be924142e728$var$_currentQuery);
    (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $6ae7be924142e728$var$_currentQuery, query);
    (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $6ae7be924142e728$var$_currentQueryInitialState, query.state);
    if (this.hasListeners()) {
        prevQuery == null || prevQuery.removeObserver(this);
        query.addObserver(this);
    }
};
$6ae7be924142e728$var$_notify = new WeakSet();
$6ae7be924142e728$var$notify_fn = function(notifyOptions) {
    (0, $21dd3588127ff3f9$export$520687f44db6e1ab).batch(()=>{
        if (notifyOptions.listeners) this.listeners.forEach((listener)=>{
            listener((0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $6ae7be924142e728$var$_currentResult));
        });
        (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $6ae7be924142e728$var$_client).getQueryCache().notify({
            query: (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $6ae7be924142e728$var$_currentQuery),
            type: "observerResultsUpdated"
        });
    });
};
function $6ae7be924142e728$var$shouldLoadOnMount(query, options) {
    return options.enabled !== false && query.state.data === void 0 && !(query.state.status === "error" && options.retryOnMount === false);
}
function $6ae7be924142e728$var$shouldFetchOnMount(query, options) {
    return $6ae7be924142e728$var$shouldLoadOnMount(query, options) || query.state.data !== void 0 && $6ae7be924142e728$var$shouldFetchOn(query, options, options.refetchOnMount);
}
function $6ae7be924142e728$var$shouldFetchOn(query, options, field) {
    if (options.enabled !== false) {
        const value = typeof field === "function" ? field(query) : field;
        return value === "always" || value !== false && $6ae7be924142e728$var$isStale(query, options);
    }
    return false;
}
function $6ae7be924142e728$var$shouldFetchOptionally(query, prevQuery, options, prevOptions) {
    return (query !== prevQuery || prevOptions.enabled === false) && (!options.suspense || query.state.status !== "error") && $6ae7be924142e728$var$isStale(query, options);
}
function $6ae7be924142e728$var$isStale(query, options) {
    return options.enabled !== false && query.isStaleByTime(options.staleTime);
}
function $6ae7be924142e728$var$shouldAssignObserverCurrentProperties(observer, optimisticResult) {
    if (!(0, $58dc61dd9f062c44$export$3e67810a3f0e9f1c)(observer.getCurrentResult(), optimisticResult)) return true;
    return false;
}




function $23175b769bb504e5$var$difference(array1, array2) {
    return array1.filter((x)=>!array2.includes(x));
}
function $23175b769bb504e5$var$replaceAt(array, index, value) {
    const copy = array.slice(0);
    copy[index] = value;
    return copy;
}
var $23175b769bb504e5$var$_client, $23175b769bb504e5$var$_result, $23175b769bb504e5$var$_queries, $23175b769bb504e5$var$_observers, $23175b769bb504e5$var$_options, $23175b769bb504e5$var$_combinedResult, $23175b769bb504e5$var$_setResult, $23175b769bb504e5$var$setResult_fn, $23175b769bb504e5$var$_combineResult, $23175b769bb504e5$var$combineResult_fn, $23175b769bb504e5$var$_findMatchingObservers, $23175b769bb504e5$var$findMatchingObservers_fn, $23175b769bb504e5$var$_onUpdate, $23175b769bb504e5$var$onUpdate_fn, $23175b769bb504e5$var$_notify, $23175b769bb504e5$var$notify_fn;
var $23175b769bb504e5$export$15352e437905ad4c = class extends (0, $f619992c377f98ae$export$d26086b469ecdbcc) {
    constructor(client, queries, options){
        super();
        (0, $82bb902b93e9fce2$export$addf369becd23283)(this, $23175b769bb504e5$var$_setResult);
        (0, $82bb902b93e9fce2$export$addf369becd23283)(this, $23175b769bb504e5$var$_combineResult);
        (0, $82bb902b93e9fce2$export$addf369becd23283)(this, $23175b769bb504e5$var$_findMatchingObservers);
        (0, $82bb902b93e9fce2$export$addf369becd23283)(this, $23175b769bb504e5$var$_onUpdate);
        (0, $82bb902b93e9fce2$export$addf369becd23283)(this, $23175b769bb504e5$var$_notify);
        (0, $82bb902b93e9fce2$export$addf369becd23283)(this, $23175b769bb504e5$var$_client, void 0);
        (0, $82bb902b93e9fce2$export$addf369becd23283)(this, $23175b769bb504e5$var$_result, void 0);
        (0, $82bb902b93e9fce2$export$addf369becd23283)(this, $23175b769bb504e5$var$_queries, void 0);
        (0, $82bb902b93e9fce2$export$addf369becd23283)(this, $23175b769bb504e5$var$_observers, void 0);
        (0, $82bb902b93e9fce2$export$addf369becd23283)(this, $23175b769bb504e5$var$_options, void 0);
        (0, $82bb902b93e9fce2$export$addf369becd23283)(this, $23175b769bb504e5$var$_combinedResult, void 0);
        (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $23175b769bb504e5$var$_client, client);
        (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $23175b769bb504e5$var$_queries, []);
        (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $23175b769bb504e5$var$_observers, []);
        (0, $82bb902b93e9fce2$export$fa92d15b718fce20)(this, $23175b769bb504e5$var$_setResult, $23175b769bb504e5$var$setResult_fn).call(this, []);
        this.setQueries(queries, options);
    }
    onSubscribe() {
        if (this.listeners.size === 1) (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $23175b769bb504e5$var$_observers).forEach((observer)=>{
            observer.subscribe((result)=>{
                (0, $82bb902b93e9fce2$export$fa92d15b718fce20)(this, $23175b769bb504e5$var$_onUpdate, $23175b769bb504e5$var$onUpdate_fn).call(this, observer, result);
            });
        });
    }
    onUnsubscribe() {
        if (!this.listeners.size) this.destroy();
    }
    destroy() {
        this.listeners = /* @__PURE__ */ new Set();
        (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $23175b769bb504e5$var$_observers).forEach((observer)=>{
            observer.destroy();
        });
    }
    setQueries(queries, options, notifyOptions) {
        (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $23175b769bb504e5$var$_queries, queries);
        (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $23175b769bb504e5$var$_options, options);
        (0, $21dd3588127ff3f9$export$520687f44db6e1ab).batch(()=>{
            const prevObservers = (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $23175b769bb504e5$var$_observers);
            const newObserverMatches = (0, $82bb902b93e9fce2$export$fa92d15b718fce20)(this, $23175b769bb504e5$var$_findMatchingObservers, $23175b769bb504e5$var$findMatchingObservers_fn).call(this, (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $23175b769bb504e5$var$_queries));
            newObserverMatches.forEach((match)=>match.observer.setOptions(match.defaultedQueryOptions, notifyOptions));
            const newObservers = newObserverMatches.map((match)=>match.observer);
            const newResult = newObservers.map((observer)=>observer.getCurrentResult());
            const hasIndexChange = newObservers.some((observer, index)=>observer !== prevObservers[index]);
            if (prevObservers.length === newObservers.length && !hasIndexChange) return;
            (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $23175b769bb504e5$var$_observers, newObservers);
            (0, $82bb902b93e9fce2$export$fa92d15b718fce20)(this, $23175b769bb504e5$var$_setResult, $23175b769bb504e5$var$setResult_fn).call(this, newResult);
            if (!this.hasListeners()) return;
            $23175b769bb504e5$var$difference(prevObservers, newObservers).forEach((observer)=>{
                observer.destroy();
            });
            $23175b769bb504e5$var$difference(newObservers, prevObservers).forEach((observer)=>{
                observer.subscribe((result)=>{
                    (0, $82bb902b93e9fce2$export$fa92d15b718fce20)(this, $23175b769bb504e5$var$_onUpdate, $23175b769bb504e5$var$onUpdate_fn).call(this, observer, result);
                });
            });
            (0, $82bb902b93e9fce2$export$fa92d15b718fce20)(this, $23175b769bb504e5$var$_notify, $23175b769bb504e5$var$notify_fn).call(this);
        });
    }
    getCurrentResult() {
        return (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $23175b769bb504e5$var$_combinedResult);
    }
    getQueries() {
        return (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $23175b769bb504e5$var$_observers).map((observer)=>observer.getCurrentQuery());
    }
    getObservers() {
        return (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $23175b769bb504e5$var$_observers);
    }
    getOptimisticResult(queries, combine) {
        const matches = (0, $82bb902b93e9fce2$export$fa92d15b718fce20)(this, $23175b769bb504e5$var$_findMatchingObservers, $23175b769bb504e5$var$findMatchingObservers_fn).call(this, queries);
        const result = matches.map((match)=>match.observer.getOptimisticResult(match.defaultedQueryOptions));
        return [
            result,
            (r)=>{
                return (0, $82bb902b93e9fce2$export$fa92d15b718fce20)(this, $23175b769bb504e5$var$_combineResult, $23175b769bb504e5$var$combineResult_fn).call(this, r ?? result, combine);
            },
            ()=>{
                return matches.map((match, index)=>{
                    const observerResult = result[index];
                    return !match.defaultedQueryOptions.notifyOnChangeProps ? match.observer.trackResult(observerResult, (accessedProp)=>{
                        matches.forEach((m)=>{
                            m.observer.trackProp(accessedProp);
                        });
                    }) : observerResult;
                });
            }
        ];
    }
};
$23175b769bb504e5$var$_client = new WeakMap();
$23175b769bb504e5$var$_result = new WeakMap();
$23175b769bb504e5$var$_queries = new WeakMap();
$23175b769bb504e5$var$_observers = new WeakMap();
$23175b769bb504e5$var$_options = new WeakMap();
$23175b769bb504e5$var$_combinedResult = new WeakMap();
$23175b769bb504e5$var$_setResult = new WeakSet();
$23175b769bb504e5$var$setResult_fn = function(value) {
    var _a;
    (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $23175b769bb504e5$var$_result, value);
    (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $23175b769bb504e5$var$_combinedResult, (0, $82bb902b93e9fce2$export$fa92d15b718fce20)(this, $23175b769bb504e5$var$_combineResult, $23175b769bb504e5$var$combineResult_fn).call(this, value, (_a = (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $23175b769bb504e5$var$_options)) == null ? void 0 : _a.combine));
};
$23175b769bb504e5$var$_combineResult = new WeakSet();
$23175b769bb504e5$var$combineResult_fn = function(input, combine) {
    if (combine) return (0, $58dc61dd9f062c44$export$77a71fc411098696)((0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $23175b769bb504e5$var$_combinedResult), combine(input));
    return input;
};
$23175b769bb504e5$var$_findMatchingObservers = new WeakSet();
$23175b769bb504e5$var$findMatchingObservers_fn = function(queries) {
    const prevObservers = (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $23175b769bb504e5$var$_observers);
    const prevObserversMap = new Map(prevObservers.map((observer)=>[
            observer.options.queryHash,
            observer
        ]));
    const defaultedQueryOptions = queries.map((options)=>(0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $23175b769bb504e5$var$_client).defaultQueryOptions(options));
    const matchingObservers = defaultedQueryOptions.flatMap((defaultedOptions)=>{
        const match = prevObserversMap.get(defaultedOptions.queryHash);
        if (match != null) return [
            {
                defaultedQueryOptions: defaultedOptions,
                observer: match
            }
        ];
        return [];
    });
    const matchedQueryHashes = new Set(matchingObservers.map((match)=>match.defaultedQueryOptions.queryHash));
    const unmatchedQueries = defaultedQueryOptions.filter((defaultedOptions)=>!matchedQueryHashes.has(defaultedOptions.queryHash));
    const getObserver = (options)=>{
        const defaultedOptions = (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $23175b769bb504e5$var$_client).defaultQueryOptions(options);
        const currentObserver = (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $23175b769bb504e5$var$_observers).find((o)=>o.options.queryHash === defaultedOptions.queryHash);
        return currentObserver ?? new (0, $6ae7be924142e728$export$a06cf8c0066f0d4c)((0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $23175b769bb504e5$var$_client), defaultedOptions);
    };
    const newOrReusedObservers = unmatchedQueries.map((options)=>{
        return {
            defaultedQueryOptions: options,
            observer: getObserver(options)
        };
    });
    const sortMatchesByOrderOfQueries = (a, b)=>defaultedQueryOptions.indexOf(a.defaultedQueryOptions) - defaultedQueryOptions.indexOf(b.defaultedQueryOptions);
    return matchingObservers.concat(newOrReusedObservers).sort(sortMatchesByOrderOfQueries);
};
$23175b769bb504e5$var$_onUpdate = new WeakSet();
$23175b769bb504e5$var$onUpdate_fn = function(observer, result) {
    const index = (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $23175b769bb504e5$var$_observers).indexOf(observer);
    if (index !== -1) {
        (0, $82bb902b93e9fce2$export$fa92d15b718fce20)(this, $23175b769bb504e5$var$_setResult, $23175b769bb504e5$var$setResult_fn).call(this, $23175b769bb504e5$var$replaceAt((0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $23175b769bb504e5$var$_result), index, result));
        (0, $82bb902b93e9fce2$export$fa92d15b718fce20)(this, $23175b769bb504e5$var$_notify, $23175b769bb504e5$var$notify_fn).call(this);
    }
};
$23175b769bb504e5$var$_notify = new WeakSet();
$23175b769bb504e5$var$notify_fn = function() {
    (0, $21dd3588127ff3f9$export$520687f44db6e1ab).batch(()=>{
        this.listeners.forEach((listener)=>{
            listener((0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $23175b769bb504e5$var$_result));
        });
    });
};





var $lBnVc = parcelRequire("lBnVc");

"use client";
function $03a81a4217ec1837$var$createValue() {
    let isReset = false;
    return {
        clearReset: ()=>{
            isReset = false;
        },
        reset: ()=>{
            isReset = true;
        },
        isReset: ()=>{
            return isReset;
        }
    };
}
var $03a81a4217ec1837$var$QueryErrorResetBoundaryContext = $lBnVc.createContext($03a81a4217ec1837$var$createValue());
var $03a81a4217ec1837$export$50dfac555130cafd = ()=>$lBnVc.useContext($03a81a4217ec1837$var$QueryErrorResetBoundaryContext);
var $03a81a4217ec1837$export$ddb9962d870f2330 = ({ children: children })=>{
    const [value] = $lBnVc.useState(()=>$03a81a4217ec1837$var$createValue());
    return /* @__PURE__ */ (0, $c0c9bc5c50648c54$exports.jsx)($03a81a4217ec1837$var$QueryErrorResetBoundaryContext.Provider, {
        value: value,
        children: typeof children === "function" ? children(value) : children
    });
};



var $lBnVc = parcelRequire("lBnVc");
// src/utils.ts
function $d721e4b2cae94204$export$2072f68e6c3507cf(throwError, params) {
    if (typeof throwError === "function") return throwError(...params);
    return !!throwError;
}
function $d721e4b2cae94204$export$8793edee2d425525() {}


"use client";
var $dc7edbc4492a49a9$export$ae8adb3de3d77633 = (options, errorResetBoundary)=>{
    if (options.suspense || options.throwOnError) {
        if (!errorResetBoundary.isReset()) options.retryOnMount = false;
    }
};
var $dc7edbc4492a49a9$export$b2b17ca3a1fb0229 = (errorResetBoundary)=>{
    $lBnVc.useEffect(()=>{
        errorResetBoundary.clearReset();
    }, [
        errorResetBoundary
    ]);
};
var $dc7edbc4492a49a9$export$1fbcf724762d607 = ({ result: result, errorResetBoundary: errorResetBoundary, throwOnError: throwOnError, query: query })=>{
    return result.isError && !errorResetBoundary.isReset() && !result.isFetching && query && (0, $d721e4b2cae94204$export$2072f68e6c3507cf)(throwOnError, [
        result.error,
        query
    ]);
};


// src/suspense.ts
var $87f5fc5bd42ccad7$export$8bed2f8d02206063 = (_error, query)=>query.state.data === void 0;
var $87f5fc5bd42ccad7$export$2c40a591ad2dafb1 = (defaultedOptions)=>{
    if (defaultedOptions.suspense) {
        if (typeof defaultedOptions.staleTime !== "number") defaultedOptions.staleTime = 1e3;
    }
};
var $87f5fc5bd42ccad7$export$e0a3f29513afe430 = (result, isRestoring)=>result.isLoading && result.isFetching && !isRestoring;
var $87f5fc5bd42ccad7$export$88d3586dfed64df9 = (defaultedOptions, result)=>(defaultedOptions == null ? void 0 : defaultedOptions.suspense) && result.isPending;
var $87f5fc5bd42ccad7$export$defdc11a9c9acfcf = (defaultedOptions, observer, errorResetBoundary)=>observer.fetchOptimistic(defaultedOptions).catch(()=>{
        errorResetBoundary.clearReset();
    });


"use client";
function $bb2f817139ccdd5b$export$408667c6c87da1e5({ queries: queries, ...options }, queryClient) {
    const client = (0, $a0b182cf42560d7a$export$22e77b9572c4fded)(queryClient);
    const isRestoring = (0, $795bf5151991f2b5$export$4da0178d6b5f553)();
    const errorResetBoundary = (0, $03a81a4217ec1837$export$50dfac555130cafd)();
    const defaultedQueries = $lBnVc.useMemo(()=>queries.map((opts)=>{
            const defaultedOptions = client.defaultQueryOptions(opts);
            defaultedOptions._optimisticResults = isRestoring ? "isRestoring" : "optimistic";
            return defaultedOptions;
        }), [
        queries,
        client,
        isRestoring
    ]);
    defaultedQueries.forEach((query)=>{
        (0, $87f5fc5bd42ccad7$export$2c40a591ad2dafb1)(query);
        (0, $dc7edbc4492a49a9$export$ae8adb3de3d77633)(query, errorResetBoundary);
    });
    (0, $dc7edbc4492a49a9$export$b2b17ca3a1fb0229)(errorResetBoundary);
    const [observer] = $lBnVc.useState(()=>new (0, $23175b769bb504e5$export$15352e437905ad4c)(client, defaultedQueries, options));
    const [optimisticResult, getCombinedResult, trackResult] = observer.getOptimisticResult(defaultedQueries, options.combine);
    $lBnVc.useSyncExternalStore($lBnVc.useCallback((onStoreChange)=>isRestoring ? ()=>void 0 : observer.subscribe((0, $21dd3588127ff3f9$export$520687f44db6e1ab).batchCalls(onStoreChange)), [
        observer,
        isRestoring
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    $lBnVc.useEffect(()=>{
        observer.setQueries(defaultedQueries, options, {
            listeners: false
        });
    }, [
        defaultedQueries,
        options,
        observer
    ]);
    const shouldAtLeastOneSuspend = optimisticResult.some((result, index)=>(0, $87f5fc5bd42ccad7$export$88d3586dfed64df9)(defaultedQueries[index], result));
    const suspensePromises = shouldAtLeastOneSuspend ? optimisticResult.flatMap((result, index)=>{
        const opts = defaultedQueries[index];
        if (opts) {
            const queryObserver = new (0, $6ae7be924142e728$export$a06cf8c0066f0d4c)(client, opts);
            if ((0, $87f5fc5bd42ccad7$export$88d3586dfed64df9)(opts, result)) return (0, $87f5fc5bd42ccad7$export$defdc11a9c9acfcf)(opts, queryObserver, errorResetBoundary);
            else if ((0, $87f5fc5bd42ccad7$export$e0a3f29513afe430)(result, isRestoring)) (0, $87f5fc5bd42ccad7$export$defdc11a9c9acfcf)(opts, queryObserver, errorResetBoundary);
        }
        return [];
    }) : [];
    if (suspensePromises.length > 0) throw Promise.all(suspensePromises);
    const firstSingleResultWhichShouldThrow = optimisticResult.find((result, index)=>{
        const query = defaultedQueries[index];
        return query && (0, $dc7edbc4492a49a9$export$1fbcf724762d607)({
            result: result,
            errorResetBoundary: errorResetBoundary,
            throwOnError: query.throwOnError,
            query: client.getQueryCache().get(query.queryHash)
        });
    });
    if (firstSingleResultWhichShouldThrow == null ? void 0 : firstSingleResultWhichShouldThrow.error) throw firstSingleResultWhichShouldThrow.error;
    return getCombinedResult(trackResult());
}



var $lBnVc = parcelRequire("lBnVc");






"use client";
function $b3caba217408ea7e$export$fff0865807e996c5(options, Observer, queryClient) {
    const client = (0, $a0b182cf42560d7a$export$22e77b9572c4fded)(queryClient);
    const isRestoring = (0, $795bf5151991f2b5$export$4da0178d6b5f553)();
    const errorResetBoundary = (0, $03a81a4217ec1837$export$50dfac555130cafd)();
    const defaultedOptions = client.defaultQueryOptions(options);
    defaultedOptions._optimisticResults = isRestoring ? "isRestoring" : "optimistic";
    (0, $87f5fc5bd42ccad7$export$2c40a591ad2dafb1)(defaultedOptions);
    (0, $dc7edbc4492a49a9$export$ae8adb3de3d77633)(defaultedOptions, errorResetBoundary);
    (0, $dc7edbc4492a49a9$export$b2b17ca3a1fb0229)(errorResetBoundary);
    const [observer] = $lBnVc.useState(()=>new Observer(client, defaultedOptions));
    const result = observer.getOptimisticResult(defaultedOptions);
    $lBnVc.useSyncExternalStore($lBnVc.useCallback((onStoreChange)=>{
        const unsubscribe = isRestoring ? ()=>void 0 : observer.subscribe((0, $21dd3588127ff3f9$export$520687f44db6e1ab).batchCalls(onStoreChange));
        observer.updateResult();
        return unsubscribe;
    }, [
        observer,
        isRestoring
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    $lBnVc.useEffect(()=>{
        observer.setOptions(defaultedOptions, {
            listeners: false
        });
    }, [
        defaultedOptions,
        observer
    ]);
    if ((0, $87f5fc5bd42ccad7$export$88d3586dfed64df9)(defaultedOptions, result)) throw (0, $87f5fc5bd42ccad7$export$defdc11a9c9acfcf)(defaultedOptions, observer, errorResetBoundary);
    if ((0, $dc7edbc4492a49a9$export$1fbcf724762d607)({
        result: result,
        errorResetBoundary: errorResetBoundary,
        throwOnError: defaultedOptions.throwOnError,
        query: client.getQueryCache().get(defaultedOptions.queryHash)
    })) throw result.error;
    return !defaultedOptions.notifyOnChangeProps ? observer.trackResult(result) : result;
}


"use client";
function $eb7b0471498e212c$export$dd0a697e1782aedd(options, queryClient) {
    return (0, $b3caba217408ea7e$export$fff0865807e996c5)(options, (0, $6ae7be924142e728$export$a06cf8c0066f0d4c), queryClient);
}





function $09736e7482b4418e$export$baf757aaf0c95c94(date, amount) {
    const timestamp = +(0, $48f2cd94c2808d74$export$e67a095c620b86fe)(date);
    return (0, $ee5e01283bb626d4$export$ead8a1812b171991)(date, timestamp + amount);
}
var // Fallback for modularized imports:
$09736e7482b4418e$export$2e2bcd8739ae039 = $09736e7482b4418e$export$baf757aaf0c95c94;



function $63cf136474441a1f$export$4a4306ad4fa0e5e6(date, amount) {
    return (0, $09736e7482b4418e$export$baf757aaf0c95c94)(date, amount * (0, $cb8083d8e93c1630$export$7f72910d6dfd237a));
}
var // Fallback for modularized imports:
$63cf136474441a1f$export$2e2bcd8739ae039 = $63cf136474441a1f$export$4a4306ad4fa0e5e6;



function $857e6f903d884172$export$17c93e242b2d3a22(date, amount) {
    const _date = (0, $48f2cd94c2808d74$export$e67a095c620b86fe)(date);
    if (isNaN(amount)) return (0, $ee5e01283bb626d4$export$ead8a1812b171991)(date, NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return _date;
    const dayOfMonth = _date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    const endOfDesiredMonth = (0, $ee5e01283bb626d4$export$ead8a1812b171991)(date, _date.getTime());
    endOfDesiredMonth.setMonth(_date.getMonth() + amount + 1, 0);
    const daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        _date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return _date;
    }
}
var // Fallback for modularized imports:
$857e6f903d884172$export$2e2bcd8739ae039 = $857e6f903d884172$export$17c93e242b2d3a22;


function $ad866f4678a92721$export$ef501a2bb4f3ee6b(date, amount) {
    const days = amount * 7;
    return (0, $cb8fdbef2aba70f2$export$dd412b56f1e4d8aa)(date, days);
}
var // Fallback for modularized imports:
$ad866f4678a92721$export$2e2bcd8739ae039 = $ad866f4678a92721$export$ef501a2bb4f3ee6b;


function $8481dd0cb1201679$export$3d83eec43f4ea476(date, amount) {
    return (0, $857e6f903d884172$export$17c93e242b2d3a22)(date, amount * 12);
}
var // Fallback for modularized imports:
$8481dd0cb1201679$export$2e2bcd8739ae039 = $8481dd0cb1201679$export$3d83eec43f4ea476;


function $19a1ba3858cb2722$export$7a337e5923c7ceb5(interval, options) {
    const startDate = (0, $48f2cd94c2808d74$export$e67a095c620b86fe)(interval.start);
    const endDate = (0, $48f2cd94c2808d74$export$e67a095c620b86fe)(interval.end);
    let reversed = +startDate > +endDate;
    const endTime = reversed ? +startDate : +endDate;
    const currentDate = reversed ? endDate : startDate;
    currentDate.setHours(0, 0, 0, 0);
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        dates.push((0, $48f2cd94c2808d74$export$e67a095c620b86fe)(currentDate));
        currentDate.setDate(currentDate.getDate() + step);
        currentDate.setHours(0, 0, 0, 0);
    }
    return reversed ? dates.reverse() : dates;
}
var // Fallback for modularized imports:
$19a1ba3858cb2722$export$2e2bcd8739ae039 = $19a1ba3858cb2722$export$7a337e5923c7ceb5;



function $d5f74bf30e2fc325$export$bb4f48fee90ea86e(interval, options) {
    const startDate = (0, $48f2cd94c2808d74$export$e67a095c620b86fe)(interval.start);
    const endDate = (0, $48f2cd94c2808d74$export$e67a095c620b86fe)(interval.end);
    let reversed = +startDate > +endDate;
    const endTime = reversed ? +startDate : +endDate;
    let currentDate = reversed ? endDate : startDate;
    currentDate.setMinutes(0, 0, 0);
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        dates.push((0, $48f2cd94c2808d74$export$e67a095c620b86fe)(currentDate));
        currentDate = (0, $63cf136474441a1f$export$4a4306ad4fa0e5e6)(currentDate, step);
    }
    return reversed ? dates.reverse() : dates;
}
var // Fallback for modularized imports:
$d5f74bf30e2fc325$export$2e2bcd8739ae039 = $d5f74bf30e2fc325$export$bb4f48fee90ea86e;


function $0789447cd4ec8bf3$export$1c9322f2d2a5eed3(interval, options) {
    const startDate = (0, $48f2cd94c2808d74$export$e67a095c620b86fe)(interval.start);
    const endDate = (0, $48f2cd94c2808d74$export$e67a095c620b86fe)(interval.end);
    let reversed = +startDate > +endDate;
    const endTime = reversed ? +startDate : +endDate;
    const currentDate = reversed ? endDate : startDate;
    currentDate.setHours(0, 0, 0, 0);
    currentDate.setDate(1);
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        dates.push((0, $48f2cd94c2808d74$export$e67a095c620b86fe)(currentDate));
        currentDate.setMonth(currentDate.getMonth() + step);
    }
    return reversed ? dates.reverse() : dates;
}
var // Fallback for modularized imports:
$0789447cd4ec8bf3$export$2e2bcd8739ae039 = $0789447cd4ec8bf3$export$1c9322f2d2a5eed3;




function $39f679ad4d152f0e$export$d31a8caec75fa456(interval, options) {
    const startDate = (0, $48f2cd94c2808d74$export$e67a095c620b86fe)(interval.start);
    const endDate = (0, $48f2cd94c2808d74$export$e67a095c620b86fe)(interval.end);
    let reversed = +startDate > +endDate;
    const startDateWeek = reversed ? (0, $f2ddddaabfe67186$export$42c81a444fbfb5d4)(endDate, options) : (0, $f2ddddaabfe67186$export$42c81a444fbfb5d4)(startDate, options);
    const endDateWeek = reversed ? (0, $f2ddddaabfe67186$export$42c81a444fbfb5d4)(startDate, options) : (0, $f2ddddaabfe67186$export$42c81a444fbfb5d4)(endDate, options);
    // Some timezones switch DST at midnight, making start of day unreliable in these timezones, 3pm is a safe bet
    startDateWeek.setHours(15);
    endDateWeek.setHours(15);
    const endTime = +endDateWeek.getTime();
    let currentDate = startDateWeek;
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        currentDate.setHours(0);
        dates.push((0, $48f2cd94c2808d74$export$e67a095c620b86fe)(currentDate));
        currentDate = (0, $ad866f4678a92721$export$ef501a2bb4f3ee6b)(currentDate, step);
        currentDate.setHours(15);
    }
    return reversed ? dates.reverse() : dates;
}
var // Fallback for modularized imports:
$39f679ad4d152f0e$export$2e2bcd8739ae039 = $39f679ad4d152f0e$export$d31a8caec75fa456;


function $99c557ac15213cc2$export$9b7f165f0a71d2a5(interval, options) {
    const startDate = (0, $48f2cd94c2808d74$export$e67a095c620b86fe)(interval.start);
    const endDate = (0, $48f2cd94c2808d74$export$e67a095c620b86fe)(interval.end);
    let reversed = +startDate > +endDate;
    const endTime = reversed ? +startDate : +endDate;
    const currentDate = reversed ? endDate : startDate;
    currentDate.setHours(0, 0, 0, 0);
    currentDate.setMonth(0, 1);
    let step = options?.step ?? 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+currentDate <= endTime){
        dates.push((0, $48f2cd94c2808d74$export$e67a095c620b86fe)(currentDate));
        currentDate.setFullYear(currentDate.getFullYear() + step);
    }
    return reversed ? dates.reverse() : dates;
}
var // Fallback for modularized imports:
$99c557ac15213cc2$export$2e2bcd8739ae039 = $99c557ac15213cc2$export$9b7f165f0a71d2a5;







const $8ce47baf257b7c7b$var$allIdsSelector = (state)=>state.allIds;
const $8ce47baf257b7c7b$var$byIdSelector = (state)=>state.byId;
const $8ce47baf257b7c7b$var$allIdsWithLocationSelector = (0, $b8b130b8bbf51c97$export$595d22ed68ca2841)($8ce47baf257b7c7b$var$allIdsSelector, $8ce47baf257b7c7b$var$byIdSelector, (allIds, byId)=>allIds.filter((id)=>{
        const { payload: payload } = byId[id];
        return typeof payload !== "string" && "location" in payload && payload.location;
    }));
const $8ce47baf257b7c7b$var$trackedCategoriesSelector = (0, $b8b130b8bbf51c97$export$595d22ed68ca2841)($8ce47baf257b7c7b$var$allIdsSelector, $8ce47baf257b7c7b$var$byIdSelector, (allIds, byId)=>{
    const normalizedCategories = {
        meditations: {
            allIds: [],
            byId: {}
        },
        moods: {
            allIds: [],
            byId: {}
        },
        sleeps: {
            allIds: [],
            byId: {}
        },
        weights: {
            allIds: [],
            byId: {}
        }
    };
    for (const id of allIds){
        const event = byId[id];
        const [_, category, operation] = event.type.split("/");
        const normalizedCategory = normalizedCategories[category];
        switch(operation){
            case "create":
                normalizedCategory.allIds.push(event.createdAt);
                normalizedCategory.byId[event.createdAt] = event.payload;
                break;
            case "delete":
                {
                    let index;
                    let i = normalizedCategory.allIds.length;
                    while(i--)if (normalizedCategory.allIds[i] === event.payload) {
                        index = i;
                        break;
                    }
                    if (index === undefined) {
                        (0, $24a8d9ab78e4f062$export$f5282963edea4a68)(Error(`Delete event error - could not find event to delete: ${JSON.stringify(event)}`));
                        break;
                    }
                    normalizedCategory.allIds.splice(index, 1);
                    delete normalizedCategory.byId[event.payload];
                    break;
                }
            case "update":
                {
                    const { payload: payload } = event;
                    const currentData = normalizedCategory.byId[payload.id];
                    const { id: _, ...rest } = payload;
                    // for reasons that are beyond my energy to investigate there is
                    // a runtime error if you try to update the data object directly
                    normalizedCategory.byId[payload.id] = {
                        ...currentData,
                        ...rest,
                        updatedAt: event.createdAt
                    };
                }
        }
    }
    return normalizedCategories;
});
const $8ce47baf257b7c7b$var$normalizedMeditationsSelector = (0, $b8b130b8bbf51c97$export$595d22ed68ca2841)($8ce47baf257b7c7b$var$trackedCategoriesSelector, ({ meditations: meditations })=>meditations);
const $8ce47baf257b7c7b$var$normalizedMoodsSelector = (0, $b8b130b8bbf51c97$export$595d22ed68ca2841)($8ce47baf257b7c7b$var$trackedCategoriesSelector, ({ moods: moods })=>moods);
const $8ce47baf257b7c7b$var$normalizedSleepsSelector = (0, $b8b130b8bbf51c97$export$595d22ed68ca2841)($8ce47baf257b7c7b$var$trackedCategoriesSelector, ({ sleeps: sleeps })=>sleeps);
const $8ce47baf257b7c7b$var$normalizedWeightsSelector = (0, $b8b130b8bbf51c97$export$595d22ed68ca2841)($8ce47baf257b7c7b$var$trackedCategoriesSelector, ({ weights: weights })=>weights);
const $8ce47baf257b7c7b$var$moodIdsWithLocationSelector = (0, $b8b130b8bbf51c97$export$595d22ed68ca2841)($8ce47baf257b7c7b$var$normalizedMoodsSelector, ({ allIds: allIds, byId: byId })=>allIds.filter((id)=>{
        const mood = byId[id];
        return "location" in mood && mood.location;
    }));
const $8ce47baf257b7c7b$var$makeMeanMoodsByPeriodSelector = (eachPeriodOfInterval, addPeriods, createId = (0, $c2e94012e82e0308$export$f3013bcc8d8645bd))=>(0, $b8b130b8bbf51c97$export$595d22ed68ca2841)($8ce47baf257b7c7b$var$normalizedMoodsSelector, (moods)=>{
        const meanMoods = {};
        if (!moods.allIds.length) return meanMoods;
        const periods = eachPeriodOfInterval({
            start: new Date(moods.allIds[0]),
            end: new Date(moods.allIds.at(-1))
        });
        const finalPeriod = addPeriods(periods.at(-1), 1);
        if (moods.allIds.length === 1) {
            meanMoods[createId(periods[0])] = moods.byId[moods.allIds[0]].mood;
            return meanMoods;
        }
        periods.push(finalPeriod);
        for(let i = 1; i < periods.length; i++){
            const p0 = periods[i - 1];
            const p1 = periods[i];
            const averageMoodInInterval = (0, $c2e94012e82e0308$export$5b8fdb0cdc6de921)(moods, p0, p1);
            if (averageMoodInInterval !== undefined) meanMoods[createId(p0)] = averageMoodInInterval;
        }
        return meanMoods;
    });
const $8ce47baf257b7c7b$var$getLastEvent = (normalizedState)=>{
    if (!normalizedState.allIds.length) throw Error("Error: `allIds` must have length > 0");
    const lastId = normalizedState.allIds.at(-1);
    return normalizedState.byId[lastId];
};
const $8ce47baf257b7c7b$var$denormalize = ({ allIds: allIds, byId: byId })=>allIds.map((id)=>({
            ...byId[id],
            createdAt: id
        }));
const $8ce47baf257b7c7b$var$normalizedStateNotEmpty = ({ allIds: allIds })=>Boolean(allIds.length);
const $8ce47baf257b7c7b$var$dateFromSelector = (_state, dateFrom)=>dateFrom;
const $8ce47baf257b7c7b$var$dateToSelector = (_state, _dateFrom, dateTo)=>dateTo;
const $8ce47baf257b7c7b$var$denormalizedSleepsSelector = (0, $b8b130b8bbf51c97$export$595d22ed68ca2841)($8ce47baf257b7c7b$var$normalizedSleepsSelector, $8ce47baf257b7c7b$var$denormalize);
const $8ce47baf257b7c7b$var$minutesSleptByDateAwokeSelector = (0, $b8b130b8bbf51c97$export$595d22ed68ca2841)($8ce47baf257b7c7b$var$denormalizedSleepsSelector, (sleeps)=>{
    const sleepByDateAwoke = (0, $c2e94012e82e0308$export$5563593ccbfe9912)(()=>0);
    for (const { dateAwoke: dateAwoke, minutesSlept: minutesSlept } of sleeps)sleepByDateAwoke[dateAwoke] += minutesSlept;
    return {
        ...sleepByDateAwoke
    };
});
const $8ce47baf257b7c7b$var$moodsInPeriodResultFunction = ({ allIds: allIds, byId: byId }, dateFrom, dateTo)=>(0, $c2e94012e82e0308$export$3a3d91da857d6da2)(allIds, dateFrom, dateTo).map((id)=>byId[id]);
const $8ce47baf257b7c7b$var$secondsMeditatedInPeriodResultFunction = ({ allIds: allIds, byId: byId }, dateFrom, dateTo)=>{
    let sum = 0;
    for (const id of (0, $c2e94012e82e0308$export$3a3d91da857d6da2)(allIds, dateFrom, dateTo))sum += byId[id].seconds;
    return sum;
};
const $8ce47baf257b7c7b$var$initialState = {
    allIds: [],
    byId: {},
    hasLoadedFromServer: false,
    idsToSync: [],
    isSyncingFromServer: false,
    isSyncingToServer: false,
    syncFromServerError: false,
    syncToServerError: false,
    nextCursor: undefined
};
var $8ce47baf257b7c7b$export$2e2bcd8739ae039 = (0, $50aea76f54d86b4e$export$4d8d9bd83c24ae8b)({
    name: "events",
    initialState: $8ce47baf257b7c7b$var$initialState,
    reducers: {
        add: (state, action)=>{
            const lastEvent = state.allIds.length ? $8ce47baf257b7c7b$var$getLastEvent(state) : undefined;
            if (lastEvent && lastEvent.createdAt > action.payload.createdAt) {
                const date = new Date(lastEvent.createdAt);
                date.setUTCMilliseconds(date.getUTCMilliseconds() + 1);
                const newCreatedAt = date.toISOString();
                action.payload.createdAt = newCreatedAt;
            }
            state.allIds.push(action.payload.createdAt);
            state.byId[action.payload.createdAt] = action.payload;
            state.idsToSync.push(action.payload.createdAt);
        },
        clear: ()=>$8ce47baf257b7c7b$var$initialState,
        loadFromStorage: (state, action)=>Object.assign(state, action.payload),
        syncToServerStart: (state)=>{
            state.isSyncingToServer = true;
            state.syncToServerError = false;
        },
        syncToServerError: (state)=>{
            state.isSyncingToServer = false;
            state.syncToServerError = true;
        },
        syncToServerSuccess: (state)=>{
            state.idsToSync = [];
            state.isSyncingToServer = false;
            state.syncToServerError = false;
        },
        syncFromServerStart: (state)=>{
            state.isSyncingFromServer = true;
            state.syncFromServerError = false;
        },
        syncFromServerError: (state)=>{
            state.isSyncingFromServer = false;
            state.syncFromServerError = true;
        },
        syncFromServerSuccess: (state, action)=>{
            state.isSyncingFromServer = false;
            state.syncFromServerError = false;
            state.hasLoadedFromServer = true;
            state.nextCursor = action.payload.cursor;
            if (!action.payload.events.length) return;
            const serverEventIds = action.payload.events.map((event)=>event.createdAt);
            if (serverEventIds.every((id)=>id in state.byId)) return;
            for (const event of action.payload.events)state.byId[event.createdAt] = event;
            state.allIds = (state.allIds.length ? [
                ...new Set([
                    ...state.allIds,
                    ...serverEventIds
                ])
            ] : serverEventIds)// The API offers no order guarantees
            .sort((a, b)=>a > b ? 1 : a < b ? -1 : 0);
        }
    },
    selectors: {
        allIds: $8ce47baf257b7c7b$var$allIdsSelector,
        byId: $8ce47baf257b7c7b$var$byIdSelector,
        hasLoadedFromServer: (state)=>state.hasLoadedFromServer,
        idsToSync: (state)=>state.idsToSync,
        idsWithLocationInPeriod: (0, $b8b130b8bbf51c97$export$595d22ed68ca2841)($8ce47baf257b7c7b$var$allIdsWithLocationSelector, $8ce47baf257b7c7b$var$dateFromSelector, $8ce47baf257b7c7b$var$dateToSelector, (0, $c2e94012e82e0308$export$3a3d91da857d6da2)),
        isSyncingFromServer: (state)=>state.isSyncingFromServer,
        isSyncingToServer: (state)=>state.isSyncingToServer,
        nextCursor: (state)=>state.nextCursor,
        syncFromServerError: (state)=>state.syncFromServerError,
        syncToServerError: (state)=>state.syncToServerError,
        allIdsWithLocation: $8ce47baf257b7c7b$var$allIdsWithLocationSelector,
        moodIdsWithLocation: $8ce47baf257b7c7b$var$moodIdsWithLocationSelector,
        moodIdsWithLocationInPeriod: (0, $b8b130b8bbf51c97$export$595d22ed68ca2841)($8ce47baf257b7c7b$var$moodIdsWithLocationSelector, $8ce47baf257b7c7b$var$dateFromSelector, $8ce47baf257b7c7b$var$dateToSelector, (0, $c2e94012e82e0308$export$3a3d91da857d6da2)),
        denormalizedMeditations: (0, $b8b130b8bbf51c97$export$595d22ed68ca2841)($8ce47baf257b7c7b$var$normalizedMeditationsSelector, $8ce47baf257b7c7b$var$denormalize),
        denormalizedMoods: (0, $b8b130b8bbf51c97$export$595d22ed68ca2841)($8ce47baf257b7c7b$var$normalizedMoodsSelector, $8ce47baf257b7c7b$var$denormalize),
        denormalizedSleeps: $8ce47baf257b7c7b$var$denormalizedSleepsSelector,
        denormalizedWeights: (0, $b8b130b8bbf51c97$export$595d22ed68ca2841)($8ce47baf257b7c7b$var$normalizedWeightsSelector, $8ce47baf257b7c7b$var$denormalize),
        envelopingMoodIds: (0, $b8b130b8bbf51c97$export$595d22ed68ca2841)($8ce47baf257b7c7b$var$normalizedMoodsSelector, $8ce47baf257b7c7b$var$dateFromSelector, $8ce47baf257b7c7b$var$dateToSelector, ({ allIds: allIds }, dateFrom, dateTo)=>(0, $c2e94012e82e0308$export$11d4869c8daa6ec)(allIds, dateFrom, dateTo)),
        envelopingWeightIds: (0, $b8b130b8bbf51c97$export$595d22ed68ca2841)($8ce47baf257b7c7b$var$normalizedWeightsSelector, $8ce47baf257b7c7b$var$dateFromSelector, $8ce47baf257b7c7b$var$dateToSelector, ({ allIds: allIds }, dateFrom, dateTo)=>(0, $c2e94012e82e0308$export$11d4869c8daa6ec)(allIds, dateFrom, dateTo)),
        envelopingIdsWithLocation: (0, $b8b130b8bbf51c97$export$595d22ed68ca2841)($8ce47baf257b7c7b$var$allIdsWithLocationSelector, $8ce47baf257b7c7b$var$dateFromSelector, $8ce47baf257b7c7b$var$dateToSelector, (0, $c2e94012e82e0308$export$11d4869c8daa6ec)),
        hasMoods: (0, $b8b130b8bbf51c97$export$595d22ed68ca2841)($8ce47baf257b7c7b$var$normalizedMoodsSelector, $8ce47baf257b7c7b$var$normalizedStateNotEmpty),
        hasMeditations: (0, $b8b130b8bbf51c97$export$595d22ed68ca2841)($8ce47baf257b7c7b$var$normalizedMeditationsSelector, $8ce47baf257b7c7b$var$normalizedStateNotEmpty),
        hasSleeps: (0, $b8b130b8bbf51c97$export$595d22ed68ca2841)($8ce47baf257b7c7b$var$normalizedSleepsSelector, $8ce47baf257b7c7b$var$normalizedStateNotEmpty),
        hasWeights: (0, $b8b130b8bbf51c97$export$595d22ed68ca2841)($8ce47baf257b7c7b$var$normalizedWeightsSelector, $8ce47baf257b7c7b$var$normalizedStateNotEmpty),
        meanDailySleepDurationInPeriod: (0, $b8b130b8bbf51c97$export$595d22ed68ca2841)($8ce47baf257b7c7b$var$minutesSleptByDateAwokeSelector, $8ce47baf257b7c7b$var$dateFromSelector, $8ce47baf257b7c7b$var$dateToSelector, (minutesSleptByDateAwoke, dateFrom, dateTo)=>{
            const minutesSleptArray = [];
            for(let date = dateFrom; date < dateTo; date = (0, $cb8fdbef2aba70f2$export$dd412b56f1e4d8aa)(date, 1)){
                const minutesSlept = minutesSleptByDateAwoke[(0, $c2e94012e82e0308$export$f3013bcc8d8645bd)(date)];
                if (minutesSlept === undefined) continue;
                minutesSleptArray.push(minutesSlept);
            }
            return (0, $c2e94012e82e0308$export$a8616ca67e2741ea)(minutesSleptArray);
        }),
        meanMinutesSleptByMonth: (0, $b8b130b8bbf51c97$export$595d22ed68ca2841)($8ce47baf257b7c7b$var$minutesSleptByDateAwokeSelector, (minutesSleptByDateAwoke)=>{
            const sleepsByMonth = (0, $c2e94012e82e0308$export$5563593ccbfe9912)(()=>[]);
            for (const [date, minutesSlept] of Object.entries(minutesSleptByDateAwoke))sleepsByMonth[date.slice(0, 7)].push(minutesSlept);
            return Object.fromEntries(Object.entries(sleepsByMonth).map(([month, sleeps])=>[
                    month,
                    (0, $c2e94012e82e0308$export$772b647faa1a81e0)(sleeps)
                ]));
        }),
        minutesSleptByDateAwoke: $8ce47baf257b7c7b$var$minutesSleptByDateAwokeSelector,
        meanWeightInPeriod: (0, $b8b130b8bbf51c97$export$595d22ed68ca2841)($8ce47baf257b7c7b$var$normalizedWeightsSelector, $8ce47baf257b7c7b$var$dateFromSelector, $8ce47baf257b7c7b$var$dateToSelector, ({ allIds: allIds, byId: byId }, dateFrom, dateTo)=>(0, $c2e94012e82e0308$export$a8616ca67e2741ea)((0, $c2e94012e82e0308$export$3a3d91da857d6da2)(allIds, dateFrom, dateTo).map((id)=>byId[id]).map(({ value: value })=>value))),
        meditationIdsInPeriod: (0, $b8b130b8bbf51c97$export$595d22ed68ca2841)($8ce47baf257b7c7b$var$normalizedMeditationsSelector, $8ce47baf257b7c7b$var$dateFromSelector, $8ce47baf257b7c7b$var$dateToSelector, ({ allIds: allIds }, dateFrom, dateTo)=>(0, $c2e94012e82e0308$export$3a3d91da857d6da2)(allIds, dateFrom, dateTo)),
        moodCloudWords: (0, $b8b130b8bbf51c97$export$595d22ed68ca2841)($8ce47baf257b7c7b$var$normalizedMoodsSelector, $8ce47baf257b7c7b$var$dateFromSelector, $8ce47baf257b7c7b$var$dateToSelector, (normalizedMoods, dateFrom, dateTo)=>{
            const moodsInPeriod = $8ce47baf257b7c7b$var$moodsInPeriodResultFunction(normalizedMoods, dateFrom, dateTo);
            const words = {};
            for (const { description: description } of moodsInPeriod){
                const normalizedDescriptionWords = description ? (0, $c2e94012e82e0308$export$d7e7e8e9e6ba5acd)(description) : [];
                for (const caseNormalizedWord of normalizedDescriptionWords)if (words[caseNormalizedWord]) words[caseNormalizedWord] += 1;
                else words[caseNormalizedWord] = 1;
            }
            return Object.keys(words).length < (0, $5a123094476b33d7$export$9659e0d912e2b51e) ? undefined : words;
        }),
        // some code may depend on the fact that the array
        // value in the returned object cannot be empty
        moodIdsByDate: (0, $b8b130b8bbf51c97$export$595d22ed68ca2841)($8ce47baf257b7c7b$var$normalizedMoodsSelector, ({ allIds: allIds })=>{
            const moodsByDate = (0, $c2e94012e82e0308$export$5563593ccbfe9912)(()=>[]);
            for (const id of allIds)moodsByDate[(0, $c2e94012e82e0308$export$f3013bcc8d8645bd)(new Date(id))].push(id);
            return {
                ...moodsByDate
            };
        }),
        moodIdsInPeriod: (0, $b8b130b8bbf51c97$export$595d22ed68ca2841)($8ce47baf257b7c7b$var$normalizedMoodsSelector, $8ce47baf257b7c7b$var$dateFromSelector, $8ce47baf257b7c7b$var$dateToSelector, ({ allIds: allIds }, dateFrom, dateTo)=>(0, $c2e94012e82e0308$export$3a3d91da857d6da2)(allIds, dateFrom, dateTo)),
        moodsInPeriod: (0, $b8b130b8bbf51c97$export$595d22ed68ca2841)($8ce47baf257b7c7b$var$normalizedMoodsSelector, $8ce47baf257b7c7b$var$dateFromSelector, $8ce47baf257b7c7b$var$dateToSelector, $8ce47baf257b7c7b$var$moodsInPeriodResultFunction),
        normalizedDescriptionWords: (0, $b8b130b8bbf51c97$export$595d22ed68ca2841)($8ce47baf257b7c7b$var$normalizedMoodsSelector, (normalizedMoods)=>{
            const descriptionWords = new Set();
            for(let i = 0; i < normalizedMoods.allIds.length; i++){
                const id = normalizedMoods.allIds[i];
                const { description: description } = normalizedMoods.byId[id];
                const normalizedWords = description ? (0, $c2e94012e82e0308$export$d7e7e8e9e6ba5acd)(description) : [];
                for(let j = 0; j < normalizedWords.length; j++)descriptionWords.add(normalizedWords[j]);
            }
            return [
                ...descriptionWords
            ].sort((a, b)=>a.localeCompare(b));
        }),
        normalizedMeditations: $8ce47baf257b7c7b$var$normalizedMeditationsSelector,
        normalizedMoods: $8ce47baf257b7c7b$var$normalizedMoodsSelector,
        normalizedSleeps: $8ce47baf257b7c7b$var$normalizedSleepsSelector,
        normalizedSleepsSortedByDateAwoke: (0, $b8b130b8bbf51c97$export$595d22ed68ca2841)($8ce47baf257b7c7b$var$normalizedSleepsSelector, (normalizedSleeps)=>({
                ...normalizedSleeps,
                // sorting is stable so 2 events with same dateAwoke will be ordered by event id
                allIds: [
                    ...normalizedSleeps.allIds
                ].sort((a, b)=>{
                    const dateAwokeA = normalizedSleeps.byId[a].dateAwoke;
                    const dateAwokeB = normalizedSleeps.byId[b].dateAwoke;
                    return dateAwokeA > dateAwokeB ? 1 : dateAwokeA < dateAwokeB ? -1 : 0;
                })
            })),
        normalizedWeights: $8ce47baf257b7c7b$var$normalizedWeightsSelector,
        meanMoodsByHour: $8ce47baf257b7c7b$var$makeMeanMoodsByPeriodSelector((0, $d5f74bf30e2fc325$export$bb4f48fee90ea86e), (0, $63cf136474441a1f$export$4a4306ad4fa0e5e6), (0, $c2e94012e82e0308$export$5de6434cc589fc5b)),
        meanMoodsByDay: $8ce47baf257b7c7b$var$makeMeanMoodsByPeriodSelector((0, $19a1ba3858cb2722$export$7a337e5923c7ceb5), (0, $cb8fdbef2aba70f2$export$dd412b56f1e4d8aa)),
        meanMoodsByWeek: $8ce47baf257b7c7b$var$makeMeanMoodsByPeriodSelector(({ start: start, end: end })=>(0, $39f679ad4d152f0e$export$d31a8caec75fa456)({
                start: start,
                end: end
            }, (0, $06d17fa75ca1067f$export$34c88de16c0a2653)), (0, $ad866f4678a92721$export$ef501a2bb4f3ee6b)),
        meanMoodsByMonth: $8ce47baf257b7c7b$var$makeMeanMoodsByPeriodSelector((0, $0789447cd4ec8bf3$export$1c9322f2d2a5eed3), (0, $857e6f903d884172$export$17c93e242b2d3a22)),
        meanMoodsByYear: $8ce47baf257b7c7b$var$makeMeanMoodsByPeriodSelector((0, $99c557ac15213cc2$export$9b7f165f0a71d2a5), (0, $8481dd0cb1201679$export$3d83eec43f4ea476)),
        normalizedTotalSecondsMeditatedByMonth: (0, $b8b130b8bbf51c97$export$595d22ed68ca2841)($8ce47baf257b7c7b$var$normalizedMeditationsSelector, (normalizedMeditations)=>{
            const allIds = [];
            const byId = {};
            const normalizedTotalSeconds = {
                allIds: allIds,
                byId: byId
            };
            if (!normalizedMeditations.allIds.length) return normalizedTotalSeconds;
            const periods = (0, $0789447cd4ec8bf3$export$1c9322f2d2a5eed3)({
                start: new Date(normalizedMeditations.allIds[0]),
                end: new Date(normalizedMeditations.allIds.at(-1))
            });
            const finalPeriod = (0, $857e6f903d884172$export$17c93e242b2d3a22)(periods.at(-1), 1);
            if (normalizedMeditations.allIds.length === 1) {
                const id = (0, $c2e94012e82e0308$export$f3013bcc8d8645bd)(periods[0]);
                allIds.push(id);
                byId[id] = normalizedMeditations.byId[normalizedMeditations.allIds[0]].seconds;
                return normalizedTotalSeconds;
            }
            periods.push(finalPeriod);
            for(let i = 1; i < periods.length; i++){
                const p0 = periods[i - 1];
                const p1 = periods[i];
                const id = (0, $c2e94012e82e0308$export$f3013bcc8d8645bd)(p0);
                allIds.push(id);
                byId[id] = $8ce47baf257b7c7b$var$secondsMeditatedInPeriodResultFunction(normalizedMeditations, p0, p1);
            }
            return normalizedTotalSeconds;
        }),
        secondsMeditatedInPeriod: (0, $b8b130b8bbf51c97$export$595d22ed68ca2841)($8ce47baf257b7c7b$var$normalizedMeditationsSelector, $8ce47baf257b7c7b$var$dateFromSelector, $8ce47baf257b7c7b$var$dateToSelector, $8ce47baf257b7c7b$var$secondsMeditatedInPeriodResultFunction)
    }
});



var $kJcVt = parcelRequire("kJcVt");
parcelRequire("avFL0");
var $cZu4U = parcelRequire("cZu4U");

var $K0nIp = parcelRequire("K0nIp");
parcelRequire("c1MK9");
var $dx4el = parcelRequire("dx4el");
var $jr2rX = parcelRequire("jr2rX");
parcelRequire("bIgHl");
var $4aYuz = parcelRequire("4aYuz");
parcelRequire("21756");
var $9iah1 = parcelRequire("9iah1");
var $eGqnu = parcelRequire("eGqnu");
var $hshmJ = parcelRequire("hshmJ");

var $e8QI9 = parcelRequire("e8QI9");
parcelRequire("f1nrT");
var $7vygy = parcelRequire("7vygy");
parcelRequire("ggI4s");
var $6Httz = parcelRequire("6Httz");
var $66f0Z = parcelRequire("66f0Z");
parcelRequire("33pc1");
var $cr1Pw = parcelRequire("cr1Pw");

var $7UJxK = parcelRequire("7UJxK");
parcelRequire("e2ELD");
var $3eYQu = parcelRequire("3eYQu");
var $j5KxT = parcelRequire("j5KxT");
const $9a5a2b2d9ad00d22$export$257fec7c5679bec2 = async (config, context, input)=>{
    return {
        operation: (0, $3eYQu.getSmithyContext)(context).operation,
        region: await (0, $j5KxT.normalizeProvider)(config.region)() || (()=>{
            throw new Error("expected `region` to be configured for `aws.auth#sigv4`");
        })()
    };
};
function $9a5a2b2d9ad00d22$var$createAwsAuthSigv4HttpAuthOption(authParameters) {
    return {
        schemeId: "aws.auth#sigv4",
        signingProperties: {
            name: "geo",
            region: authParameters.region
        },
        propertiesExtractor: (config, context)=>({
                signingProperties: {
                    config: config,
                    context: context
                }
            })
    };
}
const $9a5a2b2d9ad00d22$export$739ba9ca5f6ec443 = (authParameters)=>{
    const options = [];
    authParameters.operation;
    options.push($9a5a2b2d9ad00d22$var$createAwsAuthSigv4HttpAuthOption(authParameters));
    return options;
};
const $9a5a2b2d9ad00d22$export$d38ef9c0c6c649ab = (config)=>{
    const config_0 = (0, $7UJxK.resolveAwsSdkSigV4Config)(config);
    return {
        ...config_0
    };
};


const $5d5872ec2e5681cc$export$70b6341cd51750a8 = (options)=>{
    return {
        ...options,
        useDualstackEndpoint: options.useDualstackEndpoint ?? false,
        useFipsEndpoint: options.useFipsEndpoint ?? false,
        defaultSigningName: "geo"
    };
};
const $5d5872ec2e5681cc$export$9c07ced2019f0ae0 = {
    UseFIPS: {
        type: "builtInParams",
        name: "useFipsEndpoint"
    },
    Endpoint: {
        type: "builtInParams",
        name: "endpoint"
    },
    Region: {
        type: "builtInParams",
        name: "region"
    },
    UseDualStack: {
        type: "builtInParams",
        name: "useDualstackEndpoint"
    }
};


var $653586e68908c912$exports = {};
$653586e68908c912$exports = JSON.parse('{"name":"@aws-sdk/client-location","description":"AWS SDK for JavaScript Location Client for Node.js, Browser and React Native","version":"3.540.0","scripts":{"build":"concurrently \'yarn:build:cjs\' \'yarn:build:es\' \'yarn:build:types\'","build:cjs":"node ../../scripts/compilation/inline client-location","build:es":"tsc -p tsconfig.es.json","build:include:deps":"lerna run --scope $npm_package_name --include-dependencies build","build:types":"tsc -p tsconfig.types.json","build:types:downlevel":"downlevel-dts dist-types dist-types/ts3.4","clean":"rimraf ./dist-* && rimraf *.tsbuildinfo","extract:docs":"api-extractor run --local","generate:client":"node ../../scripts/generate-clients/single-service --solo location"},"main":"./dist-cjs/index.js","types":"./dist-types/index.d.ts","module":"./dist-es/index.js","sideEffects":false,"dependencies":{"@aws-crypto/sha256-browser":"3.0.0","@aws-crypto/sha256-js":"3.0.0","@aws-sdk/client-sts":"3.540.0","@aws-sdk/core":"3.535.0","@aws-sdk/credential-provider-node":"3.540.0","@aws-sdk/middleware-host-header":"3.535.0","@aws-sdk/middleware-logger":"3.535.0","@aws-sdk/middleware-recursion-detection":"3.535.0","@aws-sdk/middleware-user-agent":"3.540.0","@aws-sdk/region-config-resolver":"3.535.0","@aws-sdk/types":"3.535.0","@aws-sdk/util-endpoints":"3.540.0","@aws-sdk/util-user-agent-browser":"3.535.0","@aws-sdk/util-user-agent-node":"3.535.0","@smithy/config-resolver":"^2.2.0","@smithy/core":"^1.4.0","@smithy/fetch-http-handler":"^2.5.0","@smithy/hash-node":"^2.2.0","@smithy/invalid-dependency":"^2.2.0","@smithy/middleware-content-length":"^2.2.0","@smithy/middleware-endpoint":"^2.5.0","@smithy/middleware-retry":"^2.2.0","@smithy/middleware-serde":"^2.3.0","@smithy/middleware-stack":"^2.2.0","@smithy/node-config-provider":"^2.3.0","@smithy/node-http-handler":"^2.5.0","@smithy/protocol-http":"^3.3.0","@smithy/smithy-client":"^2.5.0","@smithy/types":"^2.12.0","@smithy/url-parser":"^2.2.0","@smithy/util-base64":"^2.3.0","@smithy/util-body-length-browser":"^2.2.0","@smithy/util-body-length-node":"^2.3.0","@smithy/util-defaults-mode-browser":"^2.2.0","@smithy/util-defaults-mode-node":"^2.3.0","@smithy/util-endpoints":"^1.2.0","@smithy/util-middleware":"^2.2.0","@smithy/util-retry":"^2.2.0","@smithy/util-stream":"^2.2.0","@smithy/util-utf8":"^2.3.0","tslib":"^2.6.2"},"devDependencies":{"@smithy/service-client-documentation-generator":"^2.2.0","@tsconfig/node14":"1.0.3","@types/node":"^14.14.31","concurrently":"7.0.0","downlevel-dts":"0.10.1","rimraf":"3.0.2","typescript":"~4.9.5"},"engines":{"node":">=14.0.0"},"typesVersions":{"<4.0":{"dist-types/*":["dist-types/ts3.4/*"]}},"files":["dist-*/**"],"author":{"name":"AWS SDK for JavaScript Team","url":"https://aws.amazon.com/javascript/"},"license":"Apache-2.0","browser":{"./dist-es/runtimeConfig":"./dist-es/runtimeConfig.browser"},"react-native":{"./dist-es/runtimeConfig":"./dist-es/runtimeConfig.native"},"homepage":"https://github.com/aws/aws-sdk-js-v3/tree/main/clients/client-location","repository":{"type":"git","url":"https://github.com/aws/aws-sdk-js-v3.git","directory":"clients/client-location"}}');



var $kq0db = parcelRequire("kq0db");

var $dPlLR = parcelRequire("dPlLR");
parcelRequire("bIgHl");
var $1gTFA = parcelRequire("1gTFA");
var $4GfQZ = parcelRequire("4GfQZ");
parcelRequire("ioEDO");
var $gMAof = parcelRequire("gMAof");
var $ahmip = parcelRequire("ahmip");
parcelRequire("ch0sh");
var $1j16v = parcelRequire("1j16v");
parcelRequire("3slPz");
var $9v2WL = parcelRequire("9v2WL");
parcelRequire("dysC5");
var $blSB9 = parcelRequire("blSB9");

var $59IvS = parcelRequire("59IvS");
parcelRequire("33pc1");
var $4RSUY = parcelRequire("4RSUY");

var $kOVEw = parcelRequire("kOVEw");
parcelRequire("cteja");
var $6Gr16 = parcelRequire("6Gr16");
var $030I1 = parcelRequire("030I1");
parcelRequire("cace4");
var $3tKur = parcelRequire("3tKur");
var $hpab6 = parcelRequire("hpab6");

parcelRequire("3Wq28");
var $DDoDH = parcelRequire("DDoDH");
parcelRequire("j27kH");
var $dCEjZ = parcelRequire("dCEjZ");
var $fdTj5 = parcelRequire("fdTj5");
const $7dbaf624a88eeac3$var$s = "required", $7dbaf624a88eeac3$var$t = "fn", $7dbaf624a88eeac3$var$u = "argv", $7dbaf624a88eeac3$var$v = "ref";
const $7dbaf624a88eeac3$var$a = true, $7dbaf624a88eeac3$var$b = "isSet", $7dbaf624a88eeac3$var$c = "booleanEquals", $7dbaf624a88eeac3$var$d = "error", $7dbaf624a88eeac3$var$e = "endpoint", $7dbaf624a88eeac3$var$f = "tree", $7dbaf624a88eeac3$var$g = "PartitionResult", $7dbaf624a88eeac3$var$h = {
    [$7dbaf624a88eeac3$var$s]: false,
    "type": "String"
}, $7dbaf624a88eeac3$var$i = {
    [$7dbaf624a88eeac3$var$s]: true,
    "default": false,
    "type": "Boolean"
}, $7dbaf624a88eeac3$var$j = {
    [$7dbaf624a88eeac3$var$v]: "Endpoint"
}, $7dbaf624a88eeac3$var$k = {
    [$7dbaf624a88eeac3$var$t]: $7dbaf624a88eeac3$var$c,
    [$7dbaf624a88eeac3$var$u]: [
        {
            [$7dbaf624a88eeac3$var$v]: "UseFIPS"
        },
        true
    ]
}, $7dbaf624a88eeac3$var$l = {
    [$7dbaf624a88eeac3$var$t]: $7dbaf624a88eeac3$var$c,
    [$7dbaf624a88eeac3$var$u]: [
        {
            [$7dbaf624a88eeac3$var$v]: "UseDualStack"
        },
        true
    ]
}, $7dbaf624a88eeac3$var$m = {}, $7dbaf624a88eeac3$var$n = {
    [$7dbaf624a88eeac3$var$t]: "getAttr",
    [$7dbaf624a88eeac3$var$u]: [
        {
            [$7dbaf624a88eeac3$var$v]: $7dbaf624a88eeac3$var$g
        },
        "supportsFIPS"
    ]
}, $7dbaf624a88eeac3$var$o = {
    [$7dbaf624a88eeac3$var$t]: $7dbaf624a88eeac3$var$c,
    [$7dbaf624a88eeac3$var$u]: [
        true,
        {
            [$7dbaf624a88eeac3$var$t]: "getAttr",
            [$7dbaf624a88eeac3$var$u]: [
                {
                    [$7dbaf624a88eeac3$var$v]: $7dbaf624a88eeac3$var$g
                },
                "supportsDualStack"
            ]
        }
    ]
}, $7dbaf624a88eeac3$var$p = [
    $7dbaf624a88eeac3$var$k
], $7dbaf624a88eeac3$var$q = [
    $7dbaf624a88eeac3$var$l
], $7dbaf624a88eeac3$var$r = [
    {
        [$7dbaf624a88eeac3$var$v]: "Region"
    }
];
const $7dbaf624a88eeac3$var$_data = {
    version: "1.0",
    parameters: {
        Region: $7dbaf624a88eeac3$var$h,
        UseDualStack: $7dbaf624a88eeac3$var$i,
        UseFIPS: $7dbaf624a88eeac3$var$i,
        Endpoint: $7dbaf624a88eeac3$var$h
    },
    rules: [
        {
            conditions: [
                {
                    [$7dbaf624a88eeac3$var$t]: $7dbaf624a88eeac3$var$b,
                    [$7dbaf624a88eeac3$var$u]: [
                        $7dbaf624a88eeac3$var$j
                    ]
                }
            ],
            rules: [
                {
                    conditions: $7dbaf624a88eeac3$var$p,
                    error: "Invalid Configuration: FIPS and custom endpoint are not supported",
                    type: $7dbaf624a88eeac3$var$d
                },
                {
                    conditions: $7dbaf624a88eeac3$var$q,
                    error: "Invalid Configuration: Dualstack and custom endpoint are not supported",
                    type: $7dbaf624a88eeac3$var$d
                },
                {
                    endpoint: {
                        url: $7dbaf624a88eeac3$var$j,
                        properties: $7dbaf624a88eeac3$var$m,
                        headers: $7dbaf624a88eeac3$var$m
                    },
                    type: $7dbaf624a88eeac3$var$e
                }
            ],
            type: $7dbaf624a88eeac3$var$f
        },
        {
            conditions: [
                {
                    [$7dbaf624a88eeac3$var$t]: $7dbaf624a88eeac3$var$b,
                    [$7dbaf624a88eeac3$var$u]: $7dbaf624a88eeac3$var$r
                }
            ],
            rules: [
                {
                    conditions: [
                        {
                            [$7dbaf624a88eeac3$var$t]: "aws.partition",
                            [$7dbaf624a88eeac3$var$u]: $7dbaf624a88eeac3$var$r,
                            assign: $7dbaf624a88eeac3$var$g
                        }
                    ],
                    rules: [
                        {
                            conditions: [
                                $7dbaf624a88eeac3$var$k,
                                $7dbaf624a88eeac3$var$l
                            ],
                            rules: [
                                {
                                    conditions: [
                                        {
                                            [$7dbaf624a88eeac3$var$t]: $7dbaf624a88eeac3$var$c,
                                            [$7dbaf624a88eeac3$var$u]: [
                                                $7dbaf624a88eeac3$var$a,
                                                $7dbaf624a88eeac3$var$n
                                            ]
                                        },
                                        $7dbaf624a88eeac3$var$o
                                    ],
                                    rules: [
                                        {
                                            endpoint: {
                                                url: "https://geo-fips.{Region}.{PartitionResult#dualStackDnsSuffix}",
                                                properties: $7dbaf624a88eeac3$var$m,
                                                headers: $7dbaf624a88eeac3$var$m
                                            },
                                            type: $7dbaf624a88eeac3$var$e
                                        }
                                    ],
                                    type: $7dbaf624a88eeac3$var$f
                                },
                                {
                                    error: "FIPS and DualStack are enabled, but this partition does not support one or both",
                                    type: $7dbaf624a88eeac3$var$d
                                }
                            ],
                            type: $7dbaf624a88eeac3$var$f
                        },
                        {
                            conditions: $7dbaf624a88eeac3$var$p,
                            rules: [
                                {
                                    conditions: [
                                        {
                                            [$7dbaf624a88eeac3$var$t]: $7dbaf624a88eeac3$var$c,
                                            [$7dbaf624a88eeac3$var$u]: [
                                                $7dbaf624a88eeac3$var$n,
                                                $7dbaf624a88eeac3$var$a
                                            ]
                                        }
                                    ],
                                    rules: [
                                        {
                                            endpoint: {
                                                url: "https://geo-fips.{Region}.{PartitionResult#dnsSuffix}",
                                                properties: $7dbaf624a88eeac3$var$m,
                                                headers: $7dbaf624a88eeac3$var$m
                                            },
                                            type: $7dbaf624a88eeac3$var$e
                                        }
                                    ],
                                    type: $7dbaf624a88eeac3$var$f
                                },
                                {
                                    error: "FIPS is enabled but this partition does not support FIPS",
                                    type: $7dbaf624a88eeac3$var$d
                                }
                            ],
                            type: $7dbaf624a88eeac3$var$f
                        },
                        {
                            conditions: $7dbaf624a88eeac3$var$q,
                            rules: [
                                {
                                    conditions: [
                                        $7dbaf624a88eeac3$var$o
                                    ],
                                    rules: [
                                        {
                                            endpoint: {
                                                url: "https://geo.{Region}.{PartitionResult#dualStackDnsSuffix}",
                                                properties: $7dbaf624a88eeac3$var$m,
                                                headers: $7dbaf624a88eeac3$var$m
                                            },
                                            type: $7dbaf624a88eeac3$var$e
                                        }
                                    ],
                                    type: $7dbaf624a88eeac3$var$f
                                },
                                {
                                    error: "DualStack is enabled but this partition does not support DualStack",
                                    type: $7dbaf624a88eeac3$var$d
                                }
                            ],
                            type: $7dbaf624a88eeac3$var$f
                        },
                        {
                            endpoint: {
                                url: "https://geo.{Region}.{PartitionResult#dnsSuffix}",
                                properties: $7dbaf624a88eeac3$var$m,
                                headers: $7dbaf624a88eeac3$var$m
                            },
                            type: $7dbaf624a88eeac3$var$e
                        }
                    ],
                    type: $7dbaf624a88eeac3$var$f
                }
            ],
            type: $7dbaf624a88eeac3$var$f
        },
        {
            error: "Invalid Configuration: Missing Region",
            type: $7dbaf624a88eeac3$var$d
        }
    ]
};
const $7dbaf624a88eeac3$export$7b249e066372152f = $7dbaf624a88eeac3$var$_data;


const $c9b6df5b8d32e521$export$47fc6e98c86e06e3 = (endpointParams, context = {})=>{
    return (0, $fdTj5.resolveEndpoint)((0, $7dbaf624a88eeac3$export$7b249e066372152f), {
        endpointParams: endpointParams,
        logger: context.logger
    });
};
(0, $dCEjZ.customEndpointFunctions).aws = (0, $DDoDH.awsEndpointFunctions);


const $7c985012fca81a90$export$ad0966540b0e71e5 = (config)=>{
    return {
        apiVersion: "2020-11-19",
        base64Decoder: config?.base64Decoder ?? (0, $6Gr16.fromBase64),
        base64Encoder: config?.base64Encoder ?? (0, $030I1.toBase64),
        disableHostPrefix: config?.disableHostPrefix ?? false,
        endpointProvider: config?.endpointProvider ?? (0, $c9b6df5b8d32e521$export$47fc6e98c86e06e3),
        extensions: config?.extensions ?? [],
        httpAuthSchemeProvider: config?.httpAuthSchemeProvider ?? (0, $9a5a2b2d9ad00d22$export$739ba9ca5f6ec443),
        httpAuthSchemes: config?.httpAuthSchemes ?? [
            {
                schemeId: "aws.auth#sigv4",
                identityProvider: (ipc)=>ipc.getIdentityProvider("aws.auth#sigv4"),
                signer: new (0, $59IvS.AwsSdkSigV4Signer)()
            }
        ],
        logger: config?.logger ?? new (0, $4RSUY.NoOpLogger)(),
        serviceId: config?.serviceId ?? "Location",
        urlParser: config?.urlParser ?? (0, $kOVEw.parseUrl),
        utf8Decoder: config?.utf8Decoder ?? (0, $3tKur.fromUtf8),
        utf8Encoder: config?.utf8Encoder ?? (0, $hpab6.toUtf8)
    };
};


parcelRequire("33pc1");
var $bOftX = parcelRequire("bOftX");
parcelRequire("cZNaw");
var $9hPVM = parcelRequire("9hPVM");
const $fb2f0875424db261$export$ad0966540b0e71e5 = (config)=>{
    const defaultsMode = (0, $9hPVM.resolveDefaultsModeConfig)(config);
    const defaultConfigProvider = ()=>defaultsMode().then((0, $bOftX.loadConfigsForDefaultMode));
    const clientSharedValues = (0, $7c985012fca81a90$export$ad0966540b0e71e5)(config);
    return {
        ...clientSharedValues,
        ...config,
        runtime: "browser",
        defaultsMode: defaultsMode,
        bodyLengthChecker: config?.bodyLengthChecker ?? (0, $9v2WL.calculateBodyLength),
        credentialDefaultProvider: config?.credentialDefaultProvider ?? ((_)=>()=>Promise.reject(new Error("Credential is missing"))),
        defaultUserAgentProvider: config?.defaultUserAgentProvider ?? (0, $dPlLR.defaultUserAgent)({
            serviceId: clientSharedValues.serviceId,
            clientVersion: (0, (/*@__PURE__*/$parcel$interopDefault($653586e68908c912$exports))).version
        }),
        maxAttempts: config?.maxAttempts ?? (0, $blSB9.DEFAULT_MAX_ATTEMPTS),
        region: config?.region ?? (0, $1j16v.invalidProvider)("Region is missing"),
        requestHandler: (0, $gMAof.FetchHttpHandler).create(config?.requestHandler ?? defaultConfigProvider),
        retryMode: config?.retryMode ?? (async ()=>(await defaultConfigProvider()).retryMode || (0, $blSB9.DEFAULT_RETRY_MODE)),
        sha256: config?.sha256 ?? (0, $kq0db.Sha256),
        streamCollector: config?.streamCollector ?? (0, $ahmip.streamCollector),
        useDualstackEndpoint: config?.useDualstackEndpoint ?? (()=>Promise.resolve((0, $1gTFA.DEFAULT_USE_DUALSTACK_ENDPOINT))),
        useFipsEndpoint: config?.useFipsEndpoint ?? (()=>Promise.resolve((0, $4GfQZ.DEFAULT_USE_FIPS_ENDPOINT)))
    };
};


parcelRequire("dkoxR");
var $8jFmv = parcelRequire("8jFmv");
parcelRequire("AueTL");
var $9muob = parcelRequire("9muob");
parcelRequire("33pc1");
var $5Px3r = parcelRequire("5Px3r");
const $61fb38c4a4610326$export$e536d87ced0d9700 = (runtimeConfig)=>{
    const _httpAuthSchemes = runtimeConfig.httpAuthSchemes;
    let _httpAuthSchemeProvider = runtimeConfig.httpAuthSchemeProvider;
    let _credentials = runtimeConfig.credentials;
    return {
        setHttpAuthScheme (httpAuthScheme) {
            const index = _httpAuthSchemes.findIndex((scheme)=>scheme.schemeId === httpAuthScheme.schemeId);
            if (index === -1) _httpAuthSchemes.push(httpAuthScheme);
            else _httpAuthSchemes.splice(index, 1, httpAuthScheme);
        },
        httpAuthSchemes () {
            return _httpAuthSchemes;
        },
        setHttpAuthSchemeProvider (httpAuthSchemeProvider) {
            _httpAuthSchemeProvider = httpAuthSchemeProvider;
        },
        httpAuthSchemeProvider () {
            return _httpAuthSchemeProvider;
        },
        setCredentials (credentials) {
            _credentials = credentials;
        },
        credentials () {
            return _credentials;
        }
    };
};
const $61fb38c4a4610326$export$60c55f59b27530a8 = (config)=>{
    return {
        httpAuthSchemes: config.httpAuthSchemes(),
        httpAuthSchemeProvider: config.httpAuthSchemeProvider(),
        credentials: config.credentials()
    };
};


const $41b2b8b6a619f7a1$var$asPartial = (t)=>t;
const $41b2b8b6a619f7a1$export$4278118b303a14cf = (runtimeConfig, extensions)=>{
    const extensionConfiguration = {
        ...$41b2b8b6a619f7a1$var$asPartial((0, $8jFmv.getAwsRegionExtensionConfiguration)(runtimeConfig)),
        ...$41b2b8b6a619f7a1$var$asPartial((0, $5Px3r.getDefaultExtensionConfiguration)(runtimeConfig)),
        ...$41b2b8b6a619f7a1$var$asPartial((0, $9muob.getHttpHandlerExtensionConfiguration)(runtimeConfig)),
        ...$41b2b8b6a619f7a1$var$asPartial((0, $61fb38c4a4610326$export$e536d87ced0d9700)(runtimeConfig))
    };
    extensions.forEach((extension)=>extension.configure(extensionConfiguration));
    return {
        ...runtimeConfig,
        ...(0, $8jFmv.resolveAwsRegionExtensionConfiguration)(extensionConfiguration),
        ...(0, $5Px3r.resolveDefaultRuntimeConfig)(extensionConfiguration),
        ...(0, $9muob.resolveHttpHandlerRuntimeConfig)(extensionConfiguration),
        ...(0, $61fb38c4a4610326$export$60c55f59b27530a8)(extensionConfiguration)
    };
};


class $7a3a51b2a31a837b$export$ccc9b854597617bd extends (0, $cr1Pw.Client) {
    constructor(...[configuration]){
        const _config_0 = (0, $fb2f0875424db261$export$ad0966540b0e71e5)(configuration || {});
        const _config_1 = (0, $5d5872ec2e5681cc$export$70b6341cd51750a8)(_config_0);
        const _config_2 = (0, $4aYuz.resolveRegionConfig)(_config_1);
        const _config_3 = (0, $7vygy.resolveEndpointConfig)(_config_2);
        const _config_4 = (0, $66f0Z.resolveRetryConfig)(_config_3);
        const _config_5 = (0, $kJcVt.resolveHostHeaderConfig)(_config_4);
        const _config_6 = (0, $jr2rX.resolveUserAgentConfig)(_config_5);
        const _config_7 = (0, $9a5a2b2d9ad00d22$export$d38ef9c0c6c649ab)(_config_6);
        const _config_8 = (0, $41b2b8b6a619f7a1$export$4278118b303a14cf)(_config_7, configuration?.extensions || []);
        super(_config_8);
        this.config = _config_8;
        this.middlewareStack.use((0, $6Httz.getRetryPlugin)(this.config));
        this.middlewareStack.use((0, $e8QI9.getContentLengthPlugin)(this.config));
        this.middlewareStack.use((0, $kJcVt.getHostHeaderPlugin)(this.config));
        this.middlewareStack.use((0, $cZu4U.getLoggerPlugin)(this.config));
        this.middlewareStack.use((0, $K0nIp.getRecursionDetectionPlugin)(this.config));
        this.middlewareStack.use((0, $dx4el.getUserAgentPlugin)(this.config));
        this.middlewareStack.use((0, $eGqnu.getHttpAuthSchemeEndpointRuleSetPlugin)(this.config, {
            httpAuthSchemeParametersProvider: this.getDefaultHttpAuthSchemeParametersProvider(),
            identityProviderConfigProvider: this.getIdentityProviderConfigProvider()
        }));
        this.middlewareStack.use((0, $hshmJ.getHttpSigningPlugin)(this.config));
    }
    destroy() {
        super.destroy();
    }
    getDefaultHttpAuthSchemeParametersProvider() {
        return 0, $9a5a2b2d9ad00d22$export$257fec7c5679bec2;
    }
    getIdentityProviderConfigProvider() {
        return async (config)=>new (0, $9iah1.DefaultIdentityProviderConfig)({
                "aws.auth#sigv4": config.credentials
            });
    }
}

parcelRequire("f1nrT");
var $iHLqk = parcelRequire("iHLqk");
parcelRequire("bXwma");
var $KxEGr = parcelRequire("KxEGr");
parcelRequire("33pc1");
var $hMwCU = parcelRequire("hMwCU");

parcelRequire("33pc1");
var $4HRM9 = parcelRequire("4HRM9");
parcelRequire("33pc1");
var $1CRbD = parcelRequire("1CRbD");
class $e39b019f324fbd4d$export$ac9195663c1b5e3a extends (0, $1CRbD.ServiceException) {
    constructor(options){
        super(options);
        Object.setPrototypeOf(this, $e39b019f324fbd4d$export$ac9195663c1b5e3a.prototype);
    }
}


class $454857ac2a87e2c9$export$c8018838fe3c6395 extends (0, $e39b019f324fbd4d$export$ac9195663c1b5e3a) {
    constructor(opts){
        super({
            name: "AccessDeniedException",
            $fault: "client",
            ...opts
        });
        this.name = "AccessDeniedException";
        this.$fault = "client";
        Object.setPrototypeOf(this, $454857ac2a87e2c9$export$c8018838fe3c6395.prototype);
        this.Message = opts.Message;
    }
}
class $454857ac2a87e2c9$export$c64b14d0b7091188 extends (0, $e39b019f324fbd4d$export$ac9195663c1b5e3a) {
    constructor(opts){
        super({
            name: "ConflictException",
            $fault: "client",
            ...opts
        });
        this.name = "ConflictException";
        this.$fault = "client";
        Object.setPrototypeOf(this, $454857ac2a87e2c9$export$c64b14d0b7091188.prototype);
        this.Message = opts.Message;
    }
}
class $454857ac2a87e2c9$export$e2a300c9568821ec extends (0, $e39b019f324fbd4d$export$ac9195663c1b5e3a) {
    constructor(opts){
        super({
            name: "InternalServerException",
            $fault: "server",
            ...opts
        });
        this.name = "InternalServerException";
        this.$fault = "server";
        this.$retryable = {};
        Object.setPrototypeOf(this, $454857ac2a87e2c9$export$e2a300c9568821ec.prototype);
        this.Message = opts.Message;
    }
}
class $454857ac2a87e2c9$export$1b9058cd2021c1aa extends (0, $e39b019f324fbd4d$export$ac9195663c1b5e3a) {
    constructor(opts){
        super({
            name: "ServiceQuotaExceededException",
            $fault: "client",
            ...opts
        });
        this.name = "ServiceQuotaExceededException";
        this.$fault = "client";
        Object.setPrototypeOf(this, $454857ac2a87e2c9$export$1b9058cd2021c1aa.prototype);
        this.Message = opts.Message;
    }
}
class $454857ac2a87e2c9$export$f18ab84fe430e4f3 extends (0, $e39b019f324fbd4d$export$ac9195663c1b5e3a) {
    constructor(opts){
        super({
            name: "ThrottlingException",
            $fault: "client",
            ...opts
        });
        this.name = "ThrottlingException";
        this.$fault = "client";
        this.$retryable = {};
        Object.setPrototypeOf(this, $454857ac2a87e2c9$export$f18ab84fe430e4f3.prototype);
        this.Message = opts.Message;
    }
}
class $454857ac2a87e2c9$export$1dbb1718e06c41be extends (0, $e39b019f324fbd4d$export$ac9195663c1b5e3a) {
    constructor(opts){
        super({
            name: "ValidationException",
            $fault: "client",
            ...opts
        });
        this.name = "ValidationException";
        this.$fault = "client";
        Object.setPrototypeOf(this, $454857ac2a87e2c9$export$1dbb1718e06c41be.prototype);
        this.Message = opts.Message;
        this.Reason = opts.Reason;
        this.FieldList = opts.FieldList;
    }
}
class $454857ac2a87e2c9$export$ecba565262f8bb2 extends (0, $e39b019f324fbd4d$export$ac9195663c1b5e3a) {
    constructor(opts){
        super({
            name: "ResourceNotFoundException",
            $fault: "client",
            ...opts
        });
        this.name = "ResourceNotFoundException";
        this.$fault = "client";
        Object.setPrototypeOf(this, $454857ac2a87e2c9$export$ecba565262f8bb2.prototype);
        this.Message = opts.Message;
    }
}
const $454857ac2a87e2c9$export$a66ec207b26f0f24 = (obj)=>({
        ...obj,
        ...obj.Key && {
            Key: (0, $4HRM9.SENSITIVE_STRING)
        }
    });
const $454857ac2a87e2c9$export$2bd2c560bda617dc = (obj)=>({
        ...obj,
        ...obj.Key && {
            Key: (0, $4HRM9.SENSITIVE_STRING)
        }
    });
const $454857ac2a87e2c9$export$a405d81e768440c4 = (obj)=>({
        ...obj,
        ...obj.Position && {
            Position: (0, $4HRM9.SENSITIVE_STRING)
        },
        ...obj.PositionProperties && {
            PositionProperties: (0, $4HRM9.SENSITIVE_STRING)
        }
    });
const $454857ac2a87e2c9$export$e1e905775fd8d6a1 = (obj)=>({
        ...obj,
        ...obj.DevicePositionUpdates && {
            DevicePositionUpdates: obj.DevicePositionUpdates.map((item)=>$454857ac2a87e2c9$export$a405d81e768440c4(item))
        }
    });
const $454857ac2a87e2c9$export$13129e01068f1363 = (obj)=>({
        ...obj,
        ...obj.Position && {
            Position: (0, $4HRM9.SENSITIVE_STRING)
        },
        ...obj.PositionProperties && {
            PositionProperties: (0, $4HRM9.SENSITIVE_STRING)
        }
    });
const $454857ac2a87e2c9$export$721f0494b119aeaf = (obj)=>({
        ...obj,
        ...obj.DevicePositions && {
            DevicePositions: obj.DevicePositions.map((item)=>$454857ac2a87e2c9$export$13129e01068f1363(item))
        }
    });
const $454857ac2a87e2c9$export$620c35e57b7d8fb3 = (obj)=>({
        ...obj,
        ...obj.Center && {
            Center: (0, $4HRM9.SENSITIVE_STRING)
        }
    });
const $454857ac2a87e2c9$export$52040853eb1a4021 = (obj)=>({
        ...obj,
        ...obj.Polygon && {
            Polygon: obj.Polygon.map((item)=>(0, $4HRM9.SENSITIVE_STRING))
        },
        ...obj.Circle && {
            Circle: (0, $4HRM9.SENSITIVE_STRING)
        }
    });
const $454857ac2a87e2c9$export$8a40b3fdcd10840f = (obj)=>({
        ...obj,
        ...obj.Geometry && {
            Geometry: $454857ac2a87e2c9$export$52040853eb1a4021(obj.Geometry)
        },
        ...obj.GeofenceProperties && {
            GeofenceProperties: (0, $4HRM9.SENSITIVE_STRING)
        }
    });
const $454857ac2a87e2c9$export$6ba3072fdf11c80e = (obj)=>({
        ...obj,
        ...obj.Entries && {
            Entries: obj.Entries.map((item)=>$454857ac2a87e2c9$export$8a40b3fdcd10840f(item))
        }
    });
const $454857ac2a87e2c9$export$c99af6de58df9120 = (obj)=>({
        ...obj,
        ...obj.Updates && {
            Updates: obj.Updates.map((item)=>$454857ac2a87e2c9$export$a405d81e768440c4(item))
        }
    });
const $454857ac2a87e2c9$export$130cdeff69c41e9 = (obj)=>({
        ...obj,
        ...obj.DeparturePosition && {
            DeparturePosition: (0, $4HRM9.SENSITIVE_STRING)
        },
        ...obj.DestinationPosition && {
            DestinationPosition: (0, $4HRM9.SENSITIVE_STRING)
        },
        ...obj.WaypointPositions && {
            WaypointPositions: (0, $4HRM9.SENSITIVE_STRING)
        },
        ...obj.Key && {
            Key: (0, $4HRM9.SENSITIVE_STRING)
        }
    });
const $454857ac2a87e2c9$export$fe03657ddf65c249 = (obj)=>({
        ...obj,
        ...obj.LineString && {
            LineString: (0, $4HRM9.SENSITIVE_STRING)
        }
    });
const $454857ac2a87e2c9$export$78e7d87e75f95e61 = (obj)=>({
        ...obj,
        ...obj.StartPosition && {
            StartPosition: (0, $4HRM9.SENSITIVE_STRING)
        },
        ...obj.EndPosition && {
            EndPosition: (0, $4HRM9.SENSITIVE_STRING)
        }
    });
const $454857ac2a87e2c9$export$62339df2f9d5956f = (obj)=>({
        ...obj,
        ...obj.StartPosition && {
            StartPosition: (0, $4HRM9.SENSITIVE_STRING)
        },
        ...obj.EndPosition && {
            EndPosition: (0, $4HRM9.SENSITIVE_STRING)
        },
        ...obj.Geometry && {
            Geometry: $454857ac2a87e2c9$export$fe03657ddf65c249(obj.Geometry)
        },
        ...obj.Steps && {
            Steps: obj.Steps.map((item)=>$454857ac2a87e2c9$export$78e7d87e75f95e61(item))
        }
    });
const $454857ac2a87e2c9$export$1602ac6991673bd1 = (obj)=>({
        ...obj,
        ...obj.RouteBBox && {
            RouteBBox: (0, $4HRM9.SENSITIVE_STRING)
        }
    });
const $454857ac2a87e2c9$export$1245c6552791fce9 = (obj)=>({
        ...obj,
        ...obj.Legs && {
            Legs: obj.Legs.map((item)=>$454857ac2a87e2c9$export$62339df2f9d5956f(item))
        },
        ...obj.Summary && {
            Summary: $454857ac2a87e2c9$export$1602ac6991673bd1(obj.Summary)
        }
    });
const $454857ac2a87e2c9$export$8e7013c2f0d3222e = (obj)=>({
        ...obj,
        ...obj.DeparturePositions && {
            DeparturePositions: (0, $4HRM9.SENSITIVE_STRING)
        },
        ...obj.DestinationPositions && {
            DestinationPositions: (0, $4HRM9.SENSITIVE_STRING)
        },
        ...obj.Key && {
            Key: (0, $4HRM9.SENSITIVE_STRING)
        }
    });
const $454857ac2a87e2c9$export$9987a87b5ae7011 = (obj)=>({
        ...obj,
        ...obj.SnappedDeparturePositions && {
            SnappedDeparturePositions: (0, $4HRM9.SENSITIVE_STRING)
        },
        ...obj.SnappedDestinationPositions && {
            SnappedDestinationPositions: (0, $4HRM9.SENSITIVE_STRING)
        }
    });
const $454857ac2a87e2c9$export$71dd1e98d6d56374 = (obj)=>({
        ...obj,
        ...obj.Geometry && {
            Geometry: $454857ac2a87e2c9$export$52040853eb1a4021(obj.Geometry)
        },
        ...obj.GeofenceProperties && {
            GeofenceProperties: (0, $4HRM9.SENSITIVE_STRING)
        }
    });
const $454857ac2a87e2c9$export$8365fa408111c4ae = (obj)=>({
        ...obj,
        ...obj.Geometry && {
            Geometry: $454857ac2a87e2c9$export$52040853eb1a4021(obj.Geometry)
        },
        ...obj.GeofenceProperties && {
            GeofenceProperties: (0, $4HRM9.SENSITIVE_STRING)
        }
    });
const $454857ac2a87e2c9$export$7877d75536adcfd9 = (obj)=>({
        ...obj,
        ...obj.Entries && {
            Entries: obj.Entries.map((item)=>$454857ac2a87e2c9$export$8365fa408111c4ae(item))
        }
    });
const $454857ac2a87e2c9$export$1b12aaec3ea9da8a = (obj)=>({
        ...obj,
        ...obj.Geometry && {
            Geometry: $454857ac2a87e2c9$export$52040853eb1a4021(obj.Geometry)
        },
        ...obj.GeofenceProperties && {
            GeofenceProperties: (0, $4HRM9.SENSITIVE_STRING)
        }
    });
const $454857ac2a87e2c9$export$831d67ee71b9e3f0 = (obj)=>({
        ...obj,
        ...obj.Position && {
            Position: (0, $4HRM9.SENSITIVE_STRING)
        },
        ...obj.PositionProperties && {
            PositionProperties: (0, $4HRM9.SENSITIVE_STRING)
        }
    });
const $454857ac2a87e2c9$export$16c4c0c358435d76 = (obj)=>({
        ...obj,
        ...obj.DevicePositions && {
            DevicePositions: obj.DevicePositions.map((item)=>$454857ac2a87e2c9$export$13129e01068f1363(item))
        }
    });
const $454857ac2a87e2c9$export$b74beaba3e39751 = (obj)=>({
        ...obj,
        ...obj.Key && {
            Key: (0, $4HRM9.SENSITIVE_STRING)
        }
    });
const $454857ac2a87e2c9$export$4a5293d9a23a5d1a = (obj)=>({
        ...obj,
        ...obj.Key && {
            Key: (0, $4HRM9.SENSITIVE_STRING)
        }
    });
const $454857ac2a87e2c9$export$5f58775249a90e8a = (obj)=>({
        ...obj,
        ...obj.Key && {
            Key: (0, $4HRM9.SENSITIVE_STRING)
        }
    });
const $454857ac2a87e2c9$export$cc4f7afc9b95a899 = (obj)=>({
        ...obj,
        ...obj.Key && {
            Key: (0, $4HRM9.SENSITIVE_STRING)
        }
    });
const $454857ac2a87e2c9$export$f3445d91697f050f = (obj)=>({
        ...obj,
        ...obj.Key && {
            Key: (0, $4HRM9.SENSITIVE_STRING)
        }
    });
const $454857ac2a87e2c9$export$78229b216d327a3f = (obj)=>({
        ...obj,
        ...obj.Point && {
            Point: (0, $4HRM9.SENSITIVE_STRING)
        }
    });
const $454857ac2a87e2c9$export$dff981487b875a2c = (obj)=>({
        ...obj,
        ...obj.Geometry && {
            Geometry: $454857ac2a87e2c9$export$78229b216d327a3f(obj.Geometry)
        }
    });
const $454857ac2a87e2c9$export$2dfe379372eec15f = (obj)=>({
        ...obj,
        ...obj.Place && {
            Place: $454857ac2a87e2c9$export$dff981487b875a2c(obj.Place)
        }
    });
const $454857ac2a87e2c9$export$f75ed0cf0c388c91 = (obj)=>({
        ...obj,
        ...obj.Polygon && {
            Polygon: obj.Polygon.map((item)=>(0, $4HRM9.SENSITIVE_STRING))
        }
    });
const $454857ac2a87e2c9$export$3b9c88ad5b508f59 = (obj)=>({
        ...obj,
        ...obj.FilterGeometry && {
            FilterGeometry: $454857ac2a87e2c9$export$f75ed0cf0c388c91(obj.FilterGeometry)
        }
    });
const $454857ac2a87e2c9$export$75d283db817c22df = (obj)=>({
        ...obj,
        ...obj.Position && {
            Position: (0, $4HRM9.SENSITIVE_STRING)
        },
        ...obj.PositionProperties && {
            PositionProperties: (0, $4HRM9.SENSITIVE_STRING)
        }
    });
const $454857ac2a87e2c9$export$a8da7868ffe0e854 = (obj)=>({
        ...obj,
        ...obj.Entries && {
            Entries: obj.Entries.map((item)=>$454857ac2a87e2c9$export$75d283db817c22df(item))
        }
    });
const $454857ac2a87e2c9$export$ff564e171fa64eb5 = (obj)=>({
        ...obj,
        ...obj.Position && {
            Position: (0, $4HRM9.SENSITIVE_STRING)
        },
        ...obj.Key && {
            Key: (0, $4HRM9.SENSITIVE_STRING)
        }
    });
const $454857ac2a87e2c9$export$95aa42669ec92b75 = (obj)=>({
        ...obj,
        ...obj.Place && {
            Place: $454857ac2a87e2c9$export$dff981487b875a2c(obj.Place)
        }
    });
const $454857ac2a87e2c9$export$1e67af07a803bc63 = (obj)=>({
        ...obj,
        ...obj.Position && {
            Position: (0, $4HRM9.SENSITIVE_STRING)
        }
    });
const $454857ac2a87e2c9$export$ec5957f8987a2cb3 = (obj)=>({
        ...obj,
        ...obj.Summary && {
            Summary: $454857ac2a87e2c9$export$1e67af07a803bc63(obj.Summary)
        },
        ...obj.Results && {
            Results: obj.Results.map((item)=>$454857ac2a87e2c9$export$95aa42669ec92b75(item))
        }
    });
const $454857ac2a87e2c9$export$4a0202f92baaf36d = (obj)=>({
        ...obj,
        ...obj.Text && {
            Text: (0, $4HRM9.SENSITIVE_STRING)
        },
        ...obj.BiasPosition && {
            BiasPosition: (0, $4HRM9.SENSITIVE_STRING)
        },
        ...obj.FilterBBox && {
            FilterBBox: (0, $4HRM9.SENSITIVE_STRING)
        },
        ...obj.Key && {
            Key: (0, $4HRM9.SENSITIVE_STRING)
        }
    });
const $454857ac2a87e2c9$export$16d6bb5b3dfc5cdd = (obj)=>({
        ...obj,
        ...obj.Text && {
            Text: (0, $4HRM9.SENSITIVE_STRING)
        },
        ...obj.BiasPosition && {
            BiasPosition: (0, $4HRM9.SENSITIVE_STRING)
        },
        ...obj.FilterBBox && {
            FilterBBox: (0, $4HRM9.SENSITIVE_STRING)
        }
    });
const $454857ac2a87e2c9$export$d05312e64773f4f8 = (obj)=>({
        ...obj,
        ...obj.Summary && {
            Summary: $454857ac2a87e2c9$export$16d6bb5b3dfc5cdd(obj.Summary)
        }
    });
const $454857ac2a87e2c9$export$6e5b05119858cdde = (obj)=>({
        ...obj,
        ...obj.Text && {
            Text: (0, $4HRM9.SENSITIVE_STRING)
        },
        ...obj.BiasPosition && {
            BiasPosition: (0, $4HRM9.SENSITIVE_STRING)
        },
        ...obj.FilterBBox && {
            FilterBBox: (0, $4HRM9.SENSITIVE_STRING)
        },
        ...obj.Key && {
            Key: (0, $4HRM9.SENSITIVE_STRING)
        }
    });
const $454857ac2a87e2c9$export$c6fc57fedde7f258 = (obj)=>({
        ...obj,
        ...obj.Place && {
            Place: $454857ac2a87e2c9$export$dff981487b875a2c(obj.Place)
        }
    });
const $454857ac2a87e2c9$export$d98cf48389bc2093 = (obj)=>({
        ...obj,
        ...obj.Text && {
            Text: (0, $4HRM9.SENSITIVE_STRING)
        },
        ...obj.BiasPosition && {
            BiasPosition: (0, $4HRM9.SENSITIVE_STRING)
        },
        ...obj.FilterBBox && {
            FilterBBox: (0, $4HRM9.SENSITIVE_STRING)
        },
        ...obj.ResultBBox && {
            ResultBBox: (0, $4HRM9.SENSITIVE_STRING)
        }
    });
const $454857ac2a87e2c9$export$c43e9b03ff6fcfbb = (obj)=>({
        ...obj,
        ...obj.Summary && {
            Summary: $454857ac2a87e2c9$export$d98cf48389bc2093(obj.Summary)
        },
        ...obj.Results && {
            Results: obj.Results.map((item)=>$454857ac2a87e2c9$export$c6fc57fedde7f258(item))
        }
    });



var $3Z3zT = parcelRequire("3Z3zT");
parcelRequire("21756");
var $ld8GT = parcelRequire("ld8GT");
parcelRequire("AueTL");
var $jD1Fl = parcelRequire("jD1Fl");
parcelRequire("33pc1");
var $Phm09 = parcelRequire("Phm09");
var $7fiNM = parcelRequire("7fiNM");
var $1CRbD = parcelRequire("1CRbD");
var $cXA1B = parcelRequire("cXA1B");
var $eJMW4 = parcelRequire("eJMW4");
var $d8z3h = parcelRequire("d8z3h");
var $iAvye = parcelRequire("iAvye");
var $cYbAK = parcelRequire("cYbAK");


const $0a8265f77a3f5d43$export$ff24c4dd7386603c = async (input, context)=>{
    const b = (0, $ld8GT.requestBuilder)(input, context);
    const headers = {
        "content-type": "application/json"
    };
    b.bp("/tracking/v0/trackers/{TrackerName}/consumers");
    b.p("TrackerName", ()=>input.TrackerName, "{TrackerName}", false);
    let body;
    body = JSON.stringify((0, $eJMW4.take)(input, {
        ConsumerArn: []
    }));
    let { hostname: resolvedHostname } = await context.endpoint();
    if (context.disableHostPrefix !== true) {
        resolvedHostname = "cp.tracking." + resolvedHostname;
        if (!(0, $jD1Fl.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
    }
    b.hn(resolvedHostname);
    b.m("POST").h(headers).b(body);
    return b.build();
};
const $0a8265f77a3f5d43$export$744716336cb4d394 = async (input, context)=>{
    const b = (0, $ld8GT.requestBuilder)(input, context);
    const headers = {
        "content-type": "application/json"
    };
    b.bp("/tracking/v0/trackers/{TrackerName}/delete-positions");
    b.p("TrackerName", ()=>input.TrackerName, "{TrackerName}", false);
    let body;
    body = JSON.stringify((0, $eJMW4.take)(input, {
        DeviceIds: (_)=>(0, $Phm09._json)(_)
    }));
    let { hostname: resolvedHostname } = await context.endpoint();
    if (context.disableHostPrefix !== true) {
        resolvedHostname = "tracking." + resolvedHostname;
        if (!(0, $jD1Fl.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
    }
    b.hn(resolvedHostname);
    b.m("POST").h(headers).b(body);
    return b.build();
};
const $0a8265f77a3f5d43$export$120567247e04a7c = async (input, context)=>{
    const b = (0, $ld8GT.requestBuilder)(input, context);
    const headers = {
        "content-type": "application/json"
    };
    b.bp("/geofencing/v0/collections/{CollectionName}/delete-geofences");
    b.p("CollectionName", ()=>input.CollectionName, "{CollectionName}", false);
    let body;
    body = JSON.stringify((0, $eJMW4.take)(input, {
        GeofenceIds: (_)=>(0, $Phm09._json)(_)
    }));
    let { hostname: resolvedHostname } = await context.endpoint();
    if (context.disableHostPrefix !== true) {
        resolvedHostname = "geofencing." + resolvedHostname;
        if (!(0, $jD1Fl.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
    }
    b.hn(resolvedHostname);
    b.m("POST").h(headers).b(body);
    return b.build();
};
const $0a8265f77a3f5d43$export$73a4c5b9b44cf163 = async (input, context)=>{
    const b = (0, $ld8GT.requestBuilder)(input, context);
    const headers = {
        "content-type": "application/json"
    };
    b.bp("/geofencing/v0/collections/{CollectionName}/positions");
    b.p("CollectionName", ()=>input.CollectionName, "{CollectionName}", false);
    let body;
    body = JSON.stringify((0, $eJMW4.take)(input, {
        DevicePositionUpdates: (_)=>$0a8265f77a3f5d43$var$se_DevicePositionUpdateList(_, context)
    }));
    let { hostname: resolvedHostname } = await context.endpoint();
    if (context.disableHostPrefix !== true) {
        resolvedHostname = "geofencing." + resolvedHostname;
        if (!(0, $jD1Fl.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
    }
    b.hn(resolvedHostname);
    b.m("POST").h(headers).b(body);
    return b.build();
};
const $0a8265f77a3f5d43$export$7ad4ecb8f87eb502 = async (input, context)=>{
    const b = (0, $ld8GT.requestBuilder)(input, context);
    const headers = {
        "content-type": "application/json"
    };
    b.bp("/tracking/v0/trackers/{TrackerName}/get-positions");
    b.p("TrackerName", ()=>input.TrackerName, "{TrackerName}", false);
    let body;
    body = JSON.stringify((0, $eJMW4.take)(input, {
        DeviceIds: (_)=>(0, $Phm09._json)(_)
    }));
    let { hostname: resolvedHostname } = await context.endpoint();
    if (context.disableHostPrefix !== true) {
        resolvedHostname = "tracking." + resolvedHostname;
        if (!(0, $jD1Fl.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
    }
    b.hn(resolvedHostname);
    b.m("POST").h(headers).b(body);
    return b.build();
};
const $0a8265f77a3f5d43$export$8796b56b2c2a26e1 = async (input, context)=>{
    const b = (0, $ld8GT.requestBuilder)(input, context);
    const headers = {
        "content-type": "application/json"
    };
    b.bp("/geofencing/v0/collections/{CollectionName}/put-geofences");
    b.p("CollectionName", ()=>input.CollectionName, "{CollectionName}", false);
    let body;
    body = JSON.stringify((0, $eJMW4.take)(input, {
        Entries: (_)=>$0a8265f77a3f5d43$var$se_BatchPutGeofenceRequestEntryList(_, context)
    }));
    let { hostname: resolvedHostname } = await context.endpoint();
    if (context.disableHostPrefix !== true) {
        resolvedHostname = "geofencing." + resolvedHostname;
        if (!(0, $jD1Fl.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
    }
    b.hn(resolvedHostname);
    b.m("POST").h(headers).b(body);
    return b.build();
};
const $0a8265f77a3f5d43$export$baf1988620154f7 = async (input, context)=>{
    const b = (0, $ld8GT.requestBuilder)(input, context);
    const headers = {
        "content-type": "application/json"
    };
    b.bp("/tracking/v0/trackers/{TrackerName}/positions");
    b.p("TrackerName", ()=>input.TrackerName, "{TrackerName}", false);
    let body;
    body = JSON.stringify((0, $eJMW4.take)(input, {
        Updates: (_)=>$0a8265f77a3f5d43$var$se_DevicePositionUpdateList(_, context)
    }));
    let { hostname: resolvedHostname } = await context.endpoint();
    if (context.disableHostPrefix !== true) {
        resolvedHostname = "tracking." + resolvedHostname;
        if (!(0, $jD1Fl.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
    }
    b.hn(resolvedHostname);
    b.m("POST").h(headers).b(body);
    return b.build();
};
const $0a8265f77a3f5d43$export$51228b644daad55d = async (input, context)=>{
    const b = (0, $ld8GT.requestBuilder)(input, context);
    const headers = {
        "content-type": "application/json"
    };
    b.bp("/routes/v0/calculators/{CalculatorName}/calculate/route");
    b.p("CalculatorName", ()=>input.CalculatorName, "{CalculatorName}", false);
    const query = (0, $eJMW4.map)({
        [$0a8265f77a3f5d43$var$_k]: [
            ,
            input[$0a8265f77a3f5d43$var$_K]
        ]
    });
    let body;
    body = JSON.stringify((0, $eJMW4.take)(input, {
        ArrivalTime: (_)=>_.toISOString().split(".")[0] + "Z",
        CarModeOptions: (_)=>(0, $Phm09._json)(_),
        DepartNow: [],
        DeparturePosition: (_)=>$0a8265f77a3f5d43$var$se_Position(_, context),
        DepartureTime: (_)=>_.toISOString().split(".")[0] + "Z",
        DestinationPosition: (_)=>$0a8265f77a3f5d43$var$se_Position(_, context),
        DistanceUnit: [],
        IncludeLegGeometry: [],
        OptimizeFor: [],
        TravelMode: [],
        TruckModeOptions: (_)=>$0a8265f77a3f5d43$var$se_CalculateRouteTruckModeOptions(_, context),
        WaypointPositions: (_)=>$0a8265f77a3f5d43$var$se_WaypointPositionList(_, context)
    }));
    let { hostname: resolvedHostname } = await context.endpoint();
    if (context.disableHostPrefix !== true) {
        resolvedHostname = "routes." + resolvedHostname;
        if (!(0, $jD1Fl.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
    }
    b.hn(resolvedHostname);
    b.m("POST").h(headers).q(query).b(body);
    return b.build();
};
const $0a8265f77a3f5d43$export$1e87ef1e313beaf7 = async (input, context)=>{
    const b = (0, $ld8GT.requestBuilder)(input, context);
    const headers = {
        "content-type": "application/json"
    };
    b.bp("/routes/v0/calculators/{CalculatorName}/calculate/route-matrix");
    b.p("CalculatorName", ()=>input.CalculatorName, "{CalculatorName}", false);
    const query = (0, $eJMW4.map)({
        [$0a8265f77a3f5d43$var$_k]: [
            ,
            input[$0a8265f77a3f5d43$var$_K]
        ]
    });
    let body;
    body = JSON.stringify((0, $eJMW4.take)(input, {
        CarModeOptions: (_)=>(0, $Phm09._json)(_),
        DepartNow: [],
        DeparturePositions: (_)=>$0a8265f77a3f5d43$var$se_PositionList(_, context),
        DepartureTime: (_)=>_.toISOString().split(".")[0] + "Z",
        DestinationPositions: (_)=>$0a8265f77a3f5d43$var$se_PositionList(_, context),
        DistanceUnit: [],
        TravelMode: [],
        TruckModeOptions: (_)=>$0a8265f77a3f5d43$var$se_CalculateRouteTruckModeOptions(_, context)
    }));
    let { hostname: resolvedHostname } = await context.endpoint();
    if (context.disableHostPrefix !== true) {
        resolvedHostname = "routes." + resolvedHostname;
        if (!(0, $jD1Fl.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
    }
    b.hn(resolvedHostname);
    b.m("POST").h(headers).q(query).b(body);
    return b.build();
};
const $0a8265f77a3f5d43$export$9b0e92bed353d0d0 = async (input, context)=>{
    const b = (0, $ld8GT.requestBuilder)(input, context);
    const headers = {
        "content-type": "application/json"
    };
    b.bp("/geofencing/v0/collections");
    let body;
    body = JSON.stringify((0, $eJMW4.take)(input, {
        CollectionName: [],
        Description: [],
        KmsKeyId: [],
        PricingPlan: [],
        PricingPlanDataSource: [],
        Tags: (_)=>(0, $Phm09._json)(_)
    }));
    let { hostname: resolvedHostname } = await context.endpoint();
    if (context.disableHostPrefix !== true) {
        resolvedHostname = "cp.geofencing." + resolvedHostname;
        if (!(0, $jD1Fl.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
    }
    b.hn(resolvedHostname);
    b.m("POST").h(headers).b(body);
    return b.build();
};
const $0a8265f77a3f5d43$export$1679395547c40c98 = async (input, context)=>{
    const b = (0, $ld8GT.requestBuilder)(input, context);
    const headers = {
        "content-type": "application/json"
    };
    b.bp("/metadata/v0/keys");
    let body;
    body = JSON.stringify((0, $eJMW4.take)(input, {
        Description: [],
        ExpireTime: (_)=>_.toISOString().split(".")[0] + "Z",
        KeyName: [],
        NoExpiry: [],
        Restrictions: (_)=>(0, $Phm09._json)(_),
        Tags: (_)=>(0, $Phm09._json)(_)
    }));
    let { hostname: resolvedHostname } = await context.endpoint();
    if (context.disableHostPrefix !== true) {
        resolvedHostname = "cp.metadata." + resolvedHostname;
        if (!(0, $jD1Fl.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
    }
    b.hn(resolvedHostname);
    b.m("POST").h(headers).b(body);
    return b.build();
};
const $0a8265f77a3f5d43$export$ae83bd7f174c0012 = async (input, context)=>{
    const b = (0, $ld8GT.requestBuilder)(input, context);
    const headers = {
        "content-type": "application/json"
    };
    b.bp("/maps/v0/maps");
    let body;
    body = JSON.stringify((0, $eJMW4.take)(input, {
        Configuration: (_)=>(0, $Phm09._json)(_),
        Description: [],
        MapName: [],
        PricingPlan: [],
        Tags: (_)=>(0, $Phm09._json)(_)
    }));
    let { hostname: resolvedHostname } = await context.endpoint();
    if (context.disableHostPrefix !== true) {
        resolvedHostname = "cp.maps." + resolvedHostname;
        if (!(0, $jD1Fl.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
    }
    b.hn(resolvedHostname);
    b.m("POST").h(headers).b(body);
    return b.build();
};
const $0a8265f77a3f5d43$export$b1ea8a17d6406062 = async (input, context)=>{
    const b = (0, $ld8GT.requestBuilder)(input, context);
    const headers = {
        "content-type": "application/json"
    };
    b.bp("/places/v0/indexes");
    let body;
    body = JSON.stringify((0, $eJMW4.take)(input, {
        DataSource: [],
        DataSourceConfiguration: (_)=>(0, $Phm09._json)(_),
        Description: [],
        IndexName: [],
        PricingPlan: [],
        Tags: (_)=>(0, $Phm09._json)(_)
    }));
    let { hostname: resolvedHostname } = await context.endpoint();
    if (context.disableHostPrefix !== true) {
        resolvedHostname = "cp.places." + resolvedHostname;
        if (!(0, $jD1Fl.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
    }
    b.hn(resolvedHostname);
    b.m("POST").h(headers).b(body);
    return b.build();
};
const $0a8265f77a3f5d43$export$5c900d99a0dc379c = async (input, context)=>{
    const b = (0, $ld8GT.requestBuilder)(input, context);
    const headers = {
        "content-type": "application/json"
    };
    b.bp("/routes/v0/calculators");
    let body;
    body = JSON.stringify((0, $eJMW4.take)(input, {
        CalculatorName: [],
        DataSource: [],
        Description: [],
        PricingPlan: [],
        Tags: (_)=>(0, $Phm09._json)(_)
    }));
    let { hostname: resolvedHostname } = await context.endpoint();
    if (context.disableHostPrefix !== true) {
        resolvedHostname = "cp.routes." + resolvedHostname;
        if (!(0, $jD1Fl.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
    }
    b.hn(resolvedHostname);
    b.m("POST").h(headers).b(body);
    return b.build();
};
const $0a8265f77a3f5d43$export$533016b14d9197ac = async (input, context)=>{
    const b = (0, $ld8GT.requestBuilder)(input, context);
    const headers = {
        "content-type": "application/json"
    };
    b.bp("/tracking/v0/trackers");
    let body;
    body = JSON.stringify((0, $eJMW4.take)(input, {
        Description: [],
        EventBridgeEnabled: [],
        KmsKeyEnableGeospatialQueries: [],
        KmsKeyId: [],
        PositionFiltering: [],
        PricingPlan: [],
        PricingPlanDataSource: [],
        Tags: (_)=>(0, $Phm09._json)(_),
        TrackerName: []
    }));
    let { hostname: resolvedHostname } = await context.endpoint();
    if (context.disableHostPrefix !== true) {
        resolvedHostname = "cp.tracking." + resolvedHostname;
        if (!(0, $jD1Fl.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
    }
    b.hn(resolvedHostname);
    b.m("POST").h(headers).b(body);
    return b.build();
};
const $0a8265f77a3f5d43$export$422f93faf7d4ef2e = async (input, context)=>{
    const b = (0, $ld8GT.requestBuilder)(input, context);
    const headers = {};
    b.bp("/geofencing/v0/collections/{CollectionName}");
    b.p("CollectionName", ()=>input.CollectionName, "{CollectionName}", false);
    let body;
    let { hostname: resolvedHostname } = await context.endpoint();
    if (context.disableHostPrefix !== true) {
        resolvedHostname = "cp.geofencing." + resolvedHostname;
        if (!(0, $jD1Fl.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
    }
    b.hn(resolvedHostname);
    b.m("DELETE").h(headers).b(body);
    return b.build();
};
const $0a8265f77a3f5d43$export$be1f7543833c50ac = async (input, context)=>{
    const b = (0, $ld8GT.requestBuilder)(input, context);
    const headers = {};
    b.bp("/metadata/v0/keys/{KeyName}");
    b.p("KeyName", ()=>input.KeyName, "{KeyName}", false);
    const query = (0, $eJMW4.map)({
        [$0a8265f77a3f5d43$var$_fD]: [
            ()=>input.ForceDelete !== void 0,
            ()=>input[$0a8265f77a3f5d43$var$_FD].toString()
        ]
    });
    let body;
    let { hostname: resolvedHostname } = await context.endpoint();
    if (context.disableHostPrefix !== true) {
        resolvedHostname = "cp.metadata." + resolvedHostname;
        if (!(0, $jD1Fl.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
    }
    b.hn(resolvedHostname);
    b.m("DELETE").h(headers).q(query).b(body);
    return b.build();
};
const $0a8265f77a3f5d43$export$6e584aca06133ecf = async (input, context)=>{
    const b = (0, $ld8GT.requestBuilder)(input, context);
    const headers = {};
    b.bp("/maps/v0/maps/{MapName}");
    b.p("MapName", ()=>input.MapName, "{MapName}", false);
    let body;
    let { hostname: resolvedHostname } = await context.endpoint();
    if (context.disableHostPrefix !== true) {
        resolvedHostname = "cp.maps." + resolvedHostname;
        if (!(0, $jD1Fl.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
    }
    b.hn(resolvedHostname);
    b.m("DELETE").h(headers).b(body);
    return b.build();
};
const $0a8265f77a3f5d43$export$2f0bdfedc0af1312 = async (input, context)=>{
    const b = (0, $ld8GT.requestBuilder)(input, context);
    const headers = {};
    b.bp("/places/v0/indexes/{IndexName}");
    b.p("IndexName", ()=>input.IndexName, "{IndexName}", false);
    let body;
    let { hostname: resolvedHostname } = await context.endpoint();
    if (context.disableHostPrefix !== true) {
        resolvedHostname = "cp.places." + resolvedHostname;
        if (!(0, $jD1Fl.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
    }
    b.hn(resolvedHostname);
    b.m("DELETE").h(headers).b(body);
    return b.build();
};
const $0a8265f77a3f5d43$export$f66687fa084d27bb = async (input, context)=>{
    const b = (0, $ld8GT.requestBuilder)(input, context);
    const headers = {};
    b.bp("/routes/v0/calculators/{CalculatorName}");
    b.p("CalculatorName", ()=>input.CalculatorName, "{CalculatorName}", false);
    let body;
    let { hostname: resolvedHostname } = await context.endpoint();
    if (context.disableHostPrefix !== true) {
        resolvedHostname = "cp.routes." + resolvedHostname;
        if (!(0, $jD1Fl.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
    }
    b.hn(resolvedHostname);
    b.m("DELETE").h(headers).b(body);
    return b.build();
};
const $0a8265f77a3f5d43$export$3413e61108bbec4b = async (input, context)=>{
    const b = (0, $ld8GT.requestBuilder)(input, context);
    const headers = {};
    b.bp("/tracking/v0/trackers/{TrackerName}");
    b.p("TrackerName", ()=>input.TrackerName, "{TrackerName}", false);
    let body;
    let { hostname: resolvedHostname } = await context.endpoint();
    if (context.disableHostPrefix !== true) {
        resolvedHostname = "cp.tracking." + resolvedHostname;
        if (!(0, $jD1Fl.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
    }
    b.hn(resolvedHostname);
    b.m("DELETE").h(headers).b(body);
    return b.build();
};
const $0a8265f77a3f5d43$export$984c5448435c51c1 = async (input, context)=>{
    const b = (0, $ld8GT.requestBuilder)(input, context);
    const headers = {};
    b.bp("/geofencing/v0/collections/{CollectionName}");
    b.p("CollectionName", ()=>input.CollectionName, "{CollectionName}", false);
    let body;
    let { hostname: resolvedHostname } = await context.endpoint();
    if (context.disableHostPrefix !== true) {
        resolvedHostname = "cp.geofencing." + resolvedHostname;
        if (!(0, $jD1Fl.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
    }
    b.hn(resolvedHostname);
    b.m("GET").h(headers).b(body);
    return b.build();
};
const $0a8265f77a3f5d43$export$251b72cd02ba0edf = async (input, context)=>{
    const b = (0, $ld8GT.requestBuilder)(input, context);
    const headers = {};
    b.bp("/metadata/v0/keys/{KeyName}");
    b.p("KeyName", ()=>input.KeyName, "{KeyName}", false);
    let body;
    let { hostname: resolvedHostname } = await context.endpoint();
    if (context.disableHostPrefix !== true) {
        resolvedHostname = "cp.metadata." + resolvedHostname;
        if (!(0, $jD1Fl.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
    }
    b.hn(resolvedHostname);
    b.m("GET").h(headers).b(body);
    return b.build();
};
const $0a8265f77a3f5d43$export$51dbbb1c8e2ddd11 = async (input, context)=>{
    const b = (0, $ld8GT.requestBuilder)(input, context);
    const headers = {};
    b.bp("/maps/v0/maps/{MapName}");
    b.p("MapName", ()=>input.MapName, "{MapName}", false);
    let body;
    let { hostname: resolvedHostname } = await context.endpoint();
    if (context.disableHostPrefix !== true) {
        resolvedHostname = "cp.maps." + resolvedHostname;
        if (!(0, $jD1Fl.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
    }
    b.hn(resolvedHostname);
    b.m("GET").h(headers).b(body);
    return b.build();
};
const $0a8265f77a3f5d43$export$7e683740eb8c2cb3 = async (input, context)=>{
    const b = (0, $ld8GT.requestBuilder)(input, context);
    const headers = {};
    b.bp("/places/v0/indexes/{IndexName}");
    b.p("IndexName", ()=>input.IndexName, "{IndexName}", false);
    let body;
    let { hostname: resolvedHostname } = await context.endpoint();
    if (context.disableHostPrefix !== true) {
        resolvedHostname = "cp.places." + resolvedHostname;
        if (!(0, $jD1Fl.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
    }
    b.hn(resolvedHostname);
    b.m("GET").h(headers).b(body);
    return b.build();
};
const $0a8265f77a3f5d43$export$7f41f7f3a388b797 = async (input, context)=>{
    const b = (0, $ld8GT.requestBuilder)(input, context);
    const headers = {};
    b.bp("/routes/v0/calculators/{CalculatorName}");
    b.p("CalculatorName", ()=>input.CalculatorName, "{CalculatorName}", false);
    let body;
    let { hostname: resolvedHostname } = await context.endpoint();
    if (context.disableHostPrefix !== true) {
        resolvedHostname = "cp.routes." + resolvedHostname;
        if (!(0, $jD1Fl.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
    }
    b.hn(resolvedHostname);
    b.m("GET").h(headers).b(body);
    return b.build();
};
const $0a8265f77a3f5d43$export$f1549e3aa2a07b8b = async (input, context)=>{
    const b = (0, $ld8GT.requestBuilder)(input, context);
    const headers = {};
    b.bp("/tracking/v0/trackers/{TrackerName}");
    b.p("TrackerName", ()=>input.TrackerName, "{TrackerName}", false);
    let body;
    let { hostname: resolvedHostname } = await context.endpoint();
    if (context.disableHostPrefix !== true) {
        resolvedHostname = "cp.tracking." + resolvedHostname;
        if (!(0, $jD1Fl.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
    }
    b.hn(resolvedHostname);
    b.m("GET").h(headers).b(body);
    return b.build();
};
const $0a8265f77a3f5d43$export$2d8bae01fb80af79 = async (input, context)=>{
    const b = (0, $ld8GT.requestBuilder)(input, context);
    const headers = {};
    b.bp("/tracking/v0/trackers/{TrackerName}/consumers/{ConsumerArn}");
    b.p("TrackerName", ()=>input.TrackerName, "{TrackerName}", false);
    b.p("ConsumerArn", ()=>input.ConsumerArn, "{ConsumerArn}", false);
    let body;
    let { hostname: resolvedHostname } = await context.endpoint();
    if (context.disableHostPrefix !== true) {
        resolvedHostname = "cp.tracking." + resolvedHostname;
        if (!(0, $jD1Fl.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
    }
    b.hn(resolvedHostname);
    b.m("DELETE").h(headers).b(body);
    return b.build();
};
const $0a8265f77a3f5d43$export$c6704ac4f1d35408 = async (input, context)=>{
    const b = (0, $ld8GT.requestBuilder)(input, context);
    const headers = {};
    b.bp("/tracking/v0/trackers/{TrackerName}/devices/{DeviceId}/positions/latest");
    b.p("TrackerName", ()=>input.TrackerName, "{TrackerName}", false);
    b.p("DeviceId", ()=>input.DeviceId, "{DeviceId}", false);
    let body;
    let { hostname: resolvedHostname } = await context.endpoint();
    if (context.disableHostPrefix !== true) {
        resolvedHostname = "tracking." + resolvedHostname;
        if (!(0, $jD1Fl.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
    }
    b.hn(resolvedHostname);
    b.m("GET").h(headers).b(body);
    return b.build();
};
const $0a8265f77a3f5d43$export$719e425359739166 = async (input, context)=>{
    const b = (0, $ld8GT.requestBuilder)(input, context);
    const headers = {
        "content-type": "application/json"
    };
    b.bp("/tracking/v0/trackers/{TrackerName}/devices/{DeviceId}/list-positions");
    b.p("TrackerName", ()=>input.TrackerName, "{TrackerName}", false);
    b.p("DeviceId", ()=>input.DeviceId, "{DeviceId}", false);
    let body;
    body = JSON.stringify((0, $eJMW4.take)(input, {
        EndTimeExclusive: (_)=>_.toISOString().split(".")[0] + "Z",
        MaxResults: [],
        NextToken: [],
        StartTimeInclusive: (_)=>_.toISOString().split(".")[0] + "Z"
    }));
    let { hostname: resolvedHostname } = await context.endpoint();
    if (context.disableHostPrefix !== true) {
        resolvedHostname = "tracking." + resolvedHostname;
        if (!(0, $jD1Fl.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
    }
    b.hn(resolvedHostname);
    b.m("POST").h(headers).b(body);
    return b.build();
};
const $0a8265f77a3f5d43$export$5fda31babc59268c = async (input, context)=>{
    const b = (0, $ld8GT.requestBuilder)(input, context);
    const headers = {};
    b.bp("/geofencing/v0/collections/{CollectionName}/geofences/{GeofenceId}");
    b.p("CollectionName", ()=>input.CollectionName, "{CollectionName}", false);
    b.p("GeofenceId", ()=>input.GeofenceId, "{GeofenceId}", false);
    let body;
    let { hostname: resolvedHostname } = await context.endpoint();
    if (context.disableHostPrefix !== true) {
        resolvedHostname = "geofencing." + resolvedHostname;
        if (!(0, $jD1Fl.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
    }
    b.hn(resolvedHostname);
    b.m("GET").h(headers).b(body);
    return b.build();
};
const $0a8265f77a3f5d43$export$4b548bfec1e126c6 = async (input, context)=>{
    const b = (0, $ld8GT.requestBuilder)(input, context);
    const headers = {};
    b.bp("/maps/v0/maps/{MapName}/glyphs/{FontStack}/{FontUnicodeRange}");
    b.p("MapName", ()=>input.MapName, "{MapName}", false);
    b.p("FontStack", ()=>input.FontStack, "{FontStack}", false);
    b.p("FontUnicodeRange", ()=>input.FontUnicodeRange, "{FontUnicodeRange}", false);
    const query = (0, $eJMW4.map)({
        [$0a8265f77a3f5d43$var$_k]: [
            ,
            input[$0a8265f77a3f5d43$var$_K]
        ]
    });
    let body;
    let { hostname: resolvedHostname } = await context.endpoint();
    if (context.disableHostPrefix !== true) {
        resolvedHostname = "maps." + resolvedHostname;
        if (!(0, $jD1Fl.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
    }
    b.hn(resolvedHostname);
    b.m("GET").h(headers).q(query).b(body);
    return b.build();
};
const $0a8265f77a3f5d43$export$3fd1be1ad362d43b = async (input, context)=>{
    const b = (0, $ld8GT.requestBuilder)(input, context);
    const headers = {};
    b.bp("/maps/v0/maps/{MapName}/sprites/{FileName}");
    b.p("MapName", ()=>input.MapName, "{MapName}", false);
    b.p("FileName", ()=>input.FileName, "{FileName}", false);
    const query = (0, $eJMW4.map)({
        [$0a8265f77a3f5d43$var$_k]: [
            ,
            input[$0a8265f77a3f5d43$var$_K]
        ]
    });
    let body;
    let { hostname: resolvedHostname } = await context.endpoint();
    if (context.disableHostPrefix !== true) {
        resolvedHostname = "maps." + resolvedHostname;
        if (!(0, $jD1Fl.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
    }
    b.hn(resolvedHostname);
    b.m("GET").h(headers).q(query).b(body);
    return b.build();
};
const $0a8265f77a3f5d43$export$9a9d4ebe70faf892 = async (input, context)=>{
    const b = (0, $ld8GT.requestBuilder)(input, context);
    const headers = {};
    b.bp("/maps/v0/maps/{MapName}/style-descriptor");
    b.p("MapName", ()=>input.MapName, "{MapName}", false);
    const query = (0, $eJMW4.map)({
        [$0a8265f77a3f5d43$var$_k]: [
            ,
            input[$0a8265f77a3f5d43$var$_K]
        ]
    });
    let body;
    let { hostname: resolvedHostname } = await context.endpoint();
    if (context.disableHostPrefix !== true) {
        resolvedHostname = "maps." + resolvedHostname;
        if (!(0, $jD1Fl.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
    }
    b.hn(resolvedHostname);
    b.m("GET").h(headers).q(query).b(body);
    return b.build();
};
const $0a8265f77a3f5d43$export$a40f0a0a8cee05f = async (input, context)=>{
    const b = (0, $ld8GT.requestBuilder)(input, context);
    const headers = {};
    b.bp("/maps/v0/maps/{MapName}/tiles/{Z}/{X}/{Y}");
    b.p("MapName", ()=>input.MapName, "{MapName}", false);
    b.p("Z", ()=>input.Z, "{Z}", false);
    b.p("X", ()=>input.X, "{X}", false);
    b.p("Y", ()=>input.Y, "{Y}", false);
    const query = (0, $eJMW4.map)({
        [$0a8265f77a3f5d43$var$_k]: [
            ,
            input[$0a8265f77a3f5d43$var$_K]
        ]
    });
    let body;
    let { hostname: resolvedHostname } = await context.endpoint();
    if (context.disableHostPrefix !== true) {
        resolvedHostname = "maps." + resolvedHostname;
        if (!(0, $jD1Fl.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
    }
    b.hn(resolvedHostname);
    b.m("GET").h(headers).q(query).b(body);
    return b.build();
};
const $0a8265f77a3f5d43$export$e6e30dd5040e5952 = async (input, context)=>{
    const b = (0, $ld8GT.requestBuilder)(input, context);
    const headers = {};
    b.bp("/places/v0/indexes/{IndexName}/places/{PlaceId}");
    b.p("IndexName", ()=>input.IndexName, "{IndexName}", false);
    b.p("PlaceId", ()=>input.PlaceId, "{PlaceId}", false);
    const query = (0, $eJMW4.map)({
        [$0a8265f77a3f5d43$var$_l]: [
            ,
            input[$0a8265f77a3f5d43$var$_L]
        ],
        [$0a8265f77a3f5d43$var$_k]: [
            ,
            input[$0a8265f77a3f5d43$var$_K]
        ]
    });
    let body;
    let { hostname: resolvedHostname } = await context.endpoint();
    if (context.disableHostPrefix !== true) {
        resolvedHostname = "places." + resolvedHostname;
        if (!(0, $jD1Fl.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
    }
    b.hn(resolvedHostname);
    b.m("GET").h(headers).q(query).b(body);
    return b.build();
};
const $0a8265f77a3f5d43$export$933718d1b0c49e30 = async (input, context)=>{
    const b = (0, $ld8GT.requestBuilder)(input, context);
    const headers = {
        "content-type": "application/json"
    };
    b.bp("/tracking/v0/trackers/{TrackerName}/list-positions");
    b.p("TrackerName", ()=>input.TrackerName, "{TrackerName}", false);
    let body;
    body = JSON.stringify((0, $eJMW4.take)(input, {
        FilterGeometry: (_)=>$0a8265f77a3f5d43$var$se_TrackingFilterGeometry(_, context),
        MaxResults: [],
        NextToken: []
    }));
    let { hostname: resolvedHostname } = await context.endpoint();
    if (context.disableHostPrefix !== true) {
        resolvedHostname = "tracking." + resolvedHostname;
        if (!(0, $jD1Fl.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
    }
    b.hn(resolvedHostname);
    b.m("POST").h(headers).b(body);
    return b.build();
};
const $0a8265f77a3f5d43$export$40e3d9c464bdf2fc = async (input, context)=>{
    const b = (0, $ld8GT.requestBuilder)(input, context);
    const headers = {
        "content-type": "application/json"
    };
    b.bp("/geofencing/v0/list-collections");
    let body;
    body = JSON.stringify((0, $eJMW4.take)(input, {
        MaxResults: [],
        NextToken: []
    }));
    let { hostname: resolvedHostname } = await context.endpoint();
    if (context.disableHostPrefix !== true) {
        resolvedHostname = "cp.geofencing." + resolvedHostname;
        if (!(0, $jD1Fl.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
    }
    b.hn(resolvedHostname);
    b.m("POST").h(headers).b(body);
    return b.build();
};
const $0a8265f77a3f5d43$export$b4a6654cda6dda9 = async (input, context)=>{
    const b = (0, $ld8GT.requestBuilder)(input, context);
    const headers = {
        "content-type": "application/json"
    };
    b.bp("/geofencing/v0/collections/{CollectionName}/list-geofences");
    b.p("CollectionName", ()=>input.CollectionName, "{CollectionName}", false);
    let body;
    body = JSON.stringify((0, $eJMW4.take)(input, {
        MaxResults: [],
        NextToken: []
    }));
    let { hostname: resolvedHostname } = await context.endpoint();
    if (context.disableHostPrefix !== true) {
        resolvedHostname = "geofencing." + resolvedHostname;
        if (!(0, $jD1Fl.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
    }
    b.hn(resolvedHostname);
    b.m("POST").h(headers).b(body);
    return b.build();
};
const $0a8265f77a3f5d43$export$31ebefdb5e5e0164 = async (input, context)=>{
    const b = (0, $ld8GT.requestBuilder)(input, context);
    const headers = {
        "content-type": "application/json"
    };
    b.bp("/metadata/v0/list-keys");
    let body;
    body = JSON.stringify((0, $eJMW4.take)(input, {
        Filter: (_)=>(0, $Phm09._json)(_),
        MaxResults: [],
        NextToken: []
    }));
    let { hostname: resolvedHostname } = await context.endpoint();
    if (context.disableHostPrefix !== true) {
        resolvedHostname = "cp.metadata." + resolvedHostname;
        if (!(0, $jD1Fl.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
    }
    b.hn(resolvedHostname);
    b.m("POST").h(headers).b(body);
    return b.build();
};
const $0a8265f77a3f5d43$export$1b0b48c978966657 = async (input, context)=>{
    const b = (0, $ld8GT.requestBuilder)(input, context);
    const headers = {
        "content-type": "application/json"
    };
    b.bp("/maps/v0/list-maps");
    let body;
    body = JSON.stringify((0, $eJMW4.take)(input, {
        MaxResults: [],
        NextToken: []
    }));
    let { hostname: resolvedHostname } = await context.endpoint();
    if (context.disableHostPrefix !== true) {
        resolvedHostname = "cp.maps." + resolvedHostname;
        if (!(0, $jD1Fl.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
    }
    b.hn(resolvedHostname);
    b.m("POST").h(headers).b(body);
    return b.build();
};
const $0a8265f77a3f5d43$export$b57a88e7f7c6570 = async (input, context)=>{
    const b = (0, $ld8GT.requestBuilder)(input, context);
    const headers = {
        "content-type": "application/json"
    };
    b.bp("/places/v0/list-indexes");
    let body;
    body = JSON.stringify((0, $eJMW4.take)(input, {
        MaxResults: [],
        NextToken: []
    }));
    let { hostname: resolvedHostname } = await context.endpoint();
    if (context.disableHostPrefix !== true) {
        resolvedHostname = "cp.places." + resolvedHostname;
        if (!(0, $jD1Fl.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
    }
    b.hn(resolvedHostname);
    b.m("POST").h(headers).b(body);
    return b.build();
};
const $0a8265f77a3f5d43$export$2588888cde4b948e = async (input, context)=>{
    const b = (0, $ld8GT.requestBuilder)(input, context);
    const headers = {
        "content-type": "application/json"
    };
    b.bp("/routes/v0/list-calculators");
    let body;
    body = JSON.stringify((0, $eJMW4.take)(input, {
        MaxResults: [],
        NextToken: []
    }));
    let { hostname: resolvedHostname } = await context.endpoint();
    if (context.disableHostPrefix !== true) {
        resolvedHostname = "cp.routes." + resolvedHostname;
        if (!(0, $jD1Fl.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
    }
    b.hn(resolvedHostname);
    b.m("POST").h(headers).b(body);
    return b.build();
};
const $0a8265f77a3f5d43$export$cd89308d1d2e2126 = async (input, context)=>{
    const b = (0, $ld8GT.requestBuilder)(input, context);
    const headers = {};
    b.bp("/tags/{ResourceArn}");
    b.p("ResourceArn", ()=>input.ResourceArn, "{ResourceArn}", false);
    let body;
    let { hostname: resolvedHostname } = await context.endpoint();
    if (context.disableHostPrefix !== true) {
        resolvedHostname = "cp.metadata." + resolvedHostname;
        if (!(0, $jD1Fl.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
    }
    b.hn(resolvedHostname);
    b.m("GET").h(headers).b(body);
    return b.build();
};
const $0a8265f77a3f5d43$export$8c90e91774fe1f0e = async (input, context)=>{
    const b = (0, $ld8GT.requestBuilder)(input, context);
    const headers = {
        "content-type": "application/json"
    };
    b.bp("/tracking/v0/trackers/{TrackerName}/list-consumers");
    b.p("TrackerName", ()=>input.TrackerName, "{TrackerName}", false);
    let body;
    body = JSON.stringify((0, $eJMW4.take)(input, {
        MaxResults: [],
        NextToken: []
    }));
    let { hostname: resolvedHostname } = await context.endpoint();
    if (context.disableHostPrefix !== true) {
        resolvedHostname = "cp.tracking." + resolvedHostname;
        if (!(0, $jD1Fl.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
    }
    b.hn(resolvedHostname);
    b.m("POST").h(headers).b(body);
    return b.build();
};
const $0a8265f77a3f5d43$export$3aded2ac4bb35ff9 = async (input, context)=>{
    const b = (0, $ld8GT.requestBuilder)(input, context);
    const headers = {
        "content-type": "application/json"
    };
    b.bp("/tracking/v0/list-trackers");
    let body;
    body = JSON.stringify((0, $eJMW4.take)(input, {
        MaxResults: [],
        NextToken: []
    }));
    let { hostname: resolvedHostname } = await context.endpoint();
    if (context.disableHostPrefix !== true) {
        resolvedHostname = "cp.tracking." + resolvedHostname;
        if (!(0, $jD1Fl.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
    }
    b.hn(resolvedHostname);
    b.m("POST").h(headers).b(body);
    return b.build();
};
const $0a8265f77a3f5d43$export$47770f2d42f071ae = async (input, context)=>{
    const b = (0, $ld8GT.requestBuilder)(input, context);
    const headers = {
        "content-type": "application/json"
    };
    b.bp("/geofencing/v0/collections/{CollectionName}/geofences/{GeofenceId}");
    b.p("CollectionName", ()=>input.CollectionName, "{CollectionName}", false);
    b.p("GeofenceId", ()=>input.GeofenceId, "{GeofenceId}", false);
    let body;
    body = JSON.stringify((0, $eJMW4.take)(input, {
        GeofenceProperties: (_)=>(0, $Phm09._json)(_),
        Geometry: (_)=>$0a8265f77a3f5d43$var$se_GeofenceGeometry(_, context)
    }));
    let { hostname: resolvedHostname } = await context.endpoint();
    if (context.disableHostPrefix !== true) {
        resolvedHostname = "geofencing." + resolvedHostname;
        if (!(0, $jD1Fl.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
    }
    b.hn(resolvedHostname);
    b.m("PUT").h(headers).b(body);
    return b.build();
};
const $0a8265f77a3f5d43$export$f436dbc7339eb42f = async (input, context)=>{
    const b = (0, $ld8GT.requestBuilder)(input, context);
    const headers = {
        "content-type": "application/json"
    };
    b.bp("/places/v0/indexes/{IndexName}/search/position");
    b.p("IndexName", ()=>input.IndexName, "{IndexName}", false);
    const query = (0, $eJMW4.map)({
        [$0a8265f77a3f5d43$var$_k]: [
            ,
            input[$0a8265f77a3f5d43$var$_K]
        ]
    });
    let body;
    body = JSON.stringify((0, $eJMW4.take)(input, {
        Language: [],
        MaxResults: [],
        Position: (_)=>$0a8265f77a3f5d43$var$se_Position(_, context)
    }));
    let { hostname: resolvedHostname } = await context.endpoint();
    if (context.disableHostPrefix !== true) {
        resolvedHostname = "places." + resolvedHostname;
        if (!(0, $jD1Fl.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
    }
    b.hn(resolvedHostname);
    b.m("POST").h(headers).q(query).b(body);
    return b.build();
};
const $0a8265f77a3f5d43$export$2ea9a3f10ca9eb26 = async (input, context)=>{
    const b = (0, $ld8GT.requestBuilder)(input, context);
    const headers = {
        "content-type": "application/json"
    };
    b.bp("/places/v0/indexes/{IndexName}/search/suggestions");
    b.p("IndexName", ()=>input.IndexName, "{IndexName}", false);
    const query = (0, $eJMW4.map)({
        [$0a8265f77a3f5d43$var$_k]: [
            ,
            input[$0a8265f77a3f5d43$var$_K]
        ]
    });
    let body;
    body = JSON.stringify((0, $eJMW4.take)(input, {
        BiasPosition: (_)=>$0a8265f77a3f5d43$var$se_Position(_, context),
        FilterBBox: (_)=>$0a8265f77a3f5d43$var$se_BoundingBox(_, context),
        FilterCategories: (_)=>(0, $Phm09._json)(_),
        FilterCountries: (_)=>(0, $Phm09._json)(_),
        Language: [],
        MaxResults: [],
        Text: []
    }));
    let { hostname: resolvedHostname } = await context.endpoint();
    if (context.disableHostPrefix !== true) {
        resolvedHostname = "places." + resolvedHostname;
        if (!(0, $jD1Fl.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
    }
    b.hn(resolvedHostname);
    b.m("POST").h(headers).q(query).b(body);
    return b.build();
};
const $0a8265f77a3f5d43$export$84492c48c9171082 = async (input, context)=>{
    const b = (0, $ld8GT.requestBuilder)(input, context);
    const headers = {
        "content-type": "application/json"
    };
    b.bp("/places/v0/indexes/{IndexName}/search/text");
    b.p("IndexName", ()=>input.IndexName, "{IndexName}", false);
    const query = (0, $eJMW4.map)({
        [$0a8265f77a3f5d43$var$_k]: [
            ,
            input[$0a8265f77a3f5d43$var$_K]
        ]
    });
    let body;
    body = JSON.stringify((0, $eJMW4.take)(input, {
        BiasPosition: (_)=>$0a8265f77a3f5d43$var$se_Position(_, context),
        FilterBBox: (_)=>$0a8265f77a3f5d43$var$se_BoundingBox(_, context),
        FilterCategories: (_)=>(0, $Phm09._json)(_),
        FilterCountries: (_)=>(0, $Phm09._json)(_),
        Language: [],
        MaxResults: [],
        Text: []
    }));
    let { hostname: resolvedHostname } = await context.endpoint();
    if (context.disableHostPrefix !== true) {
        resolvedHostname = "places." + resolvedHostname;
        if (!(0, $jD1Fl.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
    }
    b.hn(resolvedHostname);
    b.m("POST").h(headers).q(query).b(body);
    return b.build();
};
const $0a8265f77a3f5d43$export$3f3dfadaf322c1d5 = async (input, context)=>{
    const b = (0, $ld8GT.requestBuilder)(input, context);
    const headers = {
        "content-type": "application/json"
    };
    b.bp("/tags/{ResourceArn}");
    b.p("ResourceArn", ()=>input.ResourceArn, "{ResourceArn}", false);
    let body;
    body = JSON.stringify((0, $eJMW4.take)(input, {
        Tags: (_)=>(0, $Phm09._json)(_)
    }));
    let { hostname: resolvedHostname } = await context.endpoint();
    if (context.disableHostPrefix !== true) {
        resolvedHostname = "cp.metadata." + resolvedHostname;
        if (!(0, $jD1Fl.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
    }
    b.hn(resolvedHostname);
    b.m("POST").h(headers).b(body);
    return b.build();
};
const $0a8265f77a3f5d43$export$b056b897d8c9e1a6 = async (input, context)=>{
    const b = (0, $ld8GT.requestBuilder)(input, context);
    const headers = {};
    b.bp("/tags/{ResourceArn}");
    b.p("ResourceArn", ()=>input.ResourceArn, "{ResourceArn}", false);
    const query = (0, $eJMW4.map)({
        [$0a8265f77a3f5d43$var$_tK]: [
            (0, $cXA1B.expectNonNull)(input.TagKeys, `TagKeys`) != null,
            ()=>(input[$0a8265f77a3f5d43$var$_TK] || []).map((_entry)=>_entry)
        ]
    });
    let body;
    let { hostname: resolvedHostname } = await context.endpoint();
    if (context.disableHostPrefix !== true) {
        resolvedHostname = "cp.metadata." + resolvedHostname;
        if (!(0, $jD1Fl.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
    }
    b.hn(resolvedHostname);
    b.m("DELETE").h(headers).q(query).b(body);
    return b.build();
};
const $0a8265f77a3f5d43$export$419934f825f7242f = async (input, context)=>{
    const b = (0, $ld8GT.requestBuilder)(input, context);
    const headers = {
        "content-type": "application/json"
    };
    b.bp("/geofencing/v0/collections/{CollectionName}");
    b.p("CollectionName", ()=>input.CollectionName, "{CollectionName}", false);
    let body;
    body = JSON.stringify((0, $eJMW4.take)(input, {
        Description: [],
        PricingPlan: [],
        PricingPlanDataSource: []
    }));
    let { hostname: resolvedHostname } = await context.endpoint();
    if (context.disableHostPrefix !== true) {
        resolvedHostname = "cp.geofencing." + resolvedHostname;
        if (!(0, $jD1Fl.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
    }
    b.hn(resolvedHostname);
    b.m("PATCH").h(headers).b(body);
    return b.build();
};
const $0a8265f77a3f5d43$export$17c683ac9a005e6e = async (input, context)=>{
    const b = (0, $ld8GT.requestBuilder)(input, context);
    const headers = {
        "content-type": "application/json"
    };
    b.bp("/metadata/v0/keys/{KeyName}");
    b.p("KeyName", ()=>input.KeyName, "{KeyName}", false);
    let body;
    body = JSON.stringify((0, $eJMW4.take)(input, {
        Description: [],
        ExpireTime: (_)=>_.toISOString().split(".")[0] + "Z",
        ForceUpdate: [],
        NoExpiry: [],
        Restrictions: (_)=>(0, $Phm09._json)(_)
    }));
    let { hostname: resolvedHostname } = await context.endpoint();
    if (context.disableHostPrefix !== true) {
        resolvedHostname = "cp.metadata." + resolvedHostname;
        if (!(0, $jD1Fl.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
    }
    b.hn(resolvedHostname);
    b.m("PATCH").h(headers).b(body);
    return b.build();
};
const $0a8265f77a3f5d43$export$676c5040bc4bf267 = async (input, context)=>{
    const b = (0, $ld8GT.requestBuilder)(input, context);
    const headers = {
        "content-type": "application/json"
    };
    b.bp("/maps/v0/maps/{MapName}");
    b.p("MapName", ()=>input.MapName, "{MapName}", false);
    let body;
    body = JSON.stringify((0, $eJMW4.take)(input, {
        ConfigurationUpdate: (_)=>(0, $Phm09._json)(_),
        Description: [],
        PricingPlan: []
    }));
    let { hostname: resolvedHostname } = await context.endpoint();
    if (context.disableHostPrefix !== true) {
        resolvedHostname = "cp.maps." + resolvedHostname;
        if (!(0, $jD1Fl.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
    }
    b.hn(resolvedHostname);
    b.m("PATCH").h(headers).b(body);
    return b.build();
};
const $0a8265f77a3f5d43$export$4fe6bc26598dac0d = async (input, context)=>{
    const b = (0, $ld8GT.requestBuilder)(input, context);
    const headers = {
        "content-type": "application/json"
    };
    b.bp("/places/v0/indexes/{IndexName}");
    b.p("IndexName", ()=>input.IndexName, "{IndexName}", false);
    let body;
    body = JSON.stringify((0, $eJMW4.take)(input, {
        DataSourceConfiguration: (_)=>(0, $Phm09._json)(_),
        Description: [],
        PricingPlan: []
    }));
    let { hostname: resolvedHostname } = await context.endpoint();
    if (context.disableHostPrefix !== true) {
        resolvedHostname = "cp.places." + resolvedHostname;
        if (!(0, $jD1Fl.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
    }
    b.hn(resolvedHostname);
    b.m("PATCH").h(headers).b(body);
    return b.build();
};
const $0a8265f77a3f5d43$export$229aaee5142bdcb0 = async (input, context)=>{
    const b = (0, $ld8GT.requestBuilder)(input, context);
    const headers = {
        "content-type": "application/json"
    };
    b.bp("/routes/v0/calculators/{CalculatorName}");
    b.p("CalculatorName", ()=>input.CalculatorName, "{CalculatorName}", false);
    let body;
    body = JSON.stringify((0, $eJMW4.take)(input, {
        Description: [],
        PricingPlan: []
    }));
    let { hostname: resolvedHostname } = await context.endpoint();
    if (context.disableHostPrefix !== true) {
        resolvedHostname = "cp.routes." + resolvedHostname;
        if (!(0, $jD1Fl.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
    }
    b.hn(resolvedHostname);
    b.m("PATCH").h(headers).b(body);
    return b.build();
};
const $0a8265f77a3f5d43$export$7c600199aee778c1 = async (input, context)=>{
    const b = (0, $ld8GT.requestBuilder)(input, context);
    const headers = {
        "content-type": "application/json"
    };
    b.bp("/tracking/v0/trackers/{TrackerName}");
    b.p("TrackerName", ()=>input.TrackerName, "{TrackerName}", false);
    let body;
    body = JSON.stringify((0, $eJMW4.take)(input, {
        Description: [],
        EventBridgeEnabled: [],
        KmsKeyEnableGeospatialQueries: [],
        PositionFiltering: [],
        PricingPlan: [],
        PricingPlanDataSource: []
    }));
    let { hostname: resolvedHostname } = await context.endpoint();
    if (context.disableHostPrefix !== true) {
        resolvedHostname = "cp.tracking." + resolvedHostname;
        if (!(0, $jD1Fl.isValidHostname)(resolvedHostname)) throw new Error("ValidationError: prefixed hostname must be hostname compatible.");
    }
    b.hn(resolvedHostname);
    b.m("PATCH").h(headers).b(body);
    return b.build();
};
const $0a8265f77a3f5d43$export$186958b123a188e8 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $0a8265f77a3f5d43$var$de_CommandError(output, context);
    const contents = (0, $eJMW4.map)({
        $metadata: $0a8265f77a3f5d43$var$deserializeMetadata(output)
    });
    await (0, $7fiNM.collectBody)(output.body, context);
    return contents;
};
const $0a8265f77a3f5d43$export$c84cba3fc1c4ffa6 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $0a8265f77a3f5d43$var$de_CommandError(output, context);
    const contents = (0, $eJMW4.map)({
        $metadata: $0a8265f77a3f5d43$var$deserializeMetadata(output)
    });
    const data = (0, $cXA1B.expectNonNull)((0, $cXA1B.expectObject)(await (0, $3Z3zT.parseJsonBody)(output.body, context)), "body");
    const doc = (0, $eJMW4.take)(data, {
        Errors: (0, $Phm09._json)
    });
    Object.assign(contents, doc);
    return contents;
};
const $0a8265f77a3f5d43$export$fc40769e0287ffa2 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $0a8265f77a3f5d43$var$de_CommandError(output, context);
    const contents = (0, $eJMW4.map)({
        $metadata: $0a8265f77a3f5d43$var$deserializeMetadata(output)
    });
    const data = (0, $cXA1B.expectNonNull)((0, $cXA1B.expectObject)(await (0, $3Z3zT.parseJsonBody)(output.body, context)), "body");
    const doc = (0, $eJMW4.take)(data, {
        Errors: (0, $Phm09._json)
    });
    Object.assign(contents, doc);
    return contents;
};
const $0a8265f77a3f5d43$export$d2271f0e35b23d17 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $0a8265f77a3f5d43$var$de_CommandError(output, context);
    const contents = (0, $eJMW4.map)({
        $metadata: $0a8265f77a3f5d43$var$deserializeMetadata(output)
    });
    const data = (0, $cXA1B.expectNonNull)((0, $cXA1B.expectObject)(await (0, $3Z3zT.parseJsonBody)(output.body, context)), "body");
    const doc = (0, $eJMW4.take)(data, {
        Errors: (_)=>$0a8265f77a3f5d43$var$de_BatchEvaluateGeofencesErrorList(_, context)
    });
    Object.assign(contents, doc);
    return contents;
};
const $0a8265f77a3f5d43$export$6cfc107c261104dc = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $0a8265f77a3f5d43$var$de_CommandError(output, context);
    const contents = (0, $eJMW4.map)({
        $metadata: $0a8265f77a3f5d43$var$deserializeMetadata(output)
    });
    const data = (0, $cXA1B.expectNonNull)((0, $cXA1B.expectObject)(await (0, $3Z3zT.parseJsonBody)(output.body, context)), "body");
    const doc = (0, $eJMW4.take)(data, {
        DevicePositions: (_)=>$0a8265f77a3f5d43$var$de_DevicePositionList(_, context),
        Errors: (0, $Phm09._json)
    });
    Object.assign(contents, doc);
    return contents;
};
const $0a8265f77a3f5d43$export$65580a83cca359ba = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $0a8265f77a3f5d43$var$de_CommandError(output, context);
    const contents = (0, $eJMW4.map)({
        $metadata: $0a8265f77a3f5d43$var$deserializeMetadata(output)
    });
    const data = (0, $cXA1B.expectNonNull)((0, $cXA1B.expectObject)(await (0, $3Z3zT.parseJsonBody)(output.body, context)), "body");
    const doc = (0, $eJMW4.take)(data, {
        Errors: (0, $Phm09._json),
        Successes: (_)=>$0a8265f77a3f5d43$var$de_BatchPutGeofenceSuccessList(_, context)
    });
    Object.assign(contents, doc);
    return contents;
};
const $0a8265f77a3f5d43$export$f361c80037b2a44c = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $0a8265f77a3f5d43$var$de_CommandError(output, context);
    const contents = (0, $eJMW4.map)({
        $metadata: $0a8265f77a3f5d43$var$deserializeMetadata(output)
    });
    const data = (0, $cXA1B.expectNonNull)((0, $cXA1B.expectObject)(await (0, $3Z3zT.parseJsonBody)(output.body, context)), "body");
    const doc = (0, $eJMW4.take)(data, {
        Errors: (_)=>$0a8265f77a3f5d43$var$de_BatchUpdateDevicePositionErrorList(_, context)
    });
    Object.assign(contents, doc);
    return contents;
};
const $0a8265f77a3f5d43$export$6678c1fb54016de1 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $0a8265f77a3f5d43$var$de_CommandError(output, context);
    const contents = (0, $eJMW4.map)({
        $metadata: $0a8265f77a3f5d43$var$deserializeMetadata(output)
    });
    const data = (0, $cXA1B.expectNonNull)((0, $cXA1B.expectObject)(await (0, $3Z3zT.parseJsonBody)(output.body, context)), "body");
    const doc = (0, $eJMW4.take)(data, {
        Legs: (_)=>$0a8265f77a3f5d43$var$de_LegList(_, context),
        Summary: (_)=>$0a8265f77a3f5d43$var$de_CalculateRouteSummary(_, context)
    });
    Object.assign(contents, doc);
    return contents;
};
const $0a8265f77a3f5d43$export$7ea97460c320ec09 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $0a8265f77a3f5d43$var$de_CommandError(output, context);
    const contents = (0, $eJMW4.map)({
        $metadata: $0a8265f77a3f5d43$var$deserializeMetadata(output)
    });
    const data = (0, $cXA1B.expectNonNull)((0, $cXA1B.expectObject)(await (0, $3Z3zT.parseJsonBody)(output.body, context)), "body");
    const doc = (0, $eJMW4.take)(data, {
        RouteMatrix: (_)=>$0a8265f77a3f5d43$var$de_RouteMatrix(_, context),
        SnappedDeparturePositions: (_)=>$0a8265f77a3f5d43$var$de_PositionList(_, context),
        SnappedDestinationPositions: (_)=>$0a8265f77a3f5d43$var$de_PositionList(_, context),
        Summary: (0, $Phm09._json)
    });
    Object.assign(contents, doc);
    return contents;
};
const $0a8265f77a3f5d43$export$51b5e67859f16f24 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $0a8265f77a3f5d43$var$de_CommandError(output, context);
    const contents = (0, $eJMW4.map)({
        $metadata: $0a8265f77a3f5d43$var$deserializeMetadata(output)
    });
    const data = (0, $cXA1B.expectNonNull)((0, $cXA1B.expectObject)(await (0, $3Z3zT.parseJsonBody)(output.body, context)), "body");
    const doc = (0, $eJMW4.take)(data, {
        CollectionArn: (0, $cXA1B.expectString),
        CollectionName: (0, $cXA1B.expectString),
        CreateTime: (_)=>(0, $cXA1B.expectNonNull)((0, $d8z3h.parseRfc3339DateTimeWithOffset)(_))
    });
    Object.assign(contents, doc);
    return contents;
};
const $0a8265f77a3f5d43$export$fae44990197b63c0 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $0a8265f77a3f5d43$var$de_CommandError(output, context);
    const contents = (0, $eJMW4.map)({
        $metadata: $0a8265f77a3f5d43$var$deserializeMetadata(output)
    });
    const data = (0, $cXA1B.expectNonNull)((0, $cXA1B.expectObject)(await (0, $3Z3zT.parseJsonBody)(output.body, context)), "body");
    const doc = (0, $eJMW4.take)(data, {
        CreateTime: (_)=>(0, $cXA1B.expectNonNull)((0, $d8z3h.parseRfc3339DateTimeWithOffset)(_)),
        Key: (0, $cXA1B.expectString),
        KeyArn: (0, $cXA1B.expectString),
        KeyName: (0, $cXA1B.expectString)
    });
    Object.assign(contents, doc);
    return contents;
};
const $0a8265f77a3f5d43$export$ff361f1528f9219b = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $0a8265f77a3f5d43$var$de_CommandError(output, context);
    const contents = (0, $eJMW4.map)({
        $metadata: $0a8265f77a3f5d43$var$deserializeMetadata(output)
    });
    const data = (0, $cXA1B.expectNonNull)((0, $cXA1B.expectObject)(await (0, $3Z3zT.parseJsonBody)(output.body, context)), "body");
    const doc = (0, $eJMW4.take)(data, {
        CreateTime: (_)=>(0, $cXA1B.expectNonNull)((0, $d8z3h.parseRfc3339DateTimeWithOffset)(_)),
        MapArn: (0, $cXA1B.expectString),
        MapName: (0, $cXA1B.expectString)
    });
    Object.assign(contents, doc);
    return contents;
};
const $0a8265f77a3f5d43$export$b9e9a21b76cd7e29 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $0a8265f77a3f5d43$var$de_CommandError(output, context);
    const contents = (0, $eJMW4.map)({
        $metadata: $0a8265f77a3f5d43$var$deserializeMetadata(output)
    });
    const data = (0, $cXA1B.expectNonNull)((0, $cXA1B.expectObject)(await (0, $3Z3zT.parseJsonBody)(output.body, context)), "body");
    const doc = (0, $eJMW4.take)(data, {
        CreateTime: (_)=>(0, $cXA1B.expectNonNull)((0, $d8z3h.parseRfc3339DateTimeWithOffset)(_)),
        IndexArn: (0, $cXA1B.expectString),
        IndexName: (0, $cXA1B.expectString)
    });
    Object.assign(contents, doc);
    return contents;
};
const $0a8265f77a3f5d43$export$9d5c92704a996198 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $0a8265f77a3f5d43$var$de_CommandError(output, context);
    const contents = (0, $eJMW4.map)({
        $metadata: $0a8265f77a3f5d43$var$deserializeMetadata(output)
    });
    const data = (0, $cXA1B.expectNonNull)((0, $cXA1B.expectObject)(await (0, $3Z3zT.parseJsonBody)(output.body, context)), "body");
    const doc = (0, $eJMW4.take)(data, {
        CalculatorArn: (0, $cXA1B.expectString),
        CalculatorName: (0, $cXA1B.expectString),
        CreateTime: (_)=>(0, $cXA1B.expectNonNull)((0, $d8z3h.parseRfc3339DateTimeWithOffset)(_))
    });
    Object.assign(contents, doc);
    return contents;
};
const $0a8265f77a3f5d43$export$d194523c79c6d = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $0a8265f77a3f5d43$var$de_CommandError(output, context);
    const contents = (0, $eJMW4.map)({
        $metadata: $0a8265f77a3f5d43$var$deserializeMetadata(output)
    });
    const data = (0, $cXA1B.expectNonNull)((0, $cXA1B.expectObject)(await (0, $3Z3zT.parseJsonBody)(output.body, context)), "body");
    const doc = (0, $eJMW4.take)(data, {
        CreateTime: (_)=>(0, $cXA1B.expectNonNull)((0, $d8z3h.parseRfc3339DateTimeWithOffset)(_)),
        TrackerArn: (0, $cXA1B.expectString),
        TrackerName: (0, $cXA1B.expectString)
    });
    Object.assign(contents, doc);
    return contents;
};
const $0a8265f77a3f5d43$export$4423c2e3d944f6c4 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $0a8265f77a3f5d43$var$de_CommandError(output, context);
    const contents = (0, $eJMW4.map)({
        $metadata: $0a8265f77a3f5d43$var$deserializeMetadata(output)
    });
    await (0, $7fiNM.collectBody)(output.body, context);
    return contents;
};
const $0a8265f77a3f5d43$export$d4608655142df307 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $0a8265f77a3f5d43$var$de_CommandError(output, context);
    const contents = (0, $eJMW4.map)({
        $metadata: $0a8265f77a3f5d43$var$deserializeMetadata(output)
    });
    await (0, $7fiNM.collectBody)(output.body, context);
    return contents;
};
const $0a8265f77a3f5d43$export$960a9b9da4a2f07c = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $0a8265f77a3f5d43$var$de_CommandError(output, context);
    const contents = (0, $eJMW4.map)({
        $metadata: $0a8265f77a3f5d43$var$deserializeMetadata(output)
    });
    await (0, $7fiNM.collectBody)(output.body, context);
    return contents;
};
const $0a8265f77a3f5d43$export$82d3181d8eb14e79 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $0a8265f77a3f5d43$var$de_CommandError(output, context);
    const contents = (0, $eJMW4.map)({
        $metadata: $0a8265f77a3f5d43$var$deserializeMetadata(output)
    });
    await (0, $7fiNM.collectBody)(output.body, context);
    return contents;
};
const $0a8265f77a3f5d43$export$66fba419aac31f07 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $0a8265f77a3f5d43$var$de_CommandError(output, context);
    const contents = (0, $eJMW4.map)({
        $metadata: $0a8265f77a3f5d43$var$deserializeMetadata(output)
    });
    await (0, $7fiNM.collectBody)(output.body, context);
    return contents;
};
const $0a8265f77a3f5d43$export$90ccd67869371718 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $0a8265f77a3f5d43$var$de_CommandError(output, context);
    const contents = (0, $eJMW4.map)({
        $metadata: $0a8265f77a3f5d43$var$deserializeMetadata(output)
    });
    await (0, $7fiNM.collectBody)(output.body, context);
    return contents;
};
const $0a8265f77a3f5d43$export$ef956f74214078dd = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $0a8265f77a3f5d43$var$de_CommandError(output, context);
    const contents = (0, $eJMW4.map)({
        $metadata: $0a8265f77a3f5d43$var$deserializeMetadata(output)
    });
    const data = (0, $cXA1B.expectNonNull)((0, $cXA1B.expectObject)(await (0, $3Z3zT.parseJsonBody)(output.body, context)), "body");
    const doc = (0, $eJMW4.take)(data, {
        CollectionArn: (0, $cXA1B.expectString),
        CollectionName: (0, $cXA1B.expectString),
        CreateTime: (_)=>(0, $cXA1B.expectNonNull)((0, $d8z3h.parseRfc3339DateTimeWithOffset)(_)),
        Description: (0, $cXA1B.expectString),
        GeofenceCount: (0, $cXA1B.expectInt32),
        KmsKeyId: (0, $cXA1B.expectString),
        PricingPlan: (0, $cXA1B.expectString),
        PricingPlanDataSource: (0, $cXA1B.expectString),
        Tags: (0, $Phm09._json),
        UpdateTime: (_)=>(0, $cXA1B.expectNonNull)((0, $d8z3h.parseRfc3339DateTimeWithOffset)(_))
    });
    Object.assign(contents, doc);
    return contents;
};
const $0a8265f77a3f5d43$export$e94b30f79201765e = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $0a8265f77a3f5d43$var$de_CommandError(output, context);
    const contents = (0, $eJMW4.map)({
        $metadata: $0a8265f77a3f5d43$var$deserializeMetadata(output)
    });
    const data = (0, $cXA1B.expectNonNull)((0, $cXA1B.expectObject)(await (0, $3Z3zT.parseJsonBody)(output.body, context)), "body");
    const doc = (0, $eJMW4.take)(data, {
        CreateTime: (_)=>(0, $cXA1B.expectNonNull)((0, $d8z3h.parseRfc3339DateTimeWithOffset)(_)),
        Description: (0, $cXA1B.expectString),
        ExpireTime: (_)=>(0, $cXA1B.expectNonNull)((0, $d8z3h.parseRfc3339DateTimeWithOffset)(_)),
        Key: (0, $cXA1B.expectString),
        KeyArn: (0, $cXA1B.expectString),
        KeyName: (0, $cXA1B.expectString),
        Restrictions: (0, $Phm09._json),
        Tags: (0, $Phm09._json),
        UpdateTime: (_)=>(0, $cXA1B.expectNonNull)((0, $d8z3h.parseRfc3339DateTimeWithOffset)(_))
    });
    Object.assign(contents, doc);
    return contents;
};
const $0a8265f77a3f5d43$export$9dd637dd82f13fcb = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $0a8265f77a3f5d43$var$de_CommandError(output, context);
    const contents = (0, $eJMW4.map)({
        $metadata: $0a8265f77a3f5d43$var$deserializeMetadata(output)
    });
    const data = (0, $cXA1B.expectNonNull)((0, $cXA1B.expectObject)(await (0, $3Z3zT.parseJsonBody)(output.body, context)), "body");
    const doc = (0, $eJMW4.take)(data, {
        Configuration: (0, $Phm09._json),
        CreateTime: (_)=>(0, $cXA1B.expectNonNull)((0, $d8z3h.parseRfc3339DateTimeWithOffset)(_)),
        DataSource: (0, $cXA1B.expectString),
        Description: (0, $cXA1B.expectString),
        MapArn: (0, $cXA1B.expectString),
        MapName: (0, $cXA1B.expectString),
        PricingPlan: (0, $cXA1B.expectString),
        Tags: (0, $Phm09._json),
        UpdateTime: (_)=>(0, $cXA1B.expectNonNull)((0, $d8z3h.parseRfc3339DateTimeWithOffset)(_))
    });
    Object.assign(contents, doc);
    return contents;
};
const $0a8265f77a3f5d43$export$3596fd31a1478f57 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $0a8265f77a3f5d43$var$de_CommandError(output, context);
    const contents = (0, $eJMW4.map)({
        $metadata: $0a8265f77a3f5d43$var$deserializeMetadata(output)
    });
    const data = (0, $cXA1B.expectNonNull)((0, $cXA1B.expectObject)(await (0, $3Z3zT.parseJsonBody)(output.body, context)), "body");
    const doc = (0, $eJMW4.take)(data, {
        CreateTime: (_)=>(0, $cXA1B.expectNonNull)((0, $d8z3h.parseRfc3339DateTimeWithOffset)(_)),
        DataSource: (0, $cXA1B.expectString),
        DataSourceConfiguration: (0, $Phm09._json),
        Description: (0, $cXA1B.expectString),
        IndexArn: (0, $cXA1B.expectString),
        IndexName: (0, $cXA1B.expectString),
        PricingPlan: (0, $cXA1B.expectString),
        Tags: (0, $Phm09._json),
        UpdateTime: (_)=>(0, $cXA1B.expectNonNull)((0, $d8z3h.parseRfc3339DateTimeWithOffset)(_))
    });
    Object.assign(contents, doc);
    return contents;
};
const $0a8265f77a3f5d43$export$5f52411c8b1129f1 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $0a8265f77a3f5d43$var$de_CommandError(output, context);
    const contents = (0, $eJMW4.map)({
        $metadata: $0a8265f77a3f5d43$var$deserializeMetadata(output)
    });
    const data = (0, $cXA1B.expectNonNull)((0, $cXA1B.expectObject)(await (0, $3Z3zT.parseJsonBody)(output.body, context)), "body");
    const doc = (0, $eJMW4.take)(data, {
        CalculatorArn: (0, $cXA1B.expectString),
        CalculatorName: (0, $cXA1B.expectString),
        CreateTime: (_)=>(0, $cXA1B.expectNonNull)((0, $d8z3h.parseRfc3339DateTimeWithOffset)(_)),
        DataSource: (0, $cXA1B.expectString),
        Description: (0, $cXA1B.expectString),
        PricingPlan: (0, $cXA1B.expectString),
        Tags: (0, $Phm09._json),
        UpdateTime: (_)=>(0, $cXA1B.expectNonNull)((0, $d8z3h.parseRfc3339DateTimeWithOffset)(_))
    });
    Object.assign(contents, doc);
    return contents;
};
const $0a8265f77a3f5d43$export$39cea91c2949baf9 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $0a8265f77a3f5d43$var$de_CommandError(output, context);
    const contents = (0, $eJMW4.map)({
        $metadata: $0a8265f77a3f5d43$var$deserializeMetadata(output)
    });
    const data = (0, $cXA1B.expectNonNull)((0, $cXA1B.expectObject)(await (0, $3Z3zT.parseJsonBody)(output.body, context)), "body");
    const doc = (0, $eJMW4.take)(data, {
        CreateTime: (_)=>(0, $cXA1B.expectNonNull)((0, $d8z3h.parseRfc3339DateTimeWithOffset)(_)),
        Description: (0, $cXA1B.expectString),
        EventBridgeEnabled: (0, $cXA1B.expectBoolean),
        KmsKeyEnableGeospatialQueries: (0, $cXA1B.expectBoolean),
        KmsKeyId: (0, $cXA1B.expectString),
        PositionFiltering: (0, $cXA1B.expectString),
        PricingPlan: (0, $cXA1B.expectString),
        PricingPlanDataSource: (0, $cXA1B.expectString),
        Tags: (0, $Phm09._json),
        TrackerArn: (0, $cXA1B.expectString),
        TrackerName: (0, $cXA1B.expectString),
        UpdateTime: (_)=>(0, $cXA1B.expectNonNull)((0, $d8z3h.parseRfc3339DateTimeWithOffset)(_))
    });
    Object.assign(contents, doc);
    return contents;
};
const $0a8265f77a3f5d43$export$fcb942f8d997c640 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $0a8265f77a3f5d43$var$de_CommandError(output, context);
    const contents = (0, $eJMW4.map)({
        $metadata: $0a8265f77a3f5d43$var$deserializeMetadata(output)
    });
    await (0, $7fiNM.collectBody)(output.body, context);
    return contents;
};
const $0a8265f77a3f5d43$export$217ce85046a90f4b = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $0a8265f77a3f5d43$var$de_CommandError(output, context);
    const contents = (0, $eJMW4.map)({
        $metadata: $0a8265f77a3f5d43$var$deserializeMetadata(output)
    });
    const data = (0, $cXA1B.expectNonNull)((0, $cXA1B.expectObject)(await (0, $3Z3zT.parseJsonBody)(output.body, context)), "body");
    const doc = (0, $eJMW4.take)(data, {
        Accuracy: (_)=>$0a8265f77a3f5d43$var$de_PositionalAccuracy(_, context),
        DeviceId: (0, $cXA1B.expectString),
        Position: (_)=>$0a8265f77a3f5d43$var$de_Position(_, context),
        PositionProperties: (0, $Phm09._json),
        ReceivedTime: (_)=>(0, $cXA1B.expectNonNull)((0, $d8z3h.parseRfc3339DateTimeWithOffset)(_)),
        SampleTime: (_)=>(0, $cXA1B.expectNonNull)((0, $d8z3h.parseRfc3339DateTimeWithOffset)(_))
    });
    Object.assign(contents, doc);
    return contents;
};
const $0a8265f77a3f5d43$export$d098a0a232eabf2e = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $0a8265f77a3f5d43$var$de_CommandError(output, context);
    const contents = (0, $eJMW4.map)({
        $metadata: $0a8265f77a3f5d43$var$deserializeMetadata(output)
    });
    const data = (0, $cXA1B.expectNonNull)((0, $cXA1B.expectObject)(await (0, $3Z3zT.parseJsonBody)(output.body, context)), "body");
    const doc = (0, $eJMW4.take)(data, {
        DevicePositions: (_)=>$0a8265f77a3f5d43$var$de_DevicePositionList(_, context),
        NextToken: (0, $cXA1B.expectString)
    });
    Object.assign(contents, doc);
    return contents;
};
const $0a8265f77a3f5d43$export$59c1c07c66ede6b5 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $0a8265f77a3f5d43$var$de_CommandError(output, context);
    const contents = (0, $eJMW4.map)({
        $metadata: $0a8265f77a3f5d43$var$deserializeMetadata(output)
    });
    const data = (0, $cXA1B.expectNonNull)((0, $cXA1B.expectObject)(await (0, $3Z3zT.parseJsonBody)(output.body, context)), "body");
    const doc = (0, $eJMW4.take)(data, {
        CreateTime: (_)=>(0, $cXA1B.expectNonNull)((0, $d8z3h.parseRfc3339DateTimeWithOffset)(_)),
        GeofenceId: (0, $cXA1B.expectString),
        GeofenceProperties: (0, $Phm09._json),
        Geometry: (_)=>$0a8265f77a3f5d43$var$de_GeofenceGeometry(_, context),
        Status: (0, $cXA1B.expectString),
        UpdateTime: (_)=>(0, $cXA1B.expectNonNull)((0, $d8z3h.parseRfc3339DateTimeWithOffset)(_))
    });
    Object.assign(contents, doc);
    return contents;
};
const $0a8265f77a3f5d43$export$82582901e7da8052 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $0a8265f77a3f5d43$var$de_CommandError(output, context);
    const contents = (0, $eJMW4.map)({
        $metadata: $0a8265f77a3f5d43$var$deserializeMetadata(output),
        [$0a8265f77a3f5d43$var$_CT]: [
            ,
            output.headers[$0a8265f77a3f5d43$var$_ct]
        ],
        [$0a8265f77a3f5d43$var$_CC]: [
            ,
            output.headers[$0a8265f77a3f5d43$var$_cc]
        ]
    });
    const data = await (0, $7fiNM.collectBody)(output.body, context);
    contents.Blob = data;
    return contents;
};
const $0a8265f77a3f5d43$export$d9305f43dbb9fa62 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $0a8265f77a3f5d43$var$de_CommandError(output, context);
    const contents = (0, $eJMW4.map)({
        $metadata: $0a8265f77a3f5d43$var$deserializeMetadata(output),
        [$0a8265f77a3f5d43$var$_CT]: [
            ,
            output.headers[$0a8265f77a3f5d43$var$_ct]
        ],
        [$0a8265f77a3f5d43$var$_CC]: [
            ,
            output.headers[$0a8265f77a3f5d43$var$_cc]
        ]
    });
    const data = await (0, $7fiNM.collectBody)(output.body, context);
    contents.Blob = data;
    return contents;
};
const $0a8265f77a3f5d43$export$c0a81d552807804d = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $0a8265f77a3f5d43$var$de_CommandError(output, context);
    const contents = (0, $eJMW4.map)({
        $metadata: $0a8265f77a3f5d43$var$deserializeMetadata(output),
        [$0a8265f77a3f5d43$var$_CT]: [
            ,
            output.headers[$0a8265f77a3f5d43$var$_ct]
        ],
        [$0a8265f77a3f5d43$var$_CC]: [
            ,
            output.headers[$0a8265f77a3f5d43$var$_cc]
        ]
    });
    const data = await (0, $7fiNM.collectBody)(output.body, context);
    contents.Blob = data;
    return contents;
};
const $0a8265f77a3f5d43$export$5c660c936e5c83ea = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $0a8265f77a3f5d43$var$de_CommandError(output, context);
    const contents = (0, $eJMW4.map)({
        $metadata: $0a8265f77a3f5d43$var$deserializeMetadata(output),
        [$0a8265f77a3f5d43$var$_CT]: [
            ,
            output.headers[$0a8265f77a3f5d43$var$_ct]
        ],
        [$0a8265f77a3f5d43$var$_CC]: [
            ,
            output.headers[$0a8265f77a3f5d43$var$_cc]
        ]
    });
    const data = await (0, $7fiNM.collectBody)(output.body, context);
    contents.Blob = data;
    return contents;
};
const $0a8265f77a3f5d43$export$565d6139ff290475 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $0a8265f77a3f5d43$var$de_CommandError(output, context);
    const contents = (0, $eJMW4.map)({
        $metadata: $0a8265f77a3f5d43$var$deserializeMetadata(output)
    });
    const data = (0, $cXA1B.expectNonNull)((0, $cXA1B.expectObject)(await (0, $3Z3zT.parseJsonBody)(output.body, context)), "body");
    const doc = (0, $eJMW4.take)(data, {
        Place: (_)=>$0a8265f77a3f5d43$var$de_Place(_, context)
    });
    Object.assign(contents, doc);
    return contents;
};
const $0a8265f77a3f5d43$export$700f17aaf15b490a = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $0a8265f77a3f5d43$var$de_CommandError(output, context);
    const contents = (0, $eJMW4.map)({
        $metadata: $0a8265f77a3f5d43$var$deserializeMetadata(output)
    });
    const data = (0, $cXA1B.expectNonNull)((0, $cXA1B.expectObject)(await (0, $3Z3zT.parseJsonBody)(output.body, context)), "body");
    const doc = (0, $eJMW4.take)(data, {
        Entries: (_)=>$0a8265f77a3f5d43$var$de_ListDevicePositionsResponseEntryList(_, context),
        NextToken: (0, $cXA1B.expectString)
    });
    Object.assign(contents, doc);
    return contents;
};
const $0a8265f77a3f5d43$export$caf6aaf94f63adf9 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $0a8265f77a3f5d43$var$de_CommandError(output, context);
    const contents = (0, $eJMW4.map)({
        $metadata: $0a8265f77a3f5d43$var$deserializeMetadata(output)
    });
    const data = (0, $cXA1B.expectNonNull)((0, $cXA1B.expectObject)(await (0, $3Z3zT.parseJsonBody)(output.body, context)), "body");
    const doc = (0, $eJMW4.take)(data, {
        Entries: (_)=>$0a8265f77a3f5d43$var$de_ListGeofenceCollectionsResponseEntryList(_, context),
        NextToken: (0, $cXA1B.expectString)
    });
    Object.assign(contents, doc);
    return contents;
};
const $0a8265f77a3f5d43$export$25703e931db1244f = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $0a8265f77a3f5d43$var$de_CommandError(output, context);
    const contents = (0, $eJMW4.map)({
        $metadata: $0a8265f77a3f5d43$var$deserializeMetadata(output)
    });
    const data = (0, $cXA1B.expectNonNull)((0, $cXA1B.expectObject)(await (0, $3Z3zT.parseJsonBody)(output.body, context)), "body");
    const doc = (0, $eJMW4.take)(data, {
        Entries: (_)=>$0a8265f77a3f5d43$var$de_ListGeofenceResponseEntryList(_, context),
        NextToken: (0, $cXA1B.expectString)
    });
    Object.assign(contents, doc);
    return contents;
};
const $0a8265f77a3f5d43$export$1c84fbae48c61bbd = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $0a8265f77a3f5d43$var$de_CommandError(output, context);
    const contents = (0, $eJMW4.map)({
        $metadata: $0a8265f77a3f5d43$var$deserializeMetadata(output)
    });
    const data = (0, $cXA1B.expectNonNull)((0, $cXA1B.expectObject)(await (0, $3Z3zT.parseJsonBody)(output.body, context)), "body");
    const doc = (0, $eJMW4.take)(data, {
        Entries: (_)=>$0a8265f77a3f5d43$var$de_ListKeysResponseEntryList(_, context),
        NextToken: (0, $cXA1B.expectString)
    });
    Object.assign(contents, doc);
    return contents;
};
const $0a8265f77a3f5d43$export$a31e30081f068aa3 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $0a8265f77a3f5d43$var$de_CommandError(output, context);
    const contents = (0, $eJMW4.map)({
        $metadata: $0a8265f77a3f5d43$var$deserializeMetadata(output)
    });
    const data = (0, $cXA1B.expectNonNull)((0, $cXA1B.expectObject)(await (0, $3Z3zT.parseJsonBody)(output.body, context)), "body");
    const doc = (0, $eJMW4.take)(data, {
        Entries: (_)=>$0a8265f77a3f5d43$var$de_ListMapsResponseEntryList(_, context),
        NextToken: (0, $cXA1B.expectString)
    });
    Object.assign(contents, doc);
    return contents;
};
const $0a8265f77a3f5d43$export$1acf8176359716ac = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $0a8265f77a3f5d43$var$de_CommandError(output, context);
    const contents = (0, $eJMW4.map)({
        $metadata: $0a8265f77a3f5d43$var$deserializeMetadata(output)
    });
    const data = (0, $cXA1B.expectNonNull)((0, $cXA1B.expectObject)(await (0, $3Z3zT.parseJsonBody)(output.body, context)), "body");
    const doc = (0, $eJMW4.take)(data, {
        Entries: (_)=>$0a8265f77a3f5d43$var$de_ListPlaceIndexesResponseEntryList(_, context),
        NextToken: (0, $cXA1B.expectString)
    });
    Object.assign(contents, doc);
    return contents;
};
const $0a8265f77a3f5d43$export$d942a485900c3a63 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $0a8265f77a3f5d43$var$de_CommandError(output, context);
    const contents = (0, $eJMW4.map)({
        $metadata: $0a8265f77a3f5d43$var$deserializeMetadata(output)
    });
    const data = (0, $cXA1B.expectNonNull)((0, $cXA1B.expectObject)(await (0, $3Z3zT.parseJsonBody)(output.body, context)), "body");
    const doc = (0, $eJMW4.take)(data, {
        Entries: (_)=>$0a8265f77a3f5d43$var$de_ListRouteCalculatorsResponseEntryList(_, context),
        NextToken: (0, $cXA1B.expectString)
    });
    Object.assign(contents, doc);
    return contents;
};
const $0a8265f77a3f5d43$export$16d701d259e88048 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $0a8265f77a3f5d43$var$de_CommandError(output, context);
    const contents = (0, $eJMW4.map)({
        $metadata: $0a8265f77a3f5d43$var$deserializeMetadata(output)
    });
    const data = (0, $cXA1B.expectNonNull)((0, $cXA1B.expectObject)(await (0, $3Z3zT.parseJsonBody)(output.body, context)), "body");
    const doc = (0, $eJMW4.take)(data, {
        Tags: (0, $Phm09._json)
    });
    Object.assign(contents, doc);
    return contents;
};
const $0a8265f77a3f5d43$export$5a23c8ea60f34458 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $0a8265f77a3f5d43$var$de_CommandError(output, context);
    const contents = (0, $eJMW4.map)({
        $metadata: $0a8265f77a3f5d43$var$deserializeMetadata(output)
    });
    const data = (0, $cXA1B.expectNonNull)((0, $cXA1B.expectObject)(await (0, $3Z3zT.parseJsonBody)(output.body, context)), "body");
    const doc = (0, $eJMW4.take)(data, {
        ConsumerArns: (0, $Phm09._json),
        NextToken: (0, $cXA1B.expectString)
    });
    Object.assign(contents, doc);
    return contents;
};
const $0a8265f77a3f5d43$export$b46ba15db0e5293d = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $0a8265f77a3f5d43$var$de_CommandError(output, context);
    const contents = (0, $eJMW4.map)({
        $metadata: $0a8265f77a3f5d43$var$deserializeMetadata(output)
    });
    const data = (0, $cXA1B.expectNonNull)((0, $cXA1B.expectObject)(await (0, $3Z3zT.parseJsonBody)(output.body, context)), "body");
    const doc = (0, $eJMW4.take)(data, {
        Entries: (_)=>$0a8265f77a3f5d43$var$de_ListTrackersResponseEntryList(_, context),
        NextToken: (0, $cXA1B.expectString)
    });
    Object.assign(contents, doc);
    return contents;
};
const $0a8265f77a3f5d43$export$2f3a609a1092719b = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $0a8265f77a3f5d43$var$de_CommandError(output, context);
    const contents = (0, $eJMW4.map)({
        $metadata: $0a8265f77a3f5d43$var$deserializeMetadata(output)
    });
    const data = (0, $cXA1B.expectNonNull)((0, $cXA1B.expectObject)(await (0, $3Z3zT.parseJsonBody)(output.body, context)), "body");
    const doc = (0, $eJMW4.take)(data, {
        CreateTime: (_)=>(0, $cXA1B.expectNonNull)((0, $d8z3h.parseRfc3339DateTimeWithOffset)(_)),
        GeofenceId: (0, $cXA1B.expectString),
        UpdateTime: (_)=>(0, $cXA1B.expectNonNull)((0, $d8z3h.parseRfc3339DateTimeWithOffset)(_))
    });
    Object.assign(contents, doc);
    return contents;
};
const $0a8265f77a3f5d43$export$f1046c9c0a8aa1af = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $0a8265f77a3f5d43$var$de_CommandError(output, context);
    const contents = (0, $eJMW4.map)({
        $metadata: $0a8265f77a3f5d43$var$deserializeMetadata(output)
    });
    const data = (0, $cXA1B.expectNonNull)((0, $cXA1B.expectObject)(await (0, $3Z3zT.parseJsonBody)(output.body, context)), "body");
    const doc = (0, $eJMW4.take)(data, {
        Results: (_)=>$0a8265f77a3f5d43$var$de_SearchForPositionResultList(_, context),
        Summary: (_)=>$0a8265f77a3f5d43$var$de_SearchPlaceIndexForPositionSummary(_, context)
    });
    Object.assign(contents, doc);
    return contents;
};
const $0a8265f77a3f5d43$export$41b70e95e84dc25d = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $0a8265f77a3f5d43$var$de_CommandError(output, context);
    const contents = (0, $eJMW4.map)({
        $metadata: $0a8265f77a3f5d43$var$deserializeMetadata(output)
    });
    const data = (0, $cXA1B.expectNonNull)((0, $cXA1B.expectObject)(await (0, $3Z3zT.parseJsonBody)(output.body, context)), "body");
    const doc = (0, $eJMW4.take)(data, {
        Results: (0, $Phm09._json),
        Summary: (_)=>$0a8265f77a3f5d43$var$de_SearchPlaceIndexForSuggestionsSummary(_, context)
    });
    Object.assign(contents, doc);
    return contents;
};
const $0a8265f77a3f5d43$export$ad7ccb9e9594ce33 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $0a8265f77a3f5d43$var$de_CommandError(output, context);
    const contents = (0, $eJMW4.map)({
        $metadata: $0a8265f77a3f5d43$var$deserializeMetadata(output)
    });
    const data = (0, $cXA1B.expectNonNull)((0, $cXA1B.expectObject)(await (0, $3Z3zT.parseJsonBody)(output.body, context)), "body");
    const doc = (0, $eJMW4.take)(data, {
        Results: (_)=>$0a8265f77a3f5d43$var$de_SearchForTextResultList(_, context),
        Summary: (_)=>$0a8265f77a3f5d43$var$de_SearchPlaceIndexForTextSummary(_, context)
    });
    Object.assign(contents, doc);
    return contents;
};
const $0a8265f77a3f5d43$export$dc0f1552868d13af = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $0a8265f77a3f5d43$var$de_CommandError(output, context);
    const contents = (0, $eJMW4.map)({
        $metadata: $0a8265f77a3f5d43$var$deserializeMetadata(output)
    });
    await (0, $7fiNM.collectBody)(output.body, context);
    return contents;
};
const $0a8265f77a3f5d43$export$9bdfbc7f21c1e48f = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $0a8265f77a3f5d43$var$de_CommandError(output, context);
    const contents = (0, $eJMW4.map)({
        $metadata: $0a8265f77a3f5d43$var$deserializeMetadata(output)
    });
    await (0, $7fiNM.collectBody)(output.body, context);
    return contents;
};
const $0a8265f77a3f5d43$export$f5b1bd087968e44f = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $0a8265f77a3f5d43$var$de_CommandError(output, context);
    const contents = (0, $eJMW4.map)({
        $metadata: $0a8265f77a3f5d43$var$deserializeMetadata(output)
    });
    const data = (0, $cXA1B.expectNonNull)((0, $cXA1B.expectObject)(await (0, $3Z3zT.parseJsonBody)(output.body, context)), "body");
    const doc = (0, $eJMW4.take)(data, {
        CollectionArn: (0, $cXA1B.expectString),
        CollectionName: (0, $cXA1B.expectString),
        UpdateTime: (_)=>(0, $cXA1B.expectNonNull)((0, $d8z3h.parseRfc3339DateTimeWithOffset)(_))
    });
    Object.assign(contents, doc);
    return contents;
};
const $0a8265f77a3f5d43$export$200a664ea3f0c959 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $0a8265f77a3f5d43$var$de_CommandError(output, context);
    const contents = (0, $eJMW4.map)({
        $metadata: $0a8265f77a3f5d43$var$deserializeMetadata(output)
    });
    const data = (0, $cXA1B.expectNonNull)((0, $cXA1B.expectObject)(await (0, $3Z3zT.parseJsonBody)(output.body, context)), "body");
    const doc = (0, $eJMW4.take)(data, {
        KeyArn: (0, $cXA1B.expectString),
        KeyName: (0, $cXA1B.expectString),
        UpdateTime: (_)=>(0, $cXA1B.expectNonNull)((0, $d8z3h.parseRfc3339DateTimeWithOffset)(_))
    });
    Object.assign(contents, doc);
    return contents;
};
const $0a8265f77a3f5d43$export$b49ef45c91247b58 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $0a8265f77a3f5d43$var$de_CommandError(output, context);
    const contents = (0, $eJMW4.map)({
        $metadata: $0a8265f77a3f5d43$var$deserializeMetadata(output)
    });
    const data = (0, $cXA1B.expectNonNull)((0, $cXA1B.expectObject)(await (0, $3Z3zT.parseJsonBody)(output.body, context)), "body");
    const doc = (0, $eJMW4.take)(data, {
        MapArn: (0, $cXA1B.expectString),
        MapName: (0, $cXA1B.expectString),
        UpdateTime: (_)=>(0, $cXA1B.expectNonNull)((0, $d8z3h.parseRfc3339DateTimeWithOffset)(_))
    });
    Object.assign(contents, doc);
    return contents;
};
const $0a8265f77a3f5d43$export$a5612bfd663968f4 = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $0a8265f77a3f5d43$var$de_CommandError(output, context);
    const contents = (0, $eJMW4.map)({
        $metadata: $0a8265f77a3f5d43$var$deserializeMetadata(output)
    });
    const data = (0, $cXA1B.expectNonNull)((0, $cXA1B.expectObject)(await (0, $3Z3zT.parseJsonBody)(output.body, context)), "body");
    const doc = (0, $eJMW4.take)(data, {
        IndexArn: (0, $cXA1B.expectString),
        IndexName: (0, $cXA1B.expectString),
        UpdateTime: (_)=>(0, $cXA1B.expectNonNull)((0, $d8z3h.parseRfc3339DateTimeWithOffset)(_))
    });
    Object.assign(contents, doc);
    return contents;
};
const $0a8265f77a3f5d43$export$adf77c638f9cb02f = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $0a8265f77a3f5d43$var$de_CommandError(output, context);
    const contents = (0, $eJMW4.map)({
        $metadata: $0a8265f77a3f5d43$var$deserializeMetadata(output)
    });
    const data = (0, $cXA1B.expectNonNull)((0, $cXA1B.expectObject)(await (0, $3Z3zT.parseJsonBody)(output.body, context)), "body");
    const doc = (0, $eJMW4.take)(data, {
        CalculatorArn: (0, $cXA1B.expectString),
        CalculatorName: (0, $cXA1B.expectString),
        UpdateTime: (_)=>(0, $cXA1B.expectNonNull)((0, $d8z3h.parseRfc3339DateTimeWithOffset)(_))
    });
    Object.assign(contents, doc);
    return contents;
};
const $0a8265f77a3f5d43$export$fc39eab44ea4bcee = async (output, context)=>{
    if (output.statusCode !== 200 && output.statusCode >= 300) return $0a8265f77a3f5d43$var$de_CommandError(output, context);
    const contents = (0, $eJMW4.map)({
        $metadata: $0a8265f77a3f5d43$var$deserializeMetadata(output)
    });
    const data = (0, $cXA1B.expectNonNull)((0, $cXA1B.expectObject)(await (0, $3Z3zT.parseJsonBody)(output.body, context)), "body");
    const doc = (0, $eJMW4.take)(data, {
        TrackerArn: (0, $cXA1B.expectString),
        TrackerName: (0, $cXA1B.expectString),
        UpdateTime: (_)=>(0, $cXA1B.expectNonNull)((0, $d8z3h.parseRfc3339DateTimeWithOffset)(_))
    });
    Object.assign(contents, doc);
    return contents;
};
const $0a8265f77a3f5d43$var$de_CommandError = async (output, context)=>{
    const parsedOutput = {
        ...output,
        body: await (0, $3Z3zT.parseJsonErrorBody)(output.body, context)
    };
    const errorCode = (0, $3Z3zT.loadRestJsonErrorCode)(output, parsedOutput.body);
    switch(errorCode){
        case "AccessDeniedException":
        case "com.amazonaws.location#AccessDeniedException":
            throw await $0a8265f77a3f5d43$var$de_AccessDeniedExceptionRes(parsedOutput, context);
        case "ConflictException":
        case "com.amazonaws.location#ConflictException":
            throw await $0a8265f77a3f5d43$var$de_ConflictExceptionRes(parsedOutput, context);
        case "InternalServerException":
        case "com.amazonaws.location#InternalServerException":
            throw await $0a8265f77a3f5d43$var$de_InternalServerExceptionRes(parsedOutput, context);
        case "ResourceNotFoundException":
        case "com.amazonaws.location#ResourceNotFoundException":
            throw await $0a8265f77a3f5d43$var$de_ResourceNotFoundExceptionRes(parsedOutput, context);
        case "ServiceQuotaExceededException":
        case "com.amazonaws.location#ServiceQuotaExceededException":
            throw await $0a8265f77a3f5d43$var$de_ServiceQuotaExceededExceptionRes(parsedOutput, context);
        case "ThrottlingException":
        case "com.amazonaws.location#ThrottlingException":
            throw await $0a8265f77a3f5d43$var$de_ThrottlingExceptionRes(parsedOutput, context);
        case "ValidationException":
        case "com.amazonaws.location#ValidationException":
            throw await $0a8265f77a3f5d43$var$de_ValidationExceptionRes(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            return $0a8265f77a3f5d43$var$throwDefaultError({
                output: output,
                parsedBody: parsedBody,
                errorCode: errorCode
            });
    }
};
const $0a8265f77a3f5d43$var$throwDefaultError = (0, $cYbAK.withBaseException)((0, $e39b019f324fbd4d$export$ac9195663c1b5e3a));
const $0a8265f77a3f5d43$var$de_AccessDeniedExceptionRes = async (parsedOutput, context)=>{
    const contents = (0, $eJMW4.map)({});
    const data = parsedOutput.body;
    const doc = (0, $eJMW4.take)(data, {
        Message: [
            ,
            (0, $cXA1B.expectString),
            `message`
        ]
    });
    Object.assign(contents, doc);
    const exception = new (0, $454857ac2a87e2c9$export$c8018838fe3c6395)({
        $metadata: $0a8265f77a3f5d43$var$deserializeMetadata(parsedOutput),
        ...contents
    });
    return (0, $1CRbD.decorateServiceException)(exception, parsedOutput.body);
};
const $0a8265f77a3f5d43$var$de_ConflictExceptionRes = async (parsedOutput, context)=>{
    const contents = (0, $eJMW4.map)({});
    const data = parsedOutput.body;
    const doc = (0, $eJMW4.take)(data, {
        Message: [
            ,
            (0, $cXA1B.expectString),
            `message`
        ]
    });
    Object.assign(contents, doc);
    const exception = new (0, $454857ac2a87e2c9$export$c64b14d0b7091188)({
        $metadata: $0a8265f77a3f5d43$var$deserializeMetadata(parsedOutput),
        ...contents
    });
    return (0, $1CRbD.decorateServiceException)(exception, parsedOutput.body);
};
const $0a8265f77a3f5d43$var$de_InternalServerExceptionRes = async (parsedOutput, context)=>{
    const contents = (0, $eJMW4.map)({});
    const data = parsedOutput.body;
    const doc = (0, $eJMW4.take)(data, {
        Message: [
            ,
            (0, $cXA1B.expectString),
            `message`
        ]
    });
    Object.assign(contents, doc);
    const exception = new (0, $454857ac2a87e2c9$export$e2a300c9568821ec)({
        $metadata: $0a8265f77a3f5d43$var$deserializeMetadata(parsedOutput),
        ...contents
    });
    return (0, $1CRbD.decorateServiceException)(exception, parsedOutput.body);
};
const $0a8265f77a3f5d43$var$de_ResourceNotFoundExceptionRes = async (parsedOutput, context)=>{
    const contents = (0, $eJMW4.map)({});
    const data = parsedOutput.body;
    const doc = (0, $eJMW4.take)(data, {
        Message: [
            ,
            (0, $cXA1B.expectString),
            `message`
        ]
    });
    Object.assign(contents, doc);
    const exception = new (0, $454857ac2a87e2c9$export$ecba565262f8bb2)({
        $metadata: $0a8265f77a3f5d43$var$deserializeMetadata(parsedOutput),
        ...contents
    });
    return (0, $1CRbD.decorateServiceException)(exception, parsedOutput.body);
};
const $0a8265f77a3f5d43$var$de_ServiceQuotaExceededExceptionRes = async (parsedOutput, context)=>{
    const contents = (0, $eJMW4.map)({});
    const data = parsedOutput.body;
    const doc = (0, $eJMW4.take)(data, {
        Message: [
            ,
            (0, $cXA1B.expectString),
            `message`
        ]
    });
    Object.assign(contents, doc);
    const exception = new (0, $454857ac2a87e2c9$export$1b9058cd2021c1aa)({
        $metadata: $0a8265f77a3f5d43$var$deserializeMetadata(parsedOutput),
        ...contents
    });
    return (0, $1CRbD.decorateServiceException)(exception, parsedOutput.body);
};
const $0a8265f77a3f5d43$var$de_ThrottlingExceptionRes = async (parsedOutput, context)=>{
    const contents = (0, $eJMW4.map)({});
    const data = parsedOutput.body;
    const doc = (0, $eJMW4.take)(data, {
        Message: [
            ,
            (0, $cXA1B.expectString),
            `message`
        ]
    });
    Object.assign(contents, doc);
    const exception = new (0, $454857ac2a87e2c9$export$f18ab84fe430e4f3)({
        $metadata: $0a8265f77a3f5d43$var$deserializeMetadata(parsedOutput),
        ...contents
    });
    return (0, $1CRbD.decorateServiceException)(exception, parsedOutput.body);
};
const $0a8265f77a3f5d43$var$de_ValidationExceptionRes = async (parsedOutput, context)=>{
    const contents = (0, $eJMW4.map)({});
    const data = parsedOutput.body;
    const doc = (0, $eJMW4.take)(data, {
        FieldList: [
            ,
            (_)=>$0a8265f77a3f5d43$var$de_ValidationExceptionFieldList(_, context),
            `fieldList`
        ],
        Message: [
            ,
            (0, $cXA1B.expectString),
            `message`
        ],
        Reason: [
            ,
            (0, $cXA1B.expectString),
            `reason`
        ]
    });
    Object.assign(contents, doc);
    const exception = new (0, $454857ac2a87e2c9$export$1dbb1718e06c41be)({
        $metadata: $0a8265f77a3f5d43$var$deserializeMetadata(parsedOutput),
        ...contents
    });
    return (0, $1CRbD.decorateServiceException)(exception, parsedOutput.body);
};
const $0a8265f77a3f5d43$var$se_BatchPutGeofenceRequestEntry = (input, context)=>{
    return (0, $eJMW4.take)(input, {
        GeofenceId: [],
        GeofenceProperties: (0, $Phm09._json),
        Geometry: (_)=>$0a8265f77a3f5d43$var$se_GeofenceGeometry(_, context)
    });
};
const $0a8265f77a3f5d43$var$se_BatchPutGeofenceRequestEntryList = (input, context)=>{
    return input.filter((e)=>e != null).map((entry)=>{
        return $0a8265f77a3f5d43$var$se_BatchPutGeofenceRequestEntry(entry, context);
    });
};
const $0a8265f77a3f5d43$var$se_BoundingBox = (input, context)=>{
    return input.filter((e)=>e != null).map((entry)=>{
        return (0, $iAvye.serializeFloat)(entry);
    });
};
const $0a8265f77a3f5d43$var$se_CalculateRouteTruckModeOptions = (input, context)=>{
    return (0, $eJMW4.take)(input, {
        AvoidFerries: [],
        AvoidTolls: [],
        Dimensions: (_)=>$0a8265f77a3f5d43$var$se_TruckDimensions(_, context),
        Weight: (_)=>$0a8265f77a3f5d43$var$se_TruckWeight(_, context)
    });
};
const $0a8265f77a3f5d43$var$se_Circle = (input, context)=>{
    return (0, $eJMW4.take)(input, {
        Center: (_)=>$0a8265f77a3f5d43$var$se_Position(_, context),
        Radius: (0, $iAvye.serializeFloat)
    });
};
const $0a8265f77a3f5d43$var$se_DevicePositionUpdate = (input, context)=>{
    return (0, $eJMW4.take)(input, {
        Accuracy: (_)=>$0a8265f77a3f5d43$var$se_PositionalAccuracy(_, context),
        DeviceId: [],
        Position: (_)=>$0a8265f77a3f5d43$var$se_Position(_, context),
        PositionProperties: (0, $Phm09._json),
        SampleTime: (_)=>_.toISOString().split(".")[0] + "Z"
    });
};
const $0a8265f77a3f5d43$var$se_DevicePositionUpdateList = (input, context)=>{
    return input.filter((e)=>e != null).map((entry)=>{
        return $0a8265f77a3f5d43$var$se_DevicePositionUpdate(entry, context);
    });
};
const $0a8265f77a3f5d43$var$se_GeofenceGeometry = (input, context)=>{
    return (0, $eJMW4.take)(input, {
        Circle: (_)=>$0a8265f77a3f5d43$var$se_Circle(_, context),
        Polygon: (_)=>$0a8265f77a3f5d43$var$se_LinearRings(_, context)
    });
};
const $0a8265f77a3f5d43$var$se_LinearRing = (input, context)=>{
    return input.filter((e)=>e != null).map((entry)=>{
        return $0a8265f77a3f5d43$var$se_Position(entry, context);
    });
};
const $0a8265f77a3f5d43$var$se_LinearRings = (input, context)=>{
    return input.filter((e)=>e != null).map((entry)=>{
        return $0a8265f77a3f5d43$var$se_LinearRing(entry, context);
    });
};
const $0a8265f77a3f5d43$var$se_Position = (input, context)=>{
    return input.filter((e)=>e != null).map((entry)=>{
        return (0, $iAvye.serializeFloat)(entry);
    });
};
const $0a8265f77a3f5d43$var$se_PositionalAccuracy = (input, context)=>{
    return (0, $eJMW4.take)(input, {
        Horizontal: (0, $iAvye.serializeFloat)
    });
};
const $0a8265f77a3f5d43$var$se_PositionList = (input, context)=>{
    return input.filter((e)=>e != null).map((entry)=>{
        return $0a8265f77a3f5d43$var$se_Position(entry, context);
    });
};
const $0a8265f77a3f5d43$var$se_TrackingFilterGeometry = (input, context)=>{
    return (0, $eJMW4.take)(input, {
        Polygon: (_)=>$0a8265f77a3f5d43$var$se_LinearRings(_, context)
    });
};
const $0a8265f77a3f5d43$var$se_TruckDimensions = (input, context)=>{
    return (0, $eJMW4.take)(input, {
        Height: (0, $iAvye.serializeFloat),
        Length: (0, $iAvye.serializeFloat),
        Unit: [],
        Width: (0, $iAvye.serializeFloat)
    });
};
const $0a8265f77a3f5d43$var$se_TruckWeight = (input, context)=>{
    return (0, $eJMW4.take)(input, {
        Total: (0, $iAvye.serializeFloat),
        Unit: []
    });
};
const $0a8265f77a3f5d43$var$se_WaypointPositionList = (input, context)=>{
    return input.filter((e)=>e != null).map((entry)=>{
        return $0a8265f77a3f5d43$var$se_Position(entry, context);
    });
};
const $0a8265f77a3f5d43$var$de_BatchEvaluateGeofencesError = (output, context)=>{
    return (0, $eJMW4.take)(output, {
        DeviceId: (0, $cXA1B.expectString),
        Error: (0, $Phm09._json),
        SampleTime: (_)=>(0, $cXA1B.expectNonNull)((0, $d8z3h.parseRfc3339DateTimeWithOffset)(_))
    });
};
const $0a8265f77a3f5d43$var$de_BatchEvaluateGeofencesErrorList = (output, context)=>{
    const retVal = (output || []).filter((e)=>e != null).map((entry)=>{
        return $0a8265f77a3f5d43$var$de_BatchEvaluateGeofencesError(entry, context);
    });
    return retVal;
};
const $0a8265f77a3f5d43$var$de_BatchPutGeofenceSuccess = (output, context)=>{
    return (0, $eJMW4.take)(output, {
        CreateTime: (_)=>(0, $cXA1B.expectNonNull)((0, $d8z3h.parseRfc3339DateTimeWithOffset)(_)),
        GeofenceId: (0, $cXA1B.expectString),
        UpdateTime: (_)=>(0, $cXA1B.expectNonNull)((0, $d8z3h.parseRfc3339DateTimeWithOffset)(_))
    });
};
const $0a8265f77a3f5d43$var$de_BatchPutGeofenceSuccessList = (output, context)=>{
    const retVal = (output || []).filter((e)=>e != null).map((entry)=>{
        return $0a8265f77a3f5d43$var$de_BatchPutGeofenceSuccess(entry, context);
    });
    return retVal;
};
const $0a8265f77a3f5d43$var$de_BatchUpdateDevicePositionError = (output, context)=>{
    return (0, $eJMW4.take)(output, {
        DeviceId: (0, $cXA1B.expectString),
        Error: (0, $Phm09._json),
        SampleTime: (_)=>(0, $cXA1B.expectNonNull)((0, $d8z3h.parseRfc3339DateTimeWithOffset)(_))
    });
};
const $0a8265f77a3f5d43$var$de_BatchUpdateDevicePositionErrorList = (output, context)=>{
    const retVal = (output || []).filter((e)=>e != null).map((entry)=>{
        return $0a8265f77a3f5d43$var$de_BatchUpdateDevicePositionError(entry, context);
    });
    return retVal;
};
const $0a8265f77a3f5d43$var$de_BoundingBox = (output, context)=>{
    const retVal = (output || []).filter((e)=>e != null).map((entry)=>{
        return (0, $cXA1B.limitedParseDouble)(entry);
    });
    return retVal;
};
const $0a8265f77a3f5d43$var$de_CalculateRouteSummary = (output, context)=>{
    return (0, $eJMW4.take)(output, {
        DataSource: (0, $cXA1B.expectString),
        Distance: (0, $cXA1B.limitedParseDouble),
        DistanceUnit: (0, $cXA1B.expectString),
        DurationSeconds: (0, $cXA1B.limitedParseDouble),
        RouteBBox: (_)=>$0a8265f77a3f5d43$var$de_BoundingBox(_, context)
    });
};
const $0a8265f77a3f5d43$var$de_Circle = (output, context)=>{
    return (0, $eJMW4.take)(output, {
        Center: (_)=>$0a8265f77a3f5d43$var$de_Position(_, context),
        Radius: (0, $cXA1B.limitedParseDouble)
    });
};
const $0a8265f77a3f5d43$var$de_DevicePosition = (output, context)=>{
    return (0, $eJMW4.take)(output, {
        Accuracy: (_)=>$0a8265f77a3f5d43$var$de_PositionalAccuracy(_, context),
        DeviceId: (0, $cXA1B.expectString),
        Position: (_)=>$0a8265f77a3f5d43$var$de_Position(_, context),
        PositionProperties: (0, $Phm09._json),
        ReceivedTime: (_)=>(0, $cXA1B.expectNonNull)((0, $d8z3h.parseRfc3339DateTimeWithOffset)(_)),
        SampleTime: (_)=>(0, $cXA1B.expectNonNull)((0, $d8z3h.parseRfc3339DateTimeWithOffset)(_))
    });
};
const $0a8265f77a3f5d43$var$de_DevicePositionList = (output, context)=>{
    const retVal = (output || []).filter((e)=>e != null).map((entry)=>{
        return $0a8265f77a3f5d43$var$de_DevicePosition(entry, context);
    });
    return retVal;
};
const $0a8265f77a3f5d43$var$de_GeofenceGeometry = (output, context)=>{
    return (0, $eJMW4.take)(output, {
        Circle: (_)=>$0a8265f77a3f5d43$var$de_Circle(_, context),
        Polygon: (_)=>$0a8265f77a3f5d43$var$de_LinearRings(_, context)
    });
};
const $0a8265f77a3f5d43$var$de_Leg = (output, context)=>{
    return (0, $eJMW4.take)(output, {
        Distance: (0, $cXA1B.limitedParseDouble),
        DurationSeconds: (0, $cXA1B.limitedParseDouble),
        EndPosition: (_)=>$0a8265f77a3f5d43$var$de_Position(_, context),
        Geometry: (_)=>$0a8265f77a3f5d43$var$de_LegGeometry(_, context),
        StartPosition: (_)=>$0a8265f77a3f5d43$var$de_Position(_, context),
        Steps: (_)=>$0a8265f77a3f5d43$var$de_StepList(_, context)
    });
};
const $0a8265f77a3f5d43$var$de_LegGeometry = (output, context)=>{
    return (0, $eJMW4.take)(output, {
        LineString: (_)=>$0a8265f77a3f5d43$var$de_LineString(_, context)
    });
};
const $0a8265f77a3f5d43$var$de_LegList = (output, context)=>{
    const retVal = (output || []).filter((e)=>e != null).map((entry)=>{
        return $0a8265f77a3f5d43$var$de_Leg(entry, context);
    });
    return retVal;
};
const $0a8265f77a3f5d43$var$de_LinearRing = (output, context)=>{
    const retVal = (output || []).filter((e)=>e != null).map((entry)=>{
        return $0a8265f77a3f5d43$var$de_Position(entry, context);
    });
    return retVal;
};
const $0a8265f77a3f5d43$var$de_LinearRings = (output, context)=>{
    const retVal = (output || []).filter((e)=>e != null).map((entry)=>{
        return $0a8265f77a3f5d43$var$de_LinearRing(entry, context);
    });
    return retVal;
};
const $0a8265f77a3f5d43$var$de_LineString = (output, context)=>{
    const retVal = (output || []).filter((e)=>e != null).map((entry)=>{
        return $0a8265f77a3f5d43$var$de_Position(entry, context);
    });
    return retVal;
};
const $0a8265f77a3f5d43$var$de_ListDevicePositionsResponseEntry = (output, context)=>{
    return (0, $eJMW4.take)(output, {
        Accuracy: (_)=>$0a8265f77a3f5d43$var$de_PositionalAccuracy(_, context),
        DeviceId: (0, $cXA1B.expectString),
        Position: (_)=>$0a8265f77a3f5d43$var$de_Position(_, context),
        PositionProperties: (0, $Phm09._json),
        SampleTime: (_)=>(0, $cXA1B.expectNonNull)((0, $d8z3h.parseRfc3339DateTimeWithOffset)(_))
    });
};
const $0a8265f77a3f5d43$var$de_ListDevicePositionsResponseEntryList = (output, context)=>{
    const retVal = (output || []).filter((e)=>e != null).map((entry)=>{
        return $0a8265f77a3f5d43$var$de_ListDevicePositionsResponseEntry(entry, context);
    });
    return retVal;
};
const $0a8265f77a3f5d43$var$de_ListGeofenceCollectionsResponseEntry = (output, context)=>{
    return (0, $eJMW4.take)(output, {
        CollectionName: (0, $cXA1B.expectString),
        CreateTime: (_)=>(0, $cXA1B.expectNonNull)((0, $d8z3h.parseRfc3339DateTimeWithOffset)(_)),
        Description: (0, $cXA1B.expectString),
        PricingPlan: (0, $cXA1B.expectString),
        PricingPlanDataSource: (0, $cXA1B.expectString),
        UpdateTime: (_)=>(0, $cXA1B.expectNonNull)((0, $d8z3h.parseRfc3339DateTimeWithOffset)(_))
    });
};
const $0a8265f77a3f5d43$var$de_ListGeofenceCollectionsResponseEntryList = (output, context)=>{
    const retVal = (output || []).filter((e)=>e != null).map((entry)=>{
        return $0a8265f77a3f5d43$var$de_ListGeofenceCollectionsResponseEntry(entry, context);
    });
    return retVal;
};
const $0a8265f77a3f5d43$var$de_ListGeofenceResponseEntry = (output, context)=>{
    return (0, $eJMW4.take)(output, {
        CreateTime: (_)=>(0, $cXA1B.expectNonNull)((0, $d8z3h.parseRfc3339DateTimeWithOffset)(_)),
        GeofenceId: (0, $cXA1B.expectString),
        GeofenceProperties: (0, $Phm09._json),
        Geometry: (_)=>$0a8265f77a3f5d43$var$de_GeofenceGeometry(_, context),
        Status: (0, $cXA1B.expectString),
        UpdateTime: (_)=>(0, $cXA1B.expectNonNull)((0, $d8z3h.parseRfc3339DateTimeWithOffset)(_))
    });
};
const $0a8265f77a3f5d43$var$de_ListGeofenceResponseEntryList = (output, context)=>{
    const retVal = (output || []).filter((e)=>e != null).map((entry)=>{
        return $0a8265f77a3f5d43$var$de_ListGeofenceResponseEntry(entry, context);
    });
    return retVal;
};
const $0a8265f77a3f5d43$var$de_ListKeysResponseEntry = (output, context)=>{
    return (0, $eJMW4.take)(output, {
        CreateTime: (_)=>(0, $cXA1B.expectNonNull)((0, $d8z3h.parseRfc3339DateTimeWithOffset)(_)),
        Description: (0, $cXA1B.expectString),
        ExpireTime: (_)=>(0, $cXA1B.expectNonNull)((0, $d8z3h.parseRfc3339DateTimeWithOffset)(_)),
        KeyName: (0, $cXA1B.expectString),
        Restrictions: (0, $Phm09._json),
        UpdateTime: (_)=>(0, $cXA1B.expectNonNull)((0, $d8z3h.parseRfc3339DateTimeWithOffset)(_))
    });
};
const $0a8265f77a3f5d43$var$de_ListKeysResponseEntryList = (output, context)=>{
    const retVal = (output || []).filter((e)=>e != null).map((entry)=>{
        return $0a8265f77a3f5d43$var$de_ListKeysResponseEntry(entry, context);
    });
    return retVal;
};
const $0a8265f77a3f5d43$var$de_ListMapsResponseEntry = (output, context)=>{
    return (0, $eJMW4.take)(output, {
        CreateTime: (_)=>(0, $cXA1B.expectNonNull)((0, $d8z3h.parseRfc3339DateTimeWithOffset)(_)),
        DataSource: (0, $cXA1B.expectString),
        Description: (0, $cXA1B.expectString),
        MapName: (0, $cXA1B.expectString),
        PricingPlan: (0, $cXA1B.expectString),
        UpdateTime: (_)=>(0, $cXA1B.expectNonNull)((0, $d8z3h.parseRfc3339DateTimeWithOffset)(_))
    });
};
const $0a8265f77a3f5d43$var$de_ListMapsResponseEntryList = (output, context)=>{
    const retVal = (output || []).filter((e)=>e != null).map((entry)=>{
        return $0a8265f77a3f5d43$var$de_ListMapsResponseEntry(entry, context);
    });
    return retVal;
};
const $0a8265f77a3f5d43$var$de_ListPlaceIndexesResponseEntry = (output, context)=>{
    return (0, $eJMW4.take)(output, {
        CreateTime: (_)=>(0, $cXA1B.expectNonNull)((0, $d8z3h.parseRfc3339DateTimeWithOffset)(_)),
        DataSource: (0, $cXA1B.expectString),
        Description: (0, $cXA1B.expectString),
        IndexName: (0, $cXA1B.expectString),
        PricingPlan: (0, $cXA1B.expectString),
        UpdateTime: (_)=>(0, $cXA1B.expectNonNull)((0, $d8z3h.parseRfc3339DateTimeWithOffset)(_))
    });
};
const $0a8265f77a3f5d43$var$de_ListPlaceIndexesResponseEntryList = (output, context)=>{
    const retVal = (output || []).filter((e)=>e != null).map((entry)=>{
        return $0a8265f77a3f5d43$var$de_ListPlaceIndexesResponseEntry(entry, context);
    });
    return retVal;
};
const $0a8265f77a3f5d43$var$de_ListRouteCalculatorsResponseEntry = (output, context)=>{
    return (0, $eJMW4.take)(output, {
        CalculatorName: (0, $cXA1B.expectString),
        CreateTime: (_)=>(0, $cXA1B.expectNonNull)((0, $d8z3h.parseRfc3339DateTimeWithOffset)(_)),
        DataSource: (0, $cXA1B.expectString),
        Description: (0, $cXA1B.expectString),
        PricingPlan: (0, $cXA1B.expectString),
        UpdateTime: (_)=>(0, $cXA1B.expectNonNull)((0, $d8z3h.parseRfc3339DateTimeWithOffset)(_))
    });
};
const $0a8265f77a3f5d43$var$de_ListRouteCalculatorsResponseEntryList = (output, context)=>{
    const retVal = (output || []).filter((e)=>e != null).map((entry)=>{
        return $0a8265f77a3f5d43$var$de_ListRouteCalculatorsResponseEntry(entry, context);
    });
    return retVal;
};
const $0a8265f77a3f5d43$var$de_ListTrackersResponseEntry = (output, context)=>{
    return (0, $eJMW4.take)(output, {
        CreateTime: (_)=>(0, $cXA1B.expectNonNull)((0, $d8z3h.parseRfc3339DateTimeWithOffset)(_)),
        Description: (0, $cXA1B.expectString),
        PricingPlan: (0, $cXA1B.expectString),
        PricingPlanDataSource: (0, $cXA1B.expectString),
        TrackerName: (0, $cXA1B.expectString),
        UpdateTime: (_)=>(0, $cXA1B.expectNonNull)((0, $d8z3h.parseRfc3339DateTimeWithOffset)(_))
    });
};
const $0a8265f77a3f5d43$var$de_ListTrackersResponseEntryList = (output, context)=>{
    const retVal = (output || []).filter((e)=>e != null).map((entry)=>{
        return $0a8265f77a3f5d43$var$de_ListTrackersResponseEntry(entry, context);
    });
    return retVal;
};
const $0a8265f77a3f5d43$var$de_Place = (output, context)=>{
    return (0, $eJMW4.take)(output, {
        AddressNumber: (0, $cXA1B.expectString),
        Categories: (0, $Phm09._json),
        Country: (0, $cXA1B.expectString),
        Geometry: (_)=>$0a8265f77a3f5d43$var$de_PlaceGeometry(_, context),
        Interpolated: (0, $cXA1B.expectBoolean),
        Label: (0, $cXA1B.expectString),
        Municipality: (0, $cXA1B.expectString),
        Neighborhood: (0, $cXA1B.expectString),
        PostalCode: (0, $cXA1B.expectString),
        Region: (0, $cXA1B.expectString),
        Street: (0, $cXA1B.expectString),
        SubMunicipality: (0, $cXA1B.expectString),
        SubRegion: (0, $cXA1B.expectString),
        SupplementalCategories: (0, $Phm09._json),
        TimeZone: (0, $Phm09._json),
        UnitNumber: (0, $cXA1B.expectString),
        UnitType: (0, $cXA1B.expectString)
    });
};
const $0a8265f77a3f5d43$var$de_PlaceGeometry = (output, context)=>{
    return (0, $eJMW4.take)(output, {
        Point: (_)=>$0a8265f77a3f5d43$var$de_Position(_, context)
    });
};
const $0a8265f77a3f5d43$var$de_Position = (output, context)=>{
    const retVal = (output || []).filter((e)=>e != null).map((entry)=>{
        return (0, $cXA1B.limitedParseDouble)(entry);
    });
    return retVal;
};
const $0a8265f77a3f5d43$var$de_PositionalAccuracy = (output, context)=>{
    return (0, $eJMW4.take)(output, {
        Horizontal: (0, $cXA1B.limitedParseDouble)
    });
};
const $0a8265f77a3f5d43$var$de_PositionList = (output, context)=>{
    const retVal = (output || []).filter((e)=>e != null).map((entry)=>{
        return $0a8265f77a3f5d43$var$de_Position(entry, context);
    });
    return retVal;
};
const $0a8265f77a3f5d43$var$de_RouteMatrix = (output, context)=>{
    const retVal = (output || []).filter((e)=>e != null).map((entry)=>{
        return $0a8265f77a3f5d43$var$de_RouteMatrixRow(entry, context);
    });
    return retVal;
};
const $0a8265f77a3f5d43$var$de_RouteMatrixEntry = (output, context)=>{
    return (0, $eJMW4.take)(output, {
        Distance: (0, $cXA1B.limitedParseDouble),
        DurationSeconds: (0, $cXA1B.limitedParseDouble),
        Error: (0, $Phm09._json)
    });
};
const $0a8265f77a3f5d43$var$de_RouteMatrixRow = (output, context)=>{
    const retVal = (output || []).filter((e)=>e != null).map((entry)=>{
        return $0a8265f77a3f5d43$var$de_RouteMatrixEntry(entry, context);
    });
    return retVal;
};
const $0a8265f77a3f5d43$var$de_SearchForPositionResult = (output, context)=>{
    return (0, $eJMW4.take)(output, {
        Distance: (0, $cXA1B.limitedParseDouble),
        Place: (_)=>$0a8265f77a3f5d43$var$de_Place(_, context),
        PlaceId: (0, $cXA1B.expectString)
    });
};
const $0a8265f77a3f5d43$var$de_SearchForPositionResultList = (output, context)=>{
    const retVal = (output || []).filter((e)=>e != null).map((entry)=>{
        return $0a8265f77a3f5d43$var$de_SearchForPositionResult(entry, context);
    });
    return retVal;
};
const $0a8265f77a3f5d43$var$de_SearchForTextResult = (output, context)=>{
    return (0, $eJMW4.take)(output, {
        Distance: (0, $cXA1B.limitedParseDouble),
        Place: (_)=>$0a8265f77a3f5d43$var$de_Place(_, context),
        PlaceId: (0, $cXA1B.expectString),
        Relevance: (0, $cXA1B.limitedParseDouble)
    });
};
const $0a8265f77a3f5d43$var$de_SearchForTextResultList = (output, context)=>{
    const retVal = (output || []).filter((e)=>e != null).map((entry)=>{
        return $0a8265f77a3f5d43$var$de_SearchForTextResult(entry, context);
    });
    return retVal;
};
const $0a8265f77a3f5d43$var$de_SearchPlaceIndexForPositionSummary = (output, context)=>{
    return (0, $eJMW4.take)(output, {
        DataSource: (0, $cXA1B.expectString),
        Language: (0, $cXA1B.expectString),
        MaxResults: (0, $cXA1B.expectInt32),
        Position: (_)=>$0a8265f77a3f5d43$var$de_Position(_, context)
    });
};
const $0a8265f77a3f5d43$var$de_SearchPlaceIndexForSuggestionsSummary = (output, context)=>{
    return (0, $eJMW4.take)(output, {
        BiasPosition: (_)=>$0a8265f77a3f5d43$var$de_Position(_, context),
        DataSource: (0, $cXA1B.expectString),
        FilterBBox: (_)=>$0a8265f77a3f5d43$var$de_BoundingBox(_, context),
        FilterCategories: (0, $Phm09._json),
        FilterCountries: (0, $Phm09._json),
        Language: (0, $cXA1B.expectString),
        MaxResults: (0, $cXA1B.expectInt32),
        Text: (0, $cXA1B.expectString)
    });
};
const $0a8265f77a3f5d43$var$de_SearchPlaceIndexForTextSummary = (output, context)=>{
    return (0, $eJMW4.take)(output, {
        BiasPosition: (_)=>$0a8265f77a3f5d43$var$de_Position(_, context),
        DataSource: (0, $cXA1B.expectString),
        FilterBBox: (_)=>$0a8265f77a3f5d43$var$de_BoundingBox(_, context),
        FilterCategories: (0, $Phm09._json),
        FilterCountries: (0, $Phm09._json),
        Language: (0, $cXA1B.expectString),
        MaxResults: (0, $cXA1B.expectInt32),
        ResultBBox: (_)=>$0a8265f77a3f5d43$var$de_BoundingBox(_, context),
        Text: (0, $cXA1B.expectString)
    });
};
const $0a8265f77a3f5d43$var$de_Step = (output, context)=>{
    return (0, $eJMW4.take)(output, {
        Distance: (0, $cXA1B.limitedParseDouble),
        DurationSeconds: (0, $cXA1B.limitedParseDouble),
        EndPosition: (_)=>$0a8265f77a3f5d43$var$de_Position(_, context),
        GeometryOffset: (0, $cXA1B.expectInt32),
        StartPosition: (_)=>$0a8265f77a3f5d43$var$de_Position(_, context)
    });
};
const $0a8265f77a3f5d43$var$de_StepList = (output, context)=>{
    const retVal = (output || []).filter((e)=>e != null).map((entry)=>{
        return $0a8265f77a3f5d43$var$de_Step(entry, context);
    });
    return retVal;
};
const $0a8265f77a3f5d43$var$de_ValidationExceptionField = (output, context)=>{
    return (0, $eJMW4.take)(output, {
        Message: [
            ,
            (0, $cXA1B.expectString),
            `message`
        ],
        Name: [
            ,
            (0, $cXA1B.expectString),
            `name`
        ]
    });
};
const $0a8265f77a3f5d43$var$de_ValidationExceptionFieldList = (output, context)=>{
    const retVal = (output || []).filter((e)=>e != null).map((entry)=>{
        return $0a8265f77a3f5d43$var$de_ValidationExceptionField(entry, context);
    });
    return retVal;
};
const $0a8265f77a3f5d43$var$deserializeMetadata = (output)=>({
        httpStatusCode: output.statusCode,
        requestId: output.headers["x-amzn-requestid"] ?? output.headers["x-amzn-request-id"] ?? output.headers["x-amz-request-id"],
        extendedRequestId: output.headers["x-amz-id-2"],
        cfId: output.headers["x-amz-cf-id"]
    });
const $0a8265f77a3f5d43$var$collectBodyString = (streamBody, context)=>(0, $7fiNM.collectBody)(streamBody, context).then((body)=>context.utf8Encoder(body));
const $0a8265f77a3f5d43$var$isSerializableHeaderValue = (value)=>value !== undefined && value !== null && value !== "" && (!Object.getOwnPropertyNames(value).includes("length") || value.length != 0) && (!Object.getOwnPropertyNames(value).includes("size") || value.size != 0);
const $0a8265f77a3f5d43$var$_CC = "CacheControl";
const $0a8265f77a3f5d43$var$_CT = "ContentType";
const $0a8265f77a3f5d43$var$_FD = "ForceDelete";
const $0a8265f77a3f5d43$var$_K = "Key";
const $0a8265f77a3f5d43$var$_L = "Language";
const $0a8265f77a3f5d43$var$_TK = "TagKeys";
const $0a8265f77a3f5d43$var$_cc = "cache-control";
const $0a8265f77a3f5d43$var$_ct = "content-type";
const $0a8265f77a3f5d43$var$_fD = "forceDelete";
const $0a8265f77a3f5d43$var$_k = "key";
const $0a8265f77a3f5d43$var$_l = "language";
const $0a8265f77a3f5d43$var$_tK = "tagKeys";


class $a8fd6ca8635b5277$export$766050e2e36b49ab extends (0, $hMwCU.Command).classBuilder().ep({
    ...(0, $5d5872ec2e5681cc$export$9c07ced2019f0ae0)
}).m(function(Command, cs, config, o) {
    return [
        (0, $KxEGr.getSerdePlugin)(config, this.serialize, this.deserialize),
        (0, $iHLqk.getEndpointPlugin)(config, Command.getEndpointParameterInstructions())
    ];
}).s("LocationService", "SearchPlaceIndexForPosition", {}).n("LocationClient", "SearchPlaceIndexForPositionCommand").f((0, $454857ac2a87e2c9$export$ff564e171fa64eb5), (0, $454857ac2a87e2c9$export$ec5957f8987a2cb3)).ser((0, $0a8265f77a3f5d43$export$f436dbc7339eb42f)).de((0, $0a8265f77a3f5d43$export$f1046c9c0a8aa1af)).build() {
}




function $0d7c68eafc4da62b$export$2287e3d29250119e(date, amount) {
    return (0, $09736e7482b4418e$export$baf757aaf0c95c94)(date, amount * (0, $cb8083d8e93c1630$export$91246f0b9bd9beff));
}
var // Fallback for modularized imports:
$0d7c68eafc4da62b$export$2e2bcd8739ae039 = $0d7c68eafc4da62b$export$2287e3d29250119e;


function $4d242f5ba5f51203$export$e12a970efb73fce5(date, amount) {
    return (0, $0d7c68eafc4da62b$export$2287e3d29250119e)(date, -amount);
}
var // Fallback for modularized imports:
$4d242f5ba5f51203$export$2e2bcd8739ae039 = $4d242f5ba5f51203$export$e12a970efb73fce5;




parcelRequire("gNNye");
var $eaU4c = parcelRequire("eaU4c");
parcelRequire("gNNye");
var $eaU4c = parcelRequire("eaU4c");
function $45b0dfa4409eded9$export$fb1e896f6704b6a6(logins) {
    return Promise.all(Object.keys(logins).reduce((arr, name)=>{
        const tokenOrProvider = logins[name];
        if (typeof tokenOrProvider === "string") arr.push([
            name,
            tokenOrProvider
        ]);
        else arr.push(tokenOrProvider().then((token)=>[
                name,
                token
            ]));
        return arr;
    }, [])).then((resolvedPairs)=>resolvedPairs.reduce((logins, [key, value])=>{
            logins[key] = value;
            return logins;
        }, {}));
}



function $f90487000c3769dd$export$4d624d71eb462130(parameters) {
    return async ()=>{
        parameters.logger?.debug("@aws-sdk/credential-provider-cognito-identity", "fromCognitoIdentity");
        const { GetCredentialsForIdentityCommand: GetCredentialsForIdentityCommand, CognitoIdentityClient: CognitoIdentityClient } = await (parcelRequire("h81q0"));
        const { Credentials: { AccessKeyId: AccessKeyId = $f90487000c3769dd$var$throwOnMissingAccessKeyId(), Expiration: Expiration, SecretKey: SecretKey = $f90487000c3769dd$var$throwOnMissingSecretKey(), SessionToken: SessionToken } = $f90487000c3769dd$var$throwOnMissingCredentials() } = await (parameters.client ?? new CognitoIdentityClient(Object.assign({}, parameters.clientConfig ?? {}, {
            region: parameters.clientConfig?.region ?? parameters.parentClientConfig?.region
        }))).send(new GetCredentialsForIdentityCommand({
            CustomRoleArn: parameters.customRoleArn,
            IdentityId: parameters.identityId,
            Logins: parameters.logins ? await (0, $45b0dfa4409eded9$export$fb1e896f6704b6a6)(parameters.logins) : undefined
        }));
        return {
            identityId: parameters.identityId,
            accessKeyId: AccessKeyId,
            secretAccessKey: SecretKey,
            sessionToken: SessionToken,
            expiration: Expiration
        };
    };
}
function $f90487000c3769dd$var$throwOnMissingAccessKeyId() {
    throw new (0, $eaU4c.CredentialsProviderError)("Response from Amazon Cognito contained no access key ID");
}
function $f90487000c3769dd$var$throwOnMissingCredentials() {
    throw new (0, $eaU4c.CredentialsProviderError)("Response from Amazon Cognito contained no credentials");
}
function $f90487000c3769dd$var$throwOnMissingSecretKey() {
    throw new (0, $eaU4c.CredentialsProviderError)("Response from Amazon Cognito contained no secret key");
}


const $6c7b295571eb08ab$var$STORE_NAME = "IdentityIds";
class $6c7b295571eb08ab$export$55d38e5384f402 {
    constructor(dbName = "aws:cognito-identity-ids"){
        this.dbName = dbName;
    }
    getItem(key) {
        return this.withObjectStore("readonly", (store)=>{
            const req = store.get(key);
            return new Promise((resolve)=>{
                req.onerror = ()=>resolve(null);
                req.onsuccess = ()=>resolve(req.result ? req.result.value : null);
            });
        }).catch(()=>null);
    }
    removeItem(key) {
        return this.withObjectStore("readwrite", (store)=>{
            const req = store.delete(key);
            return new Promise((resolve, reject)=>{
                req.onerror = ()=>reject(req.error);
                req.onsuccess = ()=>resolve();
            });
        });
    }
    setItem(id, value) {
        return this.withObjectStore("readwrite", (store)=>{
            const req = store.put({
                id: id,
                value: value
            });
            return new Promise((resolve, reject)=>{
                req.onerror = ()=>reject(req.error);
                req.onsuccess = ()=>resolve();
            });
        });
    }
    getDb() {
        const openDbRequest = self.indexedDB.open(this.dbName, 1);
        return new Promise((resolve, reject)=>{
            openDbRequest.onsuccess = ()=>{
                resolve(openDbRequest.result);
            };
            openDbRequest.onerror = ()=>{
                reject(openDbRequest.error);
            };
            openDbRequest.onblocked = ()=>{
                reject(new Error("Unable to access DB"));
            };
            openDbRequest.onupgradeneeded = ()=>{
                const db = openDbRequest.result;
                db.onerror = ()=>{
                    reject(new Error("Failed to create object store"));
                };
                db.createObjectStore($6c7b295571eb08ab$var$STORE_NAME, {
                    keyPath: "id"
                });
            };
        });
    }
    withObjectStore(mode, action) {
        return this.getDb().then((db)=>{
            const tx = db.transaction($6c7b295571eb08ab$var$STORE_NAME, mode);
            tx.oncomplete = ()=>db.close();
            return new Promise((resolve, reject)=>{
                tx.onerror = ()=>reject(tx.error);
                resolve(action(tx.objectStore($6c7b295571eb08ab$var$STORE_NAME)));
            }).catch((err)=>{
                db.close();
                throw err;
            });
        });
    }
}


class $9ec08190e0b9cd2b$export$e4315e25b840a0ea {
    constructor(store = {}){
        this.store = store;
    }
    getItem(key) {
        if (key in this.store) return this.store[key];
        return null;
    }
    removeItem(key) {
        delete this.store[key];
    }
    setItem(key, value) {
        this.store[key] = value;
    }
}


const $4d794f58823bd91f$var$inMemoryStorage = new (0, $9ec08190e0b9cd2b$export$e4315e25b840a0ea)();
function $4d794f58823bd91f$export$c2ed3351cac403d1() {
    if (typeof self === "object" && self.indexedDB) return new (0, $6c7b295571eb08ab$export$55d38e5384f402)();
    if (typeof window === "object" && window.localStorage) return window.localStorage;
    return $4d794f58823bd91f$var$inMemoryStorage;
}




function $779f66e2be89c415$export$6c7d622e9507a2e({ accountId: accountId, cache: cache = (0, $4d794f58823bd91f$export$c2ed3351cac403d1)(), client: client, clientConfig: clientConfig, customRoleArn: customRoleArn, identityPoolId: identityPoolId, logins: logins, userIdentifier: userIdentifier = !logins || Object.keys(logins).length === 0 ? "ANONYMOUS" : undefined, logger: logger, parentClientConfig: parentClientConfig }) {
    logger?.debug("@aws-sdk/credential-provider-cognito-identity", "fromCognitoIdentity");
    const cacheKey = userIdentifier ? `aws:cognito-identity-credentials:${identityPoolId}:${userIdentifier}` : undefined;
    let provider = async ()=>{
        const { GetIdCommand: GetIdCommand, CognitoIdentityClient: CognitoIdentityClient } = await (parcelRequire("h81q0"));
        const _client = client ?? new CognitoIdentityClient(Object.assign({}, clientConfig ?? {}, {
            region: clientConfig?.region ?? parentClientConfig?.region
        }));
        let identityId = cacheKey && await cache.getItem(cacheKey);
        if (!identityId) {
            const { IdentityId: IdentityId = $779f66e2be89c415$var$throwOnMissingId() } = await _client.send(new GetIdCommand({
                AccountId: accountId,
                IdentityPoolId: identityPoolId,
                Logins: logins ? await (0, $45b0dfa4409eded9$export$fb1e896f6704b6a6)(logins) : undefined
            }));
            identityId = IdentityId;
            if (cacheKey) Promise.resolve(cache.setItem(cacheKey, identityId)).catch(()=>{});
        }
        provider = (0, $f90487000c3769dd$export$4d624d71eb462130)({
            client: _client,
            customRoleArn: customRoleArn,
            logins: logins,
            identityId: identityId
        });
        return provider();
    };
    return ()=>provider().catch(async (err)=>{
            if (cacheKey) Promise.resolve(cache.removeItem(cacheKey)).catch(()=>{});
            throw err;
        });
}
function $779f66e2be89c415$var$throwOnMissingId() {
    throw new (0, $eaU4c.CredentialsProviderError)("Response from Amazon Cognito contained no identity ID");
}


const $781e215d1bc07b61$export$6c7d622e9507a2e = (options)=>(0, $779f66e2be89c415$export$6c7d622e9507a2e)({
        ...options
    });


/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /** @class */ var $3d044715290b5392$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new AuthenticationDetails object
   * @param {object=} data Creation options.
   * @param {string} data.Username User being authenticated.
   * @param {string} data.Password Plain-text password to authenticate with.
   * @param {(AttributeArg[])?} data.ValidationData Application extra metadata.
   * @param {(AttributeArg[])?} data.AuthParamaters Authentication paramaters for custom auth.
   */ function AuthenticationDetails(data) {
        var _ref = data || {}, ValidationData = _ref.ValidationData, Username = _ref.Username, Password = _ref.Password, AuthParameters = _ref.AuthParameters, ClientMetadata = _ref.ClientMetadata;
        this.validationData = ValidationData || {};
        this.authParameters = AuthParameters || {};
        this.clientMetadata = ClientMetadata || {};
        this.username = Username;
        this.password = Password;
    }
    /**
   * @returns {string} the record's username
   */ var _proto = AuthenticationDetails.prototype;
    _proto.getUsername = function getUsername() {
        return this.username;
    } /**
   * @returns {string} the record's password
   */ ;
    _proto.getPassword = function getPassword() {
        return this.password;
    } /**
   * @returns {Array} the record's validationData
   */ ;
    _proto.getValidationData = function getValidationData() {
        return this.validationData;
    } /**
   * @returns {Array} the record's authParameters
   */ ;
    _proto.getAuthParameters = function getAuthParameters() {
        return this.authParameters;
    } /**
   * @returns {ClientMetadata} the clientMetadata for a Lambda trigger
   */ ;
    _proto.getClientMetadata = function getClientMetadata() {
        return this.clientMetadata;
    };
    return AuthenticationDetails;
}();


/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $jYnzf = parcelRequire("jYnzf");
var $6aee3020af7079f2$var$crypto;
// Native crypto from window (Browser)
if (typeof window !== "undefined" && window.crypto) $6aee3020af7079f2$var$crypto = window.crypto;
// Native (experimental IE 11) crypto from window (Browser)
if (!$6aee3020af7079f2$var$crypto && typeof window !== "undefined" && window.msCrypto) $6aee3020af7079f2$var$crypto = window.msCrypto;
// Native crypto from global (NodeJS)
if (!$6aee3020af7079f2$var$crypto && typeof $parcel$global !== "undefined" && $parcel$global.crypto) $6aee3020af7079f2$var$crypto = $parcel$global.crypto;

// Native crypto import via require (NodeJS)
if (!$6aee3020af7079f2$var$crypto && true) try {
    $6aee3020af7079f2$var$crypto = (parcelRequire("8Jx27"));
} catch (err) {}
function $6aee3020af7079f2$export$2e2bcd8739ae039() {
    if ($6aee3020af7079f2$var$crypto) {
        // Use getRandomValues method (Browser)
        if (typeof $6aee3020af7079f2$var$crypto.getRandomValues === "function") try {
            return $6aee3020af7079f2$var$crypto.getRandomValues(new Uint32Array(1))[0];
        } catch (err) {}
        // Use randomBytes method (NodeJS)
        if (typeof $6aee3020af7079f2$var$crypto.randomBytes === "function") try {
            return $6aee3020af7079f2$var$crypto.randomBytes(4).readInt32LE();
        } catch (err) {}
    }
    throw new Error("Native crypto module could not be used to get secure random number.");
}


/**
 * Hex encoding strategy.
 * Converts a word array to a hex string.
 * @param {WordArray} wordArray The word array.
 * @return {string} The hex string.
 * @static
 */ function $2f5cf9b959abddc6$var$hexStringify(wordArray) {
    // Shortcuts
    var words = wordArray.words;
    var sigBytes = wordArray.sigBytes;
    // Convert
    var hexChars = [];
    for(var i = 0; i < sigBytes; i++){
        var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
        hexChars.push((bite >>> 4).toString(16));
        hexChars.push((bite & 0x0f).toString(16));
    }
    return hexChars.join("");
}
var $2f5cf9b959abddc6$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function WordArray(words, sigBytes) {
        words = this.words = words || [];
        if (sigBytes != undefined) this.sigBytes = sigBytes;
        else this.sigBytes = words.length * 4;
    }
    var _proto = WordArray.prototype;
    _proto.random = function random(nBytes) {
        var words = [];
        for(var i = 0; i < nBytes; i += 4)words.push((0, $6aee3020af7079f2$export$2e2bcd8739ae039)());
        return new WordArray(words, nBytes);
    };
    _proto.toString = function toString() {
        return $2f5cf9b959abddc6$var$hexStringify(this);
    };
    return WordArray;
}();


var $5fc867b0e21dc729$exports = {};
"use strict";
Object.defineProperty($5fc867b0e21dc729$exports, "__esModule", {
    value: true
});

var $3Z7oc = parcelRequire("3Z7oc");

(0, $3Z7oc.__exportStar)((parcelRequire("pFLo9")), $5fc867b0e21dc729$exports);


// A small implementation of BigInteger based on http://www-cs-students.stanford.edu/~tjw/jsbn/
//
// All public methods have been removed except the following:
//   new BigInteger(a, b) (only radix 2, 4, 8, 16 and 32 supported)
//   toString (only radix 2, 4, 8, 16 and 32 supported)
//   negate
//   abs
//   compareTo
//   bitLength
//   mod
//   equals
//   add
//   subtract
//   multiply
//   divide
//   modPow
var $304b0713d23ec50f$export$2e2bcd8739ae039 = $304b0713d23ec50f$var$BigInteger;
/*
 * Copyright (c) 2003-2005  Tom Wu
 * All Rights Reserved.
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS-IS" AND WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS, IMPLIED OR OTHERWISE, INCLUDING WITHOUT LIMITATION, ANY
 * WARRANTY OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE.
 *
 * IN NO EVENT SHALL TOM WU BE LIABLE FOR ANY SPECIAL, INCIDENTAL,
 * INDIRECT OR CONSEQUENTIAL DAMAGES OF ANY KIND, OR ANY DAMAGES WHATSOEVER
 * RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER OR NOT ADVISED OF
 * THE POSSIBILITY OF DAMAGE, AND ON ANY THEORY OF LIABILITY, ARISING OUT
 * OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 *
 * In addition, the following condition applies:
 *
 * All redistributions must retain an intact copy of this copyright notice
 * and disclaimer.
 */ // (public) Constructor
function $304b0713d23ec50f$var$BigInteger(a, b) {
    if (a != null) this.fromString(a, b);
}
// return new, unset BigInteger
function $304b0713d23ec50f$var$nbi() {
    return new $304b0713d23ec50f$var$BigInteger(null);
}
// Bits per digit
var $304b0713d23ec50f$var$dbits;
// JavaScript engine analysis
var $304b0713d23ec50f$var$canary = 0xdeadbeefcafe;
var $304b0713d23ec50f$var$j_lm = ($304b0713d23ec50f$var$canary & 0xffffff) == 0xefcafe;
// am: Compute w_j += (x*this_i), propagate carries,
// c is initial carry, returns final carry.
// c < 3*dvalue, x < 2*dvalue, this_i < dvalue
// We need to select the fastest one that works in this environment.
// am1: use a single mult and divide to get the high bits,
// max digit bits should be 26 because
// max internal value = 2*dvalue^2-2*dvalue (< 2^53)
function $304b0713d23ec50f$var$am1(i, x, w, j, c, n) {
    while(--n >= 0){
        var v = x * this[i++] + w[j] + c;
        c = Math.floor(v / 0x4000000);
        w[j++] = v & 0x3ffffff;
    }
    return c;
}
// am2 avoids a big mult-and-extract completely.
// Max digit bits should be <= 30 because we do bitwise ops
// on values up to 2*hdvalue^2-hdvalue-1 (< 2^31)
function $304b0713d23ec50f$var$am2(i, x, w, j, c, n) {
    var xl = x & 0x7fff, xh = x >> 15;
    while(--n >= 0){
        var l = this[i] & 0x7fff;
        var h = this[i++] >> 15;
        var m = xh * l + h * xl;
        l = xl * l + ((m & 0x7fff) << 15) + w[j] + (c & 0x3fffffff);
        c = (l >>> 30) + (m >>> 15) + xh * h + (c >>> 30);
        w[j++] = l & 0x3fffffff;
    }
    return c;
}
// Alternately, set max digit bits to 28 since some
// browsers slow down when dealing with 32-bit numbers.
function $304b0713d23ec50f$var$am3(i, x, w, j, c, n) {
    var xl = x & 0x3fff, xh = x >> 14;
    while(--n >= 0){
        var l = this[i] & 0x3fff;
        var h = this[i++] >> 14;
        var m = xh * l + h * xl;
        l = xl * l + ((m & 0x3fff) << 14) + w[j] + c;
        c = (l >> 28) + (m >> 14) + xh * h;
        w[j++] = l & 0xfffffff;
    }
    return c;
}
var $304b0713d23ec50f$var$inBrowser = typeof navigator !== "undefined";
if ($304b0713d23ec50f$var$inBrowser && $304b0713d23ec50f$var$j_lm && navigator.appName == "Microsoft Internet Explorer") {
    $304b0713d23ec50f$var$BigInteger.prototype.am = $304b0713d23ec50f$var$am2;
    $304b0713d23ec50f$var$dbits = 30;
} else if ($304b0713d23ec50f$var$inBrowser && $304b0713d23ec50f$var$j_lm && navigator.appName != "Netscape") {
    $304b0713d23ec50f$var$BigInteger.prototype.am = $304b0713d23ec50f$var$am1;
    $304b0713d23ec50f$var$dbits = 26;
} else {
    // Mozilla/Netscape seems to prefer am3
    $304b0713d23ec50f$var$BigInteger.prototype.am = $304b0713d23ec50f$var$am3;
    $304b0713d23ec50f$var$dbits = 28;
}
$304b0713d23ec50f$var$BigInteger.prototype.DB = $304b0713d23ec50f$var$dbits;
$304b0713d23ec50f$var$BigInteger.prototype.DM = (1 << $304b0713d23ec50f$var$dbits) - 1;
$304b0713d23ec50f$var$BigInteger.prototype.DV = 1 << $304b0713d23ec50f$var$dbits;
var $304b0713d23ec50f$var$BI_FP = 52;
$304b0713d23ec50f$var$BigInteger.prototype.FV = Math.pow(2, $304b0713d23ec50f$var$BI_FP);
$304b0713d23ec50f$var$BigInteger.prototype.F1 = $304b0713d23ec50f$var$BI_FP - $304b0713d23ec50f$var$dbits;
$304b0713d23ec50f$var$BigInteger.prototype.F2 = 2 * $304b0713d23ec50f$var$dbits - $304b0713d23ec50f$var$BI_FP;
// Digit conversions
var $304b0713d23ec50f$var$BI_RM = "0123456789abcdefghijklmnopqrstuvwxyz";
var $304b0713d23ec50f$var$BI_RC = new Array();
var $304b0713d23ec50f$var$rr, $304b0713d23ec50f$var$vv;
$304b0713d23ec50f$var$rr = "0".charCodeAt(0);
for($304b0713d23ec50f$var$vv = 0; $304b0713d23ec50f$var$vv <= 9; ++$304b0713d23ec50f$var$vv)$304b0713d23ec50f$var$BI_RC[$304b0713d23ec50f$var$rr++] = $304b0713d23ec50f$var$vv;
$304b0713d23ec50f$var$rr = "a".charCodeAt(0);
for($304b0713d23ec50f$var$vv = 10; $304b0713d23ec50f$var$vv < 36; ++$304b0713d23ec50f$var$vv)$304b0713d23ec50f$var$BI_RC[$304b0713d23ec50f$var$rr++] = $304b0713d23ec50f$var$vv;
$304b0713d23ec50f$var$rr = "A".charCodeAt(0);
for($304b0713d23ec50f$var$vv = 10; $304b0713d23ec50f$var$vv < 36; ++$304b0713d23ec50f$var$vv)$304b0713d23ec50f$var$BI_RC[$304b0713d23ec50f$var$rr++] = $304b0713d23ec50f$var$vv;
function $304b0713d23ec50f$var$int2char(n) {
    return $304b0713d23ec50f$var$BI_RM.charAt(n);
}
function $304b0713d23ec50f$var$intAt(s, i) {
    var c = $304b0713d23ec50f$var$BI_RC[s.charCodeAt(i)];
    return c == null ? -1 : c;
}
// (protected) copy this to r
function $304b0713d23ec50f$var$bnpCopyTo(r) {
    for(var i = this.t - 1; i >= 0; --i)r[i] = this[i];
    r.t = this.t;
    r.s = this.s;
}
// (protected) set from integer value x, -DV <= x < DV
function $304b0713d23ec50f$var$bnpFromInt(x) {
    this.t = 1;
    this.s = x < 0 ? -1 : 0;
    if (x > 0) this[0] = x;
    else if (x < -1) this[0] = x + this.DV;
    else this.t = 0;
}
// return bigint initialized to value
function $304b0713d23ec50f$var$nbv(i) {
    var r = $304b0713d23ec50f$var$nbi();
    r.fromInt(i);
    return r;
}
// (protected) set from string and radix
function $304b0713d23ec50f$var$bnpFromString(s, b) {
    var k;
    if (b == 16) k = 4;
    else if (b == 8) k = 3;
    else if (b == 2) k = 1;
    else if (b == 32) k = 5;
    else if (b == 4) k = 2;
    else throw new Error("Only radix 2, 4, 8, 16, 32 are supported");
    this.t = 0;
    this.s = 0;
    var i = s.length, mi = false, sh = 0;
    while(--i >= 0){
        var x = $304b0713d23ec50f$var$intAt(s, i);
        if (x < 0) {
            if (s.charAt(i) == "-") mi = true;
            continue;
        }
        mi = false;
        if (sh == 0) this[this.t++] = x;
        else if (sh + k > this.DB) {
            this[this.t - 1] |= (x & (1 << this.DB - sh) - 1) << sh;
            this[this.t++] = x >> this.DB - sh;
        } else this[this.t - 1] |= x << sh;
        sh += k;
        if (sh >= this.DB) sh -= this.DB;
    }
    this.clamp();
    if (mi) $304b0713d23ec50f$var$BigInteger.ZERO.subTo(this, this);
}
// (protected) clamp off excess high words
function $304b0713d23ec50f$var$bnpClamp() {
    var c = this.s & this.DM;
    while(this.t > 0 && this[this.t - 1] == c)--this.t;
}
// (public) return string representation in given radix
function $304b0713d23ec50f$var$bnToString(b) {
    if (this.s < 0) return "-" + this.negate().toString(b);
    var k;
    if (b == 16) k = 4;
    else if (b == 8) k = 3;
    else if (b == 2) k = 1;
    else if (b == 32) k = 5;
    else if (b == 4) k = 2;
    else throw new Error("Only radix 2, 4, 8, 16, 32 are supported");
    var km = (1 << k) - 1, d, m = false, r = "", i = this.t;
    var p = this.DB - i * this.DB % k;
    if (i-- > 0) {
        if (p < this.DB && (d = this[i] >> p) > 0) {
            m = true;
            r = $304b0713d23ec50f$var$int2char(d);
        }
        while(i >= 0){
            if (p < k) {
                d = (this[i] & (1 << p) - 1) << k - p;
                d |= this[--i] >> (p += this.DB - k);
            } else {
                d = this[i] >> (p -= k) & km;
                if (p <= 0) {
                    p += this.DB;
                    --i;
                }
            }
            if (d > 0) m = true;
            if (m) r += $304b0713d23ec50f$var$int2char(d);
        }
    }
    return m ? r : "0";
}
// (public) -this
function $304b0713d23ec50f$var$bnNegate() {
    var r = $304b0713d23ec50f$var$nbi();
    $304b0713d23ec50f$var$BigInteger.ZERO.subTo(this, r);
    return r;
}
// (public) |this|
function $304b0713d23ec50f$var$bnAbs() {
    return this.s < 0 ? this.negate() : this;
}
// (public) return + if this > a, - if this < a, 0 if equal
function $304b0713d23ec50f$var$bnCompareTo(a) {
    var r = this.s - a.s;
    if (r != 0) return r;
    var i = this.t;
    r = i - a.t;
    if (r != 0) return this.s < 0 ? -r : r;
    while(--i >= 0)if ((r = this[i] - a[i]) != 0) return r;
    return 0;
}
// returns bit length of the integer x
function $304b0713d23ec50f$var$nbits(x) {
    var r = 1, t;
    if ((t = x >>> 16) != 0) {
        x = t;
        r += 16;
    }
    if ((t = x >> 8) != 0) {
        x = t;
        r += 8;
    }
    if ((t = x >> 4) != 0) {
        x = t;
        r += 4;
    }
    if ((t = x >> 2) != 0) {
        x = t;
        r += 2;
    }
    if ((t = x >> 1) != 0) {
        x = t;
        r += 1;
    }
    return r;
}
// (public) return the number of bits in "this"
function $304b0713d23ec50f$var$bnBitLength() {
    if (this.t <= 0) return 0;
    return this.DB * (this.t - 1) + $304b0713d23ec50f$var$nbits(this[this.t - 1] ^ this.s & this.DM);
}
// (protected) r = this << n*DB
function $304b0713d23ec50f$var$bnpDLShiftTo(n, r) {
    var i;
    for(i = this.t - 1; i >= 0; --i)r[i + n] = this[i];
    for(i = n - 1; i >= 0; --i)r[i] = 0;
    r.t = this.t + n;
    r.s = this.s;
}
// (protected) r = this >> n*DB
function $304b0713d23ec50f$var$bnpDRShiftTo(n, r) {
    for(var i = n; i < this.t; ++i)r[i - n] = this[i];
    r.t = Math.max(this.t - n, 0);
    r.s = this.s;
}
// (protected) r = this << n
function $304b0713d23ec50f$var$bnpLShiftTo(n, r) {
    var bs = n % this.DB;
    var cbs = this.DB - bs;
    var bm = (1 << cbs) - 1;
    var ds = Math.floor(n / this.DB), c = this.s << bs & this.DM, i;
    for(i = this.t - 1; i >= 0; --i){
        r[i + ds + 1] = this[i] >> cbs | c;
        c = (this[i] & bm) << bs;
    }
    for(i = ds - 1; i >= 0; --i)r[i] = 0;
    r[ds] = c;
    r.t = this.t + ds + 1;
    r.s = this.s;
    r.clamp();
}
// (protected) r = this >> n
function $304b0713d23ec50f$var$bnpRShiftTo(n, r) {
    r.s = this.s;
    var ds = Math.floor(n / this.DB);
    if (ds >= this.t) {
        r.t = 0;
        return;
    }
    var bs = n % this.DB;
    var cbs = this.DB - bs;
    var bm = (1 << bs) - 1;
    r[0] = this[ds] >> bs;
    for(var i = ds + 1; i < this.t; ++i){
        r[i - ds - 1] |= (this[i] & bm) << cbs;
        r[i - ds] = this[i] >> bs;
    }
    if (bs > 0) r[this.t - ds - 1] |= (this.s & bm) << cbs;
    r.t = this.t - ds;
    r.clamp();
}
// (protected) r = this - a
function $304b0713d23ec50f$var$bnpSubTo(a, r) {
    var i = 0, c = 0, m = Math.min(a.t, this.t);
    while(i < m){
        c += this[i] - a[i];
        r[i++] = c & this.DM;
        c >>= this.DB;
    }
    if (a.t < this.t) {
        c -= a.s;
        while(i < this.t){
            c += this[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += this.s;
    } else {
        c += this.s;
        while(i < a.t){
            c -= a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c -= a.s;
    }
    r.s = c < 0 ? -1 : 0;
    if (c < -1) r[i++] = this.DV + c;
    else if (c > 0) r[i++] = c;
    r.t = i;
    r.clamp();
}
// (protected) r = this * a, r != this,a (HAC 14.12)
// "this" should be the larger one if appropriate.
function $304b0713d23ec50f$var$bnpMultiplyTo(a, r) {
    var x = this.abs(), y = a.abs();
    var i = x.t;
    r.t = i + y.t;
    while(--i >= 0)r[i] = 0;
    for(i = 0; i < y.t; ++i)r[i + x.t] = x.am(0, y[i], r, i, 0, x.t);
    r.s = 0;
    r.clamp();
    if (this.s != a.s) $304b0713d23ec50f$var$BigInteger.ZERO.subTo(r, r);
}
// (protected) r = this^2, r != this (HAC 14.16)
function $304b0713d23ec50f$var$bnpSquareTo(r) {
    var x = this.abs();
    var i = r.t = 2 * x.t;
    while(--i >= 0)r[i] = 0;
    for(i = 0; i < x.t - 1; ++i){
        var c = x.am(i, x[i], r, 2 * i, 0, 1);
        if ((r[i + x.t] += x.am(i + 1, 2 * x[i], r, 2 * i + 1, c, x.t - i - 1)) >= x.DV) {
            r[i + x.t] -= x.DV;
            r[i + x.t + 1] = 1;
        }
    }
    if (r.t > 0) r[r.t - 1] += x.am(i, x[i], r, 2 * i, 0, 1);
    r.s = 0;
    r.clamp();
}
// (protected) divide this by m, quotient and remainder to q, r (HAC 14.20)
// r != q, this != m.  q or r may be null.
function $304b0713d23ec50f$var$bnpDivRemTo(m, q, r) {
    var pm = m.abs();
    if (pm.t <= 0) return;
    var pt = this.abs();
    if (pt.t < pm.t) {
        if (q != null) q.fromInt(0);
        if (r != null) this.copyTo(r);
        return;
    }
    if (r == null) r = $304b0713d23ec50f$var$nbi();
    var y = $304b0713d23ec50f$var$nbi(), ts = this.s, ms = m.s;
    var nsh = this.DB - $304b0713d23ec50f$var$nbits(pm[pm.t - 1]);
    // normalize modulus
    if (nsh > 0) {
        pm.lShiftTo(nsh, y);
        pt.lShiftTo(nsh, r);
    } else {
        pm.copyTo(y);
        pt.copyTo(r);
    }
    var ys = y.t;
    var y0 = y[ys - 1];
    if (y0 == 0) return;
    var yt = y0 * (1 << this.F1) + (ys > 1 ? y[ys - 2] >> this.F2 : 0);
    var d1 = this.FV / yt, d2 = (1 << this.F1) / yt, e = 1 << this.F2;
    var i = r.t, j = i - ys, t = q == null ? $304b0713d23ec50f$var$nbi() : q;
    y.dlShiftTo(j, t);
    if (r.compareTo(t) >= 0) {
        r[r.t++] = 1;
        r.subTo(t, r);
    }
    $304b0713d23ec50f$var$BigInteger.ONE.dlShiftTo(ys, t);
    t.subTo(y, y);
    // "negative" y so we can replace sub with am later
    while(y.t < ys)y[y.t++] = 0;
    while(--j >= 0){
        // Estimate quotient digit
        var qd = r[--i] == y0 ? this.DM : Math.floor(r[i] * d1 + (r[i - 1] + e) * d2);
        if ((r[i] += y.am(0, qd, r, j, 0, ys)) < qd) {
            // Try it out
            y.dlShiftTo(j, t);
            r.subTo(t, r);
            while(r[i] < --qd)r.subTo(t, r);
        }
    }
    if (q != null) {
        r.drShiftTo(ys, q);
        if (ts != ms) $304b0713d23ec50f$var$BigInteger.ZERO.subTo(q, q);
    }
    r.t = ys;
    r.clamp();
    if (nsh > 0) r.rShiftTo(nsh, r);
    // Denormalize remainder
    if (ts < 0) $304b0713d23ec50f$var$BigInteger.ZERO.subTo(r, r);
}
// (public) this mod a
function $304b0713d23ec50f$var$bnMod(a) {
    var r = $304b0713d23ec50f$var$nbi();
    this.abs().divRemTo(a, null, r);
    if (this.s < 0 && r.compareTo($304b0713d23ec50f$var$BigInteger.ZERO) > 0) a.subTo(r, r);
    return r;
}
// (protected) return "-1/this % 2^DB"; useful for Mont. reduction
// justification:
//         xy == 1 (mod m)
//         xy =  1+km
//   xy(2-xy) = (1+km)(1-km)
// x[y(2-xy)] = 1-k^2m^2
// x[y(2-xy)] == 1 (mod m^2)
// if y is 1/x mod m, then y(2-xy) is 1/x mod m^2
// should reduce x and y(2-xy) by m^2 at each step to keep size bounded.
// JS multiply "overflows" differently from C/C++, so care is needed here.
function $304b0713d23ec50f$var$bnpInvDigit() {
    if (this.t < 1) return 0;
    var x = this[0];
    if ((x & 1) == 0) return 0;
    var y = x & 3;
    // y == 1/x mod 2^2
    y = y * (2 - (x & 0xf) * y) & 0xf;
    // y == 1/x mod 2^4
    y = y * (2 - (x & 0xff) * y) & 0xff;
    // y == 1/x mod 2^8
    y = y * (2 - ((x & 0xffff) * y & 0xffff)) & 0xffff;
    // y == 1/x mod 2^16
    // last step - calculate inverse mod DV directly;
    // assumes 16 < DB <= 32 and assumes ability to handle 48-bit ints
    y = y * (2 - x * y % this.DV) % this.DV;
    // y == 1/x mod 2^dbits
    // we really want the negative inverse, and -DV < y < DV
    return y > 0 ? this.DV - y : -y;
}
function $304b0713d23ec50f$var$bnEquals(a) {
    return this.compareTo(a) == 0;
}
// (protected) r = this + a
function $304b0713d23ec50f$var$bnpAddTo(a, r) {
    var i = 0, c = 0, m = Math.min(a.t, this.t);
    while(i < m){
        c += this[i] + a[i];
        r[i++] = c & this.DM;
        c >>= this.DB;
    }
    if (a.t < this.t) {
        c += a.s;
        while(i < this.t){
            c += this[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += this.s;
    } else {
        c += this.s;
        while(i < a.t){
            c += a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += a.s;
    }
    r.s = c < 0 ? -1 : 0;
    if (c > 0) r[i++] = c;
    else if (c < -1) r[i++] = this.DV + c;
    r.t = i;
    r.clamp();
}
// (public) this + a
function $304b0713d23ec50f$var$bnAdd(a) {
    var r = $304b0713d23ec50f$var$nbi();
    this.addTo(a, r);
    return r;
}
// (public) this - a
function $304b0713d23ec50f$var$bnSubtract(a) {
    var r = $304b0713d23ec50f$var$nbi();
    this.subTo(a, r);
    return r;
}
// (public) this * a
function $304b0713d23ec50f$var$bnMultiply(a) {
    var r = $304b0713d23ec50f$var$nbi();
    this.multiplyTo(a, r);
    return r;
}
// (public) this / a
function $304b0713d23ec50f$var$bnDivide(a) {
    var r = $304b0713d23ec50f$var$nbi();
    this.divRemTo(a, r, null);
    return r;
}
// Montgomery reduction
function $304b0713d23ec50f$var$Montgomery(m) {
    this.m = m;
    this.mp = m.invDigit();
    this.mpl = this.mp & 0x7fff;
    this.mph = this.mp >> 15;
    this.um = (1 << m.DB - 15) - 1;
    this.mt2 = 2 * m.t;
}
// xR mod m
function $304b0713d23ec50f$var$montConvert(x) {
    var r = $304b0713d23ec50f$var$nbi();
    x.abs().dlShiftTo(this.m.t, r);
    r.divRemTo(this.m, null, r);
    if (x.s < 0 && r.compareTo($304b0713d23ec50f$var$BigInteger.ZERO) > 0) this.m.subTo(r, r);
    return r;
}
// x/R mod m
function $304b0713d23ec50f$var$montRevert(x) {
    var r = $304b0713d23ec50f$var$nbi();
    x.copyTo(r);
    this.reduce(r);
    return r;
}
// x = x/R mod m (HAC 14.32)
function $304b0713d23ec50f$var$montReduce(x) {
    while(x.t <= this.mt2)// pad x so am has enough room later
    x[x.t++] = 0;
    for(var i = 0; i < this.m.t; ++i){
        // faster way of calculating u0 = x[i]*mp mod DV
        var j = x[i] & 0x7fff;
        var u0 = j * this.mpl + ((j * this.mph + (x[i] >> 15) * this.mpl & this.um) << 15) & x.DM;
        // use am to combine the multiply-shift-add into one call
        j = i + this.m.t;
        x[j] += this.m.am(0, u0, x, i, 0, this.m.t);
        // propagate carry
        while(x[j] >= x.DV){
            x[j] -= x.DV;
            x[++j]++;
        }
    }
    x.clamp();
    x.drShiftTo(this.m.t, x);
    if (x.compareTo(this.m) >= 0) x.subTo(this.m, x);
}
// r = "x^2/R mod m"; x != r
function $304b0713d23ec50f$var$montSqrTo(x, r) {
    x.squareTo(r);
    this.reduce(r);
}
// r = "xy/R mod m"; x,y != r
function $304b0713d23ec50f$var$montMulTo(x, y, r) {
    x.multiplyTo(y, r);
    this.reduce(r);
}
$304b0713d23ec50f$var$Montgomery.prototype.convert = $304b0713d23ec50f$var$montConvert;
$304b0713d23ec50f$var$Montgomery.prototype.revert = $304b0713d23ec50f$var$montRevert;
$304b0713d23ec50f$var$Montgomery.prototype.reduce = $304b0713d23ec50f$var$montReduce;
$304b0713d23ec50f$var$Montgomery.prototype.mulTo = $304b0713d23ec50f$var$montMulTo;
$304b0713d23ec50f$var$Montgomery.prototype.sqrTo = $304b0713d23ec50f$var$montSqrTo;
// (public) this^e % m (HAC 14.85)
function $304b0713d23ec50f$var$bnModPow(e, m, callback) {
    var i = e.bitLength(), k, r = $304b0713d23ec50f$var$nbv(1), z = new $304b0713d23ec50f$var$Montgomery(m);
    if (i <= 0) return r;
    else if (i < 18) k = 1;
    else if (i < 48) k = 3;
    else if (i < 144) k = 4;
    else if (i < 768) k = 5;
    else k = 6;
    // precomputation
    var g = new Array(), n = 3, k1 = k - 1, km = (1 << k) - 1;
    g[1] = z.convert(this);
    if (k > 1) {
        var g2 = $304b0713d23ec50f$var$nbi();
        z.sqrTo(g[1], g2);
        while(n <= km){
            g[n] = $304b0713d23ec50f$var$nbi();
            z.mulTo(g2, g[n - 2], g[n]);
            n += 2;
        }
    }
    var j = e.t - 1, w, is1 = true, r2 = $304b0713d23ec50f$var$nbi(), t;
    i = $304b0713d23ec50f$var$nbits(e[j]) - 1;
    while(j >= 0){
        if (i >= k1) w = e[j] >> i - k1 & km;
        else {
            w = (e[j] & (1 << i + 1) - 1) << k1 - i;
            if (j > 0) w |= e[j - 1] >> this.DB + i - k1;
        }
        n = k;
        while((w & 1) == 0){
            w >>= 1;
            --n;
        }
        if ((i -= n) < 0) {
            i += this.DB;
            --j;
        }
        if (is1) {
            // ret == 1, don't bother squaring or multiplying it
            g[w].copyTo(r);
            is1 = false;
        } else {
            while(n > 1){
                z.sqrTo(r, r2);
                z.sqrTo(r2, r);
                n -= 2;
            }
            if (n > 0) z.sqrTo(r, r2);
            else {
                t = r;
                r = r2;
                r2 = t;
            }
            z.mulTo(r2, g[w], r);
        }
        while(j >= 0 && (e[j] & 1 << i) == 0){
            z.sqrTo(r, r2);
            t = r;
            r = r2;
            r2 = t;
            if (--i < 0) {
                i = this.DB - 1;
                --j;
            }
        }
    }
    var result = z.revert(r);
    callback(null, result);
    return result;
}
// protected
$304b0713d23ec50f$var$BigInteger.prototype.copyTo = $304b0713d23ec50f$var$bnpCopyTo;
$304b0713d23ec50f$var$BigInteger.prototype.fromInt = $304b0713d23ec50f$var$bnpFromInt;
$304b0713d23ec50f$var$BigInteger.prototype.fromString = $304b0713d23ec50f$var$bnpFromString;
$304b0713d23ec50f$var$BigInteger.prototype.clamp = $304b0713d23ec50f$var$bnpClamp;
$304b0713d23ec50f$var$BigInteger.prototype.dlShiftTo = $304b0713d23ec50f$var$bnpDLShiftTo;
$304b0713d23ec50f$var$BigInteger.prototype.drShiftTo = $304b0713d23ec50f$var$bnpDRShiftTo;
$304b0713d23ec50f$var$BigInteger.prototype.lShiftTo = $304b0713d23ec50f$var$bnpLShiftTo;
$304b0713d23ec50f$var$BigInteger.prototype.rShiftTo = $304b0713d23ec50f$var$bnpRShiftTo;
$304b0713d23ec50f$var$BigInteger.prototype.subTo = $304b0713d23ec50f$var$bnpSubTo;
$304b0713d23ec50f$var$BigInteger.prototype.multiplyTo = $304b0713d23ec50f$var$bnpMultiplyTo;
$304b0713d23ec50f$var$BigInteger.prototype.squareTo = $304b0713d23ec50f$var$bnpSquareTo;
$304b0713d23ec50f$var$BigInteger.prototype.divRemTo = $304b0713d23ec50f$var$bnpDivRemTo;
$304b0713d23ec50f$var$BigInteger.prototype.invDigit = $304b0713d23ec50f$var$bnpInvDigit;
$304b0713d23ec50f$var$BigInteger.prototype.addTo = $304b0713d23ec50f$var$bnpAddTo;
// public
$304b0713d23ec50f$var$BigInteger.prototype.toString = $304b0713d23ec50f$var$bnToString;
$304b0713d23ec50f$var$BigInteger.prototype.negate = $304b0713d23ec50f$var$bnNegate;
$304b0713d23ec50f$var$BigInteger.prototype.abs = $304b0713d23ec50f$var$bnAbs;
$304b0713d23ec50f$var$BigInteger.prototype.compareTo = $304b0713d23ec50f$var$bnCompareTo;
$304b0713d23ec50f$var$BigInteger.prototype.bitLength = $304b0713d23ec50f$var$bnBitLength;
$304b0713d23ec50f$var$BigInteger.prototype.mod = $304b0713d23ec50f$var$bnMod;
$304b0713d23ec50f$var$BigInteger.prototype.equals = $304b0713d23ec50f$var$bnEquals;
$304b0713d23ec50f$var$BigInteger.prototype.add = $304b0713d23ec50f$var$bnAdd;
$304b0713d23ec50f$var$BigInteger.prototype.subtract = $304b0713d23ec50f$var$bnSubtract;
$304b0713d23ec50f$var$BigInteger.prototype.multiply = $304b0713d23ec50f$var$bnMultiply;
$304b0713d23ec50f$var$BigInteger.prototype.divide = $304b0713d23ec50f$var$bnDivide;
$304b0713d23ec50f$var$BigInteger.prototype.modPow = $304b0713d23ec50f$var$bnModPow;
// "constants"
$304b0713d23ec50f$var$BigInteger.ZERO = $304b0713d23ec50f$var$nbv(0);
$304b0713d23ec50f$var$BigInteger.ONE = $304b0713d23ec50f$var$nbv(1);


/**
 * Returns a Buffer with a sequence of random nBytes
 *
 * @param {number} nBytes
 * @returns {Buffer} fixed-length sequence of random bytes
 */ function $001e67252ab4d534$var$randomBytes(nBytes) {
    return (0, $jYnzf.Buffer).from(new (0, $2f5cf9b959abddc6$export$2e2bcd8739ae039)().random(nBytes).toString(), "hex");
}
/**
 * Tests if a hex string has it most significant bit set (case-insensitive regex)
 */ var $001e67252ab4d534$var$HEX_MSB_REGEX = /^[89a-f]/i;
var $001e67252ab4d534$var$initN = "FFFFFFFFFFFFFFFFC90FDAA22168C234C4C6628B80DC1CD129024E088A67CC74020BBEA63B139B22514A08798E3404DDEF9519B3CD3A431B302B0A6DF25F14374FE1356D6D51C245E485B576625E7EC6F44C42E9A637ED6B0BFF5CB6F406B7EDEE386BFB5A899FA5AE9F24117C4B1FE649286651ECE45B3DC2007CB8A163BF0598DA48361C55D39A69163FA8FD24CF5F83655D23DCA3AD961C62F356208552BB9ED529077096966D670C354E4ABC9804F1746C08CA18217C32905E462E36CE3BE39E772C180E86039B2783A2EC07A28FB5C55DF06F4C52C9DE2BCBF6955817183995497CEA956AE515D2261898FA051015728E5A8AAAC42DAD33170D04507A33A85521ABDF1CBA64ECFB850458DBEF0A8AEA71575D060C7DB3970F85A6E1E4C7ABF5AE8CDB0933D71E8C94E04A25619DCEE3D2261AD2EE6BF12FFA06D98A0864D87602733EC86A64521F2B18177B200CBBE117577A615D6C770988C0BAD946E208E24FA074E5AB3143DB5BFCE0FD108E4B82D120A93AD2CAFFFFFFFFFFFFFFFF";
var $001e67252ab4d534$var$newPasswordRequiredChallengeUserAttributePrefix = "userAttributes.";
/** @class */ var $001e67252ab4d534$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new AuthenticationHelper object
   * @param {string} PoolName Cognito user pool name.
   */ function AuthenticationHelper(PoolName) {
        this.N = new (0, $304b0713d23ec50f$export$2e2bcd8739ae039)($001e67252ab4d534$var$initN, 16);
        this.g = new (0, $304b0713d23ec50f$export$2e2bcd8739ae039)("2", 16);
        this.k = new (0, $304b0713d23ec50f$export$2e2bcd8739ae039)(this.hexHash("" + this.padHex(this.N) + this.padHex(this.g)), 16);
        this.smallAValue = this.generateRandomSmallA();
        this.getLargeAValue(function() {});
        this.infoBits = (0, $jYnzf.Buffer).from("Caldera Derived Key", "utf8");
        this.poolName = PoolName;
    }
    /**
   * @returns {BigInteger} small A, a random number
   */ var _proto = AuthenticationHelper.prototype;
    _proto.getSmallAValue = function getSmallAValue() {
        return this.smallAValue;
    } /**
   * @param {nodeCallback<BigInteger>} callback Called with (err, largeAValue)
   * @returns {void}
   */ ;
    _proto.getLargeAValue = function getLargeAValue(callback) {
        var _this = this;
        if (this.largeAValue) callback(null, this.largeAValue);
        else this.calculateA(this.smallAValue, function(err, largeAValue) {
            if (err) callback(err, null);
            _this.largeAValue = largeAValue;
            callback(null, _this.largeAValue);
        });
    } /**
   * helper function to generate a random big integer
   * @returns {BigInteger} a random value.
   * @private
   */ ;
    _proto.generateRandomSmallA = function generateRandomSmallA() {
        // This will be interpreted as a postive 128-bit integer
        var hexRandom = $001e67252ab4d534$var$randomBytes(128).toString("hex");
        var randomBigInt = new (0, $304b0713d23ec50f$export$2e2bcd8739ae039)(hexRandom, 16);
        // There is no need to do randomBigInt.mod(this.N - 1) as N (3072-bit) is > 128 bytes (1024-bit)
        return randomBigInt;
    } /**
   * helper function to generate a random string
   * @returns {string} a random value.
   * @private
   */ ;
    _proto.generateRandomString = function generateRandomString() {
        return $001e67252ab4d534$var$randomBytes(40).toString("base64");
    } /**
   * @returns {string} Generated random value included in password hash.
   */ ;
    _proto.getRandomPassword = function getRandomPassword() {
        return this.randomPassword;
    } /**
   * @returns {string} Generated random value included in devices hash.
   */ ;
    _proto.getSaltDevices = function getSaltDevices() {
        return this.SaltToHashDevices;
    } /**
   * @returns {string} Value used to verify devices.
   */ ;
    _proto.getVerifierDevices = function getVerifierDevices() {
        return this.verifierDevices;
    } /**
   * Generate salts and compute verifier.
   * @param {string} deviceGroupKey Devices to generate verifier for.
   * @param {string} username User to generate verifier for.
   * @param {nodeCallback<null>} callback Called with (err, null)
   * @returns {void}
   */ ;
    _proto.generateHashDevice = function generateHashDevice(deviceGroupKey, username, callback) {
        var _this2 = this;
        this.randomPassword = this.generateRandomString();
        var combinedString = "" + deviceGroupKey + username + ":" + this.randomPassword;
        var hashedString = this.hash(combinedString);
        var hexRandom = $001e67252ab4d534$var$randomBytes(16).toString("hex");
        // The random hex will be unambiguously represented as a postive integer
        this.SaltToHashDevices = this.padHex(new (0, $304b0713d23ec50f$export$2e2bcd8739ae039)(hexRandom, 16));
        this.g.modPow(new (0, $304b0713d23ec50f$export$2e2bcd8739ae039)(this.hexHash(this.SaltToHashDevices + hashedString), 16), this.N, function(err, verifierDevicesNotPadded) {
            if (err) callback(err, null);
            _this2.verifierDevices = _this2.padHex(verifierDevicesNotPadded);
            callback(null, null);
        });
    } /**
   * Calculate the client's public value A = g^a%N
   * with the generated random number a
   * @param {BigInteger} a Randomly generated small A.
   * @param {nodeCallback<BigInteger>} callback Called with (err, largeAValue)
   * @returns {void}
   * @private
   */ ;
    _proto.calculateA = function calculateA(a, callback) {
        var _this3 = this;
        this.g.modPow(a, this.N, function(err, A) {
            if (err) callback(err, null);
            if (A.mod(_this3.N).equals((0, $304b0713d23ec50f$export$2e2bcd8739ae039).ZERO)) callback(new Error("Illegal paramater. A mod N cannot be 0."), null);
            callback(null, A);
        });
    } /**
   * Calculate the client's value U which is the hash of A and B
   * @param {BigInteger} A Large A value.
   * @param {BigInteger} B Server B value.
   * @returns {BigInteger} Computed U value.
   * @private
   */ ;
    _proto.calculateU = function calculateU(A, B) {
        this.UHexHash = this.hexHash(this.padHex(A) + this.padHex(B));
        var finalU = new (0, $304b0713d23ec50f$export$2e2bcd8739ae039)(this.UHexHash, 16);
        return finalU;
    } /**
   * Calculate a hash from a bitArray
   * @param {Buffer} buf Value to hash.
   * @returns {String} Hex-encoded hash.
   * @private
   */ ;
    _proto.hash = function hash(buf) {
        var awsCryptoHash = new (0, $5fc867b0e21dc729$exports.Sha256)();
        awsCryptoHash.update(buf);
        var resultFromAWSCrypto = awsCryptoHash.digestSync();
        var hashHex = (0, $jYnzf.Buffer).from(resultFromAWSCrypto).toString("hex");
        return new Array(64 - hashHex.length).join("0") + hashHex;
    } /**
   * Calculate a hash from a hex string
   * @param {String} hexStr Value to hash.
   * @returns {String} Hex-encoded hash.
   * @private
   */ ;
    _proto.hexHash = function hexHash(hexStr) {
        return this.hash((0, $jYnzf.Buffer).from(hexStr, "hex"));
    } /**
   * Standard hkdf algorithm
   * @param {Buffer} ikm Input key material.
   * @param {Buffer} salt Salt value.
   * @returns {Buffer} Strong key material.
   * @private
   */ ;
    _proto.computehkdf = function computehkdf(ikm, salt) {
        var infoBitsBuffer = (0, $jYnzf.Buffer).concat([
            this.infoBits,
            (0, $jYnzf.Buffer).from(String.fromCharCode(1), "utf8")
        ]);
        var awsCryptoHash = new (0, $5fc867b0e21dc729$exports.Sha256)(salt);
        awsCryptoHash.update(ikm);
        var resultFromAWSCryptoPrk = awsCryptoHash.digestSync();
        var awsCryptoHashHmac = new (0, $5fc867b0e21dc729$exports.Sha256)(resultFromAWSCryptoPrk);
        awsCryptoHashHmac.update(infoBitsBuffer);
        var resultFromAWSCryptoHmac = awsCryptoHashHmac.digestSync();
        var hashHexFromAWSCrypto = resultFromAWSCryptoHmac;
        var currentHex = hashHexFromAWSCrypto.slice(0, 16);
        return currentHex;
    } /**
   * Calculates the final hkdf based on computed S value, and computed U value and the key
   * @param {String} username Username.
   * @param {String} password Password.
   * @param {BigInteger} serverBValue Server B value.
   * @param {BigInteger} salt Generated salt.
   * @param {nodeCallback<Buffer>} callback Called with (err, hkdfValue)
   * @returns {void}
   */ ;
    _proto.getPasswordAuthenticationKey = function getPasswordAuthenticationKey(username, password, serverBValue, salt, callback) {
        var _this4 = this;
        if (serverBValue.mod(this.N).equals((0, $304b0713d23ec50f$export$2e2bcd8739ae039).ZERO)) throw new Error("B cannot be zero.");
        this.UValue = this.calculateU(this.largeAValue, serverBValue);
        if (this.UValue.equals((0, $304b0713d23ec50f$export$2e2bcd8739ae039).ZERO)) throw new Error("U cannot be zero.");
        var usernamePassword = "" + this.poolName + username + ":" + password;
        var usernamePasswordHash = this.hash(usernamePassword);
        var xValue = new (0, $304b0713d23ec50f$export$2e2bcd8739ae039)(this.hexHash(this.padHex(salt) + usernamePasswordHash), 16);
        this.calculateS(xValue, serverBValue, function(err, sValue) {
            if (err) callback(err, null);
            var hkdf = _this4.computehkdf((0, $jYnzf.Buffer).from(_this4.padHex(sValue), "hex"), (0, $jYnzf.Buffer).from(_this4.padHex(_this4.UValue), "hex"));
            callback(null, hkdf);
        });
    } /**
   * Calculates the S value used in getPasswordAuthenticationKey
   * @param {BigInteger} xValue Salted password hash value.
   * @param {BigInteger} serverBValue Server B value.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.calculateS = function calculateS(xValue, serverBValue, callback) {
        var _this5 = this;
        this.g.modPow(xValue, this.N, function(err, gModPowXN) {
            if (err) callback(err, null);
            var intValue2 = serverBValue.subtract(_this5.k.multiply(gModPowXN));
            intValue2.modPow(_this5.smallAValue.add(_this5.UValue.multiply(xValue)), _this5.N, function(err2, result) {
                if (err2) callback(err2, null);
                callback(null, result.mod(_this5.N));
            });
        });
    } /**
   * Return constant newPasswordRequiredChallengeUserAttributePrefix
   * @return {newPasswordRequiredChallengeUserAttributePrefix} constant prefix value
   */ ;
    _proto.getNewPasswordRequiredChallengeUserAttributePrefix = function getNewPasswordRequiredChallengeUserAttributePrefix() {
        return $001e67252ab4d534$var$newPasswordRequiredChallengeUserAttributePrefix;
    } /**
   * Returns an unambiguous, even-length hex string of the two's complement encoding of an integer.
   *
   * It is compatible with the hex encoding of Java's BigInteger's toByteArray(), wich returns a
   * byte array containing the two's-complement representation of a BigInteger. The array contains
   * the minimum number of bytes required to represent the BigInteger, including at least one sign bit.
   *
   * Examples showing how ambiguity is avoided by left padding with:
   * 	"00" (for positive values where the most-significant-bit is set)
   *  "FF" (for negative values where the most-significant-bit is set)
   *
   * padHex(bigInteger.fromInt(-236))  === "FF14"
   * padHex(bigInteger.fromInt(20))    === "14"
   *
   * padHex(bigInteger.fromInt(-200))  === "FF38"
   * padHex(bigInteger.fromInt(56))    === "38"
   *
   * padHex(bigInteger.fromInt(-20))   === "EC"
   * padHex(bigInteger.fromInt(236))   === "00EC"
   *
   * padHex(bigInteger.fromInt(-56))   === "C8"
   * padHex(bigInteger.fromInt(200))   === "00C8"
   *
   * @param {BigInteger} bigInt Number to encode.
   * @returns {String} even-length hex string of the two's complement encoding.
   */ ;
    _proto.padHex = function padHex(bigInt) {
        if (!(bigInt instanceof (0, $304b0713d23ec50f$export$2e2bcd8739ae039))) throw new Error("Not a BigInteger");
        var isNegative = bigInt.compareTo((0, $304b0713d23ec50f$export$2e2bcd8739ae039).ZERO) < 0;
        /* Get a hex string for abs(bigInt) */ var hexStr = bigInt.abs().toString(16);
        /* Pad hex to even length if needed */ hexStr = hexStr.length % 2 !== 0 ? "0" + hexStr : hexStr;
        /* Prepend "00" if the most significant bit is set */ hexStr = $001e67252ab4d534$var$HEX_MSB_REGEX.test(hexStr) ? "00" + hexStr : hexStr;
        if (isNegative) {
            /* Flip the bits of the representation */ var invertedNibbles = hexStr.split("").map(function(x) {
                var invertedNibble = ~parseInt(x, 16) & 0xf;
                return "0123456789ABCDEF".charAt(invertedNibble);
            }).join("");
            /* After flipping the bits, add one to get the 2's complement representation */ var flippedBitsBI = new (0, $304b0713d23ec50f$export$2e2bcd8739ae039)(invertedNibbles, 16).add((0, $304b0713d23ec50f$export$2e2bcd8739ae039).ONE);
            hexStr = flippedBitsBI.toString(16);
            /*
      For hex strings starting with 'FF8', 'FF' can be dropped, e.g. 0xFFFF80=0xFF80=0x80=-128
      		Any sequence of '1' bits on the left can always be substituted with a single '1' bit
      without changing the represented value.
      		This only happens in the case when the input is 80...00
      */ if (hexStr.toUpperCase().startsWith("FF8")) hexStr = hexStr.substring(2);
        }
        return hexStr;
    };
    return AuthenticationHelper;
}();


/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $jYnzf = parcelRequire("jYnzf");
/** @class */ var $1079e5dd935b77bc$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoJwtToken object
   * @param {string=} token The JWT token.
   */ function CognitoJwtToken(token) {
        // Assign object
        this.jwtToken = token || "";
        this.payload = this.decodePayload();
    }
    /**
   * @returns {string} the record's token.
   */ var _proto = CognitoJwtToken.prototype;
    _proto.getJwtToken = function getJwtToken() {
        return this.jwtToken;
    } /**
   * @returns {int} the token's expiration (exp member).
   */ ;
    _proto.getExpiration = function getExpiration() {
        return this.payload.exp;
    } /**
   * @returns {int} the token's "issued at" (iat member).
   */ ;
    _proto.getIssuedAt = function getIssuedAt() {
        return this.payload.iat;
    } /**
   * @returns {object} the token's payload.
   */ ;
    _proto.decodePayload = function decodePayload() {
        var payload = this.jwtToken.split(".")[1];
        try {
            return JSON.parse((0, $jYnzf.Buffer).from(payload, "base64").toString("utf8"));
        } catch (err) {
            return {};
        }
    };
    return CognitoJwtToken;
}();


function $06e88dd6c8c409ac$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $06e88dd6c8c409ac$var$_setPrototypeOf(subClass, superClass);
}
function $06e88dd6c8c409ac$var$_setPrototypeOf(o, p) {
    $06e88dd6c8c409ac$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $06e88dd6c8c409ac$var$_setPrototypeOf(o, p);
}
/** @class */ var $06e88dd6c8c409ac$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_CognitoJwtToken) {
    $06e88dd6c8c409ac$var$_inheritsLoose(CognitoAccessToken, _CognitoJwtToken);
    /**
   * Constructs a new CognitoAccessToken object
   * @param {string=} AccessToken The JWT access token.
   */ function CognitoAccessToken(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, AccessToken = _ref.AccessToken;
        return _CognitoJwtToken.call(this, AccessToken || "") || this;
    }
    return CognitoAccessToken;
}((0, $1079e5dd935b77bc$export$2e2bcd8739ae039));



function $c52a3226127cf6d9$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $c52a3226127cf6d9$var$_setPrototypeOf(subClass, superClass);
}
function $c52a3226127cf6d9$var$_setPrototypeOf(o, p) {
    $c52a3226127cf6d9$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $c52a3226127cf6d9$var$_setPrototypeOf(o, p);
}
/** @class */ var $c52a3226127cf6d9$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_CognitoJwtToken) {
    $c52a3226127cf6d9$var$_inheritsLoose(CognitoIdToken, _CognitoJwtToken);
    /**
   * Constructs a new CognitoIdToken object
   * @param {string=} IdToken The JWT Id token
   */ function CognitoIdToken(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, IdToken = _ref.IdToken;
        return _CognitoJwtToken.call(this, IdToken || "") || this;
    }
    return CognitoIdToken;
}((0, $1079e5dd935b77bc$export$2e2bcd8739ae039));


/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /** @class */ var $5b8285bfbb1b289f$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoRefreshToken object
   * @param {string=} RefreshToken The JWT refresh token.
   */ function CognitoRefreshToken(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, RefreshToken = _ref.RefreshToken;
        // Assign object
        this.token = RefreshToken || "";
    }
    /**
   * @returns {string} the record's token.
   */ var _proto = CognitoRefreshToken.prototype;
    _proto.getToken = function getToken() {
        return this.token;
    };
    return CognitoRefreshToken;
}();


/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $jYnzf = parcelRequire("jYnzf");

/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ // generated by genversion
var $9c42b3b85eb79805$export$83d89fbfd8236492 = "5.0.4";


var $8e066460476a01f5$var$BASE_USER_AGENT = "aws-amplify/" + (0, $9c42b3b85eb79805$export$83d89fbfd8236492);
var $8e066460476a01f5$export$2dffd0b5373a4389 = {
    userAgent: $8e066460476a01f5$var$BASE_USER_AGENT,
    isReactNative: typeof navigator !== "undefined" && navigator.product === "ReactNative"
};
var $8e066460476a01f5$export$7935961ef7719cb0 = function getUserAgent() {
    return $8e066460476a01f5$export$2dffd0b5373a4389.userAgent;
};
var /**
 * @deprecated use named import
 */ $8e066460476a01f5$export$2e2bcd8739ae039 = $8e066460476a01f5$export$2dffd0b5373a4389;







/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /** @class */ var $98867a2573ca3d6e$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoUserSession object
   * @param {CognitoIdToken} IdToken The session's Id token.
   * @param {CognitoRefreshToken=} RefreshToken The session's refresh token.
   * @param {CognitoAccessToken} AccessToken The session's access token.
   * @param {int} ClockDrift The saved computer's clock drift or undefined to force calculation.
   */ function CognitoUserSession(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, IdToken = _ref.IdToken, RefreshToken = _ref.RefreshToken, AccessToken = _ref.AccessToken, ClockDrift = _ref.ClockDrift;
        if (AccessToken == null || IdToken == null) throw new Error("Id token and Access Token must be present.");
        this.idToken = IdToken;
        this.refreshToken = RefreshToken;
        this.accessToken = AccessToken;
        this.clockDrift = ClockDrift === undefined ? this.calculateClockDrift() : ClockDrift;
    }
    /**
   * @returns {CognitoIdToken} the session's Id token
   */ var _proto = CognitoUserSession.prototype;
    _proto.getIdToken = function getIdToken() {
        return this.idToken;
    } /**
   * @returns {CognitoRefreshToken} the session's refresh token
   */ ;
    _proto.getRefreshToken = function getRefreshToken() {
        return this.refreshToken;
    } /**
   * @returns {CognitoAccessToken} the session's access token
   */ ;
    _proto.getAccessToken = function getAccessToken() {
        return this.accessToken;
    } /**
   * @returns {int} the session's clock drift
   */ ;
    _proto.getClockDrift = function getClockDrift() {
        return this.clockDrift;
    } /**
   * @returns {int} the computer's clock drift
   */ ;
    _proto.calculateClockDrift = function calculateClockDrift() {
        var now = Math.floor(new Date() / 1000);
        var iat = Math.min(this.accessToken.getIssuedAt(), this.idToken.getIssuedAt());
        return now - iat;
    } /**
   * Checks to see if the session is still valid based on session expiry information found
   * in tokens and the current time (adjusted with clock drift)
   * @returns {boolean} if the session is still valid
   */ ;
    _proto.isValid = function isValid() {
        var now = Math.floor(new Date() / 1000);
        var adjusted = now - this.clockDrift;
        return adjusted < this.accessToken.getExpiration() && adjusted < this.idToken.getExpiration();
    };
    return CognitoUserSession;
}();


/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ var $2732f22d5f2465e4$var$monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
var $2732f22d5f2465e4$var$weekNames = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat"
];
/** @class */ var $2732f22d5f2465e4$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function DateHelper() {}
    var _proto = DateHelper.prototype;
    /**
   * @returns {string} The current time in "ddd MMM D HH:mm:ss UTC YYYY" format.
   */ _proto.getNowString = function getNowString() {
        var now = new Date();
        var weekDay = $2732f22d5f2465e4$var$weekNames[now.getUTCDay()];
        var month = $2732f22d5f2465e4$var$monthNames[now.getUTCMonth()];
        var day = now.getUTCDate();
        var hours = now.getUTCHours();
        if (hours < 10) hours = "0" + hours;
        var minutes = now.getUTCMinutes();
        if (minutes < 10) minutes = "0" + minutes;
        var seconds = now.getUTCSeconds();
        if (seconds < 10) seconds = "0" + seconds;
        var year = now.getUTCFullYear();
        // ddd MMM D HH:mm:ss UTC YYYY
        var dateNow = weekDay + " " + month + " " + day + " " + hours + ":" + minutes + ":" + seconds + " UTC " + year;
        return dateNow;
    };
    return DateHelper;
}();


/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /** @class */ var $07e538300be3afb7$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoUserAttribute object
   * @param {string=} Name The record's name
   * @param {string=} Value The record's value
   */ function CognitoUserAttribute(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, Name = _ref.Name, Value = _ref.Value;
        this.Name = Name || "";
        this.Value = Value || "";
    }
    /**
   * @returns {string} the record's value.
   */ var _proto = CognitoUserAttribute.prototype;
    _proto.getValue = function getValue() {
        return this.Value;
    } /**
   * Sets the record's value.
   * @param {string} value The new value.
   * @returns {CognitoUserAttribute} The record for method chaining.
   */ ;
    _proto.setValue = function setValue(value) {
        this.Value = value;
        return this;
    } /**
   * @returns {string} the record's name.
   */ ;
    _proto.getName = function getName() {
        return this.Name;
    } /**
   * Sets the record's name
   * @param {string} name The new name.
   * @returns {CognitoUserAttribute} The record for method chaining.
   */ ;
    _proto.setName = function setName(name) {
        this.Name = name;
        return this;
    } /**
   * @returns {string} a string representation of the record.
   */ ;
    _proto.toString = function toString() {
        return JSON.stringify(this);
    } /**
   * @returns {object} a flat object representing the record.
   */ ;
    _proto.toJSON = function toJSON() {
        return {
            Name: this.Name,
            Value: this.Value
        };
    };
    return CognitoUserAttribute;
}();


/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ var $269ba0b0a309720d$var$dataMemory = {};
var $269ba0b0a309720d$export$d7392285c701ecf5 = /*#__PURE__*/ function() {
    function MemoryStorage() {}
    /**
   * This is used to set a specific item in storage
   * @param {string} key - the key for the item
   * @param {object} value - the value
   * @returns {string} value that was set
   */ MemoryStorage.setItem = function setItem(key, value) {
        $269ba0b0a309720d$var$dataMemory[key] = value;
        return $269ba0b0a309720d$var$dataMemory[key];
    } /**
   * This is used to get a specific key from storage
   * @param {string} key - the key for the item
   * This is used to clear the storage
   * @returns {string} the data item
   */ ;
    MemoryStorage.getItem = function getItem(key) {
        return Object.prototype.hasOwnProperty.call($269ba0b0a309720d$var$dataMemory, key) ? $269ba0b0a309720d$var$dataMemory[key] : undefined;
    } /**
   * This is used to remove an item from storage
   * @param {string} key - the key being set
   * @returns {boolean} return true
   */ ;
    MemoryStorage.removeItem = function removeItem(key) {
        return delete $269ba0b0a309720d$var$dataMemory[key];
    } /**
   * This is used to clear the storage
   * @returns {string} nothing
   */ ;
    MemoryStorage.clear = function clear() {
        $269ba0b0a309720d$var$dataMemory = {};
        return $269ba0b0a309720d$var$dataMemory;
    };
    return MemoryStorage;
}();
/** @class */ var $269ba0b0a309720d$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * This is used to get a storage object
   * @returns {object} the storage
   */ function StorageHelper() {
        try {
            this.storageWindow = window.localStorage;
            this.storageWindow.setItem("aws.cognito.test-ls", 1);
            this.storageWindow.removeItem("aws.cognito.test-ls");
        } catch (exception) {
            this.storageWindow = $269ba0b0a309720d$export$d7392285c701ecf5;
        }
    }
    /**
   * This is used to return the storage
   * @returns {object} the storage
   */ var _proto = StorageHelper.prototype;
    _proto.getStorage = function getStorage() {
        return this.storageWindow;
    };
    return StorageHelper;
}();


/**
 * @callback nodeCallback
 * @template T result
 * @param {*} err The operation failure reason, or null.
 * @param {T} result The operation result.
 */ /**
 * @callback onFailure
 * @param {*} err Failure reason.
 */ /**
 * @callback onSuccess
 * @template T result
 * @param {T} result The operation result.
 */ /**
 * @callback mfaRequired
 * @param {*} details MFA challenge details.
 */ /**
 * @callback customChallenge
 * @param {*} details Custom challenge details.
 */ /**
 * @callback inputVerificationCode
 * @param {*} data Server response.
 */ /**
 * @callback authSuccess
 * @param {CognitoUserSession} session The new session.
 * @param {bool=} userConfirmationNecessary User must be confirmed.
 */ var $8ebdccf88ce233cf$var$isNavigatorAvailable = typeof navigator !== "undefined";
var $8ebdccf88ce233cf$var$userAgent = $8ebdccf88ce233cf$var$isNavigatorAvailable ? (0, $8e066460476a01f5$export$2dffd0b5373a4389).isReactNative ? "react-native" : navigator.userAgent : "nodejs";
/** @class */ var $8ebdccf88ce233cf$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoUser object
   * @param {object} data Creation options
   * @param {string} data.Username The user's username.
   * @param {CognitoUserPool} data.Pool Pool containing the user.
   * @param {object} data.Storage Optional storage object.
   */ function CognitoUser(data) {
        if (data == null || data.Username == null || data.Pool == null) throw new Error("Username and Pool information are required.");
        this.username = data.Username || "";
        this.pool = data.Pool;
        this.Session = null;
        this.client = data.Pool.client;
        this.signInUserSession = null;
        this.authenticationFlowType = "USER_SRP_AUTH";
        this.storage = data.Storage || new (0, $269ba0b0a309720d$export$2e2bcd8739ae039)().getStorage();
        this.keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        this.userDataKey = this.keyPrefix + "." + this.username + ".userData";
    }
    /**
   * Sets the session for this user
   * @param {CognitoUserSession} signInUserSession the session
   * @returns {void}
   */ var _proto = CognitoUser.prototype;
    _proto.setSignInUserSession = function setSignInUserSession(signInUserSession) {
        this.clearCachedUserData();
        this.signInUserSession = signInUserSession;
        this.cacheTokens();
    } /**
   * @returns {CognitoUserSession} the current session for this user
   */ ;
    _proto.getSignInUserSession = function getSignInUserSession() {
        return this.signInUserSession;
    } /**
   * @returns {string} the user's username
   */ ;
    _proto.getUsername = function getUsername() {
        return this.username;
    } /**
   * @returns {String} the authentication flow type
   */ ;
    _proto.getAuthenticationFlowType = function getAuthenticationFlowType() {
        return this.authenticationFlowType;
    } /**
   * sets authentication flow type
   * @param {string} authenticationFlowType New value.
   * @returns {void}
   */ ;
    _proto.setAuthenticationFlowType = function setAuthenticationFlowType(authenticationFlowType) {
        this.authenticationFlowType = authenticationFlowType;
    } /**
   * This is used for authenticating the user through the custom authentication flow.
   * @param {AuthenticationDetails} authDetails Contains the authentication data
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {customChallenge} callback.customChallenge Custom challenge
   *        response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @returns {void}
   */ ;
    _proto.initiateAuth = function initiateAuth(authDetails, callback) {
        var _this = this;
        var authParameters = authDetails.getAuthParameters();
        authParameters.USERNAME = this.username;
        var clientMetaData = Object.keys(authDetails.getValidationData()).length !== 0 ? authDetails.getValidationData() : authDetails.getClientMetadata();
        var jsonReq = {
            AuthFlow: "CUSTOM_AUTH",
            ClientId: this.pool.getClientId(),
            AuthParameters: authParameters,
            ClientMetadata: clientMetaData
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("InitiateAuth", jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            var challengeName = data.ChallengeName;
            var challengeParameters = data.ChallengeParameters;
            if (challengeName === "CUSTOM_CHALLENGE") {
                _this.Session = data.Session;
                return callback.customChallenge(challengeParameters);
            }
            _this.signInUserSession = _this.getCognitoUserSession(data.AuthenticationResult);
            _this.cacheTokens();
            return callback.onSuccess(_this.signInUserSession);
        });
    } /**
   * This is used for authenticating the user.
   * stuff
   * @param {AuthenticationDetails} authDetails Contains the authentication data
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {newPasswordRequired} callback.newPasswordRequired new
   *        password and any required attributes are required to continue
   * @param {mfaRequired} callback.mfaRequired MFA code
   *        required to continue.
   * @param {customChallenge} callback.customChallenge Custom challenge
   *        response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @returns {void}
   */ ;
    _proto.authenticateUser = function authenticateUser(authDetails, callback) {
        if (this.authenticationFlowType === "USER_PASSWORD_AUTH") return this.authenticateUserPlainUsernamePassword(authDetails, callback);
        else if (this.authenticationFlowType === "USER_SRP_AUTH" || this.authenticationFlowType === "CUSTOM_AUTH") return this.authenticateUserDefaultAuth(authDetails, callback);
        return callback.onFailure(new Error("Authentication flow type is invalid."));
    } /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   * It calls the AuthenticationHelper for SRP related
   * stuff
   * @param {AuthenticationDetails} authDetails Contains the authentication data
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {newPasswordRequired} callback.newPasswordRequired new
   *        password and any required attributes are required to continue
   * @param {mfaRequired} callback.mfaRequired MFA code
   *        required to continue.
   * @param {customChallenge} callback.customChallenge Custom challenge
   *        response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @returns {void}
   */ ;
    _proto.authenticateUserDefaultAuth = function authenticateUserDefaultAuth(authDetails, callback) {
        var _this2 = this;
        var authenticationHelper = new (0, $001e67252ab4d534$export$2e2bcd8739ae039)(this.pool.getUserPoolName());
        var dateHelper = new (0, $2732f22d5f2465e4$export$2e2bcd8739ae039)();
        var serverBValue;
        var salt;
        var authParameters = {};
        if (this.deviceKey != null) authParameters.DEVICE_KEY = this.deviceKey;
        authParameters.USERNAME = this.username;
        authenticationHelper.getLargeAValue(function(errOnAValue, aValue) {
            // getLargeAValue callback start
            if (errOnAValue) callback.onFailure(errOnAValue);
            authParameters.SRP_A = aValue.toString(16);
            if (_this2.authenticationFlowType === "CUSTOM_AUTH") authParameters.CHALLENGE_NAME = "SRP_A";
            var clientMetaData = Object.keys(authDetails.getValidationData()).length !== 0 ? authDetails.getValidationData() : authDetails.getClientMetadata();
            var jsonReq = {
                AuthFlow: _this2.authenticationFlowType,
                ClientId: _this2.pool.getClientId(),
                AuthParameters: authParameters,
                ClientMetadata: clientMetaData
            };
            if (_this2.getUserContextData(_this2.username)) jsonReq.UserContextData = _this2.getUserContextData(_this2.username);
            _this2.client.request("InitiateAuth", jsonReq, function(err, data) {
                if (err) return callback.onFailure(err);
                var challengeParameters = data.ChallengeParameters;
                _this2.username = challengeParameters.USER_ID_FOR_SRP;
                _this2.userDataKey = _this2.keyPrefix + "." + _this2.username + ".userData";
                serverBValue = new (0, $304b0713d23ec50f$export$2e2bcd8739ae039)(challengeParameters.SRP_B, 16);
                salt = new (0, $304b0713d23ec50f$export$2e2bcd8739ae039)(challengeParameters.SALT, 16);
                _this2.getCachedDeviceKeyAndPassword();
                authenticationHelper.getPasswordAuthenticationKey(_this2.username, authDetails.getPassword(), serverBValue, salt, function(errOnHkdf, hkdf) {
                    // getPasswordAuthenticationKey callback start
                    if (errOnHkdf) callback.onFailure(errOnHkdf);
                    var dateNow = dateHelper.getNowString();
                    var concatBuffer = (0, $jYnzf.Buffer).concat([
                        (0, $jYnzf.Buffer).from(_this2.pool.getUserPoolName(), "utf8"),
                        (0, $jYnzf.Buffer).from(_this2.username, "utf8"),
                        (0, $jYnzf.Buffer).from(challengeParameters.SECRET_BLOCK, "base64"),
                        (0, $jYnzf.Buffer).from(dateNow, "utf8")
                    ]);
                    var awsCryptoHash = new (0, $5fc867b0e21dc729$exports.Sha256)(hkdf);
                    awsCryptoHash.update(concatBuffer);
                    var resultFromAWSCrypto = awsCryptoHash.digestSync();
                    var signatureString = (0, $jYnzf.Buffer).from(resultFromAWSCrypto).toString("base64");
                    var challengeResponses = {};
                    challengeResponses.USERNAME = _this2.username;
                    challengeResponses.PASSWORD_CLAIM_SECRET_BLOCK = challengeParameters.SECRET_BLOCK;
                    challengeResponses.TIMESTAMP = dateNow;
                    challengeResponses.PASSWORD_CLAIM_SIGNATURE = signatureString;
                    if (_this2.deviceKey != null) challengeResponses.DEVICE_KEY = _this2.deviceKey;
                    var respondToAuthChallenge = function respondToAuthChallenge(challenge, challengeCallback) {
                        return _this2.client.request("RespondToAuthChallenge", challenge, function(errChallenge, dataChallenge) {
                            if (errChallenge && errChallenge.code === "ResourceNotFoundException" && errChallenge.message.toLowerCase().indexOf("device") !== -1) {
                                challengeResponses.DEVICE_KEY = null;
                                _this2.deviceKey = null;
                                _this2.randomPassword = null;
                                _this2.deviceGroupKey = null;
                                _this2.clearCachedDeviceKeyAndPassword();
                                return respondToAuthChallenge(challenge, challengeCallback);
                            }
                            return challengeCallback(errChallenge, dataChallenge);
                        });
                    };
                    var jsonReqResp = {
                        ChallengeName: "PASSWORD_VERIFIER",
                        ClientId: _this2.pool.getClientId(),
                        ChallengeResponses: challengeResponses,
                        Session: data.Session,
                        ClientMetadata: clientMetaData
                    };
                    if (_this2.getUserContextData()) jsonReqResp.UserContextData = _this2.getUserContextData();
                    respondToAuthChallenge(jsonReqResp, function(errAuthenticate, dataAuthenticate) {
                        if (errAuthenticate) return callback.onFailure(errAuthenticate);
                        return _this2.authenticateUserInternal(dataAuthenticate, authenticationHelper, callback);
                    });
                    return undefined;
                // getPasswordAuthenticationKey callback end
                });
                return undefined;
            });
        // getLargeAValue callback end
        });
    } /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   * @param {AuthenticationDetails} authDetails Contains the authentication data.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {mfaRequired} callback.mfaRequired MFA code
   *        required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @returns {void}
   */ ;
    _proto.authenticateUserPlainUsernamePassword = function authenticateUserPlainUsernamePassword(authDetails, callback) {
        var _this3 = this;
        var authParameters = {};
        authParameters.USERNAME = this.username;
        authParameters.PASSWORD = authDetails.getPassword();
        if (!authParameters.PASSWORD) {
            callback.onFailure(new Error("PASSWORD parameter is required"));
            return;
        }
        var authenticationHelper = new (0, $001e67252ab4d534$export$2e2bcd8739ae039)(this.pool.getUserPoolName());
        this.getCachedDeviceKeyAndPassword();
        if (this.deviceKey != null) authParameters.DEVICE_KEY = this.deviceKey;
        var clientMetaData = Object.keys(authDetails.getValidationData()).length !== 0 ? authDetails.getValidationData() : authDetails.getClientMetadata();
        var jsonReq = {
            AuthFlow: "USER_PASSWORD_AUTH",
            ClientId: this.pool.getClientId(),
            AuthParameters: authParameters,
            ClientMetadata: clientMetaData
        };
        if (this.getUserContextData(this.username)) jsonReq.UserContextData = this.getUserContextData(this.username);
        // USER_PASSWORD_AUTH happens in a single round-trip: client sends userName and password,
        // Cognito UserPools verifies password and returns tokens.
        this.client.request("InitiateAuth", jsonReq, function(err, authResult) {
            if (err) return callback.onFailure(err);
            return _this3.authenticateUserInternal(authResult, authenticationHelper, callback);
        });
    } /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   * @param {object} dataAuthenticate authentication data
   * @param {object} authenticationHelper helper created
   * @param {callback} callback passed on from caller
   * @returns {void}
   */ ;
    _proto.authenticateUserInternal = function authenticateUserInternal(dataAuthenticate, authenticationHelper, callback) {
        var _this4 = this;
        var challengeName = dataAuthenticate.ChallengeName;
        var challengeParameters = dataAuthenticate.ChallengeParameters;
        if (challengeName === "SMS_MFA") {
            this.Session = dataAuthenticate.Session;
            return callback.mfaRequired(challengeName, challengeParameters);
        }
        if (challengeName === "SELECT_MFA_TYPE") {
            this.Session = dataAuthenticate.Session;
            return callback.selectMFAType(challengeName, challengeParameters);
        }
        if (challengeName === "MFA_SETUP") {
            this.Session = dataAuthenticate.Session;
            return callback.mfaSetup(challengeName, challengeParameters);
        }
        if (challengeName === "SOFTWARE_TOKEN_MFA") {
            this.Session = dataAuthenticate.Session;
            return callback.totpRequired(challengeName, challengeParameters);
        }
        if (challengeName === "CUSTOM_CHALLENGE") {
            this.Session = dataAuthenticate.Session;
            return callback.customChallenge(challengeParameters);
        }
        if (challengeName === "NEW_PASSWORD_REQUIRED") {
            this.Session = dataAuthenticate.Session;
            var userAttributes = null;
            var rawRequiredAttributes = null;
            var requiredAttributes = [];
            var userAttributesPrefix = authenticationHelper.getNewPasswordRequiredChallengeUserAttributePrefix();
            if (challengeParameters) {
                userAttributes = JSON.parse(dataAuthenticate.ChallengeParameters.userAttributes);
                rawRequiredAttributes = JSON.parse(dataAuthenticate.ChallengeParameters.requiredAttributes);
            }
            if (rawRequiredAttributes) for(var i = 0; i < rawRequiredAttributes.length; i++)requiredAttributes[i] = rawRequiredAttributes[i].substr(userAttributesPrefix.length);
            return callback.newPasswordRequired(userAttributes, requiredAttributes);
        }
        if (challengeName === "DEVICE_SRP_AUTH") {
            this.Session = dataAuthenticate.Session;
            this.getDeviceResponse(callback);
            return undefined;
        }
        this.signInUserSession = this.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
        this.challengeName = challengeName;
        this.cacheTokens();
        var newDeviceMetadata = dataAuthenticate.AuthenticationResult.NewDeviceMetadata;
        if (newDeviceMetadata == null) return callback.onSuccess(this.signInUserSession);
        authenticationHelper.generateHashDevice(dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey, dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey, function(errGenHash) {
            if (errGenHash) return callback.onFailure(errGenHash);
            var deviceSecretVerifierConfig = {
                Salt: (0, $jYnzf.Buffer).from(authenticationHelper.getSaltDevices(), "hex").toString("base64"),
                PasswordVerifier: (0, $jYnzf.Buffer).from(authenticationHelper.getVerifierDevices(), "hex").toString("base64")
            };
            _this4.verifierDevices = deviceSecretVerifierConfig.PasswordVerifier;
            _this4.deviceGroupKey = newDeviceMetadata.DeviceGroupKey;
            _this4.randomPassword = authenticationHelper.getRandomPassword();
            _this4.client.request("ConfirmDevice", {
                DeviceKey: newDeviceMetadata.DeviceKey,
                AccessToken: _this4.signInUserSession.getAccessToken().getJwtToken(),
                DeviceSecretVerifierConfig: deviceSecretVerifierConfig,
                DeviceName: $8ebdccf88ce233cf$var$userAgent
            }, function(errConfirm, dataConfirm) {
                if (errConfirm) return callback.onFailure(errConfirm);
                _this4.deviceKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey;
                _this4.cacheDeviceKeyAndPassword();
                if (dataConfirm.UserConfirmationNecessary === true) return callback.onSuccess(_this4.signInUserSession, dataConfirm.UserConfirmationNecessary);
                return callback.onSuccess(_this4.signInUserSession);
            });
            return undefined;
        });
        return undefined;
    } /**
   * This method is user to complete the NEW_PASSWORD_REQUIRED challenge.
   * Pass the new password with any new user attributes to be updated.
   * User attribute keys must be of format userAttributes.<attribute_name>.
   * @param {string} newPassword new password for this user
   * @param {object} requiredAttributeData map with values for all required attributes
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {mfaRequired} callback.mfaRequired MFA code required to continue.
   * @param {customChallenge} callback.customChallenge Custom challenge
   *         response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.completeNewPasswordChallenge = function completeNewPasswordChallenge(newPassword, requiredAttributeData, callback, clientMetadata) {
        var _this5 = this;
        if (!newPassword) return callback.onFailure(new Error("New password is required."));
        var authenticationHelper = new (0, $001e67252ab4d534$export$2e2bcd8739ae039)(this.pool.getUserPoolName());
        var userAttributesPrefix = authenticationHelper.getNewPasswordRequiredChallengeUserAttributePrefix();
        var finalUserAttributes = {};
        if (requiredAttributeData) Object.keys(requiredAttributeData).forEach(function(key) {
            finalUserAttributes[userAttributesPrefix + key] = requiredAttributeData[key];
        });
        finalUserAttributes.NEW_PASSWORD = newPassword;
        finalUserAttributes.USERNAME = this.username;
        var jsonReq = {
            ChallengeName: "NEW_PASSWORD_REQUIRED",
            ClientId: this.pool.getClientId(),
            ChallengeResponses: finalUserAttributes,
            Session: this.Session,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("RespondToAuthChallenge", jsonReq, function(errAuthenticate, dataAuthenticate) {
            if (errAuthenticate) return callback.onFailure(errAuthenticate);
            return _this5.authenticateUserInternal(dataAuthenticate, authenticationHelper, callback);
        });
        return undefined;
    } /**
   * This is used to get a session using device authentication. It is called at the end of user
   * authentication
   *
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   * @private
   */ ;
    _proto.getDeviceResponse = function getDeviceResponse(callback, clientMetadata) {
        var _this6 = this;
        var authenticationHelper = new (0, $001e67252ab4d534$export$2e2bcd8739ae039)(this.deviceGroupKey);
        var dateHelper = new (0, $2732f22d5f2465e4$export$2e2bcd8739ae039)();
        var authParameters = {};
        authParameters.USERNAME = this.username;
        authParameters.DEVICE_KEY = this.deviceKey;
        authenticationHelper.getLargeAValue(function(errAValue, aValue) {
            // getLargeAValue callback start
            if (errAValue) callback.onFailure(errAValue);
            authParameters.SRP_A = aValue.toString(16);
            var jsonReq = {
                ChallengeName: "DEVICE_SRP_AUTH",
                ClientId: _this6.pool.getClientId(),
                ChallengeResponses: authParameters,
                ClientMetadata: clientMetadata,
                Session: _this6.Session
            };
            if (_this6.getUserContextData()) jsonReq.UserContextData = _this6.getUserContextData();
            _this6.client.request("RespondToAuthChallenge", jsonReq, function(err, data) {
                if (err) return callback.onFailure(err);
                var challengeParameters = data.ChallengeParameters;
                var serverBValue = new (0, $304b0713d23ec50f$export$2e2bcd8739ae039)(challengeParameters.SRP_B, 16);
                var salt = new (0, $304b0713d23ec50f$export$2e2bcd8739ae039)(challengeParameters.SALT, 16);
                authenticationHelper.getPasswordAuthenticationKey(_this6.deviceKey, _this6.randomPassword, serverBValue, salt, function(errHkdf, hkdf) {
                    // getPasswordAuthenticationKey callback start
                    if (errHkdf) return callback.onFailure(errHkdf);
                    var dateNow = dateHelper.getNowString();
                    var concatBuffer = (0, $jYnzf.Buffer).concat([
                        (0, $jYnzf.Buffer).from(_this6.deviceGroupKey, "utf8"),
                        (0, $jYnzf.Buffer).from(_this6.deviceKey, "utf8"),
                        (0, $jYnzf.Buffer).from(challengeParameters.SECRET_BLOCK, "base64"),
                        (0, $jYnzf.Buffer).from(dateNow, "utf8")
                    ]);
                    var awsCryptoHash = new (0, $5fc867b0e21dc729$exports.Sha256)(hkdf);
                    awsCryptoHash.update(concatBuffer);
                    var resultFromAWSCrypto = awsCryptoHash.digestSync();
                    var signatureString = (0, $jYnzf.Buffer).from(resultFromAWSCrypto).toString("base64");
                    var challengeResponses = {};
                    challengeResponses.USERNAME = _this6.username;
                    challengeResponses.PASSWORD_CLAIM_SECRET_BLOCK = challengeParameters.SECRET_BLOCK;
                    challengeResponses.TIMESTAMP = dateNow;
                    challengeResponses.PASSWORD_CLAIM_SIGNATURE = signatureString;
                    challengeResponses.DEVICE_KEY = _this6.deviceKey;
                    var jsonReqResp = {
                        ChallengeName: "DEVICE_PASSWORD_VERIFIER",
                        ClientId: _this6.pool.getClientId(),
                        ChallengeResponses: challengeResponses,
                        Session: data.Session
                    };
                    if (_this6.getUserContextData()) jsonReqResp.UserContextData = _this6.getUserContextData();
                    _this6.client.request("RespondToAuthChallenge", jsonReqResp, function(errAuthenticate, dataAuthenticate) {
                        if (errAuthenticate) return callback.onFailure(errAuthenticate);
                        _this6.signInUserSession = _this6.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
                        _this6.cacheTokens();
                        return callback.onSuccess(_this6.signInUserSession);
                    });
                    return undefined;
                // getPasswordAuthenticationKey callback end
                });
                return undefined;
            });
        // getLargeAValue callback end
        });
    } /**
   * This is used for a certain user to confirm the registration by using a confirmation code
   * @param {string} confirmationCode Code entered by user.
   * @param {bool} forceAliasCreation Allow migrating from an existing email / phone number.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.confirmRegistration = function confirmRegistration(confirmationCode, forceAliasCreation, callback, clientMetadata) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            ConfirmationCode: confirmationCode,
            Username: this.username,
            ForceAliasCreation: forceAliasCreation,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("ConfirmSignUp", jsonReq, function(err) {
            if (err) return callback(err, null);
            return callback(null, "SUCCESS");
        });
    } /**
   * This is used by the user once he has the responses to a custom challenge
   * @param {string} answerChallenge The custom challenge answer.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {customChallenge} callback.customChallenge
   *    Custom challenge response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.sendCustomChallengeAnswer = function sendCustomChallengeAnswer(answerChallenge, callback, clientMetadata) {
        var _this7 = this;
        var challengeResponses = {};
        challengeResponses.USERNAME = this.username;
        challengeResponses.ANSWER = answerChallenge;
        var authenticationHelper = new (0, $001e67252ab4d534$export$2e2bcd8739ae039)(this.pool.getUserPoolName());
        this.getCachedDeviceKeyAndPassword();
        if (this.deviceKey != null) challengeResponses.DEVICE_KEY = this.deviceKey;
        var jsonReq = {
            ChallengeName: "CUSTOM_CHALLENGE",
            ChallengeResponses: challengeResponses,
            ClientId: this.pool.getClientId(),
            Session: this.Session,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("RespondToAuthChallenge", jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            return _this7.authenticateUserInternal(data, authenticationHelper, callback);
        });
    } /**
   * This is used by the user once he has an MFA code
   * @param {string} confirmationCode The MFA code entered by the user.
   * @param {object} callback Result callback map.
   * @param {string} mfaType The mfa we are replying to.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.sendMFACode = function sendMFACode(confirmationCode, callback, mfaType, clientMetadata) {
        var _this8 = this;
        var challengeResponses = {};
        challengeResponses.USERNAME = this.username;
        challengeResponses.SMS_MFA_CODE = confirmationCode;
        var mfaTypeSelection = mfaType || "SMS_MFA";
        if (mfaTypeSelection === "SOFTWARE_TOKEN_MFA") challengeResponses.SOFTWARE_TOKEN_MFA_CODE = confirmationCode;
        if (this.deviceKey != null) challengeResponses.DEVICE_KEY = this.deviceKey;
        var jsonReq = {
            ChallengeName: mfaTypeSelection,
            ChallengeResponses: challengeResponses,
            ClientId: this.pool.getClientId(),
            Session: this.Session,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("RespondToAuthChallenge", jsonReq, function(err, dataAuthenticate) {
            if (err) return callback.onFailure(err);
            var challengeName = dataAuthenticate.ChallengeName;
            if (challengeName === "DEVICE_SRP_AUTH") {
                _this8.getDeviceResponse(callback);
                return undefined;
            }
            _this8.signInUserSession = _this8.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
            _this8.cacheTokens();
            if (dataAuthenticate.AuthenticationResult.NewDeviceMetadata == null) return callback.onSuccess(_this8.signInUserSession);
            var authenticationHelper = new (0, $001e67252ab4d534$export$2e2bcd8739ae039)(_this8.pool.getUserPoolName());
            authenticationHelper.generateHashDevice(dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey, dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey, function(errGenHash) {
                if (errGenHash) return callback.onFailure(errGenHash);
                var deviceSecretVerifierConfig = {
                    Salt: (0, $jYnzf.Buffer).from(authenticationHelper.getSaltDevices(), "hex").toString("base64"),
                    PasswordVerifier: (0, $jYnzf.Buffer).from(authenticationHelper.getVerifierDevices(), "hex").toString("base64")
                };
                _this8.verifierDevices = deviceSecretVerifierConfig.PasswordVerifier;
                _this8.deviceGroupKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey;
                _this8.randomPassword = authenticationHelper.getRandomPassword();
                _this8.client.request("ConfirmDevice", {
                    DeviceKey: dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey,
                    AccessToken: _this8.signInUserSession.getAccessToken().getJwtToken(),
                    DeviceSecretVerifierConfig: deviceSecretVerifierConfig,
                    DeviceName: $8ebdccf88ce233cf$var$userAgent
                }, function(errConfirm, dataConfirm) {
                    if (errConfirm) return callback.onFailure(errConfirm);
                    _this8.deviceKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey;
                    _this8.cacheDeviceKeyAndPassword();
                    if (dataConfirm.UserConfirmationNecessary === true) return callback.onSuccess(_this8.signInUserSession, dataConfirm.UserConfirmationNecessary);
                    return callback.onSuccess(_this8.signInUserSession);
                });
                return undefined;
            });
            return undefined;
        });
    } /**
   * This is used by an authenticated user to change the current password
   * @param {string} oldUserPassword The current password.
   * @param {string} newUserPassword The requested new password.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.changePassword = function changePassword(oldUserPassword, newUserPassword, callback, clientMetadata) {
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error("User is not authenticated"), null);
        this.client.request("ChangePassword", {
            PreviousPassword: oldUserPassword,
            ProposedPassword: newUserPassword,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            ClientMetadata: clientMetadata
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, "SUCCESS");
        });
        return undefined;
    } /**
   * This is used by an authenticated user to enable MFA for itself
   * @deprecated
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.enableMFA = function enableMFA(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error("User is not authenticated"), null);
        var mfaOptions = [];
        var mfaEnabled = {
            DeliveryMedium: "SMS",
            AttributeName: "phone_number"
        };
        mfaOptions.push(mfaEnabled);
        this.client.request("SetUserSettings", {
            MFAOptions: mfaOptions,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, "SUCCESS");
        });
        return undefined;
    } /**
   * This is used by an authenticated user to enable MFA for itself
   * @param {IMfaSettings} smsMfaSettings the sms mfa settings
   * @param {IMFASettings} softwareTokenMfaSettings the software token mfa settings
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.setUserMfaPreference = function setUserMfaPreference(smsMfaSettings, softwareTokenMfaSettings, callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error("User is not authenticated"), null);
        this.client.request("SetUserMFAPreference", {
            SMSMfaSettings: smsMfaSettings,
            SoftwareTokenMfaSettings: softwareTokenMfaSettings,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, "SUCCESS");
        });
        return undefined;
    } /**
   * This is used by an authenticated user to disable MFA for itself
   * @deprecated
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.disableMFA = function disableMFA(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error("User is not authenticated"), null);
        var mfaOptions = [];
        this.client.request("SetUserSettings", {
            MFAOptions: mfaOptions,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, "SUCCESS");
        });
        return undefined;
    } /**
   * This is used by an authenticated user to delete itself
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.deleteUser = function deleteUser(callback, clientMetadata) {
        var _this9 = this;
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error("User is not authenticated"), null);
        this.client.request("DeleteUser", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            ClientMetadata: clientMetadata
        }, function(err) {
            if (err) return callback(err, null);
            _this9.clearCachedUser();
            return callback(null, "SUCCESS");
        });
        return undefined;
    } /**
   * This is used by an authenticated user to change a list of attributes
   * @param {AttributeArg[]} attributes A list of the new user attributes.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.updateAttributes = function updateAttributes(attributes, callback, clientMetadata) {
        var _this10 = this;
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error("User is not authenticated"), null);
        this.client.request("UpdateUserAttributes", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            UserAttributes: attributes,
            ClientMetadata: clientMetadata
        }, function(err, result) {
            if (err) return callback(err, null);
            // update cached user
            return _this10.getUserData(function() {
                return callback(null, "SUCCESS", result);
            }, {
                bypassCache: true
            });
        });
        return undefined;
    } /**
   * This is used by an authenticated user to get a list of attributes
   * @param {nodeCallback<CognitoUserAttribute[]>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.getUserAttributes = function getUserAttributes(callback) {
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error("User is not authenticated"), null);
        this.client.request("GetUser", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err, userData) {
            if (err) return callback(err, null);
            var attributeList = [];
            for(var i = 0; i < userData.UserAttributes.length; i++){
                var attribute = {
                    Name: userData.UserAttributes[i].Name,
                    Value: userData.UserAttributes[i].Value
                };
                var userAttribute = new (0, $07e538300be3afb7$export$2e2bcd8739ae039)(attribute);
                attributeList.push(userAttribute);
            }
            return callback(null, attributeList);
        });
        return undefined;
    } /**
   * This was previously used by an authenticated user to get MFAOptions,
   * but no longer returns a meaningful response. Refer to the documentation for
   * how to setup and use MFA: https://docs.amplify.aws/lib/auth/mfa/q/platform/js
   * @deprecated
   * @param {nodeCallback<MFAOptions>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.getMFAOptions = function getMFAOptions(callback) {
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error("User is not authenticated"), null);
        this.client.request("GetUser", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err, userData) {
            if (err) return callback(err, null);
            return callback(null, userData.MFAOptions);
        });
        return undefined;
    } /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   */ ;
    _proto.createGetUserRequest = function createGetUserRequest() {
        return this.client.promisifyRequest("GetUser", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        });
    } /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   */ ;
    _proto.refreshSessionIfPossible = function refreshSessionIfPossible(options) {
        var _this11 = this;
        if (options === void 0) options = {};
        // best effort, if not possible
        return new Promise(function(resolve) {
            var refresh = _this11.signInUserSession.getRefreshToken();
            if (refresh && refresh.getToken()) _this11.refreshSession(refresh, resolve, options.clientMetadata);
            else resolve();
        });
    } /**
   * This is used by an authenticated users to get the userData
   * @param {nodeCallback<UserData>} callback Called on success or error.
   * @param {GetUserDataOptions} params
   * @returns {void}
   */ ;
    _proto.getUserData = function getUserData(callback, params) {
        var _this12 = this;
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) {
            this.clearCachedUserData();
            return callback(new Error("User is not authenticated"), null);
        }
        var userData = this.getUserDataFromCache();
        if (!userData) {
            this.fetchUserData().then(function(data) {
                callback(null, data);
            })["catch"](callback);
            return;
        }
        if (this.isFetchUserDataAndTokenRequired(params)) {
            this.fetchUserData().then(function(data) {
                return _this12.refreshSessionIfPossible(params).then(function() {
                    return data;
                });
            }).then(function(data) {
                return callback(null, data);
            })["catch"](callback);
            return;
        }
        try {
            callback(null, JSON.parse(userData));
            return;
        } catch (err) {
            this.clearCachedUserData();
            callback(err, null);
            return;
        }
    } /**
   *
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   */ ;
    _proto.getUserDataFromCache = function getUserDataFromCache() {
        var userData = this.storage.getItem(this.userDataKey);
        return userData;
    } /**
   *
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   */ ;
    _proto.isFetchUserDataAndTokenRequired = function isFetchUserDataAndTokenRequired(params) {
        var _ref = params || {}, _ref$bypassCache = _ref.bypassCache, bypassCache = _ref$bypassCache === void 0 ? false : _ref$bypassCache;
        return bypassCache;
    } /**
   *
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   */ ;
    _proto.fetchUserData = function fetchUserData() {
        var _this13 = this;
        return this.createGetUserRequest().then(function(data) {
            _this13.cacheUserData(data);
            return data;
        });
    } /**
   * This is used by an authenticated user to delete a list of attributes
   * @param {string[]} attributeList Names of the attributes to delete.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.deleteAttributes = function deleteAttributes(attributeList, callback) {
        var _this14 = this;
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error("User is not authenticated"), null);
        this.client.request("DeleteUserAttributes", {
            UserAttributeNames: attributeList,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            // update cached user
            return _this14.getUserData(function() {
                return callback(null, "SUCCESS");
            }, {
                bypassCache: true
            });
        });
        return undefined;
    } /**
   * This is used by a user to resend a confirmation code
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.resendConfirmationCode = function resendConfirmationCode(callback, clientMetadata) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            Username: this.username,
            ClientMetadata: clientMetadata
        };
        this.client.request("ResendConfirmationCode", jsonReq, function(err, result) {
            if (err) return callback(err, null);
            return callback(null, result);
        });
    } /**
   * This is used to get a session, either from the session object
   * or from  the local storage, or by using a refresh token
   *
   * @param {nodeCallback<CognitoUserSession>} callback Called on success or error.
   * @param {GetSessionOptions} options
   * @returns {void}
   */ ;
    _proto.getSession = function getSession(callback, options) {
        if (options === void 0) options = {};
        if (this.username == null) return callback(new Error("Username is null. Cannot retrieve a new session"), null);
        if (this.signInUserSession != null && this.signInUserSession.isValid()) return callback(null, this.signInUserSession);
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var idTokenKey = keyPrefix + ".idToken";
        var accessTokenKey = keyPrefix + ".accessToken";
        var refreshTokenKey = keyPrefix + ".refreshToken";
        var clockDriftKey = keyPrefix + ".clockDrift";
        if (this.storage.getItem(idTokenKey)) {
            var idToken = new (0, $c52a3226127cf6d9$export$2e2bcd8739ae039)({
                IdToken: this.storage.getItem(idTokenKey)
            });
            var accessToken = new (0, $06e88dd6c8c409ac$export$2e2bcd8739ae039)({
                AccessToken: this.storage.getItem(accessTokenKey)
            });
            var refreshToken = new (0, $5b8285bfbb1b289f$export$2e2bcd8739ae039)({
                RefreshToken: this.storage.getItem(refreshTokenKey)
            });
            var clockDrift = parseInt(this.storage.getItem(clockDriftKey), 0) || 0;
            var sessionData = {
                IdToken: idToken,
                AccessToken: accessToken,
                RefreshToken: refreshToken,
                ClockDrift: clockDrift
            };
            var cachedSession = new (0, $98867a2573ca3d6e$export$2e2bcd8739ae039)(sessionData);
            if (cachedSession.isValid()) {
                this.signInUserSession = cachedSession;
                return callback(null, this.signInUserSession);
            }
            if (!refreshToken.getToken()) return callback(new Error("Cannot retrieve a new session. Please authenticate."), null);
            this.refreshSession(refreshToken, callback, options.clientMetadata);
        } else callback(new Error("Local storage is missing an ID Token, Please authenticate"), null);
        return undefined;
    } /**
   * This uses the refreshToken to retrieve a new session
   * @param {CognitoRefreshToken} refreshToken A previous session's refresh token.
   * @param {nodeCallback<CognitoUserSession>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.refreshSession = function refreshSession(refreshToken, callback, clientMetadata) {
        var _this15 = this;
        var wrappedCallback = this.pool.wrapRefreshSessionCallback ? this.pool.wrapRefreshSessionCallback(callback) : callback;
        var authParameters = {};
        authParameters.REFRESH_TOKEN = refreshToken.getToken();
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        var lastUserKey = keyPrefix + ".LastAuthUser";
        if (this.storage.getItem(lastUserKey)) {
            this.username = this.storage.getItem(lastUserKey);
            var deviceKeyKey = keyPrefix + "." + this.username + ".deviceKey";
            this.deviceKey = this.storage.getItem(deviceKeyKey);
            authParameters.DEVICE_KEY = this.deviceKey;
        }
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            AuthFlow: "REFRESH_TOKEN_AUTH",
            AuthParameters: authParameters,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("InitiateAuth", jsonReq, function(err, authResult) {
            if (err) {
                if (err.code === "NotAuthorizedException") _this15.clearCachedUser();
                return wrappedCallback(err, null);
            }
            if (authResult) {
                var authenticationResult = authResult.AuthenticationResult;
                if (!Object.prototype.hasOwnProperty.call(authenticationResult, "RefreshToken")) authenticationResult.RefreshToken = refreshToken.getToken();
                _this15.signInUserSession = _this15.getCognitoUserSession(authenticationResult);
                _this15.cacheTokens();
                return wrappedCallback(null, _this15.signInUserSession);
            }
            return undefined;
        });
    } /**
   * This is used to save the session tokens to local storage
   * @returns {void}
   */ ;
    _proto.cacheTokens = function cacheTokens() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        var idTokenKey = keyPrefix + "." + this.username + ".idToken";
        var accessTokenKey = keyPrefix + "." + this.username + ".accessToken";
        var refreshTokenKey = keyPrefix + "." + this.username + ".refreshToken";
        var clockDriftKey = keyPrefix + "." + this.username + ".clockDrift";
        var lastUserKey = keyPrefix + ".LastAuthUser";
        this.storage.setItem(idTokenKey, this.signInUserSession.getIdToken().getJwtToken());
        this.storage.setItem(accessTokenKey, this.signInUserSession.getAccessToken().getJwtToken());
        this.storage.setItem(refreshTokenKey, this.signInUserSession.getRefreshToken().getToken());
        this.storage.setItem(clockDriftKey, "" + this.signInUserSession.getClockDrift());
        this.storage.setItem(lastUserKey, this.username);
    } /**
   * This is to cache user data
   */ ;
    _proto.cacheUserData = function cacheUserData(userData) {
        this.storage.setItem(this.userDataKey, JSON.stringify(userData));
    } /**
   * This is to remove cached user data
   */ ;
    _proto.clearCachedUserData = function clearCachedUserData() {
        this.storage.removeItem(this.userDataKey);
    };
    _proto.clearCachedUser = function clearCachedUser() {
        this.clearCachedTokens();
        this.clearCachedUserData();
    } /**
   * This is used to cache the device key and device group and device password
   * @returns {void}
   */ ;
    _proto.cacheDeviceKeyAndPassword = function cacheDeviceKeyAndPassword() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var deviceKeyKey = keyPrefix + ".deviceKey";
        var randomPasswordKey = keyPrefix + ".randomPasswordKey";
        var deviceGroupKeyKey = keyPrefix + ".deviceGroupKey";
        this.storage.setItem(deviceKeyKey, this.deviceKey);
        this.storage.setItem(randomPasswordKey, this.randomPassword);
        this.storage.setItem(deviceGroupKeyKey, this.deviceGroupKey);
    } /**
   * This is used to get current device key and device group and device password
   * @returns {void}
   */ ;
    _proto.getCachedDeviceKeyAndPassword = function getCachedDeviceKeyAndPassword() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var deviceKeyKey = keyPrefix + ".deviceKey";
        var randomPasswordKey = keyPrefix + ".randomPasswordKey";
        var deviceGroupKeyKey = keyPrefix + ".deviceGroupKey";
        if (this.storage.getItem(deviceKeyKey)) {
            this.deviceKey = this.storage.getItem(deviceKeyKey);
            this.randomPassword = this.storage.getItem(randomPasswordKey);
            this.deviceGroupKey = this.storage.getItem(deviceGroupKeyKey);
        }
    } /**
   * This is used to clear the device key info from local storage
   * @returns {void}
   */ ;
    _proto.clearCachedDeviceKeyAndPassword = function clearCachedDeviceKeyAndPassword() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var deviceKeyKey = keyPrefix + ".deviceKey";
        var randomPasswordKey = keyPrefix + ".randomPasswordKey";
        var deviceGroupKeyKey = keyPrefix + ".deviceGroupKey";
        this.storage.removeItem(deviceKeyKey);
        this.storage.removeItem(randomPasswordKey);
        this.storage.removeItem(deviceGroupKeyKey);
    } /**
   * This is used to clear the session tokens from local storage
   * @returns {void}
   */ ;
    _proto.clearCachedTokens = function clearCachedTokens() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        var idTokenKey = keyPrefix + "." + this.username + ".idToken";
        var accessTokenKey = keyPrefix + "." + this.username + ".accessToken";
        var refreshTokenKey = keyPrefix + "." + this.username + ".refreshToken";
        var lastUserKey = keyPrefix + ".LastAuthUser";
        var clockDriftKey = keyPrefix + "." + this.username + ".clockDrift";
        this.storage.removeItem(idTokenKey);
        this.storage.removeItem(accessTokenKey);
        this.storage.removeItem(refreshTokenKey);
        this.storage.removeItem(lastUserKey);
        this.storage.removeItem(clockDriftKey);
    } /**
   * This is used to build a user session from tokens retrieved in the authentication result
   * @param {object} authResult Successful auth response from server.
   * @returns {CognitoUserSession} The new user session.
   * @private
   */ ;
    _proto.getCognitoUserSession = function getCognitoUserSession(authResult) {
        var idToken = new (0, $c52a3226127cf6d9$export$2e2bcd8739ae039)(authResult);
        var accessToken = new (0, $06e88dd6c8c409ac$export$2e2bcd8739ae039)(authResult);
        var refreshToken = new (0, $5b8285bfbb1b289f$export$2e2bcd8739ae039)(authResult);
        var sessionData = {
            IdToken: idToken,
            AccessToken: accessToken,
            RefreshToken: refreshToken
        };
        return new (0, $98867a2573ca3d6e$export$2e2bcd8739ae039)(sessionData);
    } /**
   * This is used to initiate a forgot password request
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {inputVerificationCode?} callback.inputVerificationCode
   *    Optional callback raised instead of onSuccess with response data.
   * @param {onSuccess} callback.onSuccess Called on success.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.forgotPassword = function forgotPassword(callback, clientMetadata) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            Username: this.username,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("ForgotPassword", jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            if (typeof callback.inputVerificationCode === "function") return callback.inputVerificationCode(data);
            return callback.onSuccess(data);
        });
    } /**
   * This is used to confirm a new password using a confirmationCode
   * @param {string} confirmationCode Code entered by user.
   * @param {string} newPassword Confirm new password.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<void>} callback.onSuccess Called on success.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.confirmPassword = function confirmPassword(confirmationCode, newPassword, callback, clientMetadata) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            Username: this.username,
            ConfirmationCode: confirmationCode,
            Password: newPassword,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("ConfirmForgotPassword", jsonReq, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess("SUCCESS");
        });
    } /**
   * This is used to initiate an attribute confirmation request
   * @param {string} attributeName User attribute that needs confirmation.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {inputVerificationCode} callback.inputVerificationCode Called on success.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.getAttributeVerificationCode = function getAttributeVerificationCode(attributeName, callback, clientMetadata) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("GetUserAttributeVerificationCode", {
            AttributeName: attributeName,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            ClientMetadata: clientMetadata
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            if (typeof callback.inputVerificationCode === "function") return callback.inputVerificationCode(data);
            return callback.onSuccess("SUCCESS");
        });
        return undefined;
    } /**
   * This is used to confirm an attribute using a confirmation code
   * @param {string} attributeName Attribute being confirmed.
   * @param {string} confirmationCode Code entered by user.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.verifyAttribute = function verifyAttribute(attributeName, confirmationCode, callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("VerifyUserAttribute", {
            AttributeName: attributeName,
            Code: confirmationCode,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess("SUCCESS");
        });
        return undefined;
    } /**
   * This is used to get the device information using the current device key
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<*>} callback.onSuccess Called on success with device data.
   * @returns {void}
   */ ;
    _proto.getDevice = function getDevice(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("GetDevice", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: this.deviceKey
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess(data);
        });
        return undefined;
    } /**
   * This is used to forget a specific device
   * @param {string} deviceKey Device key.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.forgetSpecificDevice = function forgetSpecificDevice(deviceKey, callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("ForgetDevice", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: deviceKey
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess("SUCCESS");
        });
        return undefined;
    } /**
   * This is used to forget the current device
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.forgetDevice = function forgetDevice(callback) {
        var _this16 = this;
        this.forgetSpecificDevice(this.deviceKey, {
            onFailure: callback.onFailure,
            onSuccess: function onSuccess(result) {
                _this16.deviceKey = null;
                _this16.deviceGroupKey = null;
                _this16.randomPassword = null;
                _this16.clearCachedDeviceKeyAndPassword();
                return callback.onSuccess(result);
            }
        });
    } /**
   * This is used to set the device status as remembered
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.setDeviceStatusRemembered = function setDeviceStatusRemembered(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("UpdateDeviceStatus", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: this.deviceKey,
            DeviceRememberedStatus: "remembered"
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess("SUCCESS");
        });
        return undefined;
    } /**
   * This is used to set the device status as not remembered
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.setDeviceStatusNotRemembered = function setDeviceStatusNotRemembered(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("UpdateDeviceStatus", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: this.deviceKey,
            DeviceRememberedStatus: "not_remembered"
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess("SUCCESS");
        });
        return undefined;
    } /**
   * This is used to list all devices for a user
   *
   * @param {int} limit the number of devices returned in a call
   * @param {string | null} paginationToken the pagination token in case any was returned before
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<*>} callback.onSuccess Called on success with device list.
   * @returns {void}
   */ ;
    _proto.listDevices = function listDevices(limit, paginationToken, callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        var requestParams = {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            Limit: limit
        };
        if (paginationToken) requestParams.PaginationToken = paginationToken;
        this.client.request("ListDevices", requestParams, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess(data);
        });
        return undefined;
    } /**
   * This is used to globally revoke all tokens issued to a user
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.globalSignOut = function globalSignOut(callback) {
        var _this17 = this;
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("GlobalSignOut", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback.onFailure(err);
            _this17.clearCachedUser();
            return callback.onSuccess("SUCCESS");
        });
        return undefined;
    } /**
   * This is used for the user to signOut of the application and clear the cached tokens.
   * @returns {void}
   */ ;
    _proto.signOut = function signOut(revokeTokenCallback) {
        var _this18 = this;
        // If tokens won't be revoked, we just clean the client data.
        if (!revokeTokenCallback || typeof revokeTokenCallback !== "function") {
            this.cleanClientData();
            return;
        }
        this.getSession(function(error, _session) {
            if (error) return revokeTokenCallback(error);
            _this18.revokeTokens(function(err) {
                _this18.cleanClientData();
                revokeTokenCallback(err);
            });
        });
    };
    _proto.revokeTokens = function revokeTokens(revokeTokenCallback) {
        if (revokeTokenCallback === void 0) revokeTokenCallback = function revokeTokenCallback() {};
        if (typeof revokeTokenCallback !== "function") throw new Error("Invalid revokeTokenCallback. It should be a function.");
        var tokensToBeRevoked = [];
        if (!this.signInUserSession) {
            var error = new Error("User is not authenticated");
            return revokeTokenCallback(error);
        }
        if (!this.signInUserSession.getAccessToken()) {
            var _error = new Error("No Access token available");
            return revokeTokenCallback(_error);
        }
        var refreshToken = this.signInUserSession.getRefreshToken().getToken();
        var accessToken = this.signInUserSession.getAccessToken();
        if (this.isSessionRevocable(accessToken)) {
            if (refreshToken) return this.revokeToken({
                token: refreshToken,
                callback: revokeTokenCallback
            });
        }
        revokeTokenCallback();
    };
    _proto.isSessionRevocable = function isSessionRevocable(token) {
        if (token && typeof token.decodePayload === "function") try {
            var _token$decodePayload = token.decodePayload(), origin_jti = _token$decodePayload.origin_jti;
            return !!origin_jti;
        } catch (err) {
        // Nothing to do, token doesnt have origin_jti claim
        }
        return false;
    };
    _proto.cleanClientData = function cleanClientData() {
        this.signInUserSession = null;
        this.clearCachedUser();
    };
    _proto.revokeToken = function revokeToken(_ref2) {
        var token = _ref2.token, callback = _ref2.callback;
        this.client.requestWithRetry("RevokeToken", {
            Token: token,
            ClientId: this.pool.getClientId()
        }, function(err) {
            if (err) return callback(err);
            callback();
        });
    } /**
   * This is used by a user trying to select a given MFA
   * @param {string} answerChallenge the mfa the user wants
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.sendMFASelectionAnswer = function sendMFASelectionAnswer(answerChallenge, callback) {
        var _this19 = this;
        var challengeResponses = {};
        challengeResponses.USERNAME = this.username;
        challengeResponses.ANSWER = answerChallenge;
        var jsonReq = {
            ChallengeName: "SELECT_MFA_TYPE",
            ChallengeResponses: challengeResponses,
            ClientId: this.pool.getClientId(),
            Session: this.Session
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("RespondToAuthChallenge", jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            _this19.Session = data.Session;
            if (answerChallenge === "SMS_MFA") return callback.mfaRequired(data.ChallengeName, data.ChallengeParameters);
            if (answerChallenge === "SOFTWARE_TOKEN_MFA") return callback.totpRequired(data.ChallengeName, data.ChallengeParameters);
            return undefined;
        });
    } /**
   * This returns the user context data for advanced security feature.
   * @returns {string} the user context data from CognitoUserPool
   */ ;
    _proto.getUserContextData = function getUserContextData() {
        var pool = this.pool;
        return pool.getUserContextData(this.username);
    } /**
   * This is used by an authenticated or a user trying to authenticate to associate a TOTP MFA
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.associateSoftwareToken = function associateSoftwareToken(callback) {
        var _this20 = this;
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) this.client.request("AssociateSoftwareToken", {
            Session: this.Session
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            _this20.Session = data.Session;
            return callback.associateSecretCode(data.SecretCode);
        });
        else this.client.request("AssociateSoftwareToken", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.associateSecretCode(data.SecretCode);
        });
    } /**
   * This is used by an authenticated or a user trying to authenticate to verify a TOTP MFA
   * @param {string} totpCode The MFA code entered by the user.
   * @param {string} friendlyDeviceName The device name we are assigning to the device.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.verifySoftwareToken = function verifySoftwareToken(totpCode, friendlyDeviceName, callback) {
        var _this21 = this;
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) this.client.request("VerifySoftwareToken", {
            Session: this.Session,
            UserCode: totpCode,
            FriendlyDeviceName: friendlyDeviceName
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            _this21.Session = data.Session;
            var challengeResponses = {};
            challengeResponses.USERNAME = _this21.username;
            var jsonReq = {
                ChallengeName: "MFA_SETUP",
                ClientId: _this21.pool.getClientId(),
                ChallengeResponses: challengeResponses,
                Session: _this21.Session
            };
            if (_this21.getUserContextData()) jsonReq.UserContextData = _this21.getUserContextData();
            _this21.client.request("RespondToAuthChallenge", jsonReq, function(errRespond, dataRespond) {
                if (errRespond) return callback.onFailure(errRespond);
                _this21.signInUserSession = _this21.getCognitoUserSession(dataRespond.AuthenticationResult);
                _this21.cacheTokens();
                return callback.onSuccess(_this21.signInUserSession);
            });
            return undefined;
        });
        else this.client.request("VerifySoftwareToken", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            UserCode: totpCode,
            FriendlyDeviceName: friendlyDeviceName
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess(data);
        });
    };
    return CognitoUser;
}();



/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ var $91cf44a51e214cfa$exports = {};


$91cf44a51e214cfa$exports = self.fetch || (self.fetch = (parcelRequire("jextc")).default || (parcelRequire("jextc")));



var $a2775ca286c4c0da$export$c388c654f0be37f3 = {
    None: "0",
    ReactNative: "1"
};
var $a2775ca286c4c0da$export$2ef00488675027c = "auth";


// constructor
function $b81df7fd523bdd8a$var$UserAgent() {}
// public
$b81df7fd523bdd8a$var$UserAgent.prototype.userAgent = (0, $8e066460476a01f5$export$7935961ef7719cb0)();
var $b81df7fd523bdd8a$export$ad34c5a3baecdb02 = function appendToCognitoUserAgent(content) {
    if (!content) return;
    if ($b81df7fd523bdd8a$var$UserAgent.prototype.userAgent && !$b81df7fd523bdd8a$var$UserAgent.prototype.userAgent.includes(content)) $b81df7fd523bdd8a$var$UserAgent.prototype.userAgent = $b81df7fd523bdd8a$var$UserAgent.prototype.userAgent.concat(" ", content);
    if (!$b81df7fd523bdd8a$var$UserAgent.prototype.userAgent || $b81df7fd523bdd8a$var$UserAgent.prototype.userAgent === "") $b81df7fd523bdd8a$var$UserAgent.prototype.userAgent = content;
};
var $b81df7fd523bdd8a$export$523857f9fc06cb0d = function addAuthCategoryToCognitoUserAgent() {
    $b81df7fd523bdd8a$var$UserAgent.category = (0, $a2775ca286c4c0da$export$2ef00488675027c);
};
var $b81df7fd523bdd8a$export$972f94ce7a888cac = function addFrameworkToCognitoUserAgent(framework) {
    $b81df7fd523bdd8a$var$UserAgent.framework = framework;
};
var $b81df7fd523bdd8a$export$ede38edb26c0bfdf = function getAmplifyUserAgent(action) {
    var uaCategoryAction = $b81df7fd523bdd8a$var$UserAgent.category ? " " + $b81df7fd523bdd8a$var$UserAgent.category : "";
    var uaFramework = $b81df7fd523bdd8a$var$UserAgent.framework ? " framework/" + $b81df7fd523bdd8a$var$UserAgent.framework : "";
    var userAgent = "" + $b81df7fd523bdd8a$var$UserAgent.prototype.userAgent + uaCategoryAction + uaFramework;
    return userAgent;
};
var // class for defining the amzn user-agent
$b81df7fd523bdd8a$export$2e2bcd8739ae039 = $b81df7fd523bdd8a$var$UserAgent;


function $53f74d63f6fb28f1$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $53f74d63f6fb28f1$var$_setPrototypeOf(subClass, superClass);
}
function $53f74d63f6fb28f1$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $53f74d63f6fb28f1$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$53f74d63f6fb28f1$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $53f74d63f6fb28f1$var$_construct(Class, arguments, $53f74d63f6fb28f1$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $53f74d63f6fb28f1$var$_setPrototypeOf(Wrapper, Class);
    };
    return $53f74d63f6fb28f1$var$_wrapNativeSuper(Class);
}
function $53f74d63f6fb28f1$var$_construct(Parent, args, Class) {
    if ($53f74d63f6fb28f1$var$_isNativeReflectConstruct()) $53f74d63f6fb28f1$var$_construct = Reflect.construct.bind();
    else $53f74d63f6fb28f1$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $53f74d63f6fb28f1$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $53f74d63f6fb28f1$var$_construct.apply(null, arguments);
}
function $53f74d63f6fb28f1$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $53f74d63f6fb28f1$var$_isNativeFunction(fn) {
    try {
        return Function.toString.call(fn).indexOf("[native code]") !== -1;
    } catch (e) {
        return typeof fn === "function";
    }
}
function $53f74d63f6fb28f1$var$_setPrototypeOf(o, p) {
    $53f74d63f6fb28f1$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $53f74d63f6fb28f1$var$_setPrototypeOf(o, p);
}
function $53f74d63f6fb28f1$var$_getPrototypeOf(o) {
    $53f74d63f6fb28f1$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $53f74d63f6fb28f1$var$_getPrototypeOf(o);
}
var $53f74d63f6fb28f1$var$CognitoError = /*#__PURE__*/ function(_Error) {
    $53f74d63f6fb28f1$var$_inheritsLoose(CognitoError, _Error);
    function CognitoError(message, code, name, statusCode) {
        var _this;
        _this = _Error.call(this, message) || this;
        _this.code = code;
        _this.name = name;
        _this.statusCode = statusCode;
        return _this;
    }
    return CognitoError;
}(/*#__PURE__*/ $53f74d63f6fb28f1$var$_wrapNativeSuper(Error));
/** @class */ var $53f74d63f6fb28f1$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new AWS Cognito Identity Provider client object
   * @param {string} region AWS region
   * @param {string} endpoint endpoint
   * @param {object} fetchOptions options for fetch API (only credentials is supported)
   */ function Client(region, endpoint, fetchOptions) {
        this.endpoint = endpoint || "https://cognito-idp." + region + ".amazonaws.com/";
        var _ref = fetchOptions || {}, credentials = _ref.credentials;
        this.fetchOptions = credentials ? {
            credentials: credentials
        } : {};
    }
    /**
   * Makes an unauthenticated request on AWS Cognito Identity Provider API
   * using fetch
   * @param {string} operation API operation
   * @param {object} params Input parameters
   * @returns Promise<object>
   */ var _proto = Client.prototype;
    _proto.promisifyRequest = function promisifyRequest(operation, params) {
        var _this2 = this;
        return new Promise(function(resolve, reject) {
            _this2.request(operation, params, function(err, data) {
                if (err) reject(new $53f74d63f6fb28f1$var$CognitoError(err.message, err.code, err.name, err.statusCode));
                else resolve(data);
            });
        });
    };
    _proto.requestWithRetry = function requestWithRetry(operation, params, callback) {
        var _this3 = this;
        var MAX_DELAY_IN_MILLIS = 5000;
        $53f74d63f6fb28f1$var$jitteredExponentialRetry(function(p) {
            return new Promise(function(res, rej) {
                _this3.request(operation, p, function(error, result) {
                    if (error) rej(error);
                    else res(result);
                });
            });
        }, [
            params
        ], MAX_DELAY_IN_MILLIS).then(function(result) {
            return callback(null, result);
        })["catch"](function(error) {
            return callback(error);
        });
    } /**
   * Makes an unauthenticated request on AWS Cognito Identity Provider API
   * using fetch
   * @param {string} operation API operation
   * @param {object} params Input parameters
   * @param {function} callback Callback called when a response is returned
   * @returns {void}
   */ ;
    _proto.request = function request(operation, params, callback) {
        var headers = {
            "Content-Type": "application/x-amz-json-1.1",
            "X-Amz-Target": "AWSCognitoIdentityProviderService." + operation,
            "X-Amz-User-Agent": (0, $b81df7fd523bdd8a$export$ede38edb26c0bfdf)(),
            "Cache-Control": "no-store"
        };
        var options = Object.assign({}, this.fetchOptions, {
            headers: headers,
            method: "POST",
            mode: "cors",
            body: JSON.stringify(params)
        });
        var response;
        var responseJsonData;
        fetch(this.endpoint, options).then(function(resp) {
            response = resp;
            return resp;
        }, function(err) {
            // If error happens here, the request failed
            // if it is TypeError throw network error
            if (err instanceof TypeError) throw new Error("Network error");
            throw err;
        }).then(function(resp) {
            return resp.json()["catch"](function() {
                return {};
            });
        }).then(function(data) {
            // return parsed body stream
            if (response.ok) return callback(null, data);
            responseJsonData = data;
            // Taken from aws-sdk-js/lib/protocol/json.js
            // eslint-disable-next-line no-underscore-dangle
            var code = (data.__type || data.code).split("#").pop();
            var error = new Error(data.message || data.Message || null);
            error.name = code;
            error.code = code;
            return callback(error);
        })["catch"](function(err) {
            // first check if we have a service error
            if (response && response.headers && response.headers.get("x-amzn-errortype")) try {
                var code = response.headers.get("x-amzn-errortype").split(":")[0];
                var error = new Error(response.status ? response.status.toString() : null);
                error.code = code;
                error.name = code;
                error.statusCode = response.status;
                return callback(error);
            } catch (ex) {
                return callback(err);
            }
            else if (err instanceof Error && err.message === "Network error") err.code = "NetworkError";
            return callback(err);
        });
    };
    return Client;
}();
var $53f74d63f6fb28f1$var$logger = {
    debug: function debug() {
    // Intentionally blank. This package doesn't have logging
    }
};
/**
 * For now, all errors are retryable.
 */ var $53f74d63f6fb28f1$var$NonRetryableError = /*#__PURE__*/ function(_Error2) {
    $53f74d63f6fb28f1$var$_inheritsLoose(NonRetryableError, _Error2);
    function NonRetryableError(message) {
        var _this4;
        _this4 = _Error2.call(this, message) || this;
        _this4.nonRetryable = true;
        return _this4;
    }
    return NonRetryableError;
}(/*#__PURE__*/ $53f74d63f6fb28f1$var$_wrapNativeSuper(Error));
var $53f74d63f6fb28f1$var$isNonRetryableError = function isNonRetryableError(obj) {
    var key = "nonRetryable";
    return obj && obj[key];
};
function $53f74d63f6fb28f1$var$retry(functionToRetry, args, delayFn, attempt) {
    if (attempt === void 0) attempt = 1;
    if (typeof functionToRetry !== "function") throw Error("functionToRetry must be a function");
    $53f74d63f6fb28f1$var$logger.debug(functionToRetry.name + " attempt #" + attempt + " with args: " + JSON.stringify(args));
    return functionToRetry.apply(void 0, args)["catch"](function(err) {
        $53f74d63f6fb28f1$var$logger.debug("error on " + functionToRetry.name, err);
        if ($53f74d63f6fb28f1$var$isNonRetryableError(err)) {
            $53f74d63f6fb28f1$var$logger.debug(functionToRetry.name + " non retryable error", err);
            throw err;
        }
        var retryIn = delayFn(attempt, args, err);
        $53f74d63f6fb28f1$var$logger.debug(functionToRetry.name + " retrying in " + retryIn + " ms");
        if (retryIn !== false) return new Promise(function(res) {
            return setTimeout(res, retryIn);
        }).then(function() {
            return $53f74d63f6fb28f1$var$retry(functionToRetry, args, delayFn, attempt + 1);
        });
        else throw err;
    });
}
function $53f74d63f6fb28f1$var$jitteredBackoff(maxDelayMs) {
    var BASE_TIME_MS = 100;
    var JITTER_FACTOR = 100;
    return function(attempt) {
        var delay = Math.pow(2, attempt) * BASE_TIME_MS + JITTER_FACTOR * Math.random();
        return delay > maxDelayMs ? false : delay;
    };
}
var $53f74d63f6fb28f1$var$MAX_DELAY_MS = 300000;
function $53f74d63f6fb28f1$var$jitteredExponentialRetry(functionToRetry, args, maxDelayMs) {
    if (maxDelayMs === void 0) maxDelayMs = $53f74d63f6fb28f1$var$MAX_DELAY_MS;
    return $53f74d63f6fb28f1$var$retry(functionToRetry, args, $53f74d63f6fb28f1$var$jitteredBackoff(maxDelayMs));
}




var $6da1f1f273b7b395$var$USER_POOL_ID_MAX_LENGTH = 55;
/** @class */ var $6da1f1f273b7b395$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoUserPool object
   * @param {object} data Creation options.
   * @param {string} data.UserPoolId Cognito user pool id.
   * @param {string} data.ClientId User pool application client id.
   * @param {string} data.endpoint Optional custom service endpoint.
   * @param {object} data.fetchOptions Optional options for fetch API.
   *        (only credentials option is supported)
   * @param {object} data.Storage Optional storage object.
   * @param {boolean} data.AdvancedSecurityDataCollectionFlag Optional:
   *        boolean flag indicating if the data collection is enabled
   *        to support cognito advanced security features. By default, this
   *        flag is set to true.
   */ function CognitoUserPool(data, wrapRefreshSessionCallback) {
        var _ref = data || {}, UserPoolId = _ref.UserPoolId, ClientId = _ref.ClientId, endpoint = _ref.endpoint, fetchOptions = _ref.fetchOptions, AdvancedSecurityDataCollectionFlag = _ref.AdvancedSecurityDataCollectionFlag;
        if (!UserPoolId || !ClientId) throw new Error("Both UserPoolId and ClientId are required.");
        if (UserPoolId.length > $6da1f1f273b7b395$var$USER_POOL_ID_MAX_LENGTH || !/^[\w-]+_[0-9a-zA-Z]+$/.test(UserPoolId)) throw new Error("Invalid UserPoolId format.");
        var region = UserPoolId.split("_")[0];
        this.userPoolId = UserPoolId;
        this.clientId = ClientId;
        this.client = new (0, $53f74d63f6fb28f1$export$2e2bcd8739ae039)(region, endpoint, fetchOptions);
        /**
     * By default, AdvancedSecurityDataCollectionFlag is set to true,
     * if no input value is provided.
     */ this.advancedSecurityDataCollectionFlag = AdvancedSecurityDataCollectionFlag !== false;
        this.storage = data.Storage || new (0, $269ba0b0a309720d$export$2e2bcd8739ae039)().getStorage();
        if (wrapRefreshSessionCallback) this.wrapRefreshSessionCallback = wrapRefreshSessionCallback;
    }
    /**
   * @returns {string} the user pool id
   */ var _proto = CognitoUserPool.prototype;
    _proto.getUserPoolId = function getUserPoolId() {
        return this.userPoolId;
    } /**
   * @returns {string} the user pool name
   */ ;
    _proto.getUserPoolName = function getUserPoolName() {
        return this.getUserPoolId().split("_")[1];
    } /**
   * @returns {string} the client id
   */ ;
    _proto.getClientId = function getClientId() {
        return this.clientId;
    } /**
   * method for signing up a user
   * @param {string} username User's username.
   * @param {string} password Plain-text initial password entered by user.
   * @param {(AttributeArg[])=} userAttributes New user attributes.
   * @param {(AttributeArg[])=} validationData Application metadata.
   * @param {(AttributeArg[])=} clientMetadata Client metadata.
   * @param {nodeCallback<SignUpResult>} callback Called on error or with the new user.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.signUp = function signUp(username, password, userAttributes, validationData, callback, clientMetadata) {
        var _this = this;
        var jsonReq = {
            ClientId: this.clientId,
            Username: username,
            Password: password,
            UserAttributes: userAttributes,
            ValidationData: validationData,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData(username)) jsonReq.UserContextData = this.getUserContextData(username);
        this.client.request("SignUp", jsonReq, function(err, data) {
            if (err) return callback(err, null);
            var cognitoUser = {
                Username: username,
                Pool: _this,
                Storage: _this.storage
            };
            var returnData = {
                user: new (0, $8ebdccf88ce233cf$export$2e2bcd8739ae039)(cognitoUser),
                userConfirmed: data.UserConfirmed,
                userSub: data.UserSub,
                codeDeliveryDetails: data.CodeDeliveryDetails
            };
            return callback(null, returnData);
        });
    } /**
   * method for getting the current user of the application from the local storage
   *
   * @returns {CognitoUser} the user retrieved from storage
   */ ;
    _proto.getCurrentUser = function getCurrentUser() {
        var lastUserKey = "CognitoIdentityServiceProvider." + this.clientId + ".LastAuthUser";
        var lastAuthUser = this.storage.getItem(lastUserKey);
        if (lastAuthUser) {
            var cognitoUser = {
                Username: lastAuthUser,
                Pool: this,
                Storage: this.storage
            };
            return new (0, $8ebdccf88ce233cf$export$2e2bcd8739ae039)(cognitoUser);
        }
        return null;
    } /**
   * This method returns the encoded data string used for cognito advanced security feature.
   * This would be generated only when developer has included the JS used for collecting the
   * data on their client. Please refer to documentation to know more about using AdvancedSecurity
   * features
   * @param {string} username the username for the context data
   * @returns {string} the user context data
   **/ ;
    _proto.getUserContextData = function getUserContextData(username) {
        if (typeof AmazonCognitoAdvancedSecurityData === "undefined") return undefined;
        /* eslint-disable */ var amazonCognitoAdvancedSecurityDataConst = AmazonCognitoAdvancedSecurityData;
        /* eslint-enable */ if (this.advancedSecurityDataCollectionFlag) {
            var advancedSecurityData = amazonCognitoAdvancedSecurityDataConst.getData(username, this.userPoolId, this.clientId);
            if (advancedSecurityData) {
                var userContextData = {
                    EncodedData: advancedSecurityData
                };
                return userContextData;
            }
        }
        return {};
    };
    return CognitoUserPool;
}();



var $f152efdd8322d373$exports = {};
(function(factory) {
    var registeredInModuleLoader;
    if (typeof define === "function" && define.amd) {
        define(factory);
        registeredInModuleLoader = true;
    }
    $f152efdd8322d373$exports = factory();
    registeredInModuleLoader = true;
    if (!registeredInModuleLoader) {
        var OldCookies = window.Cookies;
        var api = window.Cookies = factory();
        api.noConflict = function() {
            window.Cookies = OldCookies;
            return api;
        };
    }
})(function() {
    function extend() {
        var i = 0;
        var result = {};
        for(; i < arguments.length; i++){
            var attributes = arguments[i];
            for(var key in attributes)result[key] = attributes[key];
        }
        return result;
    }
    function decode(s) {
        return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
    }
    function init(converter) {
        function api() {}
        function set(key, value, attributes) {
            if (typeof document === "undefined") return;
            attributes = extend({
                path: "/"
            }, api.defaults, attributes);
            if (typeof attributes.expires === "number") attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
            // We're using "expires" because "max-age" is not supported by IE
            attributes.expires = attributes.expires ? attributes.expires.toUTCString() : "";
            try {
                var result = JSON.stringify(value);
                if (/^[\{\[]/.test(result)) value = result;
            } catch (e) {}
            value = converter.write ? converter.write(value, key) : encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
            key = encodeURIComponent(String(key)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
            var stringifiedAttributes = "";
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += "; " + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
            }
            return document.cookie = key + "=" + value + stringifiedAttributes;
        }
        function get(key, json) {
            if (typeof document === "undefined") return;
            var jar = {};
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split("; ") : [];
            var i = 0;
            for(; i < cookies.length; i++){
                var parts = cookies[i].split("=");
                var cookie = parts.slice(1).join("=");
                if (!json && cookie.charAt(0) === '"') cookie = cookie.slice(1, -1);
                try {
                    var name = decode(parts[0]);
                    cookie = (converter.read || converter)(cookie, name) || decode(cookie);
                    if (json) try {
                        cookie = JSON.parse(cookie);
                    } catch (e) {}
                    jar[name] = cookie;
                    if (key === name) break;
                } catch (e) {}
            }
            return key ? jar[key] : jar;
        }
        api.set = set;
        api.get = function(key) {
            return get(key, false);
        };
        api.getJSON = function(key) {
            return get(key, true);
        };
        api.remove = function(key, attributes) {
            set(key, "", extend(attributes, {
                expires: -1
            }));
        };
        api.defaults = {};
        api.withConverter = init;
        return api;
    }
    return init(function() {});
});


/** @class */ var $ad682aeddb96c898$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CookieStorage object
   * @param {object} data Creation options.
   * @param {string} data.domain Cookies domain (default: domain of the page
   * 				where the cookie was created, excluding subdomains)
   * @param {string} data.path Cookies path (default: '/')
   * @param {integer} data.expires Cookie expiration (in days, default: 365)
   * @param {boolean} data.secure Cookie secure flag (default: true)
   * @param {string} data.sameSite Cookie request behavior (default: null)
   */ function CookieStorage(data) {
        if (data === void 0) data = {};
        if (data.domain) this.domain = data.domain;
        if (data.path) this.path = data.path;
        else this.path = "/";
        if (Object.prototype.hasOwnProperty.call(data, "expires")) this.expires = data.expires;
        else this.expires = 365;
        if (Object.prototype.hasOwnProperty.call(data, "secure")) this.secure = data.secure;
        else this.secure = true;
        if (Object.prototype.hasOwnProperty.call(data, "sameSite")) {
            if (![
                "strict",
                "lax",
                "none"
            ].includes(data.sameSite)) throw new Error('The sameSite value of cookieStorage must be "lax", "strict" or "none".');
            if (data.sameSite === "none" && !this.secure) throw new Error("sameSite = None requires the Secure attribute in latest browser versions.");
            this.sameSite = data.sameSite;
        } else this.sameSite = null;
    }
    /**
   * This is used to set a specific item in storage
   * @param {string} key - the key for the item
   * @param {object} value - the value
   * @returns {string} value that was set
   */ var _proto = CookieStorage.prototype;
    _proto.setItem = function setItem(key, value) {
        var options = {
            path: this.path,
            expires: this.expires,
            domain: this.domain,
            secure: this.secure
        };
        if (this.sameSite) options.sameSite = this.sameSite;
        $f152efdd8322d373$exports.set(key, value, options);
        return $f152efdd8322d373$exports.get(key);
    } /**
   * This is used to get a specific key from storage
   * @param {string} key - the key for the item
   * This is used to clear the storage
   * @returns {string} the data item
   */ ;
    _proto.getItem = function getItem(key) {
        return $f152efdd8322d373$exports.get(key);
    } /**
   * This is used to remove an item from storage
   * @param {string} key - the key being set
   * @returns {string} value - value that was deleted
   */ ;
    _proto.removeItem = function removeItem(key) {
        var options = {
            path: this.path,
            expires: this.expires,
            domain: this.domain,
            secure: this.secure
        };
        if (this.sameSite) options.sameSite = this.sameSite;
        return $f152efdd8322d373$exports.remove(key, options);
    } /**
   * This is used to clear the storage of optional
   * items that were previously set
   * @returns {} an empty object
   */ ;
    _proto.clear = function clear() {
        var cookies = $f152efdd8322d373$exports.get();
        var numKeys = Object.keys(cookies).length;
        for(var index = 0; index < numKeys; ++index)this.removeItem(Object.keys(cookies)[index]);
        return {};
    };
    return CookieStorage;
}();










const $4a1b4f367ad149f7$var$initialState = {
    isStorageLoading: true,
    showNewSignInUi: false
};
var $4a1b4f367ad149f7$export$2e2bcd8739ae039 = (0, $50aea76f54d86b4e$export$4d8d9bd83c24ae8b)({
    name: "app",
    initialState: $4a1b4f367ad149f7$var$initialState,
    reducers: {
        dismissNewSignInUi: (state)=>{
            state.showNewSignInUi = false;
        },
        newSignIn: (state)=>{
            state.isStorageLoading = true;
            state.showNewSignInUi = true;
        },
        storageLoaded: (state)=>{
            state.isStorageLoading = false;
        }
    },
    selectors: {
        isStorageLoading: (state)=>state.isStorageLoading,
        showNewSignInUi: (state)=>state.showNewSignInUi
    }
});



const $2f1313f9e65d1ec4$var$initialState = {
    geolocation: undefined
};
var $2f1313f9e65d1ec4$export$2e2bcd8739ae039 = (0, $50aea76f54d86b4e$export$4d8d9bd83c24ae8b)({
    name: "device",
    initialState: $2f1313f9e65d1ec4$var$initialState,
    reducers: {
        clear: ()=>$2f1313f9e65d1ec4$var$initialState,
        setGeolocation: (state, action)=>{
            state.geolocation = action.payload;
        }
    },
    selectors: {
        geolocation: (state)=>state.geolocation
    }
});




const $cc3689f5d10378f4$var$initialState = {};
var $cc3689f5d10378f4$export$2e2bcd8739ae039 = (0, $50aea76f54d86b4e$export$4d8d9bd83c24ae8b)({
    name: "settings",
    initialState: $cc3689f5d10378f4$var$initialState,
    reducers: {
        clear: ()=>$cc3689f5d10378f4$var$initialState,
        loadFromStorage (state, action) {
            state.data = action.payload;
        },
        setLocationRecording: (state, action)=>{
            state.data = {
                recordLocation: action.payload,
                updatedAt: new Date().toISOString()
            };
        }
    },
    selectors: {
        data: (state)=>state.data,
        recordLocation: (state)=>Boolean(state.data?.recordLocation)
    }
});



const $3966632394e0ac61$export$dd06b4677f65b88a = [
    (0, $8ce47baf257b7c7b$export$2e2bcd8739ae039),
    (0, $cc3689f5d10378f4$export$2e2bcd8739ae039),
    (0, $9cfb09fae6dbced4$export$2e2bcd8739ae039)
];
const $3966632394e0ac61$var$store = (0, $50aea76f54d86b4e$export$7d8a5b498da695ac)({
    reducer: (0, $d98493d2be9cbe4c$export$66e4520cdb265d18)({
        app: (0, $4a1b4f367ad149f7$export$2e2bcd8739ae039).reducer,
        device: (0, $2f1313f9e65d1ec4$export$2e2bcd8739ae039).reducer,
        events: (0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).reducer,
        settings: (0, $cc3689f5d10378f4$export$2e2bcd8739ae039).reducer,
        user: (0, $9cfb09fae6dbced4$export$2e2bcd8739ae039).reducer
    })
});
var $3966632394e0ac61$export$2e2bcd8739ae039 = $3966632394e0ac61$var$store;







async function $638633b4bc90b6fe$export$2e2bcd8739ae039(currentUser = (0, $97fc43514b4d4584$export$9bd85d72295dec98).getCurrentUser()) {
    const { state: state } = await navigator.permissions.query({
        name: "notifications"
    });
    if (state === "granted") try {
        const token = await (0, $062e278e0d1dc91c$export$bd61301356cef08f)();
        await (0, $4b6cae14f235e72b$export$c1f49bcfceb4a1f1)(token);
    } catch (e) {
        if (!(e instanceof Error) || e.message !== "Firebase messaging is not supported in this browser") (0, $24a8d9ab78e4f062$export$f5282963edea4a68)(e);
    }
    await new Promise((resolve)=>{
        if (currentUser) return currentUser.signOut(resolve);
        resolve();
    });
    for (const slice of (0, $3966632394e0ac61$export$dd06b4677f65b88a))(0, $3966632394e0ac61$export$2e2bcd8739ae039).dispatch(slice.actions.clear());
    (0, $a14f18d5629de21e$export$7c07b633a151f9c5).clear();
}


const $97fc43514b4d4584$export$9bd85d72295dec98 = new (0, $6da1f1f273b7b395$export$2e2bcd8739ae039)({
    ClientId: "t3rc7etonlne28d9mf10ip0ci",
    UserPoolId: (0, $5a123094476b33d7$export$eb05085f459232d3).cognitoUserPoolId
});
const $97fc43514b4d4584$var$authenticateUser = ({ authenticationDetails: authenticationDetails, cognitoUser: cognitoUser })=>new Promise((resolve, reject)=>{
        cognitoUser.authenticateUser(authenticationDetails, {
            onFailure: reject,
            onSuccess: resolve
        });
    });
const $97fc43514b4d4584$var$getCurrentUser = ()=>{
    const currentUser = $97fc43514b4d4584$export$9bd85d72295dec98.getCurrentUser();
    if (currentUser) return currentUser;
    throw Error("No current user");
};
const $97fc43514b4d4584$var$getSession = (user)=>new Promise((resolve, reject)=>{
        user.getSession((error, session)=>{
            if (error) return reject(error);
            resolve(session);
        });
    });
const $97fc43514b4d4584$export$54d4d7ac67552aad = async (newEmailAddress)=>{
    const currentUser = $97fc43514b4d4584$var$getCurrentUser();
    await $97fc43514b4d4584$var$getSession(currentUser);
    return new Promise((resolve, reject)=>{
        currentUser.updateAttributes([
            new (0, $07e538300be3afb7$export$2e2bcd8739ae039)({
                Name: "email",
                Value: newEmailAddress
            })
        ], (error)=>{
            if (error) return reject(error);
            resolve();
        });
    });
};
const $97fc43514b4d4584$export$b7c211e36c1a92b5 = async (email, password)=>{
    const cognitoUser = $97fc43514b4d4584$export$a9d932d842141dae(email);
    const authenticationDetails = new (0, $3d044715290b5392$export$2e2bcd8739ae039)({
        Password: password,
        Username: email
    });
    const cognitoUserSession = await $97fc43514b4d4584$var$authenticateUser({
        authenticationDetails: authenticationDetails,
        cognitoUser: cognitoUser
    });
    return {
        cognitoUser: cognitoUser,
        cognitoUserSession: cognitoUserSession
    };
};
const $97fc43514b4d4584$export$a9d932d842141dae = (email)=>new (0, $8ebdccf88ce233cf$export$2e2bcd8739ae039)({
        Pool: $97fc43514b4d4584$export$9bd85d72295dec98,
        Username: email
    });
const $97fc43514b4d4584$export$393ade1005606e67 = ()=>new Promise((resolve, reject)=>{
        const currentUser = $97fc43514b4d4584$var$getCurrentUser();
        $97fc43514b4d4584$var$getSession(currentUser).then((session)=>resolve(session.getIdToken()), async (error)=>{
            if (error.message === "User does not exist.") {
                await (0, $638633b4bc90b6fe$export$2e2bcd8739ae039)(currentUser);
                return reject(Error("No current user"));
            }
            reject(error);
        });
    });
const $97fc43514b4d4584$export$296522b9b583854e = async ()=>{
    const currentUser = $97fc43514b4d4584$var$getCurrentUser();
    const session = await $97fc43514b4d4584$var$getSession(currentUser);
    const refreshToken = session.getRefreshToken();
    return new Promise((resolve, reject)=>currentUser.refreshSession(refreshToken, (error, session)=>{
            if (error) return reject(error);
            resolve(session);
        }));
};
const $97fc43514b4d4584$export$642dc5b3bc0f4a83 = async (verificationCode)=>{
    const currentUser = $97fc43514b4d4584$var$getCurrentUser();
    await $97fc43514b4d4584$var$getSession(currentUser);
    return new Promise((resolve, reject)=>{
        currentUser.verifyAttribute("email", verificationCode, {
            onSuccess: ()=>resolve(),
            onFailure: reject
        });
    });
};


const $4b6cae14f235e72b$var$API_URI = "/api";
const $4b6cae14f235e72b$var$EVENTS_URI = `${$4b6cae14f235e72b$var$API_URI}/events`;
const $4b6cae14f235e72b$var$USAGE_URI = `${$4b6cae14f235e72b$var$API_URI}/usage`;
const $4b6cae14f235e72b$var$WEATHER_URI = `${$4b6cae14f235e72b$var$API_URI}/weather`;
const $4b6cae14f235e72b$var$WEB_PUSH_TOKENS_URI = `${$4b6cae14f235e72b$var$API_URI}/web-push-tokens`;
const $4b6cae14f235e72b$var$WEEKLY_EMAILS_URI = `${$4b6cae14f235e72b$var$API_URI}/weekly-emails`;
const $4b6cae14f235e72b$var$fetchWithAuth = async (input, init)=>{
    const idToken = await (0, $97fc43514b4d4584$export$393ade1005606e67)();
    return fetch(input, {
        ...init,
        headers: {
            ...init?.headers,
            Authorization: `Bearer ${idToken.getJwtToken()}`
        }
    });
};
const $4b6cae14f235e72b$var$fetchWithRetry = async (input, init)=>{
    let retriesLeft = 3;
    let response = await fetch(input, init);
    do {
        if (response.status !== 429) break;
        await new Promise((resolve)=>setTimeout(resolve, 1e3));
        response = await fetch(input, init);
    }while (--retriesLeft);
    return response;
};
const $4b6cae14f235e72b$var$fetchWithAuthAndRetry = async (input, init)=>{
    const idToken = await (0, $97fc43514b4d4584$export$393ade1005606e67)();
    return $4b6cae14f235e72b$var$fetchWithRetry(input, {
        ...init,
        headers: {
            ...init?.headers,
            Authorization: `Bearer ${idToken.getJwtToken()}`
        }
    });
};
const $4b6cae14f235e72b$export$7a954b5c9a93cc61 = async ({ queryKey: [_, { date: date, latitude: latitude, longitude: longitude }] })=>{
    const response = await $4b6cae14f235e72b$var$fetchWithAuth(`${$4b6cae14f235e72b$var$WEATHER_URI}?lat=${latitude}&lon=${longitude}&t=${date}`);
    if (!response.ok) throw Error(String(response.status));
    return response.json();
};
const $4b6cae14f235e72b$export$60e88f1a377f61c6 = async (cursor)=>{
    const response = await $4b6cae14f235e72b$var$fetchWithAuthAndRetry(cursor ? `${$4b6cae14f235e72b$var$EVENTS_URI}/?cursor=${encodeURIComponent(cursor)}` : $4b6cae14f235e72b$var$EVENTS_URI);
    if (!response.ok) {
        const error = {
            body: undefined,
            status: response.status
        };
        try {
            error.body = await response.json();
        } catch (e) {
            (0, $24a8d9ab78e4f062$export$f5282963edea4a68)(e);
        }
        throw Error(JSON.stringify(error));
    }
    return response.json();
};
const $4b6cae14f235e72b$export$53537e53b6ef0786 = async (events)=>{
    const response = await $4b6cae14f235e72b$var$fetchWithAuthAndRetry($4b6cae14f235e72b$var$EVENTS_URI, {
        body: JSON.stringify(events),
        headers: {
            "Content-Type": "application/json"
        },
        method: "POST"
    });
    if (!response.ok) throw Error(String(response.status));
};
const $4b6cae14f235e72b$export$99969dd9128fc316 = async ()=>{
    const response = await $4b6cae14f235e72b$var$fetchWithAuth($4b6cae14f235e72b$var$WEEKLY_EMAILS_URI);
    if (response.status === 404) return false;
    if (!response.ok) throw Error(String(response.status));
    return true;
};
const $4b6cae14f235e72b$export$707702ec84df61a9 = async ()=>{
    const response = await $4b6cae14f235e72b$var$fetchWithAuth($4b6cae14f235e72b$var$WEEKLY_EMAILS_URI, {
        method: "DELETE"
    });
    if (!response.ok) throw Error(String(response.status));
};
const $4b6cae14f235e72b$export$f837c69388aad710 = async ()=>{
    const response = await $4b6cae14f235e72b$var$fetchWithAuth($4b6cae14f235e72b$var$WEEKLY_EMAILS_URI, {
        method: "POST"
    });
    if (!response.ok) throw Error(String(response.status));
};
const $4b6cae14f235e72b$export$7cf0865a17367a88 = async ()=>{
    const response = await fetch($4b6cae14f235e72b$var$USAGE_URI);
    if (!response.ok) throw Error(String(response.status));
    const usage = await response.json();
    return {
        expires: new Date(response.headers.get("expires")),
        usage: usage
    };
};
const $4b6cae14f235e72b$export$61804860a283679f = async ()=>{
    const response = await $4b6cae14f235e72b$var$fetchWithAuth($4b6cae14f235e72b$var$WEB_PUSH_TOKENS_URI);
    if (!response.ok) throw Error(String(response.status));
    return response.json();
};
const $4b6cae14f235e72b$export$c1f49bcfceb4a1f1 = async (token)=>{
    const response = await $4b6cae14f235e72b$var$fetchWithAuth(`${$4b6cae14f235e72b$var$WEB_PUSH_TOKENS_URI}/${encodeURIComponent(token)}`, {
        method: "DELETE"
    });
    if (!response.ok) throw Error(String(response.status));
};
const $4b6cae14f235e72b$export$249feca78be636fa = async (tokenObject)=>{
    const { token: token, ...body } = tokenObject;
    const response = await $4b6cae14f235e72b$var$fetchWithAuth(`${$4b6cae14f235e72b$var$WEB_PUSH_TOKENS_URI}/${encodeURIComponent(token)}`, {
        body: JSON.stringify(body),
        method: "PUT"
    });
    if (!response.ok) throw Error(String(response.status));
    return tokenObject;
};
const $4b6cae14f235e72b$var$getLocationClient = (()=>{
    let cachedLocationClient;
    let state = "NEVER_CALLED";
    let expiresAt = new Date(0);
    return async ()=>{
        const now = new Date();
        if (state === "IN_FLIGHT" || state === "SETTLED" && now < expiresAt) return cachedLocationClient;
        cachedLocationClient = new Promise((resolve)=>{
            (0, $97fc43514b4d4584$export$393ade1005606e67)().then((idToken)=>{
                const idTokenExpiresAt = (0, $4d242f5ba5f51203$export$e12a970efb73fce5)(new Date(idToken.getExpiration() * 1e3), 5);
                // Will expire after an hour, we use 55 minutes out of an abundance of caution
                const locationClientExpiresAt = (0, $0d7c68eafc4da62b$export$2287e3d29250119e)(now, 55);
                expiresAt = idTokenExpiresAt < locationClientExpiresAt ? idTokenExpiresAt : locationClientExpiresAt;
                resolve(new (0, $7a3a51b2a31a837b$export$ccc9b854597617bd)({
                    region: (0, $5a123094476b33d7$export$eb05085f459232d3).region,
                    credentials: (0, $781e215d1bc07b61$export$6c7d622e9507a2e)({
                        clientConfig: {
                            region: (0, $5a123094476b33d7$export$eb05085f459232d3).region
                        },
                        identityPoolId: (0, $5a123094476b33d7$export$eb05085f459232d3).cognitoIdentityPoolId,
                        logins: {
                            [`cognito-idp.${(0, $5a123094476b33d7$export$eb05085f459232d3).region}.amazonaws.com/${(0, $5a123094476b33d7$export$eb05085f459232d3).cognitoUserPoolId}`]: idToken.getJwtToken()
                        }
                    })
                }));
                state = "SETTLED";
            });
        });
        state = "IN_FLIGHT";
        return cachedLocationClient;
    };
})();
const $4b6cae14f235e72b$export$3a2482ae1281956 = async ({ queryKey: [_, { latitude: latitude, longitude: longitude }] })=>{
    const locationClient = await $4b6cae14f235e72b$var$getLocationClient();
    return locationClient.send(new (0, $a8fd6ca8635b5277$export$766050e2e36b49ab)({
        IndexName: "MoodTrackerPlaceIndex",
        Language: "en-GB",
        MaxResults: 1,
        Position: [
            longitude,
            latitude
        ]
    }));
};



const $f98bf430ea5fe891$var$roundQueryParameters = ({ latitude: latitude, longitude: longitude })=>({
        // Rounding latitude and longitude to 3 decimal places gives a resolution of about 100m (https://en.wikipedia.org/wiki/Decimal_degrees#Precision) and improves client-side caching
        latitude: Number(latitude.toFixed(3)),
        longitude: Number(longitude.toFixed(3))
    });
const $f98bf430ea5fe891$export$a633f4b7cdee33b9 = ({ latitude: latitude, longitude: longitude })=>(0, $eb7b0471498e212c$export$dd0a697e1782aedd)({
        queryKey: [
            "reverse-geolocation",
            $f98bf430ea5fe891$var$roundQueryParameters({
                latitude: latitude,
                longitude: longitude
            })
        ],
        queryFn: (0, $4b6cae14f235e72b$export$3a2482ae1281956),
        ...(0, $5a123094476b33d7$export$543f9b8922278769)
    });
const $f98bf430ea5fe891$export$399ebcd562d6b0a7 = (ids)=>{
    const eventsById = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.byId);
    return (0, $bb2f817139ccdd5b$export$408667c6c87da1e5)({
        queries: ids.map((id)=>{
            const { latitude: latitude, longitude: longitude } = eventsById[id].payload.location;
            const queryKey = [
                "reverse-geolocation",
                $f98bf430ea5fe891$var$roundQueryParameters({
                    latitude: latitude,
                    longitude: longitude
                })
            ];
            return {
                ...(0, $5a123094476b33d7$export$543f9b8922278769),
                queryKey: queryKey,
                queryFn: (0, $4b6cae14f235e72b$export$3a2482ae1281956)
            };
        })
    });
};


function $bdc0446275c44834$export$2e2bcd8739ae039({ errorFallback: errorFallback, latitude: latitude, longitude: longitude, successPostfix: successPostfix }) {
    const { data: data, isError: isError, isPending: isPending } = (0, $f98bf430ea5fe891$export$a633f4b7cdee33b9)({
        latitude: latitude,
        longitude: longitude
    });
    if (isPending) return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $b3bd040c14d4ce5c$export$2e2bcd8739ae039), {
        inline: true
    });
    if (isError) return errorFallback ?? null;
    const Place = data.Results?.[0]?.Place;
    const locationName = Place?.Municipality ?? Place?.Label;
    if (!locationName) {
        (0, $24a8d9ab78e4f062$export$f5282963edea4a68)(Error(`Failed to derive location name for ${JSON.stringify({
            latitude: latitude,
            longitude: longitude
        })}. Results: ${JSON.stringify(data.Results)}`));
        return errorFallback ?? null;
    }
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
        children: [
            locationName,
            successPostfix ?? null
        ]
    });
}













function $2e7a9197c46f3e5d$export$2e2bcd8739ae039({ daytime: daytime, description: description, id: id, main: main }) {
    const { iconName: iconName, weatherColor: weatherColor } = (0, $c2e94012e82e0308$export$6729330625148ca3)({
        isDaytime: daytime,
        weatherId: id
    });
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $7c1560fa3a8ca778$export$2e2bcd8739ae039), {
        color: weatherColor,
        children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("div", {
            className: "m-weather-icon-card",
            children: [
                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("b", {
                    children: main
                }),
                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                    color: weatherColor,
                    draw: true,
                    name: iconName,
                    size: "4"
                }),
                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("small", {
                    children: (0, $c2e94012e82e0308$export$d07f57595c356899)(description)
                })
            ]
        })
    });
}


function $70e1590c699ef123$export$2e2bcd8739ae039({ daytime: daytime, weatherIconsData: weatherIconsData }) {
    if (!weatherIconsData.length) return;
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("div", {
        className: "m-weather-icon-grid",
        children: weatherIconsData.map((weather)=>/*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $2e7a9197c46f3e5d$export$2e2bcd8739ae039), {
                daytime: daytime,
                ...weather
            }, weather.id))
    });
}









const $fafc84f9c915ea54$var$getUnixTimestampRoundedToNearestHourAndInPast = (date)=>{
    const roundedTime = Math.round(date.getTime() / 1e3 / (0, $5a123094476b33d7$export$a9905336c0111a3a).secondsPerHour) * (0, $5a123094476b33d7$export$a9905336c0111a3a).secondsPerHour;
    return roundedTime - (roundedTime > Date.now() / 1e3 ? (0, $5a123094476b33d7$export$a9905336c0111a3a).secondsPerHour : 0);
};
const $fafc84f9c915ea54$var$roundQueryParameters = ({ date: date, latitude: latitude, longitude: longitude })=>({
        // Date is rounded to the nearest hour, although finer resolution is likely available from many stations. The rounding should increase feasibility of caching on the backend
        date: $fafc84f9c915ea54$var$getUnixTimestampRoundedToNearestHourAndInPast(date),
        // Rounding latitude and longitude to 1 decimal place is required by the API and gives a resolution of about 10km (https://en.wikipedia.org/wiki/Decimal_degrees#Precision). More detail in API code
        latitude: latitude.toFixed(1),
        longitude: longitude.toFixed(1)
    });
const $fafc84f9c915ea54$export$66cd2f9777620c1f = (queryParameters)=>(0, $eb7b0471498e212c$export$dd0a697e1782aedd)({
        queryKey: [
            "weather",
            $fafc84f9c915ea54$var$roundQueryParameters(queryParameters)
        ],
        queryFn: (0, $4b6cae14f235e72b$export$7a954b5c9a93cc61),
        ...(0, $5a123094476b33d7$export$543f9b8922278769)
    });
const $fafc84f9c915ea54$export$10c8dac78addff85 = (ids)=>{
    const eventsById = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.byId);
    return (0, $bb2f817139ccdd5b$export$408667c6c87da1e5)({
        queries: ids.map((id)=>{
            const { latitude: latitude, longitude: longitude } = eventsById[id].payload.location;
            const queryKey = [
                "weather",
                $fafc84f9c915ea54$var$roundQueryParameters({
                    date: new Date(id),
                    latitude: latitude,
                    longitude: longitude
                })
            ];
            return {
                ...(0, $5a123094476b33d7$export$543f9b8922278769),
                queryKey: queryKey,
                queryFn: (0, $4b6cae14f235e72b$export$7a954b5c9a93cc61)
            };
        })
    });
};


function $0f903103cfab7975$export$2e2bcd8739ae039({ date: date, latitude: latitude, longitude: longitude }) {
    const { error: error, data: data, isError: isError, isPending: isPending } = (0, $fafc84f9c915ea54$export$66cd2f9777620c1f)({
        date: date,
        latitude: latitude,
        longitude: longitude
    });
    const weatherData = data?.data[0];
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h3", {
                children: "Weather"
            }),
            isPending ? /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $b3bd040c14d4ce5c$export$2e2bcd8739ae039), {}) : isError ? /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("p", {
                className: "negative",
                children: (0, $5a123094476b33d7$export$4fd720569787ab6f)[error instanceof Error && Number(error.message) >= 500 || error instanceof Error && error.message === "429" ? "server" : "network"]
            }) : weatherData && /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $70e1590c699ef123$export$2e2bcd8739ae039), {
                        daytime: date >= new Date(weatherData.sunrise * 1e3) && date < new Date(weatherData.sunset * 1e3),
                        weatherIconsData: weatherData.weather
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("table", {
                        children: [
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("thead", {
                                children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("th", {
                                            children: "Data"
                                        }),
                                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("th", {
                                            children: "Value"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("tbody", {
                                children: Object.entries(weatherData).map(([k, v])=>{
                                    if (k === "dt") return null;
                                    // This removes the `weather` property
                                    // It is done this way to help TypeScript understand the types
                                    // It relies on all other properties being numbers (currently true)
                                    if (typeof v !== "number") return;
                                    const name = k === "uvi" ? "Ultraviolet index" : (0, $c2e94012e82e0308$export$d07f57595c356899)(k.replaceAll("_", " "));
                                    let iconName;
                                    if (k === "sunrise" || k === "sunset") iconName = k;
                                    else if (k === "clouds") iconName = "cloud";
                                    else if (k === "dew_point") iconName = "dew-point";
                                    else if (k === "feels_like") iconName = "thermometer";
                                    else if (k === "humidity") iconName = "droplet";
                                    else if (k === "temp") iconName = "thermometer";
                                    else if (k === "uvi") iconName = "sun";
                                    else if (k === "visibility") iconName = "eye";
                                    else if (k === "wind_deg") iconName = "compass";
                                    else if (k === "wind_gust") iconName = "wind";
                                    else if (k === "wind_speed") iconName = "wind";
                                    else iconName = "chart";
                                    let supportiveText = undefined;
                                    switch(k){
                                        case "dew_point":
                                            supportiveText = "The temperature to which air must be cooled to become saturated with water vapor";
                                            break;
                                        case "pressure":
                                            supportiveText = "Typical sea-level air pressure is about 1013 hPa & 1 hPa is equal to 1 millibar";
                                            break;
                                        case "uvi":
                                            supportiveText = "The strength of sunburn-producing ultraviolet radiation";
                                    }
                                    let displayValue = v;
                                    switch(k){
                                        case "clouds":
                                        case "humidity":
                                            displayValue = (0, $035f270eea0b2c1d$export$5ed428cfaac5d75d).format(v / 100);
                                            break;
                                        case "dew_point":
                                        case "feels_like":
                                        case "temp":
                                            displayValue = (0, $035f270eea0b2c1d$export$196dadf28b8781a5)(v);
                                            break;
                                        case "pressure":
                                            displayValue = `${(0, $035f270eea0b2c1d$export$7774341304efafa2).format(v)} hPa`;
                                            break;
                                        case "rain":
                                        case "snow":
                                            // I haven't seen the actual API data and don't know what precision this number has
                                            displayValue = `${(0, $035f270eea0b2c1d$export$7774341304efafa2).format(v)} mm/hour`;
                                            break;
                                        case "sunrise":
                                        case "sunset":
                                            displayValue = (0, $06d17fa75ca1067f$export$5a00511f040384d7).format(new Date(v * 1e3));
                                            break;
                                        case "visibility":
                                            displayValue = (0, $035f270eea0b2c1d$export$73f799d1a16dbca4).format(v);
                                            break;
                                        case "wind_deg":
                                            displayValue = (0, $035f270eea0b2c1d$export$1659d1d38b1f945b).format(v);
                                            break;
                                        case "wind_speed":
                                        case "wind_gust":
                                            displayValue = `${(0, $035f270eea0b2c1d$export$10a982a3f524f6cd).format(v)} m/s`;
                                    }
                                    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("td", {
                                                children: [
                                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                                                        margin: "end",
                                                        name: iconName
                                                    }),
                                                    name,
                                                    supportiveText && /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("small", {
                                                        children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("div", {
                                                            children: supportiveText
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("td", {
                                                className: "nowrap",
                                                children: displayValue
                                            })
                                        ]
                                    }, k);
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


function $f501a7e7c8c881cb$export$2e2bcd8739ae039({ altitude: altitude, date: date, latitude: latitude, longitude: longitude }) {
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h3", {
                        children: "Location"
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $3bda04436e25bcfb$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $3bda04436e25bcfb$export$2e2bcd8739ae039).Marker, {
                            latitude: latitude,
                            longitude: longitude
                        })
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("p", {
                        className: "center",
                        children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $bdc0446275c44834$export$2e2bcd8739ae039), {
                            latitude: latitude,
                            longitude: longitude,
                            successPostfix: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("br", {})
                        })
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("small", {
                        children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("table", {
                            children: [
                                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("th", {
                                                children: "Coordinate"
                                            }),
                                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("th", {
                                                children: "Value"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("tbody", {
                                    children: [
                                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("td", {
                                                    children: "Latitude"
                                                }),
                                                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("td", {
                                                    children: (0, $035f270eea0b2c1d$export$55cce6e1b8cd4208).format(latitude)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("td", {
                                                    children: "Longitude"
                                                }),
                                                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("td", {
                                                    children: (0, $035f270eea0b2c1d$export$55cce6e1b8cd4208).format(longitude)
                                                })
                                            ]
                                        }),
                                        altitude && /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("td", {
                                                    children: "Altitude"
                                                }),
                                                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("td", {
                                                    children: (0, $035f270eea0b2c1d$export$73f799d1a16dbca4).format(altitude)
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $0f903103cfab7975$export$2e2bcd8739ae039), {
                date: date,
                latitude: latitude,
                longitude: longitude
            })
        ]
    });
}






var $lBnVc = parcelRequire("lBnVc");
function $6e4aba82666a9c9f$export$2e2bcd8739ae039(callback, delay) {
    const savedCallback = (0, $lBnVc.useRef)(callback);
    (0, $lBnVc.useEffect)(()=>{
        savedCallback.current = callback;
    }, [
        callback
    ]);
    (0, $lBnVc.useEffect)(()=>{
        const clear = ()=>clearInterval(intervalId);
        const intervalId = setInterval(()=>savedCallback.current(clear), delay);
        return clear;
    }, [
        delay
    ]);
}




var $lBnVc = parcelRequire("lBnVc");
function $2f42cbad153ba2f3$export$2e2bcd8739ae039() {
    const geolocation = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $2f1313f9e65d1ec4$export$2e2bcd8739ae039).selectors.geolocation);
    const shouldRecordLocation = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $cc3689f5d10378f4$export$2e2bcd8739ae039).selectors.recordLocation);
    const [date, setDate] = (0, $lBnVc.useState)(new Date());
    (0, $6e4aba82666a9c9f$export$2e2bcd8739ae039)(()=>{
        setDate(new Date());
    }, (0, $5a123094476b33d7$export$a9905336c0111a3a).secondsPerHour * 1e3);
    if (!shouldRecordLocation) return;
    return geolocation ? /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $f501a7e7c8c881cb$export$2e2bcd8739ae039), {
        date: date,
        ...geolocation
    }) : /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h3", {
                        children: "Location"
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $b3bd040c14d4ce5c$export$2e2bcd8739ae039), {})
                ]
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h3", {
                        children: "Weather"
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $b3bd040c14d4ce5c$export$2e2bcd8739ae039), {})
                ]
            })
        ]
    });
}






var $lBnVc = parcelRequire("lBnVc");
const $71f4b882ff6f87ec$var$MEDIA_QUERY = "(prefers-color-scheme: dark)";
const $71f4b882ff6f87ec$var$mediaQueryList = window.matchMedia($71f4b882ff6f87ec$var$MEDIA_QUERY);
function $71f4b882ff6f87ec$export$2e2bcd8739ae039() {
    const [darkMode, setDarkMode] = (0, $lBnVc.useState)(window.matchMedia($71f4b882ff6f87ec$var$MEDIA_QUERY).matches);
    (0, $lBnVc.useEffect)(()=>{
        const handler = (e)=>setDarkMode(e.matches);
        $71f4b882ff6f87ec$var$mediaQueryList.addEventListener("change", handler);
        return ()=>$71f4b882ff6f87ec$var$mediaQueryList.removeEventListener("change", handler);
    }, []);
    return darkMode;
}



var $lBnVc = parcelRequire("lBnVc");
let $a456cc3954118347$var$isMetaPressed = false;
window.addEventListener("blur", ()=>$a456cc3954118347$var$isMetaPressed = false);
window.addEventListener("keydown", (e)=>{
    if (e.key === "Meta") $a456cc3954118347$var$isMetaPressed = true;
});
window.addEventListener("keyup", (e)=>{
    if (e.key === "Meta") $a456cc3954118347$var$isMetaPressed = false;
});
function $a456cc3954118347$export$2e2bcd8739ae039(callback) {
    const savedCallback = (0, $lBnVc.useRef)(callback);
    (0, $lBnVc.useEffect)(()=>{
        savedCallback.current = callback;
    }, [
        callback
    ]);
    (0, $lBnVc.useEffect)(()=>{
        const handleKeyDown = (e)=>{
            if ((e.ctrlKey || $a456cc3954118347$var$isMetaPressed) && (e.code === "Enter" || e.code === "KeyS")) {
                e.preventDefault();
                savedCallback.current();
            }
        };
        window.addEventListener("keydown", handleKeyDown);
        return ()=>window.removeEventListener("keydown", handleKeyDown);
    }, []);
}



function $796b12d4c4a184c3$export$2e2bcd8739ae039() {
    const navigate = (0, $f02d97b5ca509f34$export$9770f232ac06a008)();
    const darkMode = (0, $71f4b882ff6f87ec$export$2e2bcd8739ae039)();
    const dispatch = (0, $d3287b130d7b0f6b$export$8ad76b76a4c905f8)();
    const [moodError, setMoodError] = (0, $lBnVc.useState)();
    const [descriptionError, setDescriptionError] = (0, $lBnVc.useState)();
    const geolocation = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $2f1313f9e65d1ec4$export$2e2bcd8739ae039).selectors.geolocation);
    const formRef = (0, $lBnVc.useRef)(null);
    const handleSubmit = ()=>{
        const formEl = formRef.current;
        const descriptionEl = formEl[(0, $5a123094476b33d7$export$e6909ad44e61103d).description.name];
        const descriptionValue = descriptionEl.value;
        const explorationValue = formEl[(0, $5a123094476b33d7$export$e6909ad44e61103d).exploration.name].value;
        const moodValue = formEl[(0, $5a123094476b33d7$export$e6909ad44e61103d).mood.name].value;
        if (!moodValue) setMoodError((0, $5a123094476b33d7$export$4fd720569787ab6f).required);
        const descriptionFieldError = descriptionEl.validity.patternMismatch;
        setDescriptionError(descriptionFieldError ? (0, $5a123094476b33d7$export$4fd720569787ab6f).specialCharacters : "");
        if (descriptionFieldError || !moodValue) return;
        const payload = {
            mood: Number(moodValue)
        };
        if (descriptionValue) payload.description = descriptionValue.trim();
        if (explorationValue) payload.exploration = explorationValue.trim();
        if (geolocation) payload.location = geolocation;
        dispatch((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).actions.add({
            type: "v1/moods/create",
            createdAt: new Date().toISOString(),
            payload: payload
        }));
        navigate("/");
    };
    (0, $a456cc3954118347$export$2e2bcd8739ae039)(handleSubmit);
    const currentHour = new Date().getHours();
    const timeOfDay = currentHour < 4 ? "evening" : currentHour < 12 ? "morning" : currentHour < 17 ? "afternoon" : "evening";
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039).Group, {
        "data-test-id": (0, $5a123094476b33d7$export$a2b4f255152a6585).addMoodPage,
        children: [
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("h2", {
                        children: [
                            "Add mood",
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $19d86a636b501d10$export$2e2bcd8739ae039), {
                                children: [
                                    "How are you feeling this ",
                                    timeOfDay,
                                    "?"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("form", {
                        noValidate: true,
                        onSubmit: (e)=>{
                            e.preventDefault();
                            handleSubmit();
                        },
                        ref: formRef,
                        children: [
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $bc720a2257db6cb9$export$2e2bcd8739ae039).Group, {
                                error: moodError,
                                label: (0, $5a123094476b33d7$export$e6909ad44e61103d).mood.label,
                                onChange: ()=>{
                                    if (moodError) setMoodError(undefined);
                                },
                                children: [
                                    ...Array(11)
                                ].map((_, i)=>/*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $bc720a2257db6cb9$export$2e2bcd8739ae039), {
                                        color: darkMode ? (0, $c2e94012e82e0308$export$18b446c953569205)(i) : undefined,
                                        "data-test-id": (0, $5a123094476b33d7$export$a2b4f255152a6585).addMoodRadioButton,
                                        name: (0, $5a123094476b33d7$export$e6909ad44e61103d).mood.name,
                                        value: i,
                                        children: i
                                    }, i))
                            }),
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $78053ee2024d275e$export$2e2bcd8739ae039), {
                                ...(0, $5a123094476b33d7$export$e6909ad44e61103d).description,
                                error: descriptionError
                            }),
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $ac4ce26ce45bf909$export$2e2bcd8739ae039), {
                                ...(0, $5a123094476b33d7$export$e6909ad44e61103d).exploration
                            }),
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039).Group, {
                                children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039), {
                                    "data-test-id": (0, $5a123094476b33d7$export$a2b4f255152a6585).addMoodSubmitButton,
                                    children: [
                                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                                            margin: "end",
                                            name: "save"
                                        }),
                                        "Save"
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $2f42cbad153ba2f3$export$2e2bcd8739ae039), {})
        ]
    });
}







var $lBnVc = parcelRequire("lBnVc");





function $22ab44955f353ba1$export$2e2bcd8739ae039() {
    const navigate = (0, $f02d97b5ca509f34$export$9770f232ac06a008)();
    const dispatch = (0, $d3287b130d7b0f6b$export$8ad76b76a4c905f8)();
    const [dateAwokeError, setDateAwokeError] = (0, $lBnVc.useState)();
    const formRef = (0, $lBnVc.useRef)(null);
    const handleSubmit = ()=>{
        const formEl = formRef.current;
        const hoursSleptEl = formEl[(0, $5a123094476b33d7$export$e6909ad44e61103d).hoursSlept.name];
        const minutesSleptEl = formEl[(0, $5a123094476b33d7$export$e6909ad44e61103d).minutesSlept.name];
        const dateAwokeEl = formEl[(0, $5a123094476b33d7$export$e6909ad44e61103d).dateAwoke.name];
        if (dateAwokeEl.validity.valueMissing) setDateAwokeError((0, $5a123094476b33d7$export$4fd720569787ab6f).required);
        else if (dateAwokeEl.validity.rangeOverflow) setDateAwokeError((0, $5a123094476b33d7$export$4fd720569787ab6f).rangeOverflow);
        else setDateAwokeError(undefined);
        if (!dateAwokeEl.validity.valid) return;
        dispatch((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).actions.add({
            type: "v1/sleeps/create",
            createdAt: new Date().toISOString(),
            payload: {
                minutesSlept: Number(hoursSleptEl.value) * 60 + Number(minutesSleptEl.value),
                dateAwoke: dateAwokeEl.value
            }
        }));
        navigate("/sleep/log");
    };
    (0, $a456cc3954118347$export$2e2bcd8739ae039)(handleSubmit);
    const isoDateStringNow = (0, $c2e94012e82e0308$export$f3013bcc8d8645bd)(new Date());
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039).Group, {
        "data-test-id": (0, $5a123094476b33d7$export$a2b4f255152a6585).sleepAddPage,
        children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h2", {
                    children: "Add sleep"
                }),
                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("form", {
                    noValidate: true,
                    onSubmit: (e)=>{
                        e.preventDefault();
                        handleSubmit();
                    },
                    ref: formRef,
                    children: [
                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("div", {
                            className: "m-interval-input",
                            children: [
                                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $9a780bd1b5aff71e$export$2e2bcd8739ae039), {
                                    ...(0, $5a123094476b33d7$export$e6909ad44e61103d).hoursSlept,
                                    children: [
                                        ...Array((0, $5a123094476b33d7$export$a9905336c0111a3a).hoursPerDay)
                                    ].map((_, i)=>/*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("option", {
                                            value: i,
                                            children: i
                                        }, i))
                                }),
                                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $9a780bd1b5aff71e$export$2e2bcd8739ae039), {
                                    ...(0, $5a123094476b33d7$export$e6909ad44e61103d).minutesSlept,
                                    children: [
                                        ...Array((0, $5a123094476b33d7$export$a9905336c0111a3a).minutesPerHour)
                                    ].map((_, i)=>/*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("option", {
                                            value: i,
                                            children: i
                                        }, i))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $78053ee2024d275e$export$2e2bcd8739ae039), {
                            ...(0, $5a123094476b33d7$export$e6909ad44e61103d).dateAwoke,
                            defaultValue: isoDateStringNow,
                            error: dateAwokeError,
                            max: isoDateStringNow
                        }),
                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039).Group, {
                            children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039), {
                                "data-test-id": (0, $5a123094476b33d7$export$a2b4f255152a6585).sleepAddSubmitButton,
                                children: [
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                                        margin: "end",
                                        name: "save"
                                    }),
                                    "Save"
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
}







var $lBnVc = parcelRequire("lBnVc");





function $70e20c362967c7c4$export$2e2bcd8739ae039() {
    const navigate = (0, $f02d97b5ca509f34$export$9770f232ac06a008)();
    const dispatch = (0, $d3287b130d7b0f6b$export$8ad76b76a4c905f8)();
    const [error, setError] = (0, $lBnVc.useState)();
    const geolocation = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $2f1313f9e65d1ec4$export$2e2bcd8739ae039).selectors.geolocation);
    const formRef = (0, $lBnVc.useRef)(null);
    const handleSubmit = ()=>{
        const formEl = formRef.current;
        const inputEl = formEl[(0, $5a123094476b33d7$export$e6909ad44e61103d).weight.name];
        const { valueAsNumber: valueAsNumber } = inputEl;
        if (inputEl.validity.valueMissing) {
            setError((0, $5a123094476b33d7$export$4fd720569787ab6f).required);
            return;
        }
        if (inputEl.validity.rangeOverflow) {
            setError((0, $5a123094476b33d7$export$4fd720569787ab6f).rangeOverflow);
            return;
        }
        if (inputEl.validity.rangeUnderflow) {
            setError((0, $5a123094476b33d7$export$4fd720569787ab6f).rangeUnderflow);
            return;
        }
        const payload = {
            value: valueAsNumber
        };
        if (geolocation) payload.location = geolocation;
        dispatch((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).actions.add({
            type: "v1/weights/create",
            createdAt: new Date().toISOString(),
            payload: payload
        }));
        navigate("/weight/log");
    };
    (0, $a456cc3954118347$export$2e2bcd8739ae039)(handleSubmit);
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039).Group, {
        "data-test-id": (0, $5a123094476b33d7$export$a2b4f255152a6585).weightAddPage,
        children: [
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h2", {
                        children: "Add weight"
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("form", {
                        noValidate: true,
                        onSubmit: (e)=>{
                            e.preventDefault();
                            handleSubmit();
                        },
                        ref: formRef,
                        children: [
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $78053ee2024d275e$export$2e2bcd8739ae039), {
                                ...(0, $5a123094476b33d7$export$e6909ad44e61103d).weight,
                                error: error
                            }),
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039).Group, {
                                children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039), {
                                    "data-test-id": (0, $5a123094476b33d7$export$a2b4f255152a6585).weightAddSubmitButton,
                                    children: [
                                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                                            margin: "end",
                                            name: "save"
                                        }),
                                        "Save"
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $2f42cbad153ba2f3$export$2e2bcd8739ae039), {})
        ]
    });
}





var $lBnVc = parcelRequire("lBnVc");


var $440d6b05cd13abc5$exports = {};
/**
 * marked v12.0.1 - a markdown parser
 * Copyright (c) 2011-2024, Christopher Jeffrey. (MIT Licensed)
 * https://github.com/markedjs/marked
 */ /**
 * DO NOT EDIT THIS FILE
 * The code in this file is generated from files in ./src/
 */ (function(global, factory) {
    factory($440d6b05cd13abc5$exports);
})($440d6b05cd13abc5$exports, function(exports1) {
    "use strict";
    /**
     * Gets the original marked default options.
     */ function _getDefaults() {
        return {
            async: false,
            breaks: false,
            extensions: null,
            gfm: true,
            hooks: null,
            pedantic: false,
            renderer: null,
            silent: false,
            tokenizer: null,
            walkTokens: null
        };
    }
    exports1.defaults = _getDefaults();
    function changeDefaults(newDefaults) {
        exports1.defaults = newDefaults;
    }
    /**
     * Helpers
     */ const escapeTest = /[&<>"']/;
    const escapeReplace = new RegExp(escapeTest.source, "g");
    const escapeTestNoEncode = /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/;
    const escapeReplaceNoEncode = new RegExp(escapeTestNoEncode.source, "g");
    const escapeReplacements = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    };
    const getEscapeReplacement = (ch)=>escapeReplacements[ch];
    function escape$1(html, encode) {
        if (encode) {
            if (escapeTest.test(html)) return html.replace(escapeReplace, getEscapeReplacement);
        } else {
            if (escapeTestNoEncode.test(html)) return html.replace(escapeReplaceNoEncode, getEscapeReplacement);
        }
        return html;
    }
    const unescapeTest = /&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/ig;
    function unescape(html) {
        // explicitly match decimal, hex, and named HTML entities
        return html.replace(unescapeTest, (_, n)=>{
            n = n.toLowerCase();
            if (n === "colon") return ":";
            if (n.charAt(0) === "#") return n.charAt(1) === "x" ? String.fromCharCode(parseInt(n.substring(2), 16)) : String.fromCharCode(+n.substring(1));
            return "";
        });
    }
    const caret = /(^|[^\[])\^/g;
    function edit(regex, opt) {
        let source = typeof regex === "string" ? regex : regex.source;
        opt = opt || "";
        const obj = {
            replace: (name, val)=>{
                let valSource = typeof val === "string" ? val : val.source;
                valSource = valSource.replace(caret, "$1");
                source = source.replace(name, valSource);
                return obj;
            },
            getRegex: ()=>{
                return new RegExp(source, opt);
            }
        };
        return obj;
    }
    function cleanUrl(href) {
        try {
            href = encodeURI(href).replace(/%25/g, "%");
        } catch (e) {
            return null;
        }
        return href;
    }
    const noopTest = {
        exec: ()=>null
    };
    function splitCells(tableRow, count) {
        // ensure that every cell-delimiting pipe has a space
        // before it to distinguish it from an escaped pipe
        const row = tableRow.replace(/\|/g, (match, offset, str)=>{
            let escaped = false;
            let curr = offset;
            while(--curr >= 0 && str[curr] === "\\")escaped = !escaped;
            if (escaped) // odd number of slashes means | is escaped
            // so we leave it alone
            return "|";
            else // add space before unescaped |
            return " |";
        }), cells = row.split(/ \|/);
        let i = 0;
        // First/last cell in a row cannot be empty if it has no leading/trailing pipe
        if (!cells[0].trim()) cells.shift();
        if (cells.length > 0 && !cells[cells.length - 1].trim()) cells.pop();
        if (count) {
            if (cells.length > count) cells.splice(count);
            else while(cells.length < count)cells.push("");
        }
        for(; i < cells.length; i++)// leading or trailing whitespace is ignored per the gfm spec
        cells[i] = cells[i].trim().replace(/\\\|/g, "|");
        return cells;
    }
    /**
     * Remove trailing 'c's. Equivalent to str.replace(/c*$/, '').
     * /c*$/ is vulnerable to REDOS.
     *
     * @param str
     * @param c
     * @param invert Remove suffix of non-c chars instead. Default falsey.
     */ function rtrim(str, c, invert) {
        const l = str.length;
        if (l === 0) return "";
        // Length of suffix matching the invert condition.
        let suffLen = 0;
        // Step left until we fail to match the invert condition.
        while(suffLen < l){
            const currChar = str.charAt(l - suffLen - 1);
            if (currChar === c && !invert) suffLen++;
            else if (currChar !== c && invert) suffLen++;
            else break;
        }
        return str.slice(0, l - suffLen);
    }
    function findClosingBracket(str, b) {
        if (str.indexOf(b[1]) === -1) return -1;
        let level = 0;
        for(let i = 0; i < str.length; i++){
            if (str[i] === "\\") i++;
            else if (str[i] === b[0]) level++;
            else if (str[i] === b[1]) {
                level--;
                if (level < 0) return i;
            }
        }
        return -1;
    }
    function outputLink(cap, link, raw, lexer) {
        const href = link.href;
        const title = link.title ? escape$1(link.title) : null;
        const text = cap[1].replace(/\\([\[\]])/g, "$1");
        if (cap[0].charAt(0) !== "!") {
            lexer.state.inLink = true;
            const token = {
                type: "link",
                raw: raw,
                href: href,
                title: title,
                text: text,
                tokens: lexer.inlineTokens(text)
            };
            lexer.state.inLink = false;
            return token;
        }
        return {
            type: "image",
            raw: raw,
            href: href,
            title: title,
            text: escape$1(text)
        };
    }
    function indentCodeCompensation(raw, text) {
        const matchIndentToCode = raw.match(/^(\s+)(?:```)/);
        if (matchIndentToCode === null) return text;
        const indentToCode = matchIndentToCode[1];
        return text.split("\n").map((node)=>{
            const matchIndentInNode = node.match(/^\s+/);
            if (matchIndentInNode === null) return node;
            const [indentInNode] = matchIndentInNode;
            if (indentInNode.length >= indentToCode.length) return node.slice(indentToCode.length);
            return node;
        }).join("\n");
    }
    /**
     * Tokenizer
     */ class _Tokenizer {
        options;
        rules;
        lexer;
        constructor(options){
            this.options = options || exports1.defaults;
        }
        space(src) {
            const cap = this.rules.block.newline.exec(src);
            if (cap && cap[0].length > 0) return {
                type: "space",
                raw: cap[0]
            };
        }
        code(src) {
            const cap = this.rules.block.code.exec(src);
            if (cap) {
                const text = cap[0].replace(/^ {1,4}/gm, "");
                return {
                    type: "code",
                    raw: cap[0],
                    codeBlockStyle: "indented",
                    text: !this.options.pedantic ? rtrim(text, "\n") : text
                };
            }
        }
        fences(src) {
            const cap = this.rules.block.fences.exec(src);
            if (cap) {
                const raw = cap[0];
                const text = indentCodeCompensation(raw, cap[3] || "");
                return {
                    type: "code",
                    raw: raw,
                    lang: cap[2] ? cap[2].trim().replace(this.rules.inline.anyPunctuation, "$1") : cap[2],
                    text: text
                };
            }
        }
        heading(src) {
            const cap = this.rules.block.heading.exec(src);
            if (cap) {
                let text = cap[2].trim();
                // remove trailing #s
                if (/#$/.test(text)) {
                    const trimmed = rtrim(text, "#");
                    if (this.options.pedantic) text = trimmed.trim();
                    else if (!trimmed || / $/.test(trimmed)) // CommonMark requires space before trailing #s
                    text = trimmed.trim();
                }
                return {
                    type: "heading",
                    raw: cap[0],
                    depth: cap[1].length,
                    text: text,
                    tokens: this.lexer.inline(text)
                };
            }
        }
        hr(src) {
            const cap = this.rules.block.hr.exec(src);
            if (cap) return {
                type: "hr",
                raw: cap[0]
            };
        }
        blockquote(src) {
            const cap = this.rules.block.blockquote.exec(src);
            if (cap) {
                const text = rtrim(cap[0].replace(/^ *>[ \t]?/gm, ""), "\n");
                const top = this.lexer.state.top;
                this.lexer.state.top = true;
                const tokens = this.lexer.blockTokens(text);
                this.lexer.state.top = top;
                return {
                    type: "blockquote",
                    raw: cap[0],
                    tokens: tokens,
                    text: text
                };
            }
        }
        list(src) {
            let cap = this.rules.block.list.exec(src);
            if (cap) {
                let bull = cap[1].trim();
                const isordered = bull.length > 1;
                const list = {
                    type: "list",
                    raw: "",
                    ordered: isordered,
                    start: isordered ? +bull.slice(0, -1) : "",
                    loose: false,
                    items: []
                };
                bull = isordered ? `\\d{1,9}\\${bull.slice(-1)}` : `\\${bull}`;
                if (this.options.pedantic) bull = isordered ? bull : "[*+-]";
                // Get next list item
                const itemRegex = new RegExp(`^( {0,3}${bull})((?:[\t ][^\\n]*)?(?:\\n|$))`);
                let raw = "";
                let itemContents = "";
                let endsWithBlankLine = false;
                // Check if current bullet point can start a new List Item
                while(src){
                    let endEarly = false;
                    if (!(cap = itemRegex.exec(src))) break;
                    if (this.rules.block.hr.test(src)) break;
                    raw = cap[0];
                    src = src.substring(raw.length);
                    let line = cap[2].split("\n", 1)[0].replace(/^\t+/, (t)=>" ".repeat(3 * t.length));
                    let nextLine = src.split("\n", 1)[0];
                    let indent = 0;
                    if (this.options.pedantic) {
                        indent = 2;
                        itemContents = line.trimStart();
                    } else {
                        indent = cap[2].search(/[^ ]/); // Find first non-space char
                        indent = indent > 4 ? 1 : indent; // Treat indented code blocks (> 4 spaces) as having only 1 indent
                        itemContents = line.slice(indent);
                        indent += cap[1].length;
                    }
                    let blankLine = false;
                    if (!line && /^ *$/.test(nextLine)) {
                        raw += nextLine + "\n";
                        src = src.substring(nextLine.length + 1);
                        endEarly = true;
                    }
                    if (!endEarly) {
                        const nextBulletRegex = new RegExp(`^ {0,${Math.min(3, indent - 1)}}(?:[*+-]|\\d{1,9}[.)])((?:[ \t][^\\n]*)?(?:\\n|$))`);
                        const hrRegex = new RegExp(`^ {0,${Math.min(3, indent - 1)}}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)`);
                        const fencesBeginRegex = new RegExp(`^ {0,${Math.min(3, indent - 1)}}(?:\`\`\`|~~~)`);
                        const headingBeginRegex = new RegExp(`^ {0,${Math.min(3, indent - 1)}}#`);
                        // Check if following lines should be included in List Item
                        while(src){
                            const rawLine = src.split("\n", 1)[0];
                            nextLine = rawLine;
                            // Re-align to follow commonmark nesting rules
                            if (this.options.pedantic) nextLine = nextLine.replace(/^ {1,4}(?=( {4})*[^ ])/g, "  ");
                            // End list item if found code fences
                            if (fencesBeginRegex.test(nextLine)) break;
                            // End list item if found start of new heading
                            if (headingBeginRegex.test(nextLine)) break;
                            // End list item if found start of new bullet
                            if (nextBulletRegex.test(nextLine)) break;
                            // Horizontal rule found
                            if (hrRegex.test(src)) break;
                            if (nextLine.search(/[^ ]/) >= indent || !nextLine.trim()) itemContents += "\n" + nextLine.slice(indent);
                            else {
                                // not enough indentation
                                if (blankLine) break;
                                // paragraph continuation unless last line was a different block level element
                                if (line.search(/[^ ]/) >= 4) break;
                                if (fencesBeginRegex.test(line)) break;
                                if (headingBeginRegex.test(line)) break;
                                if (hrRegex.test(line)) break;
                                itemContents += "\n" + nextLine;
                            }
                            if (!blankLine && !nextLine.trim()) blankLine = true;
                            raw += rawLine + "\n";
                            src = src.substring(rawLine.length + 1);
                            line = nextLine.slice(indent);
                        }
                    }
                    if (!list.loose) {
                        // If the previous item ended with a blank line, the list is loose
                        if (endsWithBlankLine) list.loose = true;
                        else if (/\n *\n *$/.test(raw)) endsWithBlankLine = true;
                    }
                    let istask = null;
                    let ischecked;
                    // Check for task list items
                    if (this.options.gfm) {
                        istask = /^\[[ xX]\] /.exec(itemContents);
                        if (istask) {
                            ischecked = istask[0] !== "[ ] ";
                            itemContents = itemContents.replace(/^\[[ xX]\] +/, "");
                        }
                    }
                    list.items.push({
                        type: "list_item",
                        raw: raw,
                        task: !!istask,
                        checked: ischecked,
                        loose: false,
                        text: itemContents,
                        tokens: []
                    });
                    list.raw += raw;
                }
                // Do not consume newlines at end of final item. Alternatively, make itemRegex *start* with any newlines to simplify/speed up endsWithBlankLine logic
                list.items[list.items.length - 1].raw = raw.trimEnd();
                list.items[list.items.length - 1].text = itemContents.trimEnd();
                list.raw = list.raw.trimEnd();
                // Item child tokens handled here at end because we needed to have the final item to trim it first
                for(let i = 0; i < list.items.length; i++){
                    this.lexer.state.top = false;
                    list.items[i].tokens = this.lexer.blockTokens(list.items[i].text, []);
                    if (!list.loose) {
                        // Check if list should be loose
                        const spacers = list.items[i].tokens.filter((t)=>t.type === "space");
                        const hasMultipleLineBreaks = spacers.length > 0 && spacers.some((t)=>/\n.*\n/.test(t.raw));
                        list.loose = hasMultipleLineBreaks;
                    }
                }
                // Set all items to loose if list is loose
                if (list.loose) for(let i = 0; i < list.items.length; i++)list.items[i].loose = true;
                return list;
            }
        }
        html(src) {
            const cap = this.rules.block.html.exec(src);
            if (cap) {
                const token = {
                    type: "html",
                    block: true,
                    raw: cap[0],
                    pre: cap[1] === "pre" || cap[1] === "script" || cap[1] === "style",
                    text: cap[0]
                };
                return token;
            }
        }
        def(src) {
            const cap = this.rules.block.def.exec(src);
            if (cap) {
                const tag = cap[1].toLowerCase().replace(/\s+/g, " ");
                const href = cap[2] ? cap[2].replace(/^<(.*)>$/, "$1").replace(this.rules.inline.anyPunctuation, "$1") : "";
                const title = cap[3] ? cap[3].substring(1, cap[3].length - 1).replace(this.rules.inline.anyPunctuation, "$1") : cap[3];
                return {
                    type: "def",
                    tag: tag,
                    raw: cap[0],
                    href: href,
                    title: title
                };
            }
        }
        table(src) {
            const cap = this.rules.block.table.exec(src);
            if (!cap) return;
            if (!/[:|]/.test(cap[2])) // delimiter row must have a pipe (|) or colon (:) otherwise it is a setext heading
            return;
            const headers = splitCells(cap[1]);
            const aligns = cap[2].replace(/^\||\| *$/g, "").split("|");
            const rows = cap[3] && cap[3].trim() ? cap[3].replace(/\n[ \t]*$/, "").split("\n") : [];
            const item = {
                type: "table",
                raw: cap[0],
                header: [],
                align: [],
                rows: []
            };
            if (headers.length !== aligns.length) // header and align columns must be equal, rows can be different.
            return;
            for (const align of aligns){
                if (/^ *-+: *$/.test(align)) item.align.push("right");
                else if (/^ *:-+: *$/.test(align)) item.align.push("center");
                else if (/^ *:-+ *$/.test(align)) item.align.push("left");
                else item.align.push(null);
            }
            for (const header of headers)item.header.push({
                text: header,
                tokens: this.lexer.inline(header)
            });
            for (const row of rows)item.rows.push(splitCells(row, item.header.length).map((cell)=>{
                return {
                    text: cell,
                    tokens: this.lexer.inline(cell)
                };
            }));
            return item;
        }
        lheading(src) {
            const cap = this.rules.block.lheading.exec(src);
            if (cap) return {
                type: "heading",
                raw: cap[0],
                depth: cap[2].charAt(0) === "=" ? 1 : 2,
                text: cap[1],
                tokens: this.lexer.inline(cap[1])
            };
        }
        paragraph(src) {
            const cap = this.rules.block.paragraph.exec(src);
            if (cap) {
                const text = cap[1].charAt(cap[1].length - 1) === "\n" ? cap[1].slice(0, -1) : cap[1];
                return {
                    type: "paragraph",
                    raw: cap[0],
                    text: text,
                    tokens: this.lexer.inline(text)
                };
            }
        }
        text(src) {
            const cap = this.rules.block.text.exec(src);
            if (cap) return {
                type: "text",
                raw: cap[0],
                text: cap[0],
                tokens: this.lexer.inline(cap[0])
            };
        }
        escape(src) {
            const cap = this.rules.inline.escape.exec(src);
            if (cap) return {
                type: "escape",
                raw: cap[0],
                text: escape$1(cap[1])
            };
        }
        tag(src) {
            const cap = this.rules.inline.tag.exec(src);
            if (cap) {
                if (!this.lexer.state.inLink && /^<a /i.test(cap[0])) this.lexer.state.inLink = true;
                else if (this.lexer.state.inLink && /^<\/a>/i.test(cap[0])) this.lexer.state.inLink = false;
                if (!this.lexer.state.inRawBlock && /^<(pre|code|kbd|script)(\s|>)/i.test(cap[0])) this.lexer.state.inRawBlock = true;
                else if (this.lexer.state.inRawBlock && /^<\/(pre|code|kbd|script)(\s|>)/i.test(cap[0])) this.lexer.state.inRawBlock = false;
                return {
                    type: "html",
                    raw: cap[0],
                    inLink: this.lexer.state.inLink,
                    inRawBlock: this.lexer.state.inRawBlock,
                    block: false,
                    text: cap[0]
                };
            }
        }
        link(src) {
            const cap = this.rules.inline.link.exec(src);
            if (cap) {
                const trimmedUrl = cap[2].trim();
                if (!this.options.pedantic && /^</.test(trimmedUrl)) {
                    // commonmark requires matching angle brackets
                    if (!/>$/.test(trimmedUrl)) return;
                    // ending angle bracket cannot be escaped
                    const rtrimSlash = rtrim(trimmedUrl.slice(0, -1), "\\");
                    if ((trimmedUrl.length - rtrimSlash.length) % 2 === 0) return;
                } else {
                    // find closing parenthesis
                    const lastParenIndex = findClosingBracket(cap[2], "()");
                    if (lastParenIndex > -1) {
                        const start = cap[0].indexOf("!") === 0 ? 5 : 4;
                        const linkLen = start + cap[1].length + lastParenIndex;
                        cap[2] = cap[2].substring(0, lastParenIndex);
                        cap[0] = cap[0].substring(0, linkLen).trim();
                        cap[3] = "";
                    }
                }
                let href = cap[2];
                let title = "";
                if (this.options.pedantic) {
                    // split pedantic href and title
                    const link = /^([^'"]*[^\s])\s+(['"])(.*)\2/.exec(href);
                    if (link) {
                        href = link[1];
                        title = link[3];
                    }
                } else title = cap[3] ? cap[3].slice(1, -1) : "";
                href = href.trim();
                if (/^</.test(href)) {
                    if (this.options.pedantic && !/>$/.test(trimmedUrl)) // pedantic allows starting angle bracket without ending angle bracket
                    href = href.slice(1);
                    else href = href.slice(1, -1);
                }
                return outputLink(cap, {
                    href: href ? href.replace(this.rules.inline.anyPunctuation, "$1") : href,
                    title: title ? title.replace(this.rules.inline.anyPunctuation, "$1") : title
                }, cap[0], this.lexer);
            }
        }
        reflink(src, links) {
            let cap;
            if ((cap = this.rules.inline.reflink.exec(src)) || (cap = this.rules.inline.nolink.exec(src))) {
                const linkString = (cap[2] || cap[1]).replace(/\s+/g, " ");
                const link = links[linkString.toLowerCase()];
                if (!link) {
                    const text = cap[0].charAt(0);
                    return {
                        type: "text",
                        raw: text,
                        text: text
                    };
                }
                return outputLink(cap, link, cap[0], this.lexer);
            }
        }
        emStrong(src, maskedSrc, prevChar = "") {
            let match = this.rules.inline.emStrongLDelim.exec(src);
            if (!match) return;
            // _ can't be between two alphanumerics. \p{L}\p{N} includes non-english alphabet/numbers as well
            if (match[3] && prevChar.match(/[\p{L}\p{N}]/u)) return;
            const nextChar = match[1] || match[2] || "";
            if (!nextChar || !prevChar || this.rules.inline.punctuation.exec(prevChar)) {
                // unicode Regex counts emoji as 1 char; spread into array for proper count (used multiple times below)
                const lLength = [
                    ...match[0]
                ].length - 1;
                let rDelim, rLength, delimTotal = lLength, midDelimTotal = 0;
                const endReg = match[0][0] === "*" ? this.rules.inline.emStrongRDelimAst : this.rules.inline.emStrongRDelimUnd;
                endReg.lastIndex = 0;
                // Clip maskedSrc to same section of string as src (move to lexer?)
                maskedSrc = maskedSrc.slice(-1 * src.length + lLength);
                while((match = endReg.exec(maskedSrc)) != null){
                    rDelim = match[1] || match[2] || match[3] || match[4] || match[5] || match[6];
                    if (!rDelim) continue; // skip single * in __abc*abc__
                    rLength = [
                        ...rDelim
                    ].length;
                    if (match[3] || match[4]) {
                        delimTotal += rLength;
                        continue;
                    } else if (match[5] || match[6]) {
                        if (lLength % 3 && !((lLength + rLength) % 3)) {
                            midDelimTotal += rLength;
                            continue; // CommonMark Emphasis Rules 9-10
                        }
                    }
                    delimTotal -= rLength;
                    if (delimTotal > 0) continue; // Haven't found enough closing delimiters
                    // Remove extra characters. *a*** -> *a*
                    rLength = Math.min(rLength, rLength + delimTotal + midDelimTotal);
                    // char length can be >1 for unicode characters;
                    const lastCharLength = [
                        ...match[0]
                    ][0].length;
                    const raw = src.slice(0, lLength + match.index + lastCharLength + rLength);
                    // Create `em` if smallest delimiter has odd char count. *a***
                    if (Math.min(lLength, rLength) % 2) {
                        const text = raw.slice(1, -1);
                        return {
                            type: "em",
                            raw: raw,
                            text: text,
                            tokens: this.lexer.inlineTokens(text)
                        };
                    }
                    // Create 'strong' if smallest delimiter has even char count. **a***
                    const text = raw.slice(2, -2);
                    return {
                        type: "strong",
                        raw: raw,
                        text: text,
                        tokens: this.lexer.inlineTokens(text)
                    };
                }
            }
        }
        codespan(src) {
            const cap = this.rules.inline.code.exec(src);
            if (cap) {
                let text = cap[2].replace(/\n/g, " ");
                const hasNonSpaceChars = /[^ ]/.test(text);
                const hasSpaceCharsOnBothEnds = /^ /.test(text) && / $/.test(text);
                if (hasNonSpaceChars && hasSpaceCharsOnBothEnds) text = text.substring(1, text.length - 1);
                text = escape$1(text, true);
                return {
                    type: "codespan",
                    raw: cap[0],
                    text: text
                };
            }
        }
        br(src) {
            const cap = this.rules.inline.br.exec(src);
            if (cap) return {
                type: "br",
                raw: cap[0]
            };
        }
        del(src) {
            const cap = this.rules.inline.del.exec(src);
            if (cap) return {
                type: "del",
                raw: cap[0],
                text: cap[2],
                tokens: this.lexer.inlineTokens(cap[2])
            };
        }
        autolink(src) {
            const cap = this.rules.inline.autolink.exec(src);
            if (cap) {
                let text, href;
                if (cap[2] === "@") {
                    text = escape$1(cap[1]);
                    href = "mailto:" + text;
                } else {
                    text = escape$1(cap[1]);
                    href = text;
                }
                return {
                    type: "link",
                    raw: cap[0],
                    text: text,
                    href: href,
                    tokens: [
                        {
                            type: "text",
                            raw: text,
                            text: text
                        }
                    ]
                };
            }
        }
        url(src) {
            let cap;
            if (cap = this.rules.inline.url.exec(src)) {
                let text, href;
                if (cap[2] === "@") {
                    text = escape$1(cap[0]);
                    href = "mailto:" + text;
                } else {
                    // do extended autolink path validation
                    let prevCapZero;
                    do {
                        prevCapZero = cap[0];
                        cap[0] = this.rules.inline._backpedal.exec(cap[0])?.[0] ?? "";
                    }while (prevCapZero !== cap[0]);
                    text = escape$1(cap[0]);
                    if (cap[1] === "www.") href = "http://" + cap[0];
                    else href = cap[0];
                }
                return {
                    type: "link",
                    raw: cap[0],
                    text: text,
                    href: href,
                    tokens: [
                        {
                            type: "text",
                            raw: text,
                            text: text
                        }
                    ]
                };
            }
        }
        inlineText(src) {
            const cap = this.rules.inline.text.exec(src);
            if (cap) {
                let text;
                if (this.lexer.state.inRawBlock) text = cap[0];
                else text = escape$1(cap[0]);
                return {
                    type: "text",
                    raw: cap[0],
                    text: text
                };
            }
        }
    }
    /**
     * Block-Level Grammar
     */ const newline = /^(?: *(?:\n|$))+/;
    const blockCode = /^( {4}[^\n]+(?:\n(?: *(?:\n|$))*)?)+/;
    const fences = /^ {0,3}(`{3,}(?=[^`\n]*(?:\n|$))|~{3,})([^\n]*)(?:\n|$)(?:|([\s\S]*?)(?:\n|$))(?: {0,3}\1[~`]* *(?=\n|$)|$)/;
    const hr = /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/;
    const heading = /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/;
    const bullet = /(?:[*+-]|\d{1,9}[.)])/;
    const lheading = edit(/^(?!bull |blockCode|fences|blockquote|heading|html)((?:.|\n(?!\s*?\n|bull |blockCode|fences|blockquote|heading|html))+?)\n {0,3}(=+|-+) *(?:\n+|$)/).replace(/bull/g, bullet) // lists can interrupt
    .replace(/blockCode/g, / {4}/) // indented code blocks can interrupt
    .replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/) // fenced code blocks can interrupt
    .replace(/blockquote/g, / {0,3}>/) // blockquote can interrupt
    .replace(/heading/g, / {0,3}#{1,6}/) // ATX heading can interrupt
    .replace(/html/g, / {0,3}<[^\n>]+>\n/) // block html can interrupt
    .getRegex();
    const _paragraph = /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/;
    const blockText = /^[^\n]+/;
    const _blockLabel = /(?!\s*\])(?:\\.|[^\[\]\\])+/;
    const def = edit(/^ {0,3}\[(label)\]: *(?:\n *)?([^<\s][^\s]*|<.*?>)(?:(?: +(?:\n *)?| *\n *)(title))? *(?:\n+|$)/).replace("label", _blockLabel).replace("title", /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/).getRegex();
    const list = edit(/^( {0,3}bull)([ \t][^\n]+?)?(?:\n|$)/).replace(/bull/g, bullet).getRegex();
    const _tag = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|search|section|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul";
    const _comment = /<!--(?:-?>|[\s\S]*?(?:-->|$))/;
    const html = edit("^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>\\n*|$)|<![A-Z][\\s\\S]*?(?:>\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n *)+\\n|$)|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$)|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$))", "i").replace("comment", _comment).replace("tag", _tag).replace("attribute", / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex();
    const paragraph = edit(_paragraph).replace("hr", hr).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "") // setex headings don't interrupt commonmark paragraphs
    .replace("|table", "").replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ") // only lists starting from 1 can interrupt
    .replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", _tag) // pars can be interrupted by type (6) html blocks
    .getRegex();
    const blockquote = edit(/^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/).replace("paragraph", paragraph).getRegex();
    /**
     * Normal Block Grammar
     */ const blockNormal = {
        blockquote: blockquote,
        code: blockCode,
        def: def,
        fences: fences,
        heading: heading,
        hr: hr,
        html: html,
        lheading: lheading,
        list: list,
        newline: newline,
        paragraph: paragraph,
        table: noopTest,
        text: blockText
    };
    /**
     * GFM Block Grammar
     */ const gfmTable = edit("^ *([^\\n ].*)\\n {0,3}((?:\\| *)?:?-+:? *(?:\\| *:?-+:? *)*(?:\\| *)?)(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)") // Cells
    .replace("hr", hr).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("blockquote", " {0,3}>").replace("code", " {4}[^\\n]").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ") // only lists starting from 1 can interrupt
    .replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", _tag) // tables can be interrupted by type (6) html blocks
    .getRegex();
    const blockGfm = {
        ...blockNormal,
        table: gfmTable,
        paragraph: edit(_paragraph).replace("hr", hr).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "") // setex headings don't interrupt commonmark paragraphs
        .replace("table", gfmTable) // interrupt paragraphs with table
        .replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ") // only lists starting from 1 can interrupt
        .replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", _tag) // pars can be interrupted by type (6) html blocks
        .getRegex()
    };
    /**
     * Pedantic grammar (original John Gruber's loose markdown specification)
     */ const blockPedantic = {
        ...blockNormal,
        html: edit("^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:\"[^\"]*\"|'[^']*'|\\s[^'\"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))").replace("comment", _comment).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(),
        def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
        heading: /^(#{1,6})(.*)(?:\n+|$)/,
        fences: noopTest,
        lheading: /^(.+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
        paragraph: edit(_paragraph).replace("hr", hr).replace("heading", " *#{1,6} *[^\n]").replace("lheading", lheading).replace("|table", "").replace("blockquote", " {0,3}>").replace("|fences", "").replace("|list", "").replace("|html", "").replace("|tag", "").getRegex()
    };
    /**
     * Inline-Level Grammar
     */ const escape = /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/;
    const inlineCode = /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/;
    const br = /^( {2,}|\\)\n(?!\s*$)/;
    const inlineText = /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/;
    // list of unicode punctuation marks, plus any missing characters from CommonMark spec
    const _punctuation = "\\p{P}\\p{S}";
    const punctuation = edit(/^((?![*_])[\spunctuation])/, "u").replace(/punctuation/g, _punctuation).getRegex();
    // sequences em should skip over [title](link), `code`, <html>
    const blockSkip = /\[[^[\]]*?\]\([^\(\)]*?\)|`[^`]*?`|<[^<>]*?>/g;
    const emStrongLDelim = edit(/^(?:\*+(?:((?!\*)[punct])|[^\s*]))|^_+(?:((?!_)[punct])|([^\s_]))/, "u").replace(/punct/g, _punctuation).getRegex();
    const emStrongRDelimAst = edit("^[^_*]*?__[^_*]*?\\*[^_*]*?(?=__)|[^*]+(?=[^*])|(?!\\*)[punct](\\*+)(?=[\\s]|$)|[^punct\\s](\\*+)(?!\\*)(?=[punct\\s]|$)|(?!\\*)[punct\\s](\\*+)(?=[^punct\\s])|[\\s](\\*+)(?!\\*)(?=[punct])|(?!\\*)[punct](\\*+)(?!\\*)(?=[punct])|[^punct\\s](\\*+)(?=[^punct\\s])", "gu") // (6) a***a can be either Left or Right Delimiter
    .replace(/punct/g, _punctuation).getRegex();
    // (6) Not allowed for _
    const emStrongRDelimUnd = edit("^[^_*]*?\\*\\*[^_*]*?_[^_*]*?(?=\\*\\*)|[^_]+(?=[^_])|(?!_)[punct](_+)(?=[\\s]|$)|[^punct\\s](_+)(?!_)(?=[punct\\s]|$)|(?!_)[punct\\s](_+)(?=[^punct\\s])|[\\s](_+)(?!_)(?=[punct])|(?!_)[punct](_+)(?!_)(?=[punct])", "gu") // (5) #___# can be either Left or Right Delimiter
    .replace(/punct/g, _punctuation).getRegex();
    const anyPunctuation = edit(/\\([punct])/, "gu").replace(/punct/g, _punctuation).getRegex();
    const autolink = edit(/^<(scheme:[^\s\x00-\x1f<>]*|email)>/).replace("scheme", /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/).replace("email", /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/).getRegex();
    const _inlineComment = edit(_comment).replace("(?:-->|$)", "-->").getRegex();
    const tag = edit("^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>") // CDATA section
    .replace("comment", _inlineComment).replace("attribute", /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/).getRegex();
    const _inlineLabel = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/;
    const link = edit(/^!?\[(label)\]\(\s*(href)(?:\s+(title))?\s*\)/).replace("label", _inlineLabel).replace("href", /<(?:\\.|[^\n<>\\])+>|[^\s\x00-\x1f]*/).replace("title", /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/).getRegex();
    const reflink = edit(/^!?\[(label)\]\[(ref)\]/).replace("label", _inlineLabel).replace("ref", _blockLabel).getRegex();
    const nolink = edit(/^!?\[(ref)\](?:\[\])?/).replace("ref", _blockLabel).getRegex();
    const reflinkSearch = edit("reflink|nolink(?!\\()", "g").replace("reflink", reflink).replace("nolink", nolink).getRegex();
    /**
     * Normal Inline Grammar
     */ const inlineNormal = {
        _backpedal: noopTest,
        anyPunctuation: anyPunctuation,
        autolink: autolink,
        blockSkip: blockSkip,
        br: br,
        code: inlineCode,
        del: noopTest,
        emStrongLDelim: emStrongLDelim,
        emStrongRDelimAst: emStrongRDelimAst,
        emStrongRDelimUnd: emStrongRDelimUnd,
        escape: escape,
        link: link,
        nolink: nolink,
        punctuation: punctuation,
        reflink: reflink,
        reflinkSearch: reflinkSearch,
        tag: tag,
        text: inlineText,
        url: noopTest
    };
    /**
     * Pedantic Inline Grammar
     */ const inlinePedantic = {
        ...inlineNormal,
        link: edit(/^!?\[(label)\]\((.*?)\)/).replace("label", _inlineLabel).getRegex(),
        reflink: edit(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace("label", _inlineLabel).getRegex()
    };
    /**
     * GFM Inline Grammar
     */ const inlineGfm = {
        ...inlineNormal,
        escape: edit(escape).replace("])", "~|])").getRegex(),
        url: edit(/^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/, "i").replace("email", /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/).getRegex(),
        _backpedal: /(?:[^?!.,:;*_'"~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_'"~)]+(?!$))+/,
        del: /^(~~?)(?=[^\s~])([\s\S]*?[^\s~])\1(?=[^~]|$)/,
        text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/
    };
    /**
     * GFM + Line Breaks Inline Grammar
     */ const inlineBreaks = {
        ...inlineGfm,
        br: edit(br).replace("{2,}", "*").getRegex(),
        text: edit(inlineGfm.text).replace("\\b_", "\\b_| {2,}\\n").replace(/\{2,\}/g, "*").getRegex()
    };
    /**
     * exports
     */ const block = {
        normal: blockNormal,
        gfm: blockGfm,
        pedantic: blockPedantic
    };
    const inline = {
        normal: inlineNormal,
        gfm: inlineGfm,
        breaks: inlineBreaks,
        pedantic: inlinePedantic
    };
    /**
     * Block Lexer
     */ class _Lexer {
        tokens;
        options;
        state;
        tokenizer;
        inlineQueue;
        constructor(options){
            // TokenList cannot be created in one go
            this.tokens = [];
            this.tokens.links = Object.create(null);
            this.options = options || exports1.defaults;
            this.options.tokenizer = this.options.tokenizer || new _Tokenizer();
            this.tokenizer = this.options.tokenizer;
            this.tokenizer.options = this.options;
            this.tokenizer.lexer = this;
            this.inlineQueue = [];
            this.state = {
                inLink: false,
                inRawBlock: false,
                top: true
            };
            const rules = {
                block: block.normal,
                inline: inline.normal
            };
            if (this.options.pedantic) {
                rules.block = block.pedantic;
                rules.inline = inline.pedantic;
            } else if (this.options.gfm) {
                rules.block = block.gfm;
                if (this.options.breaks) rules.inline = inline.breaks;
                else rules.inline = inline.gfm;
            }
            this.tokenizer.rules = rules;
        }
        /**
         * Expose Rules
         */ static get rules() {
            return {
                block: block,
                inline: inline
            };
        }
        /**
         * Static Lex Method
         */ static lex(src, options) {
            const lexer = new _Lexer(options);
            return lexer.lex(src);
        }
        /**
         * Static Lex Inline Method
         */ static lexInline(src, options) {
            const lexer = new _Lexer(options);
            return lexer.inlineTokens(src);
        }
        /**
         * Preprocessing
         */ lex(src) {
            src = src.replace(/\r\n|\r/g, "\n");
            this.blockTokens(src, this.tokens);
            for(let i = 0; i < this.inlineQueue.length; i++){
                const next = this.inlineQueue[i];
                this.inlineTokens(next.src, next.tokens);
            }
            this.inlineQueue = [];
            return this.tokens;
        }
        blockTokens(src, tokens = []) {
            if (this.options.pedantic) src = src.replace(/\t/g, "    ").replace(/^ +$/gm, "");
            else src = src.replace(/^( *)(\t+)/gm, (_, leading, tabs)=>{
                return leading + "    ".repeat(tabs.length);
            });
            let token;
            let lastToken;
            let cutSrc;
            let lastParagraphClipped;
            while(src){
                if (this.options.extensions && this.options.extensions.block && this.options.extensions.block.some((extTokenizer)=>{
                    if (token = extTokenizer.call({
                        lexer: this
                    }, src, tokens)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return true;
                    }
                    return false;
                })) continue;
                // newline
                if (token = this.tokenizer.space(src)) {
                    src = src.substring(token.raw.length);
                    if (token.raw.length === 1 && tokens.length > 0) // if there's a single \n as a spacer, it's terminating the last line,
                    // so move it there so that we don't get unnecessary paragraph tags
                    tokens[tokens.length - 1].raw += "\n";
                    else tokens.push(token);
                    continue;
                }
                // code
                if (token = this.tokenizer.code(src)) {
                    src = src.substring(token.raw.length);
                    lastToken = tokens[tokens.length - 1];
                    // An indented code block cannot interrupt a paragraph.
                    if (lastToken && (lastToken.type === "paragraph" || lastToken.type === "text")) {
                        lastToken.raw += "\n" + token.raw;
                        lastToken.text += "\n" + token.text;
                        this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
                    } else tokens.push(token);
                    continue;
                }
                // fences
                if (token = this.tokenizer.fences(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // heading
                if (token = this.tokenizer.heading(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // hr
                if (token = this.tokenizer.hr(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // blockquote
                if (token = this.tokenizer.blockquote(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // list
                if (token = this.tokenizer.list(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // html
                if (token = this.tokenizer.html(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // def
                if (token = this.tokenizer.def(src)) {
                    src = src.substring(token.raw.length);
                    lastToken = tokens[tokens.length - 1];
                    if (lastToken && (lastToken.type === "paragraph" || lastToken.type === "text")) {
                        lastToken.raw += "\n" + token.raw;
                        lastToken.text += "\n" + token.raw;
                        this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
                    } else if (!this.tokens.links[token.tag]) this.tokens.links[token.tag] = {
                        href: token.href,
                        title: token.title
                    };
                    continue;
                }
                // table (gfm)
                if (token = this.tokenizer.table(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // lheading
                if (token = this.tokenizer.lheading(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // top-level paragraph
                // prevent paragraph consuming extensions by clipping 'src' to extension start
                cutSrc = src;
                if (this.options.extensions && this.options.extensions.startBlock) {
                    let startIndex = Infinity;
                    const tempSrc = src.slice(1);
                    let tempStart;
                    this.options.extensions.startBlock.forEach((getStartIndex)=>{
                        tempStart = getStartIndex.call({
                            lexer: this
                        }, tempSrc);
                        if (typeof tempStart === "number" && tempStart >= 0) startIndex = Math.min(startIndex, tempStart);
                    });
                    if (startIndex < Infinity && startIndex >= 0) cutSrc = src.substring(0, startIndex + 1);
                }
                if (this.state.top && (token = this.tokenizer.paragraph(cutSrc))) {
                    lastToken = tokens[tokens.length - 1];
                    if (lastParagraphClipped && lastToken.type === "paragraph") {
                        lastToken.raw += "\n" + token.raw;
                        lastToken.text += "\n" + token.text;
                        this.inlineQueue.pop();
                        this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
                    } else tokens.push(token);
                    lastParagraphClipped = cutSrc.length !== src.length;
                    src = src.substring(token.raw.length);
                    continue;
                }
                // text
                if (token = this.tokenizer.text(src)) {
                    src = src.substring(token.raw.length);
                    lastToken = tokens[tokens.length - 1];
                    if (lastToken && lastToken.type === "text") {
                        lastToken.raw += "\n" + token.raw;
                        lastToken.text += "\n" + token.text;
                        this.inlineQueue.pop();
                        this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
                    } else tokens.push(token);
                    continue;
                }
                if (src) {
                    const errMsg = "Infinite loop on byte: " + src.charCodeAt(0);
                    if (this.options.silent) {
                        console.error(errMsg);
                        break;
                    } else throw new Error(errMsg);
                }
            }
            this.state.top = true;
            return tokens;
        }
        inline(src, tokens = []) {
            this.inlineQueue.push({
                src: src,
                tokens: tokens
            });
            return tokens;
        }
        /**
         * Lexing/Compiling
         */ inlineTokens(src, tokens = []) {
            let token, lastToken, cutSrc;
            // String with links masked to avoid interference with em and strong
            let maskedSrc = src;
            let match;
            let keepPrevChar, prevChar;
            // Mask out reflinks
            if (this.tokens.links) {
                const links = Object.keys(this.tokens.links);
                if (links.length > 0) {
                    while((match = this.tokenizer.rules.inline.reflinkSearch.exec(maskedSrc)) != null)if (links.includes(match[0].slice(match[0].lastIndexOf("[") + 1, -1))) maskedSrc = maskedSrc.slice(0, match.index) + "[" + "a".repeat(match[0].length - 2) + "]" + maskedSrc.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex);
                }
            }
            // Mask out other blocks
            while((match = this.tokenizer.rules.inline.blockSkip.exec(maskedSrc)) != null)maskedSrc = maskedSrc.slice(0, match.index) + "[" + "a".repeat(match[0].length - 2) + "]" + maskedSrc.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
            // Mask out escaped characters
            while((match = this.tokenizer.rules.inline.anyPunctuation.exec(maskedSrc)) != null)maskedSrc = maskedSrc.slice(0, match.index) + "++" + maskedSrc.slice(this.tokenizer.rules.inline.anyPunctuation.lastIndex);
            while(src){
                if (!keepPrevChar) prevChar = "";
                keepPrevChar = false;
                // extensions
                if (this.options.extensions && this.options.extensions.inline && this.options.extensions.inline.some((extTokenizer)=>{
                    if (token = extTokenizer.call({
                        lexer: this
                    }, src, tokens)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return true;
                    }
                    return false;
                })) continue;
                // escape
                if (token = this.tokenizer.escape(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // tag
                if (token = this.tokenizer.tag(src)) {
                    src = src.substring(token.raw.length);
                    lastToken = tokens[tokens.length - 1];
                    if (lastToken && token.type === "text" && lastToken.type === "text") {
                        lastToken.raw += token.raw;
                        lastToken.text += token.text;
                    } else tokens.push(token);
                    continue;
                }
                // link
                if (token = this.tokenizer.link(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // reflink, nolink
                if (token = this.tokenizer.reflink(src, this.tokens.links)) {
                    src = src.substring(token.raw.length);
                    lastToken = tokens[tokens.length - 1];
                    if (lastToken && token.type === "text" && lastToken.type === "text") {
                        lastToken.raw += token.raw;
                        lastToken.text += token.text;
                    } else tokens.push(token);
                    continue;
                }
                // em & strong
                if (token = this.tokenizer.emStrong(src, maskedSrc, prevChar)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // code
                if (token = this.tokenizer.codespan(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // br
                if (token = this.tokenizer.br(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // del (gfm)
                if (token = this.tokenizer.del(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // autolink
                if (token = this.tokenizer.autolink(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // url (gfm)
                if (!this.state.inLink && (token = this.tokenizer.url(src))) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // text
                // prevent inlineText consuming extensions by clipping 'src' to extension start
                cutSrc = src;
                if (this.options.extensions && this.options.extensions.startInline) {
                    let startIndex = Infinity;
                    const tempSrc = src.slice(1);
                    let tempStart;
                    this.options.extensions.startInline.forEach((getStartIndex)=>{
                        tempStart = getStartIndex.call({
                            lexer: this
                        }, tempSrc);
                        if (typeof tempStart === "number" && tempStart >= 0) startIndex = Math.min(startIndex, tempStart);
                    });
                    if (startIndex < Infinity && startIndex >= 0) cutSrc = src.substring(0, startIndex + 1);
                }
                if (token = this.tokenizer.inlineText(cutSrc)) {
                    src = src.substring(token.raw.length);
                    if (token.raw.slice(-1) !== "_") prevChar = token.raw.slice(-1);
                    keepPrevChar = true;
                    lastToken = tokens[tokens.length - 1];
                    if (lastToken && lastToken.type === "text") {
                        lastToken.raw += token.raw;
                        lastToken.text += token.text;
                    } else tokens.push(token);
                    continue;
                }
                if (src) {
                    const errMsg = "Infinite loop on byte: " + src.charCodeAt(0);
                    if (this.options.silent) {
                        console.error(errMsg);
                        break;
                    } else throw new Error(errMsg);
                }
            }
            return tokens;
        }
    }
    /**
     * Renderer
     */ class _Renderer {
        options;
        constructor(options){
            this.options = options || exports1.defaults;
        }
        code(code, infostring, escaped) {
            const lang = (infostring || "").match(/^\S*/)?.[0];
            code = code.replace(/\n$/, "") + "\n";
            if (!lang) return "<pre><code>" + (escaped ? code : escape$1(code, true)) + "</code></pre>\n";
            return '<pre><code class="language-' + escape$1(lang) + '">' + (escaped ? code : escape$1(code, true)) + "</code></pre>\n";
        }
        blockquote(quote) {
            return `<blockquote>\n${quote}</blockquote>\n`;
        }
        html(html, block) {
            return html;
        }
        heading(text, level, raw) {
            // ignore IDs
            return `<h${level}>${text}</h${level}>\n`;
        }
        hr() {
            return "<hr>\n";
        }
        list(body, ordered, start) {
            const type = ordered ? "ol" : "ul";
            const startatt = ordered && start !== 1 ? ' start="' + start + '"' : "";
            return "<" + type + startatt + ">\n" + body + "</" + type + ">\n";
        }
        listitem(text, task, checked) {
            return `<li>${text}</li>\n`;
        }
        checkbox(checked) {
            return "<input " + (checked ? 'checked="" ' : "") + 'disabled="" type="checkbox">';
        }
        paragraph(text) {
            return `<p>${text}</p>\n`;
        }
        table(header, body) {
            if (body) body = `<tbody>${body}</tbody>`;
            return "<table>\n<thead>\n" + header + "</thead>\n" + body + "</table>\n";
        }
        tablerow(content) {
            return `<tr>\n${content}</tr>\n`;
        }
        tablecell(content, flags) {
            const type = flags.header ? "th" : "td";
            const tag = flags.align ? `<${type} align="${flags.align}">` : `<${type}>`;
            return tag + content + `</${type}>\n`;
        }
        /**
         * span level renderer
         */ strong(text) {
            return `<strong>${text}</strong>`;
        }
        em(text) {
            return `<em>${text}</em>`;
        }
        codespan(text) {
            return `<code>${text}</code>`;
        }
        br() {
            return "<br>";
        }
        del(text) {
            return `<del>${text}</del>`;
        }
        link(href, title, text) {
            const cleanHref = cleanUrl(href);
            if (cleanHref === null) return text;
            href = cleanHref;
            let out = '<a href="' + href + '"';
            if (title) out += ' title="' + title + '"';
            out += ">" + text + "</a>";
            return out;
        }
        image(href, title, text) {
            const cleanHref = cleanUrl(href);
            if (cleanHref === null) return text;
            href = cleanHref;
            let out = `<img src="${href}" alt="${text}"`;
            if (title) out += ` title="${title}"`;
            out += ">";
            return out;
        }
        text(text) {
            return text;
        }
    }
    /**
     * TextRenderer
     * returns only the textual part of the token
     */ class _TextRenderer {
        // no need for block level renderers
        strong(text) {
            return text;
        }
        em(text) {
            return text;
        }
        codespan(text) {
            return text;
        }
        del(text) {
            return text;
        }
        html(text) {
            return text;
        }
        text(text) {
            return text;
        }
        link(href, title, text) {
            return "" + text;
        }
        image(href, title, text) {
            return "" + text;
        }
        br() {
            return "";
        }
    }
    /**
     * Parsing & Compiling
     */ class _Parser {
        options;
        renderer;
        textRenderer;
        constructor(options){
            this.options = options || exports1.defaults;
            this.options.renderer = this.options.renderer || new _Renderer();
            this.renderer = this.options.renderer;
            this.renderer.options = this.options;
            this.textRenderer = new _TextRenderer();
        }
        /**
         * Static Parse Method
         */ static parse(tokens, options) {
            const parser = new _Parser(options);
            return parser.parse(tokens);
        }
        /**
         * Static Parse Inline Method
         */ static parseInline(tokens, options) {
            const parser = new _Parser(options);
            return parser.parseInline(tokens);
        }
        /**
         * Parse Loop
         */ parse(tokens, top = true) {
            let out = "";
            for(let i = 0; i < tokens.length; i++){
                const token = tokens[i];
                // Run any renderer extensions
                if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[token.type]) {
                    const genericToken = token;
                    const ret = this.options.extensions.renderers[genericToken.type].call({
                        parser: this
                    }, genericToken);
                    if (ret !== false || ![
                        "space",
                        "hr",
                        "heading",
                        "code",
                        "table",
                        "blockquote",
                        "list",
                        "html",
                        "paragraph",
                        "text"
                    ].includes(genericToken.type)) {
                        out += ret || "";
                        continue;
                    }
                }
                switch(token.type){
                    case "space":
                        continue;
                    case "hr":
                        out += this.renderer.hr();
                        continue;
                    case "heading":
                        {
                            const headingToken = token;
                            out += this.renderer.heading(this.parseInline(headingToken.tokens), headingToken.depth, unescape(this.parseInline(headingToken.tokens, this.textRenderer)));
                            continue;
                        }
                    case "code":
                        {
                            const codeToken = token;
                            out += this.renderer.code(codeToken.text, codeToken.lang, !!codeToken.escaped);
                            continue;
                        }
                    case "table":
                        {
                            const tableToken = token;
                            let header = "";
                            // header
                            let cell = "";
                            for(let j = 0; j < tableToken.header.length; j++)cell += this.renderer.tablecell(this.parseInline(tableToken.header[j].tokens), {
                                header: true,
                                align: tableToken.align[j]
                            });
                            header += this.renderer.tablerow(cell);
                            let body = "";
                            for(let j = 0; j < tableToken.rows.length; j++){
                                const row = tableToken.rows[j];
                                cell = "";
                                for(let k = 0; k < row.length; k++)cell += this.renderer.tablecell(this.parseInline(row[k].tokens), {
                                    header: false,
                                    align: tableToken.align[k]
                                });
                                body += this.renderer.tablerow(cell);
                            }
                            out += this.renderer.table(header, body);
                            continue;
                        }
                    case "blockquote":
                        {
                            const blockquoteToken = token;
                            const body = this.parse(blockquoteToken.tokens);
                            out += this.renderer.blockquote(body);
                            continue;
                        }
                    case "list":
                        {
                            const listToken = token;
                            const ordered = listToken.ordered;
                            const start = listToken.start;
                            const loose = listToken.loose;
                            let body = "";
                            for(let j = 0; j < listToken.items.length; j++){
                                const item = listToken.items[j];
                                const checked = item.checked;
                                const task = item.task;
                                let itemBody = "";
                                if (item.task) {
                                    const checkbox = this.renderer.checkbox(!!checked);
                                    if (loose) {
                                        if (item.tokens.length > 0 && item.tokens[0].type === "paragraph") {
                                            item.tokens[0].text = checkbox + " " + item.tokens[0].text;
                                            if (item.tokens[0].tokens && item.tokens[0].tokens.length > 0 && item.tokens[0].tokens[0].type === "text") item.tokens[0].tokens[0].text = checkbox + " " + item.tokens[0].tokens[0].text;
                                        } else item.tokens.unshift({
                                            type: "text",
                                            text: checkbox + " "
                                        });
                                    } else itemBody += checkbox + " ";
                                }
                                itemBody += this.parse(item.tokens, loose);
                                body += this.renderer.listitem(itemBody, task, !!checked);
                            }
                            out += this.renderer.list(body, ordered, start);
                            continue;
                        }
                    case "html":
                        {
                            const htmlToken = token;
                            out += this.renderer.html(htmlToken.text, htmlToken.block);
                            continue;
                        }
                    case "paragraph":
                        {
                            const paragraphToken = token;
                            out += this.renderer.paragraph(this.parseInline(paragraphToken.tokens));
                            continue;
                        }
                    case "text":
                        {
                            let textToken = token;
                            let body = textToken.tokens ? this.parseInline(textToken.tokens) : textToken.text;
                            while(i + 1 < tokens.length && tokens[i + 1].type === "text"){
                                textToken = tokens[++i];
                                body += "\n" + (textToken.tokens ? this.parseInline(textToken.tokens) : textToken.text);
                            }
                            out += top ? this.renderer.paragraph(body) : body;
                            continue;
                        }
                    default:
                        {
                            const errMsg = 'Token with "' + token.type + '" type was not found.';
                            if (this.options.silent) {
                                console.error(errMsg);
                                return "";
                            } else throw new Error(errMsg);
                        }
                }
            }
            return out;
        }
        /**
         * Parse Inline Tokens
         */ parseInline(tokens, renderer) {
            renderer = renderer || this.renderer;
            let out = "";
            for(let i = 0; i < tokens.length; i++){
                const token = tokens[i];
                // Run any renderer extensions
                if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[token.type]) {
                    const ret = this.options.extensions.renderers[token.type].call({
                        parser: this
                    }, token);
                    if (ret !== false || ![
                        "escape",
                        "html",
                        "link",
                        "image",
                        "strong",
                        "em",
                        "codespan",
                        "br",
                        "del",
                        "text"
                    ].includes(token.type)) {
                        out += ret || "";
                        continue;
                    }
                }
                switch(token.type){
                    case "escape":
                        {
                            const escapeToken = token;
                            out += renderer.text(escapeToken.text);
                            break;
                        }
                    case "html":
                        {
                            const tagToken = token;
                            out += renderer.html(tagToken.text);
                            break;
                        }
                    case "link":
                        {
                            const linkToken = token;
                            out += renderer.link(linkToken.href, linkToken.title, this.parseInline(linkToken.tokens, renderer));
                            break;
                        }
                    case "image":
                        {
                            const imageToken = token;
                            out += renderer.image(imageToken.href, imageToken.title, imageToken.text);
                            break;
                        }
                    case "strong":
                        {
                            const strongToken = token;
                            out += renderer.strong(this.parseInline(strongToken.tokens, renderer));
                            break;
                        }
                    case "em":
                        {
                            const emToken = token;
                            out += renderer.em(this.parseInline(emToken.tokens, renderer));
                            break;
                        }
                    case "codespan":
                        {
                            const codespanToken = token;
                            out += renderer.codespan(codespanToken.text);
                            break;
                        }
                    case "br":
                        out += renderer.br();
                        break;
                    case "del":
                        {
                            const delToken = token;
                            out += renderer.del(this.parseInline(delToken.tokens, renderer));
                            break;
                        }
                    case "text":
                        {
                            const textToken = token;
                            out += renderer.text(textToken.text);
                            break;
                        }
                    default:
                        {
                            const errMsg = 'Token with "' + token.type + '" type was not found.';
                            if (this.options.silent) {
                                console.error(errMsg);
                                return "";
                            } else throw new Error(errMsg);
                        }
                }
            }
            return out;
        }
    }
    class _Hooks {
        options;
        constructor(options){
            this.options = options || exports1.defaults;
        }
        static passThroughHooks = new Set([
            "preprocess",
            "postprocess",
            "processAllTokens"
        ]);
        /**
         * Process markdown before marked
         */ preprocess(markdown) {
            return markdown;
        }
        /**
         * Process HTML after marked is finished
         */ postprocess(html) {
            return html;
        }
        /**
         * Process all tokens before walk tokens
         */ processAllTokens(tokens) {
            return tokens;
        }
    }
    class Marked {
        defaults = _getDefaults();
        options = this.setOptions;
        parse = this.#parseMarkdown(_Lexer.lex, _Parser.parse);
        parseInline = this.#parseMarkdown(_Lexer.lexInline, _Parser.parseInline);
        Parser = _Parser;
        Renderer = _Renderer;
        TextRenderer = _TextRenderer;
        Lexer = _Lexer;
        Tokenizer = _Tokenizer;
        Hooks = _Hooks;
        constructor(...args){
            this.use(...args);
        }
        /**
         * Run callback for every token
         */ walkTokens(tokens, callback) {
            let values = [];
            for (const token of tokens){
                values = values.concat(callback.call(this, token));
                switch(token.type){
                    case "table":
                        {
                            const tableToken = token;
                            for (const cell of tableToken.header)values = values.concat(this.walkTokens(cell.tokens, callback));
                            for (const row of tableToken.rows)for (const cell of row)values = values.concat(this.walkTokens(cell.tokens, callback));
                            break;
                        }
                    case "list":
                        {
                            const listToken = token;
                            values = values.concat(this.walkTokens(listToken.items, callback));
                            break;
                        }
                    default:
                        {
                            const genericToken = token;
                            if (this.defaults.extensions?.childTokens?.[genericToken.type]) this.defaults.extensions.childTokens[genericToken.type].forEach((childTokens)=>{
                                const tokens = genericToken[childTokens].flat(Infinity);
                                values = values.concat(this.walkTokens(tokens, callback));
                            });
                            else if (genericToken.tokens) values = values.concat(this.walkTokens(genericToken.tokens, callback));
                        }
                }
            }
            return values;
        }
        use(...args) {
            const extensions = this.defaults.extensions || {
                renderers: {},
                childTokens: {}
            };
            args.forEach((pack)=>{
                // copy options to new object
                const opts = {
                    ...pack
                };
                // set async to true if it was set to true before
                opts.async = this.defaults.async || opts.async || false;
                // ==-- Parse "addon" extensions --== //
                if (pack.extensions) {
                    pack.extensions.forEach((ext)=>{
                        if (!ext.name) throw new Error("extension name required");
                        if ("renderer" in ext) {
                            const prevRenderer = extensions.renderers[ext.name];
                            if (prevRenderer) // Replace extension with func to run new extension but fall back if false
                            extensions.renderers[ext.name] = function(...args) {
                                let ret = ext.renderer.apply(this, args);
                                if (ret === false) ret = prevRenderer.apply(this, args);
                                return ret;
                            };
                            else extensions.renderers[ext.name] = ext.renderer;
                        }
                        if ("tokenizer" in ext) {
                            if (!ext.level || ext.level !== "block" && ext.level !== "inline") throw new Error("extension level must be 'block' or 'inline'");
                            const extLevel = extensions[ext.level];
                            if (extLevel) extLevel.unshift(ext.tokenizer);
                            else extensions[ext.level] = [
                                ext.tokenizer
                            ];
                            if (ext.start) {
                                if (ext.level === "block") {
                                    if (extensions.startBlock) extensions.startBlock.push(ext.start);
                                    else extensions.startBlock = [
                                        ext.start
                                    ];
                                } else if (ext.level === "inline") {
                                    if (extensions.startInline) extensions.startInline.push(ext.start);
                                    else extensions.startInline = [
                                        ext.start
                                    ];
                                }
                            }
                        }
                        if ("childTokens" in ext && ext.childTokens) extensions.childTokens[ext.name] = ext.childTokens;
                    });
                    opts.extensions = extensions;
                }
                // ==-- Parse "overwrite" extensions --== //
                if (pack.renderer) {
                    const renderer = this.defaults.renderer || new _Renderer(this.defaults);
                    for(const prop in pack.renderer){
                        if (!(prop in renderer)) throw new Error(`renderer '${prop}' does not exist`);
                        if (prop === "options") continue;
                        const rendererProp = prop;
                        const rendererFunc = pack.renderer[rendererProp];
                        const prevRenderer = renderer[rendererProp];
                        // Replace renderer with func to run extension, but fall back if false
                        renderer[rendererProp] = (...args)=>{
                            let ret = rendererFunc.apply(renderer, args);
                            if (ret === false) ret = prevRenderer.apply(renderer, args);
                            return ret || "";
                        };
                    }
                    opts.renderer = renderer;
                }
                if (pack.tokenizer) {
                    const tokenizer = this.defaults.tokenizer || new _Tokenizer(this.defaults);
                    for(const prop in pack.tokenizer){
                        if (!(prop in tokenizer)) throw new Error(`tokenizer '${prop}' does not exist`);
                        if ([
                            "options",
                            "rules",
                            "lexer"
                        ].includes(prop)) continue;
                        const tokenizerProp = prop;
                        const tokenizerFunc = pack.tokenizer[tokenizerProp];
                        const prevTokenizer = tokenizer[tokenizerProp];
                        // Replace tokenizer with func to run extension, but fall back if false
                        // @ts-expect-error cannot type tokenizer function dynamically
                        tokenizer[tokenizerProp] = (...args)=>{
                            let ret = tokenizerFunc.apply(tokenizer, args);
                            if (ret === false) ret = prevTokenizer.apply(tokenizer, args);
                            return ret;
                        };
                    }
                    opts.tokenizer = tokenizer;
                }
                // ==-- Parse Hooks extensions --== //
                if (pack.hooks) {
                    const hooks = this.defaults.hooks || new _Hooks();
                    for(const prop in pack.hooks){
                        if (!(prop in hooks)) throw new Error(`hook '${prop}' does not exist`);
                        if (prop === "options") continue;
                        const hooksProp = prop;
                        const hooksFunc = pack.hooks[hooksProp];
                        const prevHook = hooks[hooksProp];
                        if (_Hooks.passThroughHooks.has(prop)) // @ts-expect-error cannot type hook function dynamically
                        hooks[hooksProp] = (arg)=>{
                            if (this.defaults.async) return Promise.resolve(hooksFunc.call(hooks, arg)).then((ret)=>{
                                return prevHook.call(hooks, ret);
                            });
                            const ret = hooksFunc.call(hooks, arg);
                            return prevHook.call(hooks, ret);
                        };
                        else // @ts-expect-error cannot type hook function dynamically
                        hooks[hooksProp] = (...args)=>{
                            let ret = hooksFunc.apply(hooks, args);
                            if (ret === false) ret = prevHook.apply(hooks, args);
                            return ret;
                        };
                    }
                    opts.hooks = hooks;
                }
                // ==-- Parse WalkTokens extensions --== //
                if (pack.walkTokens) {
                    const walkTokens = this.defaults.walkTokens;
                    const packWalktokens = pack.walkTokens;
                    opts.walkTokens = function(token) {
                        let values = [];
                        values.push(packWalktokens.call(this, token));
                        if (walkTokens) values = values.concat(walkTokens.call(this, token));
                        return values;
                    };
                }
                this.defaults = {
                    ...this.defaults,
                    ...opts
                };
            });
            return this;
        }
        setOptions(opt) {
            this.defaults = {
                ...this.defaults,
                ...opt
            };
            return this;
        }
        lexer(src, options) {
            return _Lexer.lex(src, options ?? this.defaults);
        }
        parser(tokens, options) {
            return _Parser.parse(tokens, options ?? this.defaults);
        }
        #parseMarkdown(lexer, parser) {
            return (src, options)=>{
                const origOpt = {
                    ...options
                };
                const opt = {
                    ...this.defaults,
                    ...origOpt
                };
                // Show warning if an extension set async to true but the parse was called with async: false
                if (this.defaults.async === true && origOpt.async === false) {
                    if (!opt.silent) console.warn("marked(): The async option was set to true by an extension. The async: false option sent to parse will be ignored.");
                    opt.async = true;
                }
                const throwError = this.#onError(!!opt.silent, !!opt.async);
                // throw error in case of non string input
                if (typeof src === "undefined" || src === null) return throwError(new Error("marked(): input parameter is undefined or null"));
                if (typeof src !== "string") return throwError(new Error("marked(): input parameter is of type " + Object.prototype.toString.call(src) + ", string expected"));
                if (opt.hooks) opt.hooks.options = opt;
                if (opt.async) return Promise.resolve(opt.hooks ? opt.hooks.preprocess(src) : src).then((src)=>lexer(src, opt)).then((tokens)=>opt.hooks ? opt.hooks.processAllTokens(tokens) : tokens).then((tokens)=>opt.walkTokens ? Promise.all(this.walkTokens(tokens, opt.walkTokens)).then(()=>tokens) : tokens).then((tokens)=>parser(tokens, opt)).then((html)=>opt.hooks ? opt.hooks.postprocess(html) : html).catch(throwError);
                try {
                    if (opt.hooks) src = opt.hooks.preprocess(src);
                    let tokens = lexer(src, opt);
                    if (opt.hooks) tokens = opt.hooks.processAllTokens(tokens);
                    if (opt.walkTokens) this.walkTokens(tokens, opt.walkTokens);
                    let html = parser(tokens, opt);
                    if (opt.hooks) html = opt.hooks.postprocess(html);
                    return html;
                } catch (e) {
                    return throwError(e);
                }
            };
        }
        #onError(silent, async) {
            return (e)=>{
                e.message += "\nPlease report this to https://github.com/markedjs/marked.";
                if (silent) {
                    const msg = "<p>An error occurred:</p><pre>" + escape$1(e.message + "", true) + "</pre>";
                    if (async) return Promise.resolve(msg);
                    return msg;
                }
                if (async) return Promise.reject(e);
                throw e;
            };
        }
    }
    const markedInstance = new Marked();
    function marked(src, opt) {
        return markedInstance.parse(src, opt);
    }
    /**
     * Sets the default options.
     *
     * @param options Hash of options
     */ marked.options = marked.setOptions = function(options) {
        markedInstance.setOptions(options);
        marked.defaults = markedInstance.defaults;
        changeDefaults(marked.defaults);
        return marked;
    };
    /**
     * Gets the original marked default options.
     */ marked.getDefaults = _getDefaults;
    marked.defaults = exports1.defaults;
    /**
     * Use Extension
     */ marked.use = function(...args) {
        markedInstance.use(...args);
        marked.defaults = markedInstance.defaults;
        changeDefaults(marked.defaults);
        return marked;
    };
    /**
     * Run callback for every token
     */ marked.walkTokens = function(tokens, callback) {
        return markedInstance.walkTokens(tokens, callback);
    };
    /**
     * Compiles markdown to HTML without enclosing `p` tag.
     *
     * @param src String of markdown source to be compiled
     * @param options Hash of options
     * @return String of compiled HTML
     */ marked.parseInline = markedInstance.parseInline;
    /**
     * Expose
     */ marked.Parser = _Parser;
    marked.parser = _Parser.parse;
    marked.Renderer = _Renderer;
    marked.TextRenderer = _TextRenderer;
    marked.Lexer = _Lexer;
    marked.lexer = _Lexer.lex;
    marked.Tokenizer = _Tokenizer;
    marked.Hooks = _Hooks;
    marked.parse = marked;
    const options = marked.options;
    const setOptions = marked.setOptions;
    const use = marked.use;
    const walkTokens = marked.walkTokens;
    const parseInline = marked.parseInline;
    const parse = marked;
    const parser = _Parser.parse;
    const lexer = _Lexer.lex;
    exports1.Hooks = _Hooks;
    exports1.Lexer = _Lexer;
    exports1.Marked = Marked;
    exports1.Parser = _Parser;
    exports1.Renderer = _Renderer;
    exports1.TextRenderer = _TextRenderer;
    exports1.Tokenizer = _Tokenizer;
    exports1.getDefaults = _getDefaults;
    exports1.lexer = lexer;
    exports1.marked = marked;
    exports1.options = options;
    exports1.parse = parse;
    exports1.parseInline = parseInline;
    exports1.parser = parser;
    exports1.setOptions = setOptions;
    exports1.use = use;
    exports1.walkTokens = walkTokens;
});


var $0db07e69c50f8207$exports = {};
$0db07e69c50f8207$exports = new URL("2024-03-24.ffeae563.md", import.meta.url).toString();


var $31d246f19b012bde$exports = {};
$31d246f19b012bde$exports = new URL("2023-08-25.34f9cdf9.md", import.meta.url).toString();


var $a2abee124194018c$exports = {};
$a2abee124194018c$exports = new URL("screenshot.20e66929.avif", import.meta.url).toString();


var $41e178b8c171751c$exports = {};
$41e178b8c171751c$exports = new URL("2023-04-02.2db496a8.md", import.meta.url).toString();


var $1fc5d3c2e8b00301$exports = {};
$1fc5d3c2e8b00301$exports = new URL("screenshot-1.4802d2bd.avif", import.meta.url).toString();


var $a4f90fd070634e6d$exports = {};
$a4f90fd070634e6d$exports = new URL("screenshot-2.1ca5c826.avif", import.meta.url).toString();


var $33e9770b7768bf00$exports = {};
$33e9770b7768bf00$exports = new URL("2023-01-02.674fdbf5.md", import.meta.url).toString();


var $e2745a4d3e4aeefe$exports = {};
$e2745a4d3e4aeefe$exports = new URL("screenshot-1.1f386e33.avif", import.meta.url).toString();


var $e5ffadf769e63003$exports = {};
$e5ffadf769e63003$exports = new URL("screenshot-2.82135d23.avif", import.meta.url).toString();


var $2d9e8fe111e2e161$exports = {};
$2d9e8fe111e2e161$exports = new URL("2022-12-28.c3184b05.md", import.meta.url).toString();


var $2759dc9465a67f9c$exports = {};
$2759dc9465a67f9c$exports = new URL("screenshot-1.67e4ed25.avif", import.meta.url).toString();


var $5d606495a1020f8b$exports = {};
$5d606495a1020f8b$exports = new URL("screenshot-2.ce159c6a.avif", import.meta.url).toString();


var $66fd214f30fc023f$exports = {};
$66fd214f30fc023f$exports = new URL("2022-11-01.17053a2a.md", import.meta.url).toString();


var $9288146237001341$exports = {};
$9288146237001341$exports = new URL("screenshot-1.a90939e5.avif", import.meta.url).toString();


var $347feaf42a7dd5f1$exports = {};
$347feaf42a7dd5f1$exports = new URL("screenshot-2.90e616f2.avif", import.meta.url).toString();


var $93f86d6dfa21bf5c$exports = {};
$93f86d6dfa21bf5c$exports = new URL("2022-05-22.a3cd0cb8.md", import.meta.url).toString();


var $259f7352375fe87b$exports = {};
$259f7352375fe87b$exports = new URL("screenshot.14962068.avif", import.meta.url).toString();


var $cf25823d60e8ba8b$exports = {};
$cf25823d60e8ba8b$exports = new URL("2022-02-13.885a5c5a.md", import.meta.url).toString();


var $f46e3edce46fc2ae$exports = {};
$f46e3edce46fc2ae$exports = new URL("screenshot.cb1231e4.avif", import.meta.url).toString();


var $91887c94393771b3$exports = {};
$91887c94393771b3$exports = new URL("2022-01-13.388309f8.md", import.meta.url).toString();


var $0138fc01bf08c3dd$exports = {};
$0138fc01bf08c3dd$exports = new URL("screenshot-1.4f6e6236.avif", import.meta.url).toString();


var $7e7415e4820557ec$exports = {};
$7e7415e4820557ec$exports = new URL("screenshot-2.18cee807.avif", import.meta.url).toString();


var $1da35c7c6a8e3859$exports = {};
$1da35c7c6a8e3859$exports = new URL("2021-12-15.5a202da9.md", import.meta.url).toString();


var $864a0ca1617a95d8$exports = {};
$864a0ca1617a95d8$exports = new URL("screenshot.73483145.avif", import.meta.url).toString();


var $e6b59caa1f988537$exports = {};
$e6b59caa1f988537$exports = new URL("2021-09-24.033f4470.md", import.meta.url).toString();


var $3713c58907babebc$exports = {};
$3713c58907babebc$exports = new URL("screenshot.f44de035.avif", import.meta.url).toString();


var $b61363d0d253461e$exports = {};
$b61363d0d253461e$exports = new URL("2021-07-17.3ccc4c40.md", import.meta.url).toString();


var $e276324704f6ff30$exports = {};
$e276324704f6ff30$exports = new URL("2021-07-15.e6eefe64.md", import.meta.url).toString();


var $797058480f366d7f$exports = {};
$797058480f366d7f$exports = new URL("screenshot-1.b77cbe41.avif", import.meta.url).toString();


var $814ab03464d923f1$exports = {};
$814ab03464d923f1$exports = new URL("screenshot-2.cc90d926.avif", import.meta.url).toString();


var $384cbadc983a09bb$exports = {};
$384cbadc983a09bb$exports = new URL("2021-07-02.234b26c4.md", import.meta.url).toString();


var $7fec56cce3e3678f$exports = {};
$7fec56cce3e3678f$exports = new URL("2021-04-25.9c749527.md", import.meta.url).toString();


var $2a676c512ac88208$exports = {};
$2a676c512ac88208$exports = new URL("screenshot.b0d8f213.avif", import.meta.url).toString();


var $b724b86e75a7ef4c$exports = {};
$b724b86e75a7ef4c$exports = new URL("2021-04-18.040f084b.md", import.meta.url).toString();


var $61361cdbae85dbfb$exports = {};
$61361cdbae85dbfb$exports = new URL("screenshot-1.c183f6d5.avif", import.meta.url).toString();


var $6a1079c9d80bcc77$exports = {};
$6a1079c9d80bcc77$exports = new URL("screenshot-2.1489989f.avif", import.meta.url).toString();


var $f0c1a4bf091d8bc6$exports = {};
$f0c1a4bf091d8bc6$exports = new URL("2021-04-04.8feefcdd.md", import.meta.url).toString();


var $b3153faa309b4fb7$exports = {};
$b3153faa309b4fb7$exports = new URL("screenshot.9bf18e59.avif", import.meta.url).toString();


var $2bca699edd59c123$exports = {};
$2bca699edd59c123$exports = new URL("2021-03-18.f0875482.md", import.meta.url).toString();


var $7727f92dc41c41fc$exports = {};
$7727f92dc41c41fc$exports = new URL("screenshot.029dd390.avif", import.meta.url).toString();


var $d26b3383f893b8d2$exports = {};
$d26b3383f893b8d2$exports = new URL("2021-02-19.2169bf82.md", import.meta.url).toString();


var $2f6ebc0187838cfb$exports = {};
$2f6ebc0187838cfb$exports = new URL("2021-02-17.fd50ae1d.md", import.meta.url).toString();


var $2bcfaf7d04f527e3$exports = {};
$2bcfaf7d04f527e3$exports = new URL("screenshot.3abe8ac9.avif", import.meta.url).toString();


var $cfe5fa92bb3ba3ed$exports = {};
$cfe5fa92bb3ba3ed$exports = new URL("2021-01-23.1054b941.md", import.meta.url).toString();


var $ab29512d9d0955f3$exports = {};
$ab29512d9d0955f3$exports = new URL("screenshot.e693f357.avif", import.meta.url).toString();


var $9343b2724ea9c9c5$exports = {};
$9343b2724ea9c9c5$exports = new URL("2021-01-14.ce86149f.md", import.meta.url).toString();


var $c77db5ab35bb3f82$exports = {};
$c77db5ab35bb3f82$exports = new URL("screenshot.7bbbe011.avif", import.meta.url).toString();


var $fcfca6cedfc72645$exports = {};
$fcfca6cedfc72645$exports = new URL("2021-01-12.2d2542ad.md", import.meta.url).toString();


var $ac9f0c7a308ead6c$exports = {};
$ac9f0c7a308ead6c$exports = new URL("screenshot.57a8ea69.avif", import.meta.url).toString();


var $92651a572f52b360$exports = {};
$92651a572f52b360$exports = new URL("2021-01-09.bf0b4224.md", import.meta.url).toString();


var $92b6857938d63288$exports = {};
$92b6857938d63288$exports = new URL("screenshot.e49774d8.avif", import.meta.url).toString();


var $055df9bb97a50222$exports = {};
$055df9bb97a50222$exports = new URL("2021-01-01.3c6ba747.md", import.meta.url).toString();


var $e10ad73cf3bc3efe$exports = {};
$e10ad73cf3bc3efe$exports = new URL("screenshot-1.c4098190.avif", import.meta.url).toString();


var $ab7c2f93ba80e9bd$exports = {};
$ab7c2f93ba80e9bd$exports = new URL("screenshot-2.1f89c245.avif", import.meta.url).toString();


var $812f177bfbdafe74$exports = {};
$812f177bfbdafe74$exports = new URL("2020-12-30.c18b4c12.md", import.meta.url).toString();


const $3977aad02b2c0cad$var$BLOG_POSTS = {
    "2024-03-24": {
        title: "New feature - sleep tracking",
        url: new URL($0db07e69c50f8207$exports)
    },
    "2023-08-25": {
        title: "New feature - daily push notifications",
        url: new URL($31d246f19b012bde$exports)
    },
    "2023-04-02": {
        imageUrls: [
            new URL($a2abee124194018c$exports)
        ],
        title: "Location place names",
        url: new URL($41e178b8c171751c$exports)
    },
    "2023-01-02": {
        imageUrls: [
            new URL($1fc5d3c2e8b00301$exports),
            new URL($a4f90fd070634e6d$exports)
        ],
        title: "Enhancements to Explore page",
        url: new URL($33e9770b7768bf00$exports)
    },
    "2022-12-28": {
        imageUrls: [
            new URL($e2745a4d3e4aeefe$exports),
            new URL($e5ffadf769e63003$exports)
        ],
        title: "New weather features",
        url: new URL($2d9e8fe111e2e161$exports)
    },
    "2022-11-01": {
        imageUrls: [
            new URL($2759dc9465a67f9c$exports),
            new URL($5d606495a1020f8b$exports)
        ],
        title: "Improvements to stats pages",
        url: new URL($66fd214f30fc023f$exports)
    },
    "2022-05-22": {
        imageUrls: [
            new URL($9288146237001341$exports),
            new URL($347feaf42a7dd5f1$exports)
        ],
        title: "Improvements to stats pages",
        url: new URL($93f86d6dfa21bf5c$exports)
    },
    "2022-02-13": {
        imageUrls: [
            new URL($259f7352375fe87b$exports)
        ],
        title: "New feature - location map",
        url: new URL($cf25823d60e8ba8b$exports)
    },
    "2022-01-13": {
        imageUrls: [
            new URL($f46e3edce46fc2ae$exports)
        ],
        title: "Mood chart added to day stats view",
        url: new URL($91887c94393771b3$exports)
    },
    "2021-12-15": {
        imageUrls: [
            new URL($0138fc01bf08c3dd$exports),
            new URL($7e7415e4820557ec$exports)
        ],
        title: "Updates to summary view on stats pages",
        url: new URL($1da35c7c6a8e3859$exports)
    },
    "2021-09-24": {
        imageUrls: [
            new URL($864a0ca1617a95d8$exports)
        ],
        title: "New feature - record your location",
        url: new URL($e6b59caa1f988537$exports)
    },
    "2021-07-17": {
        imageUrls: [
            new URL($3713c58907babebc$exports)
        ],
        title: "New feature - open-ended meditation",
        url: new URL($b61363d0d253461e$exports)
    },
    "2021-07-15": {
        title: "New feature - meditation stats page",
        url: new URL($e276324704f6ff30$exports)
    },
    "2021-07-02": {
        imageUrls: [
            new URL($797058480f366d7f$exports),
            new URL($814ab03464d923f1$exports)
        ],
        title: "New feature - meditation log",
        url: new URL($384cbadc983a09bb$exports)
    },
    "2021-04-25": {
        title: "New feature - daily statistics",
        url: new URL($7fec56cce3e3678f$exports)
    },
    "2021-04-18": {
        imageUrls: [
            new URL($2a676c512ac88208$exports)
        ],
        title: "New feature - meditation timer",
        url: new URL($b724b86e75a7ef4c$exports)
    },
    "2021-04-04": {
        imageUrls: [
            new URL($61361cdbae85dbfb$exports),
            new URL($6a1079c9d80bcc77$exports)
        ],
        title: "New feature - mood gradient visualization",
        url: new URL($f0c1a4bf091d8bc6$exports)
    },
    "2021-03-18": {
        imageUrls: [
            new URL($b3153faa309b4fb7$exports)
        ],
        title: "New feature - weekly email updates",
        url: new URL($2bca699edd59c123$exports)
    },
    "2021-02-19": {
        imageUrls: [
            new URL($7727f92dc41c41fc$exports)
        ],
        title: "Average mood by hour",
        url: new URL($d26b3383f893b8d2$exports)
    },
    "2021-02-17": {
        title: "Improvements to the explore page",
        url: new URL($2f6ebc0187838cfb$exports)
    },
    "2021-01-23": {
        imageUrls: [
            new URL($2bcfaf7d04f527e3$exports)
        ],
        title: "New feature - search and filter",
        url: new URL($cfe5fa92bb3ba3ed$exports)
    },
    "2021-01-14": {
        imageUrls: [
            new URL($ab29512d9d0955f3$exports)
        ],
        title: "New feature - data export",
        url: new URL($9343b2724ea9c9c5$exports)
    },
    "2021-01-12": {
        imageUrls: [
            new URL($c77db5ab35bb3f82$exports)
        ],
        title: "Yearly statistics and other improvements to stats",
        url: new URL($fcfca6cedfc72645$exports)
    },
    "2021-01-09": {
        imageUrls: [
            new URL($ac9f0c7a308ead6c$exports)
        ],
        title: "New feature - date controls on explore page",
        url: new URL($92651a572f52b360$exports)
    },
    "2021-01-01": {
        imageUrls: [
            new URL($92b6857938d63288$exports)
        ],
        title: "New feature - calendar view",
        url: new URL($055df9bb97a50222$exports)
    },
    "2020-12-30": {
        imageUrls: [
            new URL($e10ad73cf3bc3efe$exports),
            new URL($ab7c2f93ba80e9bd$exports)
        ],
        title: "New feature - exploration",
        url: new URL($812f177bfbdafe74$exports)
    }
};
function $3977aad02b2c0cad$export$2e2bcd8739ae039() {
    const [posts, setPosts] = (0, $lBnVc.useState)([]);
    (0, $lBnVc.useEffect)(()=>{
        Promise.all(Object.entries($3977aad02b2c0cad$var$BLOG_POSTS).map(async ([dateString, post])=>{
            const response = await fetch(String(post.url));
            let text = await response.text();
            if ("imageUrls" in post) for (const { pathname: pathname } of post.imageUrls)text = text.replace(pathname.slice(1).replace(/\..+\.avif$/, ".png"), pathname);
            const __html = (0, $440d6b05cd13abc5$exports.marked).parse(text);
            if (typeof __html !== "string") throw Error("Expected `marked.parse` to return a string");
            return {
                __html: __html,
                dateString: dateString,
                title: post.title
            };
        })).then(setPosts);
    }, []);
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039).Group, {
        children: [
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h2", {
                        children: "Blog"
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("p", {
                        children: "Welcome to the MoodTracker blog!"
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("p", {
                        children: "This space is for announcing interesting new features and developments."
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("p", {
                        children: [
                            "Less exciting stuff like bugfixes, performance improvements and minor UI changes won't get a mention here (if you're interested though you can see a",
                            " ",
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("a", {
                                href: "https://github.com/benji6/moodtracker/commits/master",
                                rel: "noopener",
                                target: "blank",
                                children: "full technical changelog on GitHub"
                            }),
                            ")."
                        ]
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $9025684549319f54$export$2e2bcd8739ae039), {})
                ]
            }),
            posts.length ? posts.map(({ __html: __html, dateString: dateString, title: title })=>/*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("article", {
                        itemScope: true,
                        itemType: "http://schema.org/BlogPosting",
                        children: [
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("h2", {
                                children: [
                                    title,
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $19d86a636b501d10$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("time", {
                                            dateTime: dateString,
                                            itemProp: "dateCreated datePublished pubdate",
                                            children: (0, $06d17fa75ca1067f$export$406508d2ca449bd).format(new Date(dateString))
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("div", {
                                dangerouslySetInnerHTML: {
                                    __html: __html
                                }
                            })
                        ]
                    })
                }, dateString)) : /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $b3bd040c14d4ce5c$export$2e2bcd8739ae039), {})
            })
        ]
    });
}





var $lBnVc = parcelRequire("lBnVc");


const $6a4092c3986f4410$export$2ba8fb1a64f3cffb = "new-email";





function $e0cc0e85eb6f38c2$export$2e2bcd8739ae039() {
    const navigate = (0, $f02d97b5ca509f34$export$9770f232ac06a008)();
    const currentEmail = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $9cfb09fae6dbced4$export$2e2bcd8739ae039).selectors.email);
    const [fieldError, setFieldError] = (0, $lBnVc.useState)();
    const [isSubmitting, setIsSubmitting] = (0, $lBnVc.useState)(false);
    const [submitError, setSubmitError] = (0, $lBnVc.useState)();
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039).Group, {
        children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h2", {
                    children: "Change email"
                }),
                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("p", {
                    children: "We will send a verification code to the new email address you provide us. Your email address will only change when you verify your new email address with us."
                }),
                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("form", {
                    noValidate: true,
                    onSubmit: async (e)=>{
                        e.preventDefault();
                        setFieldError(undefined);
                        setSubmitError(undefined);
                        const field = e.target.email;
                        const { value: value } = field;
                        if (field.validity.valueMissing) return setFieldError((0, $5a123094476b33d7$export$4fd720569787ab6f).required);
                        if (field.validity.typeMismatch) return setFieldError("Email address not valid");
                        if (value === currentEmail) return setFieldError("New email address is the same as your current email address");
                        setIsSubmitting(true);
                        try {
                            await (0, $97fc43514b4d4584$export$54d4d7ac67552aad)(value);
                            navigate(`/settings/verify-new-email?${(0, $6a4092c3986f4410$export$2ba8fb1a64f3cffb)}=${value}`);
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        } catch (e) {
                            switch(e.code){
                                case "NetworkError":
                                    setSubmitError((0, $5a123094476b33d7$export$4fd720569787ab6f).network);
                                    break;
                                default:
                                    setSubmitError((0, $5a123094476b33d7$export$4fd720569787ab6f).generic);
                            }
                        } finally{
                            setIsSubmitting(false);
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $78053ee2024d275e$export$2e2bcd8739ae039), {
                            autoComplete: "email",
                            autoFocus: true,
                            error: fieldError,
                            label: "New email address",
                            name: "email",
                            supportiveText: `Your current email address is: ${currentEmail}`,
                            type: "email"
                        }),
                        submitError && /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("p", {
                            className: "center",
                            children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("small", {
                                className: "negative",
                                children: submitError
                            })
                        }),
                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039).Group, {
                            children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039), {
                                disabled: isSubmitting,
                                children: "Change email"
                            })
                        }),
                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("p", {
                            className: "center",
                            children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("small", {
                                children: [
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e94b7bcc277332d2$export$a6c7ac8248d6e38a), {
                                        to: "/settings/verify-new-email",
                                        children: "Already have a verification code"
                                    }),
                                    "?"
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
}








function $75e5d4a71d4850e1$export$2e2bcd8739ae039() {
    const email = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $9cfb09fae6dbced4$export$2e2bcd8739ae039).selectors.email);
    if (!email) throw Error("User email not defined");
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $9b3b041e348a76a5$export$2e2bcd8739ae039), {
        onSubmit: async ({ currentPassword: currentPassword, newPassword: newPassword, setSubmitError: setSubmitError })=>{
            try {
                const { cognitoUser: cognitoUser } = await (0, $97fc43514b4d4584$export$b7c211e36c1a92b5)(email, currentPassword);
                return new Promise((resolve, reject)=>{
                    cognitoUser.changePassword(currentPassword, newPassword, // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    (e)=>{
                        if (!e) return resolve();
                        switch(e.code){
                            case "LimitExceededException":
                                setSubmitError("Too many attempts, please try again later");
                                break;
                            case "NetworkError":
                                setSubmitError((0, $5a123094476b33d7$export$4fd720569787ab6f).network);
                                break;
                            default:
                                setSubmitError((0, $5a123094476b33d7$export$4fd720569787ab6f).generic);
                        }
                        return reject(JSON.stringify(e));
                    });
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (e) {
                switch(e.code){
                    case "NetworkError":
                        setSubmitError((0, $5a123094476b33d7$export$4fd720569787ab6f).network);
                        break;
                    case "NotAuthorizedException":
                        setSubmitError("Current password is incorrect, please try again");
                        break;
                    default:
                        setSubmitError((0, $5a123094476b33d7$export$4fd720569787ab6f).generic);
                }
                throw Error(JSON.stringify(e));
            }
        }
    });
}













function $6813af323f7a9acb$export$2e2bcd8739ae039({ dateFrom: dateFrom, dateTo: dateTo }) {
    const eventsById = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.byId);
    const eventIdsWithLocationInPeriod = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((state)=>(0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.idsWithLocationInPeriod(state, dateFrom, dateTo));
    const coordinatesToRender = new Set();
    const locationsToRender = [];
    for (const id of eventIdsWithLocationInPeriod){
        const { location: location } = eventsById[id].payload;
        const key = `${location.longitude},${location.latitude}`;
        if (coordinatesToRender.has(key)) continue;
        coordinatesToRender.add(key);
        locationsToRender.push([
            id,
            location
        ]);
    }
    if (!locationsToRender.length) return;
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("h3", {
                children: [
                    "Location",
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $19d86a636b501d10$export$2e2bcd8739ae039), {
                        children: "Location of all data you have tracked"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $3bda04436e25bcfb$export$2e2bcd8739ae039), {
                children: locationsToRender.map(([id, location])=>/*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $3bda04436e25bcfb$export$2e2bcd8739ae039).Marker, {
                        latitude: location.latitude,
                        longitude: location.longitude
                    }, id))
            })
        ]
    });
}










function $62461b8bc8791ee1$export$2e2bcd8739ae039({ mood: mood }) {
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("div", {
        className: "m-mood-bar br-0",
        children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("div", {
            className: "m-mood-bar__bar br-0",
            style: {
                background: (0, $c2e94012e82e0308$export$18b446c953569205)(mood),
                width: `${mood * (0, $5a123094476b33d7$export$83043d74884e8814)[1]}%`
            }
        })
    });
}



function $041b0fb8a1821c7a$export$2e2bcd8739ae039({ mood: mood }) {
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("td", {
        className: "center",
        children: [
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("span", {
                children: (0, $035f270eea0b2c1d$export$da6f4123477e5931).format(mood)
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $62461b8bc8791ee1$export$2e2bcd8739ae039), {
                mood: mood
            })
        ]
    });
}



function $98c14926387db14d$export$2e2bcd8739ae039({ moodsByLocation: moodsByLocation }) {
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("table", {
        children: [
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("thead", {
                children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("tr", {
                    children: [
                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("th", {
                            children: "Location"
                        }),
                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("th", {
                            children: "Total moods"
                        }),
                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("th", {
                            children: "Average mood"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("tbody", {
                children: [
                    ...Object.entries(moodsByLocation)
                ].sort((a, b)=>b[1].length - a[1].length).map(([location, moods])=>/*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("td", {
                                children: location
                            }),
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("td", {
                                children: moods.length
                            }),
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $041b0fb8a1821c7a$export$2e2bcd8739ae039), {
                                mood: (0, $c2e94012e82e0308$export$772b647faa1a81e0)(moods)
                            })
                        ]
                    }, location))
            })
        ]
    });
}







function $d4bf939de7dd3627$export$2e2bcd8739ae039({ dateFrom: dateFrom, dateTo: dateTo }) {
    const normalizedMoods = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.normalizedMoods);
    const moodIdsWithLocationInPeriod = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((state)=>(0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.moodIdsWithLocationInPeriod(state, dateFrom, dateTo));
    const reverseGeolocationResults = (0, $f98bf430ea5fe891$export$399ebcd562d6b0a7)(moodIdsWithLocationInPeriod);
    if (!moodIdsWithLocationInPeriod.length) return;
    const moodsByLocation = {};
    let errorCount = 0;
    let loadingCount = 0;
    let successCount = 0;
    for(let i = 0; i < reverseGeolocationResults.length; i++){
        const result = reverseGeolocationResults[i];
        const { mood: mood, location: location } = normalizedMoods.byId[moodIdsWithLocationInPeriod[i]];
        if (result.isError) errorCount++;
        else if (result.isPending) loadingCount++;
        const { data: data } = result;
        if (!data) continue;
        successCount++;
        const Place = data?.Results?.[0]?.Place;
        const locationName = Place?.Municipality ?? Place?.Label;
        if (!locationName) {
            const { latitude: latitude, longitude: longitude } = location;
            (0, $24a8d9ab78e4f062$export$f5282963edea4a68)(Error(`Failed to derive location name for ${JSON.stringify({
                latitude: latitude,
                longitude: longitude
            })}. Results: ${JSON.stringify(data.Results)}`));
            continue;
        }
        const val = moodsByLocation[locationName];
        if (val) val.push(mood);
        else moodsByLocation[locationName] = [
            mood
        ];
    }
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h3", {
                children: "Average mood by location"
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $98c14926387db14d$export$2e2bcd8739ae039), {
                moodsByLocation: moodsByLocation
            }),
            loadingCount || errorCount ? /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("p", {
                children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("small", {
                    children: [
                        Boolean(loadingCount) && /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $b3bd040c14d4ce5c$export$2e2bcd8739ae039), {
                                    inline: true,
                                    margin: "end"
                                }),
                                "Fetching location data (may require an internet connection)...",
                                " ",
                                (0, $035f270eea0b2c1d$export$5ed428cfaac5d75d).format(successCount / moodIdsWithLocationInPeriod.length)
                            ]
                        }),
                        Boolean(errorCount && loadingCount) && /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("br", {}),
                        Boolean(errorCount) && /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("span", {
                            className: "negative",
                            children: [
                                "Could not fetch location for",
                                " ",
                                (0, $035f270eea0b2c1d$export$5ed428cfaac5d75d).format(errorCount / moodIdsWithLocationInPeriod.length),
                                " ",
                                "of moods, please try again later"
                            ]
                        })
                    ]
                })
            }) : null
        ]
    });
}












function $3162d8c95c68fad7$export$2e2bcd8739ae039({ date: date, latitude: latitude, longitude: longitude }) {
    const { data: data, isError: isError, isPending: isPending } = (0, $fafc84f9c915ea54$export$66cd2f9777620c1f)({
        date: date,
        latitude: latitude,
        longitude: longitude
    });
    if (isError) return;
    if (isPending) return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("div", {
        className: "m-mood-card-weather m-mood-card-weather--spinner",
        children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $b3bd040c14d4ce5c$export$2e2bcd8739ae039), {
            margin: false
        })
    });
    const weatherData = data.data[0];
    const weatherIconData = weatherData?.weather[0];
    const { iconName: iconName, weatherColor: weatherColor } = (0, $c2e94012e82e0308$export$6729330625148ca3)({
        isDaytime: date >= new Date(weatherData.sunrise * 1e3) && date < new Date(weatherData.sunset * 1e3),
        weatherId: weatherIconData.id
    });
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("div", {
        className: "m-mood-card-weather",
        children: weatherIconData && /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                    color: weatherColor,
                    draw: true,
                    name: iconName,
                    size: "3"
                }),
                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("div", {
                    children: weatherData.temp && (0, $035f270eea0b2c1d$export$196dadf28b8781a5)(weatherData.temp)
                })
            ]
        })
    });
}








function $793264348b86e468$export$2e2bcd8739ae039({ id: id }) {
    const navigate = (0, $f02d97b5ca509f34$export$9770f232ac06a008)();
    const date = new Date(id);
    const normalizedMoods = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.normalizedMoods);
    const { description: description, exploration: exploration, location: location, mood: mood } = normalizedMoods.byId[id];
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $7c1560fa3a8ca778$export$2e2bcd8739ae039), {
        color: (0, $c2e94012e82e0308$export$18b446c953569205)(mood),
        onClick: ()=>navigate(`/edit/${id}`),
        children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("div", {
            className: "m-mood-card",
            children: [
                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("h3", {
                            className: "m-mood-card__heading center",
                            children: [
                                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("span", {
                                    "data-test-id": (0, $5a123094476b33d7$export$a2b4f255152a6585).moodCardMood,
                                    children: mood
                                }),
                                description && /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $19d86a636b501d10$export$2e2bcd8739ae039), {
                                    "data-test-id": (0, $5a123094476b33d7$export$a2b4f255152a6585).moodCardTags,
                                    style: {
                                        margin: "var(--space-0) 0"
                                    },
                                    children: description
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("p", {
                            className: "m-mood-card__time center",
                            children: [
                                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("small", {
                                    "data-test-id": (0, $5a123094476b33d7$export$a2b4f255152a6585).moodCardTime,
                                    "data-time": Math.round(date.getTime() / 1e3),
                                    children: (0, $06d17fa75ca1067f$export$5a00511f040384d7).format(date)
                                }),
                                location && /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("br", {}),
                                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("small", {
                                            children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $bdc0446275c44834$export$2e2bcd8739ae039), {
                                                latitude: location.latitude,
                                                longitude: location.longitude
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                exploration && /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("p", {
                    className: "m-mood-card__exploration pre-line",
                    children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("small", {
                        children: exploration
                    })
                }),
                location && /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $3162d8c95c68fad7$export$2e2bcd8739ae039), {
                    date: date,
                    latitude: location.latitude,
                    longitude: location.longitude
                })
            ]
        })
    }, id);
}







function $29d007de3bd21b0d$export$2e2bcd8739ae039({ centerXAxisLabels: centerXAxisLabels = false, data: data, domain: domain, hidePoints: hidePoints = false, trendlinePoints: trendlinePoints, xAxisTitle: xAxisTitle = "Date", xLabels: xLabels }) {
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $2ae3cd0ef43ccc32$export$2e2bcd8739ae039).LineChart, {
        "aria-label": "Chart displaying mood against time",
        centerXAxisLabels: centerXAxisLabels,
        domain: domain,
        points: hidePoints ? undefined : data.map(([x, y])=>({
                color: (0, $c2e94012e82e0308$export$18b446c953569205)(y),
                x: x,
                y: y
            })),
        range: (0, $5a123094476b33d7$export$83043d74884e8814),
        xAxisLabels: xLabels,
        xAxisTitle: xAxisTitle,
        yAxisLabels: (0, $5a123094476b33d7$export$88df5ff28be7bede).map(String),
        yAxisTitle: "Mood",
        children: hidePoints ? /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $2ae3cd0ef43ccc32$export$2e2bcd8739ae039).Line, {
                    color: "var(--color-balance-less)",
                    data: data
                }),
                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $2ae3cd0ef43ccc32$export$2e2bcd8739ae039).Line, {
                    data: trendlinePoints,
                    thickness: 2
                })
            ]
        }) : /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $2ae3cd0ef43ccc32$export$2e2bcd8739ae039).Line, {
                    color: "var(--color-balance-less)",
                    data: trendlinePoints,
                    thickness: 2
                }),
                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $2ae3cd0ef43ccc32$export$2e2bcd8739ae039).Line, {
                    data: data
                })
            ]
        })
    });
}




const $b5ab65a44bcad5db$var$TRENDLINE_POINTS_COUNT = 32;
const $b5ab65a44bcad5db$var$TRENDLINE_MOVING_AVERAGE_PERIOD_COUNT = 3;
function $b5ab65a44bcad5db$export$2e2bcd8739ae039(moods, domain) {
    const period = (domain[1] - domain[0]) / $b5ab65a44bcad5db$var$TRENDLINE_POINTS_COUNT;
    const earliestMoodTime = new Date(moods.allIds[0]).getTime();
    const latestMoodTime = new Date(moods.allIds.at(-1)).getTime();
    const trendlinePoints = [];
    for(let i = 0; i < $b5ab65a44bcad5db$var$TRENDLINE_POINTS_COUNT + 1; i++){
        const t0 = domain[0] + (i - $b5ab65a44bcad5db$var$TRENDLINE_MOVING_AVERAGE_PERIOD_COUNT / 2) * period;
        const t1 = t0 + period * $b5ab65a44bcad5db$var$TRENDLINE_MOVING_AVERAGE_PERIOD_COUNT;
        const trendlineX = (t0 + t1) / 2;
        if (trendlineX < earliestMoodTime) continue;
        if (trendlineX > latestMoodTime) break;
        const mood = (0, $c2e94012e82e0308$export$5b8fdb0cdc6de921)(moods, new Date(t0), new Date(t1));
        if (mood !== undefined) trendlinePoints.push([
            trendlineX,
            mood
        ]);
    }
    return trendlinePoints;
}




function $997e05fd3f436e77$export$2e2bcd8739ae039({ centerXAxisLabels: centerXAxisLabels = false, dateFrom: dateFrom, dateTo: dateTo, hidePoints: hidePoints = false, xAxisTitle: xAxisTitle, xLabels: xLabels }) {
    const moods = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.normalizedMoods);
    const domain = [
        dateFrom.getTime(),
        dateTo.getTime()
    ];
    const envelopingMoodIds = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((state)=>(0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.envelopingMoodIds(state, dateFrom, dateTo));
    if (envelopingMoodIds.length < 2) return;
    const data = envelopingMoodIds.map((id)=>{
        const mood = moods.byId[id];
        return [
            new Date(id).getTime(),
            mood.mood
        ];
    });
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h3", {
                children: "Mood chart"
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $29d007de3bd21b0d$export$2e2bcd8739ae039), {
                centerXAxisLabels: centerXAxisLabels,
                data: data,
                domain: domain,
                hidePoints: hidePoints,
                trendlinePoints: (0, $b5ab65a44bcad5db$export$2e2bcd8739ae039)({
                    ...moods,
                    allIds: envelopingMoodIds
                }, domain),
                xAxisTitle: xAxisTitle,
                xLabels: xLabels
            })
        ]
    });
}







const $0a48ec8918b8b79c$var$NO_DATA_COLOR = "var(--color-balance)";
function $0a48ec8918b8b79c$export$2e2bcd8739ae039({ dateFrom: dateFrom, dateTo: dateTo }) {
    const moods = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.normalizedMoods);
    const fromTime = dateFrom.getTime();
    const toTime = dateTo.getTime();
    const timeInterval = toTime - fromTime;
    const envelopingMoodIds = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((state)=>(0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.envelopingMoodIds(state, dateFrom, dateTo));
    if (envelopingMoodIds.length < 2) return;
    const firstTime = new Date(envelopingMoodIds[0]).getTime();
    const lastTime = new Date(envelopingMoodIds.at(-1)).getTime();
    let background = `linear-gradient(0.25turn`;
    if (firstTime > fromTime) {
        const percentage = (firstTime - fromTime) / timeInterval * 100;
        background += `,${$0a48ec8918b8b79c$var$NO_DATA_COLOR} ${percentage - 0.01}%`;
    }
    for (const id of envelopingMoodIds){
        const time = new Date(id).getTime();
        const percentage = (time - fromTime) / timeInterval * 100;
        background += `,${(0, $c2e94012e82e0308$export$18b446c953569205)(moods.byId[id].mood)} ${percentage}%`;
    }
    if (lastTime < toTime) {
        const percentage = (lastTime - fromTime) / timeInterval * 100;
        background += `,${$0a48ec8918b8b79c$var$NO_DATA_COLOR} ${percentage + 0.01}%`;
    }
    background += `)`;
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("div", {
        "aria-hidden": "true",
        className: "m-mood-gradient br-max",
        style: {
            background: background
        },
        title: "Mood gradient"
    });
}













function $b864b2e36ef68541$export$2e2bcd8739ae039({ currentValue: currentValue, displayTrendSentiment: displayTrendSentiment = false, format: format = (0, $035f270eea0b2c1d$export$7774341304efafa2).format, heading: heading, isMood: isMood = false, periodType: periodType, previousValue: previousValue, units: units }) {
    if (currentValue === undefined) return;
    const round = (n)=>n ? Math.round((n + Number.EPSILON) * 10) / 10 : Math.round(n);
    const roundedCurrentValue = round(currentValue);
    const roundedPreviousValue = previousValue === undefined ? undefined : round(previousValue);
    const difference = roundedPreviousValue === undefined ? undefined : round(roundedCurrentValue - roundedPreviousValue);
    let color = "var(--color-balance)";
    if (isMood) color = (0, $c2e94012e82e0308$export$18b446c953569205)(currentValue);
    else if (displayTrendSentiment && difference) {
        if (difference > 0) color = "var(--color-positive)";
        else color = "var(--color-negative)";
    }
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $7c1560fa3a8ca778$export$2e2bcd8739ae039), {
        color: color,
        children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("div", {
            className: "m-mood-summary-item",
            children: [
                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("div", {
                    children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("b", {
                        children: heading
                    })
                }),
                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("div", {
                    className: "m-mood-summary-item__value",
                    children: [
                        format(currentValue),
                        units
                    ]
                }),
                isMood && /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("div", {
                    className: "m-mood-summary-item__mood-bar",
                    children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $62461b8bc8791ee1$export$2e2bcd8739ae039), {
                        mood: currentValue
                    })
                }),
                difference !== undefined && /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("div", {
                    className: "m-mood-summary-item__trend",
                    children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("small", {
                        children: [
                            difference < 0 ? /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("span", {
                                className: displayTrendSentiment ? "negative" : "",
                                children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                                    draw: true,
                                    margin: "end",
                                    name: "down"
                                })
                            }) : difference > 0 ? /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("span", {
                                className: displayTrendSentiment ? "positive" : "",
                                children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                                    draw: true,
                                    margin: "end",
                                    name: "up"
                                })
                            }) : /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                                draw: true,
                                margin: "end",
                                name: "minus"
                            }),
                            difference ? `${format(Math.abs(difference))}${units ?? ""}
                ${difference < 0 ? "less" : "more"} than ` : "The same as ",
                            "previous ",
                            ` ${periodType}`
                        ]
                    })
                })
            ]
        })
    });
}





const $7bf1f584ca4dd7d4$export$59efddb4f320b9c3 = (minutes)=>[
        Math.floor(minutes / (0, $5a123094476b33d7$export$a9905336c0111a3a).minutesPerHour),
        Math.round(minutes % (0, $5a123094476b33d7$export$a9905336c0111a3a).minutesPerHour)
    ].map((n)=>String(n).padStart(2, "0")).join(":");
const $7bf1f584ca4dd7d4$export$2ec4521312384146 = (minutes)=>{
    const roundedMinutes = Math.round(minutes);
    if (!roundedMinutes) return "0 minutes";
    const hoursOnly = Math.floor(roundedMinutes / (0, $5a123094476b33d7$export$a9905336c0111a3a).minutesPerHour);
    const hoursString = hoursOnly ? `${hoursOnly} hour${hoursOnly === 1 ? "" : "s"}` : "";
    const minutesOnly = Math.round(roundedMinutes % (0, $5a123094476b33d7$export$a9905336c0111a3a).minutesPerHour);
    const minutesString = minutesOnly ? `${minutesOnly} minute${minutesOnly === 1 ? "" : "s"}` : "";
    return [
        hoursString,
        minutesString
    ].filter(Boolean).join(" & ");
};
[].map((n)=>String(n).padStart(2, "0")).join(":");




function $7791941d724bc7e1$export$2e2bcd8739ae039({ currentPeriod: currentPeriod, periodType: periodType, previousPeriod: previousPeriod, showMeditationStatsOverride: showMeditationStatsOverride = false }) {
    const showMeditationStats = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.hasMeditations) && Boolean(currentPeriod.secondsMeditated || previousPeriod?.secondsMeditated);
    const showTotalMoodsRecorded = Boolean(currentPeriod.total || previousPeriod?.total);
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("div", {
        className: "m-mood-summary",
        children: [
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $b864b2e36ef68541$export$2e2bcd8739ae039), {
                currentValue: currentPeriod.mean,
                format: (0, $035f270eea0b2c1d$export$da6f4123477e5931).format,
                displayTrendSentiment: true,
                heading: "Average mood",
                isMood: true,
                periodType: periodType,
                previousValue: previousPeriod?.mean
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $b864b2e36ef68541$export$2e2bcd8739ae039), {
                currentValue: currentPeriod.best,
                displayTrendSentiment: true,
                heading: "Best mood",
                isMood: true,
                periodType: periodType,
                previousValue: previousPeriod?.best
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $b864b2e36ef68541$export$2e2bcd8739ae039), {
                currentValue: currentPeriod.worst,
                displayTrendSentiment: true,
                heading: "Worst mood",
                isMood: true,
                periodType: periodType,
                previousValue: previousPeriod?.worst
            }),
            showTotalMoodsRecorded && /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $b864b2e36ef68541$export$2e2bcd8739ae039), {
                currentValue: currentPeriod.total,
                heading: "Moods recorded",
                periodType: periodType,
                previousValue: previousPeriod?.total
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $b864b2e36ef68541$export$2e2bcd8739ae039), {
                currentValue: currentPeriod.standardDeviation,
                format: (0, $035f270eea0b2c1d$export$da6f4123477e5931).format,
                heading: "Mood standard deviation",
                periodType: periodType,
                previousValue: previousPeriod?.standardDeviation
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $b864b2e36ef68541$export$2e2bcd8739ae039), {
                currentValue: currentPeriod.meanSleep,
                format: (0, $7bf1f584ca4dd7d4$export$59efddb4f320b9c3),
                heading: periodType === "day" ? "Sleep" : " Average sleep",
                periodType: periodType,
                previousValue: previousPeriod?.meanSleep
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $b864b2e36ef68541$export$2e2bcd8739ae039), {
                currentValue: currentPeriod.meanWeight,
                format: (0, $035f270eea0b2c1d$export$da6f4123477e5931).format,
                heading: "Average weight",
                periodType: periodType,
                previousValue: previousPeriod?.meanWeight,
                units: "kg"
            }),
            (showMeditationStatsOverride || showMeditationStats) && /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $b864b2e36ef68541$export$2e2bcd8739ae039), {
                currentValue: currentPeriod.secondsMeditated / (currentPeriod.secondsMeditated >= (0, $5a123094476b33d7$export$a9905336c0111a3a).secondsPerHour ? (0, $5a123094476b33d7$export$a9905336c0111a3a).secondsPerHour : (0, $5a123094476b33d7$export$a9905336c0111a3a).secondsPerMinute),
                format: (0, $035f270eea0b2c1d$export$da6f4123477e5931).format,
                heading: `${currentPeriod.secondsMeditated >= (0, $5a123094476b33d7$export$a9905336c0111a3a).secondsPerHour ? "Hours" : "Minutes"} meditated`,
                periodType: periodType,
                previousValue: previousPeriod ? previousPeriod.secondsMeditated / (currentPeriod.secondsMeditated >= (0, $5a123094476b33d7$export$a9905336c0111a3a).secondsPerHour ? (0, $5a123094476b33d7$export$a9905336c0111a3a).secondsPerHour : (0, $5a123094476b33d7$export$a9905336c0111a3a).secondsPerMinute) : undefined
            })
        ]
    });
}





function $c25731f3cd2809a0$export$2e2bcd8739ae039({ dates: [date0, date1, date2], heading: heading = "Summary", meanMoodByDate: meanMoodByDate, periodType: periodType }) {
    const moods = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.normalizedMoods);
    const meanSleepInPeriod = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((state)=>(0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.meanDailySleepDurationInPeriod(state, date1, date2));
    const meanSleepInPreviousPeriod = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((state)=>(0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.meanDailySleepDurationInPeriod(state, date0, date1));
    const meanWeightInPeriod = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((state)=>(0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.meanWeightInPeriod(state, date1, date2));
    const meanWeightInPreviousPeriod = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((state)=>(0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.meanWeightInPeriod(state, date0, date1));
    const secondsMeditatedInCurrentPeriod = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((state)=>(0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.secondsMeditatedInPeriod(state, date1, date2));
    const secondsMeditatedInPreviousPeriod = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((state)=>(0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.secondsMeditatedInPeriod(state, date0, date1));
    const firstMoodDate = new Date(moods.allIds[0]);
    const showPrevious = date1 > firstMoodDate;
    const moodValues = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((state)=>(0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.moodsInPeriod(state, date1, date2)).map(({ mood: mood })=>mood);
    const prevMoodValues = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((state)=>(0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.moodsInPeriod(state, date0, date1)).map(({ mood: mood })=>mood);
    if (!moodValues.length && !prevMoodValues.length && meanSleepInPeriod === undefined && meanSleepInPreviousPeriod === undefined && meanWeightInPeriod === undefined && meanWeightInPreviousPeriod === undefined && !secondsMeditatedInCurrentPeriod && !secondsMeditatedInPreviousPeriod) return null;
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h3", {
                children: heading
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $7791941d724bc7e1$export$2e2bcd8739ae039), {
                currentPeriod: {
                    best: moodValues.length ? Math.max(...moodValues) : undefined,
                    mean: meanMoodByDate[(0, $c2e94012e82e0308$export$f3013bcc8d8645bd)(date1)],
                    meanSleep: meanSleepInPeriod,
                    meanWeight: meanWeightInPeriod,
                    secondsMeditated: secondsMeditatedInCurrentPeriod,
                    standardDeviation: (0, $c2e94012e82e0308$export$4683e466d9b5386c)(moodValues),
                    total: moodValues.length,
                    worst: moodValues.length ? Math.min(...moodValues) : undefined
                },
                periodType: periodType,
                previousPeriod: showPrevious ? {
                    best: prevMoodValues.length ? Math.max(...prevMoodValues) : undefined,
                    mean: meanMoodByDate[(0, $c2e94012e82e0308$export$f3013bcc8d8645bd)(date0)],
                    meanSleep: meanSleepInPreviousPeriod,
                    meanWeight: meanWeightInPreviousPeriod,
                    secondsMeditated: secondsMeditatedInPreviousPeriod,
                    standardDeviation: (0, $c2e94012e82e0308$export$4683e466d9b5386c)(prevMoodValues),
                    total: prevMoodValues.length,
                    worst: prevMoodValues.length ? Math.min(...prevMoodValues) : undefined
                } : undefined
            })
        ]
    });
}




function $8b7e9eb862378972$export$2e2bcd8739ae039(props) {
    const meanMoods = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.meanMoodsByDay);
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $c25731f3cd2809a0$export$2e2bcd8739ae039), {
        ...props,
        meanMoodByDate: meanMoods,
        periodType: "day"
    });
}




function $cfc36dd95b79da04$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("div", {
        ...props,
        className: "m-prev-next-controls"
    });
}





const $3c33284f42c31f30$export$eb997100a237f4ce = 10;








function $89e828e6f365d470$export$2e2bcd8739ae039({ coarseGrainedData: coarseGrainedData, fineGrainedData: fineGrainedData }) {
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h4", {
                children: "Average mood by temperature"
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $2ae3cd0ef43ccc32$export$2e2bcd8739ae039).LineChart, {
                "aria-label": "Chart displaying average mood by temperature",
                domain: (0, $c2e94012e82e0308$export$2c9169ad8071d2bc)(coarseGrainedData.map(([x])=>x)),
                range: (0, $5a123094476b33d7$export$83043d74884e8814),
                xAxisTitle: "Temperature (\xb0C)",
                yAxisLabels: (0, $5a123094476b33d7$export$88df5ff28be7bede).map(String),
                yAxisTitle: "Mood",
                children: [
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $2ae3cd0ef43ccc32$export$2e2bcd8739ae039).Line, {
                        data: fineGrainedData,
                        thickness: 0
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $2ae3cd0ef43ccc32$export$2e2bcd8739ae039).Line, {
                        data: coarseGrainedData,
                        thickness: 2
                    })
                ]
            })
        ]
    });
}






function $fa23d7d0662fe426$export$2e2bcd8739ae039({ dateFrom: dateFrom, dateTo: dateTo }) {
    const normalizedMoods = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.normalizedMoods);
    const moodIdsWithLocationInPeriod = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((state)=>(0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.moodIdsWithLocationInPeriod(state, dateFrom, dateTo));
    const weatherResults = (0, $fafc84f9c915ea54$export$10c8dac78addff85)(moodIdsWithLocationInPeriod);
    if (moodIdsWithLocationInPeriod.length < (0, $3c33284f42c31f30$export$eb997100a237f4ce)) return;
    const fineGrainedData = {};
    const coarseGrainedData = {};
    for(let i = 0; i < weatherResults.length; i++){
        const result = weatherResults[i];
        const { data: data } = result;
        if (!data) continue;
        const celcius = (0, $c2e94012e82e0308$export$ed258585350e1d81)(data.data[0].temp);
        const { mood: mood } = normalizedMoods.byId[moodIdsWithLocationInPeriod[i]];
        fineGrainedData[celcius] = celcius in fineGrainedData ? {
            moodCount: fineGrainedData[celcius].moodCount + 1,
            sumOfMoods: fineGrainedData[celcius].sumOfMoods + mood
        } : {
            moodCount: 1,
            sumOfMoods: mood
        };
        const roundedCelcius = Math.round(celcius);
        coarseGrainedData[roundedCelcius] = roundedCelcius in coarseGrainedData ? {
            moodCount: coarseGrainedData[roundedCelcius].moodCount + 1,
            sumOfMoods: coarseGrainedData[roundedCelcius].sumOfMoods + mood
        } : {
            moodCount: 1,
            sumOfMoods: mood
        };
    }
    const fineGrainedDataEntries = Object.entries(fineGrainedData);
    if (fineGrainedDataEntries.length < (0, $3c33284f42c31f30$export$eb997100a237f4ce)) return;
    const coarseGrainedDataEntries = Object.entries(coarseGrainedData);
    if (coarseGrainedDataEntries.length < (0, $3c33284f42c31f30$export$eb997100a237f4ce) / 2) return;
    const fineGrainedDataToRender = fineGrainedDataEntries.map(([key, { moodCount: moodCount, sumOfMoods: sumOfMoods }])=>{
        const meanMood = sumOfMoods / moodCount;
        return [
            Number(key),
            meanMood
        ];
    }).sort(([a], [b])=>a - b);
    const coarseGrainedDataToRender = coarseGrainedDataEntries.map(([key, { moodCount: moodCount, sumOfMoods: sumOfMoods }])=>{
        const meanMood = sumOfMoods / moodCount;
        return [
            Number(key),
            meanMood
        ];
    }).sort(([a], [b])=>a - b);
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $89e828e6f365d470$export$2e2bcd8739ae039), {
        coarseGrainedData: coarseGrainedDataToRender,
        fineGrainedData: fineGrainedDataToRender
    });
}








function $1c3d89a2f6b44ad2$export$2e2bcd8739ae039({ data: data }) {
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h4", {
                children: "Average mood by weather"
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $2ae3cd0ef43ccc32$export$2e2bcd8739ae039).ColumnChart, {
                "aria-label": "Chart displaying average mood for different weather types",
                data: data.map(({ iconName: iconName, key: key, labelText: labelText, moodColor: moodColor, title: title, weatherColor: weatherColor, y: y })=>({
                        color: moodColor,
                        key: key,
                        label: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                                    color: weatherColor,
                                    draw: true,
                                    name: iconName
                                }),
                                labelText
                            ]
                        }),
                        title: title,
                        y: y
                    })),
                maxRange: (0, $5a123094476b33d7$export$1c4e9440df4662e4),
                rotateXLabels: true,
                xAxisTitle: "Weather",
                yAxisTitle: "Average mood"
            })
        ]
    });
}






function $9cd14503b674b3bc$export$2e2bcd8739ae039({ dateFrom: dateFrom, dateTo: dateTo }) {
    const normalizedMoods = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.normalizedMoods);
    const moodIdsWithLocationInPeriod = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((state)=>(0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.moodIdsWithLocationInPeriod(state, dateFrom, dateTo));
    const weatherResults = (0, $fafc84f9c915ea54$export$10c8dac78addff85)(moodIdsWithLocationInPeriod);
    if (moodIdsWithLocationInPeriod.length < (0, $3c33284f42c31f30$export$eb997100a237f4ce)) return;
    const chartData = (0, $c2e94012e82e0308$export$5563593ccbfe9912)(()=>({
            moodCount: 0,
            sumOfMoods: 0
        }));
    for(let i = 0; i < weatherResults.length; i++){
        const result = weatherResults[i];
        const { data: data } = result;
        if (!data) continue;
        const [weatherData] = data.data;
        const { mood: mood } = normalizedMoods.byId[moodIdsWithLocationInPeriod[i]];
        for (const { id: weatherId } of weatherData.weather){
            const { iconName: iconName, label: label, weatherColor: weatherColor } = (0, $c2e94012e82e0308$export$6729330625148ca3)({
                isDaytime: true,
                weatherId: weatherId
            });
            const key = `${label}:${iconName}:${weatherColor}`;
            chartData[key].moodCount += 1;
            chartData[key].sumOfMoods += mood;
        }
    }
    const data = Object.entries(chartData).map(([key, { moodCount: moodCount, sumOfMoods: sumOfMoods }])=>{
        const [label, iconName, weatherColor] = key.split(":");
        const meanMood = sumOfMoods / moodCount;
        return {
            iconName: iconName,
            key: key,
            moodColor: (0, $c2e94012e82e0308$export$18b446c953569205)(meanMood),
            title: `${label} (average of ${moodCount} mood${moodCount > 1 ? "s" : ""}): ${(0, $035f270eea0b2c1d$export$da6f4123477e5931).format(meanMood)}`,
            labelText: label,
            weatherColor: weatherColor,
            y: meanMood
        };
    }).sort((a, b)=>{
        const yDifference = b.y - a.y;
        return yDifference || a.labelText.localeCompare(b.labelText);
    });
    if (!data.length) return;
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $1c3d89a2f6b44ad2$export$2e2bcd8739ae039), {
        data: data
    });
}








function $db22e466d4cc5c13$export$2e2bcd8739ae039({ centerXAxisLabels: centerXAxisLabels, dateFrom: dateFrom, dateTo: dateTo, xLabels: xLabels }) {
    const envelopingEventIdsWithLocation = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((state)=>(0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.envelopingIdsWithLocation(state, dateFrom, dateTo));
    const weatherResults = (0, $fafc84f9c915ea54$export$10c8dac78addff85)(envelopingEventIdsWithLocation);
    if (!envelopingEventIdsWithLocation.length) return;
    const temperatures = [];
    const chartData = [];
    for(let i = 0; i < weatherResults.length; i++){
        const result = weatherResults[i];
        const { data: data } = result;
        if (!data) continue;
        const celcius = (0, $c2e94012e82e0308$export$ed258585350e1d81)(data.data[0].temp);
        temperatures.push(celcius);
        chartData.push([
            new Date(envelopingEventIdsWithLocation[i]).getTime(),
            celcius
        ]);
    }
    if (chartData.length < 2) return;
    const chartVariation = chartData.length >= 128 ? "large" : chartData.length >= 48 ? "medium" : "small";
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h4", {
                children: "Temperature chart"
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $2ae3cd0ef43ccc32$export$2e2bcd8739ae039).LineChart, {
                "aria-label": "Chart displaying temperature against time",
                centerXAxisLabels: centerXAxisLabels,
                domain: [
                    dateFrom.getTime(),
                    dateTo.getTime()
                ],
                points: chartVariation === "small" ? chartData.map(([x, y])=>({
                        x: x,
                        y: y
                    })) : undefined,
                range: (0, $c2e94012e82e0308$export$2c9169ad8071d2bc)(temperatures),
                xAxisLabels: xLabels,
                xAxisTitle: "Month",
                yAxisTitle: "Temperature (\xb0C)",
                children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $2ae3cd0ef43ccc32$export$2e2bcd8739ae039).Line, {
                    data: chartData,
                    thickness: chartVariation === "medium" ? 2 : undefined
                })
            })
        ]
    });
}








function $555fa1a6bf339941$export$2e2bcd8739ae039({ dateFrom: dateFrom, dateTo: dateTo }) {
    const eventIdsWithLocationInPeriod = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((state)=>(0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.idsWithLocationInPeriod(state, dateFrom, dateTo));
    const weatherResults = (0, $fafc84f9c915ea54$export$10c8dac78addff85)(eventIdsWithLocationInPeriod);
    if (!eventIdsWithLocationInPeriod.length) return;
    const chartData = {};
    for (const { data: data } of weatherResults){
        if (!data) continue;
        const [weatherData] = data.data;
        for (const { id: weatherId } of weatherData.weather){
            const { iconName: iconName, label: label, weatherColor: weatherColor } = (0, $c2e94012e82e0308$export$6729330625148ca3)({
                isDaytime: true,
                weatherId: weatherId
            });
            const key = `${label}:${iconName}:${weatherColor}`;
            chartData[key] = key in chartData ? chartData[key] + 1 : 1;
        }
    }
    const frequencyChartData = Object.entries(chartData).map(([key, count])=>{
        const [label, iconName, color] = key.split(":");
        return {
            color: color,
            key: key,
            label: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                        color: color,
                        draw: true,
                        name: iconName
                    }),
                    label
                ]
            }),
            text: label,
            title: `${label}: ${count}`,
            y: count
        };
    }).sort((a, b)=>{
        const yDifference = b.y - a.y;
        return yDifference || a.text.localeCompare(b.text);
    });
    if (!frequencyChartData.length) return;
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h4", {
                children: "Weather frequency"
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $2ae3cd0ef43ccc32$export$2e2bcd8739ae039).ColumnChart, {
                "aria-label": "Chart displaying the frequency at which different weather types were recorded",
                data: frequencyChartData,
                rotateXLabels: true,
                xAxisTitle: "Weather",
                yAxisTitle: "Count"
            })
        ]
    });
}






function $af798ee18e885c0a$export$2e2bcd8739ae039({ centerXAxisLabels: centerXAxisLabels = false, dateFrom: dateFrom, dateTo: dateTo, xLabels: xLabels }) {
    const eventIdsWithLocationInPeriod = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((state)=>(0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.idsWithLocationInPeriod(state, dateFrom, dateTo));
    const weatherResults = (0, $fafc84f9c915ea54$export$10c8dac78addff85)(eventIdsWithLocationInPeriod);
    if (!eventIdsWithLocationInPeriod.length) return;
    let errorCount = 0;
    let loadingCount = 0;
    let successCount = 0;
    for(let i = 0; i < weatherResults.length; i++){
        const result = weatherResults[i];
        if (result.isError) errorCount++;
        else if (result.isPending) loadingCount++;
        const { data: data } = result;
        if (!data) continue;
        successCount++;
    }
    const loadingEl = loadingCount || errorCount ? /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("p", {
        children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("small", {
            children: [
                Boolean(loadingCount) && /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $b3bd040c14d4ce5c$export$2e2bcd8739ae039), {
                            inline: true,
                            margin: "end"
                        }),
                        "Fetching weather data (may require an internet connection)...",
                        " ",
                        (0, $035f270eea0b2c1d$export$5ed428cfaac5d75d).format(successCount / eventIdsWithLocationInPeriod.length)
                    ]
                }),
                Boolean(errorCount && loadingCount) && /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("br", {}),
                Boolean(errorCount) && /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("span", {
                    className: "negative",
                    children: [
                        "Could not fetch weather for",
                        " ",
                        (0, $035f270eea0b2c1d$export$5ed428cfaac5d75d).format(errorCount / eventIdsWithLocationInPeriod.length),
                        " ",
                        "of locations, please try again later"
                    ]
                })
            ]
        })
    }) : null;
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("h3", {
                children: [
                    "Weather",
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $19d86a636b501d10$export$2e2bcd8739ae039), {
                        children: [
                            eventIdsWithLocationInPeriod.length,
                            " location",
                            eventIdsWithLocationInPeriod.length > 1 ? "s" : "",
                            " recorded for this period",
                            eventIdsWithLocationInPeriod.length < (0, $3c33284f42c31f30$export$eb997100a237f4ce) && /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
                                children: [
                                    " ",
                                    "(some weather charts will not be visible unless you have at least",
                                    " ",
                                    (0, $3c33284f42c31f30$export$eb997100a237f4ce),
                                    " locations)"
                                ]
                            })
                        ]
                    })
                ]
            }),
            loadingEl,
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $555fa1a6bf339941$export$2e2bcd8739ae039), {
                dateFrom: dateFrom,
                dateTo: dateTo
            }),
            eventIdsWithLocationInPeriod.length >= (0, $3c33284f42c31f30$export$eb997100a237f4ce) && /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $c0c9bc5c50648c54$exports.Fragment), {
                children: loadingEl
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $9cd14503b674b3bc$export$2e2bcd8739ae039), {
                dateFrom: dateFrom,
                dateTo: dateTo
            }),
            eventIdsWithLocationInPeriod.length >= (0, $3c33284f42c31f30$export$eb997100a237f4ce) && /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $c0c9bc5c50648c54$exports.Fragment), {
                children: loadingEl
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $fa23d7d0662fe426$export$2e2bcd8739ae039), {
                dateFrom: dateFrom,
                dateTo: dateTo
            }),
            loadingEl,
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $db22e466d4cc5c13$export$2e2bcd8739ae039), {
                centerXAxisLabels: centerXAxisLabels,
                dateFrom: dateFrom,
                dateTo: dateTo,
                xLabels: xLabels
            }),
            loadingEl
        ]
    });
}







function $1dc16ddda003912c$export$2e2bcd8739ae039({ centerXAxisLabels: centerXAxisLabels = false, dateFrom: dateFrom, dateTo: dateTo, xLabels: xLabels }) {
    const weights = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.normalizedWeights);
    const envelopingIds = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((state)=>(0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.envelopingWeightIds(state, dateFrom, dateTo));
    if (envelopingIds.length < 2) return;
    const domain = [
        dateFrom.getTime(),
        dateTo.getTime()
    ];
    const envelopingValues = envelopingIds.map((id)=>weights.byId[id].value);
    const data = envelopingIds.map((id)=>{
        const weight = weights.byId[id];
        return [
            new Date(id).getTime(),
            weight.value
        ];
    });
    const chartVariation = data.length >= 128 ? "large" : data.length >= 48 ? "medium" : "small";
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h3", {
                children: "Weight chart"
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $2ae3cd0ef43ccc32$export$2e2bcd8739ae039).LineChart, {
                centerXAxisLabels: centerXAxisLabels,
                "aria-label": "Chart displaying weight against time",
                domain: domain,
                points: chartVariation === "small" ? data.map(([x, y])=>({
                        x: x,
                        y: y
                    })) : undefined,
                range: (0, $c2e94012e82e0308$export$2c9169ad8071d2bc)(envelopingValues),
                xAxisLabels: xLabels,
                yAxisTitle: "Weight (kg)",
                children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $2ae3cd0ef43ccc32$export$2e2bcd8739ae039).Line, {
                    data: data,
                    thickness: chartVariation === "medium" ? 2 : undefined
                })
            })
        ]
    });
}












var $lBnVc = parcelRequire("lBnVc");

var $lBnVc = parcelRequire("lBnVc");





var $05a29a0c5190aa73$var$_client, $05a29a0c5190aa73$var$_currentResult, $05a29a0c5190aa73$var$_currentMutation, $05a29a0c5190aa73$var$_mutateOptions, $05a29a0c5190aa73$var$_updateResult, $05a29a0c5190aa73$var$updateResult_fn, $05a29a0c5190aa73$var$_notify, $05a29a0c5190aa73$var$notify_fn;
var $05a29a0c5190aa73$export$d3c1860ee66f291a = class extends (0, $f619992c377f98ae$export$d26086b469ecdbcc) {
    constructor(client, options){
        super();
        (0, $82bb902b93e9fce2$export$addf369becd23283)(this, $05a29a0c5190aa73$var$_updateResult);
        (0, $82bb902b93e9fce2$export$addf369becd23283)(this, $05a29a0c5190aa73$var$_notify);
        (0, $82bb902b93e9fce2$export$addf369becd23283)(this, $05a29a0c5190aa73$var$_client, void 0);
        (0, $82bb902b93e9fce2$export$addf369becd23283)(this, $05a29a0c5190aa73$var$_currentResult, void 0);
        (0, $82bb902b93e9fce2$export$addf369becd23283)(this, $05a29a0c5190aa73$var$_currentMutation, void 0);
        (0, $82bb902b93e9fce2$export$addf369becd23283)(this, $05a29a0c5190aa73$var$_mutateOptions, void 0);
        (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $05a29a0c5190aa73$var$_client, client);
        this.setOptions(options);
        this.bindMethods();
        (0, $82bb902b93e9fce2$export$fa92d15b718fce20)(this, $05a29a0c5190aa73$var$_updateResult, $05a29a0c5190aa73$var$updateResult_fn).call(this);
    }
    bindMethods() {
        this.mutate = this.mutate.bind(this);
        this.reset = this.reset.bind(this);
    }
    setOptions(options) {
        var _a;
        const prevOptions = this.options;
        this.options = (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $05a29a0c5190aa73$var$_client).defaultMutationOptions(options);
        if (!(0, $58dc61dd9f062c44$export$3e67810a3f0e9f1c)(this.options, prevOptions)) (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $05a29a0c5190aa73$var$_client).getMutationCache().notify({
            type: "observerOptionsUpdated",
            mutation: (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $05a29a0c5190aa73$var$_currentMutation),
            observer: this
        });
        if ((prevOptions == null ? void 0 : prevOptions.mutationKey) && this.options.mutationKey && (0, $58dc61dd9f062c44$export$1e87d19d4aab5805)(prevOptions.mutationKey) !== (0, $58dc61dd9f062c44$export$1e87d19d4aab5805)(this.options.mutationKey)) this.reset();
        else if (((_a = (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $05a29a0c5190aa73$var$_currentMutation)) == null ? void 0 : _a.state.status) === "pending") (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $05a29a0c5190aa73$var$_currentMutation).setOptions(this.options);
    }
    onUnsubscribe() {
        var _a;
        if (!this.hasListeners()) (_a = (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $05a29a0c5190aa73$var$_currentMutation)) == null || _a.removeObserver(this);
    }
    onMutationUpdate(action) {
        (0, $82bb902b93e9fce2$export$fa92d15b718fce20)(this, $05a29a0c5190aa73$var$_updateResult, $05a29a0c5190aa73$var$updateResult_fn).call(this);
        (0, $82bb902b93e9fce2$export$fa92d15b718fce20)(this, $05a29a0c5190aa73$var$_notify, $05a29a0c5190aa73$var$notify_fn).call(this, action);
    }
    getCurrentResult() {
        return (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $05a29a0c5190aa73$var$_currentResult);
    }
    reset() {
        var _a;
        (_a = (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $05a29a0c5190aa73$var$_currentMutation)) == null || _a.removeObserver(this);
        (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $05a29a0c5190aa73$var$_currentMutation, void 0);
        (0, $82bb902b93e9fce2$export$fa92d15b718fce20)(this, $05a29a0c5190aa73$var$_updateResult, $05a29a0c5190aa73$var$updateResult_fn).call(this);
        (0, $82bb902b93e9fce2$export$fa92d15b718fce20)(this, $05a29a0c5190aa73$var$_notify, $05a29a0c5190aa73$var$notify_fn).call(this);
    }
    mutate(variables, options) {
        var _a;
        (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $05a29a0c5190aa73$var$_mutateOptions, options);
        (_a = (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $05a29a0c5190aa73$var$_currentMutation)) == null || _a.removeObserver(this);
        (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $05a29a0c5190aa73$var$_currentMutation, (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $05a29a0c5190aa73$var$_client).getMutationCache().build((0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $05a29a0c5190aa73$var$_client), this.options));
        (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $05a29a0c5190aa73$var$_currentMutation).addObserver(this);
        return (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $05a29a0c5190aa73$var$_currentMutation).execute(variables);
    }
};
$05a29a0c5190aa73$var$_client = new WeakMap();
$05a29a0c5190aa73$var$_currentResult = new WeakMap();
$05a29a0c5190aa73$var$_currentMutation = new WeakMap();
$05a29a0c5190aa73$var$_mutateOptions = new WeakMap();
$05a29a0c5190aa73$var$_updateResult = new WeakSet();
$05a29a0c5190aa73$var$updateResult_fn = function() {
    var _a;
    const state = ((_a = (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $05a29a0c5190aa73$var$_currentMutation)) == null ? void 0 : _a.state) ?? (0, $cf0f9d9b6103160d$export$a1659b54bac3252a)();
    (0, $82bb902b93e9fce2$export$42432efe6614d3b4)(this, $05a29a0c5190aa73$var$_currentResult, {
        ...state,
        isPending: state.status === "pending",
        isSuccess: state.status === "success",
        isError: state.status === "error",
        isIdle: state.status === "idle",
        mutate: this.mutate,
        reset: this.reset
    });
};
$05a29a0c5190aa73$var$_notify = new WeakSet();
$05a29a0c5190aa73$var$notify_fn = function(action) {
    (0, $21dd3588127ff3f9$export$520687f44db6e1ab).batch(()=>{
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if ((0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $05a29a0c5190aa73$var$_mutateOptions) && this.hasListeners()) {
            const variables = (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $05a29a0c5190aa73$var$_currentResult).variables;
            const context = (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $05a29a0c5190aa73$var$_currentResult).context;
            if ((action == null ? void 0 : action.type) === "success") {
                (_b = (_a = (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $05a29a0c5190aa73$var$_mutateOptions)).onSuccess) == null || _b.call(_a, action.data, variables, context);
                (_d = (_c = (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $05a29a0c5190aa73$var$_mutateOptions)).onSettled) == null || _d.call(_c, action.data, null, variables, context);
            } else if ((action == null ? void 0 : action.type) === "error") {
                (_f = (_e = (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $05a29a0c5190aa73$var$_mutateOptions)).onError) == null || _f.call(_e, action.error, variables, context);
                (_h = (_g = (0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $05a29a0c5190aa73$var$_mutateOptions)).onSettled) == null || _h.call(_g, void 0, action.error, variables, context);
            }
        }
        this.listeners.forEach((listener)=>{
            listener((0, $82bb902b93e9fce2$export$18a094aefa070634)(this, $05a29a0c5190aa73$var$_currentResult));
        });
    });
};




"use client";
function $5429616d3a0ed2ac$export$609860bf8b0084c(options, queryClient) {
    const client = (0, $a0b182cf42560d7a$export$22e77b9572c4fded)(queryClient);
    const [observer] = $lBnVc.useState(()=>new (0, $05a29a0c5190aa73$export$d3c1860ee66f291a)(client, options));
    $lBnVc.useEffect(()=>{
        observer.setOptions(options);
    }, [
        observer,
        options
    ]);
    const result = $lBnVc.useSyncExternalStore($lBnVc.useCallback((onStoreChange)=>observer.subscribe((0, $21dd3588127ff3f9$export$520687f44db6e1ab).batchCalls(onStoreChange)), [
        observer
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    const mutate = $lBnVc.useCallback((variables, mutateOptions)=>{
        observer.mutate(variables, mutateOptions).catch((0, $d721e4b2cae94204$export$8793edee2d425525));
    }, [
        observer
    ]);
    if (result.error && (0, $d721e4b2cae94204$export$2072f68e6c3507cf)(observer.options.throwOnError, [
        result.error
    ])) throw result.error;
    return {
        ...result,
        mutate: mutate,
        mutateAsync: result.mutate
    };
}



var $lBnVc = parcelRequire("lBnVc");



var $lBnVc = parcelRequire("lBnVc");
function $f72d9b2e2a1bcdc2$export$2e2bcd8739ae039(name) {
    const [permissionState, setPermissionState] = (0, $lBnVc.useState)();
    (0, $6e4aba82666a9c9f$export$2e2bcd8739ae039)(()=>{
        navigator.permissions.query({
            name: name
        }).then(({ state: state })=>{
            if (state !== permissionState) setPermissionState(state);
        });
    }, 1e2);
    return permissionState;
}


const $26461bcbd7cfbf69$export$622c0bed7178abee = "Notifications permission denied";
function $26461bcbd7cfbf69$export$2e2bcd8739ae039() {
    const [token, setToken] = (0, $lBnVc.useState)();
    const [isLoading, setIsLoading] = (0, $lBnVc.useState)(false);
    const permissionState = (0, $f72d9b2e2a1bcdc2$export$2e2bcd8739ae039)("notifications");
    const [error, setError] = (0, $lBnVc.useState)();
    (0, $lBnVc.useEffect)(()=>{
        if (permissionState === "denied") return setError(Error($26461bcbd7cfbf69$export$622c0bed7178abee));
        if (error?.message === $26461bcbd7cfbf69$export$622c0bed7178abee) setError(undefined);
        if (error) return;
        if (permissionState === "granted") {
            setIsLoading(true);
            (0, $062e278e0d1dc91c$export$bd61301356cef08f)().then(setToken).catch(setError).finally(()=>setIsLoading(false));
        }
    }, [
        error,
        permissionState
    ]);
    return {
        error: error,
        isLoading: isLoading,
        token: token
    };
}






function $9296770459af7ce6$export$2e2bcd8739ae039() {
    const { data: data, isError: isError, isPending: isPending } = (0, $eb7b0471498e212c$export$dd0a697e1782aedd)({
        queryKey: [
            "web-push-tokens"
        ],
        queryFn: (0, $4b6cae14f235e72b$export$61804860a283679f)
    });
    const { error: tokenError, token: token, isLoading: isTokenLoading } = (0, $26461bcbd7cfbf69$export$2e2bcd8739ae039)();
    const [shouldPostToken, setShouldPostToken] = (0, $lBnVc.useState)(false);
    const isEnabled = Boolean(data?.tokens.find(({ token: t })=>t === token));
    const deleteMutation = (0, $5429616d3a0ed2ac$export$609860bf8b0084c)({
        mutationFn: (0, $4b6cae14f235e72b$export$c1f49bcfceb4a1f1),
        onSuccess: (_, token)=>{
            (0, $a14f18d5629de21e$export$7c07b633a151f9c5).setQueryData([
                "web-push-tokens"
            ], (data)=>({
                    tokens: data.tokens.filter((t)=>t.token !== token)
                }));
        }
    });
    const putMutation = (0, $5429616d3a0ed2ac$export$609860bf8b0084c)({
        mutationFn: (0, $4b6cae14f235e72b$export$249feca78be636fa),
        onSuccess: (tokenObject)=>{
            (0, $a14f18d5629de21e$export$7c07b633a151f9c5).setQueryData([
                "web-push-tokens"
            ], (data)=>({
                    tokens: data ? [
                        ...data.tokens,
                        tokenObject
                    ] : [
                        tokenObject
                    ]
                }));
        }
    });
    (0, $lBnVc.useEffect)(()=>{
        if (!shouldPostToken || !token) return;
        const createdAt = new Date().toISOString();
        const updatedAt = createdAt;
        putMutation.mutate({
            createdAt: createdAt,
            token: token,
            updatedAt: updatedAt
        });
        setShouldPostToken(false);
    }, [
        putMutation,
        shouldPostToken,
        token
    ]);
    let registrationTokenErrorMessage;
    if (tokenError) {
        if (tokenError.message === (0, $26461bcbd7cfbf69$export$622c0bed7178abee) || tokenError.message.includes("messaging/permission-blocked")) registrationTokenErrorMessage = "Notifications permission is disabled - you will not receive any notifications unless you enable it";
        else if (tokenError.message === "Registration failed - push service error") {
            registrationTokenErrorMessage = "Something went wrong, you may need to use a different browser or try again later";
            (0, $24a8d9ab78e4f062$export$f5282963edea4a68)(tokenError);
        } else {
            registrationTokenErrorMessage = "Something went wrong, please try again later";
            (0, $24a8d9ab78e4f062$export$f5282963edea4a68)(tokenError);
        }
    }
    const isSomethingLoading = isPending || isTokenLoading || deleteMutation.isPending || putMutation.isPending;
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("p", {
                children: "Opt in to receive daily push notifications that remind you to log your mood."
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("p", {
                children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("small", {
                    children: "You will need to set this up separately on each device you use MoodTracker on and your device will need an internet connection to receive push notifications."
                })
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $828cb8aa9adcb6a3$export$2e2bcd8739ae039), {
                checked: isEnabled,
                disabled: isSomethingLoading,
                error: registrationTokenErrorMessage ?? (putMutation.isError || isError ? (0, $5a123094476b33d7$export$4fd720569787ab6f).network : undefined),
                onChange: ()=>{
                    if (!token) {
                        Notification.requestPermission().then((permission)=>{
                            if (permission === "granted") setShouldPostToken(true);
                        });
                        return;
                    }
                    if (isEnabled) deleteMutation.mutate(token);
                    else setShouldPostToken(true);
                },
                label: isSomethingLoading ? /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("span", {
                    children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $b3bd040c14d4ce5c$export$2e2bcd8739ae039), {
                        inline: true
                    })
                }) : `Daily push notifications ${isEnabled ? "en" : "dis"}abled`
            })
        ]
    });
}








function $337c47d284902652$export$2e2bcd8739ae039() {
    const { data: data, isError: isError, isPending: isPending } = (0, $eb7b0471498e212c$export$dd0a697e1782aedd)({
        queryKey: [
            "weekly-emails"
        ],
        queryFn: (0, $4b6cae14f235e72b$export$99969dd9128fc316)
    });
    const mutation = (0, $5429616d3a0ed2ac$export$609860bf8b0084c)({
        mutationFn: (isEnabled)=>isEnabled ? (0, $4b6cae14f235e72b$export$707702ec84df61a9)() : (0, $4b6cae14f235e72b$export$f837c69388aad710)(),
        onSuccess: ()=>{
            (0, $a14f18d5629de21e$export$7c07b633a151f9c5).setQueryData([
                "weekly-emails"
            ], (isEnabled)=>!isEnabled);
        }
    });
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h3", {
                children: "Weekly email updates"
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("p", {
                children: "Opt in to receive an email update every Monday morning with your own personal weekly mood report."
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $828cb8aa9adcb6a3$export$2e2bcd8739ae039), {
                checked: Boolean(data),
                disabled: mutation.isPending || isPending,
                error: mutation.isError || isError ? (0, $5a123094476b33d7$export$4fd720569787ab6f).network : undefined,
                onChange: ()=>mutation.mutate(Boolean(data)),
                label: mutation.isPending || isPending ? /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("span", {
                    children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $b3bd040c14d4ce5c$export$2e2bcd8739ae039), {
                        inline: true
                    })
                }) : `Weekly email notifications ${data ? "en" : "dis"}abled`
            })
        ]
    });
}


function $2be2442199753677$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h3", {
                children: "Daily push notifications"
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $9296770459af7ce6$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $337c47d284902652$export$2e2bcd8739ae039), {})
        ]
    });
}



function $0df6bedbf9917577$export$2e2bcd8739ae039() {
    const navigate = (0, $f02d97b5ca509f34$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h2", {
                children: "Welcome to MoodTracker!"
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $2be2442199753677$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h3", {
                children: "Get started adding moods"
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039).Group, {
                children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039), {
                    onClick: ()=>navigate(`/add`),
                    type: "button",
                    children: "Add your first mood!"
                })
            })
        ]
    });
}



var $lBnVc = parcelRequire("lBnVc");

function $caf7aee3fc8a0ef0$export$2e2bcd8739ae039() {
    const navigate = (0, $f02d97b5ca509f34$export$9770f232ac06a008)();
    (0, $lBnVc.useEffect)(()=>navigate("/"));
    return null;
}




/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param value - The value to check
 *
 * @returns True if the given value is a date
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */ function $b3ee60d5274a32a6$export$871608497c498473(value) {
    return value instanceof Date || typeof value === "object" && Object.prototype.toString.call(value) === "[object Date]";
}
var // Fallback for modularized imports:
$b3ee60d5274a32a6$export$2e2bcd8739ae039 = $b3ee60d5274a32a6$export$871608497c498473;



function $2fda460e8da3ba47$export$1ea939691cdc45b8(date) {
    if (!(0, $b3ee60d5274a32a6$export$871608497c498473)(date) && typeof date !== "number") return false;
    const _date = (0, $48f2cd94c2808d74$export$e67a095c620b86fe)(date);
    return !isNaN(Number(_date));
}
var // Fallback for modularized imports:
$2fda460e8da3ba47$export$2e2bcd8739ae039 = $2fda460e8da3ba47$export$1ea939691cdc45b8;




function $978855b79bb42918$export$2e2bcd8739ae039({ addPeriod: addPeriod, Component: Component, adjustDate: adjustDate = (x)=>x, dateRegex: dateRegex = /^\d{4}-\d{2}-\d{2}$/ }) {
    return function WithStatsPage(props) {
        const { date: dateStr } = (0, $f02d97b5ca509f34$export$99eaa27ddbbb95ef)();
        const eventsHasLoadedFromServer = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.hasLoadedFromServer);
        const moods = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.normalizedMoods);
        if (!dateStr || !dateRegex.test(dateStr)) return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $caf7aee3fc8a0ef0$export$2e2bcd8739ae039), {});
        const date = adjustDate((0, $c2e94012e82e0308$export$27d3dd4acf9951a1)(dateStr));
        if (!(0, $2fda460e8da3ba47$export$1ea939691cdc45b8)(date)) return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $caf7aee3fc8a0ef0$export$2e2bcd8739ae039), {});
        if (!eventsHasLoadedFromServer) return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $b3bd040c14d4ce5c$export$2e2bcd8739ae039), {});
        if (!moods.allIds.length) return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039).Group, {
            children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $0df6bedbf9917577$export$2e2bcd8739ae039), {})
        });
        const firstMoodDate = new Date(moods.allIds[0]);
        const nextDate = addPeriod(date, 1);
        return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)(Component, {
            ...props,
            date: date,
            nextDate: nextDate,
            prevDate: addPeriod(date, -1),
            showNext: nextDate <= new Date(),
            showPrevious: date > firstMoodDate
        });
    };
}


const $0809f0a5d27d1f86$var$X_LABELS_COUNT = 7;
function $0809f0a5d27d1f86$var$Day({ date: date, nextDate: nextDate, prevDate: prevDate, showNext: showNext, showPrevious: showPrevious }) {
    const moodIdsByDate = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.moodIdsByDate);
    const moodIds = moodIdsByDate[(0, $c2e94012e82e0308$export$f3013bcc8d8645bd)(date)];
    const startOfWeekDate = (0, $f2ddddaabfe67186$export$42c81a444fbfb5d4)(date, (0, $06d17fa75ca1067f$export$34c88de16c0a2653));
    const xLabels = [];
    for(let i = 0; i < $0809f0a5d27d1f86$var$X_LABELS_COUNT; i++)xLabels.push((0, $06d17fa75ca1067f$export$47adaa677c311957).format((0, $63cf136474441a1f$export$4a4306ad4fa0e5e6)(date, Math.round(i * (0, $5a123094476b33d7$export$a9905336c0111a3a).hoursPerDay / ($0809f0a5d27d1f86$var$X_LABELS_COUNT - 1)))));
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039).Group, {
        children: [
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("h2", {
                        children: [
                            (0, $06d17fa75ca1067f$export$5b8f5fb13700b442).format(date),
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $19d86a636b501d10$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e94b7bcc277332d2$export$a6c7ac8248d6e38a), {
                                        to: `../../weeks/${(0, $c2e94012e82e0308$export$f3013bcc8d8645bd)(startOfWeekDate)}`,
                                        children: (0, $06d17fa75ca1067f$export$1143122ff5520ba9)(startOfWeekDate)
                                    }),
                                    " ",
                                    "|",
                                    " ",
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e94b7bcc277332d2$export$a6c7ac8248d6e38a), {
                                        to: `../../months/${(0, $c2e94012e82e0308$export$30a208a52f4a49de)(date)}`,
                                        children: (0, $06d17fa75ca1067f$export$4137bbc3ff26d570).format(date)
                                    }),
                                    " ",
                                    "|",
                                    " ",
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e94b7bcc277332d2$export$a6c7ac8248d6e38a), {
                                        to: `../../years/${(0, $c2e94012e82e0308$export$60b37fc597282c94)(date)}`,
                                        children: (0, $06d17fa75ca1067f$export$daf84c177a4aeca8).format(date)
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $0a48ec8918b8b79c$export$2e2bcd8739ae039), {
                        dateFrom: date,
                        dateTo: nextDate
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $cfc36dd95b79da04$export$2e2bcd8739ae039), {
                        children: [
                            showPrevious ? /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $e94b7bcc277332d2$export$a6c7ac8248d6e38a), {
                                to: `../${(0, $c2e94012e82e0308$export$f3013bcc8d8645bd)(prevDate)}`,
                                children: [
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                                        margin: "end",
                                        name: "left"
                                    }),
                                    "Previous day"
                                ]
                            }) : /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("span", {}),
                            showNext && /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $e94b7bcc277332d2$export$a6c7ac8248d6e38a), {
                                to: `../${(0, $c2e94012e82e0308$export$f3013bcc8d8645bd)(nextDate)}`,
                                children: [
                                    "Next day",
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                                        margin: "start",
                                        name: "right"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $8b7e9eb862378972$export$2e2bcd8739ae039), {
                dates: [
                    prevDate,
                    date,
                    nextDate
                ]
            }),
            moodIds && /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $997e05fd3f436e77$export$2e2bcd8739ae039), {
                dateFrom: date,
                dateTo: nextDate,
                xAxisTitle: "Time",
                xLabels: xLabels
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $1dc16ddda003912c$export$2e2bcd8739ae039), {
                dateFrom: date,
                dateTo: nextDate,
                xLabels: xLabels
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $d4bf939de7dd3627$export$2e2bcd8739ae039), {
                dateFrom: date,
                dateTo: nextDate
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $af798ee18e885c0a$export$2e2bcd8739ae039), {
                dateFrom: date,
                dateTo: nextDate,
                xLabels: xLabels
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $6813af323f7a9acb$export$2e2bcd8739ae039), {
                dateFrom: date,
                dateTo: nextDate
            }),
            moodIds ? /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h3", {
                        children: "Moods"
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $7c1560fa3a8ca778$export$2e2bcd8739ae039).Group, {
                        children: moodIds.map((id)=>/*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $793264348b86e468$export$2e2bcd8739ae039), {
                                id: id
                            }, id))
                    })
                ]
            }) : /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("p", {
                    children: "No mood data for this day."
                })
            })
        ]
    });
}
var $0809f0a5d27d1f86$export$2e2bcd8739ae039 = (0, $978855b79bb42918$export$2e2bcd8739ae039)({
    addPeriod: (0, $cb8fdbef2aba70f2$export$dd412b56f1e4d8aa),
    Component: $0809f0a5d27d1f86$var$Day
});








var $lBnVc = parcelRequire("lBnVc");





function $0292800c7a2d6a0b$export$2e2bcd8739ae039({ eventType: eventType, id: id, onClose: onClose, open: open }) {
    const navigate = (0, $f02d97b5ca509f34$export$9770f232ac06a008)();
    const dispatch = (0, $d3287b130d7b0f6b$export$8ad76b76a4c905f8)();
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $2b02ccd0ece868b7$export$2e2bcd8739ae039), {
        onClose: onClose,
        open: open,
        title: `Delete ${eventType}?`,
        children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039).Group, {
            children: [
                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039), {
                    danger: true,
                    onClick: ()=>{
                        dispatch((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).actions.add({
                            type: `v1/${eventType}s/delete`,
                            createdAt: new Date().toISOString(),
                            payload: id
                        }));
                        navigate(`/${eventType}/log`);
                    },
                    children: [
                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                            margin: "end",
                            name: "trash"
                        }),
                        "Delete"
                    ]
                }),
                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039), {
                    onClick: onClose,
                    variant: "secondary",
                    children: [
                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                            margin: "end",
                            name: "cross"
                        }),
                        "Cancel"
                    ]
                })
            ]
        })
    });
}







function $c2818189e6340410$export$2e2bcd8739ae039({ dateCreated: dateCreated, dateUpdated: dateUpdated }) {
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("p", {
        children: [
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("small", {
                children: [
                    "Created: ",
                    (0, $06d17fa75ca1067f$export$59113f23fb667b84).format(dateCreated),
                    " (",
                    (0, $82fe5d0003ae257e$export$d130c20a256f8817)(dateCreated),
                    " ago)"
                ]
            }),
            dateUpdated && /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("small", {
                        children: [
                            "Last updated: ",
                            (0, $06d17fa75ca1067f$export$59113f23fb667b84).format(dateUpdated),
                            " (",
                            (0, $82fe5d0003ae257e$export$d130c20a256f8817)(dateUpdated),
                            " ago)"
                        ]
                    })
                ]
            })
        ]
    });
}






function $9dc955b4ee15affb$export$2e2bcd8739ae039() {
    const navigate = (0, $f02d97b5ca509f34$export$9770f232ac06a008)();
    const darkMode = (0, $71f4b882ff6f87ec$export$2e2bcd8739ae039)();
    const dispatch = (0, $d3287b130d7b0f6b$export$8ad76b76a4c905f8)();
    const { id: id } = (0, $f02d97b5ca509f34$export$99eaa27ddbbb95ef)();
    const moods = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.normalizedMoods);
    const [isDialogOpen, setIsDialogOpen] = (0, $lBnVc.useState)(false);
    const [descriptionError, setDescriptionError] = (0, $lBnVc.useState)();
    const [showNoUpdateError, setShowNoUpdateError] = (0, $lBnVc.useState)(false);
    const formRef = (0, $lBnVc.useRef)(null);
    const handleSubmit = ()=>{
        const formEl = formRef.current;
        setShowNoUpdateError(false);
        const descriptionEl = formEl[(0, $5a123094476b33d7$export$e6909ad44e61103d).description.name];
        const descriptionValue = descriptionEl.value;
        const explorationValue = formEl[(0, $5a123094476b33d7$export$e6909ad44e61103d).exploration.name].value;
        const moodValue = formEl[(0, $5a123094476b33d7$export$e6909ad44e61103d).mood.name].value;
        const descriptionFieldError = descriptionEl.validity.patternMismatch;
        setDescriptionError(descriptionFieldError ? (0, $5a123094476b33d7$export$4fd720569787ab6f).specialCharacters : "");
        // There's some code further down that redirects the user
        // if `id` is not defined
        const payload = {
            id: id
        };
        let shouldUpdate = false;
        const moodValueNumber = Number(moodValue);
        if (moodValueNumber !== mood.mood) {
            payload.mood = moodValueNumber;
            shouldUpdate = true;
        }
        const trimmedDescriptionValue = descriptionValue.trim();
        if (trimmedDescriptionValue !== mood.description) {
            payload.description = trimmedDescriptionValue;
            shouldUpdate = true;
        }
        const trimmedExplorationValue = explorationValue.trim();
        if (trimmedExplorationValue !== mood.exploration) {
            payload.exploration = explorationValue.trim();
            shouldUpdate = true;
        }
        if (!shouldUpdate) return setShowNoUpdateError(true);
        dispatch((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).actions.add({
            type: "v1/moods/update",
            createdAt: new Date().toISOString(),
            payload: payload
        }));
        navigate("/");
    };
    (0, $a456cc3954118347$export$2e2bcd8739ae039)(handleSubmit);
    if (!id) return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $caf7aee3fc8a0ef0$export$2e2bcd8739ae039), {});
    const mood = moods.byId[id];
    if (!mood) return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $caf7aee3fc8a0ef0$export$2e2bcd8739ae039), {});
    const dateCreated = new Date(id);
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039).Group, {
        children: [
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h2", {
                        children: "Edit mood"
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $c2818189e6340410$export$2e2bcd8739ae039), {
                        dateCreated: dateCreated,
                        dateUpdated: mood.updatedAt ? new Date(mood.updatedAt) : undefined
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("form", {
                        noValidate: true,
                        onSubmit: (e)=>{
                            e.preventDefault();
                            handleSubmit();
                        },
                        ref: formRef,
                        children: [
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $bc720a2257db6cb9$export$2e2bcd8739ae039).Group, {
                                label: (0, $5a123094476b33d7$export$e6909ad44e61103d).mood.label,
                                children: [
                                    ...Array(11)
                                ].map((_, i)=>/*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $bc720a2257db6cb9$export$2e2bcd8739ae039), {
                                        color: darkMode ? (0, $c2e94012e82e0308$export$18b446c953569205)(i) : undefined,
                                        // There is old data where mood is a float between 0 and 10
                                        // We handle that by rounding for this input control
                                        defaultChecked: Math.round(mood.mood) === i,
                                        name: (0, $5a123094476b33d7$export$e6909ad44e61103d).mood.name,
                                        value: i,
                                        children: i
                                    }, i))
                            }),
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $78053ee2024d275e$export$2e2bcd8739ae039), {
                                ...(0, $5a123094476b33d7$export$e6909ad44e61103d).description,
                                defaultValue: mood.description,
                                error: descriptionError
                            }),
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $ac4ce26ce45bf909$export$2e2bcd8739ae039), {
                                ...(0, $5a123094476b33d7$export$e6909ad44e61103d).exploration,
                                defaultValue: mood.exploration
                            }),
                            showNoUpdateError && /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("p", {
                                className: "center negative",
                                children: (0, $5a123094476b33d7$export$4fd720569787ab6f).noChanges
                            }),
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039).Group, {
                                children: [
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                                                margin: "end",
                                                name: "save"
                                            }),
                                            "Save"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039), {
                                        danger: true,
                                        onClick: ()=>setIsDialogOpen(true),
                                        type: "button",
                                        children: [
                                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                                                margin: "end",
                                                name: "trash"
                                            }),
                                            "Delete"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039), {
                                        onClick: ()=>window.history.back(),
                                        type: "button",
                                        variant: "secondary",
                                        children: [
                                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                                                margin: "end",
                                                name: "left"
                                            }),
                                            "Back"
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $0292800c7a2d6a0b$export$2e2bcd8739ae039), {
                        eventType: "mood",
                        id: id,
                        onClose: ()=>setIsDialogOpen(false),
                        open: isDialogOpen
                    })
                ]
            }),
            mood.location && /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $f501a7e7c8c881cb$export$2e2bcd8739ae039), {
                date: dateCreated,
                ...mood.location
            })
        ]
    });
}








var $lBnVc = parcelRequire("lBnVc");






function $d4dbe8b90289f277$export$2e2bcd8739ae039() {
    const navigate = (0, $f02d97b5ca509f34$export$9770f232ac06a008)();
    const dispatch = (0, $d3287b130d7b0f6b$export$8ad76b76a4c905f8)();
    const [dateAwokeError, setDateAwokeError] = (0, $lBnVc.useState)();
    const { id: id } = (0, $f02d97b5ca509f34$export$99eaa27ddbbb95ef)();
    const sleeps = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.normalizedSleeps);
    const [isDialogOpen, setIsDialogOpen] = (0, $lBnVc.useState)(false);
    const [showNoUpdateError, setShowNoUpdateError] = (0, $lBnVc.useState)(false);
    const formRef = (0, $lBnVc.useRef)(null);
    const handleSubmit = ()=>{
        const formEl = formRef.current;
        setShowNoUpdateError(false);
        const hoursSleptEl = formEl[(0, $5a123094476b33d7$export$e6909ad44e61103d).hoursSlept.name];
        const minutesSleptEl = formEl[(0, $5a123094476b33d7$export$e6909ad44e61103d).minutesSlept.name];
        const dateAwokeEl = formEl[(0, $5a123094476b33d7$export$e6909ad44e61103d).dateAwoke.name];
        if (dateAwokeEl.validity.valueMissing) setDateAwokeError((0, $5a123094476b33d7$export$4fd720569787ab6f).required);
        else if (dateAwokeEl.validity.rangeOverflow) setDateAwokeError((0, $5a123094476b33d7$export$4fd720569787ab6f).rangeOverflow);
        else setDateAwokeError(undefined);
        if (!dateAwokeEl.validity.valid) return;
        const minutesSlept = Number(hoursSleptEl.value) * 60 + Number(minutesSleptEl.value);
        if (minutesSlept === sleep.minutesSlept && dateAwokeEl.value === sleep.dateAwoke) return setShowNoUpdateError(true);
        dispatch((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).actions.add({
            type: "v1/sleeps/update",
            createdAt: new Date().toISOString(),
            // The user is redirected if `id` is not defined
            payload: {
                dateAwoke: dateAwokeEl.value,
                id: id,
                minutesSlept: minutesSlept
            }
        }));
        navigate("/sleep/log");
    };
    (0, $a456cc3954118347$export$2e2bcd8739ae039)(handleSubmit);
    if (!id) return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $caf7aee3fc8a0ef0$export$2e2bcd8739ae039), {});
    const sleep = sleeps.byId[id];
    if (!sleep) return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $caf7aee3fc8a0ef0$export$2e2bcd8739ae039), {});
    const dateCreated = new Date(id);
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039).Group, {
        children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h2", {
                    children: "Edit sleep"
                }),
                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $c2818189e6340410$export$2e2bcd8739ae039), {
                    dateCreated: dateCreated,
                    dateUpdated: sleep.updatedAt ? new Date(sleep.updatedAt) : undefined
                }),
                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("form", {
                    noValidate: true,
                    onSubmit: (e)=>{
                        e.preventDefault();
                        handleSubmit();
                    },
                    ref: formRef,
                    children: [
                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("div", {
                            className: "m-interval-input",
                            children: [
                                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $9a780bd1b5aff71e$export$2e2bcd8739ae039), {
                                    ...(0, $5a123094476b33d7$export$e6909ad44e61103d).hoursSlept,
                                    defaultValue: Math.floor(sleep.minutesSlept / (0, $5a123094476b33d7$export$a9905336c0111a3a).minutesPerHour),
                                    children: [
                                        ...Array((0, $5a123094476b33d7$export$a9905336c0111a3a).hoursPerDay)
                                    ].map((_, i)=>/*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("option", {
                                            value: i,
                                            children: i
                                        }, i))
                                }),
                                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $9a780bd1b5aff71e$export$2e2bcd8739ae039), {
                                    ...(0, $5a123094476b33d7$export$e6909ad44e61103d).minutesSlept,
                                    defaultValue: sleep.minutesSlept % (0, $5a123094476b33d7$export$a9905336c0111a3a).minutesPerHour,
                                    children: [
                                        ...Array((0, $5a123094476b33d7$export$a9905336c0111a3a).minutesPerHour)
                                    ].map((_, i)=>/*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("option", {
                                            value: i,
                                            children: i
                                        }, i))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $78053ee2024d275e$export$2e2bcd8739ae039), {
                            ...(0, $5a123094476b33d7$export$e6909ad44e61103d).dateAwoke,
                            defaultValue: sleep.dateAwoke,
                            error: dateAwokeError,
                            max: (0, $c2e94012e82e0308$export$f3013bcc8d8645bd)(new Date())
                        }),
                        showNoUpdateError && /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("p", {
                            className: "center negative",
                            children: (0, $5a123094476b33d7$export$4fd720569787ab6f).noChanges
                        }),
                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039).Group, {
                            children: [
                                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039), {
                                    "data-test-id": (0, $5a123094476b33d7$export$a2b4f255152a6585).sleepAddSubmitButton,
                                    children: [
                                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                                            margin: "end",
                                            name: "save"
                                        }),
                                        "Save"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039), {
                                    danger: true,
                                    onClick: ()=>setIsDialogOpen(true),
                                    type: "button",
                                    children: [
                                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                                            margin: "end",
                                            name: "trash"
                                        }),
                                        "Delete"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039), {
                                    onClick: ()=>window.history.back(),
                                    type: "button",
                                    variant: "secondary",
                                    children: [
                                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                                            margin: "end",
                                            name: "left"
                                        }),
                                        "Back"
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $0292800c7a2d6a0b$export$2e2bcd8739ae039), {
                    eventType: "sleep",
                    id: id,
                    onClose: ()=>setIsDialogOpen(false),
                    open: isDialogOpen
                })
            ]
        })
    });
}








var $lBnVc = parcelRequire("lBnVc");






function $7bcabf5d27fcc661$export$2e2bcd8739ae039() {
    const navigate = (0, $f02d97b5ca509f34$export$9770f232ac06a008)();
    const dispatch = (0, $d3287b130d7b0f6b$export$8ad76b76a4c905f8)();
    const [error, setError] = (0, $lBnVc.useState)();
    const { id: id } = (0, $f02d97b5ca509f34$export$99eaa27ddbbb95ef)();
    const weights = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.normalizedWeights);
    const [isDialogOpen, setIsDialogOpen] = (0, $lBnVc.useState)(false);
    const [showNoUpdateError, setShowNoUpdateError] = (0, $lBnVc.useState)(false);
    const formRef = (0, $lBnVc.useRef)(null);
    const handleSubmit = ()=>{
        const formEl = formRef.current;
        setShowNoUpdateError(false);
        const inputEl = formEl[(0, $5a123094476b33d7$export$e6909ad44e61103d).weight.name];
        const { valueAsNumber: valueAsNumber } = inputEl;
        if (inputEl.validity.valueMissing) {
            setError((0, $5a123094476b33d7$export$4fd720569787ab6f).required);
            return;
        }
        if (inputEl.validity.rangeOverflow) {
            setError((0, $5a123094476b33d7$export$4fd720569787ab6f).rangeOverflow);
            return;
        }
        if (inputEl.validity.rangeUnderflow) {
            setError((0, $5a123094476b33d7$export$4fd720569787ab6f).rangeUnderflow);
            return;
        }
        if (valueAsNumber === weight.value) return setShowNoUpdateError(true);
        dispatch((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).actions.add({
            type: "v1/weights/update",
            createdAt: new Date().toISOString(),
            // The user is redirected if `id` is not defined
            payload: {
                id: id,
                value: valueAsNumber
            }
        }));
        navigate("/weight/log");
    };
    (0, $a456cc3954118347$export$2e2bcd8739ae039)(handleSubmit);
    if (!id) return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $caf7aee3fc8a0ef0$export$2e2bcd8739ae039), {});
    const weight = weights.byId[id];
    if (!weight) return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $caf7aee3fc8a0ef0$export$2e2bcd8739ae039), {});
    const dateCreated = new Date(id);
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039).Group, {
        children: [
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h2", {
                        children: "Edit weight"
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $c2818189e6340410$export$2e2bcd8739ae039), {
                        dateCreated: dateCreated,
                        dateUpdated: weight.updatedAt ? new Date(weight.updatedAt) : undefined
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("form", {
                        noValidate: true,
                        onSubmit: (e)=>{
                            e.preventDefault();
                            handleSubmit();
                        },
                        ref: formRef,
                        children: [
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $78053ee2024d275e$export$2e2bcd8739ae039), {
                                ...(0, $5a123094476b33d7$export$e6909ad44e61103d).weight,
                                defaultValue: weight.value,
                                error: error
                            }),
                            showNoUpdateError && /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("p", {
                                className: "center negative",
                                children: (0, $5a123094476b33d7$export$4fd720569787ab6f).noChanges
                            }),
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039).Group, {
                                children: [
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                                                margin: "end",
                                                name: "save"
                                            }),
                                            "Save"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039), {
                                        danger: true,
                                        onClick: ()=>setIsDialogOpen(true),
                                        type: "button",
                                        children: [
                                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                                                margin: "end",
                                                name: "trash"
                                            }),
                                            "Delete"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039), {
                                        onClick: ()=>window.history.back(),
                                        type: "button",
                                        variant: "secondary",
                                        children: [
                                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                                                margin: "end",
                                                name: "left"
                                            }),
                                            "Back"
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $0292800c7a2d6a0b$export$2e2bcd8739ae039), {
                        eventType: "weight",
                        id: id,
                        onClose: ()=>setIsDialogOpen(false),
                        open: isDialogOpen
                    })
                ]
            }),
            weight.location && /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $f501a7e7c8c881cb$export$2e2bcd8739ae039), {
                date: dateCreated,
                ...weight.location
            })
        ]
    });
}




var $9176f6782201571d$exports = {};
"use strict";
var $0b827c20e339e65b$exports = {};
"use strict";

$0b827c20e339e65b$exports = (parcelRequire("lQpid"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $9176f6782201571d$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $9176f6782201571d$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $9176f6782201571d$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $9176f6782201571d$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $9176f6782201571d$var$TYPE_STATICS = {};
$9176f6782201571d$var$TYPE_STATICS[$0b827c20e339e65b$exports.ForwardRef] = $9176f6782201571d$var$FORWARD_REF_STATICS;
$9176f6782201571d$var$TYPE_STATICS[$0b827c20e339e65b$exports.Memo] = $9176f6782201571d$var$MEMO_STATICS;
function $9176f6782201571d$var$getStatics(component) {
    // React v16.11 and below
    if ($0b827c20e339e65b$exports.isMemo(component)) return $9176f6782201571d$var$MEMO_STATICS;
     // React v16.12 and above
    return $9176f6782201571d$var$TYPE_STATICS[component["$$typeof"]] || $9176f6782201571d$var$REACT_STATICS;
}
var $9176f6782201571d$var$defineProperty = Object.defineProperty;
var $9176f6782201571d$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $9176f6782201571d$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $9176f6782201571d$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $9176f6782201571d$var$getPrototypeOf = Object.getPrototypeOf;
var $9176f6782201571d$var$objectPrototype = Object.prototype;
function $9176f6782201571d$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($9176f6782201571d$var$objectPrototype) {
            var inheritedComponent = $9176f6782201571d$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $9176f6782201571d$var$objectPrototype) $9176f6782201571d$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $9176f6782201571d$var$getOwnPropertyNames(sourceComponent);
        if ($9176f6782201571d$var$getOwnPropertySymbols) keys = keys.concat($9176f6782201571d$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $9176f6782201571d$var$getStatics(targetComponent);
        var sourceStatics = $9176f6782201571d$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$9176f6782201571d$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $9176f6782201571d$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $9176f6782201571d$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$9176f6782201571d$exports = $9176f6782201571d$var$hoistNonReactStatics;



var $lBnVc = parcelRequire("lBnVc");
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $bd0c506aa2ae8e6d$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;


const $e8739e675871d84e$var$_jsxFileName = "/home/runner/work/sentry-javascript/sentry-javascript/packages/react/src/errorboundary.tsx";
function $e8739e675871d84e$export$a87138b73900f5b(version) {
    const major = version.match(/^([^.]+)/);
    return major !== null && parseInt(major[0]) >= 17;
}
const $e8739e675871d84e$export$6ef4c0367e27f2d5 = "unknown";
const $e8739e675871d84e$var$INITIAL_STATE = {
    componentStack: null,
    error: null,
    eventId: null
};
function $e8739e675871d84e$var$setCause(error, cause) {
    const seenErrors = new WeakMap();
    function recurse(error, cause) {
        // If we've already seen the error, there is a recursive loop somewhere in the error's
        // cause chain. Let's just bail out then to prevent a stack overflow.
        if (seenErrors.has(error)) return;
        if (error.cause) {
            seenErrors.set(error, true);
            return recurse(error.cause, cause);
        }
        error.cause = cause;
    }
    recurse(error, cause);
}
/**
 * A ErrorBoundary component that logs errors to Sentry. Requires React >= 16.
 * NOTE: If you are a Sentry user, and you are seeing this stack frame, it means the
 * Sentry React SDK ErrorBoundary caught an error invoking your application code. This
 * is expected behavior and NOT indicative of a bug with the Sentry React SDK.
 */ class $e8739e675871d84e$export$e926676385687eaf extends $lBnVc.Component {
    constructor(props){
        super(props);
        $e8739e675871d84e$export$e926676385687eaf.prototype.__init.call(this);
        this.state = $e8739e675871d84e$var$INITIAL_STATE;
        this._openFallbackReportDialog = true;
        const client = (0, $3bf2cc17570e59fe$export$6bb76d6eba7e258c)();
        if (client && client.on && props.showDialog) {
            this._openFallbackReportDialog = false;
            client.on("afterSendEvent", (event)=>{
                if (!event.type && event.event_id === this._lastEventId) // eslint-disable-next-line deprecation/deprecation
                (0, $a680f7f2ea4c1359$export$3a8fd680da42627b)({
                    ...props.dialogOptions,
                    eventId: this._lastEventId
                });
            });
        }
    }
    componentDidCatch(error, { componentStack: componentStack }) {
        const { beforeCapture: beforeCapture, onError: onError, showDialog: showDialog, dialogOptions: dialogOptions } = this.props;
        (0, $3bf2cc17570e59fe$export$ec58d9285c204497)((scope)=>{
            // If on React version >= 17, create stack trace from componentStack param and links
            // to to the original error using `error.cause` otherwise relies on error param for stacktrace.
            // Linking errors requires the `LinkedErrors` integration be enabled.
            // See: https://reactjs.org/blog/2020/08/10/react-v17-rc.html#native-component-stacks
            //
            // Although `componentDidCatch` is typed to accept an `Error` object, it can also be invoked
            // with non-error objects. This is why we need to check if the error is an error-like object.
            // See: https://github.com/getsentry/sentry-javascript/issues/6167
            if ($e8739e675871d84e$export$a87138b73900f5b($lBnVc.version) && (0, $9cb15bc4eaa635db$export$e6127cc7fe7395c3)(error)) {
                const errorBoundaryError = new Error(error.message);
                errorBoundaryError.name = `React ErrorBoundary ${error.name}`;
                errorBoundaryError.stack = componentStack;
                // Using the `LinkedErrors` integration to link the errors together.
                $e8739e675871d84e$var$setCause(error, errorBoundaryError);
            }
            if (beforeCapture) beforeCapture(scope, error, componentStack);
            const eventId = (0, $3bf2cc17570e59fe$export$f5282963edea4a68)(error, {
                captureContext: {
                    contexts: {
                        react: {
                            componentStack: componentStack
                        }
                    }
                },
                // If users provide a fallback component we can assume they are handling the error.
                // Therefore, we set the mechanism depending on the presence of the fallback prop.
                mechanism: {
                    handled: !!this.props.fallback
                }
            });
            if (onError) onError(error, componentStack, eventId);
            if (showDialog) {
                this._lastEventId = eventId;
                if (this._openFallbackReportDialog) (0, $a680f7f2ea4c1359$export$3a8fd680da42627b)({
                    ...dialogOptions,
                    eventId: eventId
                });
            }
            // componentDidCatch is used over getDerivedStateFromError
            // so that componentStack is accessible through state.
            this.setState({
                error: error,
                componentStack: componentStack,
                eventId: eventId
            });
        });
    }
    componentDidMount() {
        const { onMount: onMount } = this.props;
        if (onMount) onMount();
    }
    componentWillUnmount() {
        const { error: error, componentStack: componentStack, eventId: eventId } = this.state;
        const { onUnmount: onUnmount } = this.props;
        if (onUnmount) onUnmount(error, componentStack, eventId);
    }
    __init() {
        this.resetErrorBoundary = ()=>{
            const { onReset: onReset } = this.props;
            const { error: error, componentStack: componentStack, eventId: eventId } = this.state;
            if (onReset) onReset(error, componentStack, eventId);
            this.setState($e8739e675871d84e$var$INITIAL_STATE);
        };
    }
    render() {
        const { fallback: fallback, children: children } = this.props;
        const state = this.state;
        if (state.error) {
            let element = undefined;
            if (typeof fallback === "function") element = fallback({
                error: state.error,
                componentStack: state.componentStack,
                resetError: this.resetErrorBoundary,
                eventId: state.eventId
            });
            else element = fallback;
            if ($lBnVc.isValidElement(element)) return element;
            if (fallback) (0, $bd0c506aa2ae8e6d$export$16a28057038b10ef) && (0, $fa35a81632814438$export$af88d00dbe7f521).warn("fallback did not produce a valid ReactElement");
            // Fail gracefully if no fallback provided or is not valid
            return null;
        }
        if (typeof children === "function") return children();
        return children;
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $e8739e675871d84e$export$f0c7a449e0cfaec7(WrappedComponent, errorBoundaryOptions) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const componentDisplayName = WrappedComponent.displayName || WrappedComponent.name || $e8739e675871d84e$export$6ef4c0367e27f2d5;
    const Wrapped = (props)=>$lBnVc.createElement($e8739e675871d84e$export$e926676385687eaf, {
            ...errorBoundaryOptions,
            __self: this,
            __source: {
                fileName: $e8739e675871d84e$var$_jsxFileName,
                lineNumber: 240
            }
        }, $lBnVc.createElement(WrappedComponent, {
            ...props,
            __self: this,
            __source: {
                fileName: $e8739e675871d84e$var$_jsxFileName,
                lineNumber: 241
            }
        }));
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    Wrapped.displayName = `errorBoundary(${componentDisplayName})`;
    // Copy over static methods from Wrapped component to Profiler HOC
    // See: https://reactjs.org/docs/higher-order-components.html#static-methods-must-be-copied-over
    (0, (/*@__PURE__*/$parcel$interopDefault($9176f6782201571d$exports)))(Wrapped, WrappedComponent);
    return Wrapped;
}






function $cda1e781cae58ae8$export$63fa379ae8a9ba2(date) {
    const _date = (0, $48f2cd94c2808d74$export$e67a095c620b86fe)(date);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$cda1e781cae58ae8$export$2e2bcd8739ae039 = $cda1e781cae58ae8$export$63fa379ae8a9ba2;



function $63c81b3d951f3f78$export$4a02e9c37dab4871(dateLeft, dateRight) {
    const startOfDayLeft = (0, $cda1e781cae58ae8$export$63fa379ae8a9ba2)(dateLeft);
    const startOfDayRight = (0, $cda1e781cae58ae8$export$63fa379ae8a9ba2)(dateRight);
    const timestampLeft = +startOfDayLeft - (0, $d2dedf999d199de7$export$113002b5eff6e430)(startOfDayLeft);
    const timestampRight = +startOfDayRight - (0, $d2dedf999d199de7$export$113002b5eff6e430)(startOfDayRight);
    // Round the number of days to the nearest integer because the number of
    // milliseconds in a day is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((timestampLeft - timestampRight) / (0, $cb8083d8e93c1630$export$b76b1809a2898f9a));
}
var // Fallback for modularized imports:
$63c81b3d951f3f78$export$2e2bcd8739ae039 = $63c81b3d951f3f78$export$4a02e9c37dab4871;



function $e112f865c9c9912f$export$86415ebf4eb36b8c(dateLeft, dateRight) {
    const _dateLeft = (0, $48f2cd94c2808d74$export$e67a095c620b86fe)(dateLeft);
    const _dateRight = (0, $48f2cd94c2808d74$export$e67a095c620b86fe)(dateRight);
    const sign = $e112f865c9c9912f$var$compareLocalAsc(_dateLeft, _dateRight);
    const difference = Math.abs((0, $63c81b3d951f3f78$export$4a02e9c37dab4871)(_dateLeft, _dateRight));
    _dateLeft.setDate(_dateLeft.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    const isLastDayNotFull = Number($e112f865c9c9912f$var$compareLocalAsc(_dateLeft, _dateRight) === -sign);
    const result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}
// Like `compareAsc` but uses local time not UTC, which is needed
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function $e112f865c9c9912f$var$compareLocalAsc(dateLeft, dateRight) {
    const diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}
var // Fallback for modularized imports:
$e112f865c9c9912f$export$2e2bcd8739ae039 = $e112f865c9c9912f$export$86415ebf4eb36b8c;


function $58b603c9eda836d4$export$70823084e2deb1ea(date, amount) {
    return (0, $cb8fdbef2aba70f2$export$dd412b56f1e4d8aa)(date, -amount);
}
var // Fallback for modularized imports:
$58b603c9eda836d4$export$2e2bcd8739ae039 = $58b603c9eda836d4$export$70823084e2deb1ea;









function $468d5739b3a923e8$export$2e2bcd8739ae039({ dateFrom: dateFrom, dateTo: dateTo, setDateFrom: setDateFrom, setDateTo: setDateTo }) {
    const moods = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.normalizedMoods);
    const maxDate = (0, $c2e94012e82e0308$export$4b61d8bc5e82982b)(new Date());
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $3c22e17838f9d676$export$2e2bcd8739ae039), {
                label: "From",
                max: (0, $c2e94012e82e0308$export$f3013bcc8d8645bd)((0, $58b603c9eda836d4$export$70823084e2deb1ea)(dateTo, 1)),
                min: (0, $c2e94012e82e0308$export$f3013bcc8d8645bd)(new Date(moods.allIds[0])),
                onChange: (e)=>{
                    let { valueAsDate: date } = e.target;
                    if (!date) return;
                    const timezoneOffset = date.getTimezoneOffset();
                    if (timezoneOffset) date = (0, $0d7c68eafc4da62b$export$2287e3d29250119e)(date, date.getTimezoneOffset());
                    if (date < (0, $c2e94012e82e0308$export$cba7498d83c2e2d)(dateTo) && date >= (0, $c2e94012e82e0308$export$cba7498d83c2e2d)(new Date(moods.allIds[0]))) setDateFrom(date);
                },
                value: (0, $c2e94012e82e0308$export$f3013bcc8d8645bd)(dateFrom)
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $3c22e17838f9d676$export$2e2bcd8739ae039), {
                label: "To",
                max: (0, $c2e94012e82e0308$export$f3013bcc8d8645bd)(maxDate),
                min: (0, $c2e94012e82e0308$export$f3013bcc8d8645bd)(dateFrom),
                onChange: (e)=>{
                    let { valueAsDate: date } = e.target;
                    if (!date) return;
                    const timezoneOffset = date.getTimezoneOffset();
                    if (timezoneOffset) date = (0, $0d7c68eafc4da62b$export$2287e3d29250119e)(date, date.getTimezoneOffset());
                    if (date >= dateFrom && date <= maxDate) setDateTo(date);
                },
                value: (0, $c2e94012e82e0308$export$f3013bcc8d8645bd)(dateTo)
            })
        ]
    });
}










function $65f7bea3ab7355a2$export$73d1c15a21f9fae5(date, amount) {
    return (0, $857e6f903d884172$export$17c93e242b2d3a22)(date, -amount);
}
var // Fallback for modularized imports:
$65f7bea3ab7355a2$export$2e2bcd8739ae039 = $65f7bea3ab7355a2$export$73d1c15a21f9fae5;



function $4a07f79fd18a3a1a$export$f93b5905241a7cca(date, duration) {
    const { years: years = 0, months: months = 0, weeks: weeks = 0, days: days = 0, hours: hours = 0, minutes: minutes = 0, seconds: seconds = 0 } = duration;
    // Subtract years and months
    const dateWithoutMonths = (0, $65f7bea3ab7355a2$export$73d1c15a21f9fae5)(date, months + years * 12);
    // Subtract weeks and days
    const dateWithoutDays = (0, $58b603c9eda836d4$export$70823084e2deb1ea)(dateWithoutMonths, days + weeks * 7);
    // Subtract hours, minutes and seconds
    const minutestoSub = minutes + hours * 60;
    const secondstoSub = seconds + minutestoSub * 60;
    const mstoSub = secondstoSub * 1000;
    const finalDate = (0, $ee5e01283bb626d4$export$ead8a1812b171991)(date, dateWithoutDays.getTime() - mstoSub);
    return finalDate;
}
var // Fallback for modularized imports:
$4a07f79fd18a3a1a$export$2e2bcd8739ae039 = $4a07f79fd18a3a1a$export$f93b5905241a7cca;






var $lBnVc = parcelRequire("lBnVc");
const $d03f855c67127c85$var$MEDITATION_STATS_HOURS_RANGE = 4;
const $d03f855c67127c85$var$SECONDS = $d03f855c67127c85$var$MEDITATION_STATS_HOURS_RANGE * (0, $5a123094476b33d7$export$a9905336c0111a3a).secondsPerHour;
function $d03f855c67127c85$export$2e2bcd8739ae039({ dateFrom: dateFrom, dateTo: dateTo }) {
    const meditations = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.normalizedMeditations);
    const moods = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.normalizedMoods);
    const [shouldRemoveSharedWords, setShouldRemoveSharedWords] = (0, $lBnVc.useState)(true);
    const meditationIdsInPeriod = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((state)=>(0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.meditationIdsInPeriod(state, dateFrom, dateTo));
    if (!meditationIdsInPeriod.length || !moods.allIds.length) return;
    const moodChanges = [];
    let wordsBeforeList = [];
    let wordsAfterList = [];
    let i = 0;
    for (const meditationId of meditationIdsInPeriod)for(; i < moods.allIds.length; i++){
        const moodAfterId = moods.allIds[i];
        if (moodAfterId < meditationId || i === 0) continue;
        const moodBeforeId = moods.allIds[i - 1];
        const moodBefore = moods.byId[moodBeforeId];
        const moodAfter = moods.byId[moodAfterId];
        const meditationLogDate = new Date(meditationId);
        const meditationStartDate = (0, $4a07f79fd18a3a1a$export$f93b5905241a7cca)(meditationLogDate, {
            seconds: meditations.byId[meditationId].seconds
        });
        // We use differenceInSeconds instead of differenceInHours as the latter
        // rounds values down (i.e. a 4.4 hour difference is returned as 4 hours).
        const differenceBefore = (0, $24a4af32485acd32$export$c1889aec51783710)(meditationStartDate, new Date(moodBeforeId));
        const differenceAfter = (0, $24a4af32485acd32$export$c1889aec51783710)(new Date(moodAfterId), meditationLogDate);
        if (differenceBefore > $d03f855c67127c85$var$SECONDS || differenceAfter > $d03f855c67127c85$var$SECONDS) break;
        moodChanges.push(moodAfter.mood - moodBefore.mood);
        if (moodBefore.description) wordsBeforeList = wordsBeforeList.concat((0, $c2e94012e82e0308$export$d7e7e8e9e6ba5acd)(moodBefore.description));
        if (moodAfter.description) wordsAfterList = wordsAfterList.concat((0, $c2e94012e82e0308$export$d7e7e8e9e6ba5acd)(moodAfter.description));
        break;
    }
    if (!moodChanges.length) return;
    const averageMoodChangeAfterMeditation = (0, $c2e94012e82e0308$export$772b647faa1a81e0)(moodChanges);
    const wordsAfter = (0, $c2e94012e82e0308$export$e575061ef2a070eb)(wordsAfterList);
    const wordsBefore = (0, $c2e94012e82e0308$export$e575061ef2a070eb)(wordsBeforeList);
    const filteredWordsAfter = {
        ...wordsAfter
    };
    const filteredWordsBefore = {
        ...wordsBefore
    };
    for (const word of new Set(wordsBeforeList)){
        if (!Object.hasOwn(wordsAfter, word)) continue;
        const afterCount = wordsAfter[word];
        const beforeCount = wordsBefore[word];
        if (afterCount === beforeCount) {
            delete filteredWordsAfter[word];
            delete filteredWordsBefore[word];
            continue;
        }
        const lowestCount = Math.min(afterCount, beforeCount);
        if (afterCount === lowestCount) {
            delete filteredWordsAfter[word];
            filteredWordsBefore[word] -= lowestCount;
        }
        if (beforeCount === lowestCount) {
            delete filteredWordsBefore[word];
            filteredWordsAfter[word] -= lowestCount;
        }
    }
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("h3", {
                children: [
                    "Meditation impact",
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $19d86a636b501d10$export$2e2bcd8739ae039), {
                        children: [
                            "Based on ",
                            meditationIdsInPeriod.length,
                            " meditation",
                            meditationIdsInPeriod.length === 1 ? "" : "s"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("p", {
                children: Math.abs(Math.round(averageMoodChangeAfterMeditation * 10)) === 0 ? /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $c0c9bc5c50648c54$exports.Fragment), {
                    children: "On average meditation has not made much impact on your mood."
                }) : /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
                    children: [
                        "On average the mood you recorded after meditation was",
                        " ",
                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("b", {
                            children: [
                                (0, $035f270eea0b2c1d$export$da6f4123477e5931).format(Math.abs(averageMoodChangeAfterMeditation)),
                                " ",
                                averageMoodChangeAfterMeditation > 0 ? "higher" : "lower"
                            ]
                        }),
                        " ",
                        "than the mood you recorded before."
                    ]
                })
            }),
            Object.keys(filteredWordsAfter).length >= (0, $5a123094476b33d7$export$9659e0d912e2b51e) && Object.keys(filteredWordsBefore).length >= (0, $5a123094476b33d7$export$9659e0d912e2b51e) && /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h4", {
                        children: "Mood clouds"
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $828cb8aa9adcb6a3$export$2e2bcd8739ae039), {
                        checked: shouldRemoveSharedWords,
                        label: "Filter out moods that are shared between both clouds",
                        onChange: ()=>setShouldRemoveSharedWords(!shouldRemoveSharedWords)
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h5", {
                        children: "Before meditation"
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $59fee832cccbdf29$export$2e2bcd8739ae039), {
                        "aria-label": "Word cloud displaying mood descriptions before meditation",
                        words: shouldRemoveSharedWords ? filteredWordsBefore : wordsBefore
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h5", {
                        children: "After meditation"
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $59fee832cccbdf29$export$2e2bcd8739ae039), {
                        "aria-label": "Word cloud displaying mood descriptions after meditation",
                        words: shouldRemoveSharedWords ? filteredWordsAfter : wordsAfter
                    })
                ]
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h4", {
                children: "Method"
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("p", {
                children: [
                    "Only moods that are recorded up to ",
                    $d03f855c67127c85$var$MEDITATION_STATS_HOURS_RANGE,
                    " hours before meditation and up to ",
                    $d03f855c67127c85$var$MEDITATION_STATS_HOURS_RANGE,
                    " hours after are counted."
                ]
            })
        ]
    });
}









function $1313f9fd0d49e561$export$f86b797a4659b781(date, hours) {
    const _date = (0, $48f2cd94c2808d74$export$e67a095c620b86fe)(date);
    _date.setHours(hours);
    return _date;
}
var // Fallback for modularized imports:
$1313f9fd0d49e561$export$2e2bcd8739ae039 = $1313f9fd0d49e561$export$f86b797a4659b781;


const $f8fd573a29046e26$var$arbitraryDate = new Date();
function $f8fd573a29046e26$export$2e2bcd8739ae039({ data: data }) {
    const xLabels = [];
    for(let i = 0; i <= (0, $5a123094476b33d7$export$a9905336c0111a3a).hoursPerDay; i += 4)xLabels.push((0, $06d17fa75ca1067f$export$47adaa677c311957).format((0, $1313f9fd0d49e561$export$f86b797a4659b781)($f8fd573a29046e26$var$arbitraryDate, i)));
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $2ae3cd0ef43ccc32$export$2e2bcd8739ae039).LineChart, {
        "aria-label": "Chart displaying average mood against hour of the day",
        domain: [
            0,
            (0, $5a123094476b33d7$export$a9905336c0111a3a).hoursPerDay - 1
        ],
        range: (0, $5a123094476b33d7$export$83043d74884e8814),
        xAxisTitle: "Hour of day",
        yAxisTitle: "Mood",
        xAxisLabels: xLabels,
        yAxisLabels: (0, $5a123094476b33d7$export$88df5ff28be7bede).map(String),
        children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $2ae3cd0ef43ccc32$export$2e2bcd8739ae039).Line, {
            data: data,
            thickness: 2
        })
    });
}







function $f1356ddf9998b04f$export$2e2bcd8739ae039({ dateFrom: dateFrom, dateTo: dateTo }) {
    const meanMoodByHour = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.meanMoodsByHour);
    const moodsByHourIndex = [
        ...Array((0, $5a123094476b33d7$export$a9905336c0111a3a).daysPerWeek)
    ];
    for(let t0 = dateFrom; t0 < dateTo; t0 = (0, $63cf136474441a1f$export$4a4306ad4fa0e5e6)(t0, 1)){
        const mood = meanMoodByHour[(0, $c2e94012e82e0308$export$5de6434cc589fc5b)(t0)];
        if (mood === undefined) continue;
        const hourIndex = t0.getHours(); //
        const moodsForHour = moodsByHourIndex[hourIndex];
        if (moodsForHour) moodsForHour.push(mood);
        else moodsByHourIndex[hourIndex] = [
            mood
        ];
    }
    const averages = [];
    for(let i = 0; i < moodsByHourIndex.length; i++){
        const moods = moodsByHourIndex[i];
        if (!moods) continue;
        const mean = (0, $c2e94012e82e0308$export$a8616ca67e2741ea)(moods);
        if (!mean) continue;
        averages.push([
            i,
            mean
        ]);
    }
    if (averages.length < 2) return;
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h3", {
                children: "Average mood by hour"
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $f8fd573a29046e26$export$2e2bcd8739ae039), {
                data: averages
            })
        ]
    });
}









function $a67d76e60b66d2ca$export$2e2bcd8739ae039({ dateFrom: dateFrom, dateTo: dateTo }) {
    const meanMoodsByDay = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.meanMoodsByDay);
    const minutesSleptByDateAwoke = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.minutesSleptByDateAwoke);
    const minutesSleptKeys = (0, $c2e94012e82e0308$export$3a3d91da857d6da2)(Object.keys(minutesSleptByDateAwoke), dateFrom, dateTo);
    const meanMoodsKeys = (0, $c2e94012e82e0308$export$3a3d91da857d6da2)(Object.keys(meanMoodsByDay), dateFrom, dateTo);
    if (minutesSleptKeys.length < 2 || meanMoodsKeys.length < 2) return;
    const meanMoodsKeysSet = new Set(meanMoodsKeys);
    const intersectingKeys = minutesSleptKeys.filter((key)=>meanMoodsKeysSet.has(key));
    if (intersectingKeys.length < 5) return;
    const points = intersectingKeys.map((key)=>{
        const y = meanMoodsByDay[key];
        return {
            color: (0, $c2e94012e82e0308$export$18b446c953569205)(y),
            x: minutesSleptByDateAwoke[key] / 60,
            y: y
        };
    });
    const ysByX = (0, $c2e94012e82e0308$export$5563593ccbfe9912)(()=>[]);
    // Round to nearest 4 for a resolution of 15 minutes
    for (const { x: x, y: y } of points)ysByX[Math.round(x * 4) / 4].push(y);
    const linePoints = Object.keys(ysByX).map((x)=>({
            x: Number(x),
            y: (0, $c2e94012e82e0308$export$772b647faa1a81e0)(ysByX[x])
        }));
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h3", {
                children: "Average mood by time slept"
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $2ae3cd0ef43ccc32$export$2e2bcd8739ae039).LineChart, {
                "aria-label": "Chart displaying mood against time slept",
                domain: [
                    0,
                    Math.ceil(Math.max(...points.map(({ x: x })=>x)) / 5) * 5
                ],
                points: points,
                range: (0, $5a123094476b33d7$export$83043d74884e8814),
                xAxisTitle: "Hours slept",
                yAxisLabels: (0, $5a123094476b33d7$export$88df5ff28be7bede).map(String),
                yAxisTitle: "Mood",
                children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $2ae3cd0ef43ccc32$export$2e2bcd8739ae039).Line, {
                    thickness: 2,
                    data: linePoints.map(({ x: x, y: y })=>[
                            x,
                            y
                        ]).sort(([a], [b])=>a - b)
                })
            })
        ]
    });
}










function $15cd8902503c53d5$export$2e2bcd8739ae039({ averages: averages, onClick: onClick }) {
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $2ae3cd0ef43ccc32$export$2e2bcd8739ae039).ColumnChart, {
        "aria-label": "Chart displaying average mood by weekday",
        data: averages.map(([day, averageMood], i)=>({
                color: averageMood === undefined ? undefined : (0, $c2e94012e82e0308$export$18b446c953569205)(averageMood),
                key: day,
                label: day,
                onClick: onClick && (()=>onClick(i)),
                title: averageMood === undefined ? undefined : `Average mood: ${(0, $035f270eea0b2c1d$export$da6f4123477e5931).format(averageMood)}`,
                y: averageMood
            })),
        maxRange: (0, $5a123094476b33d7$export$1c4e9440df4662e4),
        rotateXLabels: true,
        xAxisTitle: "Weekday",
        yAxisTitle: "Average mood"
    });
}







function $645d8a5fcb813cb9$export$2e2bcd8739ae039({ canDrillDown: canDrillDown, dateFrom: dateFrom, dateTo: dateTo }) {
    const meanMoodByDay = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.meanMoodsByDay);
    const navigate = (0, $f02d97b5ca509f34$export$9770f232ac06a008)();
    const moodsByWeekdayIndex = [
        ...Array((0, $5a123094476b33d7$export$a9905336c0111a3a).daysPerWeek)
    ];
    const dateStrings = [];
    for(let t0 = dateFrom; t0 < dateTo; t0 = (0, $cb8fdbef2aba70f2$export$dd412b56f1e4d8aa)(t0, 1)){
        const dateString = (0, $c2e94012e82e0308$export$f3013bcc8d8645bd)(t0);
        dateStrings.push(dateString);
        const mood = meanMoodByDay[dateString];
        if (mood === undefined) continue;
        const weekdayIndex = (0, $c2e94012e82e0308$export$e8da94055c5ae2c4)(t0);
        const moodsForWeekday = moodsByWeekdayIndex[weekdayIndex];
        if (moodsForWeekday) moodsForWeekday.push(mood);
        else moodsByWeekdayIndex[weekdayIndex] = [
            mood
        ];
    }
    const averages = moodsByWeekdayIndex.map((moodsForWeekday, i)=>[
            (0, $5a123094476b33d7$export$6d6c4805e4b04e86)[i],
            moodsForWeekday && (0, $c2e94012e82e0308$export$a8616ca67e2741ea)(moodsForWeekday)
        ]);
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h3", {
                children: "Average mood by weekday"
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $15cd8902503c53d5$export$2e2bcd8739ae039), {
                averages: averages,
                onClick: canDrillDown ? (i)=>navigate(`/stats/days/${dateStrings[i]}`) : undefined
            })
        ]
    });
}








function $20457d8f726e9b74$export$2e2bcd8739ae039({ dateFrom: dateFrom, dateTo: dateTo }) {
    const words = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((state)=>(0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.moodCloudWords(state, dateFrom, dateTo));
    if (!words || Object.keys(words).length < (0, $5a123094476b33d7$export$9659e0d912e2b51e)) return;
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("h3", {
                children: [
                    "Mood cloud",
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $19d86a636b501d10$export$2e2bcd8739ae039), {
                        children: "Created from the mood tags you record"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $59fee832cccbdf29$export$2e2bcd8739ae039), {
                "aria-label": "Word cloud displaying mood descriptions",
                words: words
            })
        ]
    });
}








function $ed295c5d011b3f58$export$2e2bcd8739ae039({ data: data }) {
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $2ae3cd0ef43ccc32$export$2e2bcd8739ae039).ColumnChart, {
        "aria-label": "Chart displaying the frequency at which different moods were recorded",
        data: data.map((count, i)=>({
                color: (0, $c2e94012e82e0308$export$18b446c953569205)(i),
                key: i,
                label: String(i),
                title: `Count: ${(0, $035f270eea0b2c1d$export$7774341304efafa2).format(count)}`,
                y: count
            })),
        xAxisTitle: "Mood",
        yAxisTitle: "Count"
    });
}





function $3b3050146274ca05$export$2e2bcd8739ae039({ dateFrom: dateFrom, dateTo: dateTo }) {
    const moodsInPeriod = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((state)=>(0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.moodsInPeriod(state, dateFrom, dateTo));
    if (!moodsInPeriod.length) return null;
    const moodCounter = new Map((0, $5a123094476b33d7$export$88df5ff28be7bede).map((n)=>[
            (0, $5a123094476b33d7$export$83043d74884e8814)[0] + n,
            0
        ]));
    for (const { mood: mood } of moodsInPeriod){
        // handle old data stored in decimal format
        const rounded = Math.round(mood);
        moodCounter.set(rounded, moodCounter.get(rounded) + 1);
    }
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h3", {
                children: "Mood frequency"
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $ed295c5d011b3f58$export$2e2bcd8739ae039), {
                data: [
                    ...moodCounter.values()
                ]
            })
        ]
    });
}









function $9ecf75b1b7e1bf61$export$2e2bcd8739ae039({ dateFrom: dateFrom, dateTo: dateTo }) {
    const moodValues = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((state)=>(0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.moodsInPeriod(state, dateFrom, dateTo)).map(({ mood: mood })=>mood);
    const meanSleep = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((state)=>(0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.meanDailySleepDurationInPeriod(state, dateFrom, dateTo));
    const meanWeight = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((state)=>(0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.meanWeightInPeriod(state, dateFrom, dateTo));
    const secondsMeditated = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((state)=>(0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.secondsMeditatedInPeriod(state, dateFrom, dateTo));
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h3", {
                children: "Summary"
            }),
            !moodValues.length && !moodValues.length && meanWeight === undefined && /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("p", {
                children: "No data for the selected period"
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $7791941d724bc7e1$export$2e2bcd8739ae039), {
                currentPeriod: {
                    best: moodValues.length ? Math.max(...moodValues) : undefined,
                    mean: (0, $c2e94012e82e0308$export$a8616ca67e2741ea)(moodValues),
                    meanWeight: meanWeight,
                    meanSleep: meanSleep,
                    secondsMeditated: secondsMeditated,
                    standardDeviation: (0, $c2e94012e82e0308$export$4683e466d9b5386c)(moodValues),
                    total: moodValues.length,
                    worst: moodValues.length ? Math.min(...moodValues) : undefined
                }
            })
        ]
    });
}








var $lBnVc = parcelRequire("lBnVc");

const $feb55e7a15c25355$var$MILLISECONDS_IN_HALF_A_DAY = (0, $5a123094476b33d7$export$a9905336c0111a3a).millisecondsPerDay / 2;
const $feb55e7a15c25355$var$getFactors = (n)=>{
    const factors = [];
    for(let i = 1; i <= n; i++)if (!(n % i)) factors.push(i);
    return factors;
};
const $feb55e7a15c25355$var$createXLabels = (domain, now)=>{
    const numberOfDays = (0, $e112f865c9c9912f$export$86415ebf4eb36b8c)(domain[1], domain[0]);
    const factors = $feb55e7a15c25355$var$getFactors(numberOfDays);
    const factorsValidForLabelCount = factors.filter((n)=>n <= 10 && n > 1);
    const labelCount = Math.max(2, ...factorsValidForLabelCount) + 1;
    const roundFn = now - (0, $c2e94012e82e0308$export$cba7498d83c2e2d)(new Date(now)).getTime() < $feb55e7a15c25355$var$MILLISECONDS_IN_HALF_A_DAY ? (0, $c2e94012e82e0308$export$4b61d8bc5e82982b) : (0, $c2e94012e82e0308$export$cba7498d83c2e2d);
    return [
        ...Array(labelCount).keys()
    ].map((n)=>(0, $06d17fa75ca1067f$export$9bcd4dc4ef454cb9).format(roundFn(new Date(domain[0] + (domain[1] - domain[0]) * n / (labelCount - 1)))));
};
const $feb55e7a15c25355$var$DATE_RANGE_OPTIONS = [
    "Today",
    "Last 7 days",
    "Last 30 days",
    "Last 90 days",
    "Last half year",
    "Last year",
    "All time",
    "Custom"
];
function $feb55e7a15c25355$export$2e2bcd8739ae039() {
    const dateNow = new Date();
    const moods = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.normalizedMoods);
    const firstMoodDateRoundedDown = (0, $c2e94012e82e0308$export$cba7498d83c2e2d)(new Date(moods.allIds[0]));
    const dateToToday = (0, $c2e94012e82e0308$export$cba7498d83c2e2d)(dateNow);
    const calculateDateFrom = (days)=>{
        const dateFrom = (0, $58b603c9eda836d4$export$70823084e2deb1ea)(dateToToday, days - 1);
        return dateFrom < firstMoodDateRoundedDown ? firstMoodDateRoundedDown : dateFrom;
    };
    const initialState = {
        dateRange: `Last ${(0, $5a123094476b33d7$export$a9905336c0111a3a).daysPerWeek} days`,
        dateFrom: calculateDateFrom((0, $5a123094476b33d7$export$a9905336c0111a3a).daysPerWeek),
        displayDateTo: dateToToday
    };
    const [localState, localDispatch] = (0, $lBnVc.useReducer)((state, action)=>{
        switch(action.type){
            case "dateFrom/set":
                return {
                    ...state,
                    dateFrom: action.payload,
                    dateRange: "Custom"
                };
            case "displayDateTo/set":
                return {
                    ...state,
                    dateRange: "Custom",
                    displayDateTo: action.payload
                };
            case "dateRange/set":
                switch(action.payload){
                    case "All time":
                        return {
                            dateRange: action.payload,
                            dateFrom: firstMoodDateRoundedDown,
                            displayDateTo: dateToToday
                        };
                    case "Custom":
                        return {
                            ...state,
                            dateRange: action.payload
                        };
                    case "Last 7 days":
                        return {
                            dateRange: action.payload,
                            dateFrom: calculateDateFrom((0, $5a123094476b33d7$export$a9905336c0111a3a).daysPerWeek),
                            displayDateTo: dateToToday
                        };
                    case "Last 30 days":
                        return {
                            dateRange: action.payload,
                            dateFrom: calculateDateFrom(30),
                            displayDateTo: dateToToday
                        };
                    case "Last 90 days":
                        return {
                            dateRange: action.payload,
                            dateFrom: calculateDateFrom(90),
                            displayDateTo: dateToToday
                        };
                    case "Last half year":
                        return {
                            dateRange: action.payload,
                            dateFrom: calculateDateFrom(183),
                            displayDateTo: dateToToday
                        };
                    case "Last year":
                        return {
                            dateRange: action.payload,
                            dateFrom: calculateDateFrom(365),
                            displayDateTo: dateToToday
                        };
                    case "Today":
                        return {
                            dateRange: action.payload,
                            dateFrom: dateToToday,
                            displayDateTo: dateToToday
                        };
                }
        }
    }, initialState);
    const eventsHasLoadedFromServer = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.hasLoadedFromServer);
    const dateTo = (0, $cb8fdbef2aba70f2$export$dd412b56f1e4d8aa)(localState.displayDateTo, 1);
    const moodIdsInPeriod = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((state)=>(0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.moodIdsInPeriod(state, localState.dateFrom, dateTo));
    if (!eventsHasLoadedFromServer) return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $b3bd040c14d4ce5c$export$2e2bcd8739ae039), {});
    if (!moods.allIds.length) return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039).Group, {
        children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $0df6bedbf9917577$export$2e2bcd8739ae039), {})
    });
    const domain = [
        localState.dateFrom.getTime(),
        dateTo.getTime()
    ];
    const xLabels = $feb55e7a15c25355$var$createXLabels(domain, dateNow.getTime());
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039).Group, {
        children: [
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h2", {
                        children: "Explore"
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $0a48ec8918b8b79c$export$2e2bcd8739ae039), {
                        dateFrom: localState.dateFrom,
                        dateTo: dateTo
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $9a780bd1b5aff71e$export$2e2bcd8739ae039), {
                        label: "Date range",
                        onChange: (e)=>localDispatch({
                                payload: e.target.value,
                                type: "dateRange/set"
                            }),
                        value: localState.dateRange,
                        children: $feb55e7a15c25355$var$DATE_RANGE_OPTIONS.map((option)=>/*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("option", {
                                value: option,
                                children: option
                            }, option))
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $468d5739b3a923e8$export$2e2bcd8739ae039), {
                        dateFrom: localState.dateFrom,
                        dateTo: localState.displayDateTo,
                        setDateFrom: (payload)=>localDispatch({
                                payload: payload,
                                type: "dateFrom/set"
                            }),
                        setDateTo: (payload)=>localDispatch({
                                payload: payload,
                                type: "displayDateTo/set"
                            })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $9ecf75b1b7e1bf61$export$2e2bcd8739ae039), {
                dateFrom: localState.dateFrom,
                dateTo: localState.displayDateTo
            }),
            moodIdsInPeriod.length ? /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $997e05fd3f436e77$export$2e2bcd8739ae039), {
                        dateFrom: localState.dateFrom,
                        hidePoints: true,
                        dateTo: dateTo,
                        xLabels: xLabels
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $645d8a5fcb813cb9$export$2e2bcd8739ae039), {
                        dateFrom: localState.dateFrom,
                        dateTo: dateTo
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $f1356ddf9998b04f$export$2e2bcd8739ae039), {
                        dateFrom: localState.dateFrom,
                        dateTo: dateTo
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $20457d8f726e9b74$export$2e2bcd8739ae039), {
                        dateFrom: localState.dateFrom,
                        dateTo: dateTo
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $3b3050146274ca05$export$2e2bcd8739ae039), {
                        dateFrom: localState.dateFrom,
                        dateTo: dateTo
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $d4bf939de7dd3627$export$2e2bcd8739ae039), {
                        dateFrom: localState.dateFrom,
                        dateTo: dateTo
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $af798ee18e885c0a$export$2e2bcd8739ae039), {
                        dateFrom: localState.dateFrom,
                        dateTo: dateTo,
                        xLabels: xLabels
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $a67d76e60b66d2ca$export$2e2bcd8739ae039), {
                dateFrom: localState.dateFrom,
                dateTo: dateTo
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $1dc16ddda003912c$export$2e2bcd8739ae039), {
                dateFrom: localState.dateFrom,
                dateTo: dateTo,
                xLabels: $feb55e7a15c25355$var$createXLabels(domain, dateNow.getTime())
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $d03f855c67127c85$export$2e2bcd8739ae039), {
                dateFrom: localState.dateFrom,
                dateTo: dateTo
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $6813af323f7a9acb$export$2e2bcd8739ae039), {
                dateFrom: localState.dateFrom,
                dateTo: dateTo
            })
        ]
    });
}







var $668cabe1758e1745$exports = {};
(function(a, b) {
    if ("function" == typeof define && define.amd) define([], b);
    else b();
})($668cabe1758e1745$exports, function() {
    "use strict";
    function b(a, b) {
        return "undefined" == typeof b ? b = {
            autoBom: !1
        } : "object" != typeof b && (console.warn("Deprecated: Expected third argument to be a object"), b = {
            autoBom: !b
        }), b.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(a.type) ? new Blob([
            "\uFEFF",
            a
        ], {
            type: a.type
        }) : a;
    }
    function c(a, b, c) {
        var d = new XMLHttpRequest;
        d.open("GET", a), d.responseType = "blob", d.onload = function() {
            g(d.response, b, c);
        }, d.onerror = function() {
            console.error("could not download file");
        }, d.send();
    }
    function d(a) {
        var b = new XMLHttpRequest;
        b.open("HEAD", a, !1);
        try {
            b.send();
        } catch (a) {}
        return 200 <= b.status && 299 >= b.status;
    }
    function e(a) {
        try {
            a.dispatchEvent(new MouseEvent("click"));
        } catch (c) {
            var b = document.createEvent("MouseEvents");
            b.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), a.dispatchEvent(b);
        }
    }
    var f = "object" == typeof window && window.window === window ? window : "object" == typeof self && self.self === self ? self : "object" == typeof $parcel$global && $parcel$global.global === $parcel$global ? $parcel$global : void 0, a = f.navigator && /Macintosh/.test(navigator.userAgent) && /AppleWebKit/.test(navigator.userAgent) && !/Safari/.test(navigator.userAgent), g = f.saveAs || ("object" != typeof window || window !== f ? function() {} : "download" in HTMLAnchorElement.prototype && !a ? function(b, g, h) {
        var i = f.URL || f.webkitURL, j = document.createElement("a");
        g = g || b.name || "download", j.download = g, j.rel = "noopener", "string" == typeof b ? (j.href = b, j.origin === location.origin ? e(j) : d(j.href) ? c(b, g, h) : e(j, j.target = "_blank")) : (j.href = i.createObjectURL(b), setTimeout(function() {
            i.revokeObjectURL(j.href);
        }, 4E4), setTimeout(function() {
            e(j);
        }, 0));
    } : "msSaveOrOpenBlob" in navigator ? function(f, g, h) {
        if (g = g || f.name || "download", "string" != typeof f) navigator.msSaveOrOpenBlob(b(f, h), g);
        else if (d(f)) c(f, g, h);
        else {
            var i = document.createElement("a");
            i.href = f, i.target = "_blank", setTimeout(function() {
                e(i);
            });
        }
    } : function(b, d, e, g) {
        if (g = g || open("", "_blank"), g && (g.document.title = g.document.body.innerText = "downloading..."), "string" == typeof b) return c(b, d, e);
        var h = "application/octet-stream" === b.type, i = /constructor/i.test(f.HTMLElement) || f.safari, j = /CriOS\/[\d]+/.test(navigator.userAgent);
        if ((j || h && i || a) && "undefined" != typeof FileReader) {
            var k = new FileReader;
            k.onloadend = function() {
                var a = k.result;
                a = j ? a : a.replace(/^data:[^;]*;/, "data:attachment/file;"), g ? g.location.href = a : location = a, g = null;
            }, k.readAsDataURL(b);
        } else {
            var l = f.URL || f.webkitURL, m = l.createObjectURL(b);
            g ? g.location = m : location.href = m, g = null, setTimeout(function() {
                l.revokeObjectURL(m);
            }, 4E4);
        }
    });
    f.saveAs = g.saveAs = g, $668cabe1758e1745$exports = g;
});


var $e4d1cd7ad02ababc$exports = {};
/* @license
Papa Parse
v5.4.1
https://github.com/mholt/PapaParse
License: MIT
*/ !function(e, t) {
    "function" == typeof define && define.amd ? define([], t) : $e4d1cd7ad02ababc$exports = t();
}($e4d1cd7ad02ababc$exports, function s() {
    "use strict";
    var f = "undefined" != typeof self ? self : "undefined" != typeof window ? window : void 0 !== f ? f : {};
    var n = !f.document && !!f.postMessage, o = f.IS_PAPA_WORKER || !1, a = {}, u = 0, b = {
        parse: function(e, t) {
            var r = (t = t || {}).dynamicTyping || !1;
            J(r) && (t.dynamicTypingFunction = r, r = {});
            if (t.dynamicTyping = r, t.transform = !!J(t.transform) && t.transform, t.worker && b.WORKERS_SUPPORTED) {
                var i = function() {
                    if (!b.WORKERS_SUPPORTED) return !1;
                    var e = (r = f.URL || f.webkitURL || null, i = s.toString(), b.BLOB_URL || (b.BLOB_URL = r.createObjectURL(new Blob([
                        "var global = (function() { if (typeof self !== 'undefined') { return self; } if (typeof window !== 'undefined') { return window; } if (typeof global !== 'undefined') { return global; } return {}; })(); global.IS_PAPA_WORKER=true; ",
                        "(",
                        i,
                        ")();"
                    ], {
                        type: "text/javascript"
                    })))), t = new f.Worker(e);
                    var r, i;
                    return t.onmessage = _, t.id = u++, a[t.id] = t;
                }();
                return i.userStep = t.step, i.userChunk = t.chunk, i.userComplete = t.complete, i.userError = t.error, t.step = J(t.step), t.chunk = J(t.chunk), t.complete = J(t.complete), t.error = J(t.error), delete t.worker, void i.postMessage({
                    input: e,
                    config: t,
                    workerId: i.id
                });
            }
            var n = null;
            b.NODE_STREAM_INPUT, "string" == typeof e ? (e = function(e) {
                if (65279 === e.charCodeAt(0)) return e.slice(1);
                return e;
            }(e), n = t.download ? new l(t) : new p(t)) : !0 === e.readable && J(e.read) && J(e.on) ? n = new g(t) : (f.File && e instanceof File || e instanceof Object) && (n = new c(t));
            return n.stream(e);
        },
        unparse: function(e, t) {
            var n = !1, _ = !0, m = ",", y = "\r\n", s = '"', a = s + s, r = !1, i = null, o = !1;
            !function() {
                if ("object" != typeof t) return;
                "string" != typeof t.delimiter || b.BAD_DELIMITERS.filter(function(e) {
                    return -1 !== t.delimiter.indexOf(e);
                }).length || (m = t.delimiter);
                ("boolean" == typeof t.quotes || "function" == typeof t.quotes || Array.isArray(t.quotes)) && (n = t.quotes);
                "boolean" != typeof t.skipEmptyLines && "string" != typeof t.skipEmptyLines || (r = t.skipEmptyLines);
                "string" == typeof t.newline && (y = t.newline);
                "string" == typeof t.quoteChar && (s = t.quoteChar);
                "boolean" == typeof t.header && (_ = t.header);
                if (Array.isArray(t.columns)) {
                    if (0 === t.columns.length) throw new Error("Option columns is empty");
                    i = t.columns;
                }
                void 0 !== t.escapeChar && (a = t.escapeChar + s);
                ("boolean" == typeof t.escapeFormulae || t.escapeFormulae instanceof RegExp) && (o = t.escapeFormulae instanceof RegExp ? t.escapeFormulae : /^[=+\-@\t\r].*$/);
            }();
            var u = new RegExp(Q(s), "g");
            "string" == typeof e && (e = JSON.parse(e));
            if (Array.isArray(e)) {
                if (!e.length || Array.isArray(e[0])) return h(null, e, r);
                if ("object" == typeof e[0]) return h(i || Object.keys(e[0]), e, r);
            } else if ("object" == typeof e) return "string" == typeof e.data && (e.data = JSON.parse(e.data)), Array.isArray(e.data) && (e.fields || (e.fields = e.meta && e.meta.fields || i), e.fields || (e.fields = Array.isArray(e.data[0]) ? e.fields : "object" == typeof e.data[0] ? Object.keys(e.data[0]) : []), Array.isArray(e.data[0]) || "object" == typeof e.data[0] || (e.data = [
                e.data
            ])), h(e.fields || [], e.data || [], r);
            throw new Error("Unable to serialize unrecognized input");
            function h(e, t, r) {
                var i = "";
                "string" == typeof e && (e = JSON.parse(e)), "string" == typeof t && (t = JSON.parse(t));
                var n = Array.isArray(e) && 0 < e.length, s = !Array.isArray(t[0]);
                if (n && _) {
                    for(var a = 0; a < e.length; a++)0 < a && (i += m), i += v(e[a], a);
                    0 < t.length && (i += y);
                }
                for(var o = 0; o < t.length; o++){
                    var u = n ? e.length : t[o].length, h = !1, f = n ? 0 === Object.keys(t[o]).length : 0 === t[o].length;
                    if (r && !n && (h = "greedy" === r ? "" === t[o].join("").trim() : 1 === t[o].length && 0 === t[o][0].length), "greedy" === r && n) {
                        for(var d = [], l = 0; l < u; l++){
                            var c = s ? e[l] : l;
                            d.push(t[o][c]);
                        }
                        h = "" === d.join("").trim();
                    }
                    if (!h) {
                        for(var p = 0; p < u; p++){
                            0 < p && !f && (i += m);
                            var g = n && s ? e[p] : p;
                            i += v(t[o][g], p);
                        }
                        o < t.length - 1 && (!r || 0 < u && !f) && (i += y);
                    }
                }
                return i;
            }
            function v(e, t) {
                if (null == e) return "";
                if (e.constructor === Date) return JSON.stringify(e).slice(1, 25);
                var r = !1;
                o && "string" == typeof e && o.test(e) && (e = "'" + e, r = !0);
                var i = e.toString().replace(u, a);
                return (r = r || !0 === n || "function" == typeof n && n(e, t) || Array.isArray(n) && n[t] || function(e, t) {
                    for(var r = 0; r < t.length; r++)if (-1 < e.indexOf(t[r])) return !0;
                    return !1;
                }(i, b.BAD_DELIMITERS) || -1 < i.indexOf(m) || " " === i.charAt(0) || " " === i.charAt(i.length - 1)) ? s + i + s : i;
            }
        }
    };
    if (b.RECORD_SEP = String.fromCharCode(30), b.UNIT_SEP = String.fromCharCode(31), b.BYTE_ORDER_MARK = "\uFEFF", b.BAD_DELIMITERS = [
        "\r",
        "\n",
        '"',
        b.BYTE_ORDER_MARK
    ], b.WORKERS_SUPPORTED = !n && !!f.Worker, b.NODE_STREAM_INPUT = 1, b.LocalChunkSize = 10485760, b.RemoteChunkSize = 5242880, b.DefaultDelimiter = ",", b.Parser = E, b.ParserHandle = r, b.NetworkStreamer = l, b.FileStreamer = c, b.StringStreamer = p, b.ReadableStreamStreamer = g, f.jQuery) {
        var d = f.jQuery;
        d.fn.parse = function(o) {
            var r = o.config || {}, u = [];
            return this.each(function(e) {
                if (!("INPUT" === d(this).prop("tagName").toUpperCase() && "file" === d(this).attr("type").toLowerCase() && f.FileReader) || !this.files || 0 === this.files.length) return !0;
                for(var t = 0; t < this.files.length; t++)u.push({
                    file: this.files[t],
                    inputElem: this,
                    instanceConfig: d.extend({}, r)
                });
            }), e(), this;
            function e() {
                if (0 !== u.length) {
                    var e, t, r, i, n = u[0];
                    if (J(o.before)) {
                        var s = o.before(n.file, n.inputElem);
                        if ("object" == typeof s) {
                            if ("abort" === s.action) return e = "AbortError", t = n.file, r = n.inputElem, i = s.reason, void (J(o.error) && o.error({
                                name: e
                            }, t, r, i));
                            if ("skip" === s.action) return void h();
                            "object" == typeof s.config && (n.instanceConfig = d.extend(n.instanceConfig, s.config));
                        } else if ("skip" === s) return void h();
                    }
                    var a = n.instanceConfig.complete;
                    n.instanceConfig.complete = function(e) {
                        J(a) && a(e, n.file, n.inputElem), h();
                    }, b.parse(n.file, n.instanceConfig);
                } else J(o.complete) && o.complete();
            }
            function h() {
                u.splice(0, 1), e();
            }
        };
    }
    function h(e) {
        this._handle = null, this._finished = !1, this._completed = !1, this._halted = !1, this._input = null, this._baseIndex = 0, this._partialLine = "", this._rowCount = 0, this._start = 0, this._nextChunk = null, this.isFirstChunk = !0, this._completeResults = {
            data: [],
            errors: [],
            meta: {}
        }, (function(e) {
            var t = w(e);
            t.chunkSize = parseInt(t.chunkSize), e.step || e.chunk || (t.chunkSize = null);
            this._handle = new r(t), (this._handle.streamer = this)._config = t;
        }).call(this, e), this.parseChunk = function(e, t) {
            if (this.isFirstChunk && J(this._config.beforeFirstChunk)) {
                var r = this._config.beforeFirstChunk(e);
                void 0 !== r && (e = r);
            }
            this.isFirstChunk = !1, this._halted = !1;
            var i = this._partialLine + e;
            this._partialLine = "";
            var n = this._handle.parse(i, this._baseIndex, !this._finished);
            if (!this._handle.paused() && !this._handle.aborted()) {
                var s = n.meta.cursor;
                this._finished || (this._partialLine = i.substring(s - this._baseIndex), this._baseIndex = s), n && n.data && (this._rowCount += n.data.length);
                var a = this._finished || this._config.preview && this._rowCount >= this._config.preview;
                if (o) f.postMessage({
                    results: n,
                    workerId: b.WORKER_ID,
                    finished: a
                });
                else if (J(this._config.chunk) && !t) {
                    if (this._config.chunk(n, this._handle), this._handle.paused() || this._handle.aborted()) return void (this._halted = !0);
                    n = void 0, this._completeResults = void 0;
                }
                return this._config.step || this._config.chunk || (this._completeResults.data = this._completeResults.data.concat(n.data), this._completeResults.errors = this._completeResults.errors.concat(n.errors), this._completeResults.meta = n.meta), this._completed || !a || !J(this._config.complete) || n && n.meta.aborted || (this._config.complete(this._completeResults, this._input), this._completed = !0), a || n && n.meta.paused || this._nextChunk(), n;
            }
            this._halted = !0;
        }, this._sendError = function(e) {
            J(this._config.error) ? this._config.error(e) : o && this._config.error && f.postMessage({
                workerId: b.WORKER_ID,
                error: e,
                finished: !1
            });
        };
    }
    function l(e) {
        var i;
        (e = e || {}).chunkSize || (e.chunkSize = b.RemoteChunkSize), h.call(this, e), this._nextChunk = n ? function() {
            this._readChunk(), this._chunkLoaded();
        } : function() {
            this._readChunk();
        }, this.stream = function(e) {
            this._input = e, this._nextChunk();
        }, this._readChunk = function() {
            if (this._finished) this._chunkLoaded();
            else {
                if (i = new XMLHttpRequest, this._config.withCredentials && (i.withCredentials = this._config.withCredentials), n || (i.onload = v(this._chunkLoaded, this), i.onerror = v(this._chunkError, this)), i.open(this._config.downloadRequestBody ? "POST" : "GET", this._input, !n), this._config.downloadRequestHeaders) {
                    var e = this._config.downloadRequestHeaders;
                    for(var t in e)i.setRequestHeader(t, e[t]);
                }
                if (this._config.chunkSize) {
                    var r = this._start + this._config.chunkSize - 1;
                    i.setRequestHeader("Range", "bytes=" + this._start + "-" + r);
                }
                try {
                    i.send(this._config.downloadRequestBody);
                } catch (e) {
                    this._chunkError(e.message);
                }
                n && 0 === i.status && this._chunkError();
            }
        }, this._chunkLoaded = function() {
            4 === i.readyState && (i.status < 200 || 400 <= i.status ? this._chunkError() : (this._start += this._config.chunkSize ? this._config.chunkSize : i.responseText.length, this._finished = !this._config.chunkSize || this._start >= function(e) {
                var t = e.getResponseHeader("Content-Range");
                if (null === t) return -1;
                return parseInt(t.substring(t.lastIndexOf("/") + 1));
            }(i), this.parseChunk(i.responseText)));
        }, this._chunkError = function(e) {
            var t = i.statusText || e;
            this._sendError(new Error(t));
        };
    }
    function c(e) {
        var i, n;
        (e = e || {}).chunkSize || (e.chunkSize = b.LocalChunkSize), h.call(this, e);
        var s = "undefined" != typeof FileReader;
        this.stream = function(e) {
            this._input = e, n = e.slice || e.webkitSlice || e.mozSlice, s ? ((i = new FileReader).onload = v(this._chunkLoaded, this), i.onerror = v(this._chunkError, this)) : i = new FileReaderSync, this._nextChunk();
        }, this._nextChunk = function() {
            this._finished || this._config.preview && !(this._rowCount < this._config.preview) || this._readChunk();
        }, this._readChunk = function() {
            var e = this._input;
            if (this._config.chunkSize) {
                var t = Math.min(this._start + this._config.chunkSize, this._input.size);
                e = n.call(e, this._start, t);
            }
            var r = i.readAsText(e, this._config.encoding);
            s || this._chunkLoaded({
                target: {
                    result: r
                }
            });
        }, this._chunkLoaded = function(e) {
            this._start += this._config.chunkSize, this._finished = !this._config.chunkSize || this._start >= this._input.size, this.parseChunk(e.target.result);
        }, this._chunkError = function() {
            this._sendError(i.error);
        };
    }
    function p(e) {
        var r;
        h.call(this, e = e || {}), this.stream = function(e) {
            return r = e, this._nextChunk();
        }, this._nextChunk = function() {
            if (!this._finished) {
                var e, t = this._config.chunkSize;
                return t ? (e = r.substring(0, t), r = r.substring(t)) : (e = r, r = ""), this._finished = !r, this.parseChunk(e);
            }
        };
    }
    function g(e) {
        h.call(this, e = e || {});
        var t = [], r = !0, i = !1;
        this.pause = function() {
            h.prototype.pause.apply(this, arguments), this._input.pause();
        }, this.resume = function() {
            h.prototype.resume.apply(this, arguments), this._input.resume();
        }, this.stream = function(e) {
            this._input = e, this._input.on("data", this._streamData), this._input.on("end", this._streamEnd), this._input.on("error", this._streamError);
        }, this._checkIsFinished = function() {
            i && 1 === t.length && (this._finished = !0);
        }, this._nextChunk = function() {
            this._checkIsFinished(), t.length ? this.parseChunk(t.shift()) : r = !0;
        }, this._streamData = v(function(e) {
            try {
                t.push("string" == typeof e ? e : e.toString(this._config.encoding)), r && (r = !1, this._checkIsFinished(), this.parseChunk(t.shift()));
            } catch (e) {
                this._streamError(e);
            }
        }, this), this._streamError = v(function(e) {
            this._streamCleanUp(), this._sendError(e);
        }, this), this._streamEnd = v(function() {
            this._streamCleanUp(), i = !0, this._streamData("");
        }, this), this._streamCleanUp = v(function() {
            this._input.removeListener("data", this._streamData), this._input.removeListener("end", this._streamEnd), this._input.removeListener("error", this._streamError);
        }, this);
    }
    function r(m) {
        var a, o, u, i = Math.pow(2, 53), n = -i, s = /^\s*-?(\d+\.?|\.\d+|\d+\.\d+)([eE][-+]?\d+)?\s*$/, h = /^((\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z)))$/, t = this, r = 0, f = 0, d = !1, e = !1, l = [], c = {
            data: [],
            errors: [],
            meta: {}
        };
        if (J(m.step)) {
            var p = m.step;
            m.step = function(e) {
                if (c = e, _()) g();
                else {
                    if (g(), 0 === c.data.length) return;
                    r += e.data.length, m.preview && r > m.preview ? o.abort() : (c.data = c.data[0], p(c, t));
                }
            };
        }
        function y(e) {
            return "greedy" === m.skipEmptyLines ? "" === e.join("").trim() : 1 === e.length && 0 === e[0].length;
        }
        function g() {
            return c && u && (k("Delimiter", "UndetectableDelimiter", "Unable to auto-detect delimiting character; defaulted to '" + b.DefaultDelimiter + "'"), u = !1), m.skipEmptyLines && (c.data = c.data.filter(function(e) {
                return !y(e);
            })), _() && function() {
                if (!c) return;
                function e(e, t) {
                    J(m.transformHeader) && (e = m.transformHeader(e, t)), l.push(e);
                }
                if (Array.isArray(c.data[0])) {
                    for(var t = 0; _() && t < c.data.length; t++)c.data[t].forEach(e);
                    c.data.splice(0, 1);
                } else c.data.forEach(e);
            }(), function() {
                if (!c || !m.header && !m.dynamicTyping && !m.transform) return c;
                function e(e, t) {
                    var r, i = m.header ? {} : [];
                    for(r = 0; r < e.length; r++){
                        var n = r, s = e[r];
                        m.header && (n = r >= l.length ? "__parsed_extra" : l[r]), m.transform && (s = m.transform(s, n)), s = v(n, s), "__parsed_extra" === n ? (i[n] = i[n] || [], i[n].push(s)) : i[n] = s;
                    }
                    return m.header && (r > l.length ? k("FieldMismatch", "TooManyFields", "Too many fields: expected " + l.length + " fields but parsed " + r, f + t) : r < l.length && k("FieldMismatch", "TooFewFields", "Too few fields: expected " + l.length + " fields but parsed " + r, f + t)), i;
                }
                var t = 1;
                !c.data.length || Array.isArray(c.data[0]) ? (c.data = c.data.map(e), t = c.data.length) : c.data = e(c.data, 0);
                m.header && c.meta && (c.meta.fields = l);
                return f += t, c;
            }();
        }
        function _() {
            return m.header && 0 === l.length;
        }
        function v(e, t) {
            var r;
            return r = e, m.dynamicTypingFunction && void 0 === m.dynamicTyping[r] && (m.dynamicTyping[r] = m.dynamicTypingFunction(r)), !0 === (m.dynamicTyping[r] || m.dynamicTyping) ? "true" === t || "TRUE" === t || "false" !== t && "FALSE" !== t && (function(e) {
                if (s.test(e)) {
                    var t = parseFloat(e);
                    if (n < t && t < i) return !0;
                }
                return !1;
            }(t) ? parseFloat(t) : h.test(t) ? new Date(t) : "" === t ? null : t) : t;
        }
        function k(e, t, r, i) {
            var n = {
                type: e,
                code: t,
                message: r
            };
            void 0 !== i && (n.row = i), c.errors.push(n);
        }
        this.parse = function(e, t, r) {
            var i = m.quoteChar || '"';
            if (m.newline || (m.newline = function(e, t) {
                e = e.substring(0, 1048576);
                var r = new RegExp(Q(t) + "([^]*?)" + Q(t), "gm"), i = (e = e.replace(r, "")).split("\r"), n = e.split("\n"), s = 1 < n.length && n[0].length < i[0].length;
                if (1 === i.length || s) return "\n";
                for(var a = 0, o = 0; o < i.length; o++)"\n" === i[o][0] && a++;
                return a >= i.length / 2 ? "\r\n" : "\r";
            }(e, i)), u = !1, m.delimiter) J(m.delimiter) && (m.delimiter = m.delimiter(e), c.meta.delimiter = m.delimiter);
            else {
                var n = function(e, t, r, i, n) {
                    var s, a, o, u;
                    n = n || [
                        ",",
                        "	",
                        "|",
                        ";",
                        b.RECORD_SEP,
                        b.UNIT_SEP
                    ];
                    for(var h = 0; h < n.length; h++){
                        var f = n[h], d = 0, l = 0, c = 0;
                        o = void 0;
                        for(var p = new E({
                            comments: i,
                            delimiter: f,
                            newline: t,
                            preview: 10
                        }).parse(e), g = 0; g < p.data.length; g++)if (r && y(p.data[g])) c++;
                        else {
                            var _ = p.data[g].length;
                            l += _, void 0 !== o ? 0 < _ && (d += Math.abs(_ - o), o = _) : o = _;
                        }
                        0 < p.data.length && (l /= p.data.length - c), (void 0 === a || d <= a) && (void 0 === u || u < l) && 1.99 < l && (a = d, s = f, u = l);
                    }
                    return {
                        successful: !!(m.delimiter = s),
                        bestDelimiter: s
                    };
                }(e, m.newline, m.skipEmptyLines, m.comments, m.delimitersToGuess);
                n.successful ? m.delimiter = n.bestDelimiter : (u = !0, m.delimiter = b.DefaultDelimiter), c.meta.delimiter = m.delimiter;
            }
            var s = w(m);
            return m.preview && m.header && s.preview++, a = e, o = new E(s), c = o.parse(a, t, r), g(), d ? {
                meta: {
                    paused: !0
                }
            } : c || {
                meta: {
                    paused: !1
                }
            };
        }, this.paused = function() {
            return d;
        }, this.pause = function() {
            d = !0, o.abort(), a = J(m.chunk) ? "" : a.substring(o.getCharIndex());
        }, this.resume = function() {
            t.streamer._halted ? (d = !1, t.streamer.parseChunk(a, !0)) : setTimeout(t.resume, 3);
        }, this.aborted = function() {
            return e;
        }, this.abort = function() {
            e = !0, o.abort(), c.meta.aborted = !0, J(m.complete) && m.complete(c), a = "";
        };
    }
    function Q(e) {
        return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    }
    function E(j) {
        var z, M = (j = j || {}).delimiter, P = j.newline, U = j.comments, q = j.step, N = j.preview, B = j.fastMode, K = z = void 0 === j.quoteChar || null === j.quoteChar ? '"' : j.quoteChar;
        if (void 0 !== j.escapeChar && (K = j.escapeChar), ("string" != typeof M || -1 < b.BAD_DELIMITERS.indexOf(M)) && (M = ","), U === M) throw new Error("Comment character same as delimiter");
        !0 === U ? U = "#" : ("string" != typeof U || -1 < b.BAD_DELIMITERS.indexOf(U)) && (U = !1), "\n" !== P && "\r" !== P && "\r\n" !== P && (P = "\n");
        var W = 0, H = !1;
        this.parse = function(i, t, r) {
            if ("string" != typeof i) throw new Error("Input must be a string");
            var n = i.length, e = M.length, s = P.length, a = U.length, o = J(q), u = [], h = [], f = [], d = W = 0;
            if (!i) return L();
            if (j.header && !t) {
                var l = i.split(P)[0].split(M), c = [], p = {}, g = !1;
                for(var _ in l){
                    var m = l[_];
                    J(j.transformHeader) && (m = j.transformHeader(m, _));
                    var y = m, v = p[m] || 0;
                    for(0 < v && (g = !0, y = m + "_" + v), p[m] = v + 1; c.includes(y);)y = y + "_" + v;
                    c.push(y);
                }
                if (g) {
                    var k = i.split(P);
                    k[0] = c.join(M), i = k.join(P);
                }
            }
            if (B || !1 !== B && -1 === i.indexOf(z)) {
                for(var b = i.split(P), E = 0; E < b.length; E++){
                    if (f = b[E], W += f.length, E !== b.length - 1) W += P.length;
                    else if (r) return L();
                    if (!U || f.substring(0, a) !== U) {
                        if (o) {
                            if (u = [], I(f.split(M)), F(), H) return L();
                        } else I(f.split(M));
                        if (N && N <= E) return u = u.slice(0, N), L(!0);
                    }
                }
                return L();
            }
            for(var w = i.indexOf(M, W), R = i.indexOf(P, W), C = new RegExp(Q(K) + Q(z), "g"), S = i.indexOf(z, W);;)if (i[W] !== z) {
                if (U && 0 === f.length && i.substring(W, W + a) === U) {
                    if (-1 === R) return L();
                    W = R + s, R = i.indexOf(P, W), w = i.indexOf(M, W);
                } else if (-1 !== w && (w < R || -1 === R)) f.push(i.substring(W, w)), W = w + e, w = i.indexOf(M, W);
                else {
                    if (-1 === R) break;
                    if (f.push(i.substring(W, R)), D(R + s), o && (F(), H)) return L();
                    if (N && u.length >= N) return L(!0);
                }
            } else for(S = W, W++;;){
                if (-1 === (S = i.indexOf(z, S + 1))) return r || h.push({
                    type: "Quotes",
                    code: "MissingQuotes",
                    message: "Quoted field unterminated",
                    row: u.length,
                    index: W
                }), T();
                if (S === n - 1) return T(i.substring(W, S).replace(C, z));
                if (z !== K || i[S + 1] !== K) {
                    if (z === K || 0 === S || i[S - 1] !== K) {
                        -1 !== w && w < S + 1 && (w = i.indexOf(M, S + 1)), -1 !== R && R < S + 1 && (R = i.indexOf(P, S + 1));
                        var O = A(-1 === R ? w : Math.min(w, R));
                        if (i.substr(S + 1 + O, e) === M) {
                            f.push(i.substring(W, S).replace(C, z)), i[W = S + 1 + O + e] !== z && (S = i.indexOf(z, W)), w = i.indexOf(M, W), R = i.indexOf(P, W);
                            break;
                        }
                        var x = A(R);
                        if (i.substring(S + 1 + x, S + 1 + x + s) === P) {
                            if (f.push(i.substring(W, S).replace(C, z)), D(S + 1 + x + s), w = i.indexOf(M, W), S = i.indexOf(z, W), o && (F(), H)) return L();
                            if (N && u.length >= N) return L(!0);
                            break;
                        }
                        h.push({
                            type: "Quotes",
                            code: "InvalidQuotes",
                            message: "Trailing quote on quoted field is malformed",
                            row: u.length,
                            index: W
                        }), S++;
                    }
                } else S++;
            }
            return T();
            function I(e) {
                u.push(e), d = W;
            }
            function A(e) {
                var t = 0;
                if (-1 !== e) {
                    var r = i.substring(S + 1, e);
                    r && "" === r.trim() && (t = r.length);
                }
                return t;
            }
            function T(e) {
                return r || (void 0 === e && (e = i.substring(W)), f.push(e), W = n, I(f), o && F()), L();
            }
            function D(e) {
                W = e, I(f), f = [], R = i.indexOf(P, W);
            }
            function L(e) {
                return {
                    data: u,
                    errors: h,
                    meta: {
                        delimiter: M,
                        linebreak: P,
                        aborted: H,
                        truncated: !!e,
                        cursor: d + (t || 0)
                    }
                };
            }
            function F() {
                q(L()), u = [], h = [];
            }
        }, this.abort = function() {
            H = !0;
        }, this.getCharIndex = function() {
            return W;
        };
    }
    function _(e) {
        var t = e.data, r = a[t.workerId], i = !1;
        if (t.error) r.userError(t.error, t.file);
        else if (t.results && t.results.data) {
            var n = {
                abort: function() {
                    i = !0, m(t.workerId, {
                        data: [],
                        errors: [],
                        meta: {
                            aborted: !0
                        }
                    });
                },
                pause: y,
                resume: y
            };
            if (J(r.userStep)) {
                for(var s = 0; s < t.results.data.length && (r.userStep({
                    data: t.results.data[s],
                    errors: t.results.errors,
                    meta: t.results.meta
                }, n), !i); s++);
                delete t.results;
            } else J(r.userChunk) && (r.userChunk(t.results, n, t.file), delete t.results);
        }
        t.finished && !i && m(t.workerId, t.results);
    }
    function m(e, t) {
        var r = a[e];
        J(r.userComplete) && r.userComplete(t), r.terminate(), delete a[e];
    }
    function y() {
        throw new Error("Not implemented.");
    }
    function w(e) {
        if ("object" != typeof e || null === e) return e;
        var t = Array.isArray(e) ? [] : {};
        for(var r in e)t[r] = w(e[r]);
        return t;
    }
    function v(e, t) {
        return function() {
            e.apply(t, arguments);
        };
    }
    function J(e) {
        return "function" == typeof e;
    }
    return o && (f.onmessage = function(e) {
        var t = e.data;
        void 0 === b.WORKER_ID && t && (b.WORKER_ID = t.workerId);
        if ("string" == typeof t.input) f.postMessage({
            workerId: b.WORKER_ID,
            results: b.parse(t.input, t.config),
            finished: !0
        });
        else if (f.File && t.input instanceof File || t.input instanceof Object) {
            var r = b.parse(t.input, t.config);
            r && f.postMessage({
                workerId: b.WORKER_ID,
                results: r,
                finished: !0
            });
        }
    }), (l.prototype = Object.create(h.prototype)).constructor = l, (c.prototype = Object.create(h.prototype)).constructor = c, (p.prototype = Object.create(p.prototype)).constructor = p, (g.prototype = Object.create(h.prototype)).constructor = g, b;
});


const $d4552df15b9ab2b8$var$createFilename = (dataType, extension)=>`moodtracker-${dataType}-export-${(0, $c2e94012e82e0308$export$f3013bcc8d8645bd)(new Date())}.${extension}`;
const $d4552df15b9ab2b8$var$downloadCsv = (dataType, denormalizedData)=>{
    const columns = new Set();
    const flattenedDenormalizedData = [];
    for (const datum of denormalizedData){
        const flattenedDatum = {};
        for (const [key, val] of Object.entries(datum)){
            if (typeof val !== "object") {
                flattenedDatum[key] = val;
                columns.add(key);
                continue;
            }
            for (const [k, v] of Object.entries(val)){
                const flattenedKey = `${key}:${k}`;
                flattenedDatum[flattenedKey] = v;
                columns.add(flattenedKey);
            }
        }
        flattenedDenormalizedData.push(flattenedDatum);
    }
    (0, $668cabe1758e1745$exports.saveAs)(new Blob([
        (0, $e4d1cd7ad02ababc$exports.unparse)(flattenedDenormalizedData, {
            columns: [
                ...columns
            ]
        })
    ], {
        type: "text/csv"
    }), $d4552df15b9ab2b8$var$createFilename(dataType, "csv"));
};
const $d4552df15b9ab2b8$var$downloadJson = (dataType, denormalizedData)=>{
    (0, $668cabe1758e1745$exports.saveAs)(new Blob([
        JSON.stringify(denormalizedData)
    ], {
        type: "application/json"
    }), $d4552df15b9ab2b8$var$createFilename(dataType, "json"));
};
function $d4552df15b9ab2b8$export$2e2bcd8739ae039({ category: category, denormalizedData: denormalizedData }) {
    return denormalizedData.length ? /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039).Group, {
        children: [
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039), {
                onClick: ()=>$d4552df15b9ab2b8$var$downloadCsv(category, denormalizedData),
                type: "button",
                children: "Export as CSV"
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039), {
                onClick: ()=>$d4552df15b9ab2b8$var$downloadJson(category, denormalizedData),
                type: "button",
                variant: "secondary",
                children: "Export as JSON"
            })
        ]
    }) : null;
}





function $4149558fbda63cd8$export$2e2bcd8739ae039() {
    const denormalizedMeditations = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.denormalizedMeditations);
    const denormalizedMoods = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.denormalizedMoods);
    const denormalizedWeights = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.denormalizedWeights);
    const navigate = (0, $f02d97b5ca509f34$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039).Group, {
        children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h2", {
                    children: "Export data"
                }),
                !denormalizedMeditations.length && !denormalizedMoods.length && !denormalizedWeights.length ? /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("p", {
                            children: "No data to export"
                        }),
                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039).Group, {
                            children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039), {
                                onClick: ()=>navigate(`/add`),
                                type: "button",
                                children: "Add your first mood!"
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("p", {
                            children: "You can download all your data from here. Choose CSV format if you want to load your data into a spreadsheet and take a closer look."
                        }),
                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h3", {
                            children: "Moods"
                        }),
                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $d4552df15b9ab2b8$export$2e2bcd8739ae039), {
                            category: "moods",
                            denormalizedData: denormalizedMoods
                        }),
                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h3", {
                            children: "Meditations"
                        }),
                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $d4552df15b9ab2b8$export$2e2bcd8739ae039), {
                            category: "meditations",
                            denormalizedData: denormalizedMeditations
                        }),
                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h3", {
                            children: "Weights"
                        }),
                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $d4552df15b9ab2b8$export$2e2bcd8739ae039), {
                            category: "weights",
                            denormalizedData: denormalizedWeights
                        })
                    ]
                })
            ]
        })
    });
}






function $77e875eaed32ac4c$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $31843a75f9f755dc$export$2e2bcd8739ae039), {
        onSubmit: ({ email: email, setSubmitError: setSubmitError })=>new Promise((resolve, reject)=>{
                (0, $97fc43514b4d4584$export$a9d932d842141dae)(email).forgotPassword({
                    inputVerificationCode: resolve,
                    // doesn't actually seem to be invoked (inputVerificationCode is called instead)
                    // but is marked as required
                    onSuccess: resolve,
                    // types are wrong for `onFailure`
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    onFailure: (e)=>{
                        switch(e.code){
                            case "NetworkError":
                                setSubmitError((0, $5a123094476b33d7$export$4fd720569787ab6f).network);
                                break;
                            default:
                                setSubmitError((0, $5a123094476b33d7$export$4fd720569787ab6f).generic);
                        }
                        reject(Error(JSON.stringify(e)));
                    }
                });
            })
    });
}















function $e1680580b4b89fb5$export$2e2bcd8739ae039() {
    const locationEnabled = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $cc3689f5d10378f4$export$2e2bcd8739ae039).selectors.recordLocation);
    const dispatch = (0, $d3287b130d7b0f6b$export$8ad76b76a4c905f8)();
    const permissionState = (0, $f72d9b2e2a1bcdc2$export$2e2bcd8739ae039)("geolocation");
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("p", {
                children: "Opt in to record your location against all your events."
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("p", {
                children: "If you log your location in MoodTracker you will be able to see where you were when you look back through your history and you will be able to view location-based stats."
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $828cb8aa9adcb6a3$export$2e2bcd8739ae039), {
                checked: locationEnabled,
                error: permissionState === "denied" ? "Location permission denied, if you want to use this feature you will need to enable this permission in your browser" : undefined,
                onChange: ()=>dispatch((0, $cc3689f5d10378f4$export$2e2bcd8739ae039).actions.setLocationRecording(locationEnabled ? false : true)),
                label: locationEnabled ? permissionState === "granted" ? "Storing location against events you record" : "Settings saved to device, but not recording location" : "Not recording location"
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("p", {
                children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("small", {
                    children: [
                        "For any privacy concerns",
                        " ",
                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e94b7bcc277332d2$export$a6c7ac8248d6e38a), {
                            to: "/about/privacy-policy",
                            children: "take a look at the privacy policy"
                        }),
                        "."
                    ]
                })
            })
        ]
    });
}





function $94dd02c3a438e513$export$2e2bcd8739ae039() {
    const userHasManuallySignedIn = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $4a1b4f367ad149f7$export$2e2bcd8739ae039).selectors.showNewSignInUi);
    const dispatch = (0, $d3287b130d7b0f6b$export$8ad76b76a4c905f8)();
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $2b02ccd0ece868b7$export$2e2bcd8739ae039), {
        "data-test-id": (0, $5a123094476b33d7$export$a2b4f255152a6585).deviceSpecificSettingsDialog,
        open: userHasManuallySignedIn,
        title: "Check your device-specific settings",
        onClose: ()=>dispatch((0, $4a1b4f367ad149f7$export$2e2bcd8739ae039).actions.dismissNewSignInUi()),
        children: [
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h4", {
                children: "Daily push notifications"
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $9296770459af7ce6$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h4", {
                style: {
                    marginTop: 0
                },
                children: "Location settings"
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e1680580b4b89fb5$export$2e2bcd8739ae039), {})
        ]
    });
}
















var $lBnVc = parcelRequire("lBnVc");
const $b8f7cab810aad046$var$DAYS_PER_PAGE = 7;
function $b8f7cab810aad046$export$2e2bcd8739ae039() {
    const moodsGroupedByDay = Object.entries((0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.moodIdsByDate));
    const [page, setPage] = (0, $lBnVc.useState)(0);
    const pageCount = Math.max(Math.ceil(moodsGroupedByDay.length / $b8f7cab810aad046$var$DAYS_PER_PAGE), 1);
    const endIndex = moodsGroupedByDay.length - page * $b8f7cab810aad046$var$DAYS_PER_PAGE;
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
        children: [
            moodsGroupedByDay.length ? (0, $c2e94012e82e0308$export$7ff0d353c23134fe)(moodsGroupedByDay.slice(Math.max(endIndex - $b8f7cab810aad046$var$DAYS_PER_PAGE, 0), endIndex), ([dayStr, ids])=>{
                const date = (0, $c2e94012e82e0308$export$27d3dd4acf9951a1)(dayStr);
                return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h3", {
                            children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e94b7bcc277332d2$export$a6c7ac8248d6e38a), {
                                to: `/stats/days/${dayStr}`,
                                children: (0, $06d17fa75ca1067f$export$5b8f5fb13700b442).format(date)
                            })
                        }),
                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $0a48ec8918b8b79c$export$2e2bcd8739ae039), {
                            dateFrom: date,
                            dateTo: (0, $cb8fdbef2aba70f2$export$dd412b56f1e4d8aa)(date, 1)
                        }),
                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $7c1560fa3a8ca778$export$2e2bcd8739ae039).Group, {
                            children: (0, $c2e94012e82e0308$export$7ff0d353c23134fe)(ids, (id)=>/*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $793264348b86e468$export$2e2bcd8739ae039), {
                                    id: id
                                }, id))
                        })
                    ]
                }, dayStr);
            }) : /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h3", {
                        children: "No results found"
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("p", {
                        children: "Try again with a different search"
                    })
                ]
            }),
            pageCount > 1 && /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $64123a2209d9f6c7$export$2e2bcd8739ae039), {
                    onChange: setPage,
                    page: page,
                    pageCount: pageCount
                })
            })
        ]
    });
}





const $a777125387c77d7d$export$163a8724bf6d6514 = {
    data: [
        [
            1603667889807,
            6
        ],
        [
            1603671665641,
            5
        ],
        [
            1603699254071,
            4
        ],
        [
            1603704446665,
            6
        ],
        [
            1603708885713,
            7
        ],
        [
            1603718504147,
            7
        ],
        [
            1603734892787,
            7
        ],
        [
            1603743736493,
            8
        ],
        [
            1603749048034,
            7
        ],
        [
            1603786974015,
            5
        ],
        [
            1603792744002,
            6
        ],
        [
            1603793556929,
            6
        ],
        [
            1603802435604,
            7
        ],
        [
            1603810577119,
            6
        ],
        [
            1603814989164,
            4
        ],
        [
            1603834676926,
            7
        ],
        [
            1603841560793,
            7
        ],
        [
            1603875271570,
            6
        ],
        [
            1603882283133,
            7
        ],
        [
            1603887384681,
            7
        ],
        [
            1603890707987,
            7
        ],
        [
            1603917918279,
            7
        ],
        [
            1603920984728,
            7
        ],
        [
            1603924287954,
            7
        ],
        [
            1603963452036,
            7
        ],
        [
            1603983396198,
            7
        ],
        [
            1603990267550,
            8
        ],
        [
            1603995030623,
            8
        ],
        [
            1603999289565,
            5
        ],
        [
            1604000940301,
            6
        ],
        [
            1604002516229,
            6
        ],
        [
            1604058266660,
            7
        ],
        [
            1604060117816,
            7
        ],
        [
            1604064555131,
            7
        ],
        [
            1604067333501,
            7
        ],
        [
            1604068027309,
            7
        ],
        [
            1604071477486,
            7
        ],
        [
            1604075416890,
            7
        ],
        [
            1604079208680,
            8
        ],
        [
            1604086223061,
            8
        ],
        [
            1604087619651,
            8
        ],
        [
            1604097624205,
            8
        ],
        [
            1604100467736,
            8
        ],
        [
            1604102614909,
            8
        ],
        [
            1604135710129,
            8
        ],
        [
            1604138585881,
            8
        ],
        [
            1604140548633,
            8
        ],
        [
            1604142320115,
            8
        ],
        [
            1604161862539,
            9
        ],
        [
            1604168677188,
            8
        ],
        [
            1604174501316,
            8
        ],
        [
            1604182751770,
            8
        ],
        [
            1604189376701,
            8
        ],
        [
            1604225839595,
            8
        ],
        [
            1604232375778,
            8
        ],
        [
            1604238907342,
            7
        ],
        [
            1604244830856,
            7
        ],
        [
            1604249364806,
            7
        ],
        [
            1604253257747,
            8
        ],
        [
            1604256749442,
            8
        ],
        [
            1604274382661,
            7
        ],
        [
            1604274912955,
            8
        ],
        [
            1604301793890,
            7
        ]
    ],
    domain: [
        1603670400000,
        1604275200000
    ],
    trendlinePoints: [
        [
            1603670400000,
            4.63
        ],
        [
            1603689300000,
            5.24
        ],
        [
            1603708200000,
            5.87
        ],
        [
            1603727100000,
            6.85
        ],
        [
            1603746000000,
            6.82
        ],
        [
            1603764900000,
            6.29
        ],
        [
            1603783800000,
            5.99
        ],
        [
            1603802700000,
            5.65
        ],
        [
            1603821600000,
            6.14
        ],
        [
            1603840500000,
            6.16
        ],
        [
            1603859400000,
            6.62
        ],
        [
            1603878300000,
            6.65
        ],
        [
            1603897200000,
            6.83
        ],
        [
            1603916100000,
            7
        ],
        [
            1603935000000,
            7
        ],
        [
            1603953900000,
            7
        ],
        [
            1603972800000,
            7.05
        ],
        [
            1603991700000,
            6.77
        ],
        [
            1604010600000,
            6.6
        ],
        [
            1604029500000,
            6.48
        ],
        [
            1604048400000,
            6.77
        ],
        [
            1604067300000,
            7.26
        ],
        [
            1604086200000,
            7.65
        ],
        [
            1604105100000,
            7.98
        ],
        [
            1604124000000,
            8.04
        ],
        [
            1604142900000,
            8.23
        ],
        [
            1604161800000,
            8.23
        ],
        [
            1604180700000,
            8.18
        ],
        [
            1604199600000,
            8
        ],
        [
            1604218500000,
            7.8
        ],
        [
            1604237400000,
            7.68
        ],
        [
            1604256300000,
            7.53
        ],
        [
            1604275200000,
            7.5
        ]
    ],
    xLabels: [
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat",
        "Sun"
    ]
};
const $a777125387c77d7d$export$d88b449a795c08f0 = {
    data: [
        [
            0,
            7.43
        ],
        [
            1,
            7.39
        ],
        [
            2,
            7.36
        ],
        [
            3,
            7.32
        ],
        [
            4,
            7.29
        ],
        [
            5,
            7.25
        ],
        [
            6,
            7.21
        ],
        [
            7,
            7
        ],
        [
            8,
            7.11
        ],
        [
            9,
            7.22
        ],
        [
            10,
            7.23
        ],
        [
            11,
            7.23
        ],
        [
            12,
            7.17
        ],
        [
            13,
            7
        ],
        [
            14,
            6.3
        ],
        [
            15,
            6
        ],
        [
            16,
            6.1
        ],
        [
            17,
            6.2
        ],
        [
            18,
            6.3
        ],
        [
            19,
            6.8
        ],
        [
            20,
            7.3
        ],
        [
            21,
            7.46
        ],
        [
            22,
            7.5
        ],
        [
            23,
            7.47
        ]
    ]
};
const $a777125387c77d7d$export$30bc0a6c1bfab02f = {
    moodsByLocation: {
        "New York City": [
            1,
            10,
            6
        ],
        London: [
            7,
            7,
            7,
            8,
            9
        ],
        Paris: [
            5,
            4,
            6,
            7,
            6,
            8
        ],
        Tokyo: [
            8,
            5,
            6,
            7,
            7
        ],
        Dubai: [
            6,
            7,
            8,
            5,
            6
        ]
    }
};
const $a777125387c77d7d$export$a5efe817cf88255b = {
    coarseGrainedData: [
        [
            -5,
            8
        ],
        [
            -3,
            6.1
        ],
        [
            -2,
            7
        ],
        [
            -1,
            6.888888888888889
        ],
        [
            0,
            6.958333333333333
        ],
        [
            1,
            6
        ],
        [
            2,
            5.5
        ],
        [
            3,
            5.571428571428571
        ],
        [
            4,
            4.8
        ],
        [
            5,
            5.571428571428571
        ],
        [
            6,
            6.545454545454546
        ],
        [
            7,
            5.909090909090909
        ],
        [
            8,
            7.333333333333333
        ],
        [
            9,
            7
        ],
        [
            10,
            7.857142857142857
        ],
        [
            11,
            8.076923076923077
        ],
        [
            12,
            7.5
        ],
        [
            15,
            8
        ]
    ],
    fineGrainedData: [
        [
            -5.399999999999977,
            8
        ],
        [
            -3.25,
            6
        ],
        [
            -2.5399999999999636,
            6
        ],
        [
            -2.169999999999959,
            7
        ],
        [
            -1.8999999999999773,
            7
        ],
        [
            -1.25,
            8
        ],
        [
            -1.1399999999999864,
            8
        ],
        [
            -1.1299999999999955,
            7
        ],
        [
            -1.1099999999999568,
            7
        ],
        [
            -1.099999999999966,
            7
        ],
        [
            -1.009999999999991,
            7.5
        ],
        [
            -0.9799999999999613,
            7
        ],
        [
            -0.9599999999999795,
            7
        ],
        [
            -0.7799999999999727,
            7
        ],
        [
            -0.7599999999999909,
            7
        ],
        [
            -0.6499999999999773,
            7
        ],
        [
            -0.6299999999999955,
            7
        ],
        [
            -0.6099999999999568,
            4
        ],
        [
            -0.589999999999975,
            6
        ],
        [
            -0.5600000000000023,
            6
        ],
        [
            -0.5499999999999545,
            7
        ],
        [
            -0.48999999999995225,
            7
        ],
        [
            -0.46999999999997044,
            8
        ],
        [
            -0.44999999999998863,
            7
        ],
        [
            -0.3299999999999841,
            7
        ],
        [
            -0.2899999999999636,
            7
        ],
        [
            -0.14999999999997726,
            7
        ],
        [
            -0.07999999999998408,
            5
        ],
        [
            0.05000000000001137,
            8
        ],
        [
            0.08000000000004093,
            6
        ],
        [
            0.12999999999999545,
            8
        ],
        [
            0.1400000000000432,
            7
        ],
        [
            0.17000000000001592,
            7
        ],
        [
            0.2300000000000182,
            7
        ],
        [
            0.32000000000005,
            6.5
        ],
        [
            0.37000000000000455,
            7
        ],
        [
            0.37999999999999545,
            7
        ],
        [
            0.4200000000000159,
            8
        ],
        [
            0.4300000000000068,
            8
        ],
        [
            0.4700000000000273,
            6
        ],
        [
            0.4900000000000091,
            7
        ],
        [
            0.8500000000000227,
            6
        ],
        [
            1,
            6
        ],
        [
            1.740000000000009,
            7
        ],
        [
            1.7900000000000205,
            6
        ],
        [
            2.590000000000032,
            2
        ],
        [
            2.7200000000000273,
            7
        ],
        [
            2.890000000000043,
            6
        ],
        [
            2.9399999999999977,
            7
        ],
        [
            3.230000000000018,
            7
        ],
        [
            3.390000000000043,
            3
        ],
        [
            3.420000000000016,
            4
        ],
        [
            3.5100000000000477,
            2
        ],
        [
            3.7000000000000455,
            6
        ],
        [
            4,
            4
        ],
        [
            4.220000000000027,
            4
        ],
        [
            4.260000000000048,
            7
        ],
        [
            4.670000000000016,
            6
        ],
        [
            4.730000000000018,
            6
        ],
        [
            4.75,
            7
        ],
        [
            4.770000000000039,
            7
        ],
        [
            4.830000000000041,
            6
        ],
        [
            5,
            6
        ],
        [
            5.060000000000002,
            5
        ],
        [
            5.1200000000000045,
            5
        ],
        [
            5.2000000000000455,
            7
        ],
        [
            5.32000000000005,
            6
        ],
        [
            5.350000000000023,
            5
        ],
        [
            5.360000000000014,
            6
        ],
        [
            5.3700000000000045,
            3
        ],
        [
            5.470000000000027,
            2
        ],
        [
            5.53000000000003,
            5.5
        ],
        [
            5.6299999999999955,
            8
        ],
        [
            5.760000000000048,
            7
        ],
        [
            5.78000000000003,
            6
        ],
        [
            5.830000000000041,
            6
        ],
        [
            5.860000000000014,
            8
        ],
        [
            5.939999999999998,
            5
        ],
        [
            6.160000000000025,
            8
        ],
        [
            6.390000000000043,
            6
        ],
        [
            6.480000000000018,
            7
        ],
        [
            6.53000000000003,
            4
        ],
        [
            6.560000000000002,
            7
        ],
        [
            6.640000000000043,
            6
        ],
        [
            6.689999999999998,
            8
        ],
        [
            6.740000000000009,
            7
        ],
        [
            6.7900000000000205,
            7
        ],
        [
            6.800000000000011,
            6
        ],
        [
            6.960000000000036,
            3
        ],
        [
            6.980000000000018,
            5
        ],
        [
            7.010000000000048,
            4
        ],
        [
            7.180000000000007,
            8
        ],
        [
            7.850000000000023,
            6
        ],
        [
            8.189999999999998,
            8
        ],
        [
            8.270000000000039,
            8
        ],
        [
            8.510000000000048,
            8
        ],
        [
            8.629999999999995,
            5
        ],
        [
            8.870000000000005,
            8
        ],
        [
            9.410000000000025,
            7
        ],
        [
            9.710000000000036,
            8
        ],
        [
            9.720000000000027,
            8
        ],
        [
            9.810000000000002,
            8
        ],
        [
            10.07000000000005,
            8
        ],
        [
            10.28000000000003,
            8
        ],
        [
            10.32000000000005,
            7
        ],
        [
            10.439999999999998,
            8
        ],
        [
            10.53000000000003,
            8
        ],
        [
            10.580000000000041,
            9
        ],
        [
            10.670000000000016,
            9
        ],
        [
            10.689999999999998,
            8
        ],
        [
            10.710000000000036,
            7
        ],
        [
            10.800000000000011,
            9
        ],
        [
            10.930000000000007,
            9
        ],
        [
            10.950000000000045,
            8
        ],
        [
            10.970000000000027,
            8
        ],
        [
            11,
            8
        ],
        [
            11.020000000000039,
            7.5
        ],
        [
            11.080000000000041,
            7
        ],
        [
            11.510000000000048,
            7
        ],
        [
            11.770000000000039,
            7
        ],
        [
            11.830000000000041,
            8
        ],
        [
            11.879999999999995,
            8
        ],
        [
            12.129999999999995,
            8
        ],
        [
            12.330000000000041,
            7.5
        ],
        [
            12.400000000000034,
            7
        ],
        [
            14.53000000000003,
            8
        ]
    ]
};
const $a777125387c77d7d$export$ac4b66a5382773f7 = {
    data: [
        {
            iconName: "sun",
            key: "Clear:sun:orange",
            moodColor: "rgb(0, 242, 186)",
            title: "Clear (average of 32 moods): 8.3",
            labelText: "Clear",
            weatherColor: "orange",
            y: 8.3
        },
        {
            iconName: "partly-cloudy-day",
            key: "Partly cloudy:partly-cloudy-day:orange",
            moodColor: "rgb(0, 240, 191)",
            title: "Partly cloudy (average of 29 moods): 7.9",
            labelText: "Partly cloudy",
            weatherColor: "orange",
            y: 7.9
        },
        {
            iconName: "snow",
            key: "Snow:snow:var(--color-balance-more)",
            moodColor: "rgb(0, 242, 186)",
            title: "Snow (average of 3 moods): 7.5",
            labelText: "Snow",
            weatherColor: "var(--color-balance-more)",
            y: 7.5
        },
        {
            iconName: "rain",
            key: "Rain:rain:#30f",
            moodColor: "rgb(0, 246, 166)",
            title: "Rain (average of 12 moods): 7.4",
            labelText: "Rain",
            weatherColor: "#30f",
            y: 7.4
        },
        {
            iconName: "drizzle",
            key: "Drizzle:drizzle:steelblue",
            moodColor: "rgb(0, 244, 176)",
            title: "Drizzle (average of 3 moods): 6.9",
            labelText: "Drizzle",
            weatherColor: "steelblue",
            y: 6.9
        },
        {
            iconName: "cloud",
            key: "Clouds:cloud:var(--color-balance-more)",
            moodColor: "rgb(0, 239, 197)",
            title: "Clouds (average of 43 moods): 6.3",
            labelText: "Clouds",
            weatherColor: "var(--color-balance-more)",
            y: 6.3
        },
        {
            iconName: "fog",
            key: "Fog/Haze/Dust:fog:var(--color-balance-more)",
            moodColor: "rgb(0, 239, 197)",
            title: "Fog/Haze/Dust (average of 19 moods): 6.2",
            labelText: "Fog/Haze/Dust",
            weatherColor: "var(--color-balance-more)",
            y: 6.2
        }
    ]
};
const $a777125387c77d7d$export$4f049843a47878b1 = {
    averages: [
        [
            "Mon",
            4.82
        ],
        [
            "Tue",
            5.51
        ],
        [
            "Wed",
            5.08
        ],
        [
            "Thu",
            6.73
        ],
        [
            "Fri",
            8.01
        ],
        [
            "Sat",
            8.17
        ],
        [
            "Sun",
            7.44
        ]
    ]
};
const $a777125387c77d7d$export$b4753b61a8000a01 = {
    data: [
        0,
        0,
        0,
        0,
        1,
        4,
        9,
        18,
        7,
        1,
        0
    ]
};
const $a777125387c77d7d$export$277009e1cb1d0d7a = {
    currentPeriod: {
        best: 9,
        mean: 7.8,
        meanSleep: 490,
        secondsMeditated: 1800,
        standardDeviation: 0.52,
        total: 31,
        worst: 6
    },
    previousPeriod: {
        best: 8,
        mean: 6.1,
        meanSleep: 450,
        secondsMeditated: 600,
        standardDeviation: 1.02,
        total: 31,
        worst: 4
    },
    periodType: "week"
};
const $a777125387c77d7d$export$eb8c4bd096f179ed = {
    "\uD83D\uDE04": 2,
    "\uD83D\uDE0A": 4,
    "\uD83D\uDE0C": 3,
    "\uD83D\uDE14": 2,
    "\uD83D\uDE16": 2,
    "\uD83D\uDE21": 1,
    "\uD83D\uDE42": 3,
    Afraid: 1,
    Agitated: 2,
    Amused: 2,
    Angry: 1,
    Annoyed: 1,
    Anxious: 2,
    Awe: 1,
    Busy: 2,
    Buzzing: 1,
    Calm: 3,
    Cathartic: 2,
    Compassionate: 1,
    Confused: 1,
    Connected: 3,
    Content: 1,
    Disappointed: 1,
    Doubtful: 1,
    Emotional: 1,
    Empty: 2,
    Energetic: 3,
    Excited: 5,
    Exhausted: 2,
    Expansive: 3,
    Free: 2,
    Fulfilled: 2,
    Gloomy: 4,
    Good: 4,
    Great: 3,
    Guilty: 1,
    Happy: 8,
    Healthy: 1,
    Hopeless: 1,
    Joyful: 5,
    Lonely: 1,
    Loss: 1,
    Lost: 1,
    Loving: 1,
    Merry: 1,
    Nervous: 1,
    Nostalgic: 1,
    Offended: 1,
    Open: 1,
    Peaceful: 1,
    Positive: 6,
    Proud: 1,
    Reflective: 2,
    Relaxed: 1,
    Relieved: 1,
    Restless: 1,
    Sad: 1,
    Satisfied: 1,
    Sentimental: 1,
    Sleepy: 1,
    Spacious: 1,
    Stressed: 2,
    Tense: 1,
    Tired: 3,
    Troubled: 1,
    Unhappy: 1,
    Unsure: 1,
    Upbeat: 1,
    Worried: 3,
    "Wound-up": 1
};








const $510fccb9fd1ebc06$var$RING_THICKNESS = 1 / 9;
const $510fccb9fd1ebc06$var$RADIUS = 0.4 - $510fccb9fd1ebc06$var$RING_THICKNESS / 2;
const $510fccb9fd1ebc06$var$CIRCUMFERENCE = 2 * $510fccb9fd1ebc06$var$RADIUS * Math.PI;
const $510fccb9fd1ebc06$var$TEXT_LENGTH = ($510fccb9fd1ebc06$var$RADIUS - $510fccb9fd1ebc06$var$RING_THICKNESS) * 2;
const $510fccb9fd1ebc06$var$TEXT_X = 0.5 - $510fccb9fd1ebc06$var$RADIUS + $510fccb9fd1ebc06$var$RING_THICKNESS;
function $510fccb9fd1ebc06$export$2e2bcd8739ae039({ remainingSeconds: remainingSeconds, totalSeconds: totalSeconds }) {
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("svg", {
        "aria-label": "Time remaining",
        viewBox: "0 0 1 1",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("circle", {
                cx: "0.5",
                cy: "0.5",
                fill: "transparent",
                r: $510fccb9fd1ebc06$var$RADIUS,
                stroke: "var(--color-ground)",
                strokeWidth: $510fccb9fd1ebc06$var$RING_THICKNESS
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("circle", {
                className: "meditation-timer-clock__circle",
                cx: "0.5",
                cy: "0.5",
                fill: "transparent",
                r: $510fccb9fd1ebc06$var$RADIUS,
                stroke: "var(--color-theme)",
                strokeDasharray: $510fccb9fd1ebc06$var$CIRCUMFERENCE,
                strokeDashoffset: remainingSeconds / totalSeconds * $510fccb9fd1ebc06$var$CIRCUMFERENCE,
                strokeWidth: $510fccb9fd1ebc06$var$RING_THICKNESS
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("text", {
                className: "meditation-timer-clock__text",
                fill: "var(--color-figure)",
                dy: "0.06",
                fontSize: "0.18",
                lengthAdjust: "spacingAndGlyphs",
                textLength: $510fccb9fd1ebc06$var$TEXT_LENGTH,
                x: $510fccb9fd1ebc06$var$TEXT_X,
                y: "0.5",
                children: (0, $c2e94012e82e0308$export$e0c93ebdf17e89e6)(remainingSeconds)
            })
        ]
    });
}











const $eed218311cb3b45e$var$addMoodImgSrc = String(new URL($e10ad73cf3bc3efe$exports));
function $eed218311cb3b45e$export$2e2bcd8739ae039() {
    const navigate = (0, $f02d97b5ca509f34$export$9770f232ac06a008)();
    const navigateToSignUp = ()=>navigate("/sign-up");
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039).Group, {
        children: [
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h2", {
                        children: "Welcome to MoodTracker!"
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("p", {
                        children: (0, $5a123094476b33d7$export$b8187a7ff42a2a5e)
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039).Group, {
                        children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039), {
                            onClick: navigateToSignUp,
                            type: "button",
                            children: "Sign up now to get started!"
                        })
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("p", {
                        children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("small", {
                            children: [
                                "If you already have an account you can",
                                " ",
                                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e94b7bcc277332d2$export$a6c7ac8248d6e38a), {
                                    "data-test-id": (0, $5a123094476b33d7$export$a2b4f255152a6585).signInLink,
                                    to: "/sign-in",
                                    children: "sign in here"
                                }),
                                "."
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("p", {
                        children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("small", {
                            children: "You will need to have an account and be signed in before you can start using the app offline."
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h2", {
                        children: "Features"
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h3", {
                        children: "Record how you feel and why"
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("img", {
                        alt: "Screenshot demonstrating adding a mood with an exploration",
                        src: $eed218311cb3b45e$var$addMoodImgSrc
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h3", {
                        children: "Analyze your mood over time"
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $29d007de3bd21b0d$export$2e2bcd8739ae039), {
                        ...(0, $a777125387c77d7d$export$163a8724bf6d6514)
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h3", {
                        children: "Describe how you feel and reflect on it"
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("p", {
                        children: "You can record a short description of your mood and reflect on it on a day-by-day, week-by-week, month-by-month or year-by-year basis."
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $59fee832cccbdf29$export$2e2bcd8739ae039), {
                        "aria-label": "Word cloud displaying mood descriptions",
                        words: (0, $a777125387c77d7d$export$eb8c4bd096f179ed)
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h3", {
                        children: "Review on a daily, weekly, monthly or yearly basis"
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("p", {
                        children: "Opt in to receive weekly email updates."
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $7791941d724bc7e1$export$2e2bcd8739ae039), {
                        ...(0, $a777125387c77d7d$export$277009e1cb1d0d7a),
                        showMeditationStatsOverride: true
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h3", {
                        children: "See how your mood fluctuates by day of the week"
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("p", {
                        children: "MoodTracker can analyze your data over time to give you insights about how the day of the week influences your mood."
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $15cd8902503c53d5$export$2e2bcd8739ae039), {
                        ...(0, $a777125387c77d7d$export$4f049843a47878b1)
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h3", {
                        children: "See how your mood fluctuates by the time of day"
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("p", {
                        children: "MoodTracker can also analyze your data over time to give you insights about how the time of day influences your mood. This can help you understand yourself better \uD83D\uDE0C"
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $f8fd573a29046e26$export$2e2bcd8739ae039), {
                        ...(0, $a777125387c77d7d$export$d88b449a795c08f0)
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h3", {
                        children: "See how the weather affects your mood"
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("p", {
                        children: "This functionality is only available if you opt in to recording your location. MoodTracker then figures out the weather based on where you were when you logged your mood."
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $1c3d89a2f6b44ad2$export$2e2bcd8739ae039), {
                        ...(0, $a777125387c77d7d$export$ac4b66a5382773f7)
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $89e828e6f365d470$export$2e2bcd8739ae039), {
                        ...(0, $a777125387c77d7d$export$a5efe817cf88255b)
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h3", {
                        children: "Meditate"
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("p", {
                        children: "MoodTracker has a built in meditation timer and meditation log so you can track your practice and see how it interacts with your mood over time."
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $510fccb9fd1ebc06$export$2e2bcd8739ae039), {
                        remainingSeconds: 222,
                        totalSeconds: 600
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h3", {
                        children: "Location"
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("p", {
                        children: [
                            "This functionality is only available if you opt in to recording your location. We have an easy to configure permissions system if you are privacy conscious (see the ",
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e94b7bcc277332d2$export$a6c7ac8248d6e38a), {
                                to: "/about",
                                children: "about page"
                            }),
                            " for our privacy policy)."
                        ]
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h4", {
                        children: "See where you were when you logged your mood or did your meditation"
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $3bda04436e25bcfb$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $3bda04436e25bcfb$export$2e2bcd8739ae039).Marker, {
                                latitude: 48.8566,
                                longitude: 2.3522
                            }),
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $3bda04436e25bcfb$export$2e2bcd8739ae039).Marker, {
                                latitude: 40.7128,
                                longitude: -74.006
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h4", {
                        children: "See your mood broken down by location"
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $98c14926387db14d$export$2e2bcd8739ae039), {
                        ...(0, $a777125387c77d7d$export$30bc0a6c1bfab02f)
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h3", {
                        children: "See how often you log moods"
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $ed295c5d011b3f58$export$2e2bcd8739ae039), {
                        ...(0, $a777125387c77d7d$export$b4753b61a8000a01)
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h3", {
                        children: "And much more!"
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("ul", {
                        children: [
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("li", {
                                children: "Track your mood, weight, meditation, sleep & location (including automatic weather tracking) and see how they are connected"
                            }),
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("li", {
                                children: "Set up daily push notifications to remind you to record your mood"
                            }),
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("li", {
                                children: "Set up weekly email reports"
                            }),
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("li", {
                                children: "Export your data at any time, put it in a spreadsheet or do whatever you want with it"
                            }),
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("li", {
                                children: "See how the moods you register before meditation differ from the ones you register after meditation"
                            }),
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("li", {
                                children: "Discover more visualizations and features by signing up!"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h2", {
                        children: "Find out more"
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("p", {
                        children: [
                            "Read about our ongoing development efforts on our",
                            " ",
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e94b7bcc277332d2$export$a6c7ac8248d6e38a), {
                                to: "/blog",
                                children: "blog"
                            }),
                            ", or check out our",
                            " ",
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e94b7bcc277332d2$export$a6c7ac8248d6e38a), {
                                to: "/about",
                                children: "about page"
                            }),
                            "."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h2", {
                        children: "Give it a go!"
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039).Group, {
                        children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039), {
                            onClick: navigateToSignUp,
                            type: "button",
                            children: "Sign up here"
                        })
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("p", {
                        children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("small", {
                            children: [
                                "Or ",
                                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e94b7bcc277332d2$export$a6c7ac8248d6e38a), {
                                    to: "/sign-in",
                                    children: "sign in"
                                }),
                                " if you already have an account."
                            ]
                        })
                    })
                ]
            })
        ]
    });
}






function $21b04a3942421245$export$eece74e2e913df01() {
    const navigate = (0, $f02d97b5ca509f34$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
        "data-test-id": (0, $5a123094476b33d7$export$a2b4f255152a6585).moodList,
        children: [
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h2", {
                children: "Home"
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("div", {
                className: "mood-list__add-links",
                children: [
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039), {
                        onClick: ()=>navigate("/add"),
                        children: [
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                                margin: "end",
                                name: "heart"
                            }),
                            "Add mood"
                        ]
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039), {
                        onClick: ()=>navigate("/sleep/add"),
                        children: [
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                                margin: "end",
                                name: "moon"
                            }),
                            "Add sleep"
                        ]
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039), {
                        onClick: ()=>navigate("/weight/add"),
                        children: [
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                                margin: "end",
                                name: "weight"
                            }),
                            "Add weight"
                        ]
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039), {
                        onClick: ()=>navigate("/meditation"),
                        children: [
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                                margin: "end",
                                name: "bell"
                            }),
                            "Meditate"
                        ]
                    })
                ]
            })
        ]
    });
}





function $2ae69482e6eada79$export$2e2bcd8739ae039() {
    const eventsHasLoadedFromServer = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.hasLoadedFromServer);
    const moods = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.normalizedMoods);
    const userIsSignedIn = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $9cfb09fae6dbced4$export$2e2bcd8739ae039).selectors.isSignedIn);
    const dateToday = (0, $c2e94012e82e0308$export$cba7498d83c2e2d)(new Date());
    const dateTomorrow = (0, $cb8fdbef2aba70f2$export$dd412b56f1e4d8aa)(dateToday, 1);
    if (!userIsSignedIn) return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $eed218311cb3b45e$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039).Group, {
        children: [
            eventsHasLoadedFromServer ? moods.allIds.length ? /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $21b04a3942421245$export$eece74e2e913df01), {}),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $8b7e9eb862378972$export$2e2bcd8739ae039), {
                        heading: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e94b7bcc277332d2$export$a6c7ac8248d6e38a), {
                            to: `/stats/days/${(0, $c2e94012e82e0308$export$f3013bcc8d8645bd)(dateToday)}`,
                            children: "Today's summary"
                        }),
                        dates: [
                            (0, $58b603c9eda836d4$export$70823084e2deb1ea)(dateToday, 1),
                            dateToday,
                            dateTomorrow
                        ]
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $b8f7cab810aad046$export$2e2bcd8739ae039), {})
                ]
            }) : /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $0df6bedbf9917577$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $b3bd040c14d4ce5c$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $94dd02c3a438e513$export$2e2bcd8739ae039), {})
        ]
    });
}








const $89fc2a5c49fede9a$var$PATHS_TO_HIDE_ON = [
    "/add",
    "/edit",
    "/meditation/open-ended",
    "/meditation/timer"
];
function $89fc2a5c49fede9a$export$2e2bcd8739ae039({ hide: hide }) {
    const { pathname: pathname } = (0, $f02d97b5ca509f34$export$45d76561a5302f2b)();
    const navigate = (0, $f02d97b5ca509f34$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $44af648581d9fabc$export$2e2bcd8739ae039), {
        hide: hide || $89fc2a5c49fede9a$var$PATHS_TO_HIDE_ON.some((path)=>pathname.startsWith(path)),
        onClick: ()=>navigate(`/add`),
        children: [
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                name: "plus",
                size: "4"
            }),
            "Add mood"
        ]
    });
}








function $6a066b9e5d9baa18$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("svg", {
        ...props,
        className: "m-icon",
        viewBox: "0 0 1 1",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("linearGradient", {
                        id: "gradient",
                        children: [
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("stop", {
                                offset: "25%",
                                stopColor: "var(--m-icon-color)"
                            }),
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("stop", {
                                offset: "95%",
                                stopColor: "hsl(210,100%,44.35%)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("filter", {
                        id: "shadow",
                        children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("feDropShadow", {
                            dx: "-0.01",
                            dy: "0.00",
                            stdDeviation: "0.005"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("g", {
                filter: "url(#shadow)",
                children: [
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("mask", {
                        id: "circles-mask",
                        children: [
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("rect", {
                                x: "0",
                                y: "0",
                                width: "100",
                                height: "100",
                                fill: "white"
                            }),
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("circle", {
                                cx: ".5",
                                cy: ".5",
                                r: ".065",
                                stroke: "black",
                                strokeWidth: "0.04",
                                fill: "none"
                            }),
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("circle", {
                                cx: ".5",
                                cy: ".5",
                                r: ".167",
                                stroke: "black",
                                strokeWidth: "0.045",
                                fill: "none"
                            }),
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("circle", {
                                cx: ".5",
                                cy: ".5",
                                r: ".29",
                                stroke: "black",
                                strokeWidth: "0.05",
                                fill: "none"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("circle", {
                        cx: ".5",
                        cy: ".5",
                        r: ".4",
                        strokeWidth: "0",
                        fill: "url(#gradient)",
                        mask: "url(#circles-mask)"
                    })
                ]
            })
        ]
    });
}









var $lBnVc = parcelRequire("lBnVc");
function $986699c33ccf5b69$export$2e2bcd8739ae039({ onClose: onClose, open: open }) {
    const idsToSync = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.idsToSync);
    const [isLoading, setIsLoading] = (0, $lBnVc.useState)(false);
    const handleSignOut = async ()=>{
        setIsLoading(true);
        await (0, $638633b4bc90b6fe$export$2e2bcd8739ae039)();
        onClose();
        setIsLoading(false);
    };
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $2b02ccd0ece868b7$export$2e2bcd8739ae039), {
        disableClose: isLoading,
        onClose: onClose,
        open: open,
        title: "Sign out?",
        children: [
            idsToSync.length ? /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("p", {
                children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("strong", {
                    children: "WARNING: some of your data has not yet been synced to the server and will be lost if you sign out now. If you don't want to lose any data please connect to the internet to sync before logging out."
                })
            }) : /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("p", {
                children: "Safe to sign out, all data is synced to the server."
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039).Group, {
                children: [
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039), {
                        danger: true,
                        "data-test-id": (0, $5a123094476b33d7$export$a2b4f255152a6585).signOutConfirmButton,
                        disabled: isLoading,
                        onClick: handleSignOut,
                        children: [
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                                margin: "end",
                                name: "sign-out"
                            }),
                            "Sign out"
                        ]
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039), {
                        disabled: isLoading,
                        onClick: onClose,
                        variant: "secondary",
                        children: [
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                                margin: "end",
                                name: "cross"
                            }),
                            "Cancel"
                        ]
                    })
                ]
            })
        ]
    });
}






function $685267ac25e531ae$export$2e2bcd8739ae039() {
    const isSyncingFromServer = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.isSyncingFromServer);
    const isSyncingToServer = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.isSyncingToServer);
    const syncFromServerError = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.syncFromServerError);
    const syncToServerError = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.syncToServerError);
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("div", {
        className: "m-nav__sync-state",
        children: [
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("p", {
                className: "center",
                children: syncFromServerError || syncToServerError ? /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
                    children: [
                        "Data saved locally",
                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                            draw: true,
                            margin: "start",
                            name: "save"
                        })
                    ]
                }) : isSyncingFromServer ? isSyncingToServer ? /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
                    children: [
                        "Syncing",
                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $b3bd040c14d4ce5c$export$2e2bcd8739ae039), {
                            inline: true,
                            margin: "start"
                        })
                    ]
                }) : /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
                    children: [
                        "Syncing from server",
                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $b3bd040c14d4ce5c$export$2e2bcd8739ae039), {
                            inline: true,
                            margin: "start"
                        })
                    ]
                }) : isSyncingToServer ? /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
                    children: [
                        "Syncing to server",
                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $b3bd040c14d4ce5c$export$2e2bcd8739ae039), {
                            inline: true,
                            margin: "start"
                        })
                    ]
                }) : /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
                    children: [
                        "Synced with server",
                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                            draw: true,
                            margin: "start",
                            name: "check"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("hr", {})
        ]
    });
}








var $lBnVc = parcelRequire("lBnVc");

function $9babf85fbd32ff71$export$2e2bcd8739ae039({ handleNavClose: handleNavClose, open: open }) {
    const hasMoods = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.hasMoods);
    const hasMeditations = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.hasMeditations);
    const hasSleeps = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.hasSleeps);
    const hasWeights = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.hasWeights);
    const userEmail = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $9cfb09fae6dbced4$export$2e2bcd8739ae039).selectors.email);
    const userIsSignedIn = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $9cfb09fae6dbced4$export$2e2bcd8739ae039).selectors.isSignedIn);
    const [isDialogOpen, setIsDialogOpen] = (0, $lBnVc.useState)(false);
    const handleDialogClose = ()=>{
        setIsDialogOpen(false);
        handleNavClose();
    };
    const now = new Date();
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b7447fff7bd4991b$export$2e2bcd8739ae039), {
                onClose: handleNavClose,
                open: open,
                children: [
                    userIsSignedIn && /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("div", {
                        className: "m-nav__header",
                        children: [
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("div", {
                                className: "m-profile",
                                children: [
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $6a066b9e5d9baa18$export$2e2bcd8739ae039), {
                                        className: "br-max bs-0"
                                    }),
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("b", {
                                        className: "m-profile__state",
                                        children: "Signed in"
                                    }),
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("em", {
                                        className: "m-profile__email",
                                        title: userEmail,
                                        children: userEmail
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("div", {
                                className: "m-nav__sign-out center",
                                children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039), {
                                    danger: true,
                                    "data-test-id": (0, $5a123094476b33d7$export$a2b4f255152a6585).signOutButton,
                                    onClick: ()=>setIsDialogOpen(true),
                                    type: "button",
                                    variant: "tertiary",
                                    children: [
                                        "Sign out",
                                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                                            name: "sign-out",
                                            margin: "start"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("hr", {})
                        ]
                    }),
                    userIsSignedIn && /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $685267ac25e531ae$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b7447fff7bd4991b$export$2e2bcd8739ae039).List, {
                        children: [
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b7447fff7bd4991b$export$2e2bcd8739ae039).Link, {
                                onClick: handleNavClose,
                                to: "/",
                                children: [
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                                        margin: "end",
                                        name: "home"
                                    }),
                                    "Home"
                                ]
                            }),
                            userIsSignedIn ? /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b7447fff7bd4991b$export$2e2bcd8739ae039).SubList, {
                                        heading: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("span", {
                                            children: [
                                                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                                                    margin: "end",
                                                    name: "heart"
                                                }),
                                                "Mood"
                                            ]
                                        }),
                                        children: [
                                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b7447fff7bd4991b$export$2e2bcd8739ae039).Link, {
                                                onClick: handleNavClose,
                                                to: "/add",
                                                children: [
                                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                                                        margin: "end",
                                                        name: "plus"
                                                    }),
                                                    "Add"
                                                ]
                                            }),
                                            hasMoods && /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b7447fff7bd4991b$export$2e2bcd8739ae039).Link, {
                                                onClick: handleNavClose,
                                                to: "/mood/log",
                                                children: [
                                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                                                        margin: "end",
                                                        name: "book"
                                                    }),
                                                    "Log"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b7447fff7bd4991b$export$2e2bcd8739ae039).SubList, {
                                        heading: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("span", {
                                            children: [
                                                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                                                    margin: "end",
                                                    name: "moon"
                                                }),
                                                "Sleep"
                                            ]
                                        }),
                                        children: [
                                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b7447fff7bd4991b$export$2e2bcd8739ae039).Link, {
                                                onClick: handleNavClose,
                                                to: "/sleep/add",
                                                children: [
                                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                                                        margin: "end",
                                                        name: "plus"
                                                    }),
                                                    "Add"
                                                ]
                                            }),
                                            hasSleeps && /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $c0c9bc5c50648c54$exports.Fragment), {
                                                children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b7447fff7bd4991b$export$2e2bcd8739ae039).Link, {
                                                    onClick: handleNavClose,
                                                    to: "/sleep/log",
                                                    children: [
                                                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                                                            margin: "end",
                                                            name: "book"
                                                        }),
                                                        "Log"
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b7447fff7bd4991b$export$2e2bcd8739ae039).SubList, {
                                        heading: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("span", {
                                            children: [
                                                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                                                    margin: "end",
                                                    name: "weight"
                                                }),
                                                "Weight"
                                            ]
                                        }),
                                        children: [
                                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b7447fff7bd4991b$export$2e2bcd8739ae039).Link, {
                                                onClick: handleNavClose,
                                                to: "/weight/add",
                                                children: [
                                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                                                        margin: "end",
                                                        name: "plus"
                                                    }),
                                                    "Add"
                                                ]
                                            }),
                                            hasWeights && /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $c0c9bc5c50648c54$exports.Fragment), {
                                                children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b7447fff7bd4991b$export$2e2bcd8739ae039).Link, {
                                                    onClick: handleNavClose,
                                                    to: "/weight/log",
                                                    children: [
                                                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                                                            margin: "end",
                                                            name: "book"
                                                        }),
                                                        "Log"
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b7447fff7bd4991b$export$2e2bcd8739ae039).SubList, {
                                        heading: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("span", {
                                            children: [
                                                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                                                    margin: "end",
                                                    name: "bell"
                                                }),
                                                "Meditation"
                                            ]
                                        }),
                                        children: [
                                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b7447fff7bd4991b$export$2e2bcd8739ae039).Link, {
                                                onClick: handleNavClose,
                                                to: "/meditation",
                                                children: [
                                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                                                        margin: "end",
                                                        name: "plus"
                                                    }),
                                                    "Add"
                                                ]
                                            }),
                                            hasMeditations && /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b7447fff7bd4991b$export$2e2bcd8739ae039).Link, {
                                                onClick: handleNavClose,
                                                to: "/meditation/log",
                                                children: [
                                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                                                        margin: "end",
                                                        name: "book"
                                                    }),
                                                    "Log"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b7447fff7bd4991b$export$2e2bcd8739ae039).SubList, {
                                        heading: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("span", {
                                            children: [
                                                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                                                    margin: "end",
                                                    name: "chart"
                                                }),
                                                "Stats"
                                            ]
                                        }),
                                        children: [
                                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b7447fff7bd4991b$export$2e2bcd8739ae039).Link, {
                                                onClick: handleNavClose,
                                                to: "/stats",
                                                children: [
                                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                                                        margin: "end",
                                                        name: "chart"
                                                    }),
                                                    "Overview"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b7447fff7bd4991b$export$2e2bcd8739ae039).Link, {
                                                onClick: handleNavClose,
                                                to: `/stats/days/${(0, $c2e94012e82e0308$export$f3013bcc8d8645bd)(now)}`,
                                                children: [
                                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                                                        margin: "end",
                                                        name: "chart"
                                                    }),
                                                    "Today"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b7447fff7bd4991b$export$2e2bcd8739ae039).Link, {
                                                onClick: handleNavClose,
                                                to: `/stats/weeks/${(0, $c2e94012e82e0308$export$f3013bcc8d8645bd)((0, $f2ddddaabfe67186$export$42c81a444fbfb5d4)(now, (0, $06d17fa75ca1067f$export$34c88de16c0a2653)))}`,
                                                children: [
                                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                                                        margin: "end",
                                                        name: "chart"
                                                    }),
                                                    "This week"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b7447fff7bd4991b$export$2e2bcd8739ae039).Link, {
                                                onClick: handleNavClose,
                                                to: `/stats/months/${(0, $c2e94012e82e0308$export$30a208a52f4a49de)(now)}`,
                                                children: [
                                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                                                        margin: "end",
                                                        name: "chart"
                                                    }),
                                                    "This month"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b7447fff7bd4991b$export$2e2bcd8739ae039).Link, {
                                                onClick: handleNavClose,
                                                to: `/stats/years/${(0, $c2e94012e82e0308$export$60b37fc597282c94)(now)}`,
                                                children: [
                                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                                                        margin: "end",
                                                        name: "chart"
                                                    }),
                                                    "This year"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b7447fff7bd4991b$export$2e2bcd8739ae039).Link, {
                                                onClick: handleNavClose,
                                                to: "/stats/explore",
                                                children: [
                                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                                                        margin: "end",
                                                        name: "chart"
                                                    }),
                                                    "Explore"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b7447fff7bd4991b$export$2e2bcd8739ae039).SubList, {
                                        heading: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("span", {
                                            children: [
                                                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                                                    margin: "end",
                                                    name: "settings"
                                                }),
                                                "Settings"
                                            ]
                                        }),
                                        children: [
                                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b7447fff7bd4991b$export$2e2bcd8739ae039).Link, {
                                                onClick: handleNavClose,
                                                to: "/settings/notifications",
                                                children: [
                                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                                                        margin: "end",
                                                        name: "bell"
                                                    }),
                                                    "Notifications"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b7447fff7bd4991b$export$2e2bcd8739ae039).Link, {
                                                onClick: handleNavClose,
                                                to: "/settings/location",
                                                children: [
                                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                                                        margin: "end",
                                                        name: "location"
                                                    }),
                                                    "Location"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b7447fff7bd4991b$export$2e2bcd8739ae039).Link, {
                                                onClick: handleNavClose,
                                                to: "/settings/export",
                                                children: [
                                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                                                        margin: "end",
                                                        name: "download"
                                                    }),
                                                    "Export data"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b7447fff7bd4991b$export$2e2bcd8739ae039).Link, {
                                                onClick: handleNavClose,
                                                to: "/settings/change-password",
                                                children: [
                                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                                                        margin: "end",
                                                        name: "lock"
                                                    }),
                                                    "Change password"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b7447fff7bd4991b$export$2e2bcd8739ae039).Link, {
                                                onClick: handleNavClose,
                                                to: "/settings/change-email",
                                                children: [
                                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                                                        margin: "end",
                                                        name: "at-sign"
                                                    }),
                                                    "Change email"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b7447fff7bd4991b$export$2e2bcd8739ae039).Link, {
                                onClick: handleNavClose,
                                to: "/sign-in",
                                children: [
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                                        margin: "end",
                                        name: "key"
                                    }),
                                    "Sign in"
                                ]
                            }),
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b7447fff7bd4991b$export$2e2bcd8739ae039).Link, {
                                onClick: handleNavClose,
                                to: "/blog",
                                children: [
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                                        margin: "end",
                                        name: "book"
                                    }),
                                    "Blog"
                                ]
                            }),
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b7447fff7bd4991b$export$2e2bcd8739ae039).SubList, {
                                heading: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("span", {
                                    children: [
                                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                                            margin: "end",
                                            name: "help"
                                        }),
                                        "About"
                                    ]
                                }),
                                children: [
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b7447fff7bd4991b$export$2e2bcd8739ae039).Link, {
                                        onClick: handleNavClose,
                                        to: "/about",
                                        children: [
                                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                                                margin: "end",
                                                name: "help"
                                            }),
                                            "Overview"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b7447fff7bd4991b$export$2e2bcd8739ae039).Link, {
                                        onClick: handleNavClose,
                                        to: "/about/usage",
                                        children: [
                                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                                                margin: "end",
                                                name: "chart"
                                            }),
                                            "Usage"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b7447fff7bd4991b$export$2e2bcd8739ae039).Link, {
                                        onClick: handleNavClose,
                                        to: "/about/privacy-policy",
                                        children: [
                                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                                                margin: "end",
                                                name: "eye"
                                            }),
                                            "Privacy policy"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b7447fff7bd4991b$export$2e2bcd8739ae039).Link, {
                                onClick: handleNavClose,
                                to: "/see-also",
                                children: [
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                                        margin: "end",
                                        name: "link"
                                    }),
                                    "See also"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $986699c33ccf5b69$export$2e2bcd8739ae039), {
                onClose: handleDialogClose,
                open: isDialogOpen
            })
        ]
    });
}









var $lBnVc = parcelRequire("lBnVc");


function $a9d4b4c52bb8093a$export$2e2bcd8739ae039() {
    const eventsById = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.byId);
    const eventsIdsToSync = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.idsToSync);
    const eventsNextCursor = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.nextCursor);
    const isStorageLoading = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $4a1b4f367ad149f7$export$2e2bcd8739ae039).selectors.isStorageLoading);
    const isSyncingFromServer = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.isSyncingFromServer);
    const isSyncingToServer = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.isSyncingToServer);
    const userEmail = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $9cfb09fae6dbced4$export$2e2bcd8739ae039).selectors.email);
    const userIsSignedIn = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $9cfb09fae6dbced4$export$2e2bcd8739ae039).selectors.isSignedIn);
    const dispatch = (0, $d3287b130d7b0f6b$export$8ad76b76a4c905f8)();
    const syncFromServer = ()=>void (async ()=>{
            if (!userIsSignedIn || isSyncingFromServer || isStorageLoading) return;
            try {
                let cursor = eventsNextCursor;
                let isPaginating = true;
                while(isPaginating){
                    dispatch((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).actions.syncFromServerStart());
                    const { events: serverEvents, hasNextPage: hasNextPage, nextCursor: nextCursor } = await (0, $4b6cae14f235e72b$export$60e88f1a377f61c6)(cursor);
                    cursor = nextCursor;
                    isPaginating = hasNextPage;
                    dispatch((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).actions.syncFromServerSuccess({
                        cursor: cursor,
                        events: serverEvents
                    }));
                }
            } catch (e) {
                (0, $24a8d9ab78e4f062$export$f5282963edea4a68)(e);
                dispatch((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).actions.syncFromServerError());
            }
        })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $lBnVc.useEffect)(syncFromServer, [
        isStorageLoading,
        userEmail
    ]);
    (0, $6e4aba82666a9c9f$export$2e2bcd8739ae039)(syncFromServer, 6e4);
    (0, $lBnVc.useEffect)(()=>{
        const handleVisibilityChange = ()=>{
            if (document.visibilityState === "visible") syncFromServer();
        };
        window.addEventListener("visibilitychange", handleVisibilityChange);
        return ()=>{
            window.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    });
    const syncToServer = ()=>void (async ()=>{
            if (!userIsSignedIn || isSyncingToServer || isStorageLoading || !eventsIdsToSync.length) return;
            dispatch((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).actions.syncToServerStart());
            try {
                await (0, $4b6cae14f235e72b$export$53537e53b6ef0786)(eventsIdsToSync.map((id)=>eventsById[id]));
                dispatch((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).actions.syncToServerSuccess());
            } catch  {
                dispatch((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).actions.syncToServerError());
            }
        })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $lBnVc.useEffect)(syncToServer, [
        eventsIdsToSync,
        isStorageLoading,
        userEmail
    ]);
    (0, $6e4aba82666a9c9f$export$2e2bcd8739ae039)(syncToServer, 1e4);
}




var $lBnVc = parcelRequire("lBnVc");




var $lBnVc = parcelRequire("lBnVc");
let $b520a96ab6c6e75e$var$userActivation;
if ("userActivation" in navigator) // eslint-disable-next-line @typescript-eslint/no-explicit-any
$b520a96ab6c6e75e$var$userActivation = navigator.userActivation;
else {
    // https://html.spec.whatwg.org/multipage/interaction.html#activation-triggering-input-event
    const ACTIVATION_TRIGGERING_INPUT_EVENTS = [
        "keydown",
        "mousedown",
        "pointerdown",
        "pointerup",
        "touchend"
    ];
    $b520a96ab6c6e75e$var$userActivation = {
        hasBeenActive: false
    };
    const handleUserGesture = (e)=>{
        if (!e.isTrusted || e instanceof PointerEvent && e.pointerType !== "mouse") return;
        $b520a96ab6c6e75e$var$userActivation.hasBeenActive = true;
        for (const inputType of ACTIVATION_TRIGGERING_INPUT_EVENTS)document.documentElement.removeEventListener(inputType, handleUserGesture);
    };
    for (const inputType of ACTIVATION_TRIGGERING_INPUT_EVENTS)document.documentElement.addEventListener(inputType, handleUserGesture);
}
function $b520a96ab6c6e75e$export$2e2bcd8739ae039() {
    const [hasBeenActive, setHasBeenActive] = (0, $lBnVc.useState)(false);
    (0, $6e4aba82666a9c9f$export$2e2bcd8739ae039)((clear)=>{
        if (hasBeenActive || !$b520a96ab6c6e75e$var$userActivation.hasBeenActive) return;
        clear();
        setHasBeenActive(true);
    }, 1e2);
    return hasBeenActive;
}


function $ccd24971fb14f5d6$export$2e2bcd8739ae039() {
    const shouldRecordLocation = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $cc3689f5d10378f4$export$2e2bcd8739ae039).selectors.recordLocation);
    const dispatch = (0, $d3287b130d7b0f6b$export$8ad76b76a4c905f8)();
    const hasBeenActive = (0, $b520a96ab6c6e75e$export$2e2bcd8739ae039)();
    const idRef = (0, $lBnVc.useRef)();
    (0, $lBnVc.useEffect)(()=>{
        if (!hasBeenActive) return;
        if (!shouldRecordLocation) {
            if (idRef.current !== undefined) navigator.geolocation.clearWatch(idRef.current);
            dispatch((0, $2f1313f9e65d1ec4$export$2e2bcd8739ae039).actions.clear());
            return;
        }
        idRef.current = navigator.geolocation.watchPosition(({ coords: { accuracy: accuracy, altitude: altitude, altitudeAccuracy: altitudeAccuracy, latitude: latitude, longitude: longitude } })=>{
            const geolocation = {
                // meters
                accuracy: Math.round(accuracy),
                // Should be accurate to around 10 meters https://en.wikipedia.org/wiki/Decimal_degrees#Precision
                // This should be sufficient given the accuracy value is typically in excess of that
                latitude: Number(latitude.toFixed(4)),
                longitude: Number(longitude.toFixed(4))
            };
            if (altitude !== null) {
                geolocation.altitude = Math.round(altitude);
                if (altitudeAccuracy !== null) geolocation.altitudeAccuracy = Math.round(altitudeAccuracy);
            }
            dispatch((0, $2f1313f9e65d1ec4$export$2e2bcd8739ae039).actions.setGeolocation(geolocation));
        });
    }, [
        dispatch,
        hasBeenActive,
        shouldRecordLocation
    ]);
}





var $lBnVc = parcelRequire("lBnVc");


function $9651e33a8fb5b620$export$2feeb2629cbd4d83() {
    const { pathname: pathname } = (0, $f02d97b5ca509f34$export$45d76561a5302f2b)();
    const lastPathnameRef = (0, $lBnVc.useRef)();
    (0, $lBnVc.useEffect)(()=>{
        if (lastPathnameRef.current !== undefined && lastPathnameRef.current !== pathname) (0, $073bb8f40de3ad76$export$2e2bcd8739ae039)();
        lastPathnameRef.current = pathname;
    }, [
        pathname
    ]);
}



var $lBnVc = parcelRequire("lBnVc");


var $lBnVc = parcelRequire("lBnVc");





const $8d8adf5bcc24edcd$var$APPLICATION_NAME = "moodtracker";
const $8d8adf5bcc24edcd$var$USER_KEY = `${$8d8adf5bcc24edcd$var$APPLICATION_NAME}:user`;
const $8d8adf5bcc24edcd$var$makeEventsKey = (userId)=>`${$8d8adf5bcc24edcd$var$APPLICATION_NAME}:${userId}:events`;
const $8d8adf5bcc24edcd$var$makeSettingsKey = (userId)=>`${$8d8adf5bcc24edcd$var$APPLICATION_NAME}:${userId}:settings`;
var $8d8adf5bcc24edcd$export$2e2bcd8739ae039 = {
    // events
    deleteEvents: (userId)=>(0, $a79fa34021646067$export$1d2f21e549771e67)($8d8adf5bcc24edcd$var$makeEventsKey(userId)),
    setEvents: (userId, events)=>(0, $a79fa34021646067$export$adaa4cf7ef1b65be)($8d8adf5bcc24edcd$var$makeEventsKey(userId), events),
    // user
    deleteUser: ()=>(0, $a79fa34021646067$export$1d2f21e549771e67)($8d8adf5bcc24edcd$var$USER_KEY),
    getUser: ()=>(0, $a79fa34021646067$export$3988ae62b71be9a3)($8d8adf5bcc24edcd$var$USER_KEY),
    setUser: (user)=>(0, $a79fa34021646067$export$adaa4cf7ef1b65be)($8d8adf5bcc24edcd$var$USER_KEY, user),
    // events & settings
    setEventsAndSettings: (userId, events, settings)=>(0, $a79fa34021646067$export$daa0a5170277c7a8)([
            [
                $8d8adf5bcc24edcd$var$makeEventsKey(userId),
                events
            ],
            [
                $8d8adf5bcc24edcd$var$makeSettingsKey(userId),
                settings
            ]
        ]),
    getEventsAndSettings: (userId)=>(0, $a79fa34021646067$export$5df405cccea42673)([
            $8d8adf5bcc24edcd$var$makeEventsKey(userId),
            $8d8adf5bcc24edcd$var$makeSettingsKey(userId)
        ])
};




function $17cd25fbe07d886f$export$2e2bcd8739ae039() {
    const navigate = (0, $f02d97b5ca509f34$export$9770f232ac06a008)();
    const eventsAllIds = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.allIds);
    const eventsById = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.byId);
    const eventsHasLoadedFromServer = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.hasLoadedFromServer);
    const eventsIdsToSync = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.idsToSync);
    const eventsNextCursor = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.nextCursor);
    const isStorageLoading = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $4a1b4f367ad149f7$export$2e2bcd8739ae039).selectors.isStorageLoading);
    const settingsData = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $cc3689f5d10378f4$export$2e2bcd8739ae039).selectors.data);
    const userEmail = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $9cfb09fae6dbced4$export$2e2bcd8739ae039).selectors.email);
    const userId = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $9cfb09fae6dbced4$export$2e2bcd8739ae039).selectors.id);
    const userLoading = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $9cfb09fae6dbced4$export$2e2bcd8739ae039).selectors.loading);
    const dispatch = (0, $d3287b130d7b0f6b$export$8ad76b76a4c905f8)();
    const lastUserId = (0, $lBnVc.useRef)();
    // handle user sign out
    if (lastUserId.current && !userId) {
        (0, $8d8adf5bcc24edcd$export$2e2bcd8739ae039).deleteEvents(lastUserId.current);
        navigate("/");
    }
    lastUserId.current = userId;
    // save/clear user
    (0, $lBnVc.useEffect)(()=>{
        if (userLoading) return;
        if (!userEmail || !userId) (0, $8d8adf5bcc24edcd$export$2e2bcd8739ae039).deleteUser();
        else (0, $8d8adf5bcc24edcd$export$2e2bcd8739ae039).setUser({
            email: userEmail,
            id: userId
        });
    }, [
        userEmail,
        userLoading,
        userId
    ]);
    // load events & settings
    (0, $lBnVc.useEffect)(()=>{
        if (userLoading || !isStorageLoading) return;
        (async ()=>{
            if (!userId) return dispatch((0, $4a1b4f367ad149f7$export$2e2bcd8739ae039).actions.storageLoaded());
            try {
                const result = await Promise.race([
                    (0, $8d8adf5bcc24edcd$export$2e2bcd8739ae039).getEventsAndSettings(userId),
                    new Promise((resolve)=>setTimeout(resolve, 5e3))
                ]);
                if (result === undefined) {
                    const error = Error("Storage did not load within 5 seconds");
                    (0, $24a8d9ab78e4f062$export$f5282963edea4a68)(error);
                    throw error;
                }
                const [events, settings] = result;
                if (events) dispatch((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).actions.loadFromStorage(events));
                if (settings) dispatch((0, $cc3689f5d10378f4$export$2e2bcd8739ae039).actions.loadFromStorage(settings));
            } finally{
                dispatch((0, $4a1b4f367ad149f7$export$2e2bcd8739ae039).actions.storageLoaded());
            }
        })();
    }, [
        dispatch,
        isStorageLoading,
        userId,
        userLoading
    ]);
    // save events & settings
    (0, $lBnVc.useEffect)(()=>{
        if (isStorageLoading || !userId) return;
        const eventsData = {
            allIds: eventsAllIds,
            byId: eventsById,
            hasLoadedFromServer: eventsHasLoadedFromServer,
            idsToSync: eventsIdsToSync,
            nextCursor: eventsNextCursor
        };
        if (settingsData) return void (0, $8d8adf5bcc24edcd$export$2e2bcd8739ae039).setEventsAndSettings(userId, eventsData, settingsData);
        (0, $8d8adf5bcc24edcd$export$2e2bcd8739ae039).setEvents(userId, eventsData);
    }, [
        eventsAllIds,
        eventsById,
        eventsHasLoadedFromServer,
        eventsIdsToSync,
        eventsNextCursor,
        isStorageLoading,
        settingsData,
        userId
    ]);
}








var $lBnVc = parcelRequire("lBnVc");
function $ab660ef08d4af1d2$export$2e2bcd8739ae039() {
    const dispatch = (0, $d3287b130d7b0f6b$export$8ad76b76a4c905f8)();
    (0, $lBnVc.useEffect)(()=>void (async ()=>{
            let storedUser;
            try {
                // Fails in Firefox private browsing
                storedUser = await (0, $8d8adf5bcc24edcd$export$2e2bcd8739ae039).getUser();
            } catch  {
                dispatch((0, $9cfb09fae6dbced4$export$2e2bcd8739ae039).actions.clear());
                dispatch((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).actions.clear());
                return;
            }
            if (storedUser) dispatch((0, $9cfb09fae6dbced4$export$2e2bcd8739ae039).actions.set(storedUser));
            try {
                const idToken = await (0, $97fc43514b4d4584$export$393ade1005606e67)();
                if (!storedUser || storedUser.email !== idToken.payload.email || storedUser.id !== idToken.payload.sub) dispatch((0, $9cfb09fae6dbced4$export$2e2bcd8739ae039).actions.set({
                    email: idToken.payload.email,
                    id: idToken.payload.sub
                }));
            } catch (e) {
                if (e instanceof Error && e.message !== "No current user") return;
                dispatch((0, $9cfb09fae6dbced4$export$2e2bcd8739ae039).actions.clear());
                dispatch((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).actions.clear());
            }
        })(), [
        dispatch
    ]);
}



function $e250444002f590bc$export$2e2bcd8739ae039() {
    (0, $9651e33a8fb5b620$export$2feeb2629cbd4d83)();
    (0, $ab660ef08d4af1d2$export$2e2bcd8739ae039)();
    (0, $ccd24971fb14f5d6$export$2e2bcd8739ae039)();
    (0, $a9d4b4c52bb8093a$export$2e2bcd8739ae039)();
    (0, $17cd25fbe07d886f$export$2e2bcd8739ae039)();
    (0, $24a8d9ab78e4f062$export$208a507d199ad5b2)();
    const userIsSignedIn = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $9cfb09fae6dbced4$export$2e2bcd8739ae039).selectors.isSignedIn);
    const [isNavOpen, setIsNavOpen] = (0, $lBnVc.useState)(false);
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c96d31531953528e$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h1", {
                        children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e94b7bcc277332d2$export$a6c7ac8248d6e38a), {
                            to: "/",
                            children: "MoodTracker"
                        })
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $b7447fff7bd4991b$export$2e2bcd8739ae039).Button, {
                        "data-test-id": (0, $5a123094476b33d7$export$a2b4f255152a6585).navButton,
                        onClick: ()=>setIsNavOpen(true)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $9babf85fbd32ff71$export$2e2bcd8739ae039), {
                handleNavClose: ()=>setIsNavOpen(false),
                open: isNavOpen
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("main", {
                children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $f02d97b5ca509f34$export$910ae8079b2c2852), {})
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $89fc2a5c49fede9a$export$2e2bcd8739ae039), {
                hide: !userIsSignedIn
            }),
            userIsSignedIn && /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $6e81c212129c1867$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $6e81c212129c1867$export$2e2bcd8739ae039).Link, {
                        "aria-label": "Home",
                        to: "/",
                        children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                            name: "home",
                            size: "3"
                        })
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $6e81c212129c1867$export$2e2bcd8739ae039).Link, {
                        "aria-label": "Statistics",
                        to: "/stats",
                        children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                            name: "chart",
                            size: "3"
                        })
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $6e81c212129c1867$export$2e2bcd8739ae039).Link, {
                        "aria-label": "Meditate",
                        to: "/meditation",
                        children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                            name: "bell",
                            size: "3"
                        })
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $6e81c212129c1867$export$2e2bcd8739ae039).Link, {
                        "aria-label": "Add new mood",
                        to: "/add",
                        children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                            name: "heart",
                            size: "3"
                        })
                    })
                ]
            })
        ]
    });
}





function $04a1b09f5d72bb3c$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039).Group, {
        children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h2", {
                    children: "Location"
                }),
                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e1680580b4b89fb5$export$2e2bcd8739ae039), {})
            ]
        })
    });
}








var $lBnVc = parcelRequire("lBnVc");
const $a63a2c7303de2d4c$var$MAX_MINUTES = 180;
const $a63a2c7303de2d4c$var$MINUTES_INPUT_NAME = "minutes";
const $a63a2c7303de2d4c$var$TIMES = [
    1,
    2,
    3,
    5,
    10,
    15,
    20,
    30,
    40
];
function $a63a2c7303de2d4c$export$2e2bcd8739ae039() {
    const navigate = (0, $f02d97b5ca509f34$export$9770f232ac06a008)();
    const [error, setError] = (0, $lBnVc.useState)("");
    const navigateToTimer = (minutes)=>void navigate(`/meditation/timer?${(0, $5a123094476b33d7$export$3b818226f8d6346d)}=${minutes * (0, $5a123094476b33d7$export$a9905336c0111a3a).secondsPerMinute}`);
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039).Group, {
        "data-test-id": (0, $5a123094476b33d7$export$a2b4f255152a6585).meditatePage,
        children: [
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h2", {
                        children: "Meditate"
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("p", {
                        children: "This is a place where you can meditate. Select a preset time, enter a custom time or meditate freely with no fixed time. Once your meditation is finished you will have the opportunity to record it if you choose."
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("p", {
                        children: "Record your mood before and after to see how meditation changes things for you."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h3", {
                        children: "Presets"
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("div", {
                        className: "m-meditate__preset_group",
                        children: $a63a2c7303de2d4c$var$TIMES.map((minutes)=>/*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039), {
                                "data-minutes": minutes,
                                "data-test-id": (0, $5a123094476b33d7$export$a2b4f255152a6585).meditationPresetTimeButton,
                                onClick: ()=>navigateToTimer(minutes),
                                variant: "secondary",
                                children: [
                                    minutes,
                                    " min",
                                    minutes === 1 ? "" : "s"
                                ]
                            }, minutes))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h3", {
                        children: "Open-ended meditation"
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("p", {
                        children: "Meditate for however long you like"
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039).Group, {
                        children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039), {
                            onClick: ()=>navigate("/meditation/open-ended"),
                            type: "button",
                            children: "Start"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("form", {
                    noValidate: true,
                    onSubmit: (e)=>{
                        e.preventDefault();
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        const { validity: validity, value: value } = e.target[$a63a2c7303de2d4c$var$MINUTES_INPUT_NAME];
                        const requiredError = validity.valueMissing;
                        const patternError = validity.patternMismatch;
                        const minutes = Number(value);
                        let errorMessage = "";
                        if (requiredError) errorMessage = (0, $5a123094476b33d7$export$4fd720569787ab6f).required;
                        else if (patternError) errorMessage = (0, $5a123094476b33d7$export$4fd720569787ab6f).integer;
                        else if (minutes > $a63a2c7303de2d4c$var$MAX_MINUTES) errorMessage = `The maximum allowed time is ${$a63a2c7303de2d4c$var$MAX_MINUTES} minutes`;
                        if (!errorMessage) navigateToTimer(minutes);
                        setError(errorMessage);
                    },
                    children: [
                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h3", {
                            children: "Custom time"
                        }),
                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("p", {
                            children: "Set a custom time for your meditation here"
                        }),
                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $78053ee2024d275e$export$2e2bcd8739ae039), {
                            "data-test-id": (0, $5a123094476b33d7$export$a2b4f255152a6585).meditationCustomTimeInput,
                            inputMode: "numeric",
                            error: error,
                            label: "Minutes",
                            maxLength: 3,
                            pattern: "[0-9]*",
                            name: $a63a2c7303de2d4c$var$MINUTES_INPUT_NAME
                        }),
                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039).Group, {
                            children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039), {
                                children: "Start"
                            })
                        })
                    ]
                })
            })
        ]
    });
}














function $564e0a58ed0ac343$export$2e2bcd8739ae039({ id: id, onDelete: onDelete }) {
    const meditations = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.normalizedMeditations);
    const meditation = meditations.byId[id];
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $7c1560fa3a8ca778$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("div", {
            className: "m-meditation-card",
            children: [
                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("div", {
                    children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("small", {
                        children: [
                            (0, $06d17fa75ca1067f$export$59113f23fb667b84).format(new Date(id)),
                            meditation.location && /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("br", {}),
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $bdc0446275c44834$export$2e2bcd8739ae039), {
                                        latitude: meditation.location.latitude,
                                        longitude: meditation.location.longitude,
                                        successPostfix: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("br", {})
                                    }),
                                    "Latitude:",
                                    " ",
                                    (0, $035f270eea0b2c1d$export$55cce6e1b8cd4208).format(meditation.location.latitude),
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("br", {}),
                                    "Longitude:",
                                    " ",
                                    (0, $035f270eea0b2c1d$export$55cce6e1b8cd4208).format(meditation.location.longitude),
                                    meditation.location.altitude && /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("br", {}),
                                            "Altitude:",
                                            " ",
                                            (0, $035f270eea0b2c1d$export$73f799d1a16dbca4).format(meditation.location.altitude)
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("div", {
                    className: "center",
                    children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("b", {
                        children: (0, $c2e94012e82e0308$export$e0c93ebdf17e89e6)(meditation.seconds)
                    })
                }),
                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("div", {
                    children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039), {
                        danger: true,
                        onClick: onDelete,
                        type: "button",
                        variant: "tertiary",
                        children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                            "aria-label": "Delete",
                            margin: "end",
                            name: "cross",
                            size: "3"
                        })
                    })
                })
            ]
        })
    });
}









function $25df2facdc0b621e$export$2e2bcd8739ae039({ id: id, onClose: onClose, open: open }) {
    const dispatch = (0, $d3287b130d7b0f6b$export$8ad76b76a4c905f8)();
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $2b02ccd0ece868b7$export$2e2bcd8739ae039), {
        onClose: onClose,
        open: open,
        title: "Delete log?",
        children: [
            id && /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("p", {
                children: [
                    (0, $06d17fa75ca1067f$export$59113f23fb667b84).format(new Date(id)),
                    " (",
                    (0, $82fe5d0003ae257e$export$d130c20a256f8817)(new Date(id)),
                    " ago)"
                ]
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039).Group, {
                children: [
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039), {
                        danger: true,
                        onClick: ()=>{
                            if (!id) {
                                (0, $24a8d9ab78e4f062$export$f5282963edea4a68)(Error("Dialog button was pressed while dialog was closed"));
                                return;
                            }
                            dispatch((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).actions.add({
                                type: "v1/meditations/delete",
                                createdAt: new Date().toISOString(),
                                payload: id
                            }));
                            onClose();
                        },
                        children: [
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                                margin: "end",
                                name: "trash"
                            }),
                            "Delete"
                        ]
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039), {
                        onClick: onClose,
                        variant: "secondary",
                        children: [
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                                margin: "end",
                                name: "cross"
                            }),
                            "Cancel"
                        ]
                    })
                ]
            })
        ]
    });
}






var $lBnVc = parcelRequire("lBnVc");
const $dd3b88e3ddb8f7ea$var$MAX_ITEMS_PER_PAGE = 10;
function $dd3b88e3ddb8f7ea$export$2e2bcd8739ae039() {
    const meditations = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.normalizedMeditations);
    const denormalizedMeditations = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.denormalizedMeditations);
    const [dialogId, setDialogId] = (0, $lBnVc.useState)();
    const [isOpen, setIsOpen] = (0, $lBnVc.useState)(false);
    const [page, setPage] = (0, $lBnVc.useState)(0);
    const pageCount = Math.ceil(meditations.allIds.length / $dd3b88e3ddb8f7ea$var$MAX_ITEMS_PER_PAGE);
    const endIndex = meditations.allIds.length - $dd3b88e3ddb8f7ea$var$MAX_ITEMS_PER_PAGE * page;
    const startIndex = Math.max(0, endIndex - $dd3b88e3ddb8f7ea$var$MAX_ITEMS_PER_PAGE);
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039).Group, {
        children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h2", {
                    children: "Meditation log"
                }),
                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("h3", {
                    children: [
                        "Export",
                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $19d86a636b501d10$export$2e2bcd8739ae039), {
                            children: "Export all your meditations (choose CSV format if you want to load your data into a spreadsheet)"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $d4552df15b9ab2b8$export$2e2bcd8739ae039), {
                    category: "meditations",
                    denormalizedData: denormalizedMeditations
                }),
                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("h3", {
                    children: [
                        "Log",
                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $19d86a636b501d10$export$2e2bcd8739ae039), {
                            children: "View, edit or delete all your logged meditations"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $7c1560fa3a8ca778$export$2e2bcd8739ae039).Group, {
                    children: (0, $c2e94012e82e0308$export$7ff0d353c23134fe)(meditations.allIds.slice(startIndex, endIndex), (id)=>/*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $564e0a58ed0ac343$export$2e2bcd8739ae039), {
                            id: id,
                            onDelete: ()=>{
                                setDialogId(id);
                                setIsOpen(true);
                            }
                        }, id))
                }),
                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $64123a2209d9f6c7$export$2e2bcd8739ae039), {
                    onChange: setPage,
                    page: page,
                    pageCount: pageCount
                }),
                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $25df2facdc0b621e$export$2e2bcd8739ae039), {
                    id: dialogId,
                    onClose: ()=>setIsOpen(false),
                    open: isOpen
                })
            ]
        })
    });
}



const $e417414438b2d4e2$export$d4c72bab9d6cc13a = {
    isDialogOpen: false,
    isDimmerEnabled: false,
    remainingTime: undefined,
    timeFinished: undefined,
    timerState: "TIMING"
};
const $e417414438b2d4e2$export$1650419e431d3ba3 = (state, action)=>{
    switch(action.type){
        case "isDialogOpen/set":
            return {
                ...state,
                isDialogOpen: action.payload
            };
        case "isDimmerEnabled/set":
            return {
                ...state,
                isDimmerEnabled: action.payload
            };
        case "remainingTime/set":
            return {
                ...state,
                remainingTime: action.payload
            };
        case "timeFinished/set":
            return {
                isDialogOpen: false,
                isDimmerEnabled: false,
                remainingTime: 0,
                timeFinished: action.payload,
                timerState: "FINISHED"
            };
        case "timerState/set":
            return {
                ...state,
                timerState: action.payload
            };
    }
};




var $lBnVc = parcelRequire("lBnVc");






/**
 * The {@link formatDuration} function options.
 */ const $1a058d2719b5b038$var$defaultFormat = [
    "years",
    "months",
    "weeks",
    "days",
    "hours",
    "minutes",
    "seconds"
];
function $1a058d2719b5b038$export$bc733b0c5cbb3e8a(duration, options) {
    const defaultOptions = (0, $6fc64aba02a3bdcd$export$430a3269e24b912e)();
    const locale = options?.locale ?? defaultOptions.locale ?? (0, $276eeccbfbee2738$export$137380d9ce54f7f);
    const format = options?.format ?? $1a058d2719b5b038$var$defaultFormat;
    const zero = options?.zero ?? false;
    const delimiter = options?.delimiter ?? " ";
    if (!locale.formatDistance) return "";
    const result = format.reduce((acc, unit)=>{
        const token = `x${unit.replace(/(^.)/, (m)=>m.toUpperCase())}`;
        const value = duration[unit];
        if (value !== undefined && (zero || duration[unit])) return acc.concat(locale.formatDistance(token, value));
        return acc;
    }, []).join(delimiter);
    return result;
}
var // Fallback for modularized imports:
$1a058d2719b5b038$export$2e2bcd8739ae039 = $1a058d2719b5b038$export$bc733b0c5cbb3e8a;





function $a3edfdf29d3784c8$export$e16d8520af44a096(date, duration) {
    const { years: years = 0, months: months = 0, weeks: weeks = 0, days: days = 0, hours: hours = 0, minutes: minutes = 0, seconds: seconds = 0 } = duration;
    // Add years and months
    const _date = (0, $48f2cd94c2808d74$export$e67a095c620b86fe)(date);
    const dateWithMonths = months || years ? (0, $857e6f903d884172$export$17c93e242b2d3a22)(_date, months + years * 12) : _date;
    // Add weeks and days
    const dateWithDays = days || weeks ? (0, $cb8fdbef2aba70f2$export$dd412b56f1e4d8aa)(dateWithMonths, days + weeks * 7) : dateWithMonths;
    // Add days, hours, minutes and seconds
    const minutesToAdd = minutes + hours * 60;
    const secondsToAdd = seconds + minutesToAdd * 60;
    const msToAdd = secondsToAdd * 1000;
    const finalDate = (0, $ee5e01283bb626d4$export$ead8a1812b171991)(date, dateWithDays.getTime() + msToAdd);
    return finalDate;
}
var // Fallback for modularized imports:
$a3edfdf29d3784c8$export$2e2bcd8739ae039 = $a3edfdf29d3784c8$export$e16d8520af44a096;






function $eddcd82218cb8285$export$5436ca250d4d6872(dateLeft, dateRight, options) {
    const diff = (0, $14c320f9cc9f7d86$export$7be94d13716b4bf6)(dateLeft, dateRight) / (0, $cb8083d8e93c1630$export$7f72910d6dfd237a);
    return (0, $dcf542c2756265c7$export$b6474a47258c1211)(options?.roundingMethod)(diff);
}
var // Fallback for modularized imports:
$eddcd82218cb8285$export$2e2bcd8739ae039 = $eddcd82218cb8285$export$5436ca250d4d6872;





function $ddf3cf2afb7fe224$export$d904251335be481a(dateLeft, dateRight, options) {
    const diff = (0, $14c320f9cc9f7d86$export$7be94d13716b4bf6)(dateLeft, dateRight) / (0, $cb8083d8e93c1630$export$91246f0b9bd9beff);
    return (0, $dcf542c2756265c7$export$b6474a47258c1211)(options?.roundingMethod)(diff);
}
var // Fallback for modularized imports:
$ddf3cf2afb7fe224$export$2e2bcd8739ae039 = $ddf3cf2afb7fe224$export$d904251335be481a;






function $97707bb1ee8c2cb6$export$c06dce8b38891685(dateLeft, dateRight) {
    const _dateLeft = (0, $48f2cd94c2808d74$export$e67a095c620b86fe)(dateLeft);
    const _dateRight = (0, $48f2cd94c2808d74$export$e67a095c620b86fe)(dateRight);
    return _dateLeft.getFullYear() - _dateRight.getFullYear();
}
var // Fallback for modularized imports:
$97707bb1ee8c2cb6$export$2e2bcd8739ae039 = $97707bb1ee8c2cb6$export$c06dce8b38891685;



function $fd20c31af2da107d$export$ed6bf486f68899ca(dateLeft, dateRight) {
    const _dateLeft = (0, $48f2cd94c2808d74$export$e67a095c620b86fe)(dateLeft);
    const _dateRight = (0, $48f2cd94c2808d74$export$e67a095c620b86fe)(dateRight);
    const sign = (0, $a59d383691563bf5$export$fe114145ae75d197)(_dateLeft, _dateRight);
    const difference = Math.abs((0, $97707bb1ee8c2cb6$export$c06dce8b38891685)(_dateLeft, _dateRight));
    // Set both dates to a valid leap year for accurate comparison when dealing
    // with leap days
    _dateLeft.setFullYear(1584);
    _dateRight.setFullYear(1584);
    // Math.abs(diff in full years - diff in calendar years) === 1 if last calendar year is not full
    // If so, result must be decreased by 1 in absolute value
    const isLastYearNotFull = (0, $a59d383691563bf5$export$fe114145ae75d197)(_dateLeft, _dateRight) === -sign;
    const result = sign * (difference - +isLastYearNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}
var // Fallback for modularized imports:
$fd20c31af2da107d$export$2e2bcd8739ae039 = $fd20c31af2da107d$export$ed6bf486f68899ca;



function $67b716cb7fe62b4b$export$7b6c9a626316863(interval) {
    const start = (0, $48f2cd94c2808d74$export$e67a095c620b86fe)(interval.start);
    const end = (0, $48f2cd94c2808d74$export$e67a095c620b86fe)(interval.end);
    const duration = {};
    const years = (0, $fd20c31af2da107d$export$ed6bf486f68899ca)(end, start);
    if (years) duration.years = years;
    const remainingMonths = (0, $a3edfdf29d3784c8$export$e16d8520af44a096)(start, {
        years: duration.years
    });
    const months = (0, $44851fffdb5f797e$export$fc1ed482c2861792)(end, remainingMonths);
    if (months) duration.months = months;
    const remainingDays = (0, $a3edfdf29d3784c8$export$e16d8520af44a096)(remainingMonths, {
        months: duration.months
    });
    const days = (0, $e112f865c9c9912f$export$86415ebf4eb36b8c)(end, remainingDays);
    if (days) duration.days = days;
    const remainingHours = (0, $a3edfdf29d3784c8$export$e16d8520af44a096)(remainingDays, {
        days: duration.days
    });
    const hours = (0, $eddcd82218cb8285$export$5436ca250d4d6872)(end, remainingHours);
    if (hours) duration.hours = hours;
    const remainingMinutes = (0, $a3edfdf29d3784c8$export$e16d8520af44a096)(remainingHours, {
        hours: duration.hours
    });
    const minutes = (0, $ddf3cf2afb7fe224$export$d904251335be481a)(end, remainingMinutes);
    if (minutes) duration.minutes = minutes;
    const remainingSeconds = (0, $a3edfdf29d3784c8$export$e16d8520af44a096)(remainingMinutes, {
        minutes: duration.minutes
    });
    const seconds = (0, $24a4af32485acd32$export$c1889aec51783710)(end, remainingSeconds);
    if (seconds) duration.seconds = seconds;
    return duration;
}
var // Fallback for modularized imports:
$67b716cb7fe62b4b$export$2e2bcd8739ae039 = $67b716cb7fe62b4b$export$7b6c9a626316863;


function $c36dbebe71edd437$export$2e2bcd8739ae039(seconds) {
    const epoch = new Date(0);
    const secondsAfterEpoch = new Date(seconds * 1000);
    const durationString = (0, $1a058d2719b5b038$export$bc733b0c5cbb3e8a)((0, $67b716cb7fe62b4b$export$7b6c9a626316863)({
        start: epoch,
        end: secondsAfterEpoch
    }));
    return durationString || "N/A";
}



var $lBnVc = parcelRequire("lBnVc");
function $956c80401bc0dea9$var$LogMeditationDialog({ onClose: onClose, onDontLog: onDontLog, onLog: onLog, open: open, secondsMeditated: secondsMeditated, timerDurationInSeconds: timerDurationInSeconds }) {
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $2b02ccd0ece868b7$export$2e2bcd8739ae039), {
        onClose: onClose,
        open: open,
        title: "Log this meditation?",
        children: [
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("p", {
                children: [
                    "You haven't finished the full",
                    " ",
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("b", {
                        children: timerDurationInSeconds / (0, $5a123094476b33d7$export$a9905336c0111a3a).secondsPerMinute
                    }),
                    " minute timed meditation."
                ]
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("p", {
                children: [
                    "Would you like to log",
                    " ",
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("b", {
                        children: (0, $c36dbebe71edd437$export$2e2bcd8739ae039)(secondsMeditated)
                    }),
                    "?"
                ]
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039).Group, {
                children: [
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039), {
                        onClick: onLog,
                        children: "Log"
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039), {
                        onClick: onDontLog,
                        variant: "secondary",
                        children: "Don't log"
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039), {
                        onClick: onClose,
                        variant: "secondary",
                        children: "Resume meditation"
                    })
                ]
            })
        ]
    });
}
var $956c80401bc0dea9$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $lBnVc.memo)($956c80401bc0dea9$var$LogMeditationDialog);








var $lBnVc = parcelRequire("lBnVc");

const $4241c6959d722408$var$portalEl = document.getElementById("dimmer-portal");
function $4241c6959d722408$export$2e2bcd8739ae039({ enabled: enabled, onUndim: onUndim }) {
    const dimmerEl = (0, $lBnVc.useRef)(null);
    (0, $lBnVc.useEffect)(()=>{
        // TODO can remove `?.` once API is supported on iPhone https://caniuse.com/?search=requestfullscreen
        if (enabled && dimmerEl.current) dimmerEl.current.requestFullscreen?.();
        else if (document.fullscreenElement) document.exitFullscreen();
    }, [
        enabled
    ]);
    (0, $lBnVc.useEffect)(()=>{
        const handleKeyDown = (e)=>{
            if (document.fullscreenElement) {
                e.preventDefault();
                document.exitFullscreen();
            }
        };
        window.addEventListener("keydown", handleKeyDown);
        // When the escape key is pressed in fullscreen mode
        // the browser uses it to exit fullscreen mode and
        // it is not captured by the keydown handler.
        // so any key press will exit fullscreen mode and
        // app state will be handled by `handleExitFullscreen`
        const handleExitFullscreen = ()=>{
            if (!document.fullscreenElement) onUndim();
        };
        document.addEventListener("fullscreenchange", handleExitFullscreen);
        return ()=>{
            window.removeEventListener("keydown", handleKeyDown);
            document.removeEventListener("fullscreenchange", handleExitFullscreen);
        };
    }, [
        onUndim
    ]);
    return /*#__PURE__*/ (0, $cc4070eb400e02f6$exports.createPortal)(// Neither eslint rule is relevant in this case
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("div", {
        className: `m-dimmer${enabled ? " m-dimmer--enabled" : ""}`,
        onClick: onUndim,
        ref: dimmerEl,
        children: enabled && /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("span", {
            className: "m-dimmer__text-container",
            children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("span", {
                className: "m-dimmer__text",
                children: "Tap, click or press any key to undim the screen"
            })
        })
    }), $4241c6959d722408$var$portalEl);
}





var $lBnVc = parcelRequire("lBnVc");
function $b59afc782d57ec4f$var$MeditationTimerPresentation({ dimmed: dimmed, onDim: onDim, onDontLog: onDontLog, onFinish: onFinish, onLog: onLog, onPause: onPause, onPlay: onPlay, onUndim: onUndim, roundedSecondsRemaining: roundedSecondsRemaining, timerState: timerState, totalSeconds: totalSeconds }) {
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039).Group, {
                "data-test-id": (0, $5a123094476b33d7$export$a2b4f255152a6585).meditationTimerPage,
                children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h2", {
                            children: "Meditation timer"
                        }),
                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $510fccb9fd1ebc06$export$2e2bcd8739ae039), {
                            remainingSeconds: roundedSecondsRemaining,
                            totalSeconds: totalSeconds
                        }),
                        timerState === "FINISHED" ? /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039).Group, {
                            children: [
                                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039), {
                                    onClick: onLog,
                                    children: "Log meditation"
                                }),
                                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039), {
                                    onClick: onDontLog,
                                    variant: "secondary",
                                    children: "Finish without logging"
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039).Group, {
                            children: [
                                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039), {
                                    onClick: onFinish,
                                    children: "Finish"
                                }),
                                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039), {
                                    onClick: onDim,
                                    variant: "secondary",
                                    children: [
                                        "Dim screen",
                                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                                            margin: "start",
                                            name: "moon"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039), {
                                    onClick: ()=>{
                                        if (timerState === "PAUSED") return onPlay();
                                        onPause();
                                    },
                                    variant: "secondary",
                                    children: timerState === "PAUSED" ? /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
                                        children: [
                                            "Play",
                                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                                                margin: "start",
                                                name: "play"
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
                                        children: [
                                            "Pause",
                                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                                                margin: "start",
                                                name: "pause"
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $4241c6959d722408$export$2e2bcd8739ae039), {
                enabled: dimmed,
                onUndim: onUndim
            })
        ]
    });
}
var $b59afc782d57ec4f$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $lBnVc.memo)($b59afc782d57ec4f$var$MeditationTimerPresentation);





var $2e68e07f86228592$exports = {};
var $19627b48bc2efb50$exports = {};
$19627b48bc2efb50$exports = {
    webm: "data:video/webm;base64,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",
    mp4: "data:video/mp4;base64,AAAAHGZ0eXBNNFYgAAACAGlzb21pc28yYXZjMQAAAAhmcmVlAAAGF21kYXTeBAAAbGliZmFhYyAxLjI4AABCAJMgBDIARwAAArEGBf//rdxF6b3m2Ui3lizYINkj7u94MjY0IC0gY29yZSAxNDIgcjIgOTU2YzhkOCAtIEguMjY0L01QRUctNCBBVkMgY29kZWMgLSBDb3B5bGVmdCAyMDAzLTIwMTQgLSBodHRwOi8vd3d3LnZpZGVvbGFuLm9yZy94MjY0Lmh0bWwgLSBvcHRpb25zOiBjYWJhYz0wIHJlZj0zIGRlYmxvY2s9MTowOjAgYW5hbHlzZT0weDE6MHgxMTEgbWU9aGV4IHN1Ym1lPTcgcHN5PTEgcHN5X3JkPTEuMDA6MC4wMCBtaXhlZF9yZWY9MSBtZV9yYW5nZT0xNiBjaHJvbWFfbWU9MSB0cmVsbGlzPTEgOHg4ZGN0PTAgY3FtPTAgZGVhZHpvbmU9MjEsMTEgZmFzdF9wc2tpcD0xIGNocm9tYV9xcF9vZmZzZXQ9LTIgdGhyZWFkcz02IGxvb2thaGVhZF90aHJlYWRzPTEgc2xpY2VkX3RocmVhZHM9MCBucj0wIGRlY2ltYXRlPTEgaW50ZXJsYWNlZD0wIGJsdXJheV9jb21wYXQ9MCBjb25zdHJhaW5lZF9pbnRyYT0wIGJmcmFtZXM9MCB3ZWlnaHRwPTAga2V5aW50PTI1MCBrZXlpbnRfbWluPTI1IHNjZW5lY3V0PTQwIGludHJhX3JlZnJlc2g9MCByY19sb29rYWhlYWQ9NDAgcmM9Y3JmIG1idHJlZT0xIGNyZj0yMy4wIHFjb21wPTAuNjAgcXBtaW49MCBxcG1heD02OSBxcHN0ZXA9NCB2YnZfbWF4cmF0ZT03NjggdmJ2X2J1ZnNpemU9MzAwMCBjcmZfbWF4PTAuMCBuYWxfaHJkPW5vbmUgZmlsbGVyPTAgaXBfcmF0aW89MS40MCBhcT0xOjEuMDAAgAAAAFZliIQL8mKAAKvMnJycnJycnJycnXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXiEASZACGQAjgCEASZACGQAjgAAAAAdBmjgX4GSAIQBJkAIZACOAAAAAB0GaVAX4GSAhAEmQAhkAI4AhAEmQAhkAI4AAAAAGQZpgL8DJIQBJkAIZACOAIQBJkAIZACOAAAAABkGagC/AySEASZACGQAjgAAAAAZBmqAvwMkhAEmQAhkAI4AhAEmQAhkAI4AAAAAGQZrAL8DJIQBJkAIZACOAAAAABkGa4C/AySEASZACGQAjgCEASZACGQAjgAAAAAZBmwAvwMkhAEmQAhkAI4AAAAAGQZsgL8DJIQBJkAIZACOAIQBJkAIZACOAAAAABkGbQC/AySEASZACGQAjgCEASZACGQAjgAAAAAZBm2AvwMkhAEmQAhkAI4AAAAAGQZuAL8DJIQBJkAIZACOAIQBJkAIZACOAAAAABkGboC/AySEASZACGQAjgAAAAAZBm8AvwMkhAEmQAhkAI4AhAEmQAhkAI4AAAAAGQZvgL8DJIQBJkAIZACOAAAAABkGaAC/AySEASZACGQAjgCEASZACGQAjgAAAAAZBmiAvwMkhAEmQAhkAI4AhAEmQAhkAI4AAAAAGQZpAL8DJIQBJkAIZACOAAAAABkGaYC/AySEASZACGQAjgCEASZACGQAjgAAAAAZBmoAvwMkhAEmQAhkAI4AAAAAGQZqgL8DJIQBJkAIZACOAIQBJkAIZACOAAAAABkGawC/AySEASZACGQAjgAAAAAZBmuAvwMkhAEmQAhkAI4AhAEmQAhkAI4AAAAAGQZsAL8DJIQBJkAIZACOAAAAABkGbIC/AySEASZACGQAjgCEASZACGQAjgAAAAAZBm0AvwMkhAEmQAhkAI4AhAEmQAhkAI4AAAAAGQZtgL8DJIQBJkAIZACOAAAAABkGbgCvAySEASZACGQAjgCEASZACGQAjgAAAAAZBm6AnwMkhAEmQAhkAI4AhAEmQAhkAI4AhAEmQAhkAI4AhAEmQAhkAI4AAAAhubW9vdgAAAGxtdmhkAAAAAAAAAAAAAAAAAAAD6AAABDcAAQAAAQAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAABAAAAAAAAAAAAAAAAAABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAAAzB0cmFrAAAAXHRraGQAAAADAAAAAAAAAAAAAAABAAAAAAAAA+kAAAAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAABAAAAAAAAAAAAAAAAAABAAAAAALAAAACQAAAAAAAkZWR0cwAAABxlbHN0AAAAAAAAAAEAAAPpAAAAAAABAAAAAAKobWRpYQAAACBtZGhkAAAAAAAAAAAAAAAAAAB1MAAAdU5VxAAAAAAALWhkbHIAAAAAAAAAAHZpZGUAAAAAAAAAAAAAAABWaWRlb0hhbmRsZXIAAAACU21pbmYAAAAUdm1oZAAAAAEAAAAAAAAAAAAAACRkaW5mAAAAHGRyZWYAAAAAAAAAAQAAAAx1cmwgAAAAAQAAAhNzdGJsAAAAr3N0c2QAAAAAAAAAAQAAAJ9hdmMxAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAALAAkABIAAAASAAAAAAAAAABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGP//AAAALWF2Y0MBQsAN/+EAFWdCwA3ZAsTsBEAAAPpAADqYA8UKkgEABWjLg8sgAAAAHHV1aWRraEDyXyRPxbo5pRvPAyPzAAAAAAAAABhzdHRzAAAAAAAAAAEAAAAeAAAD6QAAABRzdHNzAAAAAAAAAAEAAAABAAAAHHN0c2MAAAAAAAAAAQAAAAEAAAABAAAAAQAAAIxzdHN6AAAAAAAAAAAAAAAeAAADDwAAAAsAAAALAAAACgAAAAoAAAAKAAAACgAAAAoAAAAKAAAACgAAAAoAAAAKAAAACgAAAAoAAAAKAAAACgAAAAoAAAAKAAAACgAAAAoAAAAKAAAACgAAAAoAAAAKAAAACgAAAAoAAAAKAAAACgAAAAoAAAAKAAAAiHN0Y28AAAAAAAAAHgAAAEYAAANnAAADewAAA5gAAAO0AAADxwAAA+MAAAP2AAAEEgAABCUAAARBAAAEXQAABHAAAASMAAAEnwAABLsAAATOAAAE6gAABQYAAAUZAAAFNQAABUgAAAVkAAAFdwAABZMAAAWmAAAFwgAABd4AAAXxAAAGDQAABGh0cmFrAAAAXHRraGQAAAADAAAAAAAAAAAAAAACAAAAAAAABDcAAAAAAAAAAAAAAAEBAAAAAAEAAAAAAAAAAAAAAAAAAAABAAAAAAAAAAAAAAAAAABAAAAAAAAAAAAAAAAAAAAkZWR0cwAAABxlbHN0AAAAAAAAAAEAAAQkAAADcAABAAAAAAPgbWRpYQAAACBtZGhkAAAAAAAAAAAAAAAAAAC7gAAAykBVxAAAAAAALWhkbHIAAAAAAAAAAHNvdW4AAAAAAAAAAAAAAABTb3VuZEhhbmRsZXIAAAADi21pbmYAAAAQc21oZAAAAAAAAAAAAAAAJGRpbmYAAAAcZHJlZgAAAAAAAAABAAAADHVybCAAAAABAAADT3N0YmwAAABnc3RzZAAAAAAAAAABAAAAV21wNGEAAAAAAAAAAQAAAAAAAAAAAAIAEAAAAAC7gAAAAAAAM2VzZHMAAAAAA4CAgCIAAgAEgICAFEAVBbjYAAu4AAAADcoFgICAAhGQBoCAgAECAAAAIHN0dHMAAAAAAAAAAgAAADIAAAQAAAAAAQAAAkAAAAFUc3RzYwAAAAAAAAAbAAAAAQAAAAEAAAABAAAAAgAAAAIAAAABAAAAAwAAAAEAAAABAAAABAAAAAIAAAABAAAABgAAAAEAAAABAAAABwAAAAIAAAABAAAACAAAAAEAAAABAAAACQAAAAIAAAABAAAACgAAAAEAAAABAAAACwAAAAIAAAABAAAADQAAAAEAAAABAAAADgAAAAIAAAABAAAADwAAAAEAAAABAAAAEAAAAAIAAAABAAAAEQAAAAEAAAABAAAAEgAAAAIAAAABAAAAFAAAAAEAAAABAAAAFQAAAAIAAAABAAAAFgAAAAEAAAABAAAAFwAAAAIAAAABAAAAGAAAAAEAAAABAAAAGQAAAAIAAAABAAAAGgAAAAEAAAABAAAAGwAAAAIAAAABAAAAHQAAAAEAAAABAAAAHgAAAAIAAAABAAAAHwAAAAQAAAABAAAA4HN0c3oAAAAAAAAAAAAAADMAAAAaAAAACQAAAAkAAAAJAAAACQAAAAkAAAAJAAAACQAAAAkAAAAJAAAACQAAAAkAAAAJAAAACQAAAAkAAAAJAAAACQAAAAkAAAAJAAAACQAAAAkAAAAJAAAACQAAAAkAAAAJAAAACQAAAAkAAAAJAAAACQAAAAkAAAAJAAAACQAAAAkAAAAJAAAACQAAAAkAAAAJAAAACQAAAAkAAAAJAAAACQAAAAkAAAAJAAAACQAAAAkAAAAJAAAACQAAAAkAAAAJAAAACQAAAAkAAACMc3RjbwAAAAAAAAAfAAAALAAAA1UAAANyAAADhgAAA6IAAAO+AAAD0QAAA+0AAAQAAAAEHAAABC8AAARLAAAEZwAABHoAAASWAAAEqQAABMUAAATYAAAE9AAABRAAAAUjAAAFPwAABVIAAAVuAAAFgQAABZ0AAAWwAAAFzAAABegAAAX7AAAGFwAAAGJ1ZHRhAAAAWm1ldGEAAAAAAAAAIWhkbHIAAAAAAAAAAG1kaXJhcHBsAAAAAAAAAAAAAAAALWlsc3QAAAAlqXRvbwAAAB1kYXRhAAAAAQAAAABMYXZmNTUuMzMuMTAw"
};


var $2e68e07f86228592$require$webm = $19627b48bc2efb50$exports.webm;
var $2e68e07f86228592$require$mp4 = $19627b48bc2efb50$exports.mp4;
// Detect iOS browsers < version 10
const $2e68e07f86228592$var$oldIOS = ()=>typeof navigator !== "undefined" && parseFloat(("" + (/CPU.*OS ([0-9_]{3,4})[0-9_]{0,1}|(CPU like).*AppleWebKit.*Mobile/i.exec(navigator.userAgent) || [
        0,
        ""
    ])[1]).replace("undefined", "3_2").replace("_", ".").replace("_", "")) < 10 && !window.MSStream;
// Detect native Wake Lock API support
const $2e68e07f86228592$var$nativeWakeLock = ()=>"wakeLock" in navigator;
class $2e68e07f86228592$var$NoSleep {
    constructor(){
        this.enabled = false;
        if ($2e68e07f86228592$var$nativeWakeLock()) {
            this._wakeLock = null;
            const handleVisibilityChange = ()=>{
                if (this._wakeLock !== null && document.visibilityState === "visible") this.enable();
            };
            document.addEventListener("visibilitychange", handleVisibilityChange);
            document.addEventListener("fullscreenchange", handleVisibilityChange);
        } else if ($2e68e07f86228592$var$oldIOS()) this.noSleepTimer = null;
        else {
            // Set up no sleep video element
            this.noSleepVideo = document.createElement("video");
            this.noSleepVideo.setAttribute("title", "No Sleep");
            this.noSleepVideo.setAttribute("playsinline", "");
            this._addSourceToVideo(this.noSleepVideo, "webm", $2e68e07f86228592$require$webm);
            this._addSourceToVideo(this.noSleepVideo, "mp4", $2e68e07f86228592$require$mp4);
            this.noSleepVideo.addEventListener("loadedmetadata", ()=>{
                if (this.noSleepVideo.duration <= 1) // webm source
                this.noSleepVideo.setAttribute("loop", "");
                else // mp4 source
                this.noSleepVideo.addEventListener("timeupdate", ()=>{
                    if (this.noSleepVideo.currentTime > 0.5) this.noSleepVideo.currentTime = Math.random();
                });
            });
        }
    }
    _addSourceToVideo(element, type, dataURI) {
        var source = document.createElement("source");
        source.src = dataURI;
        source.type = `video/${type}`;
        element.appendChild(source);
    }
    get isEnabled() {
        return this.enabled;
    }
    enable() {
        if ($2e68e07f86228592$var$nativeWakeLock()) return navigator.wakeLock.request("screen").then((wakeLock)=>{
            this._wakeLock = wakeLock;
            this.enabled = true;
            console.log("Wake Lock active.");
            this._wakeLock.addEventListener("release", ()=>{
                // ToDo: Potentially emit an event for the page to observe since
                // Wake Lock releases happen when page visibility changes.
                // (https://web.dev/wakelock/#wake-lock-lifecycle)
                console.log("Wake Lock released.");
            });
        }).catch((err)=>{
            this.enabled = false;
            console.error(`${err.name}, ${err.message}`);
            throw err;
        });
        else if ($2e68e07f86228592$var$oldIOS()) {
            this.disable();
            console.warn(`
        NoSleep enabled for older iOS devices. This can interrupt
        active or long-running network requests from completing successfully.
        See https://github.com/richtr/NoSleep.js/issues/15 for more details.
      `);
            this.noSleepTimer = window.setInterval(()=>{
                if (!document.hidden) {
                    window.location.href = window.location.href.split("#")[0];
                    window.setTimeout(window.stop, 0);
                }
            }, 15000);
            this.enabled = true;
            return Promise.resolve();
        } else {
            let playPromise = this.noSleepVideo.play();
            return playPromise.then((res)=>{
                this.enabled = true;
                return res;
            }).catch((err)=>{
                this.enabled = false;
                throw err;
            });
        }
    }
    disable() {
        if ($2e68e07f86228592$var$nativeWakeLock()) {
            if (this._wakeLock) this._wakeLock.release();
            this._wakeLock = null;
        } else if ($2e68e07f86228592$var$oldIOS()) {
            if (this.noSleepTimer) {
                console.warn(`
          NoSleep now disabled for older iOS devices.
        `);
                window.clearInterval(this.noSleepTimer);
                this.noSleepTimer = null;
            }
        } else this.noSleepVideo.pause();
        this.enabled = false;
    }
}
$2e68e07f86228592$exports = $2e68e07f86228592$var$NoSleep;


const $cd8192cd7eb9463f$export$bedec98355fa7b1e = new (0, (/*@__PURE__*/$parcel$interopDefault($2e68e07f86228592$exports)))();



var $lBnVc = parcelRequire("lBnVc");

var $ebe82b8d6843977c$exports = {};
$ebe82b8d6843977c$exports = new URL("meditation-bell.e35d0ce5.mp3", import.meta.url).toString();


const $d0da6501f303d2cd$var$meditationBellUri = String(new URL($ebe82b8d6843977c$exports));
const $d0da6501f303d2cd$var$arrayBufferPromise = fetch($d0da6501f303d2cd$var$meditationBellUri).then((response)=>response.arrayBuffer());
let $d0da6501f303d2cd$var$audioBufferPromise;
function $d0da6501f303d2cd$export$2e2bcd8739ae039() {
    const bellRef = (0, $lBnVc.useRef)();
    const hasBeenActive = (0, $b520a96ab6c6e75e$export$2e2bcd8739ae039)();
    (0, $lBnVc.useEffect)(()=>{
        if (!hasBeenActive) return;
        const audioContext = new AudioContext();
        let bufferSource;
        if (!$d0da6501f303d2cd$var$audioBufferPromise) $d0da6501f303d2cd$var$audioBufferPromise = $d0da6501f303d2cd$var$arrayBufferPromise.then((arrayBuffer)=>audioContext.decodeAudioData(arrayBuffer));
        bellRef.current = {
            async start () {
                stop();
                bufferSource = audioContext.createBufferSource();
                bufferSource.connect(audioContext.destination);
                bufferSource.buffer = await $d0da6501f303d2cd$var$audioBufferPromise;
                bufferSource.onended = stop;
                bufferSource.start();
            },
            stop () {
                if (!bufferSource) return;
                bufferSource.stop();
                bufferSource.disconnect();
                bufferSource = undefined;
            }
        };
    }, [
        hasBeenActive
    ]);
    return bellRef.current;
}


function $8d3d03e58bbd5e83$export$2e2bcd8739ae039() {
    const dispatch = (0, $d3287b130d7b0f6b$export$8ad76b76a4c905f8)();
    const navigate = (0, $f02d97b5ca509f34$export$9770f232ac06a008)();
    const [searchParams] = (0, $e94b7bcc277332d2$export$f1a78c17382fe22a)();
    const [localState, localDispatch] = (0, $lBnVc.useReducer)((0, $e417414438b2d4e2$export$1650419e431d3ba3), (0, $e417414438b2d4e2$export$d4c72bab9d6cc13a));
    const bell = (0, $d0da6501f303d2cd$export$2e2bcd8739ae039)();
    const geolocation = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $2f1313f9e65d1ec4$export$2e2bcd8739ae039).selectors.geolocation);
    const timerDurationInSeconds = Number(searchParams.get((0, $5a123094476b33d7$export$3b818226f8d6346d)));
    const initialTime = (0, $lBnVc.useRef)(Date.now());
    const roundedSecondsRemaining = Math.round((localState.remainingTime ?? timerDurationInSeconds * 1e3) / 1e3);
    const secondsMeditated = timerDurationInSeconds - roundedSecondsRemaining;
    const onDim = (0, $lBnVc.useCallback)(()=>localDispatch({
            payload: true,
            type: "isDimmerEnabled/set"
        }), []);
    const onDontLog = (0, $lBnVc.useCallback)(()=>{
        navigate("/meditation");
    }, [
        navigate
    ]);
    const onPause = (0, $lBnVc.useCallback)(()=>{
        (0, $cd8192cd7eb9463f$export$bedec98355fa7b1e).disable();
        localDispatch({
            payload: "PAUSED",
            type: "timerState/set"
        });
    }, []);
    const onPlay = (0, $lBnVc.useCallback)(()=>{
        (0, $cd8192cd7eb9463f$export$bedec98355fa7b1e).enable();
        initialTime.current = Date.now() + roundedSecondsRemaining * 1e3 - timerDurationInSeconds * 1e3;
        localDispatch({
            payload: "TIMING",
            type: "timerState/set"
        });
    }, [
        roundedSecondsRemaining,
        timerDurationInSeconds
    ]);
    const onUndim = (0, $lBnVc.useCallback)(()=>localDispatch({
            payload: false,
            type: "isDimmerEnabled/set"
        }), []);
    const onCloseDialog = (0, $lBnVc.useCallback)(()=>{
        localDispatch({
            payload: false,
            type: "isDialogOpen/set"
        });
        onPlay();
    }, [
        onPlay
    ]);
    const onFinish = (0, $lBnVc.useCallback)(()=>{
        if (secondsMeditated) {
            localDispatch({
                payload: true,
                type: "isDialogOpen/set"
            });
            onPause();
        } else onDontLog();
    }, [
        onDontLog,
        onPause,
        secondsMeditated
    ]);
    const onLog = (0, $lBnVc.useCallback)(()=>{
        const payload = {
            seconds: Math.round(secondsMeditated)
        };
        if (geolocation) payload.location = geolocation;
        let createdAt;
        if (localState.timeFinished) createdAt = localState.timeFinished.toISOString();
        else {
            (0, $24a8d9ab78e4f062$export$f5282963edea4a68)(Error("Problem logging meditation: Expected finish time to be defined, falling back to log time instead"));
            createdAt = new Date().toISOString();
        }
        dispatch((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).actions.add({
            type: "v1/meditations/create",
            createdAt: createdAt,
            payload: payload
        }));
        navigate("/meditation/log");
    }, [
        dispatch,
        geolocation,
        localState.timeFinished,
        navigate,
        secondsMeditated
    ]);
    (0, $lBnVc.useEffect)(()=>{
        (0, $cd8192cd7eb9463f$export$bedec98355fa7b1e).enable();
        return ()=>{
            bell?.stop();
            (0, $cd8192cd7eb9463f$export$bedec98355fa7b1e).disable();
        };
    }, [
        bell
    ]);
    (0, $lBnVc.useEffect)(()=>{
        let abort = false;
        requestAnimationFrame(function update() {
            if (localState.timerState === "FINISHED" || localState.timerState === "PAUSED" || abort) return;
            requestAnimationFrame(update);
            const t = timerDurationInSeconds * 1e3 - (Date.now() - initialTime.current);
            if (t > 0) return localDispatch({
                payload: t,
                type: "remainingTime/set"
            });
            localDispatch({
                payload: new Date(),
                type: "timeFinished/set"
            });
            bell?.start();
            (0, $cd8192cd7eb9463f$export$bedec98355fa7b1e).disable();
        });
        return ()=>void (abort = true);
    }, [
        bell,
        localState.isDimmerEnabled,
        timerDurationInSeconds,
        localState.timerState
    ]);
    (0, $e94b7bcc277332d2$export$c0a586b329cae57d)((0, $lBnVc.useCallback)((e)=>e.preventDefault(), []));
    if (!searchParams.has((0, $5a123094476b33d7$export$3b818226f8d6346d))) {
        navigate("/");
        return;
    }
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $b59afc782d57ec4f$export$2e2bcd8739ae039), {
                dimmed: localState.isDimmerEnabled,
                onDim: onDim,
                onDontLog: onDontLog,
                onFinish: onFinish,
                onPause: onPause,
                onPlay: onPlay,
                onLog: onLog,
                onUndim: onUndim,
                roundedSecondsRemaining: roundedSecondsRemaining,
                timerState: localState.timerState,
                totalSeconds: timerDurationInSeconds
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $956c80401bc0dea9$export$2e2bcd8739ae039), {
                onClose: onCloseDialog,
                onDontLog: onDontLog,
                onLog: onLog,
                open: localState.isDialogOpen,
                secondsMeditated: secondsMeditated,
                timerDurationInSeconds: timerDurationInSeconds
            })
        ]
    });
}
























function $93c40e6082f2320d$export$2e2bcd8739ae039({ month: month, small: small }) {
    const moods = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.normalizedMoods);
    const meanMoodByDay = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.meanMoodsByDay);
    const navigate = (0, $f02d97b5ca509f34$export$9770f232ac06a008)();
    const now = new Date();
    const firstMoodDate = (0, $c2e94012e82e0308$export$cba7498d83c2e2d)(new Date(moods.allIds[0]));
    // undefined represents padding before the month
    // undefined mood represents days that have no average mood
    const data = [];
    let i = (0, $c2e94012e82e0308$export$e8da94055c5ae2c4)(month);
    while(i--)data.push(undefined);
    let daysInMonth = (0, $60ab24d2b6cf99fc$export$f645ddd439eb259d)(month);
    let d = month;
    while(daysInMonth--){
        const dateString = (0, $c2e94012e82e0308$export$f3013bcc8d8645bd)(d);
        const mood = meanMoodByDay[dateString];
        data.push({
            dateString: dateString,
            mood: mood
        });
        d = (0, $cb8fdbef2aba70f2$export$dd412b56f1e4d8aa)(d, 1);
    }
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("div", {
        "aria-label": "A calendar visualization of mood for each day of the month",
        className: `m-mood-calendar-for-month${small ? " m-mood-calendar-for-month--small" : ""}`,
        children: [
            (0, $5a123094476b33d7$export$9c4d3a9dc816779e).map((label, i)=>/*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("div", {
                    className: "center",
                    children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("small", {
                        children: label
                    })
                }, i)),
            data.map((datum, i)=>{
                const style = {
                    animationDelay: `calc(var(--time-2) / ${data.length} * ${i}`,
                    background: datum === undefined ? "none" : datum.mood === undefined ? "var(--color-balance-less)" : (0, $c2e94012e82e0308$export$18b446c953569205)(datum.mood)
                };
                const formattedMood = datum?.mood === undefined ? undefined : (0, $035f270eea0b2c1d$export$da6f4123477e5931).format(datum.mood);
                const date = datum ? (0, $c2e94012e82e0308$export$27d3dd4acf9951a1)(datum.dateString) : undefined;
                return small || !datum || date > now || date < firstMoodDate ? /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("div", {
                    className: "m-mood-calendar-for-month__day",
                    style: style,
                    title: formattedMood ?? "No data"
                }, i) : /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("button", {
                    "aria-label": `View stats for ${(0, $06d17fa75ca1067f$export$406508d2ca449bd).format(date)}`,
                    className: "m-mood-calendar-for-month__day",
                    onClick: ()=>navigate(`/stats/days/${datum.dateString}`),
                    style: style,
                    children: formattedMood
                }, i);
            })
        ]
    });
}










var $lBnVc = parcelRequire("lBnVc");
function $d46f58da5e39a00c$export$2e2bcd8739ae039({ currentPeriod: currentPeriod, previousPeriod: previousPeriod }) {
    const [filterOutPreviousPeriod, setFilterOutPreviousPeriod] = (0, $lBnVc.useState)(false);
    const currentPeriodWords = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((state)=>(0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.moodCloudWords(state, currentPeriod.dateFrom, currentPeriod.dateTo));
    const previousPeriodWords = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((state)=>(0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.moodCloudWords(state, previousPeriod.dateFrom, previousPeriod.dateTo));
    if (!currentPeriodWords || Object.keys(currentPeriodWords).length < (0, $5a123094476b33d7$export$9659e0d912e2b51e)) return;
    const filteredWords = {
        ...currentPeriodWords
    };
    if (previousPeriodWords) for (const [word, count] of Object.entries(filteredWords)){
        if (!Object.hasOwn(previousPeriodWords, word)) continue;
        const previousCount = previousPeriodWords[word];
        if (previousCount >= count) {
            delete filteredWords[word];
            continue;
        }
        filteredWords[word] -= previousCount;
    }
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("h3", {
                children: [
                    "Mood cloud",
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $19d86a636b501d10$export$2e2bcd8739ae039), {
                        children: "Created from the mood tags you record"
                    })
                ]
            }),
            previousPeriodWords && Object.keys(filteredWords).length >= (0, $5a123094476b33d7$export$9659e0d912e2b51e) && /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $828cb8aa9adcb6a3$export$2e2bcd8739ae039), {
                checked: filterOutPreviousPeriod,
                label: "Filter out moods from previous period to show what is different about this period",
                onChange: ()=>setFilterOutPreviousPeriod(!filterOutPreviousPeriod)
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $59fee832cccbdf29$export$2e2bcd8739ae039), {
                "aria-label": "Word cloud displaying mood descriptions",
                words: filterOutPreviousPeriod ? filteredWords : currentPeriodWords
            })
        ]
    });
}








function $bc7b11be3d91baec$export$2e2bcd8739ae039(props) {
    const meanMoods = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.meanMoodsByMonth);
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $c25731f3cd2809a0$export$2e2bcd8739ae039), {
        ...props,
        meanMoodByDate: meanMoods,
        periodType: "month"
    });
}








const $100c69136c0f606e$var$X_LABELS_COUNT = 5;
function $100c69136c0f606e$var$Month({ date: date, nextDate: nextDate, prevDate: prevDate, showNext: showNext, showPrevious: showPrevious }) {
    const moodIdsInPeriod = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((state)=>(0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.moodIdsInPeriod(state, date, nextDate));
    const meanMoodsByWeek = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.meanMoodsByWeek);
    const weeks = Object.keys(meanMoodsByWeek);
    const nextMonthDateString = (0, $c2e94012e82e0308$export$f3013bcc8d8645bd)(nextDate);
    const monthMinus7DaysDateString = (0, $c2e94012e82e0308$export$f3013bcc8d8645bd)((0, $58b603c9eda836d4$export$70823084e2deb1ea)(date, 7));
    const monthLength = (0, $63c81b3d951f3f78$export$4a02e9c37dab4871)(nextDate, date);
    const xLabels = [];
    for(let i = 0; i < $100c69136c0f606e$var$X_LABELS_COUNT; i++)xLabels.push((0, $06d17fa75ca1067f$export$9bcd4dc4ef454cb9).format((0, $cb8fdbef2aba70f2$export$dd412b56f1e4d8aa)(date, Math.round(i * monthLength / ($100c69136c0f606e$var$X_LABELS_COUNT - 1)))));
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039).Group, {
        children: [
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("h2", {
                        children: [
                            (0, $06d17fa75ca1067f$export$4137bbc3ff26d570).format(date),
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $19d86a636b501d10$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e94b7bcc277332d2$export$a6c7ac8248d6e38a), {
                                    to: `../../years/${(0, $c2e94012e82e0308$export$60b37fc597282c94)(date)}`,
                                    children: (0, $06d17fa75ca1067f$export$daf84c177a4aeca8).format(date)
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $0a48ec8918b8b79c$export$2e2bcd8739ae039), {
                        dateFrom: date,
                        dateTo: nextDate
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $cfc36dd95b79da04$export$2e2bcd8739ae039), {
                        children: [
                            showPrevious ? /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $e94b7bcc277332d2$export$a6c7ac8248d6e38a), {
                                to: `../${(0, $c2e94012e82e0308$export$30a208a52f4a49de)(prevDate)}`,
                                children: [
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                                        margin: "end",
                                        name: "left"
                                    }),
                                    (0, $06d17fa75ca1067f$export$4137bbc3ff26d570).format(prevDate)
                                ]
                            }) : /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("span", {}),
                            showNext && /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $e94b7bcc277332d2$export$a6c7ac8248d6e38a), {
                                to: `../${(0, $c2e94012e82e0308$export$30a208a52f4a49de)(nextDate)}`,
                                children: [
                                    (0, $06d17fa75ca1067f$export$4137bbc3ff26d570).format(nextDate),
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                                        margin: "start",
                                        name: "right"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $bc7b11be3d91baec$export$2e2bcd8739ae039), {
                dates: [
                    prevDate,
                    date,
                    nextDate
                ]
            }),
            moodIdsInPeriod.length ? /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $997e05fd3f436e77$export$2e2bcd8739ae039), {
                        dateFrom: date,
                        dateTo: nextDate,
                        xLabels: xLabels
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h3", {
                                children: "Calendar view"
                            }),
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $93c40e6082f2320d$export$2e2bcd8739ae039), {
                                month: date
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h3", {
                                children: "Weeks"
                            }),
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("table", {
                                children: [
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("thead", {
                                        children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("th", {
                                                    children: "Week"
                                                }),
                                                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("th", {
                                                    children: "Mood gradient"
                                                }),
                                                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("th", {
                                                    children: "Average mood"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("tbody", {
                                        children: weeks.filter((dateString)=>dateString >= monthMinus7DaysDateString && dateString < nextMonthDateString).map((dateString)=>{
                                            const week = (0, $c2e94012e82e0308$export$27d3dd4acf9951a1)(dateString);
                                            const weekStr = (0, $06d17fa75ca1067f$export$c8fd8d8bcad3b27c)(week);
                                            return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("td", {
                                                        children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e94b7bcc277332d2$export$a6c7ac8248d6e38a), {
                                                            to: `../../weeks/${(0, $c2e94012e82e0308$export$f3013bcc8d8645bd)((0, $f2ddddaabfe67186$export$42c81a444fbfb5d4)(week, (0, $06d17fa75ca1067f$export$34c88de16c0a2653)))}`,
                                                            children: weekStr
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("td", {
                                                        children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $0a48ec8918b8b79c$export$2e2bcd8739ae039), {
                                                            dateFrom: week,
                                                            dateTo: (0, $ad866f4678a92721$export$ef501a2bb4f3ee6b)(week, 1)
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $041b0fb8a1821c7a$export$2e2bcd8739ae039), {
                                                        mood: meanMoodsByWeek[dateString]
                                                    })
                                                ]
                                            }, dateString);
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $645d8a5fcb813cb9$export$2e2bcd8739ae039), {
                        dateFrom: date,
                        dateTo: nextDate
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $f1356ddf9998b04f$export$2e2bcd8739ae039), {
                        dateFrom: date,
                        dateTo: nextDate
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $d46f58da5e39a00c$export$2e2bcd8739ae039), {
                        currentPeriod: {
                            dateFrom: date,
                            dateTo: nextDate
                        },
                        previousPeriod: {
                            dateFrom: prevDate,
                            dateTo: date
                        }
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $3b3050146274ca05$export$2e2bcd8739ae039), {
                        dateFrom: date,
                        dateTo: nextDate
                    })
                ]
            }) : /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("p", {
                    children: "No mood data for this month."
                })
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $a67d76e60b66d2ca$export$2e2bcd8739ae039), {
                dateFrom: date,
                dateTo: nextDate
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $1dc16ddda003912c$export$2e2bcd8739ae039), {
                dateFrom: date,
                dateTo: nextDate,
                xLabels: xLabels
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $d4bf939de7dd3627$export$2e2bcd8739ae039), {
                dateFrom: date,
                dateTo: nextDate
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $af798ee18e885c0a$export$2e2bcd8739ae039), {
                dateFrom: date,
                dateTo: nextDate,
                xLabels: xLabels
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $d03f855c67127c85$export$2e2bcd8739ae039), {
                dateFrom: date,
                dateTo: nextDate
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $6813af323f7a9acb$export$2e2bcd8739ae039), {
                dateFrom: date,
                dateTo: nextDate
            })
        ]
    });
}
var $100c69136c0f606e$export$2e2bcd8739ae039 = (0, $978855b79bb42918$export$2e2bcd8739ae039)({
    addPeriod: (0, $857e6f903d884172$export$17c93e242b2d3a22),
    dateRegex: /^\d{4}-\d{2}$/,
    Component: $100c69136c0f606e$var$Month
});






const $a87faee8b256efa8$export$d4c72bab9d6cc13a = {
    filterDescription: "",
    filterMood: undefined,
    page: 0,
    searchString: "",
    shouldShowFilter: false
};
const $a87faee8b256efa8$export$1650419e431d3ba3 = (state, action)=>{
    switch(action.type){
        case "filterDescription/set":
            return {
                ...state,
                filterDescription: action.payload,
                page: 0
            };
        case "filterMood/clear":
            return {
                ...state,
                filterMood: undefined,
                page: 0
            };
        case "filterMood/set":
            return {
                ...state,
                filterMood: action.payload,
                page: 0
            };
        case "page/set":
            return {
                ...state,
                page: action.payload
            };
        case "searchString/set":
            return {
                ...state,
                searchString: action.payload,
                page: 0
            };
        case "shouldShowFilter/set":
            if (action.payload) return {
                ...state,
                shouldShowFilter: action.payload
            };
            return {
                ...$a87faee8b256efa8$export$d4c72bab9d6cc13a
            };
    }
};



var $lBnVc = parcelRequire("lBnVc");


/**
 * Fuse.js v7.0.0 - Lightweight fuzzy-search (http://fusejs.io)
 *
 * Copyright (c) 2023 Kiro Risk (http://kiro.me)
 * All Rights Reserved. Apache Software License 2.0
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 */ function $f5b9d1c868e8b908$var$isArray(value) {
    return !Array.isArray ? $f5b9d1c868e8b908$var$getTag(value) === "[object Array]" : Array.isArray(value);
}
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/baseToString.js
const $f5b9d1c868e8b908$var$INFINITY = 1 / 0;
function $f5b9d1c868e8b908$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    let result = value + "";
    return result == "0" && 1 / value == -$f5b9d1c868e8b908$var$INFINITY ? "-0" : result;
}
function $f5b9d1c868e8b908$var$toString(value) {
    return value == null ? "" : $f5b9d1c868e8b908$var$baseToString(value);
}
function $f5b9d1c868e8b908$var$isString(value) {
    return typeof value === "string";
}
function $f5b9d1c868e8b908$var$isNumber(value) {
    return typeof value === "number";
}
// Adapted from: https://github.com/lodash/lodash/blob/master/isBoolean.js
function $f5b9d1c868e8b908$var$isBoolean(value) {
    return value === true || value === false || $f5b9d1c868e8b908$var$isObjectLike(value) && $f5b9d1c868e8b908$var$getTag(value) == "[object Boolean]";
}
function $f5b9d1c868e8b908$var$isObject(value) {
    return typeof value === "object";
}
// Checks if `value` is object-like.
function $f5b9d1c868e8b908$var$isObjectLike(value) {
    return $f5b9d1c868e8b908$var$isObject(value) && value !== null;
}
function $f5b9d1c868e8b908$var$isDefined(value) {
    return value !== undefined && value !== null;
}
function $f5b9d1c868e8b908$var$isBlank(value) {
    return !value.trim().length;
}
// Gets the `toStringTag` of `value`.
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/getTag.js
function $f5b9d1c868e8b908$var$getTag(value) {
    return value == null ? value === undefined ? "[object Undefined]" : "[object Null]" : Object.prototype.toString.call(value);
}
const $f5b9d1c868e8b908$var$EXTENDED_SEARCH_UNAVAILABLE = "Extended search is not available";
const $f5b9d1c868e8b908$var$INCORRECT_INDEX_TYPE = "Incorrect 'index' type";
const $f5b9d1c868e8b908$var$LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY = (key)=>`Invalid value for key ${key}`;
const $f5b9d1c868e8b908$var$PATTERN_LENGTH_TOO_LARGE = (max)=>`Pattern length exceeds max of ${max}.`;
const $f5b9d1c868e8b908$var$MISSING_KEY_PROPERTY = (name)=>`Missing ${name} property in key`;
const $f5b9d1c868e8b908$var$INVALID_KEY_WEIGHT_VALUE = (key)=>`Property 'weight' in key '${key}' must be a positive integer`;
const $f5b9d1c868e8b908$var$hasOwn = Object.prototype.hasOwnProperty;
class $f5b9d1c868e8b908$var$KeyStore {
    constructor(keys){
        this._keys = [];
        this._keyMap = {};
        let totalWeight = 0;
        keys.forEach((key)=>{
            let obj = $f5b9d1c868e8b908$var$createKey(key);
            this._keys.push(obj);
            this._keyMap[obj.id] = obj;
            totalWeight += obj.weight;
        });
        // Normalize weights so that their sum is equal to 1
        this._keys.forEach((key)=>{
            key.weight /= totalWeight;
        });
    }
    get(keyId) {
        return this._keyMap[keyId];
    }
    keys() {
        return this._keys;
    }
    toJSON() {
        return JSON.stringify(this._keys);
    }
}
function $f5b9d1c868e8b908$var$createKey(key) {
    let path = null;
    let id = null;
    let src = null;
    let weight = 1;
    let getFn = null;
    if ($f5b9d1c868e8b908$var$isString(key) || $f5b9d1c868e8b908$var$isArray(key)) {
        src = key;
        path = $f5b9d1c868e8b908$var$createKeyPath(key);
        id = $f5b9d1c868e8b908$var$createKeyId(key);
    } else {
        if (!$f5b9d1c868e8b908$var$hasOwn.call(key, "name")) throw new Error($f5b9d1c868e8b908$var$MISSING_KEY_PROPERTY("name"));
        const name = key.name;
        src = name;
        if ($f5b9d1c868e8b908$var$hasOwn.call(key, "weight")) {
            weight = key.weight;
            if (weight <= 0) throw new Error($f5b9d1c868e8b908$var$INVALID_KEY_WEIGHT_VALUE(name));
        }
        path = $f5b9d1c868e8b908$var$createKeyPath(name);
        id = $f5b9d1c868e8b908$var$createKeyId(name);
        getFn = key.getFn;
    }
    return {
        path: path,
        id: id,
        weight: weight,
        src: src,
        getFn: getFn
    };
}
function $f5b9d1c868e8b908$var$createKeyPath(key) {
    return $f5b9d1c868e8b908$var$isArray(key) ? key : key.split(".");
}
function $f5b9d1c868e8b908$var$createKeyId(key) {
    return $f5b9d1c868e8b908$var$isArray(key) ? key.join(".") : key;
}
function $f5b9d1c868e8b908$var$get(obj, path) {
    let list = [];
    let arr = false;
    const deepGet = (obj, path, index)=>{
        if (!$f5b9d1c868e8b908$var$isDefined(obj)) return;
        if (!path[index]) // If there's no path left, we've arrived at the object we care about.
        list.push(obj);
        else {
            let key = path[index];
            const value = obj[key];
            if (!$f5b9d1c868e8b908$var$isDefined(value)) return;
            // If we're at the last value in the path, and if it's a string/number/bool,
            // add it to the list
            if (index === path.length - 1 && ($f5b9d1c868e8b908$var$isString(value) || $f5b9d1c868e8b908$var$isNumber(value) || $f5b9d1c868e8b908$var$isBoolean(value))) list.push($f5b9d1c868e8b908$var$toString(value));
            else if ($f5b9d1c868e8b908$var$isArray(value)) {
                arr = true;
                // Search each item in the array.
                for(let i = 0, len = value.length; i < len; i += 1)deepGet(value[i], path, index + 1);
            } else if (path.length) // An object. Recurse further.
            deepGet(value, path, index + 1);
        }
    };
    // Backwards compatibility (since path used to be a string)
    deepGet(obj, $f5b9d1c868e8b908$var$isString(path) ? path.split(".") : path, 0);
    return arr ? list : list[0];
}
const $f5b9d1c868e8b908$var$MatchOptions = {
    // Whether the matches should be included in the result set. When `true`, each record in the result
    // set will include the indices of the matched characters.
    // These can consequently be used for highlighting purposes.
    includeMatches: false,
    // When `true`, the matching function will continue to the end of a search pattern even if
    // a perfect match has already been located in the string.
    findAllMatches: false,
    // Minimum number of characters that must be matched before a result is considered a match
    minMatchCharLength: 1
};
const $f5b9d1c868e8b908$var$BasicOptions = {
    // When `true`, the algorithm continues searching to the end of the input even if a perfect
    // match is found before the end of the same input.
    isCaseSensitive: false,
    // When true, the matching function will continue to the end of a search pattern even if
    includeScore: false,
    // List of properties that will be searched. This also supports nested properties.
    keys: [],
    // Whether to sort the result list, by score
    shouldSort: true,
    // Default sort function: sort by ascending score, ascending index
    sortFn: (a, b)=>a.score === b.score ? a.idx < b.idx ? -1 : 1 : a.score < b.score ? -1 : 1
};
const $f5b9d1c868e8b908$var$FuzzyOptions = {
    // Approximately where in the text is the pattern expected to be found?
    location: 0,
    // At what point does the match algorithm give up. A threshold of '0.0' requires a perfect match
    // (of both letters and location), a threshold of '1.0' would match anything.
    threshold: 0.6,
    // Determines how close the match must be to the fuzzy location (specified above).
    // An exact letter match which is 'distance' characters away from the fuzzy location
    // would score as a complete mismatch. A distance of '0' requires the match be at
    // the exact location specified, a threshold of '1000' would require a perfect match
    // to be within 800 characters of the fuzzy location to be found using a 0.8 threshold.
    distance: 100
};
const $f5b9d1c868e8b908$var$AdvancedOptions = {
    // When `true`, it enables the use of unix-like search commands
    useExtendedSearch: false,
    // The get function to use when fetching an object's properties.
    // The default will search nested paths *ie foo.bar.baz*
    getFn: $f5b9d1c868e8b908$var$get,
    // When `true`, search will ignore `location` and `distance`, so it won't matter
    // where in the string the pattern appears.
    // More info: https://fusejs.io/concepts/scoring-theory.html#fuzziness-score
    ignoreLocation: false,
    // When `true`, the calculation for the relevance score (used for sorting) will
    // ignore the field-length norm.
    // More info: https://fusejs.io/concepts/scoring-theory.html#field-length-norm
    ignoreFieldNorm: false,
    // The weight to determine how much field length norm effects scoring.
    fieldNormWeight: 1
};
var $f5b9d1c868e8b908$var$Config = {
    ...$f5b9d1c868e8b908$var$BasicOptions,
    ...$f5b9d1c868e8b908$var$MatchOptions,
    ...$f5b9d1c868e8b908$var$FuzzyOptions,
    ...$f5b9d1c868e8b908$var$AdvancedOptions
};
const $f5b9d1c868e8b908$var$SPACE = /[^ ]+/g;
// Field-length norm: the shorter the field, the higher the weight.
// Set to 3 decimals to reduce index size.
function $f5b9d1c868e8b908$var$norm(weight = 1, mantissa = 3) {
    const cache = new Map();
    const m = Math.pow(10, mantissa);
    return {
        get (value) {
            const numTokens = value.match($f5b9d1c868e8b908$var$SPACE).length;
            if (cache.has(numTokens)) return cache.get(numTokens);
            // Default function is 1/sqrt(x), weight makes that variable
            const norm = 1 / Math.pow(numTokens, 0.5 * weight);
            // In place of `toFixed(mantissa)`, for faster computation
            const n = parseFloat(Math.round(norm * m) / m);
            cache.set(numTokens, n);
            return n;
        },
        clear () {
            cache.clear();
        }
    };
}
class $f5b9d1c868e8b908$var$FuseIndex {
    constructor({ getFn: getFn = $f5b9d1c868e8b908$var$Config.getFn, fieldNormWeight: fieldNormWeight = $f5b9d1c868e8b908$var$Config.fieldNormWeight } = {}){
        this.norm = $f5b9d1c868e8b908$var$norm(fieldNormWeight, 3);
        this.getFn = getFn;
        this.isCreated = false;
        this.setIndexRecords();
    }
    setSources(docs = []) {
        this.docs = docs;
    }
    setIndexRecords(records = []) {
        this.records = records;
    }
    setKeys(keys = []) {
        this.keys = keys;
        this._keysMap = {};
        keys.forEach((key, idx)=>{
            this._keysMap[key.id] = idx;
        });
    }
    create() {
        if (this.isCreated || !this.docs.length) return;
        this.isCreated = true;
        // List is Array<String>
        if ($f5b9d1c868e8b908$var$isString(this.docs[0])) this.docs.forEach((doc, docIndex)=>{
            this._addString(doc, docIndex);
        });
        else // List is Array<Object>
        this.docs.forEach((doc, docIndex)=>{
            this._addObject(doc, docIndex);
        });
        this.norm.clear();
    }
    // Adds a doc to the end of the index
    add(doc) {
        const idx = this.size();
        if ($f5b9d1c868e8b908$var$isString(doc)) this._addString(doc, idx);
        else this._addObject(doc, idx);
    }
    // Removes the doc at the specified index of the index
    removeAt(idx) {
        this.records.splice(idx, 1);
        // Change ref index of every subsquent doc
        for(let i = idx, len = this.size(); i < len; i += 1)this.records[i].i -= 1;
    }
    getValueForItemAtKeyId(item, keyId) {
        return item[this._keysMap[keyId]];
    }
    size() {
        return this.records.length;
    }
    _addString(doc, docIndex) {
        if (!$f5b9d1c868e8b908$var$isDefined(doc) || $f5b9d1c868e8b908$var$isBlank(doc)) return;
        let record = {
            v: doc,
            i: docIndex,
            n: this.norm.get(doc)
        };
        this.records.push(record);
    }
    _addObject(doc, docIndex) {
        let record = {
            i: docIndex,
            $: {}
        };
        // Iterate over every key (i.e, path), and fetch the value at that key
        this.keys.forEach((key, keyIndex)=>{
            let value = key.getFn ? key.getFn(doc) : this.getFn(doc, key.path);
            if (!$f5b9d1c868e8b908$var$isDefined(value)) return;
            if ($f5b9d1c868e8b908$var$isArray(value)) {
                let subRecords = [];
                const stack = [
                    {
                        nestedArrIndex: -1,
                        value: value
                    }
                ];
                while(stack.length){
                    const { nestedArrIndex: nestedArrIndex, value: value } = stack.pop();
                    if (!$f5b9d1c868e8b908$var$isDefined(value)) continue;
                    if ($f5b9d1c868e8b908$var$isString(value) && !$f5b9d1c868e8b908$var$isBlank(value)) {
                        let subRecord = {
                            v: value,
                            i: nestedArrIndex,
                            n: this.norm.get(value)
                        };
                        subRecords.push(subRecord);
                    } else if ($f5b9d1c868e8b908$var$isArray(value)) value.forEach((item, k)=>{
                        stack.push({
                            nestedArrIndex: k,
                            value: item
                        });
                    });
                }
                record.$[keyIndex] = subRecords;
            } else if ($f5b9d1c868e8b908$var$isString(value) && !$f5b9d1c868e8b908$var$isBlank(value)) {
                let subRecord = {
                    v: value,
                    n: this.norm.get(value)
                };
                record.$[keyIndex] = subRecord;
            }
        });
        this.records.push(record);
    }
    toJSON() {
        return {
            keys: this.keys,
            records: this.records
        };
    }
}
function $f5b9d1c868e8b908$var$createIndex(keys, docs, { getFn: getFn = $f5b9d1c868e8b908$var$Config.getFn, fieldNormWeight: fieldNormWeight = $f5b9d1c868e8b908$var$Config.fieldNormWeight } = {}) {
    const myIndex = new $f5b9d1c868e8b908$var$FuseIndex({
        getFn: getFn,
        fieldNormWeight: fieldNormWeight
    });
    myIndex.setKeys(keys.map($f5b9d1c868e8b908$var$createKey));
    myIndex.setSources(docs);
    myIndex.create();
    return myIndex;
}
function $f5b9d1c868e8b908$var$parseIndex(data, { getFn: getFn = $f5b9d1c868e8b908$var$Config.getFn, fieldNormWeight: fieldNormWeight = $f5b9d1c868e8b908$var$Config.fieldNormWeight } = {}) {
    const { keys: keys, records: records } = data;
    const myIndex = new $f5b9d1c868e8b908$var$FuseIndex({
        getFn: getFn,
        fieldNormWeight: fieldNormWeight
    });
    myIndex.setKeys(keys);
    myIndex.setIndexRecords(records);
    return myIndex;
}
function $f5b9d1c868e8b908$var$computeScore$1(pattern, { errors: errors = 0, currentLocation: currentLocation = 0, expectedLocation: expectedLocation = 0, distance: distance = $f5b9d1c868e8b908$var$Config.distance, ignoreLocation: ignoreLocation = $f5b9d1c868e8b908$var$Config.ignoreLocation } = {}) {
    const accuracy = errors / pattern.length;
    if (ignoreLocation) return accuracy;
    const proximity = Math.abs(expectedLocation - currentLocation);
    if (!distance) // Dodge divide by zero error.
    return proximity ? 1.0 : accuracy;
    return accuracy + proximity / distance;
}
function $f5b9d1c868e8b908$var$convertMaskToIndices(matchmask = [], minMatchCharLength = $f5b9d1c868e8b908$var$Config.minMatchCharLength) {
    let indices = [];
    let start = -1;
    let end = -1;
    let i = 0;
    for(let len = matchmask.length; i < len; i += 1){
        let match = matchmask[i];
        if (match && start === -1) start = i;
        else if (!match && start !== -1) {
            end = i - 1;
            if (end - start + 1 >= minMatchCharLength) indices.push([
                start,
                end
            ]);
            start = -1;
        }
    }
    // (i-1 - start) + 1 => i - start
    if (matchmask[i - 1] && i - start >= minMatchCharLength) indices.push([
        start,
        i - 1
    ]);
    return indices;
}
// Machine word size
const $f5b9d1c868e8b908$var$MAX_BITS = 32;
function $f5b9d1c868e8b908$var$search(text, pattern, patternAlphabet, { location: location = $f5b9d1c868e8b908$var$Config.location, distance: distance = $f5b9d1c868e8b908$var$Config.distance, threshold: threshold = $f5b9d1c868e8b908$var$Config.threshold, findAllMatches: findAllMatches = $f5b9d1c868e8b908$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $f5b9d1c868e8b908$var$Config.minMatchCharLength, includeMatches: includeMatches = $f5b9d1c868e8b908$var$Config.includeMatches, ignoreLocation: ignoreLocation = $f5b9d1c868e8b908$var$Config.ignoreLocation } = {}) {
    if (pattern.length > $f5b9d1c868e8b908$var$MAX_BITS) throw new Error($f5b9d1c868e8b908$var$PATTERN_LENGTH_TOO_LARGE($f5b9d1c868e8b908$var$MAX_BITS));
    const patternLen = pattern.length;
    // Set starting location at beginning text and initialize the alphabet.
    const textLen = text.length;
    // Handle the case when location > text.length
    const expectedLocation = Math.max(0, Math.min(location, textLen));
    // Highest score beyond which we give up.
    let currentThreshold = threshold;
    // Is there a nearby exact match? (speedup)
    let bestLocation = expectedLocation;
    // Performance: only computer matches when the minMatchCharLength > 1
    // OR if `includeMatches` is true.
    const computeMatches = minMatchCharLength > 1 || includeMatches;
    // A mask of the matches, used for building the indices
    const matchMask = computeMatches ? Array(textLen) : [];
    let index;
    // Get all exact matches, here for speed up
    while((index = text.indexOf(pattern, bestLocation)) > -1){
        let score = $f5b9d1c868e8b908$var$computeScore$1(pattern, {
            currentLocation: index,
            expectedLocation: expectedLocation,
            distance: distance,
            ignoreLocation: ignoreLocation
        });
        currentThreshold = Math.min(score, currentThreshold);
        bestLocation = index + patternLen;
        if (computeMatches) {
            let i = 0;
            while(i < patternLen){
                matchMask[index + i] = 1;
                i += 1;
            }
        }
    }
    // Reset the best location
    bestLocation = -1;
    let lastBitArr = [];
    let finalScore = 1;
    let binMax = patternLen + textLen;
    const mask = 1 << patternLen - 1;
    for(let i = 0; i < patternLen; i += 1){
        // Scan for the best match; each iteration allows for one more error.
        // Run a binary search to determine how far from the match location we can stray
        // at this error level.
        let binMin = 0;
        let binMid = binMax;
        while(binMin < binMid){
            const score = $f5b9d1c868e8b908$var$computeScore$1(pattern, {
                errors: i,
                currentLocation: expectedLocation + binMid,
                expectedLocation: expectedLocation,
                distance: distance,
                ignoreLocation: ignoreLocation
            });
            if (score <= currentThreshold) binMin = binMid;
            else binMax = binMid;
            binMid = Math.floor((binMax - binMin) / 2 + binMin);
        }
        // Use the result from this iteration as the maximum for the next.
        binMax = binMid;
        let start = Math.max(1, expectedLocation - binMid + 1);
        let finish = findAllMatches ? textLen : Math.min(expectedLocation + binMid, textLen) + patternLen;
        // Initialize the bit array
        let bitArr = Array(finish + 2);
        bitArr[finish + 1] = (1 << i) - 1;
        for(let j = finish; j >= start; j -= 1){
            let currentLocation = j - 1;
            let charMatch = patternAlphabet[text.charAt(currentLocation)];
            if (computeMatches) // Speed up: quick bool to int conversion (i.e, `charMatch ? 1 : 0`)
            matchMask[currentLocation] = +!!charMatch;
            // First pass: exact match
            bitArr[j] = (bitArr[j + 1] << 1 | 1) & charMatch;
            // Subsequent passes: fuzzy match
            if (i) bitArr[j] |= (lastBitArr[j + 1] | lastBitArr[j]) << 1 | 1 | lastBitArr[j + 1];
            if (bitArr[j] & mask) {
                finalScore = $f5b9d1c868e8b908$var$computeScore$1(pattern, {
                    errors: i,
                    currentLocation: currentLocation,
                    expectedLocation: expectedLocation,
                    distance: distance,
                    ignoreLocation: ignoreLocation
                });
                // This match will almost certainly be better than any existing match.
                // But check anyway.
                if (finalScore <= currentThreshold) {
                    // Indeed it is
                    currentThreshold = finalScore;
                    bestLocation = currentLocation;
                    // Already passed `loc`, downhill from here on in.
                    if (bestLocation <= expectedLocation) break;
                    // When passing `bestLocation`, don't exceed our current distance from `expectedLocation`.
                    start = Math.max(1, 2 * expectedLocation - bestLocation);
                }
            }
        }
        // No hope for a (better) match at greater error levels.
        const score = $f5b9d1c868e8b908$var$computeScore$1(pattern, {
            errors: i + 1,
            currentLocation: expectedLocation,
            expectedLocation: expectedLocation,
            distance: distance,
            ignoreLocation: ignoreLocation
        });
        if (score > currentThreshold) break;
        lastBitArr = bitArr;
    }
    const result = {
        isMatch: bestLocation >= 0,
        // Count exact matches (those with a score of 0) to be "almost" exact
        score: Math.max(0.001, finalScore)
    };
    if (computeMatches) {
        const indices = $f5b9d1c868e8b908$var$convertMaskToIndices(matchMask, minMatchCharLength);
        if (!indices.length) result.isMatch = false;
        else if (includeMatches) result.indices = indices;
    }
    return result;
}
function $f5b9d1c868e8b908$var$createPatternAlphabet(pattern) {
    let mask = {};
    for(let i = 0, len = pattern.length; i < len; i += 1){
        const char = pattern.charAt(i);
        mask[char] = (mask[char] || 0) | 1 << len - i - 1;
    }
    return mask;
}
class $f5b9d1c868e8b908$var$BitapSearch {
    constructor(pattern, { location: location = $f5b9d1c868e8b908$var$Config.location, threshold: threshold = $f5b9d1c868e8b908$var$Config.threshold, distance: distance = $f5b9d1c868e8b908$var$Config.distance, includeMatches: includeMatches = $f5b9d1c868e8b908$var$Config.includeMatches, findAllMatches: findAllMatches = $f5b9d1c868e8b908$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $f5b9d1c868e8b908$var$Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = $f5b9d1c868e8b908$var$Config.isCaseSensitive, ignoreLocation: ignoreLocation = $f5b9d1c868e8b908$var$Config.ignoreLocation } = {}){
        this.options = {
            location: location,
            threshold: threshold,
            distance: distance,
            includeMatches: includeMatches,
            findAllMatches: findAllMatches,
            minMatchCharLength: minMatchCharLength,
            isCaseSensitive: isCaseSensitive,
            ignoreLocation: ignoreLocation
        };
        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        this.chunks = [];
        if (!this.pattern.length) return;
        const addChunk = (pattern, startIndex)=>{
            this.chunks.push({
                pattern: pattern,
                alphabet: $f5b9d1c868e8b908$var$createPatternAlphabet(pattern),
                startIndex: startIndex
            });
        };
        const len = this.pattern.length;
        if (len > $f5b9d1c868e8b908$var$MAX_BITS) {
            let i = 0;
            const remainder = len % $f5b9d1c868e8b908$var$MAX_BITS;
            const end = len - remainder;
            while(i < end){
                addChunk(this.pattern.substr(i, $f5b9d1c868e8b908$var$MAX_BITS), i);
                i += $f5b9d1c868e8b908$var$MAX_BITS;
            }
            if (remainder) {
                const startIndex = len - $f5b9d1c868e8b908$var$MAX_BITS;
                addChunk(this.pattern.substr(startIndex), startIndex);
            }
        } else addChunk(this.pattern, 0);
    }
    searchIn(text) {
        const { isCaseSensitive: isCaseSensitive, includeMatches: includeMatches } = this.options;
        if (!isCaseSensitive) text = text.toLowerCase();
        // Exact match
        if (this.pattern === text) {
            let result = {
                isMatch: true,
                score: 0
            };
            if (includeMatches) result.indices = [
                [
                    0,
                    text.length - 1
                ]
            ];
            return result;
        }
        // Otherwise, use Bitap algorithm
        const { location: location, distance: distance, threshold: threshold, findAllMatches: findAllMatches, minMatchCharLength: minMatchCharLength, ignoreLocation: ignoreLocation } = this.options;
        let allIndices = [];
        let totalScore = 0;
        let hasMatches = false;
        this.chunks.forEach(({ pattern: pattern, alphabet: alphabet, startIndex: startIndex })=>{
            const { isMatch: isMatch, score: score, indices: indices } = $f5b9d1c868e8b908$var$search(text, pattern, alphabet, {
                location: location + startIndex,
                distance: distance,
                threshold: threshold,
                findAllMatches: findAllMatches,
                minMatchCharLength: minMatchCharLength,
                includeMatches: includeMatches,
                ignoreLocation: ignoreLocation
            });
            if (isMatch) hasMatches = true;
            totalScore += score;
            if (isMatch && indices) allIndices = [
                ...allIndices,
                ...indices
            ];
        });
        let result = {
            isMatch: hasMatches,
            score: hasMatches ? totalScore / this.chunks.length : 1
        };
        if (hasMatches && includeMatches) result.indices = allIndices;
        return result;
    }
}
class $f5b9d1c868e8b908$var$BaseMatch {
    constructor(pattern){
        this.pattern = pattern;
    }
    static isMultiMatch(pattern) {
        return $f5b9d1c868e8b908$var$getMatch(pattern, this.multiRegex);
    }
    static isSingleMatch(pattern) {
        return $f5b9d1c868e8b908$var$getMatch(pattern, this.singleRegex);
    }
    search() {}
}
function $f5b9d1c868e8b908$var$getMatch(pattern, exp) {
    const matches = pattern.match(exp);
    return matches ? matches[1] : null;
}
// Token: 'file
class $f5b9d1c868e8b908$var$ExactMatch extends $f5b9d1c868e8b908$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "exact";
    }
    static get multiRegex() {
        return /^="(.*)"$/;
    }
    static get singleRegex() {
        return /^=(.*)$/;
    }
    search(text) {
        const isMatch = text === this.pattern;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                this.pattern.length - 1
            ]
        };
    }
}
// Token: !fire
class $f5b9d1c868e8b908$var$InverseExactMatch extends $f5b9d1c868e8b908$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "inverse-exact";
    }
    static get multiRegex() {
        return /^!"(.*)"$/;
    }
    static get singleRegex() {
        return /^!(.*)$/;
    }
    search(text) {
        const index = text.indexOf(this.pattern);
        const isMatch = index === -1;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
// Token: ^file
class $f5b9d1c868e8b908$var$PrefixExactMatch extends $f5b9d1c868e8b908$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "prefix-exact";
    }
    static get multiRegex() {
        return /^\^"(.*)"$/;
    }
    static get singleRegex() {
        return /^\^(.*)$/;
    }
    search(text) {
        const isMatch = text.startsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                this.pattern.length - 1
            ]
        };
    }
}
// Token: !^fire
class $f5b9d1c868e8b908$var$InversePrefixExactMatch extends $f5b9d1c868e8b908$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "inverse-prefix-exact";
    }
    static get multiRegex() {
        return /^!\^"(.*)"$/;
    }
    static get singleRegex() {
        return /^!\^(.*)$/;
    }
    search(text) {
        const isMatch = !text.startsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
// Token: .file$
class $f5b9d1c868e8b908$var$SuffixExactMatch extends $f5b9d1c868e8b908$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "suffix-exact";
    }
    static get multiRegex() {
        return /^"(.*)"\$$/;
    }
    static get singleRegex() {
        return /^(.*)\$$/;
    }
    search(text) {
        const isMatch = text.endsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                text.length - this.pattern.length,
                text.length - 1
            ]
        };
    }
}
// Token: !.file$
class $f5b9d1c868e8b908$var$InverseSuffixExactMatch extends $f5b9d1c868e8b908$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "inverse-suffix-exact";
    }
    static get multiRegex() {
        return /^!"(.*)"\$$/;
    }
    static get singleRegex() {
        return /^!(.*)\$$/;
    }
    search(text) {
        const isMatch = !text.endsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
class $f5b9d1c868e8b908$var$FuzzyMatch extends $f5b9d1c868e8b908$var$BaseMatch {
    constructor(pattern, { location: location = $f5b9d1c868e8b908$var$Config.location, threshold: threshold = $f5b9d1c868e8b908$var$Config.threshold, distance: distance = $f5b9d1c868e8b908$var$Config.distance, includeMatches: includeMatches = $f5b9d1c868e8b908$var$Config.includeMatches, findAllMatches: findAllMatches = $f5b9d1c868e8b908$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $f5b9d1c868e8b908$var$Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = $f5b9d1c868e8b908$var$Config.isCaseSensitive, ignoreLocation: ignoreLocation = $f5b9d1c868e8b908$var$Config.ignoreLocation } = {}){
        super(pattern);
        this._bitapSearch = new $f5b9d1c868e8b908$var$BitapSearch(pattern, {
            location: location,
            threshold: threshold,
            distance: distance,
            includeMatches: includeMatches,
            findAllMatches: findAllMatches,
            minMatchCharLength: minMatchCharLength,
            isCaseSensitive: isCaseSensitive,
            ignoreLocation: ignoreLocation
        });
    }
    static get type() {
        return "fuzzy";
    }
    static get multiRegex() {
        return /^"(.*)"$/;
    }
    static get singleRegex() {
        return /^(.*)$/;
    }
    search(text) {
        return this._bitapSearch.searchIn(text);
    }
}
// Token: 'file
class $f5b9d1c868e8b908$var$IncludeMatch extends $f5b9d1c868e8b908$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "include";
    }
    static get multiRegex() {
        return /^'"(.*)"$/;
    }
    static get singleRegex() {
        return /^'(.*)$/;
    }
    search(text) {
        let location = 0;
        let index;
        const indices = [];
        const patternLen = this.pattern.length;
        // Get all exact matches
        while((index = text.indexOf(this.pattern, location)) > -1){
            location = index + patternLen;
            indices.push([
                index,
                location - 1
            ]);
        }
        const isMatch = !!indices.length;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: indices
        };
    }
}
// ❗Order is important. DO NOT CHANGE.
const $f5b9d1c868e8b908$var$searchers = [
    $f5b9d1c868e8b908$var$ExactMatch,
    $f5b9d1c868e8b908$var$IncludeMatch,
    $f5b9d1c868e8b908$var$PrefixExactMatch,
    $f5b9d1c868e8b908$var$InversePrefixExactMatch,
    $f5b9d1c868e8b908$var$InverseSuffixExactMatch,
    $f5b9d1c868e8b908$var$SuffixExactMatch,
    $f5b9d1c868e8b908$var$InverseExactMatch,
    $f5b9d1c868e8b908$var$FuzzyMatch
];
const $f5b9d1c868e8b908$var$searchersLen = $f5b9d1c868e8b908$var$searchers.length;
// Regex to split by spaces, but keep anything in quotes together
const $f5b9d1c868e8b908$var$SPACE_RE = / +(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)/;
const $f5b9d1c868e8b908$var$OR_TOKEN = "|";
// Return a 2D array representation of the query, for simpler parsing.
// Example:
// "^core go$ | rb$ | py$ xy$" => [["^core", "go$"], ["rb$"], ["py$", "xy$"]]
function $f5b9d1c868e8b908$var$parseQuery(pattern, options = {}) {
    return pattern.split($f5b9d1c868e8b908$var$OR_TOKEN).map((item)=>{
        let query = item.trim().split($f5b9d1c868e8b908$var$SPACE_RE).filter((item)=>item && !!item.trim());
        let results = [];
        for(let i = 0, len = query.length; i < len; i += 1){
            const queryItem = query[i];
            // 1. Handle multiple query match (i.e, once that are quoted, like `"hello world"`)
            let found = false;
            let idx = -1;
            while(!found && ++idx < $f5b9d1c868e8b908$var$searchersLen){
                const searcher = $f5b9d1c868e8b908$var$searchers[idx];
                let token = searcher.isMultiMatch(queryItem);
                if (token) {
                    results.push(new searcher(token, options));
                    found = true;
                }
            }
            if (found) continue;
            // 2. Handle single query matches (i.e, once that are *not* quoted)
            idx = -1;
            while(++idx < $f5b9d1c868e8b908$var$searchersLen){
                const searcher = $f5b9d1c868e8b908$var$searchers[idx];
                let token = searcher.isSingleMatch(queryItem);
                if (token) {
                    results.push(new searcher(token, options));
                    break;
                }
            }
        }
        return results;
    });
}
// These extended matchers can return an array of matches, as opposed
// to a singl match
const $f5b9d1c868e8b908$var$MultiMatchSet = new Set([
    $f5b9d1c868e8b908$var$FuzzyMatch.type,
    $f5b9d1c868e8b908$var$IncludeMatch.type
]);
/**
 * Command-like searching
 * ======================
 *
 * Given multiple search terms delimited by spaces.e.g. `^jscript .python$ ruby !java`,
 * search in a given text.
 *
 * Search syntax:
 *
 * | Token       | Match type                 | Description                            |
 * | ----------- | -------------------------- | -------------------------------------- |
 * | `jscript`   | fuzzy-match                | Items that fuzzy match `jscript`       |
 * | `=scheme`   | exact-match                | Items that are `scheme`                |
 * | `'python`   | include-match              | Items that include `python`            |
 * | `!ruby`     | inverse-exact-match        | Items that do not include `ruby`       |
 * | `^java`     | prefix-exact-match         | Items that start with `java`           |
 * | `!^earlang` | inverse-prefix-exact-match | Items that do not start with `earlang` |
 * | `.js$`      | suffix-exact-match         | Items that end with `.js`              |
 * | `!.go$`     | inverse-suffix-exact-match | Items that do not end with `.go`       |
 *
 * A single pipe character acts as an OR operator. For example, the following
 * query matches entries that start with `core` and end with either`go`, `rb`,
 * or`py`.
 *
 * ```
 * ^core go$ | rb$ | py$
 * ```
 */ class $f5b9d1c868e8b908$var$ExtendedSearch {
    constructor(pattern, { isCaseSensitive: isCaseSensitive = $f5b9d1c868e8b908$var$Config.isCaseSensitive, includeMatches: includeMatches = $f5b9d1c868e8b908$var$Config.includeMatches, minMatchCharLength: minMatchCharLength = $f5b9d1c868e8b908$var$Config.minMatchCharLength, ignoreLocation: ignoreLocation = $f5b9d1c868e8b908$var$Config.ignoreLocation, findAllMatches: findAllMatches = $f5b9d1c868e8b908$var$Config.findAllMatches, location: location = $f5b9d1c868e8b908$var$Config.location, threshold: threshold = $f5b9d1c868e8b908$var$Config.threshold, distance: distance = $f5b9d1c868e8b908$var$Config.distance } = {}){
        this.query = null;
        this.options = {
            isCaseSensitive: isCaseSensitive,
            includeMatches: includeMatches,
            minMatchCharLength: minMatchCharLength,
            findAllMatches: findAllMatches,
            ignoreLocation: ignoreLocation,
            location: location,
            threshold: threshold,
            distance: distance
        };
        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        this.query = $f5b9d1c868e8b908$var$parseQuery(this.pattern, this.options);
    }
    static condition(_, options) {
        return options.useExtendedSearch;
    }
    searchIn(text) {
        const query = this.query;
        if (!query) return {
            isMatch: false,
            score: 1
        };
        const { includeMatches: includeMatches, isCaseSensitive: isCaseSensitive } = this.options;
        text = isCaseSensitive ? text : text.toLowerCase();
        let numMatches = 0;
        let allIndices = [];
        let totalScore = 0;
        // ORs
        for(let i = 0, qLen = query.length; i < qLen; i += 1){
            const searchers = query[i];
            // Reset indices
            allIndices.length = 0;
            numMatches = 0;
            // ANDs
            for(let j = 0, pLen = searchers.length; j < pLen; j += 1){
                const searcher = searchers[j];
                const { isMatch: isMatch, indices: indices, score: score } = searcher.search(text);
                if (isMatch) {
                    numMatches += 1;
                    totalScore += score;
                    if (includeMatches) {
                        const type = searcher.constructor.type;
                        if ($f5b9d1c868e8b908$var$MultiMatchSet.has(type)) allIndices = [
                            ...allIndices,
                            ...indices
                        ];
                        else allIndices.push(indices);
                    }
                } else {
                    totalScore = 0;
                    numMatches = 0;
                    allIndices.length = 0;
                    break;
                }
            }
            // OR condition, so if TRUE, return
            if (numMatches) {
                let result = {
                    isMatch: true,
                    score: totalScore / numMatches
                };
                if (includeMatches) result.indices = allIndices;
                return result;
            }
        }
        // Nothing was matched
        return {
            isMatch: false,
            score: 1
        };
    }
}
const $f5b9d1c868e8b908$var$registeredSearchers = [];
function $f5b9d1c868e8b908$var$register(...args) {
    $f5b9d1c868e8b908$var$registeredSearchers.push(...args);
}
function $f5b9d1c868e8b908$var$createSearcher(pattern, options) {
    for(let i = 0, len = $f5b9d1c868e8b908$var$registeredSearchers.length; i < len; i += 1){
        let searcherClass = $f5b9d1c868e8b908$var$registeredSearchers[i];
        if (searcherClass.condition(pattern, options)) return new searcherClass(pattern, options);
    }
    return new $f5b9d1c868e8b908$var$BitapSearch(pattern, options);
}
const $f5b9d1c868e8b908$var$LogicalOperator = {
    AND: "$and",
    OR: "$or"
};
const $f5b9d1c868e8b908$var$KeyType = {
    PATH: "$path",
    PATTERN: "$val"
};
const $f5b9d1c868e8b908$var$isExpression = (query)=>!!(query[$f5b9d1c868e8b908$var$LogicalOperator.AND] || query[$f5b9d1c868e8b908$var$LogicalOperator.OR]);
const $f5b9d1c868e8b908$var$isPath = (query)=>!!query[$f5b9d1c868e8b908$var$KeyType.PATH];
const $f5b9d1c868e8b908$var$isLeaf = (query)=>!$f5b9d1c868e8b908$var$isArray(query) && $f5b9d1c868e8b908$var$isObject(query) && !$f5b9d1c868e8b908$var$isExpression(query);
const $f5b9d1c868e8b908$var$convertToExplicit = (query)=>({
        [$f5b9d1c868e8b908$var$LogicalOperator.AND]: Object.keys(query).map((key)=>({
                [key]: query[key]
            }))
    });
// When `auto` is `true`, the parse function will infer and initialize and add
// the appropriate `Searcher` instance
function $f5b9d1c868e8b908$var$parse(query, options, { auto: auto = true } = {}) {
    const next = (query)=>{
        let keys = Object.keys(query);
        const isQueryPath = $f5b9d1c868e8b908$var$isPath(query);
        if (!isQueryPath && keys.length > 1 && !$f5b9d1c868e8b908$var$isExpression(query)) return next($f5b9d1c868e8b908$var$convertToExplicit(query));
        if ($f5b9d1c868e8b908$var$isLeaf(query)) {
            const key = isQueryPath ? query[$f5b9d1c868e8b908$var$KeyType.PATH] : keys[0];
            const pattern = isQueryPath ? query[$f5b9d1c868e8b908$var$KeyType.PATTERN] : query[key];
            if (!$f5b9d1c868e8b908$var$isString(pattern)) throw new Error($f5b9d1c868e8b908$var$LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY(key));
            const obj = {
                keyId: $f5b9d1c868e8b908$var$createKeyId(key),
                pattern: pattern
            };
            if (auto) obj.searcher = $f5b9d1c868e8b908$var$createSearcher(pattern, options);
            return obj;
        }
        let node = {
            children: [],
            operator: keys[0]
        };
        keys.forEach((key)=>{
            const value = query[key];
            if ($f5b9d1c868e8b908$var$isArray(value)) value.forEach((item)=>{
                node.children.push(next(item));
            });
        });
        return node;
    };
    if (!$f5b9d1c868e8b908$var$isExpression(query)) query = $f5b9d1c868e8b908$var$convertToExplicit(query);
    return next(query);
}
// Practical scoring function
function $f5b9d1c868e8b908$var$computeScore(results, { ignoreFieldNorm: ignoreFieldNorm = $f5b9d1c868e8b908$var$Config.ignoreFieldNorm }) {
    results.forEach((result)=>{
        let totalScore = 1;
        result.matches.forEach(({ key: key, norm: norm, score: score })=>{
            const weight = key ? key.weight : null;
            totalScore *= Math.pow(score === 0 && weight ? Number.EPSILON : score, (weight || 1) * (ignoreFieldNorm ? 1 : norm));
        });
        result.score = totalScore;
    });
}
function $f5b9d1c868e8b908$var$transformMatches(result, data) {
    const matches = result.matches;
    data.matches = [];
    if (!$f5b9d1c868e8b908$var$isDefined(matches)) return;
    matches.forEach((match)=>{
        if (!$f5b9d1c868e8b908$var$isDefined(match.indices) || !match.indices.length) return;
        const { indices: indices, value: value } = match;
        let obj = {
            indices: indices,
            value: value
        };
        if (match.key) obj.key = match.key.src;
        if (match.idx > -1) obj.refIndex = match.idx;
        data.matches.push(obj);
    });
}
function $f5b9d1c868e8b908$var$transformScore(result, data) {
    data.score = result.score;
}
function $f5b9d1c868e8b908$var$format(results, docs, { includeMatches: includeMatches = $f5b9d1c868e8b908$var$Config.includeMatches, includeScore: includeScore = $f5b9d1c868e8b908$var$Config.includeScore } = {}) {
    const transformers = [];
    if (includeMatches) transformers.push($f5b9d1c868e8b908$var$transformMatches);
    if (includeScore) transformers.push($f5b9d1c868e8b908$var$transformScore);
    return results.map((result)=>{
        const { idx: idx } = result;
        const data = {
            item: docs[idx],
            refIndex: idx
        };
        if (transformers.length) transformers.forEach((transformer)=>{
            transformer(result, data);
        });
        return data;
    });
}
class $f5b9d1c868e8b908$export$2e2bcd8739ae039 {
    constructor(docs, options = {}, index){
        this.options = {
            ...$f5b9d1c868e8b908$var$Config,
            ...options
        };
        this.options.useExtendedSearch;
        this._keyStore = new $f5b9d1c868e8b908$var$KeyStore(this.options.keys);
        this.setCollection(docs, index);
    }
    setCollection(docs, index) {
        this._docs = docs;
        if (index && !(index instanceof $f5b9d1c868e8b908$var$FuseIndex)) throw new Error($f5b9d1c868e8b908$var$INCORRECT_INDEX_TYPE);
        this._myIndex = index || $f5b9d1c868e8b908$var$createIndex(this.options.keys, this._docs, {
            getFn: this.options.getFn,
            fieldNormWeight: this.options.fieldNormWeight
        });
    }
    add(doc) {
        if (!$f5b9d1c868e8b908$var$isDefined(doc)) return;
        this._docs.push(doc);
        this._myIndex.add(doc);
    }
    remove(predicate = ()=>false) {
        const results = [];
        for(let i = 0, len = this._docs.length; i < len; i += 1){
            const doc = this._docs[i];
            if (predicate(doc, i)) {
                this.removeAt(i);
                i -= 1;
                len -= 1;
                results.push(doc);
            }
        }
        return results;
    }
    removeAt(idx) {
        this._docs.splice(idx, 1);
        this._myIndex.removeAt(idx);
    }
    getIndex() {
        return this._myIndex;
    }
    search(query, { limit: limit = -1 } = {}) {
        const { includeMatches: includeMatches, includeScore: includeScore, shouldSort: shouldSort, sortFn: sortFn, ignoreFieldNorm: ignoreFieldNorm } = this.options;
        let results = $f5b9d1c868e8b908$var$isString(query) ? $f5b9d1c868e8b908$var$isString(this._docs[0]) ? this._searchStringList(query) : this._searchObjectList(query) : this._searchLogical(query);
        $f5b9d1c868e8b908$var$computeScore(results, {
            ignoreFieldNorm: ignoreFieldNorm
        });
        if (shouldSort) results.sort(sortFn);
        if ($f5b9d1c868e8b908$var$isNumber(limit) && limit > -1) results = results.slice(0, limit);
        return $f5b9d1c868e8b908$var$format(results, this._docs, {
            includeMatches: includeMatches,
            includeScore: includeScore
        });
    }
    _searchStringList(query) {
        const searcher = $f5b9d1c868e8b908$var$createSearcher(query, this.options);
        const { records: records } = this._myIndex;
        const results = [];
        // Iterate over every string in the index
        records.forEach(({ v: text, i: idx, n: norm })=>{
            if (!$f5b9d1c868e8b908$var$isDefined(text)) return;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) results.push({
                item: text,
                idx: idx,
                matches: [
                    {
                        score: score,
                        value: text,
                        norm: norm,
                        indices: indices
                    }
                ]
            });
        });
        return results;
    }
    _searchLogical(query) {
        const expression = $f5b9d1c868e8b908$var$parse(query, this.options);
        const evaluate = (node, item, idx)=>{
            if (!node.children) {
                const { keyId: keyId, searcher: searcher } = node;
                const matches = this._findMatches({
                    key: this._keyStore.get(keyId),
                    value: this._myIndex.getValueForItemAtKeyId(item, keyId),
                    searcher: searcher
                });
                if (matches && matches.length) return [
                    {
                        idx: idx,
                        item: item,
                        matches: matches
                    }
                ];
                return [];
            }
            const res = [];
            for(let i = 0, len = node.children.length; i < len; i += 1){
                const child = node.children[i];
                const result = evaluate(child, item, idx);
                if (result.length) res.push(...result);
                else if (node.operator === $f5b9d1c868e8b908$var$LogicalOperator.AND) return [];
            }
            return res;
        };
        const records = this._myIndex.records;
        const resultMap = {};
        const results = [];
        records.forEach(({ $: item, i: idx })=>{
            if ($f5b9d1c868e8b908$var$isDefined(item)) {
                let expResults = evaluate(expression, item, idx);
                if (expResults.length) {
                    // Dedupe when adding
                    if (!resultMap[idx]) {
                        resultMap[idx] = {
                            idx: idx,
                            item: item,
                            matches: []
                        };
                        results.push(resultMap[idx]);
                    }
                    expResults.forEach(({ matches: matches })=>{
                        resultMap[idx].matches.push(...matches);
                    });
                }
            }
        });
        return results;
    }
    _searchObjectList(query) {
        const searcher = $f5b9d1c868e8b908$var$createSearcher(query, this.options);
        const { keys: keys, records: records } = this._myIndex;
        const results = [];
        // List is Array<Object>
        records.forEach(({ $: item, i: idx })=>{
            if (!$f5b9d1c868e8b908$var$isDefined(item)) return;
            let matches = [];
            // Iterate over every key (i.e, path), and fetch the value at that key
            keys.forEach((key, keyIndex)=>{
                matches.push(...this._findMatches({
                    key: key,
                    value: item[keyIndex],
                    searcher: searcher
                }));
            });
            if (matches.length) results.push({
                idx: idx,
                item: item,
                matches: matches
            });
        });
        return results;
    }
    _findMatches({ key: key, value: value, searcher: searcher }) {
        if (!$f5b9d1c868e8b908$var$isDefined(value)) return [];
        let matches = [];
        if ($f5b9d1c868e8b908$var$isArray(value)) value.forEach(({ v: text, i: idx, n: norm })=>{
            if (!$f5b9d1c868e8b908$var$isDefined(text)) return;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) matches.push({
                score: score,
                key: key,
                value: text,
                idx: idx,
                norm: norm,
                indices: indices
            });
        });
        else {
            const { v: text, n: norm } = value;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) matches.push({
                score: score,
                key: key,
                value: text,
                norm: norm,
                indices: indices
            });
        }
        return matches;
    }
}
$f5b9d1c868e8b908$export$2e2bcd8739ae039.version = "7.0.0";
$f5b9d1c868e8b908$export$2e2bcd8739ae039.createIndex = $f5b9d1c868e8b908$var$createIndex;
$f5b9d1c868e8b908$export$2e2bcd8739ae039.parseIndex = $f5b9d1c868e8b908$var$parseIndex;
$f5b9d1c868e8b908$export$2e2bcd8739ae039.config = $f5b9d1c868e8b908$var$Config;
$f5b9d1c868e8b908$export$2e2bcd8739ae039.parseQuery = $f5b9d1c868e8b908$var$parse;
$f5b9d1c868e8b908$var$register($f5b9d1c868e8b908$var$ExtendedSearch);







function $eeb013766b69d463$export$2e2bcd8739ae039({ mood: mood }) {
    return mood === undefined ? /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("td", {
        className: "center",
        children: "N/A"
    }) : /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $041b0fb8a1821c7a$export$2e2bcd8739ae039), {
        mood: mood
    });
}






const $0fbbcdf599dfcb96$var$DAYS_PER_PAGE = 7;
const $0fbbcdf599dfcb96$var$groupMoodIdsByDay = (moodIds)=>{
    const moodsByDate = (0, $c2e94012e82e0308$export$5563593ccbfe9912)(()=>[]);
    for (const id of moodIds)moodsByDate[(0, $c2e94012e82e0308$export$f3013bcc8d8645bd)(new Date(id))].push(id);
    return Object.entries(moodsByDate);
};
function $0fbbcdf599dfcb96$export$2e2bcd8739ae039() {
    const moods = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.normalizedMoods);
    const denormalizedMoods = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.denormalizedMoods);
    const moodIdsByDate = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.moodIdsByDate);
    const [localState, localDispatch] = (0, $lBnVc.useReducer)((0, $a87faee8b256efa8$export$1650419e431d3ba3), (0, $a87faee8b256efa8$export$d4c72bab9d6cc13a));
    const normalizedDescriptionWords = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.normalizedDescriptionWords);
    const dateNow = new Date();
    const [dateTo, setDateTo] = (0, $lBnVc.useState)((0, $c2e94012e82e0308$export$4b61d8bc5e82982b)(dateNow));
    const [dateFrom, setDateFrom] = (0, $lBnVc.useState)((0, $c2e94012e82e0308$export$cba7498d83c2e2d)(new Date(moods.allIds[0])));
    const filterDescriptions = localState.filterDescription.trim().toLowerCase().split(/\s+/).filter(Boolean);
    const filterFeatureAvailable = moods.allIds.length >= 5;
    let filteredMoodIds = moods.allIds;
    if (localState.shouldShowFilter) {
        let filteredMoods = denormalizedMoods.filter((mood)=>{
            if (localState.filterMood !== undefined && mood.mood !== localState.filterMood) return false;
            const date = new Date(mood.createdAt);
            if (date < dateFrom || date > dateTo) return false;
            if (filterDescriptions.length) {
                const normalizedMoodDescription = mood.description?.toLowerCase();
                if (!filterDescriptions.every((description)=>normalizedMoodDescription?.includes(description))) return false;
            }
            return true;
        });
        if (localState.searchString) {
            const fuse = new (0, $f5b9d1c868e8b908$export$2e2bcd8739ae039)(filteredMoods, {
                distance: Infinity,
                includeScore: true,
                keys: [
                    {
                        name: "description",
                        weight: 2
                    },
                    "exploration"
                ],
                shouldSort: false,
                threshold: 0.25
            });
            const result = fuse.search(localState.searchString);
            filteredMoods = result.map(({ item: item })=>item);
        }
        filteredMoodIds = filteredMoods.map(({ createdAt: createdAt })=>createdAt);
    }
    const filteredMoodsGroupedByDay = localState.shouldShowFilter ? $0fbbcdf599dfcb96$var$groupMoodIdsByDay(filteredMoodIds) : Object.entries(moodIdsByDate);
    const pageCount = Math.max(Math.ceil(filteredMoodsGroupedByDay.length / $0fbbcdf599dfcb96$var$DAYS_PER_PAGE), 1);
    let averageMood;
    if (filteredMoodIds.length) {
        let moodsSum = 0;
        for(let i = 0; i < filteredMoodIds.length; i++)moodsSum += moods.byId[filteredMoodIds[i]].mood;
        averageMood = moodsSum / filteredMoodIds.length;
    }
    const endIndex = filteredMoodsGroupedByDay.length - localState.page * $0fbbcdf599dfcb96$var$DAYS_PER_PAGE;
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039).Group, {
        children: [
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h2", {
                        children: "Mood log"
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("h3", {
                        children: [
                            "Export",
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $19d86a636b501d10$export$2e2bcd8739ae039), {
                                children: "Export all your moods (choose CSV format if you want to load your data into a spreadsheet)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $d4552df15b9ab2b8$export$2e2bcd8739ae039), {
                        category: "moods",
                        denormalizedData: denormalizedMoods
                    }),
                    filterFeatureAvailable && /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h3", {
                                children: "Search"
                            }),
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $828cb8aa9adcb6a3$export$2e2bcd8739ae039), {
                                checked: localState.shouldShowFilter,
                                label: "Toggle search",
                                onChange: (e)=>localDispatch({
                                        payload: e.target.checked,
                                        type: "shouldShowFilter/set"
                                    })
                            }),
                            localState.shouldShowFilter && /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("div", {
                                className: "slide-in",
                                children: [
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $78053ee2024d275e$export$2e2bcd8739ae039), {
                                        label: "Search",
                                        supportiveText: "Fuzzy search across mood tags and journal entries",
                                        onChange: (e)=>localDispatch({
                                                payload: e.target.value,
                                                type: "searchString/set"
                                            }),
                                        required: false,
                                        type: "search",
                                        value: localState.searchString
                                    }),
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $3b97bac8379fc04c$export$2e2bcd8739ae039), {
                                        label: (0, $5a123094476b33d7$export$e6909ad44e61103d).description.label,
                                        supportiveText: "Search for a specific mood tag",
                                        maxLength: (0, $5a123094476b33d7$export$99e2532e676f9073),
                                        onChange: (e)=>localDispatch({
                                                payload: e.target.value,
                                                type: "filterDescription/set"
                                            }),
                                        options: normalizedDescriptionWords,
                                        required: false,
                                        type: "search",
                                        value: localState.filterDescription
                                    }),
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $9a780bd1b5aff71e$export$2e2bcd8739ae039), {
                                        label: (0, $5a123094476b33d7$export$e6909ad44e61103d).mood.label,
                                        onChange: (e)=>localDispatch(e.target.value ? {
                                                payload: Number(e.target.value),
                                                type: "filterMood/set"
                                            } : {
                                                type: "filterMood/clear"
                                            }),
                                        required: false,
                                        value: localState.filterMood === undefined ? "" : localState.filterMood,
                                        supportiveText: "Search for a specific mood value",
                                        children: [
                                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("option", {
                                                value: "",
                                                children: "Any mood"
                                            }),
                                            (0, $5a123094476b33d7$export$88df5ff28be7bede).map((mood)=>/*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("option", {
                                                    value: mood,
                                                    children: mood
                                                }, mood))
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $468d5739b3a923e8$export$2e2bcd8739ae039), {
                                        dateFrom: dateFrom,
                                        dateTo: dateTo,
                                        setDateFrom: setDateFrom,
                                        setDateTo: setDateTo
                                    }),
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("table", {
                                        children: [
                                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("thead", {
                                                children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("th", {
                                                            children: "Stat"
                                                        }),
                                                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("th", {
                                                            children: "Value"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("tbody", {
                                                children: [
                                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("td", {
                                                                children: "Total moods"
                                                            }),
                                                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("td", {
                                                                children: filteredMoodIds.length
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("td", {
                                                                children: "Average mood"
                                                            }),
                                                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $eeb013766b69d463$export$2e2bcd8739ae039), {
                                                                mood: averageMood
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            filteredMoodsGroupedByDay.length ? (0, $c2e94012e82e0308$export$7ff0d353c23134fe)(filteredMoodsGroupedByDay.slice(Math.max(endIndex - $0fbbcdf599dfcb96$var$DAYS_PER_PAGE, 0), endIndex), ([dayStr, ids])=>{
                const day = (0, $c2e94012e82e0308$export$27d3dd4acf9951a1)(dayStr);
                return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h3", {
                            children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e94b7bcc277332d2$export$a6c7ac8248d6e38a), {
                                to: `/stats/days/${dayStr}`,
                                children: (0, $06d17fa75ca1067f$export$5b8f5fb13700b442).format(day)
                            })
                        }),
                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $0a48ec8918b8b79c$export$2e2bcd8739ae039), {
                            dateFrom: day,
                            dateTo: (0, $cb8fdbef2aba70f2$export$dd412b56f1e4d8aa)(day, 1)
                        }),
                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $7c1560fa3a8ca778$export$2e2bcd8739ae039).Group, {
                            children: (0, $c2e94012e82e0308$export$7ff0d353c23134fe)(ids, (id)=>/*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $793264348b86e468$export$2e2bcd8739ae039), {
                                    id: id
                                }, id))
                        })
                    ]
                }, dayStr);
            }) : /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h3", {
                        children: "No results found"
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("p", {
                        children: "Try again with a different search"
                    })
                ]
            }),
            pageCount > 1 && /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $64123a2209d9f6c7$export$2e2bcd8739ae039), {
                    onChange: (page)=>localDispatch({
                            payload: page,
                            type: "page/set"
                        }),
                    page: localState.page,
                    pageCount: pageCount
                })
            })
        ]
    });
}





function $7f16bb8c2780ff6d$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039).Group, {
        children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h2", {
                    children: "Notifications"
                }),
                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $2be2442199753677$export$2e2bcd8739ae039), {})
            ]
        })
    });
}




var $lBnVc = parcelRequire("lBnVc");







var $lBnVc = parcelRequire("lBnVc");
const $9cec7efa8374b32b$var$OpenEndedMeditationPresentation = ({ dimmed: dimmed, isPaused: isPaused, onDim: onDim, onFinishAndLog: onFinishAndLog, onPause: onPause, onPlay: onPlay, onUndim: onUndim, roundedSeconds: roundedSeconds })=>{
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039).Group, {
                children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h2", {
                            children: "Open-ended meditation"
                        }),
                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("p", {
                            className: "center m-open-ended-meditation__clock",
                            children: (0, $c2e94012e82e0308$export$e0c93ebdf17e89e6)(roundedSeconds)
                        }),
                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039).Group, {
                            children: [
                                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039), {
                                    onClick: onFinishAndLog,
                                    children: "Finish & log"
                                }),
                                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039), {
                                    onClick: onDim,
                                    variant: "secondary",
                                    children: [
                                        "Dim screen",
                                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                                            margin: "start",
                                            name: "moon"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039), {
                                    onClick: ()=>{
                                        if (isPaused) return onPlay();
                                        onPause();
                                    },
                                    variant: "secondary",
                                    children: isPaused ? /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
                                        children: [
                                            "Play",
                                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                                                margin: "start",
                                                name: "play"
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
                                        children: [
                                            "Pause",
                                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                                                margin: "start",
                                                name: "pause"
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $4241c6959d722408$export$2e2bcd8739ae039), {
                enabled: dimmed,
                onUndim: onUndim
            })
        ]
    });
};
var $9cec7efa8374b32b$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $lBnVc.memo)($9cec7efa8374b32b$var$OpenEndedMeditationPresentation);






function $29dca47dbf60e2e4$export$2e2bcd8739ae039() {
    const [secondsElapsed, setSecondsElapsed] = (0, $lBnVc.useState)(0);
    const [isDimmerEnabled, setIsDimmerEnabled] = (0, $lBnVc.useState)(false);
    const [isPaused, setIsPaused] = (0, $lBnVc.useState)(false);
    const dispatch = (0, $d3287b130d7b0f6b$export$8ad76b76a4c905f8)();
    const geolocation = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $2f1313f9e65d1ec4$export$2e2bcd8739ae039).selectors.geolocation);
    const navigate = (0, $f02d97b5ca509f34$export$9770f232ac06a008)();
    const initialTime = (0, $lBnVc.useRef)(Date.now());
    const roundedSecondsElapsed = Math.round(secondsElapsed);
    const onDim = (0, $lBnVc.useCallback)(()=>setIsDimmerEnabled(true), []);
    const onFinishAndLog = (0, $lBnVc.useCallback)(()=>{
        const payload = {
            seconds: roundedSecondsElapsed
        };
        if (geolocation) payload.location = geolocation;
        dispatch((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).actions.add({
            type: "v1/meditations/create",
            createdAt: new Date().toISOString(),
            payload: payload
        }));
        navigate("/meditation/log");
    }, [
        dispatch,
        geolocation,
        navigate,
        roundedSecondsElapsed
    ]);
    const onPause = (0, $lBnVc.useCallback)(()=>{
        (0, $cd8192cd7eb9463f$export$bedec98355fa7b1e).disable();
        setIsPaused(true);
    }, []);
    const onPlay = (0, $lBnVc.useCallback)(()=>{
        (0, $cd8192cd7eb9463f$export$bedec98355fa7b1e).enable();
        initialTime.current = Date.now() - roundedSecondsElapsed * 1e3;
        setIsPaused(false);
    }, [
        roundedSecondsElapsed
    ]);
    const onUndim = (0, $lBnVc.useCallback)(()=>setIsDimmerEnabled(false), []);
    (0, $lBnVc.useEffect)(()=>{
        (0, $cd8192cd7eb9463f$export$bedec98355fa7b1e).enable();
        return ()=>{
            (0, $cd8192cd7eb9463f$export$bedec98355fa7b1e).disable();
        };
    }, []);
    (0, $lBnVc.useEffect)(()=>{
        let abort = false;
        requestAnimationFrame(function update() {
            if (isPaused || abort) return;
            requestAnimationFrame(update);
            setSecondsElapsed((Date.now() - initialTime.current) / 1e3);
        });
        return ()=>void (abort = true);
    }, [
        isPaused,
        setSecondsElapsed
    ]);
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $9cec7efa8374b32b$export$2e2bcd8739ae039), {
        dimmed: isDimmerEnabled,
        isPaused: isPaused,
        onDim: onDim,
        onFinishAndLog: onFinishAndLog,
        onPause: onPause,
        onPlay: onPlay,
        onUndim: onUndim,
        roundedSeconds: roundedSecondsElapsed
    });
}

















var $lBnVc = parcelRequire("lBnVc");
const $7ee20e85ab855c69$var$MAX_MONTHS_PER_PAGE = 12;
function $7ee20e85ab855c69$export$2e2bcd8739ae039() {
    const meanMoodByMonth = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.meanMoodsByMonth);
    const months = Object.keys(meanMoodByMonth);
    const [page, setPage] = (0, $lBnVc.useState)(0);
    const pageCount = Math.ceil(months.length / $7ee20e85ab855c69$var$MAX_MONTHS_PER_PAGE);
    const endIndex = months.length - $7ee20e85ab855c69$var$MAX_MONTHS_PER_PAGE * page;
    const startIndex = Math.max(0, endIndex - $7ee20e85ab855c69$var$MAX_MONTHS_PER_PAGE);
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h2", {
                children: "Months"
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("table", {
                children: [
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("thead", {
                        children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("th", {
                                    children: "Month"
                                }),
                                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("th", {
                                    children: "Mood gradient"
                                }),
                                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("th", {
                                    children: "Average mood"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("tbody", {
                        children: (0, $c2e94012e82e0308$export$7ff0d353c23134fe)(months.slice(startIndex, endIndex), (dateString)=>{
                            const month = (0, $c2e94012e82e0308$export$27d3dd4acf9951a1)(dateString);
                            const monthStr = (0, $06d17fa75ca1067f$export$550deca24c3b7679).format(month);
                            return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("td", {
                                        children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e94b7bcc277332d2$export$a6c7ac8248d6e38a), {
                                            to: `months/${(0, $c2e94012e82e0308$export$30a208a52f4a49de)(month)}`,
                                            children: monthStr
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("td", {
                                        children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $0a48ec8918b8b79c$export$2e2bcd8739ae039), {
                                            dateFrom: month,
                                            dateTo: (0, $857e6f903d884172$export$17c93e242b2d3a22)(month, 1)
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $041b0fb8a1821c7a$export$2e2bcd8739ae039), {
                                        mood: meanMoodByMonth[dateString]
                                    })
                                ]
                            }, monthStr);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $64123a2209d9f6c7$export$2e2bcd8739ae039), {
                onChange: setPage,
                page: page,
                pageCount: pageCount
            })
        ]
    });
}















var $lBnVc = parcelRequire("lBnVc");
const $eb5fff7b9d3ff7dd$var$MAX_WEEKS_PER_PAGE = 8;
function $eb5fff7b9d3ff7dd$export$2e2bcd8739ae039() {
    const meanMoodsByWeek = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.meanMoodsByWeek);
    const weeks = Object.keys(meanMoodsByWeek);
    const [page, setPage] = (0, $lBnVc.useState)(0);
    const pageCount = Math.ceil(weeks.length / $eb5fff7b9d3ff7dd$var$MAX_WEEKS_PER_PAGE);
    const endIndex = weeks.length - $eb5fff7b9d3ff7dd$var$MAX_WEEKS_PER_PAGE * page;
    const startIndex = Math.max(0, endIndex - $eb5fff7b9d3ff7dd$var$MAX_WEEKS_PER_PAGE);
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h2", {
                children: "Weeks"
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("table", {
                children: [
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("thead", {
                        children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("th", {
                                    children: "Week"
                                }),
                                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("th", {
                                    children: "Mood gradient"
                                }),
                                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("th", {
                                    children: "Average mood"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("tbody", {
                        children: (0, $c2e94012e82e0308$export$7ff0d353c23134fe)(weeks.slice(startIndex, endIndex), (dateString)=>{
                            const week = (0, $c2e94012e82e0308$export$27d3dd4acf9951a1)(dateString);
                            const weekFormattedString = (0, $06d17fa75ca1067f$export$c8fd8d8bcad3b27c)(week);
                            return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("td", {
                                        children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e94b7bcc277332d2$export$a6c7ac8248d6e38a), {
                                            to: `weeks/${(0, $c2e94012e82e0308$export$f3013bcc8d8645bd)((0, $f2ddddaabfe67186$export$42c81a444fbfb5d4)(week, (0, $06d17fa75ca1067f$export$34c88de16c0a2653)))}`,
                                            children: weekFormattedString
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("td", {
                                        children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $0a48ec8918b8b79c$export$2e2bcd8739ae039), {
                                            dateFrom: week,
                                            dateTo: (0, $ad866f4678a92721$export$ef501a2bb4f3ee6b)(week, 1)
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $041b0fb8a1821c7a$export$2e2bcd8739ae039), {
                                        mood: meanMoodsByWeek[dateString]
                                    })
                                ]
                            }, weekFormattedString);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $64123a2209d9f6c7$export$2e2bcd8739ae039), {
                onChange: setPage,
                page: page,
                pageCount: pageCount
            })
        ]
    });
}












var $lBnVc = parcelRequire("lBnVc");

const $6cbad244d28b265d$var$MAX_YEARS_PER_PAGE = 8;
function $6cbad244d28b265d$export$2e2bcd8739ae039() {
    const meanMoodsByYear = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.meanMoodsByYear);
    const years = Object.keys(meanMoodsByYear);
    const [page, setPage] = (0, $lBnVc.useState)(0);
    const pageCount = Math.ceil(years.length / $6cbad244d28b265d$var$MAX_YEARS_PER_PAGE);
    const endIndex = years.length - $6cbad244d28b265d$var$MAX_YEARS_PER_PAGE * page;
    const startIndex = Math.max(0, endIndex - $6cbad244d28b265d$var$MAX_YEARS_PER_PAGE);
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h2", {
                children: "Years"
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("table", {
                children: [
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("thead", {
                        children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("th", {
                                    children: "Year"
                                }),
                                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("th", {
                                    children: "Mood gradient"
                                }),
                                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("th", {
                                    children: "Average mood"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("tbody", {
                        children: (0, $c2e94012e82e0308$export$7ff0d353c23134fe)(years.slice(startIndex, endIndex), (dateString)=>{
                            const year = (0, $c2e94012e82e0308$export$27d3dd4acf9951a1)(dateString);
                            const yearFormattedString = (0, $06d17fa75ca1067f$export$daf84c177a4aeca8).format(year);
                            return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("td", {
                                        children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e94b7bcc277332d2$export$a6c7ac8248d6e38a), {
                                            to: `years/${(0, $c2e94012e82e0308$export$60b37fc597282c94)(year)}`,
                                            children: yearFormattedString
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("td", {
                                        children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $0a48ec8918b8b79c$export$2e2bcd8739ae039), {
                                            dateFrom: year,
                                            dateTo: (0, $8481dd0cb1201679$export$3d83eec43f4ea476)(year, 1)
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $041b0fb8a1821c7a$export$2e2bcd8739ae039), {
                                        mood: meanMoodsByYear[dateString]
                                    })
                                ]
                            }, yearFormattedString);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $64123a2209d9f6c7$export$2e2bcd8739ae039), {
                onChange: setPage,
                page: page,
                pageCount: pageCount
            })
        ]
    });
}




function $766657d1346d3728$export$2e2bcd8739ae039() {
    const eventsHasLoadedFromServer = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.hasLoadedFromServer);
    const moods = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.normalizedMoods);
    if (!moods.allIds.length) return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039).Group, {
        children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $0df6bedbf9917577$export$2e2bcd8739ae039), {})
    });
    if (!eventsHasLoadedFromServer) return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $b3bd040c14d4ce5c$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039).Group, {
        "data-test-id": (0, $5a123094476b33d7$export$a2b4f255152a6585).statsOverviewPage,
        children: [
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h2", {
                        children: "Overview"
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $0a48ec8918b8b79c$export$2e2bcd8739ae039), {
                        dateFrom: new Date(moods.allIds[0]),
                        dateTo: new Date(moods.allIds.at(-1))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $eb5fff7b9d3ff7dd$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $7ee20e85ab855c69$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $6cbad244d28b265d$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h2", {
                    className: "center",
                    children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e94b7bcc277332d2$export$a6c7ac8248d6e38a), {
                        to: "explore",
                        children: "Explore"
                    })
                })
            })
        ]
    });
}




var $lBnVc = parcelRequire("lBnVc");
function $3e1054d2f56e3ed6$export$2e2bcd8739ae039({ Component: Component, title: title, ...rest }) {
    (0, $lBnVc.useEffect)(()=>{
        document.title = `MoodTracker - ${title}`;
    }, [
        title
    ]);
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)(Component, {
        ...rest
    });
}






function $2b8e3941875de3f8$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039).Group, {
        children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h2", {
                    children: "Privacy policy"
                }),
                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h3", {
                    children: "Tl;dr"
                }),
                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("p", {
                    children: [
                        "This project is",
                        " ",
                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("a", {
                            href: (0, $5a123094476b33d7$export$3508dfda2bc7d28),
                            rel: "noopener",
                            target: "_blank",
                            children: "open source"
                        }),
                        " ",
                        "so we are totally transparent about how we store your data securely. Further to this, we do not sell or share any of your data with anyone."
                    ]
                }),
                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h3", {
                    children: "What we collect and why"
                }),
                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("p", {
                    children: "We collect the minimum data required for the app to function. That means we take your email address when you sign up and we collect all the data you submit while using the app."
                }),
                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("p", {
                    children: [
                        "We also collect data on errors and crashes that we send to a",
                        " ",
                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("a", {
                            href: "https://sentry.io",
                            rel: "noopener",
                            target: "_blank",
                            children: "3rd party development tool"
                        }),
                        ". This typically does not include any user data."
                    ]
                }),
                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h3", {
                    children: "Information we do not collect"
                }),
                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("p", {
                    children: "We do not collect any data that is unnecessary for running the app, we do not collect any data you have not submitted to us, we do not use cookies and we do not run any 3rd party analytics."
                }),
                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h3", {
                    children: "Changes"
                }),
                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("p", {
                    children: [
                        "We may update this policy in the future if regulations or practices change. Because the project is open source you can view the history of this policy",
                        " ",
                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("a", {
                            href: (0, $5a123094476b33d7$export$3508dfda2bc7d28),
                            rel: "noopener",
                            target: "_blank",
                            children: "on GitHub"
                        }),
                        ". We will announce any significant policy changes on",
                        " ",
                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e94b7bcc277332d2$export$a6c7ac8248d6e38a), {
                            to: "/blog",
                            children: "our blog"
                        }),
                        "."
                    ]
                }),
                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h3", {
                    children: "Questions"
                }),
                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("p", {
                    children: [
                        "If you have any questions or feedback on this policy then please feel free to",
                        " ",
                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("a", {
                            href: (0, $5a123094476b33d7$export$2cdbc1b6a383b7bf),
                            rel: "noopener",
                            target: "_blank",
                            children: "raise an issue on GitHub"
                        }),
                        "."
                    ]
                })
            ]
        })
    });
}









const $4bdc7abd1faaabf4$var$resendConfirmation = ({ email: email })=>new Promise((resolve, reject)=>{
        (0, $97fc43514b4d4584$export$a9d932d842141dae)(email).resendConfirmationCode((err, result)=>err ? reject(err) : resolve(result));
    });
function $4bdc7abd1faaabf4$export$2e2bcd8739ae039() {
    const navigate = (0, $f02d97b5ca509f34$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $20b851c2599992db$export$2e2bcd8739ae039), {
        onSubmit: async ({ email: email, setSubmitError: setSubmitError })=>{
            try {
                await $4bdc7abd1faaabf4$var$resendConfirmation({
                    email: email
                });
                navigate("/verify");
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (e) {
                switch(e.code){
                    case "NetworkError":
                        setSubmitError((0, $5a123094476b33d7$export$4fd720569787ab6f).network);
                        break;
                    default:
                        setSubmitError((0, $5a123094476b33d7$export$4fd720569787ab6f).generic);
                }
            }
        }
    });
}






function $67c6eb35273649c1$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $c94889ba4ac6e873$export$2e2bcd8739ae039), {
        "data-test-id": (0, $5a123094476b33d7$export$a2b4f255152a6585).resetPasswordPage,
        onSubmit: async ({ code: code, email: email, password: password, setSubmitError: setSubmitError })=>new Promise((resolve, reject)=>{
                (0, $97fc43514b4d4584$export$a9d932d842141dae)(email).confirmPassword(code, password, {
                    onSuccess: ()=>resolve(),
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    onFailure: (e)=>{
                        switch(e.code){
                            case "CodeMismatchException":
                                setSubmitError("Incorrect verification code, check the data you have entered and try again");
                                break;
                            case "ExpiredCodeException":
                                setSubmitError("This verification code has expired, please request another one and try again");
                                break;
                            case "NetworkError":
                                setSubmitError((0, $5a123094476b33d7$export$4fd720569787ab6f).network);
                                break;
                            default:
                                setSubmitError((0, $5a123094476b33d7$export$4fd720569787ab6f).generic);
                        }
                        reject(JSON.stringify(e));
                    }
                });
            })
    });
}




function $0c39354e2efe43e2$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039).Group, {
        children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h2", {
                    children: "See also"
                }),
                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("p", {
                    children: "Here are some other things I've made that you might like:"
                }),
                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("ul", {
                    children: [
                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("a", {
                                    href: "https://webnotes.link",
                                    rel: "noopener",
                                    target: "_blank",
                                    children: "Webnotes"
                                }),
                                " ",
                                "is a free and open source web app that lets you create and manage notes. It's simple to use, works offline and because it runs in your browser you can use it across all your devices!"
                            ]
                        }),
                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("a", {
                                    href: "https://meditation-timer.netlify.app",
                                    rel: "noopener",
                                    target: "_blank",
                                    children: "Meditate"
                                }),
                                " ",
                                "is a free and open source web app that allows you to time your meditations. It's simple to use, works offline and aims to be the perfect aide for your meditation practice!"
                            ]
                        })
                    ]
                })
            ]
        })
    });
}










function $dd674630b2027800$export$2e2bcd8739ae039() {
    const navigate = (0, $f02d97b5ca509f34$export$9770f232ac06a008)();
    const dispatch = (0, $d3287b130d7b0f6b$export$8ad76b76a4c905f8)();
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $4089390d48037f48$export$2e2bcd8739ae039), {
        onSubmit: async ({ email: email, password: password, setSubmitError: setSubmitError })=>{
            try {
                const { cognitoUserSession: cognitoUserSession } = await (0, $97fc43514b4d4584$export$b7c211e36c1a92b5)(email, password);
                const { email: tokenEmail, sub: id } = cognitoUserSession.getIdToken().payload;
                dispatch((0, $9cfb09fae6dbced4$export$2e2bcd8739ae039).actions.set({
                    email: tokenEmail,
                    id: id
                }));
                dispatch((0, $4a1b4f367ad149f7$export$2e2bcd8739ae039).actions.newSignIn());
                navigate("/");
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (e) {
                switch(e.code){
                    case "NetworkError":
                        return setSubmitError((0, $5a123094476b33d7$export$4fd720569787ab6f).network);
                    case "UserNotConfirmedException":
                        return setSubmitError(/*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
                            children: [
                                "Check your email to verify your email address or",
                                " ",
                                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e94b7bcc277332d2$export$a6c7ac8248d6e38a), {
                                    to: "/resend-verification",
                                    children: "resend the verification email"
                                })
                            ]
                        }));
                    case "NotAuthorizedException":
                        return setSubmitError("Incorrect email/password");
                    default:
                        setSubmitError((0, $5a123094476b33d7$export$4fd720569787ab6f).generic);
                }
            }
        }
    });
}








const $9f5c29284e3de043$var$signUp = ({ attributeList: attributeList, email: email, password: password })=>new Promise((resolve, reject)=>{
        (0, $97fc43514b4d4584$export$9bd85d72295dec98).signUp(email, password, attributeList, // mismatch between types and documentation - have gone with docs
        // https://github.com/aws-amplify/amplify-js/tree/master/packages/amazon-cognito-identity-js#usage
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        null, (err, result)=>err ? reject(err) : resolve(result));
    });
function $9f5c29284e3de043$export$2e2bcd8739ae039() {
    const navigate = (0, $f02d97b5ca509f34$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $200920bc5a0804a7$export$2e2bcd8739ae039), {
        onSubmit: async ({ email: email, password: password, setSubmitError: setSubmitError })=>{
            const attributeList = [
                new (0, $07e538300be3afb7$export$2e2bcd8739ae039)({
                    Name: "email",
                    Value: email
                })
            ];
            try {
                await $9f5c29284e3de043$var$signUp({
                    attributeList: attributeList,
                    email: email,
                    password: password
                });
                navigate("/verify");
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (e) {
                switch(e.code){
                    case "NetworkError":
                        setSubmitError((0, $5a123094476b33d7$export$4fd720569787ab6f).network);
                        break;
                    case "UsernameExistsException":
                        setSubmitError("Username already exists, try signing in instead");
                        break;
                    default:
                        setSubmitError((0, $5a123094476b33d7$export$4fd720569787ab6f).generic);
                }
            }
        }
    });
}















function $1c1e8182ac650485$export$2e2bcd8739ae039({ id: id }) {
    const sleeps = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.normalizedSleeps);
    const sleep = sleeps.byId[id];
    const navigate = (0, $f02d97b5ca509f34$export$9770f232ac06a008)();
    const date = new Date(sleep.dateAwoke);
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $7c1560fa3a8ca778$export$2e2bcd8739ae039), {
        onClick: ()=>navigate(`/sleep/edit/${id}`),
        children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("div", {
            className: "m-sleep-card",
            children: [
                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("div", {
                    children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("small", {
                        children: [
                            "Slept for:",
                            " ",
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("b", {
                                "data-test-id": (0, $5a123094476b33d7$export$a2b4f255152a6585).sleepCardValue,
                                children: (0, $7bf1f584ca4dd7d4$export$2ec4521312384146)(sleep.minutesSlept)
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("div", {
                    children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("small", {
                        "data-time": Math.round(date.getTime() / 1e3),
                        children: [
                            "Woke up: ",
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("b", {
                                children: (0, $06d17fa75ca1067f$export$406508d2ca449bd).format(date)
                            })
                        ]
                    })
                })
            ]
        })
    });
}






var $lBnVc = parcelRequire("lBnVc");
const $170b09a4ef462787$var$MAX_ITEMS_PER_PAGE = 10;
function $170b09a4ef462787$export$2e2bcd8739ae039() {
    const sleeps = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.normalizedSleepsSortedByDateAwoke);
    const denormalizedSleeps = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.denormalizedSleeps);
    const [page, setPage] = (0, $lBnVc.useState)(0);
    const pageCount = Math.ceil(sleeps.allIds.length / $170b09a4ef462787$var$MAX_ITEMS_PER_PAGE);
    const endIndex = sleeps.allIds.length - $170b09a4ef462787$var$MAX_ITEMS_PER_PAGE * page;
    const startIndex = Math.max(0, endIndex - $170b09a4ef462787$var$MAX_ITEMS_PER_PAGE);
    if (!sleeps.allIds.length) return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $caf7aee3fc8a0ef0$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039).Group, {
        children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h2", {
                    children: "Sleep log"
                }),
                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("h3", {
                    children: [
                        "Export",
                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $19d86a636b501d10$export$2e2bcd8739ae039), {
                            children: "Export all your sleeps (choose CSV format if you want to load your data into a spreadsheet)"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $d4552df15b9ab2b8$export$2e2bcd8739ae039), {
                    category: "sleeps",
                    denormalizedData: denormalizedSleeps
                }),
                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("h3", {
                    children: [
                        "Log",
                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $19d86a636b501d10$export$2e2bcd8739ae039), {
                            children: "View, edit or delete all your logged sleeps"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $7c1560fa3a8ca778$export$2e2bcd8739ae039).Group, {
                    children: (0, $c2e94012e82e0308$export$7ff0d353c23134fe)(sleeps.allIds.slice(startIndex, endIndex), (id)=>/*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $1c1e8182ac650485$export$2e2bcd8739ae039), {
                            id: id
                        }, id))
                }),
                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $64123a2209d9f6c7$export$2e2bcd8739ae039), {
                    onChange: setPage,
                    page: page,
                    pageCount: pageCount
                })
            ]
        })
    });
}











function $6f12d4352e9f75ce$export$2e2bcd8739ae039({ data: data }) {
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("table", {
        className: "m-usage-table",
        children: [
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("thead", {
                children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("tr", {
                    children: [
                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("th", {
                            children: "Stat"
                        }),
                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("th", {
                            children: "Value"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("tbody", {
                children: data.map(([k, v])=>/*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("td", {
                                children: k
                            }),
                            typeof v === "object" ? v : /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("td", {
                                children: v
                            })
                        ]
                    }, k))
            })
        ]
    });
}






function $9512ed2856feb329$export$2e2bcd8739ae039() {
    const { data: data, error: error, isError: isError, isPending: isPending } = (0, $eb7b0471498e212c$export$dd0a697e1782aedd)({
        queryKey: [
            "usage"
        ],
        queryFn: (0, $4b6cae14f235e72b$export$7cf0865a17367a88),
        networkMode: "offlineFirst"
    });
    const formatAsPercentageOfMaus = (n)=>data ? (0, $035f270eea0b2c1d$export$fd01c80332d24e86).format(data.usage.MAUs ? n / data.usage.MAUs : 0) : "";
    const usersByJoinDateColumnChartData = [
        {
            label: "Less than 7 days ago",
            key: "<7 days"
        },
        {
            label: "Between 7 and 30 days ago",
            key: ">=7 & <30 days"
        },
        {
            label: "Between 30 and 60 days ago",
            key: ">=30 & <60 days"
        },
        {
            label: "Between 60 and 90 days ago",
            key: ">=60 & <90 days"
        },
        {
            label: "Between 90 and 365 days ago",
            key: ">=90 & <365 days"
        },
        {
            label: "More than a year ago",
            key: ">=365 days"
        }
    ];
    const titleEl = /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h2", {
        children: "Usage"
    });
    if (isPending) return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039).Group, {
        children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
            children: [
                titleEl,
                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("p", {
                    children: [
                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $b3bd040c14d4ce5c$export$2e2bcd8739ae039), {
                            inline: true,
                            margin: "end"
                        }),
                        "Fetching the latest stats..."
                    ]
                })
            ]
        })
    });
    if (isError) return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039).Group, {
        children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
            children: [
                titleEl,
                error instanceof Error && error.message === "500" ? /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("p", {
                    className: "negative",
                    children: [
                        "Error fetching the latest usage statistics. Something has gone wrong on our side, if the problem persists feel free to",
                        " ",
                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("a", {
                            href: (0, $5a123094476b33d7$export$2cdbc1b6a383b7bf),
                            rel: "noopener",
                            target: "_blank",
                            children: "raise an issue on GitHub"
                        }),
                        "."
                    ]
                }) : /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("p", {
                    className: "negative",
                    children: "Error fetching the latest usage statistics. You need an internet connection to fetch this data, please check and try refreshing."
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039).Group, {
        children: [
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
                children: [
                    titleEl,
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("p", {
                        children: [
                            "In case you were interested in how other people are using MoodTracker you can see some anonymized usage data here. This gets automatically updated every day or so and was last updated",
                            " ",
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("b", {
                                children: [
                                    (0, $82fe5d0003ae257e$export$d130c20a256f8817)((0, $58b603c9eda836d4$export$70823084e2deb1ea)(data.expires, 1)),
                                    " ago"
                                ]
                            }),
                            "."
                        ]
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("p", {
                        children: "In the below statistics, active users are defined as users who have tracked at least one thing over the last 30 days."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h3", {
                        children: "Users by period last active"
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $2ae3cd0ef43ccc32$export$2e2bcd8739ae039).ColumnChart, {
                        data: [
                            {
                                key: "DAUs",
                                label: "Within last 24 hours"
                            },
                            {
                                key: "WAUs",
                                label: "Within last 7 days"
                            },
                            {
                                key: "MAUs",
                                label: "Within last 30 days"
                            }
                        ].map(({ key: key, label: label })=>({
                                label: label,
                                key: key,
                                y: data.usage[key],
                                title: `${data.usage[key]} user${data.usage[key] > 1 ? "s" : ""}`
                            })),
                        rotateXLabels: true,
                        xAxisTitle: "Last active",
                        yAxisTitle: "User count"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h3", {
                        children: "Active users by join date"
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $2ae3cd0ef43ccc32$export$2e2bcd8739ae039).ColumnChart, {
                        data: usersByJoinDateColumnChartData.map(({ key: key, label: label })=>({
                                label: label,
                                key: key,
                                y: data.usage.MAUFunnel[key],
                                title: formatAsPercentageOfMaus(data.usage.MAUFunnel[key])
                            })),
                        rotateXLabels: true,
                        xAxisTitle: "Join date",
                        yAxisTitle: "Active user count"
                    })
                ]
            }),
            data.usage.byMonth && /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h3", {
                        children: "New users"
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h4", {
                        children: "Confirmed users"
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("p", {
                        children: "Confirmed users are users who create an account and confirm their email address."
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $2ae3cd0ef43ccc32$export$2e2bcd8739ae039).ColumnChart, {
                        data: Object.entries(data.usage.byMonth).map(([k, v])=>{
                            const y = v.users.confirmed;
                            return {
                                key: k,
                                label: (0, $06d17fa75ca1067f$export$d0b308cb19a3b90e).format(new Date(k)),
                                y: y,
                                title: `${k}: ${(0, $035f270eea0b2c1d$export$7774341304efafa2).format(y)} new confirmed user${y === 1 ? "" : "s"}`
                            };
                        }).sort((a, b)=>a.key.localeCompare(b.key)).slice(-12),
                        rotateXLabels: true,
                        xAxisTitle: "Month",
                        yAxisTitle: "New confirmed users"
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h4", {
                        children: "Unconfirmed users"
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("p", {
                        children: "Unconfirmed users are users who create an account but do not confirm their email address. They cannot use MoodTracker."
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $2ae3cd0ef43ccc32$export$2e2bcd8739ae039).ColumnChart, {
                        data: Object.entries(data.usage.byMonth).map(([k, v])=>{
                            const y = v.users.unconfirmed;
                            return {
                                key: k,
                                label: (0, $06d17fa75ca1067f$export$d0b308cb19a3b90e).format(new Date(k)),
                                y: y,
                                title: `${k}: ${(0, $035f270eea0b2c1d$export$7774341304efafa2).format(y)} new unconfirmed user${y === 1 ? "" : "s"}`
                            };
                        }).sort((a, b)=>a.key.localeCompare(b.key)).slice(-12),
                        rotateXLabels: true,
                        xAxisTitle: "Month",
                        yAxisTitle: "New unconfirmed users"
                    })
                ]
            }),
            data?.usage?.last28Days?.eventCountByWeekday && /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("h3", {
                        children: [
                            "Average number of events by weekday",
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $19d86a636b501d10$export$2e2bcd8739ae039), {
                                children: "Based on the last 28 days"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $2ae3cd0ef43ccc32$export$2e2bcd8739ae039).ColumnChart, {
                        data: Object.entries(data.usage.last28Days.eventCountByWeekday).map(([k, count])=>{
                            const label = (0, $5a123094476b33d7$export$6d6c4805e4b04e86)[Number(k)];
                            const y = Math.round(count / 4);
                            return {
                                y: y,
                                label: label,
                                key: k,
                                title: `${label}: ${(0, $035f270eea0b2c1d$export$7774341304efafa2).format(y)}`
                            };
                        }),
                        rotateXLabels: true,
                        xAxisTitle: "Weekday",
                        yAxisTitle: "Total events"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h3", {
                        children: "Miscellaneous usage stats"
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $6f12d4352e9f75ce$export$2e2bcd8739ae039), {
                        data: [
                            [
                                "Average mood for all users over the last 7 days",
                                // eslint-disable-next-line react/jsx-key
                                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $041b0fb8a1821c7a$export$2e2bcd8739ae039), {
                                    mood: data.usage.meanMoodInLast7Days
                                })
                            ],
                            [
                                "Average mood for all users over the last 30 days",
                                // eslint-disable-next-line react/jsx-key
                                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $041b0fb8a1821c7a$export$2e2bcd8739ae039), {
                                    mood: data.usage.last30Days.meanMood
                                })
                            ],
                            [
                                "Total time meditated by all users over the last 30 days",
                                (0, $c36dbebe71edd437$export$2e2bcd8739ae039)(data.usage.last30Days.meditationSeconds)
                            ],
                            [
                                "Total events recorded over the last 30 days",
                                data.usage.last30Days.eventCount
                            ]
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h3", {
                        children: "Miscellaneous user stats"
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $6f12d4352e9f75ce$export$2e2bcd8739ae039), {
                        data: [
                            [
                                "Retention of users since a month ago",
                                (0, $035f270eea0b2c1d$export$fd01c80332d24e86).format(data.usage.CRR)
                            ],
                            [
                                "Number of devices with push notifications enabled",
                                data.usage.totalWebPushTokens
                            ],
                            [
                                "Users who are signed up to weekly emails",
                                data.usage.usersWithWeeklyEmails
                            ],
                            [
                                "Active users who have logged a meditation over the last 30 days",
                                formatAsPercentageOfMaus(data.usage.meditationMAUs)
                            ],
                            [
                                "Active users who have logged a sleep over the last 30 days",
                                data.usage.sleepMAUs ? formatAsPercentageOfMaus(data.usage.sleepMAUs) : 0
                            ],
                            [
                                "Active users who have logged a weight over the last 30 days",
                                formatAsPercentageOfMaus(data.usage.weightMAUs)
                            ],
                            [
                                "Active users who have logged their location over the last 30 days",
                                formatAsPercentageOfMaus(data.usage.locationMAUs)
                            ],
                            [
                                "Total confirmed users",
                                data.usage.confirmedUsers
                            ]
                        ]
                    })
                ]
            })
        ]
    });
}




function $87c59931b9517b21$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $d61dd5ef7bbf6537$export$2e2bcd8739ae039), {
        appName: "MoodTracker"
    });
}





var $lBnVc = parcelRequire("lBnVc");






function $d92290301f1feaf8$export$2e2bcd8739ae039() {
    const dispatch = (0, $d3287b130d7b0f6b$export$8ad76b76a4c905f8)();
    const [fieldError, setFieldError] = (0, $lBnVc.useState)();
    const [isSubmitting, setIsSubmitting] = (0, $lBnVc.useState)(false);
    const [searchParams] = (0, $e94b7bcc277332d2$export$f1a78c17382fe22a)();
    const [successfullyUpdated, setSuccessfullyUpdated] = (0, $lBnVc.useState)(false);
    const currentEmailAddress = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $9cfb09fae6dbced4$export$2e2bcd8739ae039).selectors.email);
    const [submitError, setSubmitError] = (0, $lBnVc.useState)();
    const newEmail = searchParams.get((0, $6a4092c3986f4410$export$2ba8fb1a64f3cffb));
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039).Group, {
        children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
            children: successfullyUpdated ? /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h2", {
                        children: "Email address successfully updated!"
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("p", {
                        children: [
                            'Your new email address is "',
                            currentEmailAddress,
                            '".'
                        ]
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("p", {
                        children: [
                            "Please use your new email address to sign in next time.",
                            " ",
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("b", {
                                children: "Your old email address will no longer work."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e94b7bcc277332d2$export$a6c7ac8248d6e38a), {
                                to: "/",
                                children: "Click here to go to your homepage"
                            }),
                            "."
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h2", {
                        children: "Verify new email address"
                    }),
                    newEmail && /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("p", {
                        children: [
                            "We've sent a verification code to \"",
                            newEmail,
                            '".'
                        ]
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("p", {
                        children: "Please note that once you have verified your new email address you will be logged out and will need to sign in with your new email address."
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("p", {
                        children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("b", {
                            children: "You will no longer be able to log in with your old email address."
                        })
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("form", {
                        noValidate: true,
                        onSubmit: async (e)=>{
                            e.preventDefault();
                            setFieldError(undefined);
                            setSubmitError(undefined);
                            const field = e.target.verification;
                            if (field.validity.valueMissing) return setFieldError((0, $5a123094476b33d7$export$4fd720569787ab6f).required);
                            setIsSubmitting(true);
                            try {
                                await (0, $97fc43514b4d4584$export$642dc5b3bc0f4a83)(field.value);
                                const session = await (0, $97fc43514b4d4584$export$296522b9b583854e)();
                                const idToken = session.getIdToken();
                                dispatch((0, $9cfb09fae6dbced4$export$2e2bcd8739ae039).actions.setEmail(idToken.payload.email));
                                setSuccessfullyUpdated(true);
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            } catch (e) {
                                switch(e.code){
                                    case "CodeMismatchException":
                                        setSubmitError("The code you've provided is incorrect, please try again");
                                        break;
                                    case "ExpiredCodeException":
                                        setSubmitError(/*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
                                            children: [
                                                "The code you've provided has expired, please try",
                                                " ",
                                                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e94b7bcc277332d2$export$a6c7ac8248d6e38a), {
                                                    to: "/settings/change-email",
                                                    children: "changing your email"
                                                }),
                                                " ",
                                                "again"
                                            ]
                                        }));
                                        break;
                                    case "NetworkError":
                                        setSubmitError((0, $5a123094476b33d7$export$4fd720569787ab6f).network);
                                        break;
                                    default:
                                        setSubmitError((0, $5a123094476b33d7$export$4fd720569787ab6f).generic);
                                }
                            } finally{
                                setIsSubmitting(false);
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $78053ee2024d275e$export$2e2bcd8739ae039), {
                                autoComplete: "off",
                                autoFocus: true,
                                error: fieldError,
                                label: "Verification code",
                                supportiveText: "Check the inbox and junk folder of your new email address for the code we sent you",
                                name: "verification",
                                type: "text"
                            }),
                            submitError && /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("p", {
                                className: "center",
                                children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("small", {
                                    className: "negative",
                                    children: submitError
                                })
                            }),
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039).Group, {
                                children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $8d0e9e7c8b049b7a$export$2e2bcd8739ae039), {
                                    disabled: isSubmitting,
                                    children: "Verify new email address"
                                })
                            }),
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("p", {
                                className: "center",
                                children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("small", {
                                    children: [
                                        "If you cannot find your verification code try",
                                        " ",
                                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e94b7bcc277332d2$export$a6c7ac8248d6e38a), {
                                            to: "/settings/change-email",
                                            children: "changing your email"
                                        }),
                                        " ",
                                        "again."
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
}






















function $52157b98aab52cf5$export$2e2bcd8739ae039(props) {
    const meanMoods = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.meanMoodsByWeek);
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $c25731f3cd2809a0$export$2e2bcd8739ae039), {
        ...props,
        meanMoodByDate: meanMoods,
        periodType: "week"
    });
}












function $8c3340be60aa729e$export$2e2bcd8739ae039({ dateFrom: dateFrom }) {
    const navigate = (0, $f02d97b5ca509f34$export$9770f232ac06a008)();
    const minutesSleptByDateAwoke = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.minutesSleptByDateAwoke);
    const data = [];
    for(let i = 0; i < (0, $5a123094476b33d7$export$6d6c4805e4b04e86).length; i++){
        const dateString = (0, $c2e94012e82e0308$export$f3013bcc8d8645bd)((0, $cb8fdbef2aba70f2$export$dd412b56f1e4d8aa)(dateFrom, i));
        data.push({
            dateString: dateString,
            minutesSlept: minutesSleptByDateAwoke[dateString],
            weekday: (0, $5a123094476b33d7$export$6d6c4805e4b04e86)[i]
        });
    }
    if (data.every(({ minutesSlept: minutesSlept })=>minutesSlept === undefined)) return null;
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h3", {
                children: "Sleep chart"
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $2ae3cd0ef43ccc32$export$2e2bcd8739ae039).ColumnChart, {
                "aria-label": "Chart displaying sleep by day",
                data: data.map(({ dateString: dateString, minutesSlept: minutesSlept, weekday: weekday })=>({
                        key: dateString,
                        label: weekday,
                        onClick: ()=>navigate(`/stats/days/${dateString}`),
                        title: minutesSlept === undefined ? undefined : (0, $7bf1f584ca4dd7d4$export$2ec4521312384146)(minutesSlept),
                        y: minutesSlept === undefined ? undefined : minutesSlept / 60
                    })),
                rotateXLabels: true,
                xAxisTitle: "Day",
                yAxisTitle: "Hours slept"
            })
        ]
    });
}








function $f65675ce9bead778$var$Week({ date: date, nextDate: nextDate, prevDate: prevDate, showNext: showNext, showPrevious: showPrevious }) {
    const moodIdsInPeriod = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((state)=>(0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.moodIdsInPeriod(state, date, nextDate));
    const lastDayOfWeek = (0, $58b603c9eda836d4$export$70823084e2deb1ea)(nextDate, 1);
    const xLabels = [];
    for(let i = 0; i < (0, $5a123094476b33d7$export$a9905336c0111a3a).daysPerWeek; i++)xLabels.push((0, $06d17fa75ca1067f$export$a938dcff503049a5).format((0, $cb8fdbef2aba70f2$export$dd412b56f1e4d8aa)(date, i)));
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039).Group, {
        children: [
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("h2", {
                        children: [
                            (0, $06d17fa75ca1067f$export$1143122ff5520ba9)(date),
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $19d86a636b501d10$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e94b7bcc277332d2$export$a6c7ac8248d6e38a), {
                                        to: `../../months/${(0, $c2e94012e82e0308$export$30a208a52f4a49de)(lastDayOfWeek)}`,
                                        children: (0, $06d17fa75ca1067f$export$4137bbc3ff26d570).format(lastDayOfWeek)
                                    }),
                                    " ",
                                    "|",
                                    " ",
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e94b7bcc277332d2$export$a6c7ac8248d6e38a), {
                                        to: `../../years/${(0, $c2e94012e82e0308$export$60b37fc597282c94)(lastDayOfWeek)}`,
                                        children: (0, $06d17fa75ca1067f$export$daf84c177a4aeca8).format(lastDayOfWeek)
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $0a48ec8918b8b79c$export$2e2bcd8739ae039), {
                        dateFrom: date,
                        dateTo: nextDate
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $cfc36dd95b79da04$export$2e2bcd8739ae039), {
                        children: [
                            showPrevious ? /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $e94b7bcc277332d2$export$a6c7ac8248d6e38a), {
                                to: `../${(0, $c2e94012e82e0308$export$f3013bcc8d8645bd)(prevDate)}`,
                                children: [
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                                        margin: "end",
                                        name: "left"
                                    }),
                                    "Previous week"
                                ]
                            }) : /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("span", {}),
                            showNext && /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $e94b7bcc277332d2$export$a6c7ac8248d6e38a), {
                                to: `../${(0, $c2e94012e82e0308$export$f3013bcc8d8645bd)(nextDate)}`,
                                children: [
                                    "Next week",
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                                        margin: "start",
                                        name: "right"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $52157b98aab52cf5$export$2e2bcd8739ae039), {
                dates: [
                    prevDate,
                    date,
                    nextDate
                ]
            }),
            moodIdsInPeriod.length ? /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $997e05fd3f436e77$export$2e2bcd8739ae039), {
                        centerXAxisLabels: true,
                        dateFrom: date,
                        dateTo: nextDate,
                        xLabels: xLabels
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $d46f58da5e39a00c$export$2e2bcd8739ae039), {
                        currentPeriod: {
                            dateFrom: date,
                            dateTo: nextDate
                        },
                        previousPeriod: {
                            dateFrom: prevDate,
                            dateTo: date
                        }
                    })
                ]
            }) : /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("p", {
                    children: [
                        "No mood data for this week, ",
                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e94b7bcc277332d2$export$a6c7ac8248d6e38a), {
                            to: "/add",
                            children: "add a mood here"
                        }),
                        "!"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $3b3050146274ca05$export$2e2bcd8739ae039), {
                dateFrom: date,
                dateTo: nextDate
            }),
            moodIdsInPeriod.length ? /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $f1356ddf9998b04f$export$2e2bcd8739ae039), {
                        dateFrom: date,
                        dateTo: nextDate
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $645d8a5fcb813cb9$export$2e2bcd8739ae039), {
                        canDrillDown: true,
                        dateFrom: date,
                        dateTo: nextDate
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $8c3340be60aa729e$export$2e2bcd8739ae039), {
                dateFrom: date
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $a67d76e60b66d2ca$export$2e2bcd8739ae039), {
                dateFrom: date,
                dateTo: nextDate
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $1dc16ddda003912c$export$2e2bcd8739ae039), {
                centerXAxisLabels: true,
                dateFrom: date,
                dateTo: nextDate,
                xLabels: xLabels
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $d4bf939de7dd3627$export$2e2bcd8739ae039), {
                dateFrom: date,
                dateTo: nextDate
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $af798ee18e885c0a$export$2e2bcd8739ae039), {
                centerXAxisLabels: true,
                dateFrom: date,
                dateTo: nextDate,
                xLabels: xLabels
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $d03f855c67127c85$export$2e2bcd8739ae039), {
                dateFrom: date,
                dateTo: nextDate
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $6813af323f7a9acb$export$2e2bcd8739ae039), {
                dateFrom: date,
                dateTo: nextDate
            })
        ]
    });
}
var $f65675ce9bead778$export$2e2bcd8739ae039 = (0, $978855b79bb42918$export$2e2bcd8739ae039)({
    addPeriod: (0, $ad866f4678a92721$export$ef501a2bb4f3ee6b),
    adjustDate: (date)=>(0, $f2ddddaabfe67186$export$42c81a444fbfb5d4)(date, (0, $06d17fa75ca1067f$export$34c88de16c0a2653)),
    Component: $f65675ce9bead778$var$Week
});















function $d5bce9d14ed963fb$export$2e2bcd8739ae039({ id: id }) {
    const weights = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.normalizedWeights);
    const weight = weights.byId[id];
    const navigate = (0, $f02d97b5ca509f34$export$9770f232ac06a008)();
    const date = new Date(id);
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $7c1560fa3a8ca778$export$2e2bcd8739ae039), {
        onClick: ()=>navigate(`/weight/edit/${id}`),
        children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("div", {
            className: "m-weight-card",
            children: [
                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("div", {
                    className: "center",
                    children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("b", {
                        "data-test-id": (0, $5a123094476b33d7$export$a2b4f255152a6585).weightCardValue,
                        children: [
                            weight.value,
                            "kg"
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("div", {
                    children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("small", {
                        "data-test-id": (0, $5a123094476b33d7$export$a2b4f255152a6585).weightCardTime,
                        "data-time": Math.round(date.getTime() / 1e3),
                        children: (0, $06d17fa75ca1067f$export$59113f23fb667b84).format(new Date(id))
                    })
                }),
                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("div", {
                    children: weight.location && /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("small", {
                        children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $bdc0446275c44834$export$2e2bcd8739ae039), {
                            errorFallback: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
                                children: [
                                    "Lat: ",
                                    weight.location.latitude,
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("br", {}),
                                    "Lon: ",
                                    weight.location.longitude
                                ]
                            }),
                            latitude: weight.location.latitude,
                            longitude: weight.location.longitude
                        })
                    })
                })
            ]
        })
    });
}






var $lBnVc = parcelRequire("lBnVc");
const $b1279776c66c42a8$var$MAX_ITEMS_PER_PAGE = 10;
function $b1279776c66c42a8$export$2e2bcd8739ae039() {
    const weights = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.normalizedWeights);
    const denormalizedWeights = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.denormalizedWeights);
    const [page, setPage] = (0, $lBnVc.useState)(0);
    const pageCount = Math.ceil(weights.allIds.length / $b1279776c66c42a8$var$MAX_ITEMS_PER_PAGE);
    const endIndex = weights.allIds.length - $b1279776c66c42a8$var$MAX_ITEMS_PER_PAGE * page;
    const startIndex = Math.max(0, endIndex - $b1279776c66c42a8$var$MAX_ITEMS_PER_PAGE);
    if (!weights.allIds.length) return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $caf7aee3fc8a0ef0$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039).Group, {
        children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h2", {
                    children: "Weight log"
                }),
                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("h3", {
                    children: [
                        "Export",
                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $19d86a636b501d10$export$2e2bcd8739ae039), {
                            children: "Export all your weights (choose CSV format if you want to load your data into a spreadsheet)"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $d4552df15b9ab2b8$export$2e2bcd8739ae039), {
                    category: "weights",
                    denormalizedData: denormalizedWeights
                }),
                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("h3", {
                    children: [
                        "Log",
                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $19d86a636b501d10$export$2e2bcd8739ae039), {
                            children: "View, edit or delete all your logged weights"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $7c1560fa3a8ca778$export$2e2bcd8739ae039).Group, {
                    children: (0, $c2e94012e82e0308$export$7ff0d353c23134fe)(weights.allIds.slice(startIndex, endIndex), (id)=>/*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $d5bce9d14ed963fb$export$2e2bcd8739ae039), {
                            id: id
                        }, id))
                }),
                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $64123a2209d9f6c7$export$2e2bcd8739ae039), {
                    onChange: setPage,
                    page: page,
                    pageCount: pageCount
                })
            ]
        })
    });
}




















function $67ba3b54808fbed6$export$2e2bcd8739ae039({ dateFrom: dateFrom, dateTo: dateTo }) {
    const meditationIdsInPeriod = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((state)=>(0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.meditationIdsInPeriod(state, dateFrom, dateTo));
    const noramlizedTotalSecondsMeditatedByMonth = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.normalizedTotalSecondsMeditatedByMonth);
    const navigate = (0, $f02d97b5ca509f34$export$9770f232ac06a008)();
    if (!meditationIdsInPeriod.length) return null;
    const months = (0, $0789447cd4ec8bf3$export$1c9322f2d2a5eed3)({
        start: dateFrom,
        end: dateTo
    }).slice(0, -1);
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h3", {
                children: "Hours meditated by month"
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $2ae3cd0ef43ccc32$export$2e2bcd8739ae039).ColumnChart, {
                "aria-label": "Chart displaying hours meditated by month",
                data: months.map((month)=>{
                    const secondsMeditated = noramlizedTotalSecondsMeditatedByMonth.byId[(0, $c2e94012e82e0308$export$f3013bcc8d8645bd)(month)] ?? 0;
                    const label = (0, $06d17fa75ca1067f$export$e176cbe7be9b5dd8).format(month);
                    return {
                        key: label,
                        label: label,
                        onClick: ()=>navigate(`/stats/months/${(0, $c2e94012e82e0308$export$30a208a52f4a49de)(month)}`),
                        title: `Hours meditated: ${(0, $035f270eea0b2c1d$export$da6f4123477e5931).format(secondsMeditated / (0, $5a123094476b33d7$export$a9905336c0111a3a).secondsPerHour)}`,
                        y: (secondsMeditated ?? 0) / (0, $5a123094476b33d7$export$a9905336c0111a3a).secondsPerHour
                    };
                }),
                rotateXLabels: true,
                xAxisTitle: "Month",
                yAxisTitle: "Hours meditated"
            })
        ]
    });
}















function $688987039d82f0e8$export$2e2bcd8739ae039({ dateFrom: dateFrom, dateTo: dateTo }) {
    const meanMoodsByMonth = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.meanMoodsByMonth);
    const navigate = (0, $f02d97b5ca509f34$export$9770f232ac06a008)();
    const months = (0, $0789447cd4ec8bf3$export$1c9322f2d2a5eed3)({
        start: dateFrom,
        end: dateTo
    }).slice(0, -1);
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h3", {
                children: "Average mood by month"
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $2ae3cd0ef43ccc32$export$2e2bcd8739ae039).ColumnChart, {
                "aria-label": "Chart displaying average mood by month",
                data: months.map((month)=>{
                    const averageMood = meanMoodsByMonth[(0, $c2e94012e82e0308$export$f3013bcc8d8645bd)(month)];
                    const label = (0, $06d17fa75ca1067f$export$e176cbe7be9b5dd8).format(month);
                    return {
                        color: averageMood === undefined ? undefined : (0, $c2e94012e82e0308$export$18b446c953569205)(averageMood),
                        key: label,
                        label: label,
                        onClick: ()=>navigate(`/stats/months/${(0, $c2e94012e82e0308$export$30a208a52f4a49de)(month)}`),
                        title: averageMood === undefined ? undefined : `Average mood: ${(0, $035f270eea0b2c1d$export$da6f4123477e5931).format(averageMood)}`,
                        y: averageMood
                    };
                }),
                maxRange: (0, $5a123094476b33d7$export$1c4e9440df4662e4),
                rotateXLabels: true,
                xAxisTitle: "Month",
                yAxisTitle: "Average mood"
            })
        ]
    });
}













function $23721fc919bc0d4f$export$2e2bcd8739ae039(props) {
    const meanMoods = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.meanMoodsByYear);
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $c25731f3cd2809a0$export$2e2bcd8739ae039), {
        ...props,
        meanMoodByDate: meanMoods,
        periodType: "year"
    });
}












function $6e753cedc84db799$export$2e2bcd8739ae039({ dateFrom: dateFrom, dateTo: dateTo }) {
    const navigate = (0, $f02d97b5ca509f34$export$9770f232ac06a008)();
    const meanMinutesSleptByMonth = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.meanMinutesSleptByMonth);
    const months = (0, $0789447cd4ec8bf3$export$1c9322f2d2a5eed3)({
        start: dateFrom,
        end: dateTo
    }).slice(0, -1);
    const data = months.map((month)=>{
        const minutesSlept = meanMinutesSleptByMonth[(0, $c2e94012e82e0308$export$30a208a52f4a49de)(month)];
        const label = (0, $06d17fa75ca1067f$export$e176cbe7be9b5dd8).format(month);
        return {
            key: label,
            label: label,
            onClick: ()=>navigate(`/stats/months/${(0, $c2e94012e82e0308$export$30a208a52f4a49de)(month)}`),
            title: minutesSlept === undefined ? undefined : (0, $7bf1f584ca4dd7d4$export$2ec4521312384146)(minutesSlept),
            y: minutesSlept === undefined ? undefined : minutesSlept / 60
        };
    });
    if (data.every(({ y: y })=>y === undefined)) return null;
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h3", {
                children: "Average sleep by month"
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $2ae3cd0ef43ccc32$export$2e2bcd8739ae039).ColumnChart, {
                "aria-label": "Chart displaying average sleep by month",
                data: data,
                rotateXLabels: true,
                xAxisTitle: "Month",
                yAxisTitle: "Hours slept"
            })
        ]
    });
}








function $3aebb5ee0a60dab2$var$Year({ date: date, nextDate: nextDate, prevDate: prevDate, showNext: showNext, showPrevious: showPrevious }) {
    const moodIdsInPeriod = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((state)=>(0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.moodIdsInPeriod(state, date, nextDate));
    const navigate = (0, $f02d97b5ca509f34$export$9770f232ac06a008)();
    const meanMoodsByMonth = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $8ce47baf257b7c7b$export$2e2bcd8739ae039).selectors.meanMoodsByMonth);
    const months = (0, $0789447cd4ec8bf3$export$1c9322f2d2a5eed3)({
        start: date,
        end: nextDate
    }).slice(0, -1);
    const calendars = [];
    for (const month of months){
        const monthString = (0, $06d17fa75ca1067f$export$4137bbc3ff26d570).format(month);
        const averageMood = meanMoodsByMonth[(0, $c2e94012e82e0308$export$f3013bcc8d8645bd)(month)];
        const formattedAverageMood = averageMood === undefined ? undefined : (0, $035f270eea0b2c1d$export$da6f4123477e5931).format(averageMood);
        calendars.push(/*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("button", {
            "aria-label": `Drill down into ${monthString}`,
            className: "m-year__calendar-button br-0 p-1",
            onClick: ()=>navigate(`/stats/months/${(0, $c2e94012e82e0308$export$30a208a52f4a49de)(month)}`),
            title: formattedAverageMood && `Average mood for ${monthString}: ${formattedAverageMood}`,
            children: [
                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("h4", {
                    className: "center",
                    children: [
                        monthString,
                        /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("small", {
                            children: formattedAverageMood && ` (${formattedAverageMood})`
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $93c40e6082f2320d$export$2e2bcd8739ae039), {
                    month: month,
                    small: true
                })
            ]
        }, String(month)));
    }
    const xLabels = [
        ...Array(12).keys()
    ].map((n)=>(0, $06d17fa75ca1067f$export$9fc2c6bef079c03f).format((0, $857e6f903d884172$export$17c93e242b2d3a22)(date, n)));
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039).Group, {
        children: [
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("h2", {
                        children: (0, $06d17fa75ca1067f$export$daf84c177a4aeca8).format(date)
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $0a48ec8918b8b79c$export$2e2bcd8739ae039), {
                        dateFrom: date,
                        dateTo: nextDate
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $cfc36dd95b79da04$export$2e2bcd8739ae039), {
                        children: [
                            showPrevious ? /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $e94b7bcc277332d2$export$a6c7ac8248d6e38a), {
                                to: `../${(0, $c2e94012e82e0308$export$60b37fc597282c94)(prevDate)}`,
                                children: [
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                                        margin: "end",
                                        name: "left"
                                    }),
                                    (0, $06d17fa75ca1067f$export$daf84c177a4aeca8).format(prevDate)
                                ]
                            }) : /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("span", {}),
                            showNext && /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $e94b7bcc277332d2$export$a6c7ac8248d6e38a), {
                                to: `../${(0, $c2e94012e82e0308$export$60b37fc597282c94)(nextDate)}`,
                                children: [
                                    (0, $06d17fa75ca1067f$export$daf84c177a4aeca8).format(nextDate),
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e53b8b77a9cd0fc1$export$2e2bcd8739ae039), {
                                        margin: "start",
                                        name: "right"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $23721fc919bc0d4f$export$2e2bcd8739ae039), {
                dates: [
                    prevDate,
                    date,
                    nextDate
                ]
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $997e05fd3f436e77$export$2e2bcd8739ae039), {
                centerXAxisLabels: true,
                dateFrom: date,
                dateTo: nextDate,
                hidePoints: true,
                xLabels: xLabels
            }),
            moodIdsInPeriod.length ? /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("h3", {
                                children: [
                                    "Calendar view",
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $19d86a636b501d10$export$2e2bcd8739ae039), {
                                        children: "Tap a month to explore it in more detail"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("div", {
                                className: "m-year__calendar-grid",
                                children: calendars
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $688987039d82f0e8$export$2e2bcd8739ae039), {
                        dateFrom: date,
                        dateTo: nextDate
                    })
                ]
            }) : /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $b613c61ec3efa9f5$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("p", {
                    children: "No mood data for this year."
                })
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $6e753cedc84db799$export$2e2bcd8739ae039), {
                dateFrom: date,
                dateTo: nextDate
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $67ba3b54808fbed6$export$2e2bcd8739ae039), {
                dateFrom: date,
                dateTo: nextDate
            }),
            moodIdsInPeriod.length ? /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $645d8a5fcb813cb9$export$2e2bcd8739ae039), {
                        dateFrom: date,
                        dateTo: nextDate
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $f1356ddf9998b04f$export$2e2bcd8739ae039), {
                        dateFrom: date,
                        dateTo: nextDate
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $d46f58da5e39a00c$export$2e2bcd8739ae039), {
                        currentPeriod: {
                            dateFrom: date,
                            dateTo: nextDate
                        },
                        previousPeriod: {
                            dateFrom: prevDate,
                            dateTo: date
                        }
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $3b3050146274ca05$export$2e2bcd8739ae039), {
                dateFrom: date,
                dateTo: nextDate
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $d4bf939de7dd3627$export$2e2bcd8739ae039), {
                dateFrom: date,
                dateTo: nextDate
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $af798ee18e885c0a$export$2e2bcd8739ae039), {
                centerXAxisLabels: true,
                dateFrom: date,
                dateTo: nextDate,
                xLabels: xLabels
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $a67d76e60b66d2ca$export$2e2bcd8739ae039), {
                dateFrom: date,
                dateTo: nextDate
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $1dc16ddda003912c$export$2e2bcd8739ae039), {
                centerXAxisLabels: true,
                dateFrom: date,
                dateTo: nextDate,
                xLabels: xLabels
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $d03f855c67127c85$export$2e2bcd8739ae039), {
                dateFrom: date,
                dateTo: nextDate
            }),
            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $6813af323f7a9acb$export$2e2bcd8739ae039), {
                dateFrom: date,
                dateTo: nextDate
            })
        ]
    });
}
var $3aebb5ee0a60dab2$export$2e2bcd8739ae039 = (0, $978855b79bb42918$export$2e2bcd8739ae039)({
    addPeriod: (0, $8481dd0cb1201679$export$3d83eec43f4ea476),
    Component: $3aebb5ee0a60dab2$var$Year,
    dateRegex: /^\d{4}$/
});





function $c4b53a7722603883$var$Root() {
    const userIsSignedIn = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $9cfb09fae6dbced4$export$2e2bcd8739ae039).selectors.isSignedIn);
    const isStorageLoading = (0, $d3287b130d7b0f6b$export$2105062e25df4afe)((0, $4a1b4f367ad149f7$export$2e2bcd8739ae039).selectors.isStorageLoading);
    return /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e8739e675871d84e$export$e926676385687eaf), {
        fallback: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)("p", {
            className: "center",
            children: [
                "Oops something went wrong! The error should be reported automatically, but please do",
                " ",
                /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)("a", {
                    href: (0, $5a123094476b33d7$export$2cdbc1b6a383b7bf),
                    rel: "noopener",
                    target: "_blank",
                    children: "raise an issue on GitHub"
                }),
                " ",
                "to ensure it gets looked at."
            ]
        }),
        children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $f02d97b5ca509f34$export$3565eb3d00ca5a74), {
            children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $f02d97b5ca509f34$export$e7b0ac011bb776c6), {
                element: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e250444002f590bc$export$2e2bcd8739ae039), {}),
                children: [
                    isStorageLoading ? /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $f02d97b5ca509f34$export$e7b0ac011bb776c6), {
                        element: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $b3bd040c14d4ce5c$export$2e2bcd8739ae039), {}),
                        path: "*"
                    }) : /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $f02d97b5ca509f34$export$e7b0ac011bb776c6), {
                                element: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $caf7aee3fc8a0ef0$export$2e2bcd8739ae039), {}),
                                path: "*"
                            }),
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $f02d97b5ca509f34$export$e7b0ac011bb776c6), {
                                element: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $3e1054d2f56e3ed6$export$2e2bcd8739ae039), {
                                    Component: (0, $2ae69482e6eada79$export$2e2bcd8739ae039),
                                    title: "A mood tracker & meditation timer that helps you understand yourself"
                                }),
                                path: "/"
                            }),
                            userIsSignedIn ? /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $f02d97b5ca509f34$export$e7b0ac011bb776c6), {
                                        element: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $3e1054d2f56e3ed6$export$2e2bcd8739ae039), {
                                            Component: (0, $796b12d4c4a184c3$export$2e2bcd8739ae039),
                                            title: "Add mood"
                                        }),
                                        path: "/add"
                                    }),
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $f02d97b5ca509f34$export$e7b0ac011bb776c6), {
                                        element: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $3e1054d2f56e3ed6$export$2e2bcd8739ae039), {
                                            Component: (0, $9dc955b4ee15affb$export$2e2bcd8739ae039),
                                            title: "Edit mood"
                                        }),
                                        path: "/edit/:id"
                                    }),
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $f02d97b5ca509f34$export$e7b0ac011bb776c6), {
                                        path: "/mood",
                                        children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $f02d97b5ca509f34$export$e7b0ac011bb776c6), {
                                            element: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $3e1054d2f56e3ed6$export$2e2bcd8739ae039), {
                                                Component: (0, $0fbbcdf599dfcb96$export$2e2bcd8739ae039),
                                                title: "Mood log"
                                            }),
                                            path: "log"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $f02d97b5ca509f34$export$e7b0ac011bb776c6), {
                                        path: "/meditation",
                                        children: [
                                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $f02d97b5ca509f34$export$e7b0ac011bb776c6), {
                                                element: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $3e1054d2f56e3ed6$export$2e2bcd8739ae039), {
                                                    Component: (0, $a63a2c7303de2d4c$export$2e2bcd8739ae039),
                                                    title: "Meditate"
                                                }),
                                                path: ""
                                            }),
                                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $f02d97b5ca509f34$export$e7b0ac011bb776c6), {
                                                element: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $3e1054d2f56e3ed6$export$2e2bcd8739ae039), {
                                                    Component: (0, $dd3b88e3ddb8f7ea$export$2e2bcd8739ae039),
                                                    title: "Meditation log"
                                                }),
                                                path: "log"
                                            }),
                                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $f02d97b5ca509f34$export$e7b0ac011bb776c6), {
                                                element: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $3e1054d2f56e3ed6$export$2e2bcd8739ae039), {
                                                    Component: (0, $29dca47dbf60e2e4$export$2e2bcd8739ae039),
                                                    title: "Open-ended meditation"
                                                }),
                                                path: "open-ended"
                                            }),
                                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $f02d97b5ca509f34$export$e7b0ac011bb776c6), {
                                                element: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $3e1054d2f56e3ed6$export$2e2bcd8739ae039), {
                                                    Component: (0, $8d3d03e58bbd5e83$export$2e2bcd8739ae039),
                                                    title: "Meditation timer"
                                                }),
                                                path: "timer"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $f02d97b5ca509f34$export$e7b0ac011bb776c6), {
                                        path: "/sleep",
                                        children: [
                                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $f02d97b5ca509f34$export$e7b0ac011bb776c6), {
                                                element: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $caf7aee3fc8a0ef0$export$2e2bcd8739ae039), {}),
                                                path: ""
                                            }),
                                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $f02d97b5ca509f34$export$e7b0ac011bb776c6), {
                                                element: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $3e1054d2f56e3ed6$export$2e2bcd8739ae039), {
                                                    Component: (0, $22ab44955f353ba1$export$2e2bcd8739ae039),
                                                    title: "Add sleep"
                                                }),
                                                path: "add"
                                            }),
                                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $f02d97b5ca509f34$export$e7b0ac011bb776c6), {
                                                element: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $3e1054d2f56e3ed6$export$2e2bcd8739ae039), {
                                                    Component: (0, $d4dbe8b90289f277$export$2e2bcd8739ae039),
                                                    title: "Edit sleep"
                                                }),
                                                path: "edit/:id"
                                            }),
                                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $f02d97b5ca509f34$export$e7b0ac011bb776c6), {
                                                element: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $3e1054d2f56e3ed6$export$2e2bcd8739ae039), {
                                                    Component: (0, $170b09a4ef462787$export$2e2bcd8739ae039),
                                                    title: "Sleep log"
                                                }),
                                                path: "log"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $f02d97b5ca509f34$export$e7b0ac011bb776c6), {
                                        path: "/weight",
                                        children: [
                                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $f02d97b5ca509f34$export$e7b0ac011bb776c6), {
                                                element: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $caf7aee3fc8a0ef0$export$2e2bcd8739ae039), {}),
                                                path: ""
                                            }),
                                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $f02d97b5ca509f34$export$e7b0ac011bb776c6), {
                                                element: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $3e1054d2f56e3ed6$export$2e2bcd8739ae039), {
                                                    Component: (0, $70e20c362967c7c4$export$2e2bcd8739ae039),
                                                    title: "Add weight"
                                                }),
                                                path: "add"
                                            }),
                                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $f02d97b5ca509f34$export$e7b0ac011bb776c6), {
                                                element: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $3e1054d2f56e3ed6$export$2e2bcd8739ae039), {
                                                    Component: (0, $7bcabf5d27fcc661$export$2e2bcd8739ae039),
                                                    title: "Edit weight"
                                                }),
                                                path: "edit/:id"
                                            }),
                                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $f02d97b5ca509f34$export$e7b0ac011bb776c6), {
                                                element: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $3e1054d2f56e3ed6$export$2e2bcd8739ae039), {
                                                    Component: (0, $b1279776c66c42a8$export$2e2bcd8739ae039),
                                                    title: "Weight log"
                                                }),
                                                path: "log"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $f02d97b5ca509f34$export$e7b0ac011bb776c6), {
                                        path: "settings",
                                        children: [
                                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $f02d97b5ca509f34$export$e7b0ac011bb776c6), {
                                                element: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $3e1054d2f56e3ed6$export$2e2bcd8739ae039), {
                                                    Component: (0, $e0cc0e85eb6f38c2$export$2e2bcd8739ae039),
                                                    title: "Change email"
                                                }),
                                                path: "change-email"
                                            }),
                                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $f02d97b5ca509f34$export$e7b0ac011bb776c6), {
                                                element: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $3e1054d2f56e3ed6$export$2e2bcd8739ae039), {
                                                    Component: (0, $d92290301f1feaf8$export$2e2bcd8739ae039),
                                                    title: "Verify new email address"
                                                }),
                                                path: "verify-new-email"
                                            }),
                                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $f02d97b5ca509f34$export$e7b0ac011bb776c6), {
                                                element: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $3e1054d2f56e3ed6$export$2e2bcd8739ae039), {
                                                    Component: (0, $75e5d4a71d4850e1$export$2e2bcd8739ae039),
                                                    title: "Change password"
                                                }),
                                                path: "change-password"
                                            }),
                                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $f02d97b5ca509f34$export$e7b0ac011bb776c6), {
                                                element: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $3e1054d2f56e3ed6$export$2e2bcd8739ae039), {
                                                    Component: (0, $4149558fbda63cd8$export$2e2bcd8739ae039),
                                                    title: "Export data"
                                                }),
                                                path: "export"
                                            }),
                                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $f02d97b5ca509f34$export$e7b0ac011bb776c6), {
                                                element: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $3e1054d2f56e3ed6$export$2e2bcd8739ae039), {
                                                    Component: (0, $04a1b09f5d72bb3c$export$2e2bcd8739ae039),
                                                    title: "Location"
                                                }),
                                                path: "location"
                                            }),
                                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $f02d97b5ca509f34$export$e7b0ac011bb776c6), {
                                                element: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $3e1054d2f56e3ed6$export$2e2bcd8739ae039), {
                                                    Component: (0, $7f16bb8c2780ff6d$export$2e2bcd8739ae039),
                                                    title: "Notifications"
                                                }),
                                                path: "notifications"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $f02d97b5ca509f34$export$e7b0ac011bb776c6), {
                                        path: "/stats",
                                        children: [
                                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $f02d97b5ca509f34$export$e7b0ac011bb776c6), {
                                                element: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $3e1054d2f56e3ed6$export$2e2bcd8739ae039), {
                                                    Component: (0, $766657d1346d3728$export$2e2bcd8739ae039),
                                                    title: "Stats overview"
                                                }),
                                                path: ""
                                            }),
                                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $f02d97b5ca509f34$export$e7b0ac011bb776c6), {
                                                element: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $3e1054d2f56e3ed6$export$2e2bcd8739ae039), {
                                                    Component: (0, $feb55e7a15c25355$export$2e2bcd8739ae039),
                                                    title: "Explore stats"
                                                }),
                                                path: "explore"
                                            }),
                                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $f02d97b5ca509f34$export$e7b0ac011bb776c6), {
                                                path: "days",
                                                children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $f02d97b5ca509f34$export$e7b0ac011bb776c6), {
                                                    element: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $3e1054d2f56e3ed6$export$2e2bcd8739ae039), {
                                                        Component: (0, $0809f0a5d27d1f86$export$2e2bcd8739ae039),
                                                        title: "Day stats"
                                                    }),
                                                    path: ":date"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $f02d97b5ca509f34$export$e7b0ac011bb776c6), {
                                                path: "weeks",
                                                children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $f02d97b5ca509f34$export$e7b0ac011bb776c6), {
                                                    element: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $3e1054d2f56e3ed6$export$2e2bcd8739ae039), {
                                                        Component: (0, $f65675ce9bead778$export$2e2bcd8739ae039),
                                                        title: "Week stats"
                                                    }),
                                                    path: ":date"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $f02d97b5ca509f34$export$e7b0ac011bb776c6), {
                                                path: "months",
                                                children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $f02d97b5ca509f34$export$e7b0ac011bb776c6), {
                                                    element: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $3e1054d2f56e3ed6$export$2e2bcd8739ae039), {
                                                        Component: (0, $100c69136c0f606e$export$2e2bcd8739ae039),
                                                        title: "Month stats"
                                                    }),
                                                    path: ":date"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $f02d97b5ca509f34$export$e7b0ac011bb776c6), {
                                                path: "years",
                                                children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $f02d97b5ca509f34$export$e7b0ac011bb776c6), {
                                                    element: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $3e1054d2f56e3ed6$export$2e2bcd8739ae039), {
                                                        Component: (0, $3aebb5ee0a60dab2$export$2e2bcd8739ae039),
                                                        title: "Year stats"
                                                    }),
                                                    path: ":date"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $c0c9bc5c50648c54$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $f02d97b5ca509f34$export$e7b0ac011bb776c6), {
                                        element: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $3e1054d2f56e3ed6$export$2e2bcd8739ae039), {
                                            Component: (0, $77e875eaed32ac4c$export$2e2bcd8739ae039),
                                            title: "Forgot password"
                                        }),
                                        path: "/forgot-password"
                                    }),
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $f02d97b5ca509f34$export$e7b0ac011bb776c6), {
                                        element: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $3e1054d2f56e3ed6$export$2e2bcd8739ae039), {
                                            Component: (0, $4bdc7abd1faaabf4$export$2e2bcd8739ae039),
                                            title: "Resend verification"
                                        }),
                                        path: "/resend-verification"
                                    }),
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $f02d97b5ca509f34$export$e7b0ac011bb776c6), {
                                        element: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $3e1054d2f56e3ed6$export$2e2bcd8739ae039), {
                                            Component: (0, $67c6eb35273649c1$export$2e2bcd8739ae039),
                                            title: "Reset password"
                                        }),
                                        path: "/reset-password"
                                    }),
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $f02d97b5ca509f34$export$e7b0ac011bb776c6), {
                                        element: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $3e1054d2f56e3ed6$export$2e2bcd8739ae039), {
                                            Component: (0, $dd674630b2027800$export$2e2bcd8739ae039),
                                            title: "Sign in"
                                        }),
                                        path: "/sign-in"
                                    }),
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $f02d97b5ca509f34$export$e7b0ac011bb776c6), {
                                        element: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $3e1054d2f56e3ed6$export$2e2bcd8739ae039), {
                                            Component: (0, $9f5c29284e3de043$export$2e2bcd8739ae039),
                                            title: "Sign up"
                                        }),
                                        path: "/sign-up"
                                    }),
                                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $f02d97b5ca509f34$export$e7b0ac011bb776c6), {
                                        element: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $3e1054d2f56e3ed6$export$2e2bcd8739ae039), {
                                            Component: (0, $87c59931b9517b21$export$2e2bcd8739ae039),
                                            title: "Verify"
                                        }),
                                        path: "/verify"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsxs)((0, $f02d97b5ca509f34$export$e7b0ac011bb776c6), {
                        path: "/about",
                        children: [
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $f02d97b5ca509f34$export$e7b0ac011bb776c6), {
                                element: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $3e1054d2f56e3ed6$export$2e2bcd8739ae039), {
                                    Component: (0, $f5b733924af00917$export$2e2bcd8739ae039),
                                    title: "About"
                                }),
                                path: ""
                            }),
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $f02d97b5ca509f34$export$e7b0ac011bb776c6), {
                                element: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $3e1054d2f56e3ed6$export$2e2bcd8739ae039), {
                                    Component: (0, $2b8e3941875de3f8$export$2e2bcd8739ae039),
                                    title: "Privacy policy"
                                }),
                                path: "privacy-policy"
                            }),
                            /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $f02d97b5ca509f34$export$e7b0ac011bb776c6), {
                                element: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $3e1054d2f56e3ed6$export$2e2bcd8739ae039), {
                                    Component: (0, $9512ed2856feb329$export$2e2bcd8739ae039),
                                    title: "Usage"
                                }),
                                path: "usage"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $f02d97b5ca509f34$export$e7b0ac011bb776c6), {
                        element: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $3e1054d2f56e3ed6$export$2e2bcd8739ae039), {
                            Component: (0, $3977aad02b2c0cad$export$2e2bcd8739ae039),
                            title: "Blog"
                        }),
                        path: "/blog"
                    }),
                    /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $f02d97b5ca509f34$export$e7b0ac011bb776c6), {
                        element: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $3e1054d2f56e3ed6$export$2e2bcd8739ae039), {
                            Component: (0, $0c39354e2efe43e2$export$2e2bcd8739ae039),
                            title: "See also"
                        }),
                        path: "/see-also"
                    })
                ]
            })
        })
    });
}
var $c4b53a7722603883$export$2e2bcd8739ae039 = (0, $e94b7bcc277332d2$export$1f3f55432a00e06d)([
    {
        path: "*",
        Component: $c4b53a7722603883$var$Root
    }
]);



const $a14f18d5629de21e$export$7c07b633a151f9c5 = new (0, $3ccd5b3cb70a1e2f$export$405d0624ed55a03f)();
navigator.storage.estimate().then((estimate)=>{
    if (estimate.usage === undefined || estimate.quota === undefined || estimate.usage < estimate.quota / 2) return;
    (0, $24a8d9ab78e4f062$export$f5282963edea4a68)(Error(`Storage ${(0, $035f270eea0b2c1d$export$fd01c80332d24e86).format(estimate.usage / estimate.quota)} full: ${estimate.usage}`));
});
$f6795297da7ea874$export$882461b6382ed46c(document.getElementById("root")).render(/*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $lBnVc.StrictMode), {
    children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $d3287b130d7b0f6b$export$2881499e37b75b9a), {
        store: (0, $3966632394e0ac61$export$2e2bcd8739ae039),
        children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e17d4e73c83178d1$export$9d736f54481e482f), {
            client: $a14f18d5629de21e$export$7c07b633a151f9c5,
            persistOptions: {
                maxAge: Infinity,
                persister: (0, $3942fb3e179face4$export$5e03d65274f1beeb)({
                    // The type signatures do not match how I chose to use the API
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    deserialize: (x)=>x,
                    key: "moodtracker:react-query-cache",
                    retry (props) {
                        (0, $24a8d9ab78e4f062$export$f5282963edea4a68)(props.error);
                        return (0, $fb9419627ca4844a$export$bfdae6a8e31d44db)(props);
                    },
                    // The type signatures do not match how I chose to use the API
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    serialize: (x)=>x,
                    storage: {
                        getItem: async (key)=>// The type signatures do not match how I chose to use the API
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            (0, $a79fa34021646067$export$3988ae62b71be9a3)(key),
                        removeItem: (key)=>(0, $a79fa34021646067$export$1d2f21e549771e67)(key),
                        setItem: (key, value)=>(0, $a79fa34021646067$export$adaa4cf7ef1b65be)(key, value)
                    }
                })
            },
            children: /*#__PURE__*/ (0, $c0c9bc5c50648c54$exports.jsx)((0, $e94b7bcc277332d2$export$323e4fc2fa4753fb), {
                router: (0, $c4b53a7722603883$export$2e2bcd8739ae039)
            })
        })
    })
}));


//# sourceMappingURL=index.a410ee04.js.map
